var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var api$1 = {};

var FlatfileClient$1 = {};

var Client$j = {};

var Client$i = {};

var environments$l = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(environments$l, "__esModule", { value: true });
environments$l.FlatfileEnvironment = void 0;
environments$l.FlatfileEnvironment = {
    Production: "https://api.x.flatfile.com/v1",
};

var core$1H = {};

var fetcher = {};

var Fetcher = {};

var axios$2 = {exports: {}};

var bind$7 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$6 = bind$7;

// utils is a library of generic helper functions non-specific to axios

var toString$3 = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString$3.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$4(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer$1(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString$1(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber$2(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject$1(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject$2(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate$1 = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction$2(val) {
  return toString$3.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream$1(val) {
  return isObject$1(val) && isFunction$2(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString$3.call(thing) === pattern ||
    (isFunction$2(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach$d(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$4(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge$c(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$2(result[key]) && isPlainObject$2(val)) {
      result[key] = merge$c(result[key], val);
    } else if (isPlainObject$2(val)) {
      result[key] = merge$c({}, val);
    } else if (isArray$4(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$d(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend$2(a, b, thisArg) {
  forEach$d(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$6(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray$2(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

var utils$e = {
  isArray: isArray$4,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber$2,
  isObject: isObject$1,
  isPlainObject: isPlainObject$2,
  isUndefined: isUndefined,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$2,
  isStream: isStream$1,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach$d,
  merge: merge$c,
  extend: extend$2,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray$2,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};

var utils$d = utils$e;

function encode$1(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$d.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode$1(key) + '=' + encode$1(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$c = utils$e;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$b = utils$e;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var AxiosError_1;
var hasRequiredAxiosError;

function requireAxiosError () {
	if (hasRequiredAxiosError) return AxiosError_1;
	hasRequiredAxiosError = 1;

	var utils = utils$e;

	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [config] The config.
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	function AxiosError(message, code, config, request, response) {
	  Error.call(this);
	  this.message = message;
	  this.name = 'AxiosError';
	  code && (this.code = code);
	  config && (this.config = config);
	  request && (this.request = request);
	  response && (this.response = response);
	}

	utils.inherits(AxiosError, Error, {
	  toJSON: function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  }
	});

	var prototype = AxiosError.prototype;
	var descriptors = {};

	[
	  'ERR_BAD_OPTION_VALUE',
	  'ERR_BAD_OPTION',
	  'ECONNABORTED',
	  'ETIMEDOUT',
	  'ERR_NETWORK',
	  'ERR_FR_TOO_MANY_REDIRECTS',
	  'ERR_DEPRECATED',
	  'ERR_BAD_RESPONSE',
	  'ERR_BAD_REQUEST',
	  'ERR_CANCELED'
	// eslint-disable-next-line func-names
	].forEach(function(code) {
	  descriptors[code] = {value: code};
	});

	Object.defineProperties(AxiosError, descriptors);
	Object.defineProperty(prototype, 'isAxiosError', {value: true});

	// eslint-disable-next-line func-names
	AxiosError.from = function(error, code, config, request, response, customProps) {
	  var axiosError = Object.create(prototype);

	  utils.toFlatObject(error, axiosError, function filter(obj) {
	    return obj !== Error.prototype;
	  });

	  AxiosError.call(axiosError, error.message, code, config, request, response);

	  axiosError.name = error.name;

	  customProps && Object.assign(axiosError, customProps);

	  return axiosError;
	};

	AxiosError_1 = AxiosError;
	return AxiosError_1;
}

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var toFormData_1;
var hasRequiredToFormData;

function requireToFormData () {
	if (hasRequiredToFormData) return toFormData_1;
	hasRequiredToFormData = 1;

	var utils = utils$e;

	/**
	 * Convert a data object to FormData
	 * @param {Object} obj
	 * @param {?Object} [formData]
	 * @returns {Object}
	 **/

	function toFormData(obj, formData) {
	  // eslint-disable-next-line no-param-reassign
	  formData = formData || new FormData();

	  var stack = [];

	  function convertValue(value) {
	    if (value === null) return '';

	    if (utils.isDate(value)) {
	      return value.toISOString();
	    }

	    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
	      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
	    }

	    return value;
	  }

	  function build(data, parentKey) {
	    if (utils.isPlainObject(data) || utils.isArray(data)) {
	      if (stack.indexOf(data) !== -1) {
	        throw Error('Circular reference detected in ' + parentKey);
	      }

	      stack.push(data);

	      utils.forEach(data, function each(value, key) {
	        if (utils.isUndefined(value)) return;
	        var fullKey = parentKey ? parentKey + '.' + key : key;
	        var arr;

	        if (value && !parentKey && typeof value === 'object') {
	          if (utils.endsWith(key, '{}')) {
	            // eslint-disable-next-line no-param-reassign
	            value = JSON.stringify(value);
	          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
	            // eslint-disable-next-line func-names
	            arr.forEach(function(el) {
	              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
	            });
	            return;
	          }
	        }

	        build(value, fullKey);
	      });

	      stack.pop();
	    } else {
	      formData.append(parentKey, convertValue(data));
	    }
	  }

	  build(obj);

	  return formData;
	}

	toFormData_1 = toFormData;
	return toFormData_1;
}

var settle;
var hasRequiredSettle;

function requireSettle () {
	if (hasRequiredSettle) return settle;
	hasRequiredSettle = 1;

	var AxiosError = requireAxiosError();

	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	settle = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(new AxiosError(
	      'Request failed with status code ' + response.status,
	      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
	      response.config,
	      response.request,
	      response
	    ));
	  }
	};
	return settle;
}

var cookies;
var hasRequiredCookies;

function requireCookies () {
	if (hasRequiredCookies) return cookies;
	hasRequiredCookies = 1;

	var utils = utils$e;

	cookies = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },

	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },

	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :

	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);
	return cookies;
}

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var parseHeaders;
var hasRequiredParseHeaders;

function requireParseHeaders () {
	if (hasRequiredParseHeaders) return parseHeaders;
	hasRequiredParseHeaders = 1;

	var utils = utils$e;

	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];

	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	parseHeaders = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) { return parsed; }

	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });

	  return parsed;
	};
	return parseHeaders;
}

var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;

function requireIsURLSameOrigin () {
	if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
	hasRequiredIsURLSameOrigin = 1;

	var utils = utils$e;

	isURLSameOrigin = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;

	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href);

	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);

	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :

	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);
	return isURLSameOrigin;
}

var CanceledError_1;
var hasRequiredCanceledError;

function requireCanceledError () {
	if (hasRequiredCanceledError) return CanceledError_1;
	hasRequiredCanceledError = 1;

	var AxiosError = requireAxiosError();
	var utils = utils$e;

	/**
	 * A `CanceledError` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function CanceledError(message) {
	  // eslint-disable-next-line no-eq-null,eqeqeq
	  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
	  this.name = 'CanceledError';
	}

	utils.inherits(CanceledError, AxiosError, {
	  __CANCEL__: true
	});

	CanceledError_1 = CanceledError;
	return CanceledError_1;
}

var parseProtocol;
var hasRequiredParseProtocol;

function requireParseProtocol () {
	if (hasRequiredParseProtocol) return parseProtocol;
	hasRequiredParseProtocol = 1;

	parseProtocol = function parseProtocol(url) {
	  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
	  return match && match[1] || '';
	};
	return parseProtocol;
}

var xhr;
var hasRequiredXhr;

function requireXhr () {
	if (hasRequiredXhr) return xhr;
	hasRequiredXhr = 1;

	var utils = utils$e;
	var settle = requireSettle();
	var cookies = requireCookies();
	var buildURL = buildURL$1;
	var buildFullPath = buildFullPath$1;
	var parseHeaders = requireParseHeaders();
	var isURLSameOrigin = requireIsURLSameOrigin();
	var transitionalDefaults = transitional;
	var AxiosError = requireAxiosError();
	var CanceledError = requireCanceledError();
	var parseProtocol = requireParseProtocol();

	xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;
	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }

	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }

	    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest();

	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);

	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

	    // Set the request timeout in MS
	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };

	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response);

	      // Clean up request
	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }

	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }

	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

	      // Clean up request
	      request = null;
	    };

	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

	      // Clean up request
	      request = null;
	    };

	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || transitionalDefaults;
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(new AxiosError(
	        timeoutErrorMessage,
	        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
	        config,
	        request));

	      // Clean up request
	      request = null;
	    };

	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }

	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }

	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }

	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }

	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }

	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function(cancel) {
	        if (!request) {
	          return;
	        }
	        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
	        request.abort();
	        request = null;
	      };

	      config.cancelToken && config.cancelToken.subscribe(onCanceled);
	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }

	    if (!requestData) {
	      requestData = null;
	    }

	    var protocol = parseProtocol(fullPath);

	    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
	      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
	      return;
	    }


	    // Send the request
	    request.send(requestData);
	  });
	};
	return xhr;
}

var _null;
var hasRequired_null;

function require_null () {
	if (hasRequired_null) return _null;
	hasRequired_null = 1;
	// eslint-disable-next-line strict
	_null = null;
	return _null;
}

var utils$a = utils$e;
var normalizeHeaderName = normalizeHeaderName$1;
var AxiosError$1 = requireAxiosError();
var transitionalDefaults = transitional;
var toFormData = requireToFormData();

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$a.isUndefined(headers) && utils$a.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = requireXhr();
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = requireXhr();
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$a.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$a.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$5 = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$a.isFormData(data) ||
      utils$a.isArrayBuffer(data) ||
      utils$a.isBuffer(data) ||
      utils$a.isStream(data) ||
      utils$a.isFile(data) ||
      utils$a.isBlob(data)
    ) {
      return data;
    }
    if (utils$a.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$a.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils$a.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils$a.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults$5.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$a.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: require_null()
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils$a.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$5.headers[method] = {};
});

utils$a.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$5.headers[method] = utils$a.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$5;

var utils$9 = utils$e;
var defaults$4 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$4;
  /*eslint no-param-reassign:0*/
  utils$9.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1;
var hasRequiredIsCancel;

function requireIsCancel () {
	if (hasRequiredIsCancel) return isCancel$1;
	hasRequiredIsCancel = 1;

	isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	return isCancel$1;
}

var utils$8 = utils$e;
var transformData = transformData$1;
var isCancel = requireIsCancel();
var defaults$3 = defaults_1;
var CanceledError = requireCanceledError();

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$8.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$8.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$3.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$7 = utils$e;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$7.isPlainObject(target) && utils$7.isPlainObject(source)) {
      return utils$7.merge(target, source);
    } else if (utils$7.isPlainObject(source)) {
      return utils$7.merge({}, source);
    } else if (utils$7.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$7.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$7.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$7.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$7.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$7.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils$7.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils$7.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var data;
var hasRequiredData;

function requireData () {
	if (hasRequiredData) return data;
	hasRequiredData = 1;
	data = {
	  "version": "0.27.2"
	};
	return data;
}

var VERSION = requireData().version;
var AxiosError = requireAxiosError();

var validators$2 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$2[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$2.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$2
};

var utils$6 = utils$e;
var buildURL = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var buildFullPath = buildFullPath$1;
var validator = validator$1;

var validators$1 = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators$1.transitional(validators$1.boolean),
      forcedJSONParsing: validators$1.transitional(validators$1.boolean),
      clarifyTimeoutError: validators$1.transitional(validators$1.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils$6.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$6.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios$1.prototype[method] = generateHTTPMethod();

  Axios$1.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios_1 = Axios$1;

var CancelToken_1;
var hasRequiredCancelToken;

function requireCancelToken () {
	if (hasRequiredCancelToken) return CancelToken_1;
	hasRequiredCancelToken = 1;

	var CanceledError = requireCanceledError();

	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;

	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });

	  var token = this;

	  // eslint-disable-next-line func-names
	  this.promise.then(function(cancel) {
	    if (!token._listeners) return;

	    var i;
	    var l = token._listeners.length;

	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }
	    token._listeners = null;
	  });

	  // eslint-disable-next-line func-names
	  this.promise.then = function(onfulfilled) {
	    var _resolve;
	    // eslint-disable-next-line func-names
	    var promise = new Promise(function(resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);

	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };

	    return promise;
	  };

	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new CanceledError(message);
	    resolvePromise(token.reason);
	  });
	}

	/**
	 * Throws a `CanceledError` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};

	/**
	 * Subscribe to the cancel signal
	 */

	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }

	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};

	/**
	 * Unsubscribe from the cancel signal
	 */

	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }
	  var index = this._listeners.indexOf(listener);
	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};

	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	CancelToken_1 = CancelToken;
	return CancelToken_1;
}

var spread;
var hasRequiredSpread;

function requireSpread () {
	if (hasRequiredSpread) return spread;
	hasRequiredSpread = 1;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	return spread;
}

var isAxiosError;
var hasRequiredIsAxiosError;

function requireIsAxiosError () {
	if (hasRequiredIsAxiosError) return isAxiosError;
	hasRequiredIsAxiosError = 1;

	var utils = utils$e;

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	isAxiosError = function isAxiosError(payload) {
	  return utils.isObject(payload) && (payload.isAxiosError === true);
	};
	return isAxiosError;
}

var utils$5 = utils$e;
var bind$5 = bind$7;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults$2 = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind$5(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$5.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils$5.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults$2);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Expose Cancel & CancelToken
axios$1.CanceledError = requireCanceledError();
axios$1.CancelToken = requireCancelToken();
axios$1.isCancel = requireIsCancel();
axios$1.VERSION = requireData().version;
axios$1.toFormData = requireToFormData();

// Expose AxiosError class
axios$1.AxiosError = requireAxiosError();

// alias for CanceledError for backward compatibility
axios$1.Cancel = axios$1.CanceledError;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = requireSpread();

// Expose isAxiosError
axios$1.isAxiosError = requireIsAxiosError();

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axiosExports = axios$2.exports;

var axios = axiosExports;

var lib$1 = {};

var WHITELIST = [
	'ETIMEDOUT',
	'ECONNRESET',
	'EADDRINUSE',
	'ESOCKETTIMEDOUT',
	'ECONNREFUSED',
	'EPIPE',
	'EHOSTUNREACH',
	'EAI_AGAIN'
];

var BLACKLIST = [
	'ENOTFOUND',
	'ENETUNREACH',

	// SSL errors from https://github.com/nodejs/node/blob/ed3d8b13ee9a705d89f9e0397d9e96519e7e47ac/src/node_crypto.cc#L1950
	'UNABLE_TO_GET_ISSUER_CERT',
	'UNABLE_TO_GET_CRL',
	'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
	'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
	'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
	'CERT_SIGNATURE_FAILURE',
	'CRL_SIGNATURE_FAILURE',
	'CERT_NOT_YET_VALID',
	'CERT_HAS_EXPIRED',
	'CRL_NOT_YET_VALID',
	'CRL_HAS_EXPIRED',
	'ERROR_IN_CERT_NOT_BEFORE_FIELD',
	'ERROR_IN_CERT_NOT_AFTER_FIELD',
	'ERROR_IN_CRL_LAST_UPDATE_FIELD',
	'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
	'OUT_OF_MEM',
	'DEPTH_ZERO_SELF_SIGNED_CERT',
	'SELF_SIGNED_CERT_IN_CHAIN',
	'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
	'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
	'CERT_CHAIN_TOO_LONG',
	'CERT_REVOKED',
	'INVALID_CA',
	'PATH_LENGTH_EXCEEDED',
	'INVALID_PURPOSE',
	'CERT_UNTRUSTED',
	'CERT_REJECTED'
];

var isRetryAllowed = function (err) {
	if (!err || !err.code) {
		return true;
	}

	if (WHITELIST.indexOf(err.code) !== -1) {
		return true;
	}

	if (BLACKLIST.indexOf(err.code) !== -1) {
		return false;
	}

	return true;
};

Object.defineProperty(lib$1, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

lib$1.isNetworkError = isNetworkError;
lib$1.isRetryableError = isRetryableError;
lib$1.isSafeRequestError = isSafeRequestError;
lib$1.isIdempotentRequestError = isIdempotentRequestError;
lib$1.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
lib$1.exponentialDelay = exponentialDelay;
lib$1.default = axiosRetry$1;

var _isRetryAllowed = isRetryAllowed;

var _isRetryAllowed2 = _interopRequireDefault(_isRetryAllowed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var namespace = 'axios-retry';

/**
 * @param  {Error}  error
 * @return {boolean}
 */
function isNetworkError(error) {
  return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
  error.code !== 'ECONNABORTED' && // Prevents retrying timed out requests
  (0, _isRetryAllowed2.default)(error); // Prevents retrying unsafe errors
}

var SAFE_HTTP_METHODS = ['get', 'head', 'options'];
var IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(['put', 'delete']);

/**
 * @param  {Error}  error
 * @return {boolean}
 */
function isRetryableError(error) {
  return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
}

/**
 * @param  {Error}  error
 * @return {boolean}
 */
function isSafeRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}

/**
 * @param  {Error}  error
 * @return {boolean}
 */
function isIdempotentRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}

/**
 * @param  {Error}  error
 * @return {boolean | Promise}
 */
function isNetworkOrIdempotentRequestError(error) {
  return isNetworkError(error) || isIdempotentRequestError(error);
}

/**
 * @return {number} - delay in milliseconds, always 0
 */
function noDelay() {
  return 0;
}

/**
 * @param  {number} [retryNumber=0]
 * @return {number} - delay in milliseconds
 */
function exponentialDelay() {
  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var delay = Math.pow(2, retryNumber) * 100;
  var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
  return delay + randomSum;
}

/**
 * Initializes and returns the retry state for the given request/config
 * @param  {AxiosRequestConfig} config
 * @return {Object}
 */
function getCurrentState(config) {
  var currentState = config[namespace] || {};
  currentState.retryCount = currentState.retryCount || 0;
  config[namespace] = currentState;
  return currentState;
}

/**
 * Returns the axios-retry options for the current request
 * @param  {AxiosRequestConfig} config
 * @param  {AxiosRetryConfig} defaultOptions
 * @return {AxiosRetryConfig}
 */
function getRequestOptions(config, defaultOptions) {
  return Object.assign({}, defaultOptions, config[namespace]);
}

/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */
function fixConfig(axios, config) {
  if (axios.defaults.agent === config.agent) {
    delete config.agent;
  }
  if (axios.defaults.httpAgent === config.httpAgent) {
    delete config.httpAgent;
  }
  if (axios.defaults.httpsAgent === config.httpsAgent) {
    delete config.httpsAgent;
  }
}

/**
 * Checks retryCondition if request can be retried. Handles it's retruning value or Promise.
 * @param  {number} retries
 * @param  {Function} retryCondition
 * @param  {Object} currentState
 * @param  {Error} error
 * @return {boolean}
 */
async function shouldRetry(retries, retryCondition, currentState, error) {
  var shouldRetryOrPromise = currentState.retryCount < retries && retryCondition(error);

  // This could be a promise
  if ((typeof shouldRetryOrPromise === 'undefined' ? 'undefined' : _typeof(shouldRetryOrPromise)) === 'object') {
    try {
      await shouldRetryOrPromise;
      return true;
    } catch (_err) {
      return false;
    }
  }
  return shouldRetryOrPromise;
}

/**
 * Adds response interceptors to an axios instance to retry requests failed due to network issues
 *
 * @example
 *
 * import axios from 'axios';
 *
 * axiosRetry(axios, { retries: 3 });
 *
 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Exponential back-off retry delay between requests
 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
 *
 * // Custom retry delay
 * axiosRetry(axios, { retryDelay : (retryCount) => {
 *   return retryCount * 1000;
 * }});
 *
 * // Also works with custom axios instances
 * const client = axios.create({ baseURL: 'http://example.com' });
 * axiosRetry(client, { retries: 3 });
 *
 * client.get('/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Allows request-specific configuration
 * client
 *   .get('/test', {
 *     'axios-retry': {
 *       retries: 0
 *     }
 *   })
 *   .catch(error => { // The first request fails
 *     error !== undefined
 *   });
 *
 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
 * @param {Object} [defaultOptions]
 * @param {number} [defaultOptions.retries=3] Number of retries
 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
 *        Defines if the timeout should be reset between retries
 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
 *        A function to determine if the error can be retried
 * @param {Function} [defaultOptions.retryDelay=noDelay]
 *        A function to determine the delay between retry requests
 */
function axiosRetry$1(axios, defaultOptions) {
  axios.interceptors.request.use(function (config) {
    var currentState = getCurrentState(config);
    currentState.lastRequestTime = Date.now();
    return config;
  });

  axios.interceptors.response.use(null, async function (error) {
    var config = error.config;

    // If we have no information to retry the request
    if (!config) {
      return Promise.reject(error);
    }

    var _getRequestOptions = getRequestOptions(config, defaultOptions),
        _getRequestOptions$re = _getRequestOptions.retries,
        retries = _getRequestOptions$re === undefined ? 3 : _getRequestOptions$re,
        _getRequestOptions$re2 = _getRequestOptions.retryCondition,
        retryCondition = _getRequestOptions$re2 === undefined ? isNetworkOrIdempotentRequestError : _getRequestOptions$re2,
        _getRequestOptions$re3 = _getRequestOptions.retryDelay,
        retryDelay = _getRequestOptions$re3 === undefined ? noDelay : _getRequestOptions$re3,
        _getRequestOptions$sh = _getRequestOptions.shouldResetTimeout,
        shouldResetTimeout = _getRequestOptions$sh === undefined ? false : _getRequestOptions$sh;

    var currentState = getCurrentState(config);

    if (await shouldRetry(retries, retryCondition, currentState, error)) {
      currentState.retryCount += 1;
      var delay = retryDelay(currentState.retryCount, error);

      // Axios fails merging this configuration to the default configuration because it has an issue
      // with circular structures: https://github.com/mzabriskie/axios/issues/370
      fixConfig(axios, config);

      if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
        var lastRequestDuration = Date.now() - currentState.lastRequestTime;
        // Minimum 1ms timeout (passing 0 or less to XHR means no timeout)
        config.timeout = Math.max(config.timeout - lastRequestDuration - delay, 1);
      }

      config.transformRequest = [function (data) {
        return data;
      }];

      return new Promise(function (resolve) {
        return setTimeout(function () {
          return resolve(axios(config));
        }, delay);
      });
    }

    return Promise.reject(error);
  });
}

// Compatibility with CommonJS
axiosRetry$1.isNetworkError = isNetworkError;
axiosRetry$1.isSafeRequestError = isSafeRequestError;
axiosRetry$1.isIdempotentRequestError = isIdempotentRequestError;
axiosRetry$1.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
axiosRetry$1.exponentialDelay = exponentialDelay;
axiosRetry$1.isRetryableError = isRetryableError;

var axiosRetry = lib$1.default;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams;

var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

var test$1 = {
	foo: {}
};

var $Object = Object;

var hasProto$1 = function hasProto() {
	return { __proto__: test$1 }.foo === test$1.foo && !({ __proto__: null } instanceof $Object);
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr$1 = Object.prototype.toString;
var max$3 = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$1.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max$3(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

var hasOwnProperty = {}.hasOwnProperty;
var call = Function.prototype.call;

var src = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
  return call.call(hasOwnProperty, O, P);
};

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = hasSymbols$1();
var hasProto = hasProto$1();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind$4 = functionBind;
var hasOwn$1 = src;
var $concat$1 = bind$4.call(Function.call, Array.prototype.concat);
var $spliceApply = bind$4.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind$4.call(Function.call, String.prototype.replace);
var $strSlice = bind$4.call(Function.call, String.prototype.slice);
var $exec = bind$4.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$1(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$1(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind$1 = {exports: {}};

callBind$1.exports;

(function (module) {

	var bind = functionBind;
	var GetIntrinsic = getIntrinsic;

	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');

	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}

	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};

	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};

	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	} 
} (callBind$1));

var callBindExports = callBind$1.exports;

var GetIntrinsic$1 = getIntrinsic;

var callBind = callBindExports;

var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$1(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$c(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$c(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$c(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$c(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$c(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$3(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf$1(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$c(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp$1(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$3(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber$1(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt$1(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (obj === commonjsGlobal) {
        /* eslint-env browser */
        if (typeof window !== 'undefined') {
            return '{ [object Window] }';
        }
        return '{ [object global] }';
    }
    if (!isDate(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$3(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber$1(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt$1(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$c(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf$1(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf$1(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$3(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$c(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$c(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var GetIntrinsic = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var replace$2 = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats$3 = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace$2.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

var formats$2 = formats$3;

var has$b = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$2(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge$b = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$2(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$b.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$2(target) && !isArray$2(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$2(target) && isArray$2(source)) {
        source.forEach(function (item, i) {
            if (has$b.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$b.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode$1 = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats$2.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact$2 = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine$b = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$2(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils$4 = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine$b,
    compact: compact$2,
    decode: decode$1,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge$b
};

var getSideChannel = sideChannel;
var utils$3 = utils$4;
var formats$1 = formats$3;
var has$a = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$1 = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats$1['default'];
var defaults$1 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils$3.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats$1.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify$1 = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        obj = utils$3.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils$3.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils$3.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray$1(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray$1(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$1(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray$1(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$1;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$1.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats$1['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$a.call(formats$1.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats$1.formatters[format];

    var filter = defaults$1.filter;
    if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$1.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$1.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$1.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$1.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$1.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
    };
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$1(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify$1(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

var utils$2 = utils$4;

var has$9 = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils$2.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils$2.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has$9.call(obj, key)) {
            obj[key] = utils$2.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has$9.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has$9.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils$2.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

var parse$1 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils$2.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils$2.compact(obj);
};

var stringify = stringify_1;
var parse = parse$1;
var formats = formats$3;

var lib = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

var __awaiter$x = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$k = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Fetcher, "__esModule", { value: true });
Fetcher.fetcher = void 0;
const axios_1$1 = __importDefault$k(axios);
const axios_retry_1 = __importDefault$k(axiosRetry);
const qs_1$1 = __importDefault$k(lib);
const INITIAL_RETRY_DELAY = 1;
const MAX_RETRY_DELAY = 60;
const DEFAULT_MAX_RETRIES = 2;
const AXIOS = axios_1$1.default.create();
function fetcherImpl(args) {
    var _a, _b, _c;
    return __awaiter$x(this, void 0, void 0, function* () {
        const headers = {};
        if (args.body !== undefined && args.contentType != null) {
            headers["Content-Type"] = args.contentType;
        }
        if (args.headers != null) {
            for (const [key, value] of Object.entries(args.headers)) {
                if (value != null) {
                    headers[key] = value;
                }
            }
        }
        (0, axios_retry_1.default)(AXIOS, {
            retries: (_a = args.maxRetries) !== null && _a !== void 0 ? _a : DEFAULT_MAX_RETRIES,
            retryCondition: (error) => {
                return error.response != null && [500, 502, 429].includes(error.response.status);
            },
            retryDelay: (count) => {
                if (count == 0) {
                    return INITIAL_RETRY_DELAY;
                }
                // Apply exponential backoff, but not more than the max.
                return Math.min(INITIAL_RETRY_DELAY * Math.pow(count - 1, 2), MAX_RETRY_DELAY);
            },
        });
        try {
            const response = yield AXIOS.request({
                url: args.url,
                params: args.queryParameters,
                paramsSerializer: (params) => {
                    return qs_1$1.default.stringify(params);
                },
                method: args.method,
                headers,
                data: args.body,
                validateStatus: () => true,
                transformResponse: (response) => response,
                timeout: args.timeoutMs,
                transitional: {
                    clarifyTimeoutError: true,
                },
                withCredentials: args.withCredentials,
                adapter: args.adapter,
                onUploadProgress: args.onUploadProgress,
                maxBodyLength: Infinity,
                maxContentLength: Infinity,
                responseType: (_b = args.responseType) !== null && _b !== void 0 ? _b : "json",
            });
            let body;
            if (args.responseType === "blob") {
                body = response.data;
            }
            else if (response.data != null && response.data.length > 0) {
                try {
                    body = (_c = JSON.parse(response.data)) !== null && _c !== void 0 ? _c : undefined;
                }
                catch (_d) {
                    return {
                        ok: false,
                        error: {
                            reason: "non-json",
                            statusCode: response.status,
                            rawBody: response.data,
                        },
                    };
                }
            }
            if (response.status >= 200 && response.status < 400) {
                return {
                    ok: true,
                    body: body,
                };
            }
            else {
                return {
                    ok: false,
                    error: {
                        reason: "status-code",
                        statusCode: response.status,
                        body,
                    },
                };
            }
        }
        catch (error) {
            if (error.code === "ETIMEDOUT") {
                return {
                    ok: false,
                    error: {
                        reason: "timeout",
                    },
                };
            }
            return {
                ok: false,
                error: {
                    reason: "unknown",
                    errorMessage: error.message,
                },
            };
        }
    });
}
Fetcher.fetcher = fetcherImpl;

var Supplier = {};

var __awaiter$w = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(Supplier, "__esModule", { value: true });
Supplier.Supplier = void 0;
Supplier.Supplier = {
    get: (supplier) => __awaiter$w(void 0, void 0, void 0, function* () {
        if (typeof supplier === "function") {
            return supplier();
        }
        else {
            return supplier;
        }
    }),
};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Supplier = exports.fetcher = void 0;
	var Fetcher_1 = Fetcher;
	Object.defineProperty(exports, "fetcher", { enumerable: true, get: function () { return Fetcher_1.fetcher; } });
	var Supplier_1 = Supplier;
	Object.defineProperty(exports, "Supplier", { enumerable: true, get: function () { return Supplier_1.Supplier; } }); 
} (fetcher));

var auth$2 = {};

var BasicAuth = {};

var base64 = {exports: {}};

base64.exports;

(function (module, exports) {
	(function (global, factory) {
	    module.exports = factory()
	        ;
	}((typeof self !== 'undefined' ? self
	    : typeof window !== 'undefined' ? window
	        : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal
	            : commonjsGlobal), function () {
	    /**
	     *  base64.ts
	     *
	     *  Licensed under the BSD 3-Clause License.
	     *    http://opensource.org/licenses/BSD-3-Clause
	     *
	     *  References:
	     *    http://en.wikipedia.org/wiki/Base64
	     *
	     * @author Dan Kogai (https://github.com/dankogai)
	     */
	    var version = '3.7.2';
	    /**
	     * @deprecated use lowercase `version`.
	     */
	    var VERSION = version;
	    var _hasatob = typeof atob === 'function';
	    var _hasbtoa = typeof btoa === 'function';
	    var _hasBuffer = typeof Buffer === 'function';
	    var _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
	    var _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
	    var b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    var b64chs = Array.prototype.slice.call(b64ch);
	    var b64tab = (function (a) {
	        var tab = {};
	        a.forEach(function (c, i) { return tab[c] = i; });
	        return tab;
	    })(b64chs);
	    var b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
	    var _fromCC = String.fromCharCode.bind(String);
	    var _U8Afrom = typeof Uint8Array.from === 'function'
	        ? Uint8Array.from.bind(Uint8Array)
	        : function (it, fn) {
	            if (fn === void 0) { fn = function (x) { return x; }; }
	            return new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
	        };
	    var _mkUriSafe = function (src) { return src
	        .replace(/=/g, '').replace(/[+\/]/g, function (m0) { return m0 == '+' ? '-' : '_'; }); };
	    var _tidyB64 = function (s) { return s.replace(/[^A-Za-z0-9\+\/]/g, ''); };
	    /**
	     * polyfill version of `btoa`
	     */
	    var btoaPolyfill = function (bin) {
	        // console.log('polyfilled');
	        var u32, c0, c1, c2, asc = '';
	        var pad = bin.length % 3;
	        for (var i = 0; i < bin.length;) {
	            if ((c0 = bin.charCodeAt(i++)) > 255 ||
	                (c1 = bin.charCodeAt(i++)) > 255 ||
	                (c2 = bin.charCodeAt(i++)) > 255)
	                throw new TypeError('invalid character found');
	            u32 = (c0 << 16) | (c1 << 8) | c2;
	            asc += b64chs[u32 >> 18 & 63]
	                + b64chs[u32 >> 12 & 63]
	                + b64chs[u32 >> 6 & 63]
	                + b64chs[u32 & 63];
	        }
	        return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
	    };
	    /**
	     * does what `window.btoa` of web browsers do.
	     * @param {String} bin binary string
	     * @returns {string} Base64-encoded string
	     */
	    var _btoa = _hasbtoa ? function (bin) { return btoa(bin); }
	        : _hasBuffer ? function (bin) { return Buffer.from(bin, 'binary').toString('base64'); }
	            : btoaPolyfill;
	    var _fromUint8Array = _hasBuffer
	        ? function (u8a) { return Buffer.from(u8a).toString('base64'); }
	        : function (u8a) {
	            // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
	            var maxargs = 0x1000;
	            var strs = [];
	            for (var i = 0, l = u8a.length; i < l; i += maxargs) {
	                strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
	            }
	            return _btoa(strs.join(''));
	        };
	    /**
	     * converts a Uint8Array to a Base64 string.
	     * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
	     * @returns {string} Base64 string
	     */
	    var fromUint8Array = function (u8a, urlsafe) {
	        if (urlsafe === void 0) { urlsafe = false; }
	        return urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
	    };
	    // This trick is found broken https://github.com/dankogai/js-base64/issues/130
	    // const utob = (src: string) => unescape(encodeURIComponent(src));
	    // reverting good old fationed regexp
	    var cb_utob = function (c) {
	        if (c.length < 2) {
	            var cc = c.charCodeAt(0);
	            return cc < 0x80 ? c
	                : cc < 0x800 ? (_fromCC(0xc0 | (cc >>> 6))
	                    + _fromCC(0x80 | (cc & 0x3f)))
	                    : (_fromCC(0xe0 | ((cc >>> 12) & 0x0f))
	                        + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
	                        + _fromCC(0x80 | (cc & 0x3f)));
	        }
	        else {
	            var cc = 0x10000
	                + (c.charCodeAt(0) - 0xD800) * 0x400
	                + (c.charCodeAt(1) - 0xDC00);
	            return (_fromCC(0xf0 | ((cc >>> 18) & 0x07))
	                + _fromCC(0x80 | ((cc >>> 12) & 0x3f))
	                + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
	                + _fromCC(0x80 | (cc & 0x3f)));
	        }
	    };
	    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
	    /**
	     * @deprecated should have been internal use only.
	     * @param {string} src UTF-8 string
	     * @returns {string} UTF-16 string
	     */
	    var utob = function (u) { return u.replace(re_utob, cb_utob); };
	    //
	    var _encode = _hasBuffer
	        ? function (s) { return Buffer.from(s, 'utf8').toString('base64'); }
	        : _TE
	            ? function (s) { return _fromUint8Array(_TE.encode(s)); }
	            : function (s) { return _btoa(utob(s)); };
	    /**
	     * converts a UTF-8-encoded string to a Base64 string.
	     * @param {boolean} [urlsafe] if `true` make the result URL-safe
	     * @returns {string} Base64 string
	     */
	    var encode = function (src, urlsafe) {
	        if (urlsafe === void 0) { urlsafe = false; }
	        return urlsafe
	            ? _mkUriSafe(_encode(src))
	            : _encode(src);
	    };
	    /**
	     * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
	     * @returns {string} Base64 string
	     */
	    var encodeURI = function (src) { return encode(src, true); };
	    // This trick is found broken https://github.com/dankogai/js-base64/issues/130
	    // const btou = (src: string) => decodeURIComponent(escape(src));
	    // reverting good old fationed regexp
	    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
	    var cb_btou = function (cccc) {
	        switch (cccc.length) {
	            case 4:
	                var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                    | ((0x3f & cccc.charCodeAt(1)) << 12)
	                    | ((0x3f & cccc.charCodeAt(2)) << 6)
	                    | (0x3f & cccc.charCodeAt(3)), offset = cp - 0x10000;
	                return (_fromCC((offset >>> 10) + 0xD800)
	                    + _fromCC((offset & 0x3FF) + 0xDC00));
	            case 3:
	                return _fromCC(((0x0f & cccc.charCodeAt(0)) << 12)
	                    | ((0x3f & cccc.charCodeAt(1)) << 6)
	                    | (0x3f & cccc.charCodeAt(2)));
	            default:
	                return _fromCC(((0x1f & cccc.charCodeAt(0)) << 6)
	                    | (0x3f & cccc.charCodeAt(1)));
	        }
	    };
	    /**
	     * @deprecated should have been internal use only.
	     * @param {string} src UTF-16 string
	     * @returns {string} UTF-8 string
	     */
	    var btou = function (b) { return b.replace(re_btou, cb_btou); };
	    /**
	     * polyfill version of `atob`
	     */
	    var atobPolyfill = function (asc) {
	        // console.log('polyfilled');
	        asc = asc.replace(/\s+/g, '');
	        if (!b64re.test(asc))
	            throw new TypeError('malformed base64.');
	        asc += '=='.slice(2 - (asc.length & 3));
	        var u24, bin = '', r1, r2;
	        for (var i = 0; i < asc.length;) {
	            u24 = b64tab[asc.charAt(i++)] << 18
	                | b64tab[asc.charAt(i++)] << 12
	                | (r1 = b64tab[asc.charAt(i++)]) << 6
	                | (r2 = b64tab[asc.charAt(i++)]);
	            bin += r1 === 64 ? _fromCC(u24 >> 16 & 255)
	                : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255)
	                    : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
	        }
	        return bin;
	    };
	    /**
	     * does what `window.atob` of web browsers do.
	     * @param {String} asc Base64-encoded string
	     * @returns {string} binary string
	     */
	    var _atob = _hasatob ? function (asc) { return atob(_tidyB64(asc)); }
	        : _hasBuffer ? function (asc) { return Buffer.from(asc, 'base64').toString('binary'); }
	            : atobPolyfill;
	    //
	    var _toUint8Array = _hasBuffer
	        ? function (a) { return _U8Afrom(Buffer.from(a, 'base64')); }
	        : function (a) { return _U8Afrom(_atob(a), function (c) { return c.charCodeAt(0); }); };
	    /**
	     * converts a Base64 string to a Uint8Array.
	     */
	    var toUint8Array = function (a) { return _toUint8Array(_unURI(a)); };
	    //
	    var _decode = _hasBuffer
	        ? function (a) { return Buffer.from(a, 'base64').toString('utf8'); }
	        : _TD
	            ? function (a) { return _TD.decode(_toUint8Array(a)); }
	            : function (a) { return btou(_atob(a)); };
	    var _unURI = function (a) { return _tidyB64(a.replace(/[-_]/g, function (m0) { return m0 == '-' ? '+' : '/'; })); };
	    /**
	     * converts a Base64 string to a UTF-8 string.
	     * @param {String} src Base64 string.  Both normal and URL-safe are supported
	     * @returns {string} UTF-8 string
	     */
	    var decode = function (src) { return _decode(_unURI(src)); };
	    /**
	     * check if a value is a valid Base64 string
	     * @param {String} src a value to check
	      */
	    var isValid = function (src) {
	        if (typeof src !== 'string')
	            return false;
	        var s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
	        return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
	    };
	    //
	    var _noEnum = function (v) {
	        return {
	            value: v, enumerable: false, writable: true, configurable: true
	        };
	    };
	    /**
	     * extend String.prototype with relevant methods
	     */
	    var extendString = function () {
	        var _add = function (name, body) { return Object.defineProperty(String.prototype, name, _noEnum(body)); };
	        _add('fromBase64', function () { return decode(this); });
	        _add('toBase64', function (urlsafe) { return encode(this, urlsafe); });
	        _add('toBase64URI', function () { return encode(this, true); });
	        _add('toBase64URL', function () { return encode(this, true); });
	        _add('toUint8Array', function () { return toUint8Array(this); });
	    };
	    /**
	     * extend Uint8Array.prototype with relevant methods
	     */
	    var extendUint8Array = function () {
	        var _add = function (name, body) { return Object.defineProperty(Uint8Array.prototype, name, _noEnum(body)); };
	        _add('toBase64', function (urlsafe) { return fromUint8Array(this, urlsafe); });
	        _add('toBase64URI', function () { return fromUint8Array(this, true); });
	        _add('toBase64URL', function () { return fromUint8Array(this, true); });
	    };
	    /**
	     * extend Builtin prototypes with relevant methods
	     */
	    var extendBuiltins = function () {
	        extendString();
	        extendUint8Array();
	    };
	    var gBase64 = {
	        version: version,
	        VERSION: VERSION,
	        atob: _atob,
	        atobPolyfill: atobPolyfill,
	        btoa: _btoa,
	        btoaPolyfill: btoaPolyfill,
	        fromBase64: decode,
	        toBase64: encode,
	        encode: encode,
	        encodeURI: encodeURI,
	        encodeURL: encodeURI,
	        utob: utob,
	        btou: btou,
	        decode: decode,
	        isValid: isValid,
	        fromUint8Array: fromUint8Array,
	        toUint8Array: toUint8Array,
	        extendString: extendString,
	        extendUint8Array: extendUint8Array,
	        extendBuiltins: extendBuiltins
	    };
	    //
	    // export Base64 to the namespace
	    //
	    // ES5 is yet to have Object.assign() that may make transpilers unhappy.
	    // gBase64.Base64 = Object.assign({}, gBase64);
	    gBase64.Base64 = {};
	    Object.keys(gBase64).forEach(function (k) { return gBase64.Base64[k] = gBase64[k]; });
	    return gBase64;
	})); 
} (base64, base64.exports));

var base64Exports = base64.exports;

Object.defineProperty(BasicAuth, "__esModule", { value: true });
BasicAuth.BasicAuth = void 0;
const js_base64_1 = base64Exports;
const BASIC_AUTH_HEADER_PREFIX = /^Basic /i;
BasicAuth.BasicAuth = {
    toAuthorizationHeader: (basicAuth) => {
        if (basicAuth == null) {
            return undefined;
        }
        const token = js_base64_1.Base64.encode(`${basicAuth.username}:${basicAuth.password}`);
        return `Basic ${token}`;
    },
    fromAuthorizationHeader: (header) => {
        const credentials = header.replace(BASIC_AUTH_HEADER_PREFIX, "");
        const decoded = js_base64_1.Base64.decode(credentials);
        const [username, password] = decoded.split(":", 2);
        if (username == null || password == null) {
            throw new Error("Invalid basic auth");
        }
        return {
            username,
            password,
        };
    },
};

var BearerToken = {};

Object.defineProperty(BearerToken, "__esModule", { value: true });
BearerToken.BearerToken = void 0;
const BEARER_AUTH_HEADER_PREFIX = /^Bearer /i;
BearerToken.BearerToken = {
    toAuthorizationHeader: (token) => {
        if (token == null) {
            return undefined;
        }
        return `Bearer ${token}`;
    },
    fromAuthorizationHeader: (header) => {
        return header.replace(BEARER_AUTH_HEADER_PREFIX, "").trim();
    },
};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BearerToken = exports.BasicAuth = void 0;
	var BasicAuth_1 = BasicAuth;
	Object.defineProperty(exports, "BasicAuth", { enumerable: true, get: function () { return BasicAuth_1.BasicAuth; } });
	var BearerToken_1 = BearerToken;
	Object.defineProperty(exports, "BearerToken", { enumerable: true, get: function () { return BearerToken_1.BearerToken; } }); 
} (auth$2));

var streamingFetcher$1 = {};

var getHeader$1 = {};

Object.defineProperty(getHeader$1, "__esModule", { value: true });
getHeader$1.getHeader = void 0;
function getHeader(response, header) {
    for (const [headerKey, headerValue] of Object.entries(response.headers)) {
        if (headerKey.toLowerCase() === header.toLowerCase()) {
            return headerValue;
        }
    }
    return undefined;
}
getHeader$1.getHeader = getHeader;

var StreamingFetcher = {};

var __awaiter$v = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$j = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(StreamingFetcher, "__esModule", { value: true });
StreamingFetcher.streamingFetcher = void 0;
const axios_1 = __importDefault$j(axios);
const qs_1 = __importDefault$j(lib);
const streamingFetcher = (args) => __awaiter$v(void 0, void 0, void 0, function* () {
    var _a;
    const headers = {};
    if (args.body !== undefined) {
        headers["Content-Type"] = "application/json";
    }
    if (args.headers != null) {
        for (const [key, value] of Object.entries(args.headers)) {
            if (value != null) {
                headers[key] = value;
            }
        }
    }
    const response = yield (0, axios_1.default)({
        url: args.url,
        params: args.queryParameters,
        paramsSerializer: (params) => {
            return qs_1.default.stringify(params);
        },
        method: args.method,
        headers,
        data: args.body,
        timeout: args.timeoutMs,
        transitional: {
            clarifyTimeoutError: true,
        },
        withCredentials: args.withCredentials,
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        onUploadProgress: args.onUploadProgress,
        onDownloadProgress: args.onDownloadProgress,
        signal: (_a = args.abortController) === null || _a === void 0 ? void 0 : _a.signal,
        responseType: "stream",
        adapter: args.adapter,
    });
    if (args.onData != null) {
        const { onData } = args;
        response.data.on("data", (data) => {
            var _a;
            for (const line of data.toString().split("\n")) {
                let data = line;
                if (args.responseChunkPrefix != null) {
                    if (!data.startsWith(args.responseChunkPrefix)) {
                        continue;
                    }
                    data = data.substring(args.responseChunkPrefix.length);
                }
                try {
                    const parsed = JSON.parse(data);
                    onData(parsed);
                }
                catch (error) {
                    (_a = args.onError) === null || _a === void 0 ? void 0 : _a.call(args, error);
                }
            }
        });
    }
    if (args.onFinish != null) {
        response.data.on("end", args.onFinish);
    }
    return {
        data: response.data,
        headers: response.headers,
    };
});
StreamingFetcher.streamingFetcher = streamingFetcher;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.streamingFetcher = exports.getHeader = void 0;
	var getHeader_1 = getHeader$1;
	Object.defineProperty(exports, "getHeader", { enumerable: true, get: function () { return getHeader_1.getHeader; } });
	var StreamingFetcher_1 = StreamingFetcher;
	Object.defineProperty(exports, "streamingFetcher", { enumerable: true, get: function () { return StreamingFetcher_1.streamingFetcher; } }); 
} (streamingFetcher$1));

var formDataUtils = {};

var getFormDataContentLength$1 = {};

var __awaiter$u = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(getFormDataContentLength$1, "__esModule", { value: true });
getFormDataContentLength$1.getFormDataContentLength = void 0;
function getFormDataContentLength(formData) {
    return __awaiter$u(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            formData.getLength((err, length) => {
                if (err != null) {
                    reject(err);
                }
                else {
                    resolve(length);
                }
            });
        });
    });
}
getFormDataContentLength$1.getFormDataContentLength = getFormDataContentLength;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getFormDataContentLength = void 0;
	var getFormDataContentLength_1 = getFormDataContentLength$1;
	Object.defineProperty(exports, "getFormDataContentLength", { enumerable: true, get: function () { return getFormDataContentLength_1.getFormDataContentLength; } }); 
} (formDataUtils));

var schemas = {};

var builders = {};

var date$3 = {};

var date$2 = {};

var Schema = {};

Object.defineProperty(Schema, "__esModule", { value: true });
Schema.SchemaType = void 0;
Schema.SchemaType = {
    DATE: "date",
    ENUM: "enum",
    LIST: "list",
    STRING_LITERAL: "stringLiteral",
    OBJECT: "object",
    ANY: "any",
    BOOLEAN: "boolean",
    NUMBER: "number",
    STRING: "string",
    UNKNOWN: "unknown",
    RECORD: "record",
    SET: "set",
    UNION: "union",
    UNDISCRIMINATED_UNION: "undiscriminatedUnion",
    OPTIONAL: "optional",
};

var getErrorMessageForIncorrectType$1 = {};

Object.defineProperty(getErrorMessageForIncorrectType$1, "__esModule", { value: true });
getErrorMessageForIncorrectType$1.getErrorMessageForIncorrectType = void 0;
function getErrorMessageForIncorrectType(value, expectedType) {
    return `Expected ${expectedType}. Received ${getTypeAsString(value)}.`;
}
getErrorMessageForIncorrectType$1.getErrorMessageForIncorrectType = getErrorMessageForIncorrectType;
function getTypeAsString(value) {
    if (Array.isArray(value)) {
        return "list";
    }
    if (value === null) {
        return "null";
    }
    switch (typeof value) {
        case "string":
            return `"${value}"`;
        case "number":
        case "boolean":
        case "undefined":
            return `${value}`;
    }
    return typeof value;
}

var maybeSkipValidation$1 = {};

var __awaiter$t = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(maybeSkipValidation$1, "__esModule", { value: true });
maybeSkipValidation$1.maybeSkipValidation = void 0;
function maybeSkipValidation(schema) {
    return Object.assign(Object.assign({}, schema), { json: transformAndMaybeSkipValidation(schema.json), parse: transformAndMaybeSkipValidation(schema.parse) });
}
maybeSkipValidation$1.maybeSkipValidation = maybeSkipValidation;
function transformAndMaybeSkipValidation(transform) {
    return (value, opts) => __awaiter$t(this, void 0, void 0, function* () {
        const transformed = yield transform(value, opts);
        const { skipValidation = false } = opts !== null && opts !== void 0 ? opts : {};
        if (!transformed.ok && skipValidation) {
            // eslint-disable-next-line no-console
            console.warn([
                "Failed to validate.",
                ...transformed.errors.map((error) => "  - " +
                    (error.path.length > 0 ? `${error.path.join(".")}: ${error.message}` : error.message)),
            ].join("\n"));
            return {
                ok: true,
                value: value,
            };
        }
        else {
            return transformed;
        }
    });
}

var schemaUtils = {};

var getSchemaUtils$1 = {};

var JsonError$1 = {};

var stringifyValidationErrors = {};

Object.defineProperty(stringifyValidationErrors, "__esModule", { value: true });
stringifyValidationErrors.stringifyValidationError = void 0;
function stringifyValidationError(error) {
    if (error.path.length === 0) {
        return error.message;
    }
    return `${error.path.join(" -> ")}: ${error.message}`;
}
stringifyValidationErrors.stringifyValidationError = stringifyValidationError;

Object.defineProperty(JsonError$1, "__esModule", { value: true });
JsonError$1.JsonError = void 0;
const stringifyValidationErrors_1$1 = stringifyValidationErrors;
class JsonError extends Error {
    constructor(errors) {
        super(errors.map(stringifyValidationErrors_1$1.stringifyValidationError).join("; "));
        this.errors = errors;
        Object.setPrototypeOf(this, JsonError.prototype);
    }
}
JsonError$1.JsonError = JsonError;

var ParseError$1 = {};

Object.defineProperty(ParseError$1, "__esModule", { value: true });
ParseError$1.ParseError = void 0;
const stringifyValidationErrors_1 = stringifyValidationErrors;
class ParseError extends Error {
    constructor(errors) {
        super(errors.map(stringifyValidationErrors_1.stringifyValidationError).join("; "));
        this.errors = errors;
        Object.setPrototypeOf(this, ParseError.prototype);
    }
}
ParseError$1.ParseError = ParseError;

var __awaiter$s = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(getSchemaUtils$1, "__esModule", { value: true });
getSchemaUtils$1.transform = getSchemaUtils$1.optional = getSchemaUtils$1.getSchemaUtils = void 0;
const Schema_1$e = Schema;
const JsonError_1 = JsonError$1;
const ParseError_1 = ParseError$1;
function getSchemaUtils(schema) {
    return {
        optional: () => optional(schema),
        transform: (transformer) => transform$4(schema, transformer),
        parseOrThrow: (raw, opts) => __awaiter$s(this, void 0, void 0, function* () {
            const parsed = yield schema.parse(raw, opts);
            if (parsed.ok) {
                return parsed.value;
            }
            throw new ParseError_1.ParseError(parsed.errors);
        }),
        jsonOrThrow: (parsed, opts) => __awaiter$s(this, void 0, void 0, function* () {
            const raw = yield schema.json(parsed, opts);
            if (raw.ok) {
                return raw.value;
            }
            throw new JsonError_1.JsonError(raw.errors);
        }),
    };
}
getSchemaUtils$1.getSchemaUtils = getSchemaUtils;
/**
 * schema utils are defined in one file to resolve issues with circular imports
 */
function optional(schema) {
    const baseSchema = {
        parse: (raw, opts) => {
            if (raw == null) {
                return {
                    ok: true,
                    value: undefined,
                };
            }
            return schema.parse(raw, opts);
        },
        json: (parsed, opts) => {
            if (parsed == null) {
                return {
                    ok: true,
                    value: null,
                };
            }
            return schema.json(parsed, opts);
        },
        getType: () => Schema_1$e.SchemaType.OPTIONAL,
    };
    return Object.assign(Object.assign({}, baseSchema), getSchemaUtils(baseSchema));
}
getSchemaUtils$1.optional = optional;
function transform$4(schema, transformer) {
    const baseSchema = {
        parse: (raw, opts) => __awaiter$s(this, void 0, void 0, function* () {
            const parsed = yield schema.parse(raw, opts);
            if (!parsed.ok) {
                return parsed;
            }
            return {
                ok: true,
                value: transformer.transform(parsed.value),
            };
        }),
        json: (transformed, opts) => __awaiter$s(this, void 0, void 0, function* () {
            const parsed = yield transformer.untransform(transformed);
            return schema.json(parsed, opts);
        }),
        getType: () => schema.getType(),
    };
    return Object.assign(Object.assign({}, baseSchema), getSchemaUtils(baseSchema));
}
getSchemaUtils$1.transform = transform$4;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParseError = exports.JsonError = exports.transform = exports.optional = exports.getSchemaUtils = void 0;
	var getSchemaUtils_1 = getSchemaUtils$1;
	Object.defineProperty(exports, "getSchemaUtils", { enumerable: true, get: function () { return getSchemaUtils_1.getSchemaUtils; } });
	Object.defineProperty(exports, "optional", { enumerable: true, get: function () { return getSchemaUtils_1.optional; } });
	Object.defineProperty(exports, "transform", { enumerable: true, get: function () { return getSchemaUtils_1.transform; } });
	var JsonError_1 = JsonError$1;
	Object.defineProperty(exports, "JsonError", { enumerable: true, get: function () { return JsonError_1.JsonError; } });
	var ParseError_1 = ParseError$1;
	Object.defineProperty(exports, "ParseError", { enumerable: true, get: function () { return ParseError_1.ParseError; } }); 
} (schemaUtils));

Object.defineProperty(date$2, "__esModule", { value: true });
date$2.date = void 0;
const Schema_1$d = Schema;
const getErrorMessageForIncorrectType_1$b = getErrorMessageForIncorrectType$1;
const maybeSkipValidation_1$7 = maybeSkipValidation$1;
const schema_utils_1$a = schemaUtils;
// https://stackoverflow.com/questions/12756159/regex-and-iso8601-formatted-datetime
const ISO_8601_REGEX = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
function date$1() {
    const baseSchema = {
        parse: (raw, { breadcrumbsPrefix = [] } = {}) => {
            if (typeof raw !== "string") {
                return {
                    ok: false,
                    errors: [
                        {
                            path: breadcrumbsPrefix,
                            message: (0, getErrorMessageForIncorrectType_1$b.getErrorMessageForIncorrectType)(raw, "string"),
                        },
                    ],
                };
            }
            if (!ISO_8601_REGEX.test(raw)) {
                return {
                    ok: false,
                    errors: [
                        {
                            path: breadcrumbsPrefix,
                            message: (0, getErrorMessageForIncorrectType_1$b.getErrorMessageForIncorrectType)(raw, "ISO 8601 date string"),
                        },
                    ],
                };
            }
            return {
                ok: true,
                value: new Date(raw),
            };
        },
        json: (date, { breadcrumbsPrefix = [] } = {}) => {
            if (date instanceof Date) {
                return {
                    ok: true,
                    value: date.toISOString(),
                };
            }
            else {
                return {
                    ok: false,
                    errors: [
                        {
                            path: breadcrumbsPrefix,
                            message: (0, getErrorMessageForIncorrectType_1$b.getErrorMessageForIncorrectType)(date, "Date object"),
                        },
                    ],
                };
            }
        },
        getType: () => Schema_1$d.SchemaType.DATE,
    };
    return Object.assign(Object.assign({}, (0, maybeSkipValidation_1$7.maybeSkipValidation)(baseSchema)), (0, schema_utils_1$a.getSchemaUtils)(baseSchema));
}
date$2.date = date$1;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.date = void 0;
	var date_1 = date$2;
	Object.defineProperty(exports, "date", { enumerable: true, get: function () { return date_1.date; } }); 
} (date$3));

var _enum$1 = {};

var _enum = {};

var createIdentitySchemaCreator$1 = {};

Object.defineProperty(createIdentitySchemaCreator$1, "__esModule", { value: true });
createIdentitySchemaCreator$1.createIdentitySchemaCreator = void 0;
const schema_utils_1$9 = schemaUtils;
const maybeSkipValidation_1$6 = maybeSkipValidation$1;
function createIdentitySchemaCreator(schemaType, validate) {
    return () => {
        const baseSchema = {
            parse: validate,
            json: validate,
            getType: () => schemaType,
        };
        return Object.assign(Object.assign({}, (0, maybeSkipValidation_1$6.maybeSkipValidation)(baseSchema)), (0, schema_utils_1$9.getSchemaUtils)(baseSchema));
    };
}
createIdentitySchemaCreator$1.createIdentitySchemaCreator = createIdentitySchemaCreator;

Object.defineProperty(_enum, "__esModule", { value: true });
_enum.enum_ = void 0;
const Schema_1$c = Schema;
const createIdentitySchemaCreator_1$6 = createIdentitySchemaCreator$1;
const getErrorMessageForIncorrectType_1$a = getErrorMessageForIncorrectType$1;
function enum_(values) {
    const validValues = new Set(values);
    const schemaCreator = (0, createIdentitySchemaCreator_1$6.createIdentitySchemaCreator)(Schema_1$c.SchemaType.ENUM, (value, { allowUnrecognizedEnumValues, breadcrumbsPrefix = [] } = {}) => {
        if (typeof value !== "string") {
            return {
                ok: false,
                errors: [
                    {
                        path: breadcrumbsPrefix,
                        message: (0, getErrorMessageForIncorrectType_1$a.getErrorMessageForIncorrectType)(value, "string"),
                    },
                ],
            };
        }
        if (!validValues.has(value) && !allowUnrecognizedEnumValues) {
            return {
                ok: false,
                errors: [
                    {
                        path: breadcrumbsPrefix,
                        message: (0, getErrorMessageForIncorrectType_1$a.getErrorMessageForIncorrectType)(value, "enum"),
                    },
                ],
            };
        }
        return {
            ok: true,
            value: value,
        };
    });
    return schemaCreator();
}
_enum.enum_ = enum_;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.enum_ = void 0;
	var enum_1 = _enum;
	Object.defineProperty(exports, "enum_", { enumerable: true, get: function () { return enum_1.enum_; } }); 
} (_enum$1));

var lazy$2 = {};

var lazy$1 = {};

var __awaiter$r = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(lazy$1, "__esModule", { value: true });
lazy$1.getMemoizedSchema = lazy$1.constructLazyBaseSchema = lazy$1.lazy = void 0;
const schema_utils_1$8 = schemaUtils;
function lazy(getter) {
    const baseSchema = constructLazyBaseSchema(getter);
    return Object.assign(Object.assign({}, baseSchema), (0, schema_utils_1$8.getSchemaUtils)(baseSchema));
}
lazy$1.lazy = lazy;
function constructLazyBaseSchema(getter) {
    return {
        parse: (raw, opts) => __awaiter$r(this, void 0, void 0, function* () { return (yield getMemoizedSchema(getter)).parse(raw, opts); }),
        json: (parsed, opts) => __awaiter$r(this, void 0, void 0, function* () { return (yield getMemoizedSchema(getter)).json(parsed, opts); }),
        getType: () => __awaiter$r(this, void 0, void 0, function* () { return (yield getMemoizedSchema(getter)).getType(); }),
    };
}
lazy$1.constructLazyBaseSchema = constructLazyBaseSchema;
function getMemoizedSchema(getter) {
    return __awaiter$r(this, void 0, void 0, function* () {
        const castedGetter = getter;
        if (castedGetter.__zurg_memoized == null) {
            castedGetter.__zurg_memoized = yield getter();
        }
        return castedGetter.__zurg_memoized;
    });
}
lazy$1.getMemoizedSchema = getMemoizedSchema;

var lazyObject$1 = {};

var object$2 = {};

var object$1 = {};

var entries$1 = {};

Object.defineProperty(entries$1, "__esModule", { value: true });
entries$1.entries = void 0;
function entries(object) {
    return Object.entries(object);
}
entries$1.entries = entries;

var filterObject$1 = {};

Object.defineProperty(filterObject$1, "__esModule", { value: true });
filterObject$1.filterObject = void 0;
function filterObject(obj, keysToInclude) {
    const keysToIncludeSet = new Set(keysToInclude);
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (keysToIncludeSet.has(key)) {
            acc[key] = value;
        }
        return acc;
        // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
    }, {});
}
filterObject$1.filterObject = filterObject;

var isPlainObject$1 = {};

Object.defineProperty(isPlainObject$1, "__esModule", { value: true });
isPlainObject$1.isPlainObject = void 0;
// borrowed from https://github.com/lodash/lodash/blob/master/isPlainObject.js
function isPlainObject(value) {
    if (typeof value !== "object" || value === null) {
        return false;
    }
    if (Object.getPrototypeOf(value) === null) {
        return true;
    }
    let proto = value;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(value) === proto;
}
isPlainObject$1.isPlainObject = isPlainObject;

var keys$6 = {};

Object.defineProperty(keys$6, "__esModule", { value: true });
keys$6.keys = void 0;
function keys$5(object) {
    return Object.keys(object);
}
keys$6.keys = keys$5;

var partition$8 = {};

Object.defineProperty(partition$8, "__esModule", { value: true });
partition$8.partition = void 0;
function partition$7(items, predicate) {
    const trueItems = [], falseItems = [];
    for (const item of items) {
        if (predicate(item)) {
            trueItems.push(item);
        }
        else {
            falseItems.push(item);
        }
    }
    return [trueItems, falseItems];
}
partition$8.partition = partition$7;

var objectLike = {};

var getObjectLikeUtils$1 = {};

var __awaiter$q = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(getObjectLikeUtils$1, "__esModule", { value: true });
getObjectLikeUtils$1.withParsedProperties = getObjectLikeUtils$1.getObjectLikeUtils = void 0;
const filterObject_1$1 = filterObject$1;
const getErrorMessageForIncorrectType_1$9 = getErrorMessageForIncorrectType$1;
const isPlainObject_1$3 = isPlainObject$1;
const schema_utils_1$7 = schemaUtils;
function getObjectLikeUtils(schema) {
    return {
        withParsedProperties: (properties) => withParsedProperties(schema, properties),
    };
}
getObjectLikeUtils$1.getObjectLikeUtils = getObjectLikeUtils;
/**
 * object-like utils are defined in one file to resolve issues with circular imports
 */
function withParsedProperties(objectLike, properties) {
    const objectSchema = {
        parse: (raw, opts) => __awaiter$q(this, void 0, void 0, function* () {
            const parsedObject = yield objectLike.parse(raw, opts);
            if (!parsedObject.ok) {
                return parsedObject;
            }
            const additionalProperties = Object.entries(properties).reduce((processed, [key, value]) => {
                return Object.assign(Object.assign({}, processed), { [key]: typeof value === "function" ? value(parsedObject.value) : value });
            }, {});
            return {
                ok: true,
                value: Object.assign(Object.assign({}, parsedObject.value), additionalProperties),
            };
        }),
        json: (parsed, opts) => {
            var _a;
            if (!(0, isPlainObject_1$3.isPlainObject)(parsed)) {
                return {
                    ok: false,
                    errors: [
                        {
                            path: (_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : [],
                            message: (0, getErrorMessageForIncorrectType_1$9.getErrorMessageForIncorrectType)(parsed, "object"),
                        },
                    ],
                };
            }
            // strip out added properties
            const addedPropertyKeys = new Set(Object.keys(properties));
            const parsedWithoutAddedProperties = (0, filterObject_1$1.filterObject)(parsed, Object.keys(parsed).filter((key) => !addedPropertyKeys.has(key)));
            return objectLike.json(parsedWithoutAddedProperties, opts);
        },
        getType: () => objectLike.getType(),
    };
    return Object.assign(Object.assign(Object.assign({}, objectSchema), (0, schema_utils_1$7.getSchemaUtils)(objectSchema)), getObjectLikeUtils(objectSchema));
}
getObjectLikeUtils$1.withParsedProperties = withParsedProperties;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.withParsedProperties = exports.getObjectLikeUtils = void 0;
	var getObjectLikeUtils_1 = getObjectLikeUtils$1;
	Object.defineProperty(exports, "getObjectLikeUtils", { enumerable: true, get: function () { return getObjectLikeUtils_1.getObjectLikeUtils; } });
	Object.defineProperty(exports, "withParsedProperties", { enumerable: true, get: function () { return getObjectLikeUtils_1.withParsedProperties; } }); 
} (objectLike));

var property$3 = {};

Object.defineProperty(property$3, "__esModule", { value: true });
property$3.isProperty = property$3.property = void 0;
function property$2(rawKey, valueSchema) {
    return {
        rawKey,
        valueSchema,
        isProperty: true,
    };
}
property$3.property = property$2;
function isProperty(maybeProperty) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return maybeProperty.isProperty;
}
property$3.isProperty = isProperty;

var __awaiter$p = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(object$1, "__esModule", { value: true });
object$1.getObjectUtils = object$1.object = void 0;
const Schema_1$b = Schema;
const entries_1$1 = entries$1;
const filterObject_1 = filterObject$1;
const getErrorMessageForIncorrectType_1$8 = getErrorMessageForIncorrectType$1;
const isPlainObject_1$2 = isPlainObject$1;
const keys_1$1 = keys$6;
const maybeSkipValidation_1$5 = maybeSkipValidation$1;
const partition_1 = partition$8;
const object_like_1$2 = objectLike;
const schema_utils_1$6 = schemaUtils;
const property_1 = property$3;
function object(schemas) {
    const baseSchema = {
        _getRawProperties: () => Promise.resolve(Object.entries(schemas).map(([parsedKey, propertySchema]) => (0, property_1.isProperty)(propertySchema) ? propertySchema.rawKey : parsedKey)),
        _getParsedProperties: () => Promise.resolve((0, keys_1$1.keys)(schemas)),
        parse: (raw, opts) => __awaiter$p(this, void 0, void 0, function* () {
            const rawKeyToProperty = {};
            const requiredKeys = [];
            for (const [parsedKey, schemaOrObjectProperty] of (0, entries_1$1.entries)(schemas)) {
                const rawKey = (0, property_1.isProperty)(schemaOrObjectProperty) ? schemaOrObjectProperty.rawKey : parsedKey;
                const valueSchema = (0, property_1.isProperty)(schemaOrObjectProperty)
                    ? schemaOrObjectProperty.valueSchema
                    : schemaOrObjectProperty;
                const property = {
                    rawKey,
                    parsedKey: parsedKey,
                    valueSchema,
                };
                rawKeyToProperty[rawKey] = property;
                if (yield isSchemaRequired(valueSchema)) {
                    requiredKeys.push(rawKey);
                }
            }
            return validateAndTransformObject({
                value: raw,
                requiredKeys,
                getProperty: (rawKey) => {
                    const property = rawKeyToProperty[rawKey];
                    if (property == null) {
                        return undefined;
                    }
                    return {
                        transformedKey: property.parsedKey,
                        transform: (propertyValue) => {
                            var _a;
                            return property.valueSchema.parse(propertyValue, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), rawKey] }));
                        },
                    };
                },
                unrecognizedObjectKeys: opts === null || opts === void 0 ? void 0 : opts.unrecognizedObjectKeys,
                skipValidation: opts === null || opts === void 0 ? void 0 : opts.skipValidation,
                breadcrumbsPrefix: opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix,
            });
        }),
        json: (parsed, opts) => __awaiter$p(this, void 0, void 0, function* () {
            const requiredKeys = [];
            for (const [parsedKey, schemaOrObjectProperty] of (0, entries_1$1.entries)(schemas)) {
                const valueSchema = (0, property_1.isProperty)(schemaOrObjectProperty)
                    ? schemaOrObjectProperty.valueSchema
                    : schemaOrObjectProperty;
                if (yield isSchemaRequired(valueSchema)) {
                    requiredKeys.push(parsedKey);
                }
            }
            return validateAndTransformObject({
                value: parsed,
                requiredKeys,
                getProperty: (parsedKey) => {
                    const property = schemas[parsedKey];
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (property == null) {
                        return undefined;
                    }
                    if ((0, property_1.isProperty)(property)) {
                        return {
                            transformedKey: property.rawKey,
                            transform: (propertyValue) => {
                                var _a;
                                return property.valueSchema.json(propertyValue, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), parsedKey] }));
                            },
                        };
                    }
                    else {
                        return {
                            transformedKey: parsedKey,
                            transform: (propertyValue) => {
                                var _a;
                                return property.json(propertyValue, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), parsedKey] }));
                            },
                        };
                    }
                },
                unrecognizedObjectKeys: opts === null || opts === void 0 ? void 0 : opts.unrecognizedObjectKeys,
                skipValidation: opts === null || opts === void 0 ? void 0 : opts.skipValidation,
                breadcrumbsPrefix: opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix,
            });
        }),
        getType: () => Schema_1$b.SchemaType.OBJECT,
    };
    return Object.assign(Object.assign(Object.assign(Object.assign({}, (0, maybeSkipValidation_1$5.maybeSkipValidation)(baseSchema)), (0, schema_utils_1$6.getSchemaUtils)(baseSchema)), (0, object_like_1$2.getObjectLikeUtils)(baseSchema)), getObjectUtils(baseSchema));
}
object$1.object = object;
function validateAndTransformObject({ value, requiredKeys, getProperty, unrecognizedObjectKeys = "fail", skipValidation = false, breadcrumbsPrefix = [], }) {
    return __awaiter$p(this, void 0, void 0, function* () {
        if (!(0, isPlainObject_1$2.isPlainObject)(value)) {
            return {
                ok: false,
                errors: [
                    {
                        path: breadcrumbsPrefix,
                        message: (0, getErrorMessageForIncorrectType_1$8.getErrorMessageForIncorrectType)(value, "object"),
                    },
                ],
            };
        }
        const missingRequiredKeys = new Set(requiredKeys);
        const errors = [];
        const transformed = {};
        for (const [preTransformedKey, preTransformedItemValue] of Object.entries(value)) {
            const property = getProperty(preTransformedKey);
            if (property != null) {
                missingRequiredKeys.delete(preTransformedKey);
                const value = yield property.transform(preTransformedItemValue);
                if (value.ok) {
                    transformed[property.transformedKey] = value.value;
                }
                else {
                    transformed[preTransformedKey] = preTransformedItemValue;
                    errors.push(...value.errors);
                }
            }
            else {
                switch (unrecognizedObjectKeys) {
                    case "fail":
                        errors.push({
                            path: [...breadcrumbsPrefix, preTransformedKey],
                            message: `Unexpected key "${preTransformedKey}"`,
                        });
                        break;
                    case "strip":
                        break;
                    case "passthrough":
                        transformed[preTransformedKey] = preTransformedItemValue;
                        break;
                }
            }
        }
        errors.push(...requiredKeys
            .filter((key) => missingRequiredKeys.has(key))
            .map((key) => ({
            path: breadcrumbsPrefix,
            message: `Missing required key "${key}"`,
        })));
        if (errors.length === 0 || skipValidation) {
            return {
                ok: true,
                value: transformed,
            };
        }
        else {
            return {
                ok: false,
                errors,
            };
        }
    });
}
function getObjectUtils(schema) {
    return {
        extend: (extension) => {
            const baseSchema = {
                _getParsedProperties: () => __awaiter$p(this, void 0, void 0, function* () {
                    return [
                        ...(yield schema._getParsedProperties()),
                        ...(yield extension._getParsedProperties()),
                    ];
                }),
                _getRawProperties: () => __awaiter$p(this, void 0, void 0, function* () {
                    return [
                        ...(yield schema._getRawProperties()),
                        ...(yield extension._getRawProperties()),
                    ];
                }),
                parse: (raw, opts) => __awaiter$p(this, void 0, void 0, function* () {
                    return validateAndTransformExtendedObject({
                        extensionKeys: yield extension._getRawProperties(),
                        value: raw,
                        transformBase: (rawBase) => schema.parse(rawBase, opts),
                        transformExtension: (rawExtension) => extension.parse(rawExtension, opts),
                    });
                }),
                json: (parsed, opts) => __awaiter$p(this, void 0, void 0, function* () {
                    return validateAndTransformExtendedObject({
                        extensionKeys: yield extension._getParsedProperties(),
                        value: parsed,
                        transformBase: (parsedBase) => schema.json(parsedBase, opts),
                        transformExtension: (parsedExtension) => extension.json(parsedExtension, opts),
                    });
                }),
                getType: () => Schema_1$b.SchemaType.OBJECT,
            };
            return Object.assign(Object.assign(Object.assign(Object.assign({}, baseSchema), (0, schema_utils_1$6.getSchemaUtils)(baseSchema)), (0, object_like_1$2.getObjectLikeUtils)(baseSchema)), getObjectUtils(baseSchema));
        },
    };
}
object$1.getObjectUtils = getObjectUtils;
function validateAndTransformExtendedObject({ extensionKeys, value, transformBase, transformExtension, }) {
    return __awaiter$p(this, void 0, void 0, function* () {
        const extensionPropertiesSet = new Set(extensionKeys);
        const [extensionProperties, baseProperties] = (0, partition_1.partition)((0, keys_1$1.keys)(value), (key) => extensionPropertiesSet.has(key));
        const transformedBase = yield transformBase((0, filterObject_1.filterObject)(value, baseProperties));
        const transformedExtension = yield transformExtension((0, filterObject_1.filterObject)(value, extensionProperties));
        if (transformedBase.ok && transformedExtension.ok) {
            return {
                ok: true,
                value: Object.assign(Object.assign({}, transformedBase.value), transformedExtension.value),
            };
        }
        else {
            return {
                ok: false,
                errors: [
                    ...(transformedBase.ok ? [] : transformedBase.errors),
                    ...(transformedExtension.ok ? [] : transformedExtension.errors),
                ],
            };
        }
    });
}
function isSchemaRequired(schema) {
    return __awaiter$p(this, void 0, void 0, function* () {
        return !(yield isSchemaOptional(schema));
    });
}
function isSchemaOptional(schema) {
    return __awaiter$p(this, void 0, void 0, function* () {
        switch (yield schema.getType()) {
            case Schema_1$b.SchemaType.ANY:
            case Schema_1$b.SchemaType.UNKNOWN:
            case Schema_1$b.SchemaType.OPTIONAL:
                return true;
            default:
                return false;
        }
    });
}

var objectWithoutOptionalProperties$1 = {};

Object.defineProperty(objectWithoutOptionalProperties$1, "__esModule", { value: true });
objectWithoutOptionalProperties$1.objectWithoutOptionalProperties = void 0;
const object_1$1 = object$1;
function objectWithoutOptionalProperties(schemas) {
    return (0, object_1$1.object)(schemas);
}
objectWithoutOptionalProperties$1.objectWithoutOptionalProperties = objectWithoutOptionalProperties;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.property = exports.isProperty = exports.objectWithoutOptionalProperties = exports.object = exports.getObjectUtils = void 0;
	var object_1 = object$1;
	Object.defineProperty(exports, "getObjectUtils", { enumerable: true, get: function () { return object_1.getObjectUtils; } });
	Object.defineProperty(exports, "object", { enumerable: true, get: function () { return object_1.object; } });
	var objectWithoutOptionalProperties_1 = objectWithoutOptionalProperties$1;
	Object.defineProperty(exports, "objectWithoutOptionalProperties", { enumerable: true, get: function () { return objectWithoutOptionalProperties_1.objectWithoutOptionalProperties; } });
	var property_1 = property$3;
	Object.defineProperty(exports, "isProperty", { enumerable: true, get: function () { return property_1.isProperty; } });
	Object.defineProperty(exports, "property", { enumerable: true, get: function () { return property_1.property; } }); 
} (object$2));

var __awaiter$o = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(lazyObject$1, "__esModule", { value: true });
lazyObject$1.lazyObject = void 0;
const object_1 = object$2;
const object_like_1$1 = objectLike;
const schema_utils_1$5 = schemaUtils;
const lazy_1 = lazy$1;
function lazyObject(getter) {
    const baseSchema = Object.assign(Object.assign({}, (0, lazy_1.constructLazyBaseSchema)(getter)), { _getRawProperties: () => __awaiter$o(this, void 0, void 0, function* () { return (yield (0, lazy_1.getMemoizedSchema)(getter))._getRawProperties(); }), _getParsedProperties: () => __awaiter$o(this, void 0, void 0, function* () { return (yield (0, lazy_1.getMemoizedSchema)(getter))._getParsedProperties(); }) });
    return Object.assign(Object.assign(Object.assign(Object.assign({}, baseSchema), (0, schema_utils_1$5.getSchemaUtils)(baseSchema)), (0, object_like_1$1.getObjectLikeUtils)(baseSchema)), (0, object_1.getObjectUtils)(baseSchema));
}
lazyObject$1.lazyObject = lazyObject;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lazyObject = exports.lazy = void 0;
	var lazy_1 = lazy$1;
	Object.defineProperty(exports, "lazy", { enumerable: true, get: function () { return lazy_1.lazy; } });
	var lazyObject_1 = lazyObject$1;
	Object.defineProperty(exports, "lazyObject", { enumerable: true, get: function () { return lazyObject_1.lazyObject; } }); 
} (lazy$2));

var list$2 = {};

var list$1 = {};

var __awaiter$n = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(list$1, "__esModule", { value: true });
list$1.list = void 0;
const Schema_1$a = Schema;
const getErrorMessageForIncorrectType_1$7 = getErrorMessageForIncorrectType$1;
const maybeSkipValidation_1$4 = maybeSkipValidation$1;
const schema_utils_1$4 = schemaUtils;
function list(schema) {
    const baseSchema = {
        parse: (raw, opts) => __awaiter$n(this, void 0, void 0, function* () {
            return validateAndTransformArray(raw, (item, index) => {
                var _a;
                return schema.parse(item, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), `[${index}]`] }));
            });
        }),
        json: (parsed, opts) => validateAndTransformArray(parsed, (item, index) => {
            var _a;
            return schema.json(item, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), `[${index}]`] }));
        }),
        getType: () => Schema_1$a.SchemaType.LIST,
    };
    return Object.assign(Object.assign({}, (0, maybeSkipValidation_1$4.maybeSkipValidation)(baseSchema)), (0, schema_utils_1$4.getSchemaUtils)(baseSchema));
}
list$1.list = list;
function validateAndTransformArray(value, transformItem) {
    return __awaiter$n(this, void 0, void 0, function* () {
        if (!Array.isArray(value)) {
            return {
                ok: false,
                errors: [
                    {
                        message: (0, getErrorMessageForIncorrectType_1$7.getErrorMessageForIncorrectType)(value, "list"),
                        path: [],
                    },
                ],
            };
        }
        const maybeValidItems = yield Promise.all(value.map((item, index) => transformItem(item, index)));
        return maybeValidItems.reduce((acc, item) => {
            if (acc.ok && item.ok) {
                return {
                    ok: true,
                    value: [...acc.value, item.value],
                };
            }
            const errors = [];
            if (!acc.ok) {
                errors.push(...acc.errors);
            }
            if (!item.ok) {
                errors.push(...item.errors);
            }
            return {
                ok: false,
                errors,
            };
        }, { ok: true, value: [] });
    });
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.list = void 0;
	var list_1 = list$1;
	Object.defineProperty(exports, "list", { enumerable: true, get: function () { return list_1.list; } }); 
} (list$2));

var literals = {};

var stringLiteral$1 = {};

Object.defineProperty(stringLiteral$1, "__esModule", { value: true });
stringLiteral$1.stringLiteral = void 0;
const Schema_1$9 = Schema;
const createIdentitySchemaCreator_1$5 = createIdentitySchemaCreator$1;
const getErrorMessageForIncorrectType_1$6 = getErrorMessageForIncorrectType$1;
function stringLiteral(literal) {
    const schemaCreator = (0, createIdentitySchemaCreator_1$5.createIdentitySchemaCreator)(Schema_1$9.SchemaType.STRING_LITERAL, (value, { breadcrumbsPrefix = [] } = {}) => {
        if (value === literal) {
            return {
                ok: true,
                value: literal,
            };
        }
        else {
            return {
                ok: false,
                errors: [
                    {
                        path: breadcrumbsPrefix,
                        message: (0, getErrorMessageForIncorrectType_1$6.getErrorMessageForIncorrectType)(value, `"${literal}"`),
                    },
                ],
            };
        }
    });
    return schemaCreator();
}
stringLiteral$1.stringLiteral = stringLiteral;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.stringLiteral = void 0;
	var stringLiteral_1 = stringLiteral$1;
	Object.defineProperty(exports, "stringLiteral", { enumerable: true, get: function () { return stringLiteral_1.stringLiteral; } }); 
} (literals));

var primitives = {};

var any$1 = {};

Object.defineProperty(any$1, "__esModule", { value: true });
any$1.any = void 0;
const Schema_1$8 = Schema;
const createIdentitySchemaCreator_1$4 = createIdentitySchemaCreator$1;
any$1.any = (0, createIdentitySchemaCreator_1$4.createIdentitySchemaCreator)(Schema_1$8.SchemaType.ANY, (value) => ({ ok: true, value }));

var boolean$1 = {};

Object.defineProperty(boolean$1, "__esModule", { value: true });
boolean$1.boolean = void 0;
const Schema_1$7 = Schema;
const createIdentitySchemaCreator_1$3 = createIdentitySchemaCreator$1;
const getErrorMessageForIncorrectType_1$5 = getErrorMessageForIncorrectType$1;
boolean$1.boolean = (0, createIdentitySchemaCreator_1$3.createIdentitySchemaCreator)(Schema_1$7.SchemaType.BOOLEAN, (value, { breadcrumbsPrefix = [] } = {}) => {
    if (typeof value === "boolean") {
        return {
            ok: true,
            value,
        };
    }
    else {
        return {
            ok: false,
            errors: [
                {
                    path: breadcrumbsPrefix,
                    message: (0, getErrorMessageForIncorrectType_1$5.getErrorMessageForIncorrectType)(value, "boolean"),
                },
            ],
        };
    }
});

var number$3 = {};

Object.defineProperty(number$3, "__esModule", { value: true });
number$3.number = void 0;
const Schema_1$6 = Schema;
const createIdentitySchemaCreator_1$2 = createIdentitySchemaCreator$1;
const getErrorMessageForIncorrectType_1$4 = getErrorMessageForIncorrectType$1;
number$3.number = (0, createIdentitySchemaCreator_1$2.createIdentitySchemaCreator)(Schema_1$6.SchemaType.NUMBER, (value, { breadcrumbsPrefix = [] } = {}) => {
    if (typeof value === "number") {
        return {
            ok: true,
            value,
        };
    }
    else {
        return {
            ok: false,
            errors: [
                {
                    path: breadcrumbsPrefix,
                    message: (0, getErrorMessageForIncorrectType_1$4.getErrorMessageForIncorrectType)(value, "number"),
                },
            ],
        };
    }
});

var string$2 = {};

Object.defineProperty(string$2, "__esModule", { value: true });
string$2.string = void 0;
const Schema_1$5 = Schema;
const createIdentitySchemaCreator_1$1 = createIdentitySchemaCreator$1;
const getErrorMessageForIncorrectType_1$3 = getErrorMessageForIncorrectType$1;
string$2.string = (0, createIdentitySchemaCreator_1$1.createIdentitySchemaCreator)(Schema_1$5.SchemaType.STRING, (value, { breadcrumbsPrefix = [] } = {}) => {
    if (typeof value === "string") {
        return {
            ok: true,
            value,
        };
    }
    else {
        return {
            ok: false,
            errors: [
                {
                    path: breadcrumbsPrefix,
                    message: (0, getErrorMessageForIncorrectType_1$3.getErrorMessageForIncorrectType)(value, "string"),
                },
            ],
        };
    }
});

var unknown = {};

Object.defineProperty(unknown, "__esModule", { value: true });
unknown.unknown = void 0;
const Schema_1$4 = Schema;
const createIdentitySchemaCreator_1 = createIdentitySchemaCreator$1;
unknown.unknown = (0, createIdentitySchemaCreator_1.createIdentitySchemaCreator)(Schema_1$4.SchemaType.UNKNOWN, (value) => ({ ok: true, value }));

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.unknown = exports.string = exports.number = exports.boolean = exports.any = void 0;
	var any_1 = any$1;
	Object.defineProperty(exports, "any", { enumerable: true, get: function () { return any_1.any; } });
	var boolean_1 = boolean$1;
	Object.defineProperty(exports, "boolean", { enumerable: true, get: function () { return boolean_1.boolean; } });
	var number_1 = number$3;
	Object.defineProperty(exports, "number", { enumerable: true, get: function () { return number_1.number; } });
	var string_1 = string$2;
	Object.defineProperty(exports, "string", { enumerable: true, get: function () { return string_1.string; } });
	var unknown_1 = unknown;
	Object.defineProperty(exports, "unknown", { enumerable: true, get: function () { return unknown_1.unknown; } }); 
} (primitives));

var record$2 = {};

var record$1 = {};

var __awaiter$m = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(record$1, "__esModule", { value: true });
record$1.record = void 0;
const Schema_1$3 = Schema;
const entries_1 = entries$1;
const getErrorMessageForIncorrectType_1$2 = getErrorMessageForIncorrectType$1;
const isPlainObject_1$1 = isPlainObject$1;
const maybeSkipValidation_1$3 = maybeSkipValidation$1;
const schema_utils_1$3 = schemaUtils;
function record(keySchema, valueSchema) {
    const baseSchema = {
        parse: (raw, opts) => __awaiter$m(this, void 0, void 0, function* () {
            return validateAndTransformRecord({
                value: raw,
                isKeyNumeric: (yield keySchema.getType()) === Schema_1$3.SchemaType.NUMBER,
                transformKey: (key) => {
                    var _a;
                    return keySchema.parse(key, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), `${key} (key)`] }));
                },
                transformValue: (value, key) => {
                    var _a;
                    return valueSchema.parse(value, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), `${key}`] }));
                },
                breadcrumbsPrefix: opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix,
            });
        }),
        json: (parsed, opts) => __awaiter$m(this, void 0, void 0, function* () {
            return validateAndTransformRecord({
                value: parsed,
                isKeyNumeric: (yield keySchema.getType()) === Schema_1$3.SchemaType.NUMBER,
                transformKey: (key) => {
                    var _a;
                    return keySchema.json(key, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), `${key} (key)`] }));
                },
                transformValue: (value, key) => {
                    var _a;
                    return valueSchema.json(value, Object.assign(Object.assign({}, opts), { breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), `${key}`] }));
                },
                breadcrumbsPrefix: opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix,
            });
        }),
        getType: () => Schema_1$3.SchemaType.RECORD,
    };
    return Object.assign(Object.assign({}, (0, maybeSkipValidation_1$3.maybeSkipValidation)(baseSchema)), (0, schema_utils_1$3.getSchemaUtils)(baseSchema));
}
record$1.record = record;
function validateAndTransformRecord({ value, isKeyNumeric, transformKey, transformValue, breadcrumbsPrefix = [], }) {
    return __awaiter$m(this, void 0, void 0, function* () {
        if (!(0, isPlainObject_1$1.isPlainObject)(value)) {
            return {
                ok: false,
                errors: [
                    {
                        path: breadcrumbsPrefix,
                        message: (0, getErrorMessageForIncorrectType_1$2.getErrorMessageForIncorrectType)(value, "object"),
                    },
                ],
            };
        }
        return (0, entries_1.entries)(value).reduce((accPromise, [stringKey, value]) => __awaiter$m(this, void 0, void 0, function* () {
            // skip nullish keys
            if (value == null) {
                return accPromise;
            }
            const acc = yield accPromise;
            let key = stringKey;
            if (isKeyNumeric) {
                const numberKey = stringKey.length > 0 ? Number(stringKey) : NaN;
                if (!isNaN(numberKey)) {
                    key = numberKey;
                }
            }
            const transformedKey = yield transformKey(key);
            const transformedValue = yield transformValue(value, key);
            if (acc.ok && transformedKey.ok && transformedValue.ok) {
                return {
                    ok: true,
                    value: Object.assign(Object.assign({}, acc.value), { [transformedKey.value]: transformedValue.value }),
                };
            }
            const errors = [];
            if (!acc.ok) {
                errors.push(...acc.errors);
            }
            if (!transformedKey.ok) {
                errors.push(...transformedKey.errors);
            }
            if (!transformedValue.ok) {
                errors.push(...transformedValue.errors);
            }
            return {
                ok: false,
                errors,
            };
        }), Promise.resolve({ ok: true, value: {} }));
    });
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.record = void 0;
	var record_1 = record$1;
	Object.defineProperty(exports, "record", { enumerable: true, get: function () { return record_1.record; } }); 
} (record$2));

var set$f = {};

var set$e = {};

var __awaiter$l = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(set$e, "__esModule", { value: true });
set$e.set = void 0;
const Schema_1$2 = Schema;
const getErrorMessageForIncorrectType_1$1 = getErrorMessageForIncorrectType$1;
const maybeSkipValidation_1$2 = maybeSkipValidation$1;
const list_1 = list$2;
const schema_utils_1$2 = schemaUtils;
function set$d(schema) {
    const listSchema = (0, list_1.list)(schema);
    const baseSchema = {
        parse: (raw, opts) => __awaiter$l(this, void 0, void 0, function* () {
            const parsedList = yield listSchema.parse(raw, opts);
            if (parsedList.ok) {
                return {
                    ok: true,
                    value: new Set(parsedList.value),
                };
            }
            else {
                return parsedList;
            }
        }),
        json: (parsed, opts) => __awaiter$l(this, void 0, void 0, function* () {
            var _a;
            if (!(parsed instanceof Set)) {
                return {
                    ok: false,
                    errors: [
                        {
                            path: (_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : [],
                            message: (0, getErrorMessageForIncorrectType_1$1.getErrorMessageForIncorrectType)(parsed, "Set"),
                        },
                    ],
                };
            }
            const jsonList = yield listSchema.json([...parsed], opts);
            return jsonList;
        }),
        getType: () => Schema_1$2.SchemaType.SET,
    };
    return Object.assign(Object.assign({}, (0, maybeSkipValidation_1$2.maybeSkipValidation)(baseSchema)), (0, schema_utils_1$2.getSchemaUtils)(baseSchema));
}
set$e.set = set$d;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.set = void 0;
	var set_1 = set$e;
	Object.defineProperty(exports, "set", { enumerable: true, get: function () { return set_1.set; } }); 
} (set$f));

var undiscriminatedUnion$2 = {};

var undiscriminatedUnion$1 = {};

var __awaiter$k = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(undiscriminatedUnion$1, "__esModule", { value: true });
undiscriminatedUnion$1.undiscriminatedUnion = void 0;
const Schema_1$1 = Schema;
const maybeSkipValidation_1$1 = maybeSkipValidation$1;
const schema_utils_1$1 = schemaUtils;
function undiscriminatedUnion(schemas) {
    const baseSchema = {
        parse: (raw, opts) => __awaiter$k(this, void 0, void 0, function* () {
            return validateAndTransformUndiscriminatedUnion((schema, opts) => schema.parse(raw, opts), schemas, opts);
        }),
        json: (parsed, opts) => __awaiter$k(this, void 0, void 0, function* () {
            return validateAndTransformUndiscriminatedUnion((schema, opts) => schema.json(parsed, opts), schemas, opts);
        }),
        getType: () => Schema_1$1.SchemaType.UNDISCRIMINATED_UNION,
    };
    return Object.assign(Object.assign({}, (0, maybeSkipValidation_1$1.maybeSkipValidation)(baseSchema)), (0, schema_utils_1$1.getSchemaUtils)(baseSchema));
}
undiscriminatedUnion$1.undiscriminatedUnion = undiscriminatedUnion;
function validateAndTransformUndiscriminatedUnion(transform, schemas, opts) {
    return __awaiter$k(this, void 0, void 0, function* () {
        const errors = [];
        for (const [index, schema] of schemas.entries()) {
            const transformed = yield transform(schema, Object.assign(Object.assign({}, opts), { skipValidation: false }));
            if (transformed.ok) {
                return transformed;
            }
            else {
                for (const error of transformed.errors) {
                    errors.push({
                        path: error.path,
                        message: `[Variant ${index}] ${error.message}`,
                    });
                }
            }
        }
        return {
            ok: false,
            errors,
        };
    });
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.undiscriminatedUnion = void 0;
	var undiscriminatedUnion_1 = undiscriminatedUnion$1;
	Object.defineProperty(exports, "undiscriminatedUnion", { enumerable: true, get: function () { return undiscriminatedUnion_1.undiscriminatedUnion; } }); 
} (undiscriminatedUnion$2));

var union$b = {};

var discriminant$1 = {};

Object.defineProperty(discriminant$1, "__esModule", { value: true });
discriminant$1.discriminant = void 0;
function discriminant(parsedDiscriminant, rawDiscriminant) {
    return {
        parsedDiscriminant,
        rawDiscriminant,
    };
}
discriminant$1.discriminant = discriminant;

var union$a = {};

var __awaiter$j = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest$1 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(union$a, "__esModule", { value: true });
union$a.union = void 0;
const Schema_1 = Schema;
const getErrorMessageForIncorrectType_1 = getErrorMessageForIncorrectType$1;
const isPlainObject_1 = isPlainObject$1;
const keys_1 = keys$6;
const maybeSkipValidation_1 = maybeSkipValidation$1;
const enum_1 = _enum$1;
const object_like_1 = objectLike;
const schema_utils_1 = schemaUtils;
function union$9(discriminant, union) {
    const rawDiscriminant = typeof discriminant === "string" ? discriminant : discriminant.rawDiscriminant;
    const parsedDiscriminant = typeof discriminant === "string"
        ? discriminant
        : discriminant.parsedDiscriminant;
    const discriminantValueSchema = (0, enum_1.enum_)((0, keys_1.keys)(union));
    const baseSchema = {
        parse: (raw, opts) => __awaiter$j(this, void 0, void 0, function* () {
            return transformAndValidateUnion({
                value: raw,
                discriminant: rawDiscriminant,
                transformedDiscriminant: parsedDiscriminant,
                transformDiscriminantValue: (discriminantValue) => {
                    var _a;
                    return discriminantValueSchema.parse(discriminantValue, {
                        allowUnrecognizedEnumValues: opts === null || opts === void 0 ? void 0 : opts.allowUnrecognizedUnionMembers,
                        breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), rawDiscriminant],
                    });
                },
                getAdditionalPropertiesSchema: (discriminantValue) => union[discriminantValue],
                allowUnrecognizedUnionMembers: opts === null || opts === void 0 ? void 0 : opts.allowUnrecognizedUnionMembers,
                transformAdditionalProperties: (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.parse(additionalProperties, opts),
                breadcrumbsPrefix: opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix,
            });
        }),
        json: (parsed, opts) => __awaiter$j(this, void 0, void 0, function* () {
            return transformAndValidateUnion({
                value: parsed,
                discriminant: parsedDiscriminant,
                transformedDiscriminant: rawDiscriminant,
                transformDiscriminantValue: (discriminantValue) => {
                    var _a;
                    return discriminantValueSchema.json(discriminantValue, {
                        allowUnrecognizedEnumValues: opts === null || opts === void 0 ? void 0 : opts.allowUnrecognizedUnionMembers,
                        breadcrumbsPrefix: [...((_a = opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix) !== null && _a !== void 0 ? _a : []), parsedDiscriminant],
                    });
                },
                getAdditionalPropertiesSchema: (discriminantValue) => union[discriminantValue],
                allowUnrecognizedUnionMembers: opts === null || opts === void 0 ? void 0 : opts.allowUnrecognizedUnionMembers,
                transformAdditionalProperties: (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.json(additionalProperties, opts),
                breadcrumbsPrefix: opts === null || opts === void 0 ? void 0 : opts.breadcrumbsPrefix,
            });
        }),
        getType: () => Schema_1.SchemaType.UNION,
    };
    return Object.assign(Object.assign(Object.assign({}, (0, maybeSkipValidation_1.maybeSkipValidation)(baseSchema)), (0, schema_utils_1.getSchemaUtils)(baseSchema)), (0, object_like_1.getObjectLikeUtils)(baseSchema));
}
union$a.union = union$9;
function transformAndValidateUnion({ value, discriminant, transformedDiscriminant, transformDiscriminantValue, getAdditionalPropertiesSchema, allowUnrecognizedUnionMembers = false, transformAdditionalProperties, breadcrumbsPrefix = [], }) {
    return __awaiter$j(this, void 0, void 0, function* () {
        if (!(0, isPlainObject_1.isPlainObject)(value)) {
            return {
                ok: false,
                errors: [
                    {
                        path: breadcrumbsPrefix,
                        message: (0, getErrorMessageForIncorrectType_1.getErrorMessageForIncorrectType)(value, "object"),
                    },
                ],
            };
        }
        const _a = value, _b = discriminant, discriminantValue = _a[_b], additionalProperties = __rest$1(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        if (discriminantValue == null) {
            return {
                ok: false,
                errors: [
                    {
                        path: breadcrumbsPrefix,
                        message: `Missing discriminant ("${discriminant}")`,
                    },
                ],
            };
        }
        const transformedDiscriminantValue = yield transformDiscriminantValue(discriminantValue);
        if (!transformedDiscriminantValue.ok) {
            return {
                ok: false,
                errors: transformedDiscriminantValue.errors,
            };
        }
        const additionalPropertiesSchema = getAdditionalPropertiesSchema(transformedDiscriminantValue.value);
        if (additionalPropertiesSchema == null) {
            if (allowUnrecognizedUnionMembers) {
                return {
                    ok: true,
                    value: Object.assign({ [transformedDiscriminant]: transformedDiscriminantValue.value }, additionalProperties),
                };
            }
            else {
                return {
                    ok: false,
                    errors: [
                        {
                            path: [...breadcrumbsPrefix, discriminant],
                            message: "Unexpected discriminant value",
                        },
                    ],
                };
            }
        }
        const transformedAdditionalProperties = yield transformAdditionalProperties(additionalProperties, additionalPropertiesSchema);
        if (!transformedAdditionalProperties.ok) {
            return transformedAdditionalProperties;
        }
        return {
            ok: true,
            value: Object.assign({ [transformedDiscriminant]: discriminantValue }, transformedAdditionalProperties.value),
        };
    });
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.union = exports.discriminant = void 0;
	var discriminant_1 = discriminant$1;
	Object.defineProperty(exports, "discriminant", { enumerable: true, get: function () { return discriminant_1.discriminant; } });
	var union_1 = union$a;
	Object.defineProperty(exports, "union", { enumerable: true, get: function () { return union_1.union; } }); 
} (union$b));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(date$3, exports);
	__exportStar(_enum$1, exports);
	__exportStar(lazy$2, exports);
	__exportStar(list$2, exports);
	__exportStar(literals, exports);
	__exportStar(object$2, exports);
	__exportStar(objectLike, exports);
	__exportStar(primitives, exports);
	__exportStar(record$2, exports);
	__exportStar(schemaUtils, exports);
	__exportStar(set$f, exports);
	__exportStar(undiscriminatedUnion$2, exports);
	__exportStar(union$b, exports); 
} (builders));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(builders, exports); 
} (schemas));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.serialization = void 0;
	__exportStar(fetcher, exports);
	__exportStar(auth$2, exports);
	__exportStar(streamingFetcher$1, exports);
	__exportStar(formDataUtils, exports);
	exports.serialization = __importStar(schemas); 
} (core$1H));

var api = {};

var resources$1 = {};

var agents$1 = {};

var types$F = {};

var ListAgentsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListAgentsResponse$1, "__esModule", { value: true });

var AgentResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(AgentResponse$1, "__esModule", { value: true });

var AgentConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(AgentConfig$1, "__esModule", { value: true });

var Agent$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Agent$1, "__esModule", { value: true });

var Compiler$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Compiler$1, "__esModule", { value: true });
Compiler$1.Compiler = void 0;
Compiler$1.Compiler = {
    Js: "js",
};

var GetAgentLogsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GetAgentLogsResponse$1, "__esModule", { value: true });

var GetDetailedAgentLogResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GetDetailedAgentLogResponse$1, "__esModule", { value: true });

var GetDetailedAgentLogsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GetDetailedAgentLogsResponse$1, "__esModule", { value: true });

var GetExecutionsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GetExecutionsResponse$1, "__esModule", { value: true });

var AgentLog$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(AgentLog$1, "__esModule", { value: true });

var DetailedAgentLog$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DetailedAgentLog$1, "__esModule", { value: true });

var Execution$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Execution$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListAgentsResponse$1, exports);
	__exportStar(AgentResponse$1, exports);
	__exportStar(AgentConfig$1, exports);
	__exportStar(Agent$1, exports);
	__exportStar(Compiler$1, exports);
	__exportStar(GetAgentLogsResponse$1, exports);
	__exportStar(GetDetailedAgentLogResponse$1, exports);
	__exportStar(GetDetailedAgentLogsResponse$1, exports);
	__exportStar(GetExecutionsResponse$1, exports);
	__exportStar(AgentLog$1, exports);
	__exportStar(DetailedAgentLog$1, exports);
	__exportStar(Execution$1, exports); 
} (types$F));

var client$q = {};

var requests$k = {};

Object.defineProperty(requests$k, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$k, exports); 
} (client$q));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$F, exports);
	__exportStar(client$q, exports); 
} (agents$1));

var auth$1 = {};

var types$E = {};

var ApiKeysResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ApiKeysResponse$1, "__esModule", { value: true });

var ApiKeyType$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ApiKeyType$1, "__esModule", { value: true });
ApiKeyType$1.ApiKeyType = void 0;
ApiKeyType$1.ApiKeyType = {
    Publishable: "PUBLISHABLE",
    Secret: "SECRET",
};

var ApiKeyOperation$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ApiKeyOperation$1, "__esModule", { value: true });

var ApiKey$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ApiKey$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ApiKeysResponse$1, exports);
	__exportStar(ApiKeyType$1, exports);
	__exportStar(ApiKeyOperation$1, exports);
	__exportStar(ApiKey$1, exports); 
} (types$E));

var client$p = {};

var requests$j = {};

Object.defineProperty(requests$j, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$j, exports); 
} (client$p));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$E, exports);
	__exportStar(client$p, exports); 
} (auth$1));

var cells$1 = {};

var types$D = {};

var CellsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CellsResponse$1, "__esModule", { value: true });

var CellsResponseData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CellsResponseData$1, "__esModule", { value: true });

var CellValueWithCounts$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CellValueWithCounts$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(CellsResponse$1, exports);
	__exportStar(CellsResponseData$1, exports);
	__exportStar(CellValueWithCounts$1, exports); 
} (types$D));

var client$o = {};

var requests$i = {};

Object.defineProperty(requests$i, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$i, exports); 
} (client$o));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$D, exports);
	__exportStar(client$o, exports); 
} (cells$1));

var commits$1 = {};

var types$C = {};

var ListCommitsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListCommitsResponse$1, "__esModule", { value: true });

var CommitResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CommitResponse$1, "__esModule", { value: true });

var Commit$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Commit$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListCommitsResponse$1, exports);
	__exportStar(CommitResponse$1, exports);
	__exportStar(Commit$1, exports); 
} (types$C));

var client$n = {};

Object.defineProperty(client$n, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$C, exports);
	__exportStar(client$n, exports); 
} (commits$1));

var commons$1 = {};

var types$B = {};

var AgentId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(AgentId$1, "__esModule", { value: true });

var AccountId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(AccountId$1, "__esModule", { value: true });

var DocumentId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DocumentId$1, "__esModule", { value: true });

var GuestId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GuestId$1, "__esModule", { value: true });

var EnvironmentId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnvironmentId$1, "__esModule", { value: true });

var FileId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FileId$1, "__esModule", { value: true });

var SpaceId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SpaceId$1, "__esModule", { value: true });

var WorkbookId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(WorkbookId$1, "__esModule", { value: true });

var EventId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EventId$1, "__esModule", { value: true });

var SheetId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetId$1, "__esModule", { value: true });

var SnapshotId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SnapshotId$1, "__esModule", { value: true });

var VersionId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(VersionId$1, "__esModule", { value: true });

var JobId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobId$1, "__esModule", { value: true });

var UserId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(UserId$1, "__esModule", { value: true });

var SpaceConfigId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SpaceConfigId$1, "__esModule", { value: true });

var RecordId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordId$1, "__esModule", { value: true });

var SecretId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SecretId$1, "__esModule", { value: true });

var MappingId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingId$1, "__esModule", { value: true });

var Pagination$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Pagination$1, "__esModule", { value: true });

var Action$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Action$1, "__esModule", { value: true });

var InputForm$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InputForm$1, "__esModule", { value: true });

var InputFormType$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InputFormType$1, "__esModule", { value: true });
InputFormType$1.InputFormType = void 0;
InputFormType$1.InputFormType = {
    Simple: "simple",
};

var InputField$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InputField$1, "__esModule", { value: true });

var InputConstraint$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InputConstraint$1, "__esModule", { value: true });

var InputConstraintType$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InputConstraintType$1, "__esModule", { value: true });
InputConstraintType$1.InputConstraintType = void 0;
InputConstraintType$1.InputConstraintType = {
    Required: "required",
};

var InputConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InputConfig$1, "__esModule", { value: true });

var InputEnumPropertyOption$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InputEnumPropertyOption$1, "__esModule", { value: true });

var ActionMode$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ActionMode$1, "__esModule", { value: true });
ActionMode$1.ActionMode = void 0;
ActionMode$1.ActionMode = {
    Foreground: "foreground",
    Background: "background",
    ToolbarBlocking: "toolbarBlocking",
};

var ActionSchedule$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ActionSchedule$1, "__esModule", { value: true });
ActionSchedule$1.ActionSchedule = void 0;
ActionSchedule$1.ActionSchedule = {
    Weekly: "weekly",
    Daily: "daily",
    Hourly: "hourly",
};

var SortDirection$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SortDirection$1, "__esModule", { value: true });
SortDirection$1.SortDirection = void 0;
SortDirection$1.SortDirection = {
    Asc: "asc",
    Desc: "desc",
};

var Success$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Success$1, "__esModule", { value: true });

var SuccessData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SuccessData$1, "__esModule", { value: true });

var Error_$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Error_$1, "__esModule", { value: true });

var Errors$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Errors$1, "__esModule", { value: true });

var Filter$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Filter$1, "__esModule", { value: true });
Filter$1.Filter = void 0;
Filter$1.Filter = {
    Valid: "valid",
    Error: "error",
    All: "all",
    None: "none",
};

var FilterField$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FilterField$1, "__esModule", { value: true });

var SearchField$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SearchField$1, "__esModule", { value: true });

var SearchValue$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SearchValue$1, "__esModule", { value: true });

var SortField$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SortField$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(AgentId$1, exports);
	__exportStar(AccountId$1, exports);
	__exportStar(DocumentId$1, exports);
	__exportStar(GuestId$1, exports);
	__exportStar(EnvironmentId$1, exports);
	__exportStar(FileId$1, exports);
	__exportStar(SpaceId$1, exports);
	__exportStar(WorkbookId$1, exports);
	__exportStar(EventId$1, exports);
	__exportStar(SheetId$1, exports);
	__exportStar(SnapshotId$1, exports);
	__exportStar(VersionId$1, exports);
	__exportStar(JobId$1, exports);
	__exportStar(UserId$1, exports);
	__exportStar(SpaceConfigId$1, exports);
	__exportStar(RecordId$1, exports);
	__exportStar(SecretId$1, exports);
	__exportStar(MappingId$1, exports);
	__exportStar(Pagination$1, exports);
	__exportStar(Action$1, exports);
	__exportStar(InputForm$1, exports);
	__exportStar(InputFormType$1, exports);
	__exportStar(InputField$1, exports);
	__exportStar(InputConstraint$1, exports);
	__exportStar(InputConstraintType$1, exports);
	__exportStar(InputConfig$1, exports);
	__exportStar(InputEnumPropertyOption$1, exports);
	__exportStar(ActionMode$1, exports);
	__exportStar(ActionSchedule$1, exports);
	__exportStar(SortDirection$1, exports);
	__exportStar(Success$1, exports);
	__exportStar(SuccessData$1, exports);
	__exportStar(Error_$1, exports);
	__exportStar(Errors$1, exports);
	__exportStar(Filter$1, exports);
	__exportStar(FilterField$1, exports);
	__exportStar(SearchField$1, exports);
	__exportStar(SearchValue$1, exports);
	__exportStar(SortField$1, exports); 
} (types$B));

var errors$m = {};

var BadRequestError$1 = {};

var errors$l = {};

var FlatfileError$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FlatfileError$1, "__esModule", { value: true });
FlatfileError$1.FlatfileError = void 0;
class FlatfileError extends Error {
    constructor({ message, statusCode, body }) {
        super(buildMessage({ message, statusCode, body }));
        Object.setPrototypeOf(this, FlatfileError.prototype);
        if (statusCode != null) {
            this.statusCode = statusCode;
        }
        if (body !== undefined) {
            this.body = body;
        }
    }
}
FlatfileError$1.FlatfileError = FlatfileError;
function buildMessage({ message, statusCode, body, }) {
    let lines = [];
    if (message != null) {
        lines.push(message);
    }
    if (statusCode != null) {
        lines.push(`Status code: ${statusCode.toString()}`);
    }
    if (body != null) {
        lines.push(`Body: ${JSON.stringify(body, undefined, 2)}`);
    }
    return lines.join("\n");
}

var FlatfileTimeoutError$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FlatfileTimeoutError$1, "__esModule", { value: true });
FlatfileTimeoutError$1.FlatfileTimeoutError = void 0;
class FlatfileTimeoutError extends Error {
    constructor() {
        super("Timeout");
        Object.setPrototypeOf(this, FlatfileTimeoutError.prototype);
    }
}
FlatfileTimeoutError$1.FlatfileTimeoutError = FlatfileTimeoutError;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FlatfileTimeoutError = exports.FlatfileError = void 0;
	var FlatfileError_1 = FlatfileError$1;
	Object.defineProperty(exports, "FlatfileError", { enumerable: true, get: function () { return FlatfileError_1.FlatfileError; } });
	var FlatfileTimeoutError_1 = FlatfileTimeoutError$1;
	Object.defineProperty(exports, "FlatfileTimeoutError", { enumerable: true, get: function () { return FlatfileTimeoutError_1.FlatfileTimeoutError; } }); 
} (errors$l));

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1I = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1I = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1I = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1I(result, mod, k);
    __setModuleDefault$1I(result, mod);
    return result;
};
Object.defineProperty(BadRequestError$1, "__esModule", { value: true });
BadRequestError$1.BadRequestError = void 0;
const errors$k = __importStar$1I(errors$l);
class BadRequestError extends errors$k.FlatfileError {
    constructor(body) {
        super({
            message: "BadRequestError",
            statusCode: 400,
            body: body,
        });
        Object.setPrototypeOf(this, BadRequestError.prototype);
    }
}
BadRequestError$1.BadRequestError = BadRequestError;

var NotFoundError$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1H = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1H = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1H = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1H(result, mod, k);
    __setModuleDefault$1H(result, mod);
    return result;
};
Object.defineProperty(NotFoundError$1, "__esModule", { value: true });
NotFoundError$1.NotFoundError = void 0;
const errors$j = __importStar$1H(errors$l);
class NotFoundError extends errors$j.FlatfileError {
    constructor(body) {
        super({
            message: "NotFoundError",
            statusCode: 404,
            body: body,
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
NotFoundError$1.NotFoundError = NotFoundError;

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(BadRequestError$1, exports);
	__exportStar(NotFoundError$1, exports); 
} (errors$m));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$B, exports);
	__exportStar(errors$m, exports); 
} (commons$1));

var documents$1 = {};

var types$A = {};

var ListDocumentsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListDocumentsResponse$1, "__esModule", { value: true });

var DocumentResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DocumentResponse$1, "__esModule", { value: true });

var DocumentConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DocumentConfig$1, "__esModule", { value: true });

var Document$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Document$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListDocumentsResponse$1, exports);
	__exportStar(DocumentResponse$1, exports);
	__exportStar(DocumentConfig$1, exports);
	__exportStar(Document$1, exports); 
} (types$A));

var client$m = {};

Object.defineProperty(client$m, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$A, exports);
	__exportStar(client$m, exports); 
} (documents$1));

var environments$k = {};

var types$z = {};

var ListEnvironmentsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListEnvironmentsResponse$1, "__esModule", { value: true });

var EnvironmentResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnvironmentResponse$1, "__esModule", { value: true });

var Environment$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Environment$1, "__esModule", { value: true });

var EnvironmentConfigCreate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnvironmentConfigCreate$1, "__esModule", { value: true });

var EnvironmentConfigUpdate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnvironmentConfigUpdate$1, "__esModule", { value: true });

var GuestAuthenticationEnum$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GuestAuthenticationEnum$1, "__esModule", { value: true });
GuestAuthenticationEnum$1.GuestAuthenticationEnum = void 0;
GuestAuthenticationEnum$1.GuestAuthenticationEnum = {
    SharedLink: "shared_link",
    MagicLink: "magic_link",
};

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListEnvironmentsResponse$1, exports);
	__exportStar(EnvironmentResponse$1, exports);
	__exportStar(Environment$1, exports);
	__exportStar(EnvironmentConfigCreate$1, exports);
	__exportStar(EnvironmentConfigUpdate$1, exports);
	__exportStar(GuestAuthenticationEnum$1, exports); 
} (types$z));

var client$l = {};

var requests$h = {};

Object.defineProperty(requests$h, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$h, exports); 
} (client$l));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$z, exports);
	__exportStar(client$l, exports); 
} (environments$k));

var events$1 = {};

var types$y = {};

var ListAllEventsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListAllEventsResponse$1, "__esModule", { value: true });

var CreateEventConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CreateEventConfig$1, "__esModule", { value: true });

var EventResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EventResponse$1, "__esModule", { value: true });

var Event$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Event$1, "__esModule", { value: true });

var GenericEvent$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GenericEvent$1, "__esModule", { value: true });

var BaseEvent$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(BaseEvent$1, "__esModule", { value: true });

var EventTopic$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EventTopic$1, "__esModule", { value: true });
EventTopic$1.EventTopic = void 0;
EventTopic$1.EventTopic = {
    AgentCreated: "agent:created",
    AgentUpdated: "agent:updated",
    AgentDeleted: "agent:deleted",
    SpaceCreated: "space:created",
    SpaceUpdated: "space:updated",
    SpaceDeleted: "space:deleted",
    DocumentCreated: "document:created",
    DocumentUpdated: "document:updated",
    DocumentDeleted: "document:deleted",
    WorkbookCreated: "workbook:created",
    WorkbookUpdated: "workbook:updated",
    WorkbookDeleted: "workbook:deleted",
    SheetCreated: "sheet:created",
    SheetUpdated: "sheet:updated",
    SheetDeleted: "sheet:deleted",
    SnapshotCreated: "snapshot:created",
    RecordsCreated: "records:created",
    RecordsUpdated: "records:updated",
    RecordsDeleted: "records:deleted",
    FileCreated: "file:created",
    FileUpdated: "file:updated",
    FileDeleted: "file:deleted",
    JobCreated: "job:created",
    JobUpdated: "job:updated",
    JobDeleted: "job:deleted",
    JobCompleted: "job:completed",
    JobReady: "job:ready",
    JobScheduled: "job:scheduled",
    JobOutcomeAcknowledged: "job:outcome-acknowledged",
    JobFailed: "job:failed",
    CommitCreated: "commit:created",
    CommitUpdated: "commit:updated",
    CommitCompleted: "commit:completed",
    LayerCreated: "layer:created",
};

var Domain$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Domain$1, "__esModule", { value: true });
Domain$1.Domain = void 0;
Domain$1.Domain = {
    File: "file",
    Space: "space",
    Workbook: "workbook",
    Job: "job",
    Document: "document",
    Sheet: "sheet",
};

var Context$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Context$1, "__esModule", { value: true });

var EventContextSlugs$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EventContextSlugs$1, "__esModule", { value: true });

var ActionName$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ActionName$1, "__esModule", { value: true });

var Progress$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Progress$1, "__esModule", { value: true });

var EventAttributes$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EventAttributes$1, "__esModule", { value: true });

var SheetSlug$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetSlug$1, "__esModule", { value: true });

var Origin$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Origin$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListAllEventsResponse$1, exports);
	__exportStar(CreateEventConfig$1, exports);
	__exportStar(EventResponse$1, exports);
	__exportStar(Event$1, exports);
	__exportStar(GenericEvent$1, exports);
	__exportStar(BaseEvent$1, exports);
	__exportStar(EventTopic$1, exports);
	__exportStar(Domain$1, exports);
	__exportStar(Context$1, exports);
	__exportStar(EventContextSlugs$1, exports);
	__exportStar(ActionName$1, exports);
	__exportStar(Progress$1, exports);
	__exportStar(EventAttributes$1, exports);
	__exportStar(SheetSlug$1, exports);
	__exportStar(Origin$1, exports); 
} (types$y));

var client$k = {};

var requests$g = {};

Object.defineProperty(requests$g, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$g, exports); 
} (client$k));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$y, exports);
	__exportStar(client$k, exports); 
} (events$1));

var files$1 = {};

var types$x = {};

var ListFilesResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListFilesResponse$1, "__esModule", { value: true });

var FileResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FileResponse$1, "__esModule", { value: true });

var File_$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(File_$1, "__esModule", { value: true });

var ModelFileStatusEnum$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ModelFileStatusEnum$1, "__esModule", { value: true });
ModelFileStatusEnum$1.ModelFileStatusEnum = void 0;
ModelFileStatusEnum$1.ModelFileStatusEnum = {
    Partial: "partial",
    Complete: "complete",
    Archived: "archived",
    Purged: "purged",
    Failed: "failed",
};

var Mode$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Mode$1, "__esModule", { value: true });
Mode$1.Mode = void 0;
Mode$1.Mode = {
    Import: "import",
    Export: "export",
};

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListFilesResponse$1, exports);
	__exportStar(FileResponse$1, exports);
	__exportStar(File_$1, exports);
	__exportStar(ModelFileStatusEnum$1, exports);
	__exportStar(Mode$1, exports); 
} (types$x));

var client$j = {};

var requests$f = {};

Object.defineProperty(requests$f, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$f, exports); 
} (client$j));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$x, exports);
	__exportStar(client$j, exports); 
} (files$1));

var guests$1 = {};

var types$w = {};

var ListGuestsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListGuestsResponse$1, "__esModule", { value: true });

var CreateGuestResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CreateGuestResponse$1, "__esModule", { value: true });

var GuestResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GuestResponse$1, "__esModule", { value: true });

var Guest$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Guest$1, "__esModule", { value: true });

var GuestConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GuestConfig$1, "__esModule", { value: true });

var GuestConfigUpdate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GuestConfigUpdate$1, "__esModule", { value: true });

var GuestWorkbook$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GuestWorkbook$1, "__esModule", { value: true });

var GuestSpace$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GuestSpace$1, "__esModule", { value: true });

var Invite$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Invite$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListGuestsResponse$1, exports);
	__exportStar(CreateGuestResponse$1, exports);
	__exportStar(GuestResponse$1, exports);
	__exportStar(Guest$1, exports);
	__exportStar(GuestConfig$1, exports);
	__exportStar(GuestConfigUpdate$1, exports);
	__exportStar(GuestWorkbook$1, exports);
	__exportStar(GuestSpace$1, exports);
	__exportStar(Invite$1, exports); 
} (types$w));

var client$i = {};

var requests$e = {};

Object.defineProperty(requests$e, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$e, exports); 
} (client$i));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$w, exports);
	__exportStar(client$i, exports); 
} (guests$1));

var jobs$1 = {};

var types$v = {};

var ListJobsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListJobsResponse$1, "__esModule", { value: true });

var JobResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobResponse$1, "__esModule", { value: true });

var JobPlanResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobPlanResponse$1, "__esModule", { value: true });

var Job$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Job$1, "__esModule", { value: true });

var JobConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobConfig$1, "__esModule", { value: true });

var JobUpdate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobUpdate$1, "__esModule", { value: true });

var JobUpdateConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobUpdateConfig$1, "__esModule", { value: true });

var JobSource$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobSource$1, "__esModule", { value: true });

var JobDestination$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobDestination$1, "__esModule", { value: true });

var DeleteRecordsJobConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DeleteRecordsJobConfig$1, "__esModule", { value: true });

var FileJobConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FileJobConfig$1, "__esModule", { value: true });

var MutateJobConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MutateJobConfig$1, "__esModule", { value: true });

var Driver$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Driver$1, "__esModule", { value: true });
Driver$1.Driver = void 0;
Driver$1.Driver = {
    Csv: "csv",
};

var Trigger$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Trigger$1, "__esModule", { value: true });
Trigger$1.Trigger = void 0;
Trigger$1.Trigger = {
    Manual: "manual",
    Immediate: "immediate",
};

var PipelineJobConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(PipelineJobConfig$1, "__esModule", { value: true });

var JobType$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobType$1, "__esModule", { value: true });
JobType$1.JobType = void 0;
JobType$1.JobType = {
    File: "file",
    Workbook: "workbook",
    Sheet: "sheet",
};

var JobStatus$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobStatus$1, "__esModule", { value: true });
JobStatus$1.JobStatus = void 0;
JobStatus$1.JobStatus = {
    Planning: "planning",
    Ready: "ready",
    Executing: "executing",
    Complete: "complete",
    Failed: "failed",
};

var JobMode$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobMode$1, "__esModule", { value: true });
JobMode$1.JobMode = void 0;
JobMode$1.JobMode = {
    Foreground: "foreground",
    Background: "background",
    ToolbarBlocking: "toolbarBlocking",
};

var JobSubject$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobSubject$1, "__esModule", { value: true });

var CollectionJobSubject$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CollectionJobSubject$1, "__esModule", { value: true });

var ResourceJobSubject$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ResourceJobSubject$1, "__esModule", { value: true });

var JobPlan$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobPlan$1, "__esModule", { value: true });

var JobExecutionPlanRequest$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobExecutionPlanRequest$1, "__esModule", { value: true });

var JobExecutionPlanConfigRequest$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobExecutionPlanConfigRequest$1, "__esModule", { value: true });

var JobAckDetails$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobAckDetails$1, "__esModule", { value: true });

var JobCompleteDetails$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobCompleteDetails$1, "__esModule", { value: true });

var JobOutcome$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobOutcome$1, "__esModule", { value: true });

var JobOutcomeNext$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobOutcomeNext$1, "__esModule", { value: true });

var JobOutcomeNextId$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobOutcomeNextId$1, "__esModule", { value: true });

var JobOutcomeNextUrl$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobOutcomeNextUrl$1, "__esModule", { value: true });

var JobOutcomeNextDownload$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobOutcomeNextDownload$1, "__esModule", { value: true });

var JobOutcomeNextWait$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobOutcomeNextWait$1, "__esModule", { value: true });

var JobCancelDetails$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobCancelDetails$1, "__esModule", { value: true });

var JobExecutionPlan$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobExecutionPlan$1, "__esModule", { value: true });

var JobExecutionPlanConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(JobExecutionPlanConfig$1, "__esModule", { value: true });

var Edge$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Edge$1, "__esModule", { value: true });

var SourceField$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SourceField$1, "__esModule", { value: true });

var DestinationField$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DestinationField$1, "__esModule", { value: true });

var EnumDetails$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnumDetails$1, "__esModule", { value: true });

var EnumValue$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnumValue$1, "__esModule", { value: true });

var Metadata$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Metadata$1, "__esModule", { value: true });

var Certainty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Certainty$1, "__esModule", { value: true });
Certainty$1.Certainty = void 0;
Certainty$1.Certainty = {
    Absolute: "absolute",
    Strong: "strong",
    Moderate: "moderate",
    Weak: "weak",
};

var CategoryMapping$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CategoryMapping$1, "__esModule", { value: true });

var FindAndReplaceJobConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FindAndReplaceJobConfig$1, "__esModule", { value: true });

var ExportJobConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ExportJobConfig$1, "__esModule", { value: true });

var ExportOptions$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ExportOptions$1, "__esModule", { value: true });

var EmptyObject$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EmptyObject$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListJobsResponse$1, exports);
	__exportStar(JobResponse$1, exports);
	__exportStar(JobPlanResponse$1, exports);
	__exportStar(Job$1, exports);
	__exportStar(JobConfig$1, exports);
	__exportStar(JobUpdate$1, exports);
	__exportStar(JobUpdateConfig$1, exports);
	__exportStar(JobSource$1, exports);
	__exportStar(JobDestination$1, exports);
	__exportStar(DeleteRecordsJobConfig$1, exports);
	__exportStar(FileJobConfig$1, exports);
	__exportStar(MutateJobConfig$1, exports);
	__exportStar(Driver$1, exports);
	__exportStar(Trigger$1, exports);
	__exportStar(PipelineJobConfig$1, exports);
	__exportStar(JobType$1, exports);
	__exportStar(JobStatus$1, exports);
	__exportStar(JobMode$1, exports);
	__exportStar(JobSubject$1, exports);
	__exportStar(CollectionJobSubject$1, exports);
	__exportStar(ResourceJobSubject$1, exports);
	__exportStar(JobPlan$1, exports);
	__exportStar(JobExecutionPlanRequest$1, exports);
	__exportStar(JobExecutionPlanConfigRequest$1, exports);
	__exportStar(JobAckDetails$1, exports);
	__exportStar(JobCompleteDetails$1, exports);
	__exportStar(JobOutcome$1, exports);
	__exportStar(JobOutcomeNext$1, exports);
	__exportStar(JobOutcomeNextId$1, exports);
	__exportStar(JobOutcomeNextUrl$1, exports);
	__exportStar(JobOutcomeNextDownload$1, exports);
	__exportStar(JobOutcomeNextWait$1, exports);
	__exportStar(JobCancelDetails$1, exports);
	__exportStar(JobExecutionPlan$1, exports);
	__exportStar(JobExecutionPlanConfig$1, exports);
	__exportStar(Edge$1, exports);
	__exportStar(SourceField$1, exports);
	__exportStar(DestinationField$1, exports);
	__exportStar(EnumDetails$1, exports);
	__exportStar(EnumValue$1, exports);
	__exportStar(Metadata$1, exports);
	__exportStar(Certainty$1, exports);
	__exportStar(CategoryMapping$1, exports);
	__exportStar(FindAndReplaceJobConfig$1, exports);
	__exportStar(ExportJobConfig$1, exports);
	__exportStar(ExportOptions$1, exports);
	__exportStar(EmptyObject$1, exports); 
} (types$v));

var client$h = {};

var requests$d = {};

Object.defineProperty(requests$d, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$d, exports); 
} (client$h));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$v, exports);
	__exportStar(client$h, exports); 
} (jobs$1));

var mapping$1 = {};

var types$u = {};

var MappingRuleType$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingRuleType$1, "__esModule", { value: true });
MappingRuleType$1.MappingRuleType = void 0;
MappingRuleType$1.MappingRuleType = {
    Assign: "assign",
};

var MappingRuleConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingRuleConfig$1, "__esModule", { value: true });

var MappingRuleBase$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingRuleBase$1, "__esModule", { value: true });

var MappingRuleOneToOne$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingRuleOneToOne$1, "__esModule", { value: true });

var MappingRule$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingRule$1, "__esModule", { value: true });

var MappingRuleResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingRuleResponse$1, "__esModule", { value: true });

var MappingRulesResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(MappingRulesResponse$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(MappingRuleType$1, exports);
	__exportStar(MappingRuleConfig$1, exports);
	__exportStar(MappingRuleBase$1, exports);
	__exportStar(MappingRuleOneToOne$1, exports);
	__exportStar(MappingRule$1, exports);
	__exportStar(MappingRuleResponse$1, exports);
	__exportStar(MappingRulesResponse$1, exports); 
} (types$u));

var client$g = {};

Object.defineProperty(client$g, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$u, exports);
	__exportStar(client$g, exports); 
} (mapping$1));

var property$1 = {};

var types$t = {};

var Property$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Property$1, "__esModule", { value: true });

var BaseProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(BaseProperty$1, "__esModule", { value: true });

var ArrayableProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ArrayableProperty$1, "__esModule", { value: true });

var StringProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(StringProperty$1, "__esModule", { value: true });

var NumberProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(NumberProperty$1, "__esModule", { value: true });

var NumberConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(NumberConfig$1, "__esModule", { value: true });

var BooleanProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(BooleanProperty$1, "__esModule", { value: true });

var BooleanPropertyConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(BooleanPropertyConfig$1, "__esModule", { value: true });

var DateProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DateProperty$1, "__esModule", { value: true });

var EnumProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnumProperty$1, "__esModule", { value: true });

var EnumPropertyConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnumPropertyConfig$1, "__esModule", { value: true });

var EnumPropertyOption$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EnumPropertyOption$1, "__esModule", { value: true });

var ReferenceProperty$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ReferenceProperty$1, "__esModule", { value: true });

var ReferencePropertyConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ReferencePropertyConfig$1, "__esModule", { value: true });

var ReferencePropertyRelationship$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ReferencePropertyRelationship$1, "__esModule", { value: true });
ReferencePropertyRelationship$1.ReferencePropertyRelationship = void 0;
ReferencePropertyRelationship$1.ReferencePropertyRelationship = {
    HasOne: "has-one",
    HasMany: "has-many",
};

var Constraint$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Constraint$1, "__esModule", { value: true });

var UniqueConstraint$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(UniqueConstraint$1, "__esModule", { value: true });

var UniqueConstraintConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(UniqueConstraintConfig$1, "__esModule", { value: true });

var StringConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(StringConfig$1, "__esModule", { value: true });

var StringConfigOptions$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(StringConfigOptions$1, "__esModule", { value: true });
StringConfigOptions$1.StringConfigOptions = void 0;
StringConfigOptions$1.StringConfigOptions = {
    Tiny: "tiny",
    Normal: "normal",
    Medium: "medium",
    Long: "long",
};

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(Property$1, exports);
	__exportStar(BaseProperty$1, exports);
	__exportStar(ArrayableProperty$1, exports);
	__exportStar(StringProperty$1, exports);
	__exportStar(NumberProperty$1, exports);
	__exportStar(NumberConfig$1, exports);
	__exportStar(BooleanProperty$1, exports);
	__exportStar(BooleanPropertyConfig$1, exports);
	__exportStar(DateProperty$1, exports);
	__exportStar(EnumProperty$1, exports);
	__exportStar(EnumPropertyConfig$1, exports);
	__exportStar(EnumPropertyOption$1, exports);
	__exportStar(ReferenceProperty$1, exports);
	__exportStar(ReferencePropertyConfig$1, exports);
	__exportStar(ReferencePropertyRelationship$1, exports);
	__exportStar(Constraint$1, exports);
	__exportStar(UniqueConstraint$1, exports);
	__exportStar(UniqueConstraintConfig$1, exports);
	__exportStar(StringConfig$1, exports);
	__exportStar(StringConfigOptions$1, exports); 
} (types$t));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$t, exports); 
} (property$1));

var records$1 = {};

var types$s = {};

var RecordsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordsResponse$1, "__esModule", { value: true });

var RecordsResponseData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordsResponseData$1, "__esModule", { value: true });

var GetRecordsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GetRecordsResponse$1, "__esModule", { value: true });

var GetRecordsResponseData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GetRecordsResponseData$1, "__esModule", { value: true });

var RecordCounts$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordCounts$1, "__esModule", { value: true });

var RecordsWithLinks$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordsWithLinks$1, "__esModule", { value: true });

var RecordWithLinks$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordWithLinks$1, "__esModule", { value: true });

var RecordDataWithLinks$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordDataWithLinks$1, "__esModule", { value: true });

var CellValueWithLinks$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CellValueWithLinks$1, "__esModule", { value: true });

var RecordBase$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordBase$1, "__esModule", { value: true });

var Records$2 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Records$2, "__esModule", { value: true });

var Record_$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Record_$1, "__esModule", { value: true });

var RecordData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordData$1, "__esModule", { value: true });

var CellValue$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CellValue$1, "__esModule", { value: true });

var CellValueUnion$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CellValueUnion$1, "__esModule", { value: true });

var DiffRecordsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DiffRecordsResponse$1, "__esModule", { value: true });

var DiffRecords$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DiffRecords$1, "__esModule", { value: true });

var DiffRecord$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DiffRecord$1, "__esModule", { value: true });

var DiffData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DiffData$1, "__esModule", { value: true });

var DiffValue$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(DiffValue$1, "__esModule", { value: true });

var ValidationMessage$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ValidationMessage$1, "__esModule", { value: true });

var ValidationType$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ValidationType$1, "__esModule", { value: true });
ValidationType$1.ValidationType = void 0;
ValidationType$1.ValidationType = {
    Error: "error",
    Warn: "warn",
    Info: "info",
};

var ValidationSource$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ValidationSource$1, "__esModule", { value: true });
ValidationSource$1.ValidationSource = void 0;
ValidationSource$1.ValidationSource = {
    RequiredConstraint: "required-constraint",
    UniqueConstraint: "unique-constraint",
    CustomLogic: "custom-logic",
    Unlinked: "unlinked",
    InvalidOption: "invalid-option",
    IsArtifact: "is-artifact",
};

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(RecordsResponse$1, exports);
	__exportStar(RecordsResponseData$1, exports);
	__exportStar(GetRecordsResponse$1, exports);
	__exportStar(GetRecordsResponseData$1, exports);
	__exportStar(RecordCounts$1, exports);
	__exportStar(RecordsWithLinks$1, exports);
	__exportStar(RecordWithLinks$1, exports);
	__exportStar(RecordDataWithLinks$1, exports);
	__exportStar(CellValueWithLinks$1, exports);
	__exportStar(RecordBase$1, exports);
	__exportStar(Records$2, exports);
	__exportStar(Record_$1, exports);
	__exportStar(RecordData$1, exports);
	__exportStar(CellValue$1, exports);
	__exportStar(CellValueUnion$1, exports);
	__exportStar(DiffRecordsResponse$1, exports);
	__exportStar(DiffRecords$1, exports);
	__exportStar(DiffRecord$1, exports);
	__exportStar(DiffData$1, exports);
	__exportStar(DiffValue$1, exports);
	__exportStar(ValidationMessage$1, exports);
	__exportStar(ValidationType$1, exports);
	__exportStar(ValidationSource$1, exports); 
} (types$s));

var client$f = {};

var requests$c = {};

Object.defineProperty(requests$c, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$c, exports); 
} (client$f));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$s, exports);
	__exportStar(client$f, exports); 
} (records$1));

var secrets$1 = {};

var types$r = {};

var SecretsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SecretsResponse$1, "__esModule", { value: true });

var WriteSecret$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(WriteSecret$1, "__esModule", { value: true });

var Secret$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Secret$1, "__esModule", { value: true });

var SecretName$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SecretName$1, "__esModule", { value: true });

var SecretValue$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SecretValue$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(SecretsResponse$1, exports);
	__exportStar(WriteSecret$1, exports);
	__exportStar(Secret$1, exports);
	__exportStar(SecretName$1, exports);
	__exportStar(SecretValue$1, exports); 
} (types$r));

var client$e = {};

var requests$b = {};

Object.defineProperty(requests$b, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$b, exports); 
} (client$e));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$r, exports);
	__exportStar(client$e, exports); 
} (secrets$1));

var sheets$1 = {};

var types$q = {};

var ListSheetsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListSheetsResponse$1, "__esModule", { value: true });

var SheetResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetResponse$1, "__esModule", { value: true });

var Sheet$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Sheet$1, "__esModule", { value: true });

var SheetConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetConfig$1, "__esModule", { value: true });

var SheetConfigUpdate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetConfigUpdate$1, "__esModule", { value: true });

var SheetUpdate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetUpdate$1, "__esModule", { value: true });

var SheetConfigOrUpdate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetConfigOrUpdate$1, "__esModule", { value: true });

var RecordCountsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordCountsResponse$1, "__esModule", { value: true });

var RecordCountsResponseData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RecordCountsResponseData$1, "__esModule", { value: true });

var FieldConfigResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(FieldConfigResponse$1, "__esModule", { value: true });

var SheetAccess$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SheetAccess$1, "__esModule", { value: true });
SheetAccess$1.SheetAccess = void 0;
SheetAccess$1.SheetAccess = {
    All: "*",
    Add: "add",
    Edit: "edit",
    Delete: "delete",
    Import: "import",
};

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListSheetsResponse$1, exports);
	__exportStar(SheetResponse$1, exports);
	__exportStar(Sheet$1, exports);
	__exportStar(SheetConfig$1, exports);
	__exportStar(SheetConfigUpdate$1, exports);
	__exportStar(SheetUpdate$1, exports);
	__exportStar(SheetConfigOrUpdate$1, exports);
	__exportStar(RecordCountsResponse$1, exports);
	__exportStar(RecordCountsResponseData$1, exports);
	__exportStar(FieldConfigResponse$1, exports);
	__exportStar(SheetAccess$1, exports); 
} (types$q));

var client$d = {};

var requests$a = {};

Object.defineProperty(requests$a, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$a, exports); 
} (client$d));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$q, exports);
	__exportStar(client$d, exports); 
} (sheets$1));

var snapshots$1 = {};

var types$p = {};

var SnapshotResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SnapshotResponse$1, "__esModule", { value: true });

var SnapshotsResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SnapshotsResponse$1, "__esModule", { value: true });

var Snapshot$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Snapshot$1, "__esModule", { value: true });

var SnapshotSummary$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SnapshotSummary$1, "__esModule", { value: true });

var RestoreOptions$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(RestoreOptions$1, "__esModule", { value: true });

var SummarySection$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SummarySection$1, "__esModule", { value: true });

var ChangeType$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ChangeType$1, "__esModule", { value: true });
ChangeType$1.ChangeType = void 0;
ChangeType$1.ChangeType = {
    CreatedSince: "createdSince",
    UpdatedSince: "updatedSince",
    DeletedSince: "deletedSince",
};

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(SnapshotResponse$1, exports);
	__exportStar(SnapshotsResponse$1, exports);
	__exportStar(Snapshot$1, exports);
	__exportStar(SnapshotSummary$1, exports);
	__exportStar(RestoreOptions$1, exports);
	__exportStar(SummarySection$1, exports);
	__exportStar(ChangeType$1, exports); 
} (types$p));

var client$c = {};

var requests$9 = {};

Object.defineProperty(requests$9, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$9, exports); 
} (client$c));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$p, exports);
	__exportStar(client$c, exports); 
} (snapshots$1));

var spaces$1 = {};

var types$o = {};

var ListSpacesResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListSpacesResponse$1, "__esModule", { value: true });

var SpaceResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SpaceResponse$1, "__esModule", { value: true });

var Space$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Space$1, "__esModule", { value: true });

var SpaceSize$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SpaceSize$1, "__esModule", { value: true });

var SpaceConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SpaceConfig$1, "__esModule", { value: true });

var InternalSpaceConfigBase$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(InternalSpaceConfigBase$1, "__esModule", { value: true });

var EventTokenResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EventTokenResponse$1, "__esModule", { value: true });

var EventToken$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(EventToken$1, "__esModule", { value: true });

var GetSpacesSortField$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(GetSpacesSortField$1, "__esModule", { value: true });
GetSpacesSortField$1.GetSpacesSortField = void 0;
GetSpacesSortField$1.GetSpacesSortField = {
    Name: "name",
    WorkbooksCount: "workbooksCount",
    FilesCount: "filesCount",
    EnvironmentId: "environmentId",
    CreatedByUserName: "createdByUserName",
    CreatedAt: "createdAt",
};

var SpaceAccess$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(SpaceAccess$1, "__esModule", { value: true });
SpaceAccess$1.SpaceAccess = void 0;
SpaceAccess$1.SpaceAccess = {
    All: "*",
    Upload: "upload",
};

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListSpacesResponse$1, exports);
	__exportStar(SpaceResponse$1, exports);
	__exportStar(Space$1, exports);
	__exportStar(SpaceSize$1, exports);
	__exportStar(SpaceConfig$1, exports);
	__exportStar(InternalSpaceConfigBase$1, exports);
	__exportStar(EventTokenResponse$1, exports);
	__exportStar(EventToken$1, exports);
	__exportStar(GetSpacesSortField$1, exports);
	__exportStar(SpaceAccess$1, exports); 
} (types$o));

var client$b = {};

var requests$8 = {};

Object.defineProperty(requests$8, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$8, exports); 
} (client$b));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$o, exports);
	__exportStar(client$b, exports); 
} (spaces$1));

var users$1 = {};

var types$n = {};

var ListUsersResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListUsersResponse$1, "__esModule", { value: true });

var UserResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(UserResponse$1, "__esModule", { value: true });

var User$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(User$1, "__esModule", { value: true });

var UserConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(UserConfig$1, "__esModule", { value: true });

var ListApiTokensResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListApiTokensResponse$1, "__esModule", { value: true });

var ApiTokenResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ApiTokenResponse$1, "__esModule", { value: true });

var ApiToken$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ApiToken$1, "__esModule", { value: true });

var ExchangeTokenResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ExchangeTokenResponse$1, "__esModule", { value: true });

var ExchangeTokenData$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ExchangeTokenData$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListUsersResponse$1, exports);
	__exportStar(UserResponse$1, exports);
	__exportStar(User$1, exports);
	__exportStar(UserConfig$1, exports);
	__exportStar(ListApiTokensResponse$1, exports);
	__exportStar(ApiTokenResponse$1, exports);
	__exportStar(ApiToken$1, exports);
	__exportStar(ExchangeTokenResponse$1, exports);
	__exportStar(ExchangeTokenData$1, exports); 
} (types$n));

var client$a = {};

var requests$7 = {};

Object.defineProperty(requests$7, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$7, exports); 
} (client$a));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$n, exports);
	__exportStar(client$a, exports); 
} (users$1));

var versions$1 = {};

var types$m = {};

var VersionResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(VersionResponse$1, "__esModule", { value: true });

var Version$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Version$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(VersionResponse$1, exports);
	__exportStar(Version$1, exports); 
} (types$m));

var client$9 = {};

var requests$6 = {};

Object.defineProperty(requests$6, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$6, exports); 
} (client$9));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$m, exports);
	__exportStar(client$9, exports); 
} (versions$1));

var workbooks$1 = {};

var types$l = {};

var ListWorkbooksResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(ListWorkbooksResponse$1, "__esModule", { value: true });

var WorkbookResponse$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(WorkbookResponse$1, "__esModule", { value: true });

var Workbook$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Workbook$1, "__esModule", { value: true });

var CreateWorkbookConfig$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(CreateWorkbookConfig$1, "__esModule", { value: true });

var WorkbookConfigSettings$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(WorkbookConfigSettings$1, "__esModule", { value: true });

var WorkbookUpdate$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(WorkbookUpdate$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ListWorkbooksResponse$1, exports);
	__exportStar(WorkbookResponse$1, exports);
	__exportStar(Workbook$1, exports);
	__exportStar(CreateWorkbookConfig$1, exports);
	__exportStar(WorkbookConfigSettings$1, exports);
	__exportStar(WorkbookUpdate$1, exports); 
} (types$l));

var client$8 = {};

var requests$5 = {};

Object.defineProperty(requests$5, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$5, exports); 
} (client$8));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(types$l, exports);
	__exportStar(client$8, exports); 
} (workbooks$1));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.workbooks = exports.versions = exports.users = exports.spaces = exports.snapshots = exports.sheets = exports.secrets = exports.records = exports.property = exports.mapping = exports.jobs = exports.guests = exports.files = exports.events = exports.environments = exports.documents = exports.commons = exports.commits = exports.cells = exports.auth = exports.agents = void 0;
	exports.agents = __importStar(agents$1);
	__exportStar(types$F, exports);
	exports.auth = __importStar(auth$1);
	__exportStar(types$E, exports);
	exports.cells = __importStar(cells$1);
	__exportStar(types$D, exports);
	exports.commits = __importStar(commits$1);
	__exportStar(types$C, exports);
	exports.commons = __importStar(commons$1);
	__exportStar(types$B, exports);
	exports.documents = __importStar(documents$1);
	__exportStar(types$A, exports);
	exports.environments = __importStar(environments$k);
	__exportStar(types$z, exports);
	exports.events = __importStar(events$1);
	__exportStar(types$y, exports);
	exports.files = __importStar(files$1);
	__exportStar(types$x, exports);
	exports.guests = __importStar(guests$1);
	__exportStar(types$w, exports);
	exports.jobs = __importStar(jobs$1);
	__exportStar(types$v, exports);
	exports.mapping = __importStar(mapping$1);
	__exportStar(types$u, exports);
	exports.property = __importStar(property$1);
	__exportStar(types$t, exports);
	exports.records = __importStar(records$1);
	__exportStar(types$s, exports);
	exports.secrets = __importStar(secrets$1);
	__exportStar(types$r, exports);
	exports.sheets = __importStar(sheets$1);
	__exportStar(types$q, exports);
	exports.snapshots = __importStar(snapshots$1);
	__exportStar(types$p, exports);
	exports.spaces = __importStar(spaces$1);
	__exportStar(types$o, exports);
	exports.users = __importStar(users$1);
	__exportStar(types$n, exports);
	exports.versions = __importStar(versions$1);
	__exportStar(types$m, exports);
	exports.workbooks = __importStar(workbooks$1);
	__exportStar(types$l, exports);
	__exportStar(errors$m, exports);
	__exportStar(requests$k, exports);
	__exportStar(requests$j, exports);
	__exportStar(requests$i, exports);
	__exportStar(requests$h, exports);
	__exportStar(requests$g, exports);
	__exportStar(requests$f, exports);
	__exportStar(requests$e, exports);
	__exportStar(requests$d, exports);
	__exportStar(requests$c, exports);
	__exportStar(requests$b, exports);
	__exportStar(requests$a, exports);
	__exportStar(requests$9, exports);
	__exportStar(requests$8, exports);
	__exportStar(requests$7, exports);
	__exportStar(requests$6, exports);
	__exportStar(requests$5, exports); 
} (resources$1));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(resources$1, exports); 
} (api));

var urlJoin = {exports: {}};

urlJoin.exports;

(function (module) {
	(function (name, context, definition) {
	  if (module.exports) module.exports = definition();
	  else context[name] = definition();
	})('urljoin', commonjsGlobal, function () {

	  function normalize (strArray) {
	    var resultArray = [];
	    if (strArray.length === 0) { return ''; }

	    if (typeof strArray[0] !== 'string') {
	      throw new TypeError('Url must be a string. Received ' + strArray[0]);
	    }

	    // If the first part is a plain protocol, we combine it with the next part.
	    if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
	      var first = strArray.shift();
	      strArray[0] = first + strArray[0];
	    }

	    // There must be two or three slashes in the file protocol, two slashes in anything else.
	    if (strArray[0].match(/^file:\/\/\//)) {
	      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
	    } else {
	      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
	    }

	    for (var i = 0; i < strArray.length; i++) {
	      var component = strArray[i];

	      if (typeof component !== 'string') {
	        throw new TypeError('Url must be a string. Received ' + component);
	      }

	      if (component === '') { continue; }

	      if (i > 0) {
	        // Removing the starting slashes for each component but the first.
	        component = component.replace(/^[\/]+/, '');
	      }
	      if (i < strArray.length - 1) {
	        // Removing the ending slashes for each component but the last.
	        component = component.replace(/[\/]+$/, '');
	      } else {
	        // For the last component we will combine multiple slashes to a single one.
	        component = component.replace(/[\/]+$/, '/');
	      }

	      resultArray.push(component);

	    }

	    var str = resultArray.join('/');
	    // Each input component is now separated by a single slash except the possible first plain protocol part.

	    // remove trailing slash before parameters or hash
	    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

	    // replace ? in parameters with &
	    var parts = str.split('?');
	    str = parts.shift() + (parts.length > 0 ? '?': '') + parts.join('&');

	    return str;
	  }

	  return function () {
	    var input;

	    if (typeof arguments[0] === 'object') {
	      input = arguments[0];
	    } else {
	      input = [].slice.call(arguments);
	    }

	    return normalize(input);
	  };

	}); 
} (urlJoin));

var urlJoinExports = urlJoin.exports;

var serialization = {};

var resources = {};

var agents = {};

var types$k = {};

var ListAgentsResponse = {};

var hasRequiredListAgentsResponse;

function requireListAgentsResponse () {
	if (hasRequiredListAgentsResponse) return ListAgentsResponse;
	hasRequiredListAgentsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListAgentsResponse, "__esModule", { value: true });
	ListAgentsResponse.ListAgentsResponse = void 0;
	const core = __importStar(core$1H);
	ListAgentsResponse.ListAgentsResponse = core.serialization.object({
	    data: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Agent; })))
	        .optional(),
	});
	return ListAgentsResponse;
}

var AgentResponse = {};

var hasRequiredAgentResponse;

function requireAgentResponse () {
	if (hasRequiredAgentResponse) return AgentResponse;
	hasRequiredAgentResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(AgentResponse, "__esModule", { value: true });
	AgentResponse.AgentResponse = void 0;
	const core = __importStar(core$1H);
	AgentResponse.AgentResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Agent; })).optional(),
	});
	return AgentResponse;
}

var AgentConfig = {};

var hasRequiredAgentConfig;

function requireAgentConfig () {
	if (hasRequiredAgentConfig) return AgentConfig;
	hasRequiredAgentConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(AgentConfig, "__esModule", { value: true });
	AgentConfig.AgentConfig = void 0;
	const core = __importStar(core$1H);
	AgentConfig.AgentConfig = core.serialization.object({
	    topics: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventTopic; })))
	        .optional(),
	    compiler: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Compiler; })).optional(),
	    source: core.serialization.string().optional(),
	});
	return AgentConfig;
}

var Agent = {};

var hasRequiredAgent;

function requireAgent () {
	if (hasRequiredAgent) return Agent;
	hasRequiredAgent = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Agent, "__esModule", { value: true });
	Agent.Agent = void 0;
	const core = __importStar(core$1H);
	Agent.Agent = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AgentId; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AgentConfig; })));
	return Agent;
}

var Compiler = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1G = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1G = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1G = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1G(result, mod, k);
    __setModuleDefault$1G(result, mod);
    return result;
};
Object.defineProperty(Compiler, "__esModule", { value: true });
Compiler.Compiler = void 0;
const core$1G = __importStar$1G(core$1H);
Compiler.Compiler = core$1G.serialization.enum_(["js"]);

var GetAgentLogsResponse = {};

var hasRequiredGetAgentLogsResponse;

function requireGetAgentLogsResponse () {
	if (hasRequiredGetAgentLogsResponse) return GetAgentLogsResponse;
	hasRequiredGetAgentLogsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GetAgentLogsResponse, "__esModule", { value: true });
	GetAgentLogsResponse.GetAgentLogsResponse = void 0;
	const core = __importStar(core$1H);
	GetAgentLogsResponse.GetAgentLogsResponse = core.serialization.object({
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	    data: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AgentLog; })))
	        .optional(),
	});
	return GetAgentLogsResponse;
}

var GetDetailedAgentLogResponse = {};

var hasRequiredGetDetailedAgentLogResponse;

function requireGetDetailedAgentLogResponse () {
	if (hasRequiredGetDetailedAgentLogResponse) return GetDetailedAgentLogResponse;
	hasRequiredGetDetailedAgentLogResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GetDetailedAgentLogResponse, "__esModule", { value: true });
	GetDetailedAgentLogResponse.GetDetailedAgentLogResponse = void 0;
	const core = __importStar(core$1H);
	GetDetailedAgentLogResponse.GetDetailedAgentLogResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DetailedAgentLog; })),
	});
	return GetDetailedAgentLogResponse;
}

var GetDetailedAgentLogsResponse = {};

var hasRequiredGetDetailedAgentLogsResponse;

function requireGetDetailedAgentLogsResponse () {
	if (hasRequiredGetDetailedAgentLogsResponse) return GetDetailedAgentLogsResponse;
	hasRequiredGetDetailedAgentLogsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GetDetailedAgentLogsResponse, "__esModule", { value: true });
	GetDetailedAgentLogsResponse.GetDetailedAgentLogsResponse = void 0;
	const core = __importStar(core$1H);
	GetDetailedAgentLogsResponse.GetDetailedAgentLogsResponse = core.serialization.object({
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DetailedAgentLog; }))),
	});
	return GetDetailedAgentLogsResponse;
}

var GetExecutionsResponse = {};

var hasRequiredGetExecutionsResponse;

function requireGetExecutionsResponse () {
	if (hasRequiredGetExecutionsResponse) return GetExecutionsResponse;
	hasRequiredGetExecutionsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GetExecutionsResponse, "__esModule", { value: true });
	GetExecutionsResponse.GetExecutionsResponse = void 0;
	const core = __importStar(core$1H);
	GetExecutionsResponse.GetExecutionsResponse = core.serialization.object({
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Execution; }))),
	});
	return GetExecutionsResponse;
}

var AgentLog = {};

var hasRequiredAgentLog;

function requireAgentLog () {
	if (hasRequiredAgentLog) return AgentLog;
	hasRequiredAgentLog = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(AgentLog, "__esModule", { value: true });
	AgentLog.AgentLog = void 0;
	const core = __importStar(core$1H);
	AgentLog.AgentLog = core.serialization.object({
	    eventId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventId; })),
	    success: core.serialization.boolean(),
	    createdAt: core.serialization.string(),
	    completedAt: core.serialization.string(),
	    log: core.serialization.string().optional(),
	});
	return AgentLog;
}

var DetailedAgentLog = {};

var hasRequiredDetailedAgentLog;

function requireDetailedAgentLog () {
	if (hasRequiredDetailedAgentLog) return DetailedAgentLog;
	hasRequiredDetailedAgentLog = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DetailedAgentLog, "__esModule", { value: true });
	DetailedAgentLog.DetailedAgentLog = void 0;
	const core = __importStar(core$1H);
	DetailedAgentLog.DetailedAgentLog = core.serialization.object({
	    eventId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventId; })),
	    success: core.serialization.boolean(),
	    createdAt: core.serialization.date(),
	    completedAt: core.serialization.date(),
	    duration: core.serialization.number(),
	    topic: core.serialization.string(),
	    context: core.serialization.record(core.serialization.string(), core.serialization.any()),
	    log: core.serialization.string().optional(),
	});
	return DetailedAgentLog;
}

var Execution = {};

var hasRequiredExecution;

function requireExecution () {
	if (hasRequiredExecution) return Execution;
	hasRequiredExecution = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Execution, "__esModule", { value: true });
	Execution.Execution = void 0;
	const core = __importStar(core$1H);
	Execution.Execution = core.serialization.object({
	    eventId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventId; })),
	    success: core.serialization.boolean(),
	    createdAt: core.serialization.date(),
	    completedAt: core.serialization.date(),
	    duration: core.serialization.number(),
	    topic: core.serialization.string(),
	});
	return Execution;
}

var hasRequiredTypes$k;

function requireTypes$k () {
	if (hasRequiredTypes$k) return types$k;
	hasRequiredTypes$k = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListAgentsResponse(), exports);
		__exportStar(requireAgentResponse(), exports);
		__exportStar(requireAgentConfig(), exports);
		__exportStar(requireAgent(), exports);
		__exportStar(Compiler, exports);
		__exportStar(requireGetAgentLogsResponse(), exports);
		__exportStar(requireGetDetailedAgentLogResponse(), exports);
		__exportStar(requireGetDetailedAgentLogsResponse(), exports);
		__exportStar(requireGetExecutionsResponse(), exports);
		__exportStar(requireAgentLog(), exports);
		__exportStar(requireDetailedAgentLog(), exports);
		__exportStar(requireExecution(), exports); 
	} (types$k));
	return types$k;
}

var hasRequiredAgents;

function requireAgents () {
	if (hasRequiredAgents) return agents;
	hasRequiredAgents = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$k(), exports); 
	} (agents));
	return agents;
}

var auth = {};

var types$j = {};

var ApiKeysResponse = {};

var hasRequiredApiKeysResponse;

function requireApiKeysResponse () {
	if (hasRequiredApiKeysResponse) return ApiKeysResponse;
	hasRequiredApiKeysResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ApiKeysResponse, "__esModule", { value: true });
	ApiKeysResponse.ApiKeysResponse = void 0;
	const core = __importStar(core$1H);
	ApiKeysResponse.ApiKeysResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ApiKey; }))),
	});
	return ApiKeysResponse;
}

var ApiKeyType = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1F = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1F = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1F = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1F(result, mod, k);
    __setModuleDefault$1F(result, mod);
    return result;
};
Object.defineProperty(ApiKeyType, "__esModule", { value: true });
ApiKeyType.ApiKeyType = void 0;
const core$1F = __importStar$1F(core$1H);
ApiKeyType.ApiKeyType = core$1F.serialization.enum_(["PUBLISHABLE", "SECRET"]);

var ApiKeyOperation = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1E = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1E = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1E = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1E(result, mod, k);
    __setModuleDefault$1E(result, mod);
    return result;
};
Object.defineProperty(ApiKeyOperation, "__esModule", { value: true });
ApiKeyOperation.ApiKeyOperation = void 0;
const core$1E = __importStar$1E(core$1H);
ApiKeyOperation.ApiKeyOperation = core$1E.serialization.object({
    path: core$1E.serialization.string(),
    method: core$1E.serialization.string(),
});

var ApiKey = {};

var hasRequiredApiKey;

function requireApiKey () {
	if (hasRequiredApiKey) return ApiKey;
	hasRequiredApiKey = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ApiKey, "__esModule", { value: true });
	ApiKey.ApiKey = void 0;
	const core = __importStar(core$1H);
	ApiKey.ApiKey = core.serialization.object({
	    id: core.serialization.string(),
	    rawKey: core.serialization.string().optional(),
	    type: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ApiKeyType; })),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })).optional(),
	    accountId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AccountId; })).optional(),
	    operations: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ApiKeyOperation; }))),
	    createdAt: core.serialization.date(),
	    updatedAt: core.serialization.date().optional(),
	    deletedAt: core.serialization.date().optional(),
	    secret: core.serialization.string().optional(),
	});
	return ApiKey;
}

var hasRequiredTypes$j;

function requireTypes$j () {
	if (hasRequiredTypes$j) return types$j;
	hasRequiredTypes$j = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireApiKeysResponse(), exports);
		__exportStar(ApiKeyType, exports);
		__exportStar(ApiKeyOperation, exports);
		__exportStar(requireApiKey(), exports); 
	} (types$j));
	return types$j;
}

var hasRequiredAuth;

function requireAuth () {
	if (hasRequiredAuth) return auth;
	hasRequiredAuth = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$j(), exports); 
	} (auth));
	return auth;
}

var cells = {};

var types$i = {};

var CellsResponse = {};

var hasRequiredCellsResponse;

function requireCellsResponse () {
	if (hasRequiredCellsResponse) return CellsResponse;
	hasRequiredCellsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CellsResponse, "__esModule", { value: true });
	CellsResponse.CellsResponse = void 0;
	const core = __importStar(core$1H);
	CellsResponse.CellsResponse = core.serialization.object({
	    data: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellsResponseData; })),
	});
	return CellsResponse;
}

var CellsResponseData = {};

var hasRequiredCellsResponseData;

function requireCellsResponseData () {
	if (hasRequiredCellsResponseData) return CellsResponseData;
	hasRequiredCellsResponseData = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CellsResponseData, "__esModule", { value: true });
	CellsResponseData.CellsResponseData = void 0;
	const core = __importStar(core$1H);
	CellsResponseData.CellsResponseData = core.serialization.record(core.serialization.string(), core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueWithCounts; }))));
	return CellsResponseData;
}

var CellValueWithCounts = {};

var hasRequiredCellValueWithCounts;

function requireCellValueWithCounts () {
	if (hasRequiredCellValueWithCounts) return CellValueWithCounts;
	hasRequiredCellValueWithCounts = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CellValueWithCounts, "__esModule", { value: true });
	CellValueWithCounts.CellValueWithCounts = void 0;
	const core = __importStar(core$1H);
	CellValueWithCounts.CellValueWithCounts = core.serialization
	    .object({
	    counts: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordCounts; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValue; })));
	return CellValueWithCounts;
}

var hasRequiredTypes$i;

function requireTypes$i () {
	if (hasRequiredTypes$i) return types$i;
	hasRequiredTypes$i = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireCellsResponse(), exports);
		__exportStar(requireCellsResponseData(), exports);
		__exportStar(requireCellValueWithCounts(), exports); 
	} (types$i));
	return types$i;
}

var hasRequiredCells;

function requireCells () {
	if (hasRequiredCells) return cells;
	hasRequiredCells = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$i(), exports); 
	} (cells));
	return cells;
}

var commits = {};

var types$h = {};

var ListCommitsResponse = {};

var hasRequiredListCommitsResponse;

function requireListCommitsResponse () {
	if (hasRequiredListCommitsResponse) return ListCommitsResponse;
	hasRequiredListCommitsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListCommitsResponse, "__esModule", { value: true });
	ListCommitsResponse.ListCommitsResponse = void 0;
	const core = __importStar(core$1H);
	ListCommitsResponse.ListCommitsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Commit; }))),
	});
	return ListCommitsResponse;
}

var CommitResponse = {};

var hasRequiredCommitResponse;

function requireCommitResponse () {
	if (hasRequiredCommitResponse) return CommitResponse;
	hasRequiredCommitResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CommitResponse, "__esModule", { value: true });
	CommitResponse.CommitResponse = void 0;
	const core = __importStar(core$1H);
	CommitResponse.CommitResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Commit; })),
	});
	return CommitResponse;
}

var Commit = {};

var hasRequiredCommit;

function requireCommit () {
	if (hasRequiredCommit) return Commit;
	hasRequiredCommit = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Commit, "__esModule", { value: true });
	Commit.Commit = void 0;
	const core = __importStar(core$1H);
	Commit.Commit = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })),
	    sheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	    createdBy: core.serialization.string(),
	    completedBy: core.serialization.string().optional(),
	    createdAt: core.serialization.date(),
	    completedAt: core.serialization.date().optional(),
	});
	return Commit;
}

var hasRequiredTypes$h;

function requireTypes$h () {
	if (hasRequiredTypes$h) return types$h;
	hasRequiredTypes$h = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListCommitsResponse(), exports);
		__exportStar(requireCommitResponse(), exports);
		__exportStar(requireCommit(), exports); 
	} (types$h));
	return types$h;
}

var hasRequiredCommits;

function requireCommits () {
	if (hasRequiredCommits) return commits;
	hasRequiredCommits = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$h(), exports); 
	} (commits));
	return commits;
}

var commons = {};

var types$g = {};

var AgentId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1D = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1D = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1D = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1D(result, mod, k);
    __setModuleDefault$1D(result, mod);
    return result;
};
Object.defineProperty(AgentId, "__esModule", { value: true });
AgentId.AgentId = void 0;
const core$1D = __importStar$1D(core$1H);
AgentId.AgentId = core$1D.serialization.string();

var AccountId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1C = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1C = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1C = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1C(result, mod, k);
    __setModuleDefault$1C(result, mod);
    return result;
};
Object.defineProperty(AccountId, "__esModule", { value: true });
AccountId.AccountId = void 0;
const core$1C = __importStar$1C(core$1H);
AccountId.AccountId = core$1C.serialization.string();

var DocumentId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1B = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1B = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1B = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1B(result, mod, k);
    __setModuleDefault$1B(result, mod);
    return result;
};
Object.defineProperty(DocumentId, "__esModule", { value: true });
DocumentId.DocumentId = void 0;
const core$1B = __importStar$1B(core$1H);
DocumentId.DocumentId = core$1B.serialization.string();

var GuestId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1A = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1A = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1A = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1A(result, mod, k);
    __setModuleDefault$1A(result, mod);
    return result;
};
Object.defineProperty(GuestId, "__esModule", { value: true });
GuestId.GuestId = void 0;
const core$1A = __importStar$1A(core$1H);
GuestId.GuestId = core$1A.serialization.string();

var EnvironmentId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1z = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1z = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1z = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1z(result, mod, k);
    __setModuleDefault$1z(result, mod);
    return result;
};
Object.defineProperty(EnvironmentId, "__esModule", { value: true });
EnvironmentId.EnvironmentId = void 0;
const core$1z = __importStar$1z(core$1H);
EnvironmentId.EnvironmentId = core$1z.serialization.string();

var FileId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1y = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1y = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1y = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1y(result, mod, k);
    __setModuleDefault$1y(result, mod);
    return result;
};
Object.defineProperty(FileId, "__esModule", { value: true });
FileId.FileId = void 0;
const core$1y = __importStar$1y(core$1H);
FileId.FileId = core$1y.serialization.string();

var SpaceId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1x = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1x = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1x = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1x(result, mod, k);
    __setModuleDefault$1x(result, mod);
    return result;
};
Object.defineProperty(SpaceId, "__esModule", { value: true });
SpaceId.SpaceId = void 0;
const core$1x = __importStar$1x(core$1H);
SpaceId.SpaceId = core$1x.serialization.string();

var WorkbookId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1w = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1w = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1w = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1w(result, mod, k);
    __setModuleDefault$1w(result, mod);
    return result;
};
Object.defineProperty(WorkbookId, "__esModule", { value: true });
WorkbookId.WorkbookId = void 0;
const core$1w = __importStar$1w(core$1H);
WorkbookId.WorkbookId = core$1w.serialization.string();

var EventId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1v = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1v = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1v = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1v(result, mod, k);
    __setModuleDefault$1v(result, mod);
    return result;
};
Object.defineProperty(EventId, "__esModule", { value: true });
EventId.EventId = void 0;
const core$1v = __importStar$1v(core$1H);
EventId.EventId = core$1v.serialization.string();

var SheetId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1u = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1u = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1u = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1u(result, mod, k);
    __setModuleDefault$1u(result, mod);
    return result;
};
Object.defineProperty(SheetId, "__esModule", { value: true });
SheetId.SheetId = void 0;
const core$1u = __importStar$1u(core$1H);
SheetId.SheetId = core$1u.serialization.string();

var SnapshotId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1t = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1t = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1t = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1t(result, mod, k);
    __setModuleDefault$1t(result, mod);
    return result;
};
Object.defineProperty(SnapshotId, "__esModule", { value: true });
SnapshotId.SnapshotId = void 0;
const core$1t = __importStar$1t(core$1H);
SnapshotId.SnapshotId = core$1t.serialization.string();

var VersionId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1s = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1s = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1s = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1s(result, mod, k);
    __setModuleDefault$1s(result, mod);
    return result;
};
Object.defineProperty(VersionId, "__esModule", { value: true });
VersionId.VersionId = void 0;
const core$1s = __importStar$1s(core$1H);
VersionId.VersionId = core$1s.serialization.string();

var JobId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1r = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1r = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1r = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1r(result, mod, k);
    __setModuleDefault$1r(result, mod);
    return result;
};
Object.defineProperty(JobId, "__esModule", { value: true });
JobId.JobId = void 0;
const core$1r = __importStar$1r(core$1H);
JobId.JobId = core$1r.serialization.string();

var UserId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1q = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1q = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1q = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1q(result, mod, k);
    __setModuleDefault$1q(result, mod);
    return result;
};
Object.defineProperty(UserId, "__esModule", { value: true });
UserId.UserId = void 0;
const core$1q = __importStar$1q(core$1H);
UserId.UserId = core$1q.serialization.string();

var SpaceConfigId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1p = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1p = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1p = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1p(result, mod, k);
    __setModuleDefault$1p(result, mod);
    return result;
};
Object.defineProperty(SpaceConfigId, "__esModule", { value: true });
SpaceConfigId.SpaceConfigId = void 0;
const core$1p = __importStar$1p(core$1H);
SpaceConfigId.SpaceConfigId = core$1p.serialization.string();

var RecordId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1o = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1o = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1o = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1o(result, mod, k);
    __setModuleDefault$1o(result, mod);
    return result;
};
Object.defineProperty(RecordId, "__esModule", { value: true });
RecordId.RecordId = void 0;
const core$1o = __importStar$1o(core$1H);
RecordId.RecordId = core$1o.serialization.string();

var SecretId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1n = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1n = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1n = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1n(result, mod, k);
    __setModuleDefault$1n(result, mod);
    return result;
};
Object.defineProperty(SecretId, "__esModule", { value: true });
SecretId.SecretId = void 0;
const core$1n = __importStar$1n(core$1H);
SecretId.SecretId = core$1n.serialization.string();

var MappingId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1m = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1m = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1m = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1m(result, mod, k);
    __setModuleDefault$1m(result, mod);
    return result;
};
Object.defineProperty(MappingId, "__esModule", { value: true });
MappingId.MappingId = void 0;
const core$1m = __importStar$1m(core$1H);
MappingId.MappingId = core$1m.serialization.string();

var Pagination = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1l = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1l = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1l = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1l(result, mod, k);
    __setModuleDefault$1l(result, mod);
    return result;
};
Object.defineProperty(Pagination, "__esModule", { value: true });
Pagination.Pagination = void 0;
const core$1l = __importStar$1l(core$1H);
Pagination.Pagination = core$1l.serialization.object({
    currentPage: core$1l.serialization.number(),
    pageCount: core$1l.serialization.number(),
    totalCount: core$1l.serialization.number(),
});

var Action = {};

var hasRequiredAction;

function requireAction () {
	if (hasRequiredAction) return Action;
	hasRequiredAction = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Action, "__esModule", { value: true });
	Action.Action = void 0;
	const core = __importStar(core$1H);
	Action.Action = core.serialization.object({
	    slug: core.serialization.string().optional(),
	    operation: core.serialization.string().optional(),
	    mode: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ActionMode; })).optional(),
	    label: core.serialization.string(),
	    tooltip: core.serialization.string().optional(),
	    type: core.serialization.string().optional(),
	    description: core.serialization.string().optional(),
	    schedule: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ActionSchedule; })).optional(),
	    primary: core.serialization.boolean().optional(),
	    confirm: core.serialization.boolean().optional(),
	    icon: core.serialization.string().optional(),
	    requireAllValid: core.serialization.boolean().optional(),
	    requireSelection: core.serialization.boolean().optional(),
	    inputForm: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InputForm; })).optional(),
	});
	return Action;
}

var InputForm = {};

var hasRequiredInputForm;

function requireInputForm () {
	if (hasRequiredInputForm) return InputForm;
	hasRequiredInputForm = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(InputForm, "__esModule", { value: true });
	InputForm.InputForm = void 0;
	const core = __importStar(core$1H);
	InputForm.InputForm = core.serialization.object({
	    type: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InputFormType; })),
	    fields: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InputField; }))),
	});
	return InputForm;
}

var InputFormType = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1k = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1k = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1k = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1k(result, mod, k);
    __setModuleDefault$1k(result, mod);
    return result;
};
Object.defineProperty(InputFormType, "__esModule", { value: true });
InputFormType.InputFormType = void 0;
const core$1k = __importStar$1k(core$1H);
InputFormType.InputFormType = core$1k.serialization.enum_(["simple"]);

var InputField = {};

var hasRequiredInputField;

function requireInputField () {
	if (hasRequiredInputField) return InputField;
	hasRequiredInputField = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(InputField, "__esModule", { value: true });
	InputField.InputField = void 0;
	const core = __importStar(core$1H);
	InputField.InputField = core.serialization.object({
	    key: core.serialization.string(),
	    label: core.serialization.string(),
	    description: core.serialization.string().optional(),
	    type: core.serialization.string(),
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InputConfig; })).optional(),
	    constraints: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InputConstraint; })))
	        .optional(),
	});
	return InputField;
}

var InputConstraint = {};

var hasRequiredInputConstraint;

function requireInputConstraint () {
	if (hasRequiredInputConstraint) return InputConstraint;
	hasRequiredInputConstraint = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(InputConstraint, "__esModule", { value: true });
	InputConstraint.InputConstraint = void 0;
	const core = __importStar(core$1H);
	InputConstraint.InputConstraint = core.serialization.object({
	    type: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InputConstraintType; })),
	});
	return InputConstraint;
}

var InputConstraintType = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1j = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1j = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1j = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1j(result, mod, k);
    __setModuleDefault$1j(result, mod);
    return result;
};
Object.defineProperty(InputConstraintType, "__esModule", { value: true });
InputConstraintType.InputConstraintType = void 0;
const core$1j = __importStar$1j(core$1H);
InputConstraintType.InputConstraintType = core$1j.serialization.enum_(["required"]);

var InputConfig = {};

var hasRequiredInputConfig;

function requireInputConfig () {
	if (hasRequiredInputConfig) return InputConfig;
	hasRequiredInputConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(InputConfig, "__esModule", { value: true });
	InputConfig.InputConfig = void 0;
	const core = __importStar(core$1H);
	InputConfig.InputConfig = core.serialization.object({
	    options: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InputEnumPropertyOption; }))),
	});
	return InputConfig;
}

var InputEnumPropertyOption = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1i = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1i = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1i = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1i(result, mod, k);
    __setModuleDefault$1i(result, mod);
    return result;
};
Object.defineProperty(InputEnumPropertyOption, "__esModule", { value: true });
InputEnumPropertyOption.InputEnumPropertyOption = void 0;
const core$1i = __importStar$1i(core$1H);
InputEnumPropertyOption.InputEnumPropertyOption = core$1i.serialization.object({
    label: core$1i.serialization.string().optional(),
    description: core$1i.serialization.string().optional(),
    color: core$1i.serialization.string().optional(),
    icon: core$1i.serialization.string().optional(),
    meta: core$1i.serialization.record(core$1i.serialization.string(), core$1i.serialization.any()).optional(),
    value: core$1i.serialization.any(),
});

var ActionMode = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1h = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1h = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1h = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1h(result, mod, k);
    __setModuleDefault$1h(result, mod);
    return result;
};
Object.defineProperty(ActionMode, "__esModule", { value: true });
ActionMode.ActionMode = void 0;
const core$1h = __importStar$1h(core$1H);
ActionMode.ActionMode = core$1h.serialization.enum_(["foreground", "background", "toolbarBlocking"]);

var ActionSchedule = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1g = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1g = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1g = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1g(result, mod, k);
    __setModuleDefault$1g(result, mod);
    return result;
};
Object.defineProperty(ActionSchedule, "__esModule", { value: true });
ActionSchedule.ActionSchedule = void 0;
const core$1g = __importStar$1g(core$1H);
ActionSchedule.ActionSchedule = core$1g.serialization.enum_(["weekly", "daily", "hourly"]);

var SortDirection = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1f = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1f = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1f = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1f(result, mod, k);
    __setModuleDefault$1f(result, mod);
    return result;
};
Object.defineProperty(SortDirection, "__esModule", { value: true });
SortDirection.SortDirection = void 0;
const core$1f = __importStar$1f(core$1H);
SortDirection.SortDirection = core$1f.serialization.enum_(["asc", "desc"]);

var Success = {};

var hasRequiredSuccess;

function requireSuccess () {
	if (hasRequiredSuccess) return Success;
	hasRequiredSuccess = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Success, "__esModule", { value: true });
	Success.Success = void 0;
	const core = __importStar(core$1H);
	Success.Success = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SuccessData; })).optional(),
	});
	return Success;
}

var SuccessData = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1e = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1e = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1e = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1e(result, mod, k);
    __setModuleDefault$1e(result, mod);
    return result;
};
Object.defineProperty(SuccessData, "__esModule", { value: true });
SuccessData.SuccessData = void 0;
const core$1e = __importStar$1e(core$1H);
SuccessData.SuccessData = core$1e.serialization.object({
    success: core$1e.serialization.boolean(),
});

var Error_ = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1d = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1d = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1d = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1d(result, mod, k);
    __setModuleDefault$1d(result, mod);
    return result;
};
Object.defineProperty(Error_, "__esModule", { value: true });
Error_.Error_ = void 0;
const core$1d = __importStar$1d(core$1H);
Error_.Error_ = core$1d.serialization.object({
    key: core$1d.serialization.string().optional(),
    message: core$1d.serialization.string(),
});

var Errors = {};

var hasRequiredErrors;

function requireErrors () {
	if (hasRequiredErrors) return Errors;
	hasRequiredErrors = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Errors, "__esModule", { value: true });
	Errors.Errors = void 0;
	const core = __importStar(core$1H);
	Errors.Errors = core.serialization.object({
	    errors: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Error_; }))),
	});
	return Errors;
}

var Filter = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1c = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1c = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1c = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1c(result, mod, k);
    __setModuleDefault$1c(result, mod);
    return result;
};
Object.defineProperty(Filter, "__esModule", { value: true });
Filter.Filter = void 0;
const core$1c = __importStar$1c(core$1H);
Filter.Filter = core$1c.serialization.enum_([
    "valid",
    "error",
    "all",
    "none",
]);

var FilterField = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1b = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1b = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1b = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1b(result, mod, k);
    __setModuleDefault$1b(result, mod);
    return result;
};
Object.defineProperty(FilterField, "__esModule", { value: true });
FilterField.FilterField = void 0;
const core$1b = __importStar$1b(core$1H);
FilterField.FilterField = core$1b.serialization.string();

var SearchField = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1a = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1a = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1a = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1a(result, mod, k);
    __setModuleDefault$1a(result, mod);
    return result;
};
Object.defineProperty(SearchField, "__esModule", { value: true });
SearchField.SearchField = void 0;
const core$1a = __importStar$1a(core$1H);
SearchField.SearchField = core$1a.serialization.string();

var SearchValue = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$19 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$19 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$19 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$19(result, mod, k);
    __setModuleDefault$19(result, mod);
    return result;
};
Object.defineProperty(SearchValue, "__esModule", { value: true });
SearchValue.SearchValue = void 0;
const core$19 = __importStar$19(core$1H);
SearchValue.SearchValue = core$19.serialization.string();

var SortField = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$18 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$18 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$18 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$18(result, mod, k);
    __setModuleDefault$18(result, mod);
    return result;
};
Object.defineProperty(SortField, "__esModule", { value: true });
SortField.SortField = void 0;
const core$18 = __importStar$18(core$1H);
SortField.SortField = core$18.serialization.string();

var hasRequiredTypes$g;

function requireTypes$g () {
	if (hasRequiredTypes$g) return types$g;
	hasRequiredTypes$g = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(AgentId, exports);
		__exportStar(AccountId, exports);
		__exportStar(DocumentId, exports);
		__exportStar(GuestId, exports);
		__exportStar(EnvironmentId, exports);
		__exportStar(FileId, exports);
		__exportStar(SpaceId, exports);
		__exportStar(WorkbookId, exports);
		__exportStar(EventId, exports);
		__exportStar(SheetId, exports);
		__exportStar(SnapshotId, exports);
		__exportStar(VersionId, exports);
		__exportStar(JobId, exports);
		__exportStar(UserId, exports);
		__exportStar(SpaceConfigId, exports);
		__exportStar(RecordId, exports);
		__exportStar(SecretId, exports);
		__exportStar(MappingId, exports);
		__exportStar(Pagination, exports);
		__exportStar(requireAction(), exports);
		__exportStar(requireInputForm(), exports);
		__exportStar(InputFormType, exports);
		__exportStar(requireInputField(), exports);
		__exportStar(requireInputConstraint(), exports);
		__exportStar(InputConstraintType, exports);
		__exportStar(requireInputConfig(), exports);
		__exportStar(InputEnumPropertyOption, exports);
		__exportStar(ActionMode, exports);
		__exportStar(ActionSchedule, exports);
		__exportStar(SortDirection, exports);
		__exportStar(requireSuccess(), exports);
		__exportStar(SuccessData, exports);
		__exportStar(Error_, exports);
		__exportStar(requireErrors(), exports);
		__exportStar(Filter, exports);
		__exportStar(FilterField, exports);
		__exportStar(SearchField, exports);
		__exportStar(SearchValue, exports);
		__exportStar(SortField, exports); 
	} (types$g));
	return types$g;
}

var hasRequiredCommons;

function requireCommons () {
	if (hasRequiredCommons) return commons;
	hasRequiredCommons = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$g(), exports); 
	} (commons));
	return commons;
}

var documents = {};

var types$f = {};

var ListDocumentsResponse = {};

var hasRequiredListDocumentsResponse;

function requireListDocumentsResponse () {
	if (hasRequiredListDocumentsResponse) return ListDocumentsResponse;
	hasRequiredListDocumentsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListDocumentsResponse, "__esModule", { value: true });
	ListDocumentsResponse.ListDocumentsResponse = void 0;
	const core = __importStar(core$1H);
	ListDocumentsResponse.ListDocumentsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Document; }))),
	});
	return ListDocumentsResponse;
}

var DocumentResponse = {};

var hasRequiredDocumentResponse;

function requireDocumentResponse () {
	if (hasRequiredDocumentResponse) return DocumentResponse;
	hasRequiredDocumentResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DocumentResponse, "__esModule", { value: true });
	DocumentResponse.DocumentResponse = void 0;
	const core = __importStar(core$1H);
	DocumentResponse.DocumentResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Document; })),
	});
	return DocumentResponse;
}

var DocumentConfig = {};

var hasRequiredDocumentConfig;

function requireDocumentConfig () {
	if (hasRequiredDocumentConfig) return DocumentConfig;
	hasRequiredDocumentConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DocumentConfig, "__esModule", { value: true });
	DocumentConfig.DocumentConfig = void 0;
	const core = __importStar(core$1H);
	DocumentConfig.DocumentConfig = core.serialization.object({
	    title: core.serialization.string(),
	    body: core.serialization.string(),
	    treatments: core.serialization.list(core.serialization.string()).optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	});
	return DocumentConfig;
}

var Document = {};

var hasRequiredDocument;

function requireDocument () {
	if (hasRequiredDocument) return Document;
	hasRequiredDocument = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Document, "__esModule", { value: true });
	Document.Document = void 0;
	const core = __importStar(core$1H);
	Document.Document = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DocumentId; })),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })).optional(),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })).optional(),
	    createdAt: core.serialization.date(),
	    updatedAt: core.serialization.date(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DocumentConfig; })));
	return Document;
}

var hasRequiredTypes$f;

function requireTypes$f () {
	if (hasRequiredTypes$f) return types$f;
	hasRequiredTypes$f = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListDocumentsResponse(), exports);
		__exportStar(requireDocumentResponse(), exports);
		__exportStar(requireDocumentConfig(), exports);
		__exportStar(requireDocument(), exports); 
	} (types$f));
	return types$f;
}

var hasRequiredDocuments;

function requireDocuments () {
	if (hasRequiredDocuments) return documents;
	hasRequiredDocuments = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$f(), exports); 
	} (documents));
	return documents;
}

var environments$j = {};

var types$e = {};

var ListEnvironmentsResponse = {};

var hasRequiredListEnvironmentsResponse;

function requireListEnvironmentsResponse () {
	if (hasRequiredListEnvironmentsResponse) return ListEnvironmentsResponse;
	hasRequiredListEnvironmentsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListEnvironmentsResponse, "__esModule", { value: true });
	ListEnvironmentsResponse.ListEnvironmentsResponse = void 0;
	const core = __importStar(core$1H);
	ListEnvironmentsResponse.ListEnvironmentsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Environment; }))),
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	});
	return ListEnvironmentsResponse;
}

var EnvironmentResponse = {};

var hasRequiredEnvironmentResponse;

function requireEnvironmentResponse () {
	if (hasRequiredEnvironmentResponse) return EnvironmentResponse;
	hasRequiredEnvironmentResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EnvironmentResponse, "__esModule", { value: true });
	EnvironmentResponse.EnvironmentResponse = void 0;
	const core = __importStar(core$1H);
	EnvironmentResponse.EnvironmentResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Environment; })),
	});
	return EnvironmentResponse;
}

var Environment = {};

var hasRequiredEnvironment;

function requireEnvironment () {
	if (hasRequiredEnvironment) return Environment;
	hasRequiredEnvironment = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Environment, "__esModule", { value: true });
	Environment.Environment = void 0;
	const core = __importStar(core$1H);
	Environment.Environment = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })),
	    accountId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AccountId; })),
	    name: core.serialization.string(),
	    isProd: core.serialization.boolean(),
	    guestAuthentication: core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestAuthenticationEnum; }))),
	    features: core.serialization.record(core.serialization.string(), core.serialization.any()),
	    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()),
	    translationsPath: core.serialization.string().optional(),
	    namespaces: core.serialization.list(core.serialization.string()).optional(),
	    languageOverride: core.serialization.string().optional(),
	});
	return Environment;
}

var EnvironmentConfigCreate = {};

var hasRequiredEnvironmentConfigCreate;

function requireEnvironmentConfigCreate () {
	if (hasRequiredEnvironmentConfigCreate) return EnvironmentConfigCreate;
	hasRequiredEnvironmentConfigCreate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EnvironmentConfigCreate, "__esModule", { value: true });
	EnvironmentConfigCreate.EnvironmentConfigCreate = void 0;
	const core = __importStar(core$1H);
	EnvironmentConfigCreate.EnvironmentConfigCreate = core.serialization.object({
	    name: core.serialization.string(),
	    isProd: core.serialization.boolean(),
	    guestAuthentication: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestAuthenticationEnum; })))
	        .optional(),
	    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
	    translationsPath: core.serialization.string().optional(),
	    namespaces: core.serialization.list(core.serialization.string()).optional(),
	    languageOverride: core.serialization.string().optional(),
	});
	return EnvironmentConfigCreate;
}

var EnvironmentConfigUpdate = {};

var hasRequiredEnvironmentConfigUpdate;

function requireEnvironmentConfigUpdate () {
	if (hasRequiredEnvironmentConfigUpdate) return EnvironmentConfigUpdate;
	hasRequiredEnvironmentConfigUpdate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EnvironmentConfigUpdate, "__esModule", { value: true });
	EnvironmentConfigUpdate.EnvironmentConfigUpdate = void 0;
	const core = __importStar(core$1H);
	EnvironmentConfigUpdate.EnvironmentConfigUpdate = core.serialization.object({
	    name: core.serialization.string().optional(),
	    isProd: core.serialization.boolean().optional(),
	    guestAuthentication: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestAuthenticationEnum; })))
	        .optional(),
	    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
	    translationsPath: core.serialization.string().optional(),
	    namespaces: core.serialization.list(core.serialization.string()).optional(),
	    languageOverride: core.serialization.string().optional(),
	});
	return EnvironmentConfigUpdate;
}

var GuestAuthenticationEnum = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$17 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$17 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$17 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$17(result, mod, k);
    __setModuleDefault$17(result, mod);
    return result;
};
Object.defineProperty(GuestAuthenticationEnum, "__esModule", { value: true });
GuestAuthenticationEnum.GuestAuthenticationEnum = void 0;
const core$17 = __importStar$17(core$1H);
GuestAuthenticationEnum.GuestAuthenticationEnum = core$17.serialization.enum_(["shared_link", "magic_link"]);

var hasRequiredTypes$e;

function requireTypes$e () {
	if (hasRequiredTypes$e) return types$e;
	hasRequiredTypes$e = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListEnvironmentsResponse(), exports);
		__exportStar(requireEnvironmentResponse(), exports);
		__exportStar(requireEnvironment(), exports);
		__exportStar(requireEnvironmentConfigCreate(), exports);
		__exportStar(requireEnvironmentConfigUpdate(), exports);
		__exportStar(GuestAuthenticationEnum, exports); 
	} (types$e));
	return types$e;
}

var hasRequiredEnvironments;

function requireEnvironments () {
	if (hasRequiredEnvironments) return environments$j;
	hasRequiredEnvironments = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$e(), exports); 
	} (environments$j));
	return environments$j;
}

var events = {};

var types$d = {};

var ListAllEventsResponse = {};

var hasRequiredListAllEventsResponse;

function requireListAllEventsResponse () {
	if (hasRequiredListAllEventsResponse) return ListAllEventsResponse;
	hasRequiredListAllEventsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListAllEventsResponse, "__esModule", { value: true });
	ListAllEventsResponse.ListAllEventsResponse = void 0;
	const core = __importStar(core$1H);
	ListAllEventsResponse.ListAllEventsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Event; }))),
	});
	return ListAllEventsResponse;
}

var CreateEventConfig = {};

var hasRequiredCreateEventConfig;

function requireCreateEventConfig () {
	if (hasRequiredCreateEventConfig) return CreateEventConfig;
	hasRequiredCreateEventConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CreateEventConfig, "__esModule", { value: true });
	CreateEventConfig.CreateEventConfig = void 0;
	const core = __importStar(core$1H);
	CreateEventConfig.CreateEventConfig = core.serialization
	    .object({
	    topic: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventTopic; })),
	    payload: core.serialization.record(core.serialization.string(), core.serialization.any()),
	    deletedAt: core.serialization.date().optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseEvent; })));
	return CreateEventConfig;
}

var EventResponse = {};

var hasRequiredEventResponse;

function requireEventResponse () {
	if (hasRequiredEventResponse) return EventResponse;
	hasRequiredEventResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EventResponse, "__esModule", { value: true });
	EventResponse.EventResponse = void 0;
	const core = __importStar(core$1H);
	EventResponse.EventResponse = core.serialization.object({
	    data: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Event; })),
	});
	return EventResponse;
}

var Event = {};

var hasRequiredEvent;

function requireEvent () {
	if (hasRequiredEvent) return Event;
	hasRequiredEvent = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Event, "__esModule", { value: true });
	Event.Event = void 0;
	const core = __importStar(core$1H);
	Event.Event = core.serialization
	    .union("topic", {
	    "agent:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "agent:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "agent:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "space:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "space:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "space:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "document:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "document:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "document:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "workbook:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "workbook:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "workbook:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "sheet:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "sheet:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "sheet:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "snapshot:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "records:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "records:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "records:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "file:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "file:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "file:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:failed": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:completed": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:ready": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:scheduled": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "job:outcome-acknowledged": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "commit:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "commit:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "commit:completed": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	    "layer:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GenericEvent; })),
	})
	    .transform({
	    transform: (value) => value,
	    untransform: (value) => value,
	});
	return Event;
}

var GenericEvent = {};

var hasRequiredGenericEvent;

function requireGenericEvent () {
	if (hasRequiredGenericEvent) return GenericEvent;
	hasRequiredGenericEvent = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GenericEvent, "__esModule", { value: true });
	GenericEvent.GenericEvent = void 0;
	const core = __importStar(core$1H);
	GenericEvent.GenericEvent = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventId; })),
	    createdAt: core.serialization.date(),
	    deletedAt: core.serialization.date().optional(),
	    acknowledgedAt: core.serialization.date().optional(),
	    acknowledgedBy: core.serialization.string().optional(),
	    payload: core.serialization.record(core.serialization.string(), core.serialization.any()),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseEvent; })));
	return GenericEvent;
}

var BaseEvent = {};

var hasRequiredBaseEvent;

function requireBaseEvent () {
	if (hasRequiredBaseEvent) return BaseEvent;
	hasRequiredBaseEvent = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(BaseEvent, "__esModule", { value: true });
	BaseEvent.BaseEvent = void 0;
	const core = __importStar(core$1H);
	BaseEvent.BaseEvent = core.serialization.object({
	    domain: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Domain; })),
	    context: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Context; })),
	    attributes: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventAttributes; })).optional(),
	    callbackUrl: core.serialization.string().optional(),
	    dataUrl: core.serialization.string().optional(),
	    target: core.serialization.string().optional(),
	    origin: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Origin; })).optional(),
	    namespaces: core.serialization.list(core.serialization.string()).optional(),
	});
	return BaseEvent;
}

var EventTopic = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$16 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$16 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$16 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$16(result, mod, k);
    __setModuleDefault$16(result, mod);
    return result;
};
Object.defineProperty(EventTopic, "__esModule", { value: true });
EventTopic.EventTopic = void 0;
const core$16 = __importStar$16(core$1H);
EventTopic.EventTopic = core$16.serialization.enum_([
    "agent:created",
    "agent:updated",
    "agent:deleted",
    "space:created",
    "space:updated",
    "space:deleted",
    "document:created",
    "document:updated",
    "document:deleted",
    "workbook:created",
    "workbook:updated",
    "workbook:deleted",
    "sheet:created",
    "sheet:updated",
    "sheet:deleted",
    "snapshot:created",
    "records:created",
    "records:updated",
    "records:deleted",
    "file:created",
    "file:updated",
    "file:deleted",
    "job:created",
    "job:updated",
    "job:deleted",
    "job:completed",
    "job:ready",
    "job:scheduled",
    "job:outcome-acknowledged",
    "job:failed",
    "commit:created",
    "commit:updated",
    "commit:completed",
    "layer:created",
]);

var Domain = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$15 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$15 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$15 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$15(result, mod, k);
    __setModuleDefault$15(result, mod);
    return result;
};
Object.defineProperty(Domain, "__esModule", { value: true });
Domain.Domain = void 0;
const core$15 = __importStar$15(core$1H);
Domain.Domain = core$15.serialization.enum_([
    "file",
    "space",
    "workbook",
    "job",
    "document",
    "sheet",
]);

var Context = {};

var hasRequiredContext;

function requireContext () {
	if (hasRequiredContext) return Context;
	hasRequiredContext = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Context, "__esModule", { value: true });
	Context.Context = void 0;
	const core = __importStar(core$1H);
	Context.Context = core.serialization.object({
	    namespaces: core.serialization.list(core.serialization.string()).optional(),
	    slugs: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventContextSlugs; })).optional(),
	    actionName: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ActionName; })).optional(),
	    accountId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AccountId; })),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })).optional(),
	    workbookId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })).optional(),
	    sheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })).optional(),
	    sheetSlug: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetSlug; })).optional(),
	    snapshotId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SnapshotId; })).optional(),
	    versionId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })).optional(),
	    jobId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobId; })).optional(),
	    fileId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FileId; })).optional(),
	    documentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DocumentId; })).optional(),
	    precedingEventId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventId; })).optional(),
	    actorId: core.serialization.string().optional(),
	});
	return Context;
}

var EventContextSlugs = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$14 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$14 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$14 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$14(result, mod, k);
    __setModuleDefault$14(result, mod);
    return result;
};
Object.defineProperty(EventContextSlugs, "__esModule", { value: true });
EventContextSlugs.EventContextSlugs = void 0;
const core$14 = __importStar$14(core$1H);
EventContextSlugs.EventContextSlugs = core$14.serialization.object({
    space: core$14.serialization.string().optional(),
    workbook: core$14.serialization.string().optional(),
    sheet: core$14.serialization.string().optional(),
});

var ActionName = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$13 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$13 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$13 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$13(result, mod, k);
    __setModuleDefault$13(result, mod);
    return result;
};
Object.defineProperty(ActionName, "__esModule", { value: true });
ActionName.ActionName = void 0;
const core$13 = __importStar$13(core$1H);
ActionName.ActionName = core$13.serialization.string();

var Progress = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$12 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$12 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$12 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$12(result, mod, k);
    __setModuleDefault$12(result, mod);
    return result;
};
Object.defineProperty(Progress, "__esModule", { value: true });
Progress.Progress = void 0;
const core$12 = __importStar$12(core$1H);
Progress.Progress = core$12.serialization.object({
    current: core$12.serialization.number().optional(),
    total: core$12.serialization.number().optional(),
    percent: core$12.serialization.number().optional(),
});

var EventAttributes = {};

var hasRequiredEventAttributes;

function requireEventAttributes () {
	if (hasRequiredEventAttributes) return EventAttributes;
	hasRequiredEventAttributes = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EventAttributes, "__esModule", { value: true });
	EventAttributes.EventAttributes = void 0;
	const core = __importStar(core$1H);
	EventAttributes.EventAttributes = core.serialization.object({
	    targetUpdatedAt: core.serialization.date().optional(),
	    progress: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Progress; })).optional(),
	});
	return EventAttributes;
}

var SheetSlug = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$11 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$11 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$11 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$11(result, mod, k);
    __setModuleDefault$11(result, mod);
    return result;
};
Object.defineProperty(SheetSlug, "__esModule", { value: true });
SheetSlug.SheetSlug = void 0;
const core$11 = __importStar$11(core$1H);
SheetSlug.SheetSlug = core$11.serialization.string();

var Origin = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$10 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$10 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$10 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$10(result, mod, k);
    __setModuleDefault$10(result, mod);
    return result;
};
Object.defineProperty(Origin, "__esModule", { value: true });
Origin.Origin = void 0;
const core$10 = __importStar$10(core$1H);
Origin.Origin = core$10.serialization.object({
    id: core$10.serialization.string().optional(),
    slug: core$10.serialization.string().optional(),
});

var hasRequiredTypes$d;

function requireTypes$d () {
	if (hasRequiredTypes$d) return types$d;
	hasRequiredTypes$d = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListAllEventsResponse(), exports);
		__exportStar(requireCreateEventConfig(), exports);
		__exportStar(requireEventResponse(), exports);
		__exportStar(requireEvent(), exports);
		__exportStar(requireGenericEvent(), exports);
		__exportStar(requireBaseEvent(), exports);
		__exportStar(EventTopic, exports);
		__exportStar(Domain, exports);
		__exportStar(requireContext(), exports);
		__exportStar(EventContextSlugs, exports);
		__exportStar(ActionName, exports);
		__exportStar(Progress, exports);
		__exportStar(requireEventAttributes(), exports);
		__exportStar(SheetSlug, exports);
		__exportStar(Origin, exports); 
	} (types$d));
	return types$d;
}

var hasRequiredEvents;

function requireEvents () {
	if (hasRequiredEvents) return events;
	hasRequiredEvents = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$d(), exports); 
	} (events));
	return events;
}

var files = {};

var types$c = {};

var ListFilesResponse = {};

var hasRequiredListFilesResponse;

function requireListFilesResponse () {
	if (hasRequiredListFilesResponse) return ListFilesResponse;
	hasRequiredListFilesResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListFilesResponse, "__esModule", { value: true });
	ListFilesResponse.ListFilesResponse = void 0;
	const core = __importStar(core$1H);
	ListFilesResponse.ListFilesResponse = core.serialization.object({
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).File_; }))),
	});
	return ListFilesResponse;
}

var FileResponse = {};

var hasRequiredFileResponse;

function requireFileResponse () {
	if (hasRequiredFileResponse) return FileResponse;
	hasRequiredFileResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(FileResponse, "__esModule", { value: true });
	FileResponse.FileResponse = void 0;
	const core = __importStar(core$1H);
	FileResponse.FileResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).File_; })),
	});
	return FileResponse;
}

var File_ = {};

var hasRequiredFile_;

function requireFile_ () {
	if (hasRequiredFile_) return File_;
	hasRequiredFile_ = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(File_, "__esModule", { value: true });
	File_.File_ = void 0;
	const core = __importStar(core$1H);
	File_.File_ = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FileId; })),
	    name: core.serialization.string(),
	    ext: core.serialization.string(),
	    mimetype: core.serialization.string(),
	    encoding: core.serialization.string(),
	    status: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ModelFileStatusEnum; })),
	    mode: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Mode; })).optional(),
	    size: core.serialization.number(),
	    bytesReceived: core.serialization.number(),
	    createdAt: core.serialization.date(),
	    updatedAt: core.serialization.date(),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })),
	    workbookId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })).optional(),
	    sheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })).optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	});
	return File_;
}

var ModelFileStatusEnum = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$$ = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$$ = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$$ = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$$(result, mod, k);
    __setModuleDefault$$(result, mod);
    return result;
};
Object.defineProperty(ModelFileStatusEnum, "__esModule", { value: true });
ModelFileStatusEnum.ModelFileStatusEnum = void 0;
const core$$ = __importStar$$(core$1H);
ModelFileStatusEnum.ModelFileStatusEnum = core$$.serialization.enum_(["partial", "complete", "archived", "purged", "failed"]);

var Mode = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$_ = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$_ = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$_ = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$_(result, mod, k);
    __setModuleDefault$_(result, mod);
    return result;
};
Object.defineProperty(Mode, "__esModule", { value: true });
Mode.Mode = void 0;
const core$_ = __importStar$_(core$1H);
Mode.Mode = core$_.serialization.enum_([
    "import",
    "export",
]);

var hasRequiredTypes$c;

function requireTypes$c () {
	if (hasRequiredTypes$c) return types$c;
	hasRequiredTypes$c = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListFilesResponse(), exports);
		__exportStar(requireFileResponse(), exports);
		__exportStar(requireFile_(), exports);
		__exportStar(ModelFileStatusEnum, exports);
		__exportStar(Mode, exports); 
	} (types$c));
	return types$c;
}

var client$7 = {};

var requests$4 = {};

var UpdateFileRequest = {};

var hasRequiredUpdateFileRequest;

function requireUpdateFileRequest () {
	if (hasRequiredUpdateFileRequest) return UpdateFileRequest;
	hasRequiredUpdateFileRequest = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(UpdateFileRequest, "__esModule", { value: true });
	UpdateFileRequest.UpdateFileRequest = void 0;
	const core = __importStar(core$1H);
	UpdateFileRequest.UpdateFileRequest = core.serialization.object({
	    workbookId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })).optional(),
	    name: core.serialization.string().optional(),
	    mode: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Mode; })).optional(),
	    status: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ModelFileStatusEnum; })).optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	});
	return UpdateFileRequest;
}

var hasRequiredRequests$3;

function requireRequests$3 () {
	if (hasRequiredRequests$3) return requests$4;
	hasRequiredRequests$3 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.UpdateFileRequest = void 0;
		var UpdateFileRequest_1 = requireUpdateFileRequest();
		Object.defineProperty(exports, "UpdateFileRequest", { enumerable: true, get: function () { return UpdateFileRequest_1.UpdateFileRequest; } }); 
	} (requests$4));
	return requests$4;
}

var hasRequiredClient$6;

function requireClient$6 () {
	if (hasRequiredClient$6) return client$7;
	hasRequiredClient$6 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireRequests$3(), exports); 
	} (client$7));
	return client$7;
}

var hasRequiredFiles;

function requireFiles () {
	if (hasRequiredFiles) return files;
	hasRequiredFiles = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$c(), exports);
		__exportStar(requireClient$6(), exports); 
	} (files));
	return files;
}

var guests = {};

var types$b = {};

var ListGuestsResponse = {};

var hasRequiredListGuestsResponse;

function requireListGuestsResponse () {
	if (hasRequiredListGuestsResponse) return ListGuestsResponse;
	hasRequiredListGuestsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListGuestsResponse, "__esModule", { value: true });
	ListGuestsResponse.ListGuestsResponse = void 0;
	const core = __importStar(core$1H);
	ListGuestsResponse.ListGuestsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Guest; }))),
	});
	return ListGuestsResponse;
}

var CreateGuestResponse = {};

var hasRequiredCreateGuestResponse;

function requireCreateGuestResponse () {
	if (hasRequiredCreateGuestResponse) return CreateGuestResponse;
	hasRequiredCreateGuestResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CreateGuestResponse, "__esModule", { value: true });
	CreateGuestResponse.CreateGuestResponse = void 0;
	const core = __importStar(core$1H);
	CreateGuestResponse.CreateGuestResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Guest; }))),
	});
	return CreateGuestResponse;
}

var GuestResponse = {};

var hasRequiredGuestResponse;

function requireGuestResponse () {
	if (hasRequiredGuestResponse) return GuestResponse;
	hasRequiredGuestResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GuestResponse, "__esModule", { value: true });
	GuestResponse.GuestResponse = void 0;
	const core = __importStar(core$1H);
	GuestResponse.GuestResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Guest; })),
	});
	return GuestResponse;
}

var Guest = {};

var hasRequiredGuest;

function requireGuest () {
	if (hasRequiredGuest) return Guest;
	hasRequiredGuest = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Guest, "__esModule", { value: true });
	Guest.Guest = void 0;
	const core = __importStar(core$1H);
	Guest.Guest = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestId; })),
	    createdAt: core.serialization.date(),
	    updatedAt: core.serialization.date(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestConfig; })));
	return Guest;
}

var GuestConfig = {};

var hasRequiredGuestConfig;

function requireGuestConfig () {
	if (hasRequiredGuestConfig) return GuestConfig;
	hasRequiredGuestConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GuestConfig, "__esModule", { value: true });
	GuestConfig.GuestConfig = void 0;
	const core = __importStar(core$1H);
	GuestConfig.GuestConfig = core.serialization.object({
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })),
	    email: core.serialization.string(),
	    name: core.serialization.string(),
	    spaces: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestSpace; }))),
	});
	return GuestConfig;
}

var GuestConfigUpdate = {};

var hasRequiredGuestConfigUpdate;

function requireGuestConfigUpdate () {
	if (hasRequiredGuestConfigUpdate) return GuestConfigUpdate;
	hasRequiredGuestConfigUpdate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GuestConfigUpdate, "__esModule", { value: true });
	GuestConfigUpdate.GuestConfigUpdate = void 0;
	const core = __importStar(core$1H);
	GuestConfigUpdate.GuestConfigUpdate = core.serialization.object({
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })).optional(),
	    email: core.serialization.string().optional(),
	    name: core.serialization.string().optional(),
	    spaces: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestSpace; })))
	        .optional(),
	});
	return GuestConfigUpdate;
}

var GuestWorkbook = {};

var hasRequiredGuestWorkbook;

function requireGuestWorkbook () {
	if (hasRequiredGuestWorkbook) return GuestWorkbook;
	hasRequiredGuestWorkbook = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GuestWorkbook, "__esModule", { value: true });
	GuestWorkbook.GuestWorkbook = void 0;
	const core = __importStar(core$1H);
	GuestWorkbook.GuestWorkbook = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })),
	});
	return GuestWorkbook;
}

var GuestSpace = {};

var hasRequiredGuestSpace;

function requireGuestSpace () {
	if (hasRequiredGuestSpace) return GuestSpace;
	hasRequiredGuestSpace = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GuestSpace, "__esModule", { value: true });
	GuestSpace.GuestSpace = void 0;
	const core = __importStar(core$1H);
	GuestSpace.GuestSpace = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })),
	    workbooks: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestWorkbook; })))
	        .optional(),
	    lastAccessed: core.serialization.date().optional(),
	});
	return GuestSpace;
}

var Invite = {};

var hasRequiredInvite$1;

function requireInvite$1 () {
	if (hasRequiredInvite$1) return Invite;
	hasRequiredInvite$1 = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Invite, "__esModule", { value: true });
	Invite.Invite = void 0;
	const core = __importStar(core$1H);
	Invite.Invite = core.serialization.object({
	    guestId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestId; })),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })),
	    fromName: core.serialization.string().optional(),
	    message: core.serialization.string().optional(),
	});
	return Invite;
}

var hasRequiredTypes$b;

function requireTypes$b () {
	if (hasRequiredTypes$b) return types$b;
	hasRequiredTypes$b = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListGuestsResponse(), exports);
		__exportStar(requireCreateGuestResponse(), exports);
		__exportStar(requireGuestResponse(), exports);
		__exportStar(requireGuest(), exports);
		__exportStar(requireGuestConfig(), exports);
		__exportStar(requireGuestConfigUpdate(), exports);
		__exportStar(requireGuestWorkbook(), exports);
		__exportStar(requireGuestSpace(), exports);
		__exportStar(requireInvite$1(), exports); 
	} (types$b));
	return types$b;
}

var client$6 = {};

var create = {};

var hasRequiredCreate;

function requireCreate () {
	if (hasRequiredCreate) return create;
	hasRequiredCreate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(create, "__esModule", { value: true });
	create.Request = void 0;
	const core = __importStar(core$1H);
	create.Request = core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestConfig; })));
	return create;
}

var invite = {};

var hasRequiredInvite;

function requireInvite () {
	if (hasRequiredInvite) return invite;
	hasRequiredInvite = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(invite, "__esModule", { value: true });
	invite.Request = void 0;
	const core = __importStar(core$1H);
	invite.Request = core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Invite; })));
	return invite;
}

var hasRequiredClient$5;

function requireClient$5 () {
	if (hasRequiredClient$5) return client$6;
	hasRequiredClient$5 = 1;
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(client$6, "__esModule", { value: true });
	client$6.invite = client$6.create = void 0;
	client$6.create = __importStar(requireCreate());
	client$6.invite = __importStar(requireInvite());
	return client$6;
}

var hasRequiredGuests;

function requireGuests () {
	if (hasRequiredGuests) return guests;
	hasRequiredGuests = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$b(), exports);
		__exportStar(requireClient$5(), exports); 
	} (guests));
	return guests;
}

var jobs = {};

var types$a = {};

var ListJobsResponse = {};

var hasRequiredListJobsResponse;

function requireListJobsResponse () {
	if (hasRequiredListJobsResponse) return ListJobsResponse;
	hasRequiredListJobsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListJobsResponse, "__esModule", { value: true });
	ListJobsResponse.ListJobsResponse = void 0;
	const core = __importStar(core$1H);
	ListJobsResponse.ListJobsResponse = core.serialization.object({
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Job; }))),
	});
	return ListJobsResponse;
}

var JobResponse = {};

var hasRequiredJobResponse;

function requireJobResponse () {
	if (hasRequiredJobResponse) return JobResponse;
	hasRequiredJobResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobResponse, "__esModule", { value: true });
	JobResponse.JobResponse = void 0;
	const core = __importStar(core$1H);
	JobResponse.JobResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Job; })),
	});
	return JobResponse;
}

var JobPlanResponse = {};

var hasRequiredJobPlanResponse;

function requireJobPlanResponse () {
	if (hasRequiredJobPlanResponse) return JobPlanResponse;
	hasRequiredJobPlanResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobPlanResponse, "__esModule", { value: true });
	JobPlanResponse.JobPlanResponse = void 0;
	const core = __importStar(core$1H);
	JobPlanResponse.JobPlanResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobPlan; })),
	});
	return JobPlanResponse;
}

var Job = {};

var hasRequiredJob;

function requireJob () {
	if (hasRequiredJob) return Job;
	hasRequiredJob = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Job, "__esModule", { value: true });
	Job.Job = void 0;
	const core = __importStar(core$1H);
	Job.Job = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobId; })),
	    createdAt: core.serialization.date(),
	    updatedAt: core.serialization.date(),
	    startedAt: core.serialization.date().optional(),
	    finishedAt: core.serialization.date().optional(),
	    outcomeAcknowledgedAt: core.serialization.date().optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobConfig; })));
	return Job;
}

var JobConfig = {};

var hasRequiredJobConfig;

function requireJobConfig () {
	if (hasRequiredJobConfig) return JobConfig;
	hasRequiredJobConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobConfig, "__esModule", { value: true });
	JobConfig.JobConfig = void 0;
	const core = __importStar(core$1H);
	JobConfig.JobConfig = core.serialization.object({
	    type: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobType; })),
	    operation: core.serialization.string(),
	    source: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobSource; })),
	    destination: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobDestination; })).optional(),
	    config: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobUpdateConfig; })).optional(),
	    trigger: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Trigger; })).optional(),
	    status: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobStatus; })).optional(),
	    progress: core.serialization.number().optional(),
	    fileId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FileId; })).optional(),
	    mode: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobMode; })).optional(),
	    input: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
	    subject: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobSubject; })).optional(),
	    outcome: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
	    info: core.serialization.string().optional(),
	    managed: core.serialization.boolean().optional(),
	});
	return JobConfig;
}

var JobUpdate = {};

var hasRequiredJobUpdate;

function requireJobUpdate () {
	if (hasRequiredJobUpdate) return JobUpdate;
	hasRequiredJobUpdate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobUpdate, "__esModule", { value: true });
	JobUpdate.JobUpdate = void 0;
	const core = __importStar(core$1H);
	JobUpdate.JobUpdate = core.serialization.object({
	    config: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobUpdateConfig; })).optional(),
	    status: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobStatus; })).optional(),
	    progress: core.serialization.number().optional(),
	    outcomeAcknowledgedAt: core.serialization.date().optional(),
	});
	return JobUpdate;
}

var JobUpdateConfig = {};

var hasRequiredJobUpdateConfig;

function requireJobUpdateConfig () {
	if (hasRequiredJobUpdateConfig) return JobUpdateConfig;
	hasRequiredJobUpdateConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobUpdateConfig, "__esModule", { value: true });
	JobUpdateConfig.JobUpdateConfig = void 0;
	const core = __importStar(core$1H);
	JobUpdateConfig.JobUpdateConfig = core.serialization.undiscriminatedUnion([
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DeleteRecordsJobConfig; })),
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FileJobConfig; })),
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).PipelineJobConfig; })),
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ExportJobConfig; })),
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MutateJobConfig; })),
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FindAndReplaceJobConfig; })),
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EmptyObject; })),
	]);
	return JobUpdateConfig;
}

var JobSource = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$Z = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$Z = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$Z = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$Z(result, mod, k);
    __setModuleDefault$Z(result, mod);
    return result;
};
Object.defineProperty(JobSource, "__esModule", { value: true });
JobSource.JobSource = void 0;
const core$Z = __importStar$Z(core$1H);
JobSource.JobSource = core$Z.serialization.string();

var JobDestination = {};

var hasRequiredJobDestination;

function requireJobDestination () {
	if (hasRequiredJobDestination) return JobDestination;
	hasRequiredJobDestination = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobDestination, "__esModule", { value: true });
	JobDestination.JobDestination = void 0;
	const core = __importStar(core$1H);
	JobDestination.JobDestination = core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; }));
	return JobDestination;
}

var DeleteRecordsJobConfig = {};

var hasRequiredDeleteRecordsJobConfig;

function requireDeleteRecordsJobConfig () {
	if (hasRequiredDeleteRecordsJobConfig) return DeleteRecordsJobConfig;
	hasRequiredDeleteRecordsJobConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DeleteRecordsJobConfig, "__esModule", { value: true });
	DeleteRecordsJobConfig.DeleteRecordsJobConfig = void 0;
	const core = __importStar(core$1H);
	DeleteRecordsJobConfig.DeleteRecordsJobConfig = core.serialization.object({
	    filter: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Filter; })).optional(),
	    filterField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FilterField; })).optional(),
	    searchValue: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchValue; })).optional(),
	    searchField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchField; })).optional(),
	    q: core.serialization.string().optional(),
	    sheet: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	    exceptions: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordId; })))
	        .optional(),
	});
	return DeleteRecordsJobConfig;
}

var FileJobConfig = {};

var hasRequiredFileJobConfig;

function requireFileJobConfig () {
	if (hasRequiredFileJobConfig) return FileJobConfig;
	hasRequiredFileJobConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(FileJobConfig, "__esModule", { value: true });
	FileJobConfig.FileJobConfig = void 0;
	const core = __importStar(core$1H);
	FileJobConfig.FileJobConfig = core.serialization.object({
	    driver: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Driver; })),
	    options: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
	});
	return FileJobConfig;
}

var MutateJobConfig = {};

var hasRequiredMutateJobConfig;

function requireMutateJobConfig () {
	if (hasRequiredMutateJobConfig) return MutateJobConfig;
	hasRequiredMutateJobConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(MutateJobConfig, "__esModule", { value: true });
	MutateJobConfig.MutateJobConfig = void 0;
	const core = __importStar(core$1H);
	MutateJobConfig.MutateJobConfig = core.serialization.object({
	    sheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	    mutateRecord: core.serialization.string(),
	    mutationId: core.serialization.string().optional(),
	    filter: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Filter; })).optional(),
	    filterField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FilterField; })).optional(),
	    searchValue: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchValue; })).optional(),
	    searchField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchField; })).optional(),
	    q: core.serialization.string().optional(),
	    ids: core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordId; }))).optional(),
	});
	return MutateJobConfig;
}

var Driver = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$Y = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$Y = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$Y = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$Y(result, mod, k);
    __setModuleDefault$Y(result, mod);
    return result;
};
Object.defineProperty(Driver, "__esModule", { value: true });
Driver.Driver = void 0;
const core$Y = __importStar$Y(core$1H);
Driver.Driver = core$Y.serialization.enum_([
    "csv",
]);

var Trigger = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$X = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$X = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$X = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$X(result, mod, k);
    __setModuleDefault$X(result, mod);
    return result;
};
Object.defineProperty(Trigger, "__esModule", { value: true });
Trigger.Trigger = void 0;
const core$X = __importStar$X(core$1H);
Trigger.Trigger = core$X.serialization.enum_([
    "manual",
    "immediate",
]);

var PipelineJobConfig = {};

var hasRequiredPipelineJobConfig;

function requirePipelineJobConfig () {
	if (hasRequiredPipelineJobConfig) return PipelineJobConfig;
	hasRequiredPipelineJobConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(PipelineJobConfig, "__esModule", { value: true });
	PipelineJobConfig.PipelineJobConfig = void 0;
	const core = __importStar(core$1H);
	PipelineJobConfig.PipelineJobConfig = core.serialization.object({
	    sourceSheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	    destinationSheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	});
	return PipelineJobConfig;
}

var JobType = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$W = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$W = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$W = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$W(result, mod, k);
    __setModuleDefault$W(result, mod);
    return result;
};
Object.defineProperty(JobType, "__esModule", { value: true });
JobType.JobType = void 0;
const core$W = __importStar$W(core$1H);
JobType.JobType = core$W.serialization.enum_([
    "file",
    "workbook",
    "sheet",
]);

var JobStatus = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$V = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$V = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$V = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$V(result, mod, k);
    __setModuleDefault$V(result, mod);
    return result;
};
Object.defineProperty(JobStatus, "__esModule", { value: true });
JobStatus.JobStatus = void 0;
const core$V = __importStar$V(core$1H);
JobStatus.JobStatus = core$V.serialization.enum_(["planning", "ready", "executing", "complete", "failed"]);

var JobMode = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$U = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$U = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$U = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$U(result, mod, k);
    __setModuleDefault$U(result, mod);
    return result;
};
Object.defineProperty(JobMode, "__esModule", { value: true });
JobMode.JobMode = void 0;
const core$U = __importStar$U(core$1H);
JobMode.JobMode = core$U.serialization.enum_([
    "foreground",
    "background",
    "toolbarBlocking",
]);

var JobSubject = {};

var hasRequiredJobSubject;

function requireJobSubject () {
	if (hasRequiredJobSubject) return JobSubject;
	hasRequiredJobSubject = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobSubject, "__esModule", { value: true });
	JobSubject.JobSubject = void 0;
	const core = __importStar(core$1H);
	JobSubject.JobSubject = core.serialization
	    .union("type", {
	    resource: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ResourceJobSubject; })),
	    collection: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CollectionJobSubject; })),
	})
	    .transform({
	    transform: (value) => value,
	    untransform: (value) => value,
	});
	return JobSubject;
}

var CollectionJobSubject = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$T = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$T = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$T = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$T(result, mod, k);
    __setModuleDefault$T(result, mod);
    return result;
};
Object.defineProperty(CollectionJobSubject, "__esModule", { value: true });
CollectionJobSubject.CollectionJobSubject = void 0;
const core$T = __importStar$T(core$1H);
CollectionJobSubject.CollectionJobSubject = core$T.serialization.object({
    resource: core$T.serialization.string(),
    params: core$T.serialization.record(core$T.serialization.string(), core$T.serialization.any()).optional(),
    query: core$T.serialization.record(core$T.serialization.string(), core$T.serialization.any()).optional(),
});

var ResourceJobSubject = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$S = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$S = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$S = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$S(result, mod, k);
    __setModuleDefault$S(result, mod);
    return result;
};
Object.defineProperty(ResourceJobSubject, "__esModule", { value: true });
ResourceJobSubject.ResourceJobSubject = void 0;
const core$S = __importStar$S(core$1H);
ResourceJobSubject.ResourceJobSubject = core$S.serialization.object({
    id: core$S.serialization.string(),
});

var JobPlan = {};

var hasRequiredJobPlan;

function requireJobPlan () {
	if (hasRequiredJobPlan) return JobPlan;
	hasRequiredJobPlan = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobPlan, "__esModule", { value: true });
	JobPlan.JobPlan = void 0;
	const core = __importStar(core$1H);
	JobPlan.JobPlan = core.serialization.object({
	    job: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Job; })),
	    plan: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobExecutionPlan; })),
	});
	return JobPlan;
}

var JobExecutionPlanRequest = {};

var hasRequiredJobExecutionPlanRequest;

function requireJobExecutionPlanRequest () {
	if (hasRequiredJobExecutionPlanRequest) return JobExecutionPlanRequest;
	hasRequiredJobExecutionPlanRequest = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobExecutionPlanRequest, "__esModule", { value: true });
	JobExecutionPlanRequest.JobExecutionPlanRequest = void 0;
	const core = __importStar(core$1H);
	JobExecutionPlanRequest.JobExecutionPlanRequest = core.serialization
	    .object({
	    fileId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FileId; })),
	    jobId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobId; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobExecutionPlan; })));
	return JobExecutionPlanRequest;
}

var JobExecutionPlanConfigRequest = {};

var hasRequiredJobExecutionPlanConfigRequest;

function requireJobExecutionPlanConfigRequest () {
	if (hasRequiredJobExecutionPlanConfigRequest) return JobExecutionPlanConfigRequest;
	hasRequiredJobExecutionPlanConfigRequest = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobExecutionPlanConfigRequest, "__esModule", { value: true });
	JobExecutionPlanConfigRequest.JobExecutionPlanConfigRequest = void 0;
	const core = __importStar(core$1H);
	JobExecutionPlanConfigRequest.JobExecutionPlanConfigRequest = core.serialization
	    .object({
	    fileId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FileId; })),
	    jobId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobId; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobExecutionPlanConfig; })));
	return JobExecutionPlanConfigRequest;
}

var JobAckDetails = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$R = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$R = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$R = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$R(result, mod, k);
    __setModuleDefault$R(result, mod);
    return result;
};
Object.defineProperty(JobAckDetails, "__esModule", { value: true });
JobAckDetails.JobAckDetails = void 0;
const core$R = __importStar$R(core$1H);
JobAckDetails.JobAckDetails = core$R.serialization.object({
    info: core$R.serialization.string().optional(),
    progress: core$R.serialization.number().optional(),
    estimatedCompletionAt: core$R.serialization.date().optional(),
});

var JobCompleteDetails = {};

var hasRequiredJobCompleteDetails;

function requireJobCompleteDetails () {
	if (hasRequiredJobCompleteDetails) return JobCompleteDetails;
	hasRequiredJobCompleteDetails = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobCompleteDetails, "__esModule", { value: true });
	JobCompleteDetails.JobCompleteDetails = void 0;
	const core = __importStar(core$1H);
	JobCompleteDetails.JobCompleteDetails = core.serialization.object({
	    outcome: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobOutcome; })).optional(),
	    info: core.serialization.string().optional(),
	});
	return JobCompleteDetails;
}

var JobOutcome = {};

var hasRequiredJobOutcome;

function requireJobOutcome () {
	if (hasRequiredJobOutcome) return JobOutcome;
	hasRequiredJobOutcome = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobOutcome, "__esModule", { value: true });
	JobOutcome.JobOutcome = void 0;
	const core = __importStar(core$1H);
	JobOutcome.JobOutcome = core.serialization.object({
	    acknowledge: core.serialization.boolean().optional(),
	    buttonText: core.serialization.string().optional(),
	    next: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobOutcomeNext; })).optional(),
	    heading: core.serialization.string().optional(),
	    message: core.serialization.string().optional(),
	});
	return JobOutcome;
}

var JobOutcomeNext = {};

var hasRequiredJobOutcomeNext;

function requireJobOutcomeNext () {
	if (hasRequiredJobOutcomeNext) return JobOutcomeNext;
	hasRequiredJobOutcomeNext = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobOutcomeNext, "__esModule", { value: true });
	JobOutcomeNext.JobOutcomeNext = void 0;
	const core = __importStar(core$1H);
	JobOutcomeNext.JobOutcomeNext = core.serialization
	    .union("type", {
	    id: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobOutcomeNextId; })),
	    url: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobOutcomeNextUrl; })),
	    download: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobOutcomeNextDownload; })),
	    wait: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobOutcomeNextWait; })),
	})
	    .transform({
	    transform: (value) => value,
	    untransform: (value) => value,
	});
	return JobOutcomeNext;
}

var JobOutcomeNextId = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$Q = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$Q = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$Q = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$Q(result, mod, k);
    __setModuleDefault$Q(result, mod);
    return result;
};
Object.defineProperty(JobOutcomeNextId, "__esModule", { value: true });
JobOutcomeNextId.JobOutcomeNextId = void 0;
const core$Q = __importStar$Q(core$1H);
JobOutcomeNextId.JobOutcomeNextId = core$Q.serialization.object({
    id: core$Q.serialization.string(),
    label: core$Q.serialization.string().optional(),
});

var JobOutcomeNextUrl = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$P = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$P = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$P = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$P(result, mod, k);
    __setModuleDefault$P(result, mod);
    return result;
};
Object.defineProperty(JobOutcomeNextUrl, "__esModule", { value: true });
JobOutcomeNextUrl.JobOutcomeNextUrl = void 0;
const core$P = __importStar$P(core$1H);
JobOutcomeNextUrl.JobOutcomeNextUrl = core$P.serialization.object({
    url: core$P.serialization.string(),
    label: core$P.serialization.string().optional(),
});

var JobOutcomeNextDownload = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$O = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$O = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$O = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$O(result, mod, k);
    __setModuleDefault$O(result, mod);
    return result;
};
Object.defineProperty(JobOutcomeNextDownload, "__esModule", { value: true });
JobOutcomeNextDownload.JobOutcomeNextDownload = void 0;
const core$O = __importStar$O(core$1H);
JobOutcomeNextDownload.JobOutcomeNextDownload = core$O.serialization.object({
    url: core$O.serialization.string(),
    label: core$O.serialization.string().optional(),
    fileName: core$O.serialization.string().optional(),
});

var JobOutcomeNextWait = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$N = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$N = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$N = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$N(result, mod, k);
    __setModuleDefault$N(result, mod);
    return result;
};
Object.defineProperty(JobOutcomeNextWait, "__esModule", { value: true });
JobOutcomeNextWait.JobOutcomeNextWait = void 0;
const core$N = __importStar$N(core$1H);
JobOutcomeNextWait.JobOutcomeNextWait = core$N.serialization.object({
    fade: core$N.serialization.boolean().optional(),
    confetti: core$N.serialization.boolean().optional(),
});

var JobCancelDetails = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$M = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$M = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$M = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$M(result, mod, k);
    __setModuleDefault$M(result, mod);
    return result;
};
Object.defineProperty(JobCancelDetails, "__esModule", { value: true });
JobCancelDetails.JobCancelDetails = void 0;
const core$M = __importStar$M(core$1H);
JobCancelDetails.JobCancelDetails = core$M.serialization.object({
    info: core$M.serialization.string().optional(),
});

var JobExecutionPlan = {};

var hasRequiredJobExecutionPlan;

function requireJobExecutionPlan () {
	if (hasRequiredJobExecutionPlan) return JobExecutionPlan;
	hasRequiredJobExecutionPlan = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobExecutionPlan, "__esModule", { value: true });
	JobExecutionPlan.JobExecutionPlan = void 0;
	const core = __importStar(core$1H);
	JobExecutionPlan.JobExecutionPlan = core.serialization.object({
	    fieldMapping: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Edge; }))),
	    unmappedSourceFields: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SourceField; }))),
	    unmappedDestinationFields: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DestinationField; }))),
	});
	return JobExecutionPlan;
}

var JobExecutionPlanConfig = {};

var hasRequiredJobExecutionPlanConfig;

function requireJobExecutionPlanConfig () {
	if (hasRequiredJobExecutionPlanConfig) return JobExecutionPlanConfig;
	hasRequiredJobExecutionPlanConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(JobExecutionPlanConfig, "__esModule", { value: true });
	JobExecutionPlanConfig.JobExecutionPlanConfig = void 0;
	const core = __importStar(core$1H);
	JobExecutionPlanConfig.JobExecutionPlanConfig = core.serialization.object({
	    fieldMapping: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Edge; })))
	        .optional(),
	    unmappedSourceFields: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SourceField; })))
	        .optional(),
	    unmappedDestinationFields: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DestinationField; })))
	        .optional(),
	});
	return JobExecutionPlanConfig;
}

var Edge = {};

var hasRequiredEdge;

function requireEdge () {
	if (hasRequiredEdge) return Edge;
	hasRequiredEdge = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Edge, "__esModule", { value: true });
	Edge.Edge = void 0;
	const core = __importStar(core$1H);
	Edge.Edge = core.serialization.object({
	    sourceField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Property; })),
	    destinationField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Property; })),
	    preview: core.serialization.list(core.serialization.string()).optional(),
	    enumDetails: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumDetails; })).optional(),
	    metadata: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Metadata; })).optional(),
	});
	return Edge;
}

var SourceField = {};

var hasRequiredSourceField;

function requireSourceField () {
	if (hasRequiredSourceField) return SourceField;
	hasRequiredSourceField = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SourceField, "__esModule", { value: true });
	SourceField.SourceField = void 0;
	const core = __importStar(core$1H);
	SourceField.SourceField = core.serialization.object({
	    sourceField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Property; })),
	    preview: core.serialization.list(core.serialization.string()).optional(),
	});
	return SourceField;
}

var DestinationField = {};

var hasRequiredDestinationField;

function requireDestinationField () {
	if (hasRequiredDestinationField) return DestinationField;
	hasRequiredDestinationField = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DestinationField, "__esModule", { value: true });
	DestinationField.DestinationField = void 0;
	const core = __importStar(core$1H);
	DestinationField.DestinationField = core.serialization.object({
	    destinationField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Property; })),
	    preview: core.serialization.list(core.serialization.string()).optional(),
	});
	return DestinationField;
}

var EnumDetails = {};

var hasRequiredEnumDetails;

function requireEnumDetails () {
	if (hasRequiredEnumDetails) return EnumDetails;
	hasRequiredEnumDetails = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EnumDetails, "__esModule", { value: true });
	EnumDetails.EnumDetails = void 0;
	const core = __importStar(core$1H);
	EnumDetails.EnumDetails = core.serialization.object({
	    mapping: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CategoryMapping; })))
	        .optional(),
	    unusedSourceValues: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumValue; })))
	        .optional(),
	    unusedDestinationValues: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumValue; })))
	        .optional(),
	});
	return EnumDetails;
}

var EnumValue = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$L = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$L = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$L = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$L(result, mod, k);
    __setModuleDefault$L(result, mod);
    return result;
};
Object.defineProperty(EnumValue, "__esModule", { value: true });
EnumValue.EnumValue = void 0;
const core$L = __importStar$L(core$1H);
EnumValue.EnumValue = core$L.serialization.undiscriminatedUnion([
    core$L.serialization.string(),
    core$L.serialization.number(),
    core$L.serialization.boolean(),
]);

var Metadata = {};

var hasRequiredMetadata;

function requireMetadata () {
	if (hasRequiredMetadata) return Metadata;
	hasRequiredMetadata = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Metadata, "__esModule", { value: true });
	Metadata.Metadata = void 0;
	const core = __importStar(core$1H);
	Metadata.Metadata = core.serialization.object({
	    certainty: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Certainty; })).optional(),
	    confidence: core.serialization.number().optional(),
	    source: core.serialization.string().optional(),
	});
	return Metadata;
}

var Certainty = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$K = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$K = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$K = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$K(result, mod, k);
    __setModuleDefault$K(result, mod);
    return result;
};
Object.defineProperty(Certainty, "__esModule", { value: true });
Certainty.Certainty = void 0;
const core$K = __importStar$K(core$1H);
Certainty.Certainty = core$K.serialization.enum_(["absolute", "strong", "moderate", "weak"]);

var CategoryMapping = {};

var hasRequiredCategoryMapping;

function requireCategoryMapping () {
	if (hasRequiredCategoryMapping) return CategoryMapping;
	hasRequiredCategoryMapping = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CategoryMapping, "__esModule", { value: true });
	CategoryMapping.CategoryMapping = void 0;
	const core = __importStar(core$1H);
	CategoryMapping.CategoryMapping = core.serialization.object({
	    sourceValue: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumValue; })).optional(),
	    destinationValue: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumValue; })).optional(),
	});
	return CategoryMapping;
}

var FindAndReplaceJobConfig = {};

var hasRequiredFindAndReplaceJobConfig;

function requireFindAndReplaceJobConfig () {
	if (hasRequiredFindAndReplaceJobConfig) return FindAndReplaceJobConfig;
	hasRequiredFindAndReplaceJobConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(FindAndReplaceJobConfig, "__esModule", { value: true });
	FindAndReplaceJobConfig.FindAndReplaceJobConfig = void 0;
	const core = __importStar(core$1H);
	FindAndReplaceJobConfig.FindAndReplaceJobConfig = core.serialization.object({
	    filter: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Filter; })).optional(),
	    filterField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FilterField; })).optional(),
	    searchValue: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchValue; })).optional(),
	    searchField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchField; })).optional(),
	    q: core.serialization.string().optional(),
	    ids: core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordId; }))).optional(),
	    find: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueUnion; })).optional(),
	    replace: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueUnion; })).optional(),
	    fieldKey: core.serialization.string(),
	});
	return FindAndReplaceJobConfig;
}

var ExportJobConfig = {};

var hasRequiredExportJobConfig;

function requireExportJobConfig () {
	if (hasRequiredExportJobConfig) return ExportJobConfig;
	hasRequiredExportJobConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ExportJobConfig, "__esModule", { value: true });
	ExportJobConfig.ExportJobConfig = void 0;
	const core = __importStar(core$1H);
	ExportJobConfig.ExportJobConfig = core.serialization.object({
	    options: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ExportOptions; })),
	});
	return ExportJobConfig;
}

var ExportOptions = {};

var hasRequiredExportOptions;

function requireExportOptions () {
	if (hasRequiredExportOptions) return ExportOptions;
	hasRequiredExportOptions = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ExportOptions, "__esModule", { value: true });
	ExportOptions.ExportOptions = void 0;
	const core = __importStar(core$1H);
	ExportOptions.ExportOptions = core.serialization.object({
	    versionId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })).optional(),
	    sortField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SortField; })).optional(),
	    sortDirection: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SortDirection; })).optional(),
	    filter: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Filter; })).optional(),
	    filterField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).FilterField; })).optional(),
	    searchValue: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchValue; })).optional(),
	    searchField: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SearchField; })).optional(),
	    q: core.serialization.string().optional(),
	    ids: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordId; })))
	        .optional(),
	});
	return ExportOptions;
}

var EmptyObject = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$J = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$J = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$J = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$J(result, mod, k);
    __setModuleDefault$J(result, mod);
    return result;
};
Object.defineProperty(EmptyObject, "__esModule", { value: true });
EmptyObject.EmptyObject = void 0;
const core$J = __importStar$J(core$1H);
EmptyObject.EmptyObject = core$J.serialization.object({});

var hasRequiredTypes$a;

function requireTypes$a () {
	if (hasRequiredTypes$a) return types$a;
	hasRequiredTypes$a = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListJobsResponse(), exports);
		__exportStar(requireJobResponse(), exports);
		__exportStar(requireJobPlanResponse(), exports);
		__exportStar(requireJob(), exports);
		__exportStar(requireJobConfig(), exports);
		__exportStar(requireJobUpdate(), exports);
		__exportStar(requireJobUpdateConfig(), exports);
		__exportStar(JobSource, exports);
		__exportStar(requireJobDestination(), exports);
		__exportStar(requireDeleteRecordsJobConfig(), exports);
		__exportStar(requireFileJobConfig(), exports);
		__exportStar(requireMutateJobConfig(), exports);
		__exportStar(Driver, exports);
		__exportStar(Trigger, exports);
		__exportStar(requirePipelineJobConfig(), exports);
		__exportStar(JobType, exports);
		__exportStar(JobStatus, exports);
		__exportStar(JobMode, exports);
		__exportStar(requireJobSubject(), exports);
		__exportStar(CollectionJobSubject, exports);
		__exportStar(ResourceJobSubject, exports);
		__exportStar(requireJobPlan(), exports);
		__exportStar(requireJobExecutionPlanRequest(), exports);
		__exportStar(requireJobExecutionPlanConfigRequest(), exports);
		__exportStar(JobAckDetails, exports);
		__exportStar(requireJobCompleteDetails(), exports);
		__exportStar(requireJobOutcome(), exports);
		__exportStar(requireJobOutcomeNext(), exports);
		__exportStar(JobOutcomeNextId, exports);
		__exportStar(JobOutcomeNextUrl, exports);
		__exportStar(JobOutcomeNextDownload, exports);
		__exportStar(JobOutcomeNextWait, exports);
		__exportStar(JobCancelDetails, exports);
		__exportStar(requireJobExecutionPlan(), exports);
		__exportStar(requireJobExecutionPlanConfig(), exports);
		__exportStar(requireEdge(), exports);
		__exportStar(requireSourceField(), exports);
		__exportStar(requireDestinationField(), exports);
		__exportStar(requireEnumDetails(), exports);
		__exportStar(EnumValue, exports);
		__exportStar(requireMetadata(), exports);
		__exportStar(Certainty, exports);
		__exportStar(requireCategoryMapping(), exports);
		__exportStar(requireFindAndReplaceJobConfig(), exports);
		__exportStar(requireExportJobConfig(), exports);
		__exportStar(requireExportOptions(), exports);
		__exportStar(EmptyObject, exports); 
	} (types$a));
	return types$a;
}

var client$5 = {};

var ack = {};

var hasRequiredAck;

function requireAck () {
	if (hasRequiredAck) return ack;
	hasRequiredAck = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ack, "__esModule", { value: true });
	ack.Request = void 0;
	const core = __importStar(core$1H);
	ack.Request = core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobAckDetails; })).optional();
	return ack;
}

var complete$3 = {};

var hasRequiredComplete;

function requireComplete () {
	if (hasRequiredComplete) return complete$3;
	hasRequiredComplete = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(complete$3, "__esModule", { value: true });
	complete$3.Request = void 0;
	const core = __importStar(core$1H);
	complete$3.Request = core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobCompleteDetails; })).optional();
	return complete$3;
}

var fail$h = {};

var hasRequiredFail;

function requireFail () {
	if (hasRequiredFail) return fail$h;
	hasRequiredFail = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(fail$h, "__esModule", { value: true });
	fail$h.Request = void 0;
	const core = __importStar(core$1H);
	fail$h.Request = core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobCompleteDetails; })).optional();
	return fail$h;
}

var cancel = {};

var hasRequiredCancel;

function requireCancel () {
	if (hasRequiredCancel) return cancel;
	hasRequiredCancel = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(cancel, "__esModule", { value: true });
	cancel.Request = void 0;
	const core = __importStar(core$1H);
	cancel.Request = core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).JobCancelDetails; })).optional();
	return cancel;
}

var hasRequiredClient$4;

function requireClient$4 () {
	if (hasRequiredClient$4) return client$5;
	hasRequiredClient$4 = 1;
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(client$5, "__esModule", { value: true });
	client$5.cancel = client$5.fail = client$5.complete = client$5.ack = void 0;
	client$5.ack = __importStar(requireAck());
	client$5.complete = __importStar(requireComplete());
	client$5.fail = __importStar(requireFail());
	client$5.cancel = __importStar(requireCancel());
	return client$5;
}

var hasRequiredJobs;

function requireJobs () {
	if (hasRequiredJobs) return jobs;
	hasRequiredJobs = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$a(), exports);
		__exportStar(requireClient$4(), exports); 
	} (jobs));
	return jobs;
}

var mapping = {};

var types$9 = {};

var MappingRuleType = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$I = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$I = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$I = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$I(result, mod, k);
    __setModuleDefault$I(result, mod);
    return result;
};
Object.defineProperty(MappingRuleType, "__esModule", { value: true });
MappingRuleType.MappingRuleType = void 0;
const core$I = __importStar$I(core$1H);
MappingRuleType.MappingRuleType = core$I.serialization.enum_(["assign"]);

var MappingRuleConfig = {};

var hasRequiredMappingRuleConfig;

function requireMappingRuleConfig () {
	if (hasRequiredMappingRuleConfig) return MappingRuleConfig;
	hasRequiredMappingRuleConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(MappingRuleConfig, "__esModule", { value: true });
	MappingRuleConfig.MappingRuleConfig = void 0;
	const core = __importStar(core$1H);
	MappingRuleConfig.MappingRuleConfig = core.serialization.object({
	    name: core.serialization.string(),
	    type: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MappingRuleType; })),
	    config: core.serialization.any().optional(),
	});
	return MappingRuleConfig;
}

var MappingRuleBase = {};

var hasRequiredMappingRuleBase;

function requireMappingRuleBase () {
	if (hasRequiredMappingRuleBase) return MappingRuleBase;
	hasRequiredMappingRuleBase = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(MappingRuleBase, "__esModule", { value: true });
	MappingRuleBase.MappingRuleBase = void 0;
	const core = __importStar(core$1H);
	MappingRuleBase.MappingRuleBase = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MappingId; })),
	    confidence: core.serialization.number().optional(),
	    createdBy: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).UserId; })).optional(),
	    createdAt: core.serialization.date(),
	    updatedAt: core.serialization.date(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MappingRuleConfig; })));
	return MappingRuleBase;
}

var MappingRuleOneToOne = {};

var hasRequiredMappingRuleOneToOne;

function requireMappingRuleOneToOne () {
	if (hasRequiredMappingRuleOneToOne) return MappingRuleOneToOne;
	hasRequiredMappingRuleOneToOne = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(MappingRuleOneToOne, "__esModule", { value: true });
	MappingRuleOneToOne.MappingRuleOneToOne = void 0;
	const core = __importStar(core$1H);
	MappingRuleOneToOne.MappingRuleOneToOne = core.serialization
	    .object({
	    sourceField: core.serialization.string(),
	    destinationField: core.serialization.string(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MappingRuleBase; })));
	return MappingRuleOneToOne;
}

var MappingRule = {};

var hasRequiredMappingRule;

function requireMappingRule () {
	if (hasRequiredMappingRule) return MappingRule;
	hasRequiredMappingRule = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(MappingRule, "__esModule", { value: true });
	MappingRule.MappingRule = void 0;
	const core = __importStar(core$1H);
	MappingRule.MappingRule = core.serialization.undiscriminatedUnion([
	    core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MappingRuleOneToOne; })),
	]);
	return MappingRule;
}

var MappingRuleResponse = {};

var hasRequiredMappingRuleResponse;

function requireMappingRuleResponse () {
	if (hasRequiredMappingRuleResponse) return MappingRuleResponse;
	hasRequiredMappingRuleResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(MappingRuleResponse, "__esModule", { value: true });
	MappingRuleResponse.MappingRuleResponse = void 0;
	const core = __importStar(core$1H);
	MappingRuleResponse.MappingRuleResponse = core.serialization.object({
	    data: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MappingRule; })),
	});
	return MappingRuleResponse;
}

var MappingRulesResponse = {};

var hasRequiredMappingRulesResponse;

function requireMappingRulesResponse () {
	if (hasRequiredMappingRulesResponse) return MappingRulesResponse;
	hasRequiredMappingRulesResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(MappingRulesResponse, "__esModule", { value: true });
	MappingRulesResponse.MappingRulesResponse = void 0;
	const core = __importStar(core$1H);
	MappingRulesResponse.MappingRulesResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).MappingRule; }))),
	});
	return MappingRulesResponse;
}

var hasRequiredTypes$9;

function requireTypes$9 () {
	if (hasRequiredTypes$9) return types$9;
	hasRequiredTypes$9 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(MappingRuleType, exports);
		__exportStar(requireMappingRuleConfig(), exports);
		__exportStar(requireMappingRuleBase(), exports);
		__exportStar(requireMappingRuleOneToOne(), exports);
		__exportStar(requireMappingRule(), exports);
		__exportStar(requireMappingRuleResponse(), exports);
		__exportStar(requireMappingRulesResponse(), exports); 
	} (types$9));
	return types$9;
}

var hasRequiredMapping;

function requireMapping () {
	if (hasRequiredMapping) return mapping;
	hasRequiredMapping = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$9(), exports); 
	} (mapping));
	return mapping;
}

var property = {};

var types$8 = {};

var Property = {};

var hasRequiredProperty$1;

function requireProperty$1 () {
	if (hasRequiredProperty$1) return Property;
	hasRequiredProperty$1 = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Property, "__esModule", { value: true });
	Property.Property = void 0;
	const core = __importStar(core$1H);
	Property.Property = core.serialization
	    .union("type", {
	    string: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).StringProperty; })),
	    number: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).NumberProperty; })),
	    boolean: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BooleanProperty; })),
	    date: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DateProperty; })),
	    enum: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumProperty; })),
	    reference: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ReferenceProperty; })),
	})
	    .transform({
	    transform: (value) => value,
	    untransform: (value) => value,
	});
	return Property;
}

var BaseProperty = {};

var hasRequiredBaseProperty;

function requireBaseProperty () {
	if (hasRequiredBaseProperty) return BaseProperty;
	hasRequiredBaseProperty = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(BaseProperty, "__esModule", { value: true });
	BaseProperty.BaseProperty = void 0;
	const core = __importStar(core$1H);
	BaseProperty.BaseProperty = core.serialization.object({
	    key: core.serialization.string(),
	    label: core.serialization.string().optional(),
	    description: core.serialization.string().optional(),
	    constraints: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Constraint; })))
	        .optional(),
	    readonly: core.serialization.boolean().optional(),
	    metadata: core.serialization.any().optional(),
	    treatments: core.serialization.list(core.serialization.string()).optional(),
	});
	return BaseProperty;
}

var ArrayableProperty = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$H = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$H = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$H = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$H(result, mod, k);
    __setModuleDefault$H(result, mod);
    return result;
};
Object.defineProperty(ArrayableProperty, "__esModule", { value: true });
ArrayableProperty.ArrayableProperty = void 0;
const core$H = __importStar$H(core$1H);
ArrayableProperty.ArrayableProperty = core$H.serialization.object({
    isArray: core$H.serialization.property("is_array", core$H.serialization.boolean().optional()),
});

var StringProperty = {};

var hasRequiredStringProperty;

function requireStringProperty () {
	if (hasRequiredStringProperty) return StringProperty;
	hasRequiredStringProperty = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(StringProperty, "__esModule", { value: true });
	StringProperty.StringProperty = void 0;
	const core = __importStar(core$1H);
	StringProperty.StringProperty = core.serialization
	    .object({
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).StringConfig; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseProperty; })));
	return StringProperty;
}

var NumberProperty = {};

var hasRequiredNumberProperty;

function requireNumberProperty () {
	if (hasRequiredNumberProperty) return NumberProperty;
	hasRequiredNumberProperty = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(NumberProperty, "__esModule", { value: true });
	NumberProperty.NumberProperty = void 0;
	const core = __importStar(core$1H);
	NumberProperty.NumberProperty = core.serialization
	    .object({
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).NumberConfig; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseProperty; })))
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ArrayableProperty; })));
	return NumberProperty;
}

var NumberConfig = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$G = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$G = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$G = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$G(result, mod, k);
    __setModuleDefault$G(result, mod);
    return result;
};
Object.defineProperty(NumberConfig, "__esModule", { value: true });
NumberConfig.NumberConfig = void 0;
const core$G = __importStar$G(core$1H);
NumberConfig.NumberConfig = core$G.serialization.object({
    decimalPlaces: core$G.serialization.property("decimal_places", core$G.serialization.number()),
});

var BooleanProperty = {};

var hasRequiredBooleanProperty;

function requireBooleanProperty () {
	if (hasRequiredBooleanProperty) return BooleanProperty;
	hasRequiredBooleanProperty = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(BooleanProperty, "__esModule", { value: true });
	BooleanProperty.BooleanProperty = void 0;
	const core = __importStar(core$1H);
	BooleanProperty.BooleanProperty = core.serialization
	    .object({
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BooleanPropertyConfig; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseProperty; })));
	return BooleanProperty;
}

var BooleanPropertyConfig = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$F = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$F = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$F = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$F(result, mod, k);
    __setModuleDefault$F(result, mod);
    return result;
};
Object.defineProperty(BooleanPropertyConfig, "__esModule", { value: true });
BooleanPropertyConfig.BooleanPropertyConfig = void 0;
const core$F = __importStar$F(core$1H);
BooleanPropertyConfig.BooleanPropertyConfig = core$F.serialization.object({
    allowIndeterminate: core$F.serialization.property("allow_indeterminate", core$F.serialization.boolean()),
});

var DateProperty = {};

var hasRequiredDateProperty;

function requireDateProperty () {
	if (hasRequiredDateProperty) return DateProperty;
	hasRequiredDateProperty = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DateProperty, "__esModule", { value: true });
	DateProperty.DateProperty = void 0;
	const core = __importStar(core$1H);
	DateProperty.DateProperty = core.serialization
	    .object({})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseProperty; })));
	return DateProperty;
}

var EnumProperty = {};

var hasRequiredEnumProperty;

function requireEnumProperty () {
	if (hasRequiredEnumProperty) return EnumProperty;
	hasRequiredEnumProperty = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EnumProperty, "__esModule", { value: true });
	EnumProperty.EnumProperty = void 0;
	const core = __importStar(core$1H);
	EnumProperty.EnumProperty = core.serialization
	    .object({
	    multi: core.serialization.boolean().optional(),
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumPropertyConfig; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseProperty; })))
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ArrayableProperty; })));
	return EnumProperty;
}

var EnumPropertyConfig = {};

var hasRequiredEnumPropertyConfig;

function requireEnumPropertyConfig () {
	if (hasRequiredEnumPropertyConfig) return EnumPropertyConfig;
	hasRequiredEnumPropertyConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EnumPropertyConfig, "__esModule", { value: true });
	EnumPropertyConfig.EnumPropertyConfig = void 0;
	const core = __importStar(core$1H);
	EnumPropertyConfig.EnumPropertyConfig = core.serialization.object({
	    allowCustom: core.serialization.property("allow_custom", core.serialization.boolean().optional()),
	    options: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnumPropertyOption; }))),
	});
	return EnumPropertyConfig;
}

var EnumPropertyOption = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$E = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$E = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$E = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$E(result, mod, k);
    __setModuleDefault$E(result, mod);
    return result;
};
Object.defineProperty(EnumPropertyOption, "__esModule", { value: true });
EnumPropertyOption.EnumPropertyOption = void 0;
const core$E = __importStar$E(core$1H);
EnumPropertyOption.EnumPropertyOption = core$E.serialization.object({
    label: core$E.serialization.string().optional(),
    description: core$E.serialization.string().optional(),
    color: core$E.serialization.string().optional(),
    icon: core$E.serialization.string().optional(),
    meta: core$E.serialization.record(core$E.serialization.string(), core$E.serialization.any()).optional(),
    value: core$E.serialization.any(),
});

var ReferenceProperty = {};

var hasRequiredReferenceProperty;

function requireReferenceProperty () {
	if (hasRequiredReferenceProperty) return ReferenceProperty;
	hasRequiredReferenceProperty = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ReferenceProperty, "__esModule", { value: true });
	ReferenceProperty.ReferenceProperty = void 0;
	const core = __importStar(core$1H);
	ReferenceProperty.ReferenceProperty = core.serialization
	    .object({
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ReferencePropertyConfig; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).BaseProperty; })))
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ArrayableProperty; })));
	return ReferenceProperty;
}

var ReferencePropertyConfig = {};

var hasRequiredReferencePropertyConfig;

function requireReferencePropertyConfig () {
	if (hasRequiredReferencePropertyConfig) return ReferencePropertyConfig;
	hasRequiredReferencePropertyConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ReferencePropertyConfig, "__esModule", { value: true });
	ReferencePropertyConfig.ReferencePropertyConfig = void 0;
	const core = __importStar(core$1H);
	ReferencePropertyConfig.ReferencePropertyConfig = core.serialization.object({
	    ref: core.serialization.string(),
	    key: core.serialization.string(),
	    relationship: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ReferencePropertyRelationship; })),
	});
	return ReferencePropertyConfig;
}

var ReferencePropertyRelationship = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$D = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$D = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$D = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$D(result, mod, k);
    __setModuleDefault$D(result, mod);
    return result;
};
Object.defineProperty(ReferencePropertyRelationship, "__esModule", { value: true });
ReferencePropertyRelationship.ReferencePropertyRelationship = void 0;
const core$D = __importStar$D(core$1H);
ReferencePropertyRelationship.ReferencePropertyRelationship = core$D.serialization.enum_(["has-one", "has-many"]);

var Constraint = {};

var hasRequiredConstraint;

function requireConstraint () {
	if (hasRequiredConstraint) return Constraint;
	hasRequiredConstraint = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Constraint, "__esModule", { value: true });
	Constraint.Constraint = void 0;
	const core = __importStar(core$1H);
	Constraint.Constraint = core.serialization
	    .union("type", {
	    required: core.serialization.object({}),
	    unique: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).UniqueConstraint; })),
	    computed: core.serialization.object({}),
	})
	    .transform({
	    transform: (value) => value,
	    untransform: (value) => value,
	});
	return Constraint;
}

var UniqueConstraint = {};

var hasRequiredUniqueConstraint;

function requireUniqueConstraint () {
	if (hasRequiredUniqueConstraint) return UniqueConstraint;
	hasRequiredUniqueConstraint = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(UniqueConstraint, "__esModule", { value: true });
	UniqueConstraint.UniqueConstraint = void 0;
	const core = __importStar(core$1H);
	UniqueConstraint.UniqueConstraint = core.serialization.object({
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).UniqueConstraintConfig; })).optional(),
	});
	return UniqueConstraint;
}

var UniqueConstraintConfig = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$C = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$C = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$C = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$C(result, mod, k);
    __setModuleDefault$C(result, mod);
    return result;
};
Object.defineProperty(UniqueConstraintConfig, "__esModule", { value: true });
UniqueConstraintConfig.UniqueConstraintConfig = void 0;
const core$C = __importStar$C(core$1H);
UniqueConstraintConfig.UniqueConstraintConfig = core$C.serialization.object({
    caseSensitive: core$C.serialization.property("case_sensitive", core$C.serialization.boolean().optional()),
    ignoreEmpty: core$C.serialization.property("ignore_empty", core$C.serialization.boolean().optional()),
});

var StringConfig = {};

var hasRequiredStringConfig;

function requireStringConfig () {
	if (hasRequiredStringConfig) return StringConfig;
	hasRequiredStringConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(StringConfig, "__esModule", { value: true });
	StringConfig.StringConfig = void 0;
	const core = __importStar(core$1H);
	StringConfig.StringConfig = core.serialization.object({
	    size: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).StringConfigOptions; })),
	});
	return StringConfig;
}

var StringConfigOptions = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$B = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$B = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$B = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$B(result, mod, k);
    __setModuleDefault$B(result, mod);
    return result;
};
Object.defineProperty(StringConfigOptions, "__esModule", { value: true });
StringConfigOptions.StringConfigOptions = void 0;
const core$B = __importStar$B(core$1H);
StringConfigOptions.StringConfigOptions = core$B.serialization.enum_(["tiny", "normal", "medium", "long"]);

var hasRequiredTypes$8;

function requireTypes$8 () {
	if (hasRequiredTypes$8) return types$8;
	hasRequiredTypes$8 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireProperty$1(), exports);
		__exportStar(requireBaseProperty(), exports);
		__exportStar(ArrayableProperty, exports);
		__exportStar(requireStringProperty(), exports);
		__exportStar(requireNumberProperty(), exports);
		__exportStar(NumberConfig, exports);
		__exportStar(requireBooleanProperty(), exports);
		__exportStar(BooleanPropertyConfig, exports);
		__exportStar(requireDateProperty(), exports);
		__exportStar(requireEnumProperty(), exports);
		__exportStar(requireEnumPropertyConfig(), exports);
		__exportStar(EnumPropertyOption, exports);
		__exportStar(requireReferenceProperty(), exports);
		__exportStar(requireReferencePropertyConfig(), exports);
		__exportStar(ReferencePropertyRelationship, exports);
		__exportStar(requireConstraint(), exports);
		__exportStar(requireUniqueConstraint(), exports);
		__exportStar(UniqueConstraintConfig, exports);
		__exportStar(requireStringConfig(), exports);
		__exportStar(StringConfigOptions, exports); 
	} (types$8));
	return types$8;
}

var hasRequiredProperty;

function requireProperty () {
	if (hasRequiredProperty) return property;
	hasRequiredProperty = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$8(), exports); 
	} (property));
	return property;
}

var records = {};

var types$7 = {};

var RecordsResponse = {};

var hasRequiredRecordsResponse;

function requireRecordsResponse () {
	if (hasRequiredRecordsResponse) return RecordsResponse;
	hasRequiredRecordsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordsResponse, "__esModule", { value: true });
	RecordsResponse.RecordsResponse = void 0;
	const core = __importStar(core$1H);
	RecordsResponse.RecordsResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordsResponseData; })),
	});
	return RecordsResponse;
}

var RecordsResponseData = {};

var hasRequiredRecordsResponseData;

function requireRecordsResponseData () {
	if (hasRequiredRecordsResponseData) return RecordsResponseData;
	hasRequiredRecordsResponseData = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordsResponseData, "__esModule", { value: true });
	RecordsResponseData.RecordsResponseData = void 0;
	const core = __importStar(core$1H);
	RecordsResponseData.RecordsResponseData = core.serialization
	    .object({
	    records: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordsWithLinks; })).optional(),
	    counts: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordCounts; })).optional(),
	    versionId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SuccessData; })));
	return RecordsResponseData;
}

var GetRecordsResponse = {};

var hasRequiredGetRecordsResponse;

function requireGetRecordsResponse () {
	if (hasRequiredGetRecordsResponse) return GetRecordsResponse;
	hasRequiredGetRecordsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GetRecordsResponse, "__esModule", { value: true });
	GetRecordsResponse.GetRecordsResponse = void 0;
	const core = __importStar(core$1H);
	GetRecordsResponse.GetRecordsResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GetRecordsResponseData; })),
	});
	return GetRecordsResponse;
}

var GetRecordsResponseData = {};

var hasRequiredGetRecordsResponseData;

function requireGetRecordsResponseData () {
	if (hasRequiredGetRecordsResponseData) return GetRecordsResponseData;
	hasRequiredGetRecordsResponseData = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(GetRecordsResponseData, "__esModule", { value: true });
	GetRecordsResponseData.GetRecordsResponseData = void 0;
	const core = __importStar(core$1H);
	GetRecordsResponseData.GetRecordsResponseData = core.serialization
	    .object({
	    records: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordsWithLinks; })),
	    counts: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordCounts; })).optional(),
	    versionId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SuccessData; })));
	return GetRecordsResponseData;
}

var RecordCounts = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$A = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$A = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$A = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$A(result, mod, k);
    __setModuleDefault$A(result, mod);
    return result;
};
Object.defineProperty(RecordCounts, "__esModule", { value: true });
RecordCounts.RecordCounts = void 0;
const core$A = __importStar$A(core$1H);
RecordCounts.RecordCounts = core$A.serialization.object({
    total: core$A.serialization.number(),
    valid: core$A.serialization.number(),
    error: core$A.serialization.number(),
    errorsByField: core$A.serialization.record(core$A.serialization.string(), core$A.serialization.number()).optional(),
});

var RecordsWithLinks = {};

var hasRequiredRecordsWithLinks;

function requireRecordsWithLinks () {
	if (hasRequiredRecordsWithLinks) return RecordsWithLinks;
	hasRequiredRecordsWithLinks = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordsWithLinks, "__esModule", { value: true });
	RecordsWithLinks.RecordsWithLinks = void 0;
	const core = __importStar(core$1H);
	RecordsWithLinks.RecordsWithLinks = core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordWithLinks; })));
	return RecordsWithLinks;
}

var RecordWithLinks = {};

var hasRequiredRecordWithLinks;

function requireRecordWithLinks () {
	if (hasRequiredRecordWithLinks) return RecordWithLinks;
	hasRequiredRecordWithLinks = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordWithLinks, "__esModule", { value: true });
	RecordWithLinks.RecordWithLinks = void 0;
	const core = __importStar(core$1H);
	RecordWithLinks.RecordWithLinks = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordId; })),
	    values: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordDataWithLinks; })),
	    valid: core.serialization.boolean().optional(),
	    messages: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ValidationMessage; })))
	        .optional(),
	    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
	});
	return RecordWithLinks;
}

var RecordDataWithLinks = {};

var hasRequiredRecordDataWithLinks;

function requireRecordDataWithLinks () {
	if (hasRequiredRecordDataWithLinks) return RecordDataWithLinks;
	hasRequiredRecordDataWithLinks = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordDataWithLinks, "__esModule", { value: true });
	RecordDataWithLinks.RecordDataWithLinks = void 0;
	const core = __importStar(core$1H);
	RecordDataWithLinks.RecordDataWithLinks = core.serialization.record(core.serialization.string(), core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueWithLinks; })));
	return RecordDataWithLinks;
}

var CellValueWithLinks = {};

var hasRequiredCellValueWithLinks;

function requireCellValueWithLinks () {
	if (hasRequiredCellValueWithLinks) return CellValueWithLinks;
	hasRequiredCellValueWithLinks = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CellValueWithLinks, "__esModule", { value: true });
	CellValueWithLinks.CellValueWithLinks = void 0;
	const core = __importStar(core$1H);
	CellValueWithLinks.CellValueWithLinks = core.serialization
	    .object({
	    links: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Records; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValue; })));
	return CellValueWithLinks;
}

var RecordBase = {};

var hasRequiredRecordBase;

function requireRecordBase () {
	if (hasRequiredRecordBase) return RecordBase;
	hasRequiredRecordBase = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordBase, "__esModule", { value: true });
	RecordBase.RecordBase = void 0;
	const core = __importStar(core$1H);
	RecordBase.RecordBase = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordId; })),
	    versionId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })).optional(),
	    valid: core.serialization.boolean().optional(),
	    messages: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ValidationMessage; })))
	        .optional(),
	    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
	});
	return RecordBase;
}

var Records$1 = {};

var hasRequiredRecords$1;

function requireRecords$1 () {
	if (hasRequiredRecords$1) return Records$1;
	hasRequiredRecords$1 = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Records$1, "__esModule", { value: true });
	Records$1.Records = void 0;
	const core = __importStar(core$1H);
	Records$1.Records = core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Record_; })));
	return Records$1;
}

var Record_ = {};

var hasRequiredRecord_;

function requireRecord_ () {
	if (hasRequiredRecord_) return Record_;
	hasRequiredRecord_ = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Record_, "__esModule", { value: true });
	Record_.Record_ = void 0;
	const core = __importStar(core$1H);
	Record_.Record_ = core.serialization
	    .object({
	    values: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordData; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordBase; })));
	return Record_;
}

var RecordData = {};

var hasRequiredRecordData;

function requireRecordData () {
	if (hasRequiredRecordData) return RecordData;
	hasRequiredRecordData = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordData, "__esModule", { value: true });
	RecordData.RecordData = void 0;
	const core = __importStar(core$1H);
	RecordData.RecordData = core.serialization.record(core.serialization.string(), core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValue; })));
	return RecordData;
}

var CellValue = {};

var hasRequiredCellValue;

function requireCellValue () {
	if (hasRequiredCellValue) return CellValue;
	hasRequiredCellValue = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CellValue, "__esModule", { value: true });
	CellValue.CellValue = void 0;
	const core = __importStar(core$1H);
	CellValue.CellValue = core.serialization.object({
	    valid: core.serialization.boolean().optional(),
	    messages: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ValidationMessage; })))
	        .optional(),
	    value: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueUnion; })).optional(),
	    layer: core.serialization.string().optional(),
	    updatedAt: core.serialization.date().optional(),
	});
	return CellValue;
}

var CellValueUnion = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$z = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$z = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$z = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$z(result, mod, k);
    __setModuleDefault$z(result, mod);
    return result;
};
Object.defineProperty(CellValueUnion, "__esModule", { value: true });
CellValueUnion.CellValueUnion = void 0;
const core$z = __importStar$z(core$1H);
CellValueUnion.CellValueUnion = core$z.serialization.undiscriminatedUnion([
    core$z.serialization.string(),
    core$z.serialization.number(),
    core$z.serialization.number(),
    core$z.serialization.number(),
    core$z.serialization.boolean(),
    core$z.serialization.string(),
    core$z.serialization.date(),
]);

var DiffRecordsResponse = {};

var hasRequiredDiffRecordsResponse;

function requireDiffRecordsResponse () {
	if (hasRequiredDiffRecordsResponse) return DiffRecordsResponse;
	hasRequiredDiffRecordsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DiffRecordsResponse, "__esModule", { value: true });
	DiffRecordsResponse.DiffRecordsResponse = void 0;
	const core = __importStar(core$1H);
	DiffRecordsResponse.DiffRecordsResponse = core.serialization.object({
	    data: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DiffRecords; })),
	});
	return DiffRecordsResponse;
}

var DiffRecords = {};

var hasRequiredDiffRecords;

function requireDiffRecords () {
	if (hasRequiredDiffRecords) return DiffRecords;
	hasRequiredDiffRecords = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DiffRecords, "__esModule", { value: true });
	DiffRecords.DiffRecords = void 0;
	const core = __importStar(core$1H);
	DiffRecords.DiffRecords = core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DiffRecord; })));
	return DiffRecords;
}

var DiffRecord = {};

var hasRequiredDiffRecord;

function requireDiffRecord () {
	if (hasRequiredDiffRecord) return DiffRecord;
	hasRequiredDiffRecord = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DiffRecord, "__esModule", { value: true });
	DiffRecord.DiffRecord = void 0;
	const core = __importStar(core$1H);
	DiffRecord.DiffRecord = core.serialization
	    .object({
	    values: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DiffData; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordBase; })));
	return DiffRecord;
}

var DiffData = {};

var hasRequiredDiffData;

function requireDiffData () {
	if (hasRequiredDiffData) return DiffData;
	hasRequiredDiffData = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DiffData, "__esModule", { value: true });
	DiffData.DiffData = void 0;
	const core = __importStar(core$1H);
	DiffData.DiffData = core.serialization.record(core.serialization.string(), core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).DiffValue; })));
	return DiffData;
}

var DiffValue = {};

var hasRequiredDiffValue;

function requireDiffValue () {
	if (hasRequiredDiffValue) return DiffValue;
	hasRequiredDiffValue = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(DiffValue, "__esModule", { value: true });
	DiffValue.DiffValue = void 0;
	const core = __importStar(core$1H);
	DiffValue.DiffValue = core.serialization
	    .object({
	    snapshotValue: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueUnion; })).optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValue; })));
	return DiffValue;
}

var ValidationMessage = {};

var hasRequiredValidationMessage;

function requireValidationMessage () {
	if (hasRequiredValidationMessage) return ValidationMessage;
	hasRequiredValidationMessage = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ValidationMessage, "__esModule", { value: true });
	ValidationMessage.ValidationMessage = void 0;
	const core = __importStar(core$1H);
	ValidationMessage.ValidationMessage = core.serialization.object({
	    type: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ValidationType; })).optional(),
	    source: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ValidationSource; })).optional(),
	    message: core.serialization.string().optional(),
	});
	return ValidationMessage;
}

var ValidationType = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$y = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$y = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$y = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$y(result, mod, k);
    __setModuleDefault$y(result, mod);
    return result;
};
Object.defineProperty(ValidationType, "__esModule", { value: true });
ValidationType.ValidationType = void 0;
const core$y = __importStar$y(core$1H);
ValidationType.ValidationType = core$y.serialization.enum_(["error", "warn", "info"]);

var ValidationSource = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$x = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$x = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$x = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$x(result, mod, k);
    __setModuleDefault$x(result, mod);
    return result;
};
Object.defineProperty(ValidationSource, "__esModule", { value: true });
ValidationSource.ValidationSource = void 0;
const core$x = __importStar$x(core$1H);
ValidationSource.ValidationSource = core$x.serialization.enum_([
    "required-constraint",
    "unique-constraint",
    "custom-logic",
    "unlinked",
    "invalid-option",
    "is-artifact",
]);

var hasRequiredTypes$7;

function requireTypes$7 () {
	if (hasRequiredTypes$7) return types$7;
	hasRequiredTypes$7 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireRecordsResponse(), exports);
		__exportStar(requireRecordsResponseData(), exports);
		__exportStar(requireGetRecordsResponse(), exports);
		__exportStar(requireGetRecordsResponseData(), exports);
		__exportStar(RecordCounts, exports);
		__exportStar(requireRecordsWithLinks(), exports);
		__exportStar(requireRecordWithLinks(), exports);
		__exportStar(requireRecordDataWithLinks(), exports);
		__exportStar(requireCellValueWithLinks(), exports);
		__exportStar(requireRecordBase(), exports);
		__exportStar(requireRecords$1(), exports);
		__exportStar(requireRecord_(), exports);
		__exportStar(requireRecordData(), exports);
		__exportStar(requireCellValue(), exports);
		__exportStar(CellValueUnion, exports);
		__exportStar(requireDiffRecordsResponse(), exports);
		__exportStar(requireDiffRecords(), exports);
		__exportStar(requireDiffRecord(), exports);
		__exportStar(requireDiffData(), exports);
		__exportStar(requireDiffValue(), exports);
		__exportStar(requireValidationMessage(), exports);
		__exportStar(ValidationType, exports);
		__exportStar(ValidationSource, exports); 
	} (types$7));
	return types$7;
}

var client$4 = {};

var insert$2 = {};

var hasRequiredInsert;

function requireInsert () {
	if (hasRequiredInsert) return insert$2;
	hasRequiredInsert = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(insert$2, "__esModule", { value: true });
	insert$2.Request = void 0;
	const core = __importStar(core$1H);
	insert$2.Request = core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordData; })));
	return insert$2;
}

var requests$3 = {};

var FindAndReplaceRecordRequestDeprecated = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$w = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$w = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$w = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$w(result, mod, k);
    __setModuleDefault$w(result, mod);
    return result;
};
Object.defineProperty(FindAndReplaceRecordRequestDeprecated, "__esModule", { value: true });
FindAndReplaceRecordRequestDeprecated.FindAndReplaceRecordRequestDeprecated = void 0;
const core$w = __importStar$w(core$1H);
FindAndReplaceRecordRequestDeprecated.FindAndReplaceRecordRequestDeprecated = core$w.serialization.object({
    replace: core$w.serialization.any(),
});

var FindAndReplaceRecordRequest = {};

var hasRequiredFindAndReplaceRecordRequest;

function requireFindAndReplaceRecordRequest () {
	if (hasRequiredFindAndReplaceRecordRequest) return FindAndReplaceRecordRequest;
	hasRequiredFindAndReplaceRecordRequest = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(FindAndReplaceRecordRequest, "__esModule", { value: true });
	FindAndReplaceRecordRequest.FindAndReplaceRecordRequest = void 0;
	const core = __importStar(core$1H);
	FindAndReplaceRecordRequest.FindAndReplaceRecordRequest = core.serialization.object({
	    find: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueUnion; })).optional(),
	    replace: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).CellValueUnion; })).optional(),
	    fieldKey: core.serialization.string(),
	});
	return FindAndReplaceRecordRequest;
}

var hasRequiredRequests$2;

function requireRequests$2 () {
	if (hasRequiredRequests$2) return requests$3;
	hasRequiredRequests$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.FindAndReplaceRecordRequest = exports.FindAndReplaceRecordRequestDeprecated = void 0;
		var FindAndReplaceRecordRequestDeprecated_1 = FindAndReplaceRecordRequestDeprecated;
		Object.defineProperty(exports, "FindAndReplaceRecordRequestDeprecated", { enumerable: true, get: function () { return FindAndReplaceRecordRequestDeprecated_1.FindAndReplaceRecordRequestDeprecated; } });
		var FindAndReplaceRecordRequest_1 = requireFindAndReplaceRecordRequest();
		Object.defineProperty(exports, "FindAndReplaceRecordRequest", { enumerable: true, get: function () { return FindAndReplaceRecordRequest_1.FindAndReplaceRecordRequest; } }); 
	} (requests$3));
	return requests$3;
}

var hasRequiredClient$3;

function requireClient$3 () {
	if (hasRequiredClient$3) return client$4;
	hasRequiredClient$3 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.insert = void 0;
		exports.insert = __importStar(requireInsert());
		__exportStar(requireRequests$2(), exports); 
	} (client$4));
	return client$4;
}

var hasRequiredRecords;

function requireRecords () {
	if (hasRequiredRecords) return records;
	hasRequiredRecords = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$7(), exports);
		__exportStar(requireClient$3(), exports); 
	} (records));
	return records;
}

var secrets = {};

var types$6 = {};

var SecretsResponse = {};

var hasRequiredSecretsResponse;

function requireSecretsResponse () {
	if (hasRequiredSecretsResponse) return SecretsResponse;
	hasRequiredSecretsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SecretsResponse, "__esModule", { value: true });
	SecretsResponse.SecretsResponse = void 0;
	const core = __importStar(core$1H);
	SecretsResponse.SecretsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Secret; }))),
	});
	return SecretsResponse;
}

var WriteSecret = {};

var hasRequiredWriteSecret;

function requireWriteSecret () {
	if (hasRequiredWriteSecret) return WriteSecret;
	hasRequiredWriteSecret = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(WriteSecret, "__esModule", { value: true });
	WriteSecret.WriteSecret = void 0;
	const core = __importStar(core$1H);
	WriteSecret.WriteSecret = core.serialization.object({
	    name: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SecretName; })),
	    value: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SecretValue; })),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })).optional(),
	});
	return WriteSecret;
}

var Secret = {};

var hasRequiredSecret;

function requireSecret () {
	if (hasRequiredSecret) return Secret;
	hasRequiredSecret = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Secret, "__esModule", { value: true });
	Secret.Secret = void 0;
	const core = __importStar(core$1H);
	Secret.Secret = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SecretId; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WriteSecret; })));
	return Secret;
}

var SecretName = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$v = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$v = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$v = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$v(result, mod, k);
    __setModuleDefault$v(result, mod);
    return result;
};
Object.defineProperty(SecretName, "__esModule", { value: true });
SecretName.SecretName = void 0;
const core$v = __importStar$v(core$1H);
SecretName.SecretName = core$v.serialization.string();

var SecretValue = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$u = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$u = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$u = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$u(result, mod, k);
    __setModuleDefault$u(result, mod);
    return result;
};
Object.defineProperty(SecretValue, "__esModule", { value: true });
SecretValue.SecretValue = void 0;
const core$u = __importStar$u(core$1H);
SecretValue.SecretValue = core$u.serialization.string();

var hasRequiredTypes$6;

function requireTypes$6 () {
	if (hasRequiredTypes$6) return types$6;
	hasRequiredTypes$6 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireSecretsResponse(), exports);
		__exportStar(requireWriteSecret(), exports);
		__exportStar(requireSecret(), exports);
		__exportStar(SecretName, exports);
		__exportStar(SecretValue, exports); 
	} (types$6));
	return types$6;
}

var hasRequiredSecrets;

function requireSecrets () {
	if (hasRequiredSecrets) return secrets;
	hasRequiredSecrets = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$6(), exports); 
	} (secrets));
	return secrets;
}

var sheets = {};

var types$5 = {};

var ListSheetsResponse = {};

var hasRequiredListSheetsResponse;

function requireListSheetsResponse () {
	if (hasRequiredListSheetsResponse) return ListSheetsResponse;
	hasRequiredListSheetsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListSheetsResponse, "__esModule", { value: true });
	ListSheetsResponse.ListSheetsResponse = void 0;
	const core = __importStar(core$1H);
	ListSheetsResponse.ListSheetsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Sheet; }))),
	});
	return ListSheetsResponse;
}

var SheetResponse = {};

var hasRequiredSheetResponse;

function requireSheetResponse () {
	if (hasRequiredSheetResponse) return SheetResponse;
	hasRequiredSheetResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SheetResponse, "__esModule", { value: true });
	SheetResponse.SheetResponse = void 0;
	const core = __importStar(core$1H);
	SheetResponse.SheetResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Sheet; })),
	});
	return SheetResponse;
}

var Sheet = {};

var hasRequiredSheet;

function requireSheet () {
	if (hasRequiredSheet) return Sheet;
	hasRequiredSheet = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Sheet, "__esModule", { value: true });
	Sheet.Sheet = void 0;
	const core = __importStar(core$1H);
	Sheet.Sheet = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	    workbookId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })),
	    name: core.serialization.string(),
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetConfig; })),
	    countRecords: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordCounts; })).optional(),
	    namespace: core.serialization.string().optional(),
	    lockedBy: core.serialization.string().optional(),
	    updatedAt: core.serialization.date(),
	    createdAt: core.serialization.date(),
	    lockedAt: core.serialization.date().optional(),
	});
	return Sheet;
}

var SheetConfig = {};

var hasRequiredSheetConfig;

function requireSheetConfig () {
	if (hasRequiredSheetConfig) return SheetConfig;
	hasRequiredSheetConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SheetConfig, "__esModule", { value: true });
	SheetConfig.SheetConfig = void 0;
	const core = __importStar(core$1H);
	SheetConfig.SheetConfig = core.serialization.object({
	    name: core.serialization.string(),
	    description: core.serialization.string().optional(),
	    slug: core.serialization.string().optional(),
	    readonly: core.serialization.boolean().optional(),
	    allowAdditionalFields: core.serialization.boolean().optional(),
	    access: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetAccess; })))
	        .optional(),
	    fields: core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Property; }))),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	});
	return SheetConfig;
}

var SheetConfigUpdate = {};

var hasRequiredSheetConfigUpdate;

function requireSheetConfigUpdate () {
	if (hasRequiredSheetConfigUpdate) return SheetConfigUpdate;
	hasRequiredSheetConfigUpdate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SheetConfigUpdate, "__esModule", { value: true });
	SheetConfigUpdate.SheetConfigUpdate = void 0;
	const core = __importStar(core$1H);
	SheetConfigUpdate.SheetConfigUpdate = core.serialization.object({
	    name: core.serialization.string().optional(),
	    description: core.serialization.string().optional(),
	    slug: core.serialization.string().optional(),
	    readonly: core.serialization.boolean().optional(),
	    allowAdditionalFields: core.serialization.boolean().optional(),
	    access: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetAccess; })))
	        .optional(),
	    fields: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Property; })))
	        .optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	});
	return SheetConfigUpdate;
}

var SheetUpdate = {};

var hasRequiredSheetUpdate;

function requireSheetUpdate () {
	if (hasRequiredSheetUpdate) return SheetUpdate;
	hasRequiredSheetUpdate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SheetUpdate, "__esModule", { value: true });
	SheetUpdate.SheetUpdate = void 0;
	const core = __importStar(core$1H);
	SheetUpdate.SheetUpdate = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })).optional(),
	    workbookId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })).optional(),
	    config: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetConfig; })).optional(),
	    countRecords: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordCounts; })).optional(),
	    namespace: core.serialization.string().optional(),
	    updatedAt: core.serialization.date().optional(),
	    createdAt: core.serialization.date().optional(),
	});
	return SheetUpdate;
}

var SheetConfigOrUpdate = {};

var hasRequiredSheetConfigOrUpdate;

function requireSheetConfigOrUpdate () {
	if (hasRequiredSheetConfigOrUpdate) return SheetConfigOrUpdate;
	hasRequiredSheetConfigOrUpdate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SheetConfigOrUpdate, "__esModule", { value: true });
	SheetConfigOrUpdate.SheetConfigOrUpdate = void 0;
	const core = __importStar(core$1H);
	SheetConfigOrUpdate.SheetConfigOrUpdate = core.serialization
	    .object({})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetConfigUpdate; })))
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetUpdate; })));
	return SheetConfigOrUpdate;
}

var RecordCountsResponse = {};

var hasRequiredRecordCountsResponse;

function requireRecordCountsResponse () {
	if (hasRequiredRecordCountsResponse) return RecordCountsResponse;
	hasRequiredRecordCountsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordCountsResponse, "__esModule", { value: true });
	RecordCountsResponse.RecordCountsResponse = void 0;
	const core = __importStar(core$1H);
	RecordCountsResponse.RecordCountsResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordCountsResponseData; })),
	});
	return RecordCountsResponse;
}

var RecordCountsResponseData = {};

var hasRequiredRecordCountsResponseData;

function requireRecordCountsResponseData () {
	if (hasRequiredRecordCountsResponseData) return RecordCountsResponseData;
	hasRequiredRecordCountsResponseData = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(RecordCountsResponseData, "__esModule", { value: true });
	RecordCountsResponseData.RecordCountsResponseData = void 0;
	const core = __importStar(core$1H);
	RecordCountsResponseData.RecordCountsResponseData = core.serialization
	    .object({
	    counts: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordCounts; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Success; })));
	return RecordCountsResponseData;
}

var FieldConfigResponse = {};

var hasRequiredFieldConfigResponse;

function requireFieldConfigResponse () {
	if (hasRequiredFieldConfigResponse) return FieldConfigResponse;
	hasRequiredFieldConfigResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(FieldConfigResponse, "__esModule", { value: true });
	FieldConfigResponse.FieldConfigResponse = void 0;
	const core = __importStar(core$1H);
	FieldConfigResponse.FieldConfigResponse = core.serialization.object({
	    data: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Property; })),
	});
	return FieldConfigResponse;
}

var SheetAccess = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$t = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$t = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$t = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$t(result, mod, k);
    __setModuleDefault$t(result, mod);
    return result;
};
Object.defineProperty(SheetAccess, "__esModule", { value: true });
SheetAccess.SheetAccess = void 0;
const core$t = __importStar$t(core$1H);
SheetAccess.SheetAccess = core$t.serialization.enum_(["*", "add", "edit", "delete", "import"]);

var hasRequiredTypes$5;

function requireTypes$5 () {
	if (hasRequiredTypes$5) return types$5;
	hasRequiredTypes$5 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListSheetsResponse(), exports);
		__exportStar(requireSheetResponse(), exports);
		__exportStar(requireSheet(), exports);
		__exportStar(requireSheetConfig(), exports);
		__exportStar(requireSheetConfigUpdate(), exports);
		__exportStar(requireSheetUpdate(), exports);
		__exportStar(requireSheetConfigOrUpdate(), exports);
		__exportStar(requireRecordCountsResponse(), exports);
		__exportStar(requireRecordCountsResponseData(), exports);
		__exportStar(requireFieldConfigResponse(), exports);
		__exportStar(SheetAccess, exports); 
	} (types$5));
	return types$5;
}

var hasRequiredSheets;

function requireSheets () {
	if (hasRequiredSheets) return sheets;
	hasRequiredSheets = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$5(), exports); 
	} (sheets));
	return sheets;
}

var snapshots = {};

var types$4 = {};

var SnapshotResponse = {};

var hasRequiredSnapshotResponse;

function requireSnapshotResponse () {
	if (hasRequiredSnapshotResponse) return SnapshotResponse;
	hasRequiredSnapshotResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SnapshotResponse, "__esModule", { value: true });
	SnapshotResponse.SnapshotResponse = void 0;
	const core = __importStar(core$1H);
	SnapshotResponse.SnapshotResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Snapshot; })),
	});
	return SnapshotResponse;
}

var SnapshotsResponse = {};

var hasRequiredSnapshotsResponse;

function requireSnapshotsResponse () {
	if (hasRequiredSnapshotsResponse) return SnapshotsResponse;
	hasRequiredSnapshotsResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SnapshotsResponse, "__esModule", { value: true });
	SnapshotsResponse.SnapshotsResponse = void 0;
	const core = __importStar(core$1H);
	SnapshotsResponse.SnapshotsResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Snapshot; }))),
	});
	return SnapshotsResponse;
}

var Snapshot = {};

var hasRequiredSnapshot;

function requireSnapshot () {
	if (hasRequiredSnapshot) return Snapshot;
	hasRequiredSnapshot = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Snapshot, "__esModule", { value: true });
	Snapshot.Snapshot = void 0;
	const core = __importStar(core$1H);
	Snapshot.Snapshot = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SnapshotId; })),
	    sheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	    label: core.serialization.string().optional(),
	    summary: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SnapshotSummary; })).optional(),
	    createdAt: core.serialization.date(),
	    createdBy: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).UserId; })),
	});
	return Snapshot;
}

var SnapshotSummary = {};

var hasRequiredSnapshotSummary;

function requireSnapshotSummary () {
	if (hasRequiredSnapshotSummary) return SnapshotSummary;
	hasRequiredSnapshotSummary = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SnapshotSummary, "__esModule", { value: true });
	SnapshotSummary.SnapshotSummary = void 0;
	const core = __importStar(core$1H);
	SnapshotSummary.SnapshotSummary = core.serialization.object({
	    createdSince: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SummarySection; })),
	    updatedSince: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SummarySection; })),
	    deletedSince: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SummarySection; })),
	});
	return SnapshotSummary;
}

var RestoreOptions = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$s = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$s = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$s = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$s(result, mod, k);
    __setModuleDefault$s(result, mod);
    return result;
};
Object.defineProperty(RestoreOptions, "__esModule", { value: true });
RestoreOptions.RestoreOptions = void 0;
const core$s = __importStar$s(core$1H);
RestoreOptions.RestoreOptions = core$s.serialization.object({
    created: core$s.serialization.boolean(),
    updated: core$s.serialization.boolean(),
    deleted: core$s.serialization.boolean(),
});

var SummarySection = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$r = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$r = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$r = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$r(result, mod, k);
    __setModuleDefault$r(result, mod);
    return result;
};
Object.defineProperty(SummarySection, "__esModule", { value: true });
SummarySection.SummarySection = void 0;
const core$r = __importStar$r(core$1H);
SummarySection.SummarySection = core$r.serialization.object({
    total: core$r.serialization.number(),
    byField: core$r.serialization.record(core$r.serialization.string(), core$r.serialization.number()).optional(),
});

var ChangeType = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$q = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$q = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$q = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$q(result, mod, k);
    __setModuleDefault$q(result, mod);
    return result;
};
Object.defineProperty(ChangeType, "__esModule", { value: true });
ChangeType.ChangeType = void 0;
const core$q = __importStar$q(core$1H);
ChangeType.ChangeType = core$q.serialization.enum_(["createdSince", "updatedSince", "deletedSince"]);

var hasRequiredTypes$4;

function requireTypes$4 () {
	if (hasRequiredTypes$4) return types$4;
	hasRequiredTypes$4 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireSnapshotResponse(), exports);
		__exportStar(requireSnapshotsResponse(), exports);
		__exportStar(requireSnapshot(), exports);
		__exportStar(requireSnapshotSummary(), exports);
		__exportStar(RestoreOptions, exports);
		__exportStar(SummarySection, exports);
		__exportStar(ChangeType, exports); 
	} (types$4));
	return types$4;
}

var client$3 = {};

var restoreSnapshot = {};

var hasRequiredRestoreSnapshot;

function requireRestoreSnapshot () {
	if (hasRequiredRestoreSnapshot) return restoreSnapshot;
	hasRequiredRestoreSnapshot = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(restoreSnapshot, "__esModule", { value: true });
	restoreSnapshot.Request = void 0;
	const core = __importStar(core$1H);
	restoreSnapshot.Request = core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RestoreOptions; })).optional();
	return restoreSnapshot;
}

var requests$2 = {};

var CreateSnapshotRequest = {};

var hasRequiredCreateSnapshotRequest;

function requireCreateSnapshotRequest () {
	if (hasRequiredCreateSnapshotRequest) return CreateSnapshotRequest;
	hasRequiredCreateSnapshotRequest = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CreateSnapshotRequest, "__esModule", { value: true });
	CreateSnapshotRequest.CreateSnapshotRequest = void 0;
	const core = __importStar(core$1H);
	CreateSnapshotRequest.CreateSnapshotRequest = core.serialization.object({
	    sheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })),
	    label: core.serialization.string().optional(),
	});
	return CreateSnapshotRequest;
}

var hasRequiredRequests$1;

function requireRequests$1 () {
	if (hasRequiredRequests$1) return requests$2;
	hasRequiredRequests$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.CreateSnapshotRequest = void 0;
		var CreateSnapshotRequest_1 = requireCreateSnapshotRequest();
		Object.defineProperty(exports, "CreateSnapshotRequest", { enumerable: true, get: function () { return CreateSnapshotRequest_1.CreateSnapshotRequest; } }); 
	} (requests$2));
	return requests$2;
}

var hasRequiredClient$2;

function requireClient$2 () {
	if (hasRequiredClient$2) return client$3;
	hasRequiredClient$2 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.restoreSnapshot = void 0;
		exports.restoreSnapshot = __importStar(requireRestoreSnapshot());
		__exportStar(requireRequests$1(), exports); 
	} (client$3));
	return client$3;
}

var hasRequiredSnapshots;

function requireSnapshots () {
	if (hasRequiredSnapshots) return snapshots;
	hasRequiredSnapshots = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$4(), exports);
		__exportStar(requireClient$2(), exports); 
	} (snapshots));
	return snapshots;
}

var spaces = {};

var types$3 = {};

var ListSpacesResponse = {};

var hasRequiredListSpacesResponse;

function requireListSpacesResponse () {
	if (hasRequiredListSpacesResponse) return ListSpacesResponse;
	hasRequiredListSpacesResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListSpacesResponse, "__esModule", { value: true });
	ListSpacesResponse.ListSpacesResponse = void 0;
	const core = __importStar(core$1H);
	ListSpacesResponse.ListSpacesResponse = core.serialization.object({
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Space; }))),
	});
	return ListSpacesResponse;
}

var SpaceResponse = {};

var hasRequiredSpaceResponse;

function requireSpaceResponse () {
	if (hasRequiredSpaceResponse) return SpaceResponse;
	hasRequiredSpaceResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SpaceResponse, "__esModule", { value: true });
	SpaceResponse.SpaceResponse = void 0;
	const core = __importStar(core$1H);
	SpaceResponse.SpaceResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Space; })),
	});
	return SpaceResponse;
}

var Space = {};

var hasRequiredSpace;

function requireSpace () {
	if (hasRequiredSpace) return Space;
	hasRequiredSpace = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Space, "__esModule", { value: true });
	Space.Space = void 0;
	const core = __importStar(core$1H);
	Space.Space = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })),
	    workbooksCount: core.serialization.number().optional(),
	    filesCount: core.serialization.number().optional(),
	    createdByUserId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).UserId; })).optional(),
	    createdByUserName: core.serialization.string().optional(),
	    createdAt: core.serialization.date(),
	    updatedAt: core.serialization.date(),
	    guestLink: core.serialization.string().optional(),
	    name: core.serialization.string(),
	    displayOrder: core.serialization.number().optional(),
	    accessToken: core.serialization.string().optional(),
	    isCollaborative: core.serialization.boolean().optional(),
	    size: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceSize; })).optional(),
	    upgradedAt: core.serialization.date().optional(),
	    guestAuthentication: core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestAuthenticationEnum; }))),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InternalSpaceConfigBase; })));
	return Space;
}

var SpaceSize = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$p = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$p = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$p = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$p(result, mod, k);
    __setModuleDefault$p(result, mod);
    return result;
};
Object.defineProperty(SpaceSize, "__esModule", { value: true });
SpaceSize.SpaceSize = void 0;
const core$p = __importStar$p(core$1H);
SpaceSize.SpaceSize = core$p.serialization.object({
    name: core$p.serialization.string(),
    id: core$p.serialization.string(),
    numUsers: core$p.serialization.number(),
    pdv: core$p.serialization.number(),
    numFiles: core$p.serialization.number(),
});

var SpaceConfig = {};

var hasRequiredSpaceConfig;

function requireSpaceConfig () {
	if (hasRequiredSpaceConfig) return SpaceConfig;
	hasRequiredSpaceConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(SpaceConfig, "__esModule", { value: true });
	SpaceConfig.SpaceConfig = void 0;
	const core = __importStar(core$1H);
	SpaceConfig.SpaceConfig = core.serialization
	    .object({
	    name: core.serialization.string().optional(),
	    displayOrder: core.serialization.number().optional(),
	    guestAuthentication: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).GuestAuthenticationEnum; })))
	        .optional(),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).InternalSpaceConfigBase; })));
	return SpaceConfig;
}

var InternalSpaceConfigBase = {};

var hasRequiredInternalSpaceConfigBase;

function requireInternalSpaceConfigBase () {
	if (hasRequiredInternalSpaceConfigBase) return InternalSpaceConfigBase;
	hasRequiredInternalSpaceConfigBase = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(InternalSpaceConfigBase, "__esModule", { value: true });
	InternalSpaceConfigBase.InternalSpaceConfigBase = void 0;
	const core = __importStar(core$1H);
	InternalSpaceConfigBase.InternalSpaceConfigBase = core.serialization.object({
	    spaceConfigId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceConfigId; })).optional(),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })).optional(),
	    primaryWorkbookId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })).optional(),
	    metadata: core.serialization.any().optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	    access: core.serialization
	        .list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceAccess; })))
	        .optional(),
	    autoConfigure: core.serialization.boolean().optional(),
	    namespace: core.serialization.string().optional(),
	    labels: core.serialization.list(core.serialization.string()).optional(),
	    translationsPath: core.serialization.string().optional(),
	    languageOverride: core.serialization.string().optional(),
	    archivedAt: core.serialization.date().optional(),
	});
	return InternalSpaceConfigBase;
}

var EventTokenResponse = {};

var hasRequiredEventTokenResponse;

function requireEventTokenResponse () {
	if (hasRequiredEventTokenResponse) return EventTokenResponse;
	hasRequiredEventTokenResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EventTokenResponse, "__esModule", { value: true });
	EventTokenResponse.EventTokenResponse = void 0;
	const core = __importStar(core$1H);
	EventTokenResponse.EventTokenResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EventToken; })),
	});
	return EventTokenResponse;
}

var EventToken = {};

var hasRequiredEventToken;

function requireEventToken () {
	if (hasRequiredEventToken) return EventToken;
	hasRequiredEventToken = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(EventToken, "__esModule", { value: true });
	EventToken.EventToken = void 0;
	const core = __importStar(core$1H);
	EventToken.EventToken = core.serialization.object({
	    accountId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AccountId; })).optional(),
	    subscribeKey: core.serialization.string().optional(),
	    ttl: core.serialization.number().optional(),
	    token: core.serialization.string().optional(),
	});
	return EventToken;
}

var GetSpacesSortField = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$o = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$o = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$o = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$o(result, mod, k);
    __setModuleDefault$o(result, mod);
    return result;
};
Object.defineProperty(GetSpacesSortField, "__esModule", { value: true });
GetSpacesSortField.GetSpacesSortField = void 0;
const core$o = __importStar$o(core$1H);
GetSpacesSortField.GetSpacesSortField = core$o.serialization.enum_([
    "name",
    "workbooksCount",
    "filesCount",
    "environmentId",
    "createdByUserName",
    "createdAt",
]);

var SpaceAccess = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$n = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$n = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$n = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$n(result, mod, k);
    __setModuleDefault$n(result, mod);
    return result;
};
Object.defineProperty(SpaceAccess, "__esModule", { value: true });
SpaceAccess.SpaceAccess = void 0;
const core$n = __importStar$n(core$1H);
SpaceAccess.SpaceAccess = core$n.serialization.enum_(["*", "upload"]);

var hasRequiredTypes$3;

function requireTypes$3 () {
	if (hasRequiredTypes$3) return types$3;
	hasRequiredTypes$3 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListSpacesResponse(), exports);
		__exportStar(requireSpaceResponse(), exports);
		__exportStar(requireSpace(), exports);
		__exportStar(SpaceSize, exports);
		__exportStar(requireSpaceConfig(), exports);
		__exportStar(requireInternalSpaceConfigBase(), exports);
		__exportStar(requireEventTokenResponse(), exports);
		__exportStar(requireEventToken(), exports);
		__exportStar(GetSpacesSortField, exports);
		__exportStar(SpaceAccess, exports); 
	} (types$3));
	return types$3;
}

var hasRequiredSpaces;

function requireSpaces () {
	if (hasRequiredSpaces) return spaces;
	hasRequiredSpaces = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$3(), exports); 
	} (spaces));
	return spaces;
}

var users = {};

var types$2 = {};

var ListUsersResponse = {};

var hasRequiredListUsersResponse;

function requireListUsersResponse () {
	if (hasRequiredListUsersResponse) return ListUsersResponse;
	hasRequiredListUsersResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListUsersResponse, "__esModule", { value: true });
	ListUsersResponse.ListUsersResponse = void 0;
	const core = __importStar(core$1H);
	ListUsersResponse.ListUsersResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).User; }))),
	});
	return ListUsersResponse;
}

var UserResponse = {};

var hasRequiredUserResponse;

function requireUserResponse () {
	if (hasRequiredUserResponse) return UserResponse;
	hasRequiredUserResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(UserResponse, "__esModule", { value: true });
	UserResponse.UserResponse = void 0;
	const core = __importStar(core$1H);
	UserResponse.UserResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).User; })),
	});
	return UserResponse;
}

var User = {};

var hasRequiredUser;

function requireUser () {
	if (hasRequiredUser) return User;
	hasRequiredUser = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(User, "__esModule", { value: true });
	User.User = void 0;
	const core = __importStar(core$1H);
	User.User = core.serialization
	    .object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).UserId; })),
	})
	    .extend(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).UserConfig; })));
	return User;
}

var UserConfig = {};

var hasRequiredUserConfig;

function requireUserConfig () {
	if (hasRequiredUserConfig) return UserConfig;
	hasRequiredUserConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(UserConfig, "__esModule", { value: true });
	UserConfig.UserConfig = void 0;
	const core = __importStar(core$1H);
	UserConfig.UserConfig = core.serialization.object({
	    email: core.serialization.string(),
	    name: core.serialization.string(),
	    accountId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).AccountId; })),
	});
	return UserConfig;
}

var ListApiTokensResponse = {};

var hasRequiredListApiTokensResponse;

function requireListApiTokensResponse () {
	if (hasRequiredListApiTokensResponse) return ListApiTokensResponse;
	hasRequiredListApiTokensResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListApiTokensResponse, "__esModule", { value: true });
	ListApiTokensResponse.ListApiTokensResponse = void 0;
	const core = __importStar(core$1H);
	ListApiTokensResponse.ListApiTokensResponse = core.serialization.object({
	    pagination: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Pagination; })).optional(),
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ApiToken; }))),
	});
	return ListApiTokensResponse;
}

var ApiTokenResponse = {};

var hasRequiredApiTokenResponse;

function requireApiTokenResponse () {
	if (hasRequiredApiTokenResponse) return ApiTokenResponse;
	hasRequiredApiTokenResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ApiTokenResponse, "__esModule", { value: true });
	ApiTokenResponse.ApiTokenResponse = void 0;
	const core = __importStar(core$1H);
	ApiTokenResponse.ApiTokenResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ApiToken; })),
	});
	return ApiTokenResponse;
}

var ApiToken = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$m = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$m = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$m = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$m(result, mod, k);
    __setModuleDefault$m(result, mod);
    return result;
};
Object.defineProperty(ApiToken, "__esModule", { value: true });
ApiToken.ApiToken = void 0;
const core$m = __importStar$m(core$1H);
ApiToken.ApiToken = core$m.serialization.object({
    clientId: core$m.serialization.string(),
    description: core$m.serialization.string(),
    metadata: core$m.serialization.record(core$m.serialization.string(), core$m.serialization.any()),
    createdAt: core$m.serialization.string(),
    secret: core$m.serialization.string().optional(),
});

var ExchangeTokenResponse = {};

var hasRequiredExchangeTokenResponse;

function requireExchangeTokenResponse () {
	if (hasRequiredExchangeTokenResponse) return ExchangeTokenResponse;
	hasRequiredExchangeTokenResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ExchangeTokenResponse, "__esModule", { value: true });
	ExchangeTokenResponse.ExchangeTokenResponse = void 0;
	const core = __importStar(core$1H);
	ExchangeTokenResponse.ExchangeTokenResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).ExchangeTokenData; })),
	});
	return ExchangeTokenResponse;
}

var ExchangeTokenData = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$l = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$l = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$l = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$l(result, mod, k);
    __setModuleDefault$l(result, mod);
    return result;
};
Object.defineProperty(ExchangeTokenData, "__esModule", { value: true });
ExchangeTokenData.ExchangeTokenData = void 0;
const core$l = __importStar$l(core$1H);
ExchangeTokenData.ExchangeTokenData = core$l.serialization.object({
    valid: core$l.serialization.boolean(),
    token: core$l.serialization.string().optional(),
    sentTo: core$l.serialization.string().optional(),
});

var hasRequiredTypes$2;

function requireTypes$2 () {
	if (hasRequiredTypes$2) return types$2;
	hasRequiredTypes$2 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListUsersResponse(), exports);
		__exportStar(requireUserResponse(), exports);
		__exportStar(requireUser(), exports);
		__exportStar(requireUserConfig(), exports);
		__exportStar(requireListApiTokensResponse(), exports);
		__exportStar(requireApiTokenResponse(), exports);
		__exportStar(ApiToken, exports);
		__exportStar(requireExchangeTokenResponse(), exports);
		__exportStar(ExchangeTokenData, exports); 
	} (types$2));
	return types$2;
}

var client$2 = {};

var requests$1 = {};

var ExchangeTokenRequest = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$k = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$k = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$k = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$k(result, mod, k);
    __setModuleDefault$k(result, mod);
    return result;
};
Object.defineProperty(ExchangeTokenRequest, "__esModule", { value: true });
ExchangeTokenRequest.ExchangeTokenRequest = void 0;
const core$k = __importStar$k(core$1H);
ExchangeTokenRequest.ExchangeTokenRequest = core$k.serialization.object({
    token: core$k.serialization.string().optional(),
    email: core$k.serialization.string().optional(),
    spaceId: core$k.serialization.string().optional(),
});

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ExchangeTokenRequest = void 0;
	var ExchangeTokenRequest_1 = ExchangeTokenRequest;
	Object.defineProperty(exports, "ExchangeTokenRequest", { enumerable: true, get: function () { return ExchangeTokenRequest_1.ExchangeTokenRequest; } }); 
} (requests$1));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(requests$1, exports); 
} (client$2));

var hasRequiredUsers;

function requireUsers () {
	if (hasRequiredUsers) return users;
	hasRequiredUsers = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$2(), exports);
		__exportStar(client$2, exports); 
	} (users));
	return users;
}

var versions = {};

var types$1 = {};

var VersionResponse = {};

var hasRequiredVersionResponse;

function requireVersionResponse () {
	if (hasRequiredVersionResponse) return VersionResponse;
	hasRequiredVersionResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(VersionResponse, "__esModule", { value: true });
	VersionResponse.VersionResponse = void 0;
	const core = __importStar(core$1H);
	VersionResponse.VersionResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Version; })),
	});
	return VersionResponse;
}

var Version = {};

var hasRequiredVersion;

function requireVersion () {
	if (hasRequiredVersion) return Version;
	hasRequiredVersion = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Version, "__esModule", { value: true });
	Version.Version = void 0;
	const core = __importStar(core$1H);
	Version.Version = core.serialization.object({
	    versionId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })),
	});
	return Version;
}

var hasRequiredTypes$1;

function requireTypes$1 () {
	if (hasRequiredTypes$1) return types$1;
	hasRequiredTypes$1 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireVersionResponse(), exports);
		__exportStar(requireVersion(), exports); 
	} (types$1));
	return types$1;
}

var client$1 = {};

var requests = {};

var VersionsPostRequestBody = {};

var hasRequiredVersionsPostRequestBody;

function requireVersionsPostRequestBody () {
	if (hasRequiredVersionsPostRequestBody) return VersionsPostRequestBody;
	hasRequiredVersionsPostRequestBody = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(VersionsPostRequestBody, "__esModule", { value: true });
	VersionsPostRequestBody.VersionsPostRequestBody = void 0;
	const core = __importStar(core$1H);
	VersionsPostRequestBody.VersionsPostRequestBody = core.serialization.object({
	    sheetId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetId; })).optional(),
	    parentVersionId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).VersionId; })).optional(),
	});
	return VersionsPostRequestBody;
}

var hasRequiredRequests;

function requireRequests () {
	if (hasRequiredRequests) return requests;
	hasRequiredRequests = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.VersionsPostRequestBody = void 0;
		var VersionsPostRequestBody_1 = requireVersionsPostRequestBody();
		Object.defineProperty(exports, "VersionsPostRequestBody", { enumerable: true, get: function () { return VersionsPostRequestBody_1.VersionsPostRequestBody; } }); 
	} (requests));
	return requests;
}

var hasRequiredClient$1;

function requireClient$1 () {
	if (hasRequiredClient$1) return client$1;
	hasRequiredClient$1 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireRequests(), exports); 
	} (client$1));
	return client$1;
}

var hasRequiredVersions;

function requireVersions () {
	if (hasRequiredVersions) return versions;
	hasRequiredVersions = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes$1(), exports);
		__exportStar(requireClient$1(), exports); 
	} (versions));
	return versions;
}

var workbooks = {};

var types = {};

var ListWorkbooksResponse = {};

var hasRequiredListWorkbooksResponse;

function requireListWorkbooksResponse () {
	if (hasRequiredListWorkbooksResponse) return ListWorkbooksResponse;
	hasRequiredListWorkbooksResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(ListWorkbooksResponse, "__esModule", { value: true });
	ListWorkbooksResponse.ListWorkbooksResponse = void 0;
	const core = __importStar(core$1H);
	ListWorkbooksResponse.ListWorkbooksResponse = core.serialization.object({
	    data: core.serialization.list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Workbook; }))),
	});
	return ListWorkbooksResponse;
}

var WorkbookResponse = {};

var hasRequiredWorkbookResponse;

function requireWorkbookResponse () {
	if (hasRequiredWorkbookResponse) return WorkbookResponse;
	hasRequiredWorkbookResponse = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(WorkbookResponse, "__esModule", { value: true });
	WorkbookResponse.WorkbookResponse = void 0;
	const core = __importStar(core$1H);
	WorkbookResponse.WorkbookResponse = core.serialization.object({
	    data: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Workbook; })),
	});
	return WorkbookResponse;
}

var Workbook = {};

var hasRequiredWorkbook;

function requireWorkbook () {
	if (hasRequiredWorkbook) return Workbook;
	hasRequiredWorkbook = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(Workbook, "__esModule", { value: true });
	Workbook.Workbook = void 0;
	const core = __importStar(core$1H);
	Workbook.Workbook = core.serialization.object({
	    id: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookId; })),
	    name: core.serialization.string().optional(),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })),
	    sheets: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Sheet; })))
	        .optional(),
	    labels: core.serialization.list(core.serialization.string()).optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	    settings: core.serialization
	        .lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookConfigSettings; }))
	        .optional(),
	    metadata: core.serialization.any().optional(),
	    namespace: core.serialization.string().optional(),
	    updatedAt: core.serialization.date(),
	    createdAt: core.serialization.date(),
	});
	return Workbook;
}

var CreateWorkbookConfig = {};

var hasRequiredCreateWorkbookConfig;

function requireCreateWorkbookConfig () {
	if (hasRequiredCreateWorkbookConfig) return CreateWorkbookConfig;
	hasRequiredCreateWorkbookConfig = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(CreateWorkbookConfig, "__esModule", { value: true });
	CreateWorkbookConfig.CreateWorkbookConfig = void 0;
	const core = __importStar(core$1H);
	CreateWorkbookConfig.CreateWorkbookConfig = core.serialization.object({
	    name: core.serialization.string(),
	    labels: core.serialization.list(core.serialization.string()).optional(),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })).optional(),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })).optional(),
	    namespace: core.serialization.string().optional(),
	    sheets: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetConfig; })))
	        .optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	    settings: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).WorkbookConfigSettings; })).optional(),
	    metadata: core.serialization.any().optional(),
	});
	return CreateWorkbookConfig;
}

var WorkbookConfigSettings = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$j = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$j = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$j = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$j(result, mod, k);
    __setModuleDefault$j(result, mod);
    return result;
};
Object.defineProperty(WorkbookConfigSettings, "__esModule", { value: true });
WorkbookConfigSettings.WorkbookConfigSettings = void 0;
const core$j = __importStar$j(core$1H);
WorkbookConfigSettings.WorkbookConfigSettings = core$j.serialization.object({
    trackChanges: core$j.serialization.boolean().optional(),
});

var WorkbookUpdate = {};

var hasRequiredWorkbookUpdate;

function requireWorkbookUpdate () {
	if (hasRequiredWorkbookUpdate) return WorkbookUpdate;
	hasRequiredWorkbookUpdate = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(WorkbookUpdate, "__esModule", { value: true });
	WorkbookUpdate.WorkbookUpdate = void 0;
	const core = __importStar(core$1H);
	WorkbookUpdate.WorkbookUpdate = core.serialization.object({
	    name: core.serialization.string().optional(),
	    labels: core.serialization.list(core.serialization.string()).optional(),
	    spaceId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SpaceId; })).optional(),
	    environmentId: core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).EnvironmentId; })).optional(),
	    namespace: core.serialization.string().optional(),
	    sheets: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).SheetConfigOrUpdate; })))
	        .optional(),
	    actions: core.serialization
	        .list(core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).Action; })))
	        .optional(),
	    metadata: core.serialization.any().optional(),
	});
	return WorkbookUpdate;
}

var hasRequiredTypes;

function requireTypes () {
	if (hasRequiredTypes) return types;
	hasRequiredTypes = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireListWorkbooksResponse(), exports);
		__exportStar(requireWorkbookResponse(), exports);
		__exportStar(requireWorkbook(), exports);
		__exportStar(requireCreateWorkbookConfig(), exports);
		__exportStar(WorkbookConfigSettings, exports);
		__exportStar(requireWorkbookUpdate(), exports); 
	} (types));
	return types;
}

var client = {};

var addRecordsDeprecated = {};

var hasRequiredAddRecordsDeprecated;

function requireAddRecordsDeprecated () {
	if (hasRequiredAddRecordsDeprecated) return addRecordsDeprecated;
	hasRequiredAddRecordsDeprecated = 1;
	/**
	 * This file was auto-generated by Fern from our API Definition.
	 */
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(addRecordsDeprecated, "__esModule", { value: true });
	addRecordsDeprecated.Request = void 0;
	const core = __importStar(core$1H);
	addRecordsDeprecated.Request = core.serialization.list(core.serialization.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(requireSerialization()))).RecordData; })));
	return addRecordsDeprecated;
}

var hasRequiredClient;

function requireClient () {
	if (hasRequiredClient) return client;
	hasRequiredClient = 1;
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(client, "__esModule", { value: true });
	client.addRecordsDeprecated = void 0;
	client.addRecordsDeprecated = __importStar(requireAddRecordsDeprecated());
	return client;
}

var hasRequiredWorkbooks;

function requireWorkbooks () {
	if (hasRequiredWorkbooks) return workbooks;
	hasRequiredWorkbooks = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireTypes(), exports);
		__exportStar(requireClient(), exports); 
	} (workbooks));
	return workbooks;
}

var hasRequiredResources;

function requireResources () {
	if (hasRequiredResources) return resources;
	hasRequiredResources = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.workbooks = exports.versions = exports.users = exports.spaces = exports.snapshots = exports.sheets = exports.secrets = exports.records = exports.property = exports.mapping = exports.jobs = exports.guests = exports.files = exports.events = exports.environments = exports.documents = exports.commons = exports.commits = exports.cells = exports.auth = exports.agents = void 0;
		exports.agents = __importStar(requireAgents());
		__exportStar(requireTypes$k(), exports);
		exports.auth = __importStar(requireAuth());
		__exportStar(requireTypes$j(), exports);
		exports.cells = __importStar(requireCells());
		__exportStar(requireTypes$i(), exports);
		exports.commits = __importStar(requireCommits());
		__exportStar(requireTypes$h(), exports);
		exports.commons = __importStar(requireCommons());
		__exportStar(requireTypes$g(), exports);
		exports.documents = __importStar(requireDocuments());
		__exportStar(requireTypes$f(), exports);
		exports.environments = __importStar(requireEnvironments());
		__exportStar(requireTypes$e(), exports);
		exports.events = __importStar(requireEvents());
		__exportStar(requireTypes$d(), exports);
		exports.files = __importStar(requireFiles());
		__exportStar(requireTypes$c(), exports);
		exports.guests = __importStar(requireGuests());
		__exportStar(requireTypes$b(), exports);
		exports.jobs = __importStar(requireJobs());
		__exportStar(requireTypes$a(), exports);
		exports.mapping = __importStar(requireMapping());
		__exportStar(requireTypes$9(), exports);
		exports.property = __importStar(requireProperty());
		__exportStar(requireTypes$8(), exports);
		exports.records = __importStar(requireRecords());
		__exportStar(requireTypes$7(), exports);
		exports.secrets = __importStar(requireSecrets());
		__exportStar(requireTypes$6(), exports);
		exports.sheets = __importStar(requireSheets());
		__exportStar(requireTypes$5(), exports);
		exports.snapshots = __importStar(requireSnapshots());
		__exportStar(requireTypes$4(), exports);
		exports.spaces = __importStar(requireSpaces());
		__exportStar(requireTypes$3(), exports);
		exports.users = __importStar(requireUsers());
		__exportStar(requireTypes$2(), exports);
		exports.versions = __importStar(requireVersions());
		__exportStar(requireTypes$1(), exports);
		exports.workbooks = __importStar(requireWorkbooks());
		__exportStar(requireTypes(), exports);
		__exportStar(requireRequests$3(), exports);
		__exportStar(requireRequests$2(), exports);
		__exportStar(requireRequests$1(), exports);
		__exportStar(requests$1, exports);
		__exportStar(requireRequests(), exports); 
	} (resources));
	return resources;
}

var hasRequiredSerialization;

function requireSerialization () {
	if (hasRequiredSerialization) return serialization;
	hasRequiredSerialization = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireResources(), exports); 
	} (serialization));
	return serialization;
}

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$i = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$i = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$i = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$i(result, mod, k);
    __setModuleDefault$i(result, mod);
    return result;
};
var __awaiter$i = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$i = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$i, "__esModule", { value: true });
Client$i.Agents = void 0;
const environments$i = __importStar$i(environments$l);
const core$i = __importStar$i(core$1H);
const Flatfile$d = __importStar$i(api);
const url_join_1$i = __importDefault$i(urlJoinExports);
const serializers$i = __importStar$i(requireSerialization());
const errors$i = __importStar$i(errors$l);
class Agents {
    constructor(_options) {
        this._options = _options;
    }
    list(request, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const { environmentId } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, "/agents"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.ListAgentsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$i.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     */
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const { environmentId, body: _body } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, "/agents"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                body: yield serializers$i.AgentConfig.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.AgentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$d.BadRequestError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$i.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(agentId, request, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const { environmentId } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, `/agents/${yield serializers$i.AgentId.jsonOrThrow(agentId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.AgentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$d.BadRequestError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$d.NotFoundError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$i.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getAgentLogs(agentId, request, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const { environmentId } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, `/agents/${yield serializers$i.AgentId.jsonOrThrow(agentId)}/logs`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.GetAgentLogsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$d.BadRequestError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$d.NotFoundError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$i.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getAgentLog(eventId, request, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const { environmentId } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, `/agents/logs/${yield serializers$i.EventId.jsonOrThrow(eventId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.GetDetailedAgentLogResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$d.BadRequestError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$d.NotFoundError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$i.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getEnvironmentAgentLogs(request, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const { environmentId, spaceId, success, pageSize, pageNumber } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            _queryParams["spaceId"] = spaceId;
            if (success != null) {
                _queryParams["success"] = success.toString();
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, "/agents/logs"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.GetDetailedAgentLogsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$d.BadRequestError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$d.NotFoundError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$i.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getEnvironmentAgentExecutions(request, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const { environmentId, spaceId, success, pageSize, pageNumber } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            _queryParams["spaceId"] = spaceId;
            if (success != null) {
                _queryParams["success"] = success.toString();
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, "/agents/executions"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.GetExecutionsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$d.BadRequestError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$d.NotFoundError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$i.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a single agent
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(agentId, requestOptions) {
        var _a, _b;
        return __awaiter$i(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$i.fetcher)({
                url: (0, url_join_1$i.default)((_b = (yield core$i.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$i.FlatfileEnvironment.Production, `/agents/${yield serializers$i.AgentId.jsonOrThrow(agentId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$i.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$d.BadRequestError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$d.NotFoundError(yield serializers$i.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$i.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$i.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$i.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$i.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$i(this, void 0, void 0, function* () {
            return `Bearer ${yield core$i.Supplier.get(this._options.token)}`;
        });
    }
}
Client$i.Agents = Agents;

var Client$h = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$h = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$h = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$h = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$h(result, mod, k);
    __setModuleDefault$h(result, mod);
    return result;
};
var __awaiter$h = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$h = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$h, "__esModule", { value: true });
Client$h.Auth = void 0;
const environments$h = __importStar$h(environments$l);
const core$h = __importStar$h(core$1H);
const Flatfile$c = __importStar$h(api);
const url_join_1$h = __importDefault$h(urlJoinExports);
const serializers$h = __importStar$h(requireSerialization());
const errors$h = __importStar$h(errors$l);
class Auth {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getApiKeys(request, requestOptions) {
        var _a, _b;
        return __awaiter$h(this, void 0, void 0, function* () {
            const { environmentId } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$h.fetcher)({
                url: (0, url_join_1$h.default)((_b = (yield core$h.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$h.FlatfileEnvironment.Production, "/auth/api-keys"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$h.ApiKeysResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$c.BadRequestError(yield serializers$h.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$c.NotFoundError(yield serializers$h.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$h.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$h.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$h.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$h.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    createNewApiKey(request, requestOptions) {
        var _a, _b;
        return __awaiter$h(this, void 0, void 0, function* () {
            const { environmentId, type: type_ } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            _queryParams["type"] = type_;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$h.fetcher)({
                url: (0, url_join_1$h.default)((_b = (yield core$h.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$h.FlatfileEnvironment.Production, "/auth/api-key"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$h.ApiKeysResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$c.BadRequestError(yield serializers$h.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$c.NotFoundError(yield serializers$h.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$h.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$h.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$h.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$h.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    deleteApiKey(request, requestOptions) {
        var _a, _b;
        return __awaiter$h(this, void 0, void 0, function* () {
            const { environmentId, key } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            _queryParams["key"] = key;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$h.fetcher)({
                url: (0, url_join_1$h.default)((_b = (yield core$h.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$h.FlatfileEnvironment.Production, "/auth/api-key"),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$h.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$c.BadRequestError(yield serializers$h.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$c.NotFoundError(yield serializers$h.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$h.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$h.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$h.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$h.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$h(this, void 0, void 0, function* () {
            return `Bearer ${yield core$h.Supplier.get(this._options.token)}`;
        });
    }
}
Client$h.Auth = Auth;

var Client$g = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$g = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$g = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$g = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$g(result, mod, k);
    __setModuleDefault$g(result, mod);
    return result;
};
var __awaiter$g = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$g = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$g, "__esModule", { value: true });
Client$g.Cells = void 0;
const environments$g = __importStar$g(environments$l);
const core$g = __importStar$g(core$1H);
const serializers$g = __importStar$g(requireSerialization());
const url_join_1$g = __importDefault$g(urlJoinExports);
const errors$g = __importStar$g(errors$l);
class Cells {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns record cell values grouped by all fields in the sheet
     */
    getValues(sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter$g(this, void 0, void 0, function* () {
            const { fieldKey, sortField, sortDirection, filter, filterField, pageSize, pageNumber, distinct, includeCounts, searchValue, } = request;
            const _queryParams = {};
            _queryParams["fieldKey"] = fieldKey;
            if (sortField != null) {
                _queryParams["sortField"] = sortField;
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = sortDirection;
            }
            if (filter != null) {
                _queryParams["filter"] = filter;
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (distinct != null) {
                _queryParams["distinct"] = distinct.toString();
            }
            if (includeCounts != null) {
                _queryParams["includeCounts"] = includeCounts.toString();
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$g.fetcher)({
                url: (0, url_join_1$g.default)((_b = (yield core$g.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$g.FlatfileEnvironment.Production, `/sheets/${yield serializers$g.SheetId.jsonOrThrow(sheetId)}/cells`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$g.CellsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$g.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$g.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$g.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$g.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$g(this, void 0, void 0, function* () {
            return `Bearer ${yield core$g.Supplier.get(this._options.token)}`;
        });
    }
}
Client$g.Cells = Cells;

var Client$f = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$f = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$f = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$f = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$f(result, mod, k);
    __setModuleDefault$f(result, mod);
    return result;
};
var __awaiter$f = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$f = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$f, "__esModule", { value: true });
Client$f.Commits = void 0;
const environments$f = __importStar$f(environments$l);
const core$f = __importStar$f(core$1H);
const Flatfile$b = __importStar$f(api);
const serializers$f = __importStar$f(requireSerialization());
const url_join_1$f = __importDefault$f(urlJoinExports);
const errors$f = __importStar$f(errors$l);
class Commits {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns the details of a commit version
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(commitId, requestOptions) {
        var _a, _b;
        return __awaiter$f(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$f.fetcher)({
                url: (0, url_join_1$f.default)((_b = (yield core$f.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$f.FlatfileEnvironment.Production, `/commits/${yield serializers$f.VersionId.jsonOrThrow(commitId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$f.CommitResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$b.BadRequestError(yield serializers$f.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$b.NotFoundError(yield serializers$f.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$f.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$f.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$f.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$f.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Completes a commit version. This marks the commit as complete and acknowledges that the changes have been applied to the sheet.
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    complete(commitId, requestOptions) {
        var _a, _b;
        return __awaiter$f(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$f.fetcher)({
                url: (0, url_join_1$f.default)((_b = (yield core$f.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$f.FlatfileEnvironment.Production, `/commits/${yield serializers$f.VersionId.jsonOrThrow(commitId)}/complete`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$f.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$b.BadRequestError(yield serializers$f.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$b.NotFoundError(yield serializers$f.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$f.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$f.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$f.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$f.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Replays a commit:created event.
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    replay(commitId, requestOptions) {
        var _a, _b;
        return __awaiter$f(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$f.fetcher)({
                url: (0, url_join_1$f.default)((_b = (yield core$f.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$f.FlatfileEnvironment.Production, `/commits/${yield serializers$f.VersionId.jsonOrThrow(commitId)}/replay`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$f.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$b.BadRequestError(yield serializers$f.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$b.NotFoundError(yield serializers$f.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$f.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$f.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$f.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$f.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$f(this, void 0, void 0, function* () {
            return `Bearer ${yield core$f.Supplier.get(this._options.token)}`;
        });
    }
}
Client$f.Commits = Commits;

var Client$e = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$e = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$e = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$e = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$e(result, mod, k);
    __setModuleDefault$e(result, mod);
    return result;
};
var __awaiter$e = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$e = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$e, "__esModule", { value: true });
Client$e.Documents = void 0;
const environments$e = __importStar$e(environments$l);
const core$e = __importStar$e(core$1H);
const Flatfile$a = __importStar$e(api);
const serializers$e = __importStar$e(requireSerialization());
const url_join_1$e = __importDefault$e(urlJoinExports);
const errors$e = __importStar$e(errors$l);
class Documents {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns all documents for a space
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    list(spaceId, requestOptions) {
        var _a, _b;
        return __awaiter$e(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$e.fetcher)({
                url: (0, url_join_1$e.default)((_b = (yield core$e.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$e.FlatfileEnvironment.Production, `/spaces/${yield serializers$e.SpaceId.jsonOrThrow(spaceId)}/documents`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$e.ListDocumentsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$a.BadRequestError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$a.NotFoundError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$e.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$e.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$e.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$e.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Add a new document to the space
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    create(spaceId, request, requestOptions) {
        var _a, _b;
        return __awaiter$e(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$e.fetcher)({
                url: (0, url_join_1$e.default)((_b = (yield core$e.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$e.FlatfileEnvironment.Production, `/spaces/${yield serializers$e.SpaceId.jsonOrThrow(spaceId)}/documents`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$e.DocumentConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$e.DocumentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$a.BadRequestError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$a.NotFoundError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$e.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$e.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$e.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$e.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns a single document
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(spaceId, documentId, requestOptions) {
        var _a, _b;
        return __awaiter$e(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$e.fetcher)({
                url: (0, url_join_1$e.default)((_b = (yield core$e.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$e.FlatfileEnvironment.Production, `/spaces/${yield serializers$e.SpaceId.jsonOrThrow(spaceId)}/documents/${yield serializers$e.DocumentId.jsonOrThrow(documentId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$e.DocumentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$a.BadRequestError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$a.NotFoundError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$e.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$e.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$e.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$e.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * updates a single document, for only the body and title
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    update(spaceId, documentId, request, requestOptions) {
        var _a, _b;
        return __awaiter$e(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$e.fetcher)({
                url: (0, url_join_1$e.default)((_b = (yield core$e.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$e.FlatfileEnvironment.Production, `/spaces/${yield serializers$e.SpaceId.jsonOrThrow(spaceId)}/documents/${yield serializers$e.DocumentId.jsonOrThrow(documentId)}`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$e.DocumentConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$e.DocumentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$a.BadRequestError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$a.NotFoundError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$e.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$e.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$e.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$e.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a single document
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(spaceId, documentId, requestOptions) {
        var _a, _b;
        return __awaiter$e(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$e.fetcher)({
                url: (0, url_join_1$e.default)((_b = (yield core$e.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$e.FlatfileEnvironment.Production, `/spaces/${yield serializers$e.SpaceId.jsonOrThrow(spaceId)}/documents/${yield serializers$e.DocumentId.jsonOrThrow(documentId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$e.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$a.BadRequestError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$a.NotFoundError(yield serializers$e.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$e.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$e.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$e.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$e.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$e(this, void 0, void 0, function* () {
            return `Bearer ${yield core$e.Supplier.get(this._options.token)}`;
        });
    }
}
Client$e.Documents = Documents;

var Client$d = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$d = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$d = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$d = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$d(result, mod, k);
    __setModuleDefault$d(result, mod);
    return result;
};
var __awaiter$d = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$d = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$d, "__esModule", { value: true });
Client$d.Environments = void 0;
const environments$d = __importStar$d(environments$l);
const core$d = __importStar$d(core$1H);
const Flatfile$9 = __importStar$d(api);
const url_join_1$d = __importDefault$d(urlJoinExports);
const serializers$d = __importStar$d(requireSerialization());
const errors$d = __importStar$d(errors$l);
class Environments {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Get all environments
     */
    list(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$d(this, void 0, void 0, function* () {
            const { pageSize, pageNumber } = request;
            const _queryParams = {};
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$d.fetcher)({
                url: (0, url_join_1$d.default)((_b = (yield core$d.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$d.FlatfileEnvironment.Production, "/environments"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$d.ListEnvironmentsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$d.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$d.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$d.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$d.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Create a new environment
     */
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter$d(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$d.fetcher)({
                url: (0, url_join_1$d.default)((_b = (yield core$d.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$d.FlatfileEnvironment.Production, "/environments"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$d.EnvironmentConfigCreate.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$d.EnvironmentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$d.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$d.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$d.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$d.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Get a token which can be used to subscribe to events for this environment
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getEnvironmentEventToken(request, requestOptions) {
        var _a, _b;
        return __awaiter$d(this, void 0, void 0, function* () {
            const { environmentId } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$d.fetcher)({
                url: (0, url_join_1$d.default)((_b = (yield core$d.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$d.FlatfileEnvironment.Production, "/environments/subscription-token"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$d.EventTokenResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$9.BadRequestError(yield serializers$d.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$9.NotFoundError(yield serializers$d.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$d.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$d.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$d.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$d.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns a single environment
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(environmentId, requestOptions) {
        var _a, _b;
        return __awaiter$d(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$d.fetcher)({
                url: (0, url_join_1$d.default)((_b = (yield core$d.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$d.FlatfileEnvironment.Production, `/environments/${environmentId}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$d.EnvironmentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$9.BadRequestError(yield serializers$d.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$9.NotFoundError(yield serializers$d.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$d.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$d.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$d.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$d.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Updates a single environment, to change the name for example
     */
    update(environmentId, request, requestOptions) {
        var _a, _b;
        return __awaiter$d(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$d.fetcher)({
                url: (0, url_join_1$d.default)((_b = (yield core$d.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$d.FlatfileEnvironment.Production, `/environments/${environmentId}`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$d.EnvironmentConfigUpdate.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$d.Environment.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$d.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$d.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$d.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$d.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a single environment
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(environmentId, requestOptions) {
        var _a, _b;
        return __awaiter$d(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$d.fetcher)({
                url: (0, url_join_1$d.default)((_b = (yield core$d.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$d.FlatfileEnvironment.Production, `/environments/${environmentId}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$d.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$9.BadRequestError(yield serializers$d.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$9.NotFoundError(yield serializers$d.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$d.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$d.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$d.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$d.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$d(this, void 0, void 0, function* () {
            return `Bearer ${yield core$d.Supplier.get(this._options.token)}`;
        });
    }
}
Client$d.Environments = Environments;

var Client$c = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$c = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$c = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$c = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$c(result, mod, k);
    __setModuleDefault$c(result, mod);
    return result;
};
var __awaiter$c = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$c = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$c, "__esModule", { value: true });
Client$c.Events = void 0;
const environments$c = __importStar$c(environments$l);
const core$c = __importStar$c(core$1H);
const Flatfile$8 = __importStar$c(api);
const url_join_1$c = __importDefault$c(urlJoinExports);
const serializers$c = __importStar$c(requireSerialization());
const errors$c = __importStar$c(errors$l);
class Events {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Event topics that the Flatfile Platform emits.
     */
    list(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$c(this, void 0, void 0, function* () {
            const { environmentId, spaceId, domain, topic, since, pageSize, pageNumber, includeAcknowledged } = request;
            const _queryParams = {};
            if (environmentId != null) {
                _queryParams["environmentId"] = environmentId;
            }
            if (spaceId != null) {
                _queryParams["spaceId"] = spaceId;
            }
            if (domain != null) {
                _queryParams["domain"] = domain;
            }
            if (topic != null) {
                _queryParams["topic"] = topic;
            }
            if (since != null) {
                _queryParams["since"] = since.toISOString();
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (includeAcknowledged != null) {
                _queryParams["includeAcknowledged"] = includeAcknowledged.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$c.fetcher)({
                url: (0, url_join_1$c.default)((_b = (yield core$c.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$c.FlatfileEnvironment.Production, "events"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$c.ListAllEventsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$c.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$c.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$c.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$c.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter$c(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$c.fetcher)({
                url: (0, url_join_1$c.default)((_b = (yield core$c.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$c.FlatfileEnvironment.Production, "events"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$c.CreateEventConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$c.EventResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$8.BadRequestError(yield serializers$c.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$8.NotFoundError(yield serializers$c.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$c.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$c.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$c.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$c.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    get(eventId, requestOptions) {
        var _a, _b;
        return __awaiter$c(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$c.fetcher)({
                url: (0, url_join_1$c.default)((_b = (yield core$c.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$c.FlatfileEnvironment.Production, `events/${yield serializers$c.EventId.jsonOrThrow(eventId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$c.EventResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$c.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$c.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$c.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$c.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    ack(eventId, requestOptions) {
        var _a, _b;
        return __awaiter$c(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$c.fetcher)({
                url: (0, url_join_1$c.default)((_b = (yield core$c.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$c.FlatfileEnvironment.Production, `events/${yield serializers$c.EventId.jsonOrThrow(eventId)}/ack`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$c.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$c.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$c.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$c.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$c.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Get a token which can be used to subscribe to events for this space
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getEventToken(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$c(this, void 0, void 0, function* () {
            const { spaceId, scope } = request;
            const _queryParams = {};
            if (spaceId != null) {
                _queryParams["spaceId"] = spaceId;
            }
            if (scope != null) {
                _queryParams["scope"] = scope;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$c.fetcher)({
                url: (0, url_join_1$c.default)((_b = (yield core$c.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$c.FlatfileEnvironment.Production, "subscription"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$c.EventTokenResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$8.BadRequestError(yield serializers$c.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$8.NotFoundError(yield serializers$c.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$c.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$c.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$c.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$c.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$c(this, void 0, void 0, function* () {
            return `Bearer ${yield core$c.Supplier.get(this._options.token)}`;
        });
    }
}
Client$c.Events = Events;

var Client$b = {};

/* eslint-env browser */

var browser = typeof self == 'object' ? self.FormData : window.FormData;

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$b = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$b = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$b = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$b(result, mod, k);
    __setModuleDefault$b(result, mod);
    return result;
};
var __awaiter$b = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$b = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$b, "__esModule", { value: true });
Client$b.Files = void 0;
const environments$b = __importStar$b(environments$l);
const core$b = __importStar$b(core$1H);
const Flatfile$7 = __importStar$b(api);
const url_join_1$b = __importDefault$b(urlJoinExports);
const serializers$b = __importStar$b(requireSerialization());
const errors$b = __importStar$b(errors$l);
const form_data_1 = __importDefault$b(browser);
class Files {
    constructor(_options) {
        this._options = _options;
    }
    list(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$b(this, void 0, void 0, function* () {
            const { spaceId, pageSize, pageNumber, mode } = request;
            const _queryParams = {};
            if (spaceId != null) {
                _queryParams["spaceId"] = spaceId;
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (mode != null) {
                _queryParams["mode"] = mode;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$b.fetcher)({
                url: (0, url_join_1$b.default)((_b = (yield core$b.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$b.FlatfileEnvironment.Production, "/files"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$b.ListFilesResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$b.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$b.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$b.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$b.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     */
    upload(file, request, requestOptions) {
        var _a, _b;
        return __awaiter$b(this, void 0, void 0, function* () {
            const _request = new form_data_1.default();
            _request.append("spaceId", request.spaceId);
            _request.append("environmentId", request.environmentId);
            if (request.mode != null) {
                _request.append("mode", request.mode);
            }
            _request.append("file", file);
            if (request.actions != null) {
                for (const _item of request.actions) {
                    _request.append("actions", JSON.stringify(_item));
                }
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$b.fetcher)({
                url: (0, url_join_1$b.default)((_b = (yield core$b.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$b.FlatfileEnvironment.Production, "/files"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                    "Content-Length": (yield core$b.getFormDataContentLength(_request)).toString(),
                },
                contentType: "multipart/form-data; boundary=" + _request.getBoundary(),
                body: _request,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$b.FileResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$7.BadRequestError(yield serializers$b.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$b.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$b.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$b.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$b.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(fileId, requestOptions) {
        var _a, _b;
        return __awaiter$b(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$b.fetcher)({
                url: (0, url_join_1$b.default)((_b = (yield core$b.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$b.FlatfileEnvironment.Production, `/files/${fileId}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$b.FileResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$7.BadRequestError(yield serializers$b.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$7.NotFoundError(yield serializers$b.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$b.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$b.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$b.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$b.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(fileId, requestOptions) {
        var _a, _b;
        return __awaiter$b(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$b.fetcher)({
                url: (0, url_join_1$b.default)((_b = (yield core$b.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$b.FlatfileEnvironment.Production, `/files/${fileId}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$b.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$7.BadRequestError(yield serializers$b.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$7.NotFoundError(yield serializers$b.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$b.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$b.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$b.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$b.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Update a file, to change the workbook id for example
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    update(fileId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$b(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$b.fetcher)({
                url: (0, url_join_1$b.default)((_b = (yield core$b.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$b.FlatfileEnvironment.Production, `/files/${fileId}`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$b.UpdateFileRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$b.FileResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$7.BadRequestError(yield serializers$b.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$7.NotFoundError(yield serializers$b.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$b.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$b.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$b.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$b.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    download(fileId, requestOptions) {
        var _a, _b;
        return __awaiter$b(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.streamingFetcher) !== null && _a !== void 0 ? _a : core$b.streamingFetcher)({
                url: (0, url_join_1$b.default)((_b = (yield core$b.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$b.FlatfileEnvironment.Production, `/files/${yield serializers$b.FileId.jsonOrThrow(fileId)}/download`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                onError: (error) => {
                    throw new errors$b.FlatfileError({
                        message: error === null || error === void 0 ? void 0 : error.message,
                    });
                },
            });
            return _response.data;
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$b(this, void 0, void 0, function* () {
            return `Bearer ${yield core$b.Supplier.get(this._options.token)}`;
        });
    }
}
Client$b.Files = Files;

var Client$a = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$a = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$a = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$a = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$a(result, mod, k);
    __setModuleDefault$a(result, mod);
    return result;
};
var __awaiter$a = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$a = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$a, "__esModule", { value: true });
Client$a.Guests = void 0;
const environments$a = __importStar$a(environments$l);
const core$a = __importStar$a(core$1H);
const url_join_1$a = __importDefault$a(urlJoinExports);
const serializers$a = __importStar$a(requireSerialization());
const errors$a = __importStar$a(errors$l);
class Guests {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns all guests
     */
    list(request, requestOptions) {
        var _a, _b;
        return __awaiter$a(this, void 0, void 0, function* () {
            const { spaceId, email } = request;
            const _queryParams = {};
            _queryParams["spaceId"] = spaceId;
            if (email != null) {
                _queryParams["email"] = email;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$a.fetcher)({
                url: (0, url_join_1$a.default)((_b = (yield core$a.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$a.FlatfileEnvironment.Production, "guests"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$a.ListGuestsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$a.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$a.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$a.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$a.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Guests are only there to upload, edit, and download files and perform their tasks in a specific Space.
     */
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter$a(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$a.fetcher)({
                url: (0, url_join_1$a.default)((_b = (yield core$a.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$a.FlatfileEnvironment.Production, "guests"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$a.guests.create.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$a.CreateGuestResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$a.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$a.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$a.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$a.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns a single guest
     */
    get(guestId, requestOptions) {
        var _a, _b;
        return __awaiter$a(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$a.fetcher)({
                url: (0, url_join_1$a.default)((_b = (yield core$a.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$a.FlatfileEnvironment.Production, `guests/${yield serializers$a.GuestId.jsonOrThrow(guestId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$a.GuestResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$a.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$a.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$a.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$a.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a single guest
     */
    delete(guestId, requestOptions) {
        var _a, _b;
        return __awaiter$a(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$a.fetcher)({
                url: (0, url_join_1$a.default)((_b = (yield core$a.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$a.FlatfileEnvironment.Production, `guests/${yield serializers$a.GuestId.jsonOrThrow(guestId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$a.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$a.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$a.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$a.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$a.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Updates a single guest, for example to change name or email
     */
    update(guestId, request, requestOptions) {
        var _a, _b;
        return __awaiter$a(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$a.fetcher)({
                url: (0, url_join_1$a.default)((_b = (yield core$a.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$a.FlatfileEnvironment.Production, `guests/${yield serializers$a.GuestId.jsonOrThrow(guestId)}`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$a.GuestConfigUpdate.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$a.GuestResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$a.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$a.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$a.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$a.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Guests can be created as a named guest on the Space or there’s a global link that will let anonymous guests into the space.
     */
    invite(request, requestOptions) {
        var _a, _b;
        return __awaiter$a(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$a.fetcher)({
                url: (0, url_join_1$a.default)((_b = (yield core$a.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$a.FlatfileEnvironment.Production, "invitations"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$a.guests.invite.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$a.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$a.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$a.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$a.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$a.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$a(this, void 0, void 0, function* () {
            return `Bearer ${yield core$a.Supplier.get(this._options.token)}`;
        });
    }
}
Client$a.Guests = Guests;

var Client$9 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$9 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$9 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$9 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$9(result, mod, k);
    __setModuleDefault$9(result, mod);
    return result;
};
var __awaiter$9 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$9 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$9, "__esModule", { value: true });
Client$9.Jobs = void 0;
const environments$9 = __importStar$9(environments$l);
const core$9 = __importStar$9(core$1H);
const url_join_1$9 = __importDefault$9(urlJoinExports);
const serializers$9 = __importStar$9(requireSerialization());
const errors$9 = __importStar$9(errors$l);
class Jobs {
    constructor(_options) {
        this._options = _options;
    }
    list(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const { environmentId, spaceId, workbookId, fileId, pageSize, pageNumber, sortDirection } = request;
            const _queryParams = {};
            if (environmentId != null) {
                _queryParams["environmentId"] = environmentId;
            }
            if (spaceId != null) {
                _queryParams["spaceId"] = spaceId;
            }
            if (workbookId != null) {
                _queryParams["workbookId"] = workbookId;
            }
            if (fileId != null) {
                _queryParams["fileId"] = fileId;
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = sortDirection;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, "/jobs"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.ListJobsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, "/jobs"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$9.JobConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    get(jobId, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    update(jobId, request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$9.JobUpdate.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    delete(jobId, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Execute a job and return the job
     */
    execute(jobId, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${jobId}/execute`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns a single job's execution plan
     */
    getExecutionPlan(jobId, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}/plan`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobPlanResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Update a job's entire execution plan
     */
    updateExecutionPlan(jobId, request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}/plan`),
                method: "PUT",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$9.JobExecutionPlanRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobPlanResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Update one or more individual fields on a job's execution plan
     */
    updateExecutionPlanFields(jobId, request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${jobId}/plan`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$9.JobExecutionPlanConfigRequest.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobPlanResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Acknowledge a job and return the job
     */
    ack(jobId, request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}/ack`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: request != null
                    ? yield serializers$9.jobs.ack.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" })
                    : undefined,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Acknowledge a job outcome and return the job
     */
    ackOutcome(jobId, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}/outcome/ack`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Complete a job and return the job
     */
    complete(jobId, request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}/complete`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: request != null
                    ? yield serializers$9.jobs.complete.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" })
                    : undefined,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Fail a job and return the job
     */
    fail(jobId, request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}/fail`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: request != null
                    ? yield serializers$9.jobs.fail.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" })
                    : undefined,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Cancel a job and return the job
     */
    cancel(jobId, request, requestOptions) {
        var _a, _b;
        return __awaiter$9(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$9.fetcher)({
                url: (0, url_join_1$9.default)((_b = (yield core$9.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$9.FlatfileEnvironment.Production, `/jobs/${yield serializers$9.JobId.jsonOrThrow(jobId)}/cancel`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: request != null
                    ? yield serializers$9.jobs.cancel.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" })
                    : undefined,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$9.JobResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$9.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$9.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$9.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$9.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$9(this, void 0, void 0, function* () {
            return `Bearer ${yield core$9.Supplier.get(this._options.token)}`;
        });
    }
}
Client$9.Jobs = Jobs;

var Client$8 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$8 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$8 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$8 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$8(result, mod, k);
    __setModuleDefault$8(result, mod);
    return result;
};
var __awaiter$8 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$8 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$8, "__esModule", { value: true });
Client$8.Mapping = void 0;
const environments$8 = __importStar$8(environments$l);
const core$8 = __importStar$8(core$1H);
const Flatfile$6 = __importStar$8(api);
const serializers$8 = __importStar$8(requireSerialization());
const url_join_1$8 = __importDefault$8(urlJoinExports);
const errors$8 = __importStar$8(errors$l);
class Mapping {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Creates a mapping rule
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    createMapping(request, requestOptions) {
        var _a, _b;
        return __awaiter$8(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$8.fetcher)({
                url: (0, url_join_1$8.default)((_b = (yield core$8.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$8.FlatfileEnvironment.Production, "/mapping/rules"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$8.MappingRuleConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$8.MappingRuleResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$6.BadRequestError(yield serializers$8.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$6.NotFoundError(yield serializers$8.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$8.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$8.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$8.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$8.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * List all mapping rules
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    listMappings(requestOptions) {
        var _a, _b;
        return __awaiter$8(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$8.fetcher)({
                url: (0, url_join_1$8.default)((_b = (yield core$8.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$8.FlatfileEnvironment.Production, "/mapping/rules"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$8.MappingRulesResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$6.BadRequestError(yield serializers$8.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$6.NotFoundError(yield serializers$8.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$8.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$8.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$8.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$8.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a mapping rule
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    deleteMapping(mappingId, requestOptions) {
        var _a, _b;
        return __awaiter$8(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$8.fetcher)({
                url: (0, url_join_1$8.default)((_b = (yield core$8.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$8.FlatfileEnvironment.Production, `/mapping/rules/${yield serializers$8.MappingId.jsonOrThrow(mappingId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$8.MappingRuleResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$6.BadRequestError(yield serializers$8.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$6.NotFoundError(yield serializers$8.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$8.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$8.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$8.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$8.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$8(this, void 0, void 0, function* () {
            return `Bearer ${yield core$8.Supplier.get(this._options.token)}`;
        });
    }
}
Client$8.Mapping = Mapping;

var Client$7 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$7 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$7 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$7 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$7(result, mod, k);
    __setModuleDefault$7(result, mod);
    return result;
};
var __awaiter$7 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault$7 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$7, "__esModule", { value: true });
Client$7.Records = void 0;
const environments$7 = __importStar$7(environments$l);
const core$7 = __importStar$7(core$1H);
const Flatfile$5 = __importStar$7(api);
const serializers$7 = __importStar$7(requireSerialization());
const url_join_1$7 = __importDefault$7(urlJoinExports);
const errors$7 = __importStar$7(errors$l);
class Records {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns records from a sheet in a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(sheetId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$7(this, void 0, void 0, function* () {
            const { versionId, sinceVersionId, sortField, sortDirection, filter, filterField, searchValue, searchField, ids, pageSize, pageNumber, includeCounts, includeLength, includeLinks, includeMessages, for: for_, q, } = request;
            const _queryParams = {};
            if (versionId != null) {
                _queryParams["versionId"] = versionId;
            }
            if (sinceVersionId != null) {
                _queryParams["sinceVersionId"] = sinceVersionId;
            }
            if (sortField != null) {
                _queryParams["sortField"] = sortField;
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = sortDirection;
            }
            if (filter != null) {
                _queryParams["filter"] = filter;
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (ids != null) {
                if (Array.isArray(ids)) {
                    for (const _item of ids) {
                        _queryParams["ids"] = _item;
                    }
                }
                else {
                    _queryParams["ids"] = ids;
                }
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (includeCounts != null) {
                _queryParams["includeCounts"] = includeCounts.toString();
            }
            if (includeLength != null) {
                _queryParams["includeLength"] = includeLength.toString();
            }
            if (includeLinks != null) {
                _queryParams["includeLinks"] = includeLinks.toString();
            }
            if (includeMessages != null) {
                _queryParams["includeMessages"] = includeMessages.toString();
            }
            if (for_ != null) {
                _queryParams["for"] = for_;
            }
            if (q != null) {
                _queryParams["q"] = q;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$7.fetcher)({
                url: (0, url_join_1$7.default)((_b = (yield core$7.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$7.FlatfileEnvironment.Production, `/sheets/${yield serializers$7.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$7.GetRecordsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$5.BadRequestError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$5.NotFoundError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$7.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$7.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$7.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$7.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Updates existing records in a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    update(sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter$7(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$7.fetcher)({
                url: (0, url_join_1$7.default)((_b = (yield core$7.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$7.FlatfileEnvironment.Production, `/sheets/${yield serializers$7.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "PUT",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$7.Records.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$7.VersionResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$5.BadRequestError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$5.NotFoundError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$7.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$7.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$7.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$7.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Adds records to a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    insert(sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter$7(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$7.fetcher)({
                url: (0, url_join_1$7.default)((_b = (yield core$7.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$7.FlatfileEnvironment.Production, `/sheets/${yield serializers$7.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$7.records.insert.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$7.RecordsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$5.BadRequestError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$5.NotFoundError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$7.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$7.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$7.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$7.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes records from a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(sheetId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$7(this, void 0, void 0, function* () {
            const { ids } = request;
            const _queryParams = {};
            if (ids != null) {
                if (Array.isArray(ids)) {
                    for (const _item of ids) {
                        _queryParams["ids"] = _item;
                    }
                }
                else {
                    _queryParams["ids"] = ids;
                }
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$7.fetcher)({
                url: (0, url_join_1$7.default)((_b = (yield core$7.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$7.FlatfileEnvironment.Production, `/sheets/${yield serializers$7.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$7.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$5.BadRequestError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$5.NotFoundError(yield serializers$7.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$7.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$7.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$7.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$7.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Searches for the given searchValue in a field and replaces all instances of that value with replaceValue
     */
    findAndReplaceDeprecated(sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter$7(this, void 0, void 0, function* () {
            const { fieldKey, searchValue, filter, pageSize, pageNumber } = request, _body = __rest(request, ["fieldKey", "searchValue", "filter", "pageSize", "pageNumber"]);
            const _queryParams = {};
            _queryParams["fieldKey"] = fieldKey;
            _queryParams["searchValue"] = searchValue;
            if (filter != null) {
                _queryParams["filter"] = filter;
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$7.fetcher)({
                url: (0, url_join_1$7.default)((_b = (yield core$7.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$7.FlatfileEnvironment.Production, `/sheets/${yield serializers$7.SheetId.jsonOrThrow(sheetId)}/replace`),
                method: "PUT",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                body: yield serializers$7.FindAndReplaceRecordRequestDeprecated.jsonOrThrow(_body, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$7.RecordsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$7.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$7.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$7.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$7.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Searches for all values that match the 'find' value (globally or for a specific field via 'fieldKey') and replaces them with the 'replace' value. Wrap 'find' value in double quotes for exact match (""). Returns a versionId for the updated records
     */
    findAndReplace(sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter$7(this, void 0, void 0, function* () {
            const { filter, filterField, searchValue, searchField, ids } = request, _body = __rest(request, ["filter", "filterField", "searchValue", "searchField", "ids"]);
            const _queryParams = {};
            if (filter != null) {
                _queryParams["filter"] = filter;
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (ids != null) {
                if (Array.isArray(ids)) {
                    for (const _item of ids) {
                        _queryParams["ids"] = _item;
                    }
                }
                else {
                    _queryParams["ids"] = ids;
                }
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$7.fetcher)({
                url: (0, url_join_1$7.default)((_b = (yield core$7.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$7.FlatfileEnvironment.Production, `/sheets/${yield serializers$7.SheetId.jsonOrThrow(sheetId)}/find-replace`),
                method: "PUT",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                body: yield serializers$7.FindAndReplaceRecordRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$7.VersionResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$7.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$7.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$7.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$7.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$7(this, void 0, void 0, function* () {
            return `Bearer ${yield core$7.Supplier.get(this._options.token)}`;
        });
    }
}
Client$7.Records = Records;

var Client$6 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$6 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$6 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$6 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$6(result, mod, k);
    __setModuleDefault$6(result, mod);
    return result;
};
var __awaiter$6 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$6 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$6, "__esModule", { value: true });
Client$6.Secrets = void 0;
const environments$6 = __importStar$6(environments$l);
const core$6 = __importStar$6(core$1H);
const Flatfile$4 = __importStar$6(api);
const url_join_1$6 = __importDefault$6(urlJoinExports);
const serializers$6 = __importStar$6(requireSerialization());
const errors$6 = __importStar$6(errors$l);
class Secrets {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Fetch all secrets for a given environmentId and optionally apply space overrides
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    list(request, requestOptions) {
        var _a, _b;
        return __awaiter$6(this, void 0, void 0, function* () {
            const { environmentId, spaceId } = request;
            const _queryParams = {};
            _queryParams["environmentId"] = environmentId;
            if (spaceId != null) {
                _queryParams["spaceId"] = spaceId;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$6.fetcher)({
                url: (0, url_join_1$6.default)((_b = (yield core$6.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$6.FlatfileEnvironment.Production, "/secrets"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$6.SecretsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$4.BadRequestError(yield serializers$6.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$4.NotFoundError(yield serializers$6.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$6.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$6.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$6.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$6.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Insert or Update a Secret by name for environment or space
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    upsert(request, requestOptions) {
        var _a, _b;
        return __awaiter$6(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$6.fetcher)({
                url: (0, url_join_1$6.default)((_b = (yield core$6.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$6.FlatfileEnvironment.Production, "/secrets"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$6.WriteSecret.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$6.SecretsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$4.BadRequestError(yield serializers$6.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$4.NotFoundError(yield serializers$6.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$6.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$6.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$6.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$6.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a specific Secret from the Environment or Space as is the case
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(secretId, requestOptions) {
        var _a, _b;
        return __awaiter$6(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$6.fetcher)({
                url: (0, url_join_1$6.default)((_b = (yield core$6.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$6.FlatfileEnvironment.Production, `/secrets/${yield serializers$6.SecretId.jsonOrThrow(secretId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$6.SecretsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$4.BadRequestError(yield serializers$6.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$4.NotFoundError(yield serializers$6.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$6.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$6.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$6.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$6.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$6(this, void 0, void 0, function* () {
            return `Bearer ${yield core$6.Supplier.get(this._options.token)}`;
        });
    }
}
Client$6.Secrets = Secrets;

var Client$5 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$5 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$5 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$5 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$5(result, mod, k);
    __setModuleDefault$5(result, mod);
    return result;
};
var __awaiter$5 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$5 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$5, "__esModule", { value: true });
Client$5.Sheets = void 0;
const environments$5 = __importStar$5(environments$l);
const core$5 = __importStar$5(core$1H);
const Flatfile$3 = __importStar$5(api);
const url_join_1$5 = __importDefault$5(urlJoinExports);
const serializers$5 = __importStar$5(requireSerialization());
const errors$5 = __importStar$5(errors$l);
class Sheets {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns sheets in a workbook
     */
    list(request, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const { workbookId } = request;
            const _queryParams = {};
            _queryParams["workbookId"] = workbookId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$5.fetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, "/sheets"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$5.ListSheetsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$5.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$5.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$5.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$5.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns a sheet in a workbook
     */
    get(sheetId, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$5.fetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, `/sheets/${yield serializers$5.SheetId.jsonOrThrow(sheetId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$5.SheetResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$5.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$5.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$5.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$5.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a specific sheet from a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(sheetId, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$5.fetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, `/sheets/${yield serializers$5.SheetId.jsonOrThrow(sheetId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$5.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$3.BadRequestError(yield serializers$5.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$3.NotFoundError(yield serializers$5.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$5.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$5.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$5.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$5.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Trigger data hooks and validation to run on a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    validate(sheetId, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$5.fetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, `/sheets/${yield serializers$5.SheetId.jsonOrThrow(sheetId)}/validate`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$5.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$3.BadRequestError(yield serializers$5.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$3.NotFoundError(yield serializers$5.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$5.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$5.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$5.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$5.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns records from a sheet in a workbook as a csv file
     */
    getRecordsAsCsv(sheetId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const { versionId, sinceVersionId, sortField, sortDirection, filter, filterField, searchValue, searchField, ids, } = request;
            const _queryParams = {};
            if (versionId != null) {
                _queryParams["versionId"] = versionId;
            }
            if (sinceVersionId != null) {
                _queryParams["sinceVersionId"] = sinceVersionId;
            }
            if (sortField != null) {
                _queryParams["sortField"] = sortField;
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = sortDirection;
            }
            if (filter != null) {
                _queryParams["filter"] = filter;
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (ids != null) {
                if (Array.isArray(ids)) {
                    for (const _item of ids) {
                        _queryParams["ids"] = _item;
                    }
                }
                else {
                    _queryParams["ids"] = ids;
                }
            }
            const _response = yield ((_a = this._options.streamingFetcher) !== null && _a !== void 0 ? _a : core$5.streamingFetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, `/sheets/${yield serializers$5.SheetId.jsonOrThrow(sheetId)}/download`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                onError: (error) => {
                    throw new errors$5.FlatfileError({
                        message: error === null || error === void 0 ? void 0 : error.message,
                    });
                },
            });
            return _response.data;
        });
    }
    /**
     * Returns counts of records from a sheet
     */
    getRecordCounts(sheetId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const { versionId, sinceVersionId, filter, filterField, searchValue, searchField, byField, q } = request;
            const _queryParams = {};
            if (versionId != null) {
                _queryParams["versionId"] = versionId;
            }
            if (sinceVersionId != null) {
                _queryParams["sinceVersionId"] = sinceVersionId;
            }
            if (filter != null) {
                _queryParams["filter"] = filter;
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (byField != null) {
                _queryParams["byField"] = byField.toString();
            }
            if (q != null) {
                _queryParams["q"] = q;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$5.fetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, `/sheets/${yield serializers$5.SheetId.jsonOrThrow(sheetId)}/counts`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$5.RecordCountsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$5.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$5.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$5.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$5.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Adds a new field to a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    addField(sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$5.fetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, `/sheets/${yield serializers$5.SheetId.jsonOrThrow(sheetId)}/fields`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$5.Property.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$5.FieldConfigResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$3.BadRequestError(yield serializers$5.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$3.NotFoundError(yield serializers$5.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$5.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$5.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$5.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$5.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns the commit versions for a sheet
     */
    getSheetCommits(sheetId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$5(this, void 0, void 0, function* () {
            const { completed } = request;
            const _queryParams = {};
            if (completed != null) {
                _queryParams["completed"] = completed.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$5.fetcher)({
                url: (0, url_join_1$5.default)((_b = (yield core$5.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$5.FlatfileEnvironment.Production, `/sheets/${yield serializers$5.SheetId.jsonOrThrow(sheetId)}/commits`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$5.ListCommitsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$5.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$5.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$5.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$5.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$5(this, void 0, void 0, function* () {
            return `Bearer ${yield core$5.Supplier.get(this._options.token)}`;
        });
    }
}
Client$5.Sheets = Sheets;

var Client$4 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$4 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$4 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$4 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$4(result, mod, k);
    __setModuleDefault$4(result, mod);
    return result;
};
var __awaiter$4 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$4 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$4, "__esModule", { value: true });
Client$4.Snapshots = void 0;
const environments$4 = __importStar$4(environments$l);
const core$4 = __importStar$4(core$1H);
const Flatfile$2 = __importStar$4(api);
const serializers$4 = __importStar$4(requireSerialization());
const url_join_1$4 = __importDefault$4(urlJoinExports);
const errors$4 = __importStar$4(errors$l);
class Snapshots {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Creates a snapshot of a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    createSnapshot(request, requestOptions) {
        var _a, _b;
        return __awaiter$4(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$4.fetcher)({
                url: (0, url_join_1$4.default)((_b = (yield core$4.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$4.FlatfileEnvironment.Production, "/snapshots"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$4.CreateSnapshotRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$4.SnapshotResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$2.BadRequestError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$2.NotFoundError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$4.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$4.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$4.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$4.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * List all snapshots of a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    listSnapshots(request, requestOptions) {
        var _a, _b;
        return __awaiter$4(this, void 0, void 0, function* () {
            const { sheetId } = request;
            const _queryParams = {};
            _queryParams["sheetId"] = sheetId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$4.fetcher)({
                url: (0, url_join_1$4.default)((_b = (yield core$4.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$4.FlatfileEnvironment.Production, "/snapshots"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$4.SnapshotsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$2.BadRequestError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$2.NotFoundError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$4.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$4.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$4.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$4.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Gets a snapshot of a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getSnapshot(snapshotId, request, requestOptions) {
        var _a, _b;
        return __awaiter$4(this, void 0, void 0, function* () {
            const { includeSummary } = request;
            const _queryParams = {};
            _queryParams["includeSummary"] = includeSummary.toString();
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$4.fetcher)({
                url: (0, url_join_1$4.default)((_b = (yield core$4.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$4.FlatfileEnvironment.Production, `/snapshots/${yield serializers$4.SnapshotId.jsonOrThrow(snapshotId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$4.SnapshotResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$2.BadRequestError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$2.NotFoundError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$4.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$4.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$4.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$4.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a snapshot of a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    deleteSnapshot(snapshotId, requestOptions) {
        var _a, _b;
        return __awaiter$4(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$4.fetcher)({
                url: (0, url_join_1$4.default)((_b = (yield core$4.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$4.FlatfileEnvironment.Production, `/snapshots/${yield serializers$4.SnapshotId.jsonOrThrow(snapshotId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$4.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$2.BadRequestError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$2.NotFoundError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$4.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$4.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$4.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$4.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Restores a snapshot of a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    restoreSnapshot(snapshotId, request, requestOptions) {
        var _a, _b;
        return __awaiter$4(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$4.fetcher)({
                url: (0, url_join_1$4.default)((_b = (yield core$4.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$4.FlatfileEnvironment.Production, `/snapshots/${yield serializers$4.SnapshotId.jsonOrThrow(snapshotId)}/restore`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: request != null
                    ? yield serializers$4.snapshots.restoreSnapshot.Request.jsonOrThrow(request, {
                        unrecognizedObjectKeys: "strip",
                    })
                    : undefined,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$4.SnapshotResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$2.BadRequestError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$2.NotFoundError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$4.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$4.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$4.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$4.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Gets records from a snapshot of a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getSnapshotRecords(snapshotId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$4(this, void 0, void 0, function* () {
            const { pageSize, pageNumber, changeType } = request;
            const _queryParams = {};
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (changeType != null) {
                _queryParams["changeType"] = changeType;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$4.fetcher)({
                url: (0, url_join_1$4.default)((_b = (yield core$4.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$4.FlatfileEnvironment.Production, `/snapshots/${yield serializers$4.SnapshotId.jsonOrThrow(snapshotId)}/records`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$4.DiffRecordsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$2.BadRequestError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$2.NotFoundError(yield serializers$4.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$4.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$4.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$4.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$4.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$4(this, void 0, void 0, function* () {
            return `Bearer ${yield core$4.Supplier.get(this._options.token)}`;
        });
    }
}
Client$4.Snapshots = Snapshots;

var Client$3 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$3 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$3 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$3 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$3(result, mod, k);
    __setModuleDefault$3(result, mod);
    return result;
};
var __awaiter$3 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$3 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$3, "__esModule", { value: true });
Client$3.Spaces = void 0;
const environments$3 = __importStar$3(environments$l);
const core$3 = __importStar$3(core$1H);
const Flatfile$1 = __importStar$3(api);
const url_join_1$3 = __importDefault$3(urlJoinExports);
const serializers$3 = __importStar$3(requireSerialization());
const errors$3 = __importStar$3(errors$l);
class Spaces {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns all spaces for an account or environment
     * @throws {@link Flatfile.BadRequestError}
     */
    list(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$3(this, void 0, void 0, function* () {
            const { environmentId, pageSize, pageNumber, search, archived, sortField, sortDirection, isCollaborative } = request;
            const _queryParams = {};
            if (environmentId != null) {
                _queryParams["environmentId"] = environmentId;
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (search != null) {
                _queryParams["search"] = search;
            }
            if (archived != null) {
                _queryParams["archived"] = archived.toString();
            }
            if (sortField != null) {
                _queryParams["sortField"] = sortField;
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = sortDirection;
            }
            if (isCollaborative != null) {
                _queryParams["isCollaborative"] = isCollaborative.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$3.fetcher)({
                url: (0, url_join_1$3.default)((_b = (yield core$3.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$3.FlatfileEnvironment.Production, "/spaces"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$3.ListSpacesResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$1.BadRequestError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$3.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$3.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$3.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$3.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Creates a new space based on an existing Space Config
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter$3(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$3.fetcher)({
                url: (0, url_join_1$3.default)((_b = (yield core$3.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$3.FlatfileEnvironment.Production, "/spaces"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$3.SpaceConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$3.SpaceResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$1.BadRequestError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$1.NotFoundError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$3.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$3.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$3.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$3.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns a single space
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(spaceId, requestOptions) {
        var _a, _b;
        return __awaiter$3(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$3.fetcher)({
                url: (0, url_join_1$3.default)((_b = (yield core$3.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$3.FlatfileEnvironment.Production, `/spaces/${yield serializers$3.SpaceId.jsonOrThrow(spaceId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$3.SpaceResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$1.BadRequestError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$1.NotFoundError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$3.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$3.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$3.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$3.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Delete a space
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(spaceId, requestOptions) {
        var _a, _b;
        return __awaiter$3(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$3.fetcher)({
                url: (0, url_join_1$3.default)((_b = (yield core$3.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$3.FlatfileEnvironment.Production, `/spaces/${yield serializers$3.SpaceId.jsonOrThrow(spaceId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$3.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$1.BadRequestError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$1.NotFoundError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$3.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$3.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$3.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$3.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Update a space, to change the name for example
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    update(spaceId, request, requestOptions) {
        var _a, _b;
        return __awaiter$3(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$3.fetcher)({
                url: (0, url_join_1$3.default)((_b = (yield core$3.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$3.FlatfileEnvironment.Production, `/spaces/${yield serializers$3.SpaceId.jsonOrThrow(spaceId)}`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$3.SpaceConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$3.SpaceResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$1.BadRequestError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$1.NotFoundError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$3.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$3.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$3.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$3.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Sets archivedAt timestamp on a space
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    archiveSpace(spaceId, requestOptions) {
        var _a, _b;
        return __awaiter$3(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$3.fetcher)({
                url: (0, url_join_1$3.default)((_b = (yield core$3.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$3.FlatfileEnvironment.Production, `/spaces/${yield serializers$3.SpaceId.jsonOrThrow(spaceId)}/archive`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$3.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile$1.BadRequestError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile$1.NotFoundError(yield serializers$3.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors$3.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$3.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$3.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$3.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$3(this, void 0, void 0, function* () {
            return `Bearer ${yield core$3.Supplier.get(this._options.token)}`;
        });
    }
}
Client$3.Spaces = Spaces;

var Client$2 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$2 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$2 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$2 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$2(result, mod, k);
    __setModuleDefault$2(result, mod);
    return result;
};
var __awaiter$2 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$2 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$2, "__esModule", { value: true });
Client$2.Users = void 0;
const environments$2 = __importStar$2(environments$l);
const core$2 = __importStar$2(core$1H);
const url_join_1$2 = __importDefault$2(urlJoinExports);
const serializers$2 = __importStar$2(requireSerialization());
const errors$2 = __importStar$2(errors$l);
class Users {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Gets a list of users
     */
    list(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function* () {
            const { email } = request;
            const _queryParams = {};
            if (email != null) {
                _queryParams["email"] = email;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$2.fetcher)({
                url: (0, url_join_1$2.default)((_b = (yield core$2.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$2.FlatfileEnvironment.Production, "users"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$2.ListUsersResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$2.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$2.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$2.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$2.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * A user is a privileged user that logs in with a username and password.
     */
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$2.fetcher)({
                url: (0, url_join_1$2.default)((_b = (yield core$2.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$2.FlatfileEnvironment.Production, "users"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$2.UserConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$2.UserResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$2.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$2.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$2.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$2.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Gets a user
     */
    get(userId, requestOptions) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$2.fetcher)({
                url: (0, url_join_1$2.default)((_b = (yield core$2.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$2.FlatfileEnvironment.Production, `users/${yield serializers$2.UserId.jsonOrThrow(userId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$2.UserResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$2.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$2.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$2.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$2.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Gets all the api tokens for a user.
     */
    listApiTokens(userId, request, requestOptions) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function* () {
            const { tenantId, pageSize, pageNumber } = request;
            const _queryParams = {};
            _queryParams["tenantId"] = tenantId;
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$2.fetcher)({
                url: (0, url_join_1$2.default)((_b = (yield core$2.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$2.FlatfileEnvironment.Production, `users/${yield serializers$2.UserId.jsonOrThrow(userId)}/api-token`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$2.ListApiTokensResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$2.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$2.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$2.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$2.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Creates an api token for authenticating against Flatfile APIs.
     */
    createApiToken(userId, request, requestOptions) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function* () {
            const { tenantId } = request;
            const _queryParams = {};
            _queryParams["tenantId"] = tenantId;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$2.fetcher)({
                url: (0, url_join_1$2.default)((_b = (yield core$2.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$2.FlatfileEnvironment.Production, `users/${yield serializers$2.UserId.jsonOrThrow(userId)}/api-token`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$2.ApiTokenResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$2.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$2.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$2.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$2.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Exchange an invitation for an access token
     */
    exchangeToken(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$2.fetcher)({
                url: (0, url_join_1$2.default)((_b = (yield core$2.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$2.FlatfileEnvironment.Production, "invitations/exchange"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$2.ExchangeTokenRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$2.ExchangeTokenResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$2.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$2.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$2.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$2.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$2(this, void 0, void 0, function* () {
            return `Bearer ${yield core$2.Supplier.get(this._options.token)}`;
        });
    }
}
Client$2.Users = Users;

var Client$1 = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding$1 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
    __setModuleDefault$1(result, mod);
    return result;
};
var __awaiter$1 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client$1, "__esModule", { value: true });
Client$1.Versions = void 0;
const environments$1 = __importStar$1(environments$l);
const core$1 = __importStar$1(core$1H);
const serializers$1 = __importStar$1(requireSerialization());
const url_join_1$1 = __importDefault$1(urlJoinExports);
const errors$1 = __importStar$1(errors$l);
class Versions {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Creates a new version id that can be used to group record updates
     */
    createId(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter$1(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core$1.fetcher)({
                url: (0, url_join_1$1.default)((_b = (yield core$1.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments$1.FlatfileEnvironment.Production, "/versions"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers$1.VersionsPostRequestBody.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers$1.VersionResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors$1.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors$1.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors$1.FlatfileTimeoutError();
                case "unknown":
                    throw new errors$1.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter$1(this, void 0, void 0, function* () {
            return `Bearer ${yield core$1.Supplier.get(this._options.token)}`;
        });
    }
}
Client$1.Versions = Versions;

var Client = {};

/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Client, "__esModule", { value: true });
Client.Workbooks = void 0;
const environments = __importStar(environments$l);
const core = __importStar(core$1H);
const Flatfile = __importStar(api);
const url_join_1 = __importDefault(urlJoinExports);
const serializers = __importStar(requireSerialization());
const errors = __importStar(errors$l);
class Workbooks {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Returns all workbooks matching a filter for an account or space
     * @throws {@link Flatfile.BadRequestError}
     */
    list(request = {}, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { spaceId, includeCounts } = request;
            const _queryParams = {};
            if (spaceId != null) {
                _queryParams["spaceId"] = spaceId;
            }
            if (includeCounts != null) {
                _queryParams["includeCounts"] = includeCounts.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, "/workbooks"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.ListWorkbooksResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Creates a workbook and adds it to a space
     * @throws {@link Flatfile.BadRequestError}
     */
    create(request, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, "/workbooks"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers.CreateWorkbookConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns a single workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(workbookId, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes a workbook and all of its record data permanently
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(workbookId, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Updates a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    update(workbookId, request, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}`),
                method: "PATCH",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers.WorkbookUpdate.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Clones a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    clone(workbookId, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/clone`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns sheets from a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getSheetsDeprecated(workbookId, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.ListSheetsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Rebuild a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    rebuildWorkbook(workbookId, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/rebuild`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns records from a sheet in a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getRecordsDeprecated(workbookId, sheetId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { versionId, untilVersionId, sinceVersionId, sortField, sortDirection, filter, filterField, searchValue, searchField, pageSize, pageNumber, includeCounts, includeLinks, includeMessages, } = request;
            const _queryParams = {};
            if (versionId != null) {
                _queryParams["versionId"] = versionId;
            }
            if (untilVersionId != null) {
                _queryParams["untilVersionId"] = untilVersionId;
            }
            if (sinceVersionId != null) {
                _queryParams["sinceVersionId"] = sinceVersionId;
            }
            if (sortField != null) {
                _queryParams["sortField"] = sortField;
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = sortDirection;
            }
            if (filter != null) {
                _queryParams["filter"] = filter;
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (includeCounts != null) {
                _queryParams["includeCounts"] = includeCounts.toString();
            }
            if (includeLinks != null) {
                _queryParams["includeLinks"] = includeLinks.toString();
            }
            if (includeMessages != null) {
                _queryParams["includeMessages"] = includeMessages.toString();
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Updates existing records in a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    updateRecordsDeprecated(workbookId, sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "PUT",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers.Records.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.VersionResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Adds records to a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    addRecordsDeprecated(workbookId, sheetId, request, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                body: yield serializers.workbooks.addRecordsDeprecated.Request.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Deletes records from a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    deleteRecordsDeprecated(workbookId, sheetId, request = {}, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { ids } = request;
            const _queryParams = {};
            if (ids != null) {
                if (Array.isArray(ids)) {
                    for (const _item of ids) {
                        _queryParams["ids"] = _item;
                    }
                }
                else {
                    _queryParams["ids"] = ids;
                }
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                queryParameters: _queryParams,
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Trigger data hooks and validation to run on a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    validateSheetDeprecated(workbookId, sheetId, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/validate`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.Success.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Creates a new version of a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    createVersionDeprecated(workbookId, sheetId, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/versions`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Disable-Hooks": "true",
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@flatfile/api",
                    "X-Fern-SDK-Version": "1.5.34",
                },
                contentType: "application/json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
            });
            if (_response.ok) {
                return yield serializers.VersionResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case 404:
                        throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError();
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            return `Bearer ${yield core.Supplier.get(this._options.token)}`;
        });
    }
}
Client.Workbooks = Workbooks;

/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(Client$j, "__esModule", { value: true });
Client$j.FlatfileClient = void 0;
const Client_1 = Client$i;
const Client_2 = Client$h;
const Client_3 = Client$g;
const Client_4 = Client$f;
const Client_5 = Client$e;
const Client_6 = Client$d;
const Client_7 = Client$c;
const Client_8 = Client$b;
const Client_9 = Client$a;
const Client_10 = Client$9;
const Client_11 = Client$8;
const Client_12 = Client$7;
const Client_13 = Client$6;
const Client_14 = Client$5;
const Client_15 = Client$4;
const Client_16 = Client$3;
const Client_17 = Client$2;
const Client_18 = Client$1;
const Client_19 = Client;
class FlatfileClient {
    constructor(_options) {
        this._options = _options;
    }
    get agents() {
        var _a;
        return ((_a = this._agents) !== null && _a !== void 0 ? _a : (this._agents = new Client_1.Agents(this._options)));
    }
    get auth() {
        var _a;
        return ((_a = this._auth) !== null && _a !== void 0 ? _a : (this._auth = new Client_2.Auth(this._options)));
    }
    get cells() {
        var _a;
        return ((_a = this._cells) !== null && _a !== void 0 ? _a : (this._cells = new Client_3.Cells(this._options)));
    }
    get commits() {
        var _a;
        return ((_a = this._commits) !== null && _a !== void 0 ? _a : (this._commits = new Client_4.Commits(this._options)));
    }
    get documents() {
        var _a;
        return ((_a = this._documents) !== null && _a !== void 0 ? _a : (this._documents = new Client_5.Documents(this._options)));
    }
    get environments() {
        var _a;
        return ((_a = this._environments) !== null && _a !== void 0 ? _a : (this._environments = new Client_6.Environments(this._options)));
    }
    get events() {
        var _a;
        return ((_a = this._events) !== null && _a !== void 0 ? _a : (this._events = new Client_7.Events(this._options)));
    }
    get files() {
        var _a;
        return ((_a = this._files) !== null && _a !== void 0 ? _a : (this._files = new Client_8.Files(this._options)));
    }
    get guests() {
        var _a;
        return ((_a = this._guests) !== null && _a !== void 0 ? _a : (this._guests = new Client_9.Guests(this._options)));
    }
    get jobs() {
        var _a;
        return ((_a = this._jobs) !== null && _a !== void 0 ? _a : (this._jobs = new Client_10.Jobs(this._options)));
    }
    get mapping() {
        var _a;
        return ((_a = this._mapping) !== null && _a !== void 0 ? _a : (this._mapping = new Client_11.Mapping(this._options)));
    }
    get records() {
        var _a;
        return ((_a = this._records) !== null && _a !== void 0 ? _a : (this._records = new Client_12.Records(this._options)));
    }
    get secrets() {
        var _a;
        return ((_a = this._secrets) !== null && _a !== void 0 ? _a : (this._secrets = new Client_13.Secrets(this._options)));
    }
    get sheets() {
        var _a;
        return ((_a = this._sheets) !== null && _a !== void 0 ? _a : (this._sheets = new Client_14.Sheets(this._options)));
    }
    get snapshots() {
        var _a;
        return ((_a = this._snapshots) !== null && _a !== void 0 ? _a : (this._snapshots = new Client_15.Snapshots(this._options)));
    }
    get spaces() {
        var _a;
        return ((_a = this._spaces) !== null && _a !== void 0 ? _a : (this._spaces = new Client_16.Spaces(this._options)));
    }
    get users() {
        var _a;
        return ((_a = this._users) !== null && _a !== void 0 ? _a : (this._users = new Client_17.Users(this._options)));
    }
    get versions() {
        var _a;
        return ((_a = this._versions) !== null && _a !== void 0 ? _a : (this._versions = new Client_18.Versions(this._options)));
    }
    get workbooks() {
        var _a;
        return ((_a = this._workbooks) !== null && _a !== void 0 ? _a : (this._workbooks = new Client_19.Workbooks(this._options)));
    }
}
Client$j.FlatfileClient = FlatfileClient;

// src/index.ts
var CrossEnvConfig = class {
  /**
   * Get a config value from either the environment or any registry overrides
   * @param prop
   */
  static get(prop) {
    return this.safeEnvLookup(prop);
  }
  /**
   * Set a value explicitly
   *
   * @param key
   * @param value
   */
  static set(key, value) {
    return this._overrides.set(key, value);
  }
  /**
   * Alias a key to another key if helpful. This is useful if you have different naming
   * constructs for different environments.
   *
   * @param from
   * @param to
   */
  static alias(from, to) {
    return this._aliases.set(from, to);
  }
  /**
   * Helpful if you've decided to store settings in another object and want to
   * make that available here. For example in client-side implementations you may reserve
   * a window.FLATFILE_CONFIG object to store settings.
   *
   * @param obj
   */
  static attachConfigRegistry(obj) {
    this._registry = obj;
  }
  /**
   * Use this to provide an override getter for config values. This is useful
   * if you need to dynamically look up values. Overrides will still take precedence.
   *
   * @param cb
   */
  static attachConfigFactory(cb) {
    this._factory = cb;
  }
  static reset() {
    this._overrides = /* @__PURE__ */ new Map();
    this._registry = void 0;
    this._factory = void 0;
  }
  /**
   * Internal function for traversing the possible environment sources for a value
   *
   * @param prop
   * @private
   */
  static safeEnvLookup(prop) {
    let values = [];
    if (this._overrides.get(prop)) {
      values.push(this._overrides.get(prop));
    }
    if (typeof this._registry === "object") {
      values.push(this._registry[prop]);
    }
    if (typeof this._factory === "function") {
      values.push(this._factory(prop));
    }
    if (typeof process === "object" && typeof process.env === "object") {
      values.push(process.env[prop]);
    }
    values.push(...this.checkForBrowserVariables(prop));
    const foundValue = values.find((v) => v !== void 0);
    if (foundValue !== void 0) {
      return foundValue;
    }
    const alias = this._aliases.get(prop);
    if (alias) {
      return this.safeEnvLookup(alias);
    }
    return void 0;
  }
  /**
   * Internal function for checking for stored variables in a browser-like environment
   *
   * @param prop
   * @private
   */
  static checkForBrowserVariables(prop) {
    let values = [];
    if (typeof window === "object") {
      const windowValue = window[`CROSSENV_${prop}`];
      if (windowValue !== void 0) {
        values.push(windowValue);
      }
      if (typeof sessionStorage === "object") {
        const storedValue = sessionStorage.getItem(`CROSSENV_${prop}`);
        if (storedValue !== null) {
          values.push(storedValue);
        }
      }
    }
    return values;
  }
};
CrossEnvConfig._overrides = /* @__PURE__ */ new Map();
/**
 * A map of aliases that can be used to look up config values.
 *
 * @private
 */
CrossEnvConfig._aliases = /* @__PURE__ */ new Map();

var dist = /*#__PURE__*/Object.freeze({
	__proto__: null,
	CrossEnvConfig: CrossEnvConfig
});

var require$$3 = /*@__PURE__*/getAugmentedNamespace(dist);

var RecordsClient = {};

var deflate$3 = {};

var trees = {};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

/* Public constants ==========================================================*/
/* ===========================================================================*/


//const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const Z_FIXED$1               = 4;
//const Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
const Z_BINARY              = 0;
const Z_TEXT                = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const Z_UNKNOWN$1             = 2;

/*============================================================================*/


function zero$2(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES    = 2;
/* The three kinds of block type */

const MIN_MATCH$1    = 3;
const MAX_MATCH$1    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

const LENGTH_CODES$1  = 29;
/* number of length codes, not counting the special END_BLOCK code */

const LITERALS$1      = 256;
/* number of literal bytes 0..255 */

const L_CODES$1       = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */

const D_CODES$1       = 30;
/* number of distance codes */

const BL_CODES$1      = 19;
/* number of codes used to transfer the bit lengths */

const HEAP_SIZE$1     = 2 * L_CODES$1 + 1;
/* maximum heap size */

const MAX_BITS$1      = 15;
/* All codes must not exceed MAX_BITS bits */

const Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

const MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

const END_BLOCK   = 256;
/* end of block literal code */

const REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

const REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

const REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
const extra_lbits =   /* extra bits for each length code */
  new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]);

const extra_dbits =   /* extra bits for each distance code */
  new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]);

const extra_blbits =  /* extra bits for each bit length code */
  new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]);

const bl_order =
  new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

const DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const static_ltree  = new Array((L_CODES$1 + 2) * 2);
zero$2(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

const static_dtree  = new Array(D_CODES$1 * 2);
zero$2(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

const _dist_code    = new Array(DIST_CODE_LEN);
zero$2(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

const _length_code  = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$2(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

const base_length   = new Array(LENGTH_CODES$1);
zero$2(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

const base_dist     = new Array(D_CODES$1);
zero$2(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


let static_l_desc;
let static_d_desc;
let static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



const d_code = (dist) => {

  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
const put_short = (s, w) => {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
};


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
const send_bits = (s, value, length) => {

  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
};


const send_code = (s, c, tree) => {

  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
};


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
const bi_reverse = (code, len) => {

  let res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
};


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
const bi_flush = (s) => {

  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
};


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
const gen_bitlen = (s, desc) =>
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  const tree            = desc.dyn_tree;
  const max_code        = desc.max_code;
  const stree           = desc.stat_desc.static_tree;
  const has_stree       = desc.stat_desc.has_stree;
  const extra           = desc.stat_desc.extra_bits;
  const base            = desc.stat_desc.extra_base;
  const max_length      = desc.stat_desc.max_length;
  let h;              /* heap index */
  let n, m;           /* iterate over the tree elements */
  let bits;           /* bit length */
  let xbits;          /* extra bits */
  let f;              /* frequency */
  let overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
};


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
const gen_codes = (tree, max_code, bl_count) =>
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */
  let code = 0;              /* running code value */
  let bits;                  /* bit index */
  let n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS$1; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    let len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
};


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
const tr_static_init = () => {

  let n;        /* iterates over tree elements */
  let bits;     /* bit counter */
  let length;   /* length value */
  let code;     /* code value */
  let dist;     /* distance index */
  const bl_count = new Array(MAX_BITS$1 + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES$1 - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES$1; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES$1 + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES$1; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES$1, MAX_BITS$1);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES$1, MAX_BL_BITS);

  //static_init_done = true;
};


/* ===========================================================================
 * Initialize a new block.
 */
const init_block = (s) => {

  let n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES$1;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES$1;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES$1; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
};


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
const bi_windup = (s) =>
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
};

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
const copy_block = (s, buf, len, header) =>
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
  s.pending += len;
};

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
const smaller = (tree, n, m, depth) => {

  const _n2 = n * 2;
  const _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
};

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
const pqdownheap = (s, tree, k) =>
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  const v = s.heap[k];
  let j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
};


// inlined manually
// const SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
const compress_block = (s, ltree, dtree) =>
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  let dist;           /* distance of matched string */
  let lc;             /* match length or unmatched char (if dist == 0) */
  let lx = 0;         /* running index in l_buf */
  let code;           /* the code to send */
  let extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
};


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
const build_tree = (s, desc) =>
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  const tree     = desc.dyn_tree;
  const stree    = desc.stat_desc.static_tree;
  const has_stree = desc.stat_desc.has_stree;
  const elems    = desc.stat_desc.elems;
  let n, m;          /* iterate over heap elements */
  let max_code = -1; /* largest code with non zero frequency */
  let node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE$1;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
};


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
const scan_tree = (s, tree, max_code) =>
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
const send_tree = (s, tree, max_code) =>
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
const build_bl_tree = (s) => {

  let max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
};


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
const send_all_trees = (s, lcodes, dcodes, blcodes) =>
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  let rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
const detect_data_type = (s) => {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  let black_mask = 0xf3ffc07f;
  let n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS$1; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
};


let static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
const _tr_init$1 = (s) =>
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
};


/* ===========================================================================
 * Send a stored block
 */
const _tr_stored_block$1 = (s, buf, stored_len, last) =>
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
};


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
const _tr_align$1 = (s) => {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
};


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
const _tr_flush_block$1 = (s, buf, stored_len, last) =>
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  let opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  let max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN$1) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block$1(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
};

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
const _tr_tally$1 = (s, dist, lc) =>
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //let out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
};

trees._tr_init  = _tr_init$1;
trees._tr_stored_block = _tr_stored_block$1;
trees._tr_flush_block  = _tr_flush_block$1;
trees._tr_tally = _tr_tally$1;
trees._tr_align = _tr_align$1;

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const adler32$2 = (adler, buf, len, pos) => {
  let s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
};


var adler32_1 = adler32$2;

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
const makeTable = () => {
  let c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
};

// Create table on load. Just 255 signed longs. Not a problem.
const crcTable = new Uint32Array(makeTable());


const crc32$2 = (crc, buf, len, pos) => {
  const t = crcTable;
  const end = pos + len;

  crc ^= -1;

  for (let i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
};


var crc32_1 = crc32$2;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var messages = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var constants$1 = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  Z_MEM_ERROR:       -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;
const adler32$1 = adler32_1;
const crc32$1   = crc32_1;
const msg$2     = messages;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$1;

/*============================================================================*/


const MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
const MAX_WBITS$1 = 15;
/* 32K LZ77 window */
const DEF_MEM_LEVEL = 8;


const LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
const LITERALS      = 256;
/* number of literal bytes 0..255 */
const L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
const D_CODES       = 30;
/* number of distance codes */
const BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
const HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
const MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

const PRESET_DICT = 0x20;

const INIT_STATE = 42;
const EXTRA_STATE = 69;
const NAME_STATE = 73;
const COMMENT_STATE = 91;
const HCRC_STATE = 103;
const BUSY_STATE = 113;
const FINISH_STATE = 666;

const BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
const BS_BLOCK_DONE     = 2; /* block flush performed */
const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
const BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

const err = (strm, errorCode) => {
  strm.msg = msg$2[errorCode];
  return errorCode;
};

const rank = (f) => {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
};

const zero$1 = (buf) => {
  let len = buf.length; while (--len >= 0) { buf[len] = 0; }
};


/* eslint-disable new-cap */
let HASH_ZLIB = (s, prev, data) => ((prev << s.hash_shift) ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let HASH = HASH_ZLIB;

/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
const flush_pending = (strm) => {
  const s = strm.state;

  //_tr_flush_bits(s);
  let len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
};


const flush_block_only = (s, last) => {
  _tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
};


const put_byte = (s, b) => {
  s.pending_buf[s.pending++] = b;
};


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
const putShortMSB = (s, b) => {

  //  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
};


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
const read_buf = (strm, buf, start, size) => {

  let len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32$1(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32$1(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
};


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
const longest_match = (s, cur_match) => {

  let chain_length = s.max_chain_length;      /* max hash chain length */
  let scan = s.strstart; /* current string */
  let match;                       /* matched string */
  let len;                           /* length of current match */
  let best_len = s.prev_length;              /* best match length so far */
  let nice_match = s.nice_match;             /* stop if match long enough */
  const limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  const _win = s.window; // shortcut

  const wmask = s.w_mask;
  const prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  const strend = s.strstart + MAX_MATCH;
  let scan_end1  = _win[scan + best_len - 1];
  let scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
};


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
const fill_window = (s) => {

  const _w_size = s.w_size;
  let p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;

      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;

      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
const deflate_stored = (s, flush) => {

  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  let max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    const max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
};

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
const deflate_fast = (s, flush) => {

  let hash_head;        /* head of the hash chain */
  let bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
const deflate_slow = (s, flush) => {

  let hash_head;          /* head of hash chain */
  let bflush;              /* set if current block must be flushed */

  let max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
};


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
const deflate_rle = (s, flush) => {

  let bflush;            /* set if current block must be flushed */
  let prev;              /* byte at distance one to match */
  let scan, strend;      /* scan goes up to strend for length of run */

  const _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
const deflate_huff = (s, flush) => {

  let bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH$2) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {

  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
const lm_init = (s) => {

  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero$1(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
};


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED$2; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new Uint16Array(HEAP_SIZE * 2);
  this.dyn_dtree  = new Uint16Array((2 * D_CODES + 1) * 2);
  this.bl_tree    = new Uint16Array((2 * BL_CODES + 1) * 2);
  zero$1(this.dyn_ltree);
  zero$1(this.dyn_dtree);
  zero$1(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new Uint16Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new Uint16Array(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero$1(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero$1(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


const deflateResetKeep = (strm) => {

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR$2);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  const s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH$2;
  _tr_init(s);
  return Z_OK$3;
};


const deflateReset = (strm) => {

  const ret = deflateResetKeep(strm);
  if (ret === Z_OK$3) {
    lm_init(strm.state);
  }
  return ret;
};


const deflateSetHeader = (strm, head) => {

  if (!strm || !strm.state) { return Z_STREAM_ERROR$2; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR$2; }
  strm.state.gzhead = head;
  return Z_OK$3;
};


const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy) => {

  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR$2;
  }
  let wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION$1) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR$2);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  const s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new Uint8Array(s.w_size * 2);
  s.head = new Uint16Array(s.hash_size);
  s.prev = new Uint16Array(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new Uint8Array(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
};

const deflateInit = (strm, level) => {

  return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
};


const deflate$2 = (strm, flush) => {

  let beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK$1 || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  }

  const s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH$3)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  }

  s.strm = strm; /* just in case */
  const old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      let header = (Z_DEFLATED$2 + ((s.w_bits - 8) << 4)) << 8;
      let level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK$3;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH$3) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE)) {
    let bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK$3;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        _tr_align(s);
      }
      else if (flush !== Z_BLOCK$1) { /* FULL_FLUSH or SYNC_FLUSH */

        _tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH$1) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero$1(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK$3;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH$3) { return Z_OK$3; }
  if (s.wrap <= 0) { return Z_STREAM_END$3; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
};


const deflateEnd = (strm) => {

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR$2;
  }

  const status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR$2);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
};


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
const deflateSetDictionary = (strm, dictionary) => {

  let dictLength = dictionary.length;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR$2;
  }

  const s = strm.state;
  const wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR$2;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32$1(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero$1(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    let tmpDict = new Uint8Array(s.w_size);
    tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  const avail = strm.avail_in;
  const next = strm.next_in;
  const input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    let str = s.strstart;
    let n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK$3;
};


deflate$3.deflateInit = deflateInit;
deflate$3.deflateInit2 = deflateInit2;
deflate$3.deflateReset = deflateReset;
deflate$3.deflateResetKeep = deflateResetKeep;
deflate$3.deflateSetHeader = deflateSetHeader;
deflate$3.deflate = deflate$2;
deflate$3.deflateEnd = deflateEnd;
deflate$3.deflateSetDictionary = deflateSetDictionary;
deflate$3.deflateInfo = 'pako deflate (from Nodeca project)';

var common = {};

const _has = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

common.assign = function (obj /*from1, from2, from3, ...*/) {
  const sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    const source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (const p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// Join array of chunks to single array.
common.flattenChunks = (chunks) => {
  // calculate data length
  let len = 0;

  for (let i = 0, l = chunks.length; i < l; i++) {
    len += chunks[i].length;
  }

  // join chunks
  const result = new Uint8Array(len);

  for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
    let chunk = chunks[i];
    result.set(chunk, pos);
    pos += chunk.length;
  }

  return result;
};

var strings$2 = {};

// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const _utf8len = new Uint8Array(256);
for (let q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
strings$2.string2buf = (str) => {
  let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new Uint8Array(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper
const buf2binstring = (buf, len) => {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if (buf.subarray && STR_APPLY_UIA_OK) {
      return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
  }

  let result = '';
  for (let i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
};


// convert array to string
strings$2.buf2string = (buf, max) => {
  let i, out;
  const len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  const utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    let c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    let c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
strings$2.utf8border = (buf, max) => {

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  let pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream$2() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

var zstream = ZStream$2;

const zlib_deflate = deflate$3;
const utils$1        = common;
const strings$1      = strings$2;
const msg$1          = messages;
const ZStream$1      = zstream;

const toString$2 = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$1;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate$1(options) {
  this.options = utils$1.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, options || {});

  let opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream$1();
  this.strm.avail_out = 0;

  let status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK$2) {
    throw new Error(msg$1[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    let dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings$1.string2buf(opt.dictionary);
    } else if (toString$2.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK$2) {
      throw new Error(msg$1[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  let status, _flush_mode;

  if (this.ended) { return false; }

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings$1.string2buf(data);
  } else if (toString$2.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    // Make sure avail_out > 6 to avoid repeating markers
    if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    status = zlib_deflate.deflate(strm, _flush_mode);

    // Ended => flush and finish
    if (status === Z_STREAM_END$2) {
      if (strm.next_out > 0) {
        this.onData(strm.output.subarray(0, strm.next_out));
      }
      status = zlib_deflate.deflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return status === Z_OK$2;
    }

    // Flush if out buffer full
    if (strm.avail_out === 0) {
      this.onData(strm.output);
      continue;
    }

    // Flush if requested and has data
    if (_flush_mode > 0 && strm.next_out > 0) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK$2) {
    this.result = utils$1.flattenChunks(this.chunks);
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate$1(input, options) {
  const deflator = new Deflate$1(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg$1[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw$1(input, options) {
  options = options || {};
  options.raw = true;
  return deflate$1(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip$1(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate$1(input, options);
}


var deflate_1 = {
  Deflate: Deflate$1,
  deflate: deflate$1,
  deflateRaw: deflateRaw$1,
  gzip: gzip$1,
  constants: constants$1
};

var inflate$3 = {};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
const BAD$1 = 30;       /* got a data error -- remain here until reset */
const TYPE$1 = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
var inffast = function inflate_fast(strm, start) {
  let _in;                    /* local strm.input */
  let last;                   /* have enough input while in < last */
  let _out;                   /* local strm.output */
  let beg;                    /* inflate()'s initial strm.output */
  let end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  let dmax;                   /* maximum distance from zlib header */
//#endif
  let wsize;                  /* window size or zero if not using window */
  let whave;                  /* valid bytes in the window */
  let wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  let s_window;               /* allocated sliding window, if wsize != 0 */
  let hold;                   /* local strm.hold */
  let bits;                   /* local strm.bits */
  let lcode;                  /* local strm.lencode */
  let dcode;                  /* local strm.distcode */
  let lmask;                  /* mask for first level of length codes */
  let dmask;                  /* mask for first level of distance codes */
  let here;                   /* retrieved table entry */
  let op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  let len;                    /* match length, unused bytes */
  let dist;                   /* match distance */
  let from;                   /* where to copy match from */
  let from_source;


  let input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  const state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD$1;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD$1;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD$1;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE$1;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD$1;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const MAXBITS = 15;
const ENOUGH_LENS$1 = 852;
const ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

const CODES$1 = 0;
const LENS$1 = 1;
const DISTS$1 = 2;

const lbase = new Uint16Array([ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
]);

const lext = new Uint8Array([ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
]);

const dbase = new Uint16Array([ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
]);

const dext = new Uint8Array([ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
]);

const inflate_table$1 = (type, lens, lens_index, codes, table, table_index, work, opts) =>
{
  const bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  let len = 0;               /* a code's length in bits */
  let sym = 0;               /* index of code symbols */
  let min = 0, max = 0;          /* minimum and maximum code lengths */
  let root = 0;              /* number of index bits for root table */
  let curr = 0;              /* number of index bits for current table */
  let drop = 0;              /* code bits to drop for sub-table */
  let left = 0;                   /* number of prefix codes available */
  let used = 0;              /* code entries in table used */
  let huff = 0;              /* Huffman code */
  let incr;              /* for incrementing code, index */
  let fill;              /* index for replicating entries */
  let low;               /* low bits for current root entry */
  let mask;              /* mask for low root bits */
  let next;             /* next available space in table */
  let base = null;     /* base value table to use */
  let base_index = 0;
//  let shoextra;    /* extra bits table to use */
  let end;                    /* use base and extra for symbol > end */
  const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  let extra = null;
  let extra_index = 0;

  let here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES$1 || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES$1) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS$1) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
    (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
        (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


var inftrees = inflate_table$1;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const adler32       = adler32_1;
const crc32         = crc32_1;
const inflate_fast  = inffast;
const inflate_table = inftrees;

const CODES = 0;
const LENS = 1;
const DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_FINISH: Z_FINISH$1, Z_BLOCK, Z_TREES,
  Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR,
  Z_DEFLATED
} = constants$1;


/* STATES ====================================================================*/
/* ===========================================================================*/


const    HEAD = 1;       /* i: waiting for magic header */
const    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
const    TIME = 3;       /* i: waiting for modification time (gzip) */
const    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
const    EXLEN = 5;      /* i: waiting for extra length (gzip) */
const    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
const    NAME = 7;       /* i: waiting for end of file name (gzip) */
const    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
const    HCRC = 9;       /* i: waiting for header crc (gzip) */
const    DICTID = 10;    /* i: waiting for dictionary check value */
const    DICT = 11;      /* waiting for inflateSetDictionary() call */
const        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
const        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
const        STORED = 14;    /* i: waiting for stored size (length and complement) */
const        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
const        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
const        TABLE = 17;     /* i: waiting for dynamic block table lengths */
const        LENLENS = 18;   /* i: waiting for code length code lengths */
const        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
const            LEN_ = 20;      /* i: same as LEN below, but only first time in */
const            LEN = 21;       /* i: waiting for length/lit/eob code */
const            LENEXT = 22;    /* i: waiting for length extra bits */
const            DIST = 23;      /* i: waiting for distance code */
const            DISTEXT = 24;   /* i: waiting for distance extra bits */
const            MATCH = 25;     /* o: waiting for output space to copy string */
const            LIT = 26;       /* o: waiting for output space to write literal */
const    CHECK = 27;     /* i: waiting for 32-bit check value */
const    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
const    DONE = 29;      /* finished check, done -- remain here until reset */
const    BAD = 30;       /* got a data error -- remain here until reset */
const    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
const    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



const ENOUGH_LENS = 852;
const ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

const MAX_WBITS = 15;
/* 32K LZ77 window */
const DEF_WBITS = MAX_WBITS;


const zswap32 = (q) => {

  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
};


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new Uint16Array(320); /* temporary storage for code lengths */
  this.work = new Uint16Array(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}


const inflateResetKeep = (strm) => {

  if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
  state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK$1;
};


const inflateReset = (strm) => {

  if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

};


const inflateReset2 = (strm, windowBits) => {
  let wrap;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
  const state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR$1;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
};


const inflateInit2 = (strm, windowBits) => {

  if (!strm) { return Z_STREAM_ERROR$1; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  const state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  const ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK$1) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
};


const inflateInit = (strm) => {

  return inflateInit2(strm, DEF_WBITS);
};


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
let virgin = true;

let lenfix, distfix; // We have no pointers in JS, so keep tables separate


const fixedtables = (state) => {

  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    lenfix = new Int32Array(512);
    distfix = new Int32Array(32);

    /* literal/length table */
    let sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
};


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
const updatewindow = (strm, src, end, copy) => {

  let dist;
  const state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new Uint8Array(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    state.window.set(src.subarray(end - state.wsize, end), 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      state.window.set(src.subarray(end - copy, end), 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
};


const inflate$2 = (strm, flush) => {

  let state;
  let input, output;          // input/output buffers
  let next;                   /* next input INDEX */
  let put;                    /* next output INDEX */
  let have, left;             /* available input and output */
  let hold;                   /* bit buffer */
  let bits;                   /* bits in bit buffer */
  let _in, _out;              /* save starting available input and output */
  let copy;                   /* number of stored or match bytes to copy */
  let from;                   /* where to copy match bytes from */
  let from_source;
  let here = 0;               /* current decoding table entry */
  let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //let last;                   /* parent table entry */
  let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  let len;                    /* length to copy for repeats, bits to drop */
  let ret;                    /* return code */
  const hbuf = new Uint8Array(4);    /* buffer for gzip header crc calculation */
  let opts;

  let n; // temporary variable for NEED_BITS

  const order = /* permutation of code lengths */
    new Uint8Array([ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ]);


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR$1;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK$1;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }

        // !!! pako patch. Force use `options.windowBits` if passed.
        // Required to always use max window size by default.
        state.dmax = 1 << state.wbits;
        //state.dmax = 1 << len;

        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Uint8Array(state.head.extra_len);
              }
              state.head.extra.set(
                input.subarray(
                  next,
                  // extra field is limited to 65536 bytes
                  // - no need for additional size check
                  next + copy
                ),
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT$1;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          output.set(input.subarray(next, next + copy), put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END$1;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR$1;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR$1;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR$1;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH$1))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH$1) && ret === Z_OK$1) {
    ret = Z_BUF_ERROR;
  }
  return ret;
};


const inflateEnd = (strm) => {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR$1;
  }

  let state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK$1;
};


const inflateGetHeader = (strm, head) => {

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR$1; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK$1;
};


const inflateSetDictionary = (strm, dictionary) => {
  const dictLength = dictionary.length;

  let state;
  let dictid;
  let ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR$1; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR$1;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR$1;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR$1;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK$1;
};


inflate$3.inflateReset = inflateReset;
inflate$3.inflateReset2 = inflateReset2;
inflate$3.inflateResetKeep = inflateResetKeep;
inflate$3.inflateInit = inflateInit;
inflate$3.inflateInit2 = inflateInit2;
inflate$3.inflate = inflate$2;
inflate$3.inflateEnd = inflateEnd;
inflate$3.inflateGetHeader = inflateGetHeader;
inflate$3.inflateSetDictionary = inflateSetDictionary;
inflate$3.inflateInfo = 'pako inflate (from Nodeca project)';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader$1() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

var gzheader = GZheader$1;

const zlib_inflate = inflate$3;
const utils        = common;
const strings      = strings$2;
const msg          = messages;
const ZStream      = zstream;
const GZheader     = gzheader;

const toString$1 = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH, Z_FINISH,
  Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR
} = constants$1;

/* ===========================================================================*/


/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate$1(options) {
  this.options = utils.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ''
  }, options || {});

  const opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  let status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  const dictionary = this.options.dictionary;
  let status, _flush_mode, last_avail_out;

  if (this.ended) return false;

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;

  // Convert data if needed
  if (toString$1.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, _flush_mode);

    if (status === Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(strm, dictionary);

      if (status === Z_OK) {
        status = zlib_inflate.inflate(strm, _flush_mode);
      } else if (status === Z_DATA_ERROR) {
        // Replace code with more verbose
        status = Z_NEED_DICT;
      }
    }

    // Skip snyc markers if more data follows and not raw mode
    while (strm.avail_in > 0 &&
           status === Z_STREAM_END &&
           strm.state.wrap > 0 &&
           data[strm.next_in] !== 0)
    {
      zlib_inflate.inflateReset(strm);
      status = zlib_inflate.inflate(strm, _flush_mode);
    }

    switch (status) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        this.onEnd(status);
        this.ended = true;
        return false;
    }

    // Remember real `avail_out` value, because we may patch out buffer content
    // to align utf8 strings boundaries.
    last_avail_out = strm.avail_out;

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === Z_STREAM_END) {

        if (this.options.to === 'string') {

          let next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          let tail = strm.next_out - next_out_utf8;
          let utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail & realign counters
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);

          this.onData(utf8str);

        } else {
          this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
        }
      }
    }

    // Must repeat iteration if out buffer is full
    if (status === Z_OK && last_avail_out === 0) continue;

    // Finalize if end of stream reached.
    if (status === Z_STREAM_END) {
      status = zlib_inflate.inflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return true;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate$1(input, options) {
  const inflator = new Inflate$1(options);

  inflator.push(input);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) throw inflator.msg || msg[inflator.err];

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw$1(input, options) {
  options = options || {};
  options.raw = true;
  return inflate$1(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


var inflate_1 = {
  Inflate: Inflate$1,
  inflate: inflate$1,
  inflateRaw: inflateRaw$1,
  ungzip: inflate$1,
  constants: constants$1
};

const { Deflate, deflate, deflateRaw, gzip } = deflate_1;

const { Inflate, inflate, inflateRaw, ungzip } = inflate_1;

const constants = constants$1;

var pako = {
  Deflate, deflate, deflateRaw, gzip,
  Inflate, inflate, inflateRaw, ungzip,
  constants
};

var hasRequiredRecordsClient;

function requireRecordsClient () {
	if (hasRequiredRecordsClient) return RecordsClient;
	hasRequiredRecordsClient = 1;
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(RecordsClient, "__esModule", { value: true });
	RecordsClient.Records = void 0;
	const pako_1 = __importDefault(pako);
	const url_join_1 = __importDefault(urlJoinExports);
	const __1 = requireApi();
	const Client_1 = Client$7;
	const core = __importStar(core$1H);
	const environments = __importStar(environments$l);
	const errors = __importStar(errors$l);
	const serializers = __importStar(requireSerialization());
	class Records extends Client_1.Records {
	    /**
	     * Adds records to a workbook sheet
	     * @throws {@link Flatfile.BadRequestError}
	     * @throws {@link Flatfile.NotFoundError}
	     */
	    insert(sheetId, request, requestOptions) {
	        var _a, _b;
	        return __awaiter(this, void 0, void 0, function* () {
	            const body = (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.compressRequestBody)
	                ? pako_1.default.gzip(JSON.stringify(request))
	                : yield serializers.records.insert.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" });
	            const gzipHeaders = (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.compressRequestBody)
	                ? { "Content-Encoding": "gzip", "Content-Length": body.length.toString() }
	                : {};
	            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
	                url: (0, url_join_1.default)((_b = (yield core.Supplier.get(this._options.environment))) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
	                method: "POST",
	                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "X-Disable-Hooks": "true", "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@flatfile/api", "X-Fern-SDK-Version": "1.5.27" }, gzipHeaders),
	                contentType: "application/json",
	                body,
	                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
	            });
	            if (_response.ok) {
	                return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
	                    unrecognizedObjectKeys: "passthrough",
	                    allowUnrecognizedUnionMembers: true,
	                    allowUnrecognizedEnumValues: true,
	                    skipValidation: true,
	                    breadcrumbsPrefix: ["response"],
	                });
	            }
	            if (_response.error.reason === "status-code") {
	                switch (_response.error.statusCode) {
	                    case 400:
	                        throw new __1.Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
	                            unrecognizedObjectKeys: "passthrough",
	                            allowUnrecognizedUnionMembers: true,
	                            allowUnrecognizedEnumValues: true,
	                            skipValidation: true,
	                            breadcrumbsPrefix: ["response"],
	                        }));
	                    case 404:
	                        throw new __1.Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
	                            unrecognizedObjectKeys: "passthrough",
	                            allowUnrecognizedUnionMembers: true,
	                            allowUnrecognizedEnumValues: true,
	                            skipValidation: true,
	                            breadcrumbsPrefix: ["response"],
	                        }));
	                    default:
	                        throw new errors.FlatfileError({
	                            statusCode: _response.error.statusCode,
	                            body: _response.error.body,
	                        });
	                }
	            }
	            switch (_response.error.reason) {
	                case "non-json":
	                    throw new errors.FlatfileError({
	                        statusCode: _response.error.statusCode,
	                        body: _response.error.rawBody,
	                    });
	                case "timeout":
	                    throw new errors.FlatfileTimeoutError();
	                case "unknown":
	                    throw new errors.FlatfileError({
	                        message: _response.error.errorMessage,
	                    });
	            }
	        });
	    }
	}
	RecordsClient.Records = Records;
	return RecordsClient;
}

var hasRequiredFlatfileClient;

function requireFlatfileClient () {
	if (hasRequiredFlatfileClient) return FlatfileClient$1;
	hasRequiredFlatfileClient = 1;
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(FlatfileClient$1, "__esModule", { value: true });
	FlatfileClient$1.FlatfileClient = void 0;
	const Client_1 = Client$j;
	const environments = __importStar(environments$l);
	const url_join_1 = __importDefault(urlJoinExports);
	const cross_env_config_1 = require$$3;
	const RecordsClient_1 = requireRecordsClient();
	cross_env_config_1.CrossEnvConfig.alias("FLATFILE_API_URL", "AGENT_INTERNAL_URL");
	cross_env_config_1.CrossEnvConfig.alias("FLATFILE_BEARER_TOKEN", "FLATFILE_API_KEY");
	class FlatfileClient extends Client_1.FlatfileClient {
	    constructor(options = {}) {
	        var _a, _b;
	        super({
	            environment: (_a = (options.environment || options.apiUrl)) !== null && _a !== void 0 ? _a : environmentSupplier,
	            token: (_b = options.token) !== null && _b !== void 0 ? _b : tokenSupplier
	        });
	    }
	    get records() {
	        var _a;
	        return ((_a = this._records) !== null && _a !== void 0 ? _a : (this._records = new RecordsClient_1.Records(this._options)));
	    }
	}
	FlatfileClient$1.FlatfileClient = FlatfileClient;
	const environmentSupplier = () => {
	    const url = cross_env_config_1.CrossEnvConfig.get("FLATFILE_API_URL");
	    if (!url) {
	        return environments.FlatfileEnvironment.Production;
	    }
	    return (0, url_join_1.default)(url, "v1");
	};
	const tokenSupplier = () => {
	    const token = cross_env_config_1.CrossEnvConfig.get("FLATFILE_BEARER_TOKEN");
	    if (token == undefined) {
	        throw new Error("FLATFILE_BEARER_TOKEN is not undefined");
	    }
	    return token;
	};
	return FlatfileClient$1;
}

var hasRequiredApi;

function requireApi () {
	if (hasRequiredApi) return api$1;
	hasRequiredApi = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.FlatfileTimeoutError = exports.FlatfileError = exports.FlatfileEnvironment = exports.FlatfileClient = exports.Flatfile = void 0;
		const FlatfileClient_1 = requireFlatfileClient();
		exports.Flatfile = __importStar(api);
		var FlatfileClient_2 = requireFlatfileClient();
		Object.defineProperty(exports, "FlatfileClient", { enumerable: true, get: function () { return FlatfileClient_2.FlatfileClient; } });
		var environments_1 = environments$l;
		Object.defineProperty(exports, "FlatfileEnvironment", { enumerable: true, get: function () { return environments_1.FlatfileEnvironment; } });
		var errors_1 = errors$l;
		Object.defineProperty(exports, "FlatfileError", { enumerable: true, get: function () { return errors_1.FlatfileError; } });
		Object.defineProperty(exports, "FlatfileTimeoutError", { enumerable: true, get: function () { return errors_1.FlatfileTimeoutError; } });
		exports.default = new FlatfileClient_1.FlatfileClient(); 
	} (api$1));
	return api$1;
}

var apiExports = requireApi();
var $3cwie$flatfileapi = /*@__PURE__*/getDefaultExportFromCjs(apiExports);

class Stats {
    constructor(meta) {
        this.$meta = meta;
    }
    /**
     * The number of rows in the parsed data
     */
    get originalRows() {
        return this.$meta.count_rows;
    }
    /**
     * The number of rows that were submitted
     */
    get acceptedRows() {
        return this.$meta.count_rows_accepted || null;
    }
    /**
     * The number of columns in the parsed data
     */
    get originalColumns() {
        return this.$meta.count_columns || null;
    }
    /**
     * The number of columns submitted
     */
    get matchedColumns() {
        return this.$meta.count_columns_matched || null;
    }
}

class EndUser {
    constructor(meta) {
        this.$user = meta;
    }
    /**
     * The UUID referencing the user's record stored in Flatfile
     */
    get id() {
        return this.$user.id;
    }
    /**
     * Your internal ID reference for this user (required)
     */
    get userId() {
        return this.$user.userId;
    }
    /**
     * The user's full name if you provided it
     */
    get name() {
        return this.$user.name;
    }
    /**
     * The user's email if you provided it
     */
    get email() {
        return this.$user.name;
    }
    /**
     * The company name the user is currently operating under
     */
    get companyName() {
        return this.$user.companyName;
    }
    /**
     * The company name the user is currently operating under
     */
    get companyId() {
        return this.$user.companyId;
    }
}

class UploadFile {
    constructor(file) {
        this.$file = file;
    }
    /**
     * A unique UUID referencing this file in the Flatfile system
     */
    get id() {
        return this.$file.id;
    }
    /**
     * The original filename on the user's system
     */
    get filename() {
        return this.$file.filename;
    }
    /**
     * The size of the file in bytes
     */
    get filesize() {
        return this.$file.filesize;
    }
    /**
     * The type of file
     */
    get filetype() {
        return this.$file.filetype;
    }
    /**
     * A securely signed url giving you temporary access to download the file
     */
    get url() {
        return this.$file.url;
    }
}

class FlatfileResults {
    /**
     * Instance of importer used to manage this file
     */
    get $importer() {
        throw new Error('You cannot use this property in the Flatfile Platform');
    }
    constructor(data, meta) {
        this.$meta = meta;
        this.$data = data;
    }
    /**
     * The raw output from the importer including all deleted rows
     * and sequence info
     */
    get rawOutput() {
        return this.blobOnly(this.$data, 'rawOutput');
    }
    /**
     * An array of valid data, key-mapped to the configuration provided
     * (alias of validData)
     */
    get data() {
        return this.blobOnly(this.validData, 'data');
    }
    /**
     * An array of valid data, key-mapped to the configuration provided
     */
    get validData() {
        const res = this.$data
            .filter((v) => v.valid)
            .filter((v) => !v.deleted)
            .map((v) => v.data);
        return this.blobOnly(res, 'validData');
    }
    /**
     * Rows of data the user excluded from the final results,
     * key-mapped to the configuration provided
     */
    get deletedData() {
        const res = this.$data.filter((v) => v.deleted).map((v) => v.data);
        return this.blobOnly(res, 'deletedData');
    }
    /**
     * All data from the original file upload including deleted rows,
     * key-mapped to the configuration provided
     */
    get allData() {
        return this.blobOnly(this.$data.map((v) => v.data), 'allData');
    }
    /**
     * The uuid of the batch assigned by Flatfile (use this in internal
     * references for support purposes)
     */
    get batchId() {
        return this.$meta.batchID;
    }
    /**
     * Stats and counts about this file upload
     */
    get stats() {
        return new Stats(this.$meta);
    }
    /**
     * The customer provided in setCustomer
     */
    get customer() {
        if (this.$meta.endUser) {
            return new EndUser(this.$meta.endUser);
        }
        return null;
    }
    /**
     * A File object of the originally uploaded file stored as an AWS url
     */
    get originalFile() {
        if (this.$meta.originalFile) {
            return new UploadFile(this.$meta.originalFile);
        }
        return null;
    }
    /**
     * Same as originalFile unless it was uploaded in xls format, in which case this is the converted csv file stored as an AWS url
     */
    get csvFile() {
        if (this.$meta.originalFile) {
            if (this.$meta.originalFile.filetype === 'csv') {
                return new UploadFile(this.$meta.originalFile);
            }
            else {
                if (this.$meta.csvFile) {
                    return new UploadFile(this.$meta.csvFile);
                }
            }
        }
        return null;
    }
    /**
     * The filename of the originally uploaded file
     */
    get fileName() {
        return this.$meta.filename || null;
    }
    /**
     * If the final upload is managed by a private endpoint or not
     */
    get managed() {
        return this.$meta.managed || false;
    }
    /**
     * If the data was entered manually instead of via file upload or not
     */
    get manual() {
        return this.$meta.manual;
    }
    /**
     * The parsed and bootstrapped config object used by this importer instance
     */
    get config() {
        return this.$meta.config;
    }
    /**
     * The configuration used by the csv parser PapaParse: https://www.papaparse.com/docs#config
     */
    get parsingConfig() {
        return this.$meta.parsing_config;
    }
    /**
     * The invalid rows that were skipped on submission
     */
    get skippedRows() {
        return this.$meta.skipped_rows || null;
    }
    /**
     * The headers before they were matched as given in the original file
     */
    get headersRaw() {
        return this.$meta.headers_raw || null;
    }
    /**
     * The headers after they are matched
     */
    get headersMatched() {
        return this.$meta.headers_matched || null;
    }
    /**
     * Get the next chunk of records
     */
    nextChunk() {
        throw new Error('You cannot use nextChunk() with the v2 shim for the Flatfile Platform');
    }
    /**
     * An array of any columns that were created during import
     */
    get customColumns() {
        return this.$meta.custom_columns;
    }
    /**
     * The reason for the failure if there was a failure
     */
    get failureReason() {
        return this.$meta.failure_reason || null;
    }
    /**
     * The time that the data was submitted
     */
    get submittedAt() {
        return this.$meta.submitted_at || null;
    }
    /**
     * The time that the import failed if it failed
     */
    get failedAt() {
        return this.$meta.failed_at || null;
    }
    /**
     * The time the data began the import, whether via file upload or manual data entry
     */
    get createdAt() {
        return this.$meta.created_at;
    }
    blobOnly(v, method, alt = 'nextChunk()') {
        if (this.$meta.inChunks) {
            throw new Error(`"${method}" is not accessible when using "inChunks". Please see docs for "${alt}" instead.`);
        }
        return v;
    }
}

/**
 * A stub interface for legacy metadata
 */
class Meta {
    get batchID() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get endUser() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get status() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get originalFile() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get csvFile() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get filename() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get filetype() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get managed() {
        return true;
    }
    get manual() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get config() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get parsing_config() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get count_rows() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get count_rows_accepted() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get count_columns() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get count_columns_matched() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get skipped_rows() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get headers_raw() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get headers_matched() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get custom_columns() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get failure_reason() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get submitted_at() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get failed_at() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get created_at() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get handled_at() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get matched_at() {
        throw new Error('meta is no longer accessible in Platform 1.0');
    }
    get inChunks() {
        return false;
    }
}

/**
 * Convenience method for getting all records for a sheet. This will get records page by page until
 * all records have been fetched.
 *
 * @param sheetId
 */
async function getAllRecords(sheetId, options) {
    const PAGE_SIZE = 1000;
    const MAX_PAGES = 100;
    const allRecords = [];
    let pageNumber = 1;
    while (true) {
        // get the next page of records
        // todo: handle errors better here
        const response = await $3cwie$flatfileapi.records.get(sheetId, {
            pageNumber,
            pageSize: PAGE_SIZE,
            ...options,
        });
        // If there are no records or no records on the page we stop
        // todo: if this is null, an error occured
        if (!response.data?.records || !response.data.records.length) {
            break;
        }
        // Add the records to the result array
        // todo: using a spread operator here is not ideal for performance, improve
        allRecords.push(...response.data.records);
        // If the records returned are less than the page size we're on the last page, so we stop.
        if (response.data.records.length < PAGE_SIZE) {
            break;
        }
        // increment the page number, if we want to fetch pages in parallel this will need to be refactored later
        pageNumber++;
        // If we've fetched more than the max pages we stop - todo: this should likely error
        if (pageNumber > MAX_PAGES) {
            break;
        }
    }
    return allRecords;
}

/**
 * A plugin for handling data
 *
 * @todo does this approach make sense with the modern javascript client?
 *
 * @param handler
 */
const handleData = (handler) => {
    return (listener) => {
        listener
            .filter({ job: 'workbook:submitAction' })
            .on('job:ready', async (event) => {
            const results = await getResultsForContextSheet(event.context.workbooks);
            return handler(results);
        });
    };
};
/**
 * Returns a legacy V2 results shim for the current sheet.
 *
 * @todo solve pagination
 * @param event
 */
const getResultsForContextSheet = async (event) => {
    const sheet = await getSheet(event.context.workbookId);
    const records = await getAllRecords(sheet.id);
    return new FlatfileResults(records.map(convertRecord), new Meta());
};
/**
 * Convert an individual record to the legacy V2 format
 *
 * @param record
 * @param sequence
 */
function convertRecord(record, sequence) {
    const data = {};
    for (const key in record.values) {
        data[key] = record.values[key].value;
    }
    return {
        sequence: sequence + 1,
        valid: record.valid || false,
        data: data,
        deleted: false,
    };
}
/**
 * Get a single sheet from the workbook
 *
 * @param workbookId
 */
async function getSheet(workbookId) {
    // Collect all Sheet and Record data from the Workbook
    const { data: sheets } = await $3cwie$flatfileapi.sheets.list({ workbookId });
    if (sheets.length > 1) {
        throw new Error('You cannot use the v2 data handling shim with more than 1 sheet.');
    }
    if (!sheets.length) {
        throw new Error('You cannot use the v2 data handling shim with no sheets.');
    }
    return sheets[0];
}

const memo = (func) => {
    const cache = new WeakMap();
    return (input) => {
        if (!cache.has(input)) {
            const result = func(input);
            cache.set(input, result);
            return result;
        }
        return cache.get(input);
    };
};
function isEmpty$i(value) {
    return value === '' || value === undefined || value === null;
}
const flagMap = {
    dotAll: 's',
    ignoreCase: 'i',
    multiline: 'm',
    global: 'g',
    unicode: 'u',
};
const getRegexFlags = (source) => Object.keys(flagMap)
    .filter((flagKey) => source && source[flagKey])
    .map((flagKey) => flagMap[flagKey])
    .join('');
/**
 * Compare any value against a regex string
 *
 * @param regexString
 * @param value
 * @param flags
 * @param fallback
 */
function testRegex(regexString, flags, 
// tslint:disable-next-line:no-any
value, fallback = true) {
    const regex = new RegExp(regexString, flags);
    if (typeof value === 'string') {
        return regex.test(value);
    }
    else {
        return fallback;
    }
}

const getRegexFlagsMemo = memo(getRegexFlags);
class Validator {
    // tslint:disable-next-line:no-any
    constructor(sheet) {
        this.sheet = sheet;
    }
    getFieldLabels(keys) {
        const keyToLabel = {};
        this.sheet.fields.forEach((item) => {
            if (item.label) {
                keyToLabel[item.key] = item.label;
            }
        });
        return keys.map((key) => (key in keyToLabel ? keyToLabel[key] : key));
    }
    /**
     * Get legacy validators if they're available
     *
     * @param key
     */
    getFieldValidators(key) {
        return this.sheet.fields.find((f) => f.key === key)?.metadata?.v2_validators;
    }
    /**
     * Take a simple key/value pair and return an array of any errors detected
     *
     * @param row
     */
    validateRow(row) {
        const validations = Object.keys(row).map((key) => {
            const errors = this.validateCell(row, key);
            return errors.map((message) => ({
                key,
                level: 'error',
                message,
            }));
        });
        return validations.flat();
    }
    /**
     * Backwards compatible helper
     *
     * @todo remove this
     * @param row
     * @param key
     * @private
     */
    getRowValue(row, key) {
        return row[key];
    }
    validateCell(row, key) {
        const value = this.getRowValue(row, key);
        const validators = this.getFieldValidators(key) || [];
        const requiredValidatorKeys = [
            'required_without',
            'required_without_all',
            'required_with_all',
            'required_with',
            'required_without_values',
            'required_without_all_values',
            'required_with_all_values',
            'required_with_values',
        ];
        const requiredValidators = validators.filter((validator) => requiredValidatorKeys.includes(validator.validate));
        const requiredErrors = requiredValidators.reduce((errors, validator) => {
            let isValid = true;
            switch (validator.validate) {
                case 'required_without_all':
                    // required when all of the fields are empty
                    // i.e. allow empty when any field is non empty
                    isValid =
                        !isEmpty$i(value) ||
                            validator.fields.some((v) => !isEmpty$i(this.getRowValue(row, v)));
                    break;
                case 'required_without':
                    // required when any of the fields are empty
                    // i.e. allow empty when all fields are non empty
                    isValid =
                        !isEmpty$i(value) ||
                            !validator.fields.some((v) => isEmpty$i(this.getRowValue(row, v)));
                    break;
                case 'required_with_all':
                    // required when all of the fields are non empty
                    // i.e. allow empty when any field is empty
                    isValid =
                        !isEmpty$i(value) ||
                            validator.fields.some((v) => isEmpty$i(this.getRowValue(row, v)));
                    break;
                case 'required_with':
                    // required when any of the fields are non empty
                    // i.e. allow empty when all fields are empty
                    isValid =
                        !isEmpty$i(value) ||
                            !validator.fields.some((v) => !isEmpty$i(this.getRowValue(row, v)));
                    break;
                case 'required_without_all_values':
                    isValid =
                        !isEmpty$i(value) ||
                            // required when all of the fields are mismatched
                            // i.e. allow empty when any field is matched
                            this.someFields(validator.fieldValues, (expected, cellValue) => Array.isArray(expected)
                                ? expected.includes(cellValue)
                                : expected === cellValue, row);
                    break;
                case 'required_without_values':
                    isValid =
                        !isEmpty$i(value) ||
                            // required when any of the fields are mismatched
                            // i.e. allow empty when all fields are matched
                            !this.someFields(validator.fieldValues, (expected, cellValue) => Array.isArray(expected)
                                ? !expected.includes(cellValue)
                                : expected !== cellValue, row);
                    break;
                case 'required_with_all_values':
                    isValid =
                        !isEmpty$i(value) ||
                            // required when all of the fields are matched
                            // i.e. allow empty when any field is mismatched
                            this.someFields(validator.fieldValues, (expected, cellValue) => Array.isArray(expected)
                                ? !expected.includes(cellValue)
                                : expected !== cellValue, row);
                    break;
                case 'required_with_values':
                    isValid =
                        !isEmpty$i(value) ||
                            // required when any of the fields are matched
                            // i.e. allow empty when all fields are mismatched
                            !this.someFields(validator.fieldValues, (expected, cellValue) => Array.isArray(expected)
                                ? expected.includes(cellValue)
                                : expected === cellValue, row);
                    break;
                default:
                    // tslint:disable-next-line:no-console
                    console.error(`unhandled required validator: ${validator.validate}`);
            }
            return isValid
                ? errors
                : errors.concat([
                    validator.error ||
                        this.defaultErrorMessage(validator) ||
                        'Failed validation',
                ]);
        }, []);
        const additionalValidators = validators.filter((validator) => !requiredValidatorKeys.includes(validator.validate));
        const additionalErrors = additionalValidators.reduce((errors, validator) => {
            let isValid = true;
            switch (validator.validate) {
                case 'regex_matches':
                    isValid = testRegex(validator.regex, validator.regexFlags
                        ? getRegexFlagsMemo(validator.regexFlags)
                        : '', value);
                    break;
                case 'regex_excludes':
                    isValid = !testRegex(validator.regex, validator.regexFlags
                        ? getRegexFlagsMemo(validator.regexFlags)
                        : '', value, false);
                    break;
                case 'select':
                    throw new Error('`select` validator is no longer necessary. Remove this.');
                default:
                    // tslint:disable-next-line:no-console
                    console.error(`unhandled validator: ${validator.validate}`);
            }
            return isValid
                ? errors
                : errors.concat([
                    validator.error ||
                        this.defaultErrorMessage(validator) ||
                        'Failed validation',
                ]);
        }, []);
        if (isEmpty$i(value) && requiredErrors.length === 0) {
            return [];
        }
        return requiredErrors.concat(additionalErrors);
    }
    /**
     * check some fields against an expectation i.e. { "key": "value" } // i.e. row["key"] === "value"
     * @param expectedFields
     * @param rule
     * @param row
     */
    someFields(expectedFields, rule, row) {
        return Object.keys(expectedFields).some((fieldKey) => rule(expectedFields[fieldKey], this.getRowValue(row, fieldKey)));
    }
    defaultErrorMessage(validator) {
        const messages = {
            required_with: 'This field is required when ANY of the following fields are filled: {{fields}}',
            required_with_all: 'This field is required when ALL of the following fields are filled: {{fields}}',
            required_with_all_values: 'This field is required when ALL of the following fields have these values: {{fields}}',
            required_with_values: 'This field is required when ANY of the following fields have these values: {{fields}}',
            required_without: 'This field is required when ANY of the following fields are empty: {{fields}}',
            required_without_all: 'This field is required when ALL of the following fields are empty: {{fields}}',
            required_without_all_values: 'This field is required when NONE of the following fields have these values: {{fields}}',
            required_without_values: "This field is required when ANY of the following fields don't have these values: {{fields}}",
            unique: 'Must be unique.',
        };
        switch (validator.validate) {
            case 'required_with':
            case 'required_with_all':
            case 'required_without':
            case 'required_without_all':
                return messages[validator.validate].replace('{{fields}}', this.getFieldLabels(validator.fields).join(', '));
            case 'required_with_values':
            case 'required_with_all_values':
            case 'required_without_values':
            case 'required_without_all_values':
                const labels = this.getFieldLabels(Object.keys(validator.fieldValues));
                const requiredString = Object.values(validator.fieldValues)
                    .map((value, index) => `"${labels[index]}"${Array.isArray(value)
                    ? ` any of [${value.map((v) => `"${v}"`).join(', ')}]`
                    : ` = "${value}"`}`)
                    .join(', ');
                return messages[validator.validate].replace('{{fields}}', requiredString);
        }
    }
}

const getSheetConfigFromSession = async (sheetId) => {
    try {
        const sheetConfig = sessionStorage.getItem(sheetId);
        if (sheetConfig) {
            return sheetConfig;
        }
        else {
            const { data: { config }, } = await $3cwie$flatfileapi.sheets.get(sheetId);
            sessionStorage.setItem(sheetId, config);
            return config;
        }
    }
    catch (e) {
        const { data: { config }, } = await $3cwie$flatfileapi.sheets.get(sheetId);
        return config;
    }
};

// src/classes/FlatfileRecord.ts
var propExists = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
var FlatfileRecord = class {
  constructor(raw) {
    this._info = [];
    this.mutated = Object.assign({}, raw.rawData);
    this.data = Object.assign({}, raw.rawData);
    this.metadata = Object.assign({}, raw.metadata);
    this._rowId = raw.rowId;
  }
  get rowId() {
    return this._rowId;
  }
  get originalValue() {
    return this.data;
  }
  get value() {
    return this.mutated;
  }
  verifyField(field, data) {
    if (!propExists(data || this.data, field)) {
      console.error(`Record does not have field "${field}".`);
      return false;
    }
    return true;
  }
  isLinkedField(field) {
    const fieldValue = this.mutated[field];
    return !!fieldValue && typeof fieldValue === "object" && propExists(fieldValue, "value") && propExists(fieldValue, "links");
  }
  set(field, value) {
    if (!this.verifyField(field)) {
      return this;
    }
    const isLinked = this.isLinkedField(field);
    if (isLinked) {
      const fieldValue = this.mutated[field];
      if (!!fieldValue && typeof fieldValue === "object" && propExists(fieldValue, "value") && fieldValue.value === value) {
        return;
      } else {
        Object.defineProperty(this.mutated, field, {
          value: {
            value
          }
        });
      }
    } else {
      Object.defineProperty(this.mutated, field, {
        value
      });
    }
    return this;
  }
  setMetadata(data) {
    Object.defineProperty(this, "metadata", { value: data });
    return this;
  }
  setLinkedValue(linkedFieldKey, childKey, value) {
    if (!this.verifyField(linkedFieldKey)) {
      return this;
    }
    Object.assign(this.mutated, { [`${linkedFieldKey}::${childKey}`]: value });
    return this;
  }
  get(field) {
    if (this.verifyField(field)) {
      const value = this.mutated[field];
      if (!!value && typeof value === "object" && propExists(value, "value")) {
        return value.value;
      }
      return value;
    }
    return null;
  }
  getMetadata() {
    return this.metadata;
  }
  getLinks(field) {
    if (this.verifyField(field)) {
      const fieldValue = this.mutated[field];
      if (fieldValue && typeof fieldValue === "object") {
        const { links } = fieldValue;
        if (links) {
          return links;
        }
      }
    }
    console.error("Field has no links.");
    return null;
  }
  getLinkedValue(linkedFieldKey, childKey) {
    var _a;
    if (this.verifyField(linkedFieldKey)) {
      return (_a = this.mutated[`${linkedFieldKey}::${childKey}`]) != null ? _a : null;
    }
    return null;
  }
  addInfo(fields, message) {
    return this.pushInfoMessage(fields, message, "info", "other");
  }
  /**
   * @alias addInfo
   */
  addComment(fields, message) {
    return this.addInfo(fields, message);
  }
  addError(fields, message) {
    return this.pushInfoMessage(fields, message, "error", "other");
  }
  addWarning(fields, message) {
    return this.pushInfoMessage(fields, message, "warn", "other");
  }
  pushInfoMessage(fields, message, level, stage) {
    fields = Array.isArray(fields) ? fields : [fields];
    fields.forEach((field) => {
      if (this.verifyField(field)) {
        this._info.push({
          field,
          message,
          level,
          stage
        });
      }
    });
    return this;
  }
  compute(field, transformation, message) {
    this.set(field, transformation(this.get(field), this));
    if (message) {
      this.addComment(field, message);
    }
    return this;
  }
  computeIfPresent(field, transformation, message) {
    if (this.get(field)) {
      this.compute(field, transformation, message);
    }
    return this;
  }
  validate(field, validator, message) {
    if (!validator(this.get(field), this)) {
      this.addError(field, message);
    }
    return this;
  }
  toJSON() {
    return {
      row: {
        rawData: this.mutated,
        rowId: this.rowId,
        metadata: this.metadata
      },
      info: this._info
    };
  }
};

// src/classes/FlatfileRecords.ts
var FlatfileRecords = class {
  constructor(rawRecords) {
    this._records = rawRecords.map(
      (rawRecord) => new FlatfileRecord(rawRecord)
    );
  }
  get records() {
    return this._records;
  }
  toJSON() {
    return this.records.map((record) => record.toJSON());
  }
};

function $parcel$export$1(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $31bda95942fa1698$exports = {};

$parcel$export$1($31bda95942fa1698$exports, "asyncBatch", () => $31bda95942fa1698$export$2f3768c184a3cc95);
async function $31bda95942fa1698$export$2f3768c184a3cc95(arr, callback, options = {}, event) {
    const { chunkSize: chunkSize = 10000, parallel: parallel = 1, debug: debug = false } = options;
    const chunks = Array.from({
        length: Math.ceil(arr.length / chunkSize)
    }, (_, i)=>arr.slice(i * chunkSize, i * chunkSize + chunkSize));
    if (debug) console.log(`${chunks.length} chunks to be processed`);
    const results = new Map();
    async function processChunk(chunkIndex, threadId) {
        if (debug) console.log(`Thread ${threadId} processing chunk ${chunkIndex}`);
        const result = await callback(chunks[chunkIndex], event);
        results.set(chunkIndex, result);
    }
    let currentIndex = 0;
    async function processChunks(threadId) {
        while(currentIndex < chunks.length){
            const chunkIndex = currentIndex++;
            await processChunk(chunkIndex, threadId);
        }
    }
    const promises = Array.from({
        length: parallel
    }, (_, i)=>processChunks(i));
    await Promise.all(promises);
    if (debug) console.log("All chunks processed");
    return Array.from(results.values());
}


var $fda4ce3509276b69$exports = {};

$parcel$export$1($fda4ce3509276b69$exports, "log", () => $fda4ce3509276b69$export$bef1f36f5486a6a3);
$parcel$export$1($fda4ce3509276b69$exports, "logInfo", () => $fda4ce3509276b69$export$89c0607256d35f0a);
$parcel$export$1($fda4ce3509276b69$exports, "logWarn", () => $fda4ce3509276b69$export$cc36178e946876e8);
$parcel$export$1($fda4ce3509276b69$exports, "logError", () => $fda4ce3509276b69$export$58da9968c3170cb1);
const $fda4ce3509276b69$export$bef1f36f5486a6a3 = (packageName, msg, type = "log")=>{
    const status = {
        log: "INFO",
        warn: "WARN",
        error: "FATAL"
    };
    console[type](`[${packageName}]:[${status[type]}] ${msg}`);
};
const $fda4ce3509276b69$export$89c0607256d35f0a = (packageName, msg)=>{
    $fda4ce3509276b69$export$bef1f36f5486a6a3(packageName, msg);
};
const $fda4ce3509276b69$export$cc36178e946876e8 = (packageName, msg)=>{
    $fda4ce3509276b69$export$bef1f36f5486a6a3(packageName, msg, "warn");
};
const $fda4ce3509276b69$export$58da9968c3170cb1 = (packageName, msg)=>{
    $fda4ce3509276b69$export$bef1f36f5486a6a3(packageName, msg, "error");
};

/**
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * Tests if a value is a `function`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isFunction } from 'effect/Predicate'
 *
 * assert.deepStrictEqual(isFunction(isFunction), true)
 * assert.deepStrictEqual(isFunction("function"), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isFunction$1 = input => typeof input === "function";

/**
 * Creates a function that can be used in a data-last (aka `pipe`able) or
 * data-first style.
 *
 * The first parameter to `dual` is either the arity of the uncurried function
 * or a predicate that determines if the function is being used in a data-first
 * or data-last style.
 *
 * Using the arity is the most common use case, but there are some cases where
 * you may want to use a predicate. For example, if you have a function that
 * takes an optional argument, you can use a predicate to determine if the
 * function is being used in a data-first or data-last style.
 *
 * @param arity - Either the arity of the uncurried function or a predicate
 *                which determines if the function is being used in a data-first
 *                or data-last style.
 * @param body - The definition of the uncurried function.
 *
 * @example
 * import { dual, pipe } from "effect/Function"
 *
 * // Exampe using arity to determine data-first or data-last style
 * export const sum: {
 *   (that: number): (self: number) => number
 *   (self: number, that: number): number
 * } = dual(2, (self: number, that: number): number => self + that)
 *
 * assert.deepStrictEqual(sum(2, 3), 5)
 * assert.deepStrictEqual(pipe(2, sum(3)), 5)
 *
 * // Example using a predicate to determine data-first or data-last style
 * export const sum2: {
 *   (that: number): (self: number) => number
 *   (self: number, that: number): number
 * } = dual((args) => args.length === 1, (self: number, that: number): number => self + that)
 *
 * assert.deepStrictEqual(sum(2, 3), 5)
 * assert.deepStrictEqual(pipe(2, sum(3)), 5)
 *
 * @since 2.0.0
 */
const dual = function (arity, body) {
  if (typeof arity === "function") {
    return function () {
      if (arity(arguments)) {
        // @ts-expect-error
        return body.apply(this, arguments);
      }
      return self => body(self, ...arguments);
    };
  }
  switch (arity) {
    case 0:
      return body;
    case 1:
      return function (a) {
        if (arguments.length >= 1) {
          return body(a);
        }
        return function () {
          return body(a);
        };
      };
    case 2:
      return function (a, b) {
        if (arguments.length >= 2) {
          return body(a, b);
        }
        return function (self) {
          return body(self, a);
        };
      };
    case 3:
      return function (a, b, c) {
        if (arguments.length >= 3) {
          return body(a, b, c);
        }
        return function (self) {
          return body(self, a, b);
        };
      };
    case 4:
      return function (a, b, c, d) {
        if (arguments.length >= 4) {
          return body(a, b, c, d);
        }
        return function (self) {
          return body(self, a, b, c);
        };
      };
    case 5:
      return function (a, b, c, d, e) {
        if (arguments.length >= 5) {
          return body(a, b, c, d, e);
        }
        return function (self) {
          return body(self, a, b, c, d);
        };
      };
    default:
      return function () {
        if (arguments.length >= arity) {
          // @ts-expect-error
          return body.apply(this, arguments);
        }
        const args = arguments;
        return function (self) {
          return body(self, ...args);
        };
      };
  }
};

/**
 * A lazy argument.
 *
 * @example
 * import { LazyArg, constant } from "effect/Function"
 *
 * export const constNull: LazyArg<null> = constant(null)
 *
 * @since 2.0.0
 */

/**
 * @example
 * import { FunctionN } from "effect/Function"
 *
 * export const sum: FunctionN<[number, number], number> = (a, b) => a + b
 *
 * @since 2.0.0
 */

/**
 * The identity function, i.e. A function that returns its input argument.
 *
 * @param a - The input argument.
 *
 * @example
 * import { identity } from "effect/Function"
 *
 * assert.deepStrictEqual(identity(5), 5)
 *
 * @since 2.0.0
 */
const identity$1 = a => a;

/**
 * Creates a constant value that never changes.
 *
 * This is useful when you want to pass a value to a higher-order function (a function that takes another function as its argument)
 * and want that inner function to always use the same value, no matter how many times it is called.
 *
 * @param value - The constant value to be returned.
 *
 * @example
 * import { constant } from "effect/Function"
 *
 * const constNull = constant(null)
 *
 * assert.deepStrictEqual(constNull(), null)
 * assert.deepStrictEqual(constNull(), null)
 *
 * @since 2.0.0
 */
const constant = value => () => value;

/**
 * A thunk that returns always `true`.
 *
 * @example
 * import { constTrue } from "effect/Function"
 *
 * assert.deepStrictEqual(constTrue(), true)
 *
 * @since 2.0.0
 */
const constTrue = /*#__PURE__*/constant(true);

/**
 * A thunk that returns always `false`.
 *
 * @example
 * import { constFalse } from "effect/Function"
 *
 * assert.deepStrictEqual(constFalse(), false)
 *
 * @since 2.0.0
 */
const constFalse = /*#__PURE__*/constant(false);

/**
 * A thunk that returns always `undefined`.
 *
 * @example
 * import { constUndefined } from "effect/Function"
 *
 * assert.deepStrictEqual(constUndefined(), undefined)
 *
 * @since 2.0.0
 */
const constUndefined = /*#__PURE__*/constant(undefined);

/**
 * A thunk that returns always `void`.
 *
 * @example
 * import { constVoid } from "effect/Function"
 *
 * assert.deepStrictEqual(constVoid(), undefined)
 *
 * @since 2.0.0
 */
const constVoid = constUndefined;

/**
 * Pipes the value of an expression into a pipeline of functions.
 *
 * This is useful in combination with data-last functions as a simulation of methods:
 *
 * ```
 * as.map(f).filter(g) -> pipe(as, map(f), filter(g))
 * ```
 *
 * @example
 * import { pipe } from "effect/Function"
 *
 * const length = (s: string): number => s.length
 * const double = (n: number): number => n * 2
 * const decrement = (n: number): number => n - 1
 *
 * assert.deepStrictEqual(pipe(length("hello"), double, decrement), 9)
 *
 * @since 2.0.0
 */

function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
  switch (arguments.length) {
    case 1:
      return a;
    case 2:
      return ab(a);
    case 3:
      return bc(ab(a));
    case 4:
      return cd(bc(ab(a)));
    case 5:
      return de(cd(bc(ab(a))));
    case 6:
      return ef(de(cd(bc(ab(a)))));
    case 7:
      return fg(ef(de(cd(bc(ab(a))))));
    case 8:
      return gh(fg(ef(de(cd(bc(ab(a)))))));
    case 9:
      return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
    default:
      {
        let ret = arguments[0];
        for (let i = 1; i < arguments.length; i++) {
          ret = arguments[i](ret);
        }
        return ret;
      }
  }
}

/**
 * This module provides an implementation of the `Equivalence` type class, which defines a binary relation
 * that is reflexive, symmetric, and transitive. In other words, it defines a notion of equivalence between values of a certain type.
 * These properties are also known in mathematics as an "equivalence relation".
 *
 * @since 2.0.0
 */

/**
 * @category type class
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * @category constructors
 * @since 2.0.0
 */
const make$16 = isEquivalent => (self, that) => self === that || isEquivalent(self, that);

/**
 * @category combinators
 * @since 2.0.0
 */
const mapInput$6 = /*#__PURE__*/dual(2, (self, f) => make$16((x, y) => self(f(x), f(y))));

/**
 * Creates a new `Equivalence` for an array of values based on a given `Equivalence` for the elements of the array.
 *
 * @category combinators
 * @since 2.0.0
 */
const array$2 = item => make$16((self, that) => {
  if (self.length !== that.length) {
    return false;
  }
  for (let i = 0; i < self.length; i++) {
    const isEq = item(self[i], that[i]);
    if (!isEq) {
      return false;
    }
  }
  return true;
});

/**
 * @since 2.0.0
 */
const globalStoreId = /*#__PURE__*/Symbol.for("effect/GlobalValue/globalStoreId");
if (!(globalStoreId in globalThis)) {
  globalThis[globalStoreId] = /*#__PURE__*/new Map();
}
const globalStore = globalThis[globalStoreId];

/**
 * @since 2.0.0
 */
const globalValue = (id, compute) => {
  if (!globalStore.has(id)) {
    globalStore.set(id, compute());
  }
  return globalStore.get(id);
};

/**
 * Tests if a value is a `number`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isNumber } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNumber(2), true)
 *
 * assert.deepStrictEqual(isNumber("2"), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isNumber = input => typeof input === "number";

/**
 * Tests if a value is a `bigint`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isBigInt } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isBigInt(1n), true)
 *
 * assert.deepStrictEqual(isBigInt(1), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isBigInt = input => typeof input === "bigint";

/**
 * Tests if a value is a `function`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isFunction } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isFunction(isFunction), true)
 *
 * assert.deepStrictEqual(isFunction("function"), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isFunction = isFunction$1;

/**
 * Tests if a value is an `object`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isObject } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isObject({}), true)
 * assert.deepStrictEqual(isObject([]), true)
 *
 * assert.deepStrictEqual(isObject(null), false)
 * assert.deepStrictEqual(isObject(undefined), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isObject = input => typeof input === "object" && input != null || isFunction(input);

/**
 * Tests if a value is an `object` with a property `_tag` that matches the given tag.
 *
 * @param input - The value to test.
 * @param tag - The tag to test for.
 *
 * @example
 * import { isTagged } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isTagged(1, "a"), false)
 * assert.deepStrictEqual(isTagged(null, "a"), false)
 * assert.deepStrictEqual(isTagged({}, "a"), false)
 * assert.deepStrictEqual(isTagged({ a: "a" }, "a"), false)
 * assert.deepStrictEqual(isTagged({ _tag: "a" }, "a"), true)
 * assert.deepStrictEqual(isTagged("a")({ _tag: "a" }), true)
 *
 * @category guards
 * @since 2.0.0
 */
const isTagged = /*#__PURE__*/dual(2, (self, tag) => isObject(self) && "_tag" in self && self["_tag"] === tag);

/**
 * A guard that succeeds when the input is `null` or `undefined`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isNullable } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNullable(null), true)
 * assert.deepStrictEqual(isNullable(undefined), true)
 *
 * assert.deepStrictEqual(isNullable({}), false)
 * assert.deepStrictEqual(isNullable([]), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isNullable = input => input === null || input === undefined;

/**
 * A guard that succeeds when the input is an `Iterable`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isIterable } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isIterable([]), true)
 * assert.deepStrictEqual(isIterable(new Set()), true)
 *
 * assert.deepStrictEqual(isIterable(null), false)
 * assert.deepStrictEqual(isIterable({}), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isIterable = input => isObject(input) && Symbol.iterator in input;

const defaultIncHi = 0x14057b7e;
const defaultIncLo = 0xf767814f;
const MUL_HI = 0x5851f42d >>> 0;
const MUL_LO = 0x4c957f2d >>> 0;
const BIT_53 = 9007199254740992.0;
const BIT_27 = 134217728.0;

/**
 * @category model
 * @since 2.0.0
 */

/**
 * @category model
 * @since 2.0.0
 */

/**
 * PCG is a family of simple fast space-efficient statistically good algorithms
 * for random number generation. Unlike many general-purpose RNGs, they are also
 * hard to predict.
 *
 * @category model
 * @since 2.0.0
 */
class PCGRandom {
  /**
   * Creates an instance of PCGRandom.
   *
   * @param seed - The low 32 bits of the seed (0 is used for high 32 bits).
   *
   * @memberOf PCGRandom
   */

  /**
   * Creates an instance of PCGRandom.
   *
   * @param seedHi - The high 32 bits of the seed.
   * @param seedLo - The low 32 bits of the seed.
   * @param inc - The low 32 bits of the incrementer (0 is used for high 32 bits).
   *
   * @memberOf PCGRandom
   */

  /**
   * Creates an instance of PCGRandom.
   *
   * @param seedHi - The high 32 bits of the seed.
   * @param seedLo - The low 32 bits of the seed.
   * @param incHi - The high 32 bits of the incrementer.
   * @param incLo - The low 32 bits of the incrementer.
   *
   * @memberOf PCGRandom
   */

  constructor(seedHi, seedLo, incHi, incLo) {
    if (isNullable(seedLo) && isNullable(seedHi)) {
      seedLo = Math.random() * 0xffffffff >>> 0;
      seedHi = 0;
    } else if (isNullable(seedLo)) {
      seedLo = seedHi;
      seedHi = 0;
    }
    if (isNullable(incLo) && isNullable(incHi)) {
      incLo = this._state ? this._state[3] : defaultIncLo;
      incHi = this._state ? this._state[2] : defaultIncHi;
    } else if (isNullable(incLo)) {
      incLo = incHi;
      incHi = 0;
    }
    this._state = new Int32Array([0, 0, incHi >>> 0, ((incLo || 0) | 1) >>> 0]);
    this._next();
    add64(this._state, this._state[0], this._state[1], seedHi >>> 0, seedLo >>> 0);
    this._next();
    return this;
  }

  /**
   * Returns a copy of the internal state of this random number generator as a
   * JavaScript Array.
   *
   * @category getters
   * @since 2.0.0
   */
  getState() {
    return [this._state[0], this._state[1], this._state[2], this._state[3]];
  }

  /**
   * Restore state previously retrieved using `getState()`.
   *
   * @since 2.0.0
   */
  setState(state) {
    this._state[0] = state[0];
    this._state[1] = state[1];
    this._state[2] = state[2];
    this._state[3] = state[3] | 1;
  }

  /**
   * Get a uniformly distributed 32 bit integer between [0, max).
   *
   * @category getter
   * @since 2.0.0
   */
  integer(max) {
    if (!max) {
      return this._next();
    }
    max = max >>> 0;
    if ((max & max - 1) === 0) {
      return this._next() & max - 1; // fast path for power of 2
    }

    let num = 0;
    const skew = (-max >>> 0) % max >>> 0;
    for (num = this._next(); num < skew; num = this._next()) {
      // this loop will rarely execute more than twice,
      // and is intentionally empty
    }
    return num % max;
  }

  /**
   * Get a uniformly distributed IEEE-754 double between 0.0 and 1.0, with
   * 53 bits of precision (every bit of the mantissa is randomized).
   *
   * @category getters
   * @since 2.0.0
   */
  number() {
    const hi = (this._next() & 0x03ffffff) * 1.0;
    const lo = (this._next() & 0x07ffffff) * 1.0;
    return (hi * BIT_27 + lo) / BIT_53;
  }

  /** @internal */
  _next() {
    // save current state (what we'll use for this number)
    const oldHi = this._state[0] >>> 0;
    const oldLo = this._state[1] >>> 0;

    // churn LCG.
    mul64(this._state, oldHi, oldLo, MUL_HI, MUL_LO);
    add64(this._state, this._state[0], this._state[1], this._state[2], this._state[3]);

    // get least sig. 32 bits of ((oldstate >> 18) ^ oldstate) >> 27
    let xsHi = oldHi >>> 18;
    let xsLo = (oldLo >>> 18 | oldHi << 14) >>> 0;
    xsHi = (xsHi ^ oldHi) >>> 0;
    xsLo = (xsLo ^ oldLo) >>> 0;
    const xorshifted = (xsLo >>> 27 | xsHi << 5) >>> 0;
    // rotate xorshifted right a random amount, based on the most sig. 5 bits
    // bits of the old state.
    const rot = oldHi >>> 27;
    const rot2 = (-rot >>> 0 & 31) >>> 0;
    return (xorshifted >>> rot | xorshifted << rot2) >>> 0;
  }
}
function mul64(out, aHi, aLo, bHi, bLo) {
  let c1 = (aLo >>> 16) * (bLo & 0xffff) >>> 0;
  let c0 = (aLo & 0xffff) * (bLo >>> 16) >>> 0;
  let lo = (aLo & 0xffff) * (bLo & 0xffff) >>> 0;
  let hi = (aLo >>> 16) * (bLo >>> 16) + ((c0 >>> 16) + (c1 >>> 16)) >>> 0;
  c0 = c0 << 16 >>> 0;
  lo = lo + c0 >>> 0;
  if (lo >>> 0 < c0 >>> 0) {
    hi = hi + 1 >>> 0;
  }
  c1 = c1 << 16 >>> 0;
  lo = lo + c1 >>> 0;
  if (lo >>> 0 < c1 >>> 0) {
    hi = hi + 1 >>> 0;
  }
  hi = hi + Math.imul(aLo, bHi) >>> 0;
  hi = hi + Math.imul(aHi, bLo) >>> 0;
  out[0] = hi;
  out[1] = lo;
}

// add two 64 bit numbers (given in parts), and store the result in `out`.
function add64(out, aHi, aLo, bHi, bLo) {
  let hi = aHi + bHi >>> 0;
  const lo = aLo + bLo >>> 0;
  if (lo >>> 0 < aLo >>> 0) {
    hi = hi + 1 | 0;
  }
  out[0] = hi;
  out[1] = lo;
}

/**
 * @since 2.0.0
 */

/** @internal */
const randomHashCache = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/Hash/randomHashCache"), () => new WeakMap());
/** @internal */
const pcgr = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/Hash/pcgr"), () => new PCGRandom());

/**
 * @since 2.0.0
 * @category symbols
 */
const symbol$1 = /*#__PURE__*/Symbol.for("effect/Hash");

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category hashing
 */
const hash$1 = self => {
  switch (typeof self) {
    case "number":
      {
        return number$2(self);
      }
    case "bigint":
      {
        return string$1(self.toString(10));
      }
    case "boolean":
      {
        return string$1(String(self));
      }
    case "symbol":
      {
        return string$1(String(self));
      }
    case "string":
      {
        return string$1(self);
      }
    case "undefined":
      {
        return string$1("undefined");
      }
    case "function":
    case "object":
      {
        if (self === null) {
          return string$1("null");
        }
        if (isHash(self)) {
          return self[symbol$1]();
        } else {
          return random$2(self);
        }
      }
    default:
      {
        throw new Error("Bug in Equal.hash");
      }
  }
};

/**
 * @since 2.0.0
 * @category hashing
 */
const random$2 = self => {
  if (!randomHashCache.has(self)) {
    randomHashCache.set(self, number$2(pcgr.integer(Number.MAX_SAFE_INTEGER)));
  }
  return randomHashCache.get(self);
};

/**
 * @since 2.0.0
 * @category hashing
 */
const combine$a = b => self => self * 53 ^ b;

/**
 * @since 2.0.0
 * @category hashing
 */
const optimize = n => n & 0xbfffffff | n >>> 1 & 0x40000000;

/**
 * @since 2.0.0
 * @category guards
 */
const isHash = u => typeof u === "object" && u !== null && symbol$1 in u;

/**
 * @since 2.0.0
 * @category hashing
 */
const number$2 = n => {
  if (n !== n || n === Infinity) {
    return 0;
  }
  let h = n | 0;
  if (h !== n) {
    h ^= n * 0xffffffff;
  }
  while (n > 0xffffffff) {
    h ^= n /= 0xffffffff;
  }
  return optimize(n);
};

/**
 * @since 2.0.0
 * @category hashing
 */
const string$1 = str => {
  let h = 5381,
    i = str.length;
  while (i) {
    h = h * 33 ^ str.charCodeAt(--i);
  }
  return optimize(h);
};

/**
 * @since 2.0.0
 * @category hashing
 */
const structureKeys = (o, keys) => {
  let h = 12289;
  for (let i = 0; i < keys.length; i++) {
    h ^= pipe(string$1(keys[i]), combine$a(hash$1(o[keys[i]])));
  }
  return optimize(h);
};

/**
 * @since 2.0.0
 * @category hashing
 */
const structure = o => structureKeys(o, Object.keys(o));

/**
 * @since 2.0.0
 * @category hashing
 */
const array$1 = arr => {
  let h = 6151;
  for (let i = 0; i < arr.length; i++) {
    h = pipe(h, combine$a(hash$1(arr[i])));
  }
  return optimize(h);
};

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const symbol = /*#__PURE__*/Symbol.for("effect/Equal");

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category equality
 */

function equals$1() {
  if (arguments.length === 1) {
    return self => compareBoth(self, arguments[0]);
  }
  return compareBoth(arguments[0], arguments[1]);
}
function compareBoth(self, that) {
  if (self === that) {
    return true;
  }
  const selfType = typeof self;
  if (selfType !== typeof that) {
    return false;
  }
  if ((selfType === "object" || selfType === "function") && self !== null && that !== null) {
    if (isEqual(self) && isEqual(that)) {
      return hash$1(self) === hash$1(that) && self[symbol](that);
    }
  }
  return false;
}

/**
 * @since 2.0.0
 * @category guards
 */
const isEqual = u => typeof u === "object" && u !== null && symbol in u;

/**
 * @since 2.0.0
 * @category instances
 */
const equivalence = () => (self, that) => equals$1(self, that);

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const NodeInspectSymbol = /*#__PURE__*/Symbol.for("nodejs.util.inspect.custom");

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */
const toJSON = x => {
  if (typeof x === "object" && x !== null && "toJSON" in x && typeof x["toJSON"] === "function" && x["toJSON"].length === 0) {
    return x.toJSON();
  } else if (Array.isArray(x)) {
    return x.map(toJSON);
  }
  return x;
};

/**
 * @since 2.0.0
 */
const toString = x => JSON.stringify(x, null, 2);

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */
const pipeArguments = (self, args) => {
  switch (args.length) {
    case 1:
      return args[0](self);
    case 2:
      return args[1](args[0](self));
    case 3:
      return args[2](args[1](args[0](self)));
    case 4:
      return args[3](args[2](args[1](args[0](self))));
    case 5:
      return args[4](args[3](args[2](args[1](args[0](self)))));
    case 6:
      return args[5](args[4](args[3](args[2](args[1](args[0](self))))));
    case 7:
      return args[6](args[5](args[4](args[3](args[2](args[1](args[0](self)))))));
    case 8:
      return args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0](self))))))));
    case 9:
      return args[8](args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0](self)))))))));
    default:
      {
        let ret = self;
        for (let i = 0, len = args.length; i < len; i++) {
          ret = args[i](ret);
        }
        return ret;
      }
  }
};

/** @internal */
const StructProto = {
  [symbol$1]() {
    return structure(this);
  },
  [symbol](that) {
    const selfKeys = Object.keys(this);
    const thatKeys = Object.keys(that);
    if (selfKeys.length !== thatKeys.length) {
      return false;
    }
    for (const key of selfKeys) {
      if (!(key in that && equals$1(this[key], that[key]))) {
        return false;
      }
    }
    return true;
  }
};

/** @internal */
const Structural = /*#__PURE__*/function () {
  function Structural(args) {
    if (args) {
      Object.assign(this, args);
    }
  }
  Structural.prototype = StructProto;
  return Structural;
}();

/** @internal */
const struct$2 = as => Object.assign(Object.create(StructProto), as);

/** @internal */

/** @internal */
const OP_ASYNC = "Async";

/** @internal */

/** @internal */
const OP_COMMIT = "Commit";

/** @internal */

/** @internal */
const OP_FAILURE = "Failure";

/** @internal */

/** @internal */
const OP_ON_FAILURE$1 = "OnFailure";

/** @internal */

/** @internal */
const OP_ON_SUCCESS$1 = "OnSuccess";

/** @internal */

/** @internal */
const OP_ON_SUCCESS_AND_FAILURE = "OnSuccessAndFailure";

/** @internal */

/** @internal */
const OP_SUCCESS = "Success";

/** @internal */

/** @internal */
const OP_SYNC$1 = "Sync";

/** @internal */
const OP_TAG = "Tag";

/** @internal */

/** @internal */

/** @internal */
const OP_UPDATE_RUNTIME_FLAGS = "UpdateRuntimeFlags";

/** @internal */

/** @internal */
const OP_WHILE = "While";

/** @internal */

/** @internal */
const OP_WITH_RUNTIME = "WithRuntime";

/** @internal */

/** @internal */
const OP_YIELD$1 = "Yield";

/** @internal */

/** @internal */
const OP_REVERT_FLAGS = "RevertFlags";

/** @internal */
const EffectTypeId$2 = /*#__PURE__*/Symbol.for("effect/Effect");

/** @internal */
const StreamTypeId$2 = /*#__PURE__*/Symbol.for("effect/Stream");

/** @internal */
const SinkTypeId$1 = /*#__PURE__*/Symbol.for("effect/Sink");

/** @internal */
const ChannelTypeId$1 = /*#__PURE__*/Symbol.for("effect/Channel");

/** @internal */
const effectVariance$1 = {
  _R: _ => _,
  _E: _ => _,
  _A: _ => _
};

/** @internal */
const sinkVariance$1 = {
  _R: _ => _,
  _E: _ => _,
  _In: _ => _,
  _L: _ => _,
  _Z: _ => _
};

/** @internal */
const channelVariance$1 = {
  _Env: _ => _,
  _InErr: _ => _,
  _InElem: _ => _,
  _InDone: _ => _,
  _OutErr: _ => _,
  _OutElem: _ => _,
  _OutDone: _ => _
};

/** @internal */
const EffectPrototype = {
  [EffectTypeId$2]: effectVariance$1,
  [StreamTypeId$2]: effectVariance$1,
  [SinkTypeId$1]: sinkVariance$1,
  [ChannelTypeId$1]: channelVariance$1,
  [symbol](that) {
    return this === that;
  },
  [symbol$1]() {
    return random$2(this);
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const CommitPrototype = {
  ...EffectPrototype,
  _op: OP_COMMIT
};

/** @internal */
const StructuralCommitPrototype$1 = {
  ...CommitPrototype,
  ...Structural.prototype
};

/** @internal */
const Base = /*#__PURE__*/function () {
  function Base() {}
  Base.prototype = CommitPrototype;
  return Base;
}();

/** @internal */
const StructuralBase = /*#__PURE__*/function () {
  function Base() {}
  Base.prototype = StructuralCommitPrototype$1;
  return Base;
}();

/**
 * @since 2.0.0
 */
const TypeId$d = /*#__PURE__*/Symbol.for("effect/Option");
const CommonProto$1 = {
  ...EffectPrototype,
  [TypeId$d]: {
    _A: _ => _
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  toString() {
    return toString(this.toJSON());
  }
};
const SomeProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto$1), {
  _tag: "Some",
  _op: "Some",
  [symbol](that) {
    return isOption(that) && isSome$1(that) && equals$1(that.value, this.value);
  },
  [symbol$1]() {
    return combine$a(hash$1(this._tag))(hash$1(this.value));
  },
  toJSON() {
    return {
      _id: "Option",
      _tag: this._tag,
      value: toJSON(this.value)
    };
  }
});
const NoneProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto$1), {
  _tag: "None",
  _op: "None",
  [symbol](that) {
    return isOption(that) && isNone$2(that);
  },
  [symbol$1]() {
    return combine$a(hash$1(this._tag));
  },
  toJSON() {
    return {
      _id: "Option",
      _tag: this._tag
    };
  }
});

/** @internal */
const isOption = input => typeof input === "object" && input != null && TypeId$d in input;

/** @internal */
const isNone$2 = fa => fa._tag === "None";

/** @internal */
const isSome$1 = fa => fa._tag === "Some";

/** @internal */
const none$9 = /*#__PURE__*/Object.create(NoneProto);

/** @internal */
const some$7 = value => {
  const a = Object.create(SomeProto);
  a.value = value;
  return a;
};

/**
 * @since 2.0.0
 */

/**
 * @internal
 */
const TypeId$c = /*#__PURE__*/Symbol.for("effect/Either");
const CommonProto = {
  ...EffectPrototype,
  [TypeId$c]: {
    _A: _ => _
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  toString() {
    return toString(this.toJSON());
  }
};
const RightProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto), {
  _tag: "Right",
  _op: "Right",
  [symbol](that) {
    return isEither$2(that) && isRight$2(that) && equals$1(that.right, this.right);
  },
  [symbol$1]() {
    return combine$a(hash$1(this._tag))(hash$1(this.right));
  },
  toJSON() {
    return {
      _id: "Either",
      _tag: this._tag,
      right: toJSON(this.right)
    };
  }
});
const LeftProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto), {
  _tag: "Left",
  _op: "Left",
  [symbol](that) {
    return isEither$2(that) && isLeft$2(that) && equals$1(that.left, this.left);
  },
  [symbol$1]() {
    return combine$a(hash$1(this._tag))(hash$1(this.left));
  },
  toJSON() {
    return {
      _id: "Either",
      _tag: this._tag,
      left: toJSON(this.left)
    };
  }
});

/** @internal */
const isEither$2 = input => typeof input === "object" && input != null && TypeId$c in input;

/** @internal */
const isLeft$2 = ma => ma._tag === "Left";

/** @internal */
const isRight$2 = ma => ma._tag === "Right";

/** @internal */
const left$1 = left => {
  const a = Object.create(LeftProto);
  a.left = left;
  return a;
};

/** @internal */
const right$1 = right => {
  const a = Object.create(RightProto);
  a.right = right;
  return a;
};

/** @internal */
const getLeft = self => isRight$2(self) ? none$9 : some$7(self.left);

/** @internal */
const getRight = self => isLeft$2(self) ? none$9 : some$7(self.right);

/** @internal */
const fromOption$2 = /*#__PURE__*/dual(2, (self, onNone) => isNone$2(self) ? left$1(onNone()) : right$1(self.value));

/**
 * @since 2.0.0
 */

/**
 * @category type class
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * @category constructors
 * @since 2.0.0
 */
const make$15 = compare => (self, that) => self === that ? 0 : compare(self, that);

/**
 * @category instances
 * @since 2.0.0
 */
const number$1 = /*#__PURE__*/make$15((self, that) => self < that ? -1 : 1);

/**
 * @category combinators
 * @since 2.0.0
 */
const mapInput$5 = /*#__PURE__*/dual(2, (self, f) => make$15((b1, b2) => self(f(b1), f(b2))));

/**
 * @category combining
 * @since 2.0.0
 */
const all$6 = collection => {
  return make$15((x, y) => {
    const len = Math.min(x.length, y.length);
    let collectionLength = 0;
    for (const O of collection) {
      if (collectionLength >= len) {
        break;
      }
      const o = O(x[collectionLength], y[collectionLength]);
      if (o !== 0) {
        return o;
      }
      collectionLength++;
    }
    return 0;
  });
};

/**
 * Similar to `Promise.all` but operates on `Order`s.
 *
 * ```
 * [Order<A>, Order<B>, ...] -> Order<[A, B, ...]>
 * ```
 *
 * This function creates and returns a new `Order` for a tuple of values based on the given `Order`s for each element in the tuple.
 * The returned `Order` compares two tuples of the same type by applying the corresponding `Order` to each element in the tuple.
 * It is useful when you need to compare two tuples of the same type and you have a specific way of comparing each element
 * of the tuple.
 *
 * @category combinators
 * @since 2.0.0
 */
const tuple$1 = (...elements) => all$6(elements);

/**
 * Test whether one value is _strictly less than_ another.
 *
 * @since 2.0.0
 */
const lessThan$6 = O => dual(2, (self, that) => O(self, that) === -1);

/**
 * Test whether one value is _strictly greater than_ another.
 *
 * @since 2.0.0
 */
const greaterThan$3 = O => dual(2, (self, that) => O(self, that) === 1);

/**
 * @category symbols
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * Creates a new `Option` that represents the absence of a value.
 *
 * @category constructors
 * @since 2.0.0
 */
const none$8 = () => none$9;

/**
 * Creates a new `Option` that wraps the given value.
 *
 * @param value - The value to wrap.
 *
 * @category constructors
 * @since 2.0.0
 */
const some$6 = some$7;

/**
 * Tests if a value is a `Option`.
 *
 * @param input - The value to check.
 *
 * @example
 * import { some, none, isOption } from 'effect/Option'
 *
 * assert.deepStrictEqual(isOption(some(1)), true)
 * assert.deepStrictEqual(isOption(none()), true)
 * assert.deepStrictEqual(isOption({}), false)
 *
 * @category guards
 * @since 2.0.0
 */
isOption;

/**
 * Determine if a `Option` is a `None`.
 *
 * @param self - The `Option` to check.
 *
 * @example
 * import { some, none, isNone } from 'effect/Option'
 *
 * assert.deepStrictEqual(isNone(some(1)), false)
 * assert.deepStrictEqual(isNone(none()), true)
 *
 * @category guards
 * @since 2.0.0
 */
const isNone$1 = isNone$2;

/**
 * Determine if a `Option` is a `Some`.
 *
 * @param self - The `Option` to check.
 *
 * @example
 * import { some, none, isSome } from 'effect/Option'
 *
 * assert.deepStrictEqual(isSome(some(1)), true)
 * assert.deepStrictEqual(isSome(none()), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isSome = isSome$1;

/**
 * Matches the given `Option` and returns either the provided `onNone` value or the result of the provided `onSome`
 * function when passed the `Option`'s value.
 *
 * @param self - The `Option` to match
 * @param onNone - The value to be returned if the `Option` is `None`
 * @param onSome - The function to be called if the `Option` is `Some`, it will be passed the `Option`'s value and its result will be returned
 *
 * @example
 * import { some, none, match } from 'effect/Option'
 * import { pipe } from "effect/Function"
 *
 * assert.deepStrictEqual(
 *   pipe(some(1), match({ onNone: () => 'a none', onSome: (a) => `a some containing ${a}` })),
 *   'a some containing 1'
 * )
 *
 * assert.deepStrictEqual(
 *   pipe(none(), match({ onNone: () => 'a none', onSome: (a) => `a some containing ${a}` })),
 *   'a none'
 * )
 *
 * @category pattern matching
 * @since 2.0.0
 */
const match$j = /*#__PURE__*/dual(2, (self, {
  onNone,
  onSome
}) => isNone$1(self) ? onNone() : onSome(self.value));

/**
 * Converts a `Either` to an `Option` discarding the error.
 *
 * Alias of {@link fromEither}.
 *
 * @example
 * import * as O from "effect/Option"
 * import * as E from "effect/Either"
 *
 * assert.deepStrictEqual(O.getRight(E.right('ok')), O.some('ok'))
 * assert.deepStrictEqual(O.getRight(E.left('err')), O.none())
 *
 * @category conversions
 * @since 2.0.0
 */
getRight;

/**
 * Converts a `Either` to an `Option` discarding the value.
 *
 * @example
 * import * as O from "effect/Option"
 * import * as E from "effect/Either"
 *
 * assert.deepStrictEqual(O.getLeft(E.right("ok")), O.none())
 * assert.deepStrictEqual(O.getLeft(E.left("a")), O.some("a"))
 *
 * @category conversions
 * @since 2.0.0
 */
getLeft;

/**
 * Returns the value of the `Option` if it is `Some`, otherwise returns `onNone`
 *
 * @param self - The `Option` to get the value of.
 * @param onNone - Function that returns the default value to return if the `Option` is `None`.
 *
 * @example
 * import { some, none, getOrElse } from 'effect/Option'
 * import { pipe } from "effect/Function"
 *
 * assert.deepStrictEqual(pipe(some(1), getOrElse(() => 0)), 1)
 * assert.deepStrictEqual(pipe(none(), getOrElse(() => 0)), 0)
 *
 * @category getters
 * @since 2.0.0
 */
const getOrElse$3 = /*#__PURE__*/dual(2, (self, onNone) => isNone$1(self) ? onNone() : self.value);

/**
 * Returns the provided `Option` `that` if `self` is `None`, otherwise returns `self`.
 *
 * @param self - The first `Option` to be checked.
 * @param that - The `Option` to return if `self` is `None`.
 *
 * @example
 * import * as O from "effect/Option"
 * import { pipe } from "effect/Function"
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     O.none(),
 *     O.orElse(() => O.none())
 *   ),
 *   O.none()
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     O.some('a'),
 *     O.orElse(() => O.none())
 *   ),
 *   O.some('a')
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     O.none(),
 *     O.orElse(() => O.some('b'))
 *   ),
 *   O.some('b')
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     O.some('a'),
 *     O.orElse(() => O.some('b'))
 *   ),
 *   O.some('a')
 * )
 *
 * @category error handling
 * @since 2.0.0
 */
const orElse$b = /*#__PURE__*/dual(2, (self, that) => isNone$1(self) ? that() : self);

/**
 * Constructs a new `Option` from a nullable type. If the value is `null` or `undefined`, returns `None`, otherwise
 * returns the value wrapped in a `Some`.
 *
 * @param nullableValue - The nullable value to be converted to an `Option`.
 *
 * @example
 * import * as O from "effect/Option"
 *
 * assert.deepStrictEqual(O.fromNullable(undefined), O.none())
 * assert.deepStrictEqual(O.fromNullable(null), O.none())
 * assert.deepStrictEqual(O.fromNullable(1), O.some(1))
 *
 * @category conversions
 * @since 2.0.0
 */
const fromNullable$2 = nullableValue => nullableValue == null ? none$8() : some$6(nullableValue);

/**
 * Returns the value of the `Option` if it is a `Some`, otherwise returns `undefined`.
 *
 * @param self - The `Option` to extract the value from.
 *
 * @example
 * import * as O from "effect/Option"
 *
 * assert.deepStrictEqual(O.getOrUndefined(O.some(1)), 1)
 * assert.deepStrictEqual(O.getOrUndefined(O.none()), undefined)
 *
 * @category getters
 * @since 2.0.0
 */
const getOrUndefined = /*#__PURE__*/getOrElse$3(constUndefined);

/**
 * Extracts the value of an `Option` or throws if the `Option` is `None`.
 *
 * If a default error is sufficient for your use case and you don't need to configure the thrown error, see {@link getOrThrow}.
 *
 * @param self - The `Option` to extract the value from.
 * @param onNone - A function that will be called if the `Option` is `None`. It returns the error to be thrown.
 *
 * @example
 * import * as O from "effect/Option"
 *
 * assert.deepStrictEqual(
 *   O.getOrThrowWith(O.some(1), () => new Error('Unexpected None')),
 *   1
 * )
 * assert.throws(() => O.getOrThrowWith(O.none(), () => new Error('Unexpected None')))
 *
 * @category conversions
 * @since 2.0.0
 */
const getOrThrowWith = /*#__PURE__*/dual(2, (self, onNone) => {
  if (isSome(self)) {
    return self.value;
  }
  throw onNone();
});

/**
 * Extracts the value of an `Option` or throws if the `Option` is `None`.
 *
 * The thrown error is a default error. To configure the error thrown, see  {@link getOrThrowWith}.
 *
 * @param self - The `Option` to extract the value from.
 * @throws `Error("getOrThrow called on a None")`
 *
 * @example
 * import * as O from "effect/Option"
 *
 * assert.deepStrictEqual(O.getOrThrow(O.some(1)), 1)
 * assert.throws(() => O.getOrThrow(O.none()))
 *
 * @category conversions
 * @since 2.0.0
 */
const getOrThrow = /*#__PURE__*/getOrThrowWith(() => new Error("getOrThrow called on a None"));

/**
 * Maps the `Some` side of an `Option` value to a new `Option` value.
 *
 * @param self - An `Option` to map
 * @param f - The function to map over the value of the `Option`
 *
 * @category transforming
 * @since 2.0.0
 */
const map$n = /*#__PURE__*/dual(2, (self, f) => isNone$1(self) ? none$8() : some$6(f(self.value)));

/**
 * Applies a function to the value of an `Option` and flattens the result, if the input is `Some`.
 *
 * @category transforming
 * @since 2.0.0
 */
const flatMap$d = /*#__PURE__*/dual(2, (self, f) => isNone$1(self) ? none$8() : f(self.value));

/**
 * Takes a structure of `Option`s and returns an `Option` of values with the same structure.
 *
 * - If a tuple is supplied, then the returned `Option` will contain a tuple with the same length.
 * - If a struct is supplied, then the returned `Option` will contain a struct with the same keys.
 * - If an iterable is supplied, then the returned `Option` will contain an array.
 *
 * @param fields - the struct of `Option`s to be sequenced.
 *
 * @example
 * import * as O from "effect/Option"
 *
 * assert.deepStrictEqual(O.all([O.some(1), O.some(2)]), O.some([1, 2]))
 * assert.deepStrictEqual(O.all({ a: O.some(1), b: O.some("hello") }), O.some({ a: 1, b: "hello" }))
 * assert.deepStrictEqual(O.all({ a: O.some(1), b: O.none() }), O.none())
 *
 * @category combining
 * @since 2.0.0
 */
// @ts-expect-error
const all$5 = input => {
  if (Symbol.iterator in input) {
    const out = [];
    for (const o of input) {
      if (isNone$1(o)) {
        return none$8();
      }
      out.push(o.value);
    }
    return some$6(out);
  }
  const out = {};
  for (const key of Object.keys(input)) {
    const o = input[key];
    if (isNone$1(o)) {
      return none$8();
    }
    out[key] = o.value;
  }
  return some$6(out);
};

/**
 * Transforms a `Predicate` function into a `Some` of the input value if the predicate returns `true` or `None`
 * if the predicate returns `false`.
 *
 * @param predicate - A `Predicate` function that takes in a value of type `A` and returns a boolean.
 *
 * @example
 * import * as O from "effect/Option"
 *
 * const getOption = O.liftPredicate((n: number) => n >= 0)
 *
 * assert.deepStrictEqual(getOption(-1), O.none())
 * assert.deepStrictEqual(getOption(1), O.some(1))
 *
 * @category lifting
 * @since 2.0.0
 */
const liftPredicate = predicate => b => predicate(b) ? some$6(b) : none$8();

/**
 * Returns a function that checks if a `Option` contains a given value using a provided `isEquivalent` function.
 *
 * @param equivalent - An `Equivalence` instance to compare values of the `Option`.
 * @param self - The `Option` to apply the comparison to.
 * @param a - The value to compare against the `Option`.
 *
 * @example
 * import { some, none, containsWith } from 'effect/Option'
 * import { Equivalence } from 'effect/Number'
 * import { pipe } from "effect/Function"
 *
 * assert.deepStrictEqual(pipe(some(2), containsWith(Equivalence)(2)), true)
 * assert.deepStrictEqual(pipe(some(1), containsWith(Equivalence)(2)), false)
 * assert.deepStrictEqual(pipe(none(), containsWith(Equivalence)(2)), false)
 *
 * @category elements
 * @since 2.0.0
 */
const containsWith = isEquivalent => dual(2, (self, a) => isNone$1(self) ? false : isEquivalent(self.value, a));
const _equivalence$2 = /*#__PURE__*/equivalence();

/**
 * Returns a function that checks if an `Option` contains a given value using the default `Equivalence`.
 *
 * @category elements
 * @since 2.0.0
 */
const contains$2 = /*#__PURE__*/containsWith(_equivalence$2);

/**
 * Negates the given boolean: `!self`
 *
 * @example
 * import { not } from 'effect/Boolean'
 *
 * assert.deepStrictEqual(not(true), false)
 * assert.deepStrictEqual(not(false), true)
 *
 * @category combinators
 * @since 2.0.0
 */
const not$1 = self => !self;

/**
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category symbols
 * @since 2.0.0
 */
TypeId$c;

/**
 * @category symbols
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
 * of this structure.
 *
 * @category constructors
 * @since 2.0.0
 */
const right = right$1;

/**
 * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
 * structure.
 *
 * @category constructors
 * @since 2.0.0
 */
const left = left$1;

/**
 * @example
 * import * as Either from 'effect/Either'
 * import * as Option from 'effect/Option'
 *
 * assert.deepStrictEqual(Either.fromOption(Option.some(1), () => 'error'), Either.right(1))
 * assert.deepStrictEqual(Either.fromOption(Option.none(), () => 'error'), Either.left('error'))
 *
 * @category constructors
 * @since 2.0.0
 */
fromOption$2;

/**
 * Tests if a value is a `Either`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isEither, left, right } from 'effect/Either'
 *
 * assert.deepStrictEqual(isEither(right(1)), true)
 * assert.deepStrictEqual(isEither(left("a")), true)
 * assert.deepStrictEqual(isEither({ right: 1 }), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isEither$1 = isEither$2;

/**
 * Determine if a `Either` is a `Left`.
 *
 * @param self - The `Either` to check.
 *
 * @example
 * import { isLeft, left, right } from 'effect/Either'
 *
 * assert.deepStrictEqual(isLeft(right(1)), false)
 * assert.deepStrictEqual(isLeft(left("a")), true)
 *
 * @category guards
 * @since 2.0.0
 */
const isLeft$1 = isLeft$2;

/**
 * Determine if a `Either` is a `Right`.
 *
 * @param self - The `Either` to check.
 *
 * @example
 * import { isRight, left, right } from 'effect/Either'
 *
 * assert.deepStrictEqual(isRight(right(1)), true)
 * assert.deepStrictEqual(isRight(left("a")), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isRight$1 = isRight$2;

/**
 * Converts a `Either` to an `Option` discarding the `Left`.
 *
 * Alias of {@link toOption}.
 *
 * @example
 * import * as O from 'effect/Option'
 * import * as E from 'effect/Either'
 *
 * assert.deepStrictEqual(E.getRight(E.right('ok')), O.some('ok'))
 * assert.deepStrictEqual(E.getRight(E.left('err')), O.none())
 *
 * @category getters
 * @since 2.0.0
 */
getRight;

/**
 * Converts a `Either` to an `Option` discarding the value.
 *
 * @example
 * import * as O from 'effect/Option'
 * import * as E from 'effect/Either'
 *
 * assert.deepStrictEqual(E.getLeft(E.right('ok')), O.none())
 * assert.deepStrictEqual(E.getLeft(E.left('err')), O.some('err'))
 *
 * @category getters
 * @since 2.0.0
 */
getLeft;

/**
 * Takes two functions and an `Either` value, if the value is a `Left` the inner value is applied to the `onLeft function,
 * if the value is a `Right` the inner value is applied to the `onRight` function.
 *
 * @example
 * import * as E from 'effect/Either'
 * import { pipe } from 'effect/Function'
 *
 * const onLeft  = (strings: ReadonlyArray<string>): string => `strings: ${strings.join(', ')}`
 *
 * const onRight = (value: number): string => `Ok: ${value}`
 *
 * assert.deepStrictEqual(pipe(E.right(1), E.match({ onLeft, onRight })), 'Ok: 1')
 * assert.deepStrictEqual(
 *   pipe(E.left(['string 1', 'string 2']), E.match({ onLeft, onRight })),
 *   'strings: string 1, string 2'
 * )
 *
 * @category pattern matching
 * @since 2.0.0
 */
const match$i = /*#__PURE__*/dual(2, (self, {
  onLeft,
  onRight
}) => isLeft$1(self) ? onLeft(self.left) : onRight(self.right));

/**
 * @category getters
 * @since 2.0.0
 */
const merge$a = /*#__PURE__*/match$i({
  onLeft: identity$1,
  onRight: identity$1
});

/**
 * @since 2.0.0
 */

/** @internal */
const isNonEmptyArray$1 = self => self.length > 0;

/**
 * This module provides utility functions for working with arrays in TypeScript.
 *
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * Builds a `NonEmptyArray` from an non-empty collection of elements.
 *
 * @category constructors
 * @since 2.0.0
 */
const make$14 = (...elements) => elements;

/**
 * Return a `NonEmptyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to an integer >= 1.
 *
 * @example
 * import { makeBy } from 'effect/ReadonlyArray'
 *
 * assert.deepStrictEqual(makeBy(5, n => n * 2), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.0.0
 */
const makeBy$1 = (n, f) => {
  const max = Math.max(1, Math.floor(n));
  const out = [f(0)];
  for (let i = 1; i < max; i++) {
    out.push(f(i));
  }
  return out;
};

/**
 * @category conversions
 * @since 2.0.0
 */
const fromIterable$c = collection => Array.isArray(collection) ? collection : Array.from(collection);

/**
 * Prepend an element to the front of an `Iterable`, creating a new `NonEmptyArray`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prepend$3 = /*#__PURE__*/dual(2, (self, head) => [head, ...self]);

/**
 * Append an element to the end of an `Iterable`, creating a new `NonEmptyArray`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const append$2 = /*#__PURE__*/dual(2, (self, last) => [...self, last]);

/**
 * Determine if an `Array` is empty narrowing down the type to `[]`.
 *
 * @param self - The `Array` to check.
 *
 * @example
 * import { isEmptyArray } from "effect/ReadonlyArray"
 *
 * assert.deepStrictEqual(isEmptyArray([]), true);
 * assert.deepStrictEqual(isEmptyArray([1, 2, 3]), false);
 *
 * @category guards
 * @since 2.0.0
 */
const isEmptyArray = self => self.length === 0;

/**
 * Determine if a `ReadonlyArray` is empty narrowing down the type to `readonly []`.
 *
 * @param self - The `ReadonlyArray` to check.
 *
 * @example
 * import { isEmptyReadonlyArray } from "effect/ReadonlyArray"
 *
 * assert.deepStrictEqual(isEmptyReadonlyArray([]), true);
 * assert.deepStrictEqual(isEmptyReadonlyArray([1, 2, 3]), false);
 *
 * @category guards
 * @since 2.0.0
 */
const isEmptyReadonlyArray = isEmptyArray;

/**
 * Determine if an `Array` is non empty narrowing down the type to `NonEmptyArray`.
 *
 * An `Array` is considered to be a `NonEmptyArray` if it contains at least one element.
 *
 * @param self - The `Array` to check.
 *
 * @example
 * import { isNonEmptyArray } from "effect/ReadonlyArray"
 *
 * assert.deepStrictEqual(isNonEmptyArray([]), false);
 * assert.deepStrictEqual(isNonEmptyArray([1, 2, 3]), true);
 *
 * @category guards
 * @since 2.0.0
 */
const isNonEmptyArray = isNonEmptyArray$1;

/**
 * Determine if a `ReadonlyArray` is non empty narrowing down the type to `NonEmptyReadonlyArray`.
 *
 * A `ReadonlyArray` is considered to be a `NonEmptyReadonlyArray` if it contains at least one element.
 *
 * @param self - The `ReadonlyArray` to check.
 *
 * @example
 * import { isNonEmptyReadonlyArray } from "effect/ReadonlyArray"
 *
 * assert.deepStrictEqual(isNonEmptyReadonlyArray([]), false);
 * assert.deepStrictEqual(isNonEmptyReadonlyArray([1, 2, 3]), true);
 *
 * @category guards
 * @since 2.0.0
 */
const isNonEmptyReadonlyArray = isNonEmptyArray$1;
const isOutOfBound = (i, as) => i < 0 || i >= as.length;

/**
 * This function provides a safe way to read a value at a particular index from a `ReadonlyArray`.
 *
 * @category getters
 * @since 2.0.0
 */
const get$l = /*#__PURE__*/dual(2, (self, index) => {
  const i = Math.floor(index);
  return isOutOfBound(i, self) ? none$8() : some$6(self[i]);
});

/**
 * Gets an element unsafely, will throw on out of bounds.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet$8 = /*#__PURE__*/dual(2, (self, index) => {
  const i = Math.floor(index);
  if (isOutOfBound(i, self)) {
    throw new Error(`Index ${i} out of bounds`);
  }
  return self[i];
});

/**
 * Get the first element of a `ReadonlyArray`, or `None` if the `ReadonlyArray` is empty.
 *
 * @category getters
 * @since 2.0.0
 */
const head$5 = /*#__PURE__*/get$l(0);

/**
 * @category getters
 * @since 2.0.0
 */
const headNonEmpty$1 = /*#__PURE__*/unsafeGet$8(0);

/**
 * Get the last element in a `ReadonlyArray`, or `None` if the `ReadonlyArray` is empty.
 *
 * @category getters
 * @since 2.0.0
 */
const last$3 = self => isNonEmptyReadonlyArray(self) ? some$6(lastNonEmpty(self)) : none$8();

/**
 * @category getters
 * @since 2.0.0
 */
const lastNonEmpty = self => self[self.length - 1];

/**
 * @category getters
 * @since 2.0.0
 */
const tailNonEmpty$1 = self => self.slice(1);
const spanIndex = (self, predicate) => {
  let i = 0;
  for (const a of self) {
    if (!predicate(a)) {
      break;
    }
    i++;
  }
  return i;
};

/**
 * Split an `Iterable` into two parts:
 *
 * 1. the longest initial subarray for which all elements satisfy the specified predicate
 * 2. the remaining elements
 *
 * @category filtering
 * @since 2.0.0
 */
const span$1 = /*#__PURE__*/dual(2, (self, predicate) => splitAt$1(self, spanIndex(self, predicate)));

/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst$7 = /*#__PURE__*/dual(2, (self, predicate) => {
  const input = fromIterable$c(self);
  for (let i = 0; i < input.length; i++) {
    if (predicate(input[i])) {
      return some$6(input[i]);
    }
  }
  return none$8();
});

/**
 * Reverse an `Iterable`, creating a new `Array`.
 *
 * @category elements
 * @since 2.0.0
 */
const reverse$2 = self => Array.from(self).reverse();

/**
 * Sort the elements of an `Iterable` in increasing order, creating a new `Array`.
 *
 * @category sorting
 * @since 2.0.0
 */
const sort$1 = /*#__PURE__*/dual(2, (self, O) => {
  const out = Array.from(self);
  out.sort(O);
  return out;
});

/**
 * Takes two `Iterable`s and returns an `Array` of corresponding pairs.
 * If one input `Iterable` is short, excess elements of the
 * longer `Iterable` are discarded.
 *
 * @since 2.0.0
 */
const zip$c = /*#__PURE__*/dual(2, (self, that) => zipWith$9(self, that, (a, b) => [a, b]));

/**
 * Apply a function to pairs of elements at the same index in two `Iterable`s, collecting the results in a new `Array`. If one
 * input `Iterable` is short, excess elements of the longer `Iterable` are discarded.
 *
 * @since 2.0.0
 */
const zipWith$9 = /*#__PURE__*/dual(3, (self, that, f) => {
  const as = fromIterable$c(self);
  const bs = fromIterable$c(that);
  return isNonEmptyReadonlyArray(as) && isNonEmptyReadonlyArray(bs) ? zipNonEmptyWith(bs, f)(as) : [];
});

/**
 * @since 2.0.0
 */
const zipNonEmptyWith = /*#__PURE__*/dual(3, (self, that, f) => {
  const cs = [f(headNonEmpty$1(self), headNonEmpty$1(that))];
  const len = Math.min(self.length, that.length);
  for (let i = 1; i < len; i++) {
    cs[i] = f(self[i], that[i]);
  }
  return cs;
});

/**
 * Remove duplicates from a `NonEmptyReadonlyArray`, keeping the first occurrence of an element using the provided `isEquivalent` function.
 *
 * @since 2.0.0
 */
const dedupeNonEmptyWith = /*#__PURE__*/dual(2, (self, isEquivalent) => {
  const out = [headNonEmpty$1(self)];
  const rest = tailNonEmpty$1(self);
  for (const a of rest) {
    if (out.every(o => !isEquivalent(a, o))) {
      out.push(a);
    }
  }
  return out;
});

/**
 * Splits an `Iterable` into two pieces, the first piece has max `n` elements.
 *
 * @category getters
 * @since 2.0.0
 */
const splitAt$1 = /*#__PURE__*/dual(2, (self, n) => {
  const input = Array.from(self);
  return n >= 1 && isNonEmptyReadonlyArray(input) ? splitNonEmptyAt(input, n) : isEmptyReadonlyArray(input) ? [input, []] : [[], input];
});

/**
 * @since 2.0.0
 */
const copy$2 = self => self.slice();

/**
 * Splits a `NonEmptyReadonlyArray` into two pieces, the first piece has max `n` elements.
 *
 * @category getters
 * @since 2.0.0
 */
const splitNonEmptyAt = /*#__PURE__*/dual(2, (self, n) => {
  const m = Math.max(1, n);
  return m >= self.length ? [copy$2(self), []] : [prepend$3(self.slice(1, m), headNonEmpty$1(self)), self.slice(m)];
});

/**
 * @category constructors
 * @since 2.0.0
 */
const empty$C = () => [];

/**
 * Constructs a new `NonEmptyArray<A>` from the specified value.
 *
 * @category constructors
 * @since 2.0.0
 */
const of$4 = a => [a];

/**
 * @category mapping
 * @since 2.0.0
 */
const map$m = /*#__PURE__*/dual(2, (self, f) => self.map(f));

/**
 * @category sequencing
 * @since 2.0.0
 */
const flatMap$c = /*#__PURE__*/dual(2, (self, f) => {
  if (isEmptyReadonlyArray(self)) {
    return [];
  }
  const out = [];
  for (let i = 0; i < self.length; i++) {
    out.push(...f(self[i], i));
  }
  return out;
});

/**
 * @category sequencing
 * @since 2.0.0
 */
const flatten$a = /*#__PURE__*/flatMap$c(identity$1);

/**
 * @category filtering
 * @since 2.0.0
 */
const filterMap$3 = /*#__PURE__*/dual(2, (self, f) => {
  const as = fromIterable$c(self);
  const out = [];
  for (let i = 0; i < as.length; i++) {
    const o = f(as[i], i);
    if (isSome(o)) {
      out.push(o.value);
    }
  }
  return out;
});

/**
 * Transforms all elements of the `readonlyArray` for as long as the specified function returns some value
 *
 * @category filtering
 * @since 2.0.0
 */
const filterMapWhile$2 = /*#__PURE__*/dual(2, (self, f) => {
  const out = [];
  for (const a of self) {
    const b = f(a);
    if (isSome(b)) {
      out.push(b.value);
    } else {
      break;
    }
  }
  return out;
});

/**
 * @category filtering
 * @since 2.0.0
 */
const partitionMap$1 = /*#__PURE__*/dual(2, (self, f) => {
  const left = [];
  const right = [];
  const as = fromIterable$c(self);
  for (let i = 0; i < as.length; i++) {
    const e = f(as[i], i);
    if (isLeft$1(e)) {
      left.push(e.left);
    } else {
      right.push(e.right);
    }
  }
  return [left, right];
});

/**
 * @category filtering
 * @since 2.0.0
 */
const compact$1 = /*#__PURE__*/filterMap$3(identity$1);

/**
 * @category filtering
 * @since 2.0.0
 */
const filter$a = /*#__PURE__*/dual(2, (self, predicate) => {
  const as = fromIterable$c(self);
  const out = [];
  for (let i = 0; i < as.length; i++) {
    if (predicate(as[i], i)) {
      out.push(as[i]);
    }
  }
  return out;
});

/**
 * @category filtering
 * @since 2.0.0
 */
const partition$6 = /*#__PURE__*/dual(2, (self, predicate) => {
  const left = [];
  const right = [];
  const as = fromIterable$c(self);
  for (let i = 0; i < as.length; i++) {
    if (predicate(as[i], i)) {
      right.push(as[i]);
    } else {
      left.push(as[i]);
    }
  }
  return [left, right];
});

/**
 * @category folding
 * @since 2.0.0
 */
const reduce$i = /*#__PURE__*/dual(3, (self, b, f) => fromIterable$c(self).reduce((b, a, i) => f(b, a, i), b));

/**
 * @category folding
 * @since 2.0.0
 */
const reduceRight$4 = /*#__PURE__*/dual(3, (self, b, f) => fromIterable$c(self).reduceRight((b, a, i) => f(b, a, i), b));

/**
 * Check if a predicate holds true for every `ReadonlyArray` element.
 *
 * @category elements
 * @since 2.0.0
 */
const every$7 = /*#__PURE__*/dual(2, (self, refinement) => self.every(refinement));

/**
 * @category constructors
 * @since 2.0.0
 */
const unfold$2 = (b, f) => {
  const out = [];
  let next = b;
  let o;
  while (isSome(o = f(next))) {
    const [a, b] = o.value;
    out.push(a);
    next = b;
  }
  return out;
};

/**
 * @category instances
 * @since 2.0.0
 */
const getEquivalence$2 = array$2;

/**
 * Iterate over the `Iterable` applying `f`.
 *
 * @since 2.0.0
 */
const forEach$c = /*#__PURE__*/dual(2, (self, f) => fromIterable$c(self).forEach((a, i) => f(a, i)));

/**
 * Remove duplicates from am `Iterable` using the provided `isEquivalent` function, keeping the first occurrence of an element.
 *
 * @since 2.0.0
 */
const dedupeWith = /*#__PURE__*/dual(2, (self, isEquivalent) => {
  const input = fromIterable$c(self);
  return isNonEmptyReadonlyArray(input) ? dedupeNonEmptyWith(isEquivalent)(input) : [];
});

/**
 * Remove duplicates from am `Iterable`, keeping the first occurrence of an element.
 *
 * @since 2.0.0
 */
const dedupe$1 = /*#__PURE__*/dedupeWith( /*#__PURE__*/equivalence());

/**
 * Joins the elements together with "sep" in the middle.
 *
 * @since 2.0.0
 * @category folding
 */
const join$2 = /*#__PURE__*/dual(2, (self, sep) => fromIterable$c(self).join(sep));

/**
 * Statefully maps over the chunk, producing new elements of type `B`.
 *
 * @since 2.0.0
 * @category folding
 */
const mapAccum$4 = /*#__PURE__*/dual(3, (self, s, f) => {
  let s1 = s;
  const out = [];
  for (const a of self) {
    const r = f(s1, a);
    s1 = r[0];
    out.push(r[1]);
  }
  return [s1, out];
});

/** @internal */
const TagTypeId = /*#__PURE__*/Symbol.for("effect/Context/Tag");

/** @internal */
const STMSymbolKey$1 = "effect/STM";

/** @internal */
const STMTypeId$1 = /*#__PURE__*/Symbol.for(STMSymbolKey$1);

/** @internal */
const TagProto = {
  ...EffectPrototype,
  _tag: "Tag",
  _op: "Tag",
  [STMTypeId$1]: effectVariance$1,
  [TagTypeId]: {
    _S: _ => _,
    _I: _ => _
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "Tag",
      identifier: this.identifier,
      stack: this.stack
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  of(self) {
    return self;
  },
  context(self) {
    return make$13(this, self);
  }
};
const tagRegistry = /*#__PURE__*/globalValue("effect/Context/Tag/tagRegistry", () => new Map());

/** @internal */
const makeTag = identifier => {
  if (identifier && tagRegistry.has(identifier)) {
    return tagRegistry.get(identifier);
  }
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 2;
  const creationError = new Error();
  Error.stackTraceLimit = limit;
  const tag = Object.create(TagProto);
  Object.defineProperty(tag, "stack", {
    get() {
      return creationError.stack;
    }
  });
  if (identifier) {
    tag.identifier = identifier;
    tagRegistry.set(identifier, tag);
  }
  return tag;
};

/** @internal */
const TypeId$b = /*#__PURE__*/Symbol.for("effect/Context");

/** @internal */
const ContextProto = {
  [TypeId$b]: {
    _S: _ => _
  },
  [symbol](that) {
    if (isContext$1(that)) {
      if (this.unsafeMap.size === that.unsafeMap.size) {
        for (const k of this.unsafeMap.keys()) {
          if (!that.unsafeMap.has(k) || !equals$1(this.unsafeMap.get(k), that.unsafeMap.get(k))) {
            return false;
          }
        }
        return true;
      }
    }
    return false;
  },
  [symbol$1]() {
    return number$2(this.unsafeMap.size);
  },
  pipe() {
    return pipeArguments(this, arguments);
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "Context",
      services: Array.from(this.unsafeMap).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
};

/** @internal */
const makeContext = unsafeMap => {
  const context = Object.create(ContextProto);
  context.unsafeMap = unsafeMap;
  return context;
};
const serviceNotFoundError = tag => {
  const error = new Error(`Service not found${tag.identifier ? `: ${String(tag.identifier)}` : ""}`);
  if (tag.stack) {
    const lines = tag.stack.split("\n");
    if (lines.length > 2) {
      const afterAt = lines[2].match(/at (.*)/);
      if (afterAt) {
        error.message = error.message + ` (defined at ${afterAt[1]})`;
      }
    }
  }
  if (error.stack) {
    const lines = error.stack.split("\n");
    lines.splice(1, 3);
    error.stack = lines.join("\n");
  }
  return error;
};

/** @internal */
const isContext$1 = u => typeof u === "object" && u !== null && TypeId$b in u;

/** @internal */
const isTag$1 = u => typeof u === "object" && u !== null && TagTypeId in u;
const _empty$8 = /*#__PURE__*/makeContext( /*#__PURE__*/new Map());

/** @internal */
const empty$B = () => _empty$8;

/** @internal */
const make$13 = (tag, service) => makeContext(new Map([[tag, service]]));

/** @internal */
const add$5 = /*#__PURE__*/dual(3, (self, tag, service) => {
  const map = new Map(self.unsafeMap);
  map.set(tag, service);
  return makeContext(map);
});

/** @internal */
const unsafeGet$7 = /*#__PURE__*/dual(2, (self, tag) => {
  if (!self.unsafeMap.has(tag)) {
    throw serviceNotFoundError(tag);
  }
  return self.unsafeMap.get(tag);
});

/** @internal */
const get$k = unsafeGet$7;

/** @internal */
const getOption$1 = /*#__PURE__*/dual(2, (self, tag) => {
  if (!self.unsafeMap.has(tag)) {
    return none$9;
  }
  return some$7(self.unsafeMap.get(tag));
});

/** @internal */
const merge$9 = /*#__PURE__*/dual(2, (self, that) => {
  const map = new Map(self.unsafeMap);
  for (const [tag, s] of that.unsafeMap) {
    map.set(tag, s);
  }
  return makeContext(map);
});

/** @internal */
const pick = (...tags) => self => {
  const tagSet = new Set(tags);
  const newEnv = new Map();
  for (const [tag, s] of self.unsafeMap.entries()) {
    if (tagSet.has(tag)) {
      newEnv.set(tag, s);
    }
  }
  return makeContext(newEnv);
};

/** @internal */
const omit = (...tags) => self => {
  const newEnv = new Map(self.unsafeMap);
  for (const tag of tags) {
    newEnv.delete(tag);
  }
  return makeContext(newEnv);
};

/**
 * This module provides a data structure called `Context` that can be used for dependency injection in effectful
 * programs. It is essentially a table mapping `Tag`s to their implementations (called `Service`s), and can be used to
 * manage dependencies in a type-safe way. The `Context` data structure is essentially a way of providing access to a set
 * of related services that can be passed around as a single unit. This module provides functions to create, modify, and
 * query the contents of a `Context`, as well as a number of utility types for working with tags and services.
 *
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Creates a new `Tag` instance with an optional key parameter.
 *
 * Specifying the `key` will make the `Tag` global, meaning two tags with the same
 * key will map to the same instance.
 *
 * Note: this is useful for cases where live reload can happen and it is
 * desireable to preserve the instance across reloads.
 *
 * @param key - An optional key that makes the `Tag` global.
 *
 * @example
 * import * as Context from "effect/Context"
 *
 * assert.strictEqual(Context.Tag() === Context.Tag(), false)
 * assert.strictEqual(Context.Tag("PORT") === Context.Tag("PORT"), true)
 *
 * @since 2.0.0
 * @category constructors
 */
const Tag$1 = makeTag;

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
makeContext;

/**
 * Checks if the provided argument is a `Context`.
 *
 * @param input - The value to be checked if it is a `Context`.
 *
 * @example
 * import * as Context from "effect/Context"
 *
 * assert.strictEqual(Context.isContext(Context.empty()), true)
 *
 * @since 2.0.0
 * @category guards
 */
const isContext = isContext$1;

/**
 * Checks if the provided argument is a `Tag`.
 *
 * @param input - The value to be checked if it is a `Tag`.
 *
 * @example
 * import * as Context from "effect/Context"
 *
 * assert.strictEqual(Context.isTag(Context.Tag()), true)
 *
 * @since 2.0.0
 * @category guards
 */
const isTag = isTag$1;

/**
 * Returns an empty `Context`.
 *
 * @example
 * import * as Context from "effect/Context"
 *
 * assert.strictEqual(Context.isContext(Context.empty()), true)
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$A = empty$B;

/**
 * Creates a new `Context` with a single service associated to the tag.
 *
 * @example
 * import * as Context from "effect/Context"
 *
 * const Port = Context.Tag<{ PORT: number }>()
 *
 * const Services = Context.make(Port, { PORT: 8080 })
 *
 * assert.deepStrictEqual(Context.get(Services, Port), { PORT: 8080 })
 *
 * @since 2.0.0
 * @category constructors
 */
const make$12 = make$13;

/**
 * Adds a service to a given `Context`.
 *
 * @example
 * import * as Context from "effect/Context"
 * import { pipe } from "effect/Function"
 *
 * const Port = Context.Tag<{ PORT: number }>()
 * const Timeout = Context.Tag<{ TIMEOUT: number }>()
 *
 * const someContext = Context.make(Port, { PORT: 8080 })
 *
 * const Services = pipe(
 *   someContext,
 *   Context.add(Timeout, { TIMEOUT: 5000 })
 * )
 *
 * assert.deepStrictEqual(Context.get(Services, Port), { PORT: 8080 })
 * assert.deepStrictEqual(Context.get(Services, Timeout), { TIMEOUT: 5000 })
 *
 * @since 2.0.0
 */
const add$4 = add$5;

/**
 * Get a service from the context that corresponds to the given tag.
 *
 * @param self - The `Context` to search for the service.
 * @param tag - The `Tag` of the service to retrieve.
 *
 * @example
 * import * as Context from "effect/Context"
 * import { pipe } from "effect/Function"
 *
 * const Port = Context.Tag<{ PORT: number }>()
 * const Timeout = Context.Tag<{ TIMEOUT: number }>()
 *
 * const Services = pipe(
 *   Context.make(Port, { PORT: 8080 }),
 *   Context.add(Timeout, { TIMEOUT: 5000 })
 * )
 *
 * assert.deepStrictEqual(Context.get(Services, Timeout), { TIMEOUT: 5000 })
 *
 * @since 2.0.0
 * @category getters
 */
const get$j = get$k;

/**
 * Get a service from the context that corresponds to the given tag.
 * This function is unsafe because if the tag is not present in the context, a runtime error will be thrown.
 *
 * For a safer version see {@link getOption}.
 *
 * @param self - The `Context` to search for the service.
 * @param tag - The `Tag` of the service to retrieve.
 *
 * @example
 * import * as Context from "effect/Context"
 *
 * const Port = Context.Tag<{ PORT: number }>()
 * const Timeout = Context.Tag<{ TIMEOUT: number }>()
 *
 * const Services = Context.make(Port, { PORT: 8080 })
 *
 * assert.deepStrictEqual(Context.unsafeGet(Services, Port), { PORT: 8080 })
 * assert.throws(() => Context.unsafeGet(Services, Timeout))
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet$6 = unsafeGet$7;

/**
 * Get the value associated with the specified tag from the context wrapped in an `Option` object. If the tag is not
 * found, the `Option` object will be `None`.
 *
 * @param self - The `Context` to search for the service.
 * @param tag - The `Tag` of the service to retrieve.
 *
 * @example
 * import * as Context from "effect/Context"
 * import * as O from "effect/Option"
 *
 * const Port = Context.Tag<{ PORT: number }>()
 * const Timeout = Context.Tag<{ TIMEOUT: number }>()
 *
 * const Services = Context.make(Port, { PORT: 8080 })
 *
 * assert.deepStrictEqual(Context.getOption(Services, Port), O.some({ PORT: 8080 }))
 * assert.deepStrictEqual(Context.getOption(Services, Timeout), O.none())
 *
 * @since 2.0.0
 * @category getters
 */
const getOption = getOption$1;

/**
 * Merges two `Context`s, returning a new `Context` containing the services of both.
 *
 * @param self - The first `Context` to merge.
 * @param that - The second `Context` to merge.
 *
 * @example
 * import * as Context from "effect/Context"
 *
 * const Port = Context.Tag<{ PORT: number }>()
 * const Timeout = Context.Tag<{ TIMEOUT: number }>()
 *
 * const firstContext = Context.make(Port, { PORT: 8080 })
 * const secondContext = Context.make(Timeout, { TIMEOUT: 5000 })
 *
 * const Services = Context.merge(firstContext, secondContext)
 *
 * assert.deepStrictEqual(Context.get(Services, Port), { PORT: 8080 })
 * assert.deepStrictEqual(Context.get(Services, Timeout), { TIMEOUT: 5000 })
 *
 * @since 2.0.0
 */
const merge$8 = merge$9;

/**
 * Returns a new `Context` that contains only the specified services.
 *
 * @param self - The `Context` to prune services from.
 * @param tags - The list of `Tag`s to be included in the new `Context`.
 *
 * @example
 * import * as Context from "effect/Context"
 * import { pipe } from "effect/Function"
 * import * as O from "effect/Option"
 *
 * const Port = Context.Tag<{ PORT: number }>()
 * const Timeout = Context.Tag<{ TIMEOUT: number }>()
 *
 * const someContext = pipe(
 *   Context.make(Port, { PORT: 8080 }),
 *   Context.add(Timeout, { TIMEOUT: 5000 })
 * )
 *
 * const Services = pipe(someContext, Context.pick(Port))
 *
 * assert.deepStrictEqual(Context.getOption(Services, Port), O.some({ PORT: 8080 }))
 * assert.deepStrictEqual(Context.getOption(Services, Timeout), O.none())
 *
 * @since 2.0.0
 */
pick;

/**
 * @since 2.0.0
 */
omit;

/**
 * @since 2.0.0
 */
const TypeId$a = /*#__PURE__*/Symbol.for("effect/Chunk");

/**
 * @category symbol
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category model
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

function copy$1(src, srcPos, dest, destPos, len) {
  for (let i = srcPos; i < Math.min(src.length, srcPos + len); i++) {
    dest[destPos + i - srcPos] = src[i];
  }
  return dest;
}
const emptyArray = [];

/**
 * Compares the two chunks of equal length using the specified function
 *
 * @category equivalence
 * @since 2.0.0
 */
const getEquivalence$1 = isEquivalent => make$16((self, that) => toReadonlyArray$4(self).every((value, i) => isEquivalent(value, unsafeGet$5(that, i))));
const _equivalence$1 = /*#__PURE__*/getEquivalence$1(equals$1);
const ChunkProto = {
  [TypeId$a]: {
    _A: _ => _
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "Chunk",
      values: toReadonlyArray$4(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  [symbol](that) {
    return isChunk(that) && _equivalence$1(this, that);
  },
  [symbol$1]() {
    return array$1(toReadonlyArray$4(this));
  },
  [Symbol.iterator]() {
    switch (this.backing._tag) {
      case "IArray":
        {
          return this.backing.array[Symbol.iterator]();
        }
      case "IEmpty":
        {
          return emptyArray[Symbol.iterator]();
        }
      default:
        {
          return toReadonlyArray$4(this)[Symbol.iterator]();
        }
    }
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const makeChunk = backing => {
  const chunk = Object.create(ChunkProto);
  chunk.backing = backing;
  switch (backing._tag) {
    case "IEmpty":
      {
        chunk.length = 0;
        chunk.depth = 0;
        chunk.left = chunk;
        chunk.right = chunk;
        break;
      }
    case "IConcat":
      {
        chunk.length = backing.left.length + backing.right.length;
        chunk.depth = 1 + Math.max(backing.left.depth, backing.right.depth);
        chunk.left = backing.left;
        chunk.right = backing.right;
        break;
      }
    case "IArray":
      {
        chunk.length = backing.array.length;
        chunk.depth = 0;
        chunk.left = _empty$7;
        chunk.right = _empty$7;
        break;
      }
    case "ISingleton":
      {
        chunk.length = 1;
        chunk.depth = 0;
        chunk.left = _empty$7;
        chunk.right = _empty$7;
        break;
      }
    case "ISlice":
      {
        chunk.length = backing.length;
        chunk.depth = backing.chunk.depth + 1;
        chunk.left = _empty$7;
        chunk.right = _empty$7;
        break;
      }
  }
  return chunk;
};

/**
 * Checks if `u` is a `Chunk<unknown>`
 *
 * @category constructors
 * @since 2.0.0
 */
const isChunk = u => isObject(u) && TypeId$a in u;
const _empty$7 = /*#__PURE__*/makeChunk({
  _tag: "IEmpty"
});

/**
 * @category constructors
 * @since 2.0.0
 */
const empty$z = () => _empty$7;

/**
 * Builds a `NonEmptyChunk` from an non-empty collection of elements.
 *
 * @category constructors
 * @since 2.0.0
 */
const make$11 = (...as) => as.length === 1 ? of$3(as[0]) : unsafeFromNonEmptyArray(as);

/**
 * Builds a `NonEmptyChunk` from a single element.
 *
 * @category constructors
 * @since 2.0.0
 */
const of$3 = a => makeChunk({
  _tag: "ISingleton",
  a
});

/**
 * Converts from an `Iterable<A>`
 *
 * @category conversions
 * @since 2.0.0
 */
const fromIterable$b = self => isChunk(self) ? self : makeChunk({
  _tag: "IArray",
  array: fromIterable$c(self)
});
const copyToArray = (self, array, initial) => {
  switch (self.backing._tag) {
    case "IArray":
      {
        copy$1(self.backing.array, 0, array, initial, self.length);
        break;
      }
    case "IConcat":
      {
        copyToArray(self.left, array, initial);
        copyToArray(self.right, array, initial + self.left.length);
        break;
      }
    case "ISingleton":
      {
        array[initial] = self.backing.a;
        break;
      }
    case "ISlice":
      {
        let i = 0;
        let j = initial;
        while (i < self.length) {
          array[j] = unsafeGet$5(self, i);
          i += 1;
          j += 1;
        }
        break;
      }
  }
};

/**
 * Converts the specified `Chunk` to a `ReadonlyArray`.
 *
 * @category conversions
 * @since 2.0.0
 */
const toReadonlyArray$4 = self => {
  switch (self.backing._tag) {
    case "IEmpty":
      {
        return emptyArray;
      }
    case "IArray":
      {
        return self.backing.array;
      }
    default:
      {
        const arr = new Array(self.length);
        copyToArray(self, arr, 0);
        self.backing = {
          _tag: "IArray",
          array: arr
        };
        self.left = _empty$7;
        self.right = _empty$7;
        self.depth = 0;
        return arr;
      }
  }
};

/**
 * @since 2.0.0
 * @category elements
 */
const reverse$1 = self => {
  switch (self.backing._tag) {
    case "IEmpty":
    case "ISingleton":
      return self;
    case "IArray":
      {
        return makeChunk({
          _tag: "IArray",
          array: reverse$2(self.backing.array)
        });
      }
    case "IConcat":
      {
        return makeChunk({
          _tag: "IConcat",
          left: reverse$1(self.backing.right),
          right: reverse$1(self.backing.left)
        });
      }
    case "ISlice":
      return unsafeFromArray(reverse$2(toReadonlyArray$4(self)));
  }
};

/**
 * This function provides a safe way to read a value at a particular index from a `Chunk`.
 *
 * @category elements
 * @since 2.0.0
 */
const get$i = /*#__PURE__*/dual(2, (self, index) => index < 0 || index >= self.length ? none$8() : some$6(unsafeGet$5(self, index)));

/**
 * Wraps an array into a chunk without copying, unsafe on mutable arrays
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeFromArray = self => makeChunk({
  _tag: "IArray",
  array: self
});

/**
 * Wraps an array into a chunk without copying, unsafe on mutable arrays
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeFromNonEmptyArray = self => unsafeFromArray(self);

/**
 * Gets an element unsafely, will throw on out of bounds
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet$5 = /*#__PURE__*/dual(2, (self, index) => {
  switch (self.backing._tag) {
    case "IEmpty":
      {
        throw new Error(`Index out of bounds`);
      }
    case "ISingleton":
      {
        if (index !== 0) {
          throw new Error(`Index out of bounds`);
        }
        return self.backing.a;
      }
    case "IArray":
      {
        if (index >= self.length || index < 0) {
          throw new Error(`Index out of bounds`);
        }
        return self.backing.array[index];
      }
    case "IConcat":
      {
        return index < self.left.length ? unsafeGet$5(self.left, index) : unsafeGet$5(self.right, index - self.left.length);
      }
    case "ISlice":
      {
        return unsafeGet$5(self.backing.chunk, index + self.backing.offset);
      }
  }
});

/**
 * Appends the specified element to the end of the `Chunk`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const append$1 = /*#__PURE__*/dual(2, (self, a) => appendAllNonEmpty(self, of$3(a)));

/**
 * Prepend an element to the front of a `Chunk`, creating a new `NonEmptyChunk`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prepend$2 = /*#__PURE__*/dual(2, (self, elem) => appendAllNonEmpty(of$3(elem), self));

/**
 * Takes the first up to `n` elements from the chunk
 *
 * @since 2.0.0
 */
const take$7 = /*#__PURE__*/dual(2, (self, n) => {
  if (n <= 0) {
    return _empty$7;
  } else if (n >= self.length) {
    return self;
  } else {
    switch (self.backing._tag) {
      case "ISlice":
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self.backing.chunk,
            length: n,
            offset: self.backing.offset
          });
        }
      case "IConcat":
        {
          if (n > self.left.length) {
            return makeChunk({
              _tag: "IConcat",
              left: self.left,
              right: take$7(self.right, n - self.left.length)
            });
          }
          return take$7(self.left, n);
        }
      default:
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self,
            offset: 0,
            length: n
          });
        }
    }
  }
});

/**
 * Drops the first up to `n` elements from the chunk
 *
 * @since 2.0.0
 */
const drop$2 = /*#__PURE__*/dual(2, (self, n) => {
  if (n <= 0) {
    return self;
  } else if (n >= self.length) {
    return _empty$7;
  } else {
    switch (self.backing._tag) {
      case "ISlice":
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self.backing.chunk,
            offset: self.backing.offset + n,
            length: self.backing.length - n
          });
        }
      case "IConcat":
        {
          if (n > self.left.length) {
            return drop$2(self.right, n - self.left.length);
          }
          return makeChunk({
            _tag: "IConcat",
            left: drop$2(self.left, n),
            right: self.right
          });
        }
      default:
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self,
            offset: n,
            length: self.length - n
          });
        }
    }
  }
});

/**
 * Drops all elements so long as the predicate returns true.
 *
 * @since 2.0.0
 */
const dropWhile$4 = /*#__PURE__*/dual(2, (self, f) => {
  const arr = toReadonlyArray$4(self);
  const len = arr.length;
  let i = 0;
  while (i < len && f(arr[i])) {
    i++;
  }
  return drop$2(self, i);
});

/**
 * Concatenates the two chunks
 *
 * @category concatenating
 * @since 2.0.0
 */
const appendAll$1 = /*#__PURE__*/dual(2, (self, that) => {
  if (self.backing._tag === "IEmpty") {
    return that;
  }
  if (that.backing._tag === "IEmpty") {
    return self;
  }
  const diff = that.depth - self.depth;
  if (Math.abs(diff) <= 1) {
    return makeChunk({
      _tag: "IConcat",
      left: self,
      right: that
    });
  } else if (diff < -1) {
    if (self.left.depth >= self.right.depth) {
      const nr = appendAll$1(self.right, that);
      return makeChunk({
        _tag: "IConcat",
        left: self.left,
        right: nr
      });
    } else {
      const nrr = appendAll$1(self.right.right, that);
      if (nrr.depth === self.depth - 3) {
        const nr = makeChunk({
          _tag: "IConcat",
          left: self.right.left,
          right: nrr
        });
        return makeChunk({
          _tag: "IConcat",
          left: self.left,
          right: nr
        });
      } else {
        const nl = makeChunk({
          _tag: "IConcat",
          left: self.left,
          right: self.right.left
        });
        return makeChunk({
          _tag: "IConcat",
          left: nl,
          right: nrr
        });
      }
    }
  } else {
    if (that.right.depth >= that.left.depth) {
      const nl = appendAll$1(self, that.left);
      return makeChunk({
        _tag: "IConcat",
        left: nl,
        right: that.right
      });
    } else {
      const nll = appendAll$1(self, that.left.left);
      if (nll.depth === that.depth - 3) {
        const nl = makeChunk({
          _tag: "IConcat",
          left: nll,
          right: that.left.right
        });
        return makeChunk({
          _tag: "IConcat",
          left: nl,
          right: that.right
        });
      } else {
        const nr = makeChunk({
          _tag: "IConcat",
          left: that.left.right,
          right: that.right
        });
        return makeChunk({
          _tag: "IConcat",
          left: nll,
          right: nr
        });
      }
    }
  }
});

/**
 * @category concatenating
 * @since 2.0.0
 */
const appendAllNonEmpty = /*#__PURE__*/dual(2, (self, that) => appendAll$1(self, that));

/**
 * Returns a filtered and mapped subset of the elements.
 *
 * @since 2.0.0
 * @category filtering
 */
const filterMap$2 = /*#__PURE__*/dual(2, (self, f) => unsafeFromArray(filterMap$3(self, f)));

/**
 * Returns a filtered and mapped subset of the elements.
 *
 * @since 2.0.0
 * @category filtering
 */
const filter$9 = /*#__PURE__*/dual(2, (self, predicate) => unsafeFromArray(filterMap$3(self, liftPredicate(predicate))));

/**
 * Transforms all elements of the chunk for as long as the specified function returns some value
 *
 * @since 2.0.0
 * @category filtering
 */
const filterMapWhile$1 = /*#__PURE__*/dual(2, (self, f) => unsafeFromArray(filterMapWhile$2(self, f)));

/**
 * Returns a chunk with the elements mapped by the specified function.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap$b = /*#__PURE__*/dual(2, (self, f) => {
  if (self.backing._tag === "ISingleton") {
    return f(self.backing.a, 0);
  }
  let out = _empty$7;
  let i = 0;
  for (const k of self) {
    out = appendAll$1(out, f(k, i++));
  }
  return out;
});

/**
 * Flattens a chunk of chunks into a single chunk by concatenating all chunks.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatten$9 = /*#__PURE__*/flatMap$b(identity$1);

/**
 * Groups elements in chunks of up to `n` elements.
 *
 * @since 2.0.0
 * @category elements
 */
const chunksOf = /*#__PURE__*/dual(2, (self, n) => {
  const gr = [];
  let current = [];
  toReadonlyArray$4(self).forEach(a => {
    current.push(a);
    if (current.length >= n) {
      gr.push(unsafeFromArray(current));
      current = [];
    }
  });
  if (current.length > 0) {
    gr.push(unsafeFromArray(current));
  }
  return unsafeFromArray(gr);
});

/**
 * Determines if the chunk is empty.
 *
 * @since 2.0.0
 * @category elements
 */
const isEmpty$h = self => self.length === 0;

/**
 * Determines if the chunk is not empty.
 *
 * @since 2.0.0
 * @category elements
 */
const isNonEmpty$5 = self => self.length > 0;

/**
 * Returns the first element of this chunk if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const head$4 = /*#__PURE__*/get$i(0);

/**
 * Returns the first element of this chunk.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeHead$1 = self => unsafeGet$5(self, 0);

/**
 * Returns the first element of this non empty chunk.
 *
 * @since 2.0.0
 * @category elements
 */
const headNonEmpty = unsafeHead$1;

/**
 * Returns the last element of this chunk if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const last$2 = self => get$i(self, self.length - 1);

/**
 * Returns the last element of this chunk.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeLast = self => unsafeGet$5(self, self.length - 1);

/**
 * Returns a chunk with the elements mapped by the specified f function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map$l = /*#__PURE__*/dual(2, (self, f) => self.backing._tag === "ISingleton" ? of$3(f(self.backing.a, 0)) : unsafeFromArray(pipe(toReadonlyArray$4(self), map$m((a, i) => f(a, i)))));

/**
 * Statefully maps over the chunk, producing new elements of type `B`.
 *
 * @since 2.0.0
 * @category folding
 */
const mapAccum$3 = /*#__PURE__*/dual(3, (self, s, f) => {
  const [s1, as] = mapAccum$4(self, s, f);
  return [s1, unsafeFromArray(as)];
});

/**
 * Separate elements based on a predicate that also exposes the index of the element.
 *
 * @category filtering
 * @since 2.0.0
 */
const partition$5 = /*#__PURE__*/dual(2, (self, predicate) => pipe(partition$6(toReadonlyArray$4(self), predicate), ([l, r]) => [unsafeFromArray(l), unsafeFromArray(r)]));

/**
 * Sort the elements of a Chunk in increasing order, creating a new Chunk.
 *
 * @since 2.0.0
 * @category elements
 */
const sort = /*#__PURE__*/dual(2, (self, O) => unsafeFromArray(sort$1(toReadonlyArray$4(self), O)));

/**
 *  Returns two splits of this chunk at the specified index.
 *
 * @since 2.0.0
 * @category elements
 */
const splitAt = /*#__PURE__*/dual(2, (self, n) => [take$7(self, n), drop$2(self, n)]);

/**
 * Splits this chunk on the first element that matches this predicate.
 *
 * @category elements
 * @since 2.0.0
 */
const splitWhere$1 = /*#__PURE__*/dual(2, (self, predicate) => {
  let i = 0;
  for (const a of toReadonlyArray$4(self)) {
    if (predicate(a)) {
      break;
    } else {
      i++;
    }
  }
  return splitAt(self, i);
});

/**
 * Returns every elements after the first.
 *
 * @since 2.0.0
 * @category elements
 */
const tailNonEmpty = self => drop$2(self, 1);

/**
 * Takes the last `n` elements.
 *
 * @since 2.0.0
 * @category elements
 */
const takeRight$1 = /*#__PURE__*/dual(2, (self, n) => drop$2(self, self.length - n));

/**
 * Takes all elements so long as the predicate returns true.
 *
 * @since 2.0.0
 * @category elements
 */
const takeWhile$3 = /*#__PURE__*/dual(2, (self, predicate) => {
  const res = [];
  for (const a of toReadonlyArray$4(self)) {
    if (predicate(a)) {
      res.push(a);
    } else {
      break;
    }
  }
  return unsafeFromArray(res);
});

/**
 * Remove duplicates from an array, keeping the first occurrence of an element.
 *
 * @since 2.0.0
 * @category elements
 */
const dedupe = self => unsafeFromArray(dedupe$1(toReadonlyArray$4(self)));

/**
 * Zips this chunk pointwise with the specified chunk using the specified combiner.
 *
 * @since 2.0.0
 * @category elements
 */
const zipWith$8 = /*#__PURE__*/dual(3, (self, that, f) => unsafeFromArray(zipWith$9(self, that, f)));

/**
 * Return a Chunk of length n with element i initialized with f(i).
 *
 * **Note**. `n` is normalized to an integer >= 1.
 *
 * @category constructors
 * @since 2.0.0
 */
const makeBy = /*#__PURE__*/dual(2, (n, f) => fromIterable$b(makeBy$1(n, f)));

/**
 * Create a non empty `Chunk` containing a range of integers, including both endpoints.
 *
 * @category constructors
 * @since 2.0.0
 */
const range$1 = (start, end) => start <= end ? makeBy(end - start + 1, i => start + i) : of$3(start);

/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst$6 = findFirst$7;

/**
 * Check if a predicate holds true for some `Chunk` element.
 *
 * @category elements
 * @since 2.0.0
 */
const some$5 = /*#__PURE__*/dual(2, (self, predicate) => fromIterable$c(self).some(predicate));

/**
 * @category folding
 * @since 2.0.0
 */
const reduce$h = reduce$i;

/**
 * @category folding
 * @since 2.0.0
 */
const reduceRight$3 = reduceRight$4;

/** @internal */
const ChunkPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferChunkPatch");
function variance$6(a) {
  return a;
}
const PatchProto$4 = {
  ...Structural.prototype,
  [ChunkPatchTypeId]: {
    _Value: variance$6,
    _Patch: variance$6
  }
};
const EmptyProto$4 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$4), {
  _tag: "Empty"
});
const _empty$6 = /*#__PURE__*/Object.create(EmptyProto$4);

/**
 * @internal
 */
const empty$y = () => _empty$6;
const AndThenProto$4 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$4), {
  _tag: "AndThen"
});
const makeAndThen$4 = (first, second) => {
  const o = Object.create(AndThenProto$4);
  o.first = first;
  o.second = second;
  return o;
};
const AppendProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$4), {
  _tag: "Append"
});
const makeAppend = values => {
  const o = Object.create(AppendProto);
  o.values = values;
  return o;
};
const SliceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$4), {
  _tag: "Slice"
});
const makeSlice = (from, until) => {
  const o = Object.create(SliceProto);
  o.from = from;
  o.until = until;
  return o;
};
const UpdateProto$1 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$4), {
  _tag: "Update"
});
const makeUpdate$1 = (index, patch) => {
  const o = Object.create(UpdateProto$1);
  o.index = index;
  o.patch = patch;
  return o;
};
/** @internal */
const diff$8 = options => {
  let i = 0;
  let patch = empty$y();
  while (i < options.oldValue.length && i < options.newValue.length) {
    const oldElement = unsafeGet$5(i)(options.oldValue);
    const newElement = unsafeGet$5(i)(options.newValue);
    const valuePatch = options.differ.diff(oldElement, newElement);
    if (!equals$1(valuePatch, options.differ.empty)) {
      patch = pipe(patch, combine$9(makeUpdate$1(i, valuePatch)));
    }
    i = i + 1;
  }
  if (i < options.oldValue.length) {
    patch = pipe(patch, combine$9(makeSlice(0, i)));
  }
  if (i < options.newValue.length) {
    patch = pipe(patch, combine$9(makeAppend(drop$2(i)(options.newValue))));
  }
  return patch;
};

/** @internal */
const combine$9 = /*#__PURE__*/dual(2, (self, that) => makeAndThen$4(self, that));

/** @internal */
const patch$9 = /*#__PURE__*/dual(3, (self, oldValue, differ) => {
  let chunk = oldValue;
  let patches = of$3(self);
  while (isNonEmpty$5(patches)) {
    const head = headNonEmpty(patches);
    const tail = tailNonEmpty(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = prepend$2(head.first)(prepend$2(head.second)(tail));
          break;
        }
      case "Append":
        {
          chunk = appendAll$1(head.values)(chunk);
          patches = tail;
          break;
        }
      case "Slice":
        {
          const array = toReadonlyArray$4(chunk);
          chunk = unsafeFromArray(array.slice(head.from, head.until));
          patches = tail;
          break;
        }
      case "Update":
        {
          const array = toReadonlyArray$4(chunk);
          array[head.index] = differ.patch(head.patch, array[head.index]);
          chunk = unsafeFromArray(array);
          patches = tail;
          break;
        }
    }
  }
  return chunk;
});

/** @internal */
const ContextPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferContextPatch");
function variance$5(a) {
  return a;
}

/** @internal */
const PatchProto$3 = {
  ...Structural.prototype,
  [ContextPatchTypeId]: {
    _Value: variance$5,
    _Patch: variance$5
  }
};
const EmptyProto$3 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$3), {
  _tag: "Empty"
});
const _empty$5 = /*#__PURE__*/Object.create(EmptyProto$3);

/**
 * @internal
 */
const empty$x = () => _empty$5;

/** @internal */

const AndThenProto$3 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$3), {
  _tag: "AndThen"
});
const makeAndThen$3 = (first, second) => {
  const o = Object.create(AndThenProto$3);
  o.first = first;
  o.second = second;
  return o;
};

/** @internal */

const AddServiceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$3), {
  _tag: "AddService"
});
const makeAddService = (tag, service) => {
  const o = Object.create(AddServiceProto);
  o.tag = tag;
  o.service = service;
  return o;
};

/** @internal */

const RemoveServiceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$3), {
  _tag: "RemoveService"
});
const makeRemoveService = tag => {
  const o = Object.create(RemoveServiceProto);
  o.tag = tag;
  return o;
};

/** @internal */

const UpdateServiceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$3), {
  _tag: "UpdateService"
});
const makeUpdateService = (tag, update) => {
  const o = Object.create(UpdateServiceProto);
  o.tag = tag;
  o.update = update;
  return o;
};
/** @internal */
const diff$7 = (oldValue, newValue) => {
  const missingServices = new Map(oldValue.unsafeMap);
  let patch = empty$x();
  for (const [tag, newService] of newValue.unsafeMap.entries()) {
    if (missingServices.has(tag)) {
      const old = missingServices.get(tag);
      missingServices.delete(tag);
      if (!equals$1(old, newService)) {
        patch = combine$8(makeUpdateService(tag, () => newService))(patch);
      }
    } else {
      missingServices.delete(tag);
      patch = combine$8(makeAddService(tag, newService))(patch);
    }
  }
  for (const [tag] of missingServices.entries()) {
    patch = combine$8(makeRemoveService(tag))(patch);
  }
  return patch;
};

/** @internal */
const combine$8 = /*#__PURE__*/dual(2, (self, that) => makeAndThen$3(self, that));

/** @internal */
const patch$8 = /*#__PURE__*/dual(2, (self, context) => {
  let wasServiceUpdated = false;
  let patches = of$3(self);
  const updatedContext = new Map(context.unsafeMap);
  while (isNonEmpty$5(patches)) {
    const head = headNonEmpty(patches);
    const tail = tailNonEmpty(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AddService":
        {
          updatedContext.set(head.tag, head.service);
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = prepend$2(prepend$2(tail, head.second), head.first);
          break;
        }
      case "RemoveService":
        {
          updatedContext.delete(head.tag);
          patches = tail;
          break;
        }
      case "UpdateService":
        {
          updatedContext.set(head.tag, head.update(updatedContext.get(head.tag)));
          wasServiceUpdated = true;
          patches = tail;
          break;
        }
    }
  }
  if (!wasServiceUpdated) {
    return makeContext(updatedContext);
  }
  const map = new Map();
  for (const [tag] of context.unsafeMap) {
    if (updatedContext.has(tag)) {
      map.set(tag, updatedContext.get(tag));
      updatedContext.delete(tag);
    }
  }
  for (const [tag, s] of updatedContext) {
    map.set(tag, s);
  }
  return makeContext(map);
});

/** @internal */
const SIZE = 5;

/** @internal */
const BUCKET_SIZE = /*#__PURE__*/Math.pow(2, SIZE);

/** @internal */
const MASK = BUCKET_SIZE - 1;

/** @internal */
const MAX_INDEX_NODE = BUCKET_SIZE / 2;

/** @internal */
const MIN_ARRAY_NODE = BUCKET_SIZE / 4;

/**
 * Hamming weight.
 *
 * Taken from: http://jsperf.com/hamming-weight
 *
 * @internal
 */
function popcount(x) {
  x -= x >> 1 & 0x55555555;
  x = (x & 0x33333333) + (x >> 2 & 0x33333333);
  x = x + (x >> 4) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
}

/** @internal */
function hashFragment(shift, h) {
  return h >>> shift & MASK;
}

/** @internal */
function toBitmap(x) {
  return 1 << x;
}

/** @internal */
function fromBitmap(bitmap, bit) {
  return popcount(bitmap & bit - 1);
}

/** @internal */
function arrayUpdate(mutate, at, v, arr) {
  let out = arr;
  if (!mutate) {
    const len = arr.length;
    out = new Array(len);
    for (let i = 0; i < len; ++i) out[i] = arr[i];
  }
  out[at] = v;
  return out;
}

/** @internal */
function arraySpliceOut(mutate, at, arr) {
  const newLen = arr.length - 1;
  let i = 0;
  let g = 0;
  let out = arr;
  if (mutate) {
    i = g = at;
  } else {
    out = new Array(newLen);
    while (i < at) out[g++] = arr[i++];
  }
  ++i;
  while (i <= newLen) out[g++] = arr[i++];
  if (mutate) {
    out.length = newLen;
  }
  return out;
}

/** @internal */
function arraySpliceIn(mutate, at, v, arr) {
  const len = arr.length;
  if (mutate) {
    let i = len;
    while (i >= at) arr[i--] = arr[i];
    arr[at] = v;
    return arr;
  }
  let i = 0,
    g = 0;
  const out = new Array(len + 1);
  while (i < at) out[g++] = arr[i++];
  out[at] = v;
  while (i < len) out[++g] = arr[i++];
  return out;
}

/** @internal */
class Stack {
  constructor(value, previous) {
    this.value = value;
    this.previous = previous;
  }
}

/** @internal */

/** @internal */

/** @internal */
class EmptyNode {
  _tag = "EmptyNode";
  modify(edit, _shift, f, hash, key, size) {
    const v = f(none$8());
    if (isNone$1(v)) return new EmptyNode();
    ++size.value;
    return new LeafNode(edit, hash, key, v);
  }
}

/** @internal */
function isEmptyNode(a) {
  return a instanceof EmptyNode;
}

/** @internal */
function isLeafNode(node) {
  return isEmptyNode(node) || node._tag === "LeafNode" || node._tag === "CollisionNode";
}

/** @internal */
function canEditNode(node, edit) {
  return isEmptyNode(node) ? false : edit === node.edit;
}

/** @internal */
class LeafNode {
  _tag = "LeafNode";
  constructor(edit, hash, key, value) {
    this.edit = edit;
    this.hash = hash;
    this.key = key;
    this.value = value;
  }
  modify(edit, shift, f, hash, key, size) {
    if (equals$1(key, this.key)) {
      const v = f(this.value);
      if (v === this.value) return this;else if (isNone$1(v)) {
        --size.value;
        return new EmptyNode();
      }
      if (canEditNode(this, edit)) {
        this.value = v;
        return this;
      }
      return new LeafNode(edit, hash, key, v);
    }
    const v = f(none$8());
    if (isNone$1(v)) return this;
    ++size.value;
    return mergeLeaves(edit, shift, this.hash, this, hash, new LeafNode(edit, hash, key, v));
  }
}

/** @internal */
class CollisionNode {
  _tag = "CollisionNode";
  constructor(edit, hash, children) {
    this.edit = edit;
    this.hash = hash;
    this.children = children;
  }
  modify(edit, shift, f, hash, key, size) {
    if (hash === this.hash) {
      const canEdit = canEditNode(this, edit);
      const list = this.updateCollisionList(canEdit, edit, this.hash, this.children, f, key, size);
      if (list === this.children) return this;
      return list.length > 1 ? new CollisionNode(edit, this.hash, list) : list[0]; // collapse single element collision list
    }

    const v = f(none$8());
    if (isNone$1(v)) return this;
    ++size.value;
    return mergeLeaves(edit, shift, this.hash, this, hash, new LeafNode(edit, hash, key, v));
  }
  updateCollisionList(mutate, edit, hash, list, f, key, size) {
    const len = list.length;
    for (let i = 0; i < len; ++i) {
      const child = list[i];
      if ("key" in child && equals$1(key, child.key)) {
        const value = child.value;
        const newValue = f(value);
        if (newValue === value) return list;
        if (isNone$1(newValue)) {
          --size.value;
          return arraySpliceOut(mutate, i, list);
        }
        return arrayUpdate(mutate, i, new LeafNode(edit, hash, key, newValue), list);
      }
    }
    const newValue = f(none$8());
    if (isNone$1(newValue)) return list;
    ++size.value;
    return arrayUpdate(mutate, len, new LeafNode(edit, hash, key, newValue), list);
  }
}

/** @internal */
class IndexedNode {
  _tag = "IndexedNode";
  constructor(edit, mask, children) {
    this.edit = edit;
    this.mask = mask;
    this.children = children;
  }
  modify(edit, shift, f, hash, key, size) {
    const mask = this.mask;
    const children = this.children;
    const frag = hashFragment(shift, hash);
    const bit = toBitmap(frag);
    const indx = fromBitmap(mask, bit);
    const exists = mask & bit;
    const canEdit = canEditNode(this, edit);
    if (!exists) {
      const _newChild = new EmptyNode().modify(edit, shift + SIZE, f, hash, key, size);
      if (!_newChild) return this;
      return children.length >= MAX_INDEX_NODE ? expand(edit, frag, _newChild, mask, children) : new IndexedNode(edit, mask | bit, arraySpliceIn(canEdit, indx, _newChild, children));
    }
    const current = children[indx];
    const child = current.modify(edit, shift + SIZE, f, hash, key, size);
    if (current === child) return this;
    let bitmap = mask;
    let newChildren;
    if (isEmptyNode(child)) {
      // remove
      bitmap &= ~bit;
      if (!bitmap) return new EmptyNode();
      if (children.length <= 2 && isLeafNode(children[indx ^ 1])) {
        return children[indx ^ 1]; // collapse
      }

      newChildren = arraySpliceOut(canEdit, indx, children);
    } else {
      // modify
      newChildren = arrayUpdate(canEdit, indx, child, children);
    }
    if (canEdit) {
      this.mask = bitmap;
      this.children = newChildren;
      return this;
    }
    return new IndexedNode(edit, bitmap, newChildren);
  }
}

/** @internal */
class ArrayNode {
  _tag = "ArrayNode";
  constructor(edit, size, children) {
    this.edit = edit;
    this.size = size;
    this.children = children;
  }
  modify(edit, shift, f, hash, key, size) {
    let count = this.size;
    const children = this.children;
    const frag = hashFragment(shift, hash);
    const child = children[frag];
    const newChild = (child || new EmptyNode()).modify(edit, shift + SIZE, f, hash, key, size);
    if (child === newChild) return this;
    const canEdit = canEditNode(this, edit);
    let newChildren;
    if (isEmptyNode(child) && !isEmptyNode(newChild)) {
      ++count;
      newChildren = arrayUpdate(canEdit, frag, newChild, children);
    } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
      --count;
      if (count <= MIN_ARRAY_NODE) {
        return pack(edit, count, frag, children);
      }
      newChildren = arrayUpdate(canEdit, frag, new EmptyNode(), children);
    } else {
      // modify
      newChildren = arrayUpdate(canEdit, frag, newChild, children);
    }
    if (canEdit) {
      this.size = count;
      this.children = newChildren;
      return this;
    }
    return new ArrayNode(edit, count, newChildren);
  }
}
function pack(edit, count, removed, elements) {
  const children = new Array(count - 1);
  let g = 0;
  let bitmap = 0;
  for (let i = 0, len = elements.length; i < len; ++i) {
    if (i !== removed) {
      const elem = elements[i];
      if (elem && !isEmptyNode(elem)) {
        children[g++] = elem;
        bitmap |= 1 << i;
      }
    }
  }
  return new IndexedNode(edit, bitmap, children);
}
function expand(edit, frag, child, bitmap, subNodes) {
  const arr = [];
  let bit = bitmap;
  let count = 0;
  for (let i = 0; bit; ++i) {
    if (bit & 1) arr[i] = subNodes[count++];
    bit >>>= 1;
  }
  arr[frag] = child;
  return new ArrayNode(edit, count + 1, arr);
}
function mergeLeavesInner(edit, shift, h1, n1, h2, n2) {
  if (h1 === h2) return new CollisionNode(edit, h1, [n2, n1]);
  const subH1 = hashFragment(shift, h1);
  const subH2 = hashFragment(shift, h2);
  if (subH1 === subH2) {
    return child => new IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), [child]);
  } else {
    const children = subH1 < subH2 ? [n1, n2] : [n2, n1];
    return new IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), children);
  }
}
function mergeLeaves(edit, shift, h1, n1, h2, n2) {
  let stack = undefined;
  let currentShift = shift;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const res = mergeLeavesInner(edit, currentShift, h1, n1, h2, n2);
    if (typeof res === "function") {
      stack = new Stack(res, stack);
      currentShift = currentShift + SIZE;
    } else {
      let final = res;
      while (stack != null) {
        final = stack.value(final);
        stack = stack.previous;
      }
      return final;
    }
  }
}

/** @internal */
const HashMapTypeId = /*#__PURE__*/Symbol.for("effect/HashMap");

/** @internal */

const HashMapProto = {
  [HashMapTypeId]: HashMapTypeId,
  [Symbol.iterator]() {
    return new HashMapIterator(this, (k, v) => [k, v]);
  },
  [symbol$1]() {
    let hash$1$1 = hash$1("HashMap");
    for (const item of this) {
      hash$1$1 ^= combine$a(hash$1(item[0]))(hash$1(item[1]));
    }
    return hash$1$1;
  },
  [symbol](that) {
    if (isHashMap(that)) {
      if (that._size !== this._size) {
        return false;
      }
      for (const item of this) {
        const elem = pipe(that, getHash(item[0], hash$1(item[0])));
        if (isNone$1(elem)) {
          return false;
        } else {
          if (!equals$1(item[1], elem.value)) {
            return false;
          }
        }
      }
      return true;
    }
    return false;
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "HashMap",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const makeImpl$4 = (editable, edit, root, size) => {
  const map = Object.create(HashMapProto);
  map._editable = editable;
  map._edit = edit;
  map._root = root;
  map._size = size;
  return map;
};
class HashMapIterator {
  constructor(map, f) {
    this.map = map;
    this.f = f;
    this.v = visitLazy(this.map._root, this.f, undefined);
  }
  next() {
    if (isNone$1(this.v)) {
      return {
        done: true,
        value: undefined
      };
    }
    const v0 = this.v.value;
    this.v = applyCont(v0.cont);
    return {
      done: false,
      value: v0.value
    };
  }
  [Symbol.iterator]() {
    return new HashMapIterator(this.map, this.f);
  }
}
const applyCont = cont => cont ? visitLazyChildren(cont[0], cont[1], cont[2], cont[3], cont[4]) : none$8();
const visitLazy = (node, f, cont = undefined) => {
  switch (node._tag) {
    case "LeafNode":
      {
        if (isSome(node.value)) {
          return some$6({
            value: f(node.key, node.value.value),
            cont
          });
        }
        return applyCont(cont);
      }
    case "CollisionNode":
    case "ArrayNode":
    case "IndexedNode":
      {
        const children = node.children;
        return visitLazyChildren(children.length, children, 0, f, cont);
      }
    default:
      {
        return applyCont(cont);
      }
  }
};
const visitLazyChildren = (len, children, i, f, cont) => {
  while (i < len) {
    const child = children[i++];
    if (child && !isEmptyNode(child)) {
      return visitLazy(child, f, [len, children, i, f, cont]);
    }
  }
  return applyCont(cont);
};
const _empty$4 = /*#__PURE__*/makeImpl$4(false, 0, /*#__PURE__*/new EmptyNode(), 0);

/** @internal */
const empty$w = () => _empty$4;

/** @internal */
const make$10 = (...entries) => fromIterable$a(entries);

/** @internal */
const fromIterable$a = entries => {
  const map = beginMutation$1(empty$w());
  for (const entry of entries) {
    set$c(entry[0], entry[1])(map);
  }
  return endMutation$1(map);
};

/** @internal */
const isHashMap = u => isObject(u) && HashMapTypeId in u;

/** @internal */
const isEmpty$g = self => self && isEmptyNode(self._root);

/** @internal */
const get$h = /*#__PURE__*/dual(2, (self, key) => getHash(self, key, hash$1(key)));

/** @internal */
const getHash = /*#__PURE__*/dual(3, (self, key, hash) => {
  let node = self._root;
  let shift = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    switch (node._tag) {
      case "LeafNode":
        {
          return equals$1(key, node.key) ? node.value : none$8();
        }
      case "CollisionNode":
        {
          if (hash === node.hash) {
            const children = node.children;
            for (let i = 0, len = children.length; i < len; ++i) {
              const child = children[i];
              if ("key" in child && equals$1(key, child.key)) {
                return child.value;
              }
            }
          }
          return none$8();
        }
      case "IndexedNode":
        {
          const frag = hashFragment(shift, hash);
          const bit = toBitmap(frag);
          if (node.mask & bit) {
            node = node.children[fromBitmap(node.mask, bit)];
            shift += SIZE;
            break;
          }
          return none$8();
        }
      case "ArrayNode":
        {
          node = node.children[hashFragment(shift, hash)];
          if (node) {
            shift += SIZE;
            break;
          }
          return none$8();
        }
      default:
        return none$8();
    }
  }
});

/** @internal */
const unsafeGet$4 = /*#__PURE__*/dual(2, (self, key) => {
  const element = getHash(self, key, hash$1(key));
  if (isNone$1(element)) {
    throw new Error("Error: Expected map to contain key");
  }
  return element.value;
});

/** @internal */
const has$8 = /*#__PURE__*/dual(2, (self, key) => isSome(getHash(self, key, hash$1(key))));

/** @internal */
const hasHash = /*#__PURE__*/dual(3, (self, key, hash) => isSome(getHash(self, key, hash)));

/** @internal */
const set$c = /*#__PURE__*/dual(3, (self, key, value) => modifyAt(self, key, () => some$6(value)));

/** @internal */
const setTree = /*#__PURE__*/dual(3, (self, newRoot, newSize) => {
  if (self._editable) {
    self._root = newRoot;
    self._size = newSize;
    return self;
  }
  return newRoot === self._root ? self : makeImpl$4(self._editable, self._edit, newRoot, newSize);
});

/** @internal */
const keys$4 = self => new HashMapIterator(self, key => key);

/** @internal */
const values$4 = self => new HashMapIterator(self, (_, value) => value);

/** @internal */
const size$j = self => self._size;

/** @internal */
const beginMutation$1 = self => makeImpl$4(true, self._edit + 1, self._root, self._size);

/** @internal */
const endMutation$1 = self => {
  self._editable = false;
  return self;
};

/** @internal */
const mutate$1 = /*#__PURE__*/dual(2, (self, f) => {
  const transient = beginMutation$1(self);
  f(transient);
  return endMutation$1(transient);
});

/** @internal */
const modifyAt = /*#__PURE__*/dual(3, (self, key, f) => modifyHash(self, key, hash$1(key), f));

/** @internal */
const modifyHash = /*#__PURE__*/dual(4, (self, key, hash, f) => {
  const size = {
    value: self._size
  };
  const newRoot = self._root.modify(self._editable ? self._edit : NaN, 0, f, hash, key, size);
  return pipe(self, setTree(newRoot, size.value));
});

/** @internal */
const modify$5 = /*#__PURE__*/dual(3, (self, key, f) => modifyAt(self, key, map$n(f)));

/** @internal */
const union$8 = /*#__PURE__*/dual(2, (self, that) => {
  const result = beginMutation$1(self);
  forEach$b(that, (v, k) => set$c(result, k, v));
  return endMutation$1(result);
});

/** @internal */
const remove$9 = /*#__PURE__*/dual(2, (self, key) => modifyAt(self, key, none$8));

/** @internal */
const removeMany = /*#__PURE__*/dual(2, (self, keys) => mutate$1(self, map => {
  for (const key of keys) {
    remove$9(key)(map);
  }
}));

/**
 * Maps over the entries of the `HashMap` using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map$k = /*#__PURE__*/dual(2, (self, f) => reduce$g(self, empty$w(), (map, value, key) => set$c(map, key, f(value, key))));

/** @internal */
const flatMap$a = /*#__PURE__*/dual(2, (self, f) => reduce$g(self, empty$w(), (zero, value, key) => mutate$1(zero, map => forEach$b(f(value, key), (value, key) => set$c(map, key, value)))));

/** @internal */
const forEach$b = /*#__PURE__*/dual(2, (self, f) => reduce$g(self, void 0, (_, value, key) => f(value, key)));

/** @internal */
const reduce$g = /*#__PURE__*/dual(3, (self, zero, f) => {
  const root = self._root;
  if (root._tag === "LeafNode") {
    return isSome(root.value) ? f(zero, root.value.value, root.key) : zero;
  }
  if (root._tag === "EmptyNode") {
    return zero;
  }
  const toVisit = [root.children];
  let children;
  while (children = toVisit.pop()) {
    for (let i = 0, len = children.length; i < len;) {
      const child = children[i++];
      if (child && !isEmptyNode(child)) {
        if (child._tag === "LeafNode") {
          if (isSome(child.value)) {
            zero = f(zero, child.value.value, child.key);
          }
        } else {
          toVisit.push(child.children);
        }
      }
    }
  }
  return zero;
});

/** @internal */
const filter$8 = /*#__PURE__*/dual(2, (self, f) => mutate$1(empty$w(), map => {
  for (const [k, a] of self) {
    if (f(a, k)) {
      set$c(map, k, a);
    }
  }
}));

/** @internal */
const compact = self => filterMap$1(self, identity$1);

/** @internal */
const filterMap$1 = /*#__PURE__*/dual(2, (self, f) => mutate$1(empty$w(), map => {
  for (const [k, a] of self) {
    const option = f(a, k);
    if (isSome(option)) {
      set$c(map, k, option.value);
    }
  }
}));

/** @internal */
const findFirst$5 = /*#__PURE__*/dual(2, (self, predicate) => {
  for (const ka of self) {
    if (predicate(ka[0], ka[1])) {
      return some$6(ka);
    }
  }
  return none$8();
});

/** @internal */
const HashSetTypeId = /*#__PURE__*/Symbol.for("effect/HashSet");

/** @internal */

const HashSetProto = {
  [HashSetTypeId]: HashSetTypeId,
  [Symbol.iterator]() {
    return keys$4(this._keyMap);
  },
  [symbol$1]() {
    return combine$a(hash$1(this._keyMap))(hash$1("HashSet"));
  },
  [symbol](that) {
    if (isHashSet$1(that)) {
      return size$j(this._keyMap) === size$j(that._keyMap) && equals$1(this._keyMap, that._keyMap);
    }
    return false;
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "HashSet",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const makeImpl$3 = keyMap => {
  const set = Object.create(HashSetProto);
  set._keyMap = keyMap;
  return set;
};

/** @internal */
const isHashSet$1 = u => isObject(u) && HashSetTypeId in u;
const _empty$3 = /*#__PURE__*/makeImpl$3( /*#__PURE__*/empty$w());

/** @internal */
const empty$v = () => _empty$3;

/** @internal */
const fromIterable$9 = elements => {
  const set = beginMutation(empty$v());
  for (const value of elements) {
    add$3(set, value);
  }
  return endMutation(set);
};

/** @internal */
const make$$ = (...elements) => {
  const set = beginMutation(empty$v());
  for (const value of elements) {
    add$3(set, value);
  }
  return endMutation(set);
};

/** @internal */
const has$7 = /*#__PURE__*/dual(2, (self, value) => has$8(self._keyMap, value));

/** @internal */
const some$4 = /*#__PURE__*/dual(2, (self, f) => {
  let found = false;
  for (const value of self) {
    found = f(value);
    if (found) {
      break;
    }
  }
  return found;
});

/** @internal */
const every$6 = /*#__PURE__*/dual(2, (self, refinement) => !some$4(self, a => !refinement(a)));

/** @internal */
const isSubset = /*#__PURE__*/dual(2, (self, that) => every$6(self, value => has$7(that, value)));

/** @internal */
const values$3 = self => keys$4(self._keyMap);

/** @internal */
const size$i = self => size$j(self._keyMap);

/** @internal */
const beginMutation = self => makeImpl$3(beginMutation$1(self._keyMap));

/** @internal */
const endMutation = self => {
  self._keyMap._editable = false;
  return self;
};

/** @internal */
const mutate = /*#__PURE__*/dual(2, (self, f) => {
  const transient = beginMutation(self);
  f(transient);
  return endMutation(transient);
});

/** @internal */
const add$3 = /*#__PURE__*/dual(2, (self, value) => self._keyMap._editable ? (set$c(value, true)(self._keyMap), self) : makeImpl$3(set$c(value, true)(self._keyMap)));

/** @internal */
const remove$8 = /*#__PURE__*/dual(2, (self, value) => self._keyMap._editable ? (remove$9(value)(self._keyMap), self) : makeImpl$3(remove$9(value)(self._keyMap)));

/** @internal */
const difference$2 = /*#__PURE__*/dual(2, (self, that) => mutate(self, set => {
  for (const value of that) {
    remove$8(set, value);
  }
}));

/** @internal */
const intersection$1 = /*#__PURE__*/dual(2, (self, that) => mutate(empty$v(), set => {
  for (const value of that) {
    if (has$7(value)(self)) {
      add$3(value)(set);
    }
  }
}));

/** @internal */
const union$7 = /*#__PURE__*/dual(2, (self, that) => mutate(empty$v(), set => {
  forEach$a(self, value => add$3(set, value));
  for (const value of that) {
    add$3(set, value);
  }
}));

/** @internal */
const toggle = /*#__PURE__*/dual(2, (self, value) => has$7(self, value) ? remove$8(self, value) : add$3(self, value));

/** @internal */
const map$j = /*#__PURE__*/dual(2, (self, f) => mutate(empty$v(), set => {
  forEach$a(self, a => {
    const b = f(a);
    if (!has$7(set, b)) {
      add$3(set, b);
    }
  });
}));

/** @internal */
const flatMap$9 = /*#__PURE__*/dual(2, (self, f) => mutate(empty$v(), set => {
  forEach$a(self, a => {
    for (const b of f(a)) {
      if (!has$7(set, b)) {
        add$3(set, b);
      }
    }
  });
}));

/** @internal */
const forEach$a = /*#__PURE__*/dual(2, (self, f) => forEach$b(self._keyMap, (_, k) => f(k)));

/** @internal */
const reduce$f = /*#__PURE__*/dual(3, (self, zero, f) => reduce$g(self._keyMap, zero, (z, _, a) => f(z, a)));

/** @internal */
const filter$7 = /*#__PURE__*/dual(2, (self, f) => {
  return mutate(empty$v(), set => {
    const iterator = values$3(self);
    let next;
    while (!(next = iterator.next()).done) {
      const value = next.value;
      if (f(value)) {
        add$3(set, value);
      }
    }
  });
});

/** @internal */
const partition$4 = /*#__PURE__*/dual(2, (self, f) => {
  const iterator = values$3(self);
  let next;
  const right = beginMutation(empty$v());
  const left = beginMutation(empty$v());
  while (!(next = iterator.next()).done) {
    const value = next.value;
    if (f(value)) {
      add$3(right, value);
    } else {
      add$3(left, value);
    }
  }
  return [endMutation(left), endMutation(right)];
});

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category refinements
 */
isHashMap;

/**
 * Creates a new `HashMap`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$u = empty$w;

/**
 * Constructs a new `HashMap` from an array of key/value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const make$_ = make$10;

/**
 * Constructs a new `HashMap` from an iterable of key/value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable$8 = fromIterable$a;

/**
 * Checks if the `HashMap` contains any entries.
 *
 * @since 2.0.0
 * @category elements
 */
const isEmpty$f = isEmpty$g;

/**
 * Safely lookup the value for the specified key in the `HashMap` using the
 * internal hashing function.
 *
 * @since 2.0.0
 * @category elements
 */
const get$g = get$h;

/**
 * Lookup the value for the specified key in the `HashMap` using a custom hash.
 *
 * @since 2.0.0
 * @category elements
 */
getHash;

/**
 * Unsafely lookup the value for the specified key in the `HashMap` using the
 * internal hashing function.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet$3 = unsafeGet$4;

/**
 * Checks if the specified key has an entry in the `HashMap`.
 *
 * @since 2.0.0
 * @category elements
 */
const has$6 = has$8;

/**
 * Checks if the specified key has an entry in the `HashMap` using a custom
 * hash.
 *
 * @since 2.0.0
 * @category elements
 */
hasHash;

/**
 * Sets the specified key to the specified value using the internal hashing
 * function.
 *
 * @since 2.0.0
 */
const set$b = set$c;

/**
 * Returns an `IterableIterator` of the keys within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const keys$3 = keys$4;

/**
 * Returns an `IterableIterator` of the values within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const values$2 = values$4;

/**
 * Returns the number of entries within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const size$h = size$j;

/**
 * Marks the `HashMap` as mutable.
 *
 * @since 2.0.0
 */
beginMutation$1;

/**
 * Marks the `HashMap` as immutable.
 *
 * @since 2.0.0
 */
endMutation$1;

/**
 * Mutates the `HashMap` within the context of the provided function.
 *
 * @since 2.0.0
 */
mutate$1;

/**
 * Set or remove the specified key in the `HashMap` using the specified
 * update function. The value of the specified key will be computed using the
 * provided hash.
 *
 * The update function will be invoked with the current value of the key if it
 * exists, or `None` if no such value exists.
 *
 * @since 2.0.0
 */
modifyAt;

/**
 * Alter the value of the specified key in the `HashMap` using the specified
 * update function. The value of the specified key will be computed using the
 * provided hash.
 *
 * The update function will be invoked with the current value of the key if it
 * exists, or `None` if no such value exists.
 *
 * This function will always either update or insert a value into the `HashMap`.
 *
 * @since 2.0.0
 */
modifyHash;

/**
 * Updates the value of the specified key within the `HashMap` if it exists.
 *
 * @since 2.0.0
 */
modify$5;

/**
 * Performs a union of this `HashMap` and that `HashMap`.
 *
 * @since 2.0.0
 */
union$8;

/**
 * Remove the entry for the specified key in the `HashMap` using the internal
 * hashing function.
 *
 * @since 2.0.0
 */
const remove$7 = remove$9;

/**
 * Removes all entries in the `HashMap` which have the specified keys.
 *
 * @since 2.0.0
 */
removeMany;

/**
 * Maps over the entries of the `HashMap` using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map$i = map$k;

/**
 * Chains over the entries of the `HashMap` using the specified function.
 *
 * **NOTE**: the hash and equal of both maps have to be the same.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatMap$a;

/**
 * Applies the specified function to the entries of the `HashMap`.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEach$9 = forEach$b;

/**
 * Reduces the specified state over the entries of the `HashMap`.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce$e = reduce$g;

/**
 * Filters entries out of a `HashMap` using the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
filter$8;

/**
 * Filters out `None` values from a `HashMap` of `Options`s.
 *
 * @since 2.0.0
 * @category filtering
 */
compact;

/**
 * Maps over the entries of the `HashMap` using the specified partial function
 * and filters out `None` values.
 *
 * @since 2.0.0
 * @category filtering
 */
filterMap$1;

/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
findFirst$5;

/** @internal */
const HashMapPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferHashMapPatch");
function variance$4(a) {
  return a;
}

/** @internal */
const PatchProto$2 = {
  ...Structural.prototype,
  [HashMapPatchTypeId]: {
    _Value: variance$4,
    _Key: variance$4,
    _Patch: variance$4
  }
};
const EmptyProto$2 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$2), {
  _tag: "Empty"
});
const _empty$2 = /*#__PURE__*/Object.create(EmptyProto$2);

/** @internal */
const empty$t = () => _empty$2;
const AndThenProto$2 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$2), {
  _tag: "AndThen"
});
const makeAndThen$2 = (first, second) => {
  const o = Object.create(AndThenProto$2);
  o.first = first;
  o.second = second;
  return o;
};
const AddProto$1 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$2), {
  _tag: "Add"
});
const makeAdd$1 = (key, value) => {
  const o = Object.create(AddProto$1);
  o.key = key;
  o.value = value;
  return o;
};
const RemoveProto$1 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$2), {
  _tag: "Remove"
});
const makeRemove$1 = key => {
  const o = Object.create(RemoveProto$1);
  o.key = key;
  return o;
};
const UpdateProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$2), {
  _tag: "Update"
});
const makeUpdate = (key, patch) => {
  const o = Object.create(UpdateProto);
  o.key = key;
  o.patch = patch;
  return o;
};
/** @internal */
const diff$6 = options => {
  const [removed, patch] = reduce$e([options.oldValue, empty$t()], ([map, patch], newValue, key) => {
    const option = get$g(key)(map);
    switch (option._tag) {
      case "Some":
        {
          const valuePatch = options.differ.diff(option.value, newValue);
          if (equals$1(valuePatch, options.differ.empty)) {
            return [remove$7(key)(map), patch];
          }
          return [remove$7(key)(map), combine$7(makeUpdate(key, valuePatch))(patch)];
        }
      case "None":
        {
          return [map, combine$7(makeAdd$1(key, newValue))(patch)];
        }
    }
  })(options.newValue);
  return reduce$e(patch, (patch, _, key) => combine$7(makeRemove$1(key))(patch))(removed);
};

/** @internal */
const combine$7 = /*#__PURE__*/dual(2, (self, that) => makeAndThen$2(self, that));

/** @internal */
const patch$7 = /*#__PURE__*/dual(3, (self, oldValue, differ) => {
  let map = oldValue;
  let patches = of$3(self);
  while (isNonEmpty$5(patches)) {
    const head = headNonEmpty(patches);
    const tail = tailNonEmpty(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = prepend$2(head.first)(prepend$2(head.second)(tail));
          break;
        }
      case "Add":
        {
          map = set$b(head.key, head.value)(map);
          patches = tail;
          break;
        }
      case "Remove":
        {
          map = remove$7(head.key)(map);
          patches = tail;
          break;
        }
      case "Update":
        {
          const option = get$g(head.key)(map);
          if (option._tag === "Some") {
            map = set$b(head.key, differ.patch(head.patch, option.value))(map);
          }
          patches = tail;
          break;
        }
    }
  }
  return map;
});

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category refinements
 */
const isHashSet = isHashSet$1;

/**
 * Creates an empty `HashSet`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$s = empty$v;

/**
 * Construct a new `HashSet` from a `Collection` of values
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable$7 = fromIterable$9;

/**
 * Construct a new `HashSet` from a variable number of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const make$Z = make$$;

/**
 * Checks if the specified value exists in the `HashSet`.
 *
 * @since 2.0.0
 * @category elements
 */
const has$5 = has$7;

/**
 * Check if a predicate holds true for some `HashSet` element.
 *
 * @since 2.0.0
 * @category elements
 */
some$4;

/**
 * Check if a predicate holds true for every `HashSet` element.
 *
 * @since 2.0.0
 * @category elements
 */
const every$5 = every$6;

/**
 * Returns `true` if and only if every element in the this `HashSet` is an
 * element of the second set,
 *
 * **NOTE**: the hash and equal of both sets must be the same.
 *
 * @since 2.0.0
 * @category elements
 */
isSubset;

/**
 * Returns an `IterableIterator` of the values in the `HashSet`.
 *
 * @since 2.0.0
 * @category getters
 */
values$3;

/**
 * Calculates the number of values in the `HashSet`.
 *
 * @since 2.0.0
 * @category getters
 */
const size$g = size$i;

/**
 * Marks the `HashSet` as mutable.
 *
 * @since 2.0.0
 */
beginMutation;

/**
 * Marks the `HashSet` as immutable.
 *
 * @since 2.0.0
 */
endMutation;

/**
 * Mutates the `HashSet` within the context of the provided function.
 *
 * @since 2.0.0
 */
mutate;

/**
 * Adds a value to the `HashSet`.
 *
 * @since 2.0.0
 */
const add$2 = add$3;

/**
 * Removes a value from the `HashSet`.
 *
 * @since 2.0.0
 */
const remove$6 = remove$8;

/**
 * Computes the set difference between this `HashSet` and the specified
 * `Iterable<A>`.
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @since 2.0.0
 */
const difference$1 = difference$2;

/**
 * Returns a `HashSet` of values which are present in both this set and that
 * `Iterable<A>`.
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @since 2.0.0
 */
intersection$1;

/**
 * Computes the set union `(`self` + `that`)` between this `HashSet` and the
 * specified `Iterable<A>`.
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @since 2.0.0
 */
const union$6 = union$7;

/**
 * Checks if a value is present in the `HashSet`. If it is present, the value
 * will be removed from the `HashSet`, otherwise the value will be added to the
 * `HashSet`.
 *
 * @since 2.0.0
 */
toggle;

/**
 * Maps over the values of the `HashSet` using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map$h = map$j;

/**
 * Chains over the values of the `HashSet` using the specified function.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap$8 = flatMap$9;

/**
 * Applies the specified function to the values of the `HashSet`.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEach$8 = forEach$a;

/**
 * Reduces the specified state over the values of the `HashSet`.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce$d = reduce$f;

/**
 * Filters values out of a `HashSet` using the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
filter$7;

/**
 * Partition the values of a `HashSet` using the specified predicate.
 *
 * If a value matches the predicate, it will be placed into the `HashSet` on the
 * right side of the resulting `Tuple`, otherwise the value will be placed into
 * the left side.
 *
 * @since 2.0.0
 * @category partitioning
 */
partition$4;

/** @internal */
const HashSetPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferHashSetPatch");
function variance$3(a) {
  return a;
}

/** @internal */
const PatchProto$1 = {
  ...Structural.prototype,
  [HashSetPatchTypeId]: {
    _Value: variance$3,
    _Key: variance$3,
    _Patch: variance$3
  }
};
const EmptyProto$1 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$1), {
  _tag: "Empty"
});
const _empty$1 = /*#__PURE__*/Object.create(EmptyProto$1);

/** @internal */
const empty$r = () => _empty$1;
const AndThenProto$1 = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$1), {
  _tag: "AndThen"
});

/** @internal */
const makeAndThen$1 = (first, second) => {
  const o = Object.create(AndThenProto$1);
  o.first = first;
  o.second = second;
  return o;
};
const AddProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$1), {
  _tag: "Add"
});

/** @internal */
const makeAdd = value => {
  const o = Object.create(AddProto);
  o.value = value;
  return o;
};
const RemoveProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto$1), {
  _tag: "Remove"
});

/** @internal */
const makeRemove = value => {
  const o = Object.create(RemoveProto);
  o.value = value;
  return o;
};
/** @internal */
const diff$5 = (oldValue, newValue) => {
  const [removed, patch] = reduce$d([oldValue, empty$r()], ([set, patch], value) => {
    if (has$5(value)(set)) {
      return [remove$6(value)(set), patch];
    }
    return [set, combine$6(makeAdd(value))(patch)];
  })(newValue);
  return reduce$d(patch, (patch, value) => combine$6(makeRemove(value))(patch))(removed);
};

/** @internal */
const combine$6 = /*#__PURE__*/dual(2, (self, that) => makeAndThen$1(self, that));

/** @internal */
const patch$6 = /*#__PURE__*/dual(2, (self, oldValue) => {
  let set = oldValue;
  let patches = of$3(self);
  while (isNonEmpty$5(patches)) {
    const head = headNonEmpty(patches);
    const tail = tailNonEmpty(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = prepend$2(head.first)(prepend$2(head.second)(tail));
          break;
        }
      case "Add":
        {
          set = add$2(head.value)(set);
          patches = tail;
          break;
        }
      case "Remove":
        {
          set = remove$6(head.value)(set);
          patches = tail;
        }
    }
  }
  return set;
});

/** @internal */
const OrPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferOrPatch");
function variance$2(a) {
  return a;
}

/** @internal */
const PatchProto = {
  ...Structural.prototype,
  [OrPatchTypeId]: {
    _Value: variance$2,
    _Key: variance$2,
    _Patch: variance$2
  }
};

/** @internal */

const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);

/** @internal */
const empty$q = () => _empty;

/** @internal */

const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});

/** @internal */
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};

/** @internal */

const SetLeftProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "SetLeft"
});

/** @internal */
const makeSetLeft = value => {
  const o = Object.create(SetLeftProto);
  o.value = value;
  return o;
};

/** @internal */

const SetRightProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "SetRight"
});

/** @internal */
const makeSetRight = value => {
  const o = Object.create(SetRightProto);
  o.value = value;
  return o;
};

/** @internal */

const UpdateLeftProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "UpdateLeft"
});

/** @internal */
const makeUpdateLeft = patch => {
  const o = Object.create(UpdateLeftProto);
  o.patch = patch;
  return o;
};

/** @internal */

const UpdateRightProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "UpdateRight"
});

/** @internal */
const makeUpdateRight = patch => {
  const o = Object.create(UpdateRightProto);
  o.patch = patch;
  return o;
};
/** @internal */
const diff$4 = options => {
  switch (options.oldValue._tag) {
    case "Left":
      {
        switch (options.newValue._tag) {
          case "Left":
            {
              const valuePatch = options.left.diff(options.oldValue.left, options.newValue.left);
              if (equals$1(valuePatch, options.left.empty)) {
                return empty$q();
              }
              return makeUpdateLeft(valuePatch);
            }
          case "Right":
            {
              return makeSetRight(options.newValue.right);
            }
        }
      }
    case "Right":
      {
        switch (options.newValue._tag) {
          case "Left":
            {
              return makeSetLeft(options.newValue.left);
            }
          case "Right":
            {
              const valuePatch = options.right.diff(options.oldValue.right, options.newValue.right);
              if (equals$1(valuePatch, options.right.empty)) {
                return empty$q();
              }
              return makeUpdateRight(valuePatch);
            }
        }
      }
  }
};

/** @internal */
const combine$5 = /*#__PURE__*/dual(2, (self, that) => makeAndThen(self, that));

/** @internal */
const patch$5 = /*#__PURE__*/dual(2, (self, {
  left: left$1,
  oldValue,
  right: right$1
}) => {
  let patches = of$3(self);
  let result = oldValue;
  while (isNonEmpty$5(patches)) {
    const head = headNonEmpty(patches);
    const tail = tailNonEmpty(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = prepend$2(head.first)(prepend$2(head.second)(tail));
          break;
        }
      case "UpdateLeft":
        {
          if (result._tag === "Left") {
            result = left(left$1.patch(head.patch, result.left));
          }
          patches = tail;
          break;
        }
      case "UpdateRight":
        {
          if (result._tag === "Right") {
            result = right(right$1.patch(head.patch, result.right));
          }
          patches = tail;
          break;
        }
      case "SetLeft":
        {
          result = left(head.value);
          patches = tail;
          break;
        }
      case "SetRight":
        {
          result = right(head.value);
          patches = tail;
          break;
        }
    }
  }
  return result;
});

/** @internal */
const DifferTypeId = /*#__PURE__*/Symbol.for("effect/Differ");

/** @internal */
const DifferProto = {
  [DifferTypeId]: {
    _P: identity$1,
    _V: identity$1
  }
};

/** @internal */
const make$Y = params => {
  const differ = Object.create(DifferProto);
  differ.empty = params.empty;
  differ.diff = params.diff;
  differ.combine = params.combine;
  differ.patch = params.patch;
  return differ;
};

/** @internal */
const environment$1 = () => make$Y({
  empty: empty$x(),
  combine: (first, second) => combine$8(second)(first),
  diff: (oldValue, newValue) => diff$7(oldValue, newValue),
  patch: (patch$1, oldValue) => patch$8(oldValue)(patch$1)
});

/** @internal */
const chunk$2 = differ => make$Y({
  empty: empty$y(),
  combine: (first, second) => combine$9(second)(first),
  diff: (oldValue, newValue) => diff$8({
    oldValue,
    newValue,
    differ
  }),
  patch: (patch, oldValue) => patch$9(oldValue, differ)(patch)
});

/** @internal */
const hashMap$1 = differ => make$Y({
  empty: empty$t(),
  combine: (first, second) => combine$7(second)(first),
  diff: (oldValue, newValue) => diff$6({
    oldValue,
    newValue,
    differ
  }),
  patch: (patch, oldValue) => patch$7(oldValue, differ)(patch)
});

/** @internal */
const hashSet$2 = () => make$Y({
  empty: empty$r(),
  combine: (first, second) => combine$6(second)(first),
  diff: (oldValue, newValue) => diff$5(oldValue, newValue),
  patch: (patch, oldValue) => patch$6(oldValue)(patch)
});

/** @internal */
const orElseEither$3 = /*#__PURE__*/dual(2, (self, that) => make$Y({
  empty: empty$q(),
  combine: (first, second) => combine$5(first, second),
  diff: (oldValue, newValue) => diff$4({
    oldValue,
    newValue,
    left: self,
    right: that
  }),
  patch: (patch, oldValue) => patch$5(patch, {
    oldValue,
    left: self,
    right: that
  })
}));

/** @internal */
const transform$3 = /*#__PURE__*/dual(2, (self, {
  toNew,
  toOld
}) => make$Y({
  empty: self.empty,
  combine: (first, second) => self.combine(first, second),
  diff: (oldValue, newValue) => self.diff(toOld(oldValue), toOld(newValue)),
  patch: (patch, oldValue) => toNew(self.patch(patch, toOld(oldValue)))
}));

/** @internal */
const update$8 = () => updateWith$1((_, a) => a);

/** @internal */
const updateWith$1 = f => make$Y({
  empty: identity$1,
  combine: (first, second) => {
    if (first === identity$1) {
      return second;
    }
    if (second === identity$1) {
      return first;
    }
    return a => second(first(a));
  },
  diff: (oldValue, newValue) => {
    if (equals$1(oldValue, newValue)) {
      return identity$1;
    }
    return constant(newValue);
  },
  patch: (patch, oldValue) => f(oldValue, patch(oldValue))
});

/** @internal */
const zip$b = /*#__PURE__*/dual(2, (self, that) => make$Y({
  empty: [self.empty, that.empty],
  combine: (first, second) => [self.combine(first[0], second[0]), that.combine(first[1], second[1])],
  diff: (oldValue, newValue) => [self.diff(oldValue[0], newValue[0]), that.diff(oldValue[1], newValue[1])],
  patch: (patch, oldValue) => [self.patch(patch[0], oldValue[0]), that.patch(patch[1], oldValue[1])]
}));

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */
DifferTypeId;

/**
 * Constructs a new `Differ`.
 *
 * @since 2.0.0
 * @category constructors
 */
const make$X = make$Y;

/**
 * Constructs a differ that knows how to diff `Env` values.
 *
 * @since 2.0.0
 * @category constructors
 */
const environment = environment$1;

/**
 * Constructs a differ that knows how to diff a `Chunk` of values given a
 * differ that knows how to diff the values.
 *
 * @since 2.0.0
 * @category constructors
 */
chunk$2;

/**
 * Constructs a differ that knows how to diff a `HashMap` of keys and values given
 * a differ that knows how to diff the values.
 *
 * @since 2.0.0
 * @category constructors
 */
hashMap$1;

/**
 * Constructs a differ that knows how to diff a `HashSet` of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const hashSet$1 = hashSet$2;

/**
 * Combines this differ and the specified differ to produce a differ that
 * knows how to diff the sum of their values.
 *
 * @since 2.0.0
 */
orElseEither$3;

/**
 * Transforms the type of values that this differ knows how to differ using
 * the specified functions that map the new and old value types to each other.
 *
 * @since 2.0.0
 */
transform$3;

/**
 * Constructs a differ that just diffs two values by returning a function that
 * sets the value to the new value. This differ does not support combining
 * multiple updates to the value compositionally and should only be used when
 * there is no compositional way to update them.
 *
 * @since 2.0.0
 */
const update$7 = update$8;

/**
 * A variant of `update` that allows specifying the function that will be used
 * to combine old values with new values.
 *
 * @since 2.0.0
 */
updateWith$1;

/**
 * Combines this differ and the specified differ to produce a new differ that
 * knows how to diff the product of their values.
 *
 * @since 2.0.0
 */
zip$b;

/**
 * @since 2.0.0
 */
const TypeId$9 = /*#__PURE__*/Symbol.for("effect/MutableRef");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

const MutableRefProto = {
  [TypeId$9]: TypeId$9,
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableRef",
      current: toJSON(this.current)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/**
 * @since 2.0.0
 * @category constructors
 */
const make$W = value => {
  const ref = Object.create(MutableRefProto);
  ref.current = value;
  return ref;
};

/**
 * @since 2.0.0
 * @category general
 */
const compareAndSet = /*#__PURE__*/dual(3, (self, oldValue, newValue) => {
  if (equals$1(oldValue, self.current)) {
    self.current = newValue;
    return true;
  }
  return false;
});

/**
 * @since 2.0.0
 * @category numeric
 */
const decrementAndGet = self => updateAndGet$2(self, n => n - 1);

/**
 * @since 2.0.0
 * @category general
 */
const get$f = self => self.current;

/**
 * @since 2.0.0
 * @category numeric
 */
const incrementAndGet = self => updateAndGet$2(self, n => n + 1);

/**
 * @since 2.0.0
 * @category general
 */
const set$a = /*#__PURE__*/dual(2, (self, value) => {
  self.current = value;
  return self;
});

/**
 * @since 2.0.0
 * @category general
 */
const setAndGet$2 = /*#__PURE__*/dual(2, (self, value) => {
  self.current = value;
  return self.current;
});

/**
 * @since 2.0.0
 * @category general
 */
const update$6 = /*#__PURE__*/dual(2, (self, f) => set$a(self, f(get$f(self))));

/**
 * @since 2.0.0
 * @category general
 */
const updateAndGet$2 = /*#__PURE__*/dual(2, (self, f) => setAndGet$2(self, f(get$f(self))));

/** @internal */
const FiberIdSymbolKey = "effect/FiberId";

/** @internal */
const FiberIdTypeId = /*#__PURE__*/Symbol.for(FiberIdSymbolKey);

/** @internal */
const OP_NONE = "None";

/** @internal */

/** @internal */
const OP_RUNTIME = "Runtime";

/** @internal */

/** @internal */
const OP_COMPOSITE = "Composite";

/** @internal */

/** @internal */
class None$2 {
  [FiberIdTypeId] = FiberIdTypeId;
  _tag = OP_NONE;
  [symbol$1]() {
    return pipe(hash$1(FiberIdSymbolKey), combine$a(hash$1(this._tag)));
  }
  [symbol](that) {
    return isFiberId(that) && that._tag === OP_NONE;
  }
  toString() {
    return toString(this.toJSON());
  }
  toJSON() {
    return {
      _id: "FiberId",
      _tag: this._tag
    };
  }
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
}

/** @internal */
class Runtime {
  [FiberIdTypeId] = FiberIdTypeId;
  _tag = OP_RUNTIME;
  constructor(id, startTimeMillis) {
    this.id = id;
    this.startTimeMillis = startTimeMillis;
  }
  [symbol$1]() {
    return pipe(hash$1(FiberIdSymbolKey), combine$a(hash$1(this._tag)), combine$a(hash$1(this.id)), combine$a(hash$1(this.startTimeMillis)));
  }
  [symbol](that) {
    return isFiberId(that) && that._tag === OP_RUNTIME && this.id === that.id && this.startTimeMillis === that.startTimeMillis;
  }
  toString() {
    return toString(this.toJSON());
  }
  toJSON() {
    return {
      _id: "FiberId",
      _tag: this._tag,
      id: this.id,
      startTimeMillis: this.startTimeMillis
    };
  }
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
}

/** @internal */
class Composite {
  [FiberIdTypeId] = FiberIdTypeId;
  _tag = OP_COMPOSITE;
  constructor(left, right) {
    this.left = left;
    this.right = right;
  }
  [symbol$1]() {
    return pipe(hash$1(FiberIdSymbolKey), combine$a(hash$1(this._tag)), combine$a(hash$1(this.left)), combine$a(hash$1(this.right)));
  }
  [symbol](that) {
    return isFiberId(that) && that._tag === OP_COMPOSITE && equals$1(this.left, that.left) && equals$1(this.right, that.right);
  }
  toString() {
    return toString(this.toJSON());
  }
  toJSON() {
    return {
      _id: "FiberId",
      _tag: this._tag,
      left: toJSON(this.left),
      right: toJSON(this.right)
    };
  }
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
}

/** @internal */
const none$7 = /*#__PURE__*/new None$2();

/** @internal */
const runtime$2 = (id, startTimeMillis) => {
  return new Runtime(id, startTimeMillis);
};

/** @internal */
const composite = (left, right) => {
  return new Composite(left, right);
};

/** @internal */
const isFiberId = self => {
  return typeof self === "object" && self != null && FiberIdTypeId in self;
};

/** @internal */
const isNone = self => {
  return self._tag === OP_NONE || pipe(toSet$2(self), every$5(id => isNone(id)));
};

/** @internal */
const isRuntime = self => {
  return self._tag === OP_RUNTIME;
};

/** @internal */
const isComposite = self => {
  return self._tag === OP_COMPOSITE;
};

/** @internal */
const combine$4 = /*#__PURE__*/dual(2, (self, that) => {
  if (self._tag === OP_NONE) {
    return that;
  }
  if (that._tag === OP_NONE) {
    return self;
  }
  return new Composite(self, that);
});

/** @internal */
const combineAll = fiberIds => {
  return pipe(fiberIds, reduce$d(none$7, (a, b) => combine$4(b)(a)));
};

/** @internal */
const getOrElse$2 = /*#__PURE__*/dual(2, (self, that) => isNone(self) ? that : self);

/** @internal */
const ids$2 = self => {
  switch (self._tag) {
    case OP_NONE:
      {
        return empty$s();
      }
    case OP_RUNTIME:
      {
        return make$Z(self.id);
      }
    case OP_COMPOSITE:
      {
        return pipe(ids$2(self.left), union$6(ids$2(self.right)));
      }
  }
};
const _fiberCounter = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/Fiber/Id/_fiberCounter"), () => make$W(0));

/** @internal */
const make$V = (id, startTimeSeconds) => {
  return new Runtime(id, startTimeSeconds);
};

/** @internal */
const threadName$1 = self => {
  const identifiers = Array.from(ids$2(self)).map(n => `#${n}`).join(",");
  return identifiers;
};

/** @internal */
const toOption = self => {
  const fiberIds = toSet$2(self);
  if (size$g(fiberIds) === 0) {
    return none$8();
  }
  let first = true;
  let acc;
  for (const fiberId of fiberIds) {
    if (first) {
      acc = fiberId;
      first = false;
    } else {
      // @ts-expect-error
      acc = pipe(acc, combine$4(fiberId));
    }
  }
  // @ts-expect-error
  return some$6(acc);
};

/** @internal */
const toSet$2 = self => {
  switch (self._tag) {
    case OP_NONE:
      {
        return empty$s();
      }
    case OP_RUNTIME:
      {
        return make$Z(self);
      }
    case OP_COMPOSITE:
      {
        return pipe(toSet$2(self.left), union$6(toSet$2(self.right)));
      }
  }
};

/** @internal */
const unsafeMake$7 = () => {
  const id = get$f(_fiberCounter);
  pipe(_fiberCounter, set$a(id + 1));
  return new Runtime(id, new Date().getTime());
};

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
FiberIdTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const none$6 = none$7;

/**
 * @since 2.0.0
 * @category constructors
 */
runtime$2;

/**
 * @since 2.0.0
 * @category constructors
 */
composite;

/**
 * Returns `true` if the specified unknown value is a `FiberId`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isFiberId;

/**
 * Returns `true` if the `FiberId` is a `None`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isNone;

/**
 * Returns `true` if the `FiberId` is a `Runtime`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isRuntime;

/**
 * Returns `true` if the `FiberId` is a `Composite`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isComposite;

/**
 * Combine two `FiberId`s.
 *
 * @since 2.0.0
 * @category constructors
 */
const combine$3 = combine$4;

/**
 * Combines a set of `FiberId`s into a single `FiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
combineAll;

/**
 * Returns this `FiberId` if it is not `None`, otherwise returns that `FiberId`.
 *
 * @since 2.0.0
 * @category utils
 */
const getOrElse$1 = getOrElse$2;

/**
 * Get the set of identifiers for this `FiberId`.
 *
 * @since 2.0.0
 * @category destructors
 */
const ids$1 = ids$2;

/**
 * Creates a new `FiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
make$V;

/**
 * Creates a string representing the name of the current thread of execution
 * represented by the specified `FiberId`.
 *
 * @since 2.0.0
 * @category destructors
 */
const threadName = threadName$1;

/**
 * Convert a `FiberId` into an `Option<FiberId>`.
 *
 * @since 2.0.0
 * @category destructors
 */
toOption;

/**
 * Convert a `FiberId` into a `HashSet<FiberId>`.
 *
 * @since 2.0.0
 * @category destructors
 */
toSet$2;

/**
 * Unsafely creates a new `FiberId`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake$6 = unsafeMake$7;

/**
 * A data type for immutable linked lists representing ordered collections of elements of type `A`.
 *
 * This data type is optimal for last-in-first-out (LIFO), stack-like access patterns. If you need another access pattern, for example, random access or FIFO, consider using a collection more suited to this than `List`.
 *
 * **Performance**
 *
 * - Time: `List` has `O(1)` prepend and head/tail access. Most other operations are `O(n)` on the number of elements in the list. This includes the index-based lookup of elements, `length`, `append` and `reverse`.
 * - Space: `List` implements structural sharing of the tail list. This means that many operations are either zero- or constant-memory cost.
 *
 * @since 2.0.0
 */

/**
 * Represents an immutable linked list of elements of type `A`.
 *
 * A `List` is optimal for last-in-first-out (LIFO), stack-like access patterns.
 * If you need another access pattern, for example, random access or FIFO,
 * consider using a collection more suited for that other than `List`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category symbol
 */
const TypeId$8 = /*#__PURE__*/Symbol.for("effect/List");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * Converts the specified `List` to a `ReadonlyArray`.
 *
 * @category conversions
 * @since 2.0.0
 */
const toReadonlyArray$3 = self => Array.from(self);

/**
 * @category equivalence
 * @since 2.0.0
 */
const getEquivalence = isEquivalent => mapInput$6(getEquivalence$2(isEquivalent), toReadonlyArray$3);
const _equivalence = /*#__PURE__*/getEquivalence(equals$1);
const ConsProto = {
  [TypeId$8]: TypeId$8,
  _tag: "Cons",
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "List",
      _tag: "Cons",
      values: toReadonlyArray$3(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  [symbol](that) {
    return isList(that) && this._tag === that._tag && _equivalence(this, that);
  },
  [symbol$1]() {
    return array$1(toReadonlyArray$3(this));
  },
  [Symbol.iterator]() {
    let done = false;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let self = this;
    return {
      next() {
        if (done) {
          return this.return();
        }
        if (self._tag === "Nil") {
          done = true;
          return this.return();
        }
        const value = self.head;
        self = self.tail;
        return {
          done,
          value
        };
      },
      return(value) {
        if (!done) {
          done = true;
        }
        return {
          done: true,
          value
        };
      }
    };
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const makeCons = (head, tail) => {
  const cons = Object.create(ConsProto);
  cons.head = head;
  cons.tail = tail;
  return cons;
};
const NilProto = {
  [TypeId$8]: TypeId$8,
  _tag: "Nil",
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "List",
      _tag: "Nil"
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  [symbol$1]() {
    return array$1(toReadonlyArray$3(this));
  },
  [symbol](that) {
    return isList(that) && this._tag === that._tag;
  },
  [Symbol.iterator]() {
    return {
      next() {
        return {
          done: true,
          value: undefined
        };
      }
    };
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const _Nil = /*#__PURE__*/Object.create(NilProto);

/**
 * Returns `true` if the specified value is a `List`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isList = u => isObject(u) && TypeId$8 in u;

/**
 * Returns `true` if the specified value is a `List.Nil<A>`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isNil = self => self._tag === "Nil";

/**
 * Returns `true` if the specified value is a `List.Cons<A>`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isCons = self => self._tag === "Cons";

/**
 * Constructs a new empty `List<A>`.
 *
 * @since 2.0.0
 * @category constructors
 */
const nil = () => _Nil;

/**
 * Constructs a new `List.Cons<A>` from the specified `head` and `tail` values.
 *
 * @since 2.0.0
 * @category constructors
 */
const cons = (head, tail) => makeCons(head, tail);

/**
 * Constructs a new empty `List<A>`.
 *
 * Alias of {@link nil}.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$p = nil;

/**
 * Constructs a new `List<A>` from the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const of$2 = value => makeCons(value, _Nil);

/**
 * Concatentates the specified lists together.
 *
 * @category concatenating
 * @since 2.0.0
 */
const appendAll = /*#__PURE__*/dual(2, (self, that) => prependAll(that, self));

/**
 * Prepends the specified element to the beginning of the list.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prepend$1 = /*#__PURE__*/dual(2, (self, element) => cons(element, self));

/**
 * Prepends the specified prefix list to the beginning of the specified list.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prependAll = /*#__PURE__*/dual(2, (self, prefix) => {
  if (isNil(self)) {
    return prefix;
  } else if (isNil(prefix)) {
    return self;
  } else {
    const result = makeCons(prefix.head, self);
    let curr = result;
    let that = prefix.tail;
    while (!isNil(that)) {
      const temp = makeCons(that.head, self);
      curr.tail = temp;
      curr = temp;
      that = that.tail;
    }
    return result;
  }
});

/**
 * Folds over the elements of the list using the specified function, using the
 * specified initial value.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce$c = /*#__PURE__*/dual(3, (self, zero, f) => {
  let acc = zero;
  let these = self;
  while (!isNil(these)) {
    acc = f(acc, these.head);
    these = these.tail;
  }
  return acc;
});

/**
 * Returns a new list with the elements of the specified list in reverse order.
 *
 * @since 2.0.0
 * @category elements
 */
const reverse = self => {
  let result = empty$p();
  let these = self;
  while (!isNil(these)) {
    result = prepend$1(result, these.head);
    these = these.tail;
  }
  return result;
};

/**
 * Unsafely returns the first element of the specified `List`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeHead = self => {
  if (isNil(self)) {
    throw new Error("Expected List to be non-empty");
  }
  return self.head;
};

/**
 * Unsafely returns the tail of the specified `List`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeTail = self => {
  if (isNil(self)) {
    throw new Error("Expected List to be non-empty");
  }
  return self.tail;
};

/** @internal */
const empty$o = {
  _tag: "Empty"
};

/**
 * Combines this collection of blocked requests with the specified collection
 * of blocked requests, in parallel.
 *
 * @internal
 */
const par = (self, that) => ({
  _tag: "Par",
  left: self,
  right: that
});

/**
 * Combines this collection of blocked requests with the specified collection
 * of blocked requests, in sequence.
 *
 * @internal
 */
const seq = (self, that) => ({
  _tag: "Seq",
  left: self,
  right: that
});

/**
 * Constructs a collection of blocked requests from the specified blocked
 * request and data source.
 *
 * @internal
 */
const single = (dataSource, blockedRequest) => ({
  _tag: "Single",
  dataSource,
  blockedRequest
});

/** @internal */
const MapRequestResolversReducer = f => ({
  emptyCase: () => empty$o,
  parCase: (left, right) => par(left, right),
  seqCase: (left, right) => seq(left, right),
  singleCase: (dataSource, blockedRequest) => single(f(dataSource), blockedRequest)
});
/**
 * Transforms all data sources with the specified data source aspect, which
 * can change the environment type of data sources but must preserve the
 * request type of each data source.
 *
 * @internal
 */
const mapRequestResolvers = (self, f) => reduce$b(self, MapRequestResolversReducer(f));

/**
 * Folds over the cases of this collection of blocked requests with the
 * specified functions.
 *
 * @internal
 */
const reduce$b = (self, reducer) => {
  let input = of$2(self);
  let output = empty$p();
  while (isCons(input)) {
    const current = input.head;
    switch (current._tag) {
      case "Empty":
        {
          output = cons(right(reducer.emptyCase()), output);
          input = input.tail;
          break;
        }
      case "Par":
        {
          output = cons(left({
            _tag: "ParCase"
          }), output);
          input = cons(current.left, cons(current.right, input.tail));
          break;
        }
      case "Seq":
        {
          output = cons(left({
            _tag: "SeqCase"
          }), output);
          input = cons(current.left, cons(current.right, input.tail));
          break;
        }
      case "Single":
        {
          const result = reducer.singleCase(current.dataSource, current.blockedRequest);
          output = cons(right(result), output);
          input = input.tail;
          break;
        }
    }
  }
  const result = reduce$c(output, empty$p(), (acc, current) => {
    switch (current._tag) {
      case "Left":
        {
          const left = unsafeHead(acc);
          const right = unsafeHead(unsafeTail(acc));
          const tail = unsafeTail(unsafeTail(acc));
          switch (current.left._tag) {
            case "ParCase":
              {
                return cons(reducer.parCase(left, right), tail);
              }
            case "SeqCase":
              {
                return cons(reducer.seqCase(left, right), tail);
              }
          }
        }
      case "Right":
        {
          return cons(current.right, acc);
        }
    }
  });
  if (isNil(result)) {
    throw new Error("BUG: BlockedRequests.reduce - please report an issue at https://github.com/Effect-TS/query/issues");
  }
  return result.head;
};

/**
 * Flattens a collection of blocked requests into a collection of pipelined
 * and batched requests that can be submitted for execution.
 *
 * @internal
 */
const flatten$8 = self => {
  let current = of$2(self);
  let updated = empty$p();
  // eslint-disable-next-line no-constant-condition
  while (1) {
    const [parallel, sequential] = reduce$c(current, [parallelCollectionEmpty(), empty$p()], ([parallel, sequential], blockedRequest) => {
      const [par, seq] = step$2(blockedRequest);
      return [parallelCollectionCombine(parallel, par), appendAll(sequential, seq)];
    });
    updated = merge$7(updated, parallel);
    if (isNil(sequential)) {
      return reverse(updated);
    }
    current = sequential;
  }
  throw new Error("BUG: BlockedRequests.flatten - please report an issue at https://github.com/Effect-TS/query/issues");
};

/**
 * Takes one step in evaluating a collection of blocked requests, returning a
 * collection of blocked requests that can be performed in parallel and a list
 * of blocked requests that must be performed sequentially after those
 * requests.
 */
const step$2 = requests => {
  let current = requests;
  let parallel = parallelCollectionEmpty();
  let stack = empty$p();
  let sequential = empty$p();
  // eslint-disable-next-line no-constant-condition
  while (1) {
    switch (current._tag) {
      case "Empty":
        {
          if (isNil(stack)) {
            return [parallel, sequential];
          }
          current = stack.head;
          stack = stack.tail;
          break;
        }
      case "Par":
        {
          stack = cons(current.right, stack);
          current = current.left;
          break;
        }
      case "Seq":
        {
          const left = current.left;
          const right = current.right;
          switch (left._tag) {
            case "Empty":
              {
                current = right;
                break;
              }
            case "Par":
              {
                const l = left.left;
                const r = left.right;
                current = par(seq(l, right), seq(r, right));
                break;
              }
            case "Seq":
              {
                const l = left.left;
                const r = left.right;
                current = seq(l, seq(r, right));
                break;
              }
            case "Single":
              {
                current = left;
                sequential = cons(right, sequential);
                break;
              }
          }
          break;
        }
      case "Single":
        {
          parallel = parallelCollectionCombine(parallel, parallelCollectionMake(current.dataSource, current.blockedRequest));
          if (isNil(stack)) {
            return [parallel, sequential];
          }
          current = stack.head;
          stack = stack.tail;
          break;
        }
    }
  }
  throw new Error("BUG: BlockedRequests.step - please report an issue at https://github.com/Effect-TS/query/issues");
};

/**
 * Merges a collection of requests that must be executed sequentially with a
 * collection of requests that can be executed in parallel. If the collections
 * are both from the same single data source then the requests can be
 * pipelined while preserving ordering guarantees.
 */
const merge$7 = (sequential, parallel) => {
  if (isNil(sequential)) {
    return of$2(parallelCollectionToSequentialCollection(parallel));
  }
  if (parallelCollectionIsEmpty(parallel)) {
    return sequential;
  }
  const seqHeadKeys = sequentialCollectionKeys(sequential.head);
  const parKeys = parallelCollectionKeys(parallel);
  if (seqHeadKeys.length === 1 && parKeys.length === 1 && equals$1(seqHeadKeys[0], parKeys[0])) {
    return cons(sequentialCollectionCombine(sequential.head, parallelCollectionToSequentialCollection(parallel)), sequential.tail);
  }
  return cons(parallelCollectionToSequentialCollection(parallel), sequential);
};

//
// circular
//

/** @internal */
const EntryTypeId = /*#__PURE__*/Symbol.for("effect/RequestBlock/Entry");

/** @internal */
class EntryImpl {
  [EntryTypeId] = blockedRequestVariance;
  constructor(request, result, listeners, ownerId, state) {
    this.request = request;
    this.result = result;
    this.listeners = listeners;
    this.ownerId = ownerId;
    this.state = state;
  }
}

/** @internal */
const blockedRequestVariance = {
  _R: _ => _
};

/** @internal */
const isEntry = u => {
  return typeof u === "object" && u != null && EntryTypeId in u;
};

/** @internal */
const makeEntry = options => new EntryImpl(options.request, options.result, options.listeners, options.ownerId, options.state);

/** @internal */
const RequestBlockParallelTypeId = /*#__PURE__*/Symbol.for("effect/RequestBlock/RequestBlockParallel");
const parallelVariance = {
  _R: _ => _
};
class ParallelImpl {
  [RequestBlockParallelTypeId] = parallelVariance;
  constructor(map) {
    this.map = map;
  }
}

/** @internal */
const parallelCollectionEmpty = () => new ParallelImpl(empty$u());

/** @internal */
const parallelCollectionMake = (dataSource, blockedRequest) => new ParallelImpl(make$_([dataSource, Array.of(blockedRequest)]));

/** @internal */
const parallelCollectionCombine = (self, that) => new ParallelImpl(reduce$e(self.map, that.map, (map, value, key) => set$b(map, key, match$j(get$g(map, key), {
  onNone: () => value,
  onSome: a => [...a, ...value]
}))));

/** @internal */
const parallelCollectionIsEmpty = self => isEmpty$f(self.map);

/** @internal */
const parallelCollectionKeys = self => Array.from(keys$3(self.map));

/** @internal */
const parallelCollectionToSequentialCollection = self => sequentialCollectionMake(map$i(self.map, x => Array.of(x)));

/** @internal */
const SequentialCollectionTypeId = /*#__PURE__*/Symbol.for("effect/RequestBlock/RequestBlockSequential");

/** @internal */
const sequentialVariance = {
  _R: _ => _
};
class SequentialImpl {
  [SequentialCollectionTypeId] = sequentialVariance;
  constructor(map) {
    this.map = map;
  }
}

/** @internal */
const sequentialCollectionMake = map => new SequentialImpl(map);

/** @internal */
const sequentialCollectionCombine = (self, that) => new SequentialImpl(reduce$e(that.map, self.map, (map, value, key) => set$b(map, key, match$j(get$g(map, key), {
  onNone: () => [],
  onSome: a => [...a, ...value]
}))));

/** @internal */
const sequentialCollectionKeys = self => Array.from(keys$3(self.map));

/** @internal */
const sequentialCollectionToChunk = self => Array.from(self.map);

/** @internal */
const OP_DIE$2 = "Die";

/** @internal */

/** @internal */
const OP_EMPTY$2 = "Empty";

/** @internal */

/** @internal */
const OP_FAIL$4 = "Fail";

/** @internal */

/** @internal */
const OP_INTERRUPT$2 = "Interrupt";

/** @internal */

/** @internal */
const OP_PARALLEL$1 = "Parallel";

/** @internal */

/** @internal */
const OP_SEQUENTIAL$1 = "Sequential";

// -----------------------------------------------------------------------------
// Models
// -----------------------------------------------------------------------------
/** @internal */
const CauseSymbolKey = "effect/Cause";

/** @internal */
const CauseTypeId = /*#__PURE__*/Symbol.for(CauseSymbolKey);

/** @internal */
const variance$1 = {
  _E: _ => _
};

/** @internal */
const proto$c = {
  [CauseTypeId]: variance$1,
  [symbol$1]() {
    return pipe(hash$1(CauseSymbolKey), combine$a(hash$1(flattenCause(this))));
  },
  [symbol](that) {
    return isCause(that) && causeEquals(this, that);
  },
  pipe() {
    return pipeArguments(this, arguments);
  },
  toJSON() {
    switch (this._tag) {
      case "Empty":
        return {
          _id: "Cause",
          _tag: this._tag
        };
      case "Die":
        return {
          _id: "Cause",
          _tag: this._tag,
          defect: toJSON(this.defect)
        };
      case "Interrupt":
        return {
          _id: "Cause",
          _tag: this._tag,
          fiberId: this.fiberId.toJSON()
        };
      case "Fail":
        return {
          _id: "Cause",
          _tag: this._tag,
          failure: toJSON(this.error)
        };
      case "Sequential":
      case "Parallel":
        return {
          _id: "Cause",
          _tag: this._tag,
          left: toJSON(this.left),
          right: toJSON(this.right)
        };
    }
  },
  toString() {
    return pretty$1(this);
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
};

// -----------------------------------------------------------------------------
// Constructors
// -----------------------------------------------------------------------------

/** @internal */
const empty$n = /*#__PURE__*/(() => {
  const o = /*#__PURE__*/Object.create(proto$c);
  o._tag = OP_EMPTY$2;
  return o;
})();

/** @internal */
const fail$g = error => {
  const o = Object.create(proto$c);
  o._tag = OP_FAIL$4;
  o.error = error;
  return o;
};

/** @internal */
const die$a = defect => {
  const o = Object.create(proto$c);
  o._tag = OP_DIE$2;
  o.defect = defect;
  return o;
};

/** @internal */
const interrupt$8 = fiberId => {
  const o = Object.create(proto$c);
  o._tag = OP_INTERRUPT$2;
  o.fiberId = fiberId;
  return o;
};

/** @internal */
const parallel$3 = (left, right) => {
  const o = Object.create(proto$c);
  o._tag = OP_PARALLEL$1;
  o.left = left;
  o.right = right;
  return o;
};

/** @internal */
const sequential$2 = (left, right) => {
  const o = Object.create(proto$c);
  o._tag = OP_SEQUENTIAL$1;
  o.left = left;
  o.right = right;
  return o;
};

// -----------------------------------------------------------------------------
// Refinements
// -----------------------------------------------------------------------------

/** @internal */
const isCause = u => typeof u === "object" && u != null && CauseTypeId in u;

/** @internal */
const isEmptyType = self => self._tag === OP_EMPTY$2;

/** @internal */
const isFailType = self => self._tag === OP_FAIL$4;

/** @internal */
const isDieType$1 = self => self._tag === OP_DIE$2;

/** @internal */
const isInterruptType = self => self._tag === OP_INTERRUPT$2;

/** @internal */
const isSequentialType = self => self._tag === OP_SEQUENTIAL$1;

/** @internal */
const isParallelType = self => self._tag === OP_PARALLEL$1;

// -----------------------------------------------------------------------------
// Getters
// -----------------------------------------------------------------------------

/** @internal */
const size$f = self => reduceWithContext$1(self, void 0, SizeCauseReducer);

/** @internal */
const isEmpty$e = self => {
  if (self._tag === OP_EMPTY$2) {
    return true;
  }
  return reduce$a(self, true, (acc, cause) => {
    switch (cause._tag) {
      case OP_EMPTY$2:
        {
          return some$6(acc);
        }
      case OP_DIE$2:
      case OP_FAIL$4:
      case OP_INTERRUPT$2:
        {
          return some$6(false);
        }
      default:
        {
          return none$8();
        }
    }
  });
};

/** @internal */
const isFailure$6 = self => isSome(failureOption(self));

/** @internal */
const isDie = self => isSome(dieOption(self));

/** @internal */
const isInterrupted$1 = self => isSome(interruptOption(self));

/** @internal */
const isInterruptedOnly$1 = self => reduceWithContext$1(undefined, IsInterruptedOnlyCauseReducer)(self);

/** @internal */
const failures = self => reverse$1(reduce$a(self, empty$z(), (list, cause) => cause._tag === OP_FAIL$4 ? some$6(pipe(list, prepend$2(cause.error))) : none$8()));

/** @internal */
const defects = self => reverse$1(reduce$a(self, empty$z(), (list, cause) => cause._tag === OP_DIE$2 ? some$6(pipe(list, prepend$2(cause.defect))) : none$8()));

/** @internal */
const interruptors = self => reduce$a(self, empty$s(), (set, cause) => cause._tag === OP_INTERRUPT$2 ? some$6(pipe(set, add$2(cause.fiberId))) : none$8());

/** @internal */
const failureOption = self => find$2(self, cause => cause._tag === OP_FAIL$4 ? some$6(cause.error) : none$8());

/** @internal */
const failureOrCause$1 = self => {
  const option = failureOption(self);
  switch (option._tag) {
    case "None":
      {
        // no `E` inside this `Cause`, so it can be safely cast to `never`
        return right(self);
      }
    case "Some":
      {
        return left(option.value);
      }
  }
};

/** @internal */
const dieOption = self => find$2(self, cause => cause._tag === OP_DIE$2 ? some$6(cause.defect) : none$8());

/** @internal */
const flipCauseOption$1 = self => match$h(self, {
  onEmpty: some$6(empty$n),
  onFail: failureOption => pipe(failureOption, map$n(fail$g)),
  onDie: defect => some$6(die$a(defect)),
  onInterrupt: fiberId => some$6(interrupt$8(fiberId)),
  onSequential: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(sequential$2(left.value, right.value));
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    return none$8();
  },
  onParallel: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(parallel$3(left.value, right.value));
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    return none$8();
  }
});

/** @internal */
const interruptOption = self => find$2(self, cause => cause._tag === OP_INTERRUPT$2 ? some$6(cause.fiberId) : none$8());

/** @internal */
const keepDefects = self => match$h(self, {
  onEmpty: none$8(),
  onFail: () => none$8(),
  onDie: defect => some$6(die$a(defect)),
  onInterrupt: () => none$8(),
  onSequential: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(sequential$2(left.value, right.value));
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    return none$8();
  },
  onParallel: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(parallel$3(left.value, right.value));
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    return none$8();
  }
});

/** @internal */
const keepDefectsAndElectFailures = self => match$h(self, {
  onEmpty: none$8(),
  onFail: failure => some$6(die$a(failure)),
  onDie: defect => some$6(die$a(defect)),
  onInterrupt: () => none$8(),
  onSequential: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(sequential$2(left.value, right.value));
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    return none$8();
  },
  onParallel: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(parallel$3(left.value, right.value));
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    return none$8();
  }
});

/** @internal */
const linearize = self => match$h(self, {
  onEmpty: empty$s(),
  onFail: error => make$Z(fail$g(error)),
  onDie: defect => make$Z(die$a(defect)),
  onInterrupt: fiberId => make$Z(interrupt$8(fiberId)),
  onSequential: (leftSet, rightSet) => pipe(leftSet, flatMap$8(leftCause => pipe(rightSet, map$h(rightCause => sequential$2(leftCause, rightCause))))),
  onParallel: (leftSet, rightSet) => pipe(leftSet, flatMap$8(leftCause => pipe(rightSet, map$h(rightCause => parallel$3(leftCause, rightCause)))))
});

/** @internal */
const stripFailures = self => match$h(self, {
  onEmpty: empty$n,
  onFail: () => empty$n,
  onDie: defect => die$a(defect),
  onInterrupt: fiberId => interrupt$8(fiberId),
  onSequential: sequential$2,
  onParallel: parallel$3
});

/** @internal */
const electFailures = self => match$h(self, {
  onEmpty: empty$n,
  onFail: failure => die$a(failure),
  onDie: defect => die$a(defect),
  onInterrupt: fiberId => interrupt$8(fiberId),
  onSequential: (left, right) => sequential$2(left, right),
  onParallel: (left, right) => parallel$3(left, right)
});

/** @internal */
const stripSomeDefects = /*#__PURE__*/dual(2, (self, pf) => match$h(self, {
  onEmpty: some$6(empty$n),
  onFail: error => some$6(fail$g(error)),
  onDie: defect => {
    const option = pf(defect);
    return isSome(option) ? none$8() : some$6(die$a(defect));
  },
  onInterrupt: fiberId => some$6(interrupt$8(fiberId)),
  onSequential: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(sequential$2(left.value, right.value));
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    return none$8();
  },
  onParallel: (left, right) => {
    if (isSome(left) && isSome(right)) {
      return some$6(parallel$3(left.value, right.value));
    }
    if (isSome(left) && isNone$1(right)) {
      return some$6(left.value);
    }
    if (isNone$1(left) && isSome(right)) {
      return some$6(right.value);
    }
    return none$8();
  }
}));

// -----------------------------------------------------------------------------
// Mapping
// -----------------------------------------------------------------------------

/** @internal */
const as$7 = /*#__PURE__*/dual(2, (self, error) => map$g(self, () => error));

/** @internal */
const map$g = /*#__PURE__*/dual(2, (self, f) => flatMap$7(self, e => fail$g(f(e))));

// -----------------------------------------------------------------------------
// Sequencing
// -----------------------------------------------------------------------------

/** @internal */
const flatMap$7 = /*#__PURE__*/dual(2, (self, f) => match$h(self, {
  onEmpty: empty$n,
  onFail: error => f(error),
  onDie: defect => die$a(defect),
  onInterrupt: fiberId => interrupt$8(fiberId),
  onSequential: (left, right) => sequential$2(left, right),
  onParallel: (left, right) => parallel$3(left, right)
}));

/** @internal */
const flatten$7 = self => flatMap$7(self, identity$1);

// -----------------------------------------------------------------------------
// Equality
// -----------------------------------------------------------------------------

/** @internal */
const contains$1 = /*#__PURE__*/dual(2, (self, that) => {
  if (that._tag === OP_EMPTY$2 || self === that) {
    return true;
  }
  return reduce$a(self, false, (accumulator, cause) => {
    return some$6(accumulator || causeEquals(cause, that));
  });
});

/** @internal */
const causeEquals = (left, right) => {
  let leftStack = of$3(left);
  let rightStack = of$3(right);
  while (isNonEmpty$5(leftStack) && isNonEmpty$5(rightStack)) {
    const [leftParallel, leftSequential] = pipe(headNonEmpty(leftStack), reduce$a([empty$s(), empty$z()], ([parallel, sequential], cause) => {
      const [par, seq] = evaluateCause(cause);
      return some$6([pipe(parallel, union$6(par)), pipe(sequential, appendAll$1(seq))]);
    }));
    const [rightParallel, rightSequential] = pipe(headNonEmpty(rightStack), reduce$a([empty$s(), empty$z()], ([parallel, sequential], cause) => {
      const [par, seq] = evaluateCause(cause);
      return some$6([pipe(parallel, union$6(par)), pipe(sequential, appendAll$1(seq))]);
    }));
    if (!equals$1(leftParallel, rightParallel)) {
      return false;
    }
    leftStack = leftSequential;
    rightStack = rightSequential;
  }
  return true;
};

// -----------------------------------------------------------------------------
// Flattening
// -----------------------------------------------------------------------------

/**
 * Flattens a cause to a sequence of sets of causes, where each set represents
 * causes that fail in parallel and sequential sets represent causes that fail
 * after each other.
 *
 * @internal
 */
const flattenCause = cause => {
  return flattenCauseLoop(of$3(cause), empty$z());
};

/** @internal */
const flattenCauseLoop = (causes, flattened) => {
  // eslint-disable-next-line no-constant-condition
  while (1) {
    const [parallel, sequential] = pipe(causes, reduce$i([empty$s(), empty$z()], ([parallel, sequential], cause) => {
      const [par, seq] = evaluateCause(cause);
      return [pipe(parallel, union$6(par)), pipe(sequential, appendAll$1(seq))];
    }));
    const updated = size$g(parallel) > 0 ? pipe(flattened, prepend$2(parallel)) : flattened;
    if (isEmpty$h(sequential)) {
      return reverse$1(updated);
    }
    causes = sequential;
    flattened = updated;
  }
  throw new Error("BUG: Cause.flattenCauseLoop - please report an issue at https://github.com/Effect-TS/io/issues");
};

// -----------------------------------------------------------------------------
// Squashing
// -----------------------------------------------------------------------------

/** @internal */
const squash$1 = self => {
  return squashWith(identity$1)(self);
};

/** @internal */
const squashWith = /*#__PURE__*/dual(2, (self, f) => {
  const option = pipe(self, failureOption, map$n(f));
  switch (option._tag) {
    case "None":
      {
        return pipe(defects(self), head$4, match$j({
          onNone: () => {
            const interrupts = Array.from(interruptors(self)).flatMap(fiberId => Array.from(ids$1(fiberId)).map(id => `#${id}`));
            return InterruptedException(interrupts ? `Interrupted by fibers: ${interrupts.join(", ")}` : void 0);
          },
          onSome: identity$1
        }));
      }
    case "Some":
      {
        return option.value;
      }
  }
});

// -----------------------------------------------------------------------------
// Finding
// -----------------------------------------------------------------------------

/** @internal */
const find$2 = /*#__PURE__*/dual(2, (self, pf) => {
  const stack = [self];
  while (stack.length > 0) {
    const item = stack.pop();
    const option = pf(item);
    switch (option._tag) {
      case "None":
        {
          switch (item._tag) {
            case OP_SEQUENTIAL$1:
            case OP_PARALLEL$1:
              {
                stack.push(item.right);
                stack.push(item.left);
                break;
              }
          }
          break;
        }
      case "Some":
        {
          return option;
        }
    }
  }
  return none$8();
});

// -----------------------------------------------------------------------------
// Filtering
// -----------------------------------------------------------------------------

/** @internal */
const filter$6 = /*#__PURE__*/dual(2, (self, predicate) => reduceWithContext$1(self, void 0, FilterCauseReducer(predicate)));

// -----------------------------------------------------------------------------
// Evaluation
// -----------------------------------------------------------------------------

/**
 * Takes one step in evaluating a cause, returning a set of causes that fail
 * in parallel and a list of causes that fail sequentially after those causes.
 *
 * @internal
 */
const evaluateCause = self => {
  let cause = self;
  const stack = [];
  let _parallel = empty$s();
  let _sequential = empty$z();
  while (cause !== undefined) {
    switch (cause._tag) {
      case OP_EMPTY$2:
        {
          if (stack.length === 0) {
            return [_parallel, _sequential];
          }
          cause = stack.pop();
          break;
        }
      case OP_FAIL$4:
        {
          if (stack.length === 0) {
            return [pipe(_parallel, add$2(cause.error)), _sequential];
          }
          _parallel = pipe(_parallel, add$2(cause.error));
          cause = stack.pop();
          break;
        }
      case OP_DIE$2:
        {
          if (stack.length === 0) {
            return [pipe(_parallel, add$2(cause.defect)), _sequential];
          }
          _parallel = pipe(_parallel, add$2(cause.defect));
          cause = stack.pop();
          break;
        }
      case OP_INTERRUPT$2:
        {
          if (stack.length === 0) {
            return [pipe(_parallel, add$2(cause.fiberId)), _sequential];
          }
          _parallel = pipe(_parallel, add$2(cause.fiberId));
          cause = stack.pop();
          break;
        }
      case OP_SEQUENTIAL$1:
        {
          switch (cause.left._tag) {
            case OP_EMPTY$2:
              {
                cause = cause.right;
                break;
              }
            case OP_SEQUENTIAL$1:
              {
                cause = sequential$2(cause.left.left, sequential$2(cause.left.right, cause.right));
                break;
              }
            case OP_PARALLEL$1:
              {
                cause = parallel$3(sequential$2(cause.left.left, cause.right), sequential$2(cause.left.right, cause.right));
                break;
              }
            default:
              {
                _sequential = pipe(_sequential, prepend$2(cause.right));
                cause = cause.left;
                break;
              }
          }
          break;
        }
      case OP_PARALLEL$1:
        {
          stack.push(cause.right);
          cause = cause.left;
          break;
        }
    }
  }
  throw new Error("BUG: Cause.evaluateCauseLoop - please report an issue at https://github.com/Effect-TS/io/issues");
};

// -----------------------------------------------------------------------------
// Reducing
// -----------------------------------------------------------------------------

/** @internal */
const SizeCauseReducer = {
  emptyCase: () => 0,
  failCase: () => 1,
  dieCase: () => 1,
  interruptCase: () => 1,
  sequentialCase: (_, left, right) => left + right,
  parallelCase: (_, left, right) => left + right
};

/** @internal */
const IsInterruptedOnlyCauseReducer = {
  emptyCase: constTrue,
  failCase: constFalse,
  dieCase: constFalse,
  interruptCase: constTrue,
  sequentialCase: (_, left, right) => left && right,
  parallelCase: (_, left, right) => left && right
};

/** @internal */
const FilterCauseReducer = predicate => ({
  emptyCase: () => empty$n,
  failCase: (_, error) => fail$g(error),
  dieCase: (_, defect) => die$a(defect),
  interruptCase: (_, fiberId) => interrupt$8(fiberId),
  sequentialCase: (_, left, right) => {
    if (predicate(left)) {
      if (predicate(right)) {
        return sequential$2(left, right);
      }
      return left;
    }
    if (predicate(right)) {
      return right;
    }
    return empty$n;
  },
  parallelCase: (_, left, right) => {
    if (predicate(left)) {
      if (predicate(right)) {
        return parallel$3(left, right);
      }
      return left;
    }
    if (predicate(right)) {
      return right;
    }
    return empty$n;
  }
});

/** @internal */

const OP_SEQUENTIAL_CASE = "SequentialCase";
const OP_PARALLEL_CASE = "ParallelCase";

/** @internal */

/** @internal */

/** @internal */
const match$h = /*#__PURE__*/dual(2, (self, {
  onDie,
  onEmpty,
  onFail,
  onInterrupt,
  onParallel,
  onSequential
}) => {
  return reduceWithContext$1(self, void 0, {
    emptyCase: () => onEmpty,
    failCase: (_, error) => onFail(error),
    dieCase: (_, defect) => onDie(defect),
    interruptCase: (_, fiberId) => onInterrupt(fiberId),
    sequentialCase: (_, left, right) => onSequential(left, right),
    parallelCase: (_, left, right) => onParallel(left, right)
  });
});

/** @internal */
const reduce$a = /*#__PURE__*/dual(3, (self, zero, pf) => {
  let accumulator = zero;
  let cause = self;
  const causes = [];
  while (cause !== undefined) {
    const option = pf(accumulator, cause);
    accumulator = isSome(option) ? option.value : accumulator;
    switch (cause._tag) {
      case OP_SEQUENTIAL$1:
        {
          causes.push(cause.right);
          cause = cause.left;
          break;
        }
      case OP_PARALLEL$1:
        {
          causes.push(cause.right);
          cause = cause.left;
          break;
        }
      default:
        {
          cause = undefined;
          break;
        }
    }
    if (cause === undefined && causes.length > 0) {
      cause = causes.pop();
    }
  }
  return accumulator;
});

/** @internal */
const reduceWithContext$1 = /*#__PURE__*/dual(3, (self, context, reducer) => {
  const input = [self];
  const output = [];
  while (input.length > 0) {
    const cause = input.pop();
    switch (cause._tag) {
      case OP_EMPTY$2:
        {
          output.push(right(reducer.emptyCase(context)));
          break;
        }
      case OP_FAIL$4:
        {
          output.push(right(reducer.failCase(context, cause.error)));
          break;
        }
      case OP_DIE$2:
        {
          output.push(right(reducer.dieCase(context, cause.defect)));
          break;
        }
      case OP_INTERRUPT$2:
        {
          output.push(right(reducer.interruptCase(context, cause.fiberId)));
          break;
        }
      case OP_SEQUENTIAL$1:
        {
          input.push(cause.right);
          input.push(cause.left);
          output.push(left({
            _tag: OP_SEQUENTIAL_CASE
          }));
          break;
        }
      case OP_PARALLEL$1:
        {
          input.push(cause.right);
          input.push(cause.left);
          output.push(left({
            _tag: OP_PARALLEL_CASE
          }));
          break;
        }
    }
  }
  const accumulator = [];
  while (output.length > 0) {
    const either = output.pop();
    switch (either._tag) {
      case "Left":
        {
          switch (either.left._tag) {
            case OP_SEQUENTIAL_CASE:
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.sequentialCase(context, left, right);
                accumulator.push(value);
                break;
              }
            case OP_PARALLEL_CASE:
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.parallelCase(context, left, right);
                accumulator.push(value);
                break;
              }
          }
          break;
        }
      case "Right":
        {
          accumulator.push(either.right);
          break;
        }
    }
  }
  if (accumulator.length === 0) {
    throw new Error("BUG: Cause.reduceWithContext - please report an issue at https://github.com/Effect-TS/io/issues");
  }
  return accumulator.pop();
});

// -----------------------------------------------------------------------------
// Errors
// -----------------------------------------------------------------------------

const makeException = (proto, tag) => {
  const _tag = {
    value: tag,
    enumerable: true
  };
  const protoWithToString = {
    ...proto,
    toString() {
      return `${this._tag}: ${this.message}`;
    }
  };
  return message => Object.create(protoWithToString, {
    _tag,
    message: {
      value: message,
      enumerable: true
    }
  });
};

/** @internal */
const RuntimeExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/RuntimeException");

/** @internal */
const RuntimeException$1 = /*#__PURE__*/makeException({
  [RuntimeExceptionTypeId]: RuntimeExceptionTypeId
}, "RuntimeException");

/** @internal */
const isRuntimeException$1 = u => {
  return typeof u === "object" && u != null && RuntimeExceptionTypeId in u;
};

/** @internal */
const InterruptedExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/InterruptedException");

/** @internal */
const InterruptedException = /*#__PURE__*/makeException({
  [InterruptedExceptionTypeId]: InterruptedExceptionTypeId
}, "InterruptedException");

/** @internal */
const isInterruptedException = u => {
  return typeof u === "object" && u != null && InterruptedExceptionTypeId in u;
};

/** @internal */
const IllegalArgumentExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/IllegalArgument");

/** @internal */
const IllegalArgumentException$1 = /*#__PURE__*/makeException({
  [IllegalArgumentExceptionTypeId]: IllegalArgumentExceptionTypeId
}, "IllegalArgumentException");

/** @internal */
const isIllegalArgumentException = u => {
  return typeof u === "object" && u != null && IllegalArgumentExceptionTypeId in u;
};

/** @internal */
const NoSuchElementExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/NoSuchElement");

/** @internal */
const NoSuchElementException$1 = /*#__PURE__*/makeException({
  [NoSuchElementExceptionTypeId]: NoSuchElementExceptionTypeId
}, "NoSuchElementException");

/** @internal */
const isNoSuchElementException = u => {
  return typeof u === "object" && u != null && NoSuchElementExceptionTypeId in u;
};

/** @internal */
const InvalidPubSubCapacityExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/InvalidPubSubCapacityException");

/** @internal */
const InvalidPubSubCapacityException = /*#__PURE__*/makeException({
  [InvalidPubSubCapacityExceptionTypeId]: InvalidPubSubCapacityExceptionTypeId
}, "InvalidPubSubCapacityException");

// -----------------------------------------------------------------------------
// Pretty Printing
// -----------------------------------------------------------------------------

const filterStack = stack => {
  const lines = stack.split("\n");
  const out = [];
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].includes("EffectPrimitive") || lines[i].includes("Generator.next") || lines[i].includes("FiberRuntime")) {
      return out.join("\n");
    } else {
      out.push(lines[i]);
    }
  }
  return out.join("\n");
};

/** @internal */
const pretty$1 = cause => {
  if (isInterruptedOnly$1(cause)) {
    return "All fibers interrupted without errors.";
  }
  const final = prettyErrors(cause).map(e => {
    let message = e.message;
    if (e.stack) {
      message += `\r\n${filterStack(e.stack)}`;
    }
    if (e.span) {
      let current = e.span;
      let i = 0;
      while (current && current._tag === "Span" && i < 10) {
        message += `\r\n    at ${current.name}`;
        current = getOrUndefined(current.parent);
        i++;
      }
    }
    return message;
  }).join("\r\n");
  return final;
};
class PrettyError {
  constructor(message, stack, span) {
    this.message = message;
    this.stack = stack;
    this.span = span;
  }
  toJSON() {
    const out = {
      message: this.message
    };
    if (this.stack) {
      out.stack = this.stack;
    }
    if (this.span) {
      out.span = this.span;
    }
    return out;
  }
}

/**
 * A utility function for generating human-readable error messages from a generic error of type `unknown`.
 *
 * Rules:
 *
 * 1) If the input `u` is already a string, it's considered a message, and "Error" is added as a prefix.
 * 2) If `u` has a user-defined `toString()` method, it uses that method and adds "Error" as a prefix.
 * 3) If `u` is an object and its only (optional) properties are "name", "message", or "_tag", it constructs
 *    an error message based on those properties.
 * 4) Otherwise, it uses `JSON.stringify` to produce a string representation and uses it as the error message,
 *   with "Error" added as a prefix.
 *
 * @internal
 */
const prettyErrorMessage = u => {
  // 1)
  if (typeof u === "string") {
    return `Error: ${u}`;
  }
  // 2)
  if (typeof u === "object" && u != null && "toString" in u && typeof u["toString"] === "function" && u["toString"] !== Object.prototype.toString) {
    return u["toString"]();
  }
  // 3)
  return `Error: ${JSON.stringify(u)}`;
};
const spanSymbol$1 = /*#__PURE__*/Symbol.for("effect/SpanAnnotation");
const defaultRenderError = error => {
  const span = typeof error === "object" && error !== null && spanSymbol$1 in error && error[spanSymbol$1];
  if (typeof error === "object" && error !== null && error instanceof Error) {
    return new PrettyError(prettyErrorMessage(error), error.stack?.split("\n").filter(_ => _.match(/at (.*)/)).join("\n"), span);
  }
  return new PrettyError(prettyErrorMessage(error), void 0, span);
};

/** @internal */
const prettyErrors = cause => reduceWithContext$1(cause, void 0, {
  emptyCase: () => [],
  dieCase: (_, unknownError) => {
    return [defaultRenderError(unknownError)];
  },
  failCase: (_, error) => {
    return [defaultRenderError(error)];
  },
  interruptCase: () => [],
  parallelCase: (_, l, r) => [...l, ...r],
  sequentialCase: (_, l, r) => [...l, ...r]
});

/** @internal */
const OP_STATE_PENDING = "Pending";

/** @internal */

/** @internal */
const OP_STATE_DONE$1 = "Done";

/** @internal */
const DeferredSymbolKey = "effect/Deferred";

/** @internal */
const DeferredTypeId = /*#__PURE__*/Symbol.for(DeferredSymbolKey);

/** @internal */
const deferredVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const pending$4 = joiners => {
  return {
    _tag: OP_STATE_PENDING,
    joiners
  };
};

/** @internal */
const done$c = effect => {
  return {
    _tag: OP_STATE_DONE$1,
    effect
  };
};

/** @internal */
const BIT_MASK = 0xff;

/** @internal */
const BIT_SHIFT = 0x08;

/** @internal */
const active = patch => patch & BIT_MASK;

/** @internal */
const enabled = patch => patch >> BIT_SHIFT & BIT_MASK;

/** @internal */
const make$U = (active, enabled) => (active & BIT_MASK) + ((enabled & active & BIT_MASK) << BIT_SHIFT);

/** @internal */
const empty$m = /*#__PURE__*/make$U(0, 0);

/** @internal */
const enable$2 = flag => make$U(flag, flag);

/** @internal */
const disable$2 = flag => make$U(flag, 0);

/** @internal */
const isEmpty$d = patch => patch === 0;

/** @internal */
const isActive = /*#__PURE__*/dual(2, (self, flag) => (active(self) & flag) !== 0);

/** @internal */
const isEnabled$1 = /*#__PURE__*/dual(2, (self, flag) => (enabled(self) & flag) !== 0);

/** @internal */
const isDisabled$1 = /*#__PURE__*/dual(2, (self, flag) => (active(self) & flag) !== 0 && (enabled(self) & flag) === 0);

/** @internal */
const exclude$1 = /*#__PURE__*/dual(2, (self, flag) => make$U(active(self) & ~flag, enabled(self)));

/** @internal */
const both = /*#__PURE__*/dual(2, (self, that) => make$U(active(self) | active(that), enabled(self) & enabled(that)));

/** @internal */
const either$6 = /*#__PURE__*/dual(2, (self, that) => make$U(active(self) | active(that), enabled(self) | enabled(that)));

/** @internal */
const andThen$2 = /*#__PURE__*/dual(2, (self, that) => self | that);

/** @internal */
const inverse = patch => make$U(enabled(patch), invert(active(patch)));

/** @internal */
const invert = n => ~n >>> 0 & BIT_MASK;

/** @internal */
const None$1 = 0;

/** @internal */
const Interruption = 1 << 0;

/** @internal */
const OpSupervision = 1 << 1;

/** @internal */
const RuntimeMetrics = 1 << 2;

/** @internal */
const WindDown = 1 << 4;

/** @internal */
const CooperativeYielding = 1 << 5;

/** @internal */
const allFlags = [None$1, Interruption, OpSupervision, RuntimeMetrics, WindDown, CooperativeYielding];
const print = flag => {
  switch (flag) {
    case CooperativeYielding:
      {
        return "CooperativeYielding";
      }
    case WindDown:
      {
        return "WindDown";
      }
    case RuntimeMetrics:
      {
        return "RuntimeMetrics";
      }
    case OpSupervision:
      {
        return "OpSupervision";
      }
    case Interruption:
      {
        return "Interruption";
      }
    case None$1:
      {
        return "None";
      }
  }
};

/** @internal */
const cooperativeYielding = self => isEnabled(self, CooperativeYielding);

/** @internal */
const disable$1 = /*#__PURE__*/dual(2, (self, flag) => self & ~flag);

/** @internal */
const disableAll = /*#__PURE__*/dual(2, (self, flags) => self & ~flags);

/** @internal */
const enable$1 = /*#__PURE__*/dual(2, (self, flag) => self | flag);

/** @internal */
const enableAll = /*#__PURE__*/dual(2, (self, flags) => self | flags);

/** @internal */
const interruptible$2 = self => interruption(self) && !windDown(self);

/** @internal */
const interruption = self => isEnabled(self, Interruption);

/** @internal */
const isDisabled = /*#__PURE__*/dual(2, (self, flag) => !isEnabled(self, flag));

/** @internal */
const isEnabled = /*#__PURE__*/dual(2, (self, flag) => (self & flag) !== 0);

/** @internal */
const make$T = (...flags) => flags.reduce((a, b) => a | b, 0);

/** @internal */
const none$5 = /*#__PURE__*/make$T(None$1);

/** @internal */
const opSupervision = self => isEnabled(self, OpSupervision);

/** @internal */
const render$2 = self => {
  const active = [];
  allFlags.forEach(flag => {
    if (isEnabled(self, flag)) {
      active.push(`${print(flag)}`);
    }
  });
  return `RuntimeFlags(${active.join(", ")})`;
};

/** @internal */
const runtimeMetrics = self => isEnabled(self, RuntimeMetrics);

/** @internal */
const toSet$1 = self => new Set(allFlags.filter(flag => isEnabled(self, flag)));
const windDown = self => isEnabled(self, WindDown);

// circular with RuntimeFlagsPatch

/** @internal */
const enabledSet = self => toSet$1(active(self) & enabled(self));

/** @internal */
const disabledSet = self => toSet$1(active(self) & ~enabled(self));

/** @internal */
const diff$3 = /*#__PURE__*/dual(2, (self, that) => make$U(self ^ that, that));

/** @internal */
const patch$4 = /*#__PURE__*/dual(2, (self, patch) => self & (invert(active(patch)) | enabled(patch)) | active(patch) & enabled(patch));

/** @internal */
const renderPatch = self => {
  const enabled = Array.from(enabledSet(self)).map(flag => print(flag)).join(", ");
  const disabled = Array.from(disabledSet(self)).map(flag => print(flag)).join(", ");
  return `RuntimeFlagsPatch(enabled = (${enabled}), disabled = (${disabled}))`;
};

/** @internal */
const differ$1 = /*#__PURE__*/make$X({
  empty: empty$m,
  diff: (oldValue, newValue) => diff$3(oldValue, newValue),
  combine: (first, second) => andThen$2(second)(first),
  patch: (_patch, oldValue) => patch$4(oldValue, _patch)
});

/**
 * @since 2.0.0
 */
/** @internal */
const TracerTypeId = /*#__PURE__*/Symbol.for("effect/Tracer");

/** @internal */
const make$S = options => ({
  [TracerTypeId]: TracerTypeId,
  ...options
});

/** @internal */
const tracerTag = /*#__PURE__*/Tag$1( /*#__PURE__*/Symbol.for("effect/Tracer"));

/** @internal */
const spanTag = /*#__PURE__*/Tag$1( /*#__PURE__*/Symbol.for("effect/ParentSpan"));
const ids = /*#__PURE__*/globalValue("effect/Tracer/SpanId.ids", () => make$W(0));

/** @internal */
class NativeSpan {
  _tag = "Span";
  traceId = "native";
  sampled = true;
  events = [];
  constructor(name, parent, context, links, startTime) {
    this.name = name;
    this.parent = parent;
    this.context = context;
    this.links = links;
    this.startTime = startTime;
    this.status = {
      _tag: "Started",
      startTime
    };
    this.attributes = new Map();
    this.spanId = `span${incrementAndGet(ids)}`;
  }
  end = (endTime, exit) => {
    this.status = {
      _tag: "Ended",
      endTime,
      exit,
      startTime: this.status.startTime
    };
  };
  attribute = (key, value) => {
    this.attributes.set(key, value);
  };
  event = (name, startTime, attributes) => {
    this.events.push([name, startTime, attributes ?? {}]);
  };
}

/** @internal */
const nativeTracer = /*#__PURE__*/make$S({
  span: (name, parent, context, links, startTime) => new NativeSpan(name, parent, context, links, startTime),
  context: f => f()
});

/** @internal */
const externalSpan = options => ({
  _tag: "ExternalSpan",
  spanId: options.spanId,
  traceId: options.traceId,
  sampled: options.sampled ?? true,
  context: options.context ?? empty$A()
});

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * The empty `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$l = empty$m;

/**
 * @since 2.0.0
 * @category constructors
 */
make$U;

/**
 * Creates a `RuntimeFlagsPatch` describing enabling the provided `RuntimeFlag`.
 *
 * @since 2.0.0
 * @category constructors
 */
const enable = enable$2;

/**
 * Creates a `RuntimeFlagsPatch` describing disabling the provided `RuntimeFlag`.
 *
 * @since 2.0.0
 * @category constructors
 */
const disable = disable$2;

/**
 * Returns `true` if the specified `RuntimeFlagsPatch` is empty.
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty$d;

/**
 * Returns `true` if the `RuntimeFlagsPatch` describes the specified
 * `RuntimeFlag` as active.
 *
 * @since 2.0.0
 * @category elements
 */
isActive;

/**
 * Returns `true` if the `RuntimeFlagsPatch` describes the specified
 * `RuntimeFlag` as enabled.
 *
 * @since 2.0.0
 * @category elements
 */
isEnabled$1;

/**
 * Returns `true` if the `RuntimeFlagsPatch` describes the specified
 * `RuntimeFlag` as disabled.
 *
 * @since 2.0.0
 * @category elements
 */
isDisabled$1;

/**
 * Returns `true` if the `RuntimeFlagsPatch` includes the specified
 * `RuntimeFlag`, `false` otherwise.
 *
 * @since 2.0.0
 * @category elements
 */
isActive;

/**
 * Creates a `RuntimeFlagsPatch` describing the application of the `self` patch,
 * followed by `that` patch.
 *
 * @since 2.0.0
 * @category utils
 */
andThen$2;

/**
 * Creates a `RuntimeFlagsPatch` describing application of both the `self` patch
 * and `that` patch.
 *
 * @since 2.0.0
 * @category utils
 */
both;

/**
 * Creates a `RuntimeFlagsPatch` describing application of either the `self`
 * patch or `that` patch.
 *
 * @since 2.0.0
 * @category utils
 */
either$6;

/**
 * Creates a `RuntimeFlagsPatch` which describes exclusion of the specified
 * `RuntimeFlag` from the set of `RuntimeFlags`.
 *
 * @category utils
 * @since 2.0.0
 */
const exclude = exclude$1;

/**
 * Creates a `RuntimeFlagsPatch` which describes the inverse of the patch
 * specified by the provided `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category utils
 */
inverse;

/**
 * Returns a `ReadonlySet<number>` containing the `RuntimeFlags` described as
 * enabled by the specified `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category destructors
 */
enabledSet;

/**
 * Returns a `ReadonlySet<number>` containing the `RuntimeFlags` described as
 * disabled by the specified `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category destructors
 */
disabledSet;

/**
 * Renders the provided `RuntimeFlagsPatch` to a string.
 *
 * @since 2.0.0
 * @category destructors
 */
renderPatch;

// -----------------------------------------------------------------------------
// Effect
// -----------------------------------------------------------------------------
/** @internal */
const EffectErrorSymbolKey = "effect/EffectError";

/** @internal */
const EffectErrorTypeId = /*#__PURE__*/Symbol.for(EffectErrorSymbolKey);

/** @internal */

/** @internal */

/** @internal */
const isEffectError = u => typeof u === "object" && u != null && EffectErrorTypeId in u;

/** @internal */
const makeEffectError = cause => ({
  [EffectErrorTypeId]: EffectErrorTypeId,
  _tag: "EffectError",
  cause
});

/**
 * @internal
 */
const blocked$1 = (blockedRequests, _continue) => {
  const effect = new EffectPrimitive("Blocked");
  effect.i0 = blockedRequests;
  effect.i1 = _continue;
  return effect;
};

/**
 * @internal
 */
const runRequestBlock$1 = blockedRequests => {
  const effect = new EffectPrimitive("RunBlocked");
  effect.i0 = blockedRequests;
  return effect;
};

/** @internal */
const EffectTypeId$1 = /*#__PURE__*/Symbol.for("effect/Effect");

/** @internal */

/** @internal */

/** @internal */
class RevertFlags {
  _op = OP_REVERT_FLAGS;
  constructor(patch, op) {
    this.patch = patch;
    this.op = op;
  }
}

/** @internal */
class EffectPrimitive {
  i0 = undefined;
  i1 = undefined;
  i2 = undefined;
  trace = undefined;
  [EffectTypeId$1] = effectVariance;
  constructor(_op) {
    this._op = _op;
  }
  [symbol](that) {
    return this === that;
  }
  [symbol$1]() {
    return random$2(this);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  toJSON() {
    return {
      _id: "Effect",
      _op: this._op,
      i0: toJSON(this.i0),
      i1: toJSON(this.i1),
      i2: toJSON(this.i2)
    };
  }
  toString() {
    return toString(this.toJSON());
  }
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
}

/** @internal */
class EffectPrimitiveFailure {
  i0 = undefined;
  i1 = undefined;
  i2 = undefined;
  trace = undefined;
  [EffectTypeId$1] = effectVariance;
  constructor(_op) {
    this._op = _op;
    // @ts-expect-error
    this._tag = _op;
  }
  [symbol](that) {
    return this === that;
  }
  [symbol$1]() {
    return random$2(this);
  }
  get cause() {
    return this.i0;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  toJSON() {
    return {
      _id: "Exit",
      _tag: this._op,
      cause: this.cause.toJSON()
    };
  }
  toString() {
    return toString(this.toJSON());
  }
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
}

/** @internal */
class EffectPrimitiveSuccess {
  i0 = undefined;
  i1 = undefined;
  i2 = undefined;
  trace = undefined;
  [EffectTypeId$1] = effectVariance;
  constructor(_op) {
    this._op = _op;
    // @ts-expect-error
    this._tag = _op;
  }
  [symbol](that) {
    return this === that;
  }
  [symbol$1]() {
    return random$2(this);
  }
  get value() {
    return this.i0;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  toJSON() {
    return {
      _id: "Exit",
      _tag: this._op,
      value: toJSON(this.value)
    };
  }
  toString() {
    return toString(this.toJSON());
  }
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
}

/** @internal */
const effectVariance = {
  _R: _ => _,
  _E: _ => _,
  _A: _ => _
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const isEffect$1 = u => typeof u === "object" && u != null && EffectTypeId$1 in u;

/* @internal */
const withFiberRuntime = withRuntime => {
  const effect = new EffectPrimitive(OP_WITH_RUNTIME);
  effect.i0 = withRuntime;
  return effect;
};

/* @internal */
const acquireUseRelease$3 = /*#__PURE__*/dual(3, (acquire, use, release) => uninterruptibleMask$1(restore => flatMap$6(acquire, a => flatMap$6(exit$1(suspend$8(() => restore(step$1(use(a))))), exit => {
  if (exit._tag === "Success" && exit.value._op === "Blocked") {
    const value = exit.value;
    return blocked$1(value.i0, acquireUseRelease$3(succeed$h(a), () => value.i1, release));
  }
  const flat = exitFlatten(exit);
  return suspend$8(() => release(a, flat)).pipe(matchCauseEffect$1({
    onFailure: cause => {
      switch (flat._tag) {
        case OP_FAILURE:
          {
            return failCause$a(parallel$3(flat.i0, cause));
          }
        case OP_SUCCESS:
          {
            return failCause$a(cause);
          }
      }
    },
    onSuccess: () => flat
  }));
}))));

/* @internal */
const as$6 = /*#__PURE__*/dual(2, (self, value) => flatMap$6(self, () => succeed$h(value)));

/* @internal */
const asUnit$4 = self => as$6(self, void 0);

/* @internal */
const async$1 = (register, blockingOn = none$6) => suspend$8(() => {
  let cancelerRef = undefined;
  let controllerRef = undefined;
  const effect = new EffectPrimitive(OP_ASYNC);
  if (register.length !== 1) {
    const controller = new AbortController();
    controllerRef = controller;
    effect.i0 = resume => {
      cancelerRef = register(resume, controller.signal);
    };
  } else {
    effect.i0 = resume => {
      // @ts-expect-error
      cancelerRef = register(resume);
    };
  }
  effect.i1 = blockingOn;
  return onInterrupt$1(effect, () => {
    if (controllerRef) {
      controllerRef.abort();
    }
    return cancelerRef ?? unit$6;
  });
});

/* @internal */
const asyncEither$1 = (register, blockingOn = none$6) => async$1(resume => {
  const result = register(resume);
  if (isRight$1(result)) {
    resume(result.right);
  } else {
    return result.left;
  }
}, blockingOn);

/* @internal */
const catchAllCause$4 = /*#__PURE__*/dual(2, (self, f) => {
  const effect = new EffectPrimitive(OP_ON_FAILURE$1);
  effect.i0 = self;
  effect.i1 = f;
  return effect;
});

/* @internal */
const catchAll$5 = /*#__PURE__*/dual(2, (self, f) => matchEffect$3(self, {
  onFailure: f,
  onSuccess: succeed$h
}));

/**
 * @macro identity
 * @internal
 */
const unified$1 = f => (...args) => f(...args);

/* @internal */
const catchIf$1 = /*#__PURE__*/dual(3, (self, predicate, f) => catchAllCause$4(self, cause => {
  const either = failureOrCause$1(cause);
  switch (either._tag) {
    case "Left":
      {
        return predicate(either.left) ? f(either.left) : failCause$a(cause);
      }
    case "Right":
      {
        return failCause$a(either.right);
      }
  }
}));

/* @internal */
const catchSome$3 = /*#__PURE__*/dual(2, (self, pf) => catchAllCause$4(self, cause => {
  const either = failureOrCause$1(cause);
  switch (either._tag) {
    case "Left":
      {
        return pipe(pf(either.left), getOrElse$3(() => failCause$a(cause)));
      }
    case "Right":
      {
        return failCause$a(either.right);
      }
  }
}));

/* @internal */
const checkInterruptible$1 = f => withFiberRuntime((_, status) => f(interruption(status.runtimeFlags)));
const spanSymbol = /*#__PURE__*/Symbol.for("effect/SpanAnnotation");
const originalSymbol = /*#__PURE__*/Symbol.for("effect/OriginalAnnotation");

/* @internal */
const originalInstance = obj => {
  if (typeof obj === "object" && obj !== null && originalSymbol in obj) {
    // @ts-expect-error
    return obj[originalSymbol];
  }
  return obj;
};

/* @internal */
const capture = (obj, span) => {
  if (isSome(span)) {
    return new Proxy(obj, {
      has(target, p) {
        return p === spanSymbol || p === originalSymbol || p in target;
      },
      get(target, p) {
        if (p === spanSymbol) {
          return span.value;
        }
        if (p === originalSymbol) {
          return obj;
        }
        // @ts-expect-error
        return target[p];
      }
    });
  }
  return obj;
};

/* @internal */
const die$9 = defect => typeof defect === "object" && defect !== null && !(spanSymbol in defect) ? withFiberRuntime(fiber => failCause$a(die$a(capture(defect, currentSpanFromFiber(fiber))))) : failCause$a(die$a(defect));

/* @internal */
const dieMessage$5 = message => failCauseSync$5(() => die$a(RuntimeException$1(message)));

/* @internal */
const dieSync$5 = evaluate => flatMap$6(sync$a(evaluate), die$9);

/* @internal */
const either$5 = self => matchEffect$3(self, {
  onFailure: e => succeed$h(left(e)),
  onSuccess: a => succeed$h(right(a))
});

/* @internal */
const exit$1 = self => matchCause$2(self, {
  onFailure: exitFailCause,
  onSuccess: exitSucceed
});

/* @internal */
const fail$f = error => typeof error === "object" && error !== null && !(spanSymbol in error) ? withFiberRuntime(fiber => failCause$a(fail$g(capture(error, currentSpanFromFiber(fiber))))) : failCause$a(fail$g(error));

/* @internal */
const failSync$6 = evaluate => flatMap$6(sync$a(evaluate), fail$f);

/* @internal */
const failCause$a = cause => {
  const effect = new EffectPrimitiveFailure(OP_FAILURE);
  effect.i0 = cause;
  return effect;
};

/* @internal */
const failCauseSync$5 = evaluate => flatMap$6(sync$a(evaluate), failCause$a);

/* @internal */
const fiberId$2 = /*#__PURE__*/withFiberRuntime(state => succeed$h(state.id()));

/* @internal */
const fiberIdWith$1 = f => withFiberRuntime(state => f(state.id()));

/* @internal */
const flatMap$6 = /*#__PURE__*/dual(2, (self, f) => {
  const effect = new EffectPrimitive(OP_ON_SUCCESS$1);
  effect.i0 = self;
  effect.i1 = f;
  return effect;
});

/* @internal */
const step$1 = self => {
  const effect = new EffectPrimitive("OnStep");
  effect.i0 = self;
  effect.i1 = exitSucceed;
  return effect;
};

/* @internal */
const flatMapStep$1 = (self, f) => {
  const effect = new EffectPrimitive("OnStep");
  effect.i0 = self;
  effect.i1 = f;
  return effect;
};

/* @internal */
const flatten$6 = self => flatMap$6(self, identity$1);

/* @internal */
const flip$2 = self => matchEffect$3(self, {
  onFailure: succeed$h,
  onSuccess: fail$f
});

/* @internal */
const matchCause$2 = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchCauseEffect$1(self, {
  onFailure: cause => succeed$h(onFailure(cause)),
  onSuccess: a => succeed$h(onSuccess(a))
}));

/* @internal */
const matchCauseEffect$1 = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => {
  const effect = new EffectPrimitive(OP_ON_SUCCESS_AND_FAILURE);
  effect.i0 = self;
  effect.i1 = onFailure;
  effect.i2 = onSuccess;
  return effect;
});

/* @internal */
const matchEffect$3 = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchCauseEffect$1(self, {
  onFailure: cause => {
    const failures$1 = failures(cause);
    const defects$1 = defects(cause);
    if (defects$1.length > 0) {
      return failCause$a(electFailures(cause));
    }
    if (failures$1.length > 0) {
      return onFailure(unsafeHead$1(failures$1));
    }
    return failCause$a(cause);
  },
  onSuccess
}));

/* @internal */
const forEachSequential = /*#__PURE__*/dual(2, (self, f) => suspend$8(() => {
  const arr = fromIterable$c(self);
  const ret = new Array(arr.length);
  let i = 0;
  return as$6(whileLoop$1({
    while: () => i < arr.length,
    body: () => f(arr[i], i),
    step: b => {
      ret[i++] = b;
    }
  }), ret);
}));

/* @internal */
const forEachSequentialDiscard = /*#__PURE__*/dual(2, (self, f) => suspend$8(() => {
  const arr = fromIterable$c(self);
  let i = 0;
  return whileLoop$1({
    while: () => i < arr.length,
    body: () => f(arr[i], i),
    step: () => {
      i++;
    }
  });
}));

/* @internal */
const if_$2 = /*#__PURE__*/dual(args => typeof args[0] === "boolean" || isEffect$1(args[0]), (self, {
  onFalse,
  onTrue
}) => typeof self === "boolean" ? self ? onTrue : onFalse : flatMap$6(self, unified$1(b => b ? onTrue : onFalse)));

/* @internal */
const interrupt$7 = /*#__PURE__*/flatMap$6(fiberId$2, fiberId => interruptWith$1(fiberId));

/* @internal */
const interruptWith$1 = fiberId => failCause$a(interrupt$8(fiberId));

/* @internal */
const interruptible$1 = self => {
  const effect = new EffectPrimitive(OP_UPDATE_RUNTIME_FLAGS);
  effect.i0 = enable(Interruption);
  const _continue = orBlock => {
    if (orBlock._tag === "Blocked") {
      return blocked$1(orBlock.i0, interruptible$1(orBlock.i1));
    } else {
      return orBlock;
    }
  };
  effect.i1 = () => flatMapStep$1(self, _continue);
  return effect;
};

/* @internal */
const interruptibleMask$1 = f => {
  const effect = new EffectPrimitive(OP_UPDATE_RUNTIME_FLAGS);
  effect.i0 = enable(Interruption);
  const _continue = step => {
    if (step._op === "Blocked") {
      return blocked$1(step.i0, interruptible$1(step.i1));
    }
    return step;
  };
  effect.i1 = oldFlags => interruption(oldFlags) ? step$1(f(interruptible$1)) : step$1(f(uninterruptible$1));
  return flatMap$6(effect, _continue);
};

/* @internal */
const intoDeferred$1 = /*#__PURE__*/dual(2, (self, deferred) => uninterruptibleMask$1(restore => flatMap$6(exit$1(restore(self)), exit => deferredDone(deferred, exit))));

/* @internal */
const map$f = /*#__PURE__*/dual(2, (self, f) => flatMap$6(self, a => sync$a(() => f(a))));

/* @internal */
const mapBoth$5 = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchEffect$3(self, {
  onFailure: e => failSync$6(() => onFailure(e)),
  onSuccess: a => sync$a(() => onSuccess(a))
}));

/* @internal */
const mapError$6 = /*#__PURE__*/dual(2, (self, f) => matchCauseEffect$1(self, {
  onFailure: cause => {
    const either = failureOrCause$1(cause);
    switch (either._tag) {
      case "Left":
        {
          return failSync$6(() => f(either.left));
        }
      case "Right":
        {
          return failCause$a(either.right);
        }
    }
  },
  onSuccess: succeed$h
}));

/* @internal */
const onError$2 = /*#__PURE__*/dual(2, (self, cleanup) => onExit$1(self, unified$1(exit => exitIsSuccess(exit) ? unit$6 : cleanup(exit.i0))));

/* @internal */
const onExit$1 = /*#__PURE__*/dual(2, (self, cleanup) => uninterruptibleMask$1(restore => matchCauseEffect$1(restore(self), {
  onFailure: cause1 => {
    const result = exitFailCause(cause1);
    return matchCauseEffect$1(cleanup(result), {
      onFailure: cause2 => exitFailCause(sequential$2(cause1, cause2)),
      onSuccess: () => result
    });
  },
  onSuccess: success => {
    const result = exitSucceed(success);
    return zipRight$8(cleanup(result), result);
  }
})));

/* @internal */
const onInterrupt$1 = /*#__PURE__*/dual(2, (self, cleanup) => onExit$1(self, exitMatch({
  onFailure: cause => isInterruptedOnly$1(cause) ? asUnit$4(cleanup(interruptors(cause))) : unit$6,
  onSuccess: () => unit$6
})));

/* @internal */
const orElse$a = /*#__PURE__*/dual(2, (self, that) => attemptOrElse(self, that, succeed$h));

/* @internal */
const orDie$5 = self => orDieWith$4(self, identity$1);

/* @internal */
const orDieWith$4 = /*#__PURE__*/dual(2, (self, f) => matchEffect$3(self, {
  onFailure: e => die$9(f(e)),
  onSuccess: succeed$h
}));

/* @internal */
const partitionMap = (elements, f) => fromIterable$c(elements).reduceRight(([lefts, rights], current) => {
  const either = f(current);
  switch (either._tag) {
    case "Left":
      {
        return [[either.left, ...lefts], rights];
      }
    case "Right":
      {
        return [lefts, [either.right, ...rights]];
      }
  }
}, [new Array(), new Array()]);

/* @internal */
const runtimeFlags = /*#__PURE__*/withFiberRuntime((_, status) => succeed$h(status.runtimeFlags));

/* @internal */
const succeed$h = value => {
  const effect = new EffectPrimitiveSuccess(OP_SUCCESS);
  effect.i0 = value;
  return effect;
};

/* @internal */
const suspend$8 = effect => flatMap$6(sync$a(effect), identity$1);

/* @internal */
const sync$a = evaluate => {
  const effect = new EffectPrimitive(OP_SYNC$1);
  effect.i0 = evaluate;
  return effect;
};

/* @internal */
const tap$5 = /*#__PURE__*/dual(2, (self, f) => flatMap$6(self, a => as$6(f(a), a)));

/* @internal */
const transplant$1 = f => withFiberRuntime(state => {
  const scopeOverride = state.getFiberRef(currentForkScopeOverride);
  const scope = pipe(scopeOverride, getOrElse$3(() => state.scope()));
  return f(fiberRefLocally$1(currentForkScopeOverride, some$6(scope)));
});

/* @internal */
const attemptOrElse = /*#__PURE__*/dual(3, (self, that, onSuccess) => matchCauseEffect$1(self, {
  onFailure: cause => {
    const defects$1 = defects(cause);
    if (defects$1.length > 0) {
      return failCause$a(getOrThrow(keepDefectsAndElectFailures(cause)));
    }
    return that();
  },
  onSuccess
}));

/* @internal */
const uninterruptible$1 = self => {
  const effect = new EffectPrimitive(OP_UPDATE_RUNTIME_FLAGS);
  effect.i0 = disable(Interruption);
  effect.i1 = () => flatMapStep$1(self, _continue);
  const _continue = orBlock => {
    if (orBlock._tag === "Blocked") {
      return blocked$1(orBlock.i0, uninterruptible$1(orBlock.i1));
    } else {
      return orBlock;
    }
  };
  return effect;
};

/* @internal */
const uninterruptibleMask$1 = f => {
  const effect = new EffectPrimitive(OP_UPDATE_RUNTIME_FLAGS);
  effect.i0 = disable(Interruption);
  const _continue = step => {
    if (step._op === "Blocked") {
      return blocked$1(step.i0, uninterruptible$1(step.i1));
    }
    return step;
  };
  effect.i1 = oldFlags => interruption(oldFlags) ? step$1(f(interruptible$1)) : step$1(f(uninterruptible$1));
  return flatMap$6(effect, _continue);
};

/* @internal */
const unit$6 = /*#__PURE__*/succeed$h(void 0);

/* @internal */
const updateRuntimeFlags = patch => {
  const effect = new EffectPrimitive(OP_UPDATE_RUNTIME_FLAGS);
  effect.i0 = patch;
  effect.i1 = void 0;
  return effect;
};

/* @internal */
const whenEffect$2 = /*#__PURE__*/dual(2, (self, predicate) => flatMap$6(predicate, b => {
  if (b) {
    return pipe(self, map$f(some$6));
  }
  return succeed$h(none$8());
}));

/* @internal */
const whileLoop$1 = options => {
  const effect = new EffectPrimitive(OP_WHILE);
  effect.i0 = options.while;
  effect.i1 = options.body;
  effect.i2 = options.step;
  return effect;
};

/* @internal */
const withConcurrency$1 = /*#__PURE__*/dual(2, (self, concurrency) => fiberRefLocally$1(self, currentConcurrency, concurrency));

/* @internal */
const withRequestBatching$1 = /*#__PURE__*/dual(2, (self, requestBatching) => fiberRefLocally$1(self, currentRequestBatching, requestBatching));

/* @internal */
const withRuntimeFlags = /*#__PURE__*/dual(2, (self, update) => {
  const effect = new EffectPrimitive(OP_UPDATE_RUNTIME_FLAGS);
  effect.i0 = update;
  effect.i1 = () => self;
  return effect;
});

/** @internal */
const withTracerTiming$1 = /*#__PURE__*/dual(2, (effect, enabled) => fiberRefLocally$1(effect, currentTracerTimingEnabled, enabled));

/* @internal */
const yieldNow$2 = options => {
  const effect = new EffectPrimitive(OP_YIELD$1);
  return typeof options?.priority !== "undefined" ? withSchedulingPriority$1(options.priority)(effect) : effect;
};

/* @internal */
const zip$a = /*#__PURE__*/dual(2, (self, that) => flatMap$6(self, a => map$f(that, b => [a, b])));

/* @internal */
const zipLeft$7 = /*#__PURE__*/dual(2, (self, that) => flatMap$6(self, a => as$6(that, a)));

/* @internal */
const zipRight$8 = /*#__PURE__*/dual(2, (self, that) => flatMap$6(self, () => that));

/* @internal */
const zipWith$7 = /*#__PURE__*/dual(3, (self, that, f) => flatMap$6(self, a => map$f(that, b => f(a, b))));

/* @internal */
const never$6 = /*#__PURE__*/asyncEither$1(() => {
  const interval = setInterval(() => {
    //
  }, 2 ** 31 - 1);
  return left(sync$a(() => clearInterval(interval)));
});

// -----------------------------------------------------------------------------
// Fiber
// -----------------------------------------------------------------------------

/* @internal */
const interruptFiber = self => flatMap$6(fiberId$2, fiberId => pipe(self, interruptAsFiber(fiberId)));

/* @internal */
const interruptAsFiber = /*#__PURE__*/dual(2, (self, fiberId) => flatMap$6(self.interruptAsFork(fiberId), () => self.await()));

// -----------------------------------------------------------------------------
// LogLevel
// -----------------------------------------------------------------------------

/** @internal */
const logLevelAll = {
  _tag: "All",
  syslog: 0,
  label: "ALL",
  ordinal: Number.MIN_SAFE_INTEGER,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const logLevelFatal = {
  _tag: "Fatal",
  syslog: 2,
  label: "FATAL",
  ordinal: 50000,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const logLevelError = {
  _tag: "Error",
  syslog: 3,
  label: "ERROR",
  ordinal: 40000,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const logLevelWarning = {
  _tag: "Warning",
  syslog: 4,
  label: "WARN",
  ordinal: 30000,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const logLevelInfo = {
  _tag: "Info",
  syslog: 6,
  label: "INFO",
  ordinal: 20000,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const logLevelDebug = {
  _tag: "Debug",
  syslog: 7,
  label: "DEBUG",
  ordinal: 10000,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const logLevelTrace = {
  _tag: "Trace",
  syslog: 7,
  label: "TRACE",
  ordinal: 0,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const logLevelNone = {
  _tag: "None",
  syslog: 7,
  label: "OFF",
  ordinal: Number.MAX_SAFE_INTEGER,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const allLogLevels = [logLevelAll, logLevelTrace, logLevelDebug, logLevelInfo, logLevelWarning, logLevelError, logLevelFatal, logLevelNone];

// -----------------------------------------------------------------------------
// FiberRef
// -----------------------------------------------------------------------------

/** @internal */
const FiberRefSymbolKey = "effect/FiberRef";

/** @internal */
const FiberRefTypeId = /*#__PURE__*/Symbol.for(FiberRefSymbolKey);

/** @internal */
const fiberRefVariance = {
  _A: _ => _
};

/* @internal */
const fiberRefGet = self => fiberRefModify(self, a => [a, a]);

/* @internal */
const fiberRefGetAndSet = /*#__PURE__*/dual(2, (self, value) => fiberRefModify(self, v => [v, value]));

/* @internal */
const fiberRefGetAndUpdate = /*#__PURE__*/dual(2, (self, f) => fiberRefModify(self, v => [v, f(v)]));

/* @internal */
const fiberRefGetAndUpdateSome = /*#__PURE__*/dual(2, (self, pf) => fiberRefModify(self, v => [v, getOrElse$3(pf(v), () => v)]));

/* @internal */
const fiberRefGetWith = /*#__PURE__*/dual(2, (self, f) => flatMap$6(fiberRefGet(self), f));

/* @internal */
const fiberRefSet = /*#__PURE__*/dual(2, (self, value) => fiberRefModify(self, () => [void 0, value]));

/* @internal */
const fiberRefDelete = self => withFiberRuntime(state => {
  state.unsafeDeleteFiberRef(self);
  return unit$6;
});

/* @internal */
const fiberRefReset = self => fiberRefSet(self, self.initial);

/* @internal */
const fiberRefModify = /*#__PURE__*/dual(2, (self, f) => withFiberRuntime(state => {
  const [b, a] = f(state.getFiberRef(self));
  state.setFiberRef(self, a);
  return succeed$h(b);
}));

/* @internal */
const fiberRefModifySome = (self, def, f) => fiberRefModify(self, v => getOrElse$3(f(v), () => [def, v]));

/* @internal */
const fiberRefUpdate = /*#__PURE__*/dual(2, (self, f) => fiberRefModify(self, v => [void 0, f(v)]));

/* @internal */
const fiberRefUpdateSome = /*#__PURE__*/dual(2, (self, pf) => fiberRefModify(self, v => [void 0, getOrElse$3(pf(v), () => v)]));

/* @internal */
const fiberRefUpdateAndGet = /*#__PURE__*/dual(2, (self, f) => fiberRefModify(self, v => {
  const result = f(v);
  return [result, result];
}));

/* @internal */
const fiberRefUpdateSomeAndGet = /*#__PURE__*/dual(2, (self, pf) => fiberRefModify(self, v => {
  const result = getOrElse$3(pf(v), () => v);
  return [result, result];
}));

// circular
/** @internal */
const RequestResolverSymbolKey = "effect/RequestResolver";

/** @internal */
const RequestResolverTypeId = /*#__PURE__*/Symbol.for(RequestResolverSymbolKey);
const dataSourceVariance = {
  _R: _ => _,
  _A: _ => _
};

/** @internal */
class RequestResolverImpl {
  [RequestResolverTypeId] = dataSourceVariance;
  constructor(runAll, target) {
    this.runAll = runAll;
    this.target = target;
    this.runAll = runAll;
  }
  [symbol$1]() {
    return this.target ? hash$1(this.target) : random$2(this);
  }
  [symbol](that) {
    return this.target ? isRequestResolver(that) && equals$1(this.target, that.target) : this === that;
  }
  identified(...ids) {
    return new RequestResolverImpl(this.runAll, fromIterable$b(ids));
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const isRequestResolver = u => typeof u === "object" && u != null && RequestResolverTypeId in u;

// end

/** @internal */
const resolverLocally = /*#__PURE__*/dual(3, (use, self, value) => new RequestResolverImpl(requests => fiberRefLocally$1(use.runAll(requests), self, value), make$11("Locally", use, self, value)));

/** @internal */
const requestBlockLocally = (self, ref, value) => reduce$b(self, LocallyReducer(ref, value));
const LocallyReducer = (ref, value) => ({
  emptyCase: () => empty$o,
  parCase: (left, right) => par(left, right),
  seqCase: (left, right) => seq(left, right),
  singleCase: (dataSource, blockedRequest) => single(resolverLocally(dataSource, ref, value), blockedRequest)
});

/* @internal */
const fiberRefLocally$1 = /*#__PURE__*/dual(3, (use, self, value) => flatMap$6(acquireUseRelease$3(zipLeft$7(fiberRefGet(self), fiberRefSet(self, value)), () => step$1(use), oldValue => fiberRefSet(self, oldValue)), res => {
  if (res._op === "Blocked") {
    return blocked$1(res.i0, fiberRefLocally$1(res.i1, self, value));
  }
  return res;
}));

/* @internal */
const fiberRefLocallyWith$1 = /*#__PURE__*/dual(3, (use, self, f) => fiberRefGetWith(self, a => fiberRefLocally$1(use, self, f(a))));

/** @internal */
const fiberRefUnsafeMake = (initial, options) => fiberRefUnsafeMakePatch(initial, {
  differ: update$7(),
  fork: options?.fork ?? identity$1,
  join: options?.join
});

/** @internal */
const fiberRefUnsafeMakeHashSet = initial => {
  const differ = hashSet$1();
  return fiberRefUnsafeMakePatch(initial, {
    differ,
    fork: differ.empty
  });
};

/** @internal */
const fiberRefUnsafeMakeContext = initial => {
  const differ = environment();
  return fiberRefUnsafeMakePatch(initial, {
    differ,
    fork: differ.empty
  });
};

/** @internal */
const fiberRefUnsafeMakePatch = (initial, options) => ({
  [FiberRefTypeId]: fiberRefVariance,
  initial,
  diff: (oldValue, newValue) => options.differ.diff(oldValue, newValue),
  combine: (first, second) => options.differ.combine(first, second),
  patch: patch => oldValue => options.differ.patch(patch, oldValue),
  fork: options.fork,
  join: options.join ?? ((_, n) => n),
  pipe() {
    return pipeArguments(this, arguments);
  }
});

/** @internal */
const fiberRefUnsafeMakeRuntimeFlags = initial => fiberRefUnsafeMakePatch(initial, {
  differ: differ$1,
  fork: differ$1.empty
});

/** @internal */
const currentContext$1 = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentContext"), () => fiberRefUnsafeMakeContext(empty$A()));

/** @internal */
const currentSchedulingPriority$1 = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentSchedulingPriority"), () => fiberRefUnsafeMake(0));

/** @internal */
const currentMaxOpsBeforeYield = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentMaxOpsBeforeYield"), () => fiberRefUnsafeMake(2048));

/** @internal */
const currentLogAnnotations = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentLogAnnotation"), () => fiberRefUnsafeMake(empty$u()));

/** @internal */
const currentLogLevel = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentLogLevel"), () => fiberRefUnsafeMake(logLevelInfo));

/** @internal */
const currentLogSpan = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentLogSpan"), () => fiberRefUnsafeMake(empty$p()));

/** @internal */
const withSchedulingPriority$1 = /*#__PURE__*/dual(2, (self, scheduler) => fiberRefLocally$1(self, currentSchedulingPriority$1, scheduler));

/** @internal */
const withMaxOpsBeforeYield$1 = /*#__PURE__*/dual(2, (self, scheduler) => fiberRefLocally$1(self, currentMaxOpsBeforeYield, scheduler));

/** @internal */
const currentConcurrency = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentConcurrency"), () => fiberRefUnsafeMake("unbounded"));

/**
 * @internal
 */
const currentRequestBatching = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentRequestBatching"), () => fiberRefUnsafeMake(true));

/** @internal */
const currentUnhandledErrorLogLevel = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentUnhandledErrorLogLevel"), () => fiberRefUnsafeMake(some$6(logLevelDebug)));

/** @internal */
const withUnhandledErrorLogLevel$1 = /*#__PURE__*/dual(2, (self, level) => fiberRefLocally$1(self, currentUnhandledErrorLogLevel, level));

/** @internal */
const currentMetricLabels = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentMetricLabels"), () => fiberRefUnsafeMakeHashSet(empty$s()));

/* @internal */
const metricLabels$1 = /*#__PURE__*/fiberRefGet(currentMetricLabels);

/** @internal */
const currentForkScopeOverride = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentForkScopeOverride"), () => fiberRefUnsafeMake(none$8(), {
  fork: () => none$8(),
  join: (parent, _) => parent
}));

/** @internal */
const currentInterruptedCause = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentInterruptedCause"), () => fiberRefUnsafeMake(empty$n, {
  fork: () => empty$n,
  join: (parent, _) => parent
}));

/** @internal */
const currentTracerTimingEnabled = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentTracerTiming"), () => fiberRefUnsafeMake(true));

/** @internal */
const currentTracerSpanAnnotations = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentTracerSpanAnnotations"), () => fiberRefUnsafeMake(empty$u()));

/** @internal */
const currentTracerSpanLinks = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentTracerSpanLinks"), () => fiberRefUnsafeMake(empty$z()));

// -----------------------------------------------------------------------------
// Scope
// -----------------------------------------------------------------------------

/** @internal */
const ScopeTypeId = /*#__PURE__*/Symbol.for("effect/Scope");

/** @internal */
const CloseableScopeTypeId = /*#__PURE__*/Symbol.for("effect/CloseableScope");

/* @internal */
const scopeAddFinalizer = (self, finalizer) => self.addFinalizer(() => asUnit$4(finalizer));

/* @internal */
const scopeAddFinalizerExit = (self, finalizer) => self.addFinalizer(finalizer);

/* @internal */
const scopeClose = (self, exit) => self.close(exit);

/* @internal */
const scopeFork = (self, strategy) => self.fork(strategy);

// -----------------------------------------------------------------------------
// ReleaseMap
// -----------------------------------------------------------------------------

/** @internal */
/** @internal */
/* @internal */
const releaseMapAdd = /*#__PURE__*/dual(2, (self, finalizer) => map$f(releaseMapAddIfOpen(self, finalizer), match$j({
  onNone: () => () => unit$6,
  onSome: key => exit => releaseMapRelease(key, exit)(self)
})));

/* @internal */
const releaseMapRelease = /*#__PURE__*/dual(3, (self, key, exit) => suspend$8(() => {
  switch (self.state._tag) {
    case "Exited":
      {
        return unit$6;
      }
    case "Running":
      {
        const finalizer = self.state.finalizers.get(key);
        self.state.finalizers.delete(key);
        if (finalizer != null) {
          return self.state.update(finalizer)(exit);
        }
        return unit$6;
      }
  }
}));

/* @internal */
const releaseMapAddIfOpen = /*#__PURE__*/dual(2, (self, finalizer) => suspend$8(() => {
  switch (self.state._tag) {
    case "Exited":
      {
        self.state.nextKey += 1;
        return as$6(finalizer(self.state.exit), none$8());
      }
    case "Running":
      {
        const key = self.state.nextKey;
        self.state.finalizers.set(key, finalizer);
        self.state.nextKey += 1;
        return succeed$h(some$6(key));
      }
  }
}));

/* @internal */
const releaseMapMake = /*#__PURE__*/sync$a(() => ({
  state: {
    _tag: "Running",
    nextKey: 0,
    finalizers: new Map(),
    update: identity$1
  }
}));

// -----------------------------------------------------------------------------
// Exit
// -----------------------------------------------------------------------------

/** @internal */
const exitIsExit = u => isEffect$1(u) && "_tag" in u && (u._tag === "Success" || u._tag === "Failure");

/** @internal */
const exitIsFailure = self => self._tag === "Failure";

/** @internal */
const exitIsSuccess = self => self._tag === "Success";

/** @internal */
const exitIsInterrupted = self => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return isInterrupted$1(self.i0);
      }
    case OP_SUCCESS:
      {
        return false;
      }
  }
};

/** @internal */
const exitAs = /*#__PURE__*/dual(2, (self, value) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return exitFailCause(self.i0);
      }
    case OP_SUCCESS:
      {
        return exitSucceed(value);
      }
  }
});

/** @internal */
const exitAsUnit = self => exitAs(self, void 0);

/** @internal */
const exitCauseOption = self => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return some$6(self.i0);
      }
    case OP_SUCCESS:
      {
        return none$8();
      }
  }
};

/** @internal */
const exitCollectAll = (exits, options) => exitCollectAllInternal(exits, options?.parallel ? parallel$3 : sequential$2);

/** @internal */
const exitDie = defect => exitFailCause(die$a(defect));

/** @internal */
const exitExists = /*#__PURE__*/dual(2, (self, predicate) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return false;
      }
    case OP_SUCCESS:
      {
        return predicate(self.i0);
      }
  }
});

/** @internal */
const exitFail = error => exitFailCause(fail$g(error));

/** @internal */
const exitFailCause = cause => {
  const effect = new EffectPrimitiveFailure(OP_FAILURE);
  effect.i0 = cause;
  return effect;
};

/** @internal */
const exitFlatMap = /*#__PURE__*/dual(2, (self, f) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return exitFailCause(self.i0);
      }
    case OP_SUCCESS:
      {
        return f(self.i0);
      }
  }
});

/** @internal */
const exitFlatMapEffect = /*#__PURE__*/dual(2, (self, f) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return succeed$h(exitFailCause(self.i0));
      }
    case OP_SUCCESS:
      {
        return f(self.i0);
      }
  }
});

/** @internal */
const exitFlatten = self => pipe(self, exitFlatMap(identity$1));

/** @internal */
const exitForEachEffect = /*#__PURE__*/dual(2, (self, f) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return succeed$h(exitFailCause(self.i0));
      }
    case OP_SUCCESS:
      {
        return exit$1(f(self.i0));
      }
  }
});

/** @internal */
const exitFromEither = either => {
  switch (either._tag) {
    case "Left":
      {
        return exitFail(either.left);
      }
    case "Right":
      {
        return exitSucceed(either.right);
      }
  }
};

/** @internal */
const exitFromOption = option => {
  switch (option._tag) {
    case "None":
      {
        return exitFail(void 0);
      }
    case "Some":
      {
        return exitSucceed(option.value);
      }
  }
};

/** @internal */
const exitGetOrElse = /*#__PURE__*/dual(2, (self, orElse) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return orElse(self.i0);
      }
    case OP_SUCCESS:
      {
        return self.i0;
      }
  }
});

/** @internal */
const exitInterrupt = fiberId => exitFailCause(interrupt$8(fiberId));

/** @internal */
const exitMap = /*#__PURE__*/dual(2, (self, f) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return exitFailCause(self.i0);
      }
    case OP_SUCCESS:
      {
        return exitSucceed(f(self.i0));
      }
  }
});

/** @internal */
const exitMapBoth = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return exitFailCause(pipe(self.i0, map$g(onFailure)));
      }
    case OP_SUCCESS:
      {
        return exitSucceed(onSuccess(self.i0));
      }
  }
});

/** @internal */
const exitMapError = /*#__PURE__*/dual(2, (self, f) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return exitFailCause(pipe(self.i0, map$g(f)));
      }
    case OP_SUCCESS:
      {
        return exitSucceed(self.i0);
      }
  }
});

/** @internal */
const exitMapErrorCause = /*#__PURE__*/dual(2, (self, f) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return exitFailCause(f(self.i0));
      }
    case OP_SUCCESS:
      {
        return exitSucceed(self.i0);
      }
  }
});

/** @internal */
const exitMatch = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return onFailure(self.i0);
      }
    case OP_SUCCESS:
      {
        return onSuccess(self.i0);
      }
  }
});

/** @internal */
const exitMatchEffect = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        return onFailure(self.i0);
      }
    case OP_SUCCESS:
      {
        return onSuccess(self.i0);
      }
  }
});

/** @internal */
const exitSucceed = value => {
  const effect = new EffectPrimitiveSuccess(OP_SUCCESS);
  effect.i0 = value;
  return effect;
};

/** @internal */
const exitUnit = /*#__PURE__*/exitSucceed(void 0);

/** @internal */
const exitZip = /*#__PURE__*/dual(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, a2) => [a, a2],
  onFailure: sequential$2
}));

/** @internal */
const exitZipLeft = /*#__PURE__*/dual(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, _) => a,
  onFailure: sequential$2
}));

/** @internal */
const exitZipRight = /*#__PURE__*/dual(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (_, a2) => a2,
  onFailure: sequential$2
}));

/** @internal */
const exitZipPar = /*#__PURE__*/dual(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, a2) => [a, a2],
  onFailure: parallel$3
}));

/** @internal */
const exitZipParLeft = /*#__PURE__*/dual(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, _) => a,
  onFailure: parallel$3
}));

/** @internal */
const exitZipParRight = /*#__PURE__*/dual(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (_, a2) => a2,
  onFailure: parallel$3
}));

/** @internal */
const exitZipWith = /*#__PURE__*/dual(3, (self, that, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case OP_FAILURE:
      {
        switch (that._tag) {
          case OP_SUCCESS:
            {
              return exitFailCause(self.i0);
            }
          case OP_FAILURE:
            {
              return exitFailCause(onFailure(self.i0, that.i0));
            }
        }
      }
    case OP_SUCCESS:
      {
        switch (that._tag) {
          case OP_SUCCESS:
            {
              return exitSucceed(onSuccess(self.i0, that.i0));
            }
          case OP_FAILURE:
            {
              return exitFailCause(that.i0);
            }
        }
      }
  }
});
const exitCollectAllInternal = (exits, combineCauses) => {
  const list = fromIterable$b(exits);
  if (!isNonEmpty$5(list)) {
    return none$8();
  }
  return pipe(tailNonEmpty(list), reduce$i(pipe(headNonEmpty(list), exitMap(of$3)), (accumulator, current) => pipe(accumulator, exitZipWith(current, {
    onSuccess: (list, value) => pipe(list, prepend$2(value)),
    onFailure: combineCauses
  }))), exitMap(reverse$1), exitMap(chunk => Array.from(chunk)), some$6);
};

// -----------------------------------------------------------------------------
// Deferred
// -----------------------------------------------------------------------------

/** @internal */
const deferredUnsafeMake = fiberId => ({
  [DeferredTypeId]: deferredVariance,
  state: make$W(pending$4([])),
  blockingOn: fiberId,
  pipe() {
    return pipeArguments(this, arguments);
  }
});

/* @internal */
const deferredMake = () => flatMap$6(fiberId$2, id => deferredMakeAs(id));

/* @internal */
const deferredMakeAs = fiberId => sync$a(() => deferredUnsafeMake(fiberId));

/* @internal */
const deferredAwait = self => asyncEither$1(k => {
  const state = get$f(self.state);
  switch (state._tag) {
    case OP_STATE_DONE$1:
      {
        return right(state.effect);
      }
    case OP_STATE_PENDING:
      {
        pipe(self.state, set$a(pending$4([k, ...state.joiners])));
        return left(deferredInterruptJoiner(self, k));
      }
  }
}, self.blockingOn);

/* @internal */
const deferredComplete = /*#__PURE__*/dual(2, (self, effect) => intoDeferred$1(effect, self));

/* @internal */
const deferredCompleteWith = /*#__PURE__*/dual(2, (self, effect) => sync$a(() => {
  const state = get$f(self.state);
  switch (state._tag) {
    case OP_STATE_DONE$1:
      {
        return false;
      }
    case OP_STATE_PENDING:
      {
        pipe(self.state, set$a(done$c(effect)));
        for (let i = 0; i < state.joiners.length; i++) {
          state.joiners[i](effect);
        }
        return true;
      }
  }
}));

/* @internal */
const deferredDone = /*#__PURE__*/dual(2, (self, exit) => deferredCompleteWith(self, exit));

/* @internal */
const deferredFail = /*#__PURE__*/dual(2, (self, error) => deferredCompleteWith(self, fail$f(error)));

/* @internal */
const deferredFailSync = /*#__PURE__*/dual(2, (self, evaluate) => deferredCompleteWith(self, failSync$6(evaluate)));

/* @internal */
const deferredFailCause = /*#__PURE__*/dual(2, (self, cause) => deferredCompleteWith(self, failCause$a(cause)));

/* @internal */
const deferredFailCauseSync = /*#__PURE__*/dual(2, (self, evaluate) => deferredCompleteWith(self, failCauseSync$5(evaluate)));

/* @internal */
const deferredDie = /*#__PURE__*/dual(2, (self, defect) => deferredCompleteWith(self, die$9(defect)));

/* @internal */
const deferredDieSync = /*#__PURE__*/dual(2, (self, evaluate) => deferredCompleteWith(self, dieSync$5(evaluate)));

/* @internal */
const deferredInterrupt = self => flatMap$6(fiberId$2, fiberId => deferredCompleteWith(self, interruptWith$1(fiberId)));

/* @internal */
const deferredInterruptWith = /*#__PURE__*/dual(2, (self, fiberId) => deferredCompleteWith(self, interruptWith$1(fiberId)));

/* @internal */
const deferredIsDone = self => sync$a(() => get$f(self.state)._tag === OP_STATE_DONE$1);

/* @internal */
const deferredPoll = self => sync$a(() => {
  const state = get$f(self.state);
  switch (state._tag) {
    case OP_STATE_DONE$1:
      {
        return some$6(state.effect);
      }
    case OP_STATE_PENDING:
      {
        return none$8();
      }
  }
});

/* @internal */
const deferredSucceed = /*#__PURE__*/dual(2, (self, value) => deferredCompleteWith(self, succeed$h(value)));

/* @internal */
const deferredSync = /*#__PURE__*/dual(2, (self, evaluate) => deferredCompleteWith(self, sync$a(evaluate)));

/** @internal */
const deferredUnsafeDone = (self, effect) => {
  const state = get$f(self.state);
  if (state._tag === OP_STATE_PENDING) {
    pipe(self.state, set$a(done$c(effect)));
    for (let i = state.joiners.length - 1; i >= 0; i--) {
      state.joiners[i](effect);
    }
  }
};
const deferredInterruptJoiner = (self, joiner) => sync$a(() => {
  const state = get$f(self.state);
  if (state._tag === OP_STATE_PENDING) {
    pipe(self.state, set$a(pending$4(state.joiners.filter(j => j !== joiner))));
  }
});

// -----------------------------------------------------------------------------
// Context
// -----------------------------------------------------------------------------

const constContext = /*#__PURE__*/fiberRefGet(currentContext$1);

/* @internal */
const context$7 = () => constContext;

/* @internal */
const contextWithEffect$4 = f => flatMap$6(context$7(), f);

/* @internal */
const provideContext$6 = /*#__PURE__*/dual(2, (self, context) => fiberRefLocally$1(currentContext$1, context)(self));

/* @internal */
const provideSomeContext$1 = /*#__PURE__*/dual(2, (self, context) => fiberRefLocallyWith$1(currentContext$1, parent => merge$8(parent, context))(self));

/* @internal */
const mapInputContext$6 = /*#__PURE__*/dual(2, (self, f) => contextWithEffect$4(context => provideContext$6(self, f(context))));

// -----------------------------------------------------------------------------
// Tracing
// -----------------------------------------------------------------------------

/** @internal */
const currentSpanFromFiber = fiber => {
  const span = fiber.getFiberRef(currentContext$1).unsafeMap.get(spanTag);
  return span !== undefined && span._tag === "Span" ? some$6(span) : none$8();
};

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
DeferredTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Deferred` represents an asynchronous variable that can be set exactly
 * once, with the ability for an arbitrary number of fibers to suspend (by
 * calling `Deferred.await`) and automatically resume when the variable is set.
 *
 * `Deferred` can be used for building primitive actions whose completions
 * require the coordinated action of multiple fibers, and for building
 * higher-level concurrent or asynchronous structures.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Creates a new `Deferred`.
 *
 * @since 2.0.0
 * @category constructors
 */
const make$R = deferredMake;

/**
 * Creates a new `Deferred` from the specified `FiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
deferredMakeAs;
const _await$3 = deferredAwait;

/**
 * Completes the deferred with the result of the specified effect. If the
 * deferred has already been completed, the method will produce false.
 *
 * Note that `Deferred.completeWith` will be much faster, so consider using
 * that if you do not need to memoize the result of the specified effect.
 *
 * @since 2.0.0
 * @category utils
 */
deferredComplete;

/**
 * Completes the deferred with the result of the specified effect. If the
 * deferred has already been completed, the method will produce false.
 *
 * @since 2.0.0
 * @category utils
 */
deferredCompleteWith;

/**
 * Exits the `Deferred` with the specified `Exit` value, which will be
 * propagated to all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const done$b = deferredDone;

/**
 * Fails the `Deferred` with the specified error, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const fail$e = deferredFail;

/**
 * Fails the `Deferred` with the specified error, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
deferredFailSync;

/**
 * Fails the `Deferred` with the specified `Cause`, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const failCause$9 = deferredFailCause;

/**
 * Fails the `Deferred` with the specified `Cause`, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
deferredFailCauseSync;

/**
 * Kills the `Deferred` with the specified defect, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
deferredDie;

/**
 * Kills the `Deferred` with the specified defect, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
deferredDieSync;

/**
 * Completes the `Deferred` with interruption. This will interrupt all fibers
 * waiting on the value of the `Deferred` with the `FiberId` of the fiber
 * calling this method.
 *
 * @since 2.0.0
 * @category utils
 */
const interrupt$6 = deferredInterrupt;

/**
 * Completes the `Deferred` with interruption. This will interrupt all fibers
 * waiting on the value of the `Deferred` with the specified `FiberId`.
 *
 * @since 2.0.0
 * @category utils
 */
deferredInterruptWith;

/**
 * Returns `true` if this `Deferred` has already been completed with a value or
 * an error, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isDone$6 = deferredIsDone;

/**
 * Returns a `Some<Effect<R, E, A>>` from the `Deferred` if this `Deferred` has
 * already been completed, `None` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const poll$8 = deferredPoll;

/**
 * Completes the `Deferred` with the specified value.
 *
 * @since 2.0.0
 * @category utils
 */
const succeed$g = deferredSucceed;

/**
 * Completes the `Deferred` with the specified lazily evaluated value.
 *
 * @since 2.0.0
 * @category utils
 */
deferredSync;

/**
 * Unsafely creates a new `Deferred` from the specified `FiberId`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake$5 = deferredUnsafeMake;

/**
 * Unsafely exits the `Deferred` with the specified `Exit` value, which will be
 * propagated to all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category unsafe
 */
deferredUnsafeDone;

/**
 * @since 2.0.0
 */
const TypeId$7 = /*#__PURE__*/Symbol.for("effect/Duration");
const bigint1e3 = /*#__PURE__*/BigInt(1_000);
const bigint1e9 = /*#__PURE__*/BigInt(1_000_000_000);

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

const DURATION_REGEX = /^(-?\d+(?:\.\d+)?)\s+(nanos|micros|millis|seconds|minutes|hours|days|weeks)$/;

/**
 * @since 2.0.0
 */
const decode = input => {
  if (isDuration(input)) {
    return input;
  } else if (isNumber(input)) {
    return millis(input);
  } else if (isBigInt(input)) {
    return nanos(input);
  } else {
    DURATION_REGEX.lastIndex = 0; // Reset the lastIndex before each use
    const match = DURATION_REGEX.exec(input);
    if (match) {
      const [_, valueStr, unit] = match;
      const value = Number(valueStr);
      switch (unit) {
        case "nanos":
          return nanos(BigInt(valueStr));
        case "micros":
          return micros(BigInt(valueStr));
        case "millis":
          return millis(value);
        case "seconds":
          return seconds(value);
        case "minutes":
          return minutes(value);
        case "hours":
          return hours(value);
        case "days":
          return days(value);
        case "weeks":
          return weeks(value);
      }
    }
  }
  throw new Error("Invalid duration input");
};
const zeroValue = {
  _tag: "Millis",
  millis: 0
};
const infinityValue = {
  _tag: "Infinity"
};
const DurationProto = {
  [TypeId$7]: TypeId$7,
  [symbol$1]() {
    return structure(this.value);
  },
  [symbol](that) {
    return isDuration(that) && equals(this, that);
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    switch (this.value._tag) {
      case "Millis":
        return {
          _id: "Duration",
          _tag: "Millis",
          millis: this.value.millis
        };
      case "Nanos":
        return {
          _id: "Duration",
          _tag: "Nanos",
          hrtime: toHrTime(this)
        };
      case "Infinity":
        return {
          _id: "Duration",
          _tag: "Infinity"
        };
    }
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const make$Q = input => {
  const duration = Object.create(DurationProto);
  if (isNumber(input)) {
    if (isNaN(input) || input < 0) {
      duration.value = zeroValue;
    } else if (!Number.isFinite(input)) {
      duration.value = infinityValue;
    } else if (!Number.isInteger(input)) {
      duration.value = {
        _tag: "Nanos",
        nanos: BigInt(Math.round(input * 1_000_000))
      };
    } else {
      duration.value = {
        _tag: "Millis",
        millis: input
      };
    }
  } else if (input < BigInt(0)) {
    duration.value = zeroValue;
  } else {
    duration.value = {
      _tag: "Nanos",
      nanos: input
    };
  }
  return duration;
};

/**
 * @since 2.0.0
 * @category guards
 */
const isDuration = u => typeof u === "object" && u !== null && TypeId$7 in u;

/**
 * @since 2.0.0
 * @category constructors
 */
const zero = /*#__PURE__*/make$Q(0);

/**
 * @since 2.0.0
 * @category constructors
 */
const infinity = /*#__PURE__*/make$Q(Infinity);

/**
 * @since 2.0.0
 * @category constructors
 */
const nanos = nanos => make$Q(nanos);

/**
 * @since 2.0.0
 * @category constructors
 */
const micros = micros => make$Q(micros * bigint1e3);

/**
 * @since 2.0.0
 * @category constructors
 */
const millis = millis => make$Q(millis);

/**
 * @since 2.0.0
 * @category constructors
 */
const seconds = seconds => make$Q(seconds * 1000);

/**
 * @since 2.0.0
 * @category constructors
 */
const minutes = minutes => make$Q(minutes * 60_000);

/**
 * @since 2.0.0
 * @category constructors
 */
const hours = hours => make$Q(hours * 3_600_000);

/**
 * @since 2.0.0
 * @category constructors
 */
const days = days => make$Q(days * 86_400_000);

/**
 * @since 2.0.0
 * @category constructors
 */
const weeks = weeks => make$Q(weeks * 604_800_000);

/**
 * @since 2.0.0
 * @category getters
 */
const toMillis = self => {
  const _self = decode(self);
  switch (_self.value._tag) {
    case "Infinity":
      return Infinity;
    case "Nanos":
      return Number(_self.value.nanos) / 1_000_000;
    case "Millis":
      return _self.value.millis;
  }
};

/**
 * @since 2.0.0
 * @category getters
 */
const toHrTime = self => {
  const _self = decode(self);
  switch (_self.value._tag) {
    case "Infinity":
      return [Infinity, 0];
    case "Nanos":
      return [Number(_self.value.nanos / bigint1e9), Number(_self.value.nanos % bigint1e9)];
    case "Millis":
      return [Math.floor(_self.value.millis / 1000), Math.round(_self.value.millis % 1000 * 1_000_000)];
  }
};

/**
 * @since 2.0.0
 * @category pattern matching
 */
const match$g = /*#__PURE__*/dual(2, (self, options) => {
  const _self = decode(self);
  switch (_self.value._tag) {
    case "Nanos":
      return options.onNanos(_self.value.nanos);
    case "Infinity":
      return options.onMillis(Infinity);
    case "Millis":
      return options.onMillis(_self.value.millis);
  }
});

/**
 * @since 2.0.0
 * @category pattern matching
 */
const matchWith = /*#__PURE__*/dual(3, (self, that, options) => {
  const _self = decode(self);
  const _that = decode(that);
  if (_self.value._tag === "Infinity" || _that.value._tag === "Infinity") {
    return options.onMillis(toMillis(_self), toMillis(_that));
  } else if (_self.value._tag === "Nanos" || _that.value._tag === "Nanos") {
    const selfNanos = _self.value._tag === "Nanos" ? _self.value.nanos : BigInt(Math.round(_self.value.millis * 1_000_000));
    const thatNanos = _that.value._tag === "Nanos" ? _that.value.nanos : BigInt(Math.round(_that.value.millis * 1_000_000));
    return options.onNanos(selfNanos, thatNanos);
  }
  return options.onMillis(_self.value.millis, _that.value.millis);
});

/**
 * @category instances
 * @since 2.0.0
 */
const Equivalence = (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self === that,
  onNanos: (self, that) => self === that
});

/**
 * @since 2.0.0
 * @category math
 */
const times = /*#__PURE__*/dual(2, (self, times) => match$g(self, {
  onMillis: millis => make$Q(millis * times),
  onNanos: nanos => make$Q(nanos * BigInt(times))
}));

/**
 * @since 2.0.0
 * @category math
 */
const sum$1 = /*#__PURE__*/dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => make$Q(self + that),
  onNanos: (self, that) => make$Q(self + that)
}));

/**
 * @since 2.0.0
 * @category predicates
 */
const lessThan$5 = /*#__PURE__*/dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self < that,
  onNanos: (self, that) => self < that
}));

/**
 * @since 2.0.0
 * @category predicates
 */
const greaterThan$2 = /*#__PURE__*/dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self > that,
  onNanos: (self, that) => self > that
}));

/**
 * @since 2.0.0
 * @category predicates
 */
const greaterThanOrEqualTo = /*#__PURE__*/dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self >= that,
  onNanos: (self, that) => self >= that
}));

/**
 * @since 2.0.0
 * @category predicates
 */
const equals = /*#__PURE__*/dual(2, (self, that) => Equivalence(decode(self), decode(that)));

/**
 * @since 2.0.0
 */

/**
 * An `Exit<E, A>` describes the result of a executing an `Effect` workflow.
 *
 * There are two possible values for an `Exit<E, A>`:
 *   - `Exit.Success` contain a success value of type `A`
 *   - `Exit.Failure` contains a failure `Cause` of type `E`
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Represents a failed `Effect` workflow containing the `Cause` of the failure
 * of type `E`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * Represents a successful `Effect` workflow and containing the returned value
 * of type `A`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Returns `true` if the specified value is an `Exit`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
exitIsExit;

/**
 * Returns `true` if the specified `Exit` is a `Failure`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isFailure$5 = exitIsFailure;

/**
 * Returns `true` if the specified `Exit` is a `Success`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isSuccess$5 = exitIsSuccess;

/**
 * Returns `true` if the specified exit is a `Failure` **and** the `Cause` of
 * the failure was due to interruption, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
exitIsInterrupted;

/**
 * Maps the `Success` value of the specified exit to the provided constant
 * value.
 *
 * @since 2.0.0
 * @category mapping
 */
exitAs;

/**
 * Maps the `Success` value of the specified exit to a void.
 *
 * @since 2.0.0
 * @category mapping
 */
exitAsUnit;

/**
 * Returns a `Some<Cause<E>>` if the specified exit is a `Failure`, `None`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
exitCauseOption;

/**
 * Collects all of the specified exit values into a `Some<Exit<E, List<A>>>`. If
 * the provided iterable contains no elements, `None` will be returned.
 *
 * @since 2.0.0
 * @category constructors
 */
const all$4 = exitCollectAll;

/**
 * Constructs a new `Exit.Failure` from the specified unrecoverable defect.
 *
 * @since 2.0.0
 * @category constructors
 */
const die$8 = exitDie;

/**
 * Executes the predicate on the value of the specified exit if it is a
 * `Success`, otherwise returns `false`.
 *
 * @since 2.0.0
 * @category elements
 */
exitExists;

/**
 * Constructs a new `Exit.Failure` from the specified recoverable error of type
 * `E`.
 *
 * @since 2.0.0
 * @category constructors
 */
const fail$d = exitFail;

/**
 * Constructs a new `Exit.Failure` from the specified `Cause` of type `E`.
 *
 * @since 2.0.0
 * @category constructors
 */
const failCause$8 = exitFailCause;

/**
 * @since 2.0.0
 * @category sequencing
 */
exitFlatMap;

/**
 * @since 2.0.0
 * @category sequencing
 */
exitFlatMapEffect;

/**
 * @since 2.0.0
 * @category sequencing
 */
const flatten$5 = exitFlatten;

/**
 * @since 2.0.0
 * @category traversing
 */
const forEachEffect = exitForEachEffect;

/**
 * Converts an `Either<E, A>` into an `Exit<E, A>`.
 *
 * @since 2.0.0
 * @category conversions
 */
exitFromEither;

/**
 * Converts an `Option<A>` into an `Exit<void, A>`.
 *
 * @since 2.0.0
 * @category conversions
 */
exitFromOption;

/**
 * Returns the `A` if specified exit is a `Success`, otherwise returns the
 * alternate `A` value computed from the specified function which receives the
 * `Cause<E>` of the exit `Failure`.
 *
 * @since 2.0.0
 * @category getters
 */
exitGetOrElse;

/**
 * Constructs a new `Exit.Failure` from the specified `FiberId` indicating that
 * the `Fiber` running an `Effect` workflow was terminated due to interruption.
 *
 * @since 2.0.0
 * @category constructors
 */
const interrupt$5 = exitInterrupt;

/**
 * Maps over the `Success` value of the specified exit using the provided
 * function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map$e = exitMap;

/**
 * Maps over the `Success` and `Failure` cases of the specified exit using the
 * provided functions.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapBoth$4 = exitMapBoth;

/**
 * Maps over the error contained in the `Failure` of the specified exit using
 * the provided function.
 *
 * @since 2.0.0
 * @category mapping
 */
exitMapError;

/**
 * Maps over the `Cause` contained in the `Failure` of the specified exit using
 * the provided function.
 *
 * @since 2.0.0
 * @category mapping
 */
exitMapErrorCause;

/**
 * @since 2.0.0
 * @category folding
 */
const match$f = exitMatch;

/**
 * @since 2.0.0
 * @category folding
 */
const matchEffect$2 = exitMatchEffect;

/**
 * Constructs a new `Exit.Success` containing the specified value of type `A`.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeed$f = exitSucceed;

/**
 * Represents an `Exit` which succeeds with `undefined`.
 *
 * @since 2.0.0
 * @category constructors
 */
const unit$5 = exitUnit;

/**
 * Sequentially zips the this result with the specified result or else returns
 * the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zip$9 = exitZip;

/**
 * Sequentially zips the this result with the specified result discarding the
 * second element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
exitZipLeft;

/**
 * Sequentially zips the this result with the specified result discarding the
 * first element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipRight$7 = exitZipRight;

/**
 * Parallelly zips the this result with the specified result or else returns
 * the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
exitZipPar;

/**
 * Parallelly zips the this result with the specified result discarding the
 * second element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
exitZipParLeft;

/**
 * Parallelly zips the this result with the specified result discarding the
 * first element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
exitZipParRight;

/**
 * Zips this exit together with that exit using the specified combination
 * functions.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipWith$6 = exitZipWith;

/**
 * @since 2.0.0
 */
const TypeId$6 = /*#__PURE__*/Symbol.for("effect/MutableHashMap");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

const MutableHashMapProto = {
  [TypeId$6]: TypeId$6,
  [Symbol.iterator]() {
    return this.backingMap.current[Symbol.iterator]();
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableHashMap",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const fromHashMap = backingMap => {
  const map = Object.create(MutableHashMapProto);
  map.backingMap = make$W(backingMap);
  return map;
};

/**
 * @since 2.0.0
 * @category constructors
 */
const empty$k = () => fromHashMap(empty$u());

/**
 * @since 2.0.0
 * @category elements
 */
const get$e = /*#__PURE__*/dual(2, (self, key) => get$g(self.backingMap.current, key));

/**
 * @since 2.0.0
 * @category elements
 */
const has$4 = /*#__PURE__*/dual(2, (self, key) => isSome(get$e(self, key)));

/**
 * @since 2.0.0
 */
const remove$5 = /*#__PURE__*/dual(2, (self, key) => {
  update$6(self.backingMap, remove$7(key));
  return self;
});

/**
 * @since 2.0.0
 */
const set$9 = /*#__PURE__*/dual(3, (self, key, value) => {
  update$6(self.backingMap, set$b(key, value));
  return self;
});

/**
 * @since 2.0.0
 * @category elements
 */
const size$e = self => size$h(get$f(self.backingMap));

/**
 * @since 2.0.0
 */
const TypeId$5 = /*#__PURE__*/Symbol.for("effect/MutableList");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category model
 */

const MutableListProto = {
  [TypeId$5]: TypeId$5,
  [Symbol.iterator]() {
    let done = false;
    let head = this.head;
    return {
      next() {
        if (done) {
          return this.return();
        }
        if (head == null) {
          done = true;
          return this.return();
        }
        const value = head.value;
        head = head.next;
        return {
          done,
          value
        };
      },
      return(value) {
        if (!done) {
          done = true;
        }
        return {
          done: true,
          value
        };
      }
    };
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableList",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
/** @internal */
class LinkedListNode {
  removed = false;
  prev = undefined;
  next = undefined;
  constructor(value) {
    this.value = value;
  }
}

/**
 * Creates an empty `MutableList`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$j = () => {
  const list = Object.create(MutableListProto);
  list.head = undefined;
  list.tail = undefined;
  list._length = 0;
  return list;
};

/**
 * Returns `true` if the list contains zero elements, `false`, otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty$c = self => length$1(self) === 0;

/**
 * Returns the length of the list.
 *
 * @since 2.0.0
 * @category getters
 */
const length$1 = self => self._length;

/**
 * Appends the specified element to the end of the `MutableList`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const append = /*#__PURE__*/dual(2, (self, value) => {
  const node = new LinkedListNode(value);
  if (self.head === undefined) {
    self.head = node;
  }
  if (self.tail === undefined) {
    self.tail = node;
  } else {
    self.tail.next = node;
    node.prev = self.tail;
    self.tail = node;
  }
  self._length += 1;
  return self;
});

/**
 * Removes the first value from the list and returns it, if it exists.
 *
 * @since 0.0.1
 */
const shift = self => {
  const head = self.head;
  if (head !== undefined) {
    remove$4(self, head);
    return head.value;
  }
  return undefined;
};
const remove$4 = (self, node) => {
  if (node.removed) {
    return;
  }
  node.removed = true;
  if (node.prev !== undefined && node.next !== undefined) {
    node.prev.next = node.next;
    node.next.prev = node.prev;
  } else if (node.prev !== undefined) {
    self.tail = node.prev;
    node.prev.next = undefined;
  } else if (node.next !== undefined) {
    self.head = node.next;
    node.next.prev = undefined;
  } else {
    self.tail = undefined;
    self.head = undefined;
  }
  if (self._length > 0) {
    self._length -= 1;
  }
};

/**
 * @since 2.0.0
 */
const TypeId$4 = /*#__PURE__*/Symbol.for("effect/MutableQueue");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category symbol
 */
const EmptyMutableQueue = /*#__PURE__*/Symbol.for("effect/mutable/MutableQueue/Empty");

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 */

const MutableQueueProto = {
  [TypeId$4]: TypeId$4,
  [Symbol.iterator]() {
    return Array.from(this.queue)[Symbol.iterator]();
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableQueue",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const make$P = capacity => {
  const queue = Object.create(MutableQueueProto);
  queue.queue = empty$j();
  queue.capacity = capacity;
  return queue;
};

/**
 * Creates a new bounded `MutableQueue`.
 *
 * @since 2.0.0
 * @category constructors
 */
const bounded$6 = capacity => make$P(capacity);

/**
 * Creates a new unbounded `MutableQueue`.
 *
 * @since 2.0.0
 * @category constructors
 */
const unbounded$6 = () => make$P(undefined);

/**
 * Returns the current number of elements in the queue.
 *
 * @since 2.0.0
 * @category getters
 */
const length = self => length$1(self.queue);

/**
 * Returns `true` if the queue is empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty$b = self => isEmpty$c(self.queue);

/**
 * The **maximum** number of elements that a queue can hold.
 *
 * **Note**: unbounded queues can still implement this interface with
 * `capacity = Infinity`.
 *
 * @since 2.0.0
 * @category getters
 */
const capacity$5 = self => self.capacity === undefined ? Infinity : self.capacity;

/**
 * Offers an element to the queue.
 *
 * Returns whether the enqueue was successful or not.
 *
 * @since 2.0.0
 */
const offer$5 = /*#__PURE__*/dual(2, (self, value) => {
  const queueLength = length$1(self.queue);
  if (self.capacity !== undefined && queueLength === self.capacity) {
    return false;
  }
  append(value)(self.queue);
  return true;
});

/**
 * Enqueues a collection of values into the queue.
 *
 * Returns a `Chunk` of the values that were **not** able to be enqueued.
 *
 * @since 2.0.0
 */
const offerAll$4 = /*#__PURE__*/dual(2, (self, values) => {
  const iterator = values[Symbol.iterator]();
  let next;
  let remainder = empty$z();
  let offering = true;
  while (offering && (next = iterator.next()) && !next.done) {
    offering = offer$5(next.value)(self);
  }
  while (next != null && !next.done) {
    remainder = prepend$2(next.value)(remainder);
    next = iterator.next();
  }
  return reverse$1(remainder);
});

/**
 * Dequeues an element from the queue.
 *
 * Returns either an element from the queue, or the `def` param.
 *
 * **Note**: if there is no meaningful default for your type, you can always
 * use `poll(MutableQueue.EmptyMutableQueue)`.
 *
 * @since 2.0.0
 */
const poll$7 = /*#__PURE__*/dual(2, (self, def) => {
  if (isEmpty$c(self.queue)) {
    return def;
  }
  return shift(self.queue);
});

/**
 * Dequeues up to `n` elements from the queue.
 *
 * Returns a `List` of up to `n` elements.
 *
 * @since 2.0.0
 */
const pollUpTo = /*#__PURE__*/dual(2, (self, n) => {
  let result = empty$z();
  let count = 0;
  while (count < n) {
    const element = poll$7(EmptyMutableQueue)(self);
    if (element === EmptyMutableQueue) {
      break;
    }
    result = prepend$2(element)(result);
    count += 1;
  }
  return reverse$1(result);
});

/**
 * Bun currently has a bug where `setTimeout` doesn't behave correctly with a 0ms delay.
 *
 * @see https://github.com/oven-sh/bun/issues/3333
 */

/** @internal */
const isBun = typeof process === "undefined" ? false : !!process?.isBun;

/** @internal */
const clear$1 = isBun ? id => clearInterval(id) : id => clearTimeout(id);

/** @internal */
const set$8 = isBun ? (fn, ms) => {
  const id = setInterval(() => {
    fn();
    clearInterval(id);
  }, ms);
  return id;
} : (fn, ms) => setTimeout(fn, ms);

/** @internal */
const ClockSymbolKey = "effect/Clock";

/** @internal */
const ClockTypeId = /*#__PURE__*/Symbol.for(ClockSymbolKey);

/** @internal */
const clockTag = /*#__PURE__*/Tag$1(ClockTypeId);

/** @internal */
const MAX_TIMER_MILLIS = 2 ** 31 - 1;

/** @internal */
const globalClockScheduler = {
  unsafeSchedule(task, duration) {
    const millis = toMillis(duration);
    // If the duration is greater than the value allowable by the JS timer
    // functions, treat the value as an infinite duration
    if (millis > MAX_TIMER_MILLIS) {
      return constFalse;
    }
    let completed = false;
    const handle = set$8(() => {
      completed = true;
      task();
    }, millis);
    return () => {
      clear$1(handle);
      return !completed;
    };
  }
};
const performanceNowNanos = /*#__PURE__*/function () {
  const bigint1e6 = /*#__PURE__*/BigInt(1_000_000);
  if (typeof performance === "undefined") {
    return () => BigInt(Date.now()) * bigint1e6;
  }
  const origin = "timeOrigin" in performance && typeof performance.timeOrigin === "number" ? /*#__PURE__*/BigInt( /*#__PURE__*/Math.round(performance.timeOrigin * 1_000_000)) : /*#__PURE__*/BigInt( /*#__PURE__*/Date.now()) * bigint1e6;
  return () => origin + BigInt(Math.round(performance.now() * 1_000_000));
}();
const processOrPerformanceNow = /*#__PURE__*/function () {
  const processHrtime = typeof process === "object" && "hrtime" in process && typeof process.hrtime.bigint === "function" ? process.hrtime : undefined;
  if (!processHrtime) {
    return performanceNowNanos;
  }
  const origin = /*#__PURE__*/performanceNowNanos() - /*#__PURE__*/processHrtime.bigint();
  return () => origin + processHrtime.bigint();
}();

/** @internal */
class ClockImpl {
  [ClockTypeId] = ClockTypeId;
  unsafeCurrentTimeMillis() {
    return Date.now();
  }
  unsafeCurrentTimeNanos() {
    return processOrPerformanceNow();
  }
  currentTimeMillis = sync$a(() => this.unsafeCurrentTimeMillis());
  currentTimeNanos = sync$a(() => this.unsafeCurrentTimeNanos());
  scheduler() {
    return succeed$h(globalClockScheduler);
  }
  sleep(duration) {
    return asyncEither$1(cb => {
      const canceler = globalClockScheduler.unsafeSchedule(() => cb(unit$6), duration);
      return left(asUnit$4(sync$a(canceler)));
    });
  }
}

/** @internal */
const make$O = () => new ClockImpl();

/** @internal */

/** @internal */
const OP_AND = "And";

/** @internal */

/** @internal */
const OP_OR = "Or";

/** @internal */

/** @internal */
const OP_INVALID_DATA = "InvalidData";

/** @internal */

/** @internal */
const OP_MISSING_DATA = "MissingData";

/** @internal */

/** @internal */
const OP_SOURCE_UNAVAILABLE = "SourceUnavailable";

/** @internal */

/** @internal */
const OP_UNSUPPORTED = "Unsupported";

/** @internal */
const ConfigErrorSymbolKey = "effect/ConfigError";

/** @internal */
const ConfigErrorTypeId = /*#__PURE__*/Symbol.for(ConfigErrorSymbolKey);

/** @internal */
const proto$b = {
  [ConfigErrorTypeId]: ConfigErrorTypeId
};

/** @internal */
const And = (self, that) => {
  const error = Object.create(proto$b);
  error._tag = OP_AND;
  error.left = self;
  error.right = that;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      return `${this.left} and ${this.right}`;
    }
  });
  return error;
};

/** @internal */
const Or = (self, that) => {
  const error = Object.create(proto$b);
  error._tag = OP_OR;
  error.left = self;
  error.right = that;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      return `${this.left} or ${this.right}`;
    }
  });
  return error;
};

/** @internal */
const InvalidData = (path, message, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto$b);
  error._tag = OP_INVALID_DATA;
  error.path = path;
  error.message = message;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = pipe(this.path, join$2(options.pathDelim));
      return `(Invalid data at ${path}: "${this.message}")`;
    }
  });
  return error;
};

/** @internal */
const MissingData = (path, message, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto$b);
  error._tag = OP_MISSING_DATA;
  error.path = path;
  error.message = message;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = pipe(this.path, join$2(options.pathDelim));
      return `(Missing data at ${path}: "${this.message}")`;
    }
  });
  return error;
};

/** @internal */
const SourceUnavailable = (path, message, cause, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto$b);
  error._tag = OP_SOURCE_UNAVAILABLE;
  error.path = path;
  error.message = message;
  error.cause = cause;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = pipe(this.path, join$2(options.pathDelim));
      return `(Source unavailable at ${path}: "${this.message}")`;
    }
  });
  return error;
};

/** @internal */
const Unsupported = (path, message, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto$b);
  error._tag = OP_UNSUPPORTED;
  error.path = path;
  error.message = message;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = pipe(this.path, join$2(options.pathDelim));
      return `(Unsupported operation at ${path}: "${this.message}")`;
    }
  });
  return error;
};

/** @internal */
const isConfigError = u => typeof u === "object" && u != null && ConfigErrorTypeId in u;

/** @internal */
const isAnd = self => self._tag === OP_AND;

/** @internal */
const isOr = self => self._tag === OP_OR;

/** @internal */
const isInvalidData = self => self._tag === OP_INVALID_DATA;

/** @internal */
const isMissingData = self => self._tag === OP_MISSING_DATA;

/** @internal */
const isSourceUnavailable = self => self._tag === OP_SOURCE_UNAVAILABLE;

/** @internal */
const isUnsupported = self => self._tag === OP_UNSUPPORTED;

/** @internal */
const prefixed = /*#__PURE__*/dual(2, (self, prefix) => {
  switch (self._tag) {
    case OP_AND:
      {
        return And(prefixed(prefix)(self.left), prefixed(prefix)(self.right));
      }
    case OP_OR:
      {
        return Or(prefixed(prefix)(self.left), prefixed(prefix)(self.right));
      }
    case OP_INVALID_DATA:
      {
        return InvalidData([...prefix, ...self.path], self.message);
      }
    case OP_MISSING_DATA:
      {
        return MissingData([...prefix, ...self.path], self.message);
      }
    case OP_SOURCE_UNAVAILABLE:
      {
        return SourceUnavailable([...prefix, ...self.path], self.message, self.cause);
      }
    case OP_UNSUPPORTED:
      {
        return Unsupported([...prefix, ...self.path], self.message);
      }
  }
});

/** @internal */
const IsMissingDataOnlyReducer = {
  andCase: (_, left, right) => left && right,
  orCase: (_, left, right) => left && right,
  invalidDataCase: constFalse,
  missingDataCase: constTrue,
  sourceUnavailableCase: constFalse,
  unsupportedCase: constFalse
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const reduceWithContext = /*#__PURE__*/dual(3, (self, context, reducer) => {
  const input = [self];
  const output = [];
  while (input.length > 0) {
    const error = input.pop();
    switch (error._tag) {
      case OP_AND:
        {
          input.push(error.right);
          input.push(error.left);
          output.push(left({
            _tag: "AndCase"
          }));
          break;
        }
      case OP_OR:
        {
          input.push(error.right);
          input.push(error.left);
          output.push(left({
            _tag: "OrCase"
          }));
          break;
        }
      case OP_INVALID_DATA:
        {
          output.push(right(reducer.invalidDataCase(context, error.path, error.message)));
          break;
        }
      case OP_MISSING_DATA:
        {
          output.push(right(reducer.missingDataCase(context, error.path, error.message)));
          break;
        }
      case OP_SOURCE_UNAVAILABLE:
        {
          output.push(right(reducer.sourceUnavailableCase(context, error.path, error.message, error.cause)));
          break;
        }
      case OP_UNSUPPORTED:
        {
          output.push(right(reducer.unsupportedCase(context, error.path, error.message)));
          break;
        }
    }
  }
  const accumulator = [];
  while (output.length > 0) {
    const either = output.pop();
    switch (either._tag) {
      case "Left":
        {
          switch (either.left._tag) {
            case "AndCase":
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.andCase(context, left, right);
                accumulator.push(value);
                break;
              }
            case "OrCase":
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.orCase(context, left, right);
                accumulator.push(value);
                break;
              }
          }
          break;
        }
      case "Right":
        {
          accumulator.push(either.right);
          break;
        }
    }
  }
  if (accumulator.length === 0) {
    throw new Error("BUG: ConfigError.reduceWithContext - please report an issue at https://github.com/Effect-TS/io/issues");
  }
  return accumulator.pop();
});

/** @internal */
const isMissingDataOnly$1 = self => reduceWithContext(self, void 0, IsMissingDataOnlyReducer);

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
ConfigErrorTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * The possible ways that loading configuration data may fail.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
And;

/**
 * @since 2.0.0
 * @category constructors
 */
Or;

/**
 * @since 2.0.0
 * @category constructors
 */
MissingData;

/**
 * @since 2.0.0
 * @category constructors
 */
InvalidData;

/**
 * @since 2.0.0
 * @category constructors
 */
SourceUnavailable;

/**
 * @since 2.0.0
 * @category constructors
 */
Unsupported;

/**
 * Returns `true` if the specified value is a `ConfigError`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isConfigError;

/**
 * Returns `true` if the specified `ConfigError` is an `And`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isAnd;

/**
 * Returns `true` if the specified `ConfigError` is an `Or`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isOr;

/**
 * Returns `true` if the specified `ConfigError` is an `InvalidData`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isInvalidData;

/**
 * Returns `true` if the specified `ConfigError` is an `MissingData`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isMissingData;

/**
 * Returns `true` if the specified `ConfigError` contains only `MissingData` errors, `false` otherwise.
 *
 * @since 2.0.0
 * @categer getters
 */
const isMissingDataOnly = isMissingDataOnly$1;

/**
 * Returns `true` if the specified `ConfigError` is a `SourceUnavailable`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isSourceUnavailable;

/**
 * Returns `true` if the specified `ConfigError` is an `Unsupported`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isUnsupported;

/**
 * @since 2.0.0
 * @category utils
 */
prefixed;

/**
 * @since 2.0.0
 * @category folding
 */
reduceWithContext;

/** @internal */
const ConfigSecretSymbolKey = "effect/ConfigSecret";

/** @internal */
const ConfigSecretTypeId = /*#__PURE__*/Symbol.for(ConfigSecretSymbolKey);

/** @internal */
const proto$a = {
  [ConfigSecretTypeId]: ConfigSecretTypeId,
  [symbol$1]() {
    return pipe(hash$1(ConfigSecretSymbolKey), combine$a(array$1(this.raw)));
  },
  [symbol](that) {
    return isConfigSecret(that) && this.raw.length === that.raw.length && this.raw.every((v, i) => equals$1(v, that.raw[i]));
  }
};

/** @internal */
const isConfigSecret = u => {
  return typeof u === "object" && u != null && ConfigSecretTypeId in u;
};

/** @internal */
const make$N = bytes => {
  const secret = Object.create(proto$a);
  Object.defineProperty(secret, "toString", {
    enumerable: false,
    value() {
      return "ConfigSecret(<redacted>)";
    }
  });
  Object.defineProperty(secret, "raw", {
    enumerable: false,
    value: bytes
  });
  return secret;
};

/** @internal */
const fromChunk$2 = chunk => {
  return make$N(toReadonlyArray$4(chunk).map(char => char.charCodeAt(0)));
};

/** @internal */
const fromString = text => {
  return make$N(text.split("").map(char => char.charCodeAt(0)));
};

/** @internal */
const value$2 = self => {
  return self.raw.map(byte => String.fromCharCode(byte)).join("");
};

/** @internal */
const unsafeWipe = self => {
  for (let i = 0; i < self.raw.length; i++) {
    self.raw[i] = 0;
  }
};

/** @internal */

/** @internal */
const OP_CONSTANT = "Constant";

/** @internal */

/** @internal */
const OP_FAIL$3 = "Fail";

/** @internal */

/** @internal */
const OP_FALLBACK = "Fallback";

/** @internal */

/** @internal */
const OP_DESCRIBED = "Described";

/** @internal */

/** @internal */
const OP_LAZY = "Lazy";

/** @internal */

/** @internal */
const OP_MAP_OR_FAIL = "MapOrFail";

/** @internal */

/** @internal */
const OP_NESTED = "Nested";

/** @internal */

/** @internal */
const OP_PRIMITIVE = "Primitive";

/** @internal */

/** @internal */
const OP_SEQUENCE = "Sequence";

/** @internal */

/** @internal */
const OP_HASHMAP = "HashMap";

/** @internal */

/** @internal */
const OP_ZIP_WITH$1 = "ZipWith";

/** @internal */
const ConfigSymbolKey = "effect/Config";

/** @internal */
const ConfigTypeId = /*#__PURE__*/Symbol.for(ConfigSymbolKey);

/** @internal */

/** @internal */
const configVariance = {
  _A: _ => _
};

/** @internal */
const proto$9 = {
  [ConfigTypeId]: configVariance,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const boolean = name => {
  const config = primitive("a boolean property", text => {
    switch (text) {
      case "true":
      case "yes":
      case "on":
      case "1":
        {
          return right(true);
        }
      case "false":
      case "no":
      case "off":
      case "0":
        {
          return right(false);
        }
      default:
        {
          const error = InvalidData([], `Expected a boolean value, but received ${text}`);
          return left(error);
        }
    }
  });
  return name === undefined ? config : nested$2(name)(config);
};

/** @internal */
const array = (config, name) => {
  return pipe(chunk$1(config, name), map$d(toReadonlyArray$4));
};

/** @internal */
const chunk$1 = (config, name) => {
  return map$d(name === undefined ? repeat$2(config) : nested$2(name)(repeat$2(config)), unsafeFromArray);
};

/** @internal */
const date = name => {
  const config = primitive("a date property", text => {
    const result = Date.parse(text);
    if (Number.isNaN(result)) {
      return left(InvalidData([], `Expected a date value but received ${text}`));
    }
    return right(new Date(result));
  });
  return name === undefined ? config : nested$2(name)(config);
};

/** @internal */
const fail$c = message => {
  const fail = Object.create(proto$9);
  fail._tag = OP_FAIL$3;
  fail.message = message;
  fail.parse = () => left(Unsupported([], message));
  return fail;
};

/** @internal */
const number = name => {
  const config = primitive("a number property", text => {
    const result = Number.parseFloat(text);
    if (Number.isNaN(result)) {
      return left(InvalidData([], `Expected an number value but received ${text}`));
    }
    return right(result);
  });
  return name === undefined ? config : nested$2(name)(config);
};

/** @internal */
const integer = name => {
  const config = primitive("an integer property", text => {
    const result = Number.parseInt(text, 10);
    if (Number.isNaN(result)) {
      return left(InvalidData([], `Expected an integer value but received ${text}`));
    }
    return right(result);
  });
  return name === undefined ? config : nested$2(name)(config);
};

/** @internal */
const logLevel = name => {
  const config = mapOrFail(string(), value => {
    const label = value.toUpperCase();
    const level = allLogLevels.find(level => level.label === label);
    return level === undefined ? left(InvalidData([], `Expected a log level, but found: ${value}`)) : right(level);
  });
  return name === undefined ? config : nested$2(config, name);
};

/** @internal */
const map$d = /*#__PURE__*/dual(2, (self, f) => mapOrFail(self, a => right(f(a))));

/** @internal */
const mapAttempt$1 = /*#__PURE__*/dual(2, (self, f) => mapOrFail(self, a => {
  try {
    return right(f(a));
  } catch (error) {
    return left(InvalidData([], error instanceof Error ? error.message : `${error}`));
  }
}));

/** @internal */
const mapOrFail = /*#__PURE__*/dual(2, (self, f) => {
  const mapOrFail = Object.create(proto$9);
  mapOrFail._tag = OP_MAP_OR_FAIL;
  mapOrFail.original = self;
  mapOrFail.mapOrFail = f;
  return mapOrFail;
});

/** @internal */
const missingError = name => {
  return self => {
    return MissingData([], `Expected ${self.description} with name ${name}`);
  };
};

/** @internal */
const nested$2 = /*#__PURE__*/dual(2, (self, name) => {
  const nested = Object.create(proto$9);
  nested._tag = OP_NESTED;
  nested.name = name;
  nested.config = self;
  return nested;
});

/** @internal */
const orElse$9 = /*#__PURE__*/dual(2, (self, that) => {
  const fallback = Object.create(proto$9);
  fallback._tag = OP_FALLBACK;
  fallback.first = self;
  fallback.second = suspend$7(that);
  fallback.condition = constTrue;
  return fallback;
});

/** @internal */
const orElseIf = /*#__PURE__*/dual(2, (self, options) => {
  const fallback = Object.create(proto$9);
  fallback._tag = OP_FALLBACK;
  fallback.first = self;
  fallback.second = suspend$7(options.orElse);
  fallback.condition = options.if;
  return fallback;
});

/** @internal */
const option$4 = self => {
  return pipe(self, map$d(some$6), orElseIf({
    orElse: () => succeed$e(none$8()),
    if: isMissingDataOnly
  }));
};

/** @internal */
const primitive = (description, parse) => {
  const primitive = Object.create(proto$9);
  primitive._tag = OP_PRIMITIVE;
  primitive.description = description;
  primitive.parse = parse;
  return primitive;
};

/** @internal */
const repeat$2 = self => {
  const repeat = Object.create(proto$9);
  repeat._tag = OP_SEQUENCE;
  repeat.config = self;
  return repeat;
};

/** @internal */
const secret = name => {
  const config = primitive("a secret property", text => right(fromString(text)));
  return name === undefined ? config : nested$2(name)(config);
};

/** @internal */
const hashSet = (config, name) => {
  const newConfig = map$d(chunk$1(config), fromIterable$7);
  return name === undefined ? newConfig : nested$2(name)(newConfig);
};

/** @internal */
const string = name => {
  const config = primitive("a text property", right);
  return name === undefined ? config : nested$2(name)(config);
};
const all$3 = arg => {
  if (Array.isArray(arg)) {
    return tuple(arg);
  } else if (Symbol.iterator in arg) {
    return tuple([...arg]);
  }
  return struct$1(arg);
};
const struct$1 = r => {
  const entries = Object.entries(r);
  let result = pipe(entries[0][1], map$d(value => ({
    [entries[0][0]]: value
  })));
  if (entries.length === 1) {
    return result;
  }
  const rest = entries.slice(1);
  for (const [key, config] of rest) {
    result = pipe(result, zipWith$5(config, (record, value) => ({
      ...record,
      [key]: value
    })));
  }
  return result;
};

/** @internal */
const succeed$e = value => {
  const constant = Object.create(proto$9);
  constant._tag = OP_CONSTANT;
  constant.value = value;
  constant.parse = () => right(value);
  return constant;
};

/** @internal */
const suspend$7 = config => {
  const lazy = Object.create(proto$9);
  lazy._tag = OP_LAZY;
  lazy.config = config;
  return lazy;
};

/** @internal */
const sync$9 = value => {
  return suspend$7(() => succeed$e(value()));
};

/** @internal */
const hashMap = (config, name) => {
  const table = Object.create(proto$9);
  table._tag = OP_HASHMAP;
  table.valueConfig = config;
  return name === undefined ? table : nested$2(name)(table);
};

/** @internal */
const isConfig = u => typeof u === "object" && u != null && ConfigTypeId in u;

/** @internal */
const tuple = tuple => {
  if (tuple.length === 0) {
    return succeed$e([]);
  }
  if (tuple.length === 1) {
    return map$d(tuple[0], x => [x]);
  }
  let result = map$d(tuple[0], x => [x]);
  for (let i = 1; i < tuple.length; i++) {
    const config = tuple[i];
    result = pipe(result, zipWith$5(config, (tuple, value) => [...tuple, value]));
  }
  return result;
};

/**
 * @internal
 */
const unwrap$3 = wrapped => {
  if (isConfig(wrapped)) {
    return wrapped;
  }
  return struct$1(Object.fromEntries(Object.entries(wrapped).map(([k, a]) => [k, unwrap$3(a)])));
};

/** @internal */
const validate$2 = /*#__PURE__*/dual(2, (self, {
  message,
  validation
}) => mapOrFail(self, a => {
  if (validation(a)) {
    return right(a);
  }
  return left(InvalidData([], message));
}));

/** @internal */
const withDefault = /*#__PURE__*/dual(2, (self, def) => orElseIf(self, {
  orElse: () => succeed$e(def),
  if: isMissingDataOnly
}));

/** @internal */
const withDescription = /*#__PURE__*/dual(2, (self, description) => {
  const described = Object.create(proto$9);
  described._tag = OP_DESCRIBED;
  described.config = self;
  described.description = description;
  return described;
});

/** @internal */
const zip$8 = /*#__PURE__*/dual(2, (self, that) => zipWith$5(self, that, (a, b) => [a, b]));

/** @internal */
const zipWith$5 = /*#__PURE__*/dual(3, (self, that, f) => {
  const zipWith = Object.create(proto$9);
  zipWith._tag = OP_ZIP_WITH$1;
  zipWith.left = self;
  zipWith.right = that;
  zipWith.zip = f;
  return zipWith;
});

/** @internal */
const empty$i = {
  _tag: "Empty"
};

/** @internal */
const andThen$1 = /*#__PURE__*/dual(2, (self, that) => ({
  _tag: "AndThen",
  first: self,
  second: that
}));

/** @internal */
const mapName = /*#__PURE__*/dual(2, (self, f) => andThen$1(self, {
  _tag: "MapName",
  f
}));

/** @internal */
const nested$1 = /*#__PURE__*/dual(2, (self, name) => andThen$1(self, {
  _tag: "Nested",
  name
}));

/** @internal */
const unnested$1 = /*#__PURE__*/dual(2, (self, name) => andThen$1(self, {
  _tag: "Unnested",
  name
}));

/** @internal */
const patch$3 = /*#__PURE__*/dual(2, (path, patch) => {
  let input = of$2(patch);
  let output = path;
  while (isCons(input)) {
    const patch = input.head;
    switch (patch._tag) {
      case "Empty":
        {
          input = input.tail;
          break;
        }
      case "AndThen":
        {
          input = cons(patch.first, cons(patch.second, input.tail));
          break;
        }
      case "MapName":
        {
          output = map$m(output, patch.f);
          input = input.tail;
          break;
        }
      case "Nested":
        {
          output = prepend$3(output, patch.name);
          input = input.tail;
          break;
        }
      case "Unnested":
        {
          const containsName = pipe(head$5(output), contains$2(patch.name));
          if (containsName) {
            output = tailNonEmpty$1(output);
            input = input.tail;
          } else {
            return left(MissingData(output, `Expected ${patch.name} to be in path in ConfigProvider#unnested`));
          }
          break;
        }
    }
  }
  return right(output);
});

/**
 * Adapted from the `change-case` library.
 *
 * Copyright (c) 2014 Blake Embrey (hello@blakeembrey.com)
 */

/** @internal */
const lowerCase$1 = str => str.toLowerCase();

/** @internal */
const upperCase$1 = str => str.toUpperCase();
/**
 * Replace `re` in the input string with the replacement value.
 */
const replace$1 = (input, re, value) => re instanceof RegExp ? input.replace(re, value) : re.reduce((input, re) => input.replace(re, value), input);

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
const DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];

// Remove all non-word characters.
const DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;

/**
 * Normalize the string into something other libraries can manipulate easier.
 */
const noCase = (input, options = {}) => {
  const {
    delimiter = " ",
    splitRegexp = DEFAULT_SPLIT_REGEXP,
    stripRegexp = DEFAULT_STRIP_REGEXP,
    transform = lowerCase$1
  } = options;
  const result = replace$1(replace$1(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  let start = 0;
  let end = result.length;
  // Trim the delimiter from around the output string.
  while (result.charAt(start) === "\0") {
    start++;
  }
  while (result.charAt(end - 1) === "\0") {
    end--;
  }
  // Transform each token independently.
  return result.slice(start, end).split("\0").map(transform).join(delimiter);
};

/** @internal */
const constantCase$1 = (input, options = {}) => noCase(input, {
  delimiter: "_",
  transform: upperCase$1,
  ...options
});

/** @internal */
const kebabCase$1 = (input, options = {}) => noCase(input, {
  delimiter: "-",
  ...options
});

/** @internal */
const snakeCase$1 = (input, options = {}) => noCase(input, {
  delimiter: "_",
  ...options
});

/**
 * @category instances
 * @since 2.0.0
 */
const Order$2 = number$1;

const concat$1 = (l, r) => [...l, ...r];

/** @internal */
const ConfigProviderSymbolKey = "effect/ConfigProvider";

/** @internal */
const ConfigProviderTypeId = /*#__PURE__*/Symbol.for(ConfigProviderSymbolKey);

/** @internal */
const configProviderTag = /*#__PURE__*/Tag$1(ConfigProviderTypeId);

/** @internal */
const FlatConfigProviderSymbolKey = "effect/ConfigProviderFlat";

/** @internal */
const FlatConfigProviderTypeId = /*#__PURE__*/Symbol.for(FlatConfigProviderSymbolKey);

/** @internal */
const make$M = options => ({
  [ConfigProviderTypeId]: ConfigProviderTypeId,
  pipe() {
    return pipeArguments(this, arguments);
  },
  ...options
});

/** @internal */
const makeFlat = options => ({
  [FlatConfigProviderTypeId]: FlatConfigProviderTypeId,
  patch: options.patch,
  load: (path, config, split = true) => options.load(path, config, split),
  enumerateChildren: options.enumerateChildren
});

/** @internal */
const fromFlat = flat => make$M({
  load: config => flatMap$6(fromFlatLoop(flat, empty$C(), config, false), chunk => match$j(head$5(chunk), {
    onNone: () => fail$f(MissingData(empty$C(), `Expected a single value having structure: ${config}`)),
    onSome: succeed$h
  })),
  flattened: flat
});

/** @internal */
const fromEnv = (config = {}) => {
  const {
    pathDelim,
    seqDelim
  } = Object.assign({}, {
    pathDelim: "_",
    seqDelim: ","
  }, config);
  const makePathString = path => pipe(path, join$2(pathDelim));
  const unmakePathString = pathString => pathString.split(pathDelim);
  const getEnv = () => typeof process !== "undefined" && "env" in process && typeof process.env === "object" ? process.env : {};
  const load = (path, primitive, split = true) => {
    const pathString = makePathString(path);
    const current = getEnv();
    const valueOpt = pathString in current ? some$6(current[pathString]) : none$8();
    return pipe(valueOpt, mapError$6(() => MissingData(path, `Expected ${pathString} to exist in the process context`)), flatMap$6(value => parsePrimitive(value, path, primitive, seqDelim, split)));
  };
  const enumerateChildren = path => sync$a(() => {
    const current = getEnv();
    const keys = Object.keys(current);
    const keyPaths = Array.from(keys).map(value => unmakePathString(value.toUpperCase()));
    const filteredKeyPaths = keyPaths.filter(keyPath => {
      for (let i = 0; i < path.length; i++) {
        const pathComponent = pipe(path, unsafeGet$8(i));
        const currentElement = keyPath[i];
        if (currentElement === undefined || pathComponent !== currentElement) {
          return false;
        }
      }
      return true;
    }).flatMap(keyPath => keyPath.slice(path.length, path.length + 1));
    return fromIterable$7(filteredKeyPaths);
  });
  return fromFlat(makeFlat({
    load,
    enumerateChildren,
    patch: empty$i
  }));
};

/** @internal */
const fromMap = (map, config = {}) => {
  const {
    pathDelim,
    seqDelim
  } = Object.assign({
    seqDelim: ",",
    pathDelim: "."
  }, config);
  const makePathString = path => pipe(path, join$2(pathDelim));
  const unmakePathString = pathString => pathString.split(pathDelim);
  const mapWithIndexSplit = splitIndexInKeys(map, str => Array.from(unmakePathString(str)), makePathString);
  const load = (path, primitive, split = true) => {
    const pathString = makePathString(path);
    const valueOpt = mapWithIndexSplit.has(pathString) ? some$6(mapWithIndexSplit.get(pathString)) : none$8();
    return pipe(valueOpt, mapError$6(() => MissingData(path, `Expected ${pathString} to exist in the provided map`)), flatMap$6(value => parsePrimitive(value, path, primitive, seqDelim, split)));
  };
  const enumerateChildren = path => sync$a(() => {
    const keyPaths = Array.from(mapWithIndexSplit.keys()).map(unmakePathString);
    const filteredKeyPaths = keyPaths.filter(keyPath => {
      for (let i = 0; i < path.length; i++) {
        const pathComponent = pipe(path, unsafeGet$8(i));
        const currentElement = keyPath[i];
        if (currentElement === undefined || pathComponent !== currentElement) {
          return false;
        }
      }
      return true;
    }).flatMap(keyPath => keyPath.slice(path.length, path.length + 1));
    return fromIterable$7(filteredKeyPaths);
  });
  return fromFlat(makeFlat({
    load,
    enumerateChildren,
    patch: empty$i
  }));
};
const extend$1 = (leftDef, rightDef, left, right) => {
  const leftPad = unfold$2(left.length, index => index >= right.length ? none$8() : some$6([leftDef(index), index + 1]));
  const rightPad = unfold$2(right.length, index => index >= left.length ? none$8() : some$6([rightDef(index), index + 1]));
  const leftExtension = concat$1(left, leftPad);
  const rightExtension = concat$1(right, rightPad);
  return [leftExtension, rightExtension];
};
const fromFlatLoop = (flat, prefix, config, split) => {
  const op = config;
  switch (op._tag) {
    case OP_CONSTANT:
      {
        return succeed$h(of$4(op.value));
      }
    case OP_DESCRIBED:
      {
        return suspend$8(() => fromFlatLoop(flat, prefix, op.config, split));
      }
    case OP_FAIL$3:
      {
        return fail$f(MissingData(prefix, op.message));
      }
    case OP_FALLBACK:
      {
        return pipe(suspend$8(() => fromFlatLoop(flat, prefix, op.first, split)), catchAll$5(error1 => {
          if (op.condition(error1)) {
            return pipe(fromFlatLoop(flat, prefix, op.second, split), catchAll$5(error2 => fail$f(Or(error1, error2))));
          }
          return fail$f(error1);
        }));
      }
    case OP_LAZY:
      {
        return suspend$8(() => fromFlatLoop(flat, prefix, op.config(), split));
      }
    case OP_MAP_OR_FAIL:
      {
        return suspend$8(() => pipe(fromFlatLoop(flat, prefix, op.original, split), flatMap$6(forEachSequential(a => pipe(op.mapOrFail(a), mapError$6(prefixed(prefix)))))));
      }
    case OP_NESTED:
      {
        return suspend$8(() => fromFlatLoop(flat, concat$1(prefix, of$4(op.name)), op.config, split));
      }
    case OP_PRIMITIVE:
      {
        return pipe(patch$3(prefix, flat.patch), flatMap$6(prefix => pipe(flat.load(prefix, op, split), flatMap$6(values => {
          if (values.length === 0) {
            const name = pipe(last$3(prefix), getOrElse$3(() => "<n/a>"));
            return fail$f(missingError(name));
          }
          return succeed$h(values);
        }))));
      }
    case OP_SEQUENCE:
      {
        return pipe(patch$3(prefix, flat.patch), flatMap$6(patchedPrefix => pipe(flat.enumerateChildren(patchedPrefix), flatMap$6(indicesFrom), flatMap$6(indices => {
          if (indices.length === 0) {
            return suspend$8(() => map$f(fromFlatLoop(flat, patchedPrefix, op.config, true), of$4));
          }
          return pipe(forEachSequential(indices, index => fromFlatLoop(flat, append$2(prefix, `[${index}]`), op.config, true)), map$f(chunkChunk => {
            const flattened = flatten$a(chunkChunk);
            if (flattened.length === 0) {
              return of$4(empty$C());
            }
            return of$4(flattened);
          }));
        }))));
      }
    case OP_HASHMAP:
      {
        return suspend$8(() => pipe(patch$3(prefix, flat.patch), flatMap$6(prefix => pipe(flat.enumerateChildren(prefix), flatMap$6(keys => {
          return pipe(keys, forEachSequential(key => fromFlatLoop(flat, concat$1(prefix, of$4(key)), op.valueConfig, split)), map$f(values => {
            if (values.length === 0) {
              return of$4(empty$u());
            }
            const matrix = values.map(x => Array.from(x));
            return pipe(transpose(matrix), map$m(values => fromIterable$8(zip$c(fromIterable$c(keys), values))));
          }));
        })))));
      }
    case OP_ZIP_WITH$1:
      {
        return suspend$8(() => pipe(fromFlatLoop(flat, prefix, op.left, split), either$5, flatMap$6(left => pipe(fromFlatLoop(flat, prefix, op.right, split), either$5, flatMap$6(right$1 => {
          if (isLeft$1(left) && isLeft$1(right$1)) {
            return fail$f(And(left.left, right$1.left));
          }
          if (isLeft$1(left) && isRight$1(right$1)) {
            return fail$f(left.left);
          }
          if (isRight$1(left) && isLeft$1(right$1)) {
            return fail$f(right$1.left);
          }
          if (isRight$1(left) && isRight$1(right$1)) {
            const path = pipe(prefix, join$2("."));
            const fail = fromFlatLoopFail(prefix, path);
            const [lefts, rights] = extend$1(fail, fail, pipe(left.right, map$m(right)), pipe(right$1.right, map$m(right)));
            return pipe(lefts, zip$c(rights), forEachSequential(([left, right]) => pipe(zip$a(left, right), map$f(([left, right]) => op.zip(left, right)))));
          }
          throw new Error("BUG: ConfigProvider.fromFlatLoop - please report an issue at https://github.com/Effect-TS/io/issues");
        })))));
      }
  }
};
const fromFlatLoopFail = (prefix, path) => index => left(MissingData(prefix, `The element at index ${index} in a sequence at path "${path}" was missing`));

/** @internal */
const mapInputPath = /*#__PURE__*/dual(2, (self, f) => fromFlat(mapInputPathFlat(self.flattened, f)));
const mapInputPathFlat = (self, f) => makeFlat({
  load: (path, config, split = true) => self.load(path, config, split),
  enumerateChildren: path => self.enumerateChildren(path),
  patch: mapName(self.patch, f)
});

/** @internal */
const nested = /*#__PURE__*/dual(2, (self, name) => fromFlat(makeFlat({
  load: (path, config) => self.flattened.load(path, config, true),
  enumerateChildren: path => self.flattened.enumerateChildren(path),
  patch: nested$1(self.flattened.patch, name)
})));

/** @internal */
const unnested = /*#__PURE__*/dual(2, (self, name) => fromFlat(makeFlat({
  load: (path, config) => self.flattened.load(path, config, true),
  enumerateChildren: path => self.flattened.enumerateChildren(path),
  patch: unnested$1(self.flattened.patch, name)
})));

/** @internal */
const orElse$8 = /*#__PURE__*/dual(2, (self, that) => fromFlat(orElseFlat(self.flattened, () => that().flattened)));
const orElseFlat = (self, that) => makeFlat({
  load: (path, config, split) => pipe(patch$3(path, self.patch), flatMap$6(patch => self.load(patch, config, split)), catchAll$5(error1 => pipe(sync$a(that), flatMap$6(that => pipe(patch$3(path, that.patch), flatMap$6(patch => that.load(patch, config, split)), catchAll$5(error2 => fail$f(Or(error1, error2)))))))),
  enumerateChildren: path => pipe(patch$3(path, self.patch), flatMap$6(patch => self.enumerateChildren(patch)), either$5, flatMap$6(left => pipe(sync$a(that), flatMap$6(that => pipe(patch$3(path, that.patch), flatMap$6(patch => that.enumerateChildren(patch)), either$5, flatMap$6(right => {
    if (isLeft$1(left) && isLeft$1(right)) {
      return fail$f(And(left.left, right.left));
    }
    if (isLeft$1(left) && isRight$1(right)) {
      return succeed$h(right.right);
    }
    if (isRight$1(left) && isLeft$1(right)) {
      return succeed$h(left.right);
    }
    if (isRight$1(left) && isRight$1(right)) {
      return succeed$h(pipe(left.right, union$6(right.right)));
    }
    throw new Error("BUG: ConfigProvider.orElseFlat - please report an issue at https://github.com/Effect-TS/io/issues");
  })))))),
  patch: empty$i
});

/** @internal */
const constantCase = self => mapInputPath(self, constantCase$1);

/** @internal */
const kebabCase = self => mapInputPath(self, kebabCase$1);

/** @internal */
const lowerCase = self => mapInputPath(self, lowerCase$1);

/** @internal */
const snakeCase = self => mapInputPath(self, snakeCase$1);

/** @internal */
const upperCase = self => mapInputPath(self, upperCase$1);

/** @internal */
const within = /*#__PURE__*/dual(3, (self, path, f) => {
  const unnest = reduce$i(path, self, (provider, name) => unnested(provider, name));
  const nest = reduceRight$4(path, f(unnest), (provider, name) => nested(provider, name));
  return orElse$8(nest, () => self);
});
const splitPathString = (text, delim) => {
  const split = text.split(new RegExp(`\\s*${escapeRegex(delim)}\\s*`));
  return split;
};
const parsePrimitive = (text, path, primitive, delimiter, split) => {
  if (!split) {
    return pipe(primitive.parse(text), map$f(of$4), mapError$6(prefixed(path)));
  }
  return pipe(splitPathString(text, delimiter), forEachSequential(char => primitive.parse(char.trim())), mapError$6(prefixed(path)));
};
const transpose = array => {
  return Object.keys(array[0]).map(column => array.map(row => row[column]));
};
const escapeRegex = string => {
  return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
};
const indicesFrom = quotedIndices => pipe(forEachSequential(quotedIndices, parseQuotedIndex), mapBoth$5({
  onFailure: () => empty$C(),
  onSuccess: sort$1(Order$2)
}), either$5, map$f(merge$a));
const STR_INDEX_REGEX = /(^.+)(\[(\d+)\])$/;
const QUOTED_INDEX_REGEX = /^(\[(\d+)\])$/;
const parseQuotedIndex = str => {
  const match = str.match(QUOTED_INDEX_REGEX);
  if (match !== null) {
    const matchedIndex = match[2];
    return pipe(matchedIndex !== undefined && matchedIndex.length > 0 ? some$6(matchedIndex) : none$8(), flatMap$d(parseInteger));
  }
  return none$8();
};
const splitIndexInKeys = (map, unmakePathString, makePathString) => {
  const newMap = new Map();
  for (const [pathString, value] of map) {
    const keyWithIndex = pipe(unmakePathString(pathString), flatMap$c(key => match$j(splitIndexFrom(key), {
      onNone: () => of$4(key),
      onSome: ([key, index]) => make$14(key, `[${index}]`)
    })));
    newMap.set(makePathString(keyWithIndex), value);
  }
  return newMap;
};
const splitIndexFrom = key => {
  const match = key.match(STR_INDEX_REGEX);
  if (match !== null) {
    const matchedString = match[1];
    const matchedIndex = match[3];
    const optionalString = matchedString !== undefined && matchedString.length > 0 ? some$6(matchedString) : none$8();
    const optionalIndex = pipe(matchedIndex !== undefined && matchedIndex.length > 0 ? some$6(matchedIndex) : none$8(), flatMap$d(parseInteger));
    return all$5([optionalString, optionalIndex]);
  }
  return none$8();
};
const parseInteger = str => {
  const parsedIndex = Number.parseInt(str);
  return Number.isNaN(parsedIndex) ? none$8() : some$6(parsedIndex);
};

/** @internal */
const TypeId$3 = /*#__PURE__*/Symbol.for("effect/Console");

/** @internal */
const consoleTag = /*#__PURE__*/Tag$1(TypeId$3);

/** @internal */
const defaultConsole = {
  [TypeId$3]: TypeId$3,
  assert(condition, ...args) {
    return sync$a(() => {
      console.assert(condition, ...args);
    });
  },
  clear: /*#__PURE__*/sync$a(() => {
    console.clear();
  }),
  count(label) {
    return sync$a(() => {
      console.count(label);
    });
  },
  countReset(label) {
    return sync$a(() => {
      console.countReset(label);
    });
  },
  debug(...args) {
    return sync$a(() => {
      console.debug(...args);
    });
  },
  dir(item, options) {
    return sync$a(() => {
      console.dir(item, options);
    });
  },
  dirxml(...args) {
    return sync$a(() => {
      console.dirxml(...args);
    });
  },
  error(...args) {
    return sync$a(() => {
      console.error(...args);
    });
  },
  group(options) {
    return options?.collapsed ? sync$a(() => console.groupCollapsed(options?.label)) : sync$a(() => console.group(options?.label));
  },
  groupEnd: /*#__PURE__*/sync$a(() => {
    console.groupEnd();
  }),
  info(...args) {
    return sync$a(() => {
      console.info(...args);
    });
  },
  log(...args) {
    return sync$a(() => {
      console.log(...args);
    });
  },
  table(tabularData, properties) {
    return sync$a(() => {
      console.table(tabularData, properties);
    });
  },
  time(label) {
    return sync$a(() => console.time(label));
  },
  timeEnd(label) {
    return sync$a(() => console.timeEnd(label));
  },
  timeLog(label, ...args) {
    return sync$a(() => {
      console.timeLog(label, ...args);
    });
  },
  trace(...args) {
    return sync$a(() => {
      console.trace(...args);
    });
  },
  warn(...args) {
    return sync$a(() => {
      console.warn(...args);
    });
  },
  unsafe: console
};

/** @internal */
const RandomSymbolKey = "effect/Random";

/** @internal */
const RandomTypeId = /*#__PURE__*/Symbol.for(RandomSymbolKey);

/** @internal */
const randomTag = /*#__PURE__*/Tag$1(RandomTypeId);
/** @internal */
class RandomImpl {
  [RandomTypeId] = RandomTypeId;
  constructor(seed) {
    this.seed = seed;
    this.PRNG = new PCGRandom(seed);
  }
  next() {
    return sync$a(() => this.PRNG.number());
  }
  nextBoolean() {
    return map$f(this.next(), n => n > 0.5);
  }
  nextInt() {
    return sync$a(() => this.PRNG.integer(Number.MAX_SAFE_INTEGER));
  }
  nextRange(min, max) {
    return map$f(this.next(), n => (max - min) * n + min);
  }
  nextIntBetween(min, max) {
    return sync$a(() => this.PRNG.integer(max - min) + min);
  }
  shuffle(elements) {
    return shuffleWith$1(elements, n => this.nextIntBetween(0, n + 1));
  }
}
const shuffleWith$1 = (elements, nextIntBounded) => {
  return suspend$8(() => pipe(sync$a(() => Array.from(elements)), flatMap$6(buffer => {
    const numbers = [];
    for (let i = buffer.length; i >= 2; i = i - 1) {
      numbers.push(i);
    }
    return pipe(numbers, forEachSequentialDiscard(n => pipe(nextIntBounded(n), map$f(k => swap$1(buffer, n - 1, k)))), as$6(fromIterable$b(buffer)));
  })));
};
const swap$1 = (buffer, index1, index2) => {
  const tmp = buffer[index1];
  buffer[index1] = buffer[index2];
  buffer[index2] = tmp;
  return buffer;
};
const make$L = seed => new RandomImpl(seed);

/** @internal */
const liveServices$1 = /*#__PURE__*/pipe( /*#__PURE__*/empty$A(), /*#__PURE__*/add$4(clockTag, /*#__PURE__*/make$O()), /*#__PURE__*/add$4(consoleTag, defaultConsole), /*#__PURE__*/add$4(randomTag, /*#__PURE__*/make$L( /*#__PURE__*/Math.random() * 4294967296 >>> 0)), /*#__PURE__*/add$4(configProviderTag, /*#__PURE__*/fromEnv()), /*#__PURE__*/add$4(tracerTag, nativeTracer));

/**
 * The `FiberRef` holding the default `Effect` services.
 *
 * @since 2.0.0
 * @category fiberRefs
 */
const currentServices$1 = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/DefaultServices/currentServices"), () => fiberRefUnsafeMakeContext(liveServices$1));

// circular with Clock

/** @internal */
const sleep$3 = duration => {
  const decodedDuration = decode(duration);
  return clockWith$3(clock => clock.sleep(decodedDuration));
};

/** @internal */
const clockWith$3 = f => fiberRefGetWith(currentServices$1, services => f(get$j(services, clockTag)));

/** @internal */
const currentTimeMillis$1 = /*#__PURE__*/clockWith$3(clock => clock.currentTimeMillis);

/** @internal */
const currentTimeNanos$1 = /*#__PURE__*/clockWith$3(clock => clock.currentTimeNanos);

/** @internal */
const withClock$1 = /*#__PURE__*/dual(2, (effect, value) => fiberRefLocallyWith$1(currentServices$1, add$4(clockTag, value))(effect));

// circular with ConfigProvider

/** @internal */
const withConfigProvider$1 = /*#__PURE__*/dual(2, (effect, value) => fiberRefLocallyWith$1(currentServices$1, add$4(configProviderTag, value))(effect));

/** @internal */
const configProviderWith$1 = f => fiberRefGetWith(currentServices$1, services => f(get$j(services, configProviderTag)));

/** @internal */
const config$1 = config => configProviderWith$1(_ => _.load(config));

// circular with Random

/** @internal */
const randomWith$1 = f => fiberRefGetWith(currentServices$1, services => f(get$j(services, randomTag)));

/** @internal */
const next$2 = /*#__PURE__*/randomWith$1(random => random.next());

/** @internal */
const nextInt$1 = /*#__PURE__*/randomWith$1(random => random.nextInt());

/** @internal */
const nextBoolean$1 = /*#__PURE__*/randomWith$1(random => random.nextBoolean());

/** @internal */
const nextRange$1 = (min, max) => randomWith$1(random => random.nextRange(min, max));

/** @internal */
const nextIntBetween$1 = (min, max) => randomWith$1(random => random.nextIntBetween(min, max));

/** @internal */
const shuffle$1 = elements => randomWith$1(random => random.shuffle(elements));

// circular with Tracer

/** @internal */
const tracerWith$3 = f => fiberRefGetWith(currentServices$1, services => f(get$j(services, tracerTag)));

/** @internal */
const withTracer$1 = /*#__PURE__*/dual(2, (effect, value) => fiberRefLocallyWith$1(currentServices$1, add$4(tracerTag, value))(effect));

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
ClockTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Represents a time-based clock which provides functionality related to time
 * and scheduling.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
make$O;

/**
 * @since 2.0.0
 * @category constructors
 */
const sleep$2 = sleep$3;

/**
 * @since 2.0.0
 * @category constructors
 */
const currentTimeMillis = currentTimeMillis$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const currentTimeNanos = currentTimeNanos$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const clockWith$2 = clockWith$3;

/**
 * @since 2.0.0
 * @category context
 */
clockTag;

/** @internal */
function unsafeMake$4(fiberRefLocals) {
  return new FiberRefsImpl(fiberRefLocals);
}

/** @internal */
function empty$h() {
  return unsafeMake$4(new Map());
}

/** @internal */
const FiberRefsSym = /*#__PURE__*/Symbol.for("effect/FiberRefs");

/** @internal */
class FiberRefsImpl {
  [FiberRefsSym] = FiberRefsSym;
  constructor(locals) {
    this.locals = locals;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const findAncestor = (_ref, _parentStack, _childStack, _childModified = false) => {
  const ref = _ref;
  let parentStack = _parentStack;
  let childStack = _childStack;
  let childModified = _childModified;
  let ret = undefined;
  while (ret === undefined) {
    if (isNonEmptyReadonlyArray(parentStack) && isNonEmptyReadonlyArray(childStack)) {
      const parentFiberId = headNonEmpty$1(parentStack)[0];
      const parentAncestors = tailNonEmpty$1(parentStack);
      const childFiberId = headNonEmpty$1(childStack)[0];
      const childRefValue = headNonEmpty$1(childStack)[1];
      const childAncestors = tailNonEmpty$1(childStack);
      if (parentFiberId.startTimeMillis < childFiberId.startTimeMillis) {
        childStack = childAncestors;
        childModified = true;
      } else if (parentFiberId.startTimeMillis > childFiberId.startTimeMillis) {
        parentStack = parentAncestors;
      } else {
        if (parentFiberId.id < childFiberId.id) {
          childStack = childAncestors;
          childModified = true;
        } else if (parentFiberId.id > childFiberId.id) {
          parentStack = parentAncestors;
        } else {
          ret = [childRefValue, childModified];
        }
      }
    } else {
      ret = [ref.initial, true];
    }
  }
  return ret;
};

/** @internal */
const joinAs$1 = /*#__PURE__*/dual(3, (self, fiberId, that) => {
  const parentFiberRefs = new Map(self.locals);
  for (const [fiberRef, childStack] of that.locals) {
    const childValue = headNonEmpty$1(childStack)[1];
    if (!equals$1(headNonEmpty$1(childStack)[0], fiberId)) {
      if (!parentFiberRefs.has(fiberRef)) {
        if (equals$1(childValue, fiberRef.initial)) {
          continue;
        }
        parentFiberRefs.set(fiberRef, [[fiberId, fiberRef.join(fiberRef.initial, childValue)]]);
        continue;
      }
      const parentStack = parentFiberRefs.get(fiberRef);
      const [ancestor, wasModified] = findAncestor(fiberRef, parentStack, childStack);
      if (wasModified) {
        const patch = fiberRef.diff(ancestor, childValue);
        const oldValue = headNonEmpty$1(parentStack)[1];
        const newValue = fiberRef.join(oldValue, fiberRef.patch(patch)(oldValue));
        if (!equals$1(oldValue, newValue)) {
          let newStack;
          const parentFiberId = headNonEmpty$1(parentStack)[0];
          if (equals$1(parentFiberId, fiberId)) {
            newStack = prepend$3([parentFiberId, newValue])(tailNonEmpty$1(parentStack));
          } else {
            newStack = prepend$3([fiberId, newValue])(parentStack);
          }
          parentFiberRefs.set(fiberRef, newStack);
        }
      }
    }
  }
  return new FiberRefsImpl(new Map(parentFiberRefs));
});

/** @internal */
const forkAs$1 = /*#__PURE__*/dual(2, (self, childId) => {
  const map = new Map();
  for (const [fiberRef, stack] of self.locals.entries()) {
    const oldValue = headNonEmpty$1(stack)[1];
    const newValue = fiberRef.patch(fiberRef.fork)(oldValue);
    if (equals$1(oldValue, newValue)) {
      map.set(fiberRef, stack);
    } else {
      map.set(fiberRef, prepend$3([childId, newValue])(stack));
    }
  }
  return new FiberRefsImpl(map);
});

/** @internal */
const fiberRefs$1 = self => fromIterable$7(self.locals.keys());

/** @internal */
const setAll$1 = self => forEachSequentialDiscard(fiberRefs$1(self), fiberRef => fiberRefSet(fiberRef, getOrDefault$1(self, fiberRef)));

/** @internal */
const delete_ = /*#__PURE__*/dual(2, (self, fiberRef) => {
  const locals = new Map(self.locals);
  locals.delete(fiberRef);
  return new FiberRefsImpl(locals);
});

/** @internal */
const get$d = /*#__PURE__*/dual(2, (self, fiberRef) => {
  if (!self.locals.has(fiberRef)) {
    return none$8();
  }
  return some$6(headNonEmpty$1(self.locals.get(fiberRef))[1]);
});

/** @internal */
const getOrDefault$1 = /*#__PURE__*/dual(2, (self, fiberRef) => pipe(get$d(self, fiberRef), getOrElse$3(() => fiberRef.initial)));

/** @internal */
const updatedAs$1 = /*#__PURE__*/dual(2, (self, {
  fiberId,
  fiberRef,
  value
}) => {
  const oldStack = self.locals.has(fiberRef) ? self.locals.get(fiberRef) : empty$C();
  let newStack;
  if (isEmptyReadonlyArray(oldStack)) {
    newStack = of$4([fiberId, value]);
  } else {
    const [currentId, currentValue] = headNonEmpty$1(oldStack);
    if (equals$1(currentId, fiberId)) {
      if (equals$1(currentValue, value)) {
        return self;
      } else {
        newStack = prepend$3([fiberId, value])(tailNonEmpty$1(oldStack));
      }
    } else {
      newStack = prepend$3([fiberId, value])(oldStack);
    }
  }
  const locals = new Map(self.locals);
  return new FiberRefsImpl(locals.set(fiberRef, newStack));
});

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
FiberRefsSym;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * `FiberRefs` is a data type that represents a collection of `FiberRef` values.
 *
 * This allows safely propagating `FiberRef` values across fiber boundaries, for
 * example between an asynchronous producer and consumer.
 *
 * @since 2.0.0
 * @category models
 */

delete_;

/**
 * Returns a set of each `FiberRef` in this collection.
 *
 * @since 2.0.0
 * @category getters
 */
fiberRefs$1;

/**
 * Forks this collection of fiber refs as the specified child fiber id. This
 * will potentially modify the value of the fiber refs, as determined by the
 * individual fiber refs that make up the collection.
 *
 * @since 2.0.0
 * @category utils
 */
const forkAs = forkAs$1;

/**
 * Gets the value of the specified `FiberRef` in this collection of `FiberRef`
 * values if it exists or `None` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
get$d;

/**
 * Gets the value of the specified `FiberRef` in this collection of `FiberRef`
 * values if it exists or the `initial` value of the `FiberRef` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const getOrDefault = getOrDefault$1;

/**
 * Joins this collection of fiber refs to the specified collection, as the
 * specified fiber id. This will perform diffing and merging to ensure
 * preservation of maximum information from both child and parent refs.
 *
 * @since 2.0.0
 * @category utils
 */
const joinAs = joinAs$1;

/**
 * Set each ref to either its value or its default.
 *
 * @since 2.0.0
 * @category utils
 */
const setAll = setAll$1;

/**
 * Updates the value of the specified `FiberRef` using the provided `FiberId`
 *
 * @since 2.0.0
 * @category utils
 */
const updatedAs = updatedAs$1;

/**
 * The empty collection of `FiberRef` values.
 *
 * @category constructors
 * @since 2.0.0
 */
const empty$g = empty$h;

/** @internal */
const OP_EMPTY$1 = "Empty";

/** @internal */

/** @internal */
const OP_ADD = "Add";

/** @internal */

/** @internal */
const OP_REMOVE = "Remove";

/** @internal */

/** @internal */
const OP_UPDATE = "Update";

/** @internal */

/** @internal */
const OP_AND_THEN$1 = "AndThen";

/** @internal */

/** @internal */
const empty$f = {
  _tag: OP_EMPTY$1
};

/** @internal */
const diff$2 = (oldValue, newValue) => {
  const missingLocals = new Map(oldValue.locals);
  let patch = empty$f;
  for (const [fiberRef, pairs] of newValue.locals.entries()) {
    const newValue = headNonEmpty$1(pairs)[1];
    const old = missingLocals.get(fiberRef);
    if (old !== undefined) {
      const oldValue = headNonEmpty$1(old)[1];
      if (!equals$1(oldValue, newValue)) {
        patch = combine$2({
          _tag: OP_UPDATE,
          fiberRef,
          patch: fiberRef.diff(oldValue, newValue)
        })(patch);
      }
    } else {
      patch = combine$2({
        _tag: OP_ADD,
        fiberRef,
        value: newValue
      })(patch);
    }
    missingLocals.delete(fiberRef);
  }
  for (const [fiberRef] of missingLocals.entries()) {
    patch = combine$2({
      _tag: OP_REMOVE,
      fiberRef
    })(patch);
  }
  return patch;
};

/** @internal */
const combine$2 = /*#__PURE__*/dual(2, (self, that) => ({
  _tag: OP_AND_THEN$1,
  first: self,
  second: that
}));

/** @internal */
const patch$2 = /*#__PURE__*/dual(3, (self, fiberId, oldValue) => {
  let fiberRefs = oldValue;
  let patches = of$4(self);
  while (isNonEmptyReadonlyArray(patches)) {
    const head = headNonEmpty$1(patches);
    const tail = tailNonEmpty$1(patches);
    switch (head._tag) {
      case OP_EMPTY$1:
        {
          patches = tail;
          break;
        }
      case OP_ADD:
        {
          fiberRefs = updatedAs$1(fiberRefs, {
            fiberId,
            fiberRef: head.fiberRef,
            value: head.value
          });
          patches = tail;
          break;
        }
      case OP_REMOVE:
        {
          fiberRefs = delete_(fiberRefs, head.fiberRef);
          patches = tail;
          break;
        }
      case OP_UPDATE:
        {
          const value = getOrDefault$1(fiberRefs, head.fiberRef);
          fiberRefs = updatedAs$1(fiberRefs, {
            fiberId,
            fiberRef: head.fiberRef,
            value: head.fiberRef.patch(head.patch)(value)
          });
          patches = tail;
          break;
        }
      case OP_AND_THEN$1:
        {
          patches = prepend$3(head.first)(prepend$3(head.second)(tail));
          break;
        }
    }
  }
  return fiberRefs;
});

/** @internal */
const MetricLabelSymbolKey = "effect/MetricLabel";

/** @internal */
const MetricLabelTypeId = /*#__PURE__*/Symbol.for(MetricLabelSymbolKey);

/** @internal */
class MetricLabelImpl {
  [MetricLabelTypeId] = MetricLabelTypeId;
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
  [symbol$1]() {
    return pipe(hash$1(MetricLabelSymbolKey), combine$a(hash$1(this.key)), combine$a(hash$1(this.value)));
  }
  [symbol](that) {
    return isMetricLabel(that) && this.key === that.key && this.value === that.value;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const make$K = (key, value) => {
  return new MetricLabelImpl(key, value);
};

/** @internal */
const isMetricLabel = u => {
  return typeof u === "object" && u != null && MetricLabelTypeId in u;
};

/** @internal */
class SingleShotGen {
  called = false;
  constructor(self) {
    this.self = self;
  }
  next(a) {
    return this.called ? {
      value: a,
      done: true
    } : (this.called = true, {
      value: this.self,
      done: false
    });
  }
  return(a) {
    return {
      value: a,
      done: true
    };
  }
  throw(e) {
    throw e;
  }
  [Symbol.iterator]() {
    return new SingleShotGen(this.self);
  }
}

/**
 * @since 2.0.0
 */

/**
 * A `LogLevel` represents the log level associated with an individual logging
 * operation. Log levels are used both to describe the granularity (or
 * importance) of individual log statements, as well as to enable tuning
 * verbosity of log output.
 *
 * @since 2.0.0
 * @category model
 * @property ordinal - The priority of the log message. Larger values indicate higher priority.
 * @property label - A label associated with the log level.
 * @property syslog -The syslog severity level of the log level.
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const All = logLevelAll;

/**
 * @since 2.0.0
 * @category constructors
 */
const Fatal = logLevelFatal;

/**
 * @since 2.0.0
 * @category constructors
 */
const Error$1 = logLevelError;

/**
 * @since 2.0.0
 * @category constructors
 */
const Warning = logLevelWarning;

/**
 * @since 2.0.0
 * @category constructors
 */
const Info = logLevelInfo;

/**
 * @since 2.0.0
 * @category constructors
 */
const Debug = logLevelDebug;

/**
 * @since 2.0.0
 * @category constructors
 */
const Trace = logLevelTrace;

/**
 * @since 2.0.0
 * @category constructors
 */
const None = logLevelNone;

/**
 * @since 2.0.0
 * @category constructors
 */
allLogLevels;

/**
 * @since 2.0.0
 * @category instances
 */
const Order$1 = /*#__PURE__*/pipe(Order$2, /*#__PURE__*/mapInput$5(level => level.ordinal));

/**
 * @since 2.0.0
 * @category ordering
 */
const greaterThan$1 = /*#__PURE__*/greaterThan$3(Order$1);

/**
 * @since 2.0.0
 * @category conversions
 */
const fromLiteral = _ => {
  switch (_) {
    case "All":
      {
        return All;
      }
    case "Debug":
      {
        return Debug;
      }
    case "Error":
      {
        return Error$1;
      }
    case "Fatal":
      {
        return Fatal;
      }
    case "Info":
      {
        return Info;
      }
    case "Trace":
      {
        return Trace;
      }
    case "None":
      {
        return None;
      }
    case "Warning":
      {
        return Warning;
      }
  }
};

/** @internal */
const make$J = (label, startTime) => ({
  label,
  startTime
});

/** @internal */
const render$1 = now => {
  return self => {
    const label = self.label.replace(/[\s="]/g, "_");
    return `${label}=${now - self.startTime}ms`;
  };
};

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make$I = make$J;

/**
 * @since 2.0.0
 * @category destructors
 */
const render = render$1;

/** @internal */
const RefTypeId$1 = /*#__PURE__*/Symbol.for("effect/Ref");

/** @internal */
const refVariance = {
  _A: _ => _
};
class RefImpl {
  [RefTypeId$1] = refVariance;
  constructor(ref) {
    this.ref = ref;
  }
  modify(f) {
    return sync$a(() => {
      const current = get$f(this.ref);
      const [b, a] = f(current);
      if (current !== a) {
        set$a(a)(this.ref);
      }
      return b;
    });
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const unsafeMake$3 = value => new RefImpl(make$W(value));

/** @internal */
const make$H = value => sync$a(() => unsafeMake$3(value));

/** @internal */
const get$c = self => self.modify(a => [a, a]);

/** @internal */
const set$7 = /*#__PURE__*/dual(2, (self, value) => self.modify(() => [void 0, value]));

/** @internal */
const getAndSet$2 = /*#__PURE__*/dual(2, (self, value) => self.modify(a => [a, value]));

/** @internal */
const getAndUpdate$1 = /*#__PURE__*/dual(2, (self, f) => self.modify(a => [a, f(a)]));

/** @internal */
const getAndUpdateSome$1 = /*#__PURE__*/dual(2, (self, pf) => self.modify(value => {
  const option = pf(value);
  switch (option._tag) {
    case "None":
      {
        return [value, value];
      }
    case "Some":
      {
        return [value, option.value];
      }
  }
}));

/** @internal */
const setAndGet$1 = /*#__PURE__*/dual(2, (self, value) => self.modify(() => [value, value]));

/** @internal */
const modify$4 = /*#__PURE__*/dual(2, (self, f) => self.modify(f));

/** @internal */
const modifySome$1 = /*#__PURE__*/dual(3, (self, fallback, pf) => self.modify(value => {
  const option = pf(value);
  switch (option._tag) {
    case "None":
      {
        return [fallback, value];
      }
    case "Some":
      {
        return option.value;
      }
  }
}));

/** @internal */
const update$5 = /*#__PURE__*/dual(2, (self, f) => self.modify(a => [void 0, f(a)]));

/** @internal */
const updateAndGet$1 = /*#__PURE__*/dual(2, (self, f) => self.modify(a => {
  const result = f(a);
  return [result, result];
}));

/** @internal */
const updateSome$1 = /*#__PURE__*/dual(2, (self, f) => self.modify(a => [void 0, match$j(f(a), {
  onNone: () => a,
  onSome: b => b
})]));

/** @internal */
const updateSomeAndGet$1 = /*#__PURE__*/dual(2, (self, pf) => self.modify(value => {
  const option = pf(value);
  switch (option._tag) {
    case "None":
      {
        return [value, value];
      }
    case "Some":
      {
        return [option.value, option.value];
      }
  }
}));

/** @internal */
const unsafeGet$2 = self => get$f(self.ref);

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const RefTypeId = RefTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make$G = make$H;

/**
 * @since 2.0.0
 * @category getters
 */
const get$b = get$c;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndSet$1 = getAndSet$2;

/**
 * @since 2.0.0
 * @category utils
 */
getAndUpdate$1;

/**
 * @since 2.0.0
 * @category utils
 */
getAndUpdateSome$1;

/**
 * @since 2.0.0
 * @category utils
 */
const modify$3 = modify$4;

/**
 * @since 2.0.0
 * @category utils
 */
modifySome$1;

/**
 * @since 2.0.0
 * @category utils
 */
const set$6 = set$7;

/**
 * @since 2.0.0
 * @category utils
 */
setAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
const update$4 = update$5;

/**
 * @since 2.0.0
 * @category utils
 */
updateAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
updateSome$1;

/**
 * @since 2.0.0
 * @category utils
 */
updateSomeAndGet$1;

/**
 * @since 2.0.0
 * @category unsafe
 */
unsafeMake$3;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 */
TracerTypeId;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category tags
 */
spanTag;

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category tags
 */
tracerTag;

/**
 * @since 2.0.0
 * @category constructors
 */
make$S;

/**
 * @since 2.0.0
 * @category constructors
 */
externalSpan;

/**
 * @since 2.0.0
 * @category constructors
 */
const tracerWith$2 = tracerWith$3;

/* @internal */
const annotateLogs$1 = /*#__PURE__*/dual(args => isEffect$1(args[0]), function () {
  const args = arguments;
  return fiberRefLocallyWith$1(args[0], currentLogAnnotations, typeof args[1] === "string" ? set$b(args[1], args[2]) : annotations => Object.entries(args[1]).reduce((acc, [key, value]) => set$b(acc, key, value), annotations));
});

/* @internal */
const asSome$2 = self => map$f(self, some$6);

/* @internal */
const asSomeError$2 = self => mapError$6(self, some$6);

/* @internal */
const asyncOption$2 = (register, blockingOn = none$6) => asyncEither$1(cb => {
  const option = register(cb);
  switch (option._tag) {
    case "None":
      {
        return left(unit$6);
      }
    case "Some":
      {
        return right(option.value);
      }
  }
}, blockingOn);

/* @internal */
const try_$2 = arg => {
  let evaluate;
  let onFailure = undefined;
  if (typeof arg === "function") {
    evaluate = arg;
  } else {
    evaluate = arg.try;
    onFailure = arg.catch;
  }
  return sync$a(() => {
    try {
      return evaluate();
    } catch (error) {
      throw makeEffectError(fail$g(onFailure ? onFailure(error) : error));
    }
  });
};

/* @internal */
const _catch$1 = /*#__PURE__*/dual(
// @ts-expect-error
3, (self, tag, options) => catchAll$5(self, e => {
  if (typeof e === "object" && e != null && tag in e && e[tag] === options.failure) {
    return options.onFailure(e);
  }
  return fail$f(e);
}));

/* @internal */
const catchAllDefect$1 = /*#__PURE__*/dual(2, (self, f) => catchAllCause$4(self, unified$1(cause => {
  const option = find$2(cause, _ => isDieType$1(_) ? some$6(_) : none$8());
  switch (option._tag) {
    case "None":
      {
        return failCause$a(cause);
      }
    case "Some":
      {
        return f(option.value.defect);
      }
  }
})));

/* @internal */
const catchSomeCause$2 = /*#__PURE__*/dual(2, (self, f) => matchCauseEffect$1(self, {
  onFailure: cause => {
    const option = f(cause);
    switch (option._tag) {
      case "None":
        {
          return failCause$a(cause);
        }
      case "Some":
        {
          return option.value;
        }
    }
  },
  onSuccess: succeed$h
}));

/* @internal */
const catchSomeDefect$1 = /*#__PURE__*/dual(2, (self, pf) => catchAllCause$4(self, unified$1(cause => {
  const option = find$2(cause, _ => isDieType$1(_) ? some$6(_) : none$8());
  switch (option._tag) {
    case "None":
      {
        return failCause$a(cause);
      }
    case "Some":
      {
        const optionEffect = pf(option.value.defect);
        return optionEffect._tag === "Some" ? optionEffect.value : failCause$a(cause);
      }
  }
})));

/* @internal */
const catchTag$3 = /*#__PURE__*/dual(3, (self, k, f) => catchIf$1(self, isTagged(k), f));

/** @internal */
const catchTags$3 = /*#__PURE__*/dual(2, (self, cases) => {
  let keys;
  return catchIf$1(self, e => {
    keys ??= Object.keys(cases);
    return isObject(e) && "_tag" in e && keys.includes(e["_tag"]);
  }, e => cases[e["_tag"]](e));
});

/* @internal */
const cause$1 = self => matchCause$2(self, {
  onFailure: identity$1,
  onSuccess: () => empty$n
});

/* @internal */
const clockWith$1 = clockWith$2;

/* @internal */
const clock$1 = /*#__PURE__*/clockWith$1(succeed$h);

/* @internal */
const delay$1 = /*#__PURE__*/dual(2, (self, duration) => zipRight$8(sleep$2(duration), self));

/* @internal */
const descriptorWith$1 = f => withFiberRuntime((state, status) => f({
  id: state.id(),
  status,
  interruptors: interruptors(state.getFiberRef(currentInterruptedCause))
}));

/* @internal */
const allowInterrupt$1 = /*#__PURE__*/descriptorWith$1(descriptor => size$g(descriptor.interruptors) > 0 ? interrupt$7 : unit$6);

/* @internal */
const descriptor$1 = /*#__PURE__*/descriptorWith$1(succeed$h);

/* @internal */
const diffFiberRefs$1 = self => summarized$3(self, fiberRefs, diff$2);

/* @internal */
const diffFiberRefsAndRuntimeFlags = self => summarized$3(self, zip$a(fiberRefs, runtimeFlags), ([refs, flags], [refsNew, flagsNew]) => [diff$2(refs, refsNew), diff$3(flags, flagsNew)]);

/* @internal */
const Do$2 = /*#__PURE__*/succeed$h({});

/* @internal */
const bind$3 = /*#__PURE__*/dual(3, (self, tag, f) => flatMap$6(self, k => map$f(f(k), a => ({
  ...k,
  [tag]: a
}))));

/* @internal */
const bindTo$3 = /*#__PURE__*/dual(2, (self, tag) => map$f(self, a => ({
  [tag]: a
})));

/* @internal */
const bindValue = /*#__PURE__*/dual(3, (self, tag, f) => map$f(self, k => ({
  ...k,
  [tag]: f(k)
})));

/* @internal */
const dropUntil$3 = /*#__PURE__*/dual(2, (elements, predicate) => suspend$8(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let dropping = succeed$h(false);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    dropping = flatMap$6(dropping, bool => {
      if (bool) {
        builder.push(a);
        return succeed$h(true);
      }
      return predicate(a, index);
    });
  }
  return map$f(dropping, () => builder);
}));

/* @internal */
const dropWhile$3 = /*#__PURE__*/dual(2, (elements, f) => suspend$8(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let dropping = succeed$h(true);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    dropping = flatMap$6(dropping, d => map$f(d ? f(a, index) : succeed$h(false), b => {
      if (!b) {
        builder.push(a);
      }
      return b;
    }));
  }
  return map$f(dropping, () => builder);
}));

/* @internal */
const contextWith$5 = f => map$f(context$7(), f);

/* @internal */
const eventually$2 = self => orElse$a(self, () => flatMap$6(yieldNow$2(), () => eventually$2(self)));

/* @internal */
const filterOrDie$2 = /*#__PURE__*/dual(3, (self, filter, orDieWith) => filterOrElse$2(self, filter, a => dieSync$5(() => orDieWith(a))));

/* @internal */
const filterOrDieMessage$2 = /*#__PURE__*/dual(3, (self, filter, message) => filterOrElse$2(self, filter, () => dieMessage$5(message)));

/* @internal */
const filterOrElse$2 = /*#__PURE__*/dual(3, (self, filter, orElse) => flatMap$6(self, a => filter(a) ? succeed$h(a) : orElse(a)));

/* @internal */
const filterOrFail$2 = /*#__PURE__*/dual(3, (self, filter, orFailWith) => filterOrElse$2(self, filter, a => failSync$6(() => orFailWith(a))));

/* @internal */
const findFirst$4 = /*#__PURE__*/dual(2, (elements, f) => suspend$8(() => {
  const iterator = elements[Symbol.iterator]();
  const next = iterator.next();
  if (!next.done) {
    return findLoop(iterator, 0, f, next.value);
  }
  return succeed$h(none$8());
}));
const findLoop = (iterator, index, f, value) => flatMap$6(f(value, index), result => {
  if (result) {
    return succeed$h(some$6(value));
  }
  const next = iterator.next();
  if (!next.done) {
    return findLoop(iterator, index + 1, f, next.value);
  }
  return succeed$h(none$8());
});

/* @internal */
const firstSuccessOf$1 = effects => suspend$8(() => {
  const list = fromIterable$b(effects);
  if (!isNonEmpty$5(list)) {
    return dieSync$5(() => IllegalArgumentException$1(`Received an empty collection of effects`));
  }
  return pipe(tailNonEmpty(list), reduce$i(headNonEmpty(list), (left, right) => orElse$a(left, () => right)));
});

/* @internal */
const flipWith$2 = /*#__PURE__*/dual(2, (self, f) => flip$2(f(flip$2(self))));

/* @internal */
const match$e = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchEffect$3(self, {
  onFailure: e => succeed$h(onFailure(e)),
  onSuccess: a => succeed$h(onSuccess(a))
}));

/* @internal */
const every$4 = /*#__PURE__*/dual(2, (elements, f) => suspend$8(() => forAllLoop(elements[Symbol.iterator](), 0, f)));
const forAllLoop = (iterator, index, f) => {
  const next = iterator.next();
  return next.done ? succeed$h(true) : flatMap$6(f(next.value, index), b => b ? forAllLoop(iterator, index + 1, f) : succeed$h(b));
};

/* @internal */
const forever$4 = self => {
  const loop = flatMap$6(flatMap$6(self, () => yieldNow$2()), () => loop);
  return loop;
};

/** @internal */
class EffectGen {
  constructor(value) {
    this.value = value;
  }
  [Symbol.iterator]() {
    return new SingleShotGen(this);
  }
}
const adapter$1 = function () {
  let x = arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    x = arguments[i](x);
  }
  return new EffectGen(x);
};

/**
 * Inspired by https://github.com/tusharmath/qio/pull/22 (revised)
  @internal */
const gen$2 = function () {
  let f;
  if (arguments.length === 1) {
    f = arguments[0];
  } else {
    f = arguments[1].bind(arguments[0]);
  }
  return suspend$8(() => {
    const iterator = f(adapter$1);
    const state = iterator.next();
    const run = state => state.done ? succeed$h(state.value) : pipe(state.value.value, flatMap$6(val => run(iterator.next(val))));
    return run(state);
  });
};

/* @internal */
const fiberRefs = /*#__PURE__*/withFiberRuntime(state => succeed$h(state.getFiberRefs()));

/* @internal */
const head$3 = self => matchEffect$3(self, {
  onFailure: e => fail$f(some$6(e)),
  onSuccess: as => {
    const iterator = as[Symbol.iterator]();
    const next = iterator.next();
    if (next.done) {
      return fail$f(none$8());
    }
    return succeed$h(next.value);
  }
});

/* @internal */
const ignore$2 = self => match$e(self, {
  onFailure: constVoid,
  onSuccess: constVoid
});

/* @internal */
const ignoreLogged$1 = self => matchCauseEffect$1(self, {
  onFailure: cause => logDebug$1(cause, "An error was silently ignored because it is not anticipated to be useful"),
  onSuccess: () => unit$6
});

/* @internal */
const inheritFiberRefs$1 = childFiberRefs => updateFiberRefs$1((parentFiberId, parentFiberRefs) => joinAs(parentFiberRefs, parentFiberId, childFiberRefs));

/* @internal */
const isFailure$4 = self => match$e(self, {
  onFailure: constTrue,
  onSuccess: constFalse
});

/* @internal */
const isSuccess$4 = self => match$e(self, {
  onFailure: constFalse,
  onSuccess: constTrue
});

/* @internal */
const iterate$3 = (initial, options) => suspend$8(() => {
  if (options.while(initial)) {
    return flatMap$6(options.body(initial), z2 => iterate$3(z2, options));
  }
  return succeed$h(initial);
});
const logWithLevel = level => (messageOrCause, supplementary) => {
  const levelOption = fromNullable$2(level);
  let message;
  let cause;
  if (isCause(messageOrCause)) {
    cause = messageOrCause;
    message = supplementary ?? "";
  } else {
    message = messageOrCause;
    cause = supplementary ?? empty$n;
  }
  return withFiberRuntime(fiberState => {
    fiberState.log(message, cause, levelOption);
    return unit$6;
  });
};

/** @internal */
const log$2 = /*#__PURE__*/logWithLevel();

/** @internal */
const logTrace$1 = /*#__PURE__*/logWithLevel(Trace);

/** @internal */
const logDebug$1 = /*#__PURE__*/logWithLevel(Debug);

/** @internal */
const logInfo$1 = /*#__PURE__*/logWithLevel(Info);

/** @internal */
const logWarning$1 = /*#__PURE__*/logWithLevel(Warning);

/** @internal */
const logError$1 = /*#__PURE__*/logWithLevel(Error$1);

/** @internal */
const logFatal$1 = /*#__PURE__*/logWithLevel(Fatal);

/* @internal */
const withLogSpan$1 = /*#__PURE__*/dual(2, (effect, label) => flatMap$6(currentTimeMillis, now => fiberRefLocallyWith$1(effect, currentLogSpan, prepend$1(make$I(label, now)))));

/* @internal */
const logAnnotations$1 = /*#__PURE__*/fiberRefGet(currentLogAnnotations);

/* @internal */
// @ts-expect-error
const loop$2 = (initial, options) => options.discard ? loopDiscard(initial, options.while, options.step, options.body) : map$f(loopInternal(initial, options.while, options.step, options.body), x => Array.from(x));
const loopInternal = (initial, cont, inc, body) => suspend$8(() => cont(initial) ? flatMap$6(body(initial), a => map$f(loopInternal(inc(initial), cont, inc, body), prepend$1(a))) : sync$a(() => empty$p()));
const loopDiscard = (initial, cont, inc, body) => suspend$8(() => cont(initial) ? flatMap$6(body(initial), () => loopDiscard(inc(initial), cont, inc, body)) : unit$6);

/* @internal */
const mapAccum$2 = /*#__PURE__*/dual(3, (elements, zero, f) => suspend$8(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let result = succeed$h(zero);
  let next;
  let i = 0;
  while (!(next = iterator.next()).done) {
    const index = i++;
    result = flatMap$6(result, state => map$f(f(state, next.value, index), ([z, b]) => {
      builder.push(b);
      return z;
    }));
  }
  return map$f(result, z => [z, builder]);
}));

/* @internal */
const mapErrorCause$3 = /*#__PURE__*/dual(2, (self, f) => matchCauseEffect$1(self, {
  onFailure: c => failCauseSync$5(() => f(c)),
  onSuccess: succeed$h
}));

/* @internal */
const memoize$1 = self => pipe(deferredMake(), flatMap$6(deferred => pipe(diffFiberRefsAndRuntimeFlags(self), intoDeferred$1(deferred), once$2, map$f(complete => zipRight$8(complete, pipe(deferredAwait(deferred), flatMap$6(([patch, a]) => as$6(zip$a(patchFiberRefs$1(patch[0]), updateRuntimeFlags(patch[1])), a))))))));

/* @internal */
const merge$6 = self => matchEffect$3(self, {
  onFailure: e => succeed$h(e),
  onSuccess: succeed$h
});

/* @internal */
const negate$2 = self => map$f(self, b => !b);

/* @internal */
const none$4 = self => matchEffect$3(self, {
  onFailure: e => fail$f(some$6(e)),
  onSuccess: option => {
    switch (option._tag) {
      case "None":
        {
          return unit$6;
        }
      case "Some":
        {
          return fail$f(none$8());
        }
    }
  }
});

/* @internal */
const once$2 = self => map$f(make$G(true), ref => asUnit$4(whenEffect$2(self, getAndSet$1(ref, false))));

/* @internal */
const option$3 = self => matchEffect$3(self, {
  onFailure: () => succeed$h(none$8()),
  onSuccess: a => succeed$h(some$6(a))
});

/* @internal */
const orElseFail$3 = /*#__PURE__*/dual(2, (self, evaluate) => orElse$a(self, () => failSync$6(evaluate)));

/* @internal */
const orElseSucceed$3 = /*#__PURE__*/dual(2, (self, evaluate) => orElse$a(self, () => sync$a(evaluate)));

/* @internal */
const parallelErrors$1 = self => matchCauseEffect$1(self, {
  onFailure: cause => {
    const errors = Array.from(failures(cause));
    return errors.length === 0 ? failCause$a(cause) : fail$f(errors);
  },
  onSuccess: succeed$h
});

/* @internal */
const patchFiberRefs$1 = patch$1 => updateFiberRefs$1((fiberId, fiberRefs) => pipe(patch$1, patch$2(fiberId, fiberRefs)));

/* @internal */
const promise$1 = evaluate => evaluate.length >= 1 ? async$1((resolve, signal) => {
  evaluate(signal).then(a => resolve(exitSucceed(a))).catch(e => resolve(exitDie(e)));
}) : async$1(resolve => {
  evaluate().then(a => resolve(exitSucceed(a))).catch(e => resolve(exitDie(e)));
});

/* @internal */
const provideService$5 = /*#__PURE__*/dual(3, (self, tag, service) => contextWithEffect$4(env => provideContext$6(self, add$4(env, tag, service))));

/* @internal */
const provideServiceEffect$2 = /*#__PURE__*/dual(3, (self, tag, effect) => contextWithEffect$4(env => flatMap$6(effect, service => provideContext$6(self, pipe(env, add$4(tag, service))))));

/* @internal */
const random$1 = /*#__PURE__*/randomWith$1(succeed$h);

/* @internal */
const reduce$9 = /*#__PURE__*/dual(3, (elements, zero, f) => fromIterable$c(elements).reduce((acc, el, i) => flatMap$6(acc, a => f(a, el, i)), succeed$h(zero)));

/* @internal */
const reduceRight$2 = /*#__PURE__*/dual(3, (elements, zero, f) => fromIterable$c(elements).reduceRight((acc, el, i) => flatMap$6(acc, a => f(el, a, i)), succeed$h(zero)));

/* @internal */
const reduceWhile$1 = /*#__PURE__*/dual(3, (elements, zero, options) => flatMap$6(sync$a(() => elements[Symbol.iterator]()), iterator => reduceWhileLoop(iterator, 0, zero, options.while, options.body)));
const reduceWhileLoop = (iterator, index, state, predicate, f) => {
  const next = iterator.next();
  if (!next.done && predicate(state)) {
    return flatMap$6(f(state, next.value, index), nextState => reduceWhileLoop(iterator, index + 1, nextState, predicate, f));
  }
  return succeed$h(state);
};

/* @internal */
const repeatN$1 = /*#__PURE__*/dual(2, (self, n) => suspend$8(() => repeatNLoop(self, n)));

/* @internal */
const repeatNLoop = (self, n) => flatMap$6(self, a => n <= 0 ? succeed$h(a) : zipRight$8(yieldNow$2(), repeatNLoop(self, n - 1)));

/* @internal */
const sandbox$1 = self => matchCauseEffect$1(self, {
  onFailure: fail$f,
  onSuccess: succeed$h
});

/* @internal */
const setFiberRefs$1 = fiberRefs => suspend$8(() => setAll(fiberRefs));

/* @internal */
const sleep$1 = sleep$2;

/* @internal */
const succeedNone$2 = /*#__PURE__*/succeed$h( /*#__PURE__*/none$8());

/* @internal */
const succeedSome$2 = value => succeed$h(some$6(value));

/* @internal */
const summarized$3 = /*#__PURE__*/dual(3, (self, summary, f) => flatMap$6(summary, start => flatMap$6(self, value => map$f(summary, end => [f(start, end), value]))));

/* @internal */
const tagMetrics$1 = /*#__PURE__*/dual(args => isEffect$1(args[0]), function () {
  return labelMetrics$1(arguments[0], typeof arguments[1] === "string" ? [make$K(arguments[1], arguments[2])] : Object.entries(arguments[1]).map(([k, v]) => make$K(k, v)));
});

/* @internal */
const labelMetrics$1 = /*#__PURE__*/dual(2, (self, labels) => labelMetricsSet$1(self, fromIterable$7(labels)));

/* @internal */
const labelMetricsSet$1 = /*#__PURE__*/dual(2, (self, labels) => fiberRefLocallyWith$1(currentMetricLabels, set => pipe(set, union$6(labels)))(self));

/* @internal */
const takeUntil$2 = /*#__PURE__*/dual(2, (elements, predicate) => suspend$8(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let effect = succeed$h(false);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    effect = flatMap$6(effect, bool => {
      if (bool) {
        return succeed$h(true);
      }
      builder.push(a);
      return predicate(a, index);
    });
  }
  return map$f(effect, () => builder);
}));

/* @internal */
const takeWhile$2 = /*#__PURE__*/dual(2, (elements, predicate) => suspend$8(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let taking = succeed$h(true);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    taking = flatMap$6(taking, taking => pipe(taking ? predicate(a, index) : succeed$h(false), map$f(bool => {
      if (bool) {
        builder.push(a);
      }
      return bool;
    })));
  }
  return map$f(taking, () => builder);
}));

/* @internal */
const tapBoth$3 = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchCauseEffect$1(self, {
  onFailure: cause => {
    const either = failureOrCause$1(cause);
    switch (either._tag) {
      case "Left":
        {
          return zipRight$8(onFailure(either.left), failCause$a(cause));
        }
      case "Right":
        {
          return failCause$a(cause);
        }
    }
  },
  onSuccess: a => as$6(onSuccess(a), a)
}));

/* @internal */
const tapDefect$1 = /*#__PURE__*/dual(2, (self, f) => catchAllCause$4(self, cause => match$j(keepDefects(cause), {
  onNone: () => failCause$a(cause),
  onSome: a => zipRight$8(f(a), failCause$a(cause))
})));

/* @internal */
const tapError$4 = /*#__PURE__*/dual(2, (self, f) => matchCauseEffect$1(self, {
  onFailure: cause => {
    const either = failureOrCause$1(cause);
    switch (either._tag) {
      case "Left":
        {
          return zipRight$8(f(either.left), failCause$a(cause));
        }
      case "Right":
        {
          return failCause$a(cause);
        }
    }
  },
  onSuccess: succeed$h
}));

/* @internal */
const tapErrorTag$1 = /*#__PURE__*/dual(3, (self, k, f) => tapError$4(self, e => {
  if (isTagged(e, k)) {
    return f(e);
  }
  return unit$6;
}));

/* @internal */
const tapErrorCause$3 = /*#__PURE__*/dual(2, (self, f) => matchCauseEffect$1(self, {
  onFailure: cause => zipRight$8(f(cause), failCause$a(cause)),
  onSuccess: succeed$h
}));

/* @internal */
const timed$2 = self => timedWith$1(self, currentTimeNanos);

/* @internal */
const timedWith$1 = /*#__PURE__*/dual(2, (self, nanos$1) => summarized$3(self, nanos$1, (start, end) => nanos(end - start)));

/* @internal */
const tracerWith$1 = tracerWith$2;

/** @internal */
const tracer$1 = /*#__PURE__*/tracerWith$1(succeed$h);

/* @internal */
const tryPromise$1 = arg => {
  let evaluate;
  let catcher = undefined;
  if (typeof arg === "function") {
    evaluate = arg;
  } else {
    evaluate = arg.try;
    catcher = arg.catch;
  }
  if (evaluate.length >= 1) {
    return suspend$8(() => {
      const controller = new AbortController();
      return flatMap$6(try_$2(() => evaluate(controller.signal)), promise => async$1(resolve => {
        promise.then(a => resolve(exitSucceed(a))).catch(e => resolve(fail$f(catcher ? catcher(e) : e)));
        return sync$a(() => controller.abort());
      }));
    });
  }
  return flatMap$6(try_$2(arg), promise => async$1(resolve => {
    promise.then(a => resolve(exitSucceed(a))).catch(e => resolve(fail$f(catcher ? catcher(e) : e)));
  }));
};

/* @internal */
const tryMap$1 = /*#__PURE__*/dual(2, (self, options) => flatMap$6(self, a => try_$2({
  try: () => options.try(a),
  catch: options.catch
})));

/* @internal */
const tryMapPromise$1 = /*#__PURE__*/dual(2, (self, options) => flatMap$6(self, a => tryPromise$1({
  try: options.try.length >= 1 ? signal => options.try(a, signal) : () => options.try(a),
  catch: options.catch
})));

/* @internal */
const unless$2 = /*#__PURE__*/dual(2, (self, predicate) => suspend$8(() => predicate() ? succeedNone$2 : asSome$2(self)));

/* @internal */
const unlessEffect$1 = /*#__PURE__*/dual(2, (self, predicate) => flatMap$6(predicate, b => b ? succeedNone$2 : asSome$2(self)));

/* @internal */
const unsandbox$1 = self => mapErrorCause$3(self, flatten$7);

/* @internal */
const updateFiberRefs$1 = f => withFiberRuntime(state => {
  state.setFiberRefs(f(state.id(), state.getFiberRefs()));
  return unit$6;
});

/* @internal */
const updateService$3 = /*#__PURE__*/dual(3, (self, tag, f) => mapInputContext$6(self, context => add$4(context, tag, f(unsafeGet$6(context, tag)))));

/* @internal */
const when$4 = /*#__PURE__*/dual(2, (self, predicate) => suspend$8(() => predicate() ? map$f(self, some$6) : succeed$h(none$8())));

/* @internal */
const whenFiberRef$1 = /*#__PURE__*/dual(3, (self, fiberRef, predicate) => flatMap$6(fiberRefGet(fiberRef), s => predicate(s) ? map$f(self, a => [s, some$6(a)]) : succeed$h([s, none$8()])));

/* @internal */
const whenRef$1 = /*#__PURE__*/dual(3, (self, ref, predicate) => flatMap$6(get$b(ref), s => predicate(s) ? map$f(self, a => [s, some$6(a)]) : succeed$h([s, none$8()])));

/* @internal */
const withMetric$1 = /*#__PURE__*/dual(2, (self, metric) => metric(self));

/** @internal */
const serviceFunctionEffect$1 = (service, f) => (...args) => flatMap$6(service, a => f(a)(...args));

/** @internal */
const serviceFunction$1 = (service, f) => (...args) => map$f(service, a => f(a)(...args));

/** @internal */
const serviceFunctions$1 = tag => new Proxy({}, {
  get(_target, prop, _receiver) {
    return (...args) => flatMap$6(tag, s => s[prop](...args));
  }
});

/** @internal */
const serviceConstants$1 = tag => new Proxy({}, {
  get(_target, prop, _receiver) {
    return flatMap$6(tag, s => s[prop]);
  }
});

/** @internal */
const serviceMembers$1 = tag => ({
  functions: serviceFunctions$1(tag),
  constants: serviceConstants$1(tag)
});

/** @internal */
const serviceOption$1 = tag => map$f(context$7(), getOption(tag));

// -----------------------------------------------------------------------------
// tracing
// -----------------------------------------------------------------------------

/* @internal */
const annotateCurrentSpan$1 = function () {
  const args = arguments;
  return flatMap$6(currentSpan$1, span => span._tag === "Some" ? sync$a(() => {
    if (typeof args[0] === "string") {
      span.value.attribute(args[0], args[1]);
    } else {
      for (const key in args[0]) {
        span.value.attribute(key, args[0][key]);
      }
    }
  }) : unit$6);
};

/* @internal */
const annotateSpans$1 = /*#__PURE__*/dual(args => isEffect$1(args[0]), function () {
  const args = arguments;
  return fiberRefLocallyWith$1(args[0], currentTracerSpanAnnotations, typeof args[1] === "string" ? set$b(args[1], args[2]) : annotations => Object.entries(args[1]).reduce((acc, [key, value]) => set$b(acc, key, value), annotations));
});

/** @internal */
const currentParentSpan$1 = /*#__PURE__*/serviceOption$1(spanTag);

/** @internal */
const currentSpan$1 = /*#__PURE__*/map$f( /*#__PURE__*/context$7(), context => {
  const span = context.unsafeMap.get(spanTag);
  return span !== undefined && span._tag === "Span" ? some$6(span) : none$8();
});
const bigint0$1 = /*#__PURE__*/BigInt(0);
/** @internal */
const currentTimeNanosTracing = /*#__PURE__*/fiberRefGetWith(currentTracerTimingEnabled, enabled => enabled ? currentTimeNanos : succeed$h(bigint0$1));

/* @internal */
const linkSpans$1 = /*#__PURE__*/dual(args => isEffect$1(args[0]), (self, span, attributes) => fiberRefLocallyWith$1(self, currentTracerSpanLinks, append$1({
  _tag: "SpanLink",
  span,
  attributes: attributes ?? {}
})));

/** @internal */
const makeSpan$1 = (name, options) => tracerWith$1(tracer => flatMap$6(options?.parent ? succeedSome$2(options.parent) : options?.root ? succeedNone$2 : currentParentSpan$1, parent => flatMap$6(fiberRefGet(currentTracerSpanAnnotations), annotations => flatMap$6(fiberRefGet(currentTracerSpanLinks), links => flatMap$6(currentTimeNanosTracing, startTime => sync$a(() => {
  const linksArray = options?.links ? [...toReadonlyArray$4(links), ...options.links] : toReadonlyArray$4(links);
  const span = tracer.span(name, parent, options?.context ?? empty$A(), linksArray, startTime);
  forEach$9(annotations, (value, key) => span.attribute(key, value));
  Object.entries(options?.attributes ?? {}).forEach(([k, v]) => span.attribute(k, v));
  return span;
}))))));

/* @internal */
const spanAnnotations$1 = /*#__PURE__*/fiberRefGet(currentTracerSpanAnnotations);

/* @internal */
const spanLinks$1 = /*#__PURE__*/fiberRefGet(currentTracerSpanLinks);

/** @internal */
const useSpan$1 = (name, ...args) => {
  const options = args.length === 1 ? undefined : args[0];
  const evaluate = args[args.length - 1];
  return acquireUseRelease$3(makeSpan$1(name, options), evaluate, (span, exit) => flatMap$6(currentTimeNanosTracing, endTime => sync$a(() => span.end(endTime, exit))));
};

/** @internal */
const withParentSpan$2 = /*#__PURE__*/dual(2, (self, span) => provideService$5(self, spanTag, span));

/** @internal */
const withSpan$4 = /*#__PURE__*/dual(args => typeof args[0] !== "string", (self, name, options) => useSpan$1(name, options ?? {}, span => withParentSpan$2(self, span)));

// -------------------------------------------------------------------------------------
// optionality
// -------------------------------------------------------------------------------------

/* @internal */
const fromNullable$1 = value => value == null ? fail$f(NoSuchElementException$1()) : succeed$h(value);

/* @internal */
const optionFromOptional$1 = self => catchAll$5(map$f(self, some$6), error => isNoSuchElementException(error) ? succeedNone$2 : fail$f(error));

/** @internal */
const OP_SEQUENTIAL = "Sequential";

/** @internal */

/** @internal */
const OP_PARALLEL = "Parallel";

/** @internal */

/** @internal */
const OP_PARALLEL_N = "ParallelN";

/** @internal */

/** @internal */
const sequential$1 = {
  _tag: OP_SEQUENTIAL
};

/** @internal */
const parallel$2 = {
  _tag: OP_PARALLEL
};

/** @internal */
const parallelN$1 = parallelism => ({
  _tag: OP_PARALLEL_N,
  parallelism
});

/** @internal */
const isSequential = self => self._tag === OP_SEQUENTIAL;

/** @internal */
const isParallel = self => self._tag === OP_PARALLEL;

/** @internal */
const isParallelN = self => self._tag === OP_PARALLEL_N;

/** @internal */
const match$d = /*#__PURE__*/dual(4, (self, onSequential, onParallel, onParallelN) => {
  switch (self._tag) {
    case OP_SEQUENTIAL:
      {
        return onSequential();
      }
    case OP_PARALLEL:
      {
        return onParallel();
      }
    case OP_PARALLEL_N:
      {
        return onParallelN(self.parallelism);
      }
  }
});

/**
 * @since 2.0.0
 */

/**
 * Describes a strategy for evaluating multiple effects, potentially in
 * parallel.
 *
 * There are 3 possible execution strategies: `Sequential`, `Parallel`,
 * `ParallelN`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Execute effects sequentially.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Execute effects in parallel.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Execute effects in parallel, up to the specified number of concurrent fibers.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Execute effects sequentially.
 *
 * @since 2.0.0
 * @category constructors
 */
const sequential = sequential$1;

/**
 * Execute effects in parallel.
 *
 * @since 2.0.0
 * @category constructors
 */
const parallel$1 = parallel$2;

/**
 * Execute effects in parallel, up to the specified number of concurrent fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
const parallelN = parallelN$1;

/**
 * Returns `true` if the specified `ExecutionStrategy` is an instance of
 * `Sequential`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isSequential;

/**
 * Returns `true` if the specified `ExecutionStrategy` is an instance of
 * `Sequential`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isParallel;

/**
 * Returns `true` if the specified `ExecutionStrategy` is an instance of
 * `Sequential`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isParallelN;

/**
 * Folds over the specified `ExecutionStrategy` using the provided case
 * functions.
 *
 * @since 2.0.0
 * @category folding
 */
match$d;

/**
 * @since 2.0.0
 */

/**
 * A `FiberRefsPatch` captures the changes in `FiberRef` values made by a single
 * fiber as a value. This allows fibers to apply the changes made by a workflow
 * without inheriting all the `FiberRef` values of the fiber that executed the
 * workflow.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
empty$f;

/**
 * Constructs a patch that describes the changes between the specified
 * collections of `FiberRef`
 *
 * @since 2.0.0
 * @category constructors
 */
const diff$1 = diff$2;

/**
 * Combines this patch and the specified patch to create a new patch that
 * describes applying the changes from this patch and the specified patch
 * sequentially.
 *
 * @since 2.0.0
 * @category constructors
 */
combine$2;

/**
 * Applies the changes described by this patch to the specified collection
 * of `FiberRef` values.
 *
 * @since 2.0.0
 * @category destructors
 */
const patch$1 = patch$2;

const FiberStatusSymbolKey = "effect/FiberStatus";

/** @internal */
const FiberStatusTypeId = /*#__PURE__*/Symbol.for(FiberStatusSymbolKey);

/** @internal */
const OP_DONE$5 = "Done";

/** @internal */

/** @internal */
const OP_RUNNING$1 = "Running";

/** @internal */

/** @internal */
const OP_SUSPENDED = "Suspended";

/** @internal */

/** @internal */
class Done$3 {
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_DONE$5;
  [symbol$1]() {
    return pipe(hash$1(FiberStatusSymbolKey), combine$a(hash$1(this._tag)));
  }
  [symbol](that) {
    return isFiberStatus(that) && that._tag === OP_DONE$5;
  }
}

/** @internal */
class Running {
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_RUNNING$1;
  constructor(runtimeFlags) {
    this.runtimeFlags = runtimeFlags;
  }
  [symbol$1]() {
    return pipe(hash$1(FiberStatusSymbolKey), combine$a(hash$1(this._tag)), combine$a(hash$1(this.runtimeFlags)));
  }
  [symbol](that) {
    return isFiberStatus(that) && that._tag === OP_RUNNING$1 && this.runtimeFlags === that.runtimeFlags;
  }
}

/** @internal */
class Suspended {
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_SUSPENDED;
  constructor(runtimeFlags, blockingOn) {
    this.runtimeFlags = runtimeFlags;
    this.blockingOn = blockingOn;
  }
  [symbol$1]() {
    return pipe(hash$1(FiberStatusSymbolKey), combine$a(hash$1(this._tag)), combine$a(hash$1(this.runtimeFlags)), combine$a(hash$1(this.blockingOn)));
  }
  [symbol](that) {
    return isFiberStatus(that) && that._tag === OP_SUSPENDED && this.runtimeFlags === that.runtimeFlags && equals$1(this.blockingOn, that.blockingOn);
  }
}

/** @internal */
const done$a = /*#__PURE__*/new Done$3();

/** @internal */
const running$2 = runtimeFlags => new Running(runtimeFlags);

/** @internal */
const suspended$1 = (runtimeFlags, blockingOn) => new Suspended(runtimeFlags, blockingOn);

/** @internal */
const isFiberStatus = u => typeof u === "object" && u != null && FiberStatusTypeId in u;

/** @internal */
const isDone$5 = self => self._tag === OP_DONE$5;

/** @internal */
const isRunning$2 = self => self._tag === OP_RUNNING$1;

/** @internal */
const isSuspended$1 = self => self._tag === OP_SUSPENDED;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
FiberStatusTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const done$9 = done$a;

/**
 * @since 2.0.0
 * @category constructors
 */
const running$1 = running$2;

/**
 * @since 2.0.0
 * @category constructors
 */
const suspended = suspended$1;

/**
 * Returns `true` if the specified value is a `FiberStatus`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isFiberStatus;

/**
 * Returns `true` if the specified `FiberStatus` is `Done`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isDone$4 = isDone$5;

/**
 * Returns `true` if the specified `FiberStatus` is `Running`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRunning$1 = isRunning$2;

/**
 * Returns `true` if the specified `FiberStatus` is `Suspended`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isSuspended = isSuspended$1;

/** @internal */
const currentRequestMap = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentRequestMap"), () => fiberRefUnsafeMake(new Map()));

/** @internal */
const match$c = (options, sequential, unbounded, bounded) => {
  switch (options?.concurrency) {
    case undefined:
      {
        return sequential();
      }
    case "unbounded":
      {
        return unbounded();
      }
    case "inherit":
      {
        return fiberRefGetWith(currentConcurrency, concurrency => concurrency === "unbounded" ? unbounded() : concurrency > 1 ? bounded(concurrency) : sequential());
      }
    default:
      {
        return options.concurrency > 1 ? bounded(options.concurrency) : sequential();
      }
  }
};

/** @internal */
const matchSimple = (options, sequential, concurrent) => {
  switch (options?.concurrency) {
    case undefined:
      {
        return sequential();
      }
    case "unbounded":
      {
        return concurrent();
      }
    case "inherit":
      {
        return fiberRefGetWith(currentConcurrency, concurrency => concurrency === "unbounded" ? concurrent() : concurrency > 1 ? concurrent() : sequential());
      }
    default:
      {
        return options.concurrency > 1 ? concurrent() : sequential();
      }
  }
};

/** @internal */

/** @internal */
const OP_INTERRUPT_SIGNAL = "InterruptSignal";

/** @internal */

/** @internal */
const OP_STATEFUL = "Stateful";

/** @internal */

/** @internal */
const OP_RESUME = "Resume";

/** @internal */

/** @internal */
const OP_YIELD_NOW = "YieldNow";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const interruptSignal = cause => ({
  _tag: OP_INTERRUPT_SIGNAL,
  cause
});

/** @internal */
const stateful = onFiber => ({
  _tag: OP_STATEFUL,
  onFiber
});

/** @internal */
const resume = effect => ({
  _tag: OP_RESUME,
  effect
});

/** @internal */
const yieldNow$1 = () => ({
  _tag: OP_YIELD_NOW
});

/** @internal */
const FiberScopeSymbolKey = "effect/FiberScope";

/** @internal */
const FiberScopeTypeId = /*#__PURE__*/Symbol.for(FiberScopeSymbolKey);

/**
 * A `FiberScope` represents the scope of a fiber lifetime. The scope of a
 * fiber can be retrieved using `Effect.descriptor`, and when forking fibers,
 * you can specify a custom scope to fork them on by using the `forkIn`.
 *
 * @since 2.0.0
 * @category models
 */

/** @internal */
class Global {
  [FiberScopeTypeId] = FiberScopeTypeId;
  fiberId = none$6;
  roots = new Set();
  add(_runtimeFlags, child) {
    this.roots.add(child);
    child.addObserver(() => {
      this.roots.delete(child);
    });
  }
}

/** @internal */
class Local {
  [FiberScopeTypeId] = FiberScopeTypeId;
  constructor(fiberId, parent) {
    this.fiberId = fiberId;
    this.parent = parent;
  }
  add(_runtimeFlags, child) {
    this.parent.tell(stateful(parentFiber => {
      parentFiber.addChild(child);
      child.addObserver(() => {
        parentFiber.removeChild(child);
      });
    }));
  }
}

/** @internal */
const unsafeMake$2 = fiber => {
  return new Local(fiber.id(), fiber);
};

/** @internal */
const globalScope = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberScope/Global"), () => new Global());

/** @internal */
const FiberSymbolKey = "effect/Fiber";

/** @internal */
const FiberTypeId = /*#__PURE__*/Symbol.for(FiberSymbolKey);

/** @internal */
const fiberVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */
const fiberProto = {
  [FiberTypeId]: fiberVariance,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const RuntimeFiberSymbolKey = "effect/Fiber";

/** @internal */
const RuntimeFiberTypeId = /*#__PURE__*/Symbol.for(RuntimeFiberSymbolKey);

/** @internal */
const Order = /*#__PURE__*/pipe( /*#__PURE__*/tuple$1(Order$2, Order$2), /*#__PURE__*/mapInput$5(fiber => [fiber.id().startTimeMillis, fiber.id().id]));

/** @internal */
const isFiber = u => typeof u === "object" && u != null && FiberTypeId in u;

/** @internal */
const isRuntimeFiber = self => RuntimeFiberTypeId in self;

/** @internal */
const _await$2 = self => self.await();

/** @internal */
const children = self => self.children();

/** @internal */
const done$8 = exit => ({
  ...fiberProto,
  id: () => none$6,
  await: () => succeed$h(exit),
  children: () => succeed$h([]),
  inheritAll: () => unit$6,
  poll: () => succeed$h(some$6(exit)),
  interruptAsFork: () => unit$6
});

/** @internal */
const dump = self => map$f(self.status(), status => ({
  id: self.id(),
  status
}));

/** @internal */
const dumpAll = fibers => forEachSequential(fibers, dump);

/** @internal */
const fail$b = error => done$8(fail$d(error));

/** @internal */
const failCause$7 = cause => done$8(failCause$8(cause));

/** @internal */
const fromEffect$6 = effect => map$f(exit$1(effect), done$8);

/** @internal */
const id = self => self.id();

/** @internal */
const inheritAll$1 = self => self.inheritAll();

/** @internal */
const interrupted$1 = fiberId => done$8(interrupt$5(fiberId));

/** @internal */
const interruptAll = fibers => flatMap$6(fiberId$2, fiberId => pipe(fibers, interruptAllAs(fiberId)));

/** @internal */
const interruptAllAs = /*#__PURE__*/dual(2, (fibers, fiberId) => pipe(forEachSequentialDiscard(fibers, interruptAsFork(fiberId)), zipRight$8(pipe(fibers, forEachSequentialDiscard(_await$2)))));

/** @internal */
const interruptAsFork = /*#__PURE__*/dual(2, (self, fiberId) => self.interruptAsFork(fiberId));

/** @internal */
const join$1 = self => zipLeft$7(flatten$6(self.await()), self.inheritAll());

/** @internal */
const map$c = /*#__PURE__*/dual(2, (self, f) => mapEffect$3(self, a => sync$a(() => f(a))));

/** @internal */
const mapEffect$3 = /*#__PURE__*/dual(2, (self, f) => ({
  ...fiberProto,
  id: () => self.id(),
  await: () => flatMap$6(self.await(), forEachEffect(f)),
  children: () => self.children(),
  inheritAll: () => self.inheritAll(),
  poll: () => flatMap$6(self.poll(), result => {
    switch (result._tag) {
      case "None":
        {
          return succeed$h(none$8());
        }
      case "Some":
        {
          return pipe(forEachEffect(result.value, f), map$f(some$6));
        }
    }
  }),
  interruptAsFork: id => self.interruptAsFork(id)
}));

/** @internal */
const mapFiber = /*#__PURE__*/dual(2, (self, f) => map$f(self.await(), match$f({
  onFailure: cause => failCause$7(cause),
  onSuccess: a => f(a)
})));

/** @internal */
const match$b = /*#__PURE__*/dual(2, (self, {
  onFiber,
  onRuntimeFiber
}) => {
  if (isRuntimeFiber(self)) {
    return onRuntimeFiber(self);
  }
  return onFiber(self);
});

/** @internal */
const never$5 = {
  ...fiberProto,
  id: () => none$6,
  await: () => never$6,
  children: () => succeed$h([]),
  inheritAll: () => never$6,
  poll: () => succeed$h(none$8()),
  interruptAsFork: () => never$6
};

/** @internal */
const orElse$7 = /*#__PURE__*/dual(2, (self, that) => ({
  ...fiberProto,
  id: () => getOrElse$1(self.id(), that.id()),
  await: () => zipWith$7(self.await(), that.await(), (exit1, exit2) => isSuccess$5(exit1) ? exit1 : exit2),
  children: () => self.children(),
  inheritAll: () => zipRight$8(that.inheritAll(), self.inheritAll()),
  poll: () => zipWith$7(self.poll(), that.poll(), (option1, option2) => {
    switch (option1._tag) {
      case "None":
        {
          return none$8();
        }
      case "Some":
        {
          return isSuccess$5(option1.value) ? option1 : option2;
        }
    }
  }),
  interruptAsFork: id => pipe(interruptAsFiber(self, id), zipRight$8(pipe(that, interruptAsFiber(id))), asUnit$4)
}));

/** @internal */
const orElseEither$2 = /*#__PURE__*/dual(2, (self, that) => orElse$7(map$c(self, left), map$c(that, right)));

/** @internal */
const poll$6 = self => self.poll();

// forked from https://github.com/sindresorhus/parse-ms/blob/4da2ffbdba02c6e288c08236695bdece0adca173/index.js
// MIT License
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)
/** @internal */
const parseMs = milliseconds => {
  const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
  return {
    days: roundTowardsZero(milliseconds / 86400000),
    hours: roundTowardsZero(milliseconds / 3600000) % 24,
    minutes: roundTowardsZero(milliseconds / 60000) % 60,
    seconds: roundTowardsZero(milliseconds / 1000) % 60,
    milliseconds: roundTowardsZero(milliseconds) % 1000,
    microseconds: roundTowardsZero(milliseconds * 1000) % 1000,
    nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1000
  };
};

/** @internal */
const renderStatus = status => {
  if (isDone$4(status)) {
    return "Done";
  }
  if (isRunning$1(status)) {
    return "Running";
  }
  const isInterruptible = interruptible$2(status.runtimeFlags) ? "interruptible" : "uninterruptible";
  return `Suspended(${isInterruptible})`;
};

/** @internal */
const pretty = self => flatMap$6(currentTimeMillis, now => map$f(dump(self), dump => {
  const time = now - dump.id.startTimeMillis;
  const {
    days,
    hours,
    milliseconds,
    minutes,
    seconds
  } = parseMs(time);
  const lifeMsg = (days === 0 ? "" : `${days}d`) + (days === 0 && hours === 0 ? "" : `${hours}h`) + (days === 0 && hours === 0 && minutes === 0 ? "" : `${minutes}m`) + (days === 0 && hours === 0 && minutes === 0 && seconds === 0 ? "" : `${seconds}s`) + `${milliseconds}ms`;
  const waitMsg = isSuspended(dump.status) ? (() => {
    const ids$1$1 = ids$1(dump.status.blockingOn);
    return size$g(ids$1$1) > 0 ? `waiting on ` + Array.from(ids$1$1).map(id => `${id}`).join(", ") : "";
  })() : "";
  const statusMsg = renderStatus(dump.status);
  return `[Fiber](#${dump.id.id}) (${lifeMsg}) ${waitMsg}\n   Status: ${statusMsg}`;
}));

/** @internal */
const unsafeRoots = () => Array.from(globalScope.roots);

/** @internal */
const roots = /*#__PURE__*/sync$a(unsafeRoots);

/** @internal */
const status = self => self.status();

/** @internal */
const succeed$d = value => done$8(succeed$f(value));

/** @internal */
const unit$4 = /*#__PURE__*/succeed$d(void 0);

/** @internal */
const currentFiberURI = "effect/FiberCurrent";

/** @internal */
const getCurrentFiber = () => fromNullable$2(globalThis[currentFiberURI]);

/** @internal */
const LoggerSymbolKey = "effect/Logger";

/** @internal */
const LoggerTypeId = /*#__PURE__*/Symbol.for(LoggerSymbolKey);

/** @internal */
const loggerVariance = {
  _Message: _ => _,
  _Output: _ => _
};

/** @internal */
const makeLogger = log => ({
  [LoggerTypeId]: loggerVariance,
  log,
  pipe() {
    return pipeArguments(this, arguments);
  }
});

/** @internal */
const mapInput$4 = /*#__PURE__*/dual(2, (self, f) => makeLogger(options => self.log({
  ...options,
  message: f(options.message)
})));

/** @internal */
const filterLogLevel = /*#__PURE__*/dual(2, (self, f) => makeLogger(options => f(options.logLevel) ? some$6(self.log(options)) : none$8()));

/** @internal */
const map$b = /*#__PURE__*/dual(2, (self, f) => makeLogger(options => f(self.log(options))));

/** @internal */
const none$3 = {
  [LoggerTypeId]: loggerVariance,
  log: constVoid,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */
const simple = log => ({
  [LoggerTypeId]: loggerVariance,
  log: ({
    message
  }) => log(message),
  pipe() {
    return pipeArguments(this, arguments);
  }
});

/** @internal */
const succeed$c = value => {
  return simple(() => value);
};

/** @internal */
const sync$8 = evaluate => {
  return simple(evaluate);
};

/** @internal */
const zip$7 = /*#__PURE__*/dual(2, (self, that) => makeLogger(options => [self.log(options), that.log(options)]));

/** @internal */
const zipLeft$6 = /*#__PURE__*/dual(2, (self, that) => map$b(zip$7(self, that), tuple => tuple[0]));

/** @internal */
const zipRight$6 = /*#__PURE__*/dual(2, (self, that) => map$b(zip$7(self, that), tuple => tuple[1]));

/** @internal */
const stringLogger = /*#__PURE__*/makeLogger(({
  annotations,
  cause,
  date,
  fiberId,
  logLevel,
  message,
  spans
}) => {
  const nowMillis = date.getTime();
  const outputArray = [`timestamp=${date.toISOString()}`, `level=${logLevel.label}`, `fiber=${threadName$1(fiberId)}`];
  let output = outputArray.join(" ");
  const stringMessage = serializeUnknown(message);
  if (stringMessage.length > 0) {
    output = output + " message=";
    output = appendQuoted(stringMessage, output);
  }
  if (cause != null && cause._tag !== "Empty") {
    output = output + " cause=";
    output = appendQuoted(pretty$1(cause), output);
  }
  if (isCons(spans)) {
    output = output + " ";
    let first = true;
    for (const span of spans) {
      if (first) {
        first = false;
      } else {
        output = output + " ";
      }
      output = output + pipe(span, render(nowMillis));
    }
  }
  if (pipe(annotations, size$h) > 0) {
    output = output + " ";
    let first = true;
    for (const [key, value] of annotations) {
      if (first) {
        first = false;
      } else {
        output = output + " ";
      }
      output = output + filterKeyName(key);
      output = output + "=";
      output = appendQuoted(serializeUnknown(value), output);
    }
  }
  return output;
});
const serializeUnknown = u => {
  try {
    return typeof u === "object" ? JSON.stringify(u) : String(u);
  } catch (_) {
    return String(u);
  }
};

/** @internal */
const escapeDoubleQuotes = str => `"${str.replace(/\\([\s\S])|(")/g, "\\$1$2")}"`;
const textOnly = /^[^\s"=]+$/;

/** @internal */
const appendQuoted = (label, output) => output + (label.match(textOnly) ? label : escapeDoubleQuotes(label));

/** @internal */
const logfmtLogger = /*#__PURE__*/makeLogger(({
  annotations,
  cause,
  date,
  fiberId,
  logLevel,
  message,
  spans
}) => {
  const nowMillis = date.getTime();
  const outputArray = [`timestamp=${date.toISOString()}`, `level=${logLevel.label}`, `fiber=${threadName$1(fiberId)}`];
  let output = outputArray.join(" ");
  const stringMessage = serializeUnknown(message);
  if (stringMessage.length > 0) {
    output = output + " message=";
    output = appendQuotedLogfmt(stringMessage, output);
  }
  if (cause != null && cause._tag !== "Empty") {
    output = output + " cause=";
    output = appendQuotedLogfmt(pretty$1(cause), output);
  }
  if (isCons(spans)) {
    output = output + " ";
    let first = true;
    for (const span of spans) {
      if (first) {
        first = false;
      } else {
        output = output + " ";
      }
      output = output + pipe(span, renderLogSpanLogfmt(nowMillis));
    }
  }
  if (pipe(annotations, size$h) > 0) {
    output = output + " ";
    let first = true;
    for (const [key, value] of annotations) {
      if (first) {
        first = false;
      } else {
        output = output + " ";
      }
      output = output + filterKeyName(key);
      output = output + "=";
      output = appendQuotedLogfmt(serializeUnknown(value), output);
    }
  }
  return output;
});

/** @internal */
const filterKeyName = key => key.replace(/[\s="]/g, "_");

/** @internal */
const escapeDoubleQuotesLogfmt = str => JSON.stringify(str);

/** @internal */
const appendQuotedLogfmt = (label, output) => output + (label.match(textOnly) ? label : escapeDoubleQuotesLogfmt(label));

/** @internal */
const renderLogSpanLogfmt = now => self => {
  const label = filterKeyName(self.label);
  return `${label}=${now - self.startTime}ms`;
};

/** @internal */
const MetricBoundariesSymbolKey = "effect/MetricBoundaries";

/** @internal */
const MetricBoundariesTypeId = /*#__PURE__*/Symbol.for(MetricBoundariesSymbolKey);

/** @internal */
class MetricBoundariesImpl {
  [MetricBoundariesTypeId] = MetricBoundariesTypeId;
  constructor(values) {
    this.values = values;
  }
  [symbol$1]() {
    return pipe(hash$1(MetricBoundariesSymbolKey), combine$a(hash$1(this.values)));
  }
  [symbol](u) {
    return isMetricBoundaries(u) && equals$1(this.values, u.values);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const isMetricBoundaries = u => {
  return typeof u === "object" && u != null && MetricBoundariesTypeId in u;
};

/** @internal */
const fromChunk$1 = chunk => {
  const values = pipe(chunk, appendAll$1(of$3(Number.POSITIVE_INFINITY)), dedupe);
  return new MetricBoundariesImpl(values);
};

/** @internal */
const linear$1 = options => pipe(makeBy$1(options.count - 1, i => options.start + i * options.width), unsafeFromArray, fromChunk$1);

/** @internal */
const exponential$1 = options => pipe(makeBy$1(options.count - 1, i => options.start * Math.pow(options.factor, i)), unsafeFromArray, fromChunk$1);

/** @internal */
const MetricKeyTypeSymbolKey = "effect/MetricKeyType";

/** @internal */
const MetricKeyTypeTypeId = /*#__PURE__*/Symbol.for(MetricKeyTypeSymbolKey);

/** @internal */
const CounterKeyTypeSymbolKey = "effect/MetricKeyType/Counter";

/** @internal */
const CounterKeyTypeTypeId = /*#__PURE__*/Symbol.for(CounterKeyTypeSymbolKey);

/** @internal */
const FrequencyKeyTypeSymbolKey = "effect/MetricKeyType/Frequency";

/** @internal */
const FrequencyKeyTypeTypeId = /*#__PURE__*/Symbol.for(FrequencyKeyTypeSymbolKey);

/** @internal */
const GaugeKeyTypeSymbolKey = "effect/MetricKeyType/Gauge";

/** @internal */
const GaugeKeyTypeTypeId = /*#__PURE__*/Symbol.for(GaugeKeyTypeSymbolKey);

/** @internal */
const HistogramKeyTypeSymbolKey = "effect/MetricKeyType/Histogram";

/** @internal */
const HistogramKeyTypeTypeId = /*#__PURE__*/Symbol.for(HistogramKeyTypeSymbolKey);

/** @internal */
const SummaryKeyTypeSymbolKey = "effect/MetricKeyType/Summary";

/** @internal */
const SummaryKeyTypeTypeId = /*#__PURE__*/Symbol.for(SummaryKeyTypeSymbolKey);

/** @internal */
const metricKeyTypeVariance = {
  _In: _ => _,
  _Out: _ => _
};

/** @internal */
class CounterKeyType {
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [CounterKeyTypeTypeId] = CounterKeyTypeTypeId;
  constructor(incremental, bigint) {
    this.incremental = incremental;
    this.bigint = bigint;
  }
  [symbol$1]() {
    return hash$1(CounterKeyTypeSymbolKey);
  }
  [symbol](that) {
    return isCounterKey(that);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class FrequencyKeyType {
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [FrequencyKeyTypeTypeId] = FrequencyKeyTypeTypeId;
  [symbol$1]() {
    return hash$1(FrequencyKeyTypeSymbolKey);
  }
  [symbol](that) {
    return isFrequencyKey(that);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class GaugeKeyType {
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [GaugeKeyTypeTypeId] = GaugeKeyTypeTypeId;
  constructor(bigint) {
    this.bigint = bigint;
  }
  [symbol$1]() {
    return hash$1(GaugeKeyTypeSymbolKey);
  }
  [symbol](that) {
    return isGaugeKey(that);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/**
 * @category model
 * @since 2.0.0
 */
class HistogramKeyType {
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [HistogramKeyTypeTypeId] = HistogramKeyTypeTypeId;
  constructor(boundaries) {
    this.boundaries = boundaries;
  }
  [symbol$1]() {
    return pipe(hash$1(HistogramKeyTypeSymbolKey), combine$a(hash$1(this.boundaries)));
  }
  [symbol](that) {
    return isHistogramKey(that) && equals$1(this.boundaries, that.boundaries);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class SummaryKeyType {
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [SummaryKeyTypeTypeId] = SummaryKeyTypeTypeId;
  constructor(maxAge, maxSize, error, quantiles) {
    this.maxAge = maxAge;
    this.maxSize = maxSize;
    this.error = error;
    this.quantiles = quantiles;
  }
  [symbol$1]() {
    return pipe(hash$1(SummaryKeyTypeSymbolKey), combine$a(hash$1(this.maxAge)), combine$a(hash$1(this.maxSize)), combine$a(hash$1(this.error)), combine$a(hash$1(this.quantiles)));
  }
  [symbol](that) {
    return isSummaryKey(that) && equals$1(this.maxAge, that.maxAge) && this.maxSize === that.maxSize && this.error === that.error && equals$1(this.quantiles, that.quantiles);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/**
 * @since 2.0.0
 * @category constructors
 */
const counter$4 = options => new CounterKeyType(options?.incremental ?? false, options?.bigint ?? false);

/**
 * @since 2.0.0
 * @category constructors
 */
const frequency$4 = /*#__PURE__*/new FrequencyKeyType();

/**
 * @since 2.0.0
 * @category constructors
 */
const gauge$4 = options => new GaugeKeyType(options?.bigint ?? false);

/**
 * @since 2.0.0
 * @category constructors
 */
const histogram$4 = boundaries => {
  return new HistogramKeyType(boundaries);
};

/**
 * @since 2.0.0
 * @category constructors
 */
const summary$4 = options => {
  return new SummaryKeyType(decode(options.maxAge), options.maxSize, options.error, options.quantiles);
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isMetricKeyType = u => {
  return typeof u === "object" && u != null && MetricKeyTypeTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isCounterKey = u => {
  return typeof u === "object" && u != null && CounterKeyTypeTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isFrequencyKey = u => {
  return typeof u === "object" && u != null && FrequencyKeyTypeTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isGaugeKey = u => {
  return typeof u === "object" && u != null && GaugeKeyTypeTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isHistogramKey = u => {
  return typeof u === "object" && u != null && HistogramKeyTypeTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isSummaryKey = u => {
  return typeof u === "object" && u != null && SummaryKeyTypeTypeId in u;
};

/** @internal */
const MetricKeySymbolKey = "effect/MetricKey";

/** @internal */
const MetricKeyTypeId = /*#__PURE__*/Symbol.for(MetricKeySymbolKey);

/** @internal */
const metricKeyVariance = {
  _Type: _ => _
};

/** @internal */
class MetricKeyImpl {
  [MetricKeyTypeId] = metricKeyVariance;
  constructor(name, keyType, description, tags = empty$s()) {
    this.name = name;
    this.keyType = keyType;
    this.description = description;
    this.tags = tags;
  }
  [symbol$1]() {
    return pipe(hash$1(this.name), combine$a(hash$1(this.keyType)), combine$a(hash$1(this.description)), combine$a(hash$1(this.tags)));
  }
  [symbol](u) {
    return isMetricKey(u) && this.name === u.name && equals$1(this.keyType, u.keyType) && equals$1(this.description, u.description) && equals$1(this.tags, u.tags);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const isMetricKey = u => typeof u === "object" && u != null && MetricKeyTypeId in u;

/** @internal */
const counter$3 = (name, options) => new MetricKeyImpl(name, counter$4(options), fromNullable$2(options?.description));

/** @internal */
const frequency$3 = (name, description) => new MetricKeyImpl(name, frequency$4, fromNullable$2(description));

/** @internal */
const gauge$3 = (name, options) => new MetricKeyImpl(name, gauge$4(options), fromNullable$2(options?.description));

/** @internal */
const histogram$3 = (name, boundaries, description) => new MetricKeyImpl(name, histogram$4(boundaries), fromNullable$2(description));

/** @internal */
const summary$3 = options => new MetricKeyImpl(options.name, summary$4(options), fromNullable$2(options.description));

/** @internal */
const tagged$2 = /*#__PURE__*/dual(3, (self, key, value) => taggedWithLabelSet(self, make$Z(make$K(key, value))));

/** @internal */
const taggedWithLabels$1 = /*#__PURE__*/dual(2, (self, extraTags) => taggedWithLabelSet(self, fromIterable$7(extraTags)));

/** @internal */
const taggedWithLabelSet = /*#__PURE__*/dual(2, (self, extraTags) => size$g(extraTags) === 0 ? self : new MetricKeyImpl(self.name, self.keyType, self.description, pipe(self.tags, union$6(extraTags))));

/** @internal */
const MetricStateSymbolKey = "effect/MetricState";

/** @internal */
const MetricStateTypeId = /*#__PURE__*/Symbol.for(MetricStateSymbolKey);

/** @internal */
const CounterStateSymbolKey = "effect/MetricState/Counter";

/** @internal */
const CounterStateTypeId = /*#__PURE__*/Symbol.for(CounterStateSymbolKey);

/** @internal */
const FrequencyStateSymbolKey = "effect/MetricState/Frequency";

/** @internal */
const FrequencyStateTypeId = /*#__PURE__*/Symbol.for(FrequencyStateSymbolKey);

/** @internal */
const GaugeStateSymbolKey = "effect/MetricState/Gauge";

/** @internal */
const GaugeStateTypeId = /*#__PURE__*/Symbol.for(GaugeStateSymbolKey);

/** @internal */
const HistogramStateSymbolKey = "effect/MetricState/Histogram";

/** @internal */
const HistogramStateTypeId = /*#__PURE__*/Symbol.for(HistogramStateSymbolKey);

/** @internal */
const SummaryStateSymbolKey = "effect/MetricState/Summary";

/** @internal */
const SummaryStateTypeId = /*#__PURE__*/Symbol.for(SummaryStateSymbolKey);

/** @internal */
const metricStateVariance = {
  _A: _ => _
};

/** @internal */
class CounterState {
  [MetricStateTypeId] = metricStateVariance;
  [CounterStateTypeId] = CounterStateTypeId;
  constructor(count) {
    this.count = count;
  }
  [symbol$1]() {
    return pipe(hash$1(CounterStateSymbolKey), combine$a(hash$1(this.count)));
  }
  [symbol](that) {
    return isCounterState(that) && this.count === that.count;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class FrequencyState {
  [MetricStateTypeId] = metricStateVariance;
  [FrequencyStateTypeId] = FrequencyStateTypeId;
  constructor(occurrences) {
    this.occurrences = occurrences;
  }
  [symbol$1]() {
    return pipe(hash$1(FrequencyStateSymbolKey), combine$a(hash$1(this.occurrences)));
  }
  [symbol](that) {
    return isFrequencyState(that) && equals$1(this.occurrences, that.occurrences);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class GaugeState {
  [MetricStateTypeId] = metricStateVariance;
  [GaugeStateTypeId] = GaugeStateTypeId;
  constructor(value) {
    this.value = value;
  }
  [symbol$1]() {
    return pipe(hash$1(GaugeStateSymbolKey), combine$a(hash$1(this.value)));
  }
  [symbol](u) {
    return isGaugeState(u) && this.value === u.value;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class HistogramState {
  [MetricStateTypeId] = metricStateVariance;
  [HistogramStateTypeId] = HistogramStateTypeId;
  constructor(buckets, count, min, max, sum) {
    this.buckets = buckets;
    this.count = count;
    this.min = min;
    this.max = max;
    this.sum = sum;
  }
  [symbol$1]() {
    return pipe(hash$1(HistogramStateSymbolKey), combine$a(hash$1(this.buckets)), combine$a(hash$1(this.count)), combine$a(hash$1(this.min)), combine$a(hash$1(this.max)), combine$a(hash$1(this.sum)));
  }
  [symbol](that) {
    return isHistogramState(that) && equals$1(this.buckets, that.buckets) && this.count === that.count && this.min === that.min && this.max === that.max && this.sum === that.sum;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class SummaryState {
  [MetricStateTypeId] = metricStateVariance;
  [SummaryStateTypeId] = SummaryStateTypeId;
  constructor(error, quantiles, count, min, max, sum) {
    this.error = error;
    this.quantiles = quantiles;
    this.count = count;
    this.min = min;
    this.max = max;
    this.sum = sum;
  }
  [symbol$1]() {
    return pipe(hash$1(SummaryStateSymbolKey), combine$a(hash$1(this.error)), combine$a(hash$1(this.quantiles)), combine$a(hash$1(this.count)), combine$a(hash$1(this.min)), combine$a(hash$1(this.max)), combine$a(hash$1(this.sum)));
  }
  [symbol](that) {
    return isSummaryState(that) && this.error === that.error && equals$1(this.quantiles, that.quantiles) && this.count === that.count && this.min === that.min && this.max === that.max && this.sum === that.sum;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const counter$2 = count => new CounterState(count);

/** @internal */
const frequency$2 = occurrences => {
  return new FrequencyState(occurrences);
};

/** @internal */
const gauge$2 = count => new GaugeState(count);

/** @internal */
const histogram$2 = options => new HistogramState(options.buckets, options.count, options.min, options.max, options.sum);

/** @internal */
const summary$2 = options => new SummaryState(options.error, options.quantiles, options.count, options.min, options.max, options.sum);

/** @internal */
const isMetricState = u => {
  return typeof u === "object" && u != null && MetricStateTypeId in u;
};

/** @internal */
const isCounterState = u => {
  return typeof u === "object" && u != null && CounterStateTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isFrequencyState = u => {
  return typeof u === "object" && u != null && FrequencyStateTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isGaugeState = u => {
  return typeof u === "object" && u != null && GaugeStateTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isHistogramState = u => {
  return typeof u === "object" && u != null && HistogramStateTypeId in u;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isSummaryState = u => {
  return typeof u === "object" && u != null && SummaryStateTypeId in u;
};

/** @internal */
const MetricHookSymbolKey = "effect/MetricHook";

/** @internal */
const MetricHookTypeId = /*#__PURE__*/Symbol.for(MetricHookSymbolKey);

/** @internal */
const metricHookVariance = {
  _In: _ => _,
  _Out: _ => _
};

/** @internal */
const make$F = options => ({
  [MetricHookTypeId]: metricHookVariance,
  pipe() {
    return pipeArguments(this, arguments);
  },
  ...options
});

/** @internal */
const onUpdate = /*#__PURE__*/dual(2, (self, f) => ({
  [MetricHookTypeId]: metricHookVariance,
  pipe() {
    return pipeArguments(this, arguments);
  },
  get: self.get,
  update: input => {
    self.update(input);
    return f(input);
  }
}));
const bigint0 = /*#__PURE__*/BigInt(0);

/** @internal */
const counter$1 = key => {
  let sum = key.keyType.bigint ? bigint0 : 0;
  const canUpdate = key.keyType.incremental ? key.keyType.bigint ? value => value >= bigint0 : value => value >= 0 : _value => true;
  return make$F({
    get: () => counter$2(sum),
    update: value => {
      if (canUpdate(value)) {
        sum = sum + value;
      }
    }
  });
};

/** @internal */
const frequency$1 = _key => {
  const values = new Map();
  const update = word => {
    const slotCount = values.get(word) ?? 0;
    values.set(word, slotCount + 1);
  };
  const snapshot = () => fromIterable$8(values.entries());
  return make$F({
    get: () => frequency$2(snapshot()),
    update
  });
};

/** @internal */
const gauge$1 = (_key, startAt) => {
  let value = startAt;
  return make$F({
    get: () => gauge$2(value),
    update: v => {
      value = v;
    }
  });
};

/** @internal */
const histogram$1 = key => {
  const bounds = key.keyType.boundaries.values;
  const size = bounds.length;
  const values = new Uint32Array(size + 1);
  const boundaries = new Float32Array(size);
  let count = 0;
  let sum = 0;
  let min = Number.MAX_VALUE;
  let max = Number.MIN_VALUE;
  pipe(bounds, sort(Order$2), map$l((n, i) => {
    boundaries[i] = n;
  }));

  // Insert the value into the right bucket with a binary search
  const update = value => {
    let from = 0;
    let to = size;
    while (from !== to) {
      const mid = Math.floor(from + (to - from) / 2);
      const boundary = boundaries[mid];
      if (value <= boundary) {
        to = mid;
      } else {
        from = mid;
      }
      // The special case when to / from have a distance of one
      if (to === from + 1) {
        if (value <= boundaries[from]) {
          to = from;
        } else {
          from = to;
        }
      }
    }
    values[from] = values[from] + 1;
    count = count + 1;
    sum = sum + value;
    if (value < min) {
      min = value;
    }
    if (value > max) {
      max = value;
    }
  };
  const getBuckets = () => {
    const builder = Array(size);
    let cumulated = 0;
    for (let i = 0; i < size; i++) {
      const boundary = boundaries[i];
      const value = values[i];
      cumulated = cumulated + value;
      builder[i] = [boundary, cumulated];
    }
    return unsafeFromArray(builder);
  };
  return make$F({
    get: () => histogram$2({
      buckets: getBuckets(),
      count,
      min,
      max,
      sum
    }),
    update
  });
};

/** @internal */
const summary$1 = key => {
  const {
    error,
    maxAge,
    maxSize,
    quantiles
  } = key.keyType;
  const sortedQuantiles = pipe(quantiles, sort(Order$2));
  const values = Array(maxSize);
  let head = 0;
  let count = 0;
  let sum = 0;
  let min = Number.MAX_VALUE;
  let max = Number.MIN_VALUE;

  // Just before the snapshot we filter out all values older than maxAge
  const snapshot = now => {
    const builder = [];
    // If the buffer is not full yet it contains valid items at the 0..last
    // indices and null values at the rest of the positions.
    //
    // If the buffer is already full then all elements contains a valid
    // measurement with timestamp.
    //
    // At any given point in time we can enumerate all the non-null elements in
    // the buffer and filter them by timestamp to get a valid view of a time
    // window.
    //
    // The order does not matter because it gets sorted before passing to
    // `calculateQuantiles`.
    let i = 0;
    while (i !== maxSize - 1) {
      const item = values[i];
      if (item != null) {
        const [t, v] = item;
        const age = millis(now - t);
        if (greaterThanOrEqualTo(age, zero) && age <= maxAge) {
          builder.push(v);
        }
      }
      i = i + 1;
    }
    return calculateQuantiles(error, sortedQuantiles, pipe(unsafeFromArray(builder), sort(Order$2)));
  };
  const observe = (value, timestamp) => {
    if (maxSize > 0) {
      head = head + 1;
      const target = head % maxSize;
      values[target] = [timestamp, value];
    }
    count = count + 1;
    sum = sum + value;
    if (value < min) {
      min = value;
    }
    if (value > max) {
      max = value;
    }
  };
  return make$F({
    get: () => summary$2({
      error,
      quantiles: snapshot(Date.now()),
      count,
      min,
      max,
      sum
    }),
    update: ([value, timestamp]) => observe(value, timestamp)
  });
};

/** @internal */

/** @internal */
const calculateQuantiles = (error, sortedQuantiles, sortedSamples) => {
  // The number of samples examined
  const sampleCount = sortedSamples.length;
  if (isEmpty$h(sortedQuantiles)) {
    return empty$z();
  }
  const head = unsafeHead$1(sortedQuantiles);
  const tail = pipe(sortedQuantiles, drop$2(1));
  const resolved = pipe(tail, reduce$i(of$3(resolveQuantile(error, sampleCount, none$8(), 0, head, sortedSamples)), (accumulator, quantile) => {
    const h = unsafeHead$1(accumulator);
    return pipe(accumulator, append$1(resolveQuantile(error, sampleCount, h.value, h.consumed, quantile, h.rest)));
  }));
  return pipe(resolved, map$l(rq => [rq.quantile, rq.value]));
};

/** @internal */
const resolveQuantile = (error, sampleCount, current, consumed, quantile, rest) => {
  let error_1 = error;
  let sampleCount_1 = sampleCount;
  let current_1 = current;
  let consumed_1 = consumed;
  let quantile_1 = quantile;
  let rest_1 = rest;
  let error_2 = error;
  let sampleCount_2 = sampleCount;
  let current_2 = current;
  let consumed_2 = consumed;
  let quantile_2 = quantile;
  let rest_2 = rest;
  // eslint-disable-next-line no-constant-condition
  while (1) {
    // If the remaining list of samples is empty, there is nothing more to resolve
    if (isEmpty$h(rest_1)) {
      return {
        quantile: quantile_1,
        value: none$8(),
        consumed: consumed_1,
        rest: empty$z()
      };
    }
    // If the quantile is the 100% quantile, we can take the maximum of all the
    // remaining values as the result
    if (quantile_1 === 1) {
      return {
        quantile: quantile_1,
        value: some$6(unsafeLast(rest_1)),
        consumed: consumed_1 + rest_1.length,
        rest: empty$z()
      };
    }
    // Split into two chunks - the first chunk contains all elements of the same
    // value as the chunk head
    const sameHead = pipe(rest_1, splitWhere$1(n => n > unsafeHead$1(rest_1)));
    // How many elements do we want to accept for this quantile
    const desired = quantile_1 * sampleCount_1;
    // The error margin
    const allowedError = error_1 / 2 * desired;
    // Taking into account the elements consumed from the samples so far and the
    // number of same elements at the beginning of the chunk, calculate the number
    // of elements we would have if we selected the current head as result
    const candConsumed = consumed_1 + sameHead[0].length;
    const candError = Math.abs(candConsumed - desired);
    // If we haven't got enough elements yet, recurse
    if (candConsumed < desired - allowedError) {
      error_2 = error_1;
      sampleCount_2 = sampleCount_1;
      current_2 = head$4(rest_1);
      consumed_2 = candConsumed;
      quantile_2 = quantile_1;
      rest_2 = sameHead[1];
      error_1 = error_2;
      sampleCount_1 = sampleCount_2;
      current_1 = current_2;
      consumed_1 = consumed_2;
      quantile_1 = quantile_2;
      rest_1 = rest_2;
      continue;
    }
    // If we have too many elements, select the previous value and hand back the
    // the rest as leftover
    if (candConsumed > desired + allowedError) {
      return {
        quantile: quantile_1,
        value: current_1,
        consumed: consumed_1,
        rest: rest_1
      };
    }
    // If we are in the target interval, select the current head and hand back the leftover after dropping all elements
    // from the sample chunk that are equal to the current head
    switch (current_1._tag) {
      case "None":
        {
          error_2 = error_1;
          sampleCount_2 = sampleCount_1;
          current_2 = head$4(rest_1);
          consumed_2 = candConsumed;
          quantile_2 = quantile_1;
          rest_2 = sameHead[1];
          error_1 = error_2;
          sampleCount_1 = sampleCount_2;
          current_1 = current_2;
          consumed_1 = consumed_2;
          quantile_1 = quantile_2;
          rest_1 = rest_2;
          continue;
        }
      case "Some":
        {
          const prevError = Math.abs(desired - current_1.value);
          if (candError < prevError) {
            error_2 = error_1;
            sampleCount_2 = sampleCount_1;
            current_2 = head$4(rest_1);
            consumed_2 = candConsumed;
            quantile_2 = quantile_1;
            rest_2 = sameHead[1];
            error_1 = error_2;
            sampleCount_1 = sampleCount_2;
            current_1 = current_2;
            consumed_1 = consumed_2;
            quantile_1 = quantile_2;
            rest_1 = rest_2;
            continue;
          }
          return {
            quantile: quantile_1,
            value: some$6(current_1.value),
            consumed: consumed_1,
            rest: rest_1
          };
        }
    }
  }
  throw new Error("BUG: MetricHook.resolveQuantiles - please report an issue at https://github.com/Effect-TS/io/issues");
};

/** @internal */
const MetricPairSymbolKey = "effect/MetricPair";

/** @internal */
const MetricPairTypeId = /*#__PURE__*/Symbol.for(MetricPairSymbolKey);

/** @internal */
const metricPairVariance = {
  _Type: _ => _
};

/** @internal */
const make$E = (metricKey, metricState) => {
  return {
    [MetricPairTypeId]: metricPairVariance,
    metricKey,
    metricState,
    pipe() {
      return pipeArguments(this, arguments);
    }
  };
};

/** @internal */
const unsafeMake$1 = (metricKey, metricState) => {
  return {
    [MetricPairTypeId]: metricPairVariance,
    metricKey,
    metricState,
    pipe() {
      return pipeArguments(this, arguments);
    }
  };
};

/** @internal */
const MetricRegistrySymbolKey = "effect/MetricRegistry";

/** @internal */
const MetricRegistryTypeId = /*#__PURE__*/Symbol.for(MetricRegistrySymbolKey);

/** @internal */
class MetricRegistryImpl {
  [MetricRegistryTypeId] = MetricRegistryTypeId;
  map = empty$k();
  snapshot() {
    const result = [];
    for (const [key, hook] of this.map) {
      result.push(unsafeMake$1(key, hook.get()));
    }
    return fromIterable$7(result);
  }
  get(key) {
    const hook = pipe(this.map, get$e(key), getOrUndefined);
    if (hook == null) {
      if (isCounterKey(key.keyType)) {
        return this.getCounter(key);
      }
      if (isGaugeKey(key.keyType)) {
        return this.getGauge(key);
      }
      if (isFrequencyKey(key.keyType)) {
        return this.getFrequency(key);
      }
      if (isHistogramKey(key.keyType)) {
        return this.getHistogram(key);
      }
      if (isSummaryKey(key.keyType)) {
        return this.getSummary(key);
      }
      throw new Error("BUG: MetricRegistry.get - unknown MetricKeyType - please report an issue at https://github.com/Effect-TS/io/issues");
    } else {
      return hook;
    }
  }
  getCounter(key) {
    let value = pipe(this.map, get$e(key), getOrUndefined);
    if (value == null) {
      const counter$1$1 = counter$1(key);
      if (!pipe(this.map, has$4(key))) {
        pipe(this.map, set$9(key, counter$1$1));
      }
      value = counter$1$1;
    }
    return value;
  }
  getFrequency(key) {
    let value = pipe(this.map, get$e(key), getOrUndefined);
    if (value == null) {
      const frequency$1$1 = frequency$1();
      if (!pipe(this.map, has$4(key))) {
        pipe(this.map, set$9(key, frequency$1$1));
      }
      value = frequency$1$1;
    }
    return value;
  }
  getGauge(key) {
    let value = pipe(this.map, get$e(key), getOrUndefined);
    if (value == null) {
      const gauge$1$1 = gauge$1(key, key.keyType.bigint ? BigInt(0) : 0);
      if (!pipe(this.map, has$4(key))) {
        pipe(this.map, set$9(key, gauge$1$1));
      }
      value = gauge$1$1;
    }
    return value;
  }
  getHistogram(key) {
    let value = pipe(this.map, get$e(key), getOrUndefined);
    if (value == null) {
      const histogram$1$1 = histogram$1(key);
      if (!pipe(this.map, has$4(key))) {
        pipe(this.map, set$9(key, histogram$1$1));
      }
      value = histogram$1$1;
    }
    return value;
  }
  getSummary(key) {
    let value = pipe(this.map, get$e(key), getOrUndefined);
    if (value == null) {
      const summary$1$1 = summary$1(key);
      if (!pipe(this.map, has$4(key))) {
        pipe(this.map, set$9(key, summary$1$1));
      }
      value = summary$1$1;
    }
    return value;
  }
}

/** @internal */
const make$D = () => {
  return new MetricRegistryImpl();
};

/** @internal */
const MetricSymbolKey = "effect/Metric";

/** @internal */
const MetricTypeId = /*#__PURE__*/Symbol.for(MetricSymbolKey);

/** @internal */
const metricVariance = {
  _Type: _ => _,
  _In: _ => _,
  _Out: _ => _
};

/** @internal */
const globalMetricRegistry = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/Metric/globalMetricRegistry"), () => make$D());

/** @internal */
const make$C = function (keyType, unsafeUpdate, unsafeValue) {
  const metric = Object.assign(effect => tap$5(effect, a => sync$a(() => unsafeUpdate(a, empty$s()))), {
    [MetricTypeId]: metricVariance,
    keyType,
    unsafeUpdate,
    unsafeValue,
    pipe() {
      return pipeArguments(this, arguments);
    }
  });
  return metric;
};

/** @internal */
const mapInput$3 = /*#__PURE__*/dual(2, (self, f) => make$C(self.keyType, (input, extraTags) => self.unsafeUpdate(f(input), extraTags), self.unsafeValue));

/** @internal */
const counter = (name, options) => fromMetricKey(counter$3(name, options));

/** @internal */
const frequency = (name, description) => fromMetricKey(frequency$3(name, description));

/** @internal */
const withConstantInput = /*#__PURE__*/dual(2, (self, input) => mapInput$3(self, () => input));

/** @internal */
const fromMetricKey = key => {
  const hook = extraTags => {
    const fullKey = pipe(key, taggedWithLabelSet(extraTags));
    return globalMetricRegistry.get(fullKey);
  };
  return make$C(key.keyType, (input, extraTags) => hook(extraTags).update(input), extraTags => hook(extraTags).get());
};

/** @internal */
const gauge = (name, options) => fromMetricKey(gauge$3(name, options));

/** @internal */
const histogram = (name, boundaries, description) => fromMetricKey(histogram$3(name, boundaries, description));

/* @internal */
const increment = self => update$3(self, self.keyType.bigint ? BigInt(1) : 1);

/* @internal */
const incrementBy = /*#__PURE__*/dual(2, (self, amount) => update$3(self, amount));

/** @internal */
const map$a = /*#__PURE__*/dual(2, (self, f) => make$C(self.keyType, self.unsafeUpdate, extraTags => f(self.unsafeValue(extraTags))));

/** @internal */
const mapType = /*#__PURE__*/dual(2, (self, f) => make$C(f(self.keyType), self.unsafeUpdate, self.unsafeValue));

/* @internal */
const set$5 = /*#__PURE__*/dual(2, (self, value) => update$3(self, value));

/** @internal */
const succeed$b = out => make$C(void 0, constVoid, () => out);

/** @internal */
const sync$7 = evaluate => make$C(void 0, constVoid, evaluate);

/** @internal */
const summary = options => withNow(summaryTimestamp(options));

/** @internal */
const summaryTimestamp = options => fromMetricKey(summary$3(options));

/** @internal */
const tagged$1 = /*#__PURE__*/dual(3, (self, key, value) => taggedWithLabels(self, make$Z(make$K(key, value))));

/** @internal */
const taggedWithLabelsInput = /*#__PURE__*/dual(2, (self, f) => map$a(make$C(self.keyType, (input, extraTags) => self.unsafeUpdate(input, union$6(fromIterable$7(f(input)), extraTags)), self.unsafeValue), constVoid));

/** @internal */
const taggedWithLabels = /*#__PURE__*/dual(2, (self, extraTagsIterable) => {
  const extraTags = isHashSet(extraTagsIterable) ? extraTagsIterable : fromIterable$7(extraTagsIterable);
  return make$C(self.keyType, (input, extraTags1) => self.unsafeUpdate(input, pipe(extraTags, union$6(extraTags1))), extraTags1 => self.unsafeValue(pipe(extraTags, union$6(extraTags1))));
});

/** @internal */
const timer = name => {
  const boundaries = exponential$1({
    start: 1,
    factor: 2,
    count: 100
  });
  const base = pipe(histogram(name, boundaries), tagged$1("time_unit", "milliseconds"));
  return mapInput$3(base, toMillis);
};

/** @internal */
const timerWithBoundaries = (name, boundaries) => {
  const base = pipe(histogram(name, fromChunk$1(boundaries)), tagged$1("time_unit", "milliseconds"));
  return mapInput$3(base, toMillis);
};

/* @internal */
const trackAll = /*#__PURE__*/dual(2, (self, input) => effect => matchCauseEffect$1(effect, {
  onFailure: cause => {
    self.unsafeUpdate(input, empty$s());
    return failCause$a(cause);
  },
  onSuccess: value => {
    self.unsafeUpdate(input, empty$s());
    return succeed$h(value);
  }
}));

/* @internal */
const trackDefect = /*#__PURE__*/dual(2, (self, metric) => trackDefectWith(self, metric, identity$1));

/* @internal */
const trackDefectWith = /*#__PURE__*/dual(3, (self, metric, f) => {
  const updater = defect => metric.unsafeUpdate(f(defect), empty$s());
  return tapDefect$1(self, cause => sync$a(() => pipe(defects(cause), forEach$c(updater))));
});

/* @internal */
const trackDuration = /*#__PURE__*/dual(2, (self, metric) => trackDurationWith(self, metric, identity$1));

/* @internal */
const trackDurationWith = /*#__PURE__*/dual(3, (self, metric, f) => clockWith$2(clock => {
  const startTime = clock.unsafeCurrentTimeNanos();
  return map$f(self, a => {
    const endTime = clock.unsafeCurrentTimeNanos();
    const duration = nanos(endTime - startTime);
    metric.unsafeUpdate(f(duration), empty$s());
    return a;
  });
}));

/* @internal */
const trackError = /*#__PURE__*/dual(2, (self, metric) => trackErrorWith(self, metric, a => a));

/* @internal */
const trackErrorWith = /*#__PURE__*/dual(3, (self, metric, f) => {
  const updater = error => update$3(metric, f(error));
  return tapError$4(self, updater);
});

/* @internal */
const trackSuccess = /*#__PURE__*/dual(2, (self, metric) => trackSuccessWith(self, metric, a => a));

/* @internal */
const trackSuccessWith = /*#__PURE__*/dual(3, (self, metric, f) => {
  const updater = value => update$3(metric, f(value));
  return tap$5(self, updater);
});

/* @internal */
const update$3 = /*#__PURE__*/dual(2, (self, input) => fiberRefGetWith(currentMetricLabels, tags => sync$a(() => self.unsafeUpdate(input, tags))));

/* @internal */
const value$1 = self => fiberRefGetWith(currentMetricLabels, tags => sync$a(() => self.unsafeValue(tags)));

/** @internal */
const withNow = self => mapInput$3(self, input => [input, Date.now()]);

/** @internal */
const zip$6 = /*#__PURE__*/dual(2, (self, that) => make$C([self.keyType, that.keyType], (input, extraTags) => {
  const [l, r] = input;
  self.unsafeUpdate(l, extraTags);
  that.unsafeUpdate(r, extraTags);
}, extraTags => [self.unsafeValue(extraTags), that.unsafeValue(extraTags)]));

/** @internal */
const unsafeSnapshot = () => globalMetricRegistry.snapshot();

/** @internal */
const snapshot = /*#__PURE__*/sync$a(unsafeSnapshot);

/** @internal */
const RequestSymbolKey = "effect/Request";

/** @internal */
const RequestTypeId = /*#__PURE__*/Symbol.for(RequestSymbolKey);

/** @internal */
const requestVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */
const isRequest = u => typeof u === "object" && u != null && RequestTypeId in u;

/** @internal */
const of$1 = () => args =>
// @ts-expect-error
struct$2({
  [RequestTypeId]: requestVariance,
  ...args
});

/** @internal */
const tagged = tag => args =>
// @ts-expect-error
struct$2({
  [RequestTypeId]: requestVariance,
  _tag: tag,
  ...args
});

/** @internal */
const complete$2 = /*#__PURE__*/dual(2, (self, result) => fiberRefGetWith(currentRequestMap, map => sync$a(() => {
  if (map.has(self)) {
    const entry = map.get(self);
    if (!entry.state.completed) {
      entry.state.completed = true;
      deferredUnsafeDone(entry.result, result);
    }
  }
})));

/** @internal */
const completeEffect = /*#__PURE__*/dual(2, (self, effect) => matchEffect$3(effect, {
  onFailure: error => complete$2(self, exitFail(error)),
  onSuccess: value => complete$2(self, exitSucceed(value))
}));

/** @internal */
const fail$a = /*#__PURE__*/dual(2, (self, error) => complete$2(self, exitFail(error)));

/** @internal */
const succeed$a = /*#__PURE__*/dual(2, (self, value) => complete$2(self, exitSucceed(value)));

/** @internal */
class Listeners {
  count = 0;
  observers = new Set();
  addObserver(f) {
    this.observers.add(f);
  }
  removeObserver(f) {
    this.observers.delete(f);
  }
  increment() {
    this.count++;
    this.observers.forEach(f => f(this.count));
  }
  decrement() {
    this.count--;
    this.observers.forEach(f => f(this.count));
  }
}

/** @internal */
const Direction = {
  Forward: 0,
  Backward: 1 << 0
};

/** @internal */
class RedBlackTreeIterator {
  count = 0;
  constructor(self, stack, direction) {
    this.self = self;
    this.stack = stack;
    this.direction = direction;
  }

  /**
   * Clones the iterator
   */
  clone() {
    return new RedBlackTreeIterator(this.self, this.stack.slice(), this.direction);
  }

  /**
   * Reverse the traversal direction
   */
  reversed() {
    return new RedBlackTreeIterator(this.self, this.stack.slice(), this.direction === Direction.Forward ? Direction.Backward : Direction.Forward);
  }

  /**
   * Iterator next
   */
  next() {
    const entry = this.entry;
    this.count++;
    if (this.direction === Direction.Forward) {
      this.moveNext();
    } else {
      this.movePrev();
    }
    switch (entry._tag) {
      case "None":
        {
          return {
            done: true,
            value: this.count
          };
        }
      case "Some":
        {
          return {
            done: false,
            value: entry.value
          };
        }
    }
  }

  /**
   * Returns the key
   */
  get key() {
    if (this.stack.length > 0) {
      return some$6(this.stack[this.stack.length - 1].key);
    }
    return none$8();
  }

  /**
   * Returns the value
   */
  get value() {
    if (this.stack.length > 0) {
      return some$6(this.stack[this.stack.length - 1].value);
    }
    return none$8();
  }

  /**
   * Returns the key
   */
  get entry() {
    if (this.stack.length > 0) {
      return some$6([this.stack[this.stack.length - 1].key, this.stack[this.stack.length - 1].value]);
    }
    return none$8();
  }

  /**
   * Returns the position of this iterator in the sorted list
   */
  get index() {
    let idx = 0;
    const stack = this.stack;
    if (stack.length === 0) {
      const r = this.self._root;
      if (r != null) {
        return r.count;
      }
      return 0;
    } else if (stack[stack.length - 1].left != null) {
      idx = stack[stack.length - 1].left.count;
    }
    for (let s = stack.length - 2; s >= 0; --s) {
      if (stack[s + 1] === stack[s].right) {
        ++idx;
        if (stack[s].left != null) {
          idx += stack[s].left.count;
        }
      }
    }
    return idx;
  }

  /**
   * Advances iterator to next element in list
   */
  moveNext() {
    const stack = this.stack;
    if (stack.length === 0) {
      return;
    }
    let n = stack[stack.length - 1];
    if (n.right != null) {
      n = n.right;
      while (n != null) {
        stack.push(n);
        n = n.left;
      }
    } else {
      stack.pop();
      while (stack.length > 0 && stack[stack.length - 1].right === n) {
        n = stack[stack.length - 1];
        stack.pop();
      }
    }
  }

  /**
   * Checks if there is a next element
   */
  get hasNext() {
    const stack = this.stack;
    if (stack.length === 0) {
      return false;
    }
    if (stack[stack.length - 1].right != null) {
      return true;
    }
    for (let s = stack.length - 1; s > 0; --s) {
      if (stack[s - 1].left === stack[s]) {
        return true;
      }
    }
    return false;
  }

  /**
   * Advances iterator to previous element in list
   */
  movePrev() {
    const stack = this.stack;
    if (stack.length === 0) {
      return;
    }
    let n = stack[stack.length - 1];
    if (n != null && n.left != null) {
      n = n.left;
      while (n != null) {
        stack.push(n);
        n = n.right;
      }
    } else {
      stack.pop();
      while (stack.length > 0 && stack[stack.length - 1].left === n) {
        n = stack[stack.length - 1];
        stack.pop();
      }
    }
  }

  /**
   * Checks if there is a previous element
   */
  get hasPrev() {
    const stack = this.stack;
    if (stack.length === 0) {
      return false;
    }
    if (stack[stack.length - 1].left != null) {
      return true;
    }
    for (let s = stack.length - 1; s > 0; --s) {
      if (stack[s - 1].right === stack[s]) {
        return true;
      }
    }
    return false;
  }
}

/** @internal */
const Color = {
  Red: 0,
  Black: 1 << 0
};
/** @internal */
class Node$1 {
  constructor(color, key, value, left, right, count) {
    this.color = color;
    this.key = key;
    this.value = value;
    this.left = left;
    this.right = right;
    this.count = count;
  }
}

/** @internal */
function clone(node) {
  return new Node$1(node.color, node.key, node.value, node.left, node.right, node.count);
}

/** @internal */
function swap(n, v) {
  n.key = v.key;
  n.value = v.value;
  n.left = v.left;
  n.right = v.right;
  n.color = v.color;
  n.count = v.count;
}

/** @internal */
function repaint(node, color) {
  return new Node$1(color, node.key, node.value, node.left, node.right, node.count);
}

/** @internal */
function recount(node) {
  node.count = 1 + (node.left?.count ?? 0) + (node.right?.count ?? 0);
}

const RedBlackTreeSymbolKey = "effect/RedBlackTree";

/** @internal */
const RedBlackTreeTypeId = /*#__PURE__*/Symbol.for(RedBlackTreeSymbolKey);

/** @internal */

const RedBlackTreeProto = {
  [RedBlackTreeTypeId]: RedBlackTreeTypeId,
  [symbol$1]() {
    return combine$a(hash$1(RedBlackTreeSymbolKey))(array$1(Array.from(this)));
  },
  [symbol](that) {
    if (isRedBlackTree(that)) {
      if ((this._root?.count ?? 0) !== (that._root?.count ?? 0)) {
        return false;
      }
      return equals$1(Array.from(this), Array.from(that));
    }
    return false;
  },
  [Symbol.iterator]() {
    const stack = [];
    let n = this._root;
    while (n != null) {
      stack.push(n);
      n = n.left;
    }
    return new RedBlackTreeIterator(this, stack, Direction.Forward);
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "RedBlackTree",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const makeImpl$2 = (ord, root) => {
  const tree = Object.create(RedBlackTreeProto);
  tree._ord = ord;
  tree._root = root;
  return tree;
};

/** @internal */
const isRedBlackTree = u => isObject(u) && RedBlackTreeTypeId in u;

/** @internal */
const empty$e = ord => makeImpl$2(ord, undefined);

/** @internal */
const fromIterable$6 = ord => entries => {
  let tree = empty$e(ord);
  for (const [key, value] of entries) {
    tree = insert$1(tree, key, value);
  }
  return tree;
};

/** @internal */
const make$B = ord => (...entries) => {
  return fromIterable$6(ord)(entries);
};

/** @internal */
const atBackwards = /*#__PURE__*/dual(2, (self, index) => at(self, index, Direction.Backward));

/** @internal */
const atForwards = /*#__PURE__*/dual(2, (self, index) => at(self, index, Direction.Forward));
const at = (self, index, direction) => {
  return {
    [Symbol.iterator]: () => {
      if (index < 0) {
        return new RedBlackTreeIterator(self, [], direction);
      }
      let node = self._root;
      const stack = [];
      while (node !== undefined) {
        stack.push(node);
        if (node.left !== undefined) {
          if (index < node.left.count) {
            node = node.left;
            continue;
          }
          index -= node.left.count;
        }
        if (!index) {
          return new RedBlackTreeIterator(self, stack, direction);
        }
        index -= 1;
        if (node.right !== undefined) {
          if (index >= node.right.count) {
            break;
          }
          node = node.right;
        } else {
          break;
        }
      }
      return new RedBlackTreeIterator(self, [], direction);
    }
  };
};

/** @internal */
const findAll$1 = /*#__PURE__*/dual(2, (self, key) => {
  const stack = [];
  let node = self._root;
  let result = empty$z();
  while (node !== undefined || stack.length > 0) {
    if (node) {
      stack.push(node);
      node = node.left;
    } else {
      const current = stack.pop();
      if (equals$1(key, current.key)) {
        result = prepend$2(current.value)(result);
      }
      node = current.right;
    }
  }
  return result;
});

/** @internal */
const findFirst$3 = /*#__PURE__*/dual(2, (self, key) => {
  const cmp = self._ord;
  let node = self._root;
  while (node !== undefined) {
    const d = cmp(key, node.key);
    if (equals$1(key, node.key)) {
      return some$6(node.value);
    }
    if (d <= 0) {
      node = node.left;
    } else {
      node = node.right;
    }
  }
  return none$8();
});

/** @internal */
const first$2 = self => {
  let node = self._root;
  let current = self._root;
  while (node !== undefined) {
    current = node;
    node = node.left;
  }
  return current ? some$6([current.key, current.value]) : none$8();
};

/** @internal */
const getAt = /*#__PURE__*/dual(2, (self, index) => {
  if (index < 0) {
    return none$8();
  }
  let root = self._root;
  let node = undefined;
  while (root !== undefined) {
    node = root;
    if (root.left) {
      if (index < root.left.count) {
        root = root.left;
        continue;
      }
      index -= root.left.count;
    }
    if (!index) {
      return some$6([node.key, node.value]);
    }
    index -= 1;
    if (root.right) {
      if (index >= root.right.count) {
        break;
      }
      root = root.right;
    } else {
      break;
    }
  }
  return none$8();
});

/** @internal */
const getOrder$2 = tree => tree._ord;

/** @internal */
const has$3 = /*#__PURE__*/dual(2, (self, key) => isSome(findFirst$3(self, key)));

/** @internal */
const insert$1 = /*#__PURE__*/dual(3, (self, key, value) => {
  const cmp = self._ord;
  // Find point to insert new node at
  let n = self._root;
  const n_stack = [];
  const d_stack = [];
  while (n != null) {
    const d = cmp(key, n.key);
    n_stack.push(n);
    d_stack.push(d);
    if (d <= 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  // Rebuild path to leaf node
  n_stack.push(new Node$1(Color.Red, key, value, undefined, undefined, 1));
  for (let s = n_stack.length - 2; s >= 0; --s) {
    const n2 = n_stack[s];
    if (d_stack[s] <= 0) {
      n_stack[s] = new Node$1(n2.color, n2.key, n2.value, n_stack[s + 1], n2.right, n2.count + 1);
    } else {
      n_stack[s] = new Node$1(n2.color, n2.key, n2.value, n2.left, n_stack[s + 1], n2.count + 1);
    }
  }
  // Rebalance tree using rotations
  for (let s = n_stack.length - 1; s > 1; --s) {
    const p = n_stack[s - 1];
    const n3 = n_stack[s];
    if (p.color === Color.Black || n3.color === Color.Black) {
      break;
    }
    const pp = n_stack[s - 2];
    if (pp.left === p) {
      if (p.left === n3) {
        const y = pp.right;
        if (y && y.color === Color.Red) {
          p.color = Color.Black;
          pp.right = repaint(y, Color.Black);
          pp.color = Color.Red;
          s -= 1;
        } else {
          pp.color = Color.Red;
          pp.left = p.right;
          p.color = Color.Black;
          p.right = pp;
          n_stack[s - 2] = p;
          n_stack[s - 1] = n3;
          recount(pp);
          recount(p);
          if (s >= 3) {
            const ppp = n_stack[s - 3];
            if (ppp.left === pp) {
              ppp.left = p;
            } else {
              ppp.right = p;
            }
          }
          break;
        }
      } else {
        const y = pp.right;
        if (y && y.color === Color.Red) {
          p.color = Color.Black;
          pp.right = repaint(y, Color.Black);
          pp.color = Color.Red;
          s -= 1;
        } else {
          p.right = n3.left;
          pp.color = Color.Red;
          pp.left = n3.right;
          n3.color = Color.Black;
          n3.left = p;
          n3.right = pp;
          n_stack[s - 2] = n3;
          n_stack[s - 1] = p;
          recount(pp);
          recount(p);
          recount(n3);
          if (s >= 3) {
            const ppp = n_stack[s - 3];
            if (ppp.left === pp) {
              ppp.left = n3;
            } else {
              ppp.right = n3;
            }
          }
          break;
        }
      }
    } else {
      if (p.right === n3) {
        const y = pp.left;
        if (y && y.color === Color.Red) {
          p.color = Color.Black;
          pp.left = repaint(y, Color.Black);
          pp.color = Color.Red;
          s -= 1;
        } else {
          pp.color = Color.Red;
          pp.right = p.left;
          p.color = Color.Black;
          p.left = pp;
          n_stack[s - 2] = p;
          n_stack[s - 1] = n3;
          recount(pp);
          recount(p);
          if (s >= 3) {
            const ppp = n_stack[s - 3];
            if (ppp.right === pp) {
              ppp.right = p;
            } else {
              ppp.left = p;
            }
          }
          break;
        }
      } else {
        const y = pp.left;
        if (y && y.color === Color.Red) {
          p.color = Color.Black;
          pp.left = repaint(y, Color.Black);
          pp.color = Color.Red;
          s -= 1;
        } else {
          p.left = n3.right;
          pp.color = Color.Red;
          pp.right = n3.left;
          n3.color = Color.Black;
          n3.right = p;
          n3.left = pp;
          n_stack[s - 2] = n3;
          n_stack[s - 1] = p;
          recount(pp);
          recount(p);
          recount(n3);
          if (s >= 3) {
            const ppp = n_stack[s - 3];
            if (ppp.right === pp) {
              ppp.right = n3;
            } else {
              ppp.left = n3;
            }
          }
          break;
        }
      }
    }
  }
  // Return new tree
  n_stack[0].color = Color.Black;
  return makeImpl$2(self._ord, n_stack[0]);
});

/** @internal */
const keysForward = self => keys$2(self, Direction.Forward);

/** @internal */
const keysBackward = self => keys$2(self, Direction.Backward);
const keys$2 = (self, direction) => {
  const begin = self[Symbol.iterator]();
  let count = 0;
  return {
    [Symbol.iterator]: () => keys$2(self, direction),
    next: () => {
      count++;
      const entry = begin.key;
      if (direction === Direction.Forward) {
        begin.moveNext();
      } else {
        begin.movePrev();
      }
      switch (entry._tag) {
        case "None":
          {
            return {
              done: true,
              value: count
            };
          }
        case "Some":
          {
            return {
              done: false,
              value: entry.value
            };
          }
      }
    }
  };
};

/** @internal */
const last$1 = self => {
  let node = self._root;
  let current = self._root;
  while (node !== undefined) {
    current = node;
    node = node.right;
  }
  return current ? some$6([current.key, current.value]) : none$8();
};

/** @internal */
const reversed = self => {
  return {
    [Symbol.iterator]: () => {
      const stack = [];
      let node = self._root;
      while (node !== undefined) {
        stack.push(node);
        node = node.right;
      }
      return new RedBlackTreeIterator(self, stack, Direction.Backward);
    }
  };
};

/** @internal */
const greaterThanBackwards = /*#__PURE__*/dual(2, (self, key) => greaterThan(self, key, Direction.Backward));

/** @internal */
const greaterThanForwards = /*#__PURE__*/dual(2, (self, key) => greaterThan(self, key, Direction.Forward));
const greaterThan = (self, key, direction) => {
  return {
    [Symbol.iterator]: () => {
      const cmp = self._ord;
      let node = self._root;
      const stack = [];
      let last_ptr = 0;
      while (node !== undefined) {
        const d = cmp(key, node.key);
        stack.push(node);
        if (d < 0) {
          last_ptr = stack.length;
        }
        if (d < 0) {
          node = node.left;
        } else {
          node = node.right;
        }
      }
      stack.length = last_ptr;
      return new RedBlackTreeIterator(self, stack, direction);
    }
  };
};

/** @internal */
const greaterThanEqualBackwards = /*#__PURE__*/dual(2, (self, key) => greaterThanEqual(self, key, Direction.Backward));

/** @internal */
const greaterThanEqualForwards = /*#__PURE__*/dual(2, (self, key) => greaterThanEqual(self, key, Direction.Forward));
const greaterThanEqual = (self, key, direction = Direction.Forward) => {
  return {
    [Symbol.iterator]: () => {
      const cmp = self._ord;
      let node = self._root;
      const stack = [];
      let last_ptr = 0;
      while (node !== undefined) {
        const d = cmp(key, node.key);
        stack.push(node);
        if (d <= 0) {
          last_ptr = stack.length;
        }
        if (d <= 0) {
          node = node.left;
        } else {
          node = node.right;
        }
      }
      stack.length = last_ptr;
      return new RedBlackTreeIterator(self, stack, direction);
    }
  };
};

/** @internal */
const lessThanBackwards = /*#__PURE__*/dual(2, (self, key) => lessThan$4(self, key, Direction.Backward));

/** @internal */
const lessThanForwards = /*#__PURE__*/dual(2, (self, key) => lessThan$4(self, key, Direction.Forward));
const lessThan$4 = (self, key, direction) => {
  return {
    [Symbol.iterator]: () => {
      const cmp = self._ord;
      let node = self._root;
      const stack = [];
      let last_ptr = 0;
      while (node !== undefined) {
        const d = cmp(key, node.key);
        stack.push(node);
        if (d > 0) {
          last_ptr = stack.length;
        }
        if (d <= 0) {
          node = node.left;
        } else {
          node = node.right;
        }
      }
      stack.length = last_ptr;
      return new RedBlackTreeIterator(self, stack, direction);
    }
  };
};

/** @internal */
const lessThanEqualBackwards = /*#__PURE__*/dual(2, (self, key) => lessThanEqual(self, key, Direction.Backward));

/** @internal */
const lessThanEqualForwards = /*#__PURE__*/dual(2, (self, key) => lessThanEqual(self, key, Direction.Forward));
const lessThanEqual = (self, key, direction) => {
  return {
    [Symbol.iterator]: () => {
      const cmp = self._ord;
      let node = self._root;
      const stack = [];
      let last_ptr = 0;
      while (node !== undefined) {
        const d = cmp(key, node.key);
        stack.push(node);
        if (d >= 0) {
          last_ptr = stack.length;
        }
        if (d < 0) {
          node = node.left;
        } else {
          node = node.right;
        }
      }
      stack.length = last_ptr;
      return new RedBlackTreeIterator(self, stack, direction);
    }
  };
};

/** @internal */
const forEach$7 = /*#__PURE__*/dual(2, (self, f) => {
  const root = self._root;
  if (root !== undefined) {
    visitFull(root, (key, value) => {
      f(key, value);
      return none$8();
    });
  }
});

/** @internal */
const forEachGreaterThanEqual = /*#__PURE__*/dual(3, (self, min, f) => {
  const root = self._root;
  const ord = self._ord;
  if (root !== undefined) {
    visitGreaterThanEqual(root, min, ord, (key, value) => {
      f(key, value);
      return none$8();
    });
  }
});

/** @internal */
const forEachLessThan = /*#__PURE__*/dual(3, (self, max, f) => {
  const root = self._root;
  const ord = self._ord;
  if (root !== undefined) {
    visitLessThan(root, max, ord, (key, value) => {
      f(key, value);
      return none$8();
    });
  }
});

/** @internal */
const forEachBetween = /*#__PURE__*/dual(2, (self, {
  body,
  max,
  min
}) => {
  const root = self._root;
  const ord = self._ord;
  if (root) {
    visitBetween(root, min, max, ord, (key, value) => {
      body(key, value);
      return none$8();
    });
  }
});

/** @internal */
const reduce$8 = /*#__PURE__*/dual(3, (self, zero, f) => {
  let accumulator = zero;
  for (const entry of self) {
    accumulator = f(accumulator, entry[1], entry[0]);
  }
  return accumulator;
});

/** @internal */
const removeFirst$1 = /*#__PURE__*/dual(2, (self, key) => {
  if (!has$3(self, key)) {
    return self;
  }
  const ord = self._ord;
  const cmp = ord;
  let node = self._root;
  const stack = [];
  while (node !== undefined) {
    const d = cmp(key, node.key);
    stack.push(node);
    if (equals$1(key, node.key)) {
      node = undefined;
    } else if (d <= 0) {
      node = node.left;
    } else {
      node = node.right;
    }
  }
  if (stack.length === 0) {
    return self;
  }
  const cstack = new Array(stack.length);
  let n = stack[stack.length - 1];
  cstack[cstack.length - 1] = new Node$1(n.color, n.key, n.value, n.left, n.right, n.count);
  for (let i = stack.length - 2; i >= 0; --i) {
    n = stack[i];
    if (n.left === stack[i + 1]) {
      cstack[i] = new Node$1(n.color, n.key, n.value, cstack[i + 1], n.right, n.count);
    } else {
      cstack[i] = new Node$1(n.color, n.key, n.value, n.left, cstack[i + 1], n.count);
    }
  }
  // Get node
  n = cstack[cstack.length - 1];
  // If not leaf, then swap with previous node
  if (n.left !== undefined && n.right !== undefined) {
    // First walk to previous leaf
    const split = cstack.length;
    n = n.left;
    while (n.right != null) {
      cstack.push(n);
      n = n.right;
    }
    // Copy path to leaf
    const v = cstack[split - 1];
    cstack.push(new Node$1(n.color, v.key, v.value, n.left, n.right, n.count));
    cstack[split - 1].key = n.key;
    cstack[split - 1].value = n.value;
    // Fix up stack
    for (let i = cstack.length - 2; i >= split; --i) {
      n = cstack[i];
      cstack[i] = new Node$1(n.color, n.key, n.value, n.left, cstack[i + 1], n.count);
    }
    cstack[split - 1].left = cstack[split];
  }

  // Remove leaf node
  n = cstack[cstack.length - 1];
  if (n.color === Color.Red) {
    // Easy case: removing red leaf
    const p = cstack[cstack.length - 2];
    if (p.left === n) {
      p.left = undefined;
    } else if (p.right === n) {
      p.right = undefined;
    }
    cstack.pop();
    for (let i = 0; i < cstack.length; ++i) {
      cstack[i].count--;
    }
    return makeImpl$2(ord, cstack[0]);
  } else {
    if (n.left !== undefined || n.right !== undefined) {
      // Second easy case:  Single child black parent
      if (n.left !== undefined) {
        swap(n, n.left);
      } else if (n.right !== undefined) {
        swap(n, n.right);
      }
      // Child must be red, so repaint it black to balance color
      n.color = Color.Black;
      for (let i = 0; i < cstack.length - 1; ++i) {
        cstack[i].count--;
      }
      return makeImpl$2(ord, cstack[0]);
    } else if (cstack.length === 1) {
      // Third easy case: root
      return makeImpl$2(ord, undefined);
    } else {
      // Hard case: Repaint n, and then do some nasty stuff
      for (let i = 0; i < cstack.length; ++i) {
        cstack[i].count--;
      }
      const parent = cstack[cstack.length - 2];
      fixDoubleBlack(cstack);
      // Fix up links
      if (parent.left === n) {
        parent.left = undefined;
      } else {
        parent.right = undefined;
      }
    }
  }
  return makeImpl$2(ord, cstack[0]);
});

/** @internal */
const size$d = self => self._root?.count ?? 0;

/** @internal */
const valuesForward = self => values$1(self, Direction.Forward);

/** @internal */
const valuesBackward = self => values$1(self, Direction.Backward);

/** @internal */
const values$1 = (self, direction) => {
  const begin = self[Symbol.iterator]();
  let count = 0;
  return {
    [Symbol.iterator]: () => values$1(self, direction),
    next: () => {
      count++;
      const entry = begin.value;
      if (direction === Direction.Forward) {
        begin.moveNext();
      } else {
        begin.movePrev();
      }
      switch (entry._tag) {
        case "None":
          {
            return {
              done: true,
              value: count
            };
          }
        case "Some":
          {
            return {
              done: false,
              value: entry.value
            };
          }
      }
    }
  };
};
const visitFull = (node, visit) => {
  let current = node;
  let stack = undefined;
  let done = false;
  while (!done) {
    if (current != null) {
      stack = new Stack(current, stack);
      current = current.left;
    } else if (stack != null) {
      const value = visit(stack.value.key, stack.value.value);
      if (isSome(value)) {
        return value;
      }
      current = stack.value.right;
      stack = stack.previous;
    } else {
      done = true;
    }
  }
  return none$8();
};
const visitGreaterThanEqual = (node, min, ord, visit) => {
  let current = node;
  let stack = undefined;
  let done = false;
  while (!done) {
    if (current !== undefined) {
      stack = new Stack(current, stack);
      if (ord(min, current.key) <= 0) {
        current = current.left;
      } else {
        current = undefined;
      }
    } else if (stack !== undefined) {
      if (ord(min, stack.value.key) <= 0) {
        const value = visit(stack.value.key, stack.value.value);
        if (isSome(value)) {
          return value;
        }
      }
      current = stack.value.right;
      stack = stack.previous;
    } else {
      done = true;
    }
  }
  return none$8();
};
const visitLessThan = (node, max, ord, visit) => {
  let current = node;
  let stack = undefined;
  let done = false;
  while (!done) {
    if (current !== undefined) {
      stack = new Stack(current, stack);
      current = current.left;
    } else if (stack !== undefined && ord(max, stack.value.key) > 0) {
      const value = visit(stack.value.key, stack.value.value);
      if (isSome(value)) {
        return value;
      }
      current = stack.value.right;
      stack = stack.previous;
    } else {
      done = true;
    }
  }
  return none$8();
};
const visitBetween = (node, min, max, ord, visit) => {
  let current = node;
  let stack = undefined;
  let done = false;
  while (!done) {
    if (current !== undefined) {
      stack = new Stack(current, stack);
      if (ord(min, current.key) <= 0) {
        current = current.left;
      } else {
        current = undefined;
      }
    } else if (stack !== undefined && ord(max, stack.value.key) > 0) {
      if (ord(min, stack.value.key) <= 0) {
        const value = visit(stack.value.key, stack.value.value);
        if (isSome(value)) {
          return value;
        }
      }
      current = stack.value.right;
      stack = stack.previous;
    } else {
      done = true;
    }
  }
  return none$8();
};

/**
 * Fix up a double black node in a Red-Black Tree.
 */
const fixDoubleBlack = stack => {
  let n, p, s, z;
  for (let i = stack.length - 1; i >= 0; --i) {
    n = stack[i];
    if (i === 0) {
      n.color = Color.Black;
      return;
    }
    p = stack[i - 1];
    if (p.left === n) {
      s = p.right;
      if (s !== undefined && s.right !== undefined && s.right.color === Color.Red) {
        s = p.right = clone(s);
        z = s.right = clone(s.right);
        p.right = s.left;
        s.left = p;
        s.right = z;
        s.color = p.color;
        n.color = Color.Black;
        p.color = Color.Black;
        z.color = Color.Black;
        recount(p);
        recount(s);
        if (i > 1) {
          const pp = stack[i - 2];
          if (pp.left === p) {
            pp.left = s;
          } else {
            pp.right = s;
          }
        }
        stack[i - 1] = s;
        return;
      } else if (s !== undefined && s.left !== undefined && s.left.color === Color.Red) {
        s = p.right = clone(s);
        z = s.left = clone(s.left);
        p.right = z.left;
        s.left = z.right;
        z.left = p;
        z.right = s;
        z.color = p.color;
        p.color = Color.Black;
        s.color = Color.Black;
        n.color = Color.Black;
        recount(p);
        recount(s);
        recount(z);
        if (i > 1) {
          const pp = stack[i - 2];
          if (pp.left === p) {
            pp.left = z;
          } else {
            pp.right = z;
          }
        }
        stack[i - 1] = z;
        return;
      }
      if (s !== undefined && s.color === Color.Black) {
        if (p.color === Color.Red) {
          p.color = Color.Black;
          p.right = repaint(s, Color.Red);
          return;
        } else {
          p.right = repaint(s, Color.Red);
          continue;
        }
      } else if (s !== undefined) {
        s = clone(s);
        p.right = s.left;
        s.left = p;
        s.color = p.color;
        p.color = Color.Red;
        recount(p);
        recount(s);
        if (i > 1) {
          const pp = stack[i - 2];
          if (pp.left === p) {
            pp.left = s;
          } else {
            pp.right = s;
          }
        }
        stack[i - 1] = s;
        stack[i] = p;
        if (i + 1 < stack.length) {
          stack[i + 1] = n;
        } else {
          stack.push(n);
        }
        i = i + 2;
      }
    } else {
      s = p.left;
      if (s !== undefined && s.left !== undefined && s.left.color === Color.Red) {
        s = p.left = clone(s);
        z = s.left = clone(s.left);
        p.left = s.right;
        s.right = p;
        s.left = z;
        s.color = p.color;
        n.color = Color.Black;
        p.color = Color.Black;
        z.color = Color.Black;
        recount(p);
        recount(s);
        if (i > 1) {
          const pp = stack[i - 2];
          if (pp.right === p) {
            pp.right = s;
          } else {
            pp.left = s;
          }
        }
        stack[i - 1] = s;
        return;
      } else if (s !== undefined && s.right !== undefined && s.right.color === Color.Red) {
        s = p.left = clone(s);
        z = s.right = clone(s.right);
        p.left = z.right;
        s.right = z.left;
        z.right = p;
        z.left = s;
        z.color = p.color;
        p.color = Color.Black;
        s.color = Color.Black;
        n.color = Color.Black;
        recount(p);
        recount(s);
        recount(z);
        if (i > 1) {
          const pp = stack[i - 2];
          if (pp.right === p) {
            pp.right = z;
          } else {
            pp.left = z;
          }
        }
        stack[i - 1] = z;
        return;
      }
      if (s !== undefined && s.color === Color.Black) {
        if (p.color === Color.Red) {
          p.color = Color.Black;
          p.left = repaint(s, Color.Red);
          return;
        } else {
          p.left = repaint(s, Color.Red);
          continue;
        }
      } else if (s !== undefined) {
        s = clone(s);
        p.left = s.right;
        s.right = p;
        s.color = p.color;
        p.color = Color.Red;
        recount(p);
        recount(s);
        if (i > 1) {
          const pp = stack[i - 2];
          if (pp.right === p) {
            pp.right = s;
          } else {
            pp.left = s;
          }
        }
        stack[i - 1] = s;
        stack[i] = p;
        if (i + 1 < stack.length) {
          stack[i + 1] = n;
        } else {
          stack.push(n);
        }
        i = i + 2;
      }
    }
  }
};

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category constants
 */
Direction;

/**
 * A Red-Black Tree.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category refinements
 */
isRedBlackTree;

/**
 * Creates an empty `RedBlackTree`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$d = empty$e;

/**
 * Constructs a new tree from an iterable of key-value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterable$6;

/**
 * Constructs a new `RedBlackTree` from the specified entries.
 *
 * @since 2.0.0
 * @category constructors
 */
make$B;

/**
 * Returns an iterator that points to the element at the specified index of the
 * tree.
 *
 * **Note**: The iterator will run through elements in order.
 *
 * @since 2.0.0
 * @category traversing
 */
atForwards;

/**
 * Returns an iterator that points to the element at the specified index of the
 * tree.
 *
 * **Note**: The iterator will run through elements in reverse order.
 *
 * @since 2.0.0
 * @category traversing
 */
atBackwards;

/**
 * Finds all values in the tree associated with the specified key.
 *
 * @since 2.0.0
 * @category elements
 */
findAll$1;

/**
 * Finds the first value in the tree associated with the specified key, if it exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst$2 = findFirst$3;

/**
 * Returns the first entry in the tree, if it exists.
 *
 * @since 2.0.0
 * @category getters
 */
const first$1 = first$2;

/**
 * Returns the element at the specified index within the tree or `None` if the
 * specified index does not exist.
 *
 * @since 2.0.0
 * @category elements
 */
getAt;

/**
 * Gets the `Order<K>` that the `RedBlackTree<K, V>` is using.
 *
 * @since 2.0.0
 * @category getters
 */
const getOrder$1 = getOrder$2;

/**
 * Returns an iterator that traverse entries in order with keys greater than the
 * specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
greaterThanForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys greater
 * than the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
greaterThanBackwards;

/**
 * Returns an iterator that traverse entries in order with keys greater than or
 * equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
greaterThanEqualForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys greater
 * than or equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
greaterThanEqualBackwards;

/**
 * Finds the item with key, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const has$2 = has$3;

/**
 * Insert a new item into the tree.
 *
 * @since 2.0.0
 */
const insert = insert$1;

/**
 * Get all the keys present in the tree in order.
 *
 * @since 2.0.0
 * @category getters
 */
const keys$1 = keysForward;

/**
 * Get all the keys present in the tree in reverse order.
 *
 * @since 2.0.0
 * @category getters
 */
keysBackward;

/**
 * Returns the last entry in the tree, if it exists.
 *
 * @since 2.0.0
 * @category getters
 */
last$1;

/**
 * Returns an iterator that traverse entries in order with keys less than the
 * specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
lessThanForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys less
 * than the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
lessThanBackwards;

/**
 * Returns an iterator that traverse entries in order with keys less than or
 * equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
lessThanEqualForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys less
 * than or equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
lessThanEqualBackwards;

/**
 * Execute the specified function for each node of the tree, in order.
 *
 * @since 2.0.0
 * @category traversing
 */
forEach$7;

/**
 * Visit each node of the tree in order with key greater then or equal to max.
 *
 * @since 2.0.0
 * @category traversing
 */
forEachGreaterThanEqual;

/**
 * Visit each node of the tree in order with key lower then max.
 *
 * @since 2.0.0
 * @category traversing
 */
forEachLessThan;

/**
 * Visit each node of the tree in order with key lower than max and greater
 * than or equal to min.
 *
 * @since 2.0.0
 * @category traversing
 */
forEachBetween;

/**
 * Reduce a state over the entries of the tree.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce$7 = reduce$8;

/**
 * Removes the entry with the specified key, if it exists.
 *
 * @since 2.0.0
 */
const removeFirst = removeFirst$1;

/**
 * Traverse the tree in reverse order.
 *
 * @since 2.0.0
 * @category traversing
 */
reversed;

/**
 * Returns the size of the tree.
 *
 * @since 2.0.0
 * @category getters
 */
const size$c = size$d;

/**
 * Get all values present in the tree in order.
 *
 * @since 2.0.0
 * @category getters
 */
valuesForward;

/**
 * Get all values present in the tree in reverse order.
 *
 * @since 2.0.0
 * @category getters
 */
valuesBackward;

/**
 * @since 2.0.0
 */
const TypeId$2 = /*#__PURE__*/Symbol.for("effect/SortedSet");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

const SortedSetProto = {
  [TypeId$2]: {
    _A: _ => _
  },
  [symbol$1]() {
    return pipe(hash$1(this.keyTree), combine$a(hash$1(TypeId$2)));
  },
  [symbol](that) {
    return isSortedSet(that) && equals$1(this.keyTree, that.keyTree);
  },
  [Symbol.iterator]() {
    return keys$1(this.keyTree);
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "SortedSet",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const fromTree = keyTree => {
  const a = Object.create(SortedSetProto);
  a.keyTree = keyTree;
  return a;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isSortedSet = u => isObject(u) && TypeId$2 in u;

/**
 * @since 2.0.0
 * @category constructors
 */
const empty$c = O => fromTree(empty$d(O));

/**
 * @since 2.0.0
 * @category elements
 */
const add$1 = /*#__PURE__*/dual(2, (self, value) => has$2(self.keyTree, value) ? self : fromTree(insert(self.keyTree, value, true)));

/**
 * @since 2.0.0
 * @category filtering
 */
const filter$5 = /*#__PURE__*/dual(2, (self, predicate) => {
  const ord = getOrder$1(self.keyTree);
  let out = empty$c(ord);
  for (const value of self) {
    if (predicate(value)) {
      out = add$1(out, value);
    }
  }
  return out;
});

/**
 * @since 2.0.0
 * @category elements
 */
const remove$3 = /*#__PURE__*/dual(2, (self, value) => fromTree(removeFirst(self.keyTree, value)));

/**
 * @since 2.0.0
 */
const union$5 = /*#__PURE__*/dual(2, (self, that) => {
  const ord = getOrder$1(self.keyTree);
  let out = empty$c(ord);
  for (const value of self) {
    out = add$1(value)(out);
  }
  for (const value of that) {
    out = add$1(value)(out);
  }
  return out;
});

/** @internal */
const SupervisorSymbolKey = "effect/Supervisor";

/** @internal */
const SupervisorTypeId = /*#__PURE__*/Symbol.for(SupervisorSymbolKey);

/** @internal */
const supervisorVariance = {
  _T: _ => _
};

/** @internal */
class ProxySupervisor {
  [SupervisorTypeId] = supervisorVariance;
  constructor(underlying, value0) {
    this.underlying = underlying;
    this.value0 = value0;
  }
  value() {
    return this.value0();
  }
  onStart(context, effect, parent, fiber) {
    this.underlying.onStart(context, effect, parent, fiber);
  }
  onEnd(value, fiber) {
    this.underlying.onEnd(value, fiber);
  }
  onEffect(fiber, effect) {
    this.underlying.onEffect(fiber, effect);
  }
  onSuspend(fiber) {
    this.underlying.onSuspend(fiber);
  }
  onResume(fiber) {
    this.underlying.onResume(fiber);
  }
  map(f) {
    return new ProxySupervisor(this, () => pipe(this.value(), map$f(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
}

/** @internal */
class Zip {
  [SupervisorTypeId] = supervisorVariance;
  constructor(left, right) {
    this.left = left;
    this.right = right;
  }
  value() {
    return zip$a(this.left.value(), this.right.value());
  }
  onStart(context, effect, parent, fiber) {
    this.left.onStart(context, effect, parent, fiber);
    this.right.onStart(context, effect, parent, fiber);
  }
  onEnd(value, fiber) {
    this.left.onEnd(value, fiber);
    this.right.onEnd(value, fiber);
  }
  onEffect(fiber, effect) {
    this.left.onEffect(fiber, effect);
    this.right.onEffect(fiber, effect);
  }
  onSuspend(fiber) {
    this.left.onSuspend(fiber);
    this.right.onSuspend(fiber);
  }
  onResume(fiber) {
    this.left.onResume(fiber);
    this.right.onResume(fiber);
  }
  map(f) {
    return new ProxySupervisor(this, () => pipe(this.value(), map$f(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
}
class Track {
  [SupervisorTypeId] = supervisorVariance;
  fibers = new Set();
  value() {
    return sync$a(() => Array.from(this.fibers));
  }
  onStart(_context, _effect, _parent, fiber) {
    this.fibers.add(fiber);
  }
  onEnd(_value, fiber) {
    this.fibers.delete(fiber);
  }
  onEffect(_fiber, _effect) {
    //
  }
  onSuspend(_fiber) {
    //
  }
  onResume(_fiber) {
    //
  }
  map(f) {
    return new ProxySupervisor(this, () => pipe(this.value(), map$f(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
  onRun(execution, _fiber) {
    return execution();
  }
}
class Const {
  [SupervisorTypeId] = supervisorVariance;
  constructor(effect) {
    this.effect = effect;
  }
  value() {
    return this.effect;
  }
  onStart(_context, _effect, _parent, _fiber) {
    //
  }
  onEnd(_value, _fiber) {
    //
  }
  onEffect(_fiber, _effect) {
    //
  }
  onSuspend(_fiber) {
    //
  }
  onResume(_fiber) {
    //
  }
  map(f) {
    return new ProxySupervisor(this, () => pipe(this.value(), map$f(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
  onRun(execution, _fiber) {
    return execution();
  }
}
class FibersIn {
  [SupervisorTypeId] = supervisorVariance;
  constructor(ref) {
    this.ref = ref;
  }
  value() {
    return sync$a(() => get$f(this.ref));
  }
  onStart(_context, _effect, _parent, fiber) {
    pipe(this.ref, set$a(pipe(get$f(this.ref), add$1(fiber))));
  }
  onEnd(_value, fiber) {
    pipe(this.ref, set$a(pipe(get$f(this.ref), remove$3(fiber))));
  }
  onEffect(_fiber, _effect) {
    //
  }
  onSuspend(_fiber) {
    //
  }
  onResume(_fiber) {
    //
  }
  map(f) {
    return new ProxySupervisor(this, () => pipe(this.value(), map$f(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
  onRun(execution, _fiber) {
    return execution();
  }
}

/** @internal */
const unsafeTrack = () => {
  return new Track();
};

/** @internal */
const track = /*#__PURE__*/sync$a(unsafeTrack);

/** @internal */
const fromEffect$5 = effect => {
  return new Const(effect);
};

/** @internal */
const none$2 = /*#__PURE__*/globalValue("effect/Supervisor/none", () => fromEffect$5(unit$6));

/** @internal */
const fibersIn = ref => sync$a(() => new FibersIn(ref));

/** @internal */

/** @internal */
const OP_EMPTY = "Empty";

/** @internal */

/** @internal */
const OP_ADD_SUPERVISOR = "AddSupervisor";

/** @internal */

/** @internal */
const OP_REMOVE_SUPERVISOR = "RemoveSupervisor";

/** @internal */

/** @internal */
const OP_AND_THEN = "AndThen";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/**
 * The empty `SupervisorPatch`.
 *
 * @internal
 */
const empty$b = {
  _tag: OP_EMPTY
};

/**
 * Combines two patches to produce a new patch that describes applying the
 * updates from this patch and then the updates from the specified patch.
 *
 * @internal
 */
const combine$1 = (self, that) => {
  return {
    _tag: OP_AND_THEN,
    first: self,
    second: that
  };
};

/**
 * Applies a `SupervisorPatch` to a `Supervisor` to produce a new `Supervisor`.
 *
 * @internal
 */
const patch = (self, supervisor) => {
  return patchLoop(supervisor, of$3(self));
};

/** @internal */
const patchLoop = (_supervisor, _patches) => {
  let supervisor = _supervisor;
  let patches = _patches;
  while (isNonEmpty$5(patches)) {
    const head = headNonEmpty(patches);
    switch (head._tag) {
      case OP_EMPTY:
        {
          patches = tailNonEmpty(patches);
          break;
        }
      case OP_ADD_SUPERVISOR:
        {
          supervisor = supervisor.zip(head.supervisor);
          patches = tailNonEmpty(patches);
          break;
        }
      case OP_REMOVE_SUPERVISOR:
        {
          supervisor = removeSupervisor(supervisor, head.supervisor);
          patches = tailNonEmpty(patches);
          break;
        }
      case OP_AND_THEN:
        {
          patches = prepend$2(head.first)(prepend$2(head.second)(tailNonEmpty(patches)));
          break;
        }
    }
  }
  return supervisor;
};

/** @internal */
const removeSupervisor = (self, that) => {
  if (equals$1(self, that)) {
    return none$2;
  } else {
    if (self instanceof Zip) {
      return removeSupervisor(self.left, that).zip(removeSupervisor(self.right, that));
    } else {
      return self;
    }
  }
};

/** @internal */
const toSet = self => {
  if (equals$1(self, none$2)) {
    return empty$s();
  } else {
    if (self instanceof Zip) {
      return pipe(toSet(self.left), union$6(toSet(self.right)));
    } else {
      return make$Z(self);
    }
  }
};

/** @internal */
const diff = (oldValue, newValue) => {
  if (equals$1(oldValue, newValue)) {
    return empty$b;
  }
  const oldSupervisors = toSet(oldValue);
  const newSupervisors = toSet(newValue);
  const added = pipe(newSupervisors, difference$1(oldSupervisors), reduce$d(empty$b, (patch, supervisor) => combine$1(patch, {
    _tag: OP_ADD_SUPERVISOR,
    supervisor
  })));
  const removed = pipe(oldSupervisors, difference$1(newSupervisors), reduce$d(empty$b, (patch, supervisor) => combine$1(patch, {
    _tag: OP_REMOVE_SUPERVISOR,
    supervisor
  })));
  return combine$1(added, removed);
};

/** @internal */
const differ = /*#__PURE__*/make$X({
  empty: empty$b,
  patch,
  combine: combine$1,
  diff
});

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category utils
 */
class PriorityBuckets {
  /**
   * @since 2.0.0
   */
  buckets = [];
  /**
   * @since 2.0.0
   */
  scheduleTask(task, priority) {
    let bucket = undefined;
    let index;
    for (index = 0; index < this.buckets.length; index++) {
      if (this.buckets[index][0] <= priority) {
        bucket = this.buckets[index];
      } else {
        break;
      }
    }
    if (bucket) {
      bucket[1].push(task);
    } else {
      const newBuckets = [];
      for (let i = 0; i < index; i++) {
        newBuckets.push(this.buckets[i]);
      }
      newBuckets.push([priority, [task]]);
      for (let i = index; i < this.buckets.length; i++) {
        newBuckets.push(this.buckets[i]);
      }
      this.buckets = newBuckets;
    }
  }
}

/**
 * @since 2.0.0
 * @category constructors
 */
class MixedScheduler {
  /**
   * @since 2.0.0
   */
  running = false;
  /**
   * @since 2.0.0
   */
  tasks = new PriorityBuckets();
  constructor(
  /**
   * @since 2.0.0
   */
  maxNextTickBeforeTimer) {
    this.maxNextTickBeforeTimer = maxNextTickBeforeTimer;
  }

  /**
   * @since 2.0.0
   */
  starveInternal(depth) {
    const tasks = this.tasks.buckets;
    this.tasks.buckets = [];
    for (const [_, toRun] of tasks) {
      for (let i = 0; i < toRun.length; i++) {
        toRun[i]();
      }
    }
    if (this.tasks.buckets.length === 0) {
      this.running = false;
    } else {
      this.starve(depth);
    }
  }

  /**
   * @since 2.0.0
   */
  starve(depth = 0) {
    if (depth >= this.maxNextTickBeforeTimer) {
      set$8(() => this.starveInternal(0), 0);
    } else {
      Promise.resolve(void 0).then(() => this.starveInternal(depth + 1));
    }
  }

  /**
   * @since 2.0.0
   */
  shouldYield(fiber) {
    return fiber.currentOpCount > fiber.getFiberRef(currentMaxOpsBeforeYield) ? fiber.getFiberRef(currentSchedulingPriority$1) : false;
  }

  /**
   * @since 2.0.0
   */
  scheduleTask(task, priority) {
    this.tasks.scheduleTask(task, priority);
    if (!this.running) {
      this.running = true;
      this.starve();
    }
  }
}

/**
 * @since 2.0.0
 * @category schedulers
 */
const defaultScheduler = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/Scheduler/defaultScheduler"), () => new MixedScheduler(2048));

/**
 * @since 2.0.0
 * @category constructors
 */
class SyncScheduler {
  /**
   * @since 2.0.0
   */
  tasks = new PriorityBuckets();

  /**
   * @since 2.0.0
   */
  deferred = false;

  /**
   * @since 2.0.0
   */
  scheduleTask(task, priority) {
    if (this.deferred) {
      defaultScheduler.scheduleTask(task, priority);
    } else {
      this.tasks.scheduleTask(task, priority);
    }
  }

  /**
   * @since 2.0.0
   */
  shouldYield(fiber) {
    return fiber.currentOpCount > fiber.getFiberRef(currentMaxOpsBeforeYield) ? fiber.getFiberRef(currentSchedulingPriority$1) : false;
  }

  /**
   * @since 2.0.0
   */
  flush() {
    while (this.tasks.buckets.length > 0) {
      const tasks = this.tasks.buckets;
      this.tasks.buckets = [];
      for (const [_, toRun] of tasks) {
        for (let i = 0; i < toRun.length; i++) {
          toRun[i]();
        }
      }
    }
    this.deferred = true;
  }
}

/** @internal */
const currentScheduler$1 = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentScheduler"), () => fiberRefUnsafeMake(defaultScheduler));

/** @internal */
const withScheduler$1 = /*#__PURE__*/dual(2, (self, scheduler) => fiberRefLocally$1(self, currentScheduler$1, scheduler));

/** @internal */
const fiberStarted = /*#__PURE__*/counter("effect_fiber_started");
/** @internal */
const fiberActive = /*#__PURE__*/counter("effect_fiber_active");
/** @internal */
const fiberSuccesses = /*#__PURE__*/counter("effect_fiber_successes");
/** @internal */
const fiberFailures = /*#__PURE__*/counter("effect_fiber_failures");
/** @internal */
const fiberLifetimes = /*#__PURE__*/tagged$1( /*#__PURE__*/histogram("effect_fiber_lifetimes", /*#__PURE__*/exponential$1({
  start: 1.0,
  factor: 1.3,
  count: 100
})), "time_unit", "milliseconds");

/** @internal */

/** @internal */
const EvaluationSignalContinue = "Continue";

/** @internal */

/** @internal */
const EvaluationSignalDone = "Done";

/** @internal */

/** @internal */
const EvaluationSignalYieldNow = "Yield";

/** @internal */

/** @internal */
const runtimeFiberVariance = {
  _E: _ => _,
  _A: _ => _
};
const absurd = _ => {
  throw new Error(`BUG: FiberRuntime - ${JSON.stringify(_)} - please report an issue at https://github.com/Effect-TS/io/issues`);
};
const contOpSuccess = {
  [OP_ON_SUCCESS$1]: (_, cont, value) => {
    return cont.i1(value);
  },
  ["OnStep"]: (_, cont, value) => {
    return cont.i1(exitSucceed(value));
  },
  [OP_ON_SUCCESS_AND_FAILURE]: (_, cont, value) => {
    return cont.i2(value);
  },
  [OP_REVERT_FLAGS]: (self, cont, value) => {
    self.patchRuntimeFlags(self._runtimeFlags, cont.patch);
    if (interruptible$2(self._runtimeFlags) && self.isInterrupted()) {
      return exitFailCause(self.getInterruptedCause());
    } else {
      return exitSucceed(value);
    }
  },
  [OP_WHILE]: (self, cont, value) => {
    cont.i2(value);
    if (cont.i0()) {
      self.pushStack(cont);
      return cont.i1();
    } else {
      return unit$6;
    }
  }
};
const drainQueueWhileRunningTable = {
  [OP_INTERRUPT_SIGNAL]: (self, runtimeFlags, cur, message) => {
    self.processNewInterruptSignal(message.cause);
    return interruptible$2(runtimeFlags) ? exitFailCause(message.cause) : cur;
  },
  [OP_RESUME]: (_self, _runtimeFlags, _cur, _message) => {
    throw new Error("It is illegal to have multiple concurrent run loops in a single fiber");
  },
  [OP_STATEFUL]: (self, runtimeFlags, cur, message) => {
    message.onFiber(self, running$1(runtimeFlags));
    return cur;
  },
  [OP_YIELD_NOW]: (_self, _runtimeFlags, cur, _message) => {
    return flatMap$6(yieldNow$2(), () => cur);
  }
};

/**
 * Executes all requests, submitting requests to each data source in parallel.
 */
const runBlockedRequests = self => forEachSequentialDiscard(flatten$8(self), requestsByRequestResolver => forEachParUnboundedDiscard(sequentialCollectionToChunk(requestsByRequestResolver), ([dataSource, sequential]) => {
  const map = new Map();
  for (const block of sequential) {
    for (const entry of block) {
      map.set(entry.request, entry);
    }
  }
  return fiberRefLocally$1(invokeWithInterrupt(dataSource.runAll(sequential), sequential.flat()), currentRequestMap, map);
}, false));

/** @internal */
class FiberRuntime {
  [FiberTypeId] = fiberVariance;
  [RuntimeFiberTypeId] = runtimeFiberVariance;
  pipe() {
    return pipeArguments(this, arguments);
  }
  _queue = new Array();
  _children = null;
  _observers = new Array();
  _running = false;
  _stack = [];
  _asyncInterruptor = null;
  _asyncBlockingOn = null;
  _exitValue = null;
  _steps = [false];
  currentOpCount = 0;
  isYielding = false;
  constructor(fiberId, fiberRefs0, runtimeFlags0) {
    this._runtimeFlags = runtimeFlags0;
    this._fiberId = fiberId;
    this._fiberRefs = fiberRefs0;
    this._supervisor = this.getFiberRef(currentSupervisor);
    this._scheduler = this.getFiberRef(currentScheduler$1);
    if (runtimeMetrics(runtimeFlags0)) {
      const tags = this.getFiberRef(currentMetricLabels);
      fiberStarted.unsafeUpdate(1, tags);
      fiberActive.unsafeUpdate(1, tags);
    }
    this._tracer = get$j(this.getFiberRef(currentServices$1), tracerTag);
  }

  /**
   * The identity of the fiber.
   */
  id() {
    return this._fiberId;
  }

  /**
   * Begins execution of the effect associated with this fiber on in the
   * background. This can be called to "kick off" execution of a fiber after
   * it has been created.
   */
  resume(effect) {
    this.tell(resume(effect));
  }

  /**
   * The status of the fiber.
   */
  status() {
    return this.ask((_, status) => status);
  }

  /**
   * Gets the fiber runtime flags.
   */
  runtimeFlags() {
    return this.ask((state, status) => {
      if (isDone$4(status)) {
        return state._runtimeFlags;
      }
      return status.runtimeFlags;
    });
  }

  /**
   * Returns the current `FiberScope` for the fiber.
   */
  scope() {
    return unsafeMake$2(this);
  }

  /**
   * Retrieves the immediate children of the fiber.
   */
  children() {
    return this.ask(fiber => Array.from(fiber.getChildren()));
  }

  /**
   * Gets the fiber's set of children.
   */
  getChildren() {
    if (this._children === null) {
      this._children = new Set();
    }
    return this._children;
  }

  /**
   * Retrieves the interrupted cause of the fiber, which will be `Cause.empty`
   * if the fiber has not been interrupted.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  getInterruptedCause() {
    return this.getFiberRef(currentInterruptedCause);
  }

  /**
   * Retrieves the whole set of fiber refs.
   */
  fiberRefs() {
    return this.ask(fiber => fiber.getFiberRefs());
  }

  /**
   * Returns an effect that will contain information computed from the fiber
   * state and status while running on the fiber.
   *
   * This allows the outside world to interact safely with mutable fiber state
   * without locks or immutable data.
   */
  ask(f) {
    return suspend$8(() => {
      const deferred = deferredUnsafeMake(this._fiberId);
      this.tell(stateful((fiber, status) => {
        deferredUnsafeDone(deferred, sync$a(() => f(fiber, status)));
      }));
      return deferredAwait(deferred);
    });
  }

  /**
   * Adds a message to be processed by the fiber on the fiber.
   */
  tell(message) {
    this._queue.push(message);
    if (!this._running) {
      this._running = true;
      this.drainQueueLaterOnExecutor();
    }
  }
  await() {
    return async$1(resume => {
      const cb = exit => resume(succeed$h(exit));
      this.tell(stateful((fiber, _) => {
        if (fiber._exitValue !== null) {
          cb(this._exitValue);
        } else {
          fiber.addObserver(cb);
        }
      }));
      return sync$a(() => this.tell(stateful((fiber, _) => {
        fiber.removeObserver(cb);
      })));
    }, this.id());
  }
  inheritAll() {
    return withFiberRuntime((parentFiber, parentStatus) => {
      const parentFiberId = parentFiber.id();
      const parentFiberRefs = parentFiber.getFiberRefs();
      const parentRuntimeFlags = parentStatus.runtimeFlags;
      const childFiberRefs = this.getFiberRefs();
      const updatedFiberRefs = joinAs$1(parentFiberRefs, parentFiberId, childFiberRefs);
      parentFiber.setFiberRefs(updatedFiberRefs);
      const updatedRuntimeFlags = parentFiber.getFiberRef(currentRuntimeFlags);
      const patch = pipe(diff$3(parentRuntimeFlags, updatedRuntimeFlags),
      // Do not inherit WindDown or Interruption!
      exclude(Interruption), exclude(WindDown));
      return updateRuntimeFlags(patch);
    });
  }

  /**
   * Tentatively observes the fiber, but returns immediately if it is not
   * already done.
   */
  poll() {
    return sync$a(() => fromNullable$2(this._exitValue));
  }

  /**
   * Unsafely observes the fiber, but returns immediately if it is not
   * already done.
   */
  unsafePoll() {
    return this._exitValue;
  }

  /**
   * In the background, interrupts the fiber as if interrupted from the specified fiber.
   */
  interruptAsFork(fiberId) {
    return sync$a(() => this.tell(interruptSignal(interrupt$8(fiberId))));
  }

  /**
   * Adds an observer to the list of observers.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  addObserver(observer) {
    if (this._exitValue !== null) {
      observer(this._exitValue);
    } else {
      this._observers.push(observer);
    }
  }

  /**
   * Removes the specified observer from the list of observers that will be
   * notified when the fiber exits.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  removeObserver(observer) {
    this._observers = this._observers.filter(o => o !== observer);
  }
  /**
   * Retrieves all fiber refs of the fiber.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  getFiberRefs() {
    this.setFiberRef(currentRuntimeFlags, this._runtimeFlags);
    return this._fiberRefs;
  }

  /**
   * Deletes the specified fiber ref.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  unsafeDeleteFiberRef(fiberRef) {
    this._fiberRefs = delete_(this._fiberRefs, fiberRef);
  }

  /**
   * Retrieves the state of the fiber ref, or else its initial value.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  getFiberRef(fiberRef) {
    if (this._fiberRefs.locals.has(fiberRef)) {
      return this._fiberRefs.locals.get(fiberRef)[0][1];
    }
    return fiberRef.initial;
  }

  /**
   * Sets the fiber ref to the specified value.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  setFiberRef(fiberRef, value) {
    this._fiberRefs = updatedAs$1(this._fiberRefs, {
      fiberId: this._fiberId,
      fiberRef,
      value
    });
    this.refreshRefCache();
  }
  refreshRefCache() {
    this._tracer = get$j(this.getFiberRef(currentServices$1), tracerTag);
    this._supervisor = this.getFiberRef(currentSupervisor);
    this._scheduler = this.getFiberRef(currentScheduler$1);
  }

  /**
   * Wholesale replaces all fiber refs of this fiber.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  setFiberRefs(fiberRefs) {
    this._fiberRefs = fiberRefs;
    this.refreshRefCache();
  }

  /**
   * Adds a reference to the specified fiber inside the children set.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  addChild(child) {
    this.getChildren().add(child);
  }

  /**
   * Removes a reference to the specified fiber inside the children set.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  removeChild(child) {
    this.getChildren().delete(child);
  }

  /**
   * On the current thread, executes all messages in the fiber's inbox. This
   * method may return before all work is done, in the event the fiber executes
   * an asynchronous operation.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  drainQueueOnCurrentThread() {
    let recurse = true;
    while (recurse) {
      let evaluationSignal = EvaluationSignalContinue;
      const prev = globalThis[currentFiberURI];
      globalThis[currentFiberURI] = this;
      try {
        while (evaluationSignal === EvaluationSignalContinue) {
          evaluationSignal = this._queue.length === 0 ? EvaluationSignalDone : this.evaluateMessageWhileSuspended(this._queue.splice(0, 1)[0]);
        }
      } finally {
        this._running = false;
        globalThis[currentFiberURI] = prev;
      }
      // Maybe someone added something to the queue between us checking, and us
      // giving up the drain. If so, we need to restart the draining, but only
      // if we beat everyone else to the restart:
      if (this._queue.length > 0 && !this._running) {
        this._running = true;
        if (evaluationSignal === EvaluationSignalYieldNow) {
          this.drainQueueLaterOnExecutor();
          recurse = false;
        } else {
          recurse = true;
        }
      } else {
        recurse = false;
      }
    }
  }

  /**
   * Schedules the execution of all messages in the fiber's inbox.
   *
   * This method will return immediately after the scheduling
   * operation is completed, but potentially before such messages have been
   * executed.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  drainQueueLaterOnExecutor() {
    this._scheduler.scheduleTask(this.run, this.getFiberRef(currentSchedulingPriority$1));
  }

  /**
   * Drains the fiber's message queue while the fiber is actively running,
   * returning the next effect to execute, which may be the input effect if no
   * additional effect needs to be executed.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  drainQueueWhileRunning(runtimeFlags, cur0) {
    let cur = cur0;
    while (this._queue.length > 0) {
      const message = this._queue.splice(0, 1)[0];
      // @ts-expect-error
      cur = drainQueueWhileRunningTable[message._tag](this, runtimeFlags, cur, message);
    }
    return cur;
  }

  /**
   * Determines if the fiber is interrupted.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  isInterrupted() {
    return !isEmpty$e(this.getFiberRef(currentInterruptedCause));
  }

  /**
   * Adds an interruptor to the set of interruptors that are interrupting this
   * fiber.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  addInterruptedCause(cause) {
    const oldSC = this.getFiberRef(currentInterruptedCause);
    this.setFiberRef(currentInterruptedCause, sequential$2(oldSC, cause));
  }

  /**
   * Processes a new incoming interrupt signal.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  processNewInterruptSignal(cause) {
    this.addInterruptedCause(cause);
    this.sendInterruptSignalToAllChildren();
  }

  /**
   * Interrupts all children of the current fiber, returning an effect that will
   * await the exit of the children. This method will return null if the fiber
   * has no children.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  sendInterruptSignalToAllChildren() {
    if (this._children === null || this._children.size === 0) {
      return false;
    }
    let told = false;
    for (const child of this._children) {
      child.tell(interruptSignal(interrupt$8(this.id())));
      told = true;
    }
    return told;
  }

  /**
   * Interrupts all children of the current fiber, returning an effect that will
   * await the exit of the children. This method will return null if the fiber
   * has no children.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  interruptAllChildren() {
    if (this.sendInterruptSignalToAllChildren()) {
      const it = this._children.values();
      this._children = null;
      let isDone = false;
      const body = () => {
        const next = it.next();
        if (!next.done) {
          return asUnit$4(next.value.await());
        } else {
          return sync$a(() => {
            isDone = true;
          });
        }
      };
      return whileLoop$1({
        while: () => !isDone,
        body,
        step: () => {
          //
        }
      });
    }
    return null;
  }
  reportExitValue(exit) {
    if (runtimeMetrics(this._runtimeFlags)) {
      const tags = this.getFiberRef(currentMetricLabels);
      fiberActive.unsafeUpdate(-1, tags);
      switch (exit._tag) {
        case OP_SUCCESS:
          {
            fiberSuccesses.unsafeUpdate(1, tags);
            break;
          }
        case OP_FAILURE:
          {
            fiberFailures.unsafeUpdate(1, tags);
            break;
          }
      }
    }
    if (exit._tag === "Failure") {
      const level = this.getFiberRef(currentUnhandledErrorLogLevel);
      if (!isInterruptedOnly$1(exit.cause) && level._tag === "Some") {
        this.log("Fiber terminated with a non handled error", exit.cause, level);
      }
    }
  }
  setExitValue(exit) {
    this._exitValue = exit;
    if (runtimeMetrics(this._runtimeFlags)) {
      const tags = this.getFiberRef(currentMetricLabels);
      const startTimeMillis = this.id().startTimeMillis;
      const endTimeMillis = new Date().getTime();
      fiberLifetimes.unsafeUpdate(endTimeMillis - startTimeMillis, tags);
    }
    this.reportExitValue(exit);
    for (let i = this._observers.length - 1; i >= 0; i--) {
      this._observers[i](exit);
    }
  }
  getLoggers() {
    return this.getFiberRef(currentLoggers);
  }
  log(message, cause, overrideLogLevel) {
    const logLevel = isSome(overrideLogLevel) ? overrideLogLevel.value : this.getFiberRef(currentLogLevel);
    const minimumLogLevel = this.getFiberRef(currentMinimumLogLevel);
    if (greaterThan$1(minimumLogLevel, logLevel)) {
      return;
    }
    const spans = this.getFiberRef(currentLogSpan);
    const annotations = this.getFiberRef(currentLogAnnotations);
    const loggers = this.getLoggers();
    const contextMap = this.getFiberRefs();
    if (size$g(loggers) > 0) {
      const clockService = get$j(this.getFiberRef(currentServices$1), clockTag);
      const date = new Date(clockService.unsafeCurrentTimeMillis());
      for (const logger of loggers) {
        logger.log({
          fiberId: this.id(),
          logLevel,
          message,
          cause,
          context: contextMap,
          spans,
          annotations,
          date
        });
      }
    }
  }

  /**
   * Evaluates a single message on the current thread, while the fiber is
   * suspended. This method should only be called while evaluation of the
   * fiber's effect is suspended due to an asynchronous operation.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  evaluateMessageWhileSuspended(message) {
    switch (message._tag) {
      case OP_YIELD_NOW:
        {
          return EvaluationSignalYieldNow;
        }
      case OP_INTERRUPT_SIGNAL:
        {
          this.processNewInterruptSignal(message.cause);
          if (this._asyncInterruptor !== null) {
            this._asyncInterruptor(exitFailCause(message.cause));
            this._asyncInterruptor = null;
          }
          return EvaluationSignalContinue;
        }
      case OP_RESUME:
        {
          this._asyncInterruptor = null;
          this._asyncBlockingOn = null;
          this.evaluateEffect(message.effect);
          return EvaluationSignalContinue;
        }
      case OP_STATEFUL:
        {
          message.onFiber(this, this._exitValue !== null ? done$9 : suspended(this._runtimeFlags, this._asyncBlockingOn));
          return EvaluationSignalContinue;
        }
      default:
        {
          return absurd(message);
        }
    }
  }

  /**
   * Evaluates an effect until completion, potentially asynchronously.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  evaluateEffect(effect0) {
    this._supervisor.onResume(this);
    try {
      let effect = interruptible$2(this._runtimeFlags) && this.isInterrupted() ? exitFailCause(this.getInterruptedCause()) : effect0;
      while (effect !== null) {
        try {
          const eff = effect;
          const exit = this.runLoop(eff);
          this._runtimeFlags = pipe(this._runtimeFlags, enable$1(WindDown));
          const interruption = this.interruptAllChildren();
          if (interruption !== null) {
            effect = flatMap$6(interruption, () => exit);
          } else {
            if (this._queue.length === 0) {
              // No more messages to process, so we will allow the fiber to end life:
              this.setExitValue(exit);
            } else {
              // There are messages, possibly added by the final op executed by
              // the fiber. To be safe, we should execute those now before we
              // allow the fiber to end life:
              this.tell(resume(exit));
            }
            effect = null;
          }
        } catch (e) {
          if (isEffect$1(e)) {
            if (e._op === OP_YIELD$1) {
              if (cooperativeYielding(this._runtimeFlags)) {
                this.tell(yieldNow$1());
                this.tell(resume(exitUnit));
                effect = null;
              } else {
                effect = exitUnit;
              }
            } else if (e._op === OP_ASYNC) {
              // Terminate this evaluation, async resumption will continue evaluation:
              effect = null;
            }
          } else {
            throw e;
          }
        }
      }
    } finally {
      this._supervisor.onSuspend(this);
    }
  }

  /**
   * Begins execution of the effect associated with this fiber on the current
   * thread. This can be called to "kick off" execution of a fiber after it has
   * been created, in hopes that the effect can be executed synchronously.
   *
   * This is not the normal way of starting a fiber, but it is useful when the
   * express goal of executing the fiber is to synchronously produce its exit.
   */
  start(effect) {
    if (!this._running) {
      this._running = true;
      const prev = globalThis[currentFiberURI];
      globalThis[currentFiberURI] = this;
      try {
        this.evaluateEffect(effect);
      } finally {
        this._running = false;
        globalThis[currentFiberURI] = prev;
        // Because we're special casing `start`, we have to be responsible
        // for spinning up the fiber if there were new messages added to
        // the queue between the completion of the effect and the transition
        // to the not running state.
        if (this._queue.length > 0) {
          this.drainQueueLaterOnExecutor();
        }
      }
    } else {
      this.tell(resume(effect));
    }
  }

  /**
   * Begins execution of the effect associated with this fiber on in the
   * background, and on the correct thread pool. This can be called to "kick
   * off" execution of a fiber after it has been created, in hopes that the
   * effect can be executed synchronously.
   */
  startFork(effect) {
    this.tell(resume(effect));
  }

  /**
   * Takes the current runtime flags, patches them to return the new runtime
   * flags, and then makes any changes necessary to fiber state based on the
   * specified patch.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  patchRuntimeFlags(oldRuntimeFlags, patch$1) {
    const newRuntimeFlags = patch$4(oldRuntimeFlags, patch$1);
    globalThis[currentFiberURI] = this;
    this._runtimeFlags = newRuntimeFlags;
    return newRuntimeFlags;
  }

  /**
   * Initiates an asynchronous operation, by building a callback that will
   * resume execution, and then feeding that callback to the registration
   * function, handling error cases and repeated resumptions appropriately.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  initiateAsync(runtimeFlags, asyncRegister) {
    let alreadyCalled = false;
    const callback = effect => {
      if (!alreadyCalled) {
        alreadyCalled = true;
        this.tell(resume(effect));
      }
    };
    if (interruptible$2(runtimeFlags)) {
      this._asyncInterruptor = callback;
    }
    try {
      asyncRegister(callback);
    } catch (e) {
      callback(failCause$a(die$a(e)));
    }
  }
  pushStack(cont) {
    this._stack.push(cont);
    if (cont._op === "OnStep") {
      this._steps.push(true);
    }
    if (cont._op === "RevertFlags") {
      this._steps.push(false);
    }
  }
  popStack() {
    const item = this._stack.pop();
    if (item) {
      if (item._op === "OnStep" || item._op === "RevertFlags") {
        this._steps.pop();
      }
      return item;
    }
    return;
  }
  getNextSuccessCont() {
    let frame = this.popStack();
    while (frame) {
      if (frame._op !== OP_ON_FAILURE$1) {
        return frame;
      }
      frame = this.popStack();
    }
  }
  getNextFailCont() {
    let frame = this.popStack();
    while (frame) {
      if (frame._op !== OP_ON_SUCCESS$1 && frame._op !== OP_WHILE) {
        return frame;
      }
      frame = this.popStack();
    }
  }
  [OP_TAG](op) {
    return map$f(fiberRefGet(currentContext$1), context => {
      try {
        return unsafeGet$6(context, op);
      } catch (e) {
        console.log(e);
        throw e;
      }
    });
  }
  ["Left"](op) {
    return fail$f(op.left);
  }
  ["None"](_) {
    return fail$f(NoSuchElementException$1());
  }
  ["Right"](op) {
    return exitSucceed(op.right);
  }
  ["Some"](op) {
    return exitSucceed(op.value);
  }
  [OP_SYNC$1](op) {
    const value = op.i0();
    const cont = this.getNextSuccessCont();
    if (cont !== undefined) {
      if (!(cont._op in contOpSuccess)) {
        // @ts-expect-error
        absurd(cont);
      }
      // @ts-expect-error
      return contOpSuccess[cont._op](this, cont, value);
    } else {
      throw exitSucceed(value);
    }
  }
  [OP_SUCCESS](op) {
    const oldCur = op;
    const cont = this.getNextSuccessCont();
    if (cont !== undefined) {
      if (!(cont._op in contOpSuccess)) {
        // @ts-expect-error
        absurd(cont);
      }
      // @ts-expect-error
      return contOpSuccess[cont._op](this, cont, oldCur.i0);
    } else {
      throw oldCur;
    }
  }
  [OP_FAILURE](op) {
    const cause = op.i0;
    const cont = this.getNextFailCont();
    if (cont !== undefined) {
      switch (cont._op) {
        case OP_ON_FAILURE$1:
        case OP_ON_SUCCESS_AND_FAILURE:
          {
            if (!(interruptible$2(this._runtimeFlags) && this.isInterrupted())) {
              return cont.i1(cause);
            } else {
              return exitFailCause(stripFailures(cause));
            }
          }
        case "OnStep":
          {
            if (!(interruptible$2(this._runtimeFlags) && this.isInterrupted())) {
              return cont.i1(exitFailCause(cause));
            } else {
              return exitFailCause(stripFailures(cause));
            }
          }
        case OP_REVERT_FLAGS:
          {
            this.patchRuntimeFlags(this._runtimeFlags, cont.patch);
            if (interruptible$2(this._runtimeFlags) && this.isInterrupted()) {
              return exitFailCause(sequential$2(cause, this.getInterruptedCause()));
            } else {
              return exitFailCause(cause);
            }
          }
        default:
          {
            absurd(cont);
          }
      }
    } else {
      throw exitFailCause(cause);
    }
  }
  [OP_WITH_RUNTIME](op) {
    return op.i0(this, running$1(this._runtimeFlags));
  }
  ["Blocked"](op) {
    if (this._steps[this._steps.length - 1]) {
      const nextOp = this.popStack();
      if (nextOp) {
        switch (nextOp._op) {
          case "OnStep":
            {
              return nextOp.i1(op);
            }
          case "OnSuccess":
            {
              return blocked$1(op.i0, flatMap$6(op.i1, nextOp.i1));
            }
          case "OnSuccessAndFailure":
            {
              return blocked$1(op.i0, matchCauseEffect$1(op.i1, {
                onFailure: nextOp.i1,
                onSuccess: nextOp.i2
              }));
            }
          case "OnFailure":
            {
              return blocked$1(op.i0, catchAllCause$4(op.i1, nextOp.i1));
            }
          case "While":
            {
              return blocked$1(op.i0, flatMap$6(op.i1, a => {
                nextOp.i2(a);
                if (nextOp.i0()) {
                  return whileLoop$1({
                    while: nextOp.i0,
                    body: nextOp.i1,
                    step: nextOp.i2
                  });
                }
                return unit$6;
              }));
            }
          case "RevertFlags":
            {
              this.pushStack(nextOp);
              break;
            }
        }
      }
    }
    return uninterruptibleMask$1(restore => flatMap$6(fork$2(runRequestBlock$1(op.i0)), () => restore(op.i1)));
  }
  ["RunBlocked"](op) {
    return runBlockedRequests(op.i0);
  }
  [OP_UPDATE_RUNTIME_FLAGS](op) {
    const updateFlags = op.i0;
    const oldRuntimeFlags = this._runtimeFlags;
    const newRuntimeFlags = patch$4(oldRuntimeFlags, updateFlags);
    // One more chance to short circuit: if we're immediately going
    // to interrupt. Interruption will cause immediate reversion of
    // the flag, so as long as we "peek ahead", there's no need to
    // set them to begin with.
    if (interruptible$2(newRuntimeFlags) && this.isInterrupted()) {
      return exitFailCause(this.getInterruptedCause());
    } else {
      // Impossible to short circuit, so record the changes
      this.patchRuntimeFlags(this._runtimeFlags, updateFlags);
      if (op.i1) {
        // Since we updated the flags, we need to revert them
        const revertFlags = diff$3(newRuntimeFlags, oldRuntimeFlags);
        this.pushStack(new RevertFlags(revertFlags, op));
        return op.i1(oldRuntimeFlags);
      } else {
        return exitUnit;
      }
    }
  }
  [OP_ON_SUCCESS$1](op) {
    this.pushStack(op);
    return op.i0;
  }
  ["OnStep"](op) {
    this.pushStack(op);
    return op.i0;
  }
  [OP_ON_FAILURE$1](op) {
    this.pushStack(op);
    return op.i0;
  }
  [OP_ON_SUCCESS_AND_FAILURE](op) {
    this.pushStack(op);
    return op.i0;
  }
  [OP_ASYNC](op) {
    this._asyncBlockingOn = op.i1;
    this.initiateAsync(this._runtimeFlags, op.i0);
    throw op;
  }
  [OP_YIELD$1](op) {
    this.isYielding = false;
    throw op;
  }
  [OP_WHILE](op) {
    const check = op.i0;
    const body = op.i1;
    if (check()) {
      this.pushStack(op);
      return body();
    } else {
      return exitUnit;
    }
  }
  [OP_COMMIT](op) {
    return op.commit();
  }

  /**
   * The main run-loop for evaluating effects.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  runLoop(effect0) {
    let cur = effect0;
    this.currentOpCount = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      if ((this._runtimeFlags & OpSupervision) !== 0) {
        this._supervisor.onEffect(this, cur);
      }
      if (this._queue.length > 0) {
        cur = this.drainQueueWhileRunning(this._runtimeFlags, cur);
      }
      if (!this.isYielding) {
        this.currentOpCount += 1;
        const shouldYield = this._scheduler.shouldYield(this);
        if (shouldYield !== false) {
          this.isYielding = true;
          this.currentOpCount = 0;
          const oldCur = cur;
          cur = flatMap$6(yieldNow$2({
            priority: shouldYield
          }), () => oldCur);
        }
      }
      try {
        if (!("_op" in cur)) {
          console.log(cur);
        }
        if (!(cur._op in this)) {
          if (typeof cur === "function") {
            console.log(cur());
          }
          // @ts-expect-error
          absurd(cur);
        }
        // @ts-expect-error
        cur = this._tracer.context(
        // @ts-expect-error
        () => this[cur._op](cur), this);
      } catch (e) {
        if (isEffect$1(e)) {
          if (e._op === OP_YIELD$1 || e._op === OP_ASYNC) {
            throw e;
          }
          if (e._op === OP_SUCCESS || e._op === OP_FAILURE) {
            return e;
          }
        } else {
          if (isEffectError(e)) {
            cur = exitFailCause(e.cause);
          } else if (isInterruptedException(e)) {
            cur = exitFailCause(sequential$2(die$a(e), interrupt$8(none$6)));
          } else {
            cur = exitFailCause(die$a(e));
          }
        }
      }
    }
  }
  run = () => {
    this.drainQueueOnCurrentThread();
  };
}

// circular with Logger

/** @internal */
const currentMinimumLogLevel = /*#__PURE__*/fiberRefUnsafeMake( /*#__PURE__*/fromLiteral("Info"));

/** @internal */
const getConsole = refs => {
  const defaultServicesValue = getOrDefault(refs, currentServices$1);
  const cnsl = get$j(defaultServicesValue, consoleTag);
  return cnsl.unsafe;
};

/** @internal */
const defaultLogger = /*#__PURE__*/makeLogger(options => {
  const formatted = stringLogger.log(options);
  getConsole(options.context).log(formatted);
});

/** @internal */
const logFmtLogger = /*#__PURE__*/makeLogger(options => {
  const formatted = logfmtLogger.log(options);
  getConsole(options.context).log(formatted);
});

/** @internal */
const tracerLogger = /*#__PURE__*/makeLogger(({
  annotations,
  cause,
  context,
  fiberId,
  logLevel,
  message
}) => {
  const span = flatMap$d(get$d(context, currentContext$1), getOption(spanTag));
  const clockService = map$n(get$d(context, currentServices$1), _ => get$j(_, clockTag));
  if (span._tag === "None" || span.value._tag === "ExternalSpan" || clockService._tag === "None") {
    return;
  }
  const attributes = Object.fromEntries(map$i(annotations, value => serializeUnknown(value)));
  attributes["effect.fiberId"] = threadName(fiberId);
  attributes["effect.logLevel"] = logLevel.label;
  if (cause !== null && cause._tag !== "Empty") {
    attributes["effect.cause"] = pretty$1(cause);
  }
  span.value.event(String(message), clockService.value.unsafeCurrentTimeNanos(), attributes);
});

/** @internal */
const currentLoggers = /*#__PURE__*/fiberRefUnsafeMakeHashSet( /*#__PURE__*/make$Z(defaultLogger, tracerLogger));

// circular with Effect

/* @internal */
const acquireRelease$2 = /*#__PURE__*/dual(args => isEffect$1(args[0]), (acquire, release) => {
  return uninterruptible$1(tap$5(acquire, a => addFinalizer$2(exit => release(a, exit))));
});

/* @internal */
const acquireReleaseInterruptible$1 = /*#__PURE__*/dual(args => isEffect$1(args[0]), (acquire, release) => {
  return ensuring$6(acquire, addFinalizer$2(exit => release(exit)));
});

/* @internal */
const addFinalizer$2 = finalizer => withFiberRuntime(runtime => {
  const acquireRefs = runtime.getFiberRefs();
  const acquireFlags = runtime._runtimeFlags;
  return flatMap$6(scope$2, scope => scopeAddFinalizerExit(scope, exit => withFiberRuntime(runtimeFinalizer => {
    const preRefs = runtimeFinalizer.getFiberRefs();
    const preFlags = runtimeFinalizer._runtimeFlags;
    const patchRefs = diff$1(preRefs, acquireRefs);
    const patchFlags = diff$3(preFlags, acquireFlags);
    const inverseRefs = diff$1(acquireRefs, preRefs);
    runtimeFinalizer.setFiberRefs(patch$1(patchRefs, runtimeFinalizer.id(), acquireRefs));
    return ensuring$6(withRuntimeFlags(finalizer(exit), patchFlags), sync$a(() => {
      runtimeFinalizer.setFiberRefs(patch$1(inverseRefs, runtimeFinalizer.id(), runtimeFinalizer.getFiberRefs()));
    }));
  })));
});

/* @internal */
const daemonChildren$1 = self => {
  const forkScope = fiberRefLocally$1(currentForkScopeOverride, some$6(globalScope));
  return forkScope(self);
};

/** @internal */
const _existsParFound = /*#__PURE__*/Symbol.for("effect/Effect/existsPar/found");

/* @internal */
const exists$2 = /*#__PURE__*/dual(args => isIterable(args[0]), (elements, f, options) => matchSimple(options, () => suspend$8(() => existsLoop(elements[Symbol.iterator](), 0, f)), () => matchEffect$3(forEachOptions(elements, (a, i) => if_$2(f(a, i), {
  onTrue: fail$f(_existsParFound),
  onFalse: unit$6
}), options), {
  onFailure: e => e === _existsParFound ? succeed$h(true) : fail$f(e),
  onSuccess: () => succeed$h(false)
})));
const existsLoop = (iterator, index, f) => {
  const next = iterator.next();
  if (next.done) {
    return succeed$h(false);
  }
  return pipe(flatMap$6(f(next.value, index), b => b ? succeed$h(b) : existsLoop(iterator, index + 1, f)));
};

/* @internal */
const filter$4 = /*#__PURE__*/dual(args => isIterable(args[0]), (elements, f, options) => {
  const predicate = options?.negate ? (a, i) => map$f(f(a, i), not$1) : f;
  return matchSimple(options, () => suspend$8(() => fromIterable$c(elements).reduceRight((effect, a, i) => zipWith$7(effect, suspend$8(() => predicate(a, i)), (list, b) => b ? [a, ...list] : list), sync$a(() => new Array()))), () => map$f(forEachOptions(elements, (a, i) => map$f(predicate(a, i), b => b ? some$6(a) : none$8()), options), compact$1));
});

// === all

const allResolveInput = input => {
  if (Array.isArray(input) || isIterable(input)) {
    return [input, none$8()];
  }
  const keys = Object.keys(input);
  const size = keys.length;
  return [keys.map(k => input[k]), some$6(values => {
    const res = {};
    for (let i = 0; i < size; i++) {
      res[keys[i]] = values[i];
    }
    return res;
  })];
};
const allValidate = (effects, reconcile, options) => {
  const eitherEffects = [];
  for (const effect of effects) {
    eitherEffects.push(either$5(effect));
  }
  return flatMap$6(forEachOptions(eitherEffects, identity$1, {
    concurrency: options?.concurrency,
    batching: options?.batching
  }), eithers => {
    const none$1 = none$8();
    const size = eithers.length;
    const errors = new Array(size);
    const successes = new Array(size);
    let errored = false;
    for (let i = 0; i < size; i++) {
      const either = eithers[i];
      if (either._tag === "Left") {
        errors[i] = some$6(either.left);
        errored = true;
      } else {
        successes[i] = either.right;
        errors[i] = none$1;
      }
    }
    if (errored) {
      return reconcile._tag === "Some" ? fail$f(reconcile.value(errors)) : fail$f(errors);
    } else if (options?.discard) {
      return unit$6;
    }
    return reconcile._tag === "Some" ? succeed$h(reconcile.value(successes)) : succeed$h(successes);
  });
};
const allEither = (effects, reconcile, options) => {
  const eitherEffects = [];
  for (const effect of effects) {
    eitherEffects.push(either$5(effect));
  }
  if (options?.discard) {
    return forEachOptions(eitherEffects, identity$1, {
      concurrency: options?.concurrency,
      batching: options?.batching,
      discard: true
    });
  }
  return map$f(forEachOptions(eitherEffects, identity$1, {
    concurrency: options?.concurrency,
    batching: options?.batching
  }), eithers => reconcile._tag === "Some" ? reconcile.value(eithers) : eithers);
};

/* @internal */
const all$2 = (arg, options) => {
  const [effects, reconcile] = allResolveInput(arg);
  if (options?.mode === "validate") {
    return allValidate(effects, reconcile, options);
  } else if (options?.mode === "either") {
    return allEither(effects, reconcile, options);
  }
  return reconcile._tag === "Some" ? map$f(forEachOptions(effects, identity$1, options), reconcile.value) : forEachOptions(effects, identity$1, options);
};

/* @internal */
const allWith$1 = options => arg => all$2(arg, options);

/* @internal */
const allSuccesses$1 = (elements, options) => map$f(all$2(fromIterable$c(elements).map(exit$1), options), filterMap$3(exit => exitIsSuccess(exit) ? some$6(exit.i0) : none$8()));

/* @internal */
const replicate$2 = /*#__PURE__*/dual(2, (self, n) => Array.from({
  length: n
}, () => self));

/* @internal */
const replicateEffect$1 = /*#__PURE__*/dual(args => isEffect$1(args[0]), (self, n, options) => all$2(replicate$2(self, n), options));

// @ts-expect-error
const forEachOptions = /*#__PURE__*/dual(args => isIterable(args[0]), (self, f, options) => withFiberRuntime(r => {
  const requestBatchingEnabled = options?.batching === true || options?.batching === "inherit" && r.getFiberRef(currentRequestBatching);
  if (options?.discard) {
    return match$c(options, () => finalizersMask$1(sequential)(restore => requestBatchingEnabled ? forEachBatchedDiscard(self, (a, i) => restore(f(a, i))) : forEachSequentialDiscard(self, (a, i) => restore(f(a, i)))), () => finalizersMask$1(parallel$1)(restore => forEachParUnboundedDiscard(self, (a, i) => restore(f(a, i)), requestBatchingEnabled)), n => finalizersMask$1(parallelN(n))(restore => forEachParNDiscard(self, n, (a, i) => restore(f(a, i)), requestBatchingEnabled)));
  }
  return match$c(options, () => finalizersMask$1(sequential)(restore => requestBatchingEnabled ? forEachParN(self, 1, (a, i) => restore(f(a, i)), true) : forEachSequential(self, (a, i) => restore(f(a, i)))), () => finalizersMask$1(parallel$1)(restore => forEachParUnbounded(self, (a, i) => restore(f(a, i)), requestBatchingEnabled)), n => finalizersMask$1(parallelN(n))(restore => forEachParN(self, n, (a, i) => restore(f(a, i)), requestBatchingEnabled)));
}));

/* @internal */
const forEachParUnbounded = (self, f, batching) => suspend$8(() => {
  const as = fromIterable$c(self);
  const array = new Array(as.length);
  const fn = (a, i) => flatMap$6(f(a, i), b => sync$a(() => array[i] = b));
  return zipRight$8(forEachParUnboundedDiscard(as, fn, batching), succeed$h(array));
});
const forEachBatchedDiscard = (self, f) => suspend$8(() => {
  const as = fromIterable$c(self);
  const size = as.length;
  if (size === 0) {
    return unit$6;
  } else if (size === 1) {
    return asUnit$4(f(as[0], 0));
  }
  const effects = as.map(f);
  const blocked$1$1 = new Array();
  const loop = i => i === effects.length ? suspend$8(() => {
    if (blocked$1$1.length > 0) {
      const requests = blocked$1$1.map(b => b.i0).reduce(par);
      return blocked$1(requests, forEachBatchedDiscard(blocked$1$1.map(b => b.i1), identity$1));
    }
    return unit$6;
  }) : flatMapStep$1(effects[i], s => {
    if (s._op === "Blocked") {
      blocked$1$1.push(s);
      return loop(i + 1);
    } else if (s._op === "Failure") {
      return suspend$8(() => {
        if (blocked$1$1.length > 0) {
          const requests = blocked$1$1.map(b => b.i0).reduce(par);
          return blocked$1(requests, flatMap$6(forEachBatchedDiscard(blocked$1$1.map(b => b.i1), identity$1), () => s));
        }
        return unit$6;
      });
    } else {
      return loop(i + 1);
    }
  });
  return loop(0);
});

/* @internal */
const forEachParUnboundedDiscard = (self, f, batching) => suspend$8(() => {
  const as = fromIterable$c(self);
  const size = as.length;
  if (size === 0) {
    return unit$6;
  } else if (size === 1) {
    return asUnit$4(f(as[0], 0));
  }
  return uninterruptibleMask$1(restore => {
    const deferred = deferredUnsafeMake(none$6);
    let ref = 0;
    const residual = [];
    const joinOrder = [];
    const process = transplant$1(graft => forEachSequential(as, (a, i) => pipe(graft(pipe(suspend$8(() => restore((batching ? step$1 : exit$1)(f(a, i)))), flatMap$6(exit => {
      switch (exit._op) {
        case "Failure":
          {
            if (residual.length > 0) {
              const requests = residual.map(blocked => blocked.i0).reduce(par);
              const _continue = forEachParUnboundedDiscard(residual, blocked => blocked.i1, batching);
              return blocked$1(requests, matchCauseEffect$1(_continue, {
                onFailure: cause => zipRight$8(deferredFail(deferred, void 0), failCause$a(parallel$3(cause, exit.cause))),
                onSuccess: () => zipRight$8(deferredFail(deferred, void 0), failCause$a(exit.cause))
              }));
            }
            return zipRight$8(deferredFail(deferred, void 0), failCause$a(exit.cause));
          }
        default:
          {
            if (exit._op === "Blocked") {
              residual.push(exit);
            }
            if (ref + 1 === size) {
              if (residual.length > 0) {
                const requests = residual.map(blocked => blocked.i0).reduce(par);
                const _continue = forEachParUnboundedDiscard(residual, blocked => blocked.i1, batching);
                return deferredSucceed(deferred, blocked$1(requests, _continue));
              } else {
                deferredUnsafeDone(deferred, exitSucceed(exitUnit));
              }
            } else {
              ref = ref + 1;
            }
            return unit$6;
          }
      }
    }))), forkDaemon$1, map$f(fiber => {
      fiber.addObserver(() => {
        joinOrder.push(fiber);
      });
      return fiber;
    }))));
    return flatMap$6(process, fibers => matchCauseEffect$1(restore(deferredAwait(deferred)), {
      onFailure: cause => flatMap$6(forEachParUnbounded(fibers, interruptFiber, batching), exits => {
        const exit = exitCollectAll(exits, {
          parallel: true
        });
        if (exit._tag === "Some" && exitIsFailure(exit.value)) {
          return failCause$a(parallel$3(stripFailures(cause), exit.value.i0));
        } else {
          return failCause$a(stripFailures(cause));
        }
      }),
      onSuccess: rest => flatMap$6(rest, () => forEachSequentialDiscard(joinOrder, f => f.inheritAll()))
    }));
  });
});

/* @internal */
const forEachParN = (self, n, f, batching) => suspend$8(() => {
  const as = fromIterable$c(self);
  const array = new Array(as.length);
  const fn = (a, i) => map$f(f(a, i), b => array[i] = b);
  return zipRight$8(forEachParNDiscard(as, n, fn, batching), succeed$h(array));
});

/* @internal */
const forEachParNDiscard = (self, n, f, batching) => suspend$8(() => {
  let i = 0;
  const iterator = self[Symbol.iterator]();
  const residual = [];
  const worker = flatMap$6(sync$a(() => iterator.next()), next => next.done ? unit$6 : flatMap$6((batching ? step$1 : exit$1)(asUnit$4(f(next.value, i++))), res => {
    switch (res._op) {
      case "Blocked":
        {
          residual.push(res);
          return worker;
        }
      case "Failure":
        {
          return res;
        }
      case "Success":
        return worker;
    }
  }));
  const effects = [];
  for (let i = 0; i < n; i++) {
    effects.push(worker);
  }
  return flatMap$6(exit$1(forEachParUnboundedDiscard(effects, identity$1, batching)), exit => {
    if (residual.length === 0) {
      return exit;
    }
    const requests = residual.map(blocked => blocked.i0).reduce(par);
    const _continue = forEachParNDiscard(residual, n, blocked => blocked.i1, batching);
    if (exit._tag === "Failure") {
      return blocked$1(requests, matchCauseEffect$1(_continue, {
        onFailure: cause => exitFailCause(parallel$3(exit.cause, cause)),
        onSuccess: () => exit
      }));
    }
    return blocked$1(requests, _continue);
  });
});

/* @internal */
const fork$2 = self => withFiberRuntime((state, status) => succeed$h(unsafeFork$1(self, state, status.runtimeFlags)));

/* @internal */
const forkDaemon$1 = self => forkWithScopeOverride(self, globalScope);

/* @internal */
const forkWithErrorHandler$1 = /*#__PURE__*/dual(2, (self, handler) => fork$2(onError$2(self, cause => {
  const either = failureOrCause$1(cause);
  switch (either._tag) {
    case "Left":
      {
        return handler(either.left);
      }
    case "Right":
      {
        return failCause$a(either.right);
      }
  }
})));

/** @internal */
const unsafeFork$1 = (effect, parentFiber, parentRuntimeFlags, overrideScope = null) => {
  const childFiber = unsafeMakeChildFiber(effect, parentFiber, parentRuntimeFlags, overrideScope);
  childFiber.resume(effect);
  return childFiber;
};

/** @internal */
const unsafeMakeChildFiber = (effect, parentFiber, parentRuntimeFlags, overrideScope = null) => {
  const childId = unsafeMake$6();
  const parentFiberRefs = parentFiber.getFiberRefs();
  const childFiberRefs = forkAs$1(parentFiberRefs, childId);
  const childFiber = new FiberRuntime(childId, childFiberRefs, parentRuntimeFlags);
  const childContext = getOrDefault$1(childFiberRefs, currentContext$1);
  const supervisor = childFiber._supervisor;
  supervisor.onStart(childContext, effect, some$6(parentFiber), childFiber);
  childFiber.addObserver(exit => supervisor.onEnd(exit, childFiber));
  const parentScope = overrideScope !== null ? overrideScope : pipe(parentFiber.getFiberRef(currentForkScopeOverride), getOrElse$3(() => parentFiber.scope()));
  parentScope.add(parentRuntimeFlags, childFiber);
  return childFiber;
};

/* @internal */
const forkWithScopeOverride = (self, scopeOverride) => withFiberRuntime((parentFiber, parentStatus) => succeed$h(unsafeFork$1(self, parentFiber, parentStatus.runtimeFlags, scopeOverride)));

/* @internal */
const mergeAll$5 = /*#__PURE__*/dual(args => isIterable(args[0]), (elements, zero, f, options) => matchSimple(options, () => fromIterable$c(elements).reduce((acc, a, i) => zipWith$7(acc, a, (acc, a) => f(acc, a, i)), succeed$h(zero)), () => flatMap$6(make$G(zero), acc => flatMap$6(forEachOptions(elements, (effect, i) => flatMap$6(effect, a => update$4(acc, b => f(b, a, i))), options), () => get$b(acc)))));

/* @internal */
const partition$3 = /*#__PURE__*/dual(args => isIterable(args[0]), (elements, f, options) => pipe(forEachOptions(elements, (a, i) => either$5(f(a, i)), options), map$f(chunk => partitionMap(chunk, identity$1))));

/* @internal */
const validateAll$2 = /*#__PURE__*/dual(args => isIterable(args[0]), (elements, f, options) => flatMap$6(partition$3(elements, f, {
  concurrency: options?.concurrency,
  batching: options?.batching
}), ([es, bs]) => es.length === 0 ? options?.discard ? unit$6 : succeed$h(bs) : fail$f(es)));

/* @internal */
const raceAll$1 = all => {
  const list = fromIterable$b(all);
  if (!isNonEmpty$5(list)) {
    return dieSync$5(() => IllegalArgumentException$1(`Received an empty collection of effects`));
  }
  const self = headNonEmpty(list);
  const effects = tailNonEmpty(list);
  const inheritAll$1$1 = res => pipe(inheritAll$1(res[1]), as$6(res[0]));
  return pipe(deferredMake(), flatMap$6(done => pipe(make$G(effects.length), flatMap$6(fails => uninterruptibleMask$1(restore => pipe(fork$2(interruptible$1(self)), flatMap$6(head => pipe(effects, forEachSequential(effect => fork$2(interruptible$1(effect))), map$f(unsafeFromArray), map$f(tail => pipe(tail, prepend$2(head))), tap$5(fibers => pipe(fibers, reduce$i(unit$6, (effect, fiber) => pipe(effect, zipRight$8(pipe(_await$2(fiber), flatMap$6(raceAllArbiter(fibers, fiber, done, fails)), fork$2, asUnit$4)))))), flatMap$6(fibers => pipe(restore(pipe(_await$3(done), flatMap$6(inheritAll$1$1))), onInterrupt$1(() => pipe(fibers, reduce$i(unit$6, (effect, fiber) => pipe(effect, zipLeft$7(interruptFiber(fiber))))))))))))))));
};

/* @internal */
const raceAllArbiter = (fibers, winner, deferred, fails) => exit => exitMatchEffect(exit, {
  onFailure: cause => pipe(modify$3(fails, fails => [fails === 0 ? pipe(deferredFailCause(deferred, cause), asUnit$4) : unit$6, fails - 1]), flatten$6),
  onSuccess: value => pipe(deferredSucceed(deferred, [value, winner]), flatMap$6(set => set ? pipe(fromIterable$b(fibers), reduce$i(unit$6, (effect, fiber) => fiber === winner ? effect : pipe(effect, zipLeft$7(interruptFiber(fiber))))) : unit$6))
});

/* @internal */
const reduceEffect$2 = /*#__PURE__*/dual(args => isIterable(args[0]), (elements, zero, f, options) => matchSimple(options, () => fromIterable$c(elements).reduce((acc, a, i) => zipWith$7(acc, a, (acc, a) => f(acc, a, i)), zero), () => suspend$8(() => pipe(mergeAll$5([zero, ...elements], none$8(), (acc, elem, i) => {
  switch (acc._tag) {
    case "None":
      {
        return some$6(elem);
      }
    case "Some":
      {
        return some$6(f(acc.value, elem, i));
      }
  }
}, options), map$f(option => {
  switch (option._tag) {
    case "None":
      {
        throw new Error("BUG: Effect.reduceEffect - please report an issue at https://github.com/Effect-TS/io/issues");
      }
    case "Some":
      {
        return option.value;
      }
  }
})))));

/* @internal */
const parallelFinalizers$1 = self => contextWithEffect$4(context => match$j(getOption(context, scopeTag), {
  onNone: () => self,
  onSome: scope => {
    switch (scope.strategy._tag) {
      case "Parallel":
        return self;
      case "Sequential":
      case "ParallelN":
        return flatMap$6(scopeFork(scope, parallel$1), inner => scopeExtend(self, inner));
    }
  }
}));

/* @internal */
const parallelNFinalizers = parallelism => self => contextWithEffect$4(context => match$j(getOption(context, scopeTag), {
  onNone: () => self,
  onSome: scope => {
    if (scope.strategy._tag === "ParallelN" && scope.strategy.parallelism === parallelism) {
      return self;
    }
    return flatMap$6(scopeFork(scope, parallelN(parallelism)), inner => scopeExtend(self, inner));
  }
}));

/* @internal */
const finalizersMask$1 = strategy => self => contextWithEffect$4(context => match$j(getOption(context, scopeTag), {
  onNone: () => self(identity$1),
  onSome: scope => {
    const patch = strategy._tag === "Parallel" ? parallelFinalizers$1 : strategy._tag === "Sequential" ? sequentialFinalizers$1 : parallelNFinalizers(strategy.parallelism);
    switch (scope.strategy._tag) {
      case "Parallel":
        return patch(self(parallelFinalizers$1));
      case "Sequential":
        return patch(self(sequentialFinalizers$1));
      case "ParallelN":
        return patch(self(parallelNFinalizers(scope.strategy.parallelism)));
    }
  }
}));

/* @internal */
const scopeWith$1 = f => flatMap$6(scopeTag, f);

/* @internal */
const scopedEffect = effect => flatMap$6(scopeMake(), scope => scopeUse(scope)(effect));

/* @internal */
const sequentialFinalizers$1 = self => contextWithEffect$4(context => match$j(getOption(context, scopeTag), {
  onNone: () => self,
  onSome: scope => {
    switch (scope.strategy._tag) {
      case "Sequential":
        return self;
      case "Parallel":
      case "ParallelN":
        return flatMap$6(scopeFork(scope, sequential), inner => scopeExtend(self, inner));
    }
  }
}));

/* @internal */
const tagMetricsScoped$1 = (key, value) => labelMetricsScoped$1([make$K(key, value)]);

/* @internal */
const labelMetricsScoped$1 = labels => labelMetricsScopedSet$1(fromIterable$7(labels));

/* @internal */
const labelMetricsScopedSet$1 = labels => fiberRefLocallyScopedWith$1(currentMetricLabels, set => pipe(set, union$6(labels)));

/* @internal */
const using$1 = /*#__PURE__*/dual(2, (self, use) => acquireUseRelease$3(scopeMake(), scope => flatMap$6(scopeExtend(self, scope), use), (scope, exit) => scopeClose(scope, exit)));

/** @internal */
const validate$1 = /*#__PURE__*/dual(args => isEffect$1(args[1]), (self, that, options) => validateWith$1(self, that, (a, b) => [a, b], options));

/** @internal */
const validateWith$1 = /*#__PURE__*/dual(args => isEffect$1(args[1]), (self, that, f, options) => flatten$6(zipWithOptions(exit$1(self), exit$1(that), (ea, eb) => exitZipWith(ea, eb, {
  onSuccess: f,
  onFailure: (ca, cb) => options?.concurrent ? parallel$3(ca, cb) : sequential$2(ca, cb)
}), options)));

/* @internal */
const validateFirst$2 = /*#__PURE__*/dual(args => isIterable(args[0]), (elements, f, options) => flip$2(forEachOptions(elements, (a, i) => flip$2(f(a, i)), options)));

/* @internal */
const withClockScoped$1 = value => fiberRefLocallyScopedWith$1(currentServices$1, add$4(clockTag, value));

/* @internal */
const withConfigProviderScoped$1 = value => fiberRefLocallyScopedWith$1(currentServices$1, add$4(configProviderTag, value));

/* @internal */
const withEarlyRelease$1 = self => scopeWith$1(parent => flatMap$6(scopeFork(parent, sequential$1), child => pipe(self, scopeExtend(child), map$f(value => [fiberIdWith$1(fiberId => scopeClose(child, exitInterrupt(fiberId))), value]))));

/** @internal */
const zipOptions = /*#__PURE__*/dual(args => isEffect$1(args[1]), (self, that, options) => zipWithOptions(self, that, (a, b) => [a, b], options));

/** @internal */
const zipLeftOptions = /*#__PURE__*/dual(args => isEffect$1(args[1]), (self, that, options) => zipWithOptions(self, that, (a, _) => a, options));

/** @internal */
const zipRightOptions = /*#__PURE__*/dual(args => isEffect$1(args[1]), (self, that, options) => zipWithOptions(self, that, (_, b) => b, options));

/** @internal */
const zipWithOptions = /*#__PURE__*/dual(args => isEffect$1(args[1]), (self, that, f, options) => map$f(all$2([self, that], {
  concurrency: options?.concurrent ? 2 : 1,
  batching: options?.batching
}), ([a, a2]) => f(a, a2)));

/* @internal */
const withRuntimeFlagsScoped = update => {
  if (update === empty$l) {
    return unit$6;
  }
  return pipe(runtimeFlags, flatMap$6(runtimeFlags => {
    const updatedRuntimeFlags = patch$4(runtimeFlags, update);
    const revertRuntimeFlags = diff$3(updatedRuntimeFlags, runtimeFlags);
    return pipe(updateRuntimeFlags(update), zipRight$8(addFinalizer$2(() => updateRuntimeFlags(revertRuntimeFlags))), asUnit$4);
  }), uninterruptible$1);
};

// circular with ReleaseMap

/* @internal */
const releaseMapReleaseAll = (strategy, exit$1$1) => self => suspend$8(() => {
  switch (self.state._tag) {
    case "Exited":
      {
        return unit$6;
      }
    case "Running":
      {
        const finalizersMap = self.state.finalizers;
        const update = self.state.update;
        const finalizers = Array.from(finalizersMap.keys()).sort((a, b) => b - a).map(key => finalizersMap.get(key));
        self.state = {
          _tag: "Exited",
          nextKey: self.state.nextKey,
          exit: exit$1$1,
          update
        };
        return isSequential(strategy) ? pipe(finalizers, forEachSequential(fin => exit$1(update(fin)(exit$1$1))), flatMap$6(results => pipe(exitCollectAll(results), map$n(exitAsUnit), getOrElse$3(() => exitUnit)))) : isParallel(strategy) ? pipe(forEachParUnbounded(finalizers, fin => exit$1(update(fin)(exit$1$1)), false), flatMap$6(results => pipe(exitCollectAll(results, {
          parallel: true
        }), map$n(exitAsUnit), getOrElse$3(() => exitUnit)))) : pipe(forEachParN(finalizers, strategy.parallelism, fin => exit$1(update(fin)(exit$1$1)), false), flatMap$6(results => pipe(exitCollectAll(results, {
          parallel: true
        }), map$n(exitAsUnit), getOrElse$3(() => exitUnit))));
      }
  }
});

// circular with Scope

/** @internal */
const scopeTag = /*#__PURE__*/Tag$1(ScopeTypeId);

/* @internal */
const scope$2 = scopeTag;

/* @internal */
const scopeMake = (strategy = sequential$1) => map$f(releaseMapMake, rm => ({
  [ScopeTypeId]: ScopeTypeId,
  [CloseableScopeTypeId]: CloseableScopeTypeId,
  strategy,
  pipe() {
    return pipeArguments(this, arguments);
  },
  fork: strategy => uninterruptible$1(pipe(scopeMake(strategy), flatMap$6(scope => pipe(releaseMapAdd(rm, exit => scopeClose(scope, exit)), tap$5(fin => scopeAddFinalizerExit(scope, fin)), as$6(scope))))),
  close: exit => asUnit$4(releaseMapReleaseAll(strategy, exit)(rm)),
  addFinalizer: fin => asUnit$4(releaseMapAdd(fin)(rm))
}));

/* @internal */
const scopeExtend = /*#__PURE__*/dual(2, (effect, scope) => mapInputContext$6(effect,
// @ts-expect-error
merge$8(make$12(scopeTag, scope))));

/* @internal */
const scopeUse = /*#__PURE__*/dual(2, (effect, scope) => pipe(effect, scopeExtend(scope), onExit$1(exit => scope.close(exit))));

// circular with Supervisor

/** @internal */
const fiberRefUnsafeMakeSupervisor = initial => fiberRefUnsafeMakePatch(initial, {
  differ: differ,
  fork: empty$b
});

// circular with FiberRef

/* @internal */
const fiberRefLocallyScoped$1 = /*#__PURE__*/dual(2, (self, value) => asUnit$4(acquireRelease$2(flatMap$6(fiberRefGet(self), oldValue => as$6(fiberRefSet(self, value), oldValue)), oldValue => fiberRefSet(self, oldValue))));

/* @internal */
const fiberRefLocallyScopedWith$1 = /*#__PURE__*/dual(2, (self, f) => fiberRefGetWith(self, a => fiberRefLocallyScoped$1(self, f(a))));

/* @internal */
const fiberRefMake = (initial, options) => fiberRefMakeWith(() => fiberRefUnsafeMake(initial, options));

/* @internal */
const fiberRefMakeWith = ref => acquireRelease$2(tap$5(sync$a(ref), ref => fiberRefUpdate(ref, identity$1)), fiberRef => fiberRefDelete(fiberRef));

/* @internal */
const fiberRefMakeContext = initial => fiberRefMakeWith(() => fiberRefUnsafeMakeContext(initial));

/* @internal */
const fiberRefMakeRuntimeFlags = initial => fiberRefMakeWith(() => fiberRefUnsafeMakeRuntimeFlags(initial));

/** @internal */
const currentRuntimeFlags = /*#__PURE__*/fiberRefUnsafeMakeRuntimeFlags(none$5);

/** @internal */
const currentSupervisor = /*#__PURE__*/fiberRefUnsafeMakeSupervisor(none$2);

// circular with Fiber

/* @internal */
const fiberAwaitAll = fibers => asUnit$4(_await$2(fiberAll(fibers)));

/** @internal */
const fiberAll = fibers => ({
  [FiberTypeId]: fiberVariance,
  id: () => fromIterable$c(fibers).reduce((id, fiber) => combine$3(id, fiber.id()), none$6),
  await: () => exit$1(forEachParUnbounded(fibers, fiber => flatten$6(fiber.await()), false)),
  children: () => map$f(forEachParUnbounded(fibers, fiber => fiber.children(), false), flatten$a),
  inheritAll: () => forEachSequentialDiscard(fibers, fiber => fiber.inheritAll()),
  poll: () => map$f(forEachSequential(fibers, fiber => fiber.poll()), reduceRight$4(some$6(exitSucceed(new Array())), (optionB, optionA) => {
    switch (optionA._tag) {
      case "None":
        {
          return none$8();
        }
      case "Some":
        {
          switch (optionB._tag) {
            case "None":
              {
                return none$8();
              }
            case "Some":
              {
                return some$6(exitZipWith(optionA.value, optionB.value, {
                  onSuccess: (a, chunk) => [a, ...chunk],
                  onFailure: parallel$3
                }));
              }
          }
        }
    }
  })),
  interruptAsFork: fiberId => forEachSequentialDiscard(fibers, fiber => fiber.interruptAsFork(fiberId)),
  pipe() {
    return pipeArguments(this, arguments);
  }
});

/* @internal */
const fiberInterruptFork = self => asUnit$4(forkDaemon$1(interruptFiber(self)));

/* @internal */
const fiberJoinAll = fibers => asUnit$4(join$1(fiberAll(fibers)));

/* @internal */
const fiberScoped = self => acquireRelease$2(succeed$h(self), interruptFiber);

//
// circular race
//

/** @internal */
const raceWith$2 = /*#__PURE__*/dual(3, (self, other, options) => raceFibersWith(self, other, {
  onSelfWin: (winner, loser) => flatMap$6(winner.await(), exit => {
    switch (exit._tag) {
      case OP_SUCCESS:
        {
          return flatMap$6(winner.inheritAll(), () => options.onSelfDone(exit, loser));
        }
      case OP_FAILURE:
        {
          return options.onSelfDone(exit, loser);
        }
    }
  }),
  onOtherWin: (winner, loser) => flatMap$6(winner.await(), exit => {
    switch (exit._tag) {
      case OP_SUCCESS:
        {
          return flatMap$6(winner.inheritAll(), () => options.onOtherDone(exit, loser));
        }
      case OP_FAILURE:
        {
          return options.onOtherDone(exit, loser);
        }
    }
  })
}));

/** @internal */
const disconnect$1 = self => uninterruptibleMask$1(restore => fiberIdWith$1(fiberId => flatMap$6(forkDaemon$1(restore(self)), fiber => pipe(restore(join$1(fiber)), onInterrupt$1(() => pipe(fiber, interruptAsFork(fiberId)))))));

/** @internal */
const race$3 = /*#__PURE__*/dual(2, (self, that) => fiberIdWith$1(parentFiberId => raceWith$2(self, that, {
  onSelfDone: (exit, right) => exitMatchEffect(exit, {
    onFailure: cause => pipe(join$1(right), mapErrorCause$3(cause2 => parallel$3(cause, cause2))),
    onSuccess: value => pipe(right, interruptAsFiber(parentFiberId), as$6(value))
  }),
  onOtherDone: (exit, left) => exitMatchEffect(exit, {
    onFailure: cause => pipe(join$1(left), mapErrorCause$3(cause2 => parallel$3(cause2, cause))),
    onSuccess: value => pipe(left, interruptAsFiber(parentFiberId), as$6(value))
  })
})));

/** @internal */
const raceFibersWith = /*#__PURE__*/dual(3, (self, other, options) => withFiberRuntime((parentFiber, parentStatus) => {
  const parentRuntimeFlags = parentStatus.runtimeFlags;
  const raceIndicator = make$W(true);
  const leftFiber = unsafeMakeChildFiber(self, parentFiber, parentRuntimeFlags, options.selfScope);
  const rightFiber = unsafeMakeChildFiber(other, parentFiber, parentRuntimeFlags, options.otherScope);
  return async$1(cb => {
    leftFiber.addObserver(() => completeRace(leftFiber, rightFiber, options.onSelfWin, raceIndicator, cb));
    rightFiber.addObserver(() => completeRace(rightFiber, leftFiber, options.onOtherWin, raceIndicator, cb));
    leftFiber.startFork(self);
    rightFiber.startFork(other);
  }, combine$3(leftFiber.id(), rightFiber.id()));
}));
const completeRace = (winner, loser, cont, ab, cb) => {
  if (compareAndSet(true, false)(ab)) {
    cb(cont(winner, loser));
  }
};

/** @internal */
const ensuring$6 = /*#__PURE__*/dual(2, (self, finalizer) => uninterruptibleMask$1(restore => matchCauseEffect$1(restore(self), {
  onFailure: cause1 => matchCauseEffect$1(finalizer, {
    onFailure: cause2 => failCause$a(sequential$2(cause1, cause2)),
    onSuccess: () => failCause$a(cause1)
  }),
  onSuccess: a => as$6(finalizer, a)
})));

/** @internal */
const invokeWithInterrupt = (dataSource, all) => fiberIdWith$1(id => flatMap$6(flatMap$6(forkDaemon$1(interruptible$1(dataSource)), processing => async$1(cb => {
  const counts = all.map(_ => _.listeners.count);
  const checkDone = () => {
    if (counts.every(count => count === 0)) {
      cleanup.forEach(f => f());
      cb(interruptFiber(processing));
    }
  };
  processing.addObserver(exit => {
    cleanup.forEach(f => f());
    cb(exit);
  });
  const cleanup = all.map((r, i) => {
    const observer = count => {
      counts[i] = count;
      checkDone();
    };
    r.listeners.addObserver(observer);
    return () => r.listeners.removeObserver(observer);
  });
  checkDone();
  return sync$a(() => {
    cleanup.forEach(f => f());
  });
})), () => suspend$8(() => {
  const residual = all.flatMap(entry => {
    if (!entry.state.completed) {
      return [entry];
    }
    return [];
  });
  return forEachSequentialDiscard(residual, entry => complete$2(entry.request, exitInterrupt(id)));
})));

/** @internal */
const interruptWhenPossible = /*#__PURE__*/dual(2, (self, all) => fiberRefGetWith(currentRequestMap, map => suspend$8(() => {
  const entries = fromIterable$c(all).flatMap(_ => map.has(_) ? [map.get(_)] : []);
  return invokeWithInterrupt(self, entries);
})));

// circular Tracer

/** @internal */
const makeSpanScoped$1 = (name, options) => acquireRelease$2(makeSpan$1(name, options), (span, exit) => flatMap$6(currentTimeNanosTracing, endTime => sync$a(() => span.end(endTime, exit))));

/* @internal */
const withTracerScoped$1 = value => fiberRefLocallyScopedWith$1(currentServices$1, add$4(tracerTag, value));

/** @internal */
const withSpanScoped$1 = /*#__PURE__*/dual(args => typeof args[0] !== "string", (self, name, options) => flatMap$6(makeSpanScoped$1(name, options), span => provideService$5(self, spanTag, span)));

/**
 * A `MapValue` represents a value in the cache. A value may either be
 * `Pending` with a `Promise` that will contain the result of computing the
 * lookup function, when it is available, or `Complete` with an `Exit` value
 * that contains the result of computing the lookup function.
 *
 * @internal
 */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const complete$1 = (key, exit, entryStats, timeToLiveMillis) => struct$2({
  _tag: "Complete",
  key,
  exit,
  entryStats,
  timeToLiveMillis
});

/** @internal */
const pending$3 = (key, deferred) => struct$2({
  _tag: "Pending",
  key,
  deferred
});

/** @internal */
const refreshing$1 = (deferred, complete) => struct$2({
  _tag: "Refreshing",
  deferred,
  complete
});

/** @internal */
const MapKeyTypeId = /*#__PURE__*/Symbol.for("effect/Cache/MapKey");

/** @internal */

/**
 * A `MapKey` represents a key in the cache. It contains mutable references
 * to the previous key and next key in the `KeySet` to support an efficient
 * implementation of a sorted set of keys.
 *
 * @internal
 */

class MapKeyImpl {
  [MapKeyTypeId] = MapKeyTypeId;
  previous = undefined;
  next = undefined;
  constructor(current) {
    this.current = current;
  }
  [symbol$1]() {
    return pipe(hash$1(this.current), combine$a(hash$1(this.previous)), combine$a(hash$1(this.next)));
  }
  [symbol](that) {
    if (this === that) {
      return true;
    }
    return isMapKey(that) && equals$1(this.current, that.current) && equals$1(this.previous, that.previous) && equals$1(this.next, that.next);
  }
}

/** @internal */
const makeMapKey = current => new MapKeyImpl(current);

/** @internal */
const isMapKey = u => typeof u === "object" && u != null && MapKeyTypeId in u;

/**
 * A `KeySet` is a sorted set of keys in the cache ordered by last access.
 * For efficiency, the set is implemented in terms of a doubly linked list
 * and is not safe for concurrent access.
 *
 * @internal
 */

class KeySetImpl {
  head = undefined;
  tail = undefined;
  add(key) {
    if (key !== this.tail) {
      if (this.tail === undefined) {
        this.head = key;
        this.tail = key;
      } else {
        const previous = key.previous;
        const next = key.next;
        if (next !== undefined) {
          key.next = undefined;
          if (previous !== undefined) {
            previous.next = next;
            next.previous = previous;
          } else {
            this.head = next;
            this.head.previous = undefined;
          }
        }
        this.tail.next = key;
        key.previous = this.tail;
        this.tail = key;
      }
    }
  }
  remove() {
    const key = this.head;
    if (key !== undefined) {
      const next = key.next;
      if (next !== undefined) {
        key.next = undefined;
        this.head = next;
        this.head.previous = undefined;
      } else {
        this.head = undefined;
        this.tail = undefined;
      }
    }
    return key;
  }
}

/** @internal */
const makeKeySet = () => new KeySetImpl();

/**
 * The `CacheState` represents the mutable state underlying the cache.
 *
 * @internal
 */

/**
 * Constructs a new `CacheState` from the specified values.
 *
 * @internal
 */
const makeCacheState$1 = (map, keys, accesses, updating, hits, misses) => ({
  map,
  keys,
  accesses,
  updating,
  hits,
  misses
});

/**
 * Constructs an initial cache state.
 *
 * @internal
 */
const initialCacheState$1 = () => makeCacheState$1(empty$k(), makeKeySet(), unbounded$6(), make$W(false), 0, 0);

/** @internal */
const CacheSymbolKey = "effect/Cache";

/** @internal */
const CacheTypeId = /*#__PURE__*/Symbol.for(CacheSymbolKey);
const cacheVariance = {
  _Key: _ => _,
  _Error: _ => _,
  _Value: _ => _
};

/** @internal */
const makeCacheStats = options => options;

/** @internal */
const makeEntryStats = loadedMillis => ({
  loadedMillis
});
class CacheImpl {
  [CacheTypeId] = cacheVariance;
  constructor(capacity, context, fiberId, lookup, timeToLive) {
    this.capacity = capacity;
    this.context = context;
    this.fiberId = fiberId;
    this.lookup = lookup;
    this.timeToLive = timeToLive;
    this.cacheState = initialCacheState$1();
  }
  get(key) {
    return map$f(this.getEither(key), merge$a);
  }
  cacheStats() {
    return sync$a(() => makeCacheStats({
      hits: this.cacheState.hits,
      misses: this.cacheState.misses,
      size: size$e(this.cacheState.map)
    }));
  }
  getOption(key) {
    return suspend$8(() => match$j(get$e(this.cacheState.map, key), {
      onNone: () => {
        const mapKey = makeMapKey(key);
        this.trackAccess(mapKey);
        this.trackMiss();
        return succeed$h(none$8());
      },
      onSome: value => this.resolveMapValue(value)
    }));
  }
  getOptionComplete(key) {
    return suspend$8(() => match$j(get$e(this.cacheState.map, key), {
      onNone: () => {
        const mapKey = makeMapKey(key);
        this.trackAccess(mapKey);
        this.trackMiss();
        return succeed$h(none$8());
      },
      onSome: value => this.resolveMapValue(value, true)
    }));
  }
  contains(key) {
    return sync$a(() => has$4(this.cacheState.map, key));
  }
  entryStats(key) {
    return sync$a(() => {
      const option = get$e(this.cacheState.map, key);
      if (isSome(option)) {
        switch (option.value._tag) {
          case "Complete":
            {
              const loaded = option.value.entryStats.loadedMillis;
              return some$6(makeEntryStats(loaded));
            }
          case "Pending":
            {
              return none$8();
            }
          case "Refreshing":
            {
              const loaded = option.value.complete.entryStats.loadedMillis;
              return some$6(makeEntryStats(loaded));
            }
        }
      }
      return none$8();
    });
  }
  getEither(key) {
    return suspend$8(() => {
      const k = key;
      let mapKey = undefined;
      let deferred = undefined;
      let value = getOrUndefined(get$e(this.cacheState.map, k));
      if (value === undefined) {
        deferred = unsafeMake$5(this.fiberId);
        mapKey = makeMapKey(k);
        if (has$4(this.cacheState.map, k)) {
          value = getOrUndefined(get$e(this.cacheState.map, k));
        } else {
          set$9(this.cacheState.map, k, pending$3(mapKey, deferred));
        }
      }
      if (value === undefined) {
        this.trackAccess(mapKey);
        this.trackMiss();
        return map$f(this.lookupValueOf(key, deferred), right);
      } else {
        return flatMap$6(this.resolveMapValue(value), match$j({
          onNone: () => this.getEither(key),
          onSome: value => succeed$h(left(value))
        }));
      }
    });
  }
  invalidate(key) {
    return sync$a(() => {
      remove$5(this.cacheState.map, key);
    });
  }
  invalidateWhen(key, when) {
    return sync$a(() => {
      const value = get$e(this.cacheState.map, key);
      if (isSome(value) && value.value._tag === "Complete") {
        if (value.value.exit._tag === "Success") {
          if (when(value.value.exit.value)) {
            remove$5(this.cacheState.map, key);
          }
        }
      }
    });
  }
  invalidateAll() {
    return sync$a(() => {
      this.cacheState.map = empty$k();
    });
  }
  refresh(key) {
    return clockWith$1(clock => suspend$8(() => {
      const k = key;
      const deferred = unsafeMake$5(this.fiberId);
      let value = getOrUndefined(get$e(this.cacheState.map, k));
      if (value === undefined) {
        if (has$4(this.cacheState.map, k)) {
          value = getOrUndefined(get$e(this.cacheState.map, k));
        } else {
          set$9(this.cacheState.map, k, pending$3(makeMapKey(k), deferred));
        }
      }
      if (value === undefined) {
        return asUnit$4(this.lookupValueOf(key, deferred));
      } else {
        switch (value._tag) {
          case "Complete":
            {
              if (this.hasExpired(clock, value.timeToLiveMillis)) {
                const found = getOrUndefined(get$e(this.cacheState.map, k));
                if (equals$1(found, value)) {
                  remove$5(this.cacheState.map, k);
                }
                return asUnit$4(this.get(key));
              }
              // Only trigger the lookup if we're still the current value, `completedResult`
              return pipe(this.lookupValueOf(key, deferred), when$4(() => {
                const current = getOrUndefined(get$e(this.cacheState.map, k));
                if (equals$1(current, value)) {
                  const mapValue = refreshing$1(deferred, value);
                  set$9(this.cacheState.map, k, mapValue);
                  return true;
                }
                return false;
              }), asUnit$4);
            }
          case "Pending":
            {
              return _await$3(value.deferred);
            }
          case "Refreshing":
            {
              return _await$3(value.deferred);
            }
        }
      }
    }));
  }
  set(key, value) {
    return clockWith$1(clock => sync$a(() => {
      const now = clock.unsafeCurrentTimeMillis();
      const k = key;
      const lookupResult = succeed$f(value);
      const mapValue = complete$1(makeMapKey(k), lookupResult, makeEntryStats(now), now + toMillis(decode(this.timeToLive(lookupResult))));
      set$9(this.cacheState.map, k, mapValue);
    }));
  }
  size() {
    return sync$a(() => {
      return size$e(this.cacheState.map);
    });
  }
  values() {
    return sync$a(() => {
      const values = [];
      for (const entry of this.cacheState.map) {
        if (entry[1]._tag === "Complete" && entry[1].exit._tag === "Success") {
          values.push(entry[1].exit.value);
        }
      }
      return values;
    });
  }
  entries() {
    return sync$a(() => {
      const values = [];
      for (const entry of this.cacheState.map) {
        if (entry[1]._tag === "Complete" && entry[1].exit._tag === "Success") {
          values.push([entry[0], entry[1].exit.value]);
        }
      }
      return values;
    });
  }
  keys() {
    return sync$a(() => {
      const keys = [];
      for (const entry of this.cacheState.map) {
        if (entry[1]._tag === "Complete" && entry[1].exit._tag === "Success") {
          keys.push(entry[0]);
        }
      }
      return keys;
    });
  }
  resolveMapValue(value, ignorePending = false) {
    return clockWith$1(clock => {
      switch (value._tag) {
        case "Complete":
          {
            this.trackAccess(value.key);
            this.trackHit();
            if (this.hasExpired(clock, value.timeToLiveMillis)) {
              remove$5(this.cacheState.map, value.key.current);
              return succeed$h(none$8());
            }
            return map$f(value.exit, some$6);
          }
        case "Pending":
          {
            this.trackAccess(value.key);
            this.trackHit();
            if (ignorePending) {
              return succeed$h(none$8());
            }
            return map$f(_await$3(value.deferred), some$6);
          }
        case "Refreshing":
          {
            this.trackAccess(value.complete.key);
            this.trackHit();
            if (this.hasExpired(clock, value.complete.timeToLiveMillis)) {
              if (ignorePending) {
                return succeed$h(none$8());
              }
              return map$f(_await$3(value.deferred), some$6);
            }
            return map$f(value.complete.exit, some$6);
          }
      }
    });
  }
  trackHit() {
    this.cacheState.hits = this.cacheState.hits + 1;
  }
  trackMiss() {
    this.cacheState.misses = this.cacheState.misses + 1;
  }
  trackAccess(key) {
    offer$5(this.cacheState.accesses, key);
    if (compareAndSet(this.cacheState.updating, false, true)) {
      let loop = true;
      while (loop) {
        const key = poll$7(this.cacheState.accesses, EmptyMutableQueue);
        if (key === EmptyMutableQueue) {
          loop = false;
        } else {
          this.cacheState.keys.add(key);
        }
      }
      let size$1 = size$e(this.cacheState.map);
      loop = size$1 > this.capacity;
      while (loop) {
        const key = this.cacheState.keys.remove();
        if (key !== undefined) {
          if (has$4(this.cacheState.map, key.current)) {
            remove$5(this.cacheState.map, key.current);
            size$1 = size$1 - 1;
            loop = size$1 > this.capacity;
          }
        } else {
          loop = false;
        }
      }
      set$a(this.cacheState.updating, false);
    }
  }
  hasExpired(clock, timeToLiveMillis) {
    return clock.unsafeCurrentTimeMillis() > timeToLiveMillis;
  }
  lookupValueOf(input, deferred) {
    return clockWith$1(clock => suspend$8(() => {
      const key = input;
      return pipe(this.lookup(input), provideContext$6(this.context), exit$1, flatMap$6(exit => {
        const now = clock.unsafeCurrentTimeMillis();
        const stats = makeEntryStats(now);
        const value = complete$1(makeMapKey(key), exit, stats, now + toMillis(decode(this.timeToLive(exit))));
        set$9(this.cacheState.map, key, value);
        return zipRight$8(done$b(deferred, exit), exit);
      }), onInterrupt$1(() => zipRight$8(interrupt$6(deferred), sync$a(() => {
        remove$5(this.cacheState.map, key);
      }))));
    }));
  }
}

/** @internal */
const make$A = options => {
  const timeToLive = decode(options.timeToLive);
  return makeWith$3({
    capacity: options.capacity,
    lookup: options.lookup,
    timeToLive: () => timeToLive
  });
};

/** @internal */
const makeWith$3 = options => map$f(all$2([context$7(), fiberId$2]), ([context, fiberId]) => new CacheImpl(options.capacity, context, fiberId, options.lookup, exit => decode(options.timeToLive(exit))));

/** @internal */
const unsafeMakeWith = (capacity, lookup, timeToLive) => new CacheImpl(capacity, empty$A(), none$7, lookup, exit => decode(timeToLive(exit)));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
CacheTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Cache` is defined in terms of a lookup function that, given a key of
 * type `Key`, can either fail with an error of type `Error` or succeed with a
 * value of type `Value`. Getting a value from the cache will either return
 * the previous result of the lookup function if it is available or else
 * compute a new result with the lookup function, put it in the cache, and
 * return it.
 *
 * A cache also has a specified capacity and time to live. When the cache is
 * at capacity the least recently accessed values in the cache will be
 * removed to make room for new values. Getting a value with a life older than
 * the specified time to live will result in a new value being computed with
 * the lookup function and returned when available.
 *
 * The cache is safe for concurrent access. If multiple fibers attempt to get
 * the same key the lookup function will only be computed once and the result
 * will be returned to all fibers.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * A ConsumerCache models a portion of a cache which is safe to share without allowing to create new values or access existing ones.
 *
 * It can be used safely to give over control for request management without leaking writer side details.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Constructs a new cache with the specified capacity, time to live, and
 * lookup function.
 *
 * @since 2.0.0
 * @category constructors
 */
make$A;

/**
 * Constructs a new cache with the specified capacity, time to live, and
 * lookup function, where the time to live can depend on the `Exit` value
 * returned by the lookup function.
 *
 * @since 2.0.0
 * @category constructors
 */
makeWith$3;

/**
 * `CacheStats` represents a snapshot of statistics for the cache as of a
 * point in time.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new `CacheStats` from the specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
makeCacheStats;

/**
 * Represents a snapshot of statistics for an entry in the cache.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new `EntryStats` from the specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
makeEntryStats;

/**
 * The `Effect<R, E, A>` type is polymorphic in values of type `E` and we can
 * work with any error type that we want. However, there is a lot of information
 * that is not inside an arbitrary `E` value. So as a result, an `Effect` needs
 * somewhere to store things like unexpected errors or defects, stack and
 * execution traces, causes of fiber interruptions, and so forth.
 *
 * Effect-TS is very strict about preserving the full information related to a
 * failure. It captures all type of errors into the `Cause` data type. `Effect`
 * uses the `Cause<E>` data type to store the full story of failure. So its
 * error model is lossless. It doesn't throw information related to the failure
 * result. So we can figure out exactly what happened during the operation of
 * our effects.
 *
 * It is important to note that `Cause` is an underlying data type representing
 * errors occuring within an `Effect` workflow. Thus, we don't usually deal with
 * `Cause`s directly. Even though it is not a data type that we deal with very
 * often, the `Cause` of a failing `Effect` workflow can be accessed at any
 * time, which gives us total access to all parallel and sequential errors in
 * occurring within our codebase.
 *
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
CauseTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
RuntimeExceptionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
InterruptedExceptionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
IllegalArgumentExceptionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
NoSuchElementExceptionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
InvalidPubSubCapacityExceptionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Cause` represents the full history of a failure resulting from running an
 * `Effect` workflow.
 *
 * Effect-TS uses a data structure from functional programming called a semiring
 * to represent the `Cause` data type. This allows us to take a base type `E`
 * (which represents the error type of an `Effect`) and capture the sequential
 * and parallel composition of errors in a fully lossless fashion.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Represents a set of methods that can be used to reduce a `Cause<E>` to a
 * specified value of type `Z` with access to a context of type `C`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Represents a generic checked exception which occurs at runtime.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Represents a checked exception which occurs when a `Fiber` is interrupted.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Represents a checked exception which occurs when an invalid argument is
 * provided to a method.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Represents a checked exception which occurs when an expected element was
 * unable to be found.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Represents a checked exception which occurs when attempting to construct a
 * `PubSub` with an invalid capacity.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * The `Empty` cause represents a lack of errors.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * The `Fail` cause represents a `Cause` which failed with an expected error of
 * type `E`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * The `Die` cause represents a `Cause` which failed as a result of a defect, or
 * in other words, an unexpected error.
 *
 * type `E`.
 * @since 2.0.0
 * @category models
 */

/**
 * The `Interrupt` cause represents failure due to `Fiber` interruption, which
 * contains the `FiberId` of the interrupted `Fiber`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * The `Parallel` cause represents the composition of two causes which occurred
 * in parallel.
 *
 * In Effect-TS programs, it is possible that two operations may be performed in
 * parallel. In these cases, the `Effect` workflow can fail for more than one
 * reason. If both computations fail, then there are actually two errors which
 * occurred in parallel. In these cases, the errors can be represented by the
 * `Parallel` cause.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * The `Sequential` cause represents the composition of two causes which occurred
 * sequentially.
 *
 * For example, if we perform Effect-TS's analog of `try-finally` (i.e.
 * `Effect.ensuring`), and both the `try` and `finally` blocks fail, we have two
 * errors which occurred sequentially. In these cases, the errors can be
 * represented by the `Sequential` cause.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new `Empty` cause.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$a = empty$n;

/**
 * Constructs a new `Fail` cause from the specified `error`.
 *
 * @since 2.0.0
 * @category constructors
 */
const fail$9 = fail$g;

/**
 * Constructs a new `Die` cause from the specified `defect`.
 *
 * @since 2.0.0
 * @category constructors
 */
const die$7 = die$a;

/**
 * Constructs a new `Interrupt` cause from the specified `fiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
const interrupt$4 = interrupt$8;

/**
 * Constructs a new `Parallel` cause from the specified `left` and `right`
 * causes.
 *
 * @since 2.0.0
 * @category constructors
 */
const parallel = parallel$3;

/**
 * Constructs a new `Sequential` cause from the specified pecified `left` and
 * `right` causes.
 *
 * @since 2.0.0
 * @category constructors
 */
sequential$2;

/**
 * Returns `true` if the specified value is a `Cause`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isCause;

/**
 * Returns `true` if the specified `Cause` is an `Empty` type, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isEmptyType;

/**
 * Returns `true` if the specified `Cause` is a `Fail` type, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isFailType;

/**
 * Returns `true` if the specified `Cause` is a `Die` type, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isDieType = isDieType$1;

/**
 * Returns `true` if the specified `Cause` is an `Interrupt` type, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isInterruptType;

/**
 * Returns `true` if the specified `Cause` is a `Sequential` type, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isSequentialType;

/**
 * Returns `true` if the specified `Cause` is a `Parallel` type, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isParallelType;

/**
 * Returns the size of the cause, calculated as the number of individual `Cause`
 * nodes found in the `Cause` semiring structure.
 *
 * @since 2.0.0
 * @category getters
 */
size$f;

/**
 * Returns `true` if the specified cause is empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty$e;

/**
 * Returns `true` if the specified cause contains a failure, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isFailure$6;

/**
 * Returns `true` if the specified cause contains a defect, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isDie;

/**
 * Returns `true` if the specified cause contains an interruption, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isInterrupted = isInterrupted$1;

/**
 * Returns `true` if the specified cause contains only interruptions (without
 * any `Die` or `Fail` causes), `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isInterruptedOnly = isInterruptedOnly$1;

/**
 * Returns a `List` of all recoverable errors of type `E` in the specified
 * cause.
 *
 * @since 2.0.0
 * @category getters
 */
failures;

/**
 * Returns a `List` of all unrecoverable defects in the specified cause.
 *
 * @since 2.0.0
 * @category getters
 */
defects;

/**
 * Returns a `HashSet` of `FiberId`s for all fibers that interrupted the fiber
 * described by the specified cause.
 *
 * @since 2.0.0
 * @category getters
 */
interruptors;

/**
 * Returns the `E` associated with the first `Fail` in this `Cause`, if one
 * exists.
 *
 * @since 2.0.0
 * @category getters
 */
failureOption;

/**
 * Returns the first checked error on the `Left` if available, if there are
 * no checked errors return the rest of the `Cause` that is known to contain
 * only `Die` or `Interrupt` causes.
 *
 * @since 2.0.0
 * @category getters
 */
const failureOrCause = failureOrCause$1;

/**
 * Converts the specified `Cause<Option<E>>` to an `Option<Cause<E>>` by
 * recursively stripping out any failures with the error `None`.
 *
 * @since 2.0.0
 * @category getters
 */
const flipCauseOption = flipCauseOption$1;

/**
 * Returns the defect associated with the first `Die` in this `Cause`, if one
 * exists.
 *
 * @since 2.0.0
 * @category getters
 */
dieOption;

/**
 * Returns the `FiberId` associated with the first `Interrupt` in the specified
 * cause, if one exists.
 *
 * @since 2.0.0
 * @category getters
 */
interruptOption;

/**
 * Remove all `Fail` and `Interrupt` nodes from the specified cause, and return
 * a cause containing only `Die` cause/finalizer defects.
 *
 * @since 2.0.0
 * @category getters
 */
keepDefects;

/**
 * Linearizes the specified cause into a `HashSet` of parallel causes where each
 * parallel cause contains a linear sequence of failures.
 *
 * @since 2.0.0
 * @category getters
 */
linearize;

/**
 * Remove all `Fail` and `Interrupt` nodes from the specified cause, and return
 * a cause containing only `Die` cause/finalizer defects.
 *
 * @since 2.0.0
 * @category getters
 */
stripFailures;

/**
 * Remove all `Die` causes that the specified partial function is defined at,
 * returning `Some` with the remaining causes or `None` if there are no
 * remaining causes.
 *
 * @since 2.0.0
 * @category getters
 */
stripSomeDefects;

/**
 * @since 2.0.0
 * @category mapping
 */
as$7;

/**
 * @since 2.0.0
 * @category mapping
 */
const map$9 = map$g;

/**
 * @since 2.0.0
 * @category sequencing
 */
flatMap$7;

/**
 * @since 2.0.0
 * @category sequencing
 */
flatten$7;

/**
 * Returns `true` if the `self` cause contains or is equal to `that` cause,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category elements
 */
contains$1;

/**
 * Squashes a `Cause` down to a single defect, chosen to be the "most important"
 * defect.
 *
 * @since 2.0.0
 * @category destructors
 */
const squash = squash$1;

/**
 * Squashes a `Cause` down to a single defect, chosen to be the "most important"
 * defect. If a recoverable error is found, the provided function will be used
 * to map the error a defect, and the resulting value will be returned.
 *
 * @since 2.0.0
 * @category destructors
 */
squashWith;

/**
 * Uses the provided partial function to search the specified cause and attempt
 * to extract information from it.
 *
 * @since 2.0.0
 * @category elements
 */
find$2;

/**
 * Filters causes which match the provided predicate out of the specified cause.
 *
 * @since 2.0.0
 * @category filtering
 */
filter$6;

/**
 * Folds the specified cause into a value of type `Z`.
 *
 * @since 2.0.0
 * @category folding
 */
match$h;

/**
 * Reduces the specified cause into a value of type `Z`, beginning with the
 * provided `zero` value.
 *
 * @since 2.0.0
 * @category folding
 */
reduce$a;

/**
 * Reduces the specified cause into a value of type `Z` using a `Cause.Reducer`.
 * Also allows for accessing the provided context during reduction.
 *
 * @since 2.0.0
 * @category folding
 */
reduceWithContext$1;

/**
 * Represents a checked exception which occurs when a `Fiber` is interrupted.
 *
 * @since 2.0.0
 * @category errors
 */
InterruptedException;

/**
 * Returns `true` if the specified value is an `InterruptedException`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isInterruptedException;

/**
 * Represents a checked exception which occurs when an invalid argument is
 * provided to a method.
 *
 * @since 2.0.0
 * @category errors
 */
const IllegalArgumentException = IllegalArgumentException$1;

/**
 * Returns `true` if the specified value is an `IllegalArgumentException`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isIllegalArgumentException;

/**
 * Represents a checked exception which occurs when an expected element was
 * unable to be found.
 *
 * @since 2.0.0
 * @category errors
 */
const NoSuchElementException = NoSuchElementException$1;

/**
 * Returns `true` if the specified value is an `NoSuchElementException`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isNoSuchElementException;

/**
 * Represents a generic checked exception which occurs at runtime.
 *
 * @since 2.0.0
 * @category errors
 */
const RuntimeException = RuntimeException$1;

/**
 * Returns `true` if the specified value is an `RuntimeException`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRuntimeException = isRuntimeException$1;

/**
 * Returns the specified `Cause` as a pretty-printed string.
 *
 * @since 2.0.0
 * @category rendering
 */
pretty$1;

/**
 * Returns the original, unproxied, instance of a thrown error
 *
 * @since 2.0.0
 * @category errors
 */
originalInstance;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
RandomTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * Returns the next numeric value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
const next$1 = next$2;

/**
 * Returns the next integer value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
nextInt$1;

/**
 * Returns the next boolean value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
nextBoolean$1;

/**
 * Returns the next numeric value in the specified range from the
 * pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
nextRange$1;

/**
 * Returns the next integer value in the specified range from the
 * pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
nextIntBetween$1;

/**
 * Uses the pseudo-random number generator to shuffle the specified iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
shuffle$1;

/**
 * Retreives the `Random` service from the context and uses it to run the
 * specified workflow.
 *
 * @since 2.0.0
 * @category constructors
 */
randomWith$1;

/** @internal */
const IntervalSymbolKey = "effect/ScheduleInterval";

/** @internal */
const IntervalTypeId = /*#__PURE__*/Symbol.for(IntervalSymbolKey);

/** @internal */
const empty$9 = {
  [IntervalTypeId]: IntervalTypeId,
  startMillis: 0,
  endMillis: 0
};

/** @internal */
const make$z = (startMillis, endMillis) => {
  if (startMillis > endMillis) {
    return empty$9;
  }
  return {
    [IntervalTypeId]: IntervalTypeId,
    startMillis,
    endMillis
  };
};

/** @internal */
const lessThan$3 = /*#__PURE__*/dual(2, (self, that) => min(self, that) === self);

/** @internal */
const min = /*#__PURE__*/dual(2, (self, that) => {
  if (self.endMillis <= that.startMillis) return self;
  if (that.endMillis <= self.startMillis) return that;
  if (self.startMillis < that.startMillis) return self;
  if (that.startMillis < self.startMillis) return that;
  if (self.endMillis <= that.endMillis) return self;
  return that;
});

/** @internal */
const max$2 = /*#__PURE__*/dual(2, (self, that) => min(self, that) === self ? that : self);

/** @internal */
const isEmpty$a = self => {
  return self.startMillis >= self.endMillis;
};

/** @internal */
const isNonEmpty$4 = self => {
  return !isEmpty$a(self);
};

/** @internal */
const intersect$4 = /*#__PURE__*/dual(2, (self, that) => {
  const start = Math.max(self.startMillis, that.startMillis);
  const end = Math.min(self.endMillis, that.endMillis);
  return make$z(start, end);
});

/** @internal */
const size$b = self => {
  return millis(self.endMillis - self.startMillis);
};

/** @internal */
const union$4 = /*#__PURE__*/dual(2, (self, that) => {
  const start = Math.max(self.startMillis, that.startMillis);
  const end = Math.min(self.endMillis, that.endMillis);
  return start < end ? none$8() : some$6(make$z(start, end));
});

/** @internal */
const after$1 = startMilliseconds => {
  return make$z(startMilliseconds, Number.POSITIVE_INFINITY);
};

/** @internal */
const before = endMilliseconds => {
  return make$z(Number.NEGATIVE_INFINITY, endMilliseconds);
};

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
IntervalTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * An `Interval` represents an interval of time. Intervals can encompass all
 * time, or no time at all.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new interval from the two specified endpoints. If the start
 * endpoint greater than the end endpoint, then a zero size interval will be
 * returned.
 *
 * @since 2.0.0
 * @category constructors
 */
const make$y = make$z;

/**
 * An `Interval` of zero-width.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty$8 = empty$9;

/**
 * Returns `true` if this `Interval` is less than `that` interval, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const lessThan$2 = lessThan$3;

/**
 * Returns the minimum of two `Interval`s.
 *
 * @since 2.0.0
 * @category ordering
 */
min;

/**
 * Returns the maximum of two `Interval`s.
 *
 * @since 2.0.0
 * @category ordering
 */
max$2;

/**
 * Returns `true` if the specified `Interval` is empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const isEmpty$9 = isEmpty$a;

/**
 * Returns `true` if the specified `Interval` is non-empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
isNonEmpty$4;

/**
 * Computes a new `Interval` which is the intersection of this `Interval` and
 * that `Interval`.
 *
 * @since 2.0.0
 * @category ordering
 */
const intersect$3 = intersect$4;

/**
 * Calculates the size of the `Interval` as the `Duration` from the start of the
 * interval to the end of the interval.
 *
 * @since 2.0.0
 * @category getters
 */
const size$a = size$b;

/**
 * Computes a new `Interval` which is the union of this `Interval` and that
 * `Interval` as a `Some`, otherwise returns `None` if the two intervals cannot
 * form a union.
 *
 * @since 2.0.0
 * @category utils
 */
union$4;

/**
 * Construct an `Interval` that includes all time equal to and after the
 * specified start time.
 *
 * @since 2.0.0
 * @category constructors
 */
const after = after$1;

/**
 * Construct an `Interval` that includes all time equal to and before the
 * specified end time.
 *
 * @category constructors
 * @since 2.0.0
 */
before;

/** @internal */
const IntervalsSymbolKey = "effect/ScheduleIntervals";

/** @internal */
const IntervalsTypeId = /*#__PURE__*/Symbol.for(IntervalsSymbolKey);

/** @internal */
const make$x = intervals => {
  return {
    [IntervalsTypeId]: IntervalsTypeId,
    intervals
  };
};
/** @internal */
const empty$7 = /*#__PURE__*/make$x( /*#__PURE__*/empty$z());

/** @internal */
const fromIterable$5 = intervals => Array.from(intervals).reduce((intervals, interval) => pipe(intervals, union$3(make$x(of$3(interval)))), empty$7);

/** @internal */
const union$3 = /*#__PURE__*/dual(2, (self, that) => {
  if (!isNonEmpty$5(that.intervals)) {
    return self;
  }
  if (!isNonEmpty$5(self.intervals)) {
    return that;
  }
  if (headNonEmpty(self.intervals).startMillis < headNonEmpty(that.intervals).startMillis) {
    return unionLoop(tailNonEmpty(self.intervals), that.intervals, headNonEmpty(self.intervals), empty$z());
  }
  return unionLoop(self.intervals, tailNonEmpty(that.intervals), headNonEmpty(that.intervals), empty$z());
});

/** @internal */
const unionLoop = (_self, _that, _interval, _acc) => {
  let self = _self;
  let that = _that;
  let interval = _interval;
  let acc = _acc;
  while (isNonEmpty$5(self) || isNonEmpty$5(that)) {
    if (!isNonEmpty$5(self) && isNonEmpty$5(that)) {
      if (interval.endMillis < headNonEmpty(that).startMillis) {
        acc = pipe(acc, prepend$2(interval));
        interval = headNonEmpty(that);
        that = tailNonEmpty(that);
        self = empty$z();
      } else {
        interval = make$y(interval.startMillis, headNonEmpty(that).endMillis);
        that = tailNonEmpty(that);
        self = empty$z();
      }
    } else if (isNonEmpty$5(self) && isEmpty$h(that)) {
      if (interval.endMillis < headNonEmpty(self).startMillis) {
        acc = pipe(acc, prepend$2(interval));
        interval = headNonEmpty(self);
        that = empty$z();
        self = tailNonEmpty(self);
      } else {
        interval = make$y(interval.startMillis, headNonEmpty(self).endMillis);
        that = empty$z();
        self = tailNonEmpty(self);
      }
    } else if (isNonEmpty$5(self) && isNonEmpty$5(that)) {
      if (headNonEmpty(self).startMillis < headNonEmpty(that).startMillis) {
        if (interval.endMillis < headNonEmpty(self).startMillis) {
          acc = pipe(acc, prepend$2(interval));
          interval = headNonEmpty(self);
          self = tailNonEmpty(self);
        } else {
          interval = make$y(interval.startMillis, headNonEmpty(self).endMillis);
          self = tailNonEmpty(self);
        }
      } else if (interval.endMillis < headNonEmpty(that).startMillis) {
        acc = pipe(acc, prepend$2(interval));
        interval = headNonEmpty(that);
        that = tailNonEmpty(that);
      } else {
        interval = make$y(interval.startMillis, headNonEmpty(that).endMillis);
        that = tailNonEmpty(that);
      }
    } else {
      throw new Error("BUG: Intervals.unionLoop - please report an issue at https://github.com/Effect-TS/io/issues");
    }
  }
  return make$x(pipe(acc, prepend$2(interval), reverse$1));
};

/** @internal */
const intersect$2 = /*#__PURE__*/dual(2, (self, that) => intersectLoop(self.intervals, that.intervals, empty$z()));

/** @internal */
const intersectLoop = (_left, _right, _acc) => {
  let left = _left;
  let right = _right;
  let acc = _acc;
  while (isNonEmpty$5(left) && isNonEmpty$5(right)) {
    const interval = pipe(headNonEmpty(left), intersect$3(headNonEmpty(right)));
    const intervals = isEmpty$9(interval) ? acc : pipe(acc, prepend$2(interval));
    if (pipe(headNonEmpty(left), lessThan$2(headNonEmpty(right)))) {
      left = tailNonEmpty(left);
    } else {
      right = tailNonEmpty(right);
    }
    acc = intervals;
  }
  return make$x(reverse$1(acc));
};

/** @internal */
const start$2 = self => {
  return pipe(self.intervals, head$4, getOrElse$3(() => empty$8)).startMillis;
};

/** @internal */
const end$4 = self => {
  return pipe(self.intervals, head$4, getOrElse$3(() => empty$8)).endMillis;
};

/** @internal */
const lessThan$1 = /*#__PURE__*/dual(2, (self, that) => start$2(self) < start$2(that));

/** @internal */
const isNonEmpty$3 = self => {
  return isNonEmpty$5(self.intervals);
};

/** @internal */
const max$1 = /*#__PURE__*/dual(2, (self, that) => lessThan$1(self, that) ? that : self);

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
IntervalsTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * An `Intervals` represents a list of several `Interval`s.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Creates a new `Intervals` from a `List` of `Interval`s.
 *
 * @since 2.0.0
 * @category constructors
 */
const make$w = make$x;

/**
 * Constructs an empty list of `Interval`s.
 *
 * @since 2.0.0
 * @category constructors
 */
empty$7;

/**
 * Constructs `Intervals` from the specified `Iterable<Interval>`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterable$5;

/**
 * Computes the union of this `Intervals` and  that `Intervals`
 *
 * @since 2.0.0
 * @category utils
 */
const union$2 = union$3;

/**
 * Produces the intersection of this `Intervals` and that `Intervals`.
 *
 * @since 2.0.0
 * @category utils
 */
const intersect$1 = intersect$2;

/**
 * The start of the earliest interval in the specified `Intervals`.
 *
 * @since 2.0.0
 * @category getters
 */
const start$1 = start$2;

/**
 * The end of the latest interval in the specified `Intervals`.
 *
 * @since 2.0.0
 * @category getters
 */
const end$3 = end$4;

/**
 * Returns `true` if the start of this `Intervals` is before the start of that
 * `Intervals`, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const lessThan = lessThan$1;

/**
 * Returns `true` if this `Intervals` is non-empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isNonEmpty$2 = isNonEmpty$3;

/**
 * Returns the maximum of the two `Intervals` (i.e. which has the latest start).
 *
 * @since 2.0.0
 * @category ordering
 */
const max = max$1;

/** @internal */
const OP_CONTINUE$1 = "Continue";

/** @internal */

/** @internal */
const OP_DONE$4 = "Done";

/** @internal */

/** @internal */
const _continue$1 = intervals => {
  return {
    _tag: OP_CONTINUE$1,
    intervals
  };
};

/** @internal */
const continueWith$1 = interval => {
  return {
    _tag: OP_CONTINUE$1,
    intervals: make$w(of$3(interval))
  };
};

/** @internal */
const done$7 = {
  _tag: OP_DONE$4
};

/** @internal */
const isContinue$2 = self => {
  return self._tag === OP_CONTINUE$1;
};

/** @internal */
const isDone$3 = self => {
  return self._tag === OP_DONE$4;
};

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

const _continue = _continue$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const continueWith = continueWith$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const done$6 = done$7;

/**
 * @since 2.0.0
 * @category refinements
 */
const isContinue$1 = isContinue$2;

/**
 * @since 2.0.0
 * @category refinements
 */
const isDone$2 = isDone$3;

/** @internal */
const ScheduleSymbolKey = "effect/Schedule";

/** @internal */
const ScheduleTypeId = /*#__PURE__*/Symbol.for(ScheduleSymbolKey);

/** @internal */
const ScheduleDriverSymbolKey = "effect/ScheduleDriver";

/** @internal */
const ScheduleDriverTypeId = /*#__PURE__*/Symbol.for(ScheduleDriverSymbolKey);

/** @internal */
const scheduleVariance = {
  _Env: _ => _,
  _In: _ => _,
  _Out: _ => _
};
const scheduleDriverVariance = {
  _Env: _ => _,
  _In: _ => _,
  _Out: _ => _
};

/** @internal */
class ScheduleImpl {
  [ScheduleTypeId] = scheduleVariance;
  constructor(initial, step) {
    this.initial = initial;
    this.step = step;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
class ScheduleDriverImpl {
  [ScheduleDriverTypeId] = scheduleDriverVariance;
  constructor(schedule, ref) {
    this.schedule = schedule;
    this.ref = ref;
  }
  state() {
    return map$f(get$c(this.ref), tuple => tuple[1]);
  }
  last() {
    return flatMap$6(get$c(this.ref), ([element, _]) => {
      switch (element._tag) {
        case "None":
          {
            return failSync$6(() => NoSuchElementException$1());
          }
        case "Some":
          {
            return succeed$h(element.value);
          }
      }
    });
  }
  reset() {
    return set$7(this.ref, [none$8(), this.schedule.initial]);
  }
  next(input) {
    return pipe(map$f(get$c(this.ref), tuple => tuple[1]), flatMap$6(state => pipe(currentTimeMillis, flatMap$6(now => pipe(suspend$8(() => this.schedule.step(now, input, state)), flatMap$6(([state, out, decision]) => isDone$2(decision) ? pipe(set$7(this.ref, [some$6(out), state]), zipRight$8(fail$f(none$8()))) : pipe(set$7(this.ref, [some$6(out), state]), zipRight$8(sleep$1(millis(start$1(decision.intervals) - now))), as$6(out))))))));
  }
}

/** @internal */
const makeWithState = (initial, step) => new ScheduleImpl(initial, step);

/** @internal */
const addDelay = /*#__PURE__*/dual(2, (self, f) => addDelayEffect(self, out => sync$a(() => f(out))));

/** @internal */
const addDelayEffect = /*#__PURE__*/dual(2, (self, f) => modifyDelayEffect(self, (out, duration) => map$f(f(out), delay => sum$1(duration, decode(delay)))));

/** @internal */
const andThen = /*#__PURE__*/dual(2, (self, that) => map$8(andThenEither(self, that), merge$a));

/** @internal */
const andThenEither = /*#__PURE__*/dual(2, (self, that) => makeWithState([self.initial, that.initial, true], (now, input, state) => state[2] ? flatMap$6(self.step(now, input, state[0]), ([lState, out, decision]) => {
  if (isDone$2(decision)) {
    return map$f(that.step(now, input, state[1]), ([rState, out, decision]) => [[lState, rState, false], right(out), decision]);
  }
  return succeed$h([[lState, state[1], true], left(out), decision]);
}) : map$f(that.step(now, input, state[1]), ([rState, out, decision]) => [[state[0], rState, false], right(out), decision])));

/** @internal */
const as$5 = /*#__PURE__*/dual(2, (self, out) => map$8(self, () => out));

/** @internal */
const asUnit$3 = self => map$8(self, constVoid);

/** @internal */
const bothInOut = /*#__PURE__*/dual(2, (self, that) => makeWithState([self.initial, that.initial], (now, [in1, in2], state) => zipWith$7(self.step(now, in1, state[0]), that.step(now, in2, state[1]), ([lState, out, lDecision], [rState, out2, rDecision]) => {
  if (isContinue$1(lDecision) && isContinue$1(rDecision)) {
    const interval = pipe(lDecision.intervals, union$2(rDecision.intervals));
    return [[lState, rState], [out, out2], _continue(interval)];
  }
  return [[lState, rState], [out, out2], done$6];
})));

/** @internal */
const check$1 = /*#__PURE__*/dual(2, (self, test) => checkEffect(self, (input, out) => sync$a(() => test(input, out))));

/** @internal */
const checkEffect = /*#__PURE__*/dual(2, (self, test) => makeWithState(self.initial, (now, input, state) => flatMap$6(self.step(now, input, state), ([state, out, decision]) => {
  if (isDone$2(decision)) {
    return succeed$h([state, out, done$6]);
  }
  return map$f(test(input, out), cont => cont ? [state, out, decision] : [state, out, done$6]);
})));
/** @internal */
const collectAllInputs = () => collectAllOutputs(identity());

/** @internal */
const collectAllOutputs = self => reduce$6(self, empty$z(), (outs, out) => pipe(outs, append$1(out)));

/** @internal */
const collectUntil = f => collectAllOutputs(recurUntil(f));

/** @internal */
const collectUntilEffect = f => collectAllOutputs(recurUntilEffect(f));

/** @internal */
const collectWhile = f => collectAllOutputs(recurWhile(f));

/** @internal */
const collectWhileEffect = f => collectAllOutputs(recurWhileEffect(f));

/** @internal */
const compose$1 = /*#__PURE__*/dual(2, (self, that) => makeWithState([self.initial, that.initial], (now, input, state) => flatMap$6(self.step(now, input, state[0]), ([lState, out, lDecision]) => map$f(that.step(now, out, state[1]), ([rState, out2, rDecision]) => isDone$2(lDecision) ? [[lState, rState], out2, done$6] : isDone$2(rDecision) ? [[lState, rState], out2, done$6] : [[lState, rState], out2, _continue(pipe(lDecision.intervals, max(rDecision.intervals)))]))));

/** @internal */
const mapInput$2 = /*#__PURE__*/dual(2, (self, f) => mapInputEffect$2(self, input2 => sync$a(() => f(input2))));

/** @internal */
const mapInputContext$5 = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => mapInputContext$6(self.step(now, input, state), f)));

/** @internal */
const mapInputEffect$2 = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input2, state) => flatMap$6(f(input2), input => self.step(now, input, state))));

/** @internal */
const dayOfMonth = day => {
  return makeWithState([Number.NEGATIVE_INFINITY, 0], (now, _, state) => {
    if (!Number.isInteger(day) || day < 1 || 31 < day) {
      return dieSync$5(() => IllegalArgumentException$1(`Invalid argument in: dayOfMonth(${day}). Must be in range 1...31`));
    }
    const n = state[1];
    const initial = n === 0;
    const day0 = nextDayOfMonth(now, day, initial);
    const start = beginningOfDay(day0);
    const end = endOfDay(day0);
    const interval = make$y(start, end);
    return succeed$h([[end, n + 1], n, continueWith(interval)]);
  });
};

/** @internal */
const dayOfWeek = day => {
  return makeWithState([Number.MIN_SAFE_INTEGER, 0], (now, _, state) => {
    if (!Number.isInteger(day) || day < 1 || 7 < day) {
      return dieSync$5(() => IllegalArgumentException$1(`Invalid argument in: dayOfWeek(${day}). Must be in range 1 (Monday)...7 (Sunday)`));
    }
    const n = state[1];
    const initial = n === 0;
    const day0 = nextDay(now, day, initial);
    const start = beginningOfDay(day0);
    const end = endOfDay(day0);
    const interval = make$y(start, end);
    return succeed$h([[end, n + 1], n, continueWith(interval)]);
  });
};

/** @internal */
const delayed = /*#__PURE__*/dual(2, (self, f) => delayedEffect(self, duration => sync$a(() => f(duration))));

/** @internal */
const delayedEffect = /*#__PURE__*/dual(2, (self, f) => modifyDelayEffect(self, (_, delay) => f(delay)));

/** @internal */
const delayedSchedule = schedule => addDelay(schedule, x => x);

/** @internal */
const delays = self => makeWithState(self.initial, (now, input, state) => pipe(self.step(now, input, state), flatMap$6(([state, _, decision]) => {
  if (isDone$2(decision)) {
    return succeed$h([state, zero, decision]);
  }
  return succeed$h([state, millis(start$1(decision.intervals) - now), decision]);
})));

/** @internal */
const mapBoth$3 = /*#__PURE__*/dual(2, (self, {
  onInput,
  onOutput
}) => map$8(mapInput$2(self, onInput), onOutput));

/** @internal */
const mapBothEffect = /*#__PURE__*/dual(2, (self, {
  onInput,
  onOutput
}) => mapEffect$2(mapInputEffect$2(self, onInput), onOutput));

/** @internal */
const driver$1 = self => pipe(make$H([none$8(), self.initial]), map$f(ref => new ScheduleDriverImpl(self, ref)));

/** @internal */
const duration = durationInput => {
  const duration = decode(durationInput);
  const durationMillis = toMillis(duration);
  return makeWithState(true, (now, _, state) => succeed$h(state ? [false, duration, continueWith(after(now + durationMillis))] : [false, zero, done$6]));
};

/** @internal */
const either$4 = /*#__PURE__*/dual(2, (self, that) => union$1(self, that));

/** @internal */
const eitherWith$1 = /*#__PURE__*/dual(3, (self, that, f) => unionWith(self, that, f));

/** @internal */
const ensuring$5 = /*#__PURE__*/dual(2, (self, finalizer) => makeWithState(self.initial, (now, input, state) => flatMap$6(self.step(now, input, state), ([state, out, decision]) => isDone$2(decision) ? as$6(finalizer, [state, out, decision]) : succeed$h([state, out, decision]))));

/** @internal */
const exponential = (baseInput, factor = 2.0) => {
  const base = decode(baseInput);
  return delayedSchedule(map$8(forever$3, i => times(base, Math.pow(factor, i))));
};

/** @internal */
const fibonacci = oneInput => {
  const one = decode(oneInput);
  return delayedSchedule(pipe(unfold$1([one, one], ([a, b]) => [b, sum$1(a, b)]), map$8(out => out[0])));
};

/** @internal */
const fixed = intervalInput => {
  const interval = decode(intervalInput);
  const intervalMillis = toMillis(interval);
  return makeWithState([none$8(), 0], (now, _, [option, n]) => sync$a(() => {
    switch (option._tag) {
      case "None":
        {
          return [[some$6([now, now + intervalMillis]), n + 1], n, continueWith(after(now + intervalMillis))];
        }
      case "Some":
        {
          const [startMillis, lastRun] = option.value;
          const runningBehind = now > lastRun + intervalMillis;
          const boundary = equals$1(interval, zero) ? interval : millis(intervalMillis - (now - startMillis) % intervalMillis);
          const sleepTime = equals$1(boundary, zero) ? interval : boundary;
          const nextRun = runningBehind ? now : now + toMillis(sleepTime);
          return [[some$6([startMillis, nextRun]), n + 1], n, continueWith(after(nextRun))];
        }
    }
  }));
};

/** @internal */
const fromDelay = delay => duration(delay);

/** @internal */
const fromDelays = (delay, ...delays) => makeWithState([[delay, ...delays].map(_ => decode(_)), true], (now, _, [durations, cont]) => sync$a(() => {
  if (cont) {
    const x = durations[0];
    const interval = after(now + toMillis(x));
    if (durations.length >= 2) {
      return [[durations.slice(1), true], x, continueWith(interval)];
    }
    const y = durations.slice(1);
    return [[[x, ...y], false], x, continueWith(interval)];
  }
  return [[durations, false], zero, done$6];
}));

/** @internal */
const fromFunction$2 = f => map$8(identity(), f);

/** @internal */
const hourOfDay = hour => makeWithState([Number.NEGATIVE_INFINITY, 0], (now, _, state) => {
  if (!Number.isInteger(hour) || hour < 0 || 23 < hour) {
    return dieSync$5(() => IllegalArgumentException$1(`Invalid argument in: hourOfDay(${hour}). Must be in range 0...23`));
  }
  const n = state[1];
  const initial = n === 0;
  const hour0 = nextHour(now, hour, initial);
  const start = beginningOfHour(hour0);
  const end = endOfHour(hour0);
  const interval = make$y(start, end);
  return succeed$h([[end, n + 1], n, continueWith(interval)]);
});

/** @internal */
const identity = () => makeWithState(void 0, (now, input, state) => succeed$h([state, input, continueWith(after(now))]));

/** @internal */
const intersect = /*#__PURE__*/dual(2, (self, that) => intersectWith(self, that, intersect$1));

/** @internal */
const intersectWith = /*#__PURE__*/dual(3, (self, that, f) => makeWithState([self.initial, that.initial], (now, input, state) => pipe(zipWith$7(self.step(now, input, state[0]), that.step(now, input, state[1]), (a, b) => [a, b]), flatMap$6(([[lState, out, lDecision], [rState, out2, rDecision]]) => {
  if (isContinue$1(lDecision) && isContinue$1(rDecision)) {
    return intersectWithLoop(self, that, input, lState, out, lDecision.intervals, rState, out2, rDecision.intervals, f);
  }
  return succeed$h([[lState, rState], [out, out2], done$6]);
}))));

/** @internal */
const intersectWithLoop = (self, that, input, lState, out, lInterval, rState, out2, rInterval, f) => {
  const combined = f(lInterval, rInterval);
  if (isNonEmpty$2(combined)) {
    return succeed$h([[lState, rState], [out, out2], _continue(combined)]);
  }
  if (pipe(lInterval, lessThan(rInterval))) {
    return flatMap$6(self.step(end$3(lInterval), input, lState), ([lState, out, decision]) => {
      if (isDone$2(decision)) {
        return succeed$h([[lState, rState], [out, out2], done$6]);
      }
      return intersectWithLoop(self, that, input, lState, out, decision.intervals, rState, out2, rInterval, f);
    });
  }
  return flatMap$6(that.step(end$3(rInterval), input, rState), ([rState, out2, decision]) => {
    if (isDone$2(decision)) {
      return succeed$h([[lState, rState], [out, out2], done$6]);
    }
    return intersectWithLoop(self, that, input, lState, out, lInterval, rState, out2, decision.intervals, f);
  });
};

/** @internal */
const jittered = self => jitteredWith(self, {
  min: 0.8,
  max: 1.2
});

/** @internal */
const jitteredWith = /*#__PURE__*/dual(2, (self, options) => {
  const {
    max,
    min
  } = Object.assign({
    min: 0.8,
    max: 1.2
  }, options);
  return delayedEffect(self, duration => map$f(next$1, random => {
    const d = toMillis(duration);
    const jittered = d * min * (1 - random) + d * max * random;
    return millis(jittered);
  }));
});

/** @internal */
const linear = baseInput => {
  const base = decode(baseInput);
  return delayedSchedule(map$8(forever$3, i => times(base, i + 1)));
};

/** @internal */
const map$8 = /*#__PURE__*/dual(2, (self, f) => mapEffect$2(self, out => sync$a(() => f(out))));

/** @internal */
const mapEffect$2 = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => flatMap$6(self.step(now, input, state), ([state, out, decision]) => map$f(f(out), out2 => [state, out2, decision]))));

/** @internal */
const minuteOfHour = minute => makeWithState([Number.MIN_SAFE_INTEGER, 0], (now, _, state) => {
  if (!Number.isInteger(minute) || minute < 0 || 59 < minute) {
    return dieSync$5(() => IllegalArgumentException$1(`Invalid argument in: minuteOfHour(${minute}). Must be in range 0...59`));
  }
  const n = state[1];
  const initial = n === 0;
  const minute0 = nextMinute(now, minute, initial);
  const start = beginningOfMinute(minute0);
  const end = endOfMinute(minute0);
  const interval = make$y(start, end);
  return succeed$h([[end, n + 1], n, continueWith(interval)]);
});

/** @internal */
const modifyDelay = /*#__PURE__*/dual(2, (self, f) => modifyDelayEffect(self, (out, duration) => sync$a(() => f(out, duration))));

/** @internal */
const modifyDelayEffect = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => flatMap$6(self.step(now, input, state), ([state, out, decision]) => {
  if (isDone$2(decision)) {
    return succeed$h([state, out, decision]);
  }
  const intervals = decision.intervals;
  const delay = size$a(make$y(now, start$1(intervals)));
  return map$f(f(out, delay), durationInput => {
    const duration = decode(durationInput);
    const oldStart = start$1(intervals);
    const newStart = now + toMillis(duration);
    const delta = newStart - oldStart;
    const newEnd = Math.min(Math.max(0, end$3(intervals) + delta), Number.MAX_SAFE_INTEGER);
    const newInterval = make$y(newStart, newEnd);
    return [state, out, continueWith(newInterval)];
  });
})));

/** @internal */
const onDecision = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => flatMap$6(self.step(now, input, state), ([state, out, decision]) => as$6(f(out, decision), [state, out, decision]))));

/** @internal */
const passthrough$1 = self => makeWithState(self.initial, (now, input, state) => pipe(self.step(now, input, state), map$f(([state, _, decision]) => [state, input, decision])));

/** @internal */
const provideContext$5 = /*#__PURE__*/dual(2, (self, context) => makeWithState(self.initial, (now, input, state) => provideContext$6(self.step(now, input, state), context)));

/** @internal */
const provideService$4 = /*#__PURE__*/dual(3, (self, tag, service) => makeWithState(self.initial, (now, input, state) => contextWithEffect$4(env => provideContext$6(
// @ts-expect-error
self.step(now, input, state), add$4(env, tag, service)))));

/** @internal */
const recurUntil = f => untilInput(identity(), f);

/** @internal */
const recurUntilEffect = f => untilInputEffect(identity(), f);

/** @internal */
const recurUntilOption = pf => untilOutput(map$8(identity(), pf), isSome);

/** @internal */
const recurUpTo = durationInput => {
  const duration = decode(durationInput);
  return whileOutput(elapsed, elapsed => lessThan$5(elapsed, duration));
};

/** @internal */
const recurWhile = f => whileInput(identity(), f);

/** @internal */
const recurWhileEffect = f => whileInputEffect(identity(), f);

/** @internal */
const recurs = n => whileOutput(forever$3, out => out < n);

/** @internal */
const reduce$6 = /*#__PURE__*/dual(3, (self, zero, f) => reduceEffect$1(self, zero, (z, out) => sync$a(() => f(z, out))));

/** @internal */
const reduceEffect$1 = /*#__PURE__*/dual(3, (self, zero, f) => makeWithState([self.initial, zero], (now, input, [s, z]) => flatMap$6(self.step(now, input, s), ([s, out, decision]) => isDone$2(decision) ? succeed$h([[s, z], z, decision]) : map$f(f(z, out), z2 => [[s, z2], z, decision]))));

/** @internal */
const repetitions = self => reduce$6(self, 0, (n, _) => n + 1);

/** @internal */
const resetAfter = /*#__PURE__*/dual(2, (self, durationInput) => {
  const duration = decode(durationInput);
  return pipe(self, intersect(elapsed), resetWhen(([, time]) => greaterThanOrEqualTo(time, duration)), map$8(out => out[0]));
});

/** @internal */
const resetWhen = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => flatMap$6(self.step(now, input, state), ([state, out, decision]) => f(out) ? self.step(now, input, self.initial) : succeed$h([state, out, decision]))));

/** @internal */
const run$3 = /*#__PURE__*/dual(3, (self, now, input) => pipe(runLoop(self, now, fromIterable$b(input), self.initial, empty$z()), map$f(list => reverse$1(list))));

/** @internal */
const runLoop = (self, now, inputs, state, acc) => {
  if (!isNonEmpty$5(inputs)) {
    return succeed$h(acc);
  }
  const input = headNonEmpty(inputs);
  const nextInputs = tailNonEmpty(inputs);
  return flatMap$6(self.step(now, input, state), ([state, out, decision]) => {
    if (isDone$2(decision)) {
      return sync$a(() => pipe(acc, prepend$2(out)));
    }
    return runLoop(self, start$1(decision.intervals), nextInputs, state, prepend$2(acc, out));
  });
};

/** @internal */
const secondOfMinute = second => makeWithState([Number.NEGATIVE_INFINITY, 0], (now, _, state) => {
  if (!Number.isInteger(second) || second < 0 || 59 < second) {
    return dieSync$5(() => IllegalArgumentException$1(`Invalid argument in: secondOfMinute(${second}). Must be in range 0...59`));
  }
  const n = state[1];
  const initial = n === 0;
  const second0 = nextSecond(now, second, initial);
  const start = beginningOfSecond(second0);
  const end = endOfSecond(second0);
  const interval = make$y(start, end);
  return succeed$h([[end, n + 1], n, continueWith(interval)]);
});

/** @internal */
const spaced$1 = duration => addDelay(forever$3, () => duration);

/** @internal */
const succeed$9 = value => map$8(forever$3, () => value);

/** @internal */
const sync$6 = evaluate => map$8(forever$3, evaluate);

/** @internal */
const tapInput = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => zipRight$8(f(input), self.step(now, input, state))));

/** @internal */
const tapOutput = /*#__PURE__*/dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => tap$5(self.step(now, input, state), ([, out]) => f(out))));

/** @internal */
const unfold$1 = (initial, f) => makeWithState(initial, (now, _, state) => sync$a(() => [f(state), state, continueWith(after(now))]));

/** @internal */
const union$1 = /*#__PURE__*/dual(2, (self, that) => unionWith(self, that, union$2));

/** @internal */
const unionWith = /*#__PURE__*/dual(3, (self, that, f) => makeWithState([self.initial, that.initial], (now, input, state) => zipWith$7(self.step(now, input, state[0]), that.step(now, input, state[1]), ([lState, l, lDecision], [rState, r, rDecision]) => {
  if (isDone$2(lDecision) && isDone$2(rDecision)) {
    return [[lState, rState], [l, r], done$6];
  }
  if (isDone$2(lDecision) && isContinue$1(rDecision)) {
    return [[lState, rState], [l, r], _continue(rDecision.intervals)];
  }
  if (isContinue$1(lDecision) && isDone$2(rDecision)) {
    return [[lState, rState], [l, r], _continue(lDecision.intervals)];
  }
  if (isContinue$1(lDecision) && isContinue$1(rDecision)) {
    const combined = f(lDecision.intervals, rDecision.intervals);
    return [[lState, rState], [l, r], _continue(combined)];
  }
  throw new Error("BUG: Schedule.unionWith - please report an issue at https://github.com/Effect-TS/io/issues");
})));

/** @internal */
const untilInput = /*#__PURE__*/dual(2, (self, f) => check$1(self, (input, _) => !f(input)));

/** @internal */
const untilInputEffect = /*#__PURE__*/dual(2, (self, f) => checkEffect(self, (input, _) => negate$2(f(input))));

/** @internal */
const untilOutput = /*#__PURE__*/dual(2, (self, f) => check$1(self, (_, out) => !f(out)));

/** @internal */
const untilOutputEffect = /*#__PURE__*/dual(2, (self, f) => checkEffect(self, (_, out) => negate$2(f(out))));

/** @internal */
const upTo = /*#__PURE__*/dual(2, (self, duration) => zipLeft$5(self, recurUpTo(duration)));

/** @internal */
const whileInput = /*#__PURE__*/dual(2, (self, f) => check$1(self, (input, _) => f(input)));

/** @internal */
const whileInputEffect = /*#__PURE__*/dual(2, (self, f) => checkEffect(self, (input, _) => f(input)));

/** @internal */
const whileOutput = /*#__PURE__*/dual(2, (self, f) => check$1(self, (_, out) => f(out)));

/** @internal */
const whileOutputEffect = /*#__PURE__*/dual(2, (self, f) => checkEffect(self, (_, out) => f(out)));

/** @internal */
const windowed = intervalInput => {
  const interval = decode(intervalInput);
  const millis = toMillis(interval);
  return makeWithState([none$8(), 0], (now, _, [option, n]) => {
    switch (option._tag) {
      case "None":
        {
          return succeed$h([[some$6(now), n + 1], n, continueWith(after(now + millis))]);
        }
      case "Some":
        {
          return succeed$h([[some$6(option.value), n + 1], n, continueWith(after(now + (millis - (now - option.value) % millis)))]);
        }
    }
  });
};

/** @internal */
const zipLeft$5 = /*#__PURE__*/dual(2, (self, that) => map$8(intersect(self, that), out => out[0]));

/** @internal */
const zipRight$5 = /*#__PURE__*/dual(2, (self, that) => map$8(intersect(self, that), out => out[1]));

/** @internal */
const zipWith$4 = /*#__PURE__*/dual(3, (self, that, f) => map$8(intersect(self, that), ([out, out2]) => f(out, out2)));

// -----------------------------------------------------------------------------
// Seconds
// -----------------------------------------------------------------------------

/** @internal */
const beginningOfSecond = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0).getTime();
};

/** @internal */
const endOfSecond = now => {
  const date = new Date(beginningOfSecond(now));
  return date.setSeconds(date.getSeconds() + 1);
};

/** @internal */
const nextSecond = (now, second, initial) => {
  const date = new Date(now);
  if (date.getSeconds() === second && initial) {
    return now;
  }
  if (date.getSeconds() < second) {
    return date.setSeconds(second);
  }
  // Set seconds to the provided value and add one minute
  const newDate = new Date(date.setSeconds(second));
  return newDate.setTime(newDate.getTime() + 1000 * 60);
};

// -----------------------------------------------------------------------------
// Minutes
// -----------------------------------------------------------------------------

/** @internal */
const beginningOfMinute = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0, 0).getTime();
};

/** @internal */
const endOfMinute = now => {
  const date = new Date(beginningOfMinute(now));
  return date.setMinutes(date.getMinutes() + 1);
};

/** @internal */
const nextMinute = (now, minute, initial) => {
  const date = new Date(now);
  if (date.getMinutes() === minute && initial) {
    return now;
  }
  if (date.getMinutes() < minute) {
    return date.setMinutes(minute);
  }
  // Set minutes to the provided value and add one hour
  const newDate = new Date(date.setMinutes(minute));
  return newDate.setTime(newDate.getTime() + 1000 * 60 * 60);
};

// -----------------------------------------------------------------------------
// Hours
// -----------------------------------------------------------------------------

/** @internal */
const beginningOfHour = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0, 0, 0).getTime();
};

/** @internal */
const endOfHour = now => {
  const date = new Date(beginningOfHour(now));
  return date.setHours(date.getHours() + 1);
};

/** @internal */
const nextHour = (now, hour, initial) => {
  const date = new Date(now);
  if (date.getHours() === hour && initial) {
    return now;
  }
  if (date.getHours() < hour) {
    return date.setHours(hour);
  }
  // Set hours to the provided value and add one day
  const newDate = new Date(date.setHours(hour));
  return newDate.setTime(newDate.getTime() + 1000 * 60 * 60 * 24);
};

// -----------------------------------------------------------------------------
// Days
// -----------------------------------------------------------------------------

/** @internal */
const beginningOfDay = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();
};

/** @internal */
const endOfDay = now => {
  const date = new Date(beginningOfDay(now));
  return date.setDate(date.getDate() + 1);
};

/** @internal */
const nextDay = (now, dayOfWeek, initial) => {
  const date = new Date(now);
  if (date.getDay() === dayOfWeek && initial) {
    return now;
  }
  const nextDayOfWeek = (7 + dayOfWeek - date.getDay()) % 7;
  return date.setDate(date.getDate() + (nextDayOfWeek === 0 ? 7 : nextDayOfWeek));
};

/** @internal */
const nextDayOfMonth = (now, day, initial) => {
  const date = new Date(now);
  if (date.getDate() === day && initial) {
    return now;
  }
  if (date.getDate() < day) {
    return date.setDate(day);
  }
  return findNextMonth(now, day, 1);
};

/** @internal */
const findNextMonth = (now, day, months) => {
  const d = new Date(now);
  const tmp1 = new Date(d.setDate(day));
  const tmp2 = new Date(tmp1.setMonth(tmp1.getMonth() + months));
  if (tmp2.getDate() === day) {
    const d2 = new Date(now);
    const tmp3 = new Date(d2.setDate(day));
    return tmp3.setMonth(tmp3.getMonth() + months);
  }
  return findNextMonth(now, day, months + 1);
};

// circular with Effect

/** @internal */
const repeat_Effect = /*#__PURE__*/dual(2, (self, schedule) => repeatOrElse_Effect(self, schedule, (e, _) => fail$f(e)));

/** @internal */
const repeatOrElse_Effect = /*#__PURE__*/dual(3, (self, schedule, orElse) => flatMap$6(driver$1(schedule), driver => matchEffect$3(self, {
  onFailure: error => orElse(error, none$8()),
  onSuccess: value => repeatOrElseEffectLoop(self, driver, orElse, value)
})));

/** @internal */
const repeatOrElseEffectLoop = (self, driver, orElse, value) => {
  return matchEffect$3(driver.next(value), {
    onFailure: () => orDie$5(driver.last()),
    onSuccess: b => matchEffect$3(self, {
      onFailure: error => orElse(error, some$6(b)),
      onSuccess: value => repeatOrElseEffectLoop(self, driver, orElse, value)
    })
  });
};

/** @internal */
const repeatUntil_Effect = /*#__PURE__*/dual(2, (self, f) => repeatUntilEffect_Effect(self, a => sync$a(() => f(a))));

/** @internal */
const repeatUntilEffect_Effect = /*#__PURE__*/dual(2, (self, f) => flatMap$6(self, a => flatMap$6(f(a), result => result ? succeed$h(a) : flatMap$6(yieldNow$2(), () => repeatUntilEffect_Effect(self, f)))));

/** @internal */
const repeatWhile_Effect = /*#__PURE__*/dual(2, (self, f) => repeatWhileEffect_Effect(self, a => sync$a(() => f(a))));

/** @internal */
const repeatWhileEffect_Effect = /*#__PURE__*/dual(2, (self, f) => repeatUntilEffect_Effect(self, a => negate$2(f(a))));

/** @internal */
const retry_Effect = /*#__PURE__*/dual(2, (self, policy) => retryOrElse_Effect(self, policy, (e, _) => fail$f(e)));

/** @internal */
const retryN_Effect = /*#__PURE__*/dual(2, (self, n) => retryN_EffectLoop(self, n));

/** @internal */
const retryN_EffectLoop = (self, n) => {
  return catchAll$5(self, e => n < 0 ? fail$f(e) : flatMap$6(yieldNow$2(), () => retryN_EffectLoop(self, n - 1)));
};

/** @internal */
const retryOrElse_Effect = /*#__PURE__*/dual(3, (self, policy, orElse) => flatMap$6(driver$1(policy), driver => retryOrElse_EffectLoop(self, driver, orElse)));

/** @internal */
const retryOrElse_EffectLoop = (self, driver, orElse) => {
  return catchAll$5(self, e => matchEffect$3(driver.next(e), {
    onFailure: () => pipe(driver.last(), orDie$5, flatMap$6(out => orElse(e, out))),
    onSuccess: () => retryOrElse_EffectLoop(self, driver, orElse)
  }));
};

/** @internal */
const retryUntil_Effect = /*#__PURE__*/dual(2, (self, f) => retryUntilEffect_Effect(self, e => sync$a(() => f(e))));

/** @internal */
const retryUntilEffect_Effect = /*#__PURE__*/dual(2, (self, f) => catchAll$5(self, e => flatMap$6(f(e), b => b ? fail$f(e) : flatMap$6(yieldNow$2(), () => retryUntilEffect_Effect(self, f)))));

/** @internal */
const retryWhile_Effect = /*#__PURE__*/dual(2, (self, f) => retryWhileEffect_Effect(self, e => sync$a(() => f(e))));

/** @internal */
const retryWhileEffect_Effect = /*#__PURE__*/dual(2, (self, f) => retryUntilEffect_Effect(self, e => negate$2(f(e))));

/** @internal */
const schedule_Effect = /*#__PURE__*/dual(2, (self, schedule) => scheduleFrom_Effect(self, void 0, schedule));

/** @internal */
const scheduleFrom_Effect = /*#__PURE__*/dual(3, (self, initial, schedule) => flatMap$6(driver$1(schedule), driver => scheduleFrom_EffectLoop(self, initial, driver)));

/** @internal */
const scheduleFrom_EffectLoop = (self, initial, driver) => matchEffect$3(driver.next(initial), {
  onFailure: () => orDie$5(driver.last()),
  onSuccess: () => flatMap$6(self, a => scheduleFrom_EffectLoop(self, a, driver))
});

/** @internal */
const count$3 = /*#__PURE__*/unfold$1(0, n => n + 1);

/** @internal */
const elapsed = /*#__PURE__*/makeWithState( /*#__PURE__*/none$8(), (now, _, state) => {
  switch (state._tag) {
    case "None":
      {
        return succeed$h([some$6(now), zero, continueWith(after(now))]);
      }
    case "Some":
      {
        return succeed$h([some$6(state.value), millis(now - state.value), continueWith(after(now))]);
      }
  }
});

/** @internal */
const forever$3 = /*#__PURE__*/unfold$1(0, n => n + 1);

/** @internal */
const once$1 = /*#__PURE__*/asUnit$3( /*#__PURE__*/recurs(1));

/** @internal */
const stop = /*#__PURE__*/asUnit$3( /*#__PURE__*/recurs(0));

/** @internal */
class Semaphore {
  waiters = new Array();
  taken = 0;
  constructor(permits) {
    this.permits = permits;
  }
  get free() {
    return this.permits - this.taken;
  }
  take = n => asyncEither$1(resume => {
    if (this.free < n) {
      const observer = () => {
        if (this.free >= n) {
          const observerIndex = this.waiters.findIndex(cb => cb === observer);
          if (observerIndex !== -1) {
            this.waiters.splice(observerIndex, 1);
          }
          this.taken += n;
          resume(succeed$h(n));
        }
      };
      this.waiters.push(observer);
      return left(sync$a(() => {
        const observerIndex = this.waiters.findIndex(cb => cb === observer);
        if (observerIndex !== -1) {
          this.waiters.splice(observerIndex, 1);
        }
      }));
    }
    this.taken += n;
    return right(succeed$h(n));
  });
  release = n => withFiberRuntime(fiber => {
    this.taken -= n;
    fiber.getFiberRef(currentScheduler$1).scheduleTask(() => {
      this.waiters.forEach(wake => wake());
    }, fiber.getFiberRef(currentSchedulingPriority$1));
    return unit$6;
  });
  withPermits = n => self => uninterruptibleMask$1(restore => flatMap$6(restore(this.take(n)), permits => ensuring$6(restore(self), this.release(permits))));
}

/** @internal */
const unsafeMakeSemaphore$2 = leases => {
  return new Semaphore(leases);
};

/** @internal */
const makeSemaphore$1 = permits => sync$a(() => unsafeMakeSemaphore$2(permits));

/** @internal */
const awaitAllChildren$1 = self => ensuringChildren$1(self, fiberAwaitAll);

/** @internal */
const cached$1 = /*#__PURE__*/dual(2, (self, timeToLive) => map$f(cachedInvalidate(self, timeToLive), tuple => tuple[0]));

/** @internal */
const cachedInvalidate = /*#__PURE__*/dual(2, (self, timeToLive) => {
  const duration = decode(timeToLive);
  return flatMap$6(context$7(), env => map$f(makeSynchronized(none$8()), cache => [provideContext$6(getCachedValue(self, duration, cache), env), invalidateCache(cache)]));
});

/** @internal */
const computeCachedValue = (self, timeToLive, start) => {
  const timeToLiveMillis = toMillis(decode(timeToLive));
  return pipe(deferredMake(), tap$5(deferred => intoDeferred$1(self, deferred)), map$f(deferred => some$6([start + timeToLiveMillis, deferred])));
};

/** @internal */
const getCachedValue = (self, timeToLive, cache) => uninterruptibleMask$1(restore => pipe(clockWith$1(clock => clock.currentTimeMillis), flatMap$6(time => updateSomeAndGetEffectSynchronized(cache, option => {
  switch (option._tag) {
    case "None":
      {
        return some$6(computeCachedValue(self, timeToLive, time));
      }
    case "Some":
      {
        const [end] = option.value;
        return end - time <= 0 ? some$6(computeCachedValue(self, timeToLive, time)) : none$8();
      }
  }
})), flatMap$6(option => isNone$1(option) ? dieMessage$5("BUG: Effect.cachedInvalidate - please report an issue at https://github.com/Effect-TS/io/issues") : restore(deferredAwait(option.value[1])))));

/** @internal */
const invalidateCache = cache => set$7(cache, none$8());

/** @internal */
const ensuringChild$1 = /*#__PURE__*/dual(2, (self, f) => ensuringChildren$1(self, children => f(fiberAll(children))));

/** @internal */
const ensuringChildren$1 = /*#__PURE__*/dual(2, (self, children) => flatMap$6(track, supervisor => pipe(supervised$1(self, supervisor), ensuring$6(flatMap$6(supervisor.value(), children)))));

/** @internal */
// @ts-expect-error
const forkAll$1 = /*#__PURE__*/dual(args => isIterable(args[0]), (effects, options) => options?.discard ? forEachSequentialDiscard(effects, fork$2) : map$f(forEachSequential(effects, fork$2), fiberAll));

/** @internal */
const forkIn$1 = /*#__PURE__*/dual(2, (self, scope) => uninterruptibleMask$1(restore => flatMap$6(scope.fork(sequential$1), child => pipe(restore(self), onExit$1(exit => child.close(exit)), forkDaemon$1, tap$5(fiber => child.addFinalizer(() => fiberIdWith$1(fiberId => equals$1(fiberId, fiber.id()) ? unit$6 : asUnit$4(interruptFiber(fiber)))))))));

/** @internal */
const forkScoped$1 = self => scopeWith$1(scope => forkIn$1(self, scope));

/** @internal */
const fromFiber$1 = fiber => join$1(fiber);

/** @internal */
const fromFiberEffect$1 = fiber => suspend$8(() => flatMap$6(fiber, join$1));
const memoKeySymbol = /*#__PURE__*/Symbol.for("effect/Effect/memoizeFunction.key");
class Key {
  [memoKeySymbol] = memoKeySymbol;
  constructor(a, eq) {
    this.a = a;
    this.eq = eq;
  }
  [symbol](that) {
    if (typeof that === "object" && that !== null && memoKeySymbol in that) {
      if (this.eq) {
        return this.eq(this.a, that.a);
      } else {
        return equals$1(this.a, that.a);
      }
    }
    return false;
  }
  [symbol$1]() {
    return this.eq ? 0 : hash$1(this.a);
  }
}

/** @internal */
const memoizeFunction = (f, eq) => {
  return pipe(sync$a(() => empty$k()), flatMap$6(makeSynchronized), map$f(ref => a => pipe(ref.modifyEffect(map$1 => {
    const result = pipe(map$1, get$e(new Key(a, eq)));
    if (isNone$1(result)) {
      return pipe(deferredMake(), tap$5(deferred => pipe(diffFiberRefs$1(f(a)), intoDeferred$1(deferred), fork$2)), map$f(deferred => [deferred, pipe(map$1, set$9(new Key(a, eq), deferred))]));
    }
    return succeed$h([result.value, map$1]);
  }), flatMap$6(deferredAwait), flatMap$6(([patch, b]) => pipe(patchFiberRefs$1(patch), as$6(b))))));
};

/** @internal */
const raceFirst$1 = /*#__PURE__*/dual(2, (self, that) => pipe(exit$1(self), race$3(exit$1(that)), effect => flatten$6(effect)));

/** @internal */
const scheduleForked$1 = /*#__PURE__*/dual(2, (self, schedule) => pipe(self, schedule_Effect(schedule), forkScoped$1));

/** @internal */
const supervised$1 = /*#__PURE__*/dual(2, (self, supervisor) => {
  const supervise = fiberRefLocallyWith$1(currentSupervisor, s => s.zip(supervisor));
  return supervise(self);
});

/** @internal */
const timeout$2 = /*#__PURE__*/dual(2, (self, duration) => timeoutTo$2(self, {
  onTimeout: none$8,
  onSuccess: some$6,
  duration
}));

/** @internal */
const timeoutFail$2 = /*#__PURE__*/dual(2, (self, {
  duration,
  onTimeout
}) => flatten$6(timeoutTo$2(self, {
  onTimeout: () => failSync$6(onTimeout),
  onSuccess: succeed$h,
  duration
})));

/** @internal */
const timeoutFailCause$2 = /*#__PURE__*/dual(2, (self, {
  duration,
  onTimeout
}) => flatten$6(timeoutTo$2(self, {
  onTimeout: () => failCauseSync$5(onTimeout),
  onSuccess: succeed$h,
  duration
})));

/** @internal */
const timeoutTo$2 = /*#__PURE__*/dual(2, (self, {
  duration,
  onSuccess,
  onTimeout
}) => fiberIdWith$1(parentFiberId => raceFibersWith(self, interruptible$1(sleep$1(duration)), {
  onSelfWin: (winner, loser) => flatMap$6(winner.await(), exit => {
    if (exit._tag === "Success") {
      return flatMap$6(winner.inheritAll(), () => as$6(interruptAsFiber(loser, parentFiberId), onSuccess(exit.value)));
    } else {
      return flatMap$6(interruptAsFiber(loser, parentFiberId), () => exitFailCause(exit.cause));
    }
  }),
  onOtherWin: (winner, loser) => flatMap$6(winner.await(), exit => {
    if (exit._tag === "Success") {
      return flatMap$6(winner.inheritAll(), () => as$6(interruptAsFiber(loser, parentFiberId), onTimeout()));
    } else {
      return flatMap$6(interruptAsFiber(loser, parentFiberId), () => exitFailCause(exit.cause));
    }
  }),
  otherScope: globalScope
})));

// circular with Synchronized

/** @internal */
const SynchronizedSymbolKey = "effect/Ref/SynchronizedRef";

/** @internal */
const SynchronizedTypeId = /*#__PURE__*/Symbol.for(SynchronizedSymbolKey);

/** @internal */
const synchronizedVariance = {
  _A: _ => _
};

/** @internal */
class SynchronizedImpl {
  [SynchronizedTypeId] = synchronizedVariance;
  [RefTypeId$1] = refVariance;
  constructor(ref, withLock) {
    this.ref = ref;
    this.withLock = withLock;
  }
  modify(f) {
    return this.modifyEffect(a => succeed$h(f(a)));
  }
  modifyEffect(f) {
    return this.withLock(pipe(flatMap$6(get$c(this.ref), f), flatMap$6(([b, a]) => as$6(set$7(this.ref, a), b))));
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const makeSynchronized = value => sync$a(() => unsafeMakeSynchronized(value));

/** @internal */
const unsafeMakeSynchronized = value => {
  const ref = unsafeMake$3(value);
  const sem = unsafeMakeSemaphore$2(1);
  return new SynchronizedImpl(ref, sem.withPermits(1));
};

/** @internal */
const updateSomeAndGetEffectSynchronized = /*#__PURE__*/dual(2, (self, pf) => self.modifyEffect(value => {
  const result = pf(value);
  switch (result._tag) {
    case "None":
      {
        return succeed$h([value, value]);
      }
    case "Some":
      {
        return map$f(result.value, a => [a, a]);
      }
  }
}));

// circular with Fiber

/** @internal */
const zipFiber = /*#__PURE__*/dual(2, (self, that) => zipWithFiber(self, that, (a, b) => [a, b]));

/** @internal */
const zipLeftFiber = /*#__PURE__*/dual(2, (self, that) => zipWithFiber(self, that, (a, _) => a));

/** @internal */
const zipRightFiber = /*#__PURE__*/dual(2, (self, that) => zipWithFiber(self, that, (_, b) => b));

/** @internal */
const zipWithFiber = /*#__PURE__*/dual(3, (self, that, f) => ({
  [FiberTypeId]: fiberVariance,
  id: () => pipe(self.id(), getOrElse$1(that.id())),
  await: () => pipe(self.await(), flatten$6, zipWithOptions(flatten$6(that.await()), f, {
    concurrent: true
  }), exit$1),
  children: () => self.children(),
  inheritAll: () => zipRight$8(that.inheritAll(), self.inheritAll()),
  poll: () => zipWith$7(self.poll(), that.poll(), (optionA, optionB) => pipe(optionA, flatMap$d(exitA => pipe(optionB, map$n(exitB => zipWith$6(exitA, exitB, {
    onSuccess: f,
    onFailure: parallel$3
  })))))),
  interruptAsFork: id => zipRight$8(self.interruptAsFork(id), that.interruptAsFork(id)),
  pipe() {
    return pipeArguments(this, arguments);
  }
}));

/** @internal */
const OP_EXTEND_SCOPE = "ExtendScope";

/** @internal */

/** @internal */
const OP_FOLD$1 = "Fold";

/** @internal */

/** @internal */
const OP_FRESH = "Fresh";

/** @internal */

/** @internal */
const OP_FROM_EFFECT$2 = "FromEffect";

/** @internal */

/** @internal */
const OP_SCOPED = "Scoped";

/** @internal */

/** @internal */
const OP_SUSPEND$2 = "Suspend";

/** @internal */

/** @internal */
const OP_PROVIDE_TO = "ProvideTo";

/** @internal */

/** @internal */
const OP_ZIP_WITH = "ZipWith";

/** @internal */

/** @internal */
const OP_ZIP_WITH_PAR = "ZipWithPar";

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
FiberTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
RuntimeFiberTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A fiber is a lightweight thread of execution that never consumes more than a
 * whole thread (but may consume much less, depending on contention and
 * asynchronicity). Fibers are spawned by forking effects, which run
 * concurrently with the parent effect.
 *
 * Fibers can be joined, yielding their result to other fibers, or interrupted,
 * which terminates the fiber, safely releasing all resources.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * A runtime fiber that is executing an effect. Runtime fibers have an
 * identity and a trace.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category instances
 */
Order;

/**
 * Returns `true` if the specified value is a `Fiber`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isFiber;

/**
 * Returns `true` if the specified `Fiber` is a `RuntimeFiber`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isRuntimeFiber;

/**
 * The identity of the fiber.
 *
 * @since 2.0.0
 * @category getters
 */
id;
const _await$1 = _await$2;

/**
 * Awaits on all fibers to be completed, successfully or not.
 *
 * @since 2.0.0
 * @category destructors
 */
fiberAwaitAll;

/**
 * Retrieves the immediate children of the fiber.
 *
 * @since 2.0.0
 * @category getters
 */
children;

/**
 * Collects all fibers into a single fiber producing an in-order list of the
 * results.
 *
 * @since 2.0.0
 * @category constructors
 */
fiberAll;

/**
 * A fiber that is done with the specified `Exit` value.
 *
 * @since 2.0.0
 * @category constructors
 */
done$8;

/**
 * @since 2.0.0
 * @category destructors
 */
dump;

/**
 * @since 2.0.0
 * @category destructors
 */
dumpAll;

/**
 * A fiber that has already failed with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$b;

/**
 * Creates a `Fiber` that has already failed with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
failCause$7;

/**
 * Lifts an `Effect` into a `Fiber`.
 *
 * @since 2.0.0
 * @category conversions
 */
fromEffect$6;

/**
 * Gets the current fiber if one is running.
 *
 * @since 2.0.0
 * @category utilities
 */
getCurrentFiber;

/**
 * Inherits values from all `FiberRef` instances into current fiber. This
 * will resume immediately.
 *
 * @since 2.0.0
 * @category destructors
 */
const inheritAll = inheritAll$1;

/**
 * Interrupts the fiber from whichever fiber is calling this method. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interrupt$3 = interruptFiber;

/**
 * Constructrs a `Fiber` that is already interrupted.
 *
 * @since 2.0.0
 * @category constructors
 */
interrupted$1;

/**
 * Interrupts the fiber as if interrupted from the specified fiber. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAs$2 = interruptAsFiber;

/**
 * Interrupts the fiber as if interrupted from the specified fiber. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
interruptAsFork;

/**
 * Interrupts all fibers, awaiting their interruption.
 *
 * @since 2.0.0
 * @category interruption
 */
interruptAll;

/**
 * Interrupts all fibers as by the specified fiber, awaiting their
 * interruption.
 *
 * @since 2.0.0
 * @category interruption
 */
interruptAllAs;

/**
 * Interrupts the fiber from whichever fiber is calling this method. The
 * interruption will happen in a separate daemon fiber, and the returned
 * effect will always resume immediately without waiting.
 *
 * @since 2.0.0
 * @category interruption
 */
fiberInterruptFork;

/**
 * Joins the fiber, which suspends the joining fiber until the result of the
 * fiber has been determined. Attempting to join a fiber that has erred will
 * result in a catchable error. Joining an interrupted fiber will result in an
 * "inner interruption" of this fiber, unlike interruption triggered by
 * another fiber, "inner interruption" can be caught and recovered.
 *
 * @since 2.0.0
 * @category destructors
 */
const join = join$1;

/**
 * Joins all fibers, awaiting their _successful_ completion. Attempting to
 * join a fiber that has erred will result in a catchable error, _if_ that
 * error does not result from interruption.
 *
 * @since 2.0.0
 * @category destructors
 */
fiberJoinAll;

/**
 * Maps over the value the Fiber computes.
 *
 * @since 2.0.0
 * @category mapping
 */
map$c;

/**
 * Effectually maps over the value the fiber computes.
 *
 * @since 2.0.0
 * @category mapping
 */
mapEffect$3;

/**
 * Passes the success of this fiber to the specified callback, and continues
 * with the fiber that it returns.
 *
 * @since 2.0.0
 * @category mapping
 */
mapFiber;

/**
 * Folds over the `Fiber` or `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category folding
 */
match$b;

/**
 * A fiber that never fails or succeeds.
 *
 * @since 2.0.0
 * @category constructors
 */
never$5;

/**
 * Returns a fiber that prefers `this` fiber, but falls back to the `that` one
 * when `this` one fails. Interrupting the returned fiber will interrupt both
 * fibers, sequentially, from left to right.
 *
 * @since 2.0.0
 * @category alternatives
 */
orElse$7;

/**
 * Returns a fiber that prefers `this` fiber, but falls back to the `that` one
 * when `this` one fails. Interrupting the returned fiber will interrupt both
 * fibers, sequentially, from left to right.
 *
 * @since 2.0.0
 * @category alternatives
 */
orElseEither$2;

/**
 * Tentatively observes the fiber, but returns immediately if it is not
 * already done.
 *
 * @since 2.0.0
 * @category getters
 */
const poll$5 = poll$6;

/**
 * Pretty-prints a `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category destructors
 */
pretty;

/**
 * Returns a chunk containing all root fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
roots;

/**
 * Returns a chunk containing all root fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
unsafeRoots;

/**
 * Converts this fiber into a scoped effect. The fiber is interrupted when the
 * scope is closed.
 *
 * @since 2.0.0
 * @category destructors
 */
fiberScoped;

/**
 * Returns the `FiberStatus` of a `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category getters
 */
status;

/**
 * Returns a fiber that has already succeeded with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$d;

/**
 * A fiber that has already succeeded with unit.
 *
 * @since 2.0.0
 * @category constructors
 */
unit$4;

/**
 * Zips this fiber and the specified fiber together, producing a tuple of
 * their output.
 *
 * @since 2.0.0
 * @category zipping
 */
zipFiber;

/**
 * Same as `zip` but discards the output of that `Fiber`.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLeftFiber;

/**
 * Same as `zip` but discards the output of this `Fiber`.
 *
 * @since 2.0.0
 * @category zipping
 */
zipRightFiber;

/**
 * Zips this fiber with the specified fiber, combining their results using the
 * specified combiner function. Both joins and interruptions are performed in
 * sequential order from left to right.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWithFiber;

/** @internal */
const unsafeFork = runtime => (self, options) => {
  const fiberId = unsafeMake$6();
  const effect = self;
  let fiberRefs = updatedAs(runtime.fiberRefs, {
    fiberId,
    fiberRef: currentContext$1,
    value: runtime.context
  });
  if (options?.scheduler) {
    fiberRefs = updatedAs(fiberRefs, {
      fiberId,
      fiberRef: currentScheduler$1,
      value: options.scheduler
    });
  }
  if (options?.updateRefs) {
    fiberRefs = options.updateRefs(fiberRefs, fiberId);
  }
  const fiberRuntime = new FiberRuntime(fiberId, forkAs(fiberRefs, fiberId), runtime.runtimeFlags);
  const supervisor = fiberRuntime._supervisor;

  // we can compare by reference here as _supervisor.none is wrapped with globalValue
  if (supervisor !== none$2) {
    supervisor.onStart(runtime.context, effect, none$8(), fiberRuntime);
    fiberRuntime.addObserver(exit => supervisor.onEnd(exit, fiberRuntime));
  }
  globalScope.add(runtime.runtimeFlags, fiberRuntime);
  fiberRuntime.start(effect);
  return fiberRuntime;
};

/** @internal */
const unsafeRunCallback = runtime => (effect, onExit) => {
  const fiberRuntime = unsafeFork(runtime)(effect);
  if (onExit) {
    fiberRuntime.addObserver(exit => {
      onExit(exit);
    });
  }
  return (id, onExitInterrupt) => unsafeRunCallback(runtime)(pipe(fiberRuntime, interruptAs$2(id ?? none$6)), onExitInterrupt ? exit => onExitInterrupt(flatten$5(exit)) : void 0);
};

/** @internal */
const unsafeRunSync = runtime => effect => {
  const result = unsafeRunSyncExit(runtime)(effect);
  if (result._tag === "Failure") {
    throw fiberFailure(result.i0);
  } else {
    return result.i0;
  }
};

/** @internal */
const asyncFiberException = fiber => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 0;
  const error = new Error();
  Error.stackTraceLimit = limit;
  const message = `Fiber #${fiber.id().id} cannot be be resolved synchronously, this is caused by using runSync on an effect that performs async work`;
  const _tag = "AsyncFiberException";
  Object.defineProperties(error, {
    _tag: {
      value: _tag
    },
    fiber: {
      value: fiber
    },
    message: {
      value: message
    },
    name: {
      value: _tag
    },
    toString: {
      get() {
        return () => message;
      }
    },
    [NodeInspectSymbol]: {
      get() {
        return () => message;
      }
    }
  });
  return error;
};

/** @internal */
const isAsyncFiberException = u => isTagged(u, "AsyncFiberException") && "fiber" in u;

/** @internal */
const FiberFailureId = /*#__PURE__*/Symbol.for("effect/Runtime/FiberFailure");
/** @internal */
const FiberFailureCauseId = /*#__PURE__*/Symbol.for("effect/Runtime/FiberFailure/Cause");
/** @internal */
const fiberFailure = cause => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 0;
  const error = new Error();
  Error.stackTraceLimit = limit;
  const prettyErrors$1 = prettyErrors(cause);
  if (prettyErrors$1.length > 0) {
    const head = prettyErrors$1[0];
    error.name = head.message.split(":")[0];
    error.message = head.message.substring(error.name.length + 2);
    error.stack = `${error.name}: ${error.message}\n${head.stack}`;
  }
  error[FiberFailureId] = FiberFailureId;
  error[FiberFailureCauseId] = cause;
  error.toJSON = () => {
    return {
      _id: "FiberFailure",
      cause: cause.toJSON()
    };
  };
  error.toString = () => {
    return toString(error.toJSON());
  };
  error[NodeInspectSymbol] = () => {
    return error.toJSON();
  };
  return error;
};

/** @internal */
const isFiberFailure = u => typeof u === "object" && u !== null && FiberFailureId in u;
const fastPath = effect => {
  const op = effect;
  switch (op._op) {
    case "Failure":
    case "Success":
      {
        // @ts-expect-error
        return op;
      }
    case "Left":
      {
        return exitFail(op.left);
      }
    case "Right":
      {
        return exitSucceed(op.right);
      }
    case "Some":
      {
        return exitSucceed(op.value);
      }
    case "None":
      {
        // @ts-expect-error
        return exitFail(NoSuchElementException$1());
      }
  }
};

/** @internal */
const unsafeRunSyncExit = runtime => effect => {
  const op = fastPath(effect);
  if (op) {
    return op;
  }
  const scheduler = new SyncScheduler();
  const fiberRuntime = unsafeFork(runtime)(effect, {
    scheduler
  });
  scheduler.flush();
  const result = fiberRuntime.unsafePoll();
  if (result) {
    return result;
  }
  throw asyncFiberException(fiberRuntime);
};

/** @internal */
const unsafeRunPromise = runtime => effect => unsafeRunPromiseExit(runtime)(effect).then(result => {
  switch (result._tag) {
    case OP_SUCCESS:
      {
        return result.i0;
      }
    case OP_FAILURE:
      {
        throw fiberFailure(result.i0);
      }
  }
});

/** @internal */
const unsafeRunPromiseExit = runtime => effect => new Promise(resolve => {
  const op = fastPath(effect);
  if (op) {
    resolve(op);
  }
  unsafeFork(runtime)(effect).addObserver(exit => {
    resolve(exit);
  });
});

/** @internal */
class RuntimeImpl {
  constructor(context, runtimeFlags, fiberRefs) {
    this.context = context;
    this.runtimeFlags = runtimeFlags;
    this.fiberRefs = fiberRefs;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const make$v = options => new RuntimeImpl(options.context, options.runtimeFlags, options.fiberRefs);

/** @internal */
const runtime$1 = () => withFiberRuntime((state, status) => succeed$h(new RuntimeImpl(state.getFiberRef(currentContext$1), status.runtimeFlags, state.getFiberRefs())));

/** @internal */
const defaultRuntimeFlags = /*#__PURE__*/make$T(Interruption, CooperativeYielding, RuntimeMetrics);

/** @internal */
const defaultRuntime = /*#__PURE__*/make$v({
  context: /*#__PURE__*/empty$A(),
  runtimeFlags: defaultRuntimeFlags,
  fiberRefs: /*#__PURE__*/empty$g()
});

/** @internal */
const unsafeRunEffect = /*#__PURE__*/unsafeRunCallback(defaultRuntime);

/** @internal */
const unsafeForkEffect = /*#__PURE__*/unsafeFork(defaultRuntime);

/** @internal */
const unsafeRunPromiseEffect = /*#__PURE__*/unsafeRunPromise(defaultRuntime);

/** @internal */
const unsafeRunPromiseExitEffect = /*#__PURE__*/unsafeRunPromiseExit(defaultRuntime);

/** @internal */
const unsafeRunSyncEffect = /*#__PURE__*/unsafeRunSync(defaultRuntime);

/** @internal */
const unsafeRunSyncExitEffect = /*#__PURE__*/unsafeRunSyncExit(defaultRuntime);

// circular with Effect

/** @internal */
const asyncEffect$2 = register => flatMap$6(deferredMake(), deferred => flatMap$6(runtime$1(), runtime => uninterruptibleMask$1(restore => zipRight$8(fork$2(restore(catchAllCause$4(register(cb => unsafeRunCallback(runtime)(intoDeferred$1(cb, deferred))), cause => deferredFailCause(deferred, cause)))), restore(deferredAwait(deferred))))));

/** @internal */
const getAndUpdateEffect = /*#__PURE__*/dual(2, (self, f) => self.modifyEffect(value => map$f(f(value), result => [value, result])));

/** @internal */
const getAndUpdateSomeEffect = /*#__PURE__*/dual(2, (self, pf) => self.modifyEffect(value => {
  const result = pf(value);
  switch (result._tag) {
    case "None":
      {
        return succeed$h([value, value]);
      }
    case "Some":
      {
        return map$f(result.value, newValue => [value, newValue]);
      }
  }
}));

/** @internal */
const modify$2 = /*#__PURE__*/dual(2, (self, f) => self.modify(f));

/** @internal */
const modifyEffect$1 = /*#__PURE__*/dual(2, (self, f) => self.modifyEffect(f));

/** @internal */
const modifySomeEffect = /*#__PURE__*/dual(3, (self, fallback, pf) => self.modifyEffect(value => pipe(pf(value), getOrElse$3(() => succeed$h([fallback, value])))));

/** @internal */
const updateEffect = /*#__PURE__*/dual(2, (self, f) => self.modifyEffect(value => map$f(f(value), result => [undefined, result])));

/** @internal */
const updateAndGetEffect = /*#__PURE__*/dual(2, (self, f) => self.modifyEffect(value => map$f(f(value), result => [result, result])));

/** @internal */
const updateSomeEffect = /*#__PURE__*/dual(2, (self, pf) => self.modifyEffect(value => {
  const result = pf(value);
  switch (result._tag) {
    case "None":
      {
        return succeed$h([void 0, value]);
      }
    case "Some":
      {
        return map$f(result.value, a => [void 0, a]);
      }
  }
}));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ScopeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
CloseableScopeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category context
 */
const Scope = scopeTag;

/**
 * @since 2.0.0
 */

/**
 * Adds a finalizer to this scope. The finalizer is guaranteed to be run when
 * the scope is closed.
 *
 * @since 2.0.0
 * @category utils
 */
const addFinalizer$1 = scopeAddFinalizer;

/**
 * A simplified version of `addFinalizerWith` when the `finalizer` does not
 * depend on the `Exit` value that the scope is closed with.
 *
 * @since 2.0.0
 * @category utils
 */
scopeAddFinalizerExit;

/**
 * Closes a scope with the specified exit value, running all finalizers that
 * have been added to the scope.
 *
 * @since 2.0.0
 * @category destructors
 */
const close$1 = scopeClose;

/**
 * Extends the scope of an `Effect` workflow that needs a scope into this
 * scope by providing it to the workflow but not closing the scope when the
 * workflow completes execution. This allows extending a scoped value into a
 * larger scope.
 *
 * @since 2.0.0
 * @category utils
 */
const extend = scopeExtend;

/**
 * Forks a new scope that is a child of this scope. The child scope will
 * automatically be closed when this scope is closed.
 *
 * @since 2.0.0
 * @category utils
 */
const fork$1 = scopeFork;

/**
 * Uses the scope by providing it to an `Effect` workflow that needs a scope,
 * guaranteeing that the scope is closed with the result of that workflow as
 * soon as the workflow completes execution, whether by success, failure, or
 * interruption.
 *
 * @since 2.0.0
 * @category destructors
 */
const use$1 = scopeUse;

/**
 * Creates a Scope where Finalizers will run according to the `ExecutionStrategy`.
 *
 * If an ExecutionStrategy is not provided `sequential` will be used.
 *
 * @since 2.0.0
 * @category constructors
 */
const make$u = scopeMake;

/** @internal */
const LayerSymbolKey = "effect/Layer";

/** @internal */
const LayerTypeId = /*#__PURE__*/Symbol.for(LayerSymbolKey);

/** @internal */
const layerVariance = {
  _RIn: _ => _,
  _E: _ => _,
  _ROut: _ => _
};

/** @internal */
const proto$8 = {
  [LayerTypeId]: layerVariance,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const isLayer = u => {
  return typeof u === "object" && u != null && LayerTypeId in u;
};

/** @internal */
const isFresh = self => {
  return self._tag === OP_FRESH;
};

// -----------------------------------------------------------------------------
// MemoMap
// -----------------------------------------------------------------------------

/** @internal */
class MemoMap {
  constructor(ref) {
    this.ref = ref;
  }

  /**
   * Checks the memo map to see if a layer exists. If it is, immediately
   * returns it. Otherwise, obtains the layer, stores it in the memo map,
   * and adds a finalizer to the `Scope`.
   */
  getOrElseMemoize(layer, scope) {
    return pipe(modifyEffect$1(this.ref, map => {
      const inMap = map.get(layer);
      if (inMap !== undefined) {
        const [acquire, release] = inMap;
        const cached = pipe(acquire, flatMap$6(([patch, b]) => pipe(patchFiberRefs$1(patch), as$6(b))), onExit$1(exitMatch({
          onFailure: () => unit$6,
          onSuccess: () => scopeAddFinalizerExit(scope, release)
        })));
        return succeed$h([cached, map]);
      }
      return pipe(make$H(0), flatMap$6(observers => pipe(deferredMake(), flatMap$6(deferred => pipe(make$H(() => unit$6), map$f(finalizerRef => {
        const resource = uninterruptibleMask$1(restore => pipe(scopeMake(), flatMap$6(innerScope => pipe(restore(flatMap$6(withScope(layer, innerScope), f => diffFiberRefs$1(f(this)))), exit$1, flatMap$6(exit => {
          switch (exit._tag) {
            case OP_FAILURE:
              {
                return pipe(deferredFailCause(deferred, exit.i0), zipRight$8(scopeClose(innerScope, exit)), zipRight$8(failCause$a(exit.i0)));
              }
            case OP_SUCCESS:
              {
                return pipe(set$7(finalizerRef, exit => pipe(scopeClose(innerScope, exit), whenEffect$2(modify$4(observers, n => [n === 1, n - 1])), asUnit$4)), zipRight$8(update$5(observers, n => n + 1)), zipRight$8(scopeAddFinalizerExit(scope, exit => pipe(get$c(finalizerRef), flatMap$6(finalizer => finalizer(exit))))), zipRight$8(deferredSucceed(deferred, exit.i0)), as$6(exit.i0[1]));
              }
          }
        })))));
        const memoized = [pipe(deferredAwait(deferred), onExit$1(exitMatchEffect({
          onFailure: () => unit$6,
          onSuccess: () => update$5(observers, n => n + 1)
        }))), exit => pipe(get$c(finalizerRef), flatMap$6(finalizer => finalizer(exit)))];
        return [resource, isFresh(layer) ? map : map.set(layer, memoized)];
      }))))));
    }), flatten$6);
  }
}
const makeMemoMap = () => map$f(makeSynchronized(new Map()), ref => new MemoMap(ref));

/** @internal */
const build$1 = self => scopeWith$1(scope => buildWithScope(self, scope));

/** @internal */
const buildWithScope = /*#__PURE__*/dual(2, (self, scope) => flatMap$6(makeMemoMap(), memoMap => flatMap$6(withScope(self, scope), run => run(memoMap))));
const withScope = (self, scope) => {
  const op = self;
  switch (op._tag) {
    case "Locally":
      {
        return sync$a(() => memoMap => op.f(memoMap.getOrElseMemoize(op.self, scope)));
      }
    case "ExtendScope":
      {
        return sync$a(() => memoMap => scopeWith$1(scope => memoMap.getOrElseMemoize(op.layer, scope)));
      }
    case "Fold":
      {
        return sync$a(() => memoMap => pipe(memoMap.getOrElseMemoize(op.layer, scope), matchCauseEffect$1({
          onFailure: cause => memoMap.getOrElseMemoize(op.failureK(cause), scope),
          onSuccess: value => memoMap.getOrElseMemoize(op.successK(value), scope)
        })));
      }
    case "Fresh":
      {
        return sync$a(() => _ => pipe(op.layer, buildWithScope(scope)));
      }
    case "FromEffect":
      {
        return sync$a(() => _ => op.effect);
      }
    case "ProvideTo":
      {
        return sync$a(() => memoMap => pipe(memoMap.getOrElseMemoize(op.first, scope), flatMap$6(env => pipe(memoMap.getOrElseMemoize(op.second, scope), provideContext$6(env)))));
      }
    case "Scoped":
      {
        return sync$a(() => _ => scopeExtend(op.effect, scope));
      }
    case "Suspend":
      {
        return sync$a(() => memoMap => memoMap.getOrElseMemoize(op.evaluate(), scope));
      }
    case "ZipWith":
      {
        return sync$a(() => memoMap => pipe(memoMap.getOrElseMemoize(op.first, scope), zipWith$7(memoMap.getOrElseMemoize(op.second, scope), op.zipK)));
      }
    case "ZipWithPar":
      {
        return sync$a(() => memoMap => pipe(memoMap.getOrElseMemoize(op.first, scope), zipWithOptions(memoMap.getOrElseMemoize(op.second, scope), op.zipK, {
          concurrent: true
        })));
      }
  }
};

// -----------------------------------------------------------------------------
// Layer
// -----------------------------------------------------------------------------

/** @internal */
const catchAll$4 = /*#__PURE__*/dual(2, (self, onFailure) => match$a(self, {
  onFailure,
  onSuccess: succeedContext
}));

/** @internal */
const catchAllCause$3 = /*#__PURE__*/dual(2, (self, onFailure) => matchCause$1(self, {
  onFailure,
  onSuccess: succeedContext
}));

/** @internal */
const die$6 = defect => failCause$6(die$7(defect));

/** @internal */
const dieSync$4 = evaluate => failCauseSync$4(() => die$7(evaluate()));

/** @internal */
const discard = self => map$7(self, () => empty$A());

/** @internal */
const context$6 = () => fromEffectContext(context$7());

/** @internal */
const extendScope = self => {
  const extendScope = Object.create(proto$8);
  extendScope._tag = OP_EXTEND_SCOPE;
  extendScope.layer = self;
  return extendScope;
};

/** @internal */
const fail$8 = error => failCause$6(fail$9(error));

/** @internal */
const failSync$5 = evaluate => failCauseSync$4(() => fail$9(evaluate()));

/** @internal */
const failCause$6 = cause => fromEffectContext(failCause$a(cause));

/** @internal */
const failCauseSync$4 = evaluate => fromEffectContext(failCauseSync$5(evaluate));

/** @internal */
const flatMap$5 = /*#__PURE__*/dual(2, (self, f) => match$a(self, {
  onFailure: fail$8,
  onSuccess: f
}));

/** @internal */
const flatten$4 = /*#__PURE__*/dual(2, (self, tag) => flatMap$5(self, get$j(tag)));

/** @internal */
const fresh = self => {
  const fresh = Object.create(proto$8);
  fresh._tag = OP_FRESH;
  fresh.layer = self;
  return fresh;
};

/** @internal */
const fromEffect$4 = /*#__PURE__*/dual(2, (a, b) => {
  const tagFirst = isTag(a);
  const tag = tagFirst ? a : b;
  const effect = tagFirst ? b : a;
  return fromEffectContext(map$f(effect, service => make$12(tag, service)));
});

/** @internal */
const fromEffectDiscard = effect => fromEffectContext(map$f(effect, () => empty$A()));

/** @internal */
function fromEffectContext(effect) {
  const fromEffect = Object.create(proto$8);
  fromEffect._tag = OP_FROM_EFFECT$2;
  fromEffect.effect = effect;
  return fromEffect;
}

/** @internal */
const fiberRefLocally = /*#__PURE__*/dual(3, (self, ref, value) => locallyEffect(self, fiberRefLocally$1(ref, value)));

/** @internal */
const locallyEffect = /*#__PURE__*/dual(2, (self, f) => {
  const locally = Object.create(proto$8);
  locally._tag = "Locally";
  locally.self = self;
  locally.f = f;
  return locally;
});

/** @internal */
const fiberRefLocallyWith = /*#__PURE__*/dual(3, (self, ref, value) => locallyEffect(self, fiberRefLocallyWith$1(ref, value)));

/** @internal */
const fiberRefLocallyScoped = (self, value) => scopedDiscard(fiberRefLocallyScoped$1(self, value));

/** @internal */
const fiberRefLocallyScopedWith = (self, value) => scopedDiscard(fiberRefLocallyScopedWith$1(self, value));

/** @internal */
const fromFunction$1 = (tagA, tagB, f) => fromEffectContext(map$f(tagA, a => make$12(tagB, f(a))));

/** @internal */
const launch$1 = self => scopedEffect(zipRight$8(scopeWith$1(scope => pipe(self, buildWithScope(scope))), never$6));

/** @internal */
const map$7 = /*#__PURE__*/dual(2, (self, f) => flatMap$5(self, context => succeedContext(f(context))));

/** @internal */
const mapError$5 = /*#__PURE__*/dual(2, (self, f) => catchAll$4(self, error => failSync$5(() => f(error))));

/** @internal */
const matchCause$1 = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => {
  const fold = Object.create(proto$8);
  fold._tag = OP_FOLD$1;
  fold.layer = self;
  fold.failureK = onFailure;
  fold.successK = onSuccess;
  return fold;
});

/** @internal */
const match$a = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchCause$1(self, {
  onFailure: cause => {
    const failureOrCause$1 = failureOrCause(cause);
    switch (failureOrCause$1._tag) {
      case "Left":
        {
          return onFailure(failureOrCause$1.left);
        }
      case "Right":
        {
          return failCause$6(failureOrCause$1.right);
        }
    }
  },
  onSuccess
}));

/** @internal */
const memoize = self => scopeWith$1(scope => map$f(memoize$1(buildWithScope(self, scope)), fromEffectContext));

/** @internal */
const merge$5 = /*#__PURE__*/dual(2, (self, that) => zipWithPar(self, that, (a, b) => pipe(a, merge$8(b))));

/** @internal */
const mergeAll$4 = (...layers) => {
  let final = layers[0];
  for (let i = 1; i < layers.length; i++) {
    final = merge$5(layers[i])(final);
  }
  return final;
};

/** @internal */
const orDie$4 = self => catchAll$4(self, defect => die$6(defect));

/** @internal */
const orElse$6 = /*#__PURE__*/dual(2, (self, that) => catchAll$4(self, that));

/** @internal */
const passthrough = self => merge$5(context$6(), self);

/** @internal */
const project = /*#__PURE__*/dual(4, (self, tagA, tagB, f) => map$7(self, context => make$12(tagB, f(unsafeGet$6(context, tagA)))));

/** @internal */
const provide$1 = /*#__PURE__*/dual(2, (self, that) => suspend$6(() => {
  const provideTo = Object.create(proto$8);
  provideTo._tag = OP_PROVIDE_TO;
  provideTo.first = Object.create(proto$8, {
    _tag: {
      value: OP_ZIP_WITH,
      enumerable: true
    },
    first: {
      value: context$6(),
      enumerable: true
    },
    second: {
      value: self
    },
    zipK: {
      value: (a, b) => merge$8(a, b)
    }
  });
  provideTo.second = that;
  return provideTo;
}));

/** @internal */
const provideMerge = /*#__PURE__*/dual(2, (self, that) => {
  const zipWith = Object.create(proto$8);
  zipWith._tag = OP_ZIP_WITH;
  zipWith.first = self;
  zipWith.second = pipe(self, provide$1(that));
  zipWith.zipK = (a, b) => merge$8(a, b);
  return zipWith;
});

/** @internal */
const retry$6 = /*#__PURE__*/dual(2, (self, schedule) => suspend$6(() => {
  const stateTag = Tag$1();
  return pipe(succeed$8(stateTag, {
    state: schedule.initial
  }), flatMap$5(env => retryLoop(self, schedule, stateTag, pipe(env, get$j(stateTag)).state)));
}));

/** @internal */
const retryLoop = (self, schedule, stateTag, state) => {
  return pipe(self, catchAll$4(error => pipe(retryUpdate(schedule, stateTag, error, state), flatMap$5(env => fresh(retryLoop(self, schedule, stateTag, pipe(env, get$j(stateTag)).state))))));
};

/** @internal */
const retryUpdate = (schedule, stateTag, error, state) => {
  return fromEffect$4(stateTag, pipe(currentTimeMillis, flatMap$6(now => pipe(schedule.step(now, error, state), flatMap$6(([state, _, decision]) => isDone$2(decision) ? fail$f(error) : pipe(sleep$2(millis(start$1(decision.intervals) - now)), as$6({
    state
  })))))));
};

/** @internal */
const scoped$3 = /*#__PURE__*/dual(2, (a, b) => {
  const tagFirst = isTag(a);
  const tag = tagFirst ? a : b;
  const effect = tagFirst ? b : a;
  return scopedContext(map$f(effect, service => make$12(tag, service)));
});

/** @internal */
const scopedDiscard = effect => {
  return scopedContext(pipe(effect, as$6(empty$A())));
};

/** @internal */
const scopedContext = effect => {
  const scoped = Object.create(proto$8);
  scoped._tag = OP_SCOPED;
  scoped.effect = effect;
  return scoped;
};

/** @internal */
const scope$1 = /*#__PURE__*/scopedContext( /*#__PURE__*/map$f( /*#__PURE__*/acquireRelease$2( /*#__PURE__*/scopeMake(), (scope, exit) => scope.close(exit)), scope => make$12(Scope, scope)));

/** @internal */
const service = tag => {
  return fromEffect$4(tag, tag);
};

/** @internal */
const succeed$8 = /*#__PURE__*/dual(2, (a, b) => {
  const tagFirst = isTag(a);
  const tag = tagFirst ? a : b;
  const resource = tagFirst ? b : a;
  return fromEffectContext(succeed$h(make$12(tag, resource)));
});

/** @internal */
const succeedContext = context => {
  return fromEffectContext(succeed$h(context));
};

/** @internal */
const suspend$6 = evaluate => {
  const suspend = Object.create(proto$8);
  suspend._tag = OP_SUSPEND$2;
  suspend.evaluate = evaluate;
  return suspend;
};

/** @internal */
const sync$5 = /*#__PURE__*/dual(2, (a, b) => {
  const tagFirst = isTag(a);
  const tag = tagFirst ? a : b;
  const evaluate = tagFirst ? b : a;
  return fromEffectContext(sync$a(() => make$12(tag, evaluate())));
});

/** @internal */
const syncContext = evaluate => {
  return fromEffectContext(sync$a(evaluate));
};

/** @internal */
const tap$4 = /*#__PURE__*/dual(2, (self, f) => flatMap$5(self, context => fromEffectContext(as$6(f(context), context))));

/** @internal */
const tapError$3 = /*#__PURE__*/dual(2, (self, f) => catchAll$4(self, e => fromEffectContext(flatMap$6(f(e), () => fail$f(e)))));

/** @internal */
const tapErrorCause$2 = /*#__PURE__*/dual(2, (self, f) => catchAllCause$3(self, cause => fromEffectContext(flatMap$6(f(cause), () => failCause$a(cause)))));

/** @internal */
const toRuntime = self => {
  return pipe(scopeWith$1(scope => pipe(self, buildWithScope(scope))), flatMap$6(context => pipe(runtime$1(), provideContext$6(context))));
};

/** @internal */
const use = /*#__PURE__*/dual(2, (that, self) => suspend$6(() => {
  const provideTo = Object.create(proto$8);
  provideTo._tag = OP_PROVIDE_TO;
  provideTo.first = Object.create(proto$8, {
    _tag: {
      value: OP_ZIP_WITH,
      enumerable: true
    },
    first: {
      value: context$6(),
      enumerable: true
    },
    second: {
      value: self
    },
    zipK: {
      value: (a, b) => pipe(a, merge$8(b))
    }
  });
  provideTo.second = that;
  return provideTo;
}));

/** @internal */
const useMerge = /*#__PURE__*/dual(2, (that, self) => {
  const zipWith = Object.create(proto$8);
  zipWith._tag = OP_ZIP_WITH;
  zipWith.first = self;
  zipWith.second = pipe(self, provide$1(that));
  zipWith.zipK = (a, b) => {
    return pipe(a, merge$8(b));
  };
  return zipWith;
});

/** @internal */
const zipWithPar = /*#__PURE__*/dual(3, (self, that, f) => suspend$6(() => {
  const zipWithPar = Object.create(proto$8);
  zipWithPar._tag = OP_ZIP_WITH_PAR;
  zipWithPar.first = self;
  zipWithPar.second = that;
  zipWithPar.zipK = f;
  return zipWithPar;
}));

/** @internal */
const unwrapEffect = self => {
  const tag = Tag$1();
  return flatMap$5(fromEffect$4(tag, self), context => get$j(context, tag));
};

/** @internal */
const unwrapScoped$3 = self => {
  const tag = Tag$1();
  return flatMap$5(scoped$3(tag, self), context => get$j(context, tag));
};

// -----------------------------------------------------------------------------
// tracing
// -----------------------------------------------------------------------------

/** @internal */
const withSpan$3 = /*#__PURE__*/dual(args => isLayer(args[0]), (self, name, options) => unwrapScoped$3(map$f(options?.onEnd ? tap$5(makeSpanScoped$1(name, options), span => addFinalizer$2(exit => options.onEnd(span, exit))) : makeSpanScoped$1(name, options), span => withParentSpan$1(self, span))));

/** @internal */
const withParentSpan$1 = /*#__PURE__*/dual(2, (self, span) => provide$1(succeedContext(make$12(spanTag, span)), self));

// circular with Effect

const provideSomeLayer$2 = /*#__PURE__*/dual(2, (self, layer) => acquireUseRelease$3(scopeMake(), scope => flatMap$6(buildWithScope(layer, scope), context => provideSomeContext$1(self, context)), (scope, exit) => scopeClose(scope, exit)));
const provideSomeRuntime = /*#__PURE__*/dual(2, (self, rt) => {
  const patchFlags = diff$3(defaultRuntime.runtimeFlags, rt.runtimeFlags);
  const inversePatchFlags = diff$3(rt.runtimeFlags, defaultRuntime.runtimeFlags);
  const patchRefs = diff$1(defaultRuntime.fiberRefs, rt.fiberRefs);
  const inversePatchRefs = diff$1(rt.fiberRefs, defaultRuntime.fiberRefs);
  return acquireUseRelease$3(flatMap$6(updateRuntimeFlags(patchFlags), () => patchFiberRefs$1(patchRefs)), () => provideSomeContext$1(self, rt.context), () => flatMap$6(updateRuntimeFlags(inversePatchFlags), () => patchFiberRefs$1(inversePatchRefs)));
});

/** @internal */
const effect_provide = /*#__PURE__*/dual(2, (self, source) => isLayer(source) ? provideSomeLayer$2(self, source) : isContext(source) ? provideSomeContext$1(self, source) : provideSomeRuntime(self, source));

/** @internal */
const currentCache = /*#__PURE__*/fiberRefUnsafeMake( /*#__PURE__*/unsafeMakeWith(65536, () => map$f(deferredMake(), handle => ({
  listeners: new Listeners(),
  handle
})), () => seconds(60)));

/** @internal */
const currentCacheEnabled = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/FiberRef/currentCacheEnabled"), () => fiberRefUnsafeMake(false));

/** @internal */
const fromRequest = (request, dataSource) => flatMap$6(isEffect$1(dataSource) ? dataSource : succeed$h(dataSource), ds => fiberIdWith$1(id => {
  const proxy = new Proxy(request, {});
  return fiberRefGetWith(currentCacheEnabled, cacheEnabled => {
    if (cacheEnabled) {
      return fiberRefGetWith(currentCache, cache => flatMap$6(cache.getEither(proxy), orNew => {
        switch (orNew._tag) {
          case "Left":
            {
              orNew.left.listeners.increment();
              return blocked$1(empty$o, flatMap$6(exit$1(deferredAwait(orNew.left.handle)), exit => {
                if (exit._tag === "Failure" && isInterruptedOnly$1(exit.cause)) {
                  orNew.left.listeners.decrement();
                  return flatMap$6(cache.invalidateWhen(proxy, entry => entry.handle === orNew.left.handle), () => fromRequest(proxy, dataSource));
                }
                return ensuring$6(deferredAwait(orNew.left.handle), sync$a(() => orNew.left.listeners.decrement()));
              }));
            }
          case "Right":
            {
              orNew.right.listeners.increment();
              return blocked$1(single(ds, makeEntry({
                request: proxy,
                result: orNew.right.handle,
                listeners: orNew.right.listeners,
                ownerId: id,
                state: {
                  completed: false
                }
              })), uninterruptibleMask$1(restore => flatMap$6(exit$1(restore(deferredAwait(orNew.right.handle))), exit => {
                orNew.right.listeners.decrement();
                return exit;
              })));
            }
        }
      }));
    }
    const listeners = new Listeners();
    listeners.increment();
    return flatMap$6(deferredMake(), ref => blocked$1(single(ds, makeEntry({
      request: proxy,
      result: ref,
      listeners,
      ownerId: id,
      state: {
        completed: false
      }
    })), ensuring$6(deferredAwait(ref), sync$a(() => listeners.decrement()))));
  });
}));

/** @internal */
const cacheRequest = (request, result) => {
  return fiberRefGetWith(currentCacheEnabled, cacheEnabled => {
    if (cacheEnabled) {
      return fiberRefGetWith(currentCache, cache => flatMap$6(cache.getEither(request), orNew => {
        switch (orNew._tag) {
          case "Left":
            {
              return unit$6;
            }
          case "Right":
            {
              return deferredComplete(orNew.right.handle, result);
            }
        }
      }));
    }
    return unit$6;
  });
};

/** @internal */
const withRequestCaching$1 = /*#__PURE__*/dual(2, (self, strategy) => fiberRefLocally$1(self, currentCacheEnabled, strategy));

/** @internal */
const withRequestCache$1 = /*#__PURE__*/dual(2,
// @ts-expect-error
(self, cache) => fiberRefLocally$1(self, currentCache, cache));

/**
 * @since 2.0.0
 */

// -------------------------------------------------------------------------------------
// models
// -------------------------------------------------------------------------------------
/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const EffectTypeId = EffectTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * The `Effect` interface defines a value that lazily describes a workflow or job.
 * The workflow requires some context `R`, and may fail with an error of type `E`,
 * or succeed with a value of type `A`.
 *
 * `Effect` values model resourceful interaction with the outside world, including
 * synchronous, asynchronous, concurrent, and parallel interaction. They use a
 * fiber-based concurrency model, with built-in support for scheduling, fine-grained
 * interruption, structured concurrency, and high scalability.
 *
 * To run an `Effect` value, you need a `Runtime`, which is a type that is capable
 * of executing `Effect` values.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * This function returns `true` if the specified value is an `Effect` value,
 * `false` otherwise.
 *
 * This function can be useful for checking the type of a value before
 * attempting to operate on it as an `Effect` value. For example, you could
 * use `isEffect` to check the type of a value before using it as an
 * argument to a function that expects an `Effect` value.
 *
 * @param u - The value to check for being an `Effect` value.
 *
 * @returns `true` if the specified value is an `Effect` value, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isEffect = isEffect$1;

// -------------------------------------------------------------------------------------
// caching
// -------------------------------------------------------------------------------------

/**
 * Returns an effect that, if evaluated, will return the cached result of this
 * effect. Cached results will expire after `timeToLive` duration.
 *
 * @since 2.0.0
 * @category caching
 */
const cachedWithTTL = cached$1;

/**
 * Returns an effect that, if evaluated, will return the cached result of this
 * effect. Cached results will expire after `timeToLive` duration. In
 * addition, returns an effect that can be used to invalidate the current
 * cached value before the `timeToLive` duration expires.
 *
 * @since 2.0.0
 * @category caching
 */
const cachedInvalidateWithTTL = cachedInvalidate;

/**
 * Returns an effect that, if evaluated, will return the lazily computed
 * result of this effect.
 *
 * @since 2.0.0
 * @category caching
 */
const cached = memoize$1;

/**
 * Returns a memoized version of the specified effectual function.
 *
 * @since 2.0.0
 * @category caching
 */
const cachedFunction = memoizeFunction;

/**
 * Returns an effect that will be executed at most once, even if it is
 * evaluated multiple times.
 *
 * @since 2.0.0
 * @category caching
 */
const once = once$2;

// -------------------------------------------------------------------------------------
// collecting & elements
// -------------------------------------------------------------------------------------

/**
 * Runs all the provided effects in sequence respecting the structure provided in input.
 *
 * Supports multiple arguments, a single argument tuple / array or record / struct.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const all$1 = all$2;

/**
 * Data-last variant of `Effect.all`.
 *
 * Runs all the provided effects in sequence respecting the structure provided in input.
 *
 * Supports multiple arguments, a single argument tuple / array or record / struct.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const allWith = allWith$1;

/**
 * @since 2.0.0
 */

/**
 * Evaluate and run each effect in the structure and collect the results,
 * discarding results from failed effects.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const allSuccesses = allSuccesses$1;

/**
 * Drops all elements until the effectful predicate returns true.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const dropUntil$2 = dropUntil$3;

/**
 * Drops all elements so long as the predicate returns true.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const dropWhile$2 = dropWhile$3;

/**
 * Determines whether all elements of the `Collection<A>` satisfies the effectual
 * predicate `f`.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const every$3 = every$4;

/**
 * Determines whether any element of the `Iterable<A>` satisfies the effectual
 * predicate `f`.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const exists$1 = exists$2;

/**
 * Filters the collection using the specified effectful predicate.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const filter$3 = filter$4;

/**
 * Returns the first element that satisfies the effectful predicate.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const findFirst$1 = findFirst$4;

/**
 * This function takes an iterable of `Effect` values and returns a new
 * `Effect` value that represents the first `Effect` value in the iterable
 * that succeeds. If all of the `Effect` values in the iterable fail, then
 * the resulting `Effect` value will fail as well.
 *
 * This function is sequential, meaning that the `Effect` values in the
 * iterable will be executed in sequence, and the first one that succeeds
 * will determine the outcome of the resulting `Effect` value.
 *
 * @param effects - The iterable of `Effect` values to evaluate.
 *
 * @returns A new `Effect` value that represents the first successful
 * `Effect` value in the iterable, or a failed `Effect` value if all of the
 * `Effect` values in the iterable fail.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const firstSuccessOf = firstSuccessOf$1;

/**
 * @since 2.0.0
 * @category collecting & elements
 */
const forEach$6 = forEachOptions;

/**
 * Returns a successful effect with the head of the collection if the collection
 * is non-empty, or fails with the error `None` if the collection is empty.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const head$2 = head$3;

/**
 * Merges an `Iterable<Effect<R, E, A>>` to a single effect, working
 * sequentially.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const mergeAll$3 = mergeAll$5;

/**
 * Feeds elements of type `A` to a function `f` that returns an effect.
 * Collects all successes and failures in a tupled fashion.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const partition$2 = partition$3;

/**
 * Folds an `Iterable<A>` using an effectual function f, working sequentially
 * from left to right.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const reduce$5 = reduce$9;

/**
 * Reduces an `Iterable<Effect<R, E, A>>` to a single effect.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const reduceEffect = reduceEffect$2;

/**
 * Folds an `Iterable<A>` using an effectual function f, working sequentially from left to right.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const reduceRight$1 = reduceRight$2;

/**
 * Folds over the elements in this chunk from the left, stopping the fold early
 * when the predicate is not satisfied.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const reduceWhile = reduceWhile$1;

/**
 * Replicates the given effect `n` times.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const replicate$1 = replicate$2;

/**
 * Performs this effect the specified number of times and collects the
 * results.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const replicateEffect = replicateEffect$1;

/**
 * Takes elements until the effectual predicate returns true.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const takeUntil$1 = takeUntil$2;

/**
 * Takes all elements so long as the effectual predicate returns true.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const takeWhile$1 = takeWhile$2;

/**
 * Feeds elements of type `A` to `f` and accumulates all errors in error
 * channel or successes in success channel.
 *
 * This combinator is lossy meaning that if there are errors all successes
 * will be lost. To retain all information please use `partition`.
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const validateAll$1 = validateAll$2;

/**
 * Feeds elements of type `A` to `f` until it succeeds. Returns first success
 * or the accumulation of all errors.
 *
 * If `elements` is empty then `Effect.fail([])` is returned.
 *
 * @example
 * import * as Effect from "effect/Effect"
 * import * as Exit from "effect/Exit"
 *
 * const f = (n: number) => (n > 0 ? Effect.succeed(n) : Effect.fail(`${n} is negative`))
 *
 * assert.deepStrictEqual(Effect.runSyncExit(Effect.validateFirst([], f)), Exit.fail([]))
 * assert.deepStrictEqual(Effect.runSyncExit(Effect.validateFirst([1, 2], f)), Exit.succeed(1))
 * assert.deepStrictEqual(Effect.runSyncExit(Effect.validateFirst([1, -1], f)), Exit.succeed(1))
 * assert.deepStrictEqual(Effect.runSyncExit(Effect.validateFirst([-1, 2], f)), Exit.succeed(2))
 * assert.deepStrictEqual(Effect.runSyncExit(Effect.validateFirst([-1, -2], f)), Exit.fail(['-1 is negative', '-2 is negative']))
 *
 * @since 2.0.0
 * @category collecting & elements
 */
const validateFirst$1 = validateFirst$2;

// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------

/**
 * Imports an asynchronous side-effect into a pure `Effect` value.
 * The callback function `Effect<R, E, A> => void` must be called at most once.
 *
 * If an Effect is returned by the registration function, it will be executed
 * if the fiber executing the effect is interrupted.
 *
 * The registration function can also receive an `AbortSignal` if required for
 * interruption.
 *
 * The `FiberId` of the fiber that may complete the async callback may be
 * provided to allow for better diagnostics.
 *
 * @since 2.0.0
 * @category constructors
 */
const async = async$1;

/**
 * Converts an asynchronous, callback-style API into an `Effect`, which will
 * be executed asynchronously.
 *
 * With this variant, the registration function may return a an `Effect`.
 *
 * @since 2.0.0
 * @category constructors
 */
const asyncEffect$1 = asyncEffect$2;

/**
 * Imports an asynchronous effect into a pure `Effect` value, possibly returning
 * the value synchronously.
 *
 * If the register function returns a value synchronously, then the callback
 * function `Effect<R, E, A> => void` must not be called. Otherwise the callback
 * function must be called at most once.
 *
 * The `FiberId` of the fiber that may complete the async callback may be
 * provided to allow for better diagnostics.
 *
 * @since 2.0.0
 * @category constructors
 */
const asyncOption$1 = asyncOption$2;

/**
 * Imports an asynchronous side-effect into an effect. It has the option of
 * returning the value synchronously, which is useful in cases where it cannot
 * be determined if the effect is synchronous or asynchronous until the register
 * is actually executed. It also has the option of returning a canceler,
 * which will be used by the runtime to cancel the asynchronous effect if the fiber
 * executing the effect is interrupted.
 *
 * If the register function returns a value synchronously, then the callback
 * function `Effect<R, E, A> => void` must not be called. Otherwise the callback
 * function must be called at most once.
 *
 * The `FiberId` of the fiber that may complete the async callback may be
 * provided to allow for better diagnostics.
 *
 * @since 2.0.0
 * @category constructors
 */
const asyncEither = asyncEither$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const fail$7 = fail$f;

/**
 * @since 2.0.0
 * @category constructors
 */
const failSync$4 = failSync$6;

/**
 * @since 2.0.0
 * @category constructors
 */
const failCause$5 = failCause$a;

/**
 * @since 2.0.0
 * @category constructors
 */
const failCauseSync$3 = failCauseSync$5;

/**
 * @since 2.0.0
 * @category constructors
 */
const die$5 = die$9;

/**
 * Returns an effect that dies with a `RuntimeException` having the specified
 * text message. This method can be used for terminating a fiber because a
 * defect has been detected in the code.
 *
 * @since 2.0.0
 * @category constructors
 */
const dieMessage$4 = dieMessage$5;

/**
 * @since 2.0.0
 * @category constructors
 */
const dieSync$3 = dieSync$5;

/**
 * @since 2.0.0
 * @category constructors
 */
const gen$1 = gen$2;

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * Returns a effect that will never produce anything. The moral equivalent of
 * `while(true) {}`, only without the wasted CPU cycles.
 *
 * @since 2.0.0
 * @category constructors
 */
const never$4 = never$6;

/**
 * Requires the option produced by this value to be `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
const none$1 = none$4;

/**
 * Like `tryPromise` but produces a defect in case of errors.
 *
 * An optional `AbortSignal` can be provided to allow for interruption of the
 * wrapped Promise api.
 *
 * @since 2.0.0
 * @category constructors
 */
const promise = promise$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const succeed$7 = succeed$h;

/**
 * Returns an effect which succeeds with `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeedNone$1 = succeedNone$2;

/**
 * Returns an effect which succeeds with the value wrapped in a `Some`.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeedSome$1 = succeedSome$2;

/**
 * @since 2.0.0
 * @category constructors
 */
const suspend$5 = suspend$8;

/**
 * @since 2.0.0
 * @category constructors
 */
const sync$4 = sync$a;

/**
 * @since 2.0.0
 * @category constructors
 */
const unit$3 = unit$6;

/**
 * @since 2.0.0
 * @category constructors
 */
const yieldNow = yieldNow$2;

// -------------------------------------------------------------------------------------
// error handling
// -------------------------------------------------------------------------------------

const _catch = _catch$1;

/**
 * Recovers from all recoverable errors.
 *
 * **Note**: that `Effect.catchAll` will not recover from unrecoverable defects. To
 * recover from both recoverable and unrecoverable errors use
 * `Effect.catchAllCause`.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchAll$3 = catchAll$5;

/**
 * Recovers from both recoverable and unrecoverable errors.
 *
 * See `absorb`, `sandbox`, `mapErrorCause` for other functions that can
 * recover from defects.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchAllCause$2 = catchAllCause$4;

/**
 * Recovers from all defects with provided function.
 *
 * **WARNING**: There is no sensible way to recover from defects. This
 * method should be used only at the boundary between Effect and an external
 * system, to transmit information on a defect for diagnostic or explanatory
 * purposes.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchAllDefect = catchAllDefect$1;

/**
 * Recovers from errors that match the given predicate.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchIf = catchIf$1;

/**
 * Recovers from some or all of the error cases.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchSome$2 = catchSome$3;

/**
 * Recovers from some or all of the error cases with provided cause.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchSomeCause$1 = catchSomeCause$2;

/**
 * Recovers from some or all of the defects with provided partial function.
 *
 * **WARNING**: There is no sensible way to recover from defects. This
 * method should be used only at the boundary between Effect and an external
 * system, to transmit information on a defect for diagnostic or explanatory
 * purposes.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchSomeDefect = catchSomeDefect$1;

/**
 * Recovers from the specified tagged error.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchTag$2 = catchTag$3;

/**
 * Recovers from the specified tagged errors.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchTags$2 = catchTags$3;

/**
 * Returns an effect that succeeds with the cause of failure of this effect,
 * or `Cause.empty` if the effect did succeed.
 *
 * @since 2.0.0
 * @category error handling
 */
const cause = cause$1;

/**
 * Returns an effect that ignores errors and runs repeatedly until it
 * eventually succeeds.
 *
 * @since 2.0.0
 * @category error handling
 */
const eventually$1 = eventually$2;

/**
 * Returns a new effect that ignores the success or failure of this effect.
 *
 * @since 2.0.0
 * @category error handling
 */
const ignore$1 = ignore$2;

/**
 * Returns a new effect that ignores the success or failure of this effect,
 * but which also logs failures at the Debug level, just in case the failure
 * turns out to be important.
 *
 * @since 2.0.0
 * @category error handling
 */
const ignoreLogged = ignoreLogged$1;

/**
 * Exposes all parallel errors in a single call.
 *
 * @since 2.0.0
 * @category error handling
 */
const parallelErrors = parallelErrors$1;

/**
 * Exposes the full `Cause` of failure for the specified effect.
 *
 * @since 2.0.0
 * @category error handling
 */
const sandbox = sandbox$1;

/**
 * Retries with the specified retry policy. Retries are done following the
 * failure of the original `io` (up to a fixed maximum with `once` or `recurs`
 * for example), so that that `io.retry(Schedule.once)` means "execute `io`
 * and in case of failure, try again once".
 *
 * @since 2.0.0
 * @category error handling
 */
const retry$5 = retry_Effect;

/**
 * Retries this effect the specified number of times.
 *
 * @since 2.0.0
 * @category error handling
 */
const retryN = retryN_Effect;

/**
 * Retries with the specified schedule, until it fails, and then both the
 * value produced by the schedule together with the last error are passed to
 * the recovery function.
 *
 * @since 2.0.0
 * @category error handling
 */
const retryOrElse = retryOrElse_Effect;

/**
 * Retries this effect until its error satisfies the specified predicate.
 *
 * @since 2.0.0
 * @category error handling
 */
const retryUntil$1 = retryUntil_Effect;

/**
 * Retries this effect until its error satisfies the specified effectful
 * predicate.
 *
 * @since 2.0.0
 * @category error handling
 */
const retryUntilEffect = retryUntilEffect_Effect;

/**
 * Retries this effect while its error satisfies the specified predicate.
 *
 * @since 2.0.0
 * @category error handling
 */
const retryWhile$1 = retryWhile_Effect;

/**
 * Retries this effect while its error satisfies the specified effectful
 * predicate.
 *
 * @since 2.0.0
 * @category error handling
 */
const retryWhileEffect = retryWhileEffect_Effect;
const try_$1 = try_$2;

/**
 * Returns an effect whose success is mapped by the specified side effecting
 * `try` function, translating any promise rejections into typed failed effects
 * via the `catch` function.
 *
 * @since 2.0.0
 * @category error handling
 */
const tryMap = tryMap$1;

/**
 * Returns an effect whose success is mapped by the specified side effecting
 * `try` function, translating any promise rejections into typed failed effects
 * via the `catch` function.
 *
 * An optional `AbortSignal` can be provided to allow for interruption of the
 * wrapped Promise api.
 *
 * @since 2.0.0
 * @category error handling
 */
const tryMapPromise = tryMapPromise$1;

/**
 * Create an `Effect` that when executed will construct `promise` and wait for
 * its result, errors will produce failure as `unknown`.
 *
 * An optional `AbortSignal` can be provided to allow for interruption of the
 * wrapped Promise api.
 *
 * @since 2.0.0
 * @category error handling
 */
const tryPromise = tryPromise$1;

/**
 * The inverse operation `sandbox(effect)`
 *
 * Terminates with exceptions on the `Left` side of the `Either` error, if it
 * exists. Otherwise extracts the contained `Effect<R, E, A>`
 *
 * @since 2.0.0
 * @category error handling
 */
const unsandbox = unsandbox$1;

// -------------------------------------------------------------------------------------
// interuption
// -------------------------------------------------------------------------------------

/**
 * This function checks if any fibers are attempting to interrupt the current
 * fiber, and if so, performs self-interruption.
 *
 * Note that this allows for interruption to occur in uninterruptible regions.
 *
 * @returns A new `Effect` value that represents the check for interruption
 * and the potential self-interruption of the current fiber.
 *
 * @since 2.0.0
 * @category interruption
 */
const allowInterrupt = allowInterrupt$1;

/**
 * Checks the interrupt status, and produces the effect returned by the
 * specified callback.
 *
 * @since 2.0.0
 * @category interruption
 */
const checkInterruptible = checkInterruptible$1;

/**
 * Returns an effect whose interruption will be disconnected from the
 * fiber's own interruption, being performed in the background without
 * slowing down the fiber's interruption.
 *
 * This method is useful to create "fast interrupting" effects. For
 * example, if you call this on a bracketed effect, then even if the
 * effect is "stuck" in acquire or release, its interruption will return
 * immediately, while the acquire / release are performed in the
 * background.
 *
 * See timeout and race for other applications.
 *
 * @since 2.0.0
 * @category interruption
 */
const disconnect = disconnect$1;

/**
 * @since 2.0.0
 * @category interruption
 */
const interrupt$2 = interrupt$7;

/**
 * @since 2.0.0
 * @category interruption
 */
const interruptWith = interruptWith$1;

/**
 * @since 2.0.0
 * @category interruption
 */
const interruptible = interruptible$1;

/**
 * @since 2.0.0
 * @category interruption
 */
const interruptibleMask = interruptibleMask$1;

/**
 * @since 2.0.0
 * @category interruption
 */
const onInterrupt = onInterrupt$1;

/**
 * @since 2.0.0
 * @category interruption
 */
const uninterruptible = uninterruptible$1;

/**
 * @since 2.0.0
 * @category interruption
 */
const uninterruptibleMask = uninterruptibleMask$1;

// -------------------------------------------------------------------------------------
// mapping
// -------------------------------------------------------------------------------------

/**
 * This function maps the success value of an `Effect` value to a specified
 * constant value.
 *
 * @param value - The constant value that the success value of the `Effect`
 * value will be mapped to.
 * @param self - The `Effect` value whose success value will be mapped to the
 * specified constant value.
 *
 * @returns A new `Effect` value that represents the mapping of the success
 * value of the original `Effect` value to the specified constant value.
 *
 * @since 2.0.0
 * @category mapping
 */
const as$4 = as$6;

/**
 * This function maps the success value of an `Effect` value to a `Some` value
 * in an `Option` value. If the original `Effect` value fails, the returned
 * `Effect` value will also fail.
 *
 * @param self - The `Effect` value whose success value will be mapped to a
 * `Some` value in an `Option` value.
 *
 * @returns A new `Effect` value that represents the mapping of the success
 * value of the original `Effect` value to a `Some` value in an `Option`
 * value. The returned `Effect` value may fail if the original `Effect` value
 * fails.
 *
 * @category mapping
 * @since 2.0.0
 */
const asSome$1 = asSome$2;

/**
 * This function maps the error value of an `Effect` value to a `Some` value
 * in an `Option` value. If the original `Effect` value succeeds, the returned
 * `Effect` value will also succeed.
 *
 * @param self - The `Effect` value whose error value will be mapped to a
 * `Some` value in an `Option` value.
 *
 * @returns A new `Effect` value that represents the mapping of the error
 * value of the original `Effect` value to a `Some` value in an `Option`
 * value. The returned `Effect` value may succeed if the original `Effect`
 * value succeeds.
 *
 * @category mapping
 * @since 2.0.0
 */
const asSomeError$1 = asSomeError$2;

/**
 * This function maps the success value of an `Effect` value to `void`. If the
 * original `Effect` value succeeds, the returned `Effect` value will also
 * succeed. If the original `Effect` value fails, the returned `Effect` value
 * will fail with the same error.
 *
 * @param self - The `Effect` value whose success value will be mapped to `void`.
 *
 * @returns A new `Effect` value that represents the mapping of the success
 * value of the original `Effect` value to `void`.
 *
 * @since 2.0.0
 * @category mapping
 */
const asUnit$2 = asUnit$4;

/**
 * Returns an effect that swaps the error/success cases. This allows you to
 * use all methods on the error channel, possibly before flipping back.
 *
 * @since 2.0.0
 * @category mapping
 */
const flip$1 = flip$2;

/**
 * Swaps the error/value parameters, applies the function `f` and flips the
 * parameters back
 *
 * @since 2.0.0
 * @category mapping
 */
const flipWith$1 = flipWith$2;

/**
 * @since 2.0.0
 * @category mapping
 */
const map$6 = map$f;

/**
 * Statefully and effectfully maps over the elements of this chunk to produce
 * new elements.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapAccum$1 = mapAccum$2;

/**
 * Returns an effect whose failure and success channels have been mapped by
 * the specified `onFailure` and `onSuccess` functions.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapBoth$2 = mapBoth$5;

/**
 * Returns an effect with its error channel mapped using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapError$4 = mapError$6;

/**
 * Returns an effect with its full cause of failure mapped using the specified
 * function. This can be used to transform errors while preserving the
 * original structure of `Cause`.
 *
 * See `absorb`, `sandbox`, `catchAllCause` for other functions for dealing
 * with defects.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapErrorCause$2 = mapErrorCause$3;

/**
 * Returns a new effect where the error channel has been merged into the
 * success channel to their common combined type.
 *
 * @since 2.0.0
 * @category mapping
 */
const merge$4 = merge$6;

/**
 * Returns a new effect where boolean value of this effect is negated.
 *
 * @since 2.0.0
 * @category mapping
 */
const negate$1 = negate$2;

// -------------------------------------------------------------------------------------
// scoping, resources & finalization
// -------------------------------------------------------------------------------------

/**
 * This function constructs a scoped resource from an `acquire` and `release`
 * `Effect` value.
 *
 * If the `acquire` `Effect` value successfully completes execution, then the
 * `release` `Effect` value will be added to the finalizers associated with the
 * scope of this `Effect` value, and it is guaranteed to be run when the scope
 * is closed.
 *
 * The `acquire` and `release` `Effect` values will be run uninterruptibly.
 * Additionally, the `release` `Effect` value may depend on the `Exit` value
 * specified when the scope is closed.
 *
 * @param acquire - The `Effect` value that acquires the resource.
 * @param release - The `Effect` value that releases the resource.
 *
 * @returns A new `Effect` value that represents the scoped resource.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const acquireRelease$1 = acquireRelease$2;

/**
 * This function constructs a scoped resource from an `acquire` and `release`
 * `Effect` value.
 *
 * If the `acquire` `Effect` value successfully completes execution, then the
 * `release` `Effect` value will be added to the finalizers associated with the
 * scope of this `Effect` value, and it is guaranteed to be run when the scope
 * is closed.
 *
 * The `acquire` `Effect` values will be run interruptibly.
 * The `release` `Effect` values will be run uninterruptibly.
 *
 * Additionally, the `release` `Effect` value may depend on the `Exit` value
 * specified when the scope is closed.
 *
 * @param acquire - The `Effect` value that acquires the resource.
 * @param release - The `Effect` value that releases the resource.
 *
 * @returns A new `Effect` value that represents the scoped resource.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const acquireReleaseInterruptible = acquireReleaseInterruptible$1;

/**
 * This function is used to ensure that an `Effect` value that represents the
 * acquisition of a resource (for example, opening a file, launching a thread,
 * etc.) will not be interrupted, and that the resource will always be released
 * when the `Effect` value completes execution.
 *
 * `acquireUseRelease` does the following:
 *
 *   1. Ensures that the `Effect` value that acquires the resource will not be
 *      interrupted. Note that acquisition may still fail due to internal
 *      reasons (such as an uncaught exception).
 *   2. Ensures that the `release` `Effect` value will not be interrupted,
 *      and will be executed as long as the acquisition `Effect` value
 *      successfully acquires the resource.
 *
 * During the time period between the acquisition and release of the resource,
 * the `use` `Effect` value will be executed.
 *
 * If the `release` `Effect` value fails, then the entire `Effect` value will
 * fail, even if the `use` `Effect` value succeeds. If this fail-fast behavior
 * is not desired, errors produced by the `release` `Effect` value can be caught
 * and ignored.
 *
 * @param acquire - The `Effect` value that acquires the resource.
 * @param use - The `Effect` value that is executed between the acquisition
 * and release of the resource.
 * @param release - The `Effect` value that releases the resource.
 *
 * @returns A new `Effect` value that represents the acquisition, use, and
 * release of the resource.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const acquireUseRelease$2 = acquireUseRelease$3;

/**
 * This function adds a finalizer to the scope of the calling `Effect` value.
 * The finalizer is guaranteed to be run when the scope is closed, and it may
 * depend on the `Exit` value that the scope is closed with.
 *
 * @param finalizer - The finalizer to add to the scope of the calling
 * `Effect` value. This function must take an `Exit` value as its parameter,
 * and return a new `Effect` value.
 *
 * @returns A new `Effect` value that represents the addition of the finalizer
 * to the scope of the calling `Effect` value.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const addFinalizer = addFinalizer$2;

/**
 * Returns an effect that, if this effect _starts_ execution, then the
 * specified `finalizer` is guaranteed to be executed, whether this effect
 * succeeds, fails, or is interrupted.
 *
 * For use cases that need access to the effect's result, see `onExit`.
 *
 * Finalizers offer very powerful guarantees, but they are low-level, and
 * should generally not be used for releasing resources. For higher-level
 * logic built on `ensuring`, see the `acquireRelease` family of methods.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const ensuring$4 = ensuring$6;

/**
 * Runs the specified effect if this effect fails, providing the error to the
 * effect if it exists. The provided effect will not be interrupted.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const onError$1 = onError$2;

/**
 * Ensures that a cleanup functions runs, whether this effect succeeds, fails,
 * or is interrupted.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const onExit = onExit$1;

/**
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const parallelFinalizers = parallelFinalizers$1;

/**
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const finalizersMask = finalizersMask$1;

/**
 * Returns a new scoped workflow that runs finalizers added to the scope of
 * this workflow sequentially in the reverse of the order in which they were
 * added. Note that finalizers are run sequentially by default so this only
 * has meaning if used within a scope where finalizers are being run in
 * parallel.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const sequentialFinalizers = sequentialFinalizers$1;

/**
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const scope = scope$2;

/**
 * Accesses the current scope and uses it to perform the specified effect.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const scopeWith = scopeWith$1;

/**
 * Scopes all resources uses in this workflow to the lifetime of the workflow,
 * ensuring that their finalizers are run as soon as this workflow completes
 * execution, whether by success, failure, or interruption.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const scoped$2 = scopedEffect;

/**
 * Scopes all resources acquired by `resource` to the lifetime of `use`
 * without effecting the scope of any resources acquired by `use`.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const using = using$1;

/**
 * Returns a new scoped workflow that returns the result of this workflow as
 * well as a finalizer that can be run to close the scope of this workflow.
 *
 * @since 2.0.0
 * @category scoping, resources & finalization
 */
const withEarlyRelease = withEarlyRelease$1;

// -------------------------------------------------------------------------------------
// supervision & fibers
// -------------------------------------------------------------------------------------

/**
 * Returns a new effect that will not succeed with its value before first
 * waiting for the end of all child fibers forked by the effect.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const awaitAllChildren = awaitAllChildren$1;

/**
 * Returns a new workflow that will not supervise any fibers forked by this
 * workflow.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const daemonChildren = daemonChildren$1;

/**
 * Constructs an effect with information about the current `Fiber`.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const descriptor = descriptor$1;

/**
 * Constructs an effect based on information about the current `Fiber`.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const descriptorWith = descriptorWith$1;

/**
 * Returns a new workflow that executes this one and captures the changes in
 * `FiberRef` values.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const diffFiberRefs = diffFiberRefs$1;

/**
 * Acts on the children of this fiber (collected into a single fiber),
 * guaranteeing the specified callback will be invoked, whether or not this
 * effect succeeds.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const ensuringChild = ensuringChild$1;

/**
 * Acts on the children of this fiber, guaranteeing the specified callback
 * will be invoked, whether or not this effect succeeds.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const ensuringChildren = ensuringChildren$1;

/**
 * @since 2.0.0
 * @category supervision & fibers
 */
const fiberId$1 = fiberId$2;

/**
 * @since 2.0.0
 * @category supervision & fibers
 */
const fiberIdWith = fiberIdWith$1;

/**
 * Returns an effect that forks this effect into its own separate fiber,
 * returning the fiber immediately, without waiting for it to begin executing
 * the effect.
 *
 * You can use the `fork` method whenever you want to execute an effect in a
 * new fiber, concurrently and without "blocking" the fiber executing other
 * effects. Using fibers can be tricky, so instead of using this method
 * directly, consider other higher-level methods, such as `raceWith`,
 * `zipPar`, and so forth.
 *
 * The fiber returned by this method has methods to interrupt the fiber and to
 * wait for it to finish executing the effect. See `Fiber` for more
 * information.
 *
 * Whenever you use this method to launch a new fiber, the new fiber is
 * attached to the parent fiber's scope. This means when the parent fiber
 * terminates, the child fiber will be terminated as well, ensuring that no
 * fibers leak. This behavior is called "auto supervision", and if this
 * behavior is not desired, you may use the `forkDaemon` or `forkIn` methods.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const fork = fork$2;

/**
 * Forks the effect into a new fiber attached to the global scope. Because the
 * new fiber is attached to the global scope, when the fiber executing the
 * returned effect terminates, the forked fiber will continue running.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const forkDaemon = forkDaemon$1;

/**
 * Returns an effect that forks all of the specified values, and returns a
 * composite fiber that produces a list of their results, in order.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const forkAll = forkAll$1;

/**
 * Forks the effect in the specified scope. The fiber will be interrupted
 * when the scope is closed.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const forkIn = forkIn$1;

/**
 * Forks the fiber in a `Scope`, interrupting it when the scope is closed.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const forkScoped = forkScoped$1;

/**
 * Like fork but handles an error with the provided handler.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const forkWithErrorHandler = forkWithErrorHandler$1;

/**
 * Creates an `Effect` value that represents the exit value of the specified
 * fiber.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const fromFiber = fromFiber$1;

/**
 * Creates an `Effect` value that represents the exit value of the specified
 * fiber.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const fromFiberEffect = fromFiberEffect$1;

/**
 * Returns an effect with the behavior of this one, but where all child fibers
 * forked in the effect are reported to the specified supervisor.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const supervised = supervised$1;

/**
 * Transplants specified effects so that when those effects fork other
 * effects, the forked effects will be governed by the scope of the fiber that
 * executes this effect.
 *
 * This can be used to "graft" deep grandchildren onto a higher-level scope,
 * effectively extending their lifespans into the parent scope.
 *
 * @since 2.0.0
 * @category supervision & fibers
 */
const transplant = transplant$1;

/**
 * @since 2.0.0
 * @category supervision & fibers
 */
const withConcurrency = withConcurrency$1;

// ---------------------------------------------------------------------------------------
// scheduler
// ---------------------------------------------------------------------------------------

/**
 * Sets the provided scheduler for usage in the wrapped effect
 *
 * @since 2.0.0
 * @category scheduler
 */
const withScheduler = withScheduler$1;

/**
 * Sets the scheduling priority used when yielding
 *
 * @since 2.0.0
 * @category utils
 */
const withSchedulingPriority = withSchedulingPriority$1;

/**
 * Sets the maximum number of operations before yield by the default schedulers
 *
 * @since 2.0.0
 * @category utils
 */
const withMaxOpsBeforeYield = withMaxOpsBeforeYield$1;

// ---------------------------------------------------------------------------------------
// clock
// ---------------------------------------------------------------------------------------

/**
 * Retreives the `Clock` service from the context
 *
 * @since 2.0.0
 * @category clock
 */
const clock = clock$1;

/**
 * Retreives the `Clock` service from the context and provides it to the
 * specified effectful function.
 *
 * @since 2.0.0
 * @category clock
 */
const clockWith = clockWith$1;

/**
 * Sets the implementation of the clock service to the specified value and
 * restores it to its original value when the scope is closed.
 *
 * @since 2.0.0
 * @category constructors
 */
const withClockScoped = withClockScoped$1;

/**
 * Executes the specified workflow with the specified implementation of the
 * clock service.
 *
 * @since 2.0.0
 * @category clock
 */
const withClock = withClock$1;

// ---------------------------------------------------------------------------------------
// delays & timeouts
// ---------------------------------------------------------------------------------------

/**
 * Returns an effect that is delayed from this effect by the specified
 * `Duration`.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const delay = delay$1;

/**
 * Returns an effect that suspends for the specified duration. This method is
 * asynchronous, and does not actually block the fiber executing the effect.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const sleep = sleep$1;

/**
 * Returns a new effect that executes this one and times the execution.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const timed$1 = timed$2;

/**
 * A more powerful variation of `timed` that allows specifying the clock.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const timedWith = timedWith$1;

/**
 * Returns an effect that will timeout this effect, returning `None` if the
 * timeout elapses before the effect has produced a value; and returning
 * `Some` of the produced value otherwise.
 *
 * If the timeout elapses without producing a value, the running effect will
 * be safely interrupted.
 *
 * WARNING: The effect returned by this method will not itself return until
 * the underlying effect is actually interrupted. This leads to more
 * predictable resource utilization. If early return is desired, then instead
 * of using `effect.timeout(d)`, use `effect.disconnect.timeout(d)`, which
 * first disconnects the effect's interruption signal before performing the
 * timeout, resulting in earliest possible return, before an underlying effect
 * has been successfully interrupted.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const timeout$1 = timeout$2;

/**
 * The same as `timeout`, but instead of producing a `None` in the event of
 * timeout, it will produce the specified error.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const timeoutFail$1 = timeoutFail$2;

/**
 * The same as `timeout`, but instead of producing a `None` in the event of
 * timeout, it will produce the specified failure.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const timeoutFailCause$1 = timeoutFailCause$2;

/**
 * Returns an effect that will timeout this effect, returning either the
 * default value if the timeout elapses before the effect has produced a
 * value or returning the result of applying the function `onSuccess` to the
 * success value of the effect.
 *
 * If the timeout elapses without producing a value, the running effect will
 * be safely interrupted.
 *
 * @since 2.0.0
 * @category delays & timeouts
 */
const timeoutTo$1 = timeoutTo$2;

// -------------------------------------------------------------------------------------
// config
// -------------------------------------------------------------------------------------

/**
 * Uses the default config provider to load the specified config, or fail with
 * an error of type Config.Error.
 *
 * @since 2.0.0
 * @category config
 */
const config = config$1;

/**
 * Retrieves the default config provider, and passes it to the specified
 * function, which may return an effect that uses the provider to perform some
 * work or compute some value.
 *
 * @since 2.0.0
 * @category config
 */
const configProviderWith = configProviderWith$1;

/**
 * Executes the specified workflow with the specified configuration provider.
 *
 * @since 2.0.0
 * @category config
 */
const withConfigProvider = withConfigProvider$1;

/**
 * Sets the configuration provider to the specified value and restores it to its original value
 * when the scope is closed.
 *
 * @since 2.0.0
 * @category config
 */
const withConfigProviderScoped = withConfigProviderScoped$1;

// -------------------------------------------------------------------------------------
// context
// -------------------------------------------------------------------------------------

/**
 * @since 2.0.0
 * @category context
 */
const context$5 = context$7;

/**
 * Accesses the context of the effect.
 *
 * @since 2.0.0
 * @category context
 */
const contextWith$4 = contextWith$5;

/**
 * Effectually accesses the context of the effect.
 *
 * @since 2.0.0
 * @category context
 */
const contextWithEffect$3 = contextWithEffect$4;

/**
 * Provides some of the context required to run this effect,
 * leaving the remainder `R0`.
 *
 * @since 2.0.0
 * @category context
 */
const mapInputContext$4 = mapInputContext$6;

/**
 * Splits the context into two parts, providing one part using the
 * specified layer/context/runtime and leaving the remainder `R0`
 *
 * @since 2.0.0
 * @category context
 */
const provide = effect_provide;

/**
 * Provides the effect with the single service it requires. If the effect
 * requires more than one service use `provideContext` instead.
 *
 * @since 2.0.0
 * @category context
 */
const provideService$3 = provideService$5;

/**
 * Provides the effect with the single service it requires. If the effect
 * requires more than one service use `provideContext` instead.
 *
 * @since 2.0.0
 * @category context
 */
const provideServiceEffect$1 = provideServiceEffect$2;

/**
 * @since 2.0.0
 * @category context
 */
const serviceFunction = serviceFunction$1;

/**
 * @since 2.0.0
 * @category context
 */
const serviceFunctionEffect = serviceFunctionEffect$1;

/**
 * @since 2.0.0
 * @category context
 */
const serviceFunctions = serviceFunctions$1;

/**
 * @since 2.0.0
 * @category context
 */
const serviceConstants = serviceConstants$1;

/**
 * @since 2.0.0
 * @category context
 */
const serviceMembers = serviceMembers$1;

/**
 * @since 2.0.0
 * @category context
 */
const serviceOption = serviceOption$1;

/**
 * Updates the service with the required service entry.
 *
 * @since 2.0.0
 * @category context
 */
const updateService$2 = updateService$3;

// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------

/**
 * @since 2.0.0
 * @category do notation
 */
const Do$1 = Do$2;

/**
 * Binds an effectful value in a `do` scope
 *
 * @since 2.0.0
 * @category do notation
 */
const bind$2 = bind$3;

/**
 * @category do notation
 * @since 2.0.0
 */
const bindTo$2 = bindTo$3;
const let_$2 = bindValue;

// -------------------------------------------------------------------------------------
// conversions
// -------------------------------------------------------------------------------------

/**
 * Returns an effect whose failure and success have been lifted into an
 * `Either`. The resulting effect cannot fail, because the failure case has
 * been exposed as part of the `Either` success case.
 *
 * This method is useful for recovering from effects that may fail.
 *
 * The error parameter of the returned `Effect` is `never`, since it is
 * guaranteed the effect does not model failure.
 *
 * @since 2.0.0
 * @category conversions
 */
const either$3 = either$5;

/**
 * @since 2.0.0
 * @category conversions
 */
const exit = exit$1;

/**
 * @since 2.0.0
 * @category conversions
 */
const intoDeferred = intoDeferred$1;

/**
 * Executes this effect, skipping the error but returning optionally the
 * success.
 *
 * @since 2.0.0
 * @category conversions
 */
const option$2 = option$3;

// -------------------------------------------------------------------------------------
// filtering & conditionals
// -------------------------------------------------------------------------------------

const if_$1 = if_$2;

/**
 * Filter the specified effect with the provided function, dying with specified
 * defect if the predicate fails.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const filterOrDie$1 = filterOrDie$2;

/**
 * Filter the specified effect with the provided function, dying with specified
 * message if the predicate fails.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const filterOrDieMessage$1 = filterOrDieMessage$2;

/**
 * Filters the specified effect with the provided function returning the value
 * of the effect if it is successful, otherwise returns the value of `orElse`.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const filterOrElse$1 = filterOrElse$2;

/**
 * Filter the specified effect with the provided function, failing with specified
 * error if the predicate fails.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const filterOrFail$1 = filterOrFail$2;

/**
 * The moral equivalent of `if (!p) exp`.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const unless$1 = unless$2;

/**
 * The moral equivalent of `if (!p) exp` when `p` has side-effects.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const unlessEffect = unlessEffect$1;

/**
 * The moral equivalent of `if (p) exp`.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const when$3 = when$4;

/**
 * @since 2.0.0
 * @category filtering & conditionals
 */
const whenEffect$1 = whenEffect$2;

/**
 * Executes this workflow when value of the specified `FiberRef` satisfies the
 * predicate.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const whenFiberRef = whenFiberRef$1;

/**
 * Executes this workflow when the value of the `Ref` satisfies the predicate.
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const whenRef = whenRef$1;

// -------------------------------------------------------------------------------------
// sequencing
// -------------------------------------------------------------------------------------

/**
 * This function is a pipeable operator that maps over an `Effect` value,
 * flattening the result of the mapping function into a new `Effect` value.
 *
 * @param f - The mapping function to apply to the `Effect` value.
 * This function must return another `Effect` value.
 *
 * @returns A new `Effect` value that is the result of flattening the
 * mapped `Effect` value.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap$4 = flatMap$6;

/**
 * @since 2.0.0
 * @category sequencing
 */
const flatten$3 = flatten$6;

/**
 * Returns an effect that races this effect with all the specified effects,
 * yielding the value of the first effect to succeed with a value. Losers of
 * the race will be interrupted immediately
 *
 * @since 2.0.0
 * @category sequencing
 */
const raceAll = raceAll$1;

/**
 * Returns an effect that races this effect with the specified effect,
 * returning the first successful `A` from the faster side. If one effect
 * succeeds, the other will be interrupted. If neither succeeds, then the
 * effect will fail with some error.
 *
 * @since 2.0.0
 * @category sequencing
 */
const race$2 = race$3;

/**
 * Returns an effect that races this effect with the specified effect,
 * yielding the first result to complete, whether by success or failure. If
 * neither effect completes, then the composed effect will not complete.
 *
 * WARNING: The raced effect will safely interrupt the "loser", but will not
 * resume until the loser has been cleanly terminated. If early return is
 * desired, then instead of performing `l raceFirst r`, perform
 * `l.disconnect raceFirst r.disconnect`, which disconnects left and right
 * interrupt signal, allowing a fast return, with interruption performed
 * in the background.
 *
 * @since 2.0.0
 * @category sequencing
 */
const raceFirst = raceFirst$1;

/**
 * Returns an effect that races this effect with the specified effect, calling
 * the specified finisher as soon as one result or the other has been computed.
 *
 * @since 2.0.0
 * @category sequencing
 */
const raceWith$1 = raceWith$2;

/**
 * Summarizes a effect by computing some value before and after execution, and
 * then combining the values to produce a summary, together with the result of
 * execution.
 *
 * @since 2.0.0
 * @category sequencing
 */
const summarized$2 = summarized$3;

/**
 * @since 2.0.0
 * @category sequencing
 */
const tap$3 = tap$5;

/**
 * Returns an effect that effectfully "peeks" at the failure or success of
 * this effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tapBoth$2 = tapBoth$3;

/**
 * Returns an effect that effectually "peeks" at the defect of this effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tapDefect = tapDefect$1;

/**
 * Returns an effect that effectfully "peeks" at the failure of this effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tapError$2 = tapError$4;

/**
 * Returns an effect that effectfully "peeks" at the specific tagged failure of this effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tapErrorTag = tapErrorTag$1;

/**
 * Returns an effect that effectually "peeks" at the cause of the failure of
 * this effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tapErrorCause$1 = tapErrorCause$3;

// -------------------------------------------------------------------------------------
// repetition / recursion
// -------------------------------------------------------------------------------------

/**
 * Repeats this effect forever (until the first error).
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const forever$2 = forever$4;

/**
 * Iterates with the specified effectual function. The moral equivalent of:
 *
 * ```ts
 * let s = initial
 *
 * while (cont(s)) {
 *   s = body(s)
 * }
 *
 * return s
 * ```
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const iterate$2 = iterate$3;

/**
 * Loops with the specified effectual function, collecting the results into a
 * list. The moral equivalent of:
 *
 * ```ts
 * let s  = initial
 * let as = [] as readonly A[]
 *
 * while (cont(s)) {
 *   as = [body(s), ...as]
 *   s  = inc(s)
 * }
 *
 * A.reverse(as)
 * ```
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const loop$1 = loop$2;

/**
 * Returns a new effect that repeats this effect according to the specified
 * schedule or until the first failure. Scheduled recurrences are in addition
 * to the first execution, so that `io.repeat(Schedule.once)` yields an effect
 * that executes `io`, and then if that succeeds, executes `io` an additional
 * time.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const repeat$1 = repeat_Effect;

/**
 * Returns a new effect that repeats this effect the specified number of times
 * or until the first failure. Repeats are in addition to the first execution,
 * so that `io.repeatN(1)` yields an effect that executes `io`, and then if
 * that succeeds, executes `io` an additional time.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const repeatN = repeatN$1;

/**
 * Returns a new effect that repeats this effect according to the specified
 * schedule or until the first failure, at which point, the failure value and
 * schedule output are passed to the specified handler.
 *
 * Scheduled recurrences are in addition to the first execution, so that
 * `pipe(effect, Effect.repeat(Schedule.once()))` yields an effect that executes
 * `effect`, and then if that succeeds, executes `effect` an additional time.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const repeatOrElse = repeatOrElse_Effect;

/**
 * Repeats this effect until its value satisfies the specified predicate or
 * until the first failure.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const repeatUntil$1 = repeatUntil_Effect;

/**
 * Repeats this effect until its value satisfies the specified effectful
 * predicate or until the first failure.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const repeatUntilEffect = repeatUntilEffect_Effect;

/**
 * Repeats this effect while its value satisfies the specified effectful
 * predicate or until the first failure.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const repeatWhile$1 = repeatWhile_Effect;

/**
 * Repeats this effect while its value satisfies the specified effectful
 * predicate or until the first failure.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const repeatWhileEffect = repeatWhileEffect_Effect;

/**
 * Runs this effect according to the specified schedule.
 *
 * See `scheduleFrom` for a variant that allows the schedule's decision to
 * depend on the result of this effect.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const schedule$1 = schedule_Effect;

/**
 * Runs this effect according to the specified schedule in a new fiber
 * attached to the current scope.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const scheduleForked = scheduleForked$1;

/**
 * Runs this effect according to the specified schedule starting from the
 * specified input value.
 *
 * @since 2.0.0
 * @category repetition / recursion
 */
const scheduleFrom = scheduleFrom_Effect;

/**
 * @since 2.0.0
 * @category repetition / recursion
 */
const whileLoop = whileLoop$1;

// -------------------------------------------------------------------------------------
// fiber refs
// -------------------------------------------------------------------------------------

/**
 * Returns a collection of all `FiberRef` values for the fiber running this
 * effect.
 *
 * @since 2.0.0
 * @category fiber refs
 */
const getFiberRefs = fiberRefs;

/**
 * Inherits values from all `FiberRef` instances into current fiber.
 *
 * @since 2.0.0
 * @category fiber refs
 */
const inheritFiberRefs = inheritFiberRefs$1;

/**
 * @since 2.0.0
 * @category fiber refs
 */
const locally = fiberRefLocally$1;

/**
 * @since 2.0.0
 * @category fiber refs
 */
const locallyWith = fiberRefLocallyWith$1;

/**
 * @since 2.0.0
 * @category fiber refs
 */
const locallyScoped = fiberRefLocallyScoped$1;

/**
 * @since 2.0.0
 * @category fiber refs
 */
const locallyScopedWith = fiberRefLocallyScopedWith$1;

/**
 * Applies the specified changes to the `FiberRef` values for the fiber
 * running this workflow.
 *
 * @since 2.0.0
 * @category fiber refs
 */
const patchFiberRefs = patchFiberRefs$1;

/**
 * Sets the `FiberRef` values for the fiber running this effect to the values
 * in the specified collection of `FiberRef` values.
 *
 * @since 2.0.0
 * @category fiber refs
 */
const setFiberRefs = setFiberRefs$1;

/**
 * Updates the `FiberRef` values for the fiber running this effect using the
 * specified function.
 *
 * @since 2.0.0
 * @category fiber refs
 */
const updateFiberRefs = updateFiberRefs$1;

// -------------------------------------------------------------------------------------
// getters & folding
// -------------------------------------------------------------------------------------

/**
 * Returns `true` if this effect is a failure, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters & folding
 */
const isFailure$3 = isFailure$4;

/**
 * Returns `true` if this effect is a success, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters & folding
 */
const isSuccess$3 = isSuccess$4;

/**
 * Folds over the failure value or the success value to yield an effect that
 * does not fail, but succeeds with the value returned by the left or right
 * function passed to `match`.
 *
 * @since 2.0.0
 * @category getters & folding
 */
const match$9 = match$e;

/**
 * @since 2.0.0
 * @category getters & folding
 */
const matchCause = matchCause$2;

/**
 * @since 2.0.0
 * @category getters & folding
 */
const matchCauseEffect = matchCauseEffect$1;

/**
 * @since 2.0.0
 * @category getters & folding
 */
const matchEffect$1 = matchEffect$3;

// -------------------------------------------------------------------------------------
// logging
// -------------------------------------------------------------------------------------

/**
 * Logs the specified message or cause at the current log level.
 *
 * You can set the current log level using `FiberRef.currentLogLevel`.
 *
 * @since 2.0.0
 * @category logging
 */
const log$1 = log$2;

/**
 * Logs the specified message or cause at the Trace log level.
 *
 * @since 2.0.0
 * @category logging
 */
const logTrace = logTrace$1;

/**
 * Logs the specified message or cause at the Debug log level.
 *
 * @since 2.0.0
 * @category logging
 */
const logDebug = logDebug$1;

/**
 * Logs the specified message or cause at the Info log level.
 *
 * @since 2.0.0
 * @category logging
 */
const logInfo = logInfo$1;

/**
 * Logs the specified message or cause at the Warning log level.
 *
 * @since 2.0.0
 * @category logging
 */
const logWarning = logWarning$1;

/**
 * Logs the specified message or cause at the Error log level.
 *
 * @since 2.0.0
 * @category logging
 */
const logError = logError$1;

/**
 * Logs the specified message or cause at the Fatal log level.
 *
 * @since 2.0.0
 * @category logging
 */
const logFatal = logFatal$1;

/**
 * Adjusts the label for the current logging span.
 *
 * @since 2.0.0
 * @category logging
 */
const withLogSpan = withLogSpan$1;

/**
 * Annotates each log in this effect with the specified log annotation.
 *
 * @since 2.0.0
 * @category logging
 */
const annotateLogs = annotateLogs$1;

/**
 * Retrieves the log annotations associated with the current scope.
 *
 * @since 2.0.0
 * @category logging
 */
const logAnnotations = logAnnotations$1;

/**
 * Decides wether child fibers will report or not unhandled errors via the logger
 *
 * @since 2.0.0
 * @category logging
 */
const withUnhandledErrorLogLevel = withUnhandledErrorLogLevel$1;

// -------------------------------------------------------------------------------------
// alternatives
// -------------------------------------------------------------------------------------

/**
 * Translates effect failure into death of the fiber, making all failures
 * unchecked and not a part of the type of the effect.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orDie$3 = orDie$5;

/**
 * Keeps none of the errors, and terminates the fiber with them, using the
 * specified function to convert the `E` into a `Throwable`.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orDieWith$3 = orDieWith$4;

/**
 * Executes this effect and returns its value, if it succeeds, but otherwise
 * executes the specified effect.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orElse$5 = orElse$a;

/**
 * Executes this effect and returns its value, if it succeeds, but otherwise
 * fails with the specified error.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orElseFail$2 = orElseFail$3;

/**
 * Executes this effect and returns its value, if it succeeds, but
 * otherwise succeeds with the specified value.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orElseSucceed$2 = orElseSucceed$3;

// -------------------------------------------------------------------------------------
// random
// -------------------------------------------------------------------------------------

/**
 * Retreives the `Random` service from the context.
 *
 * @since 2.0.0
 * @category random
 */
const random = random$1;

/**
 * Retreives the `Random` service from the context and uses it to run the
 * specified workflow.
 *
 * @since 2.0.0
 * @category random
 */
const randomWith = randomWith$1;

// -------------------------------------------------------------------------------------
// runtime
// -------------------------------------------------------------------------------------

/**
 * Returns an effect that accesses the runtime, which can be used to
 * (unsafely) execute tasks. This is useful for integration with legacy code
 * that must call back into Effect code.
 *
 * @since 2.0.0
 * @category runtime
 */
const runtime = runtime$1;

/**
 * Retrieves an effect that succeeds with the current runtime flags, which
 * govern behavior and features of the runtime system.
 *
 * @since 2.0.0
 * @category runtime
 */
const getRuntimeFlags = runtimeFlags;

/**
 * @since 2.0.0
 * @category runtime
 */
const patchRuntimeFlags = updateRuntimeFlags;

/**
 * @since 2.0.0
 * @category runtime
 */
const withRuntimeFlagsPatch = withRuntimeFlags;

/**
 * @since 2.0.0
 * @category runtime
 */
const withRuntimeFlagsPatchScoped = withRuntimeFlagsScoped;

// -------------------------------------------------------------------------------------
// metrics
// -------------------------------------------------------------------------------------

/**
 * Tags each metric in this effect with the specific tag.
 *
 * @since 2.0.0
 * @category metrics
 */
const tagMetrics = tagMetrics$1;

/**
 * Tags each metric in this effect with the specific tag.
 *
 * @since 2.0.0
 * @category metrics
 */
const labelMetrics = labelMetrics$1;

/**
 * Tags each metric in this effect with the specific tag.
 *
 * @since 2.0.0
 * @category metrics
 */
const labelMetricsSet = labelMetricsSet$1;

/**
 * Tags each metric in a scope with a the specific tag.
 *
 * @since 2.0.0
 * @category metrics
 */
const tagMetricsScoped = tagMetricsScoped$1;

/**
 * Tags each metric in a scope with a the specific tag.
 *
 * @since 2.0.0
 * @category metrics
 */
const labelMetricsScoped = labelMetricsScoped$1;

/**
 * Tags each metric in a scope with a the specific tag.
 *
 * @since 2.0.0
 * @category metrics
 */
const labelMetricsScopedSet = labelMetricsScopedSet$1;

/**
 * Retrieves the metric labels associated with the current scope.
 *
 * @since 2.0.0
 * @category metrics
 */
const metricLabels = metricLabels$1;

/**
 * @since 2.0.0
 * @category metrics
 */
const withMetric = withMetric$1;

// -------------------------------------------------------------------------------------
// unify
// -------------------------------------------------------------------------------------

/**
 * Used to unify functions that would otherwise return `Effect<A, B, C> | Effect<D, E, F>`
 *
 * @category unify
 * @since 2.0.0
 */
const unifiedFn = unified$1;

/**
 * Used to unify effects that would otherwise be `Effect<A, B, C> | Effect<D, E, F>`
 *
 * @category unify
 * @since 2.0.0
 */
const unified = identity$1;

// -------------------------------------------------------------------------------------
// semaphore
// -------------------------------------------------------------------------------------

/**
 * @category semaphore
 * @since 2.0.0
 */
/**
 * @category semaphore
 * @since 2.0.0
 */
/**
 * Unsafely creates a new Semaphore
 *
 * @since 2.0.0
 * @category semaphore
 */
const unsafeMakeSemaphore$1 = unsafeMakeSemaphore$2;

/**
 * Creates a new Semaphore
 *
 * @since 2.0.0
 * @category semaphore
 */
const makeSemaphore = makeSemaphore$1;

// -------------------------------------------------------------------------------------
// execution
// -------------------------------------------------------------------------------------

/**
 * @since 2.0.0
 * @category execution
 */
const runFork = unsafeForkEffect;

/**
 * @since 2.0.0
 * @category execution
 */
const runCallback = unsafeRunEffect;

/**
 * Runs an `Effect` workflow, returning a `Promise` which resolves with the
 * result of the workflow or rejects with an error.
 *
 * @since 2.0.0
 * @category execution
 */
const runPromise = unsafeRunPromiseEffect;

/**
 * Runs an `Effect` workflow, returning a `Promise` which resolves with the
 * `Exit` value of the workflow.
 *
 * @since 2.0.0
 * @category execution
 */
const runPromiseExit$1 = unsafeRunPromiseExitEffect;

/**
 * @since 2.0.0
 * @category execution
 */
const runSync = unsafeRunSyncEffect;

/**
 * @since 2.0.0
 * @category execution
 */
const runSyncExit = unsafeRunSyncExitEffect;

// -------------------------------------------------------------------------------------
// zipping
// -------------------------------------------------------------------------------------

/**
 * Sequentially zips the this result with the specified result. Combines both
 * `Cause`s when both effects fail.
 *
 * @since 2.0.0
 * @category zipping
 */
const validate = validate$1;

/**
 * Sequentially zips this effect with the specified effect using the specified
 * combiner function. Combines the causes in case both effect fail.
 *
 * @since 2.0.0
 * @category zipping
 */
const validateWith = validateWith$1;

/**
 * @since 2.0.0
 * @category zipping
 */
const zip$5 = zipOptions;

/**
 * @since 2.0.0
 * @category zipping
 */
const zipLeft$4 = zipLeftOptions;

/**
 * @since 2.0.0
 * @category zipping
 */
const zipRight$4 = zipRightOptions;

/**
 * @since 2.0.0
 * @category zipping
 */
const zipWith$3 = zipWithOptions;

// -------------------------------------------------------------------------------------
// applicatives
// -------------------------------------------------------------------------------------
/**
 * @category combining
 * @since 2.0.0
 */
const ap = /*#__PURE__*/dual(2, (self, that) => zipWith$3(self, that, (f, a) => f(a)));
// -------------------------------------------------------------------------------------
// requests & batching
// -------------------------------------------------------------------------------------

/**
 * @category requests & batching
 * @since 2.0.0
 */
const blocked = blocked$1;

/**
 * @category requests & batching
 * @since 2.0.0
 */
const runRequestBlock = runRequestBlock$1;

/**
 * @category requests & batching
 * @since 2.0.0
 */
const step = step$1;

/**
 * @category requests & batching
 * @since 2.0.0
 */
const flatMapStep = flatMapStep$1;

/**
 * @since 2.0.0
 * @category requests & batching
 */
const request = fromRequest;

/**
 * @since 2.0.0
 * @category requests & batching
 */
const cacheRequestResult = cacheRequest;

/**
 * @since 2.0.0
 * @category requests & batching
 */
const withRequestBatching = withRequestBatching$1;

/**
 * @since 2.0.0
 * @category requests & batching
 */
const withRequestCaching = withRequestCaching$1;

/**
 * @since 2.0.0
 * @category requests & batching
 */
const withRequestCache = withRequestCache$1;

// -------------------------------------------------------------------------------------
// tracing
// -------------------------------------------------------------------------------------

/**
 * @since 2.0.0
 * @category tracing
 */
const tracer = tracer$1;

/**
 * @since 2.0.0
 * @category tracing
 */
const tracerWith = tracerWith$3;

/**
 * @since 2.0.0
 * @category tracing
 */
const withTracer = withTracer$1;

/**
 * @since 2.0.0
 * @category tracing
 */
const withTracerScoped = withTracerScoped$1;

/**
 * @since 2.0.0
 * @category tracing
 */
const withTracerTiming = withTracerTiming$1;

/**
 * Adds an annotation to each span in this effect.
 *
 * @since 2.0.0
 * @category tracing
 */
const annotateSpans = annotateSpans$1;

/**
 * Adds an annotation to the current span if available
 *
 * @since 2.0.0
 * @category tracing
 */
const annotateCurrentSpan = annotateCurrentSpan$1;

/**
 * @since 2.0.0
 * @category tracing
 */
const currentSpan = currentSpan$1;

/**
 * @since 2.0.0
 * @category tracing
 */
const currentParentSpan = currentParentSpan$1;

/**
 * @since 2.0.0
 * @category tracing
 */
const spanAnnotations = spanAnnotations$1;

/**
 * @since 2.0.0
 * @category tracing
 */
const spanLinks = spanLinks$1;

/**
 * For all spans in this effect, add a link with the provided span.
 *
 * @since 2.0.0
 * @category tracing
 */
const linkSpans = linkSpans$1;

/**
 * Create a new span for tracing.
 *
 * @since 2.0.0
 * @category tracing
 */
const makeSpan = makeSpan$1;

/**
 * Create a new span for tracing, and automatically close it when the Scope
 * finalizes.
 *
 * The span is not added to the current span stack, so no child spans will be
 * created for it.
 *
 * @since 2.0.0
 * @category tracing
 */
const makeSpanScoped = makeSpanScoped$1;

/**
 * Create a new span for tracing, and automatically close it when the effect
 * completes.
 *
 * The span is not added to the current span stack, so no child spans will be
 * created for it.
 *
 * @since 2.0.0
 * @category tracing
 */
const useSpan = useSpan$1;

/**
 * Wraps the effect with a new span for tracing.
 *
 * @since 2.0.0
 * @category tracing
 */
const withSpan$2 = withSpan$4;

/**
 * Wraps the effect with a new span for tracing.
 *
 * The span is ended when the Scope is finalized.
 *
 * @since 2.0.0
 * @category tracing
 */
const withSpanScoped = withSpanScoped$1;

/**
 * Adds the provided span to the current span stack.
 *
 * @since 2.0.0
 * @category tracing
 */
const withParentSpan = withParentSpan$2;

// -------------------------------------------------------------------------------------
// optionality
// -------------------------------------------------------------------------------------

/**
 * Returns an effect that errors with `NoSuchElementException` if the value is
 * null or undefined, otherwise succeeds with the value.
 *
 * @since 2.0.0
 * @category optionality
 */
const fromNullable = fromNullable$1;

/**
 * Wraps the success value of this effect with `Option.some`, and maps
 * `Cause.NoSuchElementException` to `Option.none`.
 *
 * @since 2.0.0
 * @category optionality
 */
const optionFromOptional = optionFromOptional$1;

var $3cwie$Effect = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Do: Do$1,
	EffectTypeId: EffectTypeId,
	acquireRelease: acquireRelease$1,
	acquireReleaseInterruptible: acquireReleaseInterruptible,
	acquireUseRelease: acquireUseRelease$2,
	addFinalizer: addFinalizer,
	all: all$1,
	allSuccesses: allSuccesses,
	allWith: allWith,
	allowInterrupt: allowInterrupt,
	annotateCurrentSpan: annotateCurrentSpan,
	annotateLogs: annotateLogs,
	annotateSpans: annotateSpans,
	ap: ap,
	as: as$4,
	asSome: asSome$1,
	asSomeError: asSomeError$1,
	asUnit: asUnit$2,
	async: async,
	asyncEffect: asyncEffect$1,
	asyncEither: asyncEither,
	asyncOption: asyncOption$1,
	awaitAllChildren: awaitAllChildren,
	bind: bind$2,
	bindTo: bindTo$2,
	blocked: blocked,
	cacheRequestResult: cacheRequestResult,
	cached: cached,
	cachedFunction: cachedFunction,
	cachedInvalidateWithTTL: cachedInvalidateWithTTL,
	cachedWithTTL: cachedWithTTL,
	'catch': _catch,
	catchAll: catchAll$3,
	catchAllCause: catchAllCause$2,
	catchAllDefect: catchAllDefect,
	catchIf: catchIf,
	catchSome: catchSome$2,
	catchSomeCause: catchSomeCause$1,
	catchSomeDefect: catchSomeDefect,
	catchTag: catchTag$2,
	catchTags: catchTags$2,
	cause: cause,
	checkInterruptible: checkInterruptible,
	clock: clock,
	clockWith: clockWith,
	config: config,
	configProviderWith: configProviderWith,
	context: context$5,
	contextWith: contextWith$4,
	contextWithEffect: contextWithEffect$3,
	currentParentSpan: currentParentSpan,
	currentSpan: currentSpan,
	daemonChildren: daemonChildren,
	delay: delay,
	descriptor: descriptor,
	descriptorWith: descriptorWith,
	die: die$5,
	dieMessage: dieMessage$4,
	dieSync: dieSync$3,
	diffFiberRefs: diffFiberRefs,
	disconnect: disconnect,
	dropUntil: dropUntil$2,
	dropWhile: dropWhile$2,
	either: either$3,
	ensuring: ensuring$4,
	ensuringChild: ensuringChild,
	ensuringChildren: ensuringChildren,
	eventually: eventually$1,
	every: every$3,
	exists: exists$1,
	exit: exit,
	fail: fail$7,
	failCause: failCause$5,
	failCauseSync: failCauseSync$3,
	failSync: failSync$4,
	fiberId: fiberId$1,
	fiberIdWith: fiberIdWith,
	filter: filter$3,
	filterOrDie: filterOrDie$1,
	filterOrDieMessage: filterOrDieMessage$1,
	filterOrElse: filterOrElse$1,
	filterOrFail: filterOrFail$1,
	finalizersMask: finalizersMask,
	findFirst: findFirst$1,
	firstSuccessOf: firstSuccessOf,
	flatMap: flatMap$4,
	flatMapStep: flatMapStep,
	flatten: flatten$3,
	flip: flip$1,
	flipWith: flipWith$1,
	forEach: forEach$6,
	forever: forever$2,
	fork: fork,
	forkAll: forkAll,
	forkDaemon: forkDaemon,
	forkIn: forkIn,
	forkScoped: forkScoped,
	forkWithErrorHandler: forkWithErrorHandler,
	fromFiber: fromFiber,
	fromFiberEffect: fromFiberEffect,
	fromNullable: fromNullable,
	gen: gen$1,
	getFiberRefs: getFiberRefs,
	getRuntimeFlags: getRuntimeFlags,
	head: head$2,
	'if': if_$1,
	ignore: ignore$1,
	ignoreLogged: ignoreLogged,
	inheritFiberRefs: inheritFiberRefs,
	interrupt: interrupt$2,
	interruptWith: interruptWith,
	interruptible: interruptible,
	interruptibleMask: interruptibleMask,
	intoDeferred: intoDeferred,
	isEffect: isEffect,
	isFailure: isFailure$3,
	isSuccess: isSuccess$3,
	iterate: iterate$2,
	labelMetrics: labelMetrics,
	labelMetricsScoped: labelMetricsScoped,
	labelMetricsScopedSet: labelMetricsScopedSet,
	labelMetricsSet: labelMetricsSet,
	'let': let_$2,
	linkSpans: linkSpans,
	locally: locally,
	locallyScoped: locallyScoped,
	locallyScopedWith: locallyScopedWith,
	locallyWith: locallyWith,
	log: log$1,
	logAnnotations: logAnnotations,
	logDebug: logDebug,
	logError: logError,
	logFatal: logFatal,
	logInfo: logInfo,
	logTrace: logTrace,
	logWarning: logWarning,
	loop: loop$1,
	makeSemaphore: makeSemaphore,
	makeSpan: makeSpan,
	makeSpanScoped: makeSpanScoped,
	map: map$6,
	mapAccum: mapAccum$1,
	mapBoth: mapBoth$2,
	mapError: mapError$4,
	mapErrorCause: mapErrorCause$2,
	mapInputContext: mapInputContext$4,
	match: match$9,
	matchCause: matchCause,
	matchCauseEffect: matchCauseEffect,
	matchEffect: matchEffect$1,
	merge: merge$4,
	mergeAll: mergeAll$3,
	metricLabels: metricLabels,
	negate: negate$1,
	never: never$4,
	none: none$1,
	onError: onError$1,
	onExit: onExit,
	onInterrupt: onInterrupt,
	once: once,
	option: option$2,
	optionFromOptional: optionFromOptional,
	orDie: orDie$3,
	orDieWith: orDieWith$3,
	orElse: orElse$5,
	orElseFail: orElseFail$2,
	orElseSucceed: orElseSucceed$2,
	parallelErrors: parallelErrors,
	parallelFinalizers: parallelFinalizers,
	partition: partition$2,
	patchFiberRefs: patchFiberRefs,
	patchRuntimeFlags: patchRuntimeFlags,
	promise: promise,
	provide: provide,
	provideService: provideService$3,
	provideServiceEffect: provideServiceEffect$1,
	race: race$2,
	raceAll: raceAll,
	raceFirst: raceFirst,
	raceWith: raceWith$1,
	random: random,
	randomWith: randomWith,
	reduce: reduce$5,
	reduceEffect: reduceEffect,
	reduceRight: reduceRight$1,
	reduceWhile: reduceWhile,
	repeat: repeat$1,
	repeatN: repeatN,
	repeatOrElse: repeatOrElse,
	repeatUntil: repeatUntil$1,
	repeatUntilEffect: repeatUntilEffect,
	repeatWhile: repeatWhile$1,
	repeatWhileEffect: repeatWhileEffect,
	replicate: replicate$1,
	replicateEffect: replicateEffect,
	request: request,
	retry: retry$5,
	retryN: retryN,
	retryOrElse: retryOrElse,
	retryUntil: retryUntil$1,
	retryUntilEffect: retryUntilEffect,
	retryWhile: retryWhile$1,
	retryWhileEffect: retryWhileEffect,
	runCallback: runCallback,
	runFork: runFork,
	runPromise: runPromise,
	runPromiseExit: runPromiseExit$1,
	runRequestBlock: runRequestBlock,
	runSync: runSync,
	runSyncExit: runSyncExit,
	runtime: runtime,
	sandbox: sandbox,
	schedule: schedule$1,
	scheduleForked: scheduleForked,
	scheduleFrom: scheduleFrom,
	scope: scope,
	scopeWith: scopeWith,
	scoped: scoped$2,
	sequentialFinalizers: sequentialFinalizers,
	serviceConstants: serviceConstants,
	serviceFunction: serviceFunction,
	serviceFunctionEffect: serviceFunctionEffect,
	serviceFunctions: serviceFunctions,
	serviceMembers: serviceMembers,
	serviceOption: serviceOption,
	setFiberRefs: setFiberRefs,
	sleep: sleep,
	spanAnnotations: spanAnnotations,
	spanLinks: spanLinks,
	step: step,
	succeed: succeed$7,
	succeedNone: succeedNone$1,
	succeedSome: succeedSome$1,
	summarized: summarized$2,
	supervised: supervised,
	suspend: suspend$5,
	sync: sync$4,
	tagMetrics: tagMetrics,
	tagMetricsScoped: tagMetricsScoped,
	takeUntil: takeUntil$1,
	takeWhile: takeWhile$1,
	tap: tap$3,
	tapBoth: tapBoth$2,
	tapDefect: tapDefect,
	tapError: tapError$2,
	tapErrorCause: tapErrorCause$1,
	tapErrorTag: tapErrorTag,
	timed: timed$1,
	timedWith: timedWith,
	timeout: timeout$1,
	timeoutFail: timeoutFail$1,
	timeoutFailCause: timeoutFailCause$1,
	timeoutTo: timeoutTo$1,
	tracer: tracer,
	tracerWith: tracerWith,
	transplant: transplant,
	'try': try_$1,
	tryMap: tryMap,
	tryMapPromise: tryMapPromise,
	tryPromise: tryPromise,
	unified: unified,
	unifiedFn: unifiedFn,
	uninterruptible: uninterruptible,
	uninterruptibleMask: uninterruptibleMask,
	unit: unit$3,
	unless: unless$1,
	unlessEffect: unlessEffect,
	unsafeMakeSemaphore: unsafeMakeSemaphore$1,
	unsandbox: unsandbox,
	updateFiberRefs: updateFiberRefs,
	updateService: updateService$2,
	useSpan: useSpan,
	using: using,
	validate: validate,
	validateAll: validateAll$1,
	validateFirst: validateFirst$1,
	validateWith: validateWith,
	when: when$3,
	whenEffect: whenEffect$1,
	whenFiberRef: whenFiberRef,
	whenRef: whenRef,
	whileLoop: whileLoop,
	withClock: withClock,
	withClockScoped: withClockScoped,
	withConcurrency: withConcurrency,
	withConfigProvider: withConfigProvider,
	withConfigProviderScoped: withConfigProviderScoped,
	withEarlyRelease: withEarlyRelease,
	withLogSpan: withLogSpan,
	withMaxOpsBeforeYield: withMaxOpsBeforeYield,
	withMetric: withMetric,
	withParentSpan: withParentSpan,
	withRequestBatching: withRequestBatching,
	withRequestCache: withRequestCache,
	withRequestCaching: withRequestCaching,
	withRuntimeFlagsPatch: withRuntimeFlagsPatch,
	withRuntimeFlagsPatchScoped: withRuntimeFlagsPatchScoped,
	withScheduler: withScheduler,
	withSchedulingPriority: withSchedulingPriority,
	withSpan: withSpan$2,
	withSpanScoped: withSpanScoped,
	withTracer: withTracer,
	withTracerScoped: withTracerScoped,
	withTracerTiming: withTracerTiming,
	withUnhandledErrorLogLevel: withUnhandledErrorLogLevel,
	yieldNow: yieldNow,
	zip: zip$5,
	zipLeft: zipLeft$4,
	zipRight: zipRight$4,
	zipWith: zipWith$3
});

// circular with Logger

/** @internal */
const minimumLogLevel = level => scopedDiscard(fiberRefLocallyScoped$1(currentMinimumLogLevel, level));

/** @internal */
const withMinimumLogLevel = /*#__PURE__*/dual(2, (self, level) => fiberRefLocally$1(currentMinimumLogLevel, level)(self));

/** @internal */
const addLogger = logger => scopedDiscard(fiberRefLocallyScopedWith$1(currentLoggers, add$2(logger)));

/** @internal */
const addLoggerEffect = effect => unwrapEffect(map$f(effect, addLogger));

/** @internal */
const addLoggerScoped = effect => unwrapScoped$3(map$f(effect, addLogger));

/** @internal */
const removeLogger = logger => scopedDiscard(fiberRefLocallyScopedWith$1(currentLoggers, remove$6(logger)));

/** @internal */
const replaceLogger = /*#__PURE__*/dual(2, (self, that) => flatMap$5(removeLogger(self), () => addLogger(that)));

/** @internal */
const replaceLoggerEffect = /*#__PURE__*/dual(2, (self, that) => flatMap$5(removeLogger(self), () => addLoggerEffect(that)));

/** @internal */
const replaceLoggerScoped = /*#__PURE__*/dual(2, (self, that) => flatMap$5(removeLogger(self), () => addLoggerScoped(that)));

/** @internal */
const addSupervisor = supervisor => scopedDiscard(fiberRefLocallyScopedWith$1(currentSupervisor, current => new Zip(current, supervisor)));

/** @internal */
const enableCooperativeYielding = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/enable$2(CooperativeYielding)));

/** @internal */
const enableInterruption = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/enable$2(Interruption)));

/** @internal */
const enableOpSupervision = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/enable$2(OpSupervision)));

/** @internal */
const enableRuntimeMetrics = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/enable$2(RuntimeMetrics)));

/** @internal */
const enableWindDown = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/enable$2(WindDown)));

/** @internal */
const disableCooperativeYielding = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/disable$2(CooperativeYielding)));

/** @internal */
const disableInterruption = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/disable$2(Interruption)));

/** @internal */
const disableOpSupervision = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/disable$2(OpSupervision)));

/** @internal */
const disableRuntimeMetrics = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/disable$2(RuntimeMetrics)));

/** @internal */
const disableWindDown = /*#__PURE__*/scopedDiscard( /*#__PURE__*/withRuntimeFlagsScoped( /*#__PURE__*/disable$2(WindDown)));

/** @internal */
const setConfigProvider = configProvider => scopedDiscard(withConfigProviderScoped$1(configProvider));

/** @internal */
const parentSpan = span => succeedContext(make$12(spanTag, span));

/** @internal */
const span = (name, options) => scoped$3(spanTag, options?.onEnd ? tap$5(makeSpanScoped$1(name, options), span => addFinalizer$2(exit => options.onEnd(span, exit))) : makeSpanScoped$1(name, options));

/** @internal */
const setTracer = tracer => scopedDiscard(withTracerScoped$1(tracer));

/**
 * A `Layer<RIn, E, ROut>` describes how to build one or more services in your
 * application. Services can be injected into effects via
 * `Effect.provideService`. Effects can require services via `Effect.service`.
 *
 * Layer can be thought of as recipes for producing bundles of services, given
 * their dependencies (other services).
 *
 * Construction of services can be effectful and utilize resources that must be
 * acquired and safely released when the services are done being utilized.
 *
 * By default layers are shared, meaning that if the same layer is used twice
 * the layer will only be allocated a single time.
 *
 * Because of their excellent composition properties, layers are the idiomatic
 * way in Effect-TS to create services that depend on other services.
 *
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
LayerTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Returns `true` if the specified value is a `Layer`, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isLayer;

/**
 * Returns `true` if the specified `Layer` is a fresh version that will not be
 * shared, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isFresh;

/**
 * Builds a layer into a scoped value.
 *
 * @since 2.0.0
 * @category destructors
 */
const build = build$1;

/**
 * Builds a layer into an `Effect` value. Any resources associated with this
 * layer will be released when the specified scope is closed unless their scope
 * has been extended. This allows building layers where the lifetime of some of
 * the services output by the layer exceed the lifetime of the effect the
 * layer is provided to.
 *
 * @since 2.0.0
 * @category destructors
 */
buildWithScope;

/**
 * Recovers from all errors.
 *
 * @since 2.0.0
 * @category error handling
 */
catchAll$4;

/**
 * Recovers from all errors.
 *
 * @since 2.0.0
 * @category error handling
 */
catchAllCause$3;

/**
 * Constructs a `Layer` that passes along the specified context as an
 * output.
 *
 * @since 2.0.0
 * @category constructors
 */
const context$4 = context$6;

/**
 * Constructs a layer that dies with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
die$6;

/**
 * Constructs a layer that dies with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
dieSync$4;

/**
 * Replaces the layer's output with `void` and includes the layer only for its
 * side-effects.
 *
 * @since 2.0.0
 * @category mapping
 */
discard;

/**
 * Constructs a layer from the specified effect.
 *
 * @since 2.0.0
 * @category constructors
 */
const effect$2 = fromEffect$4;

/**
 * Constructs a layer from the specified effect discarding it's output.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEffectDiscard;

/**
 * Extends the scope of this layer, returning a new layer that when provided
 * to an effect will not immediately release its associated resources when
 * that effect completes execution but instead when the scope the resulting
 * effect depends on is closed.
 *
 * @since 2.0.0
 * @category utils
 */
extendScope;

/**
 * Constructs a layer that fails with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$8;

/**
 * Constructs a layer that fails with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
failSync$5;

/**
 * Constructs a layer that fails with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
failCause$6;

/**
 * Constructs a layer that fails with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
failCauseSync$4;

/**
 * Constructs a layer dynamically based on the output of this layer.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatMap$5;

/**
 * Flattens layers nested in the context of an effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatten$4;

/**
 * Creates a fresh version of this layer that will not be shared.
 *
 * @since 2.0.0
 * @category utils
 */
fresh;
fromFunction$1;

/**
 * Builds this layer and uses it until it is interrupted. This is useful when
 * your entire application is a layer, such as an HTTP server.
 *
 * @since 2.0.0
 * @category conversions
 */
launch$1;

/**
 * Returns a new layer whose output is mapped by the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
map$7;

/**
 * Returns a layer with its error channel mapped using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
mapError$5;

/**
 * Feeds the error or output services of this layer into the input of either
 * the specified `failure` or `success` layers, resulting in a new layer with
 * the inputs of this layer, and the error or outputs of the specified layer.
 *
 * @since 2.0.0
 * @category folding
 */
match$a;

/**
 * Feeds the error or output services of this layer into the input of either
 * the specified `failure` or `success` layers, resulting in a new layer with
 * the inputs of this layer, and the error or outputs of the specified layer.
 *
 * @since 2.0.0
 * @category folding
 */
matchCause$1;

/**
 * Returns a scoped effect that, if evaluated, will return the lazily computed
 * result of this layer.
 *
 * @since 2.0.0
 * @category utils
 */
memoize;

/**
 * Combines this layer with the specified layer, producing a new layer that
 * has the inputs and outputs of both.
 *
 * @since 2.0.0
 * @category utils
 */
const merge$3 = merge$5;

/**
 * Merges all the layers together in parallel.
 *
 * @since 2.0.0
 * @category zipping
 */
mergeAll$4;

/**
 * Translates effect failure into death of the fiber, making all failures
 * unchecked and not a part of the type of the layer.
 *
 * @since 2.0.0
 * @category error handling
 */
orDie$4;

/**
 * Executes this layer and returns its output, if it succeeds, but otherwise
 * executes the specified layer.
 *
 * @since 2.0.0
 * @category error handling
 */
orElse$6;

/**
 * Returns a new layer that produces the outputs of this layer but also
 * passes through the inputs.
 *
 * @since 2.0.0
 * @category utils
 */
passthrough;

/**
 * Projects out part of one of the services output by this layer using the
 * specified function.
 *
 * @since 2.0.0
 * @category utils
 */
project;

/**
 * Feeds the output services of this builder into the input of the specified
 * builder, resulting in a new builder with the inputs of this builder as
 * well as any leftover inputs, and the outputs of the specified builder.
 *
 * @since 2.0.0
 * @category utils
 */
provide$1;

/**
 * @since 2.0.0
 * @category utils
 */
locallyEffect;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefLocally;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefLocallyWith;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefLocallyScoped;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefLocallyScopedWith;

/**
 * Feeds the output services of this layer into the input of the specified
 * layer, resulting in a new layer with the inputs of this layer, and the
 * outputs of both layers.
 *
 * @since 2.0.0
 * @category utils
 */
provideMerge;

/**
 * Retries constructing this layer according to the specified schedule.
 *
 * @since 2.0.0
 * @category retrying
 */
retry$6;

/**
 * A layer that constructs a scope and closes it when the workflow the layer
 * is provided to completes execution, whether by success, failure, or
 * interruption. This can be used to close a scope when providing a layer to a
 * workflow.
 *
 * @since 2.0.0
 * @category constructors
 */
scope$1;

/**
 * Constructs a layer from the specified scoped effect.
 *
 * @since 2.0.0
 * @category constructors
 */
scoped$3;

/**
 * Constructs a layer from the specified scoped effect.
 *
 * @since 2.0.0
 * @category constructors
 */
scopedDiscard;

/**
 * Constructs a layer from the specified scoped effect, which must return one
 * or more services.
 *
 * @since 2.0.0
 * @category constructors
 */
scopedContext;

/**
 * Constructs a layer that accesses and returns the specified service from the
 * context.
 *
 * @since 2.0.0
 * @category constructors
 */
service;

/**
 * Constructs a layer from the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$8;

/**
 * Constructs a layer from the specified value, which must return one or more
 * services.
 *
 * @since 2.0.0
 * @category constructors
 */
succeedContext;

/**
 * Lazily constructs a layer. This is useful to avoid infinite recursion when
 * creating layers that refer to themselves.
 *
 * @since 2.0.0
 * @category constructors
 */
suspend$6;

/**
 * Lazily constructs a layer from the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
sync$5;

/**
 * Lazily constructs a layer from the specified value, which must return one or more
 * services.
 *
 * @since 2.0.0
 * @category constructors
 */
syncContext;

/**
 * Performs the specified effect if this layer succeeds.
 *
 * @since 2.0.0
 * @category sequencing
 */
tap$4;

/**
 * Performs the specified effect if this layer fails.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapError$3;

/**
 * Performs the specified effect if this layer fails.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapErrorCause$2;

/**
 * Converts a layer that requires no services into a scoped runtime, which can
 * be used to execute effects.
 *
 * @since 2.0.0
 * @category conversions
 */
toRuntime;

/**
 * Feeds the output services of this builder into the input of the specified
 * builder, resulting in a new builder with the inputs of this builder as
 * well as any leftover inputs, and the outputs of the specified builder.
 *
 * @since 2.0.0
 * @category utils
 */
use;

/**
 * Feeds the output services of this layer into the input of the specified
 * layer, resulting in a new layer with the inputs of this layer, and the
 * outputs of both layers.
 *
 * @since 2.0.0
 * @category utils
 */
useMerge;

/**
 * Combines this layer the specified layer, producing a new layer that has the
 * inputs of both, and the outputs of both combined using the specified
 * function.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWithPar;

/**
 * @since 2.0.0
 * @category utils
 */
unwrapEffect;

/**
 * @since 2.0.0
 * @category utils
 */
unwrapScoped$3;

/**
 * Sets the current `ConfigProvider`.
 *
 * @since 2.0.0
 * @category config
 */
setConfigProvider;

/**
 * Adds the provided span to the span stack.
 *
 * @since 2.0.0
 * @category tracing
 */
parentSpan;

/**
 * Create and add a span to the current span stack.
 *
 * The span is ended when the Layer is released.
 *
 * @since 2.0.0
 * @category tracing
 */
span;

/**
 * Create a Layer that sets the current Tracer
 *
 * @since 2.0.0
 * @category tracing
 */
setTracer;

/**
 * @since 2.0.0
 * @category tracing
 */
withSpan$3;

/**
 * @since 2.0.0
 * @category tracing
 */
withParentSpan$1;

/** @internal */
const EnqueueSymbolKey = "effect/QueueEnqueue";

/** @internal */
const EnqueueTypeId = /*#__PURE__*/Symbol.for(EnqueueSymbolKey);

/** @internal */
const DequeueSymbolKey = "effect/QueueDequeue";

/** @internal */
const DequeueTypeId$1 = /*#__PURE__*/Symbol.for(DequeueSymbolKey);

/** @internal */
const QueueStrategySymbolKey = "effect/QueueStrategy";

/** @internal */
const QueueStrategyTypeId = /*#__PURE__*/Symbol.for(QueueStrategySymbolKey);

/** @internal */
const queueStrategyVariance = {
  _A: _ => _
};

/** @internal */
const enqueueVariance = {
  _In: _ => _
};

/** @internal */
const dequeueVariance = {
  _Out: _ => _
};

/** @internal */
class QueueImpl {
  [EnqueueTypeId] = enqueueVariance;
  [DequeueTypeId$1] = dequeueVariance;
  constructor( /** @internal */
  queue, /** @internal */
  takers, /** @internal */
  shutdownHook, /** @internal */
  shutdownFlag, /** @internal */
  strategy) {
    this.queue = queue;
    this.takers = takers;
    this.shutdownHook = shutdownHook;
    this.shutdownFlag = shutdownFlag;
    this.strategy = strategy;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  capacity() {
    return this.queue.capacity();
  }
  size() {
    return suspend$8(() => catchAll$5(this.unsafeSize(), () => interrupt$7));
  }
  unsafeSize() {
    if (get$f(this.shutdownFlag)) {
      return none$8();
    }
    return some$6(this.queue.length() - length(this.takers) + this.strategy.surplusSize());
  }
  isEmpty() {
    return map$f(this.size(), size => size <= 0);
  }
  isFull() {
    return map$f(this.size(), size => size >= this.capacity());
  }
  shutdown() {
    return uninterruptible$1(withFiberRuntime(state => {
      pipe(this.shutdownFlag, set$a(true));
      return pipe(forEachParUnboundedDiscard(unsafePollAll(this.takers), d => deferredInterruptWith(d, state.id()), false), zipRight$8(this.strategy.shutdown()), whenEffect$2(deferredSucceed(this.shutdownHook, void 0)), asUnit$4);
    }));
  }
  isShutdown() {
    return sync$a(() => get$f(this.shutdownFlag));
  }
  awaitShutdown() {
    return deferredAwait(this.shutdownHook);
  }
  isActive() {
    return !get$f(this.shutdownFlag);
  }
  unsafeOffer(value) {
    if (get$f(this.shutdownFlag)) {
      return false;
    }
    let noRemaining;
    if (this.queue.length() === 0) {
      const taker = pipe(this.takers, poll$7(EmptyMutableQueue));
      if (taker !== EmptyMutableQueue) {
        unsafeCompleteDeferred$1(taker, value);
        noRemaining = true;
      } else {
        noRemaining = false;
      }
    } else {
      noRemaining = false;
    }
    if (noRemaining) {
      return true;
    }
    // Not enough takers, offer to the queue
    const succeeded = this.queue.offer(value);
    unsafeCompleteTakers(this.strategy, this.queue, this.takers);
    return succeeded;
  }
  offer(value) {
    return suspend$8(() => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      let noRemaining;
      if (this.queue.length() === 0) {
        const taker = pipe(this.takers, poll$7(EmptyMutableQueue));
        if (taker !== EmptyMutableQueue) {
          unsafeCompleteDeferred$1(taker, value);
          noRemaining = true;
        } else {
          noRemaining = false;
        }
      } else {
        noRemaining = false;
      }
      if (noRemaining) {
        return succeed$h(true);
      }
      // Not enough takers, offer to the queue
      const succeeded = this.queue.offer(value);
      unsafeCompleteTakers(this.strategy, this.queue, this.takers);
      return succeeded ? succeed$h(true) : this.strategy.handleSurplus([value], this.queue, this.takers, this.shutdownFlag);
    });
  }
  offerAll(iterable) {
    return suspend$8(() => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      const values = fromIterable$c(iterable);
      const pTakers = this.queue.length() === 0 ? fromIterable$c(unsafePollN$1(this.takers, values.length)) : empty$C;
      const [forTakers, remaining] = pipe(values, splitAt$1(pTakers.length));
      for (let i = 0; i < pTakers.length; i++) {
        const taker = pTakers[i];
        const item = forTakers[i];
        unsafeCompleteDeferred$1(taker, item);
      }
      if (remaining.length === 0) {
        return succeed$h(true);
      }
      // Not enough takers, offer to the queue
      const surplus = this.queue.offerAll(remaining);
      unsafeCompleteTakers(this.strategy, this.queue, this.takers);
      return isEmpty$h(surplus) ? succeed$h(true) : this.strategy.handleSurplus(surplus, this.queue, this.takers, this.shutdownFlag);
    });
  }
  take() {
    return withFiberRuntime(state => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      const item = this.queue.poll(EmptyMutableQueue);
      if (item !== EmptyMutableQueue) {
        this.strategy.unsafeOnQueueEmptySpace(this.queue, this.takers);
        return succeed$h(item);
      } else {
        // Add the deferred to takers, then:
        // - Try to take again in case a value was added since
        // - Wait for the deferred to be completed
        // - Clean up resources in case of interruption
        const deferred = deferredUnsafeMake(state.id());
        return pipe(suspend$8(() => {
          pipe(this.takers, offer$5(deferred));
          unsafeCompleteTakers(this.strategy, this.queue, this.takers);
          return get$f(this.shutdownFlag) ? interrupt$7 : deferredAwait(deferred);
        }), onInterrupt$1(() => {
          return sync$a(() => unsafeRemove$1(this.takers, deferred));
        }));
      }
    });
  }
  takeAll() {
    return suspend$8(() => {
      return get$f(this.shutdownFlag) ? interrupt$7 : sync$a(() => {
        const values = this.queue.pollUpTo(Number.POSITIVE_INFINITY);
        this.strategy.unsafeOnQueueEmptySpace(this.queue, this.takers);
        return fromIterable$b(values);
      });
    });
  }
  takeUpTo(max) {
    return suspend$8(() => get$f(this.shutdownFlag) ? interrupt$7 : sync$a(() => {
      const values = this.queue.pollUpTo(max);
      this.strategy.unsafeOnQueueEmptySpace(this.queue, this.takers);
      return fromIterable$b(values);
    }));
  }
  takeBetween(min, max) {
    return suspend$8(() => takeRemainderLoop$1(this, min, max, empty$z()));
  }
}

/** @internal */
const takeRemainderLoop$1 = (self, min, max, acc) => {
  if (max < min) {
    return succeed$h(acc);
  }
  return pipe(takeUpTo$3(self, max), flatMap$6(bs => {
    const remaining = min - bs.length;
    if (remaining === 1) {
      return pipe(take$6(self), map$f(b => pipe(acc, appendAll$1(bs), append$1(b))));
    }
    if (remaining > 1) {
      return pipe(take$6(self), flatMap$6(b => takeRemainderLoop$1(self, remaining - 1, max - bs.length - 1, pipe(acc, appendAll$1(bs), append$1(b)))));
    }
    return succeed$h(pipe(acc, appendAll$1(bs)));
  }));
};

/** @internal */
const isQueue = u => isEnqueue(u) && isDequeue(u);

/** @internal */
const isEnqueue = u => typeof u === "object" && u != null && EnqueueTypeId in u;

/** @internal */
const isDequeue = u => typeof u === "object" && u != null && DequeueTypeId$1 in u;

/** @internal */
const bounded$5 = requestedCapacity => pipe(sync$a(() => bounded$6(requestedCapacity)), flatMap$6(queue => make$t(backingQueueFromMutableQueue(queue), backPressureStrategy())));

/** @internal */
const dropping$4 = requestedCapacity => pipe(sync$a(() => bounded$6(requestedCapacity)), flatMap$6(queue => make$t(backingQueueFromMutableQueue(queue), droppingStrategy())));

/** @internal */
const sliding$5 = requestedCapacity => pipe(sync$a(() => bounded$6(requestedCapacity)), flatMap$6(queue => make$t(backingQueueFromMutableQueue(queue), slidingStrategy())));

/** @internal */
const unbounded$5 = () => pipe(sync$a(() => unbounded$6()), flatMap$6(queue => make$t(backingQueueFromMutableQueue(queue), droppingStrategy())));

/** @internal */
const unsafeMake = (queue, takers, shutdownHook, shutdownFlag, strategy) => {
  return new QueueImpl(queue, takers, shutdownHook, shutdownFlag, strategy);
};

/** @internal */
const make$t = (queue, strategy) => pipe(deferredMake(), map$f(deferred => unsafeMake(queue, unbounded$6(), deferred, make$W(false), strategy)));

/** @internal */
class BackingQueueFromMutableQueue {
  constructor(mutable) {
    this.mutable = mutable;
  }
  poll(def) {
    return poll$7(this.mutable, def);
  }
  pollUpTo(limit) {
    return pollUpTo(this.mutable, limit);
  }
  offerAll(elements) {
    return offerAll$4(this.mutable, elements);
  }
  offer(element) {
    return offer$5(this.mutable, element);
  }
  capacity() {
    return capacity$5(this.mutable);
  }
  length() {
    return length(this.mutable);
  }
}

/** @internal */
const backingQueueFromMutableQueue = mutable => new BackingQueueFromMutableQueue(mutable);

/** @internal */
const capacity$4 = self => self.capacity();

/** @internal */
const size$9 = self => self.size();

/** @internal */
const isFull$4 = self => self.isFull();

/** @internal */
const isEmpty$8 = self => self.isEmpty();

/** @internal */
const isShutdown$4 = self => self.isShutdown();

/** @internal */
const awaitShutdown$4 = self => self.awaitShutdown();

/** @internal */
const shutdown$5 = self => self.shutdown();

/** @internal */
const offer$4 = /*#__PURE__*/dual(2, (self, value) => self.offer(value));

/** @internal */
const unsafeOffer = /*#__PURE__*/dual(2, (self, value) => self.unsafeOffer(value));

/** @internal */
const offerAll$3 = /*#__PURE__*/dual(2, (self, iterable) => self.offerAll(iterable));

/** @internal */
const poll$4 = self => map$f(self.takeUpTo(1), head$4);

/** @internal */
const take$6 = self => self.take();

/** @internal */
const takeAll$3 = self => self.takeAll();

/** @internal */
const takeUpTo$3 = /*#__PURE__*/dual(2, (self, max) => self.takeUpTo(max));

/** @internal */
const takeBetween$2 = /*#__PURE__*/dual(3, (self, min, max) => self.takeBetween(min, max));

/** @internal */
const takeN$2 = /*#__PURE__*/dual(2, (self, n) => self.takeBetween(n, n));

// -----------------------------------------------------------------------------
// Strategy
// -----------------------------------------------------------------------------

/** @internal */
const backPressureStrategy = () => new BackPressureStrategy$1();

/** @internal */
const droppingStrategy = () => new DroppingStrategy$1();

/** @internal */
const slidingStrategy = () => new SlidingStrategy$1();

/** @internal */
class BackPressureStrategy$1 {
  [QueueStrategyTypeId] = queueStrategyVariance;
  putters = unbounded$6();
  surplusSize() {
    return length(this.putters);
  }
  onCompleteTakersWithEmptyQueue(takers) {
    while (!isEmpty$b(this.putters) && !isEmpty$b(takers)) {
      const taker = poll$7(takers, void 0);
      const putter = poll$7(this.putters, void 0);
      if (putter[2]) {
        unsafeCompleteDeferred$1(putter[1], true);
      }
      unsafeCompleteDeferred$1(taker, putter[0]);
    }
  }
  shutdown() {
    return pipe(fiberId$2, flatMap$6(fiberId => pipe(sync$a(() => unsafePollAll(this.putters)), flatMap$6(putters => forEachParUnboundedDiscard(putters, ([_, deferred, isLastItem]) => isLastItem ? pipe(deferredInterruptWith(deferred, fiberId), asUnit$4) : unit$6, false)))));
  }
  handleSurplus(iterable, queue, takers, isShutdown) {
    return withFiberRuntime(state => {
      const deferred = deferredUnsafeMake(state.id());
      return pipe(suspend$8(() => {
        this.unsafeOffer(iterable, deferred);
        this.unsafeOnQueueEmptySpace(queue, takers);
        unsafeCompleteTakers(this, queue, takers);
        return get$f(isShutdown) ? interrupt$7 : deferredAwait(deferred);
      }), onInterrupt$1(() => sync$a(() => this.unsafeRemove(deferred))));
    });
  }
  unsafeOnQueueEmptySpace(queue, takers) {
    let keepPolling = true;
    while (keepPolling && (queue.capacity() === Number.POSITIVE_INFINITY || queue.length() < queue.capacity())) {
      const putter = pipe(this.putters, poll$7(EmptyMutableQueue));
      if (putter === EmptyMutableQueue) {
        keepPolling = false;
      } else {
        const offered = queue.offer(putter[0]);
        if (offered && putter[2]) {
          unsafeCompleteDeferred$1(putter[1], true);
        } else if (!offered) {
          unsafeOfferAll$1(this.putters, pipe(unsafePollAll(this.putters), prepend$2(putter)));
        }
        unsafeCompleteTakers(this, queue, takers);
      }
    }
  }
  unsafeOffer(iterable, deferred) {
    const stuff = Array.from(iterable);
    for (let i = 0; i < stuff.length; i++) {
      const value = stuff[i];
      if (i === stuff.length - 1) {
        pipe(this.putters, offer$5([value, deferred, true]));
      } else {
        pipe(this.putters, offer$5([value, deferred, false]));
      }
    }
  }
  unsafeRemove(deferred) {
    unsafeOfferAll$1(this.putters, pipe(unsafePollAll(this.putters), filter$9(([, _]) => _ !== deferred)));
  }
}

/** @internal */
class DroppingStrategy$1 {
  [QueueStrategyTypeId] = queueStrategyVariance;
  surplusSize() {
    return 0;
  }
  shutdown() {
    return unit$6;
  }
  onCompleteTakersWithEmptyQueue() {}
  handleSurplus(_iterable, _queue, _takers, _isShutdown) {
    return succeed$h(false);
  }
  unsafeOnQueueEmptySpace(_queue, _takers) {
    //
  }
}

/** @internal */
class SlidingStrategy$1 {
  [QueueStrategyTypeId] = queueStrategyVariance;
  surplusSize() {
    return 0;
  }
  shutdown() {
    return unit$6;
  }
  onCompleteTakersWithEmptyQueue() {}
  handleSurplus(iterable, queue, takers, _isShutdown) {
    return sync$a(() => {
      this.unsafeOffer(queue, iterable);
      unsafeCompleteTakers(this, queue, takers);
      return true;
    });
  }
  unsafeOnQueueEmptySpace(_queue, _takers) {
    //
  }
  unsafeOffer(queue, iterable) {
    const iterator = iterable[Symbol.iterator]();
    let next;
    let offering = true;
    while (!(next = iterator.next()).done && offering) {
      if (queue.capacity() === 0) {
        return;
      }
      // Poll 1 and retry
      queue.poll(EmptyMutableQueue);
      offering = queue.offer(next.value);
    }
  }
}

/** @internal */
const unsafeCompleteDeferred$1 = (deferred, a) => {
  return deferredUnsafeDone(deferred, succeed$h(a));
};

/** @internal */
const unsafeOfferAll$1 = (queue, as) => {
  return pipe(queue, offerAll$4(as));
};

/** @internal */
const unsafePollAll = queue => {
  return pipe(queue, pollUpTo(Number.POSITIVE_INFINITY));
};

/** @internal */
const unsafePollN$1 = (queue, max) => {
  return pipe(queue, pollUpTo(max));
};

/** @internal */
const unsafeRemove$1 = (queue, a) => {
  unsafeOfferAll$1(queue, pipe(unsafePollAll(queue), filter$9(b => a !== b)));
};

/** @internal */
const unsafeCompleteTakers = (strategy, queue, takers) => {
  // Check both a taker and an item are in the queue, starting with the taker
  let keepPolling = true;
  while (keepPolling && queue.length() !== 0) {
    const taker = pipe(takers, poll$7(EmptyMutableQueue));
    if (taker !== EmptyMutableQueue) {
      const element = queue.poll(EmptyMutableQueue);
      if (element !== EmptyMutableQueue) {
        unsafeCompleteDeferred$1(taker, element);
        strategy.unsafeOnQueueEmptySpace(queue, takers);
      } else {
        unsafeOfferAll$1(takers, pipe(unsafePollAll(takers), prepend$2(taker)));
      }
      keepPolling = true;
    } else {
      keepPolling = false;
    }
  }
  if (keepPolling && queue.length() === 0 && !isEmpty$b(takers)) {
    strategy.onCompleteTakersWithEmptyQueue(takers);
  }
};

/** @internal */

/** @internal */

/** @internal */

const addSubscribers = (subscription, pollers) => subscribers => {
  if (!subscribers.has(subscription)) {
    subscribers.set(subscription, new Set());
  }
  const set = subscribers.get(subscription);
  set.add(pollers);
};
const removeSubscribers = (subscription, pollers) => subscribers => {
  if (!subscribers.has(subscription)) {
    return;
  }
  const set = subscribers.get(subscription);
  set.delete(pollers);
  if (set.size === 0) {
    subscribers.delete(subscription);
  }
};

/** @internal */
const bounded$4 = requestedCapacity => pipe(sync$a(() => makeBoundedPubSub(requestedCapacity)), flatMap$6(atomicPubSub => makePubSub(atomicPubSub, new BackPressureStrategy())));

/** @internal */
const dropping$3 = requestedCapacity => pipe(sync$a(() => makeBoundedPubSub(requestedCapacity)), flatMap$6(atomicPubSub => makePubSub(atomicPubSub, new DroppingStrategy())));

/** @internal */
const sliding$4 = requestedCapacity => pipe(sync$a(() => makeBoundedPubSub(requestedCapacity)), flatMap$6(atomicPubSub => makePubSub(atomicPubSub, new SlidingStrategy())));

/** @internal */
const unbounded$4 = () => pipe(sync$a(() => makeUnboundedPubSub()), flatMap$6(atomicPubSub => makePubSub(atomicPubSub, new DroppingStrategy())));

/** @internal */
const capacity$3 = self => self.capacity();

/** @internal */
const size$8 = self => self.size();

/** @internal */
const isFull$3 = self => self.isFull();

/** @internal */
const isEmpty$7 = self => self.isEmpty();

/** @internal */
const shutdown$4 = self => self.shutdown();

/** @internal */
const isShutdown$3 = self => self.isShutdown();

/** @internal */
const awaitShutdown$3 = self => self.awaitShutdown();

/** @internal */
const publish$2 = /*#__PURE__*/dual(2, (self, value) => self.publish(value));

/** @internal */
const publishAll$1 = /*#__PURE__*/dual(2, (self, elements) => self.publishAll(elements));

/** @internal */
const subscribe$2 = self => self.subscribe();

/** @internal */
const makeBoundedPubSub = requestedCapacity => {
  ensureCapacity(requestedCapacity);
  if (requestedCapacity === 1) {
    return new BoundedPubSubSingle();
  } else if (nextPow2(requestedCapacity) === requestedCapacity) {
    return new BoundedPubSubPow2(requestedCapacity);
  } else {
    return new BoundedPubSubArb(requestedCapacity);
  }
};

/** @internal */
const makeUnboundedPubSub = () => {
  return new UnboundedPubSub();
};

/** @internal */
const makeSubscription$1 = (pubsub, subscribers, strategy) => map$f(deferredMake(), deferred => unsafeMakeSubscription(pubsub, subscribers, pubsub.subscribe(), unbounded$6(), deferred, make$W(false), strategy));

/** @internal */
const unsafeMakeSubscription = (pubsub, subscribers, subscription, pollers, shutdownHook, shutdownFlag, strategy) => {
  return new SubscriptionImpl(pubsub, subscribers, subscription, pollers, shutdownHook, shutdownFlag, strategy);
};

/** @internal */
class BoundedPubSubArb {
  publisherIndex = 0;
  subscriberCount = 0;
  subscribersIndex = 0;
  constructor(requestedCapacity) {
    this.array = Array.from({
      length: requestedCapacity
    });
    this.subscribers = Array.from({
      length: requestedCapacity
    });
    this.capacity = requestedCapacity;
  }
  isEmpty() {
    return this.publisherIndex === this.subscribersIndex;
  }
  isFull() {
    return this.publisherIndex === this.subscribersIndex + this.capacity;
  }
  size() {
    return this.publisherIndex - this.subscribersIndex;
  }
  publish(value) {
    if (this.isFull()) {
      return false;
    }
    if (this.subscriberCount !== 0) {
      const index = this.publisherIndex % this.capacity;
      this.array[index] = value;
      this.subscribers[index] = this.subscriberCount;
      this.publisherIndex += 1;
    }
    return true;
  }
  publishAll(elements) {
    const chunk = fromIterable$b(elements);
    const n = chunk.length;
    const size = this.publisherIndex - this.subscribersIndex;
    const available = this.capacity - size;
    const forPubSub = Math.min(n, available);
    if (forPubSub === 0) {
      return chunk;
    }
    let iteratorIndex = 0;
    const publishAllIndex = this.publisherIndex + forPubSub;
    while (this.publisherIndex !== publishAllIndex) {
      const a = unsafeGet$5(chunk, iteratorIndex++);
      const index = this.publisherIndex % this.capacity;
      this.array[index] = a;
      this.subscribers[index] = this.subscriberCount;
      this.publisherIndex += 1;
    }
    return drop$2(chunk, iteratorIndex);
  }
  slide() {
    if (this.subscribersIndex !== this.publisherIndex) {
      const index = this.subscribersIndex % this.capacity;
      this.array[index] = null;
      this.subscribers[index] = 0;
      this.subscribersIndex += 1;
    }
  }
  subscribe() {
    this.subscriberCount += 1;
    return new BoundedPubSubArbSubscription(this, this.publisherIndex, false);
  }
}
class BoundedPubSubArbSubscription {
  constructor(self, subscriberIndex, unsubscribed) {
    this.self = self;
    this.subscriberIndex = subscriberIndex;
    this.unsubscribed = unsubscribed;
  }
  isEmpty() {
    return this.unsubscribed || this.self.publisherIndex === this.subscriberIndex || this.self.publisherIndex === this.self.subscribersIndex;
  }
  size() {
    if (this.unsubscribed) {
      return 0;
    }
    return this.self.publisherIndex - Math.max(this.subscriberIndex, this.self.subscribersIndex);
  }
  poll(default_) {
    if (this.unsubscribed) {
      return default_;
    }
    this.subscriberIndex = Math.max(this.subscriberIndex, this.self.subscribersIndex);
    if (this.subscriberIndex !== this.self.publisherIndex) {
      const index = this.subscriberIndex % this.self.capacity;
      const elem = this.self.array[index];
      this.self.subscribers[index] -= 1;
      if (this.self.subscribers[index] === 0) {
        this.self.array[index] = null;
        this.self.subscribersIndex += 1;
      }
      this.subscriberIndex += 1;
      return elem;
    }
    return default_;
  }
  pollUpTo(n) {
    if (this.unsubscribed) {
      return empty$z();
    }
    this.subscriberIndex = Math.max(this.subscriberIndex, this.self.subscribersIndex);
    const size = this.self.publisherIndex - this.subscriberIndex;
    const toPoll = Math.min(n, size);
    if (toPoll <= 0) {
      return empty$z();
    }
    const builder = [];
    const pollUpToIndex = this.subscriberIndex + toPoll;
    while (this.subscriberIndex !== pollUpToIndex) {
      const index = this.subscriberIndex % this.self.capacity;
      const a = this.self.array[index];
      this.self.subscribers[index] -= 1;
      if (this.self.subscribers[index] === 0) {
        this.self.array[index] = null;
        this.self.subscribersIndex += 1;
      }
      builder.push(a);
      this.subscriberIndex += 1;
    }
    return fromIterable$b(builder);
  }
  unsubscribe() {
    if (!this.unsubscribed) {
      this.unsubscribed = true;
      this.self.subscriberCount -= 1;
      this.subscriberIndex = Math.max(this.subscriberIndex, this.self.subscribersIndex);
      while (this.subscriberIndex !== this.self.publisherIndex) {
        const index = this.subscriberIndex % this.self.capacity;
        this.self.subscribers[index] -= 1;
        if (this.self.subscribers[index] === 0) {
          this.self.array[index] = null;
          this.self.subscribersIndex += 1;
        }
        this.subscriberIndex += 1;
      }
    }
  }
}

/** @internal */
class BoundedPubSubPow2 {
  publisherIndex = 0;
  subscriberCount = 0;
  subscribersIndex = 0;
  constructor(requestedCapacity) {
    this.array = Array.from({
      length: requestedCapacity
    });
    this.mask = requestedCapacity - 1;
    this.subscribers = Array.from({
      length: requestedCapacity
    });
    this.capacity = requestedCapacity;
  }
  isEmpty() {
    return this.publisherIndex === this.subscribersIndex;
  }
  isFull() {
    return this.publisherIndex === this.subscribersIndex + this.capacity;
  }
  size() {
    return this.publisherIndex - this.subscribersIndex;
  }
  publish(value) {
    if (this.isFull()) {
      return false;
    }
    if (this.subscriberCount !== 0) {
      const index = this.publisherIndex & this.mask;
      this.array[index] = value;
      this.subscribers[index] = this.subscriberCount;
      this.publisherIndex += 1;
    }
    return true;
  }
  publishAll(elements) {
    const chunk = fromIterable$b(elements);
    const n = chunk.length;
    const size = this.publisherIndex - this.subscribersIndex;
    const available = this.capacity - size;
    const forPubSub = Math.min(n, available);
    if (forPubSub === 0) {
      return chunk;
    }
    let iteratorIndex = 0;
    const publishAllIndex = this.publisherIndex + forPubSub;
    while (this.publisherIndex !== publishAllIndex) {
      const elem = unsafeGet$5(chunk, iteratorIndex++);
      const index = this.publisherIndex & this.mask;
      this.array[index] = elem;
      this.subscribers[index] = this.subscriberCount;
      this.publisherIndex += 1;
    }
    return drop$2(chunk, iteratorIndex);
  }
  slide() {
    if (this.subscribersIndex !== this.publisherIndex) {
      const index = this.subscribersIndex & this.mask;
      this.array[index] = null;
      this.subscribers[index] = 0;
      this.subscribersIndex += 1;
    }
  }
  subscribe() {
    this.subscriberCount += 1;
    return new BoundedPubSubPow2Subscription(this, this.publisherIndex, false);
  }
}

/** @internal */
class BoundedPubSubPow2Subscription {
  constructor(self, subscriberIndex, unsubscribed) {
    this.self = self;
    this.subscriberIndex = subscriberIndex;
    this.unsubscribed = unsubscribed;
  }
  isEmpty() {
    return this.unsubscribed || this.self.publisherIndex === this.subscriberIndex || this.self.publisherIndex === this.self.subscribersIndex;
  }
  size() {
    if (this.unsubscribed) {
      return 0;
    }
    return this.self.publisherIndex - Math.max(this.subscriberIndex, this.self.subscribersIndex);
  }
  poll(default_) {
    if (this.unsubscribed) {
      return default_;
    }
    this.subscriberIndex = Math.max(this.subscriberIndex, this.self.subscribersIndex);
    if (this.subscriberIndex !== this.self.publisherIndex) {
      const index = this.subscriberIndex & this.self.mask;
      const elem = this.self.array[index];
      this.self.subscribers[index] -= 1;
      if (this.self.subscribers[index] === 0) {
        this.self.array[index] = null;
        this.self.subscribersIndex += 1;
      }
      this.subscriberIndex += 1;
      return elem;
    }
    return default_;
  }
  pollUpTo(n) {
    if (this.unsubscribed) {
      return empty$z();
    }
    this.subscriberIndex = Math.max(this.subscriberIndex, this.self.subscribersIndex);
    const size = this.self.publisherIndex - this.subscriberIndex;
    const toPoll = Math.min(n, size);
    if (toPoll <= 0) {
      return empty$z();
    }
    const builder = [];
    const pollUpToIndex = this.subscriberIndex + toPoll;
    while (this.subscriberIndex !== pollUpToIndex) {
      const index = this.subscriberIndex & this.self.mask;
      const elem = this.self.array[index];
      this.self.subscribers[index] -= 1;
      if (this.self.subscribers[index] === 0) {
        this.self.array[index] = null;
        this.self.subscribersIndex += 1;
      }
      builder.push(elem);
      this.subscriberIndex += 1;
    }
    return fromIterable$b(builder);
  }
  unsubscribe() {
    if (!this.unsubscribed) {
      this.unsubscribed = true;
      this.self.subscriberCount -= 1;
      this.subscriberIndex = Math.max(this.subscriberIndex, this.self.subscribersIndex);
      while (this.subscriberIndex !== this.self.publisherIndex) {
        const index = this.subscriberIndex & this.self.mask;
        this.self.subscribers[index] -= 1;
        if (this.self.subscribers[index] === 0) {
          this.self.array[index] = null;
          this.self.subscribersIndex += 1;
        }
        this.subscriberIndex += 1;
      }
    }
  }
}

/** @internal */
class BoundedPubSubSingle {
  publisherIndex = 0;
  subscriberCount = 0;
  subscribers = 0;
  value = null;
  capacity = 1;
  pipe() {
    return pipeArguments(this, arguments);
  }
  isEmpty() {
    return this.subscribers === 0;
  }
  isFull() {
    return !this.isEmpty();
  }
  size() {
    return this.isEmpty() ? 0 : 1;
  }
  publish(value) {
    if (this.isFull()) {
      return false;
    }
    if (this.subscriberCount !== 0) {
      this.value = value;
      this.subscribers = this.subscriberCount;
      this.publisherIndex += 1;
    }
    return true;
  }
  publishAll(elements) {
    const chunk = fromIterable$b(elements);
    if (isEmpty$h(chunk)) {
      return chunk;
    }
    if (this.publish(unsafeHead$1(chunk))) {
      return drop$2(chunk, 1);
    } else {
      return chunk;
    }
  }
  slide() {
    if (this.isFull()) {
      this.subscribers = 0;
      this.value = null;
    }
  }
  subscribe() {
    this.subscriberCount += 1;
    return new BoundedPubSubSingleSubscription(this, this.publisherIndex, false);
  }
}

/** @internal */
class BoundedPubSubSingleSubscription {
  constructor(self, subscriberIndex, unsubscribed) {
    this.self = self;
    this.subscriberIndex = subscriberIndex;
    this.unsubscribed = unsubscribed;
  }
  isEmpty() {
    return this.unsubscribed || this.self.subscribers === 0 || this.subscriberIndex === this.self.publisherIndex;
  }
  size() {
    return this.isEmpty() ? 0 : 1;
  }
  poll(default_) {
    if (this.isEmpty()) {
      return default_;
    }
    const elem = this.self.value;
    this.self.subscribers -= 1;
    if (this.self.subscribers === 0) {
      this.self.value = null;
    }
    this.subscriberIndex += 1;
    return elem;
  }
  pollUpTo(n) {
    if (this.isEmpty() || n < 1) {
      return empty$z();
    }
    const a = this.self.value;
    this.self.subscribers -= 1;
    if (this.self.subscribers === 0) {
      this.self.value = null;
    }
    this.subscriberIndex += 1;
    return of$3(a);
  }
  unsubscribe() {
    if (!this.unsubscribed) {
      this.unsubscribed = true;
      this.self.subscriberCount -= 1;
      if (this.subscriberIndex !== this.self.publisherIndex) {
        this.self.subscribers -= 1;
        if (this.self.subscribers === 0) {
          this.self.value = null;
        }
      }
    }
  }
}

/** @internal */
class Node {
  constructor(value, subscribers, next) {
    this.value = value;
    this.subscribers = subscribers;
    this.next = next;
  }
}

/** @internal */
class UnboundedPubSub {
  publisherHead = new Node(null, 0, null);
  publisherIndex = 0;
  subscribersIndex = 0;
  capacity = Number.MAX_SAFE_INTEGER;
  constructor() {
    this.publisherTail = this.publisherHead;
  }
  isEmpty() {
    return this.publisherHead === this.publisherTail;
  }
  isFull() {
    return false;
  }
  size() {
    return this.publisherIndex - this.subscribersIndex;
  }
  publish(value) {
    const subscribers = this.publisherTail.subscribers;
    if (subscribers !== 0) {
      this.publisherTail.next = new Node(value, subscribers, null);
      this.publisherTail = this.publisherTail.next;
      this.publisherIndex += 1;
    }
    return true;
  }
  publishAll(elements) {
    for (const a of elements) {
      this.publish(a);
    }
    return empty$z();
  }
  slide() {
    if (this.publisherHead !== this.publisherTail) {
      this.publisherHead = this.publisherHead.next;
      this.publisherHead.value = null;
      this.subscribersIndex += 1;
    }
  }
  subscribe() {
    this.publisherTail.subscribers += 1;
    return new UnboundedPubSubSubscription(this, this.publisherTail, this.publisherIndex, false);
  }
}

/** @internal */
class UnboundedPubSubSubscription {
  constructor(self, subscriberHead, subscriberIndex, unsubscribed) {
    this.self = self;
    this.subscriberHead = subscriberHead;
    this.subscriberIndex = subscriberIndex;
    this.unsubscribed = unsubscribed;
  }
  isEmpty() {
    if (this.unsubscribed) {
      return true;
    }
    let empty = true;
    let loop = true;
    while (loop) {
      if (this.subscriberHead === this.self.publisherTail) {
        loop = false;
      } else {
        if (this.subscriberHead.next.value !== null) {
          empty = false;
          loop = false;
        } else {
          this.subscriberHead = this.subscriberHead.next;
          this.subscriberIndex += 1;
        }
      }
    }
    return empty;
  }
  size() {
    if (this.unsubscribed) {
      return 0;
    }
    return this.self.publisherIndex - Math.max(this.subscriberIndex, this.self.subscribersIndex);
  }
  poll(default_) {
    if (this.unsubscribed) {
      return default_;
    }
    let loop = true;
    let polled = default_;
    while (loop) {
      if (this.subscriberHead === this.self.publisherTail) {
        loop = false;
      } else {
        const elem = this.subscriberHead.next.value;
        if (elem !== null) {
          polled = elem;
          this.subscriberHead.subscribers -= 1;
          if (this.subscriberHead.subscribers === 0) {
            this.self.publisherHead = this.self.publisherHead.next;
            this.self.publisherHead.value = null;
            this.self.subscribersIndex += 1;
          }
          loop = false;
        }
        this.subscriberHead = this.subscriberHead.next;
        this.subscriberIndex += 1;
      }
    }
    return polled;
  }
  pollUpTo(n) {
    const builder = [];
    const default_ = null;
    let i = 0;
    while (i !== n) {
      const a = this.poll(default_);
      if (a === default_) {
        i = n;
      } else {
        builder.push(a);
        i += 1;
      }
    }
    return fromIterable$b(builder);
  }
  unsubscribe() {
    if (!this.unsubscribed) {
      this.unsubscribed = true;
      this.self.publisherTail.subscribers -= 1;
      while (this.subscriberHead !== this.self.publisherTail) {
        if (this.subscriberHead.next.value !== null) {
          this.subscriberHead.subscribers -= 1;
          if (this.subscriberHead.subscribers === 0) {
            this.self.publisherHead = this.self.publisherHead.next;
            this.self.publisherHead.value = null;
            this.self.subscribersIndex += 1;
          }
        }
        this.subscriberHead = this.subscriberHead.next;
      }
    }
  }
}

/** @internal */
class SubscriptionImpl {
  [DequeueTypeId$1] = dequeueVariance;
  constructor(pubsub, subscribers, subscription, pollers, shutdownHook, shutdownFlag, strategy) {
    this.pubsub = pubsub;
    this.subscribers = subscribers;
    this.subscription = subscription;
    this.pollers = pollers;
    this.shutdownHook = shutdownHook;
    this.shutdownFlag = shutdownFlag;
    this.strategy = strategy;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  capacity() {
    return this.pubsub.capacity;
  }
  isActive() {
    return !get$f(this.shutdownFlag);
  }
  size() {
    return suspend$8(() => get$f(this.shutdownFlag) ? interrupt$7 : succeed$h(this.subscription.size()));
  }
  unsafeSize() {
    if (get$f(this.shutdownFlag)) {
      return none$8();
    }
    return some$6(this.subscription.size());
  }
  isFull() {
    return map$f(this.size(), size => size === this.capacity());
  }
  isEmpty() {
    return map$f(this.size(), size => size === 0);
  }
  shutdown() {
    return uninterruptible$1(withFiberRuntime(state => {
      set$a(this.shutdownFlag, true);
      return pipe(forEachParUnbounded(unsafePollAllQueue(this.pollers), d => deferredInterruptWith(d, state.id()), false), zipRight$8(sync$a(() => {
        this.subscribers.delete(this.subscription);
        this.subscription.unsubscribe();
        this.strategy.unsafeOnPubSubEmptySpace(this.pubsub, this.subscribers);
      })), whenEffect$2(deferredSucceed(this.shutdownHook, void 0)), asUnit$4);
    }));
  }
  isShutdown() {
    return sync$a(() => get$f(this.shutdownFlag));
  }
  awaitShutdown() {
    return deferredAwait(this.shutdownHook);
  }
  take() {
    return withFiberRuntime(state => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      const message = isEmpty$b(this.pollers) ? this.subscription.poll(EmptyMutableQueue) : EmptyMutableQueue;
      if (message === EmptyMutableQueue) {
        const deferred = deferredUnsafeMake(state.id());
        return pipe(suspend$8(() => {
          pipe(this.pollers, offer$5(deferred));
          pipe(this.subscribers, addSubscribers(this.subscription, this.pollers));
          this.strategy.unsafeCompletePollers(this.pubsub, this.subscribers, this.subscription, this.pollers);
          return get$f(this.shutdownFlag) ? interrupt$7 : deferredAwait(deferred);
        }), onInterrupt$1(() => sync$a(() => unsafeRemove(this.pollers, deferred))));
      } else {
        this.strategy.unsafeOnPubSubEmptySpace(this.pubsub, this.subscribers);
        return succeed$h(message);
      }
    });
  }
  takeAll() {
    return suspend$8(() => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      const as = isEmpty$b(this.pollers) ? unsafePollAllSubscription(this.subscription) : empty$z();
      this.strategy.unsafeOnPubSubEmptySpace(this.pubsub, this.subscribers);
      return succeed$h(as);
    });
  }
  takeUpTo(max) {
    return suspend$8(() => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      const as = isEmpty$b(this.pollers) ? unsafePollN(this.subscription, max) : empty$z();
      this.strategy.unsafeOnPubSubEmptySpace(this.pubsub, this.subscribers);
      return succeed$h(as);
    });
  }
  takeBetween(min, max) {
    return suspend$8(() => takeRemainderLoop(this, min, max, empty$z()));
  }
}

/** @internal */
const takeRemainderLoop = (self, min, max, acc) => {
  if (max < min) {
    return succeed$h(acc);
  }
  return pipe(self.takeUpTo(max), flatMap$6(bs => {
    const remaining = min - bs.length;
    if (remaining === 1) {
      return pipe(self.take(), map$f(b => pipe(acc, appendAll$1(bs), append$1(b))));
    }
    if (remaining > 1) {
      return pipe(self.take(), flatMap$6(b => takeRemainderLoop(self, remaining - 1, max - bs.length - 1, pipe(acc, appendAll$1(bs), append$1(b)))));
    }
    return succeed$h(pipe(acc, appendAll$1(bs)));
  }));
};

/** @internal */
class PubSubImpl {
  [EnqueueTypeId] = enqueueVariance;
  constructor(pubsub, subscribers, scope, shutdownHook, shutdownFlag, strategy) {
    this.pubsub = pubsub;
    this.subscribers = subscribers;
    this.scope = scope;
    this.shutdownHook = shutdownHook;
    this.shutdownFlag = shutdownFlag;
    this.strategy = strategy;
  }
  capacity() {
    return this.pubsub.capacity;
  }
  size() {
    return suspend$8(() => get$f(this.shutdownFlag) ? interrupt$7 : sync$a(() => this.pubsub.size()));
  }
  unsafeSize() {
    if (get$f(this.shutdownFlag)) {
      return none$8();
    }
    return some$6(this.pubsub.size());
  }
  isFull() {
    return map$f(this.size(), size => size === this.capacity());
  }
  isEmpty() {
    return map$f(this.size(), size => size === 0);
  }
  awaitShutdown() {
    return deferredAwait(this.shutdownHook);
  }
  isShutdown() {
    return sync$a(() => get$f(this.shutdownFlag));
  }
  shutdown() {
    return uninterruptible$1(withFiberRuntime(state => {
      pipe(this.shutdownFlag, set$a(true));
      return pipe(this.scope.close(exitInterrupt(state.id())), zipRight$8(this.strategy.shutdown()), whenEffect$2(deferredSucceed(this.shutdownHook, void 0)), asUnit$4);
    }));
  }
  publish(value) {
    return suspend$8(() => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      if (this.pubsub.publish(value)) {
        this.strategy.unsafeCompleteSubscribers(this.pubsub, this.subscribers);
        return succeed$h(true);
      }
      return this.strategy.handleSurplus(this.pubsub, this.subscribers, of$3(value), this.shutdownFlag);
    });
  }
  isActive() {
    return !get$f(this.shutdownFlag);
  }
  unsafeOffer(value) {
    if (get$f(this.shutdownFlag)) {
      return false;
    }
    if (this.pubsub.publish(value)) {
      this.strategy.unsafeCompleteSubscribers(this.pubsub, this.subscribers);
      return true;
    }
    return false;
  }
  publishAll(elements) {
    return suspend$8(() => {
      if (get$f(this.shutdownFlag)) {
        return interrupt$7;
      }
      const surplus = unsafePublishAll(this.pubsub, elements);
      this.strategy.unsafeCompleteSubscribers(this.pubsub, this.subscribers);
      if (isEmpty$h(surplus)) {
        return succeed$h(true);
      }
      return this.strategy.handleSurplus(this.pubsub, this.subscribers, surplus, this.shutdownFlag);
    });
  }
  subscribe() {
    const acquire = tap$5(all$2([this.scope.fork(sequential$1), makeSubscription$1(this.pubsub, this.subscribers, this.strategy)]), tuple => tuple[0].addFinalizer(() => tuple[1].shutdown()));
    return map$f(acquireRelease$2(acquire, (tuple, exit) => tuple[0].close(exit)), tuple => tuple[1]);
  }
  offer(value) {
    return this.publish(value);
  }
  offerAll(elements) {
    return this.publishAll(elements);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const makePubSub = (pubsub, strategy) => flatMap$6(scopeMake(), scope => map$f(deferredMake(), deferred => unsafeMakePubSub(pubsub, new Map(), scope, deferred, make$W(false), strategy)));

/** @internal */
const unsafeMakePubSub = (pubsub, subscribers, scope, shutdownHook, shutdownFlag, strategy) => {
  return new PubSubImpl(pubsub, subscribers, scope, shutdownHook, shutdownFlag, strategy);
};

/** @internal */
const nextPow2 = n => {
  const nextPow = Math.ceil(Math.log(n) / Math.log(2.0));
  return Math.max(Math.pow(2, nextPow), 2);
};

/** @internal */
const ensureCapacity = capacity => {
  if (capacity <= 0) {
    throw InvalidPubSubCapacityException(`Cannot construct PubSub with capacity of ${capacity}`);
  }
};

/** @internal */
const unsafeCompleteDeferred = (deferred, a) => {
  deferredUnsafeDone(deferred, succeed$h(a));
};

/** @internal */
const unsafeOfferAll = (queue, as) => {
  return pipe(queue, offerAll$4(as));
};

/** @internal */
const unsafePollAllQueue = queue => {
  return pipe(queue, pollUpTo(Number.POSITIVE_INFINITY));
};

/** @internal */
const unsafePollAllSubscription = subscription => {
  return subscription.pollUpTo(Number.POSITIVE_INFINITY);
};

/** @internal */
const unsafePollN = (subscription, max) => {
  return subscription.pollUpTo(max);
};

/** @internal */
const unsafePublishAll = (pubsub, as) => {
  return pubsub.publishAll(as);
};

/** @internal */
const unsafeRemove = (queue, value) => {
  unsafeOfferAll(queue, pipe(unsafePollAllQueue(queue), filter$9(elem => elem !== value)));
};

// -----------------------------------------------------------------------------
// PubSub.Strategy
// -----------------------------------------------------------------------------

/**
 * A `PubSubStrategy<A>` describes the protocol for how publishers and subscribers
 * will communicate with each other through the `PubSub`.
 *
 * @internal
 */
/**
 * A strategy that applies back pressure to publishers when the `PubSub` is at
 * capacity. This guarantees that all subscribers will receive all messages
 * published to the `PubSub` while they are subscribed. However, it creates the
 * risk that a slow subscriber will slow down the rate at which messages
 * are published and received by other subscribers.
 *
 * @internal
 */
class BackPressureStrategy {
  publishers = unbounded$6();
  shutdown() {
    return flatMap$6(fiberId$2, fiberId => flatMap$6(sync$a(() => unsafePollAllQueue(this.publishers)), publishers => forEachParUnboundedDiscard(publishers, ([_, deferred, last]) => last ? pipe(deferredInterruptWith(deferred, fiberId), asUnit$4) : unit$6, false)));
  }
  handleSurplus(pubsub, subscribers, elements, isShutdown) {
    return withFiberRuntime(state => {
      const deferred = deferredUnsafeMake(state.id());
      return pipe(suspend$8(() => {
        this.unsafeOffer(elements, deferred);
        this.unsafeOnPubSubEmptySpace(pubsub, subscribers);
        this.unsafeCompleteSubscribers(pubsub, subscribers);
        return get$f(isShutdown) ? interrupt$7 : deferredAwait(deferred);
      }), onInterrupt$1(() => sync$a(() => this.unsafeRemove(deferred))));
    });
  }
  unsafeOnPubSubEmptySpace(pubsub, subscribers) {
    let keepPolling = true;
    while (keepPolling && !pubsub.isFull()) {
      const publisher = pipe(this.publishers, poll$7(EmptyMutableQueue));
      if (publisher === EmptyMutableQueue) {
        keepPolling = false;
      } else {
        const published = pubsub.publish(publisher[0]);
        if (published && publisher[2]) {
          unsafeCompleteDeferred(publisher[1], true);
        } else if (!published) {
          unsafeOfferAll(this.publishers, pipe(unsafePollAllQueue(this.publishers), prepend$2(publisher)));
        }
        this.unsafeCompleteSubscribers(pubsub, subscribers);
      }
    }
  }
  unsafeCompletePollers(pubsub, subscribers, subscription, pollers) {
    return unsafeStrategyCompletePollers(this, pubsub, subscribers, subscription, pollers);
  }
  unsafeCompleteSubscribers(pubsub, subscribers) {
    return unsafeStrategyCompleteSubscribers(this, pubsub, subscribers);
  }
  unsafeOffer(elements, deferred) {
    const iterator = elements[Symbol.iterator]();
    let next = iterator.next();
    if (!next.done) {
      // eslint-disable-next-line no-constant-condition
      while (1) {
        const value = next.value;
        next = iterator.next();
        if (next.done) {
          pipe(this.publishers, offer$5([value, deferred, true]));
          break;
        }
        pipe(this.publishers, offer$5([value, deferred, false]));
      }
    }
  }
  unsafeRemove(deferred) {
    unsafeOfferAll(this.publishers, pipe(unsafePollAllQueue(this.publishers), filter$9(([_, a]) => a !== deferred)));
  }
}

/**
 * A strategy that drops new messages when the `PubSub` is at capacity. This
 * guarantees that a slow subscriber will not slow down the rate at which
 * messages are published. However, it creates the risk that a slow
 * subscriber will slow down the rate at which messages are received by
 * other subscribers and that subscribers may not receive all messages
 * published to the `PubSub` while they are subscribed.
 *
 * @internal
 */
class DroppingStrategy {
  shutdown() {
    return unit$6;
  }
  handleSurplus(_pubsub, _subscribers, _elements, _isShutdown) {
    return succeed$h(false);
  }
  unsafeOnPubSubEmptySpace(_pubsub, _subscribers) {
    //
  }
  unsafeCompletePollers(pubsub, subscribers, subscription, pollers) {
    return unsafeStrategyCompletePollers(this, pubsub, subscribers, subscription, pollers);
  }
  unsafeCompleteSubscribers(pubsub, subscribers) {
    return unsafeStrategyCompleteSubscribers(this, pubsub, subscribers);
  }
}

/**
 * A strategy that adds new messages and drops old messages when the `PubSub` is
 * at capacity. This guarantees that a slow subscriber will not slow down
 * the rate at which messages are published and received by other
 * subscribers. However, it creates the risk that a slow subscriber will
 * not receive some messages published to the `PubSub` while it is subscribed.
 *
 * @internal
 */
class SlidingStrategy {
  shutdown() {
    return unit$6;
  }
  handleSurplus(pubsub, subscribers, elements, _isShutdown) {
    return sync$a(() => {
      this.unsafeSlidingPublish(pubsub, elements);
      this.unsafeCompleteSubscribers(pubsub, subscribers);
      return true;
    });
  }
  unsafeOnPubSubEmptySpace(_pubsub, _subscribers) {
    //
  }
  unsafeCompletePollers(pubsub, subscribers, subscription, pollers) {
    return unsafeStrategyCompletePollers(this, pubsub, subscribers, subscription, pollers);
  }
  unsafeCompleteSubscribers(pubsub, subscribers) {
    return unsafeStrategyCompleteSubscribers(this, pubsub, subscribers);
  }
  unsafeSlidingPublish(pubsub, elements) {
    const it = elements[Symbol.iterator]();
    let next = it.next();
    if (!next.done && pubsub.capacity > 0) {
      let a = next.value;
      let loop = true;
      while (loop) {
        pubsub.slide();
        const pub = pubsub.publish(a);
        if (pub && (next = it.next()) && !next.done) {
          a = next.value;
        } else if (pub) {
          loop = false;
        }
      }
    }
  }
}

/** @internal */
const unsafeStrategyCompletePollers = (strategy, pubsub, subscribers, subscription, pollers) => {
  let keepPolling = true;
  while (keepPolling && !subscription.isEmpty()) {
    const poller = pipe(pollers, poll$7(EmptyMutableQueue));
    if (poller === EmptyMutableQueue) {
      pipe(subscribers, removeSubscribers(subscription, pollers));
      if (isEmpty$b(pollers)) {
        keepPolling = false;
      } else {
        pipe(subscribers, addSubscribers(subscription, pollers));
      }
    } else {
      const pollResult = subscription.poll(EmptyMutableQueue);
      if (pollResult === EmptyMutableQueue) {
        unsafeOfferAll(pollers, pipe(unsafePollAllQueue(pollers), prepend$2(poller)));
      } else {
        unsafeCompleteDeferred(poller, pollResult);
        strategy.unsafeOnPubSubEmptySpace(pubsub, subscribers);
      }
    }
  }
};

/** @internal */
const unsafeStrategyCompleteSubscribers = (strategy, pubsub, subscribers) => {
  for (const [subscription, pollersSet] of subscribers) {
    for (const pollers of pollersSet) {
      strategy.unsafeCompletePollers(pubsub, subscribers, subscription, pollers);
    }
  }
};

/**
 * @since 2.0.0
 */

/**
 * A `PubSub<A>` is an asynchronous message hub into which publishers can publish
 * messages of type `A` and subscribers can subscribe to take messages of type
 * `A`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Creates a bounded `PubSub` with the back pressure strategy. The `PubSub` will retain
 * messages until they have been taken by all subscribers, applying back
 * pressure to publishers if the `PubSub` is at capacity.
 *
 * For best performance use capacities that are powers of two.
 *
 * @since 2.0.0
 * @category constructors
 */
const bounded$3 = bounded$4;

/**
 * Creates a bounded `PubSub` with the dropping strategy. The `PubSub` will drop new
 * messages if the `PubSub` is at capacity.
 *
 * For best performance use capacities that are powers of two.
 *
 * @since 2.0.0
 * @category constructors
 */
dropping$3;

/**
 * Creates a bounded `PubSub` with the sliding strategy. The `PubSub` will add new
 * messages and drop old messages if the `PubSub` is at capacity.
 *
 * For best performance use capacities that are powers of two.
 *
 * @since 2.0.0
 * @category constructors
 */
sliding$4;

/**
 * Creates an unbounded `PubSub`.
 *
 * @since 2.0.0
 * @category constructors
 */
const unbounded$3 = unbounded$4;

/**
 *  Returns the number of elements the queue can hold.
 *
 * @since 2.0.0
 * @category getters
 */
capacity$3;

/**
 * Retrieves the size of the queue, which is equal to the number of elements
 * in the queue. This may be negative if fibers are suspended waiting for
 * elements to be added to the queue.
 *
 * @since 2.0.0
 * @category getters
 */
size$8;

/**
 * Returns `true` if the `Queue` contains at least one element, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isFull$3;

/**
 * Returns `true` if the `Queue` contains zero elements, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty$7;

/**
 * Interrupts any fibers that are suspended on `offer` or `take`. Future calls
 * to `offer*` and `take*` will be interrupted immediately.
 *
 * @since 2.0.0
 * @category utils
 */
const shutdown$3 = shutdown$4;

/**
 * Returns `true` if `shutdown` has been called, otherwise returns `false`.
 *
 * @since 2.0.0
 * @category getters
 */
isShutdown$3;

/**
 * Waits until the queue is shutdown. The `Effect` returned by this method will
 * not resume until the queue has been shutdown. If the queue is already
 * shutdown, the `Effect` will resume right away.
 *
 * @since 2.0.0
 * @category utils
 */
awaitShutdown$3;

/**
 * Publishes a message to the `PubSub`, returning whether the message was published
 * to the `PubSub`.
 *
 * @since 2.0.0
 * @category utils
 */
const publish$1 = publish$2;

/**
 * Publishes all of the specified messages to the `PubSub`, returning whether they
 * were published to the `PubSub`.
 *
 * @since 2.0.0
 * @category utils
 */
publishAll$1;

/**
 * Subscribes to receive messages from the `PubSub`. The resulting subscription can
 * be evaluated multiple times within the scope to take a message from the `PubSub`
 * each time.
 *
 * @since 2.0.0
 * @category utils
 */
const subscribe$1 = subscribe$2;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
EnqueueTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const DequeueTypeId = DequeueTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
QueueStrategyTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * The base interface that all `Queue`s must implement.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Returns `true` if the specified value is a `Queue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isQueue;

/**
 * Returns `true` if the specified value is a `Dequeue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isDequeue;

/**
 * Returns `true` if the specified value is a `Enqueue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isEnqueue;

/**
 * @since 2.0.0
 * @category strategies
 */
backPressureStrategy;

/**
 * @since 2.0.0
 * @category strategies
 */
droppingStrategy;

/**
 * @since 2.0.0
 * @category strategies
 */
slidingStrategy;

/**
 * @since 2.0.0
 * @category constructors
 */
make$t;

/**
 * Makes a new bounded `Queue`. When the capacity of the queue is reached, any
 * additional calls to `offer` will be suspended until there is more room in
 * the queue.
 *
 * **Note**: When possible use only power of 2 capacities; this will provide
 * better performance by utilising an optimised version of the underlying
 * `RingBuffer`.
 *
 * @since 2.0.0
 * @category constructors
 */
const bounded$2 = bounded$5;

/**
 * Makes a new bounded `Queue` with the dropping strategy.
 *
 * When the capacity of the queue is reached, new elements will be dropped and the
 * old elements will remain.
 *
 * **Note**: When possible use only power of 2 capacities; this will provide
 * better performance by utilising an optimised version of the underlying
 * `RingBuffer`.
 *
 * @since 2.0.0
 * @category constructors
 */
const dropping$2 = dropping$4;

/**
 * Makes a new bounded `Queue` with the sliding strategy.
 *
 * When the capacity of the queue is reached, new elements will be added and the
 * old elements will be dropped.
 *
 * **Note**: When possible use only power of 2 capacities; this will provide
 * better performance by utilising an optimised version of the underlying
 * `RingBuffer`.
 *
 * @since 2.0.0
 * @category constructors
 */
const sliding$3 = sliding$5;

/**
 * Creates a new unbounded `Queue`.
 *
 * @since 2.0.0
 * @category constructors
 */
const unbounded$2 = unbounded$5;

/**
 * Returns the number of elements the queue can hold.
 *
 * @since 2.0.0
 * @category getters
 */
const capacity$2 = capacity$4;

/**
 * Retrieves the size of the queue, which is equal to the number of elements
 * in the queue. This may be negative if fibers are suspended waiting for
 * elements to be added to the queue.
 *
 * @since 2.0.0
 * @category getters
 */
const size$7 = size$9;

/**
 * Returns `true` if the `Queue` contains zero elements, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty$6 = isEmpty$8;

/**
 * Returns `true` if the `Queue` contains at least one element, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isFull$2 = isFull$4;

/**
 * Returns `true` if `shutdown` has been called, otherwise returns `false`.
 *
 * @since 2.0.0
 * @category getters
 */
const isShutdown$2 = isShutdown$4;

/**
 * Waits until the queue is shutdown. The `Effect` returned by this method will
 * not resume until the queue has been shutdown. If the queue is already
 * shutdown, the `Effect` will resume right away.
 *
 * @since 2.0.0
 * @category utils
 */
const awaitShutdown$2 = awaitShutdown$4;

/**
 * Interrupts any fibers that are suspended on `offer` or `take`. Future calls
 * to `offer*` and `take*` will be interrupted immediately.
 *
 * @since 2.0.0
 * @category utils
 */
const shutdown$2 = shutdown$5;

/**
 * Places one value in the queue.
 *
 * @since 2.0.0
 * @category utils
 */
const offer$3 = offer$4;

/**
 * Places one value in the queue.
 *
 * @since 2.0.0
 * @category utils
 */
unsafeOffer;

/**
 * For Bounded Queue: uses the `BackPressure` Strategy, places the values in
 * the queue and always returns true. If the queue has reached capacity, then
 * the fiber performing the `offerAll` will be suspended until there is room
 * in the queue.
 *
 * For Unbounded Queue: Places all values in the queue and returns true.
 *
 * For Sliding Queue: uses `Sliding` Strategy If there is room in the queue,
 * it places the values otherwise it removes the old elements and enqueues the
 * new ones. Always returns true.
 *
 * For Dropping Queue: uses `Dropping` Strategy, It places the values in the
 * queue but if there is no room it will not enqueue them and return false.
 *
 * @since 2.0.0
 * @category utils
 */
const offerAll$2 = offerAll$3;

/**
 * Returns the first value in the `Queue` as a `Some<A>`, or `None` if the queue
 * is empty.
 *
 * @since 2.0.0
 * @category utils
 */
const poll$3 = poll$4;

/**
 * Takes the oldest value in the queue. If the queue is empty, this will return
 * a computation that resumes when an item has been added to the queue.
 *
 * @since 2.0.0
 * @category utils
 */
const take$5 = take$6;

/**
 * Takes all the values in the queue and returns the values. If the queue is
 * empty returns an empty collection.
 *
 * @since 2.0.0
 * @category utils
 */
const takeAll$2 = takeAll$3;

/**
 * Takes up to max number of values from the queue.
 *
 * @since 2.0.0
 * @category utils
 */
const takeUpTo$2 = takeUpTo$3;

/**
 * Takes a number of elements from the queue between the specified minimum and
 * maximum. If there are fewer than the minimum number of elements available,
 * suspends until at least the minimum number of elements have been collected.
 *
 * @since 2.0.0
 * @category utils
 */
const takeBetween$1 = takeBetween$2;

/**
 * Takes the specified number of elements from the queue. If there are fewer
 * than the specified number of elements available, it suspends until they
 * become available.
 *
 * @since 2.0.0
 * @category utils
 */
const takeN$1 = takeN$2;

/** @internal */
const OP_CONTINUE = "Continue";

/** @internal */

/** @internal */
const OP_CLOSE = "Close";

/** @internal */

/** @internal */
const OP_YIELD = "Yield";

/** @internal */
const ChildExecutorDecisionSymbolKey = "effect/ChannelChildExecutorDecision";

/** @internal */
const ChildExecutorDecisionTypeId = /*#__PURE__*/Symbol.for(ChildExecutorDecisionSymbolKey);

/** @internal */
const proto$7 = {
  [ChildExecutorDecisionTypeId]: ChildExecutorDecisionTypeId
};

/** @internal */
const Continue = _ => {
  const op = Object.create(proto$7);
  op._tag = OP_CONTINUE;
  return op;
};

/** @internal */
const Close = value => {
  const op = Object.create(proto$7);
  op._tag = OP_CLOSE;
  op.value = value;
  return op;
};

/** @internal */
const Yield = _ => {
  const op = Object.create(proto$7);
  op._tag = OP_YIELD;
  return op;
};

/** @internal */
const isChildExecutorDecision = u => typeof u === "object" && u != null && ChildExecutorDecisionTypeId in u;

/** @internal */
const isContinue = self => self._tag === OP_CONTINUE;

/** @internal */
const isClose = self => self._tag === OP_CLOSE;

/** @internal */
const isYield = self => self._tag === OP_YIELD;

/** @internal */
const match$8 = /*#__PURE__*/dual(2, (self, {
  onClose,
  onContinue,
  onYield
}) => {
  switch (self._tag) {
    case OP_CONTINUE:
      {
        return onContinue();
      }
    case OP_CLOSE:
      {
        return onClose(self.value);
      }
    case OP_YIELD:
      {
        return onYield();
      }
  }
});

/** @internal */
const OP_CONTINUATION_K = "ContinuationK";

/** @internal */

/** @internal */
const OP_CONTINUATION_FINALIZER = "ContinuationFinalizer";

/** @internal */
const ContinuationTypeId = /*#__PURE__*/Symbol.for("effect/ChannelContinuation");

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const continuationVariance = {
  _Env: _ => _,
  _InErr: _ => _,
  _InElem: _ => _,
  _InDone: _ => _,
  _OutErr: _ => _,
  _OutDone: _ => _,
  _OutErr2: _ => _,
  _OutElem: _ => _,
  _OutDone2: _ => _
};

/** @internal */
class ContinuationKImpl {
  _tag = OP_CONTINUATION_K;
  [ContinuationTypeId] = continuationVariance;
  constructor(onSuccess, onHalt) {
    this.onSuccess = onSuccess;
    this.onHalt = onHalt;
  }
  onExit(exit) {
    return isFailure$5(exit) ? this.onHalt(exit.cause) : this.onSuccess(exit.value);
  }
}

/** @internal */
class ContinuationFinalizerImpl {
  _tag = OP_CONTINUATION_FINALIZER;
  [ContinuationTypeId] = continuationVariance;
  constructor(finalizer) {
    this.finalizer = finalizer;
  }
}

/** @internal */
const OP_PULL_AFTER_NEXT = "PullAfterNext";

/** @internal */

/** @internal */
const OP_PULL_AFTER_ALL_ENQUEUED = "PullAfterAllEnqueued";

/** @internal */
const UpstreamPullStrategySymbolKey = "effect/ChannelUpstreamPullStrategy";

/** @internal */
const UpstreamPullStrategyTypeId = /*#__PURE__*/Symbol.for(UpstreamPullStrategySymbolKey);

/** @internal */
const upstreamPullStrategyVariance = {
  _A: _ => _
};

/** @internal */
const proto$6 = {
  [UpstreamPullStrategyTypeId]: upstreamPullStrategyVariance
};

/** @internal */
const PullAfterNext = emitSeparator => {
  const op = Object.create(proto$6);
  op._tag = OP_PULL_AFTER_NEXT;
  op.emitSeparator = emitSeparator;
  return op;
};

/** @internal */
const PullAfterAllEnqueued = emitSeparator => {
  const op = Object.create(proto$6);
  op._tag = OP_PULL_AFTER_ALL_ENQUEUED;
  op.emitSeparator = emitSeparator;
  return op;
};

/** @internal */
const isUpstreamPullStrategy = u => typeof u === "object" && u != null && UpstreamPullStrategyTypeId in u;

/** @internal */
const isPullAfterNext = self => self._tag === OP_PULL_AFTER_NEXT;

/** @internal */
const isPullAfterAllEnqueued = self => self._tag === OP_PULL_AFTER_ALL_ENQUEUED;

/** @internal */
const match$7 = /*#__PURE__*/dual(2, (self, {
  onAllEnqueued,
  onNext
}) => {
  switch (self._tag) {
    case OP_PULL_AFTER_NEXT:
      {
        return onNext(self.emitSeparator);
      }
    case OP_PULL_AFTER_ALL_ENQUEUED:
      {
        return onAllEnqueued(self.emitSeparator);
      }
  }
});

/** @internal */
const OP_BRACKET_OUT = "BracketOut";

/** @internal */

/** @internal */
const OP_BRIDGE = "Bridge";

/** @internal */

/** @internal */
const OP_CONCAT_ALL = "ConcatAll";

/** @internal */

/** @internal */
const OP_EMIT$3 = "Emit";

/** @internal */

/** @internal */
const OP_ENSURING = "Ensuring";

/** @internal */

/** @internal */
const OP_FAIL$2 = "Fail";

/** @internal */

/** @internal */
const OP_FOLD = "Fold";

/** @internal */

/** @internal */
const OP_FROM_EFFECT$1 = "FromEffect";

/** @internal */

/** @internal */
const OP_PIPE_TO = "PipeTo";

/** @internal */

/** @internal */
const OP_PROVIDE$1 = "Provide";

/** @internal */

/** @internal */
const OP_READ$1 = "Read";

/** @internal */

/** @internal */
const OP_SUCCEED$2 = "Succeed";

/** @internal */

/** @internal */
const OP_SUCCEED_NOW = "SucceedNow";

/** @internal */

/** @internal */
const OP_SUSPEND$1 = "Suspend";

/** @internal */
const ChannelSymbolKey = "effect/Channel";

/** @internal */
const ChannelTypeId = /*#__PURE__*/Symbol.for(ChannelSymbolKey);

/** @internal */
const channelVariance = {
  _Env: _ => _,
  _InErr: _ => _,
  _InElem: _ => _,
  _InDone: _ => _,
  _OutErr: _ => _,
  _OutElem: _ => _,
  _OutDone: _ => _
};

/** @internal */
const proto$5 = {
  [ChannelTypeId]: channelVariance,
  pipe() {
    return pipeArguments(this, arguments);
  }
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const isChannel = u => typeof u === "object" && u != null && ChannelTypeId in u || isEffect(u);

/** @internal */
const acquireReleaseOut = /*#__PURE__*/dual(2, (self, release) => {
  const op = Object.create(proto$5);
  op._tag = OP_BRACKET_OUT;
  op.acquire = () => self;
  op.finalizer = release;
  return op;
});

/** @internal */
const catchAllCause$1 = /*#__PURE__*/dual(2, (self, f) => {
  const op = Object.create(proto$5);
  op._tag = OP_FOLD;
  op.channel = self;
  op.k = new ContinuationKImpl(succeed$6, f);
  return op;
});

/** @internal */
const collectElements = self => {
  return suspend$4(() => {
    const builder = [];
    return flatMap$3(pipeTo(self, collectElementsReader(builder)), value => sync$3(() => [fromIterable$b(builder), value]));
  });
};

/** @internal */
const collectElementsReader = builder => readWith({
  onInput: outElem => flatMap$3(sync$3(() => {
    builder.push(outElem);
  }), () => collectElementsReader(builder)),
  onFailure: fail$6,
  onDone: succeedNow
});

/** @internal */
const concatAll$1 = channels => concatAllWith(channels, constVoid, constVoid);

/** @internal */
const concatAllWith = (channels, f, g) => {
  const op = Object.create(proto$5);
  op._tag = OP_CONCAT_ALL;
  op.combineInners = f;
  op.combineAll = g;
  op.onPull = () => PullAfterNext(none$8());
  op.onEmit = () => Continue;
  op.value = () => channels;
  op.k = identity$1;
  return op;
};

/** @internal */
const concatMapWith = /*#__PURE__*/dual(4, (self, f, g, h) => {
  const op = Object.create(proto$5);
  op._tag = OP_CONCAT_ALL;
  op.combineInners = g;
  op.combineAll = h;
  op.onPull = () => PullAfterNext(none$8());
  op.onEmit = () => Continue;
  op.value = () => self;
  op.k = f;
  return op;
});

/** @internal */
const concatMapWithCustom = /*#__PURE__*/dual(6, (self, f, g, h, onPull, onEmit) => {
  const op = Object.create(proto$5);
  op._tag = OP_CONCAT_ALL;
  op.combineInners = g;
  op.combineAll = h;
  op.onPull = onPull;
  op.onEmit = onEmit;
  op.value = () => self;
  op.k = f;
  return op;
});

/** @internal */
const embedInput = /*#__PURE__*/dual(2, (self, input) => {
  const op = Object.create(proto$5);
  op._tag = OP_BRIDGE;
  op.input = input;
  op.channel = self;
  return op;
});

/** @internal */
const ensuringWith$2 = /*#__PURE__*/dual(2, (self, finalizer) => {
  const op = Object.create(proto$5);
  op._tag = OP_ENSURING;
  op.channel = self;
  op.finalizer = finalizer;
  return op;
});

/** @internal */
const fail$6 = error => failCause$4(fail$9(error));

/** @internal */
const failSync$3 = evaluate => failCauseSync$2(() => fail$9(evaluate()));

/** @internal */
const failCause$4 = cause => failCauseSync$2(() => cause);

/** @internal */
const failCauseSync$2 = evaluate => {
  const op = Object.create(proto$5);
  op._tag = OP_FAIL$2;
  op.error = evaluate;
  return op;
};

/** @internal */
const flatMap$3 = /*#__PURE__*/dual(2, (self, f) => {
  const op = Object.create(proto$5);
  op._tag = OP_FOLD;
  op.channel = self;
  op.k = new ContinuationKImpl(f, failCause$4);
  return op;
});

/** @internal */
const foldCauseChannel = /*#__PURE__*/dual(2, (self, options) => {
  const op = Object.create(proto$5);
  op._tag = OP_FOLD;
  op.channel = self;
  op.k = new ContinuationKImpl(options.onSuccess, options.onFailure);
  return op;
});

/** @internal */
const fromEffect$3 = effect => {
  const op = Object.create(proto$5);
  op._tag = OP_FROM_EFFECT$1;
  op.effect = () => effect;
  return op;
};

/** @internal */
const pipeTo = /*#__PURE__*/dual(2, (self, that) => {
  const op = Object.create(proto$5);
  op._tag = OP_PIPE_TO;
  op.left = () => self;
  op.right = () => that;
  return op;
});

/** @internal */
const provideContext$4 = /*#__PURE__*/dual(2, (self, env) => {
  const op = Object.create(proto$5);
  op._tag = OP_PROVIDE$1;
  op.context = () => env;
  op.inner = self;
  return op;
});

/** @internal */
const readOrFail = error => {
  const op = Object.create(proto$5);
  op._tag = OP_READ$1;
  op.more = succeed$6;
  op.done = new ContinuationKImpl(() => fail$6(error), () => fail$6(error));
  return op;
};

/** @internal */
const readWith = options => readWithCause({
  onInput: options.onInput,
  onFailure: cause => match$i(failureOrCause(cause), {
    onLeft: options.onFailure,
    onRight: failCause$4
  }),
  onDone: options.onDone
});

/** @internal */
const readWithCause = options => {
  const op = Object.create(proto$5);
  op._tag = OP_READ$1;
  op.more = options.onInput;
  op.done = new ContinuationKImpl(options.onDone, options.onFailure);
  return op;
};

/** @internal */
const succeed$6 = value => sync$3(() => value);

/** @internal */
const succeedNow = result => {
  const op = Object.create(proto$5);
  op._tag = OP_SUCCEED_NOW;
  op.terminal = result;
  return op;
};

/** @internal */
const suspend$4 = evaluate => {
  const op = Object.create(proto$5);
  op._tag = OP_SUSPEND$1;
  op.channel = evaluate;
  return op;
};
const sync$3 = evaluate => {
  const op = Object.create(proto$5);
  op._tag = OP_SUCCEED$2;
  op.evaluate = evaluate;
  return op;
};

/** @internal */
const unit$2 = /*#__PURE__*/succeedNow(void 0);

/** @internal */
const write = out => {
  const op = Object.create(proto$5);
  op._tag = OP_EMIT$3;
  op.out = out;
  return op;
};

/** @internal */
const OP_DONE$3 = "Done";

/** @internal */

/** @internal */
const OP_EMIT$2 = "Emit";

/** @internal */

/** @internal */
const OP_FROM_EFFECT = "FromEffect";

/** @internal */

/** @internal */
const OP_READ = "Read";

/** @internal */
const ChannelStateTypeId = /*#__PURE__*/Symbol.for("effect/ChannelState");

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const channelStateVariance = {
  _R: _ => _,
  _E: _ => _
};

/** @internal */
const proto$4 = {
  [ChannelStateTypeId]: channelStateVariance
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const Done$2 = () => {
  const op = Object.create(proto$4);
  op._tag = OP_DONE$3;
  return op;
};

/** @internal */
const Emit$1 = () => {
  const op = Object.create(proto$4);
  op._tag = OP_EMIT$2;
  return op;
};

/** @internal */
const FromEffect = effect => {
  const op = Object.create(proto$4);
  op._tag = OP_FROM_EFFECT;
  op.effect = effect;
  return op;
};

/** @internal */
const Read = (upstream, onEffect, onEmit, onDone) => {
  const op = Object.create(proto$4);
  op._tag = OP_READ;
  op.upstream = upstream;
  op.onEffect = onEffect;
  op.onEmit = onEmit;
  op.onDone = onDone;
  return op;
};

/** @internal */
const isFromEffect = self => self._tag === OP_FROM_EFFECT;

/** @internal */
const effect$1 = self => isFromEffect(self) ? self.effect : unit$3;

/** @internal */
const effectOrUndefinedIgnored = self => isFromEffect(self) ? ignore$1(self.effect) : undefined;

/** @internal */

/** @internal */

/** @internal */
const OP_PULL_FROM_CHILD = "PullFromChild";

/** @internal */

/** @internal */
const OP_PULL_FROM_UPSTREAM = "PullFromUpstream";

/** @internal */

/** @internal */
const OP_DRAIN_CHILD_EXECUTORS = "DrainChildExecutors";

/** @internal */

/** @internal */
const OP_EMIT$1 = "Emit";

/** @internal */

/**
 * Execute the `childExecutor` and on each emitted value, decide what to do by
 * `onEmit`.
 *
 * @internal
 */
class PullFromChild {
  _tag = OP_PULL_FROM_CHILD;
  constructor(childExecutor, parentSubexecutor, onEmit) {
    this.childExecutor = childExecutor;
    this.parentSubexecutor = parentSubexecutor;
    this.onEmit = onEmit;
  }
  close(exit$1) {
    const fin1 = this.childExecutor.close(exit$1);
    const fin2 = this.parentSubexecutor.close(exit$1);
    if (fin1 !== undefined && fin2 !== undefined) {
      return zipWith$3(exit(fin1), exit(fin2), (exit1, exit2) => pipe(exit1, zipRight$7(exit2)));
    } else if (fin1 !== undefined) {
      return fin1;
    } else if (fin2 !== undefined) {
      return fin2;
    } else {
      return undefined;
    }
  }
  enqueuePullFromChild(_child) {
    return this;
  }
}

/**
 * Execute `upstreamExecutor` and for each emitted element, spawn a child
 * channel and continue with processing it by `PullFromChild`.
 *
 * @internal
 */
class PullFromUpstream {
  _tag = OP_PULL_FROM_UPSTREAM;
  constructor(upstreamExecutor, createChild, lastDone, activeChildExecutors, combineChildResults, combineWithChildResult, onPull, onEmit) {
    this.upstreamExecutor = upstreamExecutor;
    this.createChild = createChild;
    this.lastDone = lastDone;
    this.activeChildExecutors = activeChildExecutors;
    this.combineChildResults = combineChildResults;
    this.combineWithChildResult = combineWithChildResult;
    this.onPull = onPull;
    this.onEmit = onEmit;
  }
  close(exit$1) {
    const fin1 = this.upstreamExecutor.close(exit$1);
    const fins = [...this.activeChildExecutors.map(child => child !== undefined ? child.childExecutor.close(exit$1) : undefined), fin1];
    const result = fins.reduce((acc, next) => {
      if (acc !== undefined && next !== undefined) {
        return zipWith$3(acc, exit(next), (exit1, exit2) => zipRight$7(exit1, exit2));
      } else if (acc !== undefined) {
        return acc;
      } else if (next !== undefined) {
        return exit(next);
      } else {
        return undefined;
      }
    }, undefined);
    return result === undefined ? result : result;
  }
  enqueuePullFromChild(child) {
    return new PullFromUpstream(this.upstreamExecutor, this.createChild, this.lastDone, [...this.activeChildExecutors, child], this.combineChildResults, this.combineWithChildResult, this.onPull, this.onEmit);
  }
}

/**
 * Transformed from `PullFromUpstream` when upstream has finished but there
 * are still active child executors.
 *
 * @internal
 */
class DrainChildExecutors {
  _tag = OP_DRAIN_CHILD_EXECUTORS;
  constructor(upstreamExecutor, lastDone, activeChildExecutors, upstreamDone, combineChildResults, combineWithChildResult, onPull) {
    this.upstreamExecutor = upstreamExecutor;
    this.lastDone = lastDone;
    this.activeChildExecutors = activeChildExecutors;
    this.upstreamDone = upstreamDone;
    this.combineChildResults = combineChildResults;
    this.combineWithChildResult = combineWithChildResult;
    this.onPull = onPull;
  }
  close(exit$1) {
    const fin1 = this.upstreamExecutor.close(exit$1);
    const fins = [...this.activeChildExecutors.map(child => child !== undefined ? child.childExecutor.close(exit$1) : undefined), fin1];
    const result = fins.reduce((acc, next) => {
      if (acc !== undefined && next !== undefined) {
        return zipWith$3(acc, exit(next), (exit1, exit2) => zipRight$7(exit1, exit2));
      } else if (acc !== undefined) {
        return acc;
      } else if (next !== undefined) {
        return exit(next);
      } else {
        return undefined;
      }
    }, undefined);
    return result === undefined ? result : result;
  }
  enqueuePullFromChild(child) {
    return new DrainChildExecutors(this.upstreamExecutor, this.lastDone, [...this.activeChildExecutors, child], this.upstreamDone, this.combineChildResults, this.combineWithChildResult, this.onPull);
  }
}

/** @internal */
class Emit {
  _tag = OP_EMIT$1;
  constructor(value, next) {
    this.value = value;
    this.next = next;
  }
  close(exit) {
    const result = this.next.close(exit);
    return result === undefined ? result : result;
  }
  enqueuePullFromChild(_child) {
    return this;
  }
}

/** @internal */
const OP_PULLED = "Pulled";

/** @internal */

/** @internal */
const OP_NO_UPSTREAM = "NoUpstream";

/** @internal */
const UpstreamPullRequestSymbolKey = "effect/ChannelUpstreamPullRequest";

/** @internal */
const UpstreamPullRequestTypeId = /*#__PURE__*/Symbol.for(UpstreamPullRequestSymbolKey);

/** @internal */
const upstreamPullRequestVariance = {
  _A: _ => _
};

/** @internal */
const proto$3 = {
  [UpstreamPullRequestTypeId]: upstreamPullRequestVariance
};

/** @internal */
const Pulled = value => {
  const op = Object.create(proto$3);
  op._tag = OP_PULLED;
  op.value = value;
  return op;
};

/** @internal */
const NoUpstream = activeDownstreamCount => {
  const op = Object.create(proto$3);
  op._tag = OP_NO_UPSTREAM;
  op.activeDownstreamCount = activeDownstreamCount;
  return op;
};

/** @internal */
const isUpstreamPullRequest = u => typeof u === "object" && u != null && UpstreamPullRequestTypeId in u;

/** @internal */
const isPulled = self => self._tag === OP_PULLED;

/** @internal */
const isNoUpstream = self => self._tag === OP_NO_UPSTREAM;

/** @internal */
const match$6 = /*#__PURE__*/dual(2, (self, {
  onNoUpstream,
  onPulled
}) => {
  switch (self._tag) {
    case OP_PULLED:
      {
        return onPulled(self.value);
      }
    case OP_NO_UPSTREAM:
      {
        return onNoUpstream(self.activeDownstreamCount);
      }
  }
});

/** @internal */

/** @internal */

/** @internal */

class ChannelExecutor {
  _activeSubexecutor = undefined;
  _cancelled = undefined;
  _closeLastSubstream = undefined;
  _done = undefined;
  _doneStack = [];
  _emitted = undefined;
  _input = undefined;
  _inProgressFinalizer = undefined;
  constructor(initialChannel, providedEnv, executeCloseLastSubstream) {
    this._currentChannel = initialChannel;
    this._executeCloseLastSubstream = executeCloseLastSubstream;
    this._providedEnv = providedEnv;
  }
  run() {
    let result = undefined;
    while (result === undefined) {
      if (this._cancelled !== undefined) {
        result = this.processCancellation();
      } else if (this._activeSubexecutor !== undefined) {
        result = this.runSubexecutor();
      } else {
        try {
          if (this._currentChannel === undefined) {
            result = Done$2();
          } else {
            if (isEffect(this._currentChannel)) {
              this._currentChannel = fromEffect$3(this._currentChannel);
            } else {
              switch (this._currentChannel._tag) {
                case OP_BRACKET_OUT:
                  {
                    result = this.runBracketOut(this._currentChannel);
                    break;
                  }
                case OP_BRIDGE:
                  {
                    const bridgeInput = this._currentChannel.input;

                    // PipeTo(left, Bridge(queue, channel))
                    // In a fiber: repeatedly run left and push its outputs to the queue
                    // Add a finalizer to interrupt the fiber and close the executor
                    this._currentChannel = this._currentChannel.channel;
                    if (this._input !== undefined) {
                      const inputExecutor = this._input;
                      this._input = undefined;
                      const drainer = () => flatMap$4(bridgeInput.awaitRead(), () => suspend$5(() => {
                        const state = inputExecutor.run();
                        switch (state._tag) {
                          case OP_DONE$3:
                            {
                              return match$f(inputExecutor.getDone(), {
                                onFailure: cause => bridgeInput.error(cause),
                                onSuccess: value => bridgeInput.done(value)
                              });
                            }
                          case OP_EMIT$2:
                            {
                              return flatMap$4(bridgeInput.emit(inputExecutor.getEmit()), () => drainer());
                            }
                          case OP_FROM_EFFECT:
                            {
                              return matchCauseEffect(state.effect, {
                                onFailure: cause => bridgeInput.error(cause),
                                onSuccess: () => drainer()
                              });
                            }
                          case OP_READ:
                            {
                              return readUpstream(state, () => drainer(), cause => bridgeInput.error(cause));
                            }
                        }
                      }));
                      result = FromEffect(flatMap$4(forkDaemon(drainer()), fiber => sync$4(() => this.addFinalizer(exit => flatMap$4(interrupt$3(fiber), () => suspend$5(() => {
                        const effect = this.restorePipe(exit, inputExecutor);
                        return effect !== undefined ? effect : unit$3;
                      }))))));
                    }
                    break;
                  }
                case OP_CONCAT_ALL:
                  {
                    const executor = new ChannelExecutor(this._currentChannel.value(), this._providedEnv, effect => sync$4(() => {
                      const prevLastClose = this._closeLastSubstream === undefined ? unit$3 : this._closeLastSubstream;
                      this._closeLastSubstream = pipe(prevLastClose, zipRight$4(effect));
                    }));
                    executor._input = this._input;
                    const channel = this._currentChannel;
                    this._activeSubexecutor = new PullFromUpstream(executor, value => channel.k(value), undefined, [], (x, y) => channel.combineInners(x, y), (x, y) => channel.combineAll(x, y), request => channel.onPull(request), value => channel.onEmit(value));
                    this._closeLastSubstream = undefined;
                    this._currentChannel = undefined;
                    break;
                  }
                case OP_EMIT$3:
                  {
                    this._emitted = this._currentChannel.out;
                    this._currentChannel = this._activeSubexecutor !== undefined ? undefined : unit$2;
                    result = Emit$1();
                    break;
                  }
                case OP_ENSURING:
                  {
                    this.runEnsuring(this._currentChannel);
                    break;
                  }
                case OP_FAIL$2:
                  {
                    result = this.doneHalt(this._currentChannel.error());
                    break;
                  }
                case OP_FOLD:
                  {
                    this._doneStack.push(this._currentChannel.k);
                    this._currentChannel = this._currentChannel.channel;
                    break;
                  }
                case OP_FROM_EFFECT$1:
                  {
                    const effect = this._providedEnv === undefined ? this._currentChannel.effect() : pipe(this._currentChannel.effect(), provide(this._providedEnv));
                    result = FromEffect(matchCauseEffect(effect, {
                      onFailure: cause => {
                        const state = this.doneHalt(cause);
                        return state !== undefined && isFromEffect(state) ? state.effect : unit$3;
                      },
                      onSuccess: value => {
                        const state = this.doneSucceed(value);
                        return state !== undefined && isFromEffect(state) ? state.effect : unit$3;
                      }
                    }));
                    break;
                  }
                case OP_PIPE_TO:
                  {
                    const previousInput = this._input;
                    const leftExec = new ChannelExecutor(this._currentChannel.left(), this._providedEnv, effect => this._executeCloseLastSubstream(effect));
                    leftExec._input = previousInput;
                    this._input = leftExec;
                    this.addFinalizer(exit => {
                      const effect = this.restorePipe(exit, previousInput);
                      return effect !== undefined ? effect : unit$3;
                    });
                    this._currentChannel = this._currentChannel.right();
                    break;
                  }
                case OP_PROVIDE$1:
                  {
                    const previousEnv = this._providedEnv;
                    this._providedEnv = this._currentChannel.context();
                    this._currentChannel = this._currentChannel.inner;
                    this.addFinalizer(() => sync$4(() => {
                      this._providedEnv = previousEnv;
                    }));
                    break;
                  }
                case OP_READ$1:
                  {
                    const read = this._currentChannel;
                    result = Read(this._input, identity$1, emitted => {
                      try {
                        this._currentChannel = read.more(emitted);
                      } catch (error) {
                        this._currentChannel = read.done.onExit(die$8(error));
                      }
                      return undefined;
                    }, exit => {
                      const onExit = exit => {
                        return read.done.onExit(exit);
                      };
                      this._currentChannel = onExit(exit);
                      return undefined;
                    });
                    break;
                  }
                case OP_SUCCEED$2:
                  {
                    result = this.doneSucceed(this._currentChannel.evaluate());
                    break;
                  }
                case OP_SUCCEED_NOW:
                  {
                    result = this.doneSucceed(this._currentChannel.terminal);
                    break;
                  }
                case OP_SUSPEND$1:
                  {
                    this._currentChannel = this._currentChannel.channel();
                    break;
                  }
                default:
                  {
                    // @ts-expect-error
                    this._currentChannel._tag;
                  }
              }
            }
          }
        } catch (error) {
          this._currentChannel = failCause$4(die$7(error));
        }
      }
    }
    return result;
  }
  getDone() {
    return this._done;
  }
  getEmit() {
    return this._emitted;
  }
  cancelWith(exit) {
    this._cancelled = exit;
  }
  clearInProgressFinalizer() {
    this._inProgressFinalizer = undefined;
  }
  storeInProgressFinalizer(finalizer) {
    this._inProgressFinalizer = finalizer;
  }
  popAllFinalizers(exit) {
    const finalizers = [];
    let next = this._doneStack.pop();
    while (next) {
      if (next._tag === "ContinuationFinalizer") {
        finalizers.push(next.finalizer);
      }
      next = this._doneStack.pop();
    }
    const effect = finalizers.length === 0 ? unit$3 : runFinalizers(finalizers, exit);
    this.storeInProgressFinalizer(effect);
    return effect;
  }
  popNextFinalizers() {
    const builder = [];
    while (this._doneStack.length !== 0) {
      const cont = this._doneStack[this._doneStack.length - 1];
      if (cont._tag === OP_CONTINUATION_K) {
        return builder;
      }
      builder.push(cont);
      this._doneStack.pop();
    }
    return builder;
  }
  restorePipe(exit, prev) {
    const currInput = this._input;
    this._input = prev;
    if (currInput !== undefined) {
      const effect = currInput.close(exit);
      return effect;
    }
    return unit$3;
  }
  close(exit$1) {
    let runInProgressFinalizers = undefined;
    const finalizer = this._inProgressFinalizer;
    if (finalizer !== undefined) {
      runInProgressFinalizers = pipe(finalizer, ensuring$4(sync$4(() => this.clearInProgressFinalizer())));
    }
    let closeSelf = undefined;
    const selfFinalizers = this.popAllFinalizers(exit$1);
    if (selfFinalizers !== undefined) {
      closeSelf = pipe(selfFinalizers, ensuring$4(sync$4(() => this.clearInProgressFinalizer())));
    }
    const closeSubexecutors = this._activeSubexecutor === undefined ? undefined : this._activeSubexecutor.close(exit$1);
    if (closeSubexecutors === undefined && runInProgressFinalizers === undefined && closeSelf === undefined) {
      return undefined;
    }
    return pipe(exit(ifNotNull(closeSubexecutors)), zip$5(exit(ifNotNull(runInProgressFinalizers))), zip$5(exit(ifNotNull(closeSelf))), map$6(([[exit1, exit2], exit3]) => pipe(exit1, zipRight$7(exit2), zipRight$7(exit3))), uninterruptible,
    // TODO: remove
    flatMap$4(exit => suspend$5(() => exit)));
  }
  doneSucceed(value) {
    if (this._doneStack.length === 0) {
      this._done = succeed$f(value);
      this._currentChannel = undefined;
      return Done$2();
    }
    const head = this._doneStack[this._doneStack.length - 1];
    if (head._tag === OP_CONTINUATION_K) {
      this._doneStack.pop();
      this._currentChannel = head.onSuccess(value);
      return undefined;
    }
    const finalizers = this.popNextFinalizers();
    if (this._doneStack.length === 0) {
      this._doneStack = finalizers.reverse();
      this._done = succeed$f(value);
      this._currentChannel = undefined;
      return Done$2();
    }
    const finalizerEffect = runFinalizers(finalizers.map(f => f.finalizer), succeed$f(value));
    this.storeInProgressFinalizer(finalizerEffect);
    const effect = pipe(finalizerEffect, ensuring$4(sync$4(() => this.clearInProgressFinalizer())), uninterruptible, flatMap$4(() => sync$4(() => this.doneSucceed(value))));
    return FromEffect(effect);
  }
  doneHalt(cause) {
    if (this._doneStack.length === 0) {
      this._done = failCause$8(cause);
      this._currentChannel = undefined;
      return Done$2();
    }
    const head = this._doneStack[this._doneStack.length - 1];
    if (head._tag === OP_CONTINUATION_K) {
      this._doneStack.pop();
      this._currentChannel = head.onHalt(cause);
      return undefined;
    }
    const finalizers = this.popNextFinalizers();
    if (this._doneStack.length === 0) {
      this._doneStack = finalizers.reverse();
      this._done = failCause$8(cause);
      this._currentChannel = undefined;
      return Done$2();
    }
    const finalizerEffect = runFinalizers(finalizers.map(f => f.finalizer), failCause$8(cause));
    this.storeInProgressFinalizer(finalizerEffect);
    const effect = pipe(finalizerEffect, ensuring$4(sync$4(() => this.clearInProgressFinalizer())), uninterruptible, flatMap$4(() => sync$4(() => this.doneHalt(cause))));
    return FromEffect(effect);
  }
  processCancellation() {
    this._currentChannel = undefined;
    this._done = this._cancelled;
    this._cancelled = undefined;
    return Done$2();
  }
  runBracketOut(bracketOut) {
    const effect = uninterruptible(matchCauseEffect(this.provide(bracketOut.acquire()), {
      onFailure: cause => sync$4(() => {
        this._currentChannel = failCause$4(cause);
      }),
      onSuccess: out => sync$4(() => {
        this.addFinalizer(exit => this.provide(bracketOut.finalizer(out, exit)));
        this._currentChannel = write(out);
      })
    }));
    return FromEffect(effect);
  }
  provide(effect) {
    if (this._providedEnv === undefined) {
      return effect;
    }
    return pipe(effect, provide(this._providedEnv));
  }
  runEnsuring(ensuring) {
    this.addFinalizer(ensuring.finalizer);
    this._currentChannel = ensuring.channel;
  }
  addFinalizer(f) {
    this._doneStack.push(new ContinuationFinalizerImpl(f));
  }
  runSubexecutor() {
    const subexecutor = this._activeSubexecutor;
    switch (subexecutor._tag) {
      case OP_PULL_FROM_CHILD:
        {
          return this.pullFromChild(subexecutor.childExecutor, subexecutor.parentSubexecutor, subexecutor.onEmit, subexecutor);
        }
      case OP_PULL_FROM_UPSTREAM:
        {
          return this.pullFromUpstream(subexecutor);
        }
      case OP_DRAIN_CHILD_EXECUTORS:
        {
          return this.drainChildExecutors(subexecutor);
        }
      case OP_EMIT$1:
        {
          this._emitted = subexecutor.value;
          this._activeSubexecutor = subexecutor.next;
          return Emit$1();
        }
    }
  }
  replaceSubexecutor(nextSubExec) {
    this._currentChannel = undefined;
    this._activeSubexecutor = nextSubExec;
  }
  finishWithExit(exit) {
    const state = match$f(exit, {
      onFailure: cause => this.doneHalt(cause),
      onSuccess: value => this.doneSucceed(value)
    });
    this._activeSubexecutor = undefined;
    return state === undefined ? unit$3 : effect$1(state);
  }
  finishSubexecutorWithCloseEffect(subexecutorDone, ...closeFuncs) {
    this.addFinalizer(() => pipe(closeFuncs, forEach$6(closeFunc => pipe(sync$4(() => closeFunc(subexecutorDone)), flatMap$4(closeEffect => closeEffect !== undefined ? closeEffect : unit$3)), {
      discard: true
    })));
    const state = pipe(subexecutorDone, match$f({
      onFailure: cause => this.doneHalt(cause),
      onSuccess: value => this.doneSucceed(value)
    }));
    this._activeSubexecutor = undefined;
    return state;
  }
  applyUpstreamPullStrategy(upstreamFinished, queue, strategy) {
    switch (strategy._tag) {
      case OP_PULL_AFTER_NEXT:
        {
          const shouldPrepend = !upstreamFinished || queue.some(subexecutor => subexecutor !== undefined);
          return [strategy.emitSeparator, shouldPrepend ? [undefined, ...queue] : queue];
        }
      case OP_PULL_AFTER_ALL_ENQUEUED:
        {
          const shouldEnqueue = !upstreamFinished || queue.some(subexecutor => subexecutor !== undefined);
          return [strategy.emitSeparator, shouldEnqueue ? [...queue, undefined] : queue];
        }
    }
  }
  pullFromChild(childExecutor, parentSubexecutor, onEmitted, subexecutor) {
    return Read(childExecutor, identity$1, emitted => {
      const childExecutorDecision = onEmitted(emitted);
      switch (childExecutorDecision._tag) {
        case OP_CONTINUE:
          {
            break;
          }
        case OP_CLOSE:
          {
            this.finishWithDoneValue(childExecutor, parentSubexecutor, childExecutorDecision.value);
            break;
          }
        case OP_YIELD:
          {
            const modifiedParent = parentSubexecutor.enqueuePullFromChild(subexecutor);
            this.replaceSubexecutor(modifiedParent);
            break;
          }
      }
      this._activeSubexecutor = new Emit(emitted, this._activeSubexecutor);
      return undefined;
    }, match$f({
      onFailure: cause => {
        const state = this.handleSubexecutorFailure(childExecutor, parentSubexecutor, cause);
        return state === undefined ? undefined : effectOrUndefinedIgnored(state);
      },
      onSuccess: doneValue => {
        this.finishWithDoneValue(childExecutor, parentSubexecutor, doneValue);
        return undefined;
      }
    }));
  }
  finishWithDoneValue(childExecutor, parentSubexecutor, doneValue) {
    const subexecutor = parentSubexecutor;
    switch (subexecutor._tag) {
      case OP_PULL_FROM_UPSTREAM:
        {
          const modifiedParent = new PullFromUpstream(subexecutor.upstreamExecutor, subexecutor.createChild, subexecutor.lastDone !== undefined ? subexecutor.combineChildResults(subexecutor.lastDone, doneValue) : doneValue, subexecutor.activeChildExecutors, subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull, subexecutor.onEmit);
          this._closeLastSubstream = childExecutor.close(succeed$f(doneValue));
          this.replaceSubexecutor(modifiedParent);
          break;
        }
      case OP_DRAIN_CHILD_EXECUTORS:
        {
          const modifiedParent = new DrainChildExecutors(subexecutor.upstreamExecutor, subexecutor.lastDone !== undefined ? subexecutor.combineChildResults(subexecutor.lastDone, doneValue) : doneValue, subexecutor.activeChildExecutors, subexecutor.upstreamDone, subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull);
          this._closeLastSubstream = childExecutor.close(succeed$f(doneValue));
          this.replaceSubexecutor(modifiedParent);
          break;
        }
    }
  }
  handleSubexecutorFailure(childExecutor, parentSubexecutor, cause) {
    return this.finishSubexecutorWithCloseEffect(failCause$8(cause), exit => parentSubexecutor.close(exit), exit => childExecutor.close(exit));
  }
  pullFromUpstream(subexecutor) {
    if (subexecutor.activeChildExecutors.length === 0) {
      return this.performPullFromUpstream(subexecutor);
    }
    const activeChild = subexecutor.activeChildExecutors[0];
    const parentSubexecutor = new PullFromUpstream(subexecutor.upstreamExecutor, subexecutor.createChild, subexecutor.lastDone, subexecutor.activeChildExecutors.slice(1), subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull, subexecutor.onEmit);
    if (activeChild === undefined) {
      return this.performPullFromUpstream(parentSubexecutor);
    }
    this.replaceSubexecutor(new PullFromChild(activeChild.childExecutor, parentSubexecutor, activeChild.onEmit));
    return undefined;
  }
  performPullFromUpstream(subexecutor) {
    return Read(subexecutor.upstreamExecutor, effect => {
      const closeLastSubstream = this._closeLastSubstream === undefined ? unit$3 : this._closeLastSubstream;
      this._closeLastSubstream = undefined;
      return pipe(this._executeCloseLastSubstream(closeLastSubstream), zipRight$4(effect));
    }, emitted => {
      if (this._closeLastSubstream !== undefined) {
        const closeLastSubstream = this._closeLastSubstream;
        this._closeLastSubstream = undefined;
        return pipe(this._executeCloseLastSubstream(closeLastSubstream), map$6(() => {
          const childExecutor = new ChannelExecutor(subexecutor.createChild(emitted), this._providedEnv, this._executeCloseLastSubstream);
          childExecutor._input = this._input;
          const [emitSeparator, updatedChildExecutors] = this.applyUpstreamPullStrategy(false, subexecutor.activeChildExecutors, subexecutor.onPull(Pulled(emitted)));
          this._activeSubexecutor = new PullFromChild(childExecutor, new PullFromUpstream(subexecutor.upstreamExecutor, subexecutor.createChild, subexecutor.lastDone, updatedChildExecutors, subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull, subexecutor.onEmit), subexecutor.onEmit);
          if (isSome(emitSeparator)) {
            this._activeSubexecutor = new Emit(emitSeparator.value, this._activeSubexecutor);
          }
          return undefined;
        }));
      }
      const childExecutor = new ChannelExecutor(subexecutor.createChild(emitted), this._providedEnv, this._executeCloseLastSubstream);
      childExecutor._input = this._input;
      const [emitSeparator, updatedChildExecutors] = this.applyUpstreamPullStrategy(false, subexecutor.activeChildExecutors, subexecutor.onPull(Pulled(emitted)));
      this._activeSubexecutor = new PullFromChild(childExecutor, new PullFromUpstream(subexecutor.upstreamExecutor, subexecutor.createChild, subexecutor.lastDone, updatedChildExecutors, subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull, subexecutor.onEmit), subexecutor.onEmit);
      if (isSome(emitSeparator)) {
        this._activeSubexecutor = new Emit(emitSeparator.value, this._activeSubexecutor);
      }
      return undefined;
    }, exit => {
      if (subexecutor.activeChildExecutors.some(subexecutor => subexecutor !== undefined)) {
        const drain = new DrainChildExecutors(subexecutor.upstreamExecutor, subexecutor.lastDone, [undefined, ...subexecutor.activeChildExecutors], subexecutor.upstreamExecutor.getDone(), subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull);
        if (this._closeLastSubstream !== undefined) {
          const closeLastSubstream = this._closeLastSubstream;
          this._closeLastSubstream = undefined;
          return pipe(this._executeCloseLastSubstream(closeLastSubstream), map$6(() => this.replaceSubexecutor(drain)));
        }
        this.replaceSubexecutor(drain);
        return undefined;
      }
      const closeLastSubstream = this._closeLastSubstream;
      const state = this.finishSubexecutorWithCloseEffect(pipe(exit, map$e(a => subexecutor.combineWithChildResult(subexecutor.lastDone, a))), () => closeLastSubstream, exit => subexecutor.upstreamExecutor.close(exit));
      return state === undefined ? undefined :
      // NOTE: assuming finalizers cannot fail
      effectOrUndefinedIgnored(state);
    });
  }
  drainChildExecutors(subexecutor) {
    if (subexecutor.activeChildExecutors.length === 0) {
      const lastClose = this._closeLastSubstream;
      if (lastClose !== undefined) {
        this.addFinalizer(() => succeed$7(lastClose));
      }
      return this.finishSubexecutorWithCloseEffect(subexecutor.upstreamDone, () => lastClose, exit => subexecutor.upstreamExecutor.close(exit));
    }
    const activeChild = subexecutor.activeChildExecutors[0];
    const rest = subexecutor.activeChildExecutors.slice(1);
    if (activeChild === undefined) {
      const [emitSeparator, remainingExecutors] = this.applyUpstreamPullStrategy(true, rest, subexecutor.onPull(NoUpstream(rest.reduce((n, curr) => curr !== undefined ? n + 1 : n, 0))));
      this.replaceSubexecutor(new DrainChildExecutors(subexecutor.upstreamExecutor, subexecutor.lastDone, remainingExecutors, subexecutor.upstreamDone, subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull));
      if (isSome(emitSeparator)) {
        this._emitted = emitSeparator.value;
        return Emit$1();
      }
      return undefined;
    }
    const parentSubexecutor = new DrainChildExecutors(subexecutor.upstreamExecutor, subexecutor.lastDone, rest, subexecutor.upstreamDone, subexecutor.combineChildResults, subexecutor.combineWithChildResult, subexecutor.onPull);
    this.replaceSubexecutor(new PullFromChild(activeChild.childExecutor, parentSubexecutor, activeChild.onEmit));
    return undefined;
  }
}
const ifNotNull = effect => effect !== undefined ? effect : unit$3;
const runFinalizers = (finalizers, exit$1) => {
  return pipe(forEach$6(finalizers, fin => exit(fin(exit$1))), map$6(exits => pipe(all$4(exits), getOrElse$3(() => unit$5))), flatMap$4(exit => suspend$5(() => exit)));
};

/**
 * @internal
 */
const readUpstream = (r, onSuccess, onFailure) => {
  const readStack = [r];
  const read = () => {
    const current = readStack.pop();
    if (current === undefined || current.upstream === undefined) {
      return dieMessage$4("Unexpected end of input for channel execution");
    }
    const state = current.upstream.run();
    switch (state._tag) {
      case OP_EMIT$2:
        {
          const emitEffect = current.onEmit(current.upstream.getEmit());
          if (readStack.length === 0) {
            if (emitEffect === undefined) {
              return suspend$5(onSuccess);
            }
            return pipe(emitEffect, matchCauseEffect({
              onFailure,
              onSuccess
            }));
          }
          if (emitEffect === undefined) {
            return suspend$5(() => read());
          }
          return pipe(emitEffect, matchCauseEffect({
            onFailure,
            onSuccess: () => read()
          }));
        }
      case OP_DONE$3:
        {
          const doneEffect = current.onDone(current.upstream.getDone());
          if (readStack.length === 0) {
            if (doneEffect === undefined) {
              return suspend$5(onSuccess);
            }
            return pipe(doneEffect, matchCauseEffect({
              onFailure,
              onSuccess
            }));
          }
          if (doneEffect === undefined) {
            return suspend$5(() => read());
          }
          return pipe(doneEffect, matchCauseEffect({
            onFailure,
            onSuccess: () => read()
          }));
        }
      case OP_FROM_EFFECT:
        {
          readStack.push(current);
          return pipe(current.onEffect(state.effect), catchAllCause$2(cause => suspend$5(() => {
            const doneEffect = current.onDone(failCause$8(cause));
            return doneEffect === undefined ? unit$3 : doneEffect;
          })), matchCauseEffect({
            onFailure,
            onSuccess: () => read()
          }));
        }
      case OP_READ:
        {
          readStack.push(current);
          readStack.push(state);
          return suspend$5(() => read());
        }
    }
  };
  return read();
};

/** @internal */
const run$2 = self => pipe(runScoped$1(self), scoped$2);

/** @internal */
const runScoped$1 = self => {
  const run = (channelDeferred, scopeDeferred, scope) => acquireUseRelease$2(sync$4(() => new ChannelExecutor(self, void 0, identity$1)), exec => suspend$5(() => pipe(runScopedInterpret(exec.run(), exec), intoDeferred(channelDeferred), zipRight$4(_await$3(channelDeferred)), zipLeft$4(_await$3(scopeDeferred)))), (exec, exit) => {
    const finalize = exec.close(exit);
    if (finalize === undefined) {
      return unit$3;
    }
    return tapErrorCause$1(finalize, cause => addFinalizer$1(scope, failCause$5(cause)));
  });
  return uninterruptibleMask(restore => flatMap$4(scope, parent => pipe(all$1([fork$1(parent, sequential), make$R(), make$R()]), flatMap$4(([child, channelDeferred, scopeDeferred]) => pipe(forkScoped(restore(run(channelDeferred, scopeDeferred, child))), flatMap$4(fiber => pipe(addFinalizer(() => succeed$g(scopeDeferred, void 0)), zipRight$4(restore(_await$3(channelDeferred))), zipLeft$4(inheritAll(fiber)))))))));
};

/** @internal */
const runScopedInterpret = (channelState, exec) => {
  const op = channelState;
  switch (op._tag) {
    case OP_FROM_EFFECT:
      {
        return pipe(op.effect, flatMap$4(() => runScopedInterpret(exec.run(), exec)));
      }
    case OP_EMIT$2:
      {
        // Can't really happen because Out <:< Nothing. So just skip ahead.
        return runScopedInterpret(exec.run(), exec);
      }
    case OP_DONE$3:
      {
        return suspend$5(() => exec.getDone());
      }
    case OP_READ:
      {
        return readUpstream(op, () => runScopedInterpret(exec.run(), exec), failCause$5);
      }
  }
};

/** @internal */
const OP_DONE$2 = "Done";

/** @internal */

/** @internal */
const OP_AWAIT = "Await";

/** @internal */
const MergeDecisionSymbolKey = "effect/ChannelMergeDecision";

/** @internal */
const MergeDecisionTypeId = /*#__PURE__*/Symbol.for(MergeDecisionSymbolKey);

/** @internal */
const proto$2 = {
  [MergeDecisionTypeId]: {
    _R: _ => _,
    _E0: _ => _,
    _Z0: _ => _,
    _E: _ => _,
    _Z: _ => _
  }
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const Done$1 = effect => {
  const op = Object.create(proto$2);
  op._tag = OP_DONE$2;
  op.effect = effect;
  return op;
};

/** @internal */
const Await$1 = f => {
  const op = Object.create(proto$2);
  op._tag = OP_AWAIT;
  op.f = f;
  return op;
};

/** @internal */
const AwaitConst = effect => Await$1(() => effect);

/** @internal */
const isMergeDecision = u => typeof u === "object" && u != null && MergeDecisionTypeId in u;

/** @internal */
const match$5 = /*#__PURE__*/dual(2, (self, {
  onAwait,
  onDone
}) => {
  const op = self;
  switch (op._tag) {
    case OP_DONE$2:
      {
        return onDone(op.effect);
      }
    case OP_AWAIT:
      {
        return onAwait(op.f);
      }
  }
});

/** @internal */
const OP_BOTH_RUNNING = "BothRunning";

/** @internal */

/** @internal */
const OP_LEFT_DONE = "LeftDone";

/** @internal */

/** @internal */
const OP_RIGHT_DONE = "RightDone";

/** @internal */
const MergeStateSymbolKey = "effect/ChannelMergeState";

/** @internal */
const MergeStateTypeId = /*#__PURE__*/Symbol.for(MergeStateSymbolKey);

/** @internal */
const proto$1 = {
  [MergeStateTypeId]: MergeStateTypeId
};

/** @internal */
const BothRunning = (left, right) => {
  const op = Object.create(proto$1);
  op._tag = OP_BOTH_RUNNING;
  op.left = left;
  op.right = right;
  return op;
};

/** @internal */
const LeftDone = f => {
  const op = Object.create(proto$1);
  op._tag = OP_LEFT_DONE;
  op.f = f;
  return op;
};

/** @internal */
const RightDone = f => {
  const op = Object.create(proto$1);
  op._tag = OP_RIGHT_DONE;
  op.f = f;
  return op;
};

/** @internal */
const isMergeState = u => {
  return typeof u === "object" && u != null && MergeStateTypeId in u;
};

/** @internal */
const isBothRunning = self => {
  return self._tag === OP_BOTH_RUNNING;
};

/** @internal */
const isLeftDone = self => {
  return self._tag === OP_LEFT_DONE;
};

/** @internal */
const isRightDone = self => {
  return self._tag === OP_RIGHT_DONE;
};

/** @internal */
const match$4 = /*#__PURE__*/dual(2, (self, {
  onBothRunning,
  onLeftDone,
  onRightDone
}) => {
  switch (self._tag) {
    case OP_BOTH_RUNNING:
      {
        return onBothRunning(self.left, self.right);
      }
    case OP_LEFT_DONE:
      {
        return onLeftDone(self.f);
      }
    case OP_RIGHT_DONE:
      {
        return onRightDone(self.f);
      }
  }
});

/** @internal */
const OP_BACK_PRESSURE = "BackPressure";

/** @internal */

/** @internal */
const OP_BUFFER_SLIDING = "BufferSliding";

/** @internal */
const MergeStrategySymbolKey = "effect/ChannelMergeStrategy";

/** @internal */
const MergeStrategyTypeId = /*#__PURE__*/Symbol.for(MergeStrategySymbolKey);

/** @internal */
const proto = {
  [MergeStrategyTypeId]: MergeStrategyTypeId
};

/** @internal */
const BackPressure$1 = _ => {
  const op = Object.create(proto);
  op._tag = OP_BACK_PRESSURE;
  return op;
};

/** @internal */
const BufferSliding = _ => {
  const op = Object.create(proto);
  op._tag = OP_BUFFER_SLIDING;
  return op;
};

/** @internal */
const isMergeStrategy = u => typeof u === "object" && u != null && MergeStrategyTypeId in u;

/** @internal */
const isBackPressure = self => self._tag === OP_BACK_PRESSURE;

/** @internal */
const isBufferSliding = self => self._tag === OP_BUFFER_SLIDING;

/** @internal */
const match$3 = /*#__PURE__*/dual(2, (self, {
  onBackPressure,
  onBufferSliding
}) => {
  switch (self._tag) {
    case OP_BACK_PRESSURE:
      {
        return onBackPressure();
      }
    case OP_BUFFER_SLIDING:
      {
        return onBufferSliding();
      }
  }
});

/** @internal */

/** @internal */
const OP_STATE_EMPTY = "Empty";

/** @internal */

/** @internal */
const OP_STATE_EMIT = "Emit";

/** @internal */

/** @internal */
const OP_STATE_ERROR = "Error";

/** @internal */

/** @internal */
const OP_STATE_DONE = "Done";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const stateEmpty = notifyProducer => ({
  _tag: OP_STATE_EMPTY,
  notifyProducer
});

/** @internal */
const stateEmit = notifyConsumers => ({
  _tag: OP_STATE_EMIT,
  notifyConsumers
});

/** @internal */
const stateError = cause => ({
  _tag: OP_STATE_ERROR,
  cause
});

/** @internal */
const stateDone = done => ({
  _tag: OP_STATE_DONE,
  done
});

/** @internal */
class SingleProducerAsyncInputImpl {
  constructor(ref) {
    this.ref = ref;
  }
  awaitRead() {
    return flatten$3(modify$3(this.ref, state => state._tag === OP_STATE_EMPTY ? [_await$3(state.notifyProducer), state] : [unit$3, state]));
  }
  close() {
    return fiberIdWith(fiberId => this.error(interrupt$4(fiberId)));
  }
  done(value) {
    return flatten$3(modify$3(this.ref, state => {
      switch (state._tag) {
        case OP_STATE_EMPTY:
          {
            return [_await$3(state.notifyProducer), state];
          }
        case OP_STATE_EMIT:
          {
            return [forEach$6(state.notifyConsumers, deferred => succeed$g(deferred, left(value)), {
              discard: true
            }), stateDone(value)];
          }
        case OP_STATE_ERROR:
          {
            return [interrupt$2, state];
          }
        case OP_STATE_DONE:
          {
            return [interrupt$2, state];
          }
      }
    }));
  }
  emit(element) {
    return flatMap$4(make$R(), deferred => flatten$3(modify$3(this.ref, state => {
      switch (state._tag) {
        case OP_STATE_EMPTY:
          {
            return [_await$3(state.notifyProducer), state];
          }
        case OP_STATE_EMIT:
          {
            const notifyConsumer = state.notifyConsumers[0];
            const notifyConsumers = state.notifyConsumers.slice(1);
            if (notifyConsumer !== undefined) {
              return [succeed$g(notifyConsumer, right(element)), notifyConsumers.length === 0 ? stateEmpty(deferred) : stateEmit(notifyConsumers)];
            }
            throw new Error("Bug: Channel.SingleProducerAsyncInput.emit - Queue was empty! Please report an issue at https://github.com/Effect-TS/stream/issues");
          }
        case OP_STATE_ERROR:
          {
            return [interrupt$2, state];
          }
        case OP_STATE_DONE:
          {
            return [interrupt$2, state];
          }
      }
    })));
  }
  error(cause) {
    return flatten$3(modify$3(this.ref, state => {
      switch (state._tag) {
        case OP_STATE_EMPTY:
          {
            return [_await$3(state.notifyProducer), state];
          }
        case OP_STATE_EMIT:
          {
            return [forEach$6(state.notifyConsumers, deferred => failCause$9(deferred, cause), {
              discard: true
            }), stateError(cause)];
          }
        case OP_STATE_ERROR:
          {
            return [interrupt$2, state];
          }
        case OP_STATE_DONE:
          {
            return [interrupt$2, state];
          }
      }
    }));
  }
  take() {
    return this.takeWith(cause => failCause$8(map$9(cause, left)), elem => succeed$f(elem), done => fail$d(right(done)));
  }
  takeWith(onError, onElement, onDone) {
    return flatMap$4(make$R(), deferred => flatten$3(modify$3(this.ref, state => {
      switch (state._tag) {
        case OP_STATE_EMPTY:
          {
            return [zipRight$4(succeed$g(state.notifyProducer, void 0), matchCause(_await$3(deferred), {
              onFailure: onError,
              onSuccess: match$i({
                onLeft: onDone,
                onRight: onElement
              })
            })), stateEmit([deferred])];
          }
        case OP_STATE_EMIT:
          {
            return [matchCause(_await$3(deferred), {
              onFailure: onError,
              onSuccess: match$i({
                onLeft: onDone,
                onRight: onElement
              })
            }), stateEmit([...state.notifyConsumers, deferred])];
          }
        case OP_STATE_ERROR:
          {
            return [succeed$7(onError(state.cause)), state];
          }
        case OP_STATE_DONE:
          {
            return [succeed$7(onDone(state.done)), state];
          }
      }
    })));
  }
}

/** @internal */
const make$s = () => pipe(make$R(), flatMap$4(deferred => make$G(stateEmpty(deferred))), map$6(ref => new SingleProducerAsyncInputImpl(ref)));

/** @internal */
const acquireUseRelease$1 = (acquire, use, release) => flatMap$3(fromEffect$3(make$G(() => unit$3)), ref => pipe(fromEffect$3(uninterruptible(tap$3(acquire, a => set$6(ref, exit => release(a, exit))))), flatMap$3(use), ensuringWith$2(exit => flatMap$4(get$b(ref), f => f(exit)))));

/** @internal */
const as$3 = /*#__PURE__*/dual(2, (self, value) => map$5(self, () => value));

/** @internal */
const asUnit$1 = self => map$5(self, constVoid);

/** @internal */
const buffer$1 = options => suspend$4(() => {
  const doBuffer = (empty, isEmpty, ref) => unwrap$2(modify$3(ref, inElem => isEmpty(inElem) ? [readWith({
    onInput: input => flatMap$3(write(input), () => doBuffer(empty, isEmpty, ref)),
    onFailure: error => fail$6(error),
    onDone: done => succeedNow(done)
  }), inElem] : [flatMap$3(write(inElem), () => doBuffer(empty, isEmpty, ref)), empty]));
  return doBuffer(options.empty, options.isEmpty, options.ref);
});

/** @internal */
const bufferChunk = ref => buffer$1({
  empty: empty$z(),
  isEmpty: isEmpty$h,
  ref
});

/** @internal */
const catchAll$2 = /*#__PURE__*/dual(2, (self, f) => catchAllCause$1(self, cause => match$i(failureOrCause(cause), {
  onLeft: f,
  onRight: failCause$4
})));

/** @internal */
const concatMap = /*#__PURE__*/dual(2, (self, f) => concatMapWith(self, f, () => void 0, () => void 0));

/** @internal */
const collect$1 = /*#__PURE__*/dual(2, (self, pf) => {
  const collector = readWith({
    onInput: out => match$j(pf(out), {
      onNone: () => collector,
      onSome: out2 => flatMap$3(write(out2), () => collector)
    }),
    onFailure: fail$6,
    onDone: succeedNow
  });
  return pipeTo(self, collector);
});

/** @internal */
const concatOut = self => concatAll$1(self);

/** @internal */
const mapInput$1 = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWith({
    onInput: inElem => flatMap$3(write(inElem), () => reader),
    onFailure: fail$6,
    onDone: done => succeedNow(f(done))
  });
  return pipeTo(reader, self);
});

/** @internal */
const mapInputEffect$1 = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWith({
    onInput: inElem => flatMap$3(write(inElem), () => reader),
    onFailure: fail$6,
    onDone: done => fromEffect$3(f(done))
  });
  return pipeTo(reader, self);
});

/** @internal */
const mapInputError = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWith({
    onInput: inElem => flatMap$3(write(inElem), () => reader),
    onFailure: error => fail$6(f(error)),
    onDone: succeedNow
  });
  return pipeTo(reader, self);
});

/** @internal */
const mapInputErrorEffect = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWith({
    onInput: inElem => flatMap$3(write(inElem), () => reader),
    onFailure: error => fromEffect$3(f(error)),
    onDone: succeedNow
  });
  return pipeTo(reader, self);
});

/** @internal */
const mapInputIn = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWith({
    onInput: inElem => flatMap$3(write(f(inElem)), () => reader),
    onFailure: fail$6,
    onDone: succeedNow
  });
  return pipeTo(reader, self);
});
const mapInputInEffect = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWith({
    onInput: inElem => flatMap$3(flatMap$3(fromEffect$3(f(inElem)), write), () => reader),
    onFailure: fail$6,
    onDone: succeedNow
  });
  return pipeTo(reader, self);
});

/** @internal */
const doneCollect = self => suspend$4(() => {
  const builder = [];
  return pipe(pipeTo(self, doneCollectReader(builder)), flatMap$3(outDone => succeed$6([unsafeFromArray(builder), outDone])));
});

/** @internal */
const doneCollectReader = builder => {
  return readWith({
    onInput: outElem => flatMap$3(sync$3(() => {
      builder.push(outElem);
    }), () => doneCollectReader(builder)),
    onFailure: fail$6,
    onDone: succeed$6
  });
};

/** @internal */
const drain$2 = self => {
  const drainer = readWithCause({
    onInput: () => drainer,
    onFailure: failCause$4,
    onDone: succeed$6
  });
  return pipeTo(self, drainer);
};

/** @internal */
const emitCollect = self => flatMap$3(doneCollect(self), write);

/** @internal */
const ensuring$3 = /*#__PURE__*/dual(2, (self, finalizer) => ensuringWith$2(self, () => finalizer));

/** @internal */
const context$3 = () => fromEffect$3(context$5());

/** @internal */
const contextWith$3 = f => map$5(context$3(), f);

/** @internal */
const contextWithChannel = f => flatMap$3(context$3(), f);

/** @internal */
const contextWithEffect$2 = f => mapEffect$1(context$3(), f);

/** @internal */
const flatten$2 = self => flatMap$3(self, identity$1);

/** @internal */
const foldChannel = /*#__PURE__*/dual(2, (self, options) => foldCauseChannel(self, {
  onFailure: cause => {
    const either = failureOrCause(cause);
    switch (either._tag) {
      case "Left":
        {
          return options.onFailure(either.left);
        }
      case "Right":
        {
          return failCause$4(either.right);
        }
    }
  },
  onSuccess: options.onSuccess
}));

/** @internal */
const fromEither$1 = either => suspend$4(() => match$i(either, {
  onLeft: fail$6,
  onRight: succeed$6
}));

/** @internal */
const fromInput$1 = input => unwrap$2(input.takeWith(failCause$4, elem => flatMap$3(write(elem), () => fromInput$1(input)), succeed$6));

/** @internal */
const fromPubSub$2 = pubsub => unwrapScoped$2(map$6(subscribe$1(pubsub), fromQueue$2));

/** @internal */
const fromPubSubScoped = pubsub => map$6(subscribe$1(pubsub), fromQueue$2);

/** @internal */
const fromOption$1 = option => suspend$4(() => match$j(option, {
  onNone: () => fail$6(none$8()),
  onSome: succeed$6
}));

/** @internal */
const fromQueue$2 = queue => suspend$4(() => fromQueueInternal(queue));

/** @internal */
const fromQueueInternal = queue => pipe(fromEffect$3(take$5(queue)), flatMap$3(match$i({
  onLeft: match$f({
    onFailure: failCause$4,
    onSuccess: succeedNow
  }),
  onRight: elem => flatMap$3(write(elem), () => fromQueueInternal(queue))
})));

/** @internal */
const identityChannel = () => readWith({
  onInput: input => flatMap$3(write(input), () => identityChannel()),
  onFailure: fail$6,
  onDone: succeedNow
});

/** @internal */
const interruptWhen$1 = /*#__PURE__*/dual(2, (self, effect) => mergeWith$1(self, {
  other: fromEffect$3(effect),
  onSelfDone: selfDone => Done$1(suspend$5(() => selfDone)),
  onOtherDone: effectDone => Done$1(suspend$5(() => effectDone))
}));

/** @internal */
const interruptWhenDeferred$1 = /*#__PURE__*/dual(2, (self, deferred) => interruptWhen$1(self, _await$3(deferred)));

/** @internal */
const map$5 = /*#__PURE__*/dual(2, (self, f) => flatMap$3(self, a => sync$3(() => f(a))));

/** @internal */
const mapEffect$1 = /*#__PURE__*/dual(2, (self, f) => flatMap$3(self, z => fromEffect$3(f(z))));

/** @internal */
const mapError$3 = /*#__PURE__*/dual(2, (self, f) => mapErrorCause$1(self, map$9(f)));

/** @internal */
const mapErrorCause$1 = /*#__PURE__*/dual(2, (self, f) => catchAllCause$1(self, cause => failCause$4(f(cause))));

/** @internal */
const mapOut = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWith({
    onInput: outElem => flatMap$3(write(f(outElem)), () => reader),
    onFailure: fail$6,
    onDone: succeedNow
  });
  return pipeTo(self, reader);
});

/** @internal */
const mapOutEffect = /*#__PURE__*/dual(2, (self, f) => {
  const reader = readWithCause({
    onInput: outElem => pipe(fromEffect$3(f(outElem)), flatMap$3(write), flatMap$3(() => reader)),
    onFailure: failCause$4,
    onDone: succeedNow
  });
  return pipeTo(self, reader);
});

/** @internal */
const mapOutEffectPar = /*#__PURE__*/dual(3, (self, f, n) => pipe(gen$1(function* ($) {
  const queue = yield* $(acquireRelease$1(bounded$2(n), queue => shutdown$2(queue)));
  const errorSignal = yield* $(make$R());
  const withPermits = n === Number.POSITIVE_INFINITY ? _ => identity$1 : (yield* $(makeSemaphore(n))).withPermits;
  const pull = yield* $(toPull$1(self));
  yield* $(matchCauseEffect(pull, {
    onFailure: cause => offer$3(queue, failCause$5(cause)),
    onSuccess: either => match$i(either, {
      onLeft: outDone => {
        const lock = withPermits(n);
        return zipRight$4(interruptible(lock(unit$3)), asUnit$2(offer$3(queue, succeed$7(left(outDone)))));
      },
      onRight: outElem => gen$1(function* ($) {
        const deferred = yield* $(make$R());
        const latch = yield* $(make$R());
        yield* $(asUnit$2(offer$3(queue, map$6(_await$3(deferred), right))));
        yield* $(succeed$g(latch, void 0), zipRight$4(pipe(uninterruptibleMask(restore => pipe(exit(restore(_await$3(errorSignal))), raceFirst(exit(restore(f(outElem)))),
        // TODO: remove
        flatMap$4(exit => suspend$5(() => exit)))), tapErrorCause$1(cause => failCause$9(errorSignal, cause)), intoDeferred(deferred))), withPermits(1), forkScoped);
        yield* $(_await$3(latch));
      })
    })
  }), forever$2, interruptible, forkScoped);
  return queue;
}), map$6(queue => {
  const consumer = unwrap$2(matchCause(flatten$3(take$5(queue)), {
    onFailure: failCause$4,
    onSuccess: match$i({
      onLeft: succeedNow,
      onRight: outElem => flatMap$3(write(outElem), () => consumer)
    })
  }));
  return consumer;
}), unwrapScoped$2));

/** @internal */
const mergeAll$2 = options => {
  return channels => mergeAllWith(options)(channels, constVoid);
};

/** @internal */
const mergeAllUnbounded = channels => mergeAllWith({
  concurrency: "unbounded"
})(channels, constVoid);

/** @internal */
const mergeAllUnboundedWith = (channels, f) => mergeAllWith({
  concurrency: "unbounded"
})(channels, f);

/** @internal */
const mergeAllWith = ({
  bufferSize = 16,
  concurrency,
  mergeStrategy = BackPressure$1()
}) => (channels, f) => pipe(gen$1(function* ($) {
  const concurrencyN = concurrency === "unbounded" ? Number.MAX_SAFE_INTEGER : concurrency;
  const input = yield* $(make$s());
  const queueReader = fromInput$1(input);
  const queue = yield* $(acquireRelease$1(bounded$2(bufferSize), queue => shutdown$2(queue)));
  const cancelers = yield* $(acquireRelease$1(unbounded$2(), queue => shutdown$2(queue)));
  const lastDone = yield* $(make$G(none$8()));
  const errorSignal = yield* $(make$R());
  const withPermits = (yield* $(makeSemaphore(concurrencyN))).withPermits;
  const pull = yield* $(toPull$1(channels));
  const evaluatePull = pull => pipe(flatMap$4(pull, match$i({
    onLeft: done => succeed$7(some$6(done)),
    onRight: outElem => as$4(offer$3(queue, succeed$7(right(outElem))), none$8())
  })), repeatUntil$1(isSome), flatMap$4(outDone => update$4(lastDone, match$j({
    onNone: () => some$6(outDone.value),
    onSome: lastDone => some$6(f(lastDone, outDone.value))
  }))), catchAllCause$2(cause => isInterrupted(cause) ? failCause$5(cause) : pipe(offer$3(queue, failCause$5(cause)), zipRight$4(succeed$g(errorSignal, void 0)), asUnit$2)));
  yield* $(matchCauseEffect(pull, {
    onFailure: cause => pipe(offer$3(queue, failCause$5(cause)), zipRight$4(succeed$7(false))),
    onSuccess: match$i({
      onLeft: outDone => raceWith$1(_await$3(errorSignal), withPermits(concurrencyN)(unit$3), {
        onSelfDone: (_, permitAcquisition) => as$4(interrupt$3(permitAcquisition), false),
        onOtherDone: (_, failureAwait) => zipRight$4(interrupt$3(failureAwait), pipe(get$b(lastDone), flatMap$4(match$j({
          onNone: () => offer$3(queue, succeed$7(left(outDone))),
          onSome: lastDone => offer$3(queue, succeed$7(left(f(lastDone, outDone))))
        })), as$4(false)))
      }),
      onRight: channel => match$3(mergeStrategy, {
        onBackPressure: () => gen$1(function* ($) {
          const latch = yield* $(make$R());
          const raceEffects = pipe(queueReader, pipeTo(channel), toPull$1, flatMap$4(pull => race$2(evaluatePull(pull), _await$3(errorSignal))), scoped$2);
          yield* $(succeed$g(latch, void 0), zipRight$4(raceEffects), withPermits(1), forkScoped);
          yield* $(_await$3(latch));
          const errored = yield* $(isDone$6(errorSignal));
          return !errored;
        }),
        onBufferSliding: () => gen$1(function* ($) {
          const canceler = yield* $(make$R());
          const latch = yield* $(make$R());
          const size$1 = yield* $(size$7(cancelers));
          yield* $(take$5(cancelers), flatMap$4(_ => succeed$g(_, void 0)), when$3(() => size$1 >= concurrencyN));
          yield* $(offer$3(cancelers, canceler));
          const raceEffects = pipe(queueReader, pipeTo(channel), toPull$1, flatMap$4(pull => pipe(evaluatePull(pull), race$2(_await$3(errorSignal)), race$2(_await$3(canceler)))), scoped$2);
          yield* $(succeed$g(latch, void 0), zipRight$4(raceEffects), withPermits(1), forkScoped);
          yield* $(_await$3(latch));
          const errored = yield* $(isDone$6(errorSignal));
          return !errored;
        })
      })
    })
  }), repeatWhile$1(identity$1), forkScoped);
  return [queue, input];
}), map$6(([queue, input]) => {
  const consumer = pipe(take$5(queue), flatten$3, matchCause({
    onFailure: failCause$4,
    onSuccess: match$i({
      onLeft: succeedNow,
      onRight: outElem => flatMap$3(write(outElem), () => consumer)
    })
  }), unwrap$2);
  return embedInput(consumer, input);
}), unwrapScoped$2);

/** @internal */
const mergeMap = /*#__PURE__*/dual(3, (self, f, options) => mergeAll$2(options)(mapOut(self, f)));

/** @internal */
const mergeOut = /*#__PURE__*/dual(2, (self, n) => mergeAll$2({
  concurrency: n
})(mapOut(self, identity$1)));

/** @internal */
const mergeOutWith = /*#__PURE__*/dual(3, (self, n, f) => mergeAllWith({
  concurrency: n
})(mapOut(self, identity$1), f));

/** @internal */
const mergeWith$1 = /*#__PURE__*/dual(2, (self, options) => unwrapScoped$2(flatMap$4(make$s(), input => {
  const queueReader = fromInput$1(input);
  return map$6(zip$5(toPull$1(pipeTo(queueReader, self)), toPull$1(pipeTo(queueReader, options.other))), ([pullL, pullR]) => {
    const handleSide = (exit, fiber, pull) => (done, both, single) => {
      const onDecision = decision => {
        const op = decision;
        if (op._tag === OP_DONE$2) {
          return succeed$7(fromEffect$3(zipRight$4(interrupt$3(fiber), op.effect)));
        }
        return map$6(_await$1(fiber), match$f({
          onFailure: cause => fromEffect$3(op.f(failCause$8(cause))),
          onSuccess: match$i({
            onLeft: done => fromEffect$3(op.f(succeed$f(done))),
            onRight: elem => zipRight$3(write(elem), go(single(op.f)))
          })
        }));
      };
      return match$f(exit, {
        onFailure: cause => onDecision(done(failCause$8(cause))),
        onSuccess: match$i({
          onLeft: z => onDecision(done(succeed$f(z))),
          onRight: elem => succeed$7(flatMap$3(write(elem), () => flatMap$3(fromEffect$3(forkDaemon(pull)), leftFiber => go(both(leftFiber, fiber)))))
        })
      });
    };
    const go = state => {
      switch (state._tag) {
        case OP_BOTH_RUNNING:
          {
            const leftJoin = interruptible(join(state.left));
            const rightJoin = interruptible(join(state.right));
            return unwrap$2(raceWith$1(leftJoin, rightJoin, {
              onSelfDone: (leftExit, rf) => zipRight$4(interrupt$3(rf), handleSide(leftExit, state.right, pullL)(options.onSelfDone, BothRunning, f => LeftDone(f))),
              onOtherDone: (rightExit, lf) => zipRight$4(interrupt$3(lf), handleSide(rightExit, state.left, pullR)(options.onOtherDone, (left, right) => BothRunning(right, left), f => RightDone(f)))
            }));
          }
        case OP_LEFT_DONE:
          {
            return unwrap$2(map$6(exit(pullR), match$f({
              onFailure: cause => fromEffect$3(state.f(failCause$8(cause))),
              onSuccess: match$i({
                onLeft: done => fromEffect$3(state.f(succeed$f(done))),
                onRight: elem => flatMap$3(write(elem), () => go(LeftDone(state.f)))
              })
            })));
          }
        case OP_RIGHT_DONE:
          {
            return unwrap$2(map$6(exit(pullL), match$f({
              onFailure: cause => fromEffect$3(state.f(failCause$8(cause))),
              onSuccess: match$i({
                onLeft: done => fromEffect$3(state.f(succeed$f(done))),
                onRight: elem => flatMap$3(write(elem), () => go(RightDone(state.f)))
              })
            })));
          }
      }
    };
    return pipe(fromEffect$3(zipWith$3(forkDaemon(pullL), forkDaemon(pullR), (left, right) => BothRunning(left, right))), flatMap$3(go), embedInput(input));
  });
})));

/** @internal */
const never$3 = /*#__PURE__*/fromEffect$3(never$4);

/** @internal */
const orDie$2 = /*#__PURE__*/dual(2, (self, error) => orDieWith$2(self, error));

/** @internal */
const orDieWith$2 = /*#__PURE__*/dual(2, (self, f) => catchAll$2(self, e => {
  throw f(e);
}));

/** @internal */
const orElse$4 = /*#__PURE__*/dual(2, (self, that) => catchAll$2(self, that));

/** @internal */
const pipeToOrFail = /*#__PURE__*/dual(2, (self, that) => suspend$4(() => {
  let channelException = undefined;
  const reader = readWith({
    onInput: outElem => flatMap$3(write(outElem), () => reader),
    onFailure: outErr => {
      channelException = ChannelException(outErr);
      return failCause$4(die$7(channelException));
    },
    onDone: succeedNow
  });
  const writer = readWithCause({
    onInput: outElem => pipe(write(outElem), flatMap$3(() => writer)),
    onFailure: cause => isDieType(cause) && isChannelException(cause.defect) && equals$1(cause.defect, channelException) ? fail$6(cause.defect.error) : failCause$4(cause),
    onDone: succeedNow
  });
  return pipeTo(pipeTo(pipeTo(self, reader), that), writer);
}));

/** @internal */
const provideService$2 = /*#__PURE__*/dual(3, (self, tag, service) => {
  return flatMap$3(context$3(), context => provideContext$4(self, add$4(context, tag, service)));
});

/** @internal */
const provideLayer$1 = /*#__PURE__*/dual(2, (self, layer) => unwrapScoped$2(map$6(build(layer), env => provideContext$4(self, env))));

/** @internal */
const mapInputContext$3 = /*#__PURE__*/dual(2, (self, f) => contextWithChannel(context => provideContext$4(self, f(context))));

/** @internal */
const provideSomeLayer$1 = /*#__PURE__*/dual(2, (self, layer) =>
// @ts-expect-error
provideLayer$1(self, merge$3(context$4(), layer)));

/** @internal */
const read = () => readOrFail(none$8());

/** @internal */
const repeated = self => flatMap$3(self, () => repeated(self));

/** @internal */
const run$1 = self => scoped$2(runScoped$1(self));

/** @internal */
const runCollect$1 = self => run$2(collectElements(self));

/** @internal */
const runDrain$1 = self => run$2(drain$2(self));

/** @internal */
const scoped$1 = effect => unwrap$2(uninterruptibleMask(restore => map$6(make$u(), scope => acquireReleaseOut(tapErrorCause$1(restore(extend(scope)(effect)), cause => close$1(scope, failCause$8(cause))), (_, exit) => close$1(scope, exit)))));

/** @internal */
const toPubSub$1 = pubsub => toQueue$1(pubsub);

/** @internal */
const toPull$1 = self => map$6(acquireRelease$1(sync$4(() => new ChannelExecutor(self, void 0, identity$1)), (exec, exit) => {
  const finalize = exec.close(exit);
  return finalize === undefined ? unit$3 : finalize;
}), exec => suspend$5(() => interpretToPull(exec.run(), exec)));

/** @internal */
const interpretToPull = (channelState, exec) => {
  const state = channelState;
  switch (state._tag) {
    case OP_DONE$3:
      {
        return match$f(exec.getDone(), {
          onFailure: failCause$5,
          onSuccess: done => succeed$7(left(done))
        });
      }
    case OP_EMIT$2:
      {
        return succeed$7(right(exec.getEmit()));
      }
    case OP_FROM_EFFECT:
      {
        return pipe(state.effect, flatMap$4(() => interpretToPull(exec.run(), exec)));
      }
    case OP_READ:
      {
        return readUpstream(state, () => interpretToPull(exec.run(), exec), cause => failCause$5(cause));
      }
  }
};

/** @internal */
const toQueue$1 = queue => suspend$4(() => toQueueInternal(queue));

/** @internal */
const toQueueInternal = queue => {
  return readWithCause({
    onInput: elem => flatMap$3(fromEffect$3(offer$3(queue, right(elem))), () => toQueueInternal(queue)),
    onFailure: cause => fromEffect$3(pipe(offer$3(queue, left(failCause$8(cause))))),
    onDone: done => fromEffect$3(pipe(offer$3(queue, left(succeed$f(done)))))
  });
};

/** @internal */
const unwrap$2 = channel => flatten$2(fromEffect$3(channel));

/** @internal */
const unwrapScoped$2 = self => concatAllWith(scoped$1(self), (d, _) => d, (d, _) => d);

/** @internal */
const updateService$1 = /*#__PURE__*/dual(3, (self, tag, f) => mapInputContext$3(self, context => merge$8(context, make$12(tag, f(unsafeGet$6(context, tag))))));

/** @internal */
const withSpan$1 = /*#__PURE__*/dual(3, (self, name, options) => unwrapScoped$2(flatMap$4(context$5(), context => map$6(makeSpanScoped(name, options), span => provideContext$4(self, add$4(context, spanTag, span))))));

/** @internal */
const writeAll = (...outs) => writeChunk(fromIterable$b(outs));

/** @internal */
const writeChunk = outs => writeChunkWriter(0, outs.length, outs);

/** @internal */
const writeChunkWriter = (idx, len, chunk) => {
  return idx === len ? unit$2 : pipe(write(pipe(chunk, unsafeGet$5(idx))), flatMap$3(() => writeChunkWriter(idx + 1, len, chunk)));
};

/** @internal */
const zip$4 = /*#__PURE__*/dual(args => isChannel(args[1]), (self, that, options) => options?.concurrent ? mergeWith$1(self, {
  other: that,
  onSelfDone: exit1 => Await$1(exit2 => suspend$5(() => zip$9(exit1, exit2))),
  onOtherDone: exit2 => Await$1(exit1 => suspend$5(() => zip$9(exit1, exit2)))
}) : flatMap$3(self, a => map$5(that, b => [a, b])));

/** @internal */
const zipLeft$3 = /*#__PURE__*/dual(args => isChannel(args[1]), (self, that, options) => options?.concurrent ? map$5(zip$4(self, that, {
  concurrent: true
}), tuple => tuple[0]) : flatMap$3(self, z => as$3(that, z)));

/** @internal */
const zipRight$3 = /*#__PURE__*/dual(args => isChannel(args[1]), (self, that, options) => options?.concurrent ? map$5(zip$4(self, that, {
  concurrent: true
}), tuple => tuple[1]) : flatMap$3(self, () => that));

/** @internal */
const ChannelExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Channel/ChannelException");

/** @internal */
const ChannelException = error => ({
  _tag: "ChannelException",
  [ChannelExceptionTypeId]: ChannelExceptionTypeId,
  error
});

/** @internal */
const isChannelException = u => typeof u === "object" && u != null && ChannelExceptionTypeId in u;

/** @internal */
const SinkTypeId = /*#__PURE__*/Symbol.for("effect/Sink");

/** @internal */
const sinkVariance = {
  _R: _ => _,
  _E: _ => _,
  _In: _ => _,
  _L: _ => _,
  _Z: _ => _
};

/** @internal */
class SinkImpl {
  [SinkTypeId] = sinkVariance;
  constructor(channel) {
    this.channel = channel;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const isSink = u => typeof u === "object" && u != null && SinkTypeId in u;

/** @internal */
const suspend$3 = evaluate => new SinkImpl(suspend$4(() => toChannel$1(evaluate())));

/** @internal */
const as$2 = /*#__PURE__*/dual(2, (self, z) => pipe(self, map$4(() => z)));

/** @internal */
const collectAll$1 = () => new SinkImpl(collectAllLoop(empty$z()));

/** @internal */
const collectAllLoop = acc => readWithCause({
  onInput: chunk => collectAllLoop(pipe(acc, appendAll$1(chunk))),
  onFailure: failCause$4,
  onDone: () => succeed$6(acc)
});

/** @internal */
const collectAllN = n => suspend$3(() => fromChannel$1(collectAllNLoop(n, empty$z())));

/** @internal */
const collectAllNLoop = (n, acc) => readWithCause({
  onInput: chunk => {
    const [collected, leftovers] = splitAt(chunk, n);
    if (collected.length < n) {
      return collectAllNLoop(n - collected.length, appendAll$1(acc, collected));
    }
    if (isEmpty$h(leftovers)) {
      return succeed$6(appendAll$1(acc, collected));
    }
    return flatMap$3(write(leftovers), () => succeed$6(appendAll$1(acc, collected)));
  },
  onFailure: failCause$4,
  onDone: () => succeed$6(acc)
});

/** @internal */
const collectAllFrom = self => collectAllWhileWith(self, {
  initial: empty$z(),
  while: constTrue,
  body: (chunk, z) => pipe(chunk, append$1(z))
});

/** @internal */
const collectAllToMap = (key, merge) => {
  return pipe(foldLeftChunks(empty$u(), (map, chunk) => pipe(chunk, reduce$h(map, (map, input) => {
    const k = key(input);
    const v = pipe(map, has$6(k)) ? merge(pipe(map, unsafeGet$3(k)), input) : input;
    return pipe(map, set$b(k, v));
  }))));
};

/** @internal */
const collectAllToMapN = (n, key, merge) => {
  return foldWeighted({
    initial: empty$u(),
    maxCost: n,
    cost: (acc, input) => pipe(acc, has$6(key(input))) ? 0 : 1,
    body: (acc, input) => {
      const k = key(input);
      const v = pipe(acc, has$6(k)) ? merge(pipe(acc, unsafeGet$3(k)), input) : input;
      return pipe(acc, set$b(k, v));
    }
  });
};

/** @internal */
const collectAllToSet = () => foldLeftChunks(empty$s(), (acc, chunk) => pipe(chunk, reduce$h(acc, (acc, input) => pipe(acc, add$2(input)))));

/** @internal */
const collectAllToSetN = n => foldWeighted({
  initial: empty$s(),
  maxCost: n,
  cost: (acc, input) => has$5(acc, input) ? 0 : 1,
  body: (acc, input) => add$2(acc, input)
});

/** @internal */
const collectAllUntil = p => {
  return pipe(fold([empty$z(), true], tuple => tuple[1], ([chunk, _], input) => [pipe(chunk, append$1(input)), !p(input)]), map$4(tuple => tuple[0]));
};

/** @internal */
const collectAllUntilEffect = p => {
  return pipe(foldEffect([empty$z(), true], tuple => tuple[1], ([chunk, _], input) => pipe(p(input), map$6(bool => [pipe(chunk, append$1(input)), !bool]))), map$4(tuple => tuple[0]));
};

/** @internal */
const collectAllWhile = predicate => fromChannel$1(collectAllWhileReader(predicate, empty$z()));

/** @internal */
const collectAllWhileReader = (predicate, done) => readWith({
  onInput: input => {
    const [collected, leftovers] = pipe(toReadonlyArray$4(input), span$1(predicate));
    if (leftovers.length === 0) {
      return collectAllWhileReader(predicate, pipe(done, appendAll$1(unsafeFromArray(collected))));
    }
    return pipe(write(unsafeFromArray(leftovers)), zipRight$3(succeed$6(pipe(done, appendAll$1(unsafeFromArray(collected))))));
  },
  onFailure: fail$6,
  onDone: () => succeed$6(done)
});

/** @internal */
const collectAllWhileEffect = predicate => fromChannel$1(collectAllWhileEffectReader(predicate, empty$z()));

/** @internal */
const collectAllWhileEffectReader = (predicate, done) => readWith({
  onInput: input => pipe(fromEffect$3(pipe(input, takeWhile$1(predicate), map$6(unsafeFromArray))), flatMap$3(collected => {
    const leftovers = pipe(input, drop$2(collected.length));
    if (isEmpty$h(leftovers)) {
      return collectAllWhileEffectReader(predicate, pipe(done, appendAll$1(collected)));
    }
    return pipe(write(leftovers), zipRight$3(succeed$6(pipe(done, appendAll$1(collected)))));
  })),
  onFailure: fail$6,
  onDone: () => succeed$6(done)
});

/** @internal */
const collectAllWhileWith = /*#__PURE__*/dual(2, (self, options) => {
  const refs = pipe(make$G(empty$z()), zip$5(make$G(false)));
  const newChannel = pipe(fromEffect$3(refs), flatMap$3(([leftoversRef, upstreamDoneRef]) => {
    const upstreamMarker = readWith({
      onInput: input => pipe(write(input), flatMap$3(() => upstreamMarker)),
      onFailure: fail$6,
      onDone: done => pipe(fromEffect$3(set$6(upstreamDoneRef, true)), as$3(done))
    });
    return pipe(upstreamMarker, pipeTo(bufferChunk(leftoversRef)), pipeTo(collectAllWhileWithLoop(self, leftoversRef, upstreamDoneRef, options.initial, options.while, options.body)));
  }));
  return new SinkImpl(newChannel);
});

/** @internal */
const collectAllWhileWithLoop = (self, leftoversRef, upstreamDoneRef, currentResult, p, f) => {
  return pipe(toChannel$1(self), doneCollect, foldChannel({
    onFailure: fail$6,
    onSuccess: ([leftovers, doneValue]) => p(doneValue) ? pipe(fromEffect$3(set$6(leftoversRef, flatten$9(leftovers))), flatMap$3(() => pipe(fromEffect$3(get$b(upstreamDoneRef)), flatMap$3(upstreamDone => {
      const accumulatedResult = f(currentResult, doneValue);
      return upstreamDone ? pipe(write(flatten$9(leftovers)), as$3(accumulatedResult)) : collectAllWhileWithLoop(self, leftoversRef, upstreamDoneRef, accumulatedResult, p, f);
    })))) : pipe(write(flatten$9(leftovers)), as$3(currentResult))
  }));
};

/** @internal */
const collectLeftover = self => new SinkImpl(pipe(collectElements(toChannel$1(self)), map$5(([chunks, z]) => [z, flatten$9(chunks)])));

/** @internal */
const mapInput = /*#__PURE__*/dual(2, (self, f) => pipe(self, mapInputChunks(map$l(f))));

/** @internal */
const mapInputEffect = /*#__PURE__*/dual(2, (self, f) => mapInputChunksEffect(self, chunk => map$6(forEach$6(chunk, v => f(v)), unsafeFromArray)));

/** @internal */
const mapInputChunks = /*#__PURE__*/dual(2, (self, f) => {
  const loop = readWith({
    onInput: chunk => pipe(write(f(chunk)), flatMap$3(() => loop)),
    onFailure: fail$6,
    onDone: succeed$6
  });
  return new SinkImpl(pipe(loop, pipeTo(toChannel$1(self))));
});

/** @internal */
const mapInputChunksEffect = /*#__PURE__*/dual(2, (self, f) => {
  const loop = readWith({
    onInput: chunk => pipe(fromEffect$3(f(chunk)), flatMap$3(write), flatMap$3(() => loop)),
    onFailure: fail$6,
    onDone: succeed$6
  });
  return new SinkImpl(pipe(loop, pipeToOrFail(toChannel$1(self))));
});

/** @internal */
const die$4 = defect => failCause$3(die$7(defect));

/** @internal */
const dieMessage$3 = message => failCause$3(die$7(RuntimeException(message)));

/** @internal */
const dieSync$2 = evaluate => failCauseSync$1(() => die$7(evaluate()));

/** @internal */
const dimap = /*#__PURE__*/dual(2, (self, options) => map$4(mapInput(self, options.onInput), options.onDone));

/** @internal */
const dimapEffect = /*#__PURE__*/dual(2, (self, options) => mapEffect(mapInputEffect(self, options.onInput), options.onDone));

/** @internal */
const dimapChunks = /*#__PURE__*/dual(2, (self, options) => map$4(mapInputChunks(self, options.onInput), options.onDone));

/** @internal */
const dimapChunksEffect = /*#__PURE__*/dual(2, (self, options) => mapEffect(mapInputChunksEffect(self, options.onInput), options.onDone));

/** @internal */
const drain$1 = /*#__PURE__*/new SinkImpl( /*#__PURE__*/drain$2( /*#__PURE__*/identityChannel()));

/** @internal */
const drop$1 = n => suspend$3(() => new SinkImpl(dropLoop(n)));

/** @internal */
const dropLoop = n => readWith({
  onInput: input => {
    const dropped = pipe(input, drop$2(n));
    const leftover = Math.max(n - input.length, 0);
    const more = isEmpty$h(input) || leftover > 0;
    if (more) {
      return dropLoop(leftover);
    }
    return pipe(write(dropped), zipRight$3(identityChannel()));
  },
  onFailure: fail$6,
  onDone: () => unit$2
});

/** @internal */
const dropUntil$1 = predicate => new SinkImpl(pipe(toChannel$1(dropWhile$1(input => !predicate(input))), pipeToOrFail(toChannel$1(drop$1(1)))));

/** @internal */
const dropUntilEffect$1 = predicate => suspend$3(() => new SinkImpl(dropUntilEffectReader(predicate)));

/** @internal */
const dropUntilEffectReader = predicate => readWith({
  onInput: input => pipe(input, dropUntil$2(predicate), map$6(leftover => {
    const more = leftover.length === 0;
    return more ? dropUntilEffectReader(predicate) : pipe(write(unsafeFromArray(leftover)), zipRight$3(identityChannel()));
  }), unwrap$2),
  onFailure: fail$6,
  onDone: () => unit$2
});

/** @internal */
const dropWhile$1 = predicate => new SinkImpl(dropWhileReader(predicate));

/** @internal */
const dropWhileReader = predicate => readWith({
  onInput: input => {
    const out = pipe(input, dropWhile$4(predicate));
    if (isEmpty$h(out)) {
      return dropWhileReader(predicate);
    }
    return pipe(write(out), zipRight$3(identityChannel()));
  },
  onFailure: fail$6,
  onDone: succeedNow
});

/** @internal */
const dropWhileEffect$1 = predicate => suspend$3(() => new SinkImpl(dropWhileEffectReader(predicate)));

/** @internal */
const dropWhileEffectReader = predicate => readWith({
  onInput: input => pipe(input, dropWhile$2(predicate), map$6(leftover => {
    const more = leftover.length === 0;
    return more ? dropWhileEffectReader(predicate) : pipe(write(unsafeFromArray(leftover)), zipRight$3(identityChannel()));
  }), unwrap$2),
  onFailure: fail$6,
  onDone: () => unit$2
});

/** @internal */
const ensuring$2 = /*#__PURE__*/dual(2, (self, finalizer) => new SinkImpl(pipe(self, toChannel$1, ensuring$3(finalizer))));

/** @internal */
const ensuringWith$1 = /*#__PURE__*/dual(2, (self, finalizer) => new SinkImpl(pipe(self, toChannel$1, ensuringWith$2(finalizer))));

/** @internal */
const context$2 = () => fromEffect$2(context$5());

/** @internal */
const contextWith$2 = f => pipe(context$2(), map$4(f));

/** @internal */
const contextWithEffect$1 = f => pipe(context$2(), mapEffect(f));

/** @internal */
const contextWithSink = f => new SinkImpl(unwrap$2(pipe(contextWith$4(context => toChannel$1(f(context))))));

/** @internal */
const every$2 = predicate => fold(true, identity$1, (acc, input) => acc && predicate(input));

/** @internal */
const fail$5 = e => new SinkImpl(fail$6(e));

/** @internal */
const failSync$2 = evaluate => new SinkImpl(failSync$3(evaluate));

/** @internal */
const failCause$3 = cause => new SinkImpl(failCause$4(cause));

/** @internal */
const failCauseSync$1 = evaluate => new SinkImpl(failCauseSync$2(evaluate));

/** @internal */
const filterInput = f => {
  return self => pipe(self, mapInputChunks(filter$9(f)));
};

/** @internal */
const filterInputEffect = /*#__PURE__*/dual(2, (self, f) => mapInputChunksEffect(self, chunk => map$6(filter$3(chunk, f), unsafeFromArray)));

/** @internal */
const findEffect$1 = /*#__PURE__*/dual(2, (self, f) => {
  const newChannel = pipe(fromEffect$3(pipe(make$G(empty$z()), zip$5(make$G(false)))), flatMap$3(([leftoversRef, upstreamDoneRef]) => {
    const upstreamMarker = readWith({
      onInput: input => pipe(write(input), flatMap$3(() => upstreamMarker)),
      onFailure: fail$6,
      onDone: done => pipe(fromEffect$3(set$6(upstreamDoneRef, true)), as$3(done))
    });
    const loop = foldChannel(collectElements(toChannel$1(self)), {
      onFailure: fail$6,
      onSuccess: ([leftovers, doneValue]) => pipe(fromEffect$3(f(doneValue)), flatMap$3(satisfied => pipe(fromEffect$3(set$6(leftoversRef, flatten$9(leftovers))), zipRight$3(pipe(fromEffect$3(get$b(upstreamDoneRef)), flatMap$3(upstreamDone => {
        if (satisfied) {
          return pipe(write(flatten$9(leftovers)), as$3(some$6(doneValue)));
        }
        if (upstreamDone) {
          return pipe(write(flatten$9(leftovers)), as$3(none$8()));
        }
        return loop;
      }))))))
    });
    return pipe(upstreamMarker, pipeTo(bufferChunk(leftoversRef)), pipeTo(loop));
  }));
  return new SinkImpl(newChannel);
});

/** @internal */
const fold = (s, contFn, f) => suspend$3(() => new SinkImpl(foldReader(s, contFn, f)));

/** @internal */
const foldReader = (s, contFn, f) => {
  if (!contFn(s)) {
    return succeedNow(s);
  }
  return readWith({
    onInput: input => {
      const [nextS, leftovers] = foldChunkSplit(s, input, contFn, f, 0, input.length);
      if (isNonEmpty$5(leftovers)) {
        return pipe(write(leftovers), as$3(nextS));
      }
      return foldReader(nextS, contFn, f);
    },
    onFailure: fail$6,
    onDone: () => succeedNow(s)
  });
};

/** @internal */
const foldChunkSplit = (s, chunk, contFn, f, index, length) => {
  if (index === length) {
    return [s, empty$z()];
  }
  const s1 = f(s, pipe(chunk, unsafeGet$5(index)));
  if (contFn(s1)) {
    return foldChunkSplit(s1, chunk, contFn, f, index + 1, length);
  }
  return [s1, pipe(chunk, drop$2(index + 1))];
};

/** @internal */
const foldSink = /*#__PURE__*/dual(2, (self, options) => {
  const newChannel = pipe(toChannel$1(self), collectElements, foldChannel({
    onFailure: error => toChannel$1(options.onFailure(error)),
    onSuccess: ([leftovers, z]) => suspend$4(() => {
      const leftoversRef = {
        ref: pipe(leftovers, filter$9(isNonEmpty$5))
      };
      const refReader = pipe(sync$3(() => {
        const ref = leftoversRef.ref;
        leftoversRef.ref = empty$z();
        return ref;
      }),
      // This cast is safe because of the L1 >: L <: In1 bound. It follows that
      // L <: In1 and therefore Chunk[L] can be safely cast to Chunk[In1].
      flatMap$3(chunk => writeChunk(chunk)));
      const passthrough = identityChannel();
      const continuationSink = pipe(refReader, zipRight$3(passthrough), pipeTo(toChannel$1(options.onSuccess(z))));
      return flatMap$3(collectElements(continuationSink), ([newLeftovers, z1]) => pipe(succeed$6(leftoversRef.ref), flatMap$3(writeChunk), zipRight$3(writeChunk(newLeftovers)), as$3(z1)));
    })
  }));
  return new SinkImpl(newChannel);
});

/** @internal */
const foldChunks = (s, contFn, f) => suspend$3(() => new SinkImpl(foldChunksReader(s, contFn, f)));

/** @internal */
const foldChunksReader = (s, contFn, f) => {
  if (!contFn(s)) {
    return succeedNow(s);
  }
  return readWith({
    onInput: input => foldChunksReader(f(s, input), contFn, f),
    onFailure: fail$6,
    onDone: () => succeedNow(s)
  });
};

/** @internal */
const foldChunksEffect = (s, contFn, f) => suspend$3(() => new SinkImpl(foldChunksEffectReader(s, contFn, f)));

/** @internal */
const foldChunksEffectReader = (s, contFn, f) => {
  if (!contFn(s)) {
    return succeedNow(s);
  }
  return readWith({
    onInput: input => pipe(fromEffect$3(f(s, input)), flatMap$3(s => foldChunksEffectReader(s, contFn, f))),
    onFailure: fail$6,
    onDone: () => succeedNow(s)
  });
};

/** @internal */
const foldEffect = (s, contFn, f) => suspend$3(() => new SinkImpl(foldEffectReader(s, contFn, f)));

/** @internal */
const foldEffectReader = (s, contFn, f) => {
  if (!contFn(s)) {
    return succeedNow(s);
  }
  return readWith({
    onInput: input => pipe(fromEffect$3(foldChunkSplitEffect(s, input, contFn, f)), flatMap$3(([nextS, leftovers]) => pipe(leftovers, match$j({
      onNone: () => foldEffectReader(nextS, contFn, f),
      onSome: leftover => pipe(write(leftover), as$3(nextS))
    })))),
    onFailure: fail$6,
    onDone: () => succeedNow(s)
  });
};

/** @internal */
const foldChunkSplitEffect = (s, chunk, contFn, f) => foldChunkSplitEffectInternal(s, chunk, 0, chunk.length, contFn, f);

/** @internal */
const foldChunkSplitEffectInternal = (s, chunk, index, length, contFn, f) => {
  if (index === length) {
    return succeed$7([s, none$8()]);
  }
  return pipe(f(s, pipe(chunk, unsafeGet$5(index))), flatMap$4(s1 => contFn(s1) ? foldChunkSplitEffectInternal(s1, chunk, index + 1, length, contFn, f) : succeed$7([s1, some$6(pipe(chunk, drop$2(index + 1)))])));
};

/** @internal */
const foldLeft = (s, f) => ignoreLeftover(fold(s, constTrue, f));

/** @internal */
const foldLeftChunks = (s, f) => foldChunks(s, constTrue, f);

/** @internal */
const foldLeftChunksEffect = (s, f) => ignoreLeftover(foldChunksEffect(s, constTrue, f));

/** @internal */
const foldLeftEffect = (s, f) => foldEffect(s, constTrue, f);

/** @internal */
const foldUntil = (s, max, f) => pipe(fold([s, 0], tuple => tuple[1] < max, ([output, count], input) => [f(output, input), count + 1]), map$4(tuple => tuple[0]));

/** @internal */
const foldUntilEffect = (s, max, f) => pipe(foldEffect([s, 0], tuple => tuple[1] < max, ([output, count], input) => pipe(f(output, input), map$6(s => [s, count + 1]))), map$4(tuple => tuple[0]));

/** @internal */
const foldWeighted = options => foldWeightedDecompose({
  ...options,
  decompose: of$3
});

/** @internal */
const foldWeightedDecompose = options => suspend$3(() => new SinkImpl(foldWeightedDecomposeLoop(options.initial, 0, false, options.maxCost, options.cost, options.decompose, options.body)));

/** @internal */
const foldWeightedDecomposeLoop = (s, cost, dirty, max, costFn, decompose, f) => readWith({
  onInput: input => {
    const [nextS, nextCost, nextDirty, leftovers] = foldWeightedDecomposeFold(input, 0, s, cost, dirty, max, costFn, decompose, f);
    if (isNonEmpty$5(leftovers)) {
      return pipe(write(leftovers), zipRight$3(succeedNow(nextS)));
    }
    if (cost > max) {
      return succeedNow(nextS);
    }
    return foldWeightedDecomposeLoop(nextS, nextCost, nextDirty, max, costFn, decompose, f);
  },
  onFailure: fail$6,
  onDone: () => succeedNow(s)
});

/** @internal */
const foldWeightedDecomposeFold = (input, index, s, cost, dirty, max, costFn, decompose, f) => {
  if (index === input.length) {
    return [s, cost, dirty, empty$z()];
  }
  const elem = pipe(input, unsafeGet$5(index));
  const total = cost + costFn(s, elem);
  if (total <= max) {
    return foldWeightedDecomposeFold(input, index + 1, f(s, elem), total, true, max, costFn, decompose, f);
  }
  const decomposed = decompose(elem);
  if (decomposed.length <= 1 && !dirty) {
    // If `elem` cannot be decomposed, we need to cross the `max` threshold. To
    // minimize "injury", we only allow this when we haven't added anything else
    // to the aggregate (dirty = false).
    return [f(s, elem), total, true, pipe(input, drop$2(index + 1))];
  }
  if (decomposed.length <= 1 && dirty) {
    // If the state is dirty and `elem` cannot be decomposed, we stop folding
    // and include `elem` in the leftovers.
    return [s, cost, dirty, pipe(input, drop$2(index))];
  }
  // `elem` got decomposed, so we will recurse with the decomposed elements pushed
  // into the chunk we're processing and see if we can aggregate further.
  const next = pipe(decomposed, appendAll$1(pipe(input, drop$2(index + 1))));
  return foldWeightedDecomposeFold(next, 0, s, cost, dirty, max, costFn, decompose, f);
};

/** @internal */
const foldWeightedDecomposeEffect = options => suspend$3(() => new SinkImpl(foldWeightedDecomposeEffectLoop(options.initial, options.maxCost, options.cost, options.decompose, options.body, 0, false)));

/** @internal */
const foldWeightedEffect = options => foldWeightedDecomposeEffect({
  ...options,
  decompose: input => succeed$7(of$3(input))
});

/** @internal */
const foldWeightedDecomposeEffectLoop = (s, max, costFn, decompose, f, cost, dirty) => readWith({
  onInput: input => pipe(fromEffect$3(foldWeightedDecomposeEffectFold(s, max, costFn, decompose, f, input, dirty, cost, 0)), flatMap$3(([nextS, nextCost, nextDirty, leftovers]) => {
    if (isNonEmpty$5(leftovers)) {
      return pipe(write(leftovers), zipRight$3(succeedNow(nextS)));
    }
    if (cost > max) {
      return succeedNow(nextS);
    }
    return foldWeightedDecomposeEffectLoop(nextS, max, costFn, decompose, f, nextCost, nextDirty);
  })),
  onFailure: fail$6,
  onDone: () => succeedNow(s)
});

/** @internal */
const foldWeightedDecomposeEffectFold = (s, max, costFn, decompose, f, input, dirty, cost, index) => {
  if (index === input.length) {
    return succeed$7([s, cost, dirty, empty$z()]);
  }
  const elem = pipe(input, unsafeGet$5(index));
  return pipe(costFn(s, elem), map$6(newCost => cost + newCost), flatMap$4(total => {
    if (total <= max) {
      return pipe(f(s, elem), flatMap$4(s => foldWeightedDecomposeEffectFold(s, max, costFn, decompose, f, input, true, total, index + 1)));
    }
    return pipe(decompose(elem), flatMap$4(decomposed => {
      if (decomposed.length <= 1 && !dirty) {
        // If `elem` cannot be decomposed, we need to cross the `max` threshold. To
        // minimize "injury", we only allow this when we haven't added anything else
        // to the aggregate (dirty = false).
        return pipe(f(s, elem), map$6(s => [s, total, true, pipe(input, drop$2(index + 1))]));
      }
      if (decomposed.length <= 1 && dirty) {
        // If the state is dirty and `elem` cannot be decomposed, we stop folding
        // and include `elem` in th leftovers.
        return succeed$7([s, cost, dirty, pipe(input, drop$2(index))]);
      }
      // `elem` got decomposed, so we will recurse with the decomposed elements pushed
      // into the chunk we're processing and see if we can aggregate further.
      const next = pipe(decomposed, appendAll$1(pipe(input, drop$2(index + 1))));
      return foldWeightedDecomposeEffectFold(s, max, costFn, decompose, f, next, dirty, cost, 0);
    }));
  }));
};

/** @internal */
const flatMap$2 = /*#__PURE__*/dual(2, (self, f) => foldSink(self, {
  onFailure: fail$5,
  onSuccess: f
}));

/** @internal */
const forEach$5 = f => {
  const process = readWithCause({
    onInput: input => pipe(fromEffect$3(forEach$6(input, v => f(v), {
      discard: true
    })), flatMap$3(() => process)),
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  return new SinkImpl(process);
};

/** @internal */
const forEachChunk = f => {
  const process = readWithCause({
    onInput: input => pipe(fromEffect$3(f(input)), flatMap$3(() => process)),
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  return new SinkImpl(process);
};

/** @internal */
const forEachWhile = f => {
  const process = readWithCause({
    onInput: input => forEachWhileReader(f, input, 0, input.length, process),
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  return new SinkImpl(process);
};

/** @internal */
const forEachWhileReader = (f, input, index, length, cont) => {
  if (index === length) {
    return cont;
  }
  return pipe(fromEffect$3(f(pipe(input, unsafeGet$5(index)))), flatMap$3(bool => bool ? forEachWhileReader(f, input, index + 1, length, cont) : write(pipe(input, drop$2(index)))), catchAll$2(error => pipe(write(pipe(input, drop$2(index))), zipRight$3(fail$6(error)))));
};

/** @internal */
const forEachChunkWhile = f => {
  const reader = readWith({
    onInput: input => pipe(fromEffect$3(f(input)), flatMap$3(cont => cont ? reader : unit$2)),
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new SinkImpl(reader);
};

/** @internal */
const fromChannel$1 = channel => new SinkImpl(channel);

/** @internal */
const fromEffect$2 = effect => new SinkImpl(fromEffect$3(effect));

/** @internal */
const fromPubSub$1 = (pubsub, options) => fromQueue$1(pubsub, options);

/** @internal */
const fromPush = push => new SinkImpl(unwrapScoped$2(pipe(push, map$6(fromPushPull))));
const fromPushPull = push => readWith({
  onInput: input => foldChannel(fromEffect$3(push(some$6(input))), {
    onFailure: ([either, leftovers]) => match$i(either, {
      onLeft: error => pipe(write(leftovers), zipRight$3(fail$6(error))),
      onRight: z => pipe(write(leftovers), zipRight$3(succeedNow(z)))
    }),
    onSuccess: () => fromPushPull(push)
  }),
  onFailure: fail$6,
  onDone: () => foldChannel(fromEffect$3(push(none$8())), {
    onFailure: ([either, leftovers]) => match$i(either, {
      onLeft: error => pipe(write(leftovers), zipRight$3(fail$6(error))),
      onRight: z => pipe(write(leftovers), zipRight$3(succeedNow(z)))
    }),
    onSuccess: () => fromEffect$3(dieMessage$4("BUG: Sink.fromPush - please report an issue at https://github.com/Effect-TS/stream/issues"))
  })
});

/** @internal */
const fromQueue$1 = (queue, options) => options?.shutdown ? unwrapScoped$1(map$6(acquireRelease$1(succeed$7(queue), shutdown$2), fromQueue$1)) : forEachChunk(input => pipe(offerAll$2(queue, input)));

/** @internal */
const head$1 = () => fold(none$8(), isNone$1, (option, input) => match$j(option, {
  onNone: () => some$6(input),
  onSome: () => option
}));

/** @internal */
const ignoreLeftover = self => new SinkImpl(drain$2(toChannel$1(self)));

/** @internal */
const last = () => foldLeftChunks(none$8(), (s, input) => orElse$b(last$2(input), () => s));

/** @internal */
const leftover = chunk => new SinkImpl(suspend$4(() => write(chunk)));

/** @internal */
const map$4 = /*#__PURE__*/dual(2, (self, f) => {
  return new SinkImpl(pipe(toChannel$1(self), map$5(f)));
});

/** @internal */
const mapEffect = /*#__PURE__*/dual(2, (self, f) => new SinkImpl(pipe(toChannel$1(self), mapEffect$1(f))));

/** @internal */
const mapError$2 = /*#__PURE__*/dual(2, (self, f) => new SinkImpl(pipe(toChannel$1(self), mapError$3(f))));

/** @internal */
const mapLeftover = /*#__PURE__*/dual(2, (self, f) => new SinkImpl(pipe(toChannel$1(self), mapOut(map$l(f)))));

/** @internal */
const never$2 = /*#__PURE__*/fromEffect$2(never$4);

/** @internal */
const orElse$3 = /*#__PURE__*/dual(2, (self, that) => new SinkImpl(pipe(toChannel$1(self), orElse$4(() => toChannel$1(that())))));

/** @internal */
const provideContext$3 = /*#__PURE__*/dual(2, (self, context) => new SinkImpl(pipe(toChannel$1(self), provideContext$4(context))));

/** @internal */
const race$1 = /*#__PURE__*/dual(2, (self, that) => pipe(self, raceBoth(that), map$4(merge$a)));

/** @internal */
const raceBoth = /*#__PURE__*/dual(args => isSink(args[1]), (self, that, options) => raceWith(self, {
  other: that,
  onSelfDone: selfDone => Done$1(map$6(selfDone, left)),
  onOtherDone: thatDone => Done$1(map$6(thatDone, right)),
  capacity: options?.capacity ?? 16
}));

/** @internal */
const raceWith = /*#__PURE__*/dual(2, (self, options) => {
  const scoped = gen$1(function* ($) {
    const pubsub = yield* $(bounded$3(options?.capacity ?? 16));
    const channel1 = yield* $(fromPubSubScoped(pubsub));
    const channel2 = yield* $(fromPubSubScoped(pubsub));
    const reader = toPubSub$1(pubsub);
    const writer = pipe(channel1, pipeTo(toChannel$1(self)), mergeWith$1({
      other: pipe(channel2, pipeTo(toChannel$1(options.other))),
      onSelfDone: options.onSelfDone,
      onOtherDone: options.onOtherDone
    }));
    const racedChannel = mergeWith$1(reader, {
      other: writer,
      onSelfDone: _ => Await$1(exit => suspend$5(() => exit)),
      onOtherDone: done => Done$1(suspend$5(() => done))
    });
    return new SinkImpl(racedChannel);
  });
  return unwrapScoped$1(scoped);
});

/** @internal */
const refineOrDie$2 = /*#__PURE__*/dual(2, (self, pf) => pipe(self, refineOrDieWith$2(pf, identity$1)));

/** @internal */
const refineOrDieWith$2 = /*#__PURE__*/dual(3, (self, pf, f) => {
  const newChannel = pipe(self, toChannel$1, catchAll$2(error => match$j(pf(error), {
    onNone: () => failCauseSync$2(() => die$7(f(error))),
    onSome: fail$6
  })));
  return new SinkImpl(newChannel);
});

/** @internal */
const some$3 = predicate => fold(false, bool => !bool, (acc, input) => acc || predicate(input));

/** @internal */
const splitWhere = /*#__PURE__*/dual(2, (self, f) => {
  const newChannel = pipe(fromEffect$3(make$G(empty$z())), flatMap$3(ref => pipe(splitWhereSplitter(false, ref, f), pipeToOrFail(toChannel$1(self)), collectElements, flatMap$3(([leftovers, z]) => pipe(fromEffect$3(get$b(ref)), flatMap$3(leftover => pipe(write(pipe(leftover, appendAll$1(flatten$9(leftovers)))), zipRight$3(succeed$6(z)))))))));
  return new SinkImpl(newChannel);
});

/** @internal */
const splitWhereSplitter = (written, leftovers, f) => readWithCause({
  onInput: input => {
    if (isEmpty$h(input)) {
      return splitWhereSplitter(written, leftovers, f);
    }
    if (written) {
      const index = indexWhere(input, f);
      if (index === -1) {
        return zipRight$3(write(input), splitWhereSplitter(true, leftovers, f));
      }
      const [left, right] = splitAt(input, index);
      return zipRight$3(write(left), fromEffect$3(set$6(leftovers, right)));
    }
    const index = indexWhere(input, f, 1);
    if (index === -1) {
      return zipRight$3(write(input), splitWhereSplitter(true, leftovers, f));
    }
    const [left, right] = pipe(input, splitAt(Math.max(index, 1)));
    return zipRight$3(write(left), fromEffect$3(set$6(leftovers, right)));
  },
  onFailure: failCause$4,
  onDone: succeed$6
});

/** @internal */
const indexWhere = (self, predicate, from = 0) => {
  const iterator = self[Symbol.iterator]();
  let index = 0;
  let result = -1;
  let next;
  while (result < 0 && (next = iterator.next()) && !next.done) {
    const a = next.value;
    if (index >= from && predicate(a)) {
      result = index;
    }
    index = index + 1;
  }
  return result;
};

/** @internal */
const succeed$5 = z => new SinkImpl(succeed$6(z));

/** @internal */
const sum = /*#__PURE__*/foldLeftChunks(0, (acc, chunk) => acc + reduce$h(chunk, 0, (s, a) => s + a));

/** @internal */
const summarized$1 = /*#__PURE__*/dual(3, (self, summary, f) => {
  const newChannel = pipe(fromEffect$3(summary), flatMap$3(start => pipe(self, toChannel$1, flatMap$3(done => pipe(fromEffect$3(summary), map$5(end => [done, f(start, end)]))))));
  return new SinkImpl(newChannel);
});

/** @internal */
const sync$2 = evaluate => new SinkImpl(sync$3(evaluate));

/** @internal */
const take$4 = n => pipe(foldChunks(empty$z(), chunk => chunk.length < n, (acc, chunk) => pipe(acc, appendAll$1(chunk))), flatMap$2(acc => {
  const [taken, leftover] = pipe(acc, splitAt(n));
  return new SinkImpl(pipe(write(leftover), zipRight$3(succeedNow(taken))));
}));

/** @internal */
const toChannel$1 = self => isEffect(self) ? toChannel$1(fromEffect$2(self)) : self.channel;

/** @internal */
const unwrap$1 = effect => new SinkImpl(unwrap$2(pipe(effect, map$6(sink => toChannel$1(sink)))));

/** @internal */
const unwrapScoped$1 = effect => {
  return new SinkImpl(unwrapScoped$2(pipe(effect, map$6(sink => toChannel$1(sink)))));
};

/** @internal */
const withDuration = self => pipe(self, summarized$1(currentTimeMillis, (start, end) => millis(end - start)));

/** @internal */
const zip$3 = /*#__PURE__*/dual(args => isSink(args[1]), (self, that, options) => zipWith$2(self, that, (z, z2) => [z, z2], options));

/** @internal */
const zipLeft$2 = /*#__PURE__*/dual(args => isSink(args[1]), (self, that, options) => zipWith$2(self, that, (z, _) => z, options));

/** @internal */
const zipRight$2 = /*#__PURE__*/dual(args => isSink(args[1]), (self, that, options) => zipWith$2(self, that, (_, z2) => z2, options));

/** @internal */
const zipWith$2 = /*#__PURE__*/dual(args => isSink(args[1]), (self, that, f, options) => options?.concurrent ? raceWith(self, {
  other: that,
  onSelfDone: match$f({
    onFailure: cause => Done$1(failCause$5(cause)),
    onSuccess: leftZ => Await$1(match$f({
      onFailure: failCause$5,
      onSuccess: rightZ => succeed$7(f(leftZ, rightZ))
    }))
  }),
  onOtherDone: match$f({
    onFailure: cause => Done$1(failCause$5(cause)),
    onSuccess: rightZ => Await$1(match$f({
      onFailure: failCause$5,
      onSuccess: leftZ => succeed$7(f(leftZ, rightZ))
    }))
  })
}) : flatMap$2(self, z => map$4(that, z2 => f(z, z2))));

// Circular with Channel

/** @internal */
const channelToSink = self => new SinkImpl(self);

// Constants

/** @internal */
const count$2 = /*#__PURE__*/foldLeftChunks(0, (acc, chunk) => acc + chunk.length);

/** @internal */
const mkString$1 = /*#__PURE__*/suspend$3(() => {
  const strings = [];
  return pipe(foldLeftChunks(void 0, (_, elems) => map$l(elems, elem => {
    strings.push(String(elem));
  })), map$4(() => strings.join("")));
});

/** @internal */
const timed = /*#__PURE__*/pipe( /*#__PURE__*/withDuration(drain$1), /*#__PURE__*/map$4(tuple => tuple[1]));

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
MergeDecisionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const Done = Done$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const Await = Await$1;

/**
 * @since 2.0.0
 * @category constructors
 */
AwaitConst;

/**
 * Returns `true` if the specified value is a `MergeDecision`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isMergeDecision;

/**
 * @since 2.0.0
 * @category folding
 */
match$5;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * Executes the effect using the provided Scheduler or using the global
 * Scheduler if not provided
 *
 * @since 2.0.0
 * @category execution
 */
unsafeFork;

/**
 * Executes the effect synchronously returning the exit.
 *
 * This method is effectful and should only be invoked at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
unsafeRunSyncExit;

/**
 * Executes the effect synchronously throwing in case of errors or async boundaries.
 *
 * This method is effectful and should only be invoked at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
unsafeRunSync;

/**
 * Executes the effect asynchronously, eventually passing the exit value to
 * the specified callback.
 *
 * This method is effectful and should only be invoked at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
unsafeRunCallback;

/**
 * Runs the `Effect`, returning a JavaScript `Promise` that will be resolved
 * with the value of the effect once the effect has been executed, or will be
 * rejected with the first error or exception throw by the effect.
 *
 * This method is effectful and should only be used at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
unsafeRunPromise;

/**
 * Runs the `Effect`, returning a JavaScript `Promise` that will be resolved
 * with the `Exit` state of the effect once the effect has been executed.
 *
 * This method is effectful and should only be used at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
const runPromiseExit = unsafeRunPromiseExit;

/**
 * @since 2.0.0
 * @category constructors
 */
defaultRuntime;

/**
 * @since 2.0.0
 * @category constructors
 */
defaultRuntimeFlags;

/**
 * @since 2.0.0
 * @category constructors
 */
make$v;
/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
FiberFailureCauseId;

/**
 * @since 2.0.0
 * @category exports
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category guards
 */
isAsyncFiberException;

/**
 * @since 2.0.0
 * @category guards
 */
isFiberFailure;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberFailure;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ScheduleTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
ScheduleDriverTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Schedule<Env, In, Out>` defines a recurring schedule, which consumes
 * values of type `In`, and which returns values of type `Out`.
 *
 * Schedules are defined as a possibly infinite set of intervals spread out over
 * time. Each interval defines a window in which recurrence is possible.
 *
 * When schedules are used to repeat or retry effects, the starting boundary of
 * each interval produced by a schedule is used as the moment when the effect
 * will be executed again.
 *
 * Schedules compose in the following primary ways:
 *
 * - Union: performs the union of the intervals of two schedules
 * - Intersection: performs the intersection of the intervals of two schedules
 * - Sequence: concatenates the intervals of one schedule onto another
 *
 * In addition, schedule inputs and outputs can be transformed, filtered (to
 * terminate a schedule early in response to some input or output), and so
 * forth.
 *
 * A variety of other operators exist for transforming and combining schedules,
 * and the companion object for `Schedule` contains all common types of
 * schedules, both for performing retrying, as well as performing repetition.
 *
 * @category model
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new `Schedule` with the specified `initial` state and the
 * specified `step` function.
 *
 * @since 2.0.0
 * @category constructors
 */
makeWithState;

/**
 * Returns a new schedule with the given delay added to every interval defined
 * by this schedule.
 *
 * @since 2.0.0
 * @category utils
 */
addDelay;

/**
 * Returns a new schedule with the given effectfully computed delay added to
 * every interval defined by this schedule.
 *
 * @since 2.0.0
 * @category utils
 */
addDelayEffect;

/**
 * The same as `andThenEither`, but merges the output.
 *
 * @since 2.0.0
 * @category sequencing
 */
andThen;

/**
 * Returns a new schedule that first executes this schedule to completion, and
 * then executes the specified schedule to completion.
 *
 * @since 2.0.0
 * @category sequencing
 */
andThenEither;

/**
 * Returns a new schedule that maps this schedule to a constant output.
 *
 * @since 2.0.0
 * @category mapping
 */
as$5;

/**
 * Returns a new schedule that maps the output of this schedule to unit.
 *
 * @since 2.0.0
 * @category constructors
 */
asUnit$3;

/**
 * Returns a new schedule that has both the inputs and outputs of this and the
 * specified schedule.
 *
 * @since 2.0.0
 * @category utils
 */
bothInOut;

/**
 * Returns a new schedule that passes each input and output of this schedule
 * to the specified function, and then determines whether or not to continue
 * based on the return value of the function.
 *
 * @since 2.0.0
 * @category utils
 */
check$1;

/**
 * Returns a new schedule that passes each input and output of this schedule
 * to the specified function, and then determines whether or not to continue
 * based on the return value of the function.
 *
 * @since 2.0.0
 * @category utils
 */
checkEffect;

/**
 * A schedule that recurs anywhere, collecting all inputs into a `Chunk`.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllInputs;

/**
 * Returns a new schedule that collects the outputs of this one into a chunk.
 *
 * @since 2.0.0
 * @category utils
 */
collectAllOutputs;

/**
 * A schedule that recurs until the condition f fails, collecting all inputs
 * into a list.
 *
 * @since 2.0.0
 * @category utils
 */
collectUntil;

/**
 * A schedule that recurs until the effectful condition f fails, collecting
 * all inputs into a list.
 *
 * @since 2.0.0
 * @category utils
 */
collectUntilEffect;

/**
 * A schedule that recurs as long as the condition f holds, collecting all
 * inputs into a list.
 *
 * @since 2.0.0
 * @category utils
 */
collectWhile;

/**
 * A schedule that recurs as long as the effectful condition holds, collecting
 * all inputs into a list.
 *
 * @category utils
 * @since 2.0.0
 */
collectWhileEffect;

/**
 * Returns the composition of this schedule and the specified schedule, by
 * piping the output of this one into the input of the other. Effects
 * described by this schedule will always be executed before the effects
 * described by the second schedule.
 *
 * @since 2.0.0
 * @category utils
 */
compose$1;

/**
 * Returns a new schedule that deals with a narrower class of inputs than this
 * schedule.
 *
 * @since 2.0.0
 * @category mapping
 */
mapInput$2;

/**
 * Transforms the context being provided to this schedule with the
 * specified function.
 *
 * @since 2.0.0
 * @category context
 */
mapInputContext$5;

/**
 * Returns a new schedule that deals with a narrower class of inputs than this
 * schedule.
 *
 * @since 2.0.0
 * @category mapping
 */
mapInputEffect$2;

/**
 * A schedule that always recurs, which counts the number of recurrences.
 *
 * @since 2.0.0
 * @category constructors
 */
count$3;

/**
 * Cron-like schedule that recurs every specified `day` of month. Won't recur
 * on months containing less days than specified in `day` param.
 *
 * It triggers at zero hour of the day. Producing a count of repeats: 0, 1, 2.
 *
 * NOTE: `day` parameter is validated lazily. Must be in range 1...31.
 *
 * @since 2.0.0
 * @category constructors
 */
dayOfMonth;

/**
 * Cron-like schedule that recurs every specified `day` of each week. It
 * triggers at zero hour of the week. Producing a count of repeats: 0, 1, 2.
 *
 * NOTE: `day` parameter is validated lazily. Must be in range 1 (Monday)...7
 * (Sunday).
 *
 * @since 2.0.0
 * @category constructors
 */
dayOfWeek;

/**
 * Returns a new schedule with the specified effectfully computed delay added
 * before the start of each interval produced by this schedule.
 *
 * @since 2.0.0
 * @category utils
 */
delayed;

/**
 * Returns a new schedule with the specified effectfully computed delay added
 * before the start of each interval produced by this schedule.
 *
 * @since 2.0.0
 * @category constructors
 */
delayedEffect;

/**
 * Takes a schedule that produces a delay, and returns a new schedule that
 * uses this delay to further delay intervals in the resulting schedule.
 *
 * @since 2.0.0
 * @category constructors
 */
delayedSchedule;

/**
 * Returns a new schedule that outputs the delay between each occurence.
 *
 * @since 2.0.0
 * @category constructors
 */
delays;

/**
 * Returns a new schedule that maps both the input and output.
 *
 * @since 2.0.0
 * @category mapping
 */
mapBoth$3;

/**
 * Returns a new schedule that maps both the input and output.
 *
 * @since 2.0.0
 * @category mapping
 */
mapBothEffect;

/**
 * Returns a driver that can be used to step the schedule, appropriately
 * handling sleeping.
 *
 * @since 2.0.0
 * @category getter
 */
const driver = driver$1;

/**
 * A schedule that can recur one time, the specified amount of time into the
 * future.
 *
 * @since 2.0.0
 * @category constructors
 */
duration;

/**
 * Returns a new schedule that performs a geometric union on the intervals
 * defined by both schedules.
 *
 * @since 2.0.0
 * @category alternatives
 */
either$4;

/**
 * The same as `either` followed by `map`.
 *
 * @since 2.0.0
 * @category alternatives
 */
eitherWith$1;

/**
 * A schedule that occurs everywhere, which returns the total elapsed duration
 * since the first step.
 *
 * @since 2.0.0
 * @category constructors
 */
elapsed;

/**
 * Returns a new schedule that will run the specified finalizer as soon as the
 * schedule is complete. Note that unlike `Effect.ensuring`, this method does not
 * guarantee the finalizer will be run. The `Schedule` may not initialize or
 * the driver of the schedule may not run to completion. However, if the
 * `Schedule` ever decides not to continue, then the finalizer will be run.
 *
 * @since 2.0.0
 * @category finalization
 */
ensuring$5;

/**
 * A schedule that always recurs, but will wait a certain amount between
 * repetitions, given by `base * factor.pow(n)`, where `n` is the number of
 * repetitions so far. Returns the current duration between recurrences.
 *
 * @since 2.0.0
 * @category constructors
 */
exponential;

/**
 * A schedule that always recurs, increasing delays by summing the preceding
 * two delays (similar to the fibonacci sequence). Returns the current
 * duration between recurrences.
 *
 * @since 2.0.0
 * @category constructors
 */
fibonacci;

/**
 * A schedule that recurs on a fixed interval. Returns the number of
 * repetitions of the schedule so far.
 *
 * If the action run between updates takes longer than the interval, then the
 * action will be run immediately, but re-runs will not "pile up".
 *
 * ```
 * |-----interval-----|-----interval-----|-----interval-----|
 * |---------action--------||action|-----|action|-----------|
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
fixed;

/**
 * A schedule that always recurs, producing a count of repeats: 0, 1, 2.
 *
 * @since 2.0.0
 * @category constructors
 */
const forever$1 = forever$3;

/**
 * A schedule that recurs once with the specified delay.
 *
 * @since 2.0.0
 * @category constructors
 */
fromDelay;

/**
 * A schedule that recurs once for each of the specified durations, delaying
 * each time for the length of the specified duration. Returns the length of
 * the current duration between recurrences.
 *
 * @since 2.0.0
 * @category constructors
 */
fromDelays;

/**
 * A schedule that always recurs, mapping input values through the specified
 * function.
 *
 * @since 2.0.0
 * @category constructors
 */
fromFunction$2;

/**
 * Cron-like schedule that recurs every specified `hour` of each day. It
 * triggers at zero minute of the hour. Producing a count of repeats: 0, 1, 2.
 *
 * NOTE: `hour` parameter is validated lazily. Must be in range 0...23.
 *
 * @since 2.0.0
 * @category constructors
 */
hourOfDay;

/**
 * A schedule that always recurs, which returns inputs as outputs.
 *
 * @since 2.0.0
 * @category constructors
 */
identity;

/**
 * Returns a new schedule that performs a geometric intersection on the
 * intervals defined by both schedules.
 *
 * @since 2.0.0
 * @category utils
 */
intersect;

/**
 * Returns a new schedule that combines this schedule with the specified
 * schedule, continuing as long as both schedules want to continue and merging
 * the next intervals according to the specified merge function.
 *
 * @since 2.0.0
 * @category utils
 */
intersectWith;

/**
 * Returns a new schedule that randomly modifies the size of the intervals of
 * this schedule.
 *
 * Defaults `min` to `0.8` and `max` to `1.2`.
 *
 * The new interval size is between `min * old interval size` and `max * old
 * interval size`.
 *
 * @since 2.0.0
 * @category constructors
 */
jittered;

/**
 * Returns a new schedule that randomly modifies the size of the intervals of
 * this schedule.
 *
 * The new interval size is between `min * old interval size` and `max * old
 * interval size`.
 *
 * @since 2.0.0
 * @category constructors
 */
jitteredWith;

/**
 * A schedule that always recurs, but will repeat on a linear time interval,
 * given by `base * n` where `n` is the number of repetitions so far. Returns
 * the current duration between recurrences.
 *
 * @since 2.0.0
 * @category constructors
 */
linear;

/**
 * Returns a new schedule that maps the output of this schedule through the
 * specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
map$8;

/**
 * Returns a new schedule that maps the output of this schedule through the
 * specified effectful function.
 *
 * @since 2.0.0
 * @category mapping
 */
mapEffect$2;

/**
 * Cron-like schedule that recurs every specified `minute` of each hour. It
 * triggers at zero second of the minute. Producing a count of repeats: 0, 1,
 * 2.
 *
 * NOTE: `minute` parameter is validated lazily. Must be in range 0...59.
 *
 * @since 2.0.0
 * @category constructors
 */
minuteOfHour;

/**
 * Returns a new schedule that modifies the delay using the specified
 * function.
 *
 * @since 2.0.0
 * @category utils
 */
modifyDelay;

/**
 * Returns a new schedule that modifies the delay using the specified
 * effectual function.
 *
 * @since 2.0.0
 * @category utils
 */
modifyDelayEffect;

/**
 * Returns a new schedule that applies the current one but runs the specified
 * effect for every decision of this schedule. This can be used to create
 * schedules that log failures, decisions, or computed values.
 *
 * @since 2.0.0
 * @category utils
 */
onDecision;

/**
 * A schedule that recurs one time.
 *
 * @since 2.0.0
 * @category constructors
 */
once$1;

/**
 * Returns a new schedule that passes through the inputs of this schedule.
 *
 * @since 2.0.0
 * @category utils
 */
passthrough$1;

/**
 * Returns a new schedule with its context provided to it, so the
 * resulting schedule does not require any context.
 *
 * @since 2.0.0
 * @category context
 */
provideContext$5;

/**
 * Returns a new schedule with the single service it requires provided to it.
 * If the schedule requires multiple services use `provideContext`
 * instead.
 *
 * @since 2.0.0
 * @category context
 */
provideService$4;

/**
 * A schedule that recurs for until the predicate evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
recurUntil;

/**
 * A schedule that recurs for until the predicate evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
recurUntilEffect;

/**
 * A schedule that recurs for until the input value becomes applicable to
 * partial function and then map that value with given function.
 *
 * @since 2.0.0
 * @category utils
 */
recurUntilOption;

/**
 * A schedule that recurs during the given duration.
 *
 * @since 2.0.0
 * @category utils
 */
recurUpTo;

/**
 * A schedule that recurs for as long as the predicate evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
recurWhile;

/**
 * A schedule that recurs for as long as the effectful predicate evaluates to
 * true.
 *
 * @since 2.0.0
 * @category utils
 */
recurWhileEffect;

/**
 * A schedule spanning all time, which can be stepped only the specified
 * number of times before it terminates.
 *
 * @category constructors
 * @since 2.0.0
 */
recurs;

/**
 * Returns a new schedule that folds over the outputs of this one.
 *
 * @since 2.0.0
 * @category folding
 */
reduce$6;

/**
 * Returns a new schedule that effectfully folds over the outputs of this one.
 *
 * @since 2.0.0
 * @category folding
 */
reduceEffect$1;

/**
 * Returns a new schedule that loops this one continuously, resetting the
 * state when this schedule is done.
 *
 * @since 2.0.0
 * @category constructors
 */
forever$3;

/**
 * Returns a new schedule that outputs the number of repetitions of this one.
 *
 * @since 2.0.0
 * @category utils
 */
repetitions;

/**
 * Return a new schedule that automatically resets the schedule to its initial
 * state after some time of inactivity defined by `duration`.
 *
 * @since 2.0.0
 * @category utils
 */
resetAfter;

/**
 * Resets the schedule when the specified predicate on the schedule output
 * evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
resetWhen;

/**
 * Runs a schedule using the provided inputs, and collects all outputs.
 *
 * @since 2.0.0
 * @category destructors
 */
run$3;

/**
 * Cron-like schedule that recurs every specified `second` of each minute. It
 * triggers at zero nanosecond of the second. Producing a count of repeats: 0,
 * 1, 2.
 *
 * NOTE: `second` parameter is validated lazily. Must be in range 0...59.
 *
 * @since 2.0.0
 * @category constructors
 */
secondOfMinute;

/**
 * Returns a schedule that recurs continuously, each repetition spaced the
 * specified duration from the last run.
 *
 * @since 2.0.0
 * @category constructors
 */
const spaced = spaced$1;

/**
 * A schedule that does not recur, it just stops.
 *
 * @since 2.0.0
 * @category constructors
 */
stop;

/**
 * Returns a schedule that repeats one time, producing the specified constant
 * value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$9;

/**
 * Returns a schedule that repeats one time, producing the specified constant
 * value.
 *
 * @category constructors
 * @since 2.0.0
 */
sync$6;

/**
 * Returns a new schedule that effectfully processes every input to this
 * schedule.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapInput;

/**
 * Returns a new schedule that effectfully processes every output from this
 * schedule.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapOutput;

/**
 * Unfolds a schedule that repeats one time from the specified state and
 * iterator.
 *
 * @since 2.0.0
 * @category constructors
 */
unfold$1;

/**
 * Returns a new schedule that performs a geometric union on the intervals
 * defined by both schedules.
 *
 * @since 2.0.0
 * @category utils
 */
union$1;

/**
 * Returns a new schedule that combines this schedule with the specified
 * schedule, continuing as long as either schedule wants to continue and
 * merging the next intervals according to the specified merge function.
 *
 * @since 2.0.0
 * @category utils
 */
unionWith;

/**
 * Returns a new schedule that continues until the specified predicate on the
 * input evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
untilInput;

/**
 * Returns a new schedule that continues until the specified effectful
 * predicate on the input evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
untilInputEffect;

/**
 * Returns a new schedule that continues until the specified predicate on the
 * output evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
untilOutput;

/**
 * Returns a new schedule that continues until the specified effectful
 * predicate on the output evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
untilOutputEffect;

/**
 * A schedule that recurs during the given duration.
 *
 * @since 2.0.0
 * @category utils
 */
upTo;

/**
 * Returns a new schedule that continues for as long the specified predicate
 * on the input evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
whileInput;

/**
 * Returns a new schedule that continues for as long the specified effectful
 * predicate on the input evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
whileInputEffect;

/**
 * Returns a new schedule that continues for as long the specified predicate
 * on the output evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
whileOutput;

/**
 * Returns a new schedule that continues for as long the specified effectful
 * predicate on the output evaluates to true.
 *
 * @since 2.0.0
 * @category utils
 */
whileOutputEffect;

/**
 * A schedule that divides the timeline to `interval`-long windows, and sleeps
 * until the nearest window boundary every time it recurs.
 *
 * For example, `windowed(Duration.seconds(10))` would produce a schedule as
 * follows:
 *
 * ```
 *      10s        10s        10s       10s
 * |----------|----------|----------|----------|
 * |action------|sleep---|act|-sleep|action----|
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
windowed;

/**
 * The same as `intersect` but ignores the right output.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLeft$5;

/**
 * The same as `intersect` but ignores the left output.
 *
 * @since 2.0.0
 * @category zipping
 */
zipRight$5;

/**
 * Equivalent to `intersect` followed by `map`.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWith$4;

/** @internal */
const OP_LEFT = "Left";

/** @internal */

/** @internal */
const OP_RIGHT = "Right";

/** @internal */

/** @internal */
const OP_BOTH = "Both";

/** @internal */

/** @internal */
const OP_EITHER = "Either";

/** @internal */
const Left = {
  _tag: OP_LEFT
};

/** @internal */
const Right = {
  _tag: OP_RIGHT
};

/** @internal */
const Both$1 = {
  _tag: OP_BOTH
};

/** @internal */
const Either = {
  _tag: OP_EITHER
};

/** @internal */
const fromInput = input => {
  switch (input) {
    case "left":
      return Left;
    case "right":
      return Right;
    case "both":
      return Both$1;
    case "either":
      return Either;
    default:
      return input;
  }
};

/** @internal */
const isLeft = self => self._tag === OP_LEFT;

/** @internal */
const isRight = self => self._tag === OP_RIGHT;

/** @internal */
const isBoth = self => self._tag === OP_BOTH;

/** @internal */
const isEither = self => self._tag === OP_EITHER;

/** @internal */
const match$2 = /*#__PURE__*/dual(5, (self, onLeft, onRight, onBoth, onEither) => {
  switch (self._tag) {
    case OP_LEFT:
      {
        return onLeft();
      }
    case OP_RIGHT:
      {
        return onRight();
      }
    case OP_BOTH:
      {
        return onBoth();
      }
    case OP_EITHER:
      {
        return onEither();
      }
  }
});

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
Left;

/**
 * @since 2.0.0
 * @category constructors
 */
Right;

/**
 * @since 2.0.0
 * @category constructors
 */
const Both = Both$1;

/**
 * @since 2.0.0
 * @category constructors
 */
Either;

/**
 * @since 2.0.0
 * @category constructors
 */
fromInput;

/**
 * @since 2.0.0
 * @category refinements
 */
isLeft;

/**
 * @since 2.0.0
 * @category refinements
 */
isRight;

/**
 * @since 2.0.0
 * @category refinements
 */
isBoth;

/**
 * @since 2.0.0
 * @category refinements
 */
isEither;

/**
 * @since 2.0.0
 * @category folding
 */
match$2;

/** @internal */
class RingBuffer {
  size = 0;
  current = 0;
  constructor(capacity) {
    this.capacity = capacity;
    this.array = Array.from({
      length: capacity
    }, constUndefined);
  }
  head() {
    return fromNullable$2(this.array[this.current]);
  }
  lastOrNull() {
    if (this.size === 0) {
      return undefined;
    }
    const index = this.current === 0 ? this.array.length - 1 : this.current - 1;
    return this.array[index] ?? undefined;
  }
  put(value) {
    this.array[this.current] = value;
    this.increment();
  }
  dropLast() {
    if (this.size > 0) {
      this.decrement();
      this.array[this.current] = undefined;
    }
  }
  toChunk() {
    const begin = this.current - this.size;
    const newArray = begin < 0 ? [...this.array.slice(this.capacity + begin, this.capacity), ...this.array.slice(0, this.current)] : this.array.slice(begin, this.current);
    return fromIterable$b(newArray);
  }
  increment() {
    if (this.size < this.capacity) {
      this.size += 1;
    }
    this.current = (this.current + 1) % this.capacity;
  }
  decrement() {
    this.size -= 1;
    if (this.current > 0) {
      this.current -= 1;
    } else {
      this.current = this.capacity - 1;
    }
  }
}

/** @internal */

/** @internal */
const OP_NOT_STARTED = "NotStarted";

/** @internal */

/** @internal */
const OP_PREVIOUS = "Previous";

/** @internal */

/** @internal */
const OP_CURRENT = "Current";

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const notStarted = {
  _tag: OP_NOT_STARTED
};

/** @internal */
const previous = fiber => ({
  _tag: OP_PREVIOUS,
  fiber
});

/** @internal */
const current = fiber => ({
  _tag: OP_CURRENT,
  fiber
});

/** @internal */
const make$r = emit => {
  const ops = {
    chunk(as) {
      return this(succeed$7(as));
    },
    die(defect) {
      return this(die$5(defect));
    },
    dieMessage(message) {
      return this(dieMessage$4(message));
    },
    done(exit) {
      return this(suspend$5(() => mapBoth$4(exit, {
        onFailure: some$6,
        onSuccess: of$3
      })));
    },
    end() {
      return this(fail$7(none$8()));
    },
    fail(e) {
      return this(fail$7(some$6(e)));
    },
    fromEffect(effect) {
      return this(mapBoth$2(effect, {
        onFailure: some$6,
        onSuccess: of$3
      }));
    },
    fromEffectChunk(effect) {
      return this(pipe(effect, mapError$4(some$6)));
    },
    halt(cause) {
      return this(failCause$5(pipe(cause, map$9(some$6))));
    },
    single(value) {
      return this(succeed$7(of$3(value)));
    }
  };
  return Object.assign(emit, ops);
};

/** @internal */
const HandoffTypeId = /*#__PURE__*/Symbol.for("effect/Stream/Handoff");

/** @internal */

/**
 * A synchronous queue-like abstraction that allows a producer to offer an
 * element and wait for it to be taken, and allows a consumer to wait for an
 * element to be available.
 *
 * @internal
 */

/** @internal */
const OP_HANDOFF_STATE_EMPTY = "Empty";

/** @internal */

/** @internal */
const OP_HANDOFF_STATE_FULL = "Full";

/** @internal */

/** @internal */

/** @internal */
const handoffStateEmpty = notifyConsumer => ({
  _tag: OP_HANDOFF_STATE_EMPTY,
  notifyConsumer
});

/** @internal */
const handoffStateFull = (value, notifyProducer) => ({
  _tag: OP_HANDOFF_STATE_FULL,
  value,
  notifyProducer
});

/** @internal */
const handoffStateMatch = (onEmpty, onFull) => {
  return self => {
    switch (self._tag) {
      case OP_HANDOFF_STATE_EMPTY:
        {
          return onEmpty(self.notifyConsumer);
        }
      case OP_HANDOFF_STATE_FULL:
        {
          return onFull(self.value, self.notifyProducer);
        }
    }
  };
};

/** @internal */
const handoffVariance = {
  _A: _ => _
};

/** @internal */
const make$q = () => pipe(make$R(), flatMap$4(deferred => make$G(handoffStateEmpty(deferred))), map$6(ref => ({
  [HandoffTypeId]: handoffVariance,
  ref
})));

/** @internal */
const offer$2 = /*#__PURE__*/dual(2, (self, value) => {
  return flatMap$4(make$R(), deferred => flatten$3(modify$3(self.ref, state => pipe(state, handoffStateMatch(notifyConsumer => [zipRight$4(succeed$g(notifyConsumer, void 0), _await$3(deferred)), handoffStateFull(value, deferred)], (_, notifyProducer) => [flatMap$4(_await$3(notifyProducer), () => pipe(self, offer$2(value))), state])))));
});

/** @internal */
const take$3 = self => flatMap$4(make$R(), deferred => flatten$3(modify$3(self.ref, state => pipe(state, handoffStateMatch(notifyConsumer => [flatMap$4(_await$3(notifyConsumer), () => take$3(self)), state], (value, notifyProducer) => [as$4(succeed$g(notifyProducer, void 0), value), handoffStateEmpty(deferred)])))));

/** @internal */

/** @internal */
const OP_EMIT = "Emit";

/** @internal */

/** @internal */
const OP_HALT = "Halt";

/** @internal */

/** @internal */
const OP_END = "End";

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const emit = elements => ({
  _tag: OP_EMIT,
  elements
});

/** @internal */
const halt = cause => ({
  _tag: OP_HALT,
  cause
});

/** @internal */
const end$2 = reason => ({
  _tag: OP_END,
  reason
});

/** @internal */
const end$1 = () => fail$7(none$8());

/** @internal */
const failCause$2 = cause => mapError$4(failCause$5(cause), some$6);

/** @internal */

/** @internal */
const OP_SCHEDULE_END = "ScheduleEnd";

/** @internal */

/** @internal */
const OP_UPSTREAM_END = "UpstreamEnd";

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const ScheduleEnd = {
  _tag: OP_SCHEDULE_END
};

/** @internal */
const UpstreamEnd = {
  _tag: OP_UPSTREAM_END
};

/** @internal */

/** @internal */
const OP_DRAIN_LEFT = "DrainLeft";

/** @internal */

/** @internal */
const OP_DRAIN_RIGHT = "DrainRight";

/** @internal */

/** @internal */
const OP_PULL_BOTH$1 = "PullBoth";

/** @internal */

/** @internal */
const OP_PULL_LEFT$1 = "PullLeft";

/** @internal */

/** @internal */
const OP_PULL_RIGHT$1 = "PullRight";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const DrainLeft = {
  _tag: OP_DRAIN_LEFT
};

/** @internal */
const DrainRight = {
  _tag: OP_DRAIN_RIGHT
};

/** @internal */
const PullBoth$1 = {
  _tag: OP_PULL_BOTH$1
};

/** @internal */
const PullLeft$1 = rightChunk => ({
  _tag: OP_PULL_LEFT$1,
  rightChunk
});

/** @internal */
const PullRight$1 = leftChunk => ({
  _tag: OP_PULL_RIGHT$1,
  leftChunk
});

/** @internal */

/** @internal */
const OP_PULL_BOTH = "PullBoth";

/** @internal */

/** @internal */
const OP_PULL_LEFT = "PullLet";

/** @internal */

/** @internal */
const OP_PULL_RIGHT = "PullRight";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const PullBoth = {
  _tag: OP_PULL_BOTH
};

/** @internal */
const PullLeft = rightChunk => ({
  _tag: OP_PULL_LEFT,
  rightChunk
});

/** @internal */
const PullRight = leftChunk => ({
  _tag: OP_PULL_RIGHT,
  leftChunk
});

/** @internal */
const TakeSymbolKey = "effect/Take";

/** @internal */
const TakeTypeId = /*#__PURE__*/Symbol.for(TakeSymbolKey);

/** @internal */
const takeVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */
class TakeImpl {
  [TakeTypeId] = takeVariance;
  constructor(exit) {
    this.exit = exit;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const chunk = chunk => new TakeImpl(succeed$f(chunk));

/** @internal */
const die$3 = defect => new TakeImpl(die$8(defect));

/** @internal */
const dieMessage$2 = message => new TakeImpl(die$8(RuntimeException(message)));

/** @internal */
const done$5 = self => suspend$5(() => self.exit);

/** @internal */
const end = /*#__PURE__*/new TakeImpl( /*#__PURE__*/fail$d( /*#__PURE__*/none$8()));

/** @internal */
const fail$4 = error => new TakeImpl(fail$d(some$6(error)));

/** @internal */
const failCause$1 = cause => new TakeImpl(failCause$8(pipe(cause, map$9(some$6))));

/** @internal */
const fromEffect$1 = effect => matchCause(effect, {
  onFailure: failCause$1,
  onSuccess: of
});

/** @internal */
const fromExit = exit => new TakeImpl(pipe(exit, mapBoth$4({
  onFailure: some$6,
  onSuccess: of$3
})));

/** @internal */
const fromPull$1 = pull => matchCause(pull, {
  onFailure: cause => match$j(flipCauseOption(cause), {
    onNone: () => end,
    onSome: failCause$1
  }),
  onSuccess: chunk
});

/** @internal */
const isDone$1 = self => match$f(self.exit, {
  onFailure: cause => isNone$1(flipCauseOption(cause)),
  onSuccess: constFalse
});

/** @internal */
const isFailure$2 = self => match$f(self.exit, {
  onFailure: cause => isSome(flipCauseOption(cause)),
  onSuccess: constFalse
});

/** @internal */
const isSuccess$2 = self => match$f(self.exit, {
  onFailure: constFalse,
  onSuccess: constTrue
});

/** @internal */
const make$p = exit => new TakeImpl(exit);

/** @internal */
const match$1 = /*#__PURE__*/dual(2, (self, {
  onEnd,
  onFailure,
  onSuccess
}) => match$f(self.exit, {
  onFailure: cause => match$j(flipCauseOption(cause), {
    onNone: onEnd,
    onSome: onFailure
  }),
  onSuccess
}));

/** @internal */
const matchEffect = /*#__PURE__*/dual(2, (self, {
  onEnd,
  onFailure,
  onSuccess
}) => matchEffect$2(self.exit, {
  onFailure: cause => match$j(flipCauseOption(cause), {
    onNone: onEnd,
    onSome: onFailure
  }),
  onSuccess
}));

/** @internal */
const map$3 = /*#__PURE__*/dual(2, (self, f) => new TakeImpl(pipe(self.exit, map$e(map$l(f)))));

/** @internal */
const of = value => new TakeImpl(succeed$f(of$3(value)));

/** @internal */
const tap$2 = /*#__PURE__*/dual(2, (self, f) => pipe(self.exit, forEachEffect(f), asUnit$2));

/** @internal */
const StreamSymbolKey = "effect/Stream";

/** @internal */
const StreamTypeId$1 = /*#__PURE__*/Symbol.for(StreamSymbolKey);

/** @internal */
const streamVariance = {
  _R: _ => _,
  _E: _ => _,
  _A: _ => _
};

/** @internal */
class StreamImpl {
  [StreamTypeId$1] = streamVariance;
  constructor(channel) {
    this.channel = channel;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const isStream = u => typeof u === "object" && u != null && StreamTypeId$1 in u || isEffect(u);

/** @internal */
const DefaultChunkSize = 4096;

/** @internal */
const acquireRelease = (acquire, release) => scoped(acquireRelease$1(acquire, release));

/** @internal */
const aggregate = /*#__PURE__*/dual(2, (self, sink) => aggregateWithin(self, sink, forever$1));

/** @internal */
const aggregateWithin = /*#__PURE__*/dual(3, (self, sink, schedule) => filterMap(aggregateWithinEither(self, sink, schedule), _ => match$i(_, {
  onLeft: none$8,
  onRight: some$6
})));

/** @internal */
const aggregateWithinEither = /*#__PURE__*/dual(3, (self, sink, schedule) => {
  const layer = all$1([make$q(), make$G(ScheduleEnd), make$G(empty$z()), driver(schedule), make$G(false), make$G(false)]);
  return pipe(fromEffect(layer), flatMap$1(([handoff, sinkEndReason, sinkLeftovers, scheduleDriver, consumed, endAfterEmit]) => {
    const handoffProducer = readWithCause({
      onInput: input => flatMap$3(fromEffect$3(pipe(handoff, offer$2(emit(input)), when$3(() => isNonEmpty$5(input)))), () => handoffProducer),
      onFailure: cause => fromEffect$3(offer$2(handoff, halt(cause))),
      onDone: () => fromEffect$3(offer$2(handoff, end$2(UpstreamEnd)))
    });
    const handoffConsumer = pipe(getAndSet$1(sinkLeftovers, empty$z()), flatMap$4(leftovers => {
      if (isNonEmpty$5(leftovers)) {
        return pipe(set$6(consumed, true), zipRight$4(succeed$7(pipe(write(leftovers), flatMap$3(() => handoffConsumer)))));
      }
      return pipe(take$3(handoff), map$6(signal => {
        switch (signal._tag) {
          case OP_EMIT:
            {
              return pipe(fromEffect$3(set$6(consumed, true)), zipRight$3(write(signal.elements)), zipRight$3(fromEffect$3(get$b(endAfterEmit))), flatMap$3(bool => bool ? unit$2 : handoffConsumer));
            }
          case OP_HALT:
            {
              return failCause$4(signal.cause);
            }
          case OP_END:
            {
              if (signal.reason._tag === OP_SCHEDULE_END) {
                return pipe(get$b(consumed), map$6(bool => bool ? fromEffect$3(pipe(set$6(sinkEndReason, ScheduleEnd), zipRight$4(set$6(endAfterEmit, true)))) : pipe(fromEffect$3(pipe(set$6(sinkEndReason, ScheduleEnd), zipRight$4(set$6(endAfterEmit, true)))), flatMap$3(() => handoffConsumer))), unwrap$2);
              }
              return pipe(set$6(sinkEndReason, signal.reason), zipRight$4(set$6(endAfterEmit, true)), fromEffect$3);
            }
        }
      }));
    }), unwrap$2);
    const timeout = lastB => scheduleDriver.next(lastB);
    const scheduledAggregator = (sinkFiber, scheduleFiber, scope) => {
      const forkSink = pipe(set$6(consumed, false), zipRight$4(set$6(endAfterEmit, false)), zipRight$4(pipe(handoffConsumer, pipeToOrFail(toChannel$1(sink)), collectElements, run$2, forkIn(scope))));
      const handleSide = (leftovers, b, c) => pipe(set$6(sinkLeftovers, flatten$9(leftovers)), zipRight$4(map$6(get$b(sinkEndReason), reason => {
        switch (reason._tag) {
          case OP_SCHEDULE_END:
            {
              return pipe(all$1([get$b(consumed), forkSink, pipe(timeout(some$6(b)), forkIn(scope))]), map$6(([wasConsumed, sinkFiber, scheduleFiber]) => {
                const toWrite = pipe(c, match$j({
                  onNone: () => of$3(right(b)),
                  onSome: c => make$11(right(b), left(c))
                }));
                if (wasConsumed) {
                  return pipe(write(toWrite), flatMap$3(() => scheduledAggregator(sinkFiber, scheduleFiber, scope)));
                }
                return scheduledAggregator(sinkFiber, scheduleFiber, scope);
              }), unwrap$2);
            }
          case OP_UPSTREAM_END:
            {
              return pipe(get$b(consumed), map$6(wasConsumed => wasConsumed ? write(of$3(right(b))) : unit$2), unwrap$2);
            }
        }
      })), unwrap$2);
      return unwrap$2(raceWith$1(join(sinkFiber), join(scheduleFiber), {
        onSelfDone: (sinkExit, _) => pipe(interrupt$3(scheduleFiber), zipRight$4(pipe(suspend$5(() => sinkExit), map$6(([leftovers, b]) => handleSide(leftovers, b, none$8()))))),
        onOtherDone: (scheduleExit, _) => matchCauseEffect(suspend$5(() => scheduleExit), {
          onFailure: cause => match$i(failureOrCause(cause), {
            onLeft: () => pipe(handoff, offer$2(end$2(ScheduleEnd)), forkDaemon, zipRight$4(pipe(join(sinkFiber), map$6(([leftovers, b]) => handleSide(leftovers, b, none$8()))))),
            onRight: cause => pipe(handoff, offer$2(halt(cause)), forkDaemon, zipRight$4(pipe(join(sinkFiber), map$6(([leftovers, b]) => handleSide(leftovers, b, none$8())))))
          }),
          onSuccess: c => pipe(handoff, offer$2(end$2(ScheduleEnd)), forkDaemon, zipRight$4(pipe(join(sinkFiber), map$6(([leftovers, b]) => handleSide(leftovers, b, some$6(c))))))
        })
      }));
    };
    return unwrapScoped(pipe(self, toChannel, pipeTo(handoffProducer), run$2, forkScoped, zipRight$4(pipe(handoffConsumer, pipeToOrFail(toChannel$1(sink)), collectElements, run$2, forkScoped, flatMap$4(sinkFiber => pipe(forkScoped(timeout(none$8())), flatMap$4(scheduleFiber => pipe(scope, map$6(scope => new StreamImpl(scheduledAggregator(sinkFiber, scheduleFiber, scope)))))))))));
  }));
});

/** @internal */
const as$1 = /*#__PURE__*/dual(2, (self, value) => map$2(self, () => value));

/** @internal */
const _async = (register, outputBuffer = 16) => asyncOption(cb => {
  register(cb);
  return none$8();
}, outputBuffer);

/** @internal */
const asyncEffect = (register, outputBuffer = 16) => pipe(acquireRelease$1(bounded$2(outputBuffer), queue => shutdown$2(queue)), flatMap$4(output => pipe(runtime(), flatMap$4(runtime => pipe(register(make$r(k => pipe(fromPull$1(k), flatMap$4(take => offer$3(output, take)), asUnit$2, runPromiseExit(runtime)).then(exit => {
  if (isFailure$5(exit)) {
    if (!isInterrupted(exit.cause)) {
      throw squash(exit.cause);
    }
  }
}))), map$6(() => {
  const loop = pipe(take$5(output), flatMap$4(done$5), match$9({
    onFailure: maybeError => pipe(fromEffect$3(shutdown$2(output)), zipRight$3(match$j(maybeError, {
      onNone: () => unit$2,
      onSome: fail$6
    }))),
    onSuccess: chunk => pipe(write(chunk), flatMap$3(() => loop))
  }), unwrap$2);
  return loop;
}))))), unwrapScoped$2, fromChannel);

/** @internal */
const asyncInterrupt = (register, outputBuffer = 16) => pipe(acquireRelease$1(bounded$2(outputBuffer), queue => shutdown$2(queue)), flatMap$4(output => pipe(runtime(), flatMap$4(runtime => pipe(sync$4(() => register(make$r(k => pipe(fromPull$1(k), flatMap$4(take => offer$3(output, take)), asUnit$2, runPromiseExit(runtime)).then(exit => {
  if (isFailure$5(exit)) {
    if (!isInterrupted(exit.cause)) {
      throw squash(exit.cause);
    }
  }
})))), map$6(match$i({
  onLeft: canceler => {
    const loop = pipe(take$5(output), flatMap$4(done$5), match$9({
      onFailure: maybeError => zipRight$3(fromEffect$3(shutdown$2(output)), match$j(maybeError, {
        onNone: () => unit$2,
        onSome: fail$6
      })),
      onSuccess: chunk => pipe(write(chunk), flatMap$3(() => loop))
    }), unwrap$2);
    return pipe(fromChannel(loop), ensuring$1(canceler));
  },
  onRight: stream => unwrap(pipe(shutdown$2(output), as$4(stream)))
})))))), unwrapScoped);

/** @internal */
const asyncOption = (register, outputBuffer = 16) => asyncInterrupt(emit => match$j(register(emit), {
  onNone: () => left(unit$3),
  onSome: right
}), outputBuffer);

/** @internal */
const asyncScoped = (register, outputBuffer = 16) => pipe(acquireRelease$1(bounded$2(outputBuffer), queue => shutdown$2(queue)), flatMap$4(output => pipe(runtime(), flatMap$4(runtime => pipe(register(make$r(k => pipe(fromPull$1(k), flatMap$4(take => offer$3(output, take)), asUnit$2, runPromiseExit(runtime)).then(exit => {
  if (isFailure$5(exit)) {
    if (!isInterrupted(exit.cause)) {
      throw squash(exit.cause);
    }
  }
}))), zipRight$4(make$G(false)), flatMap$4(ref => pipe(get$b(ref), map$6(isDone => isDone ? end$1() : pipe(take$5(output), flatMap$4(done$5), onError$1(() => pipe(set$6(ref, true), zipRight$4(shutdown$2(output)))))))))))), scoped, flatMap$1(repeatEffectChunkOption));

/** @internal */
const branchAfter = /*#__PURE__*/dual(3, (self, n, f) => suspend$2(() => {
  const buffering = acc => readWith({
    onInput: input => {
      const nextSize = acc.length + input.length;
      if (nextSize >= n) {
        const [b1, b2] = pipe(input, splitAt(n - acc.length));
        return running(pipe(acc, appendAll$1(b1)), b2);
      }
      return buffering(pipe(acc, appendAll$1(input)));
    },
    onFailure: fail$6,
    onDone: () => running(acc, empty$z())
  });
  const running = (prefix, leftover) => pipeTo(zipRight$3(write(leftover), identityChannel()), toChannel(f(prefix)));
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(buffering(empty$z()))));
}));

/** @internal */
const broadcast = /*#__PURE__*/dual(3, (self, n, maximumLag) => pipe(self, broadcastedQueues(n, maximumLag), map$6(tuple => tuple.map(queue => flattenTake(fromQueue(queue, {
  shutdown: true
}))))));

/** @internal */
const broadcastDynamic = /*#__PURE__*/dual(2, (self, maximumLag) => pipe(self, broadcastedQueuesDynamic(maximumLag), map$6(effect => flattenTake(flatMap$1(scoped(effect), fromQueue)))));

/** @internal */
const broadcastedQueues = /*#__PURE__*/dual(3, (self, n, maximumLag) => flatMap$4(bounded$3(maximumLag), pubsub => pipe(all$1(Array.from({
  length: n
}, () => subscribe$1(pubsub))), tap$3(() => forkScoped(runIntoPubSubScoped(self, pubsub))))));

/** @internal */
const broadcastedQueuesDynamic = /*#__PURE__*/dual(2, (self, maximumLag) => map$6(toPubSub(self, maximumLag), subscribe$1));

/** @internal */
const buffer = /*#__PURE__*/dual(2, (self, options) => {
  if (options.capacity === "unbounded") {
    return bufferUnbounded(self);
  } else if (options.strategy === "dropping") {
    return bufferDropping(self, options.capacity);
  } else if (options.strategy === "sliding") {
    return bufferSliding(self, options.capacity);
  }
  const queue = toQueueOfElements(self, options);
  return new StreamImpl(unwrapScoped$2(map$6(queue, queue => {
    const process = pipe(fromEffect$3(take$5(queue)), flatMap$3(match$f({
      onFailure: cause => pipe(flipCauseOption(cause), match$j({
        onNone: () => unit$2,
        onSome: failCause$4
      })),
      onSuccess: value => flatMap$3(write(of$3(value)), () => process)
    })));
    return process;
  })));
});

/** @internal */
const bufferChunks = /*#__PURE__*/dual(2, (self, options) => {
  if (options.strategy === "dropping") {
    return bufferChunksDropping(self, options.capacity);
  } else if (options.strategy === "sliding") {
    return bufferChunksSliding(self, options.capacity);
  }
  const queue = toQueue(self, options);
  return new StreamImpl(unwrapScoped$2(map$6(queue, queue => {
    const process = pipe(fromEffect$3(take$5(queue)), flatMap$3(match$1({
      onEnd: () => unit$2,
      onFailure: failCause$4,
      onSuccess: value => pipe(write(value), flatMap$3(() => process))
    })));
    return process;
  })));
});
const bufferChunksDropping = /*#__PURE__*/dual(2, (self, capacity) => {
  const queue = acquireRelease$1(dropping$2(capacity), queue => shutdown$2(queue));
  return new StreamImpl(bufferSignal(queue, toChannel(self)));
});
const bufferChunksSliding = /*#__PURE__*/dual(2, (self, capacity) => {
  const queue = acquireRelease$1(sliding$3(capacity), queue => shutdown$2(queue));
  return new StreamImpl(bufferSignal(queue, toChannel(self)));
});
const bufferDropping = /*#__PURE__*/dual(2, (self, capacity) => {
  const queue = acquireRelease$1(dropping$2(capacity), queue => shutdown$2(queue));
  return new StreamImpl(bufferSignal(queue, toChannel(rechunk(1)(self))));
});
const bufferSliding = /*#__PURE__*/dual(2, (self, capacity) => {
  const queue = acquireRelease$1(sliding$3(capacity), queue => shutdown$2(queue));
  return new StreamImpl(bufferSignal(queue, toChannel(pipe(self, rechunk(1)))));
});
const bufferUnbounded = self => {
  const queue = toQueue(self, {
    strategy: "unbounded"
  });
  return new StreamImpl(unwrapScoped$2(map$6(queue, queue => {
    const process = pipe(fromEffect$3(take$5(queue)), flatMap$3(match$1({
      onEnd: () => unit$2,
      onFailure: failCause$4,
      onSuccess: value => flatMap$3(write(value), () => process)
    })));
    return process;
  })));
};

/** @internal */
const bufferSignal = (scoped, bufferChannel) => {
  const producer = (queue, ref) => {
    const terminate = take => pipe(get$b(ref), tap$3(_await$3), zipRight$4(make$R()), flatMap$4(deferred => pipe(offer$3(queue, [take, deferred]), zipRight$4(set$6(ref, deferred)), zipRight$4(_await$3(deferred)))), asUnit$2, fromEffect$3);
    return readWithCause({
      onInput: input => pipe(make$R(), flatMap$4(deferred => pipe(offer$3(queue, [chunk(input), deferred]), flatMap$4(added => pipe(set$6(ref, deferred), when$3(() => added))))), asUnit$2, fromEffect$3, flatMap$3(() => producer(queue, ref))),
      onFailure: error => terminate(failCause$1(error)),
      onDone: () => terminate(end)
    });
  };
  const consumer = queue => {
    const process = pipe(fromEffect$3(take$5(queue)), flatMap$3(([take, deferred]) => zipRight$3(fromEffect$3(succeed$g(deferred, void 0)), match$1(take, {
      onEnd: () => unit$2,
      onFailure: failCause$4,
      onSuccess: value => pipe(write(value), flatMap$3(() => process))
    }))));
    return process;
  };
  return unwrapScoped$2(pipe(scoped, flatMap$4(queue => pipe(make$R(), tap$3(start => succeed$g(start, void 0)), flatMap$4(start => pipe(make$G(start), flatMap$4(ref => pipe(bufferChannel, pipeTo(producer(queue, ref)), runScoped$1, forkScoped)), as$4(consumer(queue))))))));
};

/** @internal */
const catchAll$1 = /*#__PURE__*/dual(2, (self, f) => catchAllCause(self, cause => match$i(failureOrCause(cause), {
  onLeft: f,
  onRight: failCause
})));

/** @internal */
const catchAllCause = /*#__PURE__*/dual(2, (self, f) => new StreamImpl(pipe(toChannel(self), catchAllCause$1(cause => toChannel(f(cause))))));

/** @internal */
const catchSome$1 = /*#__PURE__*/dual(2, (self, pf) => pipe(self, catchAll$1(error => pipe(pf(error), getOrElse$3(() => fail$3(error))))));

/** @internal */
const catchSomeCause = /*#__PURE__*/dual(2, (self, pf) => pipe(self, catchAllCause(cause => pipe(pf(cause), getOrElse$3(() => failCause(cause))))));

/* @internal */
const catchTag$1 = /*#__PURE__*/dual(3, (self, k, f) => catchAll$1(self, e => {
  if ("_tag" in e && e["_tag"] === k) {
    return f(e);
  }
  return fail$3(e);
}));

/** @internal */
const catchTags$1 = /*#__PURE__*/dual(2, (self, cases) => catchAll$1(self, e => {
  const keys = Object.keys(cases);
  if ("_tag" in e && keys.includes(e["_tag"])) {
    return cases[e["_tag"]](e);
  }
  return fail$3(e);
}));

/** @internal */
const changes = self => pipe(self, changesWith((x, y) => equals$1(y)(x)));

/** @internal */
const changesWith = /*#__PURE__*/dual(2, (self, f) => {
  const writer = last => readWithCause({
    onInput: input => {
      const [newLast, newChunk] = reduce$h(input, [last, empty$z()], ([option, outputs], output) => {
        if (isSome(option) && f(option.value, output)) {
          return [some$6(output), outputs];
        }
        return [some$6(output), pipe(outputs, append$1(output))];
      });
      return flatMap$3(write(newChunk), () => writer(newLast));
    },
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(writer(none$8()))));
});

/** @internal */
const changesWithEffect = /*#__PURE__*/dual(2, (self, f) => {
  const writer = last => readWithCause({
    onInput: input => pipe(input, reduce$5([last, empty$z()], ([option, outputs], output) => {
      if (isSome(option)) {
        return pipe(f(option.value, output), map$6(bool => bool ? [some$6(output), outputs] : [some$6(output), pipe(outputs, append$1(output))]));
      }
      return succeed$7([some$6(output), pipe(outputs, append$1(output))]);
    }), fromEffect$3, flatMap$3(([newLast, newChunk]) => pipe(write(newChunk), flatMap$3(() => writer(newLast))))),
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(writer(none$8()))));
});

/** @internal */
const chunks = self => pipe(self, mapChunks(of$3));

/** @internal */
const chunksWith = /*#__PURE__*/dual(2, (self, f) => flattenChunks(f(chunks(self))));
const unsome$1 = effect => catchAll$3(asSome$1(effect), o => o._tag === "None" ? succeedNone$1 : fail$7(o.value));

/** @internal */
const combine = /*#__PURE__*/dual(4, (self, that, s, f) => {
  const producer = (handoff, latch) => pipe(fromEffect$3(take$3(latch)), zipRight$3(readWithCause({
    onInput: input => flatMap$3(fromEffect$3(pipe(handoff, offer$2(succeed$f(input)))), () => producer(handoff, latch)),
    onFailure: cause => fromEffect$3(offer$2(handoff, failCause$8(pipe(cause, map$9(some$6))))),
    onDone: () => flatMap$3(fromEffect$3(offer$2(handoff, fail$d(none$8()))), () => producer(handoff, latch))
  })));
  return new StreamImpl(unwrapScoped$2(gen$1(function* ($) {
    const left = yield* $(make$q());
    const right = yield* $(make$q());
    const latchL = yield* $(make$q());
    const latchR = yield* $(make$q());
    yield* $(toChannel(self), concatMap(writeChunk), pipeTo(producer(left, latchL)), runScoped$1, forkScoped);
    yield* $(toChannel(that), concatMap(writeChunk), pipeTo(producer(right, latchR)), runScoped$1, forkScoped);
    const pullLeft = pipe(latchL, offer$2(void 0),
    // TODO: remove
    zipRight$4(pipe(take$3(left), flatMap$4(exit => suspend$5(() => exit)))));
    const pullRight = pipe(latchR, offer$2(void 0),
    // TODO: remove
    zipRight$4(pipe(take$3(right), flatMap$4(exit => suspend$5(() => exit)))));
    return toChannel(unfoldEffect(s, s => flatMap$4(f(s, pullLeft, pullRight), unsome$1)));
  })));
});

/** @internal */
const combineChunks = /*#__PURE__*/dual(4, (self, that, s, f) => {
  const producer = (handoff, latch) => zipRight$3(fromEffect$3(take$3(latch)), readWithCause({
    onInput: input => flatMap$3(fromEffect$3(pipe(handoff, offer$2(chunk(input)))), () => producer(handoff, latch)),
    onFailure: cause => fromEffect$3(offer$2(handoff, failCause$1(cause))),
    onDone: () => fromEffect$3(offer$2(handoff, end))
  }));
  return new StreamImpl(pipe(all$1([make$q(), make$q(), make$q(), make$q()]), tap$3(([left, _, latchL]) => pipe(toChannel(self), pipeTo(producer(left, latchL)), runScoped$1, forkScoped)), tap$3(([_, right, __, latchR]) => pipe(toChannel(that), pipeTo(producer(right, latchR)), runScoped$1, forkScoped)), map$6(([left, right, latchL, latchR]) => {
    const pullLeft = pipe(latchL, offer$2(void 0), zipRight$4(pipe(take$3(left), flatMap$4(done$5))));
    const pullRight = pipe(latchR, offer$2(void 0), zipRight$4(pipe(take$3(right), flatMap$4(done$5))));
    return toChannel(unfoldChunkEffect(s, s => flatMap$4(f(s, pullLeft, pullRight), unsome$1)));
  }), unwrapScoped$2));
});

/** @internal */
const concat = /*#__PURE__*/dual(2, (self, that) => new StreamImpl(pipe(toChannel(self), zipRight$3(toChannel(that)))));

/** @internal */
const concatAll = streams => suspend$2(() => pipe(streams, reduce$h(empty$6, (x, y) => concat(y)(x))));

/** @internal */
const cross = /*#__PURE__*/dual(2, (self, that) => pipe(self, crossWith(that, (a, a2) => [a, a2])));

/** @internal */
const crossLeft = /*#__PURE__*/dual(2, (self, that) => pipe(self, crossWith(that, (a, _) => a)));

/** @internal */
const crossRight = /*#__PURE__*/dual(2, (self, that) => flatMap$1(self, () => that));

/** @internal */
const crossWith = /*#__PURE__*/dual(3, (self, that, f) => pipe(self, flatMap$1(a => pipe(that, map$2(b => f(a, b))))));

/** @internal */
const debounce = /*#__PURE__*/dual(2, (self, duration) => pipe(make$s(), flatMap$4(input => transplant(grafter => pipe(make$q(), map$6(handoff => {
  const enqueue = last => pipe(sleep$2(duration), as$4(last), fork, grafter, map$6(fiber => consumer(previous(fiber))));
  const producer = readWithCause({
    onInput: input => match$j(last$2(input), {
      onNone: () => producer,
      onSome: last => flatMap$3(fromEffect$3(offer$2(handoff, emit(of$3(last)))), () => producer)
    }),
    onFailure: cause => fromEffect$3(offer$2(handoff, halt(cause))),
    onDone: () => fromEffect$3(offer$2(handoff, end$2(UpstreamEnd)))
  });
  const consumer = state => {
    switch (state._tag) {
      case OP_NOT_STARTED:
        {
          return pipe(take$3(handoff), map$6(signal => {
            switch (signal._tag) {
              case OP_EMIT:
                {
                  return unwrap$2(enqueue(signal.elements));
                }
              case OP_HALT:
                {
                  return failCause$4(signal.cause);
                }
              case OP_END:
                {
                  return unit$2;
                }
            }
          }), unwrap$2);
        }
      case OP_PREVIOUS:
        {
          return unwrap$2(raceWith$1(join(state.fiber), take$3(handoff), {
            onSelfDone: (leftExit, current$1) => match$f(leftExit, {
              onFailure: cause => pipe(interrupt$3(current$1), as$4(failCause$4(cause))),
              onSuccess: chunk => succeed$7(pipe(write(chunk), flatMap$3(() => consumer(current(current$1)))))
            }),
            onOtherDone: (rightExit, previous) => match$f(rightExit, {
              onFailure: cause => pipe(interrupt$3(previous), as$4(failCause$4(cause))),
              onSuccess: signal => {
                switch (signal._tag) {
                  case OP_EMIT:
                    {
                      return pipe(interrupt$3(previous), zipRight$4(enqueue(signal.elements)));
                    }
                  case OP_HALT:
                    {
                      return pipe(interrupt$3(previous), as$4(failCause$4(signal.cause)));
                    }
                  case OP_END:
                    {
                      return pipe(join(previous), map$6(chunk => pipe(write(chunk), zipRight$3(unit$2))));
                    }
                }
              }
            })
          }));
        }
      case OP_CURRENT:
        {
          return pipe(join(state.fiber), map$6(signal => {
            switch (signal._tag) {
              case OP_EMIT:
                {
                  return unwrap$2(enqueue(signal.elements));
                }
              case OP_HALT:
                {
                  return failCause$4(signal.cause);
                }
              case OP_END:
                {
                  return unit$2;
                }
            }
          }), unwrap$2);
        }
    }
  };
  const debounceChannel = pipe(fromInput$1(input), pipeTo(producer), run$2, forkScoped, as$4(pipe(consumer(notStarted), embedInput(input))), unwrapScoped$2);
  return new StreamImpl(pipe(toChannel(self), pipeTo(debounceChannel)));
})))), unwrap));

/** @internal */
const die$2 = defect => fromEffect(die$5(defect));

/** @internal */
const dieSync$1 = evaluate => fromEffect(dieSync$3(evaluate));

/** @internal */
const dieMessage$1 = message => fromEffect(dieMessage$4(message));

/** @internal */
const distributedWith = /*#__PURE__*/dual(2, (self, options) => pipe(make$R(), flatMap$4(deferred => pipe(self, distributedWithDynamic({
  maximumLag: options.maximumLag,
  decide: a => flatMap$4(_await$3(deferred), f => f(a))
}), flatMap$4(next => pipe(all$1(map$l(range$1(0, options.size - 1), id => map$6(next, ([key, queue]) => [[key, id], queue]))), map$6(unsafeFromArray), flatMap$4(entries => {
  const [mappings, queues] = reduceRight$3(entries, [new Map(), empty$z()], ([mappings, queues], [mapping, queue]) => [mappings.set(mapping[0], mapping[1]), pipe(queues, prepend$2(queue))]);
  return pipe(succeed$g(deferred, a => map$6(options.decide(a), f => key => pipe(f(mappings.get(key))))), as$4(Array.from(queues)));
})))))));

/** @internal */
const distributedWithDynamicId = {
  ref: 0
};
const newDistributedWithDynamicId = () => {
  const current = distributedWithDynamicId.ref;
  distributedWithDynamicId.ref = current + 1;
  return current;
};

/** @internal */
const distributedWithDynamic = /*#__PURE__*/dual(2, (self, options) => distributedWithDynamicCallback(self, options.maximumLag, options.decide, () => unit$3));
const distributedWithDynamicCallback = /*#__PURE__*/dual(4, (self, maximumLag, decide, done) => pipe(acquireRelease$1(make$G(new Map()), (ref, _) => pipe(get$b(ref), flatMap$4(queues => pipe(queues.values(), forEach$6(shutdown$2))))), flatMap$4(queuesRef => gen$1(function* ($) {
  const offer = a => pipe(decide(a), flatMap$4(shouldProcess => pipe(get$b(queuesRef), flatMap$4(queues => pipe(queues.entries(), reduce$5(empty$z(), (acc, [id, queue]) => {
    if (shouldProcess(id)) {
      return pipe(offer$3(queue, succeed$f(a)), matchCauseEffect({
        onFailure: cause =>
        // Ignore all downstream queues that were shut
        // down and remove them later
        isInterrupted(cause) ? succeed$7(pipe(acc, prepend$2(id))) : failCause$5(cause),
        onSuccess: () => succeed$7(acc)
      }));
    }
    return succeed$7(acc);
  }), flatMap$4(ids => {
    if (isNonEmpty$5(ids)) {
      return pipe(update$4(queuesRef, map => {
        for (const id of ids) {
          map.delete(id);
        }
        return map;
      }));
    }
    return unit$3;
  }))))), asUnit$2);
  const queuesLock = yield* $(makeSemaphore(1));
  const newQueue = yield* $(make$G(pipe(bounded$2(maximumLag), flatMap$4(queue => {
    const id = newDistributedWithDynamicId();
    return pipe(update$4(queuesRef, map => map.set(id, queue)), as$4([id, queue]));
  }))));
  const finalize = endTake =>
  // Make sure that no queues are currently being added
  queuesLock.withPermits(1)(pipe(set$6(newQueue, pipe(
  // All newly created queues should end immediately
  bounded$2(1), tap$3(queue => offer$3(queue, endTake)), flatMap$4(queue => {
    const id = newDistributedWithDynamicId();
    return pipe(update$4(queuesRef, map => map.set(id, queue)), as$4([id, queue]));
  }))), zipRight$4(pipe(get$b(queuesRef), flatMap$4(map => pipe(fromIterable$b(map.values()), forEach$6(queue => pipe(offer$3(queue, endTake), catchSomeCause$1(cause => isInterrupted(cause) ? some$6(unit$3) : none$8()))))))), zipRight$4(done(endTake)), asUnit$2));
  yield* $(self, runForEachScoped(offer), matchCauseEffect({
    onFailure: cause => finalize(failCause$8(pipe(cause, map$9(some$6)))),
    onSuccess: () => finalize(fail$d(none$8()))
  }), forkScoped);
  return queuesLock.withPermits(1)(flatten$3(get$b(newQueue)));
}))));

/** @internal */
const drain = self => new StreamImpl(drain$2(toChannel(self)));

/** @internal */
const drainFork = /*#__PURE__*/dual(2, (self, that) => pipe(fromEffect(make$R()), flatMap$1(backgroundDied => pipe(scoped(pipe(that, runForEachScoped(() => unit$3), catchAllCause$2(cause => failCause$9(backgroundDied, cause)), forkScoped)), crossRight(pipe(self, interruptWhenDeferred(backgroundDied)))))));

/** @internal */
const drop = /*#__PURE__*/dual(2, (self, n) => {
  const loop = r => readWith({
    onInput: input => {
      const dropped = pipe(input, drop$2(r));
      const leftover = Math.max(0, r - input.length);
      const more = isEmpty$h(input) || leftover > 0;
      if (more) {
        return loop(leftover);
      }
      return pipe(write(dropped), zipRight$3(identityChannel()));
    },
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(loop(n))));
});

/** @internal */
const dropRight = /*#__PURE__*/dual(2, (self, n) => {
  if (n <= 0) {
    return identityStream();
  }
  return suspend$2(() => {
    const queue = new RingBuffer(n);
    const reader = readWith({
      onInput: input => {
        const outputs = pipe(input, filterMap$2(elem => {
          const head = queue.head();
          queue.put(elem);
          return head;
        }));
        return pipe(write(outputs), flatMap$3(() => reader));
      },
      onFailure: fail$6,
      onDone: () => unit$2
    });
    return new StreamImpl(pipe(toChannel(self), pipeToOrFail(reader)));
  });
});

/** @internal */
const dropUntil = /*#__PURE__*/dual(2, (self, predicate) => drop(dropWhile(self, a => !predicate(a)), 1));

/** @internal */
const dropUntilEffect = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = readWith({
    onInput: input => pipe(dropUntil$2(input, predicate), map$6(unsafeFromArray), map$6(leftover => {
      const more = isEmpty$h(leftover);
      if (more) {
        return suspend$4(() => loop);
      }
      return pipe(write(leftover), zipRight$3(identityChannel()));
    }), unwrap$2),
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(loop)));
});

/** @internal */
const dropWhile = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = readWith({
    onInput: input => {
      const output = dropWhile$4(input, predicate);
      if (isEmpty$h(output)) {
        return suspend$4(() => loop);
      }
      return zipRight$3(write(output), identityChannel());
    },
    onFailure: fail$6,
    onDone: succeedNow
  });
  return new StreamImpl(pipeToOrFail(toChannel(self), loop));
});

/** @internal */
const dropWhileEffect = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = readWith({
    onInput: input => pipe(dropWhile$2(input, predicate), map$6(unsafeFromArray), map$6(leftover => {
      const more = isEmpty$h(leftover);
      if (more) {
        return suspend$4(() => loop);
      }
      return zipRight$3(write(leftover), identityChannel());
    }), unwrap$2),
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new StreamImpl(pipeToOrFail(toChannel(self), loop));
});

/** @internal */
const either$2 = self => pipe(self, map$2(right), catchAll$1(error => make$o(left(error))));

/** @internal */
const empty$6 = /*#__PURE__*/new StreamImpl( /*#__PURE__*/write( /*#__PURE__*/empty$z()));

/** @internal */
const ensuring$1 = /*#__PURE__*/dual(2, (self, finalizer) => new StreamImpl(pipe(toChannel(self), ensuring$3(finalizer))));

/** @internal */
const ensuringWith = /*#__PURE__*/dual(2, (self, finalizer) => new StreamImpl(ensuringWith$2(toChannel(self), finalizer)));

/** @internal */
const context$1 = () => fromEffect(context$5());

/** @internal */
const contextWith$1 = f => pipe(context$1(), map$2(f));

/** @internal */
const contextWithEffect = f => pipe(context$1(), mapEffectSequential(f));

/** @internal */
const contextWithStream = f => pipe(context$1(), flatMap$1(f));

/** @internal */
const execute = effect => drain(fromEffect(effect));

/** @internal */
const fail$3 = error => fromEffectOption(fail$7(some$6(error)));

/** @internal */
const failSync$1 = evaluate => fromEffectOption(failSync$4(() => some$6(evaluate())));

/** @internal */
const failCause = cause => fromEffect(failCause$5(cause));

/** @internal */
const failCauseSync = evaluate => fromEffect(failCauseSync$3(evaluate));

/** @internal */
const filter$2 = /*#__PURE__*/dual(2, (self, predicate) => mapChunks(self, filter$9(predicate)));

/** @internal */
const filterEffect = /*#__PURE__*/dual(2, (self, f) => {
  const loop = iterator => {
    const next = iterator.next();
    if (next.done) {
      return readWithCause({
        onInput: input => loop(input[Symbol.iterator]()),
        onFailure: failCause$4,
        onDone: succeed$6
      });
    } else {
      return pipe(f(next.value), map$6(bool => bool ? pipe(write(of$3(next.value)), flatMap$3(() => loop(iterator))) : loop(iterator)), unwrap$2);
    }
  };
  return new StreamImpl(suspend$4(() => pipe(toChannel(self), pipeTo(loop(empty$z()[Symbol.iterator]())))));
});

/** @internal */
const filterMap = /*#__PURE__*/dual(2, (self, pf) => mapChunks(self, filterMap$2(pf)));

/** @internal */
const filterMapEffect = /*#__PURE__*/dual(2, (self, pf) => suspend$2(() => {
  const loop = iterator => {
    const next = iterator.next();
    if (next.done) {
      return readWithCause({
        onInput: input => loop(input[Symbol.iterator]()),
        onFailure: failCause$4,
        onDone: succeed$6
      });
    } else {
      return pipe(pf(next.value), match$j({
        onNone: () => sync$4(() => loop(iterator)),
        onSome: map$6(a2 => flatMap$3(write(of$3(a2)), () => loop(iterator)))
      }), unwrap$2);
    }
  };
  return new StreamImpl(pipe(toChannel(self), pipeTo(loop(empty$z()[Symbol.iterator]()))));
}));

/** @internal */
const filterMapWhile = /*#__PURE__*/dual(2, (self, pf) => {
  const loop = readWith({
    onInput: input => {
      const mapped = filterMapWhile$1(input, pf);
      if (mapped.length === input.length) {
        return pipe(write(mapped), flatMap$3(() => loop));
      }
      return write(mapped);
    },
    onFailure: fail$6,
    onDone: succeed$6
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(loop)));
});

/** @internal */
const filterMapWhileEffect = /*#__PURE__*/dual(2, (self, pf) => suspend$2(() => {
  const loop = iterator => {
    const next = iterator.next();
    if (next.done) {
      return readWithCause({
        onInput: input => loop(input[Symbol.iterator]()),
        onFailure: failCause$4,
        onDone: succeed$6
      });
    } else {
      return unwrap$2(match$j(pf(next.value), {
        onNone: () => succeed$7(unit$2),
        onSome: map$6(a2 => flatMap$3(write(of$3(a2)), () => loop(iterator)))
      }));
    }
  };
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(loop(empty$z()[Symbol.iterator]()))));
}));

/** @internal */
const finalizer = finalizer => acquireRelease(unit$3, () => finalizer);

/** @internal */
const find$1 = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = readWith({
    onInput: input => match$j(findFirst$6(input, predicate), {
      onNone: () => loop,
      onSome: n => write(of$3(n))
    }),
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(loop)));
});

/** @internal */
const findEffect = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = readWith({
    onInput: input => pipe(findFirst$1(input, predicate), map$6(match$j({
      onNone: () => loop,
      onSome: n => write(of$3(n))
    })), unwrap$2),
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(loop)));
});

/** @internal */
const flatMap$1 = /*#__PURE__*/dual(args => typeof args[0] !== "function", (self, f, options) => {
  const bufferSize = options?.bufferSize ?? 16;
  if (options?.switch) {
    return matchConcurrency(options?.concurrency, () => flatMapParSwitchBuffer(self, 1, bufferSize, f), n => flatMapParSwitchBuffer(self, n, bufferSize, f));
  }
  return matchConcurrency(options?.concurrency, () => new StreamImpl(concatMap(toChannel(self), as => pipe(as, map$l(a => toChannel(f(a))), reduce$h(unit$2, (left, right) => pipe(left, zipRight$3(right)))))), _ => new StreamImpl(pipe(toChannel(self), concatMap(writeChunk), mergeMap(out => toChannel(f(out)), options))));
});

/** @internal */
const matchConcurrency = (concurrency, sequential, bounded) => {
  switch (concurrency) {
    case undefined:
      return sequential();
    case "unbounded":
      return bounded(Number.MAX_SAFE_INTEGER);
    default:
      return concurrency > 1 ? bounded(concurrency) : sequential();
  }
};
const flatMapParSwitchBuffer = /*#__PURE__*/dual(4, (self, n, bufferSize, f) => new StreamImpl(pipe(toChannel(self), concatMap(writeChunk), mergeMap(out => toChannel(f(out)), {
  concurrency: n,
  mergeStrategy: BufferSliding(),
  bufferSize
}))));

/** @internal */
const flatten$1 = /*#__PURE__*/dual(args => isStream(args[0]), (self, options) => flatMap$1(self, identity$1, options));

/** @internal */
const flattenChunks = self => {
  const flatten = readWithCause({
    onInput: chunks => flatMap$3(writeChunk(chunks), () => flatten),
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(flatten)));
};

/** @internal */
const flattenEffect = /*#__PURE__*/dual(args => isStream(args[0]), (self, options) => options?.unordered ? flatMap$1(self, a => fromEffect(a), {
  concurrency: options.concurrency
}) : matchConcurrency(options?.concurrency, () => mapEffectSequential(self, identity$1), n => new StreamImpl(pipe(toChannel(self), concatMap(writeChunk), mapOutEffectPar(identity$1, n), mapOut(of$3)))));

/** @internal */
const flattenExitOption = self => {
  const processChunk = (chunk, cont) => {
    const [toEmit, rest] = pipe(chunk, splitWhere$1(exit => !isSuccess$5(exit)));
    const next = pipe(head$4(rest), match$j({
      onNone: () => cont,
      onSome: match$f({
        onFailure: cause => match$j(flipCauseOption(cause), {
          onNone: () => unit$2,
          onSome: failCause$4
        }),
        onSuccess: () => unit$2
      })
    }));
    return pipe(write(pipe(toEmit, filterMap$2(exit => isSuccess$5(exit) ? some$6(exit.value) : none$8()))), flatMap$3(() => next));
  };
  const process = readWithCause({
    onInput: chunk => processChunk(chunk, process),
    onFailure: cause => failCause$4(cause),
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(process)));
};

/** @internal */
const flattenIterables = self => pipe(self, map$2(fromIterable$b), flattenChunks);

/** @internal */
const flattenTake = self => flattenChunks(flattenExitOption(pipe(self, map$2(take => take.exit))));

/** @internal */
const forever = self => new StreamImpl(repeated(toChannel(self)));

/** @internal */
const fromAsyncIterable = (iterable, onError) => pipe(acquireRelease$1(sync$4(() => iterable[Symbol.asyncIterator]()), iterator => iterator.return ? promise(async () => iterator.return()) : unit$3), map$6(iterator => repeatEffectOption(pipe(tryPromise({
  try: async () => iterator.next(),
  catch: reason => some$6(onError(reason))
}), flatMap$4(result => result.done ? fail$7(none$8()) : succeed$7(result.value))))), unwrapScoped);

/** @internal */
const fromChannel = channel => new StreamImpl(channel);

/** @internal */
const toChannel = stream => {
  if ("channel" in stream) {
    return stream.channel;
  } else if (isEffect(stream)) {
    return toChannel(fromEffect(stream));
  } else {
    throw new TypeError(`Expected a Stream.`);
  }
};

/** @internal */
const fromChunk = chunk => new StreamImpl(isEmpty$h(chunk) ? unit$2 : write(chunk));

/** @internal */
const fromChunkPubSub = (pubsub, options) => {
  if (options?.scoped) {
    const effect = map$6(subscribe$1(pubsub), fromChunkQueue);
    return options.shutdown ? map$6(effect, ensuring$1(shutdown$3(pubsub))) : effect;
  }
  const stream = flatMap$1(scoped(subscribe$1(pubsub)), fromChunkQueue);
  return options?.shutdown ? ensuring$1(stream, shutdown$3(pubsub)) : stream;
};

/** @internal */
const fromChunkQueue = (queue, options) => pipe(take$5(queue), catchAllCause$2(cause => pipe(isShutdown$2(queue), flatMap$4(isShutdown => isShutdown && isInterrupted(cause) ? end$1() : failCause$2(cause)))), repeatEffectChunkOption, options?.shutdown ? ensuring$1(shutdown$2(queue)) : identity$1);

/** @internal */
const fromChunks = (...chunks) => pipe(fromIterable$4(chunks), flatMap$1(fromChunk));

/** @internal */
const fromEffect = effect => pipe(effect, mapError$4(some$6), fromEffectOption);

/** @internal */
const fromEffectOption = effect => new StreamImpl(unwrap$2(match$9(effect, {
  onFailure: match$j({
    onNone: () => unit$2,
    onSome: fail$6
  }),
  onSuccess: a => write(of$3(a))
})));

/** @internal */
const fromPubSub = (pubsub, options) => {
  const maxChunkSize = options?.maxChunkSize ?? DefaultChunkSize;
  if (options?.scoped) {
    const effect = map$6(subscribe$1(pubsub), queue => fromQueue(queue, {
      maxChunkSize,
      shutdown: true
    }));
    return options.shutdown ? map$6(effect, ensuring$1(shutdown$3(pubsub))) : effect;
  }
  const stream = flatMap$1(scoped(subscribe$1(pubsub)), queue => fromQueue(queue, {
    maxChunkSize
  }));
  return options?.shutdown ? ensuring$1(stream, shutdown$3(pubsub)) : stream;
};

/** @internal */
const fromIterable$4 = iterable => suspend$2(() => isChunk(iterable) ? fromChunk(iterable) : fromIteratorSucceed(iterable[Symbol.iterator]()));

/** @internal */
const fromIterableEffect = effect => pipe(effect, map$6(fromIterable$4), unwrap);

/** @internal */
const fromIteratorSucceed = (iterator, maxChunkSize = DefaultChunkSize) => {
  return pipe(sync$4(() => {
    let builder = [];
    const loop = iterator => pipe(sync$4(() => {
      let next = iterator.next();
      if (maxChunkSize === 1) {
        if (next.done) {
          return unit$2;
        }
        return pipe(write(of$3(next.value)), flatMap$3(() => loop(iterator)));
      }
      builder = [];
      let count = 0;
      while (next.done === false) {
        builder.push(next.value);
        count = count + 1;
        if (count >= maxChunkSize) {
          break;
        }
        next = iterator.next();
      }
      if (count > 0) {
        return pipe(write(unsafeFromArray(builder)), flatMap$3(() => loop(iterator)));
      }
      return unit$2;
    }), unwrap$2);
    return new StreamImpl(loop(iterator));
  }), unwrap);
};

/** @internal */
const fromPull = effect => pipe(effect, map$6(repeatEffectChunkOption), unwrapScoped);

/** @internal */
const fromQueue = (queue, options) => pipe(takeBetween$1(queue, 1, options?.maxChunkSize ?? DefaultChunkSize), catchAllCause$2(cause => pipe(isShutdown$2(queue), flatMap$4(isShutdown => isShutdown && isInterrupted(cause) ? end$1() : failCause$2(cause)))), repeatEffectChunkOption, options?.shutdown ? ensuring$1(shutdown$2(queue)) : identity$1);

/** @internal */
const fromSchedule = schedule => pipe(driver(schedule), map$6(driver => repeatEffectOption(driver.next(void 0))), unwrap);

/** @internal */
const fromReadableStream = (evaluate, onError) => unwrapScoped(map$6(acquireRelease$1(sync$4(() => evaluate().getReader()), reader => promise(() => reader.cancel())), reader => repeatEffectOption(flatMap$4(tryPromise({
  try: () => reader.read(),
  catch: reason => some$6(onError(reason))
}), ({
  done,
  value
}) => done ? fail$7(none$8()) : succeed$7(value)))));

/** @internal */
const fromReadableStreamByob = (evaluate, onError, allocSize = 4096) => unwrapScoped(map$6(acquireRelease$1(sync$4(() => evaluate().getReader({
  mode: "byob"
})), reader => promise(() => reader.cancel())), reader => catchAll$1(forever(readChunkStreamByobReader(reader, onError, allocSize)), error => typeof error === "object" && error !== null && "_tag" in error && error._tag === "EOF" ? empty$6 : fail$3(error))));
const readChunkStreamByobReader = (reader, onError, size) => {
  const buffer = new ArrayBuffer(size);
  return paginateEffect(0, offset => flatMap$4(tryPromise({
    try: () => reader.read(new Uint8Array(buffer, offset, buffer.byteLength - offset)),
    catch: reason => onError(reason)
  }), ({
    done,
    value
  }) => {
    if (done) {
      return fail$7({
        _tag: "EOF"
      });
    }
    const newOffset = offset + value.byteLength;
    return succeed$7([value, newOffset >= buffer.byteLength ? none$8() : some$6(newOffset)]);
  }));
};

/** @internal */
const groupAdjacentBy = /*#__PURE__*/dual(2, (self, f) => {
  const groupAdjacentByChunk = (state, chunk) => {
    if (isEmpty$h(chunk)) {
      return [state, empty$z()];
    }
    const builder = [];
    let from = 0;
    let until = 0;
    let key = undefined;
    let previousChunk = empty$z();
    switch (state._tag) {
      case "Some":
        {
          const tuple = state.value;
          key = tuple[0];
          let loop = true;
          while (loop && until < chunk.length) {
            const input = unsafeGet$5(chunk, until);
            const updatedKey = f(input);
            if (!equals$1(key, updatedKey)) {
              const previousChunk = tuple[1];
              const additionalChunk = unsafeFromArray(Array.from(chunk).slice(from, until));
              const group = appendAllNonEmpty(previousChunk, additionalChunk);
              builder.push([key, group]);
              key = updatedKey;
              from = until;
              loop = false;
            }
            until = until + 1;
          }
          if (loop) {
            previousChunk = tuple[1];
          }
          break;
        }
      case "None":
        {
          key = f(unsafeGet$5(chunk, until));
          until = until + 1;
          break;
        }
    }
    while (until < chunk.length) {
      const input = unsafeGet$5(chunk, until);
      const updatedKey = f(input);
      if (!equals$1(key, updatedKey)) {
        builder.push([key, unsafeFromArray(Array.from(chunk).slice(from, until))]);
        key = updatedKey;
        from = until;
      }
      until = until + 1;
    }
    const nonEmptyChunk = appendAll$1(previousChunk, unsafeFromArray(Array.from(chunk).slice(from, until)));
    const output = unsafeFromArray(builder);
    return [some$6([key, nonEmptyChunk]), output];
  };
  const groupAdjacent = state => readWithCause({
    onInput: input => {
      const [updatedState, output] = groupAdjacentByChunk(state, input);
      return isEmpty$h(output) ? groupAdjacent(updatedState) : flatMap$3(write(output), () => groupAdjacent(updatedState));
    },
    onFailure: cause => match$j(state, {
      onNone: () => failCause$4(cause),
      onSome: output => flatMap$3(write(of$3(output)), () => failCause$4(cause))
    }),
    onDone: done => match$j(state, {
      onNone: () => succeedNow(done),
      onSome: output => flatMap$3(write(of$3(output)), () => succeedNow(done))
    })
  });
  return new StreamImpl(pipeToOrFail(toChannel(self), groupAdjacent(none$8())));
});

/** @internal */
const grouped = /*#__PURE__*/dual(2, (self, chunkSize) => pipe(self, rechunk(chunkSize), chunks));

/** @internal */
const groupedWithin = /*#__PURE__*/dual(3, (self, chunkSize, duration) => aggregateWithin(self, collectAllN(chunkSize), spaced(duration)));

/** @internal */
const haltWhen = /*#__PURE__*/dual(2, (self, effect) => {
  const writer = fiber => pipe(poll$5(fiber), map$6(match$j({
    onNone: () => readWith({
      onInput: input => flatMap$3(write(input), () => writer(fiber)),
      onFailure: fail$6,
      onDone: () => unit$2
    }),
    onSome: match$f({
      onFailure: failCause$4,
      onSuccess: () => unit$2
    })
  })), unwrap$2);
  return new StreamImpl(pipe(forkScoped(effect), map$6(fiber => pipe(toChannel(self), pipeTo(writer(fiber)))), unwrapScoped$2));
});

/** @internal */
const haltAfter = /*#__PURE__*/dual(2, (self, duration) => pipe(self, haltWhen(sleep$2(duration))));

/** @internal */
const haltWhenDeferred = /*#__PURE__*/dual(2, (self, deferred) => {
  const writer = pipe(poll$8(deferred), map$6(match$j({
    onNone: () => readWith({
      onInput: input => pipe(write(input), flatMap$3(() => writer)),
      onFailure: fail$6,
      onDone: () => unit$2
    }),
    onSome: effect => unwrap$2(match$9(effect, {
      onFailure: fail$6,
      onSuccess: () => unit$2
    }))
  })), unwrap$2);
  return new StreamImpl(pipe(toChannel(self), pipeTo(writer)));
});

/** @internal */
const identityStream = () => new StreamImpl(identityChannel());

/** @internal */
const interleave = /*#__PURE__*/dual(2, (self, that) => pipe(self, interleaveWith(that, forever(make$o(true, false)))));

/** @internal */
const interleaveWith = /*#__PURE__*/dual(3, (self, that, decider) => {
  const producer = handoff => readWithCause({
    onInput: value => flatMap$3(fromEffect$3(offer$2(handoff, of(value))), () => producer(handoff)),
    onFailure: cause => fromEffect$3(offer$2(handoff, failCause$1(cause))),
    onDone: () => fromEffect$3(offer$2(handoff, end))
  });
  return new StreamImpl(unwrapScoped$2(pipe(make$q(), zip$5(make$q()), tap$3(([left]) => pipe(toChannel(self), concatMap(writeChunk), pipeTo(producer(left)), runScoped$1, forkScoped)), tap$3(([_, right]) => pipe(toChannel(that), concatMap(writeChunk), pipeTo(producer(right)), runScoped$1, forkScoped)), map$6(([left, right]) => {
    const process = (leftDone, rightDone) => readWithCause({
      onInput: bool => {
        if (bool && !leftDone) {
          return pipe(fromEffect$3(take$3(left)), flatMap$3(match$1({
            onEnd: () => rightDone ? unit$2 : process(true, rightDone),
            onFailure: failCause$4,
            onSuccess: chunk => pipe(write(chunk), flatMap$3(() => process(leftDone, rightDone)))
          })));
        }
        if (!bool && !rightDone) {
          return pipe(fromEffect$3(take$3(right)), flatMap$3(match$1({
            onEnd: () => leftDone ? unit$2 : process(leftDone, true),
            onFailure: failCause$4,
            onSuccess: chunk => pipe(write(chunk), flatMap$3(() => process(leftDone, rightDone)))
          })));
        }
        return process(leftDone, rightDone);
      },
      onFailure: failCause$4,
      onDone: () => unit$2
    });
    return pipe(toChannel(decider), concatMap(writeChunk), pipeTo(process(false, false)));
  }))));
});

/** @internal */
const intersperse = /*#__PURE__*/dual(2, (self, element) => new StreamImpl(pipe(toChannel(self), pipeToOrFail(suspend$4(() => {
  const writer = isFirst => readWithCause({
    onInput: chunk => {
      const builder = [];
      let flagResult = isFirst;
      for (const output of chunk) {
        if (flagResult) {
          flagResult = false;
          builder.push(output);
        } else {
          builder.push(element);
          builder.push(output);
        }
      }
      return pipe(write(unsafeFromArray(builder)), flatMap$3(() => writer(flagResult)));
    },
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  return writer(true);
})))));

/** @internal */
const intersperseAffixes = /*#__PURE__*/dual(2, (self, {
  end,
  middle,
  start
}) => pipe(make$o(start), concat(pipe(self, intersperse(middle))), concat(make$o(end))));

/** @internal */
const interruptAfter = /*#__PURE__*/dual(2, (self, duration) => pipe(self, interruptWhen(sleep$2(duration))));

/** @internal */
const interruptWhen = /*#__PURE__*/dual(2, (self, effect) => new StreamImpl(pipe(toChannel(self), interruptWhen$1(effect))));

/** @internal */
const interruptWhenDeferred = /*#__PURE__*/dual(2, (self, deferred) => new StreamImpl(pipe(toChannel(self), interruptWhenDeferred$1(deferred))));

/** @internal */
const iterate$1 = (value, next) => unfold(value, a => some$6([a, next(a)]));

/** @internal */
const make$o = (...as) => fromIterable$4(as);

/** @internal */
const map$2 = /*#__PURE__*/dual(2, (self, f) => new StreamImpl(pipe(toChannel(self), mapOut(map$l(f)))));

/** @internal */
const mapAccum = /*#__PURE__*/dual(3, (self, s, f) => {
  const accumulator = s => readWith({
    onInput: input => {
      const [nextS, chunk] = mapAccum$3(input, s, f);
      return flatMap$3(write(chunk), () => accumulator(nextS));
    },
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(accumulator(s))));
});

/** @internal */
const mapAccumEffect = /*#__PURE__*/dual(3, (self, s, f) => suspend$2(() => {
  const accumulator = s => readWith({
    onInput: input => pipe(suspend$5(() => {
      const outputs = [];
      const emit = output => sync$4(() => {
        outputs.push(output);
      });
      return pipe(input, reduce$5(s, (s, a) => pipe(f(s, a), flatMap$4(([s, a]) => pipe(emit(a), as$4(s))))), match$9({
        onFailure: error => {
          if (outputs.length !== 0) {
            return zipRight$3(write(unsafeFromArray(outputs)), fail$6(error));
          }
          return fail$6(error);
        },
        onSuccess: s => flatMap$3(write(unsafeFromArray(outputs)), () => accumulator(s))
      }));
    }), unwrap$2),
    onFailure: fail$6,
    onDone: () => unit$2
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(accumulator(s))));
}));

/** @internal */
const mapBoth$1 = /*#__PURE__*/dual(2, (self, options) => pipe(self, mapError$1(options.onFailure), map$2(options.onSuccess)));

/** @internal */
const mapChunks = /*#__PURE__*/dual(2, (self, f) => new StreamImpl(pipe(toChannel(self), mapOut(f))));

/** @internal */
const mapChunksEffect = /*#__PURE__*/dual(2, (self, f) => new StreamImpl(pipe(toChannel(self), mapOutEffect(f))));

/** @internal */
const mapConcat = /*#__PURE__*/dual(2, (self, f) => pipe(self, mapConcatChunk(a => fromIterable$b(f(a)))));

/** @internal */
const mapConcatChunk = /*#__PURE__*/dual(2, (self, f) => pipe(self, mapChunks(flatMap$b(f))));

/** @internal */
const mapConcatChunkEffect = /*#__PURE__*/dual(2, (self, f) => pipe(self, mapEffectSequential(f), mapConcatChunk(identity$1)));

/** @internal */
const mapConcatEffect = /*#__PURE__*/dual(2, (self, f) => pipe(self, mapEffectSequential(a => pipe(f(a), map$6(fromIterable$b))), mapConcatChunk(identity$1)));

/** @internal */
const mapEffectSequential = /*#__PURE__*/dual(2, (self, f) => {
  const loop = iterator => {
    const next = iterator.next();
    if (next.done) {
      return readWithCause({
        onInput: elem => loop(elem[Symbol.iterator]()),
        onFailure: failCause$4,
        onDone: succeed$6
      });
    } else {
      const value = next.value;
      return unwrap$2(map$6(f(value), a2 => flatMap$3(write(of$3(a2)), () => loop(iterator))));
    }
  };
  return new StreamImpl(pipe(toChannel(self), pipeTo(suspend$4(() => loop(empty$z()[Symbol.iterator]())))));
});

/** @internal */
const mapEffectPar = /*#__PURE__*/dual(3, (self, n, f) => new StreamImpl(pipe(toChannel(self), concatMap(writeChunk), mapOutEffectPar(f, n), mapOut(of$3))));

/** @internal */
const mapError$1 = /*#__PURE__*/dual(2, (self, f) => new StreamImpl(pipe(toChannel(self), mapError$3(f))));

/** @internal */
const mapErrorCause = /*#__PURE__*/dual(2, (self, f) => new StreamImpl(pipe(toChannel(self), mapErrorCause$1(f))));

/** @internal */
const merge$2 = /*#__PURE__*/dual(args => isStream(args[1]), (self, that, options) => mergeWith(self, that, {
  onSelf: identity$1,
  onOther: identity$1,
  haltStrategy: options?.haltStrategy
}));

/** @internal */
const mergeAll$1 = /*#__PURE__*/dual(args => Symbol.iterator in args[0], (streams, options) => flatten$1(fromIterable$4(streams), options));

/** @internal */
const mergeEither = /*#__PURE__*/dual(2, (self, that) => mergeWith(self, that, {
  onSelf: left,
  onOther: right
}));

/** @internal */
const mergeLeft = /*#__PURE__*/dual(2, (self, that) => pipe(self, merge$2(drain(that))));

/** @internal */
const mergeRight = /*#__PURE__*/dual(2, (self, that) => pipe(drain(self), merge$2(that)));

/** @internal */
const mergeWith = /*#__PURE__*/dual(3, (self, other, options) => {
  const strategy = options.haltStrategy ? fromInput(options.haltStrategy) : Both;
  const handler = terminate => exit => terminate || !isSuccess$5(exit) ?
  // TODO: remove
  Done(suspend$5(() => exit)) : Await(exit => suspend$5(() => exit));
  return new StreamImpl(mergeWith$1(toChannel(map$2(self, options.onSelf)), {
    other: toChannel(map$2(other, options.onOther)),
    onSelfDone: handler(strategy._tag === "Either" || strategy._tag === "Left"),
    onOtherDone: handler(strategy._tag === "Either" || strategy._tag === "Right")
  }));
});

/** @internal */
const mkString = self => run(self, mkString$1);

/** @internal */
const never$1 = /*#__PURE__*/fromEffect(never$4);

/** @internal */
const onError = /*#__PURE__*/dual(2, (self, cleanup) => pipe(self, catchAllCause(cause => fromEffect(pipe(cleanup(cause), zipRight$4(failCause$5(cause)))))));

/** @internal */
const onDone = /*#__PURE__*/dual(2, (self, cleanup) => new StreamImpl(pipe(toChannel(self), ensuringWith$2(exit => isSuccess$5(exit) ? cleanup() : unit$3))));

/** @internal */
const orDie$1 = self => pipe(self, orDieWith$1(identity$1));

/** @internal */
const orDieWith$1 = /*#__PURE__*/dual(2, (self, f) => new StreamImpl(pipe(toChannel(self), orDieWith$2(f))));

/** @internal */
const orElse$2 = /*#__PURE__*/dual(2, (self, that) => new StreamImpl(pipe(toChannel(self), orElse$4(() => toChannel(that())))));

/** @internal */
const orElseEither$1 = /*#__PURE__*/dual(2, (self, that) => pipe(self, map$2(left), orElse$2(() => pipe(that(), map$2(right)))));

/** @internal */
const orElseFail$1 = /*#__PURE__*/dual(2, (self, error) => pipe(self, orElse$2(() => failSync$1(error))));

/** @internal */
const orElseIfEmpty = /*#__PURE__*/dual(2, (self, element) => pipe(self, orElseIfEmptyChunk(() => of$3(element()))));

/** @internal */
const orElseIfEmptyChunk = /*#__PURE__*/dual(2, (self, chunk) => pipe(self, orElseIfEmptyStream(() => new StreamImpl(write(chunk())))));

/** @internal */
const orElseIfEmptyStream = /*#__PURE__*/dual(2, (self, stream) => {
  const writer = readWith({
    onInput: input => {
      if (isEmpty$h(input)) {
        return suspend$4(() => writer);
      }
      return pipe(write(input), zipRight$3(identityChannel()));
    },
    onFailure: fail$6,
    onDone: () => suspend$4(() => toChannel(stream()))
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(writer)));
});

/** @internal */
const orElseSucceed$1 = /*#__PURE__*/dual(2, (self, value) => pipe(self, orElse$2(() => sync$1(value))));

/** @internal */
const paginate = (s, f) => paginateChunk(s, s => {
  const page = f(s);
  return [of$3(page[0]), page[1]];
});

/** @internal */
const paginateChunk = (s, f) => {
  const loop = s => {
    const page = f(s);
    return match$j(page[1], {
      onNone: () => zipRight$3(write(page[0]), unit$2),
      onSome: s => flatMap$3(write(page[0]), () => loop(s))
    });
  };
  return new StreamImpl(suspend$4(() => loop(s)));
};

/** @internal */
const paginateChunkEffect = (s, f) => {
  const loop = s => unwrap$2(map$6(f(s), ([chunk, option]) => match$j(option, {
    onNone: () => zipRight$3(write(chunk), unit$2),
    onSome: s => flatMap$3(write(chunk), () => loop(s))
  })));
  return new StreamImpl(suspend$4(() => loop(s)));
};

/** @internal */
const paginateEffect = (s, f) => paginateChunkEffect(s, s => pipe(f(s), map$6(([a, s]) => [of$3(a), s])));

/** @internal */
const peel = /*#__PURE__*/dual(2, (self, sink) => {
  const OP_EMIT = "Emit";
  const OP_HALT = "Halt";
  const OP_END = "End";
  return pipe(make$R(), flatMap$4(deferred => pipe(make$q(), map$6(handoff => {
    const consumer = foldSink(collectLeftover(sink), {
      onFailure: error => zipRight$2(fromEffect$2(fail$e(deferred, error)), fail$5(error)),
      onSuccess: ([z, leftovers]) => {
        const loop = readWithCause({
          onInput: elements => flatMap$3(fromEffect$3(offer$2(handoff, {
            _tag: OP_EMIT,
            elements
          })), () => loop),
          onFailure: cause => zipRight$3(fromEffect$3(offer$2(handoff, {
            _tag: OP_HALT,
            cause
          })), failCause$4(cause)),
          onDone: _ => zipRight$3(fromEffect$3(offer$2(handoff, {
            _tag: OP_END
          })), unit$2)
        });
        return fromChannel$1(pipe(fromEffect$3(succeed$g(deferred, z)), zipRight$3(fromEffect$3(pipe(handoff, offer$2({
          _tag: OP_EMIT,
          elements: leftovers
        })))), zipRight$3(loop)));
      }
    });
    const producer = pipe(take$3(handoff), map$6(signal => {
      switch (signal._tag) {
        case OP_EMIT:
          {
            return pipe(write(signal.elements), flatMap$3(() => producer));
          }
        case OP_HALT:
          {
            return failCause$4(signal.cause);
          }
        case OP_END:
          {
            return unit$2;
          }
      }
    }), unwrap$2);
    return pipe(self, tapErrorCause(cause => failCause$9(deferred, cause)), run(consumer), forkScoped, zipRight$4(_await$3(deferred)), map$6(z => [z, new StreamImpl(producer)]));
  }))), flatten$3);
});

/** @internal */
const partition$1 = /*#__PURE__*/dual(args => typeof args[1] === "function", (self, predicate, options) => partitionEither(self, a => succeed$7(predicate(a) ? left(a) : right(a)), options));

/** @internal */
const partitionEither = /*#__PURE__*/dual(args => typeof args[1] === "function", (self, predicate, options) => pipe(mapEffectSequential(self, predicate), distributedWith({
  size: 2,
  maximumLag: options?.bufferSize ?? 16,
  decide: match$i({
    onLeft: () => succeed$7(n => n === 0),
    onRight: () => succeed$7(n => n === 1)
  })
}), flatMap$4(([queue1, queue2]) => succeed$7([filterMap(flattenExitOption(fromQueue(queue1, {
  shutdown: true
})), _ => match$i(_, {
  onLeft: some$6,
  onRight: none$8
})), filterMap(flattenExitOption(fromQueue(queue2, {
  shutdown: true
})), _ => match$i(_, {
  onLeft: none$8,
  onRight: some$6
}))]))));

/** @internal */
const pipeThrough = /*#__PURE__*/dual(2, (self, sink) => new StreamImpl(pipe(toChannel(self), pipeToOrFail(toChannel$1(sink)))));

/** @internal */
const pipeThroughChannel = /*#__PURE__*/dual(2, (self, channel) => new StreamImpl(pipe(toChannel(self), pipeTo(channel))));

/** @internal */
const pipeThroughChannelOrFail = /*#__PURE__*/dual(2, (self, chan) => new StreamImpl(pipe(toChannel(self), pipeToOrFail(chan))));

/** @internal */
const prepend = /*#__PURE__*/dual(2, (self, values) => new StreamImpl(zipRight$3(write(values), toChannel(self))));

/** @internal */
const provideContext$2 = /*#__PURE__*/dual(2, (self, context) => new StreamImpl(pipe(toChannel(self), provideContext$4(context))));

/** @internal */
const provideLayer = /*#__PURE__*/dual(2, (self, layer) => new StreamImpl(unwrapScoped$2(pipe(build(layer), map$6(env => pipe(toChannel(self), provideContext$4(env)))))));

/** @internal */
const provideService$1 = /*#__PURE__*/dual(3, (self, tag, resource) => provideServiceEffect(self, tag, succeed$7(resource)));

/** @internal */
const provideServiceEffect = /*#__PURE__*/dual(3, (self, tag, effect) => provideServiceStream(self, tag, fromEffect(effect)));

/** @internal */
const provideServiceStream = /*#__PURE__*/dual(3, (self, tag, stream) => contextWithStream(env => flatMap$1(stream, service => pipe(self, provideContext$2(add$4(env, tag, service))))));

/** @internal */
const mapInputContext$2 = /*#__PURE__*/dual(2, (self, f) => contextWithStream(env => pipe(self, provideContext$2(f(env)))));

/** @internal */
const provideSomeLayer = /*#__PURE__*/dual(2, (self, layer) =>
// @ts-expect-error
pipe(self, provideLayer(pipe(context$4(), merge$3(layer)))));

/** @internal */
const range = (min, max, chunkSize = DefaultChunkSize) => suspend$2(() => {
  if (min > max) {
    return empty$6;
  }
  const go = (min, max, chunkSize) => {
    const remaining = max - min + 1;
    if (remaining > chunkSize) {
      return pipe(write(range$1(min, min + chunkSize - 1)), flatMap$3(() => go(min + chunkSize, max, chunkSize)));
    }
    return write(range$1(min, min + remaining - 1));
  };
  return new StreamImpl(go(min, max, chunkSize));
});

/** @internal */
const rechunk = /*#__PURE__*/dual(2, (self, n) => suspend$2(() => {
  const target = Math.max(n, 1);
  const process = rechunkProcess(new StreamRechunker(target), target);
  return new StreamImpl(pipe(toChannel(self), pipeTo(process)));
}));

/** @internal */
const rechunkProcess = (rechunker, target) => readWithCause({
  onInput: chunk => {
    if (chunk.length === target && rechunker.isEmpty()) {
      return flatMap$3(write(chunk), () => rechunkProcess(rechunker, target));
    }
    if (chunk.length > 0) {
      const chunks = [];
      let result = undefined;
      let index = 0;
      while (index < chunk.length) {
        while (index < chunk.length && result === undefined) {
          result = rechunker.write(pipe(chunk, unsafeGet$5(index)));
          index = index + 1;
        }
        if (result !== undefined) {
          chunks.push(result);
          result = undefined;
        }
      }
      return flatMap$3(writeAll(...chunks), () => rechunkProcess(rechunker, target));
    }
    return suspend$4(() => rechunkProcess(rechunker, target));
  },
  onFailure: cause => zipRight$3(rechunker.emitIfNotEmpty(), failCause$4(cause)),
  onDone: () => rechunker.emitIfNotEmpty()
});

/** @internal */
class StreamRechunker {
  builder = [];
  pos = 0;
  constructor(n) {
    this.n = n;
  }
  isEmpty() {
    return this.pos === 0;
  }
  write(elem) {
    this.builder.push(elem);
    this.pos += 1;
    if (this.pos === this.n) {
      const result = unsafeFromArray(this.builder);
      this.builder = [];
      this.pos = 0;
      return result;
    }
    return undefined;
  }
  emitIfNotEmpty() {
    if (this.pos !== 0) {
      return write(unsafeFromArray(this.builder));
    }
    return unit$2;
  }
}

/** @internal */
const refineOrDie$1 = /*#__PURE__*/dual(2, (self, pf) => pipe(self, refineOrDieWith$1(pf, identity$1)));

/** @internal */
const refineOrDieWith$1 = /*#__PURE__*/dual(3, (self, pf, f) => new StreamImpl(catchAll$2(toChannel(self), error => match$j(pf(error), {
  onNone: () => failCause$4(die$7(f(error))),
  onSome: fail$6
}))));

/** @internal */
const repeat = /*#__PURE__*/dual(2, (self, schedule) => filterMap(repeatEither(self, schedule), _ => match$i(_, {
  onLeft: none$8,
  onRight: some$6
})));

/** @internal */
const repeatEffect = effect => repeatEffectOption(pipe(effect, mapError$4(some$6)));

/** @internal */
const repeatEffectChunk = effect => repeatEffectChunkOption(pipe(effect, mapError$4(some$6)));

/** @internal */
const repeatEffectChunkOption = effect => unfoldChunkEffect(effect, effect => pipe(map$6(effect, chunk => some$6([chunk, effect])), catchAll$3(match$j({
  onNone: () => succeed$7(none$8()),
  onSome: fail$7
}))));

/** @internal */
const repeatEffectOption = effect => repeatEffectChunkOption(pipe(effect, map$6(of$3)));

/** @internal */
const repeatEither = /*#__PURE__*/dual(2, (self, schedule) => repeatWith(self, schedule, {
  onElement: a => right(a),
  onSchedule: left
}));

/** @internal */
const repeatElements = /*#__PURE__*/dual(2, (self, schedule) => filterMap(repeatElementsWith(self, schedule, {
  onElement: a => some$6(a),
  onSchedule: none$8
}), identity$1));

/** @internal */
const repeatElementsWith = /*#__PURE__*/dual(3, (self, schedule, options) => {
  const driver$1 = pipe(driver(schedule), map$6(driver => {
    const feed = input => match$j(head$4(input), {
      onNone: () => loop,
      onSome: a => zipRight$3(write(of$3(options.onElement(a))), step(pipe(input, drop$2(1)), a))
    });
    const step = (input, a) => {
      const advance = pipe(driver.next(a), as$4(pipe(write(of$3(options.onElement(a))), flatMap$3(() => step(input, a)))));
      const reset = pipe(driver.last(), orDie$3, flatMap$4(b => pipe(driver.reset(), map$6(() => pipe(write(of$3(options.onSchedule(b))), zipRight$3(feed(input)))))));
      return pipe(advance, orElse$5(() => reset), unwrap$2);
    };
    const loop = readWith({
      onInput: feed,
      onFailure: fail$6,
      onDone: () => unit$2
    });
    return loop;
  }), unwrap$2);
  return new StreamImpl(pipe(toChannel(self), pipeTo(driver$1)));
});

/** @internal */
const repeatValue = value => new StreamImpl(repeated(write(of$3(value))));

/** @internal */
const repeatWith = /*#__PURE__*/dual(3, (self, schedule, options) => {
  return pipe(driver(schedule), map$6(driver => {
    const scheduleOutput = pipe(driver.last(), orDie$3, map$6(options.onSchedule));
    const process = pipe(self, map$2(options.onElement), toChannel);
    const loop = unwrap$2(match$9(driver.next(void 0), {
      onFailure: () => unit$2,
      onSuccess: () => pipe(process, zipRight$3(pipe(scheduleOutput, map$6(c => pipe(write(of$3(c)), flatMap$3(() => loop))), unwrap$2)))
    }));
    return new StreamImpl(pipe(process, zipRight$3(loop)));
  }), unwrap);
});

/** @internal */
const repeatWithSchedule = (value, schedule) => repeatEffectWithSchedule(succeed$7(value), schedule);

/** @internal */
const repeatEffectWithSchedule = (effect, schedule) => flatMap$1(fromEffect(zip$5(effect, driver(schedule))), ([a, driver]) => concat(succeed$4(a), unfoldEffect(a, s => matchEffect$1(driver.next(s), {
  onFailure: succeed$7,
  onSuccess: () => map$6(effect, nextA => some$6([nextA, nextA]))
}))));

/** @internal */
const retry$4 = /*#__PURE__*/dual(2, (self, schedule) => unwrap(map$6(driver(schedule), driver => {
  const loop = catchAll$1(self, error => unwrap(matchEffect$1(driver.next(error), {
    onFailure: () => fail$7(error),
    onSuccess: () => succeed$7(pipe(loop, tap$1(() => driver.reset())))
  })));
  return loop;
})));

/** @internal */
const run = /*#__PURE__*/dual(2, (self, sink) => pipe(toChannel(self), pipeToOrFail(toChannel$1(sink)), runDrain$1));

/** @internal */
const runCollect = self => pipe(self, run(collectAll$1()));

/** @internal */
const runCount = self => pipe(self, run(count$2));

/** @internal */
const runDrain = self => pipe(self, run(drain$1));

/** @internal */
const runFold = /*#__PURE__*/dual(3, (self, s, f) => pipe(self, runFoldWhileScoped(s, constTrue, f), scoped$2));

/** @internal */
const runFoldEffect = /*#__PURE__*/dual(3, (self, s, f) => pipe(self, runFoldWhileScopedEffect(s, constTrue, f), scoped$2));

/** @internal */
const runFoldScoped = /*#__PURE__*/dual(3, (self, s, f) => pipe(self, runFoldWhileScoped(s, constTrue, f)));

/** @internal */
const runFoldScopedEffect = /*#__PURE__*/dual(3, (self, s, f) => pipe(self, runFoldWhileScopedEffect(s, constTrue, f)));

/** @internal */
const runFoldWhile = /*#__PURE__*/dual(4, (self, s, cont, f) => pipe(self, runFoldWhileScoped(s, cont, f), scoped$2));

/** @internal */
const runFoldWhileEffect = /*#__PURE__*/dual(4, (self, s, cont, f) => pipe(self, runFoldWhileScopedEffect(s, cont, f), scoped$2));

/** @internal */
const runFoldWhileScoped = /*#__PURE__*/dual(4, (self, s, cont, f) => pipe(self, runScoped(fold(s, cont, f))));

/** @internal */
const runFoldWhileScopedEffect = /*#__PURE__*/dual(4, (self, s, cont, f) => pipe(self, runScoped(foldEffect(s, cont, f))));

/** @internal */
const runForEach = /*#__PURE__*/dual(2, (self, f) => pipe(self, run(forEach$5(f))));

/** @internal */
const runForEachChunk = /*#__PURE__*/dual(2, (self, f) => pipe(self, run(forEachChunk(f))));

/** @internal */
const runForEachChunkScoped = /*#__PURE__*/dual(2, (self, f) => pipe(self, runScoped(forEachChunk(f))));

/** @internal */
const runForEachScoped = /*#__PURE__*/dual(2, (self, f) => pipe(self, runScoped(forEach$5(f))));

/** @internal */
const runForEachWhile = /*#__PURE__*/dual(2, (self, f) => pipe(self, run(forEachWhile(f))));

/** @internal */
const runForEachWhileScoped = /*#__PURE__*/dual(2, (self, f) => pipe(self, runScoped(forEachWhile(f))));

/** @internal */
const runHead = self => pipe(self, run(head$1()));

/** @internal */
const runIntoPubSub = /*#__PURE__*/dual(2, (self, pubsub) => pipe(self, runIntoQueue(pubsub)));

/** @internal */
const runIntoPubSubScoped = /*#__PURE__*/dual(2, (self, pubsub) => pipe(self, runIntoQueueScoped(pubsub)));

/** @internal */
const runIntoQueue = /*#__PURE__*/dual(2, (self, queue) => pipe(self, runIntoQueueScoped(queue), scoped$2));

/** @internal */
const runIntoQueueElementsScoped = /*#__PURE__*/dual(2, (self, queue) => {
  const writer = readWithCause({
    onInput: input => flatMap$3(fromEffect$3(offerAll$2(queue, map$l(input, succeed$f))), () => writer),
    onFailure: cause => fromEffect$3(offer$3(queue, failCause$8(map$9(cause, some$6)))),
    onDone: () => fromEffect$3(offer$3(queue, fail$d(none$8())))
  });
  return pipe(pipeTo(toChannel(self), writer), drain$2, runScoped$1, asUnit$2);
});

/** @internal */
const runIntoQueueScoped = /*#__PURE__*/dual(2, (self, queue) => {
  const writer = readWithCause({
    onInput: input => flatMap$3(write(chunk(input)), () => writer),
    onFailure: cause => write(failCause$1(cause)),
    onDone: () => write(end)
  });
  return pipe(pipeTo(toChannel(self), writer), mapOutEffect(take => offer$3(queue, take)), drain$2, runScoped$1, asUnit$2);
});

/** @internal */
const runLast = self => pipe(self, run(last()));

/** @internal */
const runScoped = /*#__PURE__*/dual(2, (self, sink) => pipe(toChannel(self), pipeToOrFail(toChannel$1(sink)), drain$2, runScoped$1));

/** @internal */
const runSum = self => pipe(self, run(sum));

/** @internal */
const scan = /*#__PURE__*/dual(3, (self, s, f) => pipe(self, scanEffect(s, (s, a) => succeed$7(f(s, a)))));

/** @internal */
const scanReduce = /*#__PURE__*/dual(2, (self, f) => pipe(self, scanReduceEffect((a2, a) => succeed$7(f(a2, a)))));

/** @internal */
const scanReduceEffect = /*#__PURE__*/dual(2, (self, f) => pipe(self, mapAccumEffect(none$8(), (option, a) => {
  switch (option._tag) {
    case "None":
      {
        return succeed$7([some$6(a), a]);
      }
    case "Some":
      {
        return pipe(f(option.value, a), map$6(b => [some$6(b), b]));
      }
  }
})));

/** @internal */
const schedule = /*#__PURE__*/dual(2, (self, schedule) => filterMap(scheduleWith(self, schedule, {
  onElement: some$6,
  onSchedule: none$8
}), identity$1));

/** @internal */
const scheduleWith = /*#__PURE__*/dual(3, (self, schedule, options) => {
  const loop = (driver, iterator) => {
    const next = iterator.next();
    if (next.done) {
      return readWithCause({
        onInput: chunk => loop(driver, chunk[Symbol.iterator]()),
        onFailure: failCause$4,
        onDone: succeedNow
      });
    }
    return unwrap$2(matchEffect$1(driver.next(next.value), {
      onFailure: () => pipe(driver.last(), orDie$3, map$6(b => pipe(write(make$11(options.onElement(next.value), options.onSchedule(b))), flatMap$3(() => loop(driver, iterator)))), zipLeft$4(driver.reset())),
      onSuccess: () => succeed$7(pipe(write(of$3(options.onElement(next.value))), flatMap$3(() => loop(driver, iterator))))
    }));
  };
  return new StreamImpl(pipe(fromEffect$3(driver(schedule)), flatMap$3(driver => pipe(toChannel(self), pipeTo(loop(driver, empty$z()[Symbol.iterator]()))))));
});

/** @internal */
const scanEffect = /*#__PURE__*/dual(3, (self, s, f) => new StreamImpl(pipe(write(of$3(s)), flatMap$3(() => toChannel(pipe(self, mapAccumEffect(s, (s, a) => pipe(f(s, a), map$6(s => [s, s])))))))));

/** @internal */
const scoped = effect => new StreamImpl(ensuring$3(scoped$1(pipe(effect, map$6(of$3))), unit$3));

/** @internal */
const some$2 = self => pipe(self, mapError$1(some$6), someOrFail(() => none$8()));

/** @internal */
const someOrElse = /*#__PURE__*/dual(2, (self, fallback) => pipe(self, map$2(getOrElse$3(fallback))));

/** @internal */
const someOrFail = /*#__PURE__*/dual(2, (self, error) => mapEffectSequential(self, match$j({
  onNone: () => failSync$4(error),
  onSome: succeed$7
})));

/** @internal */
const sliding$2 = /*#__PURE__*/dual(2, (self, chunkSize) => slidingSize(self, chunkSize, 1));

/** @internal */
const slidingSize = /*#__PURE__*/dual(3, (self, chunkSize, stepSize) => {
  if (chunkSize <= 0 || stepSize <= 0) {
    return die$2(IllegalArgumentException("Invalid bounds - `chunkSize` and `stepSize` must be greater than zero"));
  }
  return new StreamImpl(suspend$4(() => {
    const queue = new RingBuffer(chunkSize);
    const emitOnStreamEnd = (queueSize, channelEnd) => {
      if (queueSize < chunkSize) {
        const items = queue.toChunk();
        const result = isEmpty$h(items) ? empty$z() : of$3(items);
        return pipe(write(result), flatMap$3(() => channelEnd));
      }
      const lastEmitIndex = queueSize - (queueSize - chunkSize) % stepSize;
      if (lastEmitIndex === queueSize) {
        return channelEnd;
      }
      const leftovers = queueSize - (lastEmitIndex - chunkSize + stepSize);
      const lastItems = pipe(queue.toChunk(), takeRight$1(leftovers));
      const result = isEmpty$h(lastItems) ? empty$z() : of$3(lastItems);
      return pipe(write(result), flatMap$3(() => channelEnd));
    };
    const reader = queueSize => readWithCause({
      onInput: input => flatMap$3(write(filterMap$2(input, (element, index) => {
        queue.put(element);
        const currentIndex = queueSize + index + 1;
        if (currentIndex < chunkSize || (currentIndex - chunkSize) % stepSize > 0) {
          return none$8();
        }
        return some$6(queue.toChunk());
      })), () => reader(queueSize + input.length)),
      onFailure: cause => emitOnStreamEnd(queueSize, failCause$4(cause)),
      onDone: () => emitOnStreamEnd(queueSize, unit$2)
    });
    return pipe(toChannel(self), pipeTo(reader(0)));
  }));
});

/** @internal */
const split = /*#__PURE__*/dual(2, (self, predicate) => {
  const split = (leftovers, input) => {
    const [chunk, remaining] = pipe(leftovers, appendAll$1(input), splitWhere$1(predicate));
    if (isEmpty$h(chunk) || isEmpty$h(remaining)) {
      return loop(pipe(chunk, appendAll$1(pipe(remaining, drop$2(1)))));
    }
    return pipe(write(of$3(chunk)), flatMap$3(() => split(empty$z(), pipe(remaining, drop$2(1)))));
  };
  const loop = leftovers => readWith({
    onInput: input => split(leftovers, input),
    onFailure: fail$6,
    onDone: () => {
      if (isEmpty$h(leftovers)) {
        return unit$2;
      }
      if (isNone$1(pipe(leftovers, findFirst$6(predicate)))) {
        return zipRight$3(write(of$3(leftovers)), unit$2);
      }
      return zipRight$3(split(empty$z(), leftovers), unit$2);
    }
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(loop(empty$z()))));
});

/** @internal */
const splitOnChunk = /*#__PURE__*/dual(2, (self, delimiter) => {
  const next = (leftover, delimiterIndex) => readWithCause({
    onInput: inputChunk => {
      let buffer;
      const [carry, delimiterCursor] = pipe(inputChunk, reduce$h([pipe(leftover, getOrElse$3(() => empty$z())), delimiterIndex], ([carry, delimiterCursor], a) => {
        const concatenated = pipe(carry, append$1(a));
        if (delimiterCursor < delimiter.length && equals$1(a, pipe(delimiter, unsafeGet$5(delimiterCursor)))) {
          if (delimiterCursor + 1 === delimiter.length) {
            if (buffer === undefined) {
              buffer = [];
            }
            buffer.push(pipe(concatenated, take$7(concatenated.length - delimiter.length)));
            return [empty$z(), 0];
          }
          return [concatenated, delimiterCursor + 1];
        }
        return [concatenated, equals$1(a, pipe(delimiter, unsafeGet$5(0))) ? 1 : 0];
      }));
      const output = buffer === undefined ? empty$z() : unsafeFromArray(buffer);
      return flatMap$3(write(output), () => next(isNonEmpty$5(carry) ? some$6(carry) : none$8(), delimiterCursor));
    },
    onFailure: cause => match$j(leftover, {
      onNone: () => failCause$4(cause),
      onSome: chunk => zipRight$3(write(of$3(chunk)), failCause$4(cause))
    }),
    onDone: done => match$j(leftover, {
      onNone: () => succeed$6(done),
      onSome: chunk => zipRight$3(write(of$3(chunk)), succeed$6(done))
    })
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(next(none$8(), 0))));
});

/** @internal */
const splitLines = self => suspend$2(() => {
  let stringBuilder = "";
  let midCRLF = false;
  const splitLinesChunk = chunk => {
    const chunkBuilder = [];
    map$l(chunk, str => {
      if (str.length !== 0) {
        let from = 0;
        let indexOfCR = str.indexOf("\r");
        let indexOfLF = str.indexOf("\n");
        if (midCRLF) {
          if (indexOfLF === 0) {
            chunkBuilder.push(stringBuilder);
            stringBuilder = "";
            from = 1;
            indexOfLF = str.indexOf("\n", from);
          } else {
            stringBuilder = stringBuilder + "\r";
          }
          midCRLF = false;
        }
        while (indexOfCR !== -1 || indexOfLF !== -1) {
          if (indexOfCR === -1 || indexOfLF !== -1 && indexOfLF < indexOfCR) {
            if (stringBuilder.length === 0) {
              chunkBuilder.push(str.substring(from, indexOfLF));
            } else {
              chunkBuilder.push(stringBuilder + str.substring(from, indexOfLF));
              stringBuilder = "";
            }
            from = indexOfLF + 1;
            indexOfLF = str.indexOf("\n", from);
          } else {
            if (str.length === indexOfCR + 1) {
              midCRLF = true;
              indexOfCR = -1;
            } else {
              if (indexOfLF === indexOfCR + 1) {
                if (stringBuilder.length === 0) {
                  chunkBuilder.push(str.substring(from, indexOfCR));
                } else {
                  stringBuilder = stringBuilder + str.substring(from, indexOfCR);
                  chunkBuilder.push(stringBuilder);
                  stringBuilder = "";
                }
                from = indexOfCR + 2;
                indexOfCR = str.indexOf("\r", from);
                indexOfLF = str.indexOf("\n", from);
              } else {
                indexOfCR = str.indexOf("\r", indexOfCR + 1);
              }
            }
          }
        }
        if (midCRLF) {
          stringBuilder = stringBuilder + str.substring(from, str.length - 1);
        } else {
          stringBuilder = stringBuilder + str.substring(from, str.length);
        }
      }
    });
    return unsafeFromArray(chunkBuilder);
  };
  const loop = readWithCause({
    onInput: input => {
      const out = splitLinesChunk(input);
      return isEmpty$h(out) ? loop : flatMap$3(write(out), () => loop);
    },
    onFailure: cause => stringBuilder.length === 0 ? failCause$4(cause) : flatMap$3(write(of$3(stringBuilder)), () => failCause$4(cause)),
    onDone: done => stringBuilder.length === 0 ? succeed$6(done) : flatMap$3(write(of$3(stringBuilder)), () => succeed$6(done))
  });
  return new StreamImpl(pipeTo(toChannel(self), loop));
});

/** @internal */
const succeed$4 = value => fromChunk(of$3(value));

/** @internal */
const sync$1 = evaluate => suspend$2(() => fromChunk(of$3(evaluate())));

/** @internal */
const suspend$2 = stream => new StreamImpl(suspend$4(() => toChannel(stream())));

/** @internal */
const take$2 = /*#__PURE__*/dual(2, (self, n) => {
  if (!Number.isInteger(n)) {
    return die$2(IllegalArgumentException(`${n} must be an integer`));
  }
  const loop = n => readWith({
    onInput: input => {
      const taken = pipe(input, take$7(Math.min(n, Number.POSITIVE_INFINITY)));
      const leftover = Math.max(0, n - taken.length);
      const more = leftover > 0;
      if (more) {
        return pipe(write(taken), flatMap$3(() => loop(leftover)));
      }
      return write(taken);
    },
    onFailure: fail$6,
    onDone: succeed$6
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(0 < n ? loop(n) : unit$2)));
});

/** @internal */
const takeRight = /*#__PURE__*/dual(2, (self, n) => {
  if (n <= 0) {
    return empty$6;
  }
  return new StreamImpl(pipe(succeed$7(new RingBuffer(n)), map$6(queue => {
    const reader = readWith({
      onInput: input => {
        for (const element of input) {
          queue.put(element);
        }
        return reader;
      },
      onFailure: fail$6,
      onDone: () => pipe(write(queue.toChunk()), zipRight$3(unit$2))
    });
    return pipe(toChannel(self), pipeTo(reader));
  }), unwrap$2));
});

/** @internal */
const takeUntil = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = readWith({
    onInput: input => {
      const taken = pipe(input, takeWhile$3(a => !predicate(a)));
      const last = pipe(input, drop$2(taken.length), take$7(1));
      if (isEmpty$h(last)) {
        return pipe(write(taken), flatMap$3(() => loop));
      }
      return write(pipe(taken, appendAll$1(last)));
    },
    onFailure: fail$6,
    onDone: succeed$6
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(loop)));
});

/** @internal */
const takeUntilEffect = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = iterator => {
    const next = iterator.next();
    if (next.done) {
      return readWithCause({
        onInput: elem => loop(elem[Symbol.iterator]()),
        onFailure: failCause$4,
        onDone: succeed$6
      });
    }
    return pipe(predicate(next.value), map$6(bool => bool ? write(of$3(next.value)) : pipe(write(of$3(next.value)), flatMap$3(() => loop(iterator)))), unwrap$2);
  };
  return new StreamImpl(pipe(toChannel(self), pipeTo(loop(empty$z()[Symbol.iterator]()))));
});

/** @internal */
const takeWhile = /*#__PURE__*/dual(2, (self, predicate) => {
  const loop = readWith({
    onInput: input => {
      const taken = pipe(input, takeWhile$3(predicate));
      const more = taken.length === input.length;
      if (more) {
        return pipe(write(taken), flatMap$3(() => loop));
      }
      return write(taken);
    },
    onFailure: fail$6,
    onDone: succeed$6
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(loop)));
});

/** @internal */
const tap$1 = /*#__PURE__*/dual(2, (self, f) => mapEffectSequential(self, a => as$4(f(a), a)));

/** @internal */
const tapBoth$1 = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => pipe(self, tapError$1(onFailure), tap$1(onSuccess)));

/** @internal */
const tapError$1 = /*#__PURE__*/dual(2, (self, f) => catchAll$1(self, error => fromEffect(zipRight$4(f(error), fail$7(error)))));

/** @internal */
const tapErrorCause = /*#__PURE__*/dual(2, (self, f) => {
  const loop = readWithCause({
    onInput: chunk => flatMap$3(write(chunk), () => loop),
    onFailure: cause => fromEffect$3(zipRight$4(f(cause), failCause$5(cause))),
    onDone: succeedNow
  });
  return new StreamImpl(pipe(toChannel(self), pipeTo(loop)));
});

/** @internal */
const tapSink = /*#__PURE__*/dual(2, (self, sink) => pipe(fromEffect(all$1([bounded$2(1), make$R()])), flatMap$1(([queue, deferred]) => {
  const right = flattenTake(fromQueue(queue, {
    maxChunkSize: 1
  }));
  const loop = readWithCause({
    onInput: chunk$1 => pipe(fromEffect$3(offer$3(queue, chunk(chunk$1))), foldCauseChannel({
      onFailure: () => flatMap$3(write(chunk$1), () => identityChannel()),
      onSuccess: () => flatMap$3(write(chunk$1), () => loop)
    })),
    onFailure: cause => pipe(fromEffect$3(offer$3(queue, failCause$1(cause))), foldCauseChannel({
      onFailure: () => failCause$4(cause),
      onSuccess: () => failCause$4(cause)
    })),
    onDone: () => pipe(fromEffect$3(offer$3(queue, end)), foldCauseChannel({
      onFailure: () => unit$2,
      onSuccess: () => unit$2
    }))
  });
  return pipe(new StreamImpl(pipe(pipeTo(toChannel(self), loop), ensuring$3(zipRight$4(forkDaemon(offer$3(queue, end)), _await$3(deferred))))), merge$2(execute(pipe(run(right, sink), ensuring$4(zipRight$4(shutdown$2(queue), succeed$g(deferred, void 0)))))));
})));

/** @internal */
const throttle = /*#__PURE__*/dual(2, (self, options) => throttleEffect(self, {
  ...options,
  cost: chunk => succeed$7(options.cost(chunk))
}));

/** @internal */
const throttleEffect = /*#__PURE__*/dual(2, (self, options) => {
  if (options.strategy === "enforce") {
    return throttleEnforceEffect(self, options.cost, options.units, options.duration, options.burst ?? 0);
  }
  return throttleShapeEffect(self, options.cost, options.units, options.duration, options.burst ?? 0);
});
const throttleEnforceEffect = (self, cost, units, duration, burst) => {
  const loop = (tokens, timestampMillis) => readWithCause({
    onInput: input => pipe(cost(input), zip$5(currentTimeMillis), map$6(([weight, currentTimeMillis]) => {
      const elapsed = currentTimeMillis - timestampMillis;
      const cycles = elapsed / toMillis(duration);
      const sum = tokens + cycles * units;
      const max = units + burst < 0 ? Number.POSITIVE_INFINITY : units + burst;
      const available = sum < 0 ? max : Math.min(sum, max);
      if (weight <= available) {
        return pipe(write(input), flatMap$3(() => loop(available - weight, currentTimeMillis)));
      }
      return loop(tokens, timestampMillis);
    }), unwrap$2),
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  const throttled = pipe(currentTimeMillis, map$6(currentTimeMillis => loop(units, currentTimeMillis)), unwrap$2);
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(throttled)));
};
const throttleShapeEffect = (self, costFn, units, duration, burst) => {
  const loop = (tokens, timestampMillis) => readWithCause({
    onInput: input => pipe(costFn(input), zip$5(currentTimeMillis), map$6(([weight, currentTimeMillis]) => {
      const elapsed = currentTimeMillis - timestampMillis;
      const cycles = elapsed / toMillis(duration);
      const sum = tokens + cycles * units;
      const max = units + burst < 0 ? Number.POSITIVE_INFINITY : units + burst;
      const available = sum < 0 ? max : Math.min(sum, max);
      const remaining = available - weight;
      const waitCycles = remaining >= 0 ? 0 : -remaining / units;
      const delay = millis(Math.max(0, waitCycles * toMillis(duration)));
      if (greaterThan$2(delay, zero)) {
        return pipe(fromEffect$3(sleep$2(delay)), zipRight$3(write(input)), flatMap$3(() => loop(remaining, currentTimeMillis)));
      }
      return flatMap$3(write(input), () => loop(remaining, currentTimeMillis));
    }), unwrap$2),
    onFailure: failCause$4,
    onDone: () => unit$2
  });
  const throttled = pipe(currentTimeMillis, map$6(currentTimeMillis => loop(units, currentTimeMillis)), unwrap$2);
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(throttled)));
};

/** @internal */
const tick = interval => repeatWithSchedule(void 0, spaced(interval));

/** @internal */
const timeout = /*#__PURE__*/dual(2, (self, duration) => pipe(toPull(self), map$6(timeoutFail$1({
  onTimeout: () => none$8(),
  duration
})), fromPull));

/** @internal */
const timeoutFail = /*#__PURE__*/dual(3, (self, error, duration) => pipe(self, timeoutTo(duration, failSync$1(error))));

/** @internal */
const timeoutFailCause = /*#__PURE__*/dual(3, (self, cause, duration) => pipe(toPull(self), map$6(timeoutFailCause$1({
  onTimeout: () => map$9(cause(), some$6),
  duration
})), fromPull));

/** @internal */
const timeoutTo = /*#__PURE__*/dual(3, (self, duration, that) => {
  const StreamTimeout = RuntimeException("Stream Timeout");
  return pipe(self, timeoutFailCause(() => die$7(StreamTimeout), duration), catchSomeCause(cause => isDieType(cause) && isRuntimeException(cause.defect) && cause.defect.message !== undefined && cause.defect.message === "Stream Timeout" ? some$6(that) : none$8()));
});

/** @internal */
const toPubSub = /*#__PURE__*/dual(2, (self, capacity) => pipe(acquireRelease$1(bounded$3(capacity), pubsub => shutdown$3(pubsub)), tap$3(pubsub => pipe(self, runIntoPubSubScoped(pubsub), forkScoped))));

/** @internal */
const toPull = self => map$6(toPull$1(toChannel(self)), pull => pipe(pull, mapError$4(some$6), flatMap$4(match$i({
  onLeft: () => fail$7(none$8()),
  onRight: succeed$7
}))));

/** @internal */
const toQueue = /*#__PURE__*/dual(args => isStream(args[0]), (self, options) => tap$3(acquireRelease$1(options?.strategy === "unbounded" ? unbounded$2() : options?.strategy === "dropping" ? dropping$2(options.capacity ?? 2) : options?.strategy === "sliding" ? sliding$3(options.capacity ?? 2) : bounded$2(options?.capacity ?? 2), queue => shutdown$2(queue)), queue => forkScoped(runIntoQueueScoped(self, queue))));

/** @internal */
const toQueueOfElements = /*#__PURE__*/dual(args => isStream(args[0]), (self, options) => tap$3(acquireRelease$1(bounded$2(options?.capacity ?? 2), queue => shutdown$2(queue)), queue => forkScoped(runIntoQueueElementsScoped(self, queue))));

/** @internal */
const toReadableStream = source => {
  let pull;
  let scope;
  return new ReadableStream({
    start(controller) {
      scope = runSync(make$u());
      pull = pipe(toPull(source), use$1(scope), runSync, tap$3(chunk => sync$4(() => {
        map$l(chunk, a => {
          controller.enqueue(a);
        });
      })), tapErrorCause$1(() => close$1(scope, unit$5)), catchTags$2({
        "None": () => sync$4(() => {
          controller.close();
        }),
        "Some": error => sync$4(() => {
          controller.error(error.value);
        })
      }), asUnit$2);
    },
    pull() {
      return runPromise(pull);
    },
    cancel() {
      return runPromise(close$1(scope, unit$5));
    }
  });
};

/** @internal */
const transduce = /*#__PURE__*/dual(2, (self, sink) => {
  const newChannel = suspend$4(() => {
    const leftovers = {
      ref: empty$z()
    };
    const upstreamDone = {
      ref: false
    };
    const buffer = suspend$4(() => {
      const leftover = leftovers.ref;
      if (isEmpty$h(leftover)) {
        return readWith({
          onInput: input => pipe(write(input), flatMap$3(() => buffer)),
          onFailure: fail$6,
          onDone: succeedNow
        });
      }
      leftovers.ref = empty$z();
      return pipe(writeChunk(leftover), flatMap$3(() => buffer));
    });
    const concatAndGet = chunk => {
      const leftover = leftovers.ref;
      const concatenated = appendAll$1(leftover, filter$9(chunk, chunk => chunk.length !== 0));
      leftovers.ref = concatenated;
      return concatenated;
    };
    const upstreamMarker = readWith({
      onInput: input => flatMap$3(write(input), () => upstreamMarker),
      onFailure: fail$6,
      onDone: done => zipRight$3(sync$3(() => {
        upstreamDone.ref = true;
      }), succeedNow(done))
    });
    const transducer = pipe(sink, toChannel$1, collectElements, flatMap$3(([leftover, z]) => pipe(succeed$6([upstreamDone.ref, concatAndGet(leftover)]), flatMap$3(([done, newLeftovers]) => {
      const nextChannel = done && isEmpty$h(newLeftovers) ? unit$2 : transducer;
      return pipe(write(of$3(z)), flatMap$3(() => nextChannel));
    }))));
    return pipe(toChannel(self), pipeTo(upstreamMarker), pipeTo(buffer), pipeToOrFail(transducer));
  });
  return new StreamImpl(newChannel);
});

/** @internal */
const unfold = (s, f) => unfoldChunk(s, s => pipe(f(s), map$n(([a, s]) => [of$3(a), s])));

/** @internal */
const unfoldChunk = (s, f) => {
  const loop = s => match$j(f(s), {
    onNone: () => unit$2,
    onSome: ([chunk, s]) => flatMap$3(write(chunk), () => loop(s))
  });
  return new StreamImpl(suspend$4(() => loop(s)));
};

/** @internal */
const unfoldChunkEffect = (s, f) => suspend$2(() => {
  const loop = s => unwrap$2(map$6(f(s), match$j({
    onNone: () => unit$2,
    onSome: ([chunk, s]) => flatMap$3(write(chunk), () => loop(s))
  })));
  return new StreamImpl(loop(s));
});

/** @internal */
const unfoldEffect = (s, f) => unfoldChunkEffect(s, s => pipe(f(s), map$6(map$n(([a, s]) => [of$3(a), s]))));

/** @internal */
const unit$1 = /*#__PURE__*/succeed$4(void 0);

/** @internal */
const unwrap = effect => flatten$1(fromEffect(effect));

/** @internal */
const unwrapScoped = effect => flatten$1(scoped(effect));

/** @internal */
const updateService = /*#__PURE__*/dual(3, (self, tag, f) => pipe(self, mapInputContext$2(context => pipe(context, add$4(tag, f(pipe(context, unsafeGet$6(tag))))))));

/** @internal */
const when$2 = /*#__PURE__*/dual(2, (self, predicate) => pipe(self, whenEffect(sync$4(predicate))));

/** @internal */
const whenCase = (evaluate, pf) => whenCaseEffect(pf)(sync$4(evaluate));

/** @internal */
const whenCaseEffect = /*#__PURE__*/dual(2, (self, pf) => pipe(fromEffect(self), flatMap$1(a => pipe(pf(a), getOrElse$3(() => empty$6)))));

/** @internal */
const whenEffect = /*#__PURE__*/dual(2, (self, effect) => pipe(fromEffect(effect), flatMap$1(bool => bool ? self : empty$6)));

/** @internal */
const withSpan = /*#__PURE__*/dual(3, (self, name, options) => new StreamImpl(withSpan$1(toChannel(self), name, options)));

/** @internal */
const zip$2 = /*#__PURE__*/dual(2, (self, that) => pipe(self, zipWith$1(that, (a, a2) => [a, a2])));

/** @internal */
const zipFlatten = /*#__PURE__*/dual(2, (self, that) => pipe(self, zipWith$1(that, (a, a2) => [...a, a2])));

/** @internal */
const zipAll = /*#__PURE__*/dual(2, (self, options) => zipAllWith(self, {
  other: options.other,
  onSelf: a => [a, options.defaultOther],
  onOther: a2 => [options.defaultSelf, a2],
  onBoth: (a, a2) => [a, a2]
}));

/** @internal */
const zipAllLeft = /*#__PURE__*/dual(3, (self, other, defaultSelf) => zipAllWith(self, {
  other,
  onSelf: identity$1,
  onOther: () => defaultSelf,
  onBoth: a => a
}));

/** @internal */
const zipAllRight = /*#__PURE__*/dual(3, (self, other, defaultRight) => zipAllWith(self, {
  other,
  onSelf: () => defaultRight,
  onOther: identity$1,
  onBoth: (_, a2) => a2
}));

/** @internal */
const zipAllSortedByKey = /*#__PURE__*/dual(2, (self, options) => zipAllSortedByKeyWith(self, {
  other: options.other,
  onSelf: a => [a, options.defaultOther],
  onOther: a2 => [options.defaultSelf, a2],
  onBoth: (a, a2) => [a, a2],
  order: options.order
}));

/** @internal */
const zipAllSortedByKeyLeft = /*#__PURE__*/dual(2, (self, options) => zipAllSortedByKeyWith(self, {
  other: options.other,
  onSelf: identity$1,
  onOther: () => options.defaultSelf,
  onBoth: a => a,
  order: options.order
}));

/** @internal */
const zipAllSortedByKeyRight = /*#__PURE__*/dual(2, (self, options) => zipAllSortedByKeyWith(self, {
  other: options.other,
  onSelf: () => options.defaultOther,
  onOther: identity$1,
  onBoth: (_, a2) => a2,
  order: options.order
}));

/** @internal */
const zipAllSortedByKeyWith = /*#__PURE__*/dual(2, (self, options) => {
  const pull = (state, pullLeft, pullRight) => {
    switch (state._tag) {
      case OP_DRAIN_LEFT:
        {
          return pipe(pullLeft, match$9({
            onFailure: fail$d,
            onSuccess: leftChunk => succeed$f([map$l(leftChunk, ([k, a]) => [k, options.onSelf(a)]), DrainLeft])
          }));
        }
      case OP_DRAIN_RIGHT:
        {
          return pipe(pullRight, match$9({
            onFailure: fail$d,
            onSuccess: rightChunk => succeed$f([map$l(rightChunk, ([k, a2]) => [k, options.onOther(a2)]), DrainRight])
          }));
        }
      case OP_PULL_BOTH$1:
        {
          return pipe(unsome$1(pullLeft), zip$5(unsome$1(pullRight), {
            concurrent: true
          }), matchEffect$1({
            onFailure: error => succeed$7(fail$d(some$6(error))),
            onSuccess: ([leftOption, rightOption]) => {
              if (isSome(leftOption) && isSome(rightOption)) {
                if (isEmpty$h(leftOption.value) && isEmpty$h(rightOption.value)) {
                  return pull(PullBoth$1, pullLeft, pullRight);
                }
                if (isEmpty$h(leftOption.value)) {
                  return pull(PullLeft$1(rightOption.value), pullLeft, pullRight);
                }
                if (isEmpty$h(rightOption.value)) {
                  return pull(PullRight$1(leftOption.value), pullLeft, pullRight);
                }
                return succeed$7(succeed$f(merge(leftOption.value, rightOption.value)));
              }
              if (isSome(leftOption) && isNone$1(rightOption)) {
                if (isEmpty$h(leftOption.value)) {
                  return pull(DrainLeft, pullLeft, pullRight);
                }
                return succeed$7(succeed$f([pipe(leftOption.value, map$l(([k, a]) => [k, options.onSelf(a)])), DrainLeft]));
              }
              if (isNone$1(leftOption) && isSome(rightOption)) {
                if (isEmpty$h(rightOption.value)) {
                  return pull(DrainRight, pullLeft, pullRight);
                }
                return succeed$7(succeed$f([pipe(rightOption.value, map$l(([k, a2]) => [k, options.onOther(a2)])), DrainRight]));
              }
              return succeed$7(fail$d(none$8()));
            }
          }));
        }
      case OP_PULL_LEFT$1:
        {
          return matchEffect$1(pullLeft, {
            onFailure: match$j({
              onNone: () => succeed$7(succeed$f([pipe(state.rightChunk, map$l(([k, a2]) => [k, options.onOther(a2)])), DrainRight])),
              onSome: error => succeed$7(fail$d(some$6(error)))
            }),
            onSuccess: leftChunk => isEmpty$h(leftChunk) ? pull(PullLeft$1(state.rightChunk), pullLeft, pullRight) : succeed$7(succeed$f(merge(leftChunk, state.rightChunk)))
          });
        }
      case OP_PULL_RIGHT$1:
        {
          return matchEffect$1(pullRight, {
            onFailure: match$j({
              onNone: () => succeed$7(succeed$f([map$l(state.leftChunk, ([k, a]) => [k, options.onSelf(a)]), DrainLeft])),
              onSome: error => succeed$7(fail$d(some$6(error)))
            }),
            onSuccess: rightChunk => isEmpty$h(rightChunk) ? pull(PullRight$1(state.leftChunk), pullLeft, pullRight) : succeed$7(succeed$f(merge(state.leftChunk, rightChunk)))
          });
        }
    }
  };
  const merge = (leftChunk, rightChunk) => {
    const hasNext = (chunk, index) => index < chunk.length - 1;
    const builder = [];
    let state = undefined;
    let leftIndex = 0;
    let rightIndex = 0;
    let leftTuple = pipe(leftChunk, unsafeGet$5(leftIndex));
    let rightTuple = pipe(rightChunk, unsafeGet$5(rightIndex));
    let k1 = leftTuple[0];
    let a = leftTuple[1];
    let k2 = rightTuple[0];
    let a2 = rightTuple[1];
    let loop = true;
    while (loop) {
      const compare = options.order(k1, k2);
      if (compare === 0) {
        builder.push([k1, options.onBoth(a, a2)]);
        if (hasNext(leftChunk, leftIndex) && hasNext(rightChunk, rightIndex)) {
          leftIndex = leftIndex + 1;
          rightIndex = rightIndex + 1;
          leftTuple = pipe(leftChunk, unsafeGet$5(leftIndex));
          rightTuple = pipe(rightChunk, unsafeGet$5(rightIndex));
          k1 = leftTuple[0];
          a = leftTuple[1];
          k2 = rightTuple[0];
          a2 = rightTuple[1];
        } else if (hasNext(leftChunk, leftIndex)) {
          state = PullRight$1(pipe(leftChunk, drop$2(leftIndex + 1)));
          loop = false;
        } else if (hasNext(rightChunk, rightIndex)) {
          state = PullLeft$1(pipe(rightChunk, drop$2(rightIndex + 1)));
          loop = false;
        } else {
          state = PullBoth$1;
          loop = false;
        }
      } else if (compare < 0) {
        builder.push([k1, options.onSelf(a)]);
        if (hasNext(leftChunk, leftIndex)) {
          leftIndex = leftIndex + 1;
          leftTuple = pipe(leftChunk, unsafeGet$5(leftIndex));
          k1 = leftTuple[0];
          a = leftTuple[1];
        } else {
          const rightBuilder = [];
          rightBuilder.push(rightTuple);
          while (hasNext(rightChunk, rightIndex)) {
            rightIndex = rightIndex + 1;
            rightTuple = pipe(rightChunk, unsafeGet$5(rightIndex));
            rightBuilder.push(rightTuple);
          }
          state = PullLeft$1(unsafeFromArray(rightBuilder));
          loop = false;
        }
      } else {
        builder.push([k2, options.onOther(a2)]);
        if (hasNext(rightChunk, rightIndex)) {
          rightIndex = rightIndex + 1;
          rightTuple = pipe(rightChunk, unsafeGet$5(rightIndex));
          k2 = rightTuple[0];
          a2 = rightTuple[1];
        } else {
          const leftBuilder = [];
          leftBuilder.push(leftTuple);
          while (hasNext(leftChunk, leftIndex)) {
            leftIndex = leftIndex + 1;
            leftTuple = pipe(leftChunk, unsafeGet$5(leftIndex));
            leftBuilder.push(leftTuple);
          }
          state = PullRight$1(unsafeFromArray(leftBuilder));
          loop = false;
        }
      }
    }
    return [unsafeFromArray(builder), state];
  };
  return combineChunks(self, options.other, PullBoth$1, pull);
});

/** @internal */
const zipAllWith = /*#__PURE__*/dual(2, (self, options) => {
  const pull = (state, pullLeft, pullRight) => {
    switch (state._tag) {
      case OP_DRAIN_LEFT:
        {
          return matchEffect$1(pullLeft, {
            onFailure: error => succeed$7(fail$d(error)),
            onSuccess: leftChunk => succeed$7(succeed$f([map$l(leftChunk, options.onSelf), DrainLeft]))
          });
        }
      case OP_DRAIN_RIGHT:
        {
          return matchEffect$1(pullRight, {
            onFailure: error => succeed$7(fail$d(error)),
            onSuccess: rightChunk => succeed$7(succeed$f([map$l(rightChunk, options.onOther), DrainRight]))
          });
        }
      case OP_PULL_BOTH$1:
        {
          return pipe(unsome$1(pullLeft), zip$5(unsome$1(pullRight), {
            concurrent: true
          }), matchEffect$1({
            onFailure: error => succeed$7(fail$d(some$6(error))),
            onSuccess: ([leftOption, rightOption]) => {
              if (isSome(leftOption) && isSome(rightOption)) {
                if (isEmpty$h(leftOption.value) && isEmpty$h(rightOption.value)) {
                  return pull(PullBoth$1, pullLeft, pullRight);
                }
                if (isEmpty$h(leftOption.value)) {
                  return pull(PullLeft$1(rightOption.value), pullLeft, pullRight);
                }
                if (isEmpty$h(rightOption.value)) {
                  return pull(PullRight$1(leftOption.value), pullLeft, pullRight);
                }
                return succeed$7(succeed$f(zip(leftOption.value, rightOption.value, options.onBoth)));
              }
              if (isSome(leftOption) && isNone$1(rightOption)) {
                return succeed$7(succeed$f([map$l(leftOption.value, options.onSelf), DrainLeft]));
              }
              if (isNone$1(leftOption) && isSome(rightOption)) {
                return succeed$7(succeed$f([map$l(rightOption.value, options.onOther), DrainRight]));
              }
              return succeed$7(fail$d(none$8()));
            }
          }));
        }
      case OP_PULL_LEFT$1:
        {
          return matchEffect$1(pullLeft, {
            onFailure: match$j({
              onNone: () => succeed$7(succeed$f([map$l(state.rightChunk, options.onOther), DrainRight])),
              onSome: error => succeed$7(fail$d(some$6(error)))
            }),
            onSuccess: leftChunk => {
              if (isEmpty$h(leftChunk)) {
                return pull(PullLeft$1(state.rightChunk), pullLeft, pullRight);
              }
              if (isEmpty$h(state.rightChunk)) {
                return pull(PullRight$1(leftChunk), pullLeft, pullRight);
              }
              return succeed$7(succeed$f(zip(leftChunk, state.rightChunk, options.onBoth)));
            }
          });
        }
      case OP_PULL_RIGHT$1:
        {
          return matchEffect$1(pullRight, {
            onFailure: match$j({
              onNone: () => succeed$7(succeed$f([map$l(state.leftChunk, options.onSelf), DrainLeft])),
              onSome: error => succeed$7(fail$d(some$6(error)))
            }),
            onSuccess: rightChunk => {
              if (isEmpty$h(rightChunk)) {
                return pull(PullRight$1(state.leftChunk), pullLeft, pullRight);
              }
              if (isEmpty$h(state.leftChunk)) {
                return pull(PullLeft$1(rightChunk), pullLeft, pullRight);
              }
              return succeed$7(succeed$f(zip(state.leftChunk, rightChunk, options.onBoth)));
            }
          });
        }
    }
  };
  const zip = (leftChunk, rightChunk, f) => {
    const [output, either] = zipChunks(leftChunk, rightChunk, f);
    switch (either._tag) {
      case "Left":
        {
          if (isEmpty$h(either.left)) {
            return [output, PullBoth$1];
          }
          return [output, PullRight$1(either.left)];
        }
      case "Right":
        {
          if (isEmpty$h(either.right)) {
            return [output, PullBoth$1];
          }
          return [output, PullLeft$1(either.right)];
        }
    }
  };
  return combineChunks(self, options.other, PullBoth$1, pull);
});

/** @internal */
const zipLatest = /*#__PURE__*/dual(2, (self, that) => pipe(self, zipLatestWith(that, (a, a2) => [a, a2])));

/** @internal */
const zipLatestWith = /*#__PURE__*/dual(3, (self, that, f) => {
  const pullNonEmpty = pull => pipe(pull, flatMap$4(chunk => isEmpty$h(chunk) ? pullNonEmpty(pull) : succeed$7(chunk)));
  return pipe(toPull(self), map$6(pullNonEmpty), zip$5(pipe(toPull(that), map$6(pullNonEmpty))), flatMap$4(([left, right]) => pipe(fromEffectOption(raceWith$1(left, right, {
    onSelfDone: (leftDone, rightFiber) => pipe(suspend$5(() => leftDone), zipWith$3(join(rightFiber), (l, r) => [l, r, true])),
    onOtherDone: (rightDone, leftFiber) => pipe(suspend$5(() => rightDone), zipWith$3(join(leftFiber), (l, r) => [r, l, false]))
  })), flatMap$1(([l, r, leftFirst]) => pipe(fromEffect(make$G([unsafeLast(l), unsafeLast(r)])), flatMap$1(latest => pipe(fromChunk(leftFirst ? pipe(r, map$l(a2 => f(unsafeLast(l), a2))) : pipe(l, map$l(a => f(a, unsafeLast(r))))), concat(pipe(repeatEffectOption(left), mergeEither(repeatEffectOption(right)), mapEffectSequential(match$i({
    onLeft: leftChunk => pipe(modify$3(latest, ([_, rightLatest]) => [pipe(leftChunk, map$l(a => f(a, rightLatest))), [unsafeLast(leftChunk), rightLatest]])),
    onRight: rightChunk => pipe(modify$3(latest, ([leftLatest, _]) => [pipe(rightChunk, map$l(a2 => f(leftLatest, a2))), [leftLatest, unsafeLast(rightChunk)]]))
  })), flatMap$1(fromChunk))))))), toPull)), fromPull);
});

/** @internal */
const zipLeft$1 = /*#__PURE__*/dual(2, (self, that) => pipe(self, zipWithChunks(that, (left$1, right$1) => {
  if (left$1.length > right$1.length) {
    return [pipe(left$1, take$7(right$1.length)), left(pipe(left$1, take$7(right$1.length)))];
  }
  return [left$1, right(pipe(right$1, drop$2(left$1.length)))];
})));

/** @internal */
const zipRight$1 = /*#__PURE__*/dual(2, (self, that) => pipe(self, zipWithChunks(that, (left$1, right$1) => {
  if (left$1.length > right$1.length) {
    return [right$1, left(pipe(left$1, take$7(right$1.length)))];
  }
  return [pipe(right$1, take$7(left$1.length)), right(pipe(right$1, drop$2(left$1.length)))];
})));

/** @internal */
const zipWith$1 = /*#__PURE__*/dual(3, (self, that, f) => pipe(self, zipWithChunks(that, (leftChunk, rightChunk) => zipChunks(leftChunk, rightChunk, f))));

/** @internal */
const zipWithChunks = /*#__PURE__*/dual(3, (self, that, f) => {
  const pull = (state, pullLeft, pullRight) => {
    switch (state._tag) {
      case OP_PULL_BOTH:
        {
          return pipe(unsome$1(pullLeft), zip$5(unsome$1(pullRight), {
            concurrent: true
          }), matchEffect$1({
            onFailure: error => succeed$7(fail$d(some$6(error))),
            onSuccess: ([leftOption, rightOption]) => {
              if (isSome(leftOption) && isSome(rightOption)) {
                if (isEmpty$h(leftOption.value) && isEmpty$h(rightOption.value)) {
                  return pull(PullBoth, pullLeft, pullRight);
                }
                if (isEmpty$h(leftOption.value)) {
                  return pull(PullLeft(rightOption.value), pullLeft, pullRight);
                }
                if (isEmpty$h(rightOption.value)) {
                  return pull(PullRight(leftOption.value), pullLeft, pullRight);
                }
                return succeed$7(succeed$f(zip(leftOption.value, rightOption.value)));
              }
              return succeed$7(fail$d(none$8()));
            }
          }));
        }
      case OP_PULL_LEFT:
        {
          return matchEffect$1(pullLeft, {
            onFailure: error => succeed$7(fail$d(error)),
            onSuccess: leftChunk => {
              if (isEmpty$h(leftChunk)) {
                return pull(PullLeft(state.rightChunk), pullLeft, pullRight);
              }
              if (isEmpty$h(state.rightChunk)) {
                return pull(PullRight(leftChunk), pullLeft, pullRight);
              }
              return succeed$7(succeed$f(zip(leftChunk, state.rightChunk)));
            }
          });
        }
      case OP_PULL_RIGHT:
        {
          return matchEffect$1(pullRight, {
            onFailure: error => succeed$7(fail$d(error)),
            onSuccess: rightChunk => {
              if (isEmpty$h(rightChunk)) {
                return pull(PullRight(state.leftChunk), pullLeft, pullRight);
              }
              if (isEmpty$h(state.leftChunk)) {
                return pull(PullLeft(rightChunk), pullLeft, pullRight);
              }
              return succeed$7(succeed$f(zip(state.leftChunk, rightChunk)));
            }
          });
        }
    }
  };
  const zip = (leftChunk, rightChunk) => {
    const [output, either] = f(leftChunk, rightChunk);
    switch (either._tag) {
      case "Left":
        {
          if (isEmpty$h(either.left)) {
            return [output, PullBoth];
          }
          return [output, PullRight(either.left)];
        }
      case "Right":
        {
          if (isEmpty$h(either.right)) {
            return [output, PullBoth];
          }
          return [output, PullLeft(either.right)];
        }
    }
  };
  return pipe(self, combineChunks(that, PullBoth, pull));
});

/** @internal */
const zipWithIndex = self => pipe(self, mapAccum(0, (index, a) => [index + 1, [a, index]]));

/** @internal */
const zipWithNext = self => {
  const process = last => readWithCause({
    onInput: input => {
      const [newLast, chunk] = mapAccum$3(input, last, (prev, curr) => [some$6(curr), pipe(prev, map$n(a => [a, curr]))]);
      const output = filterMap$2(chunk, option => isSome(option) ? some$6([option.value[0], some$6(option.value[1])]) : none$8());
      return flatMap$3(write(output), () => process(newLast));
    },
    onFailure: failCause$4,
    onDone: () => match$j(last, {
      onNone: () => unit$2,
      onSome: value => zipRight$3(write(of$3([value, none$8()])), unit$2)
    })
  });
  return new StreamImpl(pipe(toChannel(self), pipeToOrFail(process(none$8()))));
};

/** @internal */
const zipWithPrevious = self => pipe(self, mapAccum(none$8(), (prev, curr) => [some$6(curr), [prev, curr]]));

/** @internal */
const zipWithPreviousAndNext = self => pipe(zipWithNext(zipWithPrevious(self)), map$2(([[prev, curr], next]) => [prev, curr, pipe(next, map$n(tuple => tuple[1]))]));

/** @internal */
const zipChunks = (left$1, right$1, f) => {
  if (left$1.length > right$1.length) {
    return [pipe(left$1, take$7(right$1.length), zipWith$8(right$1, f)), left(pipe(left$1, drop$2(right$1.length)))];
  }
  return [pipe(left$1, zipWith$8(pipe(right$1, take$7(left$1.length)), f)), right(pipe(right$1, drop$2(left$1.length)))];
};

// Do notation

/** @internal */
const Do = /*#__PURE__*/succeed$4({});

/** @internal */
const bind$1 = /*#__PURE__*/dual(args => typeof args[0] !== "string", (self, tag, f, options) => flatMap$1(self, k => map$2(f(k), a => ({
  ...k,
  [tag]: a
})), options));

/* @internal */
const bindTo$1 = /*#__PURE__*/dual(2, (self, tag) => map$2(self, a => ({
  [tag]: a
})));

/* @internal */
const let_$1 = /*#__PURE__*/dual(3, (self, tag, f) => map$2(self, k => ({
  ...k,
  [tag]: f(k)
})));

// Circular with Channel

/** @internal */
const channelToStream = self => {
  return new StreamImpl(self);
};

// =============================================================================
// encoding
// =============================================================================

/** @internal */
const decodeText = /*#__PURE__*/dual(args => isStream(args[0]), (self, encoding = "utf-8") => suspend$2(() => {
  const decoder = new TextDecoder(encoding);
  return map$2(self, s => decoder.decode(s));
}));

/** @internal */
const encodeText = self => suspend$2(() => {
  const encoder = new TextEncoder();
  return map$2(self, s => encoder.encode(s));
});

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ChannelTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Channel` is a nexus of I/O operations, which supports both reading and
 * writing. A channel may read values of type `InElem` and write values of type
 * `OutElem`. When the channel finishes, it yields a value of type `OutDone`. A
 * channel may fail with a value of type `OutErr`.
 *
 * Channels are the foundation of Streams: both streams and sinks are built on
 * channels. Most users shouldn't have to use channels directly, as streams and
 * sinks are much more convenient and cover all common use cases. However, when
 * adding new stream and sink operators, or doing something highly specialized,
 * it may be useful to use channels directly.
 *
 * Channels compose in a variety of ways:
 *
 *  - **Piping**: One channel can be piped to another channel, assuming the
 *    input type of the second is the same as the output type of the first.
 *  - **Sequencing**: The terminal value of one channel can be used to create
 *    another channel, and both the first channel and the function that makes
 *    the second channel can be composed into a channel.
 *  - **Concatenating**: The output of one channel can be used to create other
 *    channels, which are all concatenated together. The first channel and the
 *    function that makes the other channels can be composed into a channel.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
ChannelExceptionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Represents a generic checked exception which occurs when a `Channel` is
 * executed.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
acquireUseRelease$1;

/**
 * @since 2.0.0
 * @category constructors
 */
acquireReleaseOut;

/**
 * Returns a new channel that is the same as this one, except the terminal
 * value of the channel is the specified constant value.
 *
 * This method produces the same result as mapping this channel to the
 * specified constant value.
 *
 * @since 2.0.0
 * @category mapping
 */
as$3;

/**
 * @since 2.0.0
 * @category mapping
 */
asUnit$1;

/**
 * Creates a channel backed by a buffer. When the buffer is empty, the channel
 * will simply passthrough its input as output. However, when the buffer is
 * non-empty, the value inside the buffer will be passed along as output.
 *
 * @since 2.0.0
 * @category constructors
 */
buffer$1;

/**
 * @since 2.0.0
 * @category constructors
 */
bufferChunk;

/**
 * Returns a new channel that is the same as this one, except if this channel
 * errors for any typed error, then the returned channel will switch over to
 * using the fallback channel returned by the specified error handler.
 *
 * @since 2.0.0
 * @category error handling
 */
catchAll$2;

/**
 * Returns a new channel that is the same as this one, except if this channel
 * errors for any typed error, then the returned channel will switch over to
 * using the fallback channel returned by the specified error handler.
 *
 * @since 2.0.0
 * @category error handling
 */
catchAllCause$1;

/**
 * Concat sequentially a channel of channels.
 *
 * @since 2.0.0
 * @category constructors
 */
concatAll$1;

/**
 * Concat sequentially a channel of channels.
 *
 * @since 2.0.0
 * @category constructors
 */
concatAllWith;

/**
 * Returns a new channel whose outputs are fed to the specified factory
 * function, which creates new channels in response. These new channels are
 * sequentially concatenated together, and all their outputs appear as outputs
 * of the newly returned channel.
 *
 * @since 2.0.0
 * @category utils
 */
concatMap;

/**
 * Returns a new channel whose outputs are fed to the specified factory
 * function, which creates new channels in response. These new channels are
 * sequentially concatenated together, and all their outputs appear as outputs
 * of the newly returned channel. The provided merging function is used to
 * merge the terminal values of all channels into the single terminal value of
 * the returned channel.
 *
 * @since 2.0.0
 * @category utils
 */
concatMapWith;

/**
 * Returns a new channel whose outputs are fed to the specified factory
 * function, which creates new channels in response. These new channels are
 * sequentially concatenated together, and all their outputs appear as outputs
 * of the newly returned channel. The provided merging function is used to
 * merge the terminal values of all channels into the single terminal value of
 * the returned channel.
 *
 * @since 2.0.0
 * @category utils
 */
concatMapWithCustom;

/**
 * Returns a new channel, which is the same as this one, except its outputs
 * are filtered and transformed by the specified partial function.
 *
 * @since 2.0.0
 * @category utils
 */
collect$1;

/**
 * Returns a new channel, which is the concatenation of all the channels that
 * are written out by this channel. This method may only be called on channels
 * that output other channels.
 *
 * @since 2.0.0
 * @category utils
 */
concatOut;

/**
 * Returns a new channel which is the same as this one but applies the given
 * function to the input channel's done value.
 *
 * @since 2.0.0
 * @category utils
 */
mapInput$1;

/**
 * Returns a new channel which is the same as this one but applies the given
 * effectual function to the input channel's done value.
 *
 * @since 2.0.0
 * @category utils
 */
mapInputEffect$1;

/**
 * Returns a new channel which is the same as this one but applies the given
 * function to the input channel's error value.
 *
 * @since 2.0.0
 * @category utils
 */
mapInputError;

/**
 * Returns a new channel which is the same as this one but applies the given
 * effectual function to the input channel's error value.
 *
 * @since 2.0.0
 * @category utils
 */
mapInputErrorEffect;

/**
 * Returns a new channel which is the same as this one but applies the given
 * function to the input channel's output elements.
 *
 * @since 2.0.0
 * @category utils
 */
mapInputIn;

/**
 * Returns a new channel which is the same as this one but applies the given
 * effectual function to the input channel's output elements.
 *
 * @since 2.0.0
 * @category utils
 */
mapInputInEffect;

/**
 * Returns a new channel, which is the same as this one, except that all the
 * outputs are collected and bundled into a tuple together with the terminal
 * value of this channel.
 *
 * As the channel returned from this channel collects all of this channel's
 * output into an in- memory chunk, it is not safe to call this method on
 * channels that output a large or unbounded number of values.
 *
 * @since 2.0.0
 * @category utils
 */
doneCollect;

/**
 * Returns a new channel which reads all the elements from upstream's output
 * channel and ignores them, then terminates with the upstream result value.
 *
 * @since 2.0.0
 * @category utils
 */
drain$2;

/**
 * Returns a new channel which connects the given `AsyncInputProducer` as
 * this channel's input.
 *
 * @since 2.0.0
 * @category utils
 */
embedInput;

/**
 * Returns a new channel that collects the output and terminal value of this
 * channel, which it then writes as output of the returned channel.
 *
 * @since 2.0.0
 * @category utils
 */
emitCollect;

/**
 * Returns a new channel with an attached finalizer. The finalizer is
 * guaranteed to be executed so long as the channel begins execution (and
 * regardless of whether or not it completes).
 *
 * @since 2.0.0
 * @category utils
 */
ensuring$3;

/**
 * Returns a new channel with an attached finalizer. The finalizer is
 * guaranteed to be executed so long as the channel begins execution (and
 * regardless of whether or not it completes).
 *
 * @since 2.0.0
 * @category utils
 */
ensuringWith$2;

/**
 * Accesses the whole context of the channel.
 *
 * @since 2.0.0
 * @category context
 */
context$3;

/**
 * Accesses the context of the channel with the specified function.
 *
 * @since 2.0.0
 * @category context
 */
contextWith$3;

/**
 * Accesses the context of the channel in the context of a channel.
 *
 * @since 2.0.0
 * @category context
 */
contextWithChannel;

/**
 * Accesses the context of the channel in the context of an effect.
 *
 * @since 2.0.0
 * @category context
 */
contextWithEffect$2;

/**
 * Constructs a channel that fails immediately with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$6;

/**
 * Constructs a channel that succeeds immediately with the specified lazily
 * evaluated value.
 *
 * @since 2.0.0
 * @category constructors
 */
failSync$3;

/**
 * Constructs a channel that fails immediately with the specified `Cause`.
 *
 * @since 2.0.0
 * @category constructors
 */
failCause$4;

/**
 * Constructs a channel that succeeds immediately with the specified lazily
 * evaluated `Cause`.
 *
 * @since 2.0.0
 * @category constructors
 */
failCauseSync$2;

/**
 * Returns a new channel, which sequentially combines this channel, together
 * with the provided factory function, which creates a second channel based on
 * the terminal value of this channel. The result is a channel that will first
 * perform the functions of this channel, before performing the functions of
 * the created channel (including yielding its terminal value).
 *
 * @since 2.0.0
 * @category sequencing
 */
flatMap$3;

/**
 * Returns a new channel, which flattens the terminal value of this channel.
 * This function may only be called if the terminal value of this channel is
 * another channel of compatible types.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatten$2;

/**
 * Folds over the result of this channel.
 *
 * @since 2.0.0
 * @category utils
 */
foldChannel;

/**
 * Folds over the result of this channel including any cause of termination.
 *
 * @since 2.0.0
 * @category utils
 */
foldCauseChannel;

/**
 * Use an effect to end a channel.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEffect$3;

/**
 * Constructs a channel from an `Either`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEither$1;

/**
 * Construct a `Channel` from an `AsyncInputConsumer`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromInput$1;

/**
 * Construct a `Channel` from a `PubSub`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromPubSub$2;

/**
 * Construct a `Channel` from a `PubSub` within a scoped effect.
 *
 * @since 2.0.0
 * @category constructors
 */
fromPubSubScoped;

/**
 * Construct a `Channel` from an `Option`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromOption$1;

/**
 * Construct a `Channel` from a `Queue`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromQueue$2;

/**
 * @since 2.0.0
 * @category constructors
 */
identityChannel;

/**
 * Returns a new channel, which is the same as this one, except it will be
 * interrupted when the specified effect completes. If the effect completes
 * successfully before the underlying channel is done, then the returned
 * channel will yield the success value of the effect as its terminal value.
 * On the other hand, if the underlying channel finishes first, then the
 * returned channel will yield the success value of the underlying channel as
 * its terminal value.
 *
 * @since 2.0.0
 * @category utils
 */
interruptWhen$1;

/**
 * Returns a new channel, which is the same as this one, except it will be
 * interrupted when the specified deferred is completed. If the deferred is
 * completed before the underlying channel is done, then the returned channel
 * will yield the value of the deferred. Otherwise, if the underlying channel
 * finishes first, then the returned channel will yield the value of the
 * underlying channel.
 *
 * @since 2.0.0
 * @category utils
 */
interruptWhenDeferred$1;

/**
 * Returns a new channel, which is the same as this one, except the terminal
 * value of the returned channel is created by applying the specified function
 * to the terminal value of this channel.
 *
 * @since 2.0.0
 * @category mapping
 */
map$5;

/**
 * Returns a new channel, which is the same as this one, except the terminal
 * value of the returned channel is created by applying the specified
 * effectful function to the terminal value of this channel.
 *
 * @since 2.0.0
 * @category mapping
 */
mapEffect$1;

/**
 * Returns a new channel, which is the same as this one, except the failure
 * value of the returned channel is created by applying the specified function
 * to the failure value of this channel.
 *
 * @since 2.0.0
 * @category mapping
 */
mapError$3;

/**
 * A more powerful version of `mapError` which also surfaces the `Cause`
 * of the channel failure.
 *
 * @since 2.0.0
 * @category mapping
 */
mapErrorCause$1;

/**
 * Maps the output of this channel using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
mapOut;

/**
 * Creates a channel that is like this channel but the given effectful function
 * gets applied to each emitted output element.
 *
 * @since 2.0.0
 * @category mapping
 */
mapOutEffect;

/**
 * Creates a channel that is like this channel but the given ZIO function gets
 * applied to each emitted output element, taking `n` elements at once and
 * mapping them in parallel.
 *
 * @since 2.0.0
 * @category mapping
 */
mapOutEffectPar;

/**
 * @since 2.0.0
 * @category utils
 */
mergeAll$2;

/**
 * @since 2.0.0
 * @category utils
 */
mergeAllUnbounded;

/**
 * @since 2.0.0
 * @category utils
 */
mergeAllUnboundedWith;

/**
 * @since 2.0.0
 * @category utils
 */
mergeAllWith;

/**
 * Returns a new channel which creates a new channel for each emitted element
 * and merges some of them together. Different merge strategies control what
 * happens if there are more than the given maximum number of channels gets
 * created. See `Channel.mergeAll`.
 *
 * @param n The maximum number of channels to merge.
 * @param f The function that creates a new channel from each emitted element.
 * @since 2.0.0
 * @category mapping
 */
mergeMap;

/**
 * Returns a new channel which merges a number of channels emitted by this
 * channel using the back pressuring merge strategy. See `Channel.mergeAll`.
 *
 * @since 2.0.0
 * @category utils
 */
mergeOut;

/**
 * Returns a new channel which merges a number of channels emitted by this
 * channel using the back pressuring merge strategy and uses a given function
 * to merge each completed subchannel's result value. See
 * `Channel.mergeAll`.
 *
 * @since 2.0.0
 * @category utils
 */
mergeOutWith;

/**
 * Returns a new channel, which is the merge of this channel and the specified
 * channel, where the behavior of the returned channel on left or right early
 * termination is decided by the specified `leftDone` and `rightDone` merge
 * decisions.
 *
 * @since 2.0.0
 * @category utils
 */
mergeWith$1;

/**
 * Returns a channel that never completes
 *
 * @since 2.0.0
 * @category constructors
 */
never$3;

/**
 * Translates channel failure into death of the fiber, making all failures
 * unchecked and not a part of the type of the channel.
 *
 * @since 2.0.0
 * @category error handling
 */
orDie$2;

/**
 * Keeps none of the errors, and terminates the fiber with them, using the
 * specified function to convert the `OutErr` into a defect.
 *
 * @since 2.0.0
 * @category error handling
 */
orDieWith$2;

/**
 * Returns a new channel that will perform the operations of this one, until
 * failure, and then it will switch over to the operations of the specified
 * fallback channel.
 *
 * @since 2.0.0
 * @category error handling
 */
orElse$4;

/**
 * Returns a new channel that pipes the output of this channel into the
 * specified channel. The returned channel has the input type of this channel,
 * and the output type of the specified channel, terminating with the value of
 * the specified channel.
 *
 * @since 2.0.0
 * @category utils
 */
pipeTo;

/**
 * Returns a new channel that pipes the output of this channel into the
 * specified channel and preserves this channel's failures without providing
 * them to the other channel for observation.
 *
 * @since 2.0.0
 * @category utils
 */
pipeToOrFail;

/**
 * Provides the channel with its required context, which eliminates its
 * dependency on `Env`.
 *
 * @since 2.0.0
 * @category context
 */
provideContext$4;

/**
 * Provides a layer to the channel, which translates it to another level.
 *
 * @since 2.0.0
 * @category context
 */
provideLayer$1;

/**
 * Transforms the context being provided to the channel with the specified
 * function.
 *
 * @since 2.0.0
 * @category context
 */
mapInputContext$3;

/**
 * Splits the context into two parts, providing one part using the
 * specified layer and leaving the remainder `Env0`.
 *
 * @since 2.0.0
 * @category context
 */
provideSomeLayer$1;

/**
 * Provides the effect with the single service it requires. If the effect
 * requires more than one service use `provideContext` instead.
 *
 * @since 2.0.0
 * @category context
 */
provideService$2;

/**
 * @since 2.0.0
 * @category constructors
 */
read;

/**
 * @since 2.0.0
 * @category constructors
 */
readOrFail;

/**
 * @since 2.0.0
 * @category constructors
 */
readWith;

/**
 * @since 2.0.0
 * @category constructors
 */
readWithCause;

/**
 * Creates a channel which repeatedly runs this channel.
 *
 * @since 2.0.0
 * @category utils
 */
repeated;

/**
 * Runs a channel until the end is received.
 *
 * @since 2.0.0
 * @category destructors
 */
run$1;

/**
 * Run the channel until it finishes with a done value or fails with an error
 * and collects its emitted output elements.
 *
 * The channel must not read any input.
 *
 * @since 2.0.0
 * @category destructors
 */
runCollect$1;

/**
 * Runs a channel until the end is received.
 *
 * @since 2.0.0
 * @category destructors
 */
runDrain$1;

/**
 * Use a scoped effect to emit an output element.
 *
 * @since 2.0.0
 * @category constructors
 */
scoped$1;

/**
 * Constructs a channel that succeeds immediately with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$6;

/**
 * Lazily constructs a channel from the given side effect.
 *
 * @since 2.0.0
 * @category constructors
 */
suspend$4;

/**
 * Constructs a channel that succeeds immediately with the specified lazy value.
 *
 * @since 2.0.0
 * @category constructors
 */
sync$3;

/**
 * Converts a `Channel` to a `PubSub`.
 *
 * @since 2.0.0
 * @category destructors
 */
toPubSub$1;

/**
 * Returns a scoped `Effect` that can be used to repeatedly pull elements from
 * the constructed `Channel`. The pull effect fails with the channel's failure
 * in case the channel fails, or returns either the channel's done value or an
 * emitted element.
 *
 * @since 2.0.0
 * @category destructors
 */
toPull$1;

/**
 * Converts a `Channel` to a `Queue`.
 *
 * @since 2.0.0
 * @category destructors
 */
toQueue$1;

/** Converts this channel to a `Sink`.
 *
 * @since 2.0.0
 * @category destructors
 */
channelToSink;

/**
 * Converts this channel to a `Stream`.
 *
 * @since 2.0.0
 * @category destructors
 */
channelToStream;

/**
 * @since 2.0.0
 * @category constructors
 */
unit$2;

/**
 * Makes a channel from an effect that returns a channel in case of success.
 *
 * @since 2.0.0
 * @category constructors
 */
unwrap$2;

/**
 * Makes a channel from a managed that returns a channel in case of success.
 *
 * @since 2.0.0
 * @category constructors
 */
unwrapScoped$2;

/**
 * Updates a service in the context of this channel.
 *
 * @since 2.0.0
 * @category context
 */
updateService$1;

/**
 * Wraps the channel with a new span for tracing.
 *
 * @since 2.0.0
 * @category tracing
 */
withSpan$1;

/**
 * Writes a single value to the channel.
 *
 * @since 2.0.0
 * @category constructors
 */
write;

/**
 * Writes a sequence of values to the channel.
 *
 * @since 2.0.0
 * @category constructors
 */
writeAll;

/**
 * Writes a `Chunk` of values to the channel.
 *
 * @since 2.0.0
 * @category constructors
 */
writeChunk;

/**
 * Returns a new channel that is the sequential composition of this channel
 * and the specified channel. The returned channel terminates with a tuple of
 * the terminal values of both channels.
 *
 * @since 2.0.0
 * @category zipping
 */
zip$4;

/**
 * Returns a new channel that is the sequential composition of this channel
 * and the specified channel. The returned channel terminates with the
 * terminal value of this channel.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLeft$3;

/**
 * Returns a new channel that is the sequential composition of this channel
 * and the specified channel. The returned channel terminates with the
 * terminal value of that channel.
 *
 * @since 2.0.0
 * @category zipping
 */
zipRight$3;

/**
 * Represents a generic checked exception which occurs when a `Channel` is
 * executed.
 *
 * @since 2.0.0
 * @category errors
 */
ChannelException;

/**
 * Returns `true` if the specified value is an `ChannelException`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isChannelException;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
ChildExecutorDecisionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Continue executing the current substream
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Close the current substream with a given value and pass execution to the
 * next substream
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Pass execution to the next substream. This either pulls a new element
 * from upstream, or yields to an already created active substream.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
Continue;

/**
 * @since 2.0.0
 * @category constructors
 */
Close;

/**
 * @since 2.0.0
 * @category constructors
 */
Yield;

/**
 * Returns `true` if the specified value is a `ChildExecutorDecision`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isChildExecutorDecision;

/**
 * Returns `true` if the specified `ChildExecutorDecision` is a `Continue`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isContinue;

/**
 * Returns `true` if the specified `ChildExecutorDecision` is a `Close`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isClose;

/**
 * Returns `true` if the specified `ChildExecutorDecision` is a `Yield`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isYield;

/**
 * Folds over a `ChildExecutorDecision` to produce a value of type `A`.
 *
 * @since 2.0.0
 * @category folding
 */
match$8;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
MergeStateTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
BothRunning;

/**
 * @since 2.0.0
 * @category constructors
 */
LeftDone;

/**
 * @since 2.0.0
 * @category constructors
 */
RightDone;

/**
 * Returns `true` if the specified value is a `MergeState`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isMergeState;

/**
 * Returns `true` if the specified `MergeState` is a `BothRunning`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isBothRunning;

/**
 * Returns `true` if the specified `MergeState` is a `LeftDone`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isLeftDone;

/**
 * Returns `true` if the specified `MergeState` is a `RightDone`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isRightDone;

/**
 * @since 2.0.0
 * @category folding
 */
match$4;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
MergeStrategyTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
BackPressure$1;

/**
 * @since 2.0.0
 * @category constructors
 */
BufferSliding;

/**
 * Returns `true` if the specified value is a `MergeStrategy`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isMergeStrategy;

/**
 * Returns `true` if the specified `MergeStrategy` is a `BackPressure`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isBackPressure;

/**
 * Returns `true` if the specified `MergeStrategy` is a `BufferSliding`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isBufferSliding;

/**
 * Folds an `MergeStrategy` into a value of type `A`.
 *
 * @since 2.0.0
 * @category folding
 */
match$3;

/**
 * @since 2.0.0
 */

/**
 * An MVar-like abstraction for sending data to channels asynchronously which is
 * designed for one producer and multiple consumers.
 *
 * Features the following semantics:
 *   - Buffer of size 1.
 *   - When emitting, the producer waits for a consumer to pick up the value to
 *     prevent "reading ahead" too much.
 *   - Once an emitted element is read by a consumer, it is cleared from the
 *     buffer, so that at most one consumer sees every emitted element.
 *   - When sending a done or error signal, the producer does not wait for a
 *     consumer to pick up the signal. The signal stays in the buffer after
 *     being read by a consumer, so it can be propagated to multiple consumers.
 *   - Trying to publish another emit/error/done after an error/done have
 *     already been published results in an interruption.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Producer-side view of `SingleProducerAsyncInput` for variance purposes.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Consumer-side view of `SingleProducerAsyncInput` for variance purposes.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
make$s;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
UpstreamPullRequestTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
Pulled;

/**
 * @since 2.0.0
 * @category constructors
 */
NoUpstream;

/**
 * Returns `true` if the specified value is an `UpstreamPullRequest`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isUpstreamPullRequest;

/**
 * Returns `true` if the specified `UpstreamPullRequest` is a `Pulled`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isPulled;

/**
 * Returns `true` if the specified `UpstreamPullRequest` is a `NoUpstream`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isNoUpstream;

/**
 * Folds an `UpstreamPullRequest<A>` into a value of type `Z`.
 *
 * @since 2.0.0
 * @category folding
 */
match$6;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
UpstreamPullStrategyTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
PullAfterNext;

/**
 * @since 2.0.0
 * @category constructors
 */
PullAfterAllEnqueued;

/**
 * Returns `true` if the specified value is an `UpstreamPullStrategy`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isUpstreamPullStrategy;

/**
 * Returns `true` if the specified `UpstreamPullStrategy` is a `PullAfterNext`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isPullAfterNext;

/**
 * Returns `true` if the specified `UpstreamPullStrategy` is a
 * `PullAfterAllEnqueued`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isPullAfterAllEnqueued;

/**
 * Folds an `UpstreamPullStrategy<A>` into a value of type `Z`.
 *
 * @since 2.0.0
 * @category folding
 */
match$7;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ConfigTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Config` describes the structure of some configuration data.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Constructs a config from a tuple / struct / arguments of configs.
 *
 * @since 2.0.0
 * @category constructors
 */
all$3;

/**
 * Constructs a config for an array of values.
 *
 * @since 2.0.0
 * @category constructors
 */
array;

/**
 * Constructs a config for a boolean value.
 *
 * @since 2.0.0
 * @category constructors
 */
boolean;

/**
 * Constructs a config for a sequence of values.
 *
 * @since 2.0.0
 * @category constructors
 */
chunk$1;

/**
 * Constructs a config for a date value.
 *
 * @since 2.0.0
 * @category constructors
 */
date;

/**
 * Constructs a config that fails with the specified message.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$c;

/**
 * Constructs a config for a float value.
 *
 * @since 2.0.0
 * @category constructors
 */
number;

/**
 * Constructs a config for a integer value.
 *
 * @since 2.0.0
 * @category constructors
 */
integer;

/**
 * Constructs a config for a `LogLevel` value.
 *
 * @since 2.0.0
 * @category constructors
 */
logLevel;

/**
 * This function returns `true` if the specified value is an `Config` value,
 * `false` otherwise.
 *
 * This function can be useful for checking the type of a value before
 * attempting to operate on it as an `Config` value. For example, you could
 * use `isConfig` to check the type of a value before using it as an
 * argument to a function that expects an `Config` value.
 *
 * @param u - The value to check for being a `Config` value.
 *
 * @returns `true` if the specified value is a `Config` value, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isConfig;

/**
 * Returns a  config whose structure is the same as this one, but which produces
 * a different value, constructed using the specified function.
 *
 * @since 2.0.0
 * @category utils
 */
map$d;

/**
 * Returns a config whose structure is the same as this one, but which may
 * produce a different value, constructed using the specified function, which
 * may throw exceptions that will be translated into validation errors.
 *
 * @since 2.0.0
 * @category utils
 */
mapAttempt$1;

/**
 * Returns a new config whose structure is the samea as this one, but which
 * may produce a different value, constructed using the specified fallible
 * function.
 *
 * @since 2.0.0
 * @category utils
 */
mapOrFail;

/**
 * Returns a config that has this configuration nested as a property of the
 * specified name.
 *
 * @since 2.0.0
 * @category utils
 */
nested$2;

/**
 * Returns a config whose structure is preferentially described by this
 * config, but which falls back to the specified config if there is an issue
 * reading from this config.
 *
 * @since 2.0.0
 * @category utils
 */
orElse$9;

/**
 * Returns configuration which reads from this configuration, but which falls
 * back to the specified configuration if reading from this configuration
 * fails with an error satisfying the specified predicate.
 *
 * @since 2.0.0
 * @category utils
 */
orElseIf;

/**
 * Returns an optional version of this config, which will be `None` if the
 * data is missing from configuration, and `Some` otherwise.
 *
 * @since 2.0.0
 * @category utils
 */
option$4;

/**
 * Constructs a new primitive config.
 *
 * @since 2.0.0
 * @category constructors
 */
primitive;

/**
 * Returns a config that describes a sequence of values, each of which has the
 * structure of this config.
 *
 * @since 2.0.0
 * @category utils
 */
repeat$2;

/**
 * Constructs a config for a secret value.
 *
 * @since 2.0.0
 * @category constructors
 */
secret;

/**
 * Constructs a config for a sequence of values.
 *
 * @since 2.0.0
 * @category constructors
 */
hashSet;

/**
 * Constructs a config for a string value.
 *
 * @since 2.0.0
 * @category constructors
 */
string;

/**
 * Constructs a config which contains the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$e;

/**
 * Lazily constructs a config.
 *
 * @since 2.0.0
 * @category constructors
 */
suspend$7;

/**
 * Constructs a config which contains the specified lazy value.
 *
 * @since 2.0.0
 * @category constructors
 */
sync$9;

/**
 * Constructs a config for a sequence of values.
 *
 * @since 2.0.0
 * @category constructors
 */
hashMap;

/**
 * Constructs a config from some configuration wrapped with the `Wrap<A>` utility type.
 *
 * For example:
 *
 * ```
 * import { Config, unwrap } from "./Config"
 *
 * interface Options { key: string }
 *
 * const makeConfig = (config: Config.Wrap<Options>): Config<Options> => unwrap(config)
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
unwrap$3;

/**
 * Returns a config that describes the same structure as this one, but which
 * performs validation during loading.
 *
 * @since 2.0.0
 * @category utils
 */
validate$2;

/**
 * Returns a config that describes the same structure as this one, but has the
 * specified default value in case the information cannot be found.
 *
 * @since 2.0.0
 * @category utils
 */
withDefault;

/**
 * Adds a description to this configuration, which is intended for humans.
 *
 * @since 2.0.0
 * @category utils
 */
withDescription;

/**
 * Returns a config that is the composition of this config and the specified
 * config.
 *
 * @since 2.0.0
 * @category utils
 */
zip$8;

/**
 * Returns a config that is the composes this config and the specified config
 * using the provided function.
 *
 * @since 2.0.0
 * @category utils
 */
zipWith$5;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ConfigProviderTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
FlatConfigProviderTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A ConfigProvider is a service that provides configuration given a description
 * of the structure of that configuration.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * The service tag for `ConfigProvider`.
 *
 * @since 2.0.0
 * @category context
 */
configProviderTag;

/**
 * Creates a new config provider.
 *
 * @since 2.0.0
 * @category constructors
 */
make$M;

/**
 * Creates a new flat config provider.
 *
 * @since 2.0.0
 * @category constructors
 */
makeFlat;

/**
 * A config provider that loads configuration from context variables,
 * using the default System service.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEnv;

/**
 * Constructs a new `ConfigProvider` from a key/value (flat) provider, where
 * nesting is embedded into the string keys.
 *
 * @since 2.0.0
 * @category constructors
 */
fromFlat;

/**
 * Constructs a ConfigProvider using a map and the specified delimiter string,
 * which determines how to split the keys in the map into path segments.
 *
 * @since 2.0.0
 * @category constructors
 */
fromMap;

/**
 * Returns a new config provider that will automatically convert all property
 * names to constant case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
constantCase;

/**
 * Returns a new config provider that will automatically tranform all path
 * configuration names with the specified function. This can be utilized to
 * adapt the names of configuration properties from one naming convention to
 * another.
 *
 * @since 2.0.0
 * @category utils
 */
mapInputPath;

/**
 * Returns a new config provider that will automatically convert all property
 * names to kebab case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
kebabCase;

/**
 * Returns a new config provider that will automatically convert all property
 * names to lower case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
lowerCase;

/**
 * Returns a new config provider that will automatically nest all
 * configuration under the specified property name. This can be utilized to
 * aggregate separate configuration sources that are all required to load a
 * single configuration value.
 *
 * @since 2.0.0
 * @category utils
 */
nested;

/**
 * Returns a new config provider that preferentially loads configuration data
 * from this one, but which will fall back to the specified alternate provider
 * if there are any issues loading the configuration from this provider.
 *
 * @since 2.0.0
 * @category utils
 */
orElse$8;

/**
 * Returns a new config provider that will automatically un-nest all
 * configuration under the specified property name. This can be utilized to
 * de-aggregate separate configuration sources that are all required to load a
 * single configuration value.
 *
 * @since 2.0.0
 * @category utils
 */
unnested;

/**
 * Returns a new config provider that will automatically convert all property
 * names to upper case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
snakeCase;

/**
 * Returns a new config provider that will automatically convert all property
 * names to upper case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
upperCase;

/**
 * Returns a new config provider that transforms the config provider with the
 * specified function within the specified path.
 *
 * @since 2.0.0
 * @category combinators
 */
within;

/**
 * @since 2.0.0
 */

/**
 * Represents a description of how to modify the path to a configuration
 * value.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
empty$i;

/**
 * @since 2.0.0
 * @category constructors
 */
andThen$1;

/**
 * @since 2.0.0
 * @category constructors
 */
mapName;

/**
 * @since 2.0.0
 * @category constructors
 */
nested$1;

/**
 * @since 2.0.0
 * @category constructors
 */
unnested$1;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
ConfigSecretTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category refinements
 */
isConfigSecret;

/**
 * @since 2.0.0
 * @category constructors
 */
make$N;

/**
 * @since 2.0.0
 * @category constructors
 */
fromChunk$2;

/**
 * @since 2.0.0
 * @category constructors
 */
fromString;

/**
 * @since 2.0.0
 * @category getters
 */
value$2;

/**
 * @since 2.0.0
 * @category unsafe
 */
unsafeWipe;

/** @internal */
const consoleWith = f => fiberRefGetWith(currentServices$1, services => f(get$j(services, consoleTag)));

/** @internal */
const withConsole = /*#__PURE__*/dual(2, (effect, value) => fiberRefLocallyWith$1(effect, currentServices$1, add$4(consoleTag, value)));

/** @internal */
const setConsole = console => scopedDiscard(fiberRefLocallyScopedWith$1(currentServices$1, add$4(consoleTag, console)));

/** @internal */
const assert = (condition, ...args) => consoleWith(_ => _.assert(condition, ...args));

/** @internal */
const clear = /*#__PURE__*/consoleWith(_ => _.clear);

/** @internal */
const count$1 = label => consoleWith(_ => _.count(label));

/** @internal */
const countReset = label => consoleWith(_ => _.countReset(label));

/** @internal */
const debug = (...args) => consoleWith(_ => _.debug(...args));

/** @internal */
const dir = (item, options) => consoleWith(_ => _.dir(item, options));

/** @internal */
const dirxml = (...args) => consoleWith(_ => _.dirxml(...args));

/** @internal */
const error = (...args) => consoleWith(_ => _.error(...args));

/** @internal */
const group = options => consoleWith(_ => acquireRelease$2(_.group(options), () => _.groupEnd));

/** @internal */
const info = (...args) => consoleWith(_ => _.info(...args));

/** @internal */
const log = (...args) => consoleWith(_ => _.log(...args));

/** @internal */
const table = (tabularData, properties) => consoleWith(_ => _.table(tabularData, properties));

/** @internal */
const time = label => consoleWith(_ => acquireRelease$2(_.time(label), () => _.timeEnd(label)));

/** @internal */
const timeLog = (label, ...args) => consoleWith(_ => _.timeLog(label, ...args));

/** @internal */
const trace = (...args) => consoleWith(_ => _.trace(...args));

/** @internal */
const warn = (...args) => consoleWith(_ => _.warn(...args));

/** @internal */
const withGroup = /*#__PURE__*/dual(args => isEffect$1(args[0]), (self, options) => consoleWith(_ => acquireUseRelease$3(_.group(options), () => self, () => _.groupEnd)));

/** @internal */
const withTime = /*#__PURE__*/dual(args => isEffect$1(args[0]), (self, label) => consoleWith(_ => acquireUseRelease$3(_.time(label), () => self, () => _.timeEnd(label))));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category type ids
 */
TypeId$3;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category default services
 */
withConsole;

/**
 * @since 2.0.0
 * @category default services
 */
setConsole;

/**
 * @since 2.0.0
 * @category accessor
 */
consoleWith;

/**
 * @since 2.0.0
 * @category accessor
 */
assert;

/**
 * @since 2.0.0
 * @category accessor
 */
clear;

/**
 * @since 2.0.0
 * @category accessor
 */
count$1;

/**
 * @since 2.0.0
 * @category accessor
 */
countReset;

/**
 * @since 2.0.0
 * @category accessor
 */
debug;

/**
 * @since 2.0.0
 * @category accessor
 */
dir;

/**
 * @since 2.0.0
 * @category accessor
 */
dirxml;

/**
 * @since 2.0.0
 * @category accessor
 */
error;

/**
 * @since 2.0.0
 * @category accessor
 */
group;

/**
 * @since 2.0.0
 * @category accessor
 */
info;

/**
 * @since 2.0.0
 * @category accessor
 */
log;

/**
 * @since 2.0.0
 * @category accessor
 */
table;

/**
 * @since 2.0.0
 * @category accessor
 */
time;

/**
 * @since 2.0.0
 * @category accessor
 */
timeLog;

/**
 * @since 2.0.0
 * @category accessor
 */
trace;

/**
 * @since 2.0.0
 * @category accessor
 */
warn;

/**
 * @since 2.0.0
 * @category accessor
 */
withGroup;

/**
 * @since 2.0.0
 * @category accessor
 */
withTime;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category type ids
 */
EffectTypeId$2;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category type ids
 */
StreamTypeId$2;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category type ids
 */
SinkTypeId$1;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category type ids
 */
ChannelTypeId$1;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category prototypes
 */
EffectPrototype;

/**
 * @since 2.0.0
 * @category prototypes
 */
CommitPrototype;

/**
 * @since 2.0.0
 * @category prototypes
 */
const StructuralCommitPrototype = StructuralCommitPrototype$1;
Base;
StructuralBase;

/**
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * `Case` represents a datatype similar to a case class in Scala. Namely, a
 * datatype created using `Case` will, by default, provide an implementation
 * for a constructor, `Hash`, and `Equal`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @category constructors
 * @since 2.0.0
 */
const struct = struct$2;

/**
 * Provides a constructor for a Case Class.
 *
 * @since 2.0.0
 * @category constructors
 */
Structural;

/**
 * @since 2.0.0
 * @category constructors
 */
Structural;

/**
 * @since 2.0.0
 * @category models
 */

const YieldableErrorMessage = /*#__PURE__*/Symbol.for("effect/Data/YieldableError/message");
({
  ...StructuralCommitPrototype,
  __proto__: globalThis.Error.prototype,
  commit() {
    return fail$7(this);
  },
  toString() {
    return `${this.name}: ${this.message}`;
  },
  get message() {
    return this[YieldableErrorMessage] ?? JSON.stringify(this);
  },
  set message(value) {
    this[YieldableErrorMessage] = value;
  }
});

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
liveServices$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentServices$1;

/** @internal */
const DecodeExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Encoding/errors/Decode");

/** @internal */
const DecodeException = (input, message) => ({
  _tag: "DecodeException",
  [DecodeExceptionTypeId]: DecodeExceptionTypeId,
  input,
  message
});

/** @internal */
const isDecodeException = u => typeof u === "object" && u != null && DecodeExceptionTypeId in u;

/**
 * @since 2.0.0
 * @category symbols
 */
DecodeExceptionTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Represents a checked exception which occurs when decoding fails.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Creates a checked exception which occurs when decoding fails.
 *
 * @since 2.0.0
 * @category errors
 */
DecodeException;

/**
 * Returns `true` if the specified value is an `DecodeException`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isDecodeException;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
FiberRefTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefMake;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefMakeWith;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefMakeContext;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefMakeRuntimeFlags;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefUnsafeMake;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefUnsafeMakeHashSet;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefUnsafeMakeContext;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefUnsafeMakeSupervisor;

/**
 * @since 2.0.0
 * @category constructors
 */
fiberRefUnsafeMakePatch;

/**
 * @since 2.0.0
 * @category getters
 */
fiberRefGet;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefGetAndSet;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefGetAndUpdate;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefGetAndUpdateSome;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefGetWith;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefSet;
fiberRefDelete;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefReset;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefModify;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefModifySome;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefUpdate;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefUpdateSome;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefUpdateAndGet;

/**
 * @since 2.0.0
 * @category utils
 */
fiberRefUpdateSomeAndGet;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentRequestBatching;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentCache;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentCacheEnabled;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentContext = currentContext$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentSchedulingPriority = currentSchedulingPriority$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentMaxOpsBeforeYield;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentUnhandledErrorLogLevel;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentLogAnnotations;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentLoggers;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentLogLevel;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentMinimumLogLevel;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentLogSpan;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentRuntimeFlags;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentScheduler = currentScheduler$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentSupervisor;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentMetricLabels;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentTracerTimingEnabled;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentTracerSpanAnnotations;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentTracerSpanLinks;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
currentInterruptedCause;

/** @internal */
const GroupBySymbolKey = "effect/GroupBy";

/** @internal */
const GroupByTypeId = /*#__PURE__*/Symbol.for(GroupBySymbolKey);

/** @internal */
const groupByVariance = {
  _R: _ => _,
  _E: _ => _,
  _K: _ => _,
  _V: _ => _
};

/** @internal */
const isGroupBy = u => typeof u === "object" && u != null && GroupByTypeId in u;

/** @internal */
const evaluate = /*#__PURE__*/dual(args => isGroupBy(args[0]), (self, f, options) => flatMap$1(self.grouped, ([key, queue]) => f(key, flattenTake(fromQueue(queue, {
  shutdown: true
}))), {
  concurrency: "unbounded",
  bufferSize: options?.bufferSize ?? 16
}));

/** @internal */
const filter$1 = /*#__PURE__*/dual(2, (self, predicate) => make$n(pipe(self.grouped, filterEffect(tuple => {
  if (predicate(tuple[0])) {
    return pipe(succeed$7(tuple), as$4(true));
  }
  return pipe(shutdown$2(tuple[1]), as$4(false));
}))));

/** @internal */
const first = /*#__PURE__*/dual(2, (self, n) => make$n(pipe(zipWithIndex(self.grouped), filterEffect(tuple => {
  const index = tuple[1];
  const queue = tuple[0][1];
  if (index < n) {
    return pipe(succeed$7(tuple), as$4(true));
  }
  return pipe(shutdown$2(queue), as$4(false));
}), map$2(tuple => tuple[0]))));

/** @internal */
const make$n = grouped => ({
  [GroupByTypeId]: groupByVariance,
  pipe() {
    return pipeArguments(this, arguments);
  },
  grouped
});

// Circular with Stream

/** @internal */
const groupBy = /*#__PURE__*/dual(args => isStream(args[0]), (self, f, options) => make$n(unwrapScoped(gen$1(function* ($) {
  const decider = yield* $(make$R());
  const output = yield* $(acquireRelease$1(bounded$2(options?.bufferSize ?? 16), queue => shutdown$2(queue)));
  const ref = yield* $(make$G(new Map()));
  const add = yield* $(mapEffectSequential(self, f), distributedWithDynamicCallback(options?.bufferSize ?? 16, ([key, value]) => flatMap$4(_await$3(decider), f => f(key, value)), exit => offer$3(output, exit)));
  yield* $(succeed$g(decider, (key, _) => pipe(get$b(ref), map$6(map => fromNullable$2(map.get(key))), flatMap$4(match$j({
    onNone: () => flatMap$4(add, ([index, queue]) => zipRight$4(update$4(ref, map => map.set(key, index)), pipe(offer$3(output, succeed$f([key, mapDequeue(queue, exit => new TakeImpl(pipe(exit, map$e(tuple => of$3(tuple[1])))))])), as$4(n => n === index)))),
    onSome: index => succeed$7(n => n === index)
  })))));
  return flattenExitOption(fromQueue(output, {
    shutdown: true
  }));
}))));

/** @internal */
const mapEffectOptions = /*#__PURE__*/dual(args => typeof args[0] !== "function", (self, f, options) => {
  if (options?.key) {
    return evaluate(groupByKey(self, options.key, {
      bufferSize: options.bufferSize
    }), (_, s) => mapEffectSequential(s, f));
  }
  return matchConcurrency(options?.concurrency, () => mapEffectSequential(self, f), n => options?.unordered ? flatMap$1(self, a => fromEffect(f(a)), {
    concurrency: n
  }) : mapEffectPar(self, n, f));
});

/** @internal */
const bindEffect = /*#__PURE__*/dual(args => typeof args[0] !== "string", (self, tag, f, options) => mapEffectOptions(self, k => map$6(f(k), a => ({
  ...k,
  [tag]: a
})), options));
const mapDequeue = (dequeue, f) => new MapDequeue(dequeue, f);
class MapDequeue {
  [DequeueTypeId] = {
    _Out: _ => _
  };
  constructor(dequeue, f) {
    this.dequeue = dequeue;
    this.f = f;
  }
  capacity() {
    return capacity$2(this.dequeue);
  }
  size() {
    return size$7(this.dequeue);
  }
  unsafeSize() {
    return this.dequeue.unsafeSize();
  }
  awaitShutdown() {
    return awaitShutdown$2(this.dequeue);
  }
  isActive() {
    return this.dequeue.isActive();
  }
  isShutdown() {
    return isShutdown$2(this.dequeue);
  }
  shutdown() {
    return shutdown$2(this.dequeue);
  }
  isFull() {
    return isFull$2(this.dequeue);
  }
  isEmpty() {
    return isEmpty$6(this.dequeue);
  }
  take() {
    return pipe(take$5(this.dequeue), map$6(a => this.f(a)));
  }
  takeAll() {
    return pipe(takeAll$2(this.dequeue), map$6(map$l(a => this.f(a))));
  }
  takeUpTo(max) {
    return pipe(takeUpTo$2(this.dequeue, max), map$6(map$l(a => this.f(a))));
  }
  takeBetween(min, max) {
    return pipe(takeBetween$1(this.dequeue, min, max), map$6(map$l(a => this.f(a))));
  }
  takeN(n) {
    return pipe(takeN$1(this.dequeue, n), map$6(map$l(a => this.f(a))));
  }
  poll() {
    return pipe(poll$3(this.dequeue), map$6(map$n(a => this.f(a))));
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const groupByKey = /*#__PURE__*/dual(args => typeof args[0] !== "function", (self, f, options) => {
  const loop = (map, outerQueue) => readWithCause({
    onInput: input => flatMap$3(fromEffect$3(forEach$6(groupByIterable(input, f), ([key, values]) => {
      const innerQueue = map.get(key);
      if (innerQueue === undefined) {
        return pipe(bounded$2(options?.bufferSize ?? 16), flatMap$4(innerQueue => pipe(sync$4(() => {
          map.set(key, innerQueue);
        }), zipRight$4(offer$3(outerQueue, of([key, innerQueue]))), zipRight$4(pipe(offer$3(innerQueue, chunk(values)), catchSomeCause$1(cause => isInterruptedOnly(cause) ? some$6(unit$3) : none$8()))))));
      }
      return catchSomeCause$1(offer$3(innerQueue, chunk(values)), cause => isInterruptedOnly(cause) ? some$6(unit$3) : none$8());
    }, {
      discard: true
    })), () => loop(map, outerQueue)),
    onFailure: cause => fromEffect$3(offer$3(outerQueue, failCause$1(cause))),
    onDone: () => pipe(fromEffect$3(pipe(forEach$6(map.entries(), ([_, innerQueue]) => pipe(offer$3(innerQueue, end), catchSomeCause$1(cause => isInterruptedOnly(cause) ? some$6(unit$3) : none$8())), {
      discard: true
    }), zipRight$4(offer$3(outerQueue, end)))))
  });
  return make$n(unwrapScoped(pipe(sync$4(() => new Map()), flatMap$4(map => pipe(acquireRelease$1(unbounded$2(), queue => shutdown$2(queue)), flatMap$4(queue => pipe(self, toChannel, pipeTo(loop(map, queue)), drain$2, runScoped$1, forkScoped, as$4(flattenTake(fromQueue(queue, {
    shutdown: true
  }))))))))));
});

/**
 * A variant of `groupBy` that retains the insertion order of keys.
 *
 * @internal
 */
const groupByIterable = /*#__PURE__*/dual(2, (iterable, f) => {
  const builder = [];
  const iterator = iterable[Symbol.iterator]();
  const map = new Map();
  let next;
  while ((next = iterator.next()) && !next.done) {
    const value = next.value;
    const key = f(value);
    if (map.has(key)) {
      const innerBuilder = map.get(key);
      innerBuilder.push(value);
    } else {
      const innerBuilder = [value];
      builder.push([key, innerBuilder]);
      map.set(key, innerBuilder);
    }
  }
  return unsafeFromArray(builder.map(tuple => [tuple[0], unsafeFromArray(tuple[1])]));
});

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
GroupByTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Representation of a grouped stream. This allows to filter which groups will
 * be processed. Once this is applied all groups will be processed in parallel
 * and the results will be merged in arbitrary order.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Run the function across all groups, collecting the results in an
 * arbitrary order.
 *
 * @since 2.0.0
 * @category destructors
 */
evaluate;

/**
 * Filter the groups to be processed.
 *
 * @since 2.0.0
 * @category utils
 */
filter$1;

/**
 * Only consider the first `n` groups found in the `Stream`.
 *
 * @since 2.0.0
 * @category utils
 */
first;

/**
 * Constructs a `GroupBy` from a `Stream`.
 *
 * @since 2.0.0
 * @category constructors
 */
make$n;

/** @internal */
const PoolSymbolKey = "effect/Pool";

/** @internal */
const PoolTypeId = /*#__PURE__*/Symbol.for(PoolSymbolKey);
const poolVariance = {
  _E: _ => _,
  _A: _ => _
};

/**
 * A `Strategy` describes the protocol for how a pool whose excess items are
 * not being used should shrink down to the minimum pool size.
 */

/**
 * A strategy that does nothing to shrink excess items. This is useful when
 * the minimum size of the pool is equal to its maximum size and so there is
 * nothing to do.
 */
class NoneStrategy {
  initial() {
    return unit$6;
  }
  track() {
    return unit$6;
  }
  run() {
    return unit$6;
  }
}

/**
 * A strategy that shrinks the pool down to its minimum size if items in the
 * pool have not been used for the specified duration.
 */
class TimeToLiveStrategy {
  constructor(timeToLive) {
    this.timeToLive = timeToLive;
  }
  initial() {
    return flatMap$6(clock$1, clock => flatMap$6(clock.currentTimeMillis, now => map$f(make$H(now), ref => [clock, ref])));
  }
  track(state) {
    return asUnit$4(flatMap$6(state[0].currentTimeMillis, now => set$7(state[1], now)));
  }
  run(state, getExcess, shrink) {
    return flatMap$6(getExcess, excess => excess <= 0 ? zipRight$8(state[0].sleep(this.timeToLive), this.run(state, getExcess, shrink)) : pipe(zipWith$7(get$c(state[1]), state[0].currentTimeMillis, (start, end) => end - start), flatMap$6(duration => {
      if (duration >= toMillis(this.timeToLive)) {
        return zipRight$8(shrink, this.run(state, getExcess, shrink));
      } else {
        return zipRight$8(state[0].sleep(this.timeToLive), this.run(state, getExcess, shrink));
      }
    })));
  }
}
class PoolImpl {
  [PoolTypeId] = poolVariance;
  constructor(creator, min, max, isShuttingDown, state, items, invalidated, track) {
    this.creator = creator;
    this.min = min;
    this.max = max;
    this.isShuttingDown = isShuttingDown;
    this.state = state;
    this.items = items;
    this.invalidated = invalidated;
    this.track = track;
  }
  [symbol$1]() {
    return pipe(hash$1(this.creator), combine$a(number$2(this.min)), combine$a(number$2(this.max)), combine$a(hash$1(this.isShuttingDown)), combine$a(hash$1(this.state)), combine$a(hash$1(this.items)), combine$a(hash$1(this.invalidated)), combine$a(hash$1(this.track)));
  }
  [symbol](that) {
    return isPool(that) && equals$1(this.creator, that.creator) && this.min === that.min && this.max === that.max && equals$1(this.isShuttingDown, that.isShuttingDown) && equals$1(this.state, that.state) && equals$1(this.items, that.items) && equals$1(this.invalidated, that.invalidated) && equals$1(this.track, that.track);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  get() {
    const acquire = () => flatMap$6(get$c(this.isShuttingDown), down => down ? interrupt$7 : flatten$6(modify$4(this.state, state => {
      if (state.free > 0 || state.size >= this.max) {
        return [flatMap$6(take$6(this.items), attempted => exitMatch(attempted.result, {
          onFailure: () => succeed$h(attempted),
          onSuccess: item => flatMap$6(get$c(this.invalidated), set => {
            if (pipe(set, has$5(item))) {
              return flatMap$6(finalizeInvalid(this, attempted), acquire);
            }
            return succeed$h(attempted);
          })
        })), {
          ...state,
          free: state.free - 1
        }];
      }
      if (state.size >= 0) {
        return [flatMap$6(allocate$1(this), acquire), {
          size: state.size + 1,
          free: state.free + 1
        }];
      }
      return [interrupt$7, state];
    })));
    const release = attempted => exitMatch(attempted.result, {
      onFailure: () => flatten$6(modify$4(this.state, state => {
        if (state.size <= this.min) {
          return [allocate$1(this), {
            ...state,
            free: state.free + 1
          }];
        }
        return [unit$6, {
          ...state,
          size: state.size - 1
        }];
      })),
      onSuccess: item => flatMap$6(get$c(this.invalidated), set => {
        if (pipe(set, has$5(item))) {
          return finalizeInvalid(this, attempted);
        }
        return pipe(update$5(this.state, state => ({
          ...state,
          free: state.free + 1
        })), zipRight$8(offer$4(this.items, attempted)), zipRight$8(this.track(attempted.result)), zipRight$8(whenEffect$2(getAndShutdown(this), get$c(this.isShuttingDown))));
      })
    });
    return pipe(acquireRelease$2(acquire(), release), withEarlyRelease$1, disconnect$1, flatMap$6(([release, attempted]) => pipe(when$4(release, () => isFailure$1(attempted)), zipRight$8(toEffect(attempted)))));
  }
  invalidate(item) {
    return update$5(this.invalidated, add$2(item));
  }
}
const allocate$1 = self => uninterruptibleMask$1(restore => flatMap$6(scopeMake(), scope => flatMap$6(exit$1(restore(scopeExtend(self.creator, scope))), exit => flatMap$6(succeed$h({
  result: exit,
  finalizer: scopeClose(scope, exitSucceed(void 0))
}), attempted => pipe(offer$4(self.items, attempted), zipRight$8(self.track(attempted.result)), zipRight$8(whenEffect$2(getAndShutdown(self), get$c(self.isShuttingDown))), as$6(attempted))))));

/**
 * Returns the number of items in the pool in excess of the minimum size.
 */
const excess = self => map$f(get$c(self.state), state => state.size - Math.min(self.min, state.free));
const finalizeInvalid = (self, attempted) => pipe(forEach$4(attempted, a => update$5(self.invalidated, remove$6(a))), zipRight$8(attempted.finalizer), zipRight$8(flatten$6(modify$4(self.state, state => {
  if (state.size <= self.min) {
    return [allocate$1(self), {
      ...state,
      free: state.free + 1
    }];
  }
  return [unit$6, {
    ...state,
    size: state.size - 1
  }];
}))));

/**
 * Gets items from the pool and shuts them down as long as there are items
 * free, signalling shutdown of the pool if the pool is empty.
 */
const getAndShutdown = self => flatten$6(modify$4(self.state, state => {
  if (state.free > 0) {
    return [matchCauseEffect$1(take$6(self.items), {
      onFailure: () => unit$6,
      onSuccess: attempted => pipe(forEach$4(attempted, a => update$5(self.invalidated, remove$6(a))), zipRight$8(attempted.finalizer), zipRight$8(update$5(self.state, state => ({
        ...state,
        size: state.size - 1
      }))), flatMap$6(() => getAndShutdown(self)))
    }), {
      ...state,
      free: state.free - 1
    }];
  }
  if (state.size > 0) {
    return [unit$6, state];
  }
  return [shutdown$5(self.items), {
    ...state,
    size: state.size - 1
  }];
}));

/**
 * Begins pre-allocating pool entries based on minimum pool size.
 */
const initialize = self => replicateEffect$1(uninterruptibleMask$1(restore => flatten$6(modify$4(self.state, state => {
  if (state.size < self.min && state.size >= 0) {
    return [flatMap$6(scopeMake(), scope => flatMap$6(exit$1(restore(scopeExtend(self.creator, scope))), exit => flatMap$6(succeed$h({
      result: exit,
      finalizer: scopeClose(scope, exitSucceed(void 0))
    }), attempted => pipe(offer$4(self.items, attempted), zipRight$8(self.track(attempted.result)), zipRight$8(whenEffect$2(getAndShutdown(self), get$c(self.isShuttingDown))), as$6(attempted))))), {
      size: state.size + 1,
      free: state.free + 1
    }];
  }
  return [unit$6, state];
}))), self.min, {
  discard: true
});

/**
 * Shrinks the pool down, but never to less than the minimum size.
 */
const shrink = self => uninterruptible$1(flatten$6(modify$4(self.state, state => {
  if (state.size > self.min && state.free > 0) {
    return [pipe(take$6(self.items), flatMap$6(attempted => pipe(forEach$4(attempted, a => update$5(self.invalidated, remove$6(a))), zipRight$8(attempted.finalizer), zipRight$8(update$5(self.state, state => ({
      ...state,
      size: state.size - 1
    })))))), {
      ...state,
      free: state.free - 1
    }];
  }
  return [unit$6, state];
})));
const shutdown$1 = self => flatten$6(modify$4(self.isShuttingDown, down => down ? [awaitShutdown$4(self.items), true] : [zipRight$8(getAndShutdown(self), awaitShutdown$4(self.items)), true]));
const isFailure$1 = self => exitIsFailure(self.result);
const forEach$4 = (self, f) => exitMatch(self.result, {
  onFailure: () => unit$6,
  onSuccess: f
});
const toEffect = self => self.result;

/**
 * A more powerful variant of `make` that allows specifying a `Strategy` that
 * describes how a pool whose excess items are not being used will be shrunk
 * down to the minimum size.
 */
const makeWith$2 = options => uninterruptibleMask$1(restore => pipe(all$2([context$7(), make$H(false), make$H({
  size: 0,
  free: 0
}), bounded$5(options.max), make$H(empty$s()), options.strategy.initial()]), flatMap$6(([context, down, state, items, inv, initial]) => {
  const pool = new PoolImpl(mapInputContext$6(options.acquire, old => merge$8(old)(context)), options.min, options.max, down, state, items, inv, exit => options.strategy.track(initial, exit));
  return pipe(forkDaemon$1(restore(initialize(pool))), flatMap$6(fiber => flatMap$6(forkDaemon$1(restore(options.strategy.run(initial, excess(pool), shrink(pool)))), shrink => addFinalizer$2(() => pipe(shutdown$1(pool), zipRight$8(interruptFiber(fiber)), zipRight$8(interruptFiber(shrink)))))), as$6(pool));
})));

/** @internal */
const isPool = u => typeof u === "object" && u != null && PoolTypeId in u;

/** @internal */
const make$m = options => makeWith$2({
  acquire: options.acquire,
  min: options.size,
  max: options.size,
  strategy: new NoneStrategy()
});

/** @internal */
const makeWithTTL$1 = options => makeWith$2({
  acquire: options.acquire,
  min: options.min,
  max: options.max,
  strategy: new TimeToLiveStrategy(decode(options.timeToLive))
});

/** @internal */
const get$a = self => self.get();

/** @internal */
const invalidate$1 = /*#__PURE__*/dual(2, (self, value) => self.invalidate(value));

/** @internal */
const KeyedPoolSymbolKey = "effect/KeyedPool";

/** @internal */
const KeyedPoolTypeId = /*#__PURE__*/Symbol.for(KeyedPoolSymbolKey);
const KeyedPoolMapValueSymbol = /*#__PURE__*/Symbol.for("effect/KeyedPool/MapValue");
const keyedPoolVariance = {
  _K: _ => _,
  _E: _ => _,
  _A: _ => _
};
class KeyedPoolImpl {
  [KeyedPoolTypeId] = keyedPoolVariance;
  constructor(getOrCreatePool, activePools) {
    this.getOrCreatePool = getOrCreatePool;
    this.activePools = activePools;
  }
  get(key) {
    return flatMap$6(this.getOrCreatePool(key), get$a);
  }
  invalidate(item) {
    return flatMap$6(this.activePools(), forEachSequentialDiscard(pool => pool.invalidate(item)));
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}
class Complete {
  _tag = "Complete";
  [KeyedPoolMapValueSymbol] = KeyedPoolMapValueSymbol;
  constructor(pool) {
    this.pool = pool;
  }
  [symbol$1]() {
    return pipe(string$1("effect/KeyedPool/Complete"), combine$a(hash$1(this.pool)));
  }
  [symbol](u) {
    return isComplete(u) && equals$1(this.pool, u.pool);
  }
}
const isComplete = u => isTagged(u, "Complete") && KeyedPoolMapValueSymbol in u;
class Pending {
  _tag = "Pending";
  [KeyedPoolMapValueSymbol] = KeyedPoolMapValueSymbol;
  constructor(deferred) {
    this.deferred = deferred;
  }
  [symbol$1]() {
    return pipe(string$1("effect/KeyedPool/Pending"), combine$a(hash$1(this.deferred)));
  }
  [symbol](u) {
    return isPending$2(u) && equals$1(this.deferred, u.deferred);
  }
}
const isPending$2 = u => isTagged(u, "Pending") && KeyedPoolMapValueSymbol in u;
const makeImpl$1 = (get, min, max, timeToLive) => pipe(all$2([context$7(), fiberId$2, sync$a(() => make$W(empty$u())), scopeMake()]), map$f(([context, fiberId, map, scope]) => {
  const getOrCreatePool = key => suspend$8(() => {
    let value = getOrUndefined(get$g(get$f(map), key));
    if (value === undefined) {
      return uninterruptibleMask$1(restore => {
        const deferred = deferredUnsafeMake(fiberId);
        value = new Pending(deferred);
        let previous = undefined;
        if (has$6(get$f(map), key)) {
          previous = getOrUndefined(get$g(get$f(map), key));
        } else {
          update$6(map, set$b(key, value));
        }
        if (previous === undefined) {
          return pipe(restore(scopeExtend(makeWithTTL$1({
            acquire: provideContext$6(get(key), context),
            min: min(key),
            max: max(key),
            timeToLive: getOrElse$3(timeToLive(key), () => infinity)
          }), scope)), matchCauseEffect$1({
            onFailure: cause => {
              const current = getOrUndefined(get$g(get$f(map), key));
              if (equals$1(current, value)) {
                update$6(map, remove$7(key));
              }
              return zipRight$8(deferredFailCause(deferred, cause), failCause$a(cause));
            },
            onSuccess: pool => {
              update$6(map, set$b(key, new Complete(pool)));
              return as$6(deferredSucceed(deferred, pool), pool);
            }
          }));
        }
        switch (previous._tag) {
          case "Complete":
            {
              return succeed$h(previous.pool);
            }
          case "Pending":
            {
              return restore(deferredAwait(previous.deferred));
            }
        }
      });
    }
    switch (value._tag) {
      case "Complete":
        {
          return succeed$h(value.pool);
        }
      case "Pending":
        {
          return deferredAwait(value.deferred);
        }
    }
  });
  const activePools = () => suspend$8(() => forEachSequential(Array.from(values$2(get$f(map))), value => {
    switch (value._tag) {
      case "Complete":
        {
          return succeed$h(value.pool);
        }
      case "Pending":
        {
          return deferredAwait(value.deferred);
        }
    }
  }));
  return new KeyedPoolImpl(getOrCreatePool, activePools);
}));

/** @internal */
const make$l = options => makeImpl$1(options.acquire, () => options.size, () => options.size, () => none$8());

/** @internal */
const makeWith$1 = options => makeImpl$1(options.acquire, options.size, options.size, () => none$8());

/** @internal */
const makeWithTTL = options => {
  const timeToLive = decode(options.timeToLive);
  return makeImpl$1(options.acquire, options.min, options.max, () => some$6(timeToLive));
};

/** @internal */
const makeWithTTLBy = options => makeImpl$1(options.acquire, options.min, options.max, key => some$6(decode(options.timeToLive(key))));

/** @internal */
const get$9 = /*#__PURE__*/dual(2, (self, key) => self.get(key));

/** @internal */
const invalidate = /*#__PURE__*/dual(2, (self, item) => self.invalidate(item));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
KeyedPoolTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `KeyedPool<K, E, A>` is a pool of `Pool`s of items of type `A`. Each pool
 * in the `KeyedPool` is associated with a key of type `K`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Makes a new pool of the specified fixed size. The pool is returned in a
 * `Scope`, which governs the lifetime of the pool. When the pool is shutdown
 * because the `Scope` is closed, the individual items allocated by the pool
 * will be released in some unspecified order.
 *
 * @since 2.0.0
 * @category constructors
 */
make$l;

/**
 * Makes a new pool of the specified fixed size. The pool is returned in a
 * `Scope`, which governs the lifetime of the pool. When the pool is shutdown
 * because the `Scope` is closed, the individual items allocated by the pool
 * will be released in some unspecified order.
 *
 * The size of the underlying pools can be configured per key.
 *
 * @since 2.0.0
 * @category constructors
 */
makeWith$1;

/**
 * Makes a new pool with the specified minimum and maximum sizes and time to
 * live before a pool whose excess items are not being used will be shrunk
 * down to the minimum size. The pool is returned in a `Scope`, which governs
 * the lifetime of the pool. When the pool is shutdown because the `Scope` is
 * used, the individual items allocated by the pool will be released in some
 * unspecified order.
 *
 * The size of the underlying pools can be configured per key.
 *
 * @since 2.0.0
 * @category constructors
 */
makeWithTTL;

/**
 * Makes a new pool with the specified minimum and maximum sizes and time to
 * live before a pool whose excess items are not being used will be shrunk
 * down to the minimum size. The pool is returned in a `Scope`, which governs
 * the lifetime of the pool. When the pool is shutdown because the `Scope` is
 * used, the individual items allocated by the pool will be released in some
 * unspecified order.
 *
 * The size of the underlying pools can be configured per key.
 *
 * @since 2.0.0
 * @category constructors
 */
makeWithTTLBy;

/**
 * Retrieves an item from the pool belonging to the given key in a scoped
 * effect. Note that if acquisition fails, then the returned effect will fail
 * for that same reason. Retrying a failed acquisition attempt will repeat the
 * acquisition attempt.
 *
 * @since 2.0.0
 * @category combinators
 */
get$9;

/**
 * Invalidates the specified item. This will cause the pool to eventually
 * reallocate the item, although this reallocation may occur lazily rather
 * than eagerly.
 *
 * @since 2.0.0
 * @category combinators
 */
invalidate;

/** @internal */
const test = /*#__PURE__*/dual(2, (self, input) => self.log({
  fiberId: none$7,
  logLevel: logLevelInfo,
  message: input,
  cause: empty$a,
  context: empty$h(),
  spans: empty$p(),
  annotations: empty$u(),
  date: new Date()
}));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
LoggerTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @category constructors
 * @since 2.0.0
 */
makeLogger;

/**
 * @since 2.0.0
 * @category context
 */
addLogger;

/**
 * @since 2.0.0
 * @category context
 */
addLoggerEffect;

/**
 * @since 2.0.0
 * @category context
 */
addLoggerScoped;

/**
 * @since 2.0.0
 * @category mapping
 */
mapInput$4;

/**
 * Returns a version of this logger that only logs messages when the log level
 * satisfies the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
filterLogLevel;

/**
 * @since 2.0.0
 * @category mapping
 */
map$b;

/**
 * A logger that does nothing in response to logging events.
 *
 * @since 2.0.0
 * @category constructors
 */
none$3;

/**
 * @since 2.0.0
 * @category context
 */
removeLogger;

/**
 * @since 2.0.0
 * @category context
 */
const replace = replaceLogger;

/**
 * @since 2.0.0
 * @category context
 */
replaceLoggerEffect;

/**
 * @since 2.0.0
 * @category context
 */
replaceLoggerScoped;

/**
 * @since 2.0.0
 * @category constructors
 */
simple;

/**
 * @since 2.0.0
 * @category constructors
 */
succeed$c;

/**
 * @since 2.0.0
 * @category constructors
 */
sync$8;

/**
 * @since 2.0.0
 * @category constructors
 */
test;

/**
 * @since 2.0.0
 * @category context
 */
withMinimumLogLevel;

/**
 * Combines this logger with the specified logger to produce a new logger that
 * logs to both this logger and that logger.
 *
 * @since 2.0.0
 * @category zipping
 */
zip$7;

/**
 * @since 2.0.0
 * @category zipping
 */
zipLeft$6;

/**
 * @since 2.0.0
 * @category zipping
 */
zipRight$6;

/**
 * @since 2.0.0
 * @category constructors
 */
defaultLogger;

/**
 * @since 2.0.0
 * @category constructors
 */
logfmtLogger;

/**
 * @since 2.0.0
 * @category constructors
 */
stringLogger;

/**
 * @since 2.0.0
 * @category constructors
 */
tracerLogger;

/**
 * @since 2.0.0
 * @category constructors
 */
/*#__PURE__*/replace(defaultLogger, logFmtLogger);

/**
 * @since 2.0.0
 * @category context
 */
minimumLogLevel;

/** @internal */
const TypeId$1 = /*#__PURE__*/Symbol.for("@effect/matcher/Matcher");
const TypeMatcherProto = {
  [TypeId$1]: {
    _input: identity$1,
    _filters: identity$1,
    _remaining: identity$1,
    _result: identity$1
  },
  _tag: "TypeMatcher",
  add(_case) {
    return makeTypeMatcher([...this.cases, _case]);
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
function makeTypeMatcher(cases) {
  const matcher = Object.create(TypeMatcherProto);
  matcher.cases = cases;
  return matcher;
}
const ValueMatcherProto = {
  [TypeId$1]: {
    _input: identity$1,
    _filters: identity$1,
    _result: identity$1
  },
  _tag: "ValueMatcher",
  add(_case) {
    if (this.value._tag === "Right") {
      return this;
    }
    if (_case._tag === "When" && _case.guard(this.provided) === true) {
      return makeValueMatcher(this.provided, right(_case.evaluate(this.provided)));
    } else if (_case._tag === "Not" && _case.guard(this.provided) === false) {
      return makeValueMatcher(this.provided, right(_case.evaluate(this.provided)));
    }
    return this;
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
function makeValueMatcher(provided, value) {
  const matcher = Object.create(ValueMatcherProto);
  matcher.provided = provided;
  matcher.value = value;
  return matcher;
}
const makeWhen = (guard, evaluate) => ({
  _tag: "When",
  guard,
  evaluate
});
const makeNot = (guard, evaluate) => ({
  _tag: "Not",
  guard,
  evaluate
});
const makePredicate = pattern => {
  if (typeof pattern === "function") {
    return pattern;
  } else if (Array.isArray(pattern)) {
    const predicates = pattern.map(makePredicate);
    const len = predicates.length;
    return u => {
      if (!Array.isArray(u)) {
        return false;
      }
      for (let i = 0; i < len; i++) {
        if (predicates[i](u[i]) === false) {
          return false;
        }
      }
      return true;
    };
  } else if (pattern !== null && typeof pattern === "object") {
    const keysAndPredicates = Object.entries(pattern).map(([k, p]) => [k, makePredicate(p)]);
    const len = keysAndPredicates.length;
    return u => {
      if (typeof u !== "object" || u === null) {
        return false;
      }
      for (let i = 0; i < len; i++) {
        const [key, predicate] = keysAndPredicates[i];
        if (!(key in u) || predicate(u[key]) === false) {
          return false;
        }
      }
      return true;
    };
  }
  return u => u === pattern;
};
const makeOrPredicate = patterns => {
  const predicates = patterns.map(makePredicate);
  const len = predicates.length;
  return u => {
    for (let i = 0; i < len; i++) {
      if (predicates[i](u) === true) {
        return true;
      }
    }
    return false;
  };
};
const makeAndPredicate = patterns => {
  const predicates = patterns.map(makePredicate);
  const len = predicates.length;
  return u => {
    for (let i = 0; i < len; i++) {
      if (predicates[i](u) === false) {
        return false;
      }
    }
    return true;
  };
};

/** @internal */
const type = () => makeTypeMatcher([]);

/** @internal */
const value = i => makeValueMatcher(i, left(i));

/** @internal */
const valueTags = fields => {
  const match = tagsExhaustive(fields)(makeTypeMatcher([]));
  return input => match(input);
};

/** @internal */
const typeTags = () => fields => {
  const match = tagsExhaustive(fields)(makeTypeMatcher([]));
  return input => match(input);
};

/** @internal */
const when$1 = (pattern, f) => self => self.add(makeWhen(makePredicate(pattern), f));

/** @internal */
const whenOr = (...args) => self => {
  const onMatch = args[args.length - 1];
  const patterns = args.slice(0, -1);
  return self.add(makeWhen(makeOrPredicate(patterns), onMatch));
};

/** @internal */
const whenAnd = (...args) => self => {
  const onMatch = args[args.length - 1];
  const patterns = args.slice(0, -1);
  return self.add(makeWhen(makeAndPredicate(patterns), onMatch));
};

/** @internal */
const discriminator = field => (...pattern) => {
  const f = pattern[pattern.length - 1];
  const values = pattern.slice(0, -1);
  const pred = values.length === 1 ? _ => _[field] === values[0] : _ => values.includes(_[field]);
  return self => self.add(makeWhen(pred, f));
};

/** @internal */
const discriminatorStartsWith = field => (pattern, f) => {
  const pred = _ => typeof _[field] === "string" && _[field].startsWith(pattern);
  return self => self.add(makeWhen(pred, f));
};

/** @internal */
const discriminators = field => fields => {
  const predicates = [];
  for (const key in fields) {
    const pred = _ => _[field] === key;
    const f = fields[key];
    if (f) {
      predicates.push(makeWhen(pred, f));
    }
  }
  const len = predicates.length;
  return self => {
    let matcher = self;
    for (let i = 0; i < len; i++) {
      matcher = matcher.add(predicates[i]);
    }
    return matcher;
  };
};

/** @internal */
const discriminatorsExhaustive = field => fields => {
  const addCases = discriminators(field)(fields);
  return matcher => exhaustive(addCases(matcher));
};

/** @internal */
const tag = /*#__PURE__*/discriminator("_tag");

/** @internal */
const tagStartsWith = /*#__PURE__*/discriminatorStartsWith("_tag");

/** @internal */
const tags = /*#__PURE__*/discriminators("_tag");

/** @internal */
const tagsExhaustive = /*#__PURE__*/discriminatorsExhaustive("_tag");

/** @internal */
const not = (pattern, f) => self => self.add(makeNot(makePredicate(pattern), f));

/** @internal */
const nonEmptyString = u => typeof u === "string" && u.length > 0;

/** @internal */
const is = (...literals) => {
  const len = literals.length;
  return u => {
    for (let i = 0; i < len; i++) {
      if (u === literals[i]) {
        return true;
      }
    }
    return false;
  };
};

/** @internal */
const any = () => true;

/** @internal */
const defined = u => u !== undefined && u !== null;

/** @internal */
const instanceOf = constructor => u => u instanceof constructor;

/** @internal */
const orElse$1 = f => self => {
  const result = either$1(self);
  if (isEither$1(result)) {
    // @ts-expect-error
    return result._tag === "Right" ? result.right : f(result.left);
  }

  // @ts-expect-error
  return input => {
    const a = result(input);
    return a._tag === "Right" ? a.right : f(a.left);
  };
};

/** @internal */
const orElseAbsurd = self => orElse$1(() => {
  throw new Error("absurd");
})(self);

/** @internal */
const either$1 = self => {
  if (self._tag === "ValueMatcher") {
    return self.value;
  }
  const len = self.cases.length;
  return input => {
    for (let i = 0; i < len; i++) {
      const _case = self.cases[i];
      if (_case._tag === "When" && _case.guard(input) === true) {
        return right(_case.evaluate(input));
      } else if (_case._tag === "Not" && _case.guard(input) === false) {
        return right(_case.evaluate(input));
      }
    }
    return left(input);
  };
};

/** @internal */
const option$1 = self => {
  const toEither = either$1(self);
  if (isEither$1(toEither)) {
    return match$i(toEither, {
      onLeft: () => none$8(),
      onRight: some$6
    });
  }
  return input => match$i(toEither(input), {
    onLeft: () => none$8(),
    onRight: some$6
  });
};

/** @internal */
const exhaustive = self => {
  const toEither = either$1(self);
  if (isEither$1(toEither)) {
    if (toEither._tag === "Right") {
      return toEither.right;
    }
    throw new Error("@effect/match: exhaustive absurd");
  }
  return u => {
    // @ts-expect-error
    const result = toEither(u);
    if (result._tag === "Right") {
      return result.right;
    }
    throw new Error("@effect/match: exhaustive absurd");
  };
};

/**
 * @since 1.0.0
 */
/**
 * @category type ids
 * @since 1.0.0
 */
TypeId$1;

/**
 * @category type ids
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category constructors
 * @since 1.0.0
 */
type;

/**
 * @category constructors
 * @since 1.0.0
 */
value;

/**
 * @category constructors
 * @since 1.0.0
 */
valueTags;

/**
 * @category constructors
 * @since 1.0.0
 */
typeTags;

/**
 * @category combinators
 * @since 1.0.0
 */
when$1;

/**
 * @category combinators
 * @since 1.0.0
 */
whenOr;

/**
 * @category combinators
 * @since 1.0.0
 */
whenAnd;

/**
 * @category combinators
 * @since 1.0.0
 */
discriminator;

/**
 * @category combinators
 * @since 1.0.0
 */
discriminatorStartsWith;

/**
 * @category combinators
 * @since 1.0.0
 */
discriminators;

/**
 * @category combinators
 * @since 1.0.0
 */
discriminatorsExhaustive;

/**
 * @category combinators
 * @since 1.0.0
 */
tag;

/**
 * @category combinators
 * @since 1.0.0
 */
tagStartsWith;

/**
 * @category combinators
 * @since 1.0.0
 */
tags;

/**
 * @category combinators
 * @since 1.0.0
 */
tagsExhaustive;

/**
 * @category combinators
 * @since 1.0.0
 */
not;

/**
 * @category predicates
 * @since 1.0.0
 */
nonEmptyString;

/**
 * @category predicates
 * @since 1.0.0
 */
is;

/**
 * @category predicates
 * @since 1.0.0
 */
any;

/**
 * @category predicates
 * @since 1.0.0
 */
defined;

/**
 * @category predicates
 * @since 1.0.0
 */
instanceOf;

/**
 * @category predicates
 * @since 1.0.0
 */
instanceOf;

/**
 * @category conversions
 * @since 1.0.0
 */
orElse$1;

/**
 * @category conversions
 * @since 1.0.0
 */
orElseAbsurd;

/**
 * @category conversions
 * @since 1.0.0
 */
either$1;

/**
 * @category conversions
 * @since 1.0.0
 */
option$1;

/**
 * @category conversions
 * @since 1.0.0
 */
exhaustive;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Metric<Type, In, Out>` represents a concurrent metric which accepts
 * updates of type `In` and are aggregated to a stateful value of type `Out`.
 *
 * For example, a counter metric would have type `Metric<number, number>`,
 * representing the fact that the metric can be updated with numbers (the amount
 * to increment or decrement the counter by), and the state of the counter is a
 * number.
 *
 * There are five primitive metric types supported by Effect:
 *
 *   - Counters
 *   - Frequencies
 *   - Gauges
 *   - Histograms
 *   - Summaries
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category globals
 */
globalMetricRegistry;

/**
 * @since 2.0.0
 * @category constructors
 */
make$C;

/**
 * Returns a new metric that is powered by this one, but which accepts updates
 * of the specified new type, which must be transformable to the input type of
 * this metric.
 *
 * @since 2.0.0
 * @category mapping
 */
mapInput$3;

/**
 * Represents a Counter metric that tracks cumulative numerical values over time.
 * Counters can be incremented and decremented and provide a running total of changes.
 *
 * @param name - The name of the counter metric.
 * @param options - An optional configuration for the counter:
 * - description - A description of the counter.
 * - bigint - Indicates if the counter uses 'bigint' data type.
 * - incremental - Set to 'true' for a counter that only increases. With this configuration, Effect ensures that non-incremental updates have no impact on the counter, making it exclusively suitable for counting upwards.
 *
 * @example
 * import * as Metric from "effect/Metric"
 *
 * const numberCounter = Metric.counter("count", {
 *   description: "A number counter"
 * });
 *
 * const bigintCounter = Metric.counter("count", {
 *   description: "A bigint counter",
 *   bigint: true
 * });
 *
 * @since 2.0.0
 * @category constructors
 */
counter;

/**
 * Creates a Frequency metric to count occurrences of events.
 * Frequency metrics are used to count the number of times specific events or incidents occur.
 *
 * @param name - The name of the Frequency metric.
 * @param description - An optional description of the Frequency metric.
 *
 * @example
 * import * as Metric from "effect/Metric"
 *
 * const errorFrequency = Metric.frequency("error_frequency", "Counts the occurrences of errors.");
 *
 * @since 2.0.0
 * @category constructors
 */
frequency;

/**
 * Returns a new metric that is powered by this one, but which accepts updates
 * of any type, and translates them to updates with the specified constant
 * update value.
 *
 * @since 2.0.0
 * @category constructors
 */
withConstantInput;

/**
 * @since 2.0.0
 * @category constructors
 */
fromMetricKey;

/**
 * Represents a Gauge metric that tracks and reports a single numerical value at a specific moment.
 * Gauges are suitable for metrics that represent instantaneous values, such as memory usage or CPU load.
 *
 * @param name - The name of the gauge metric.
 * @param options - An optional configuration for the gauge:
 * - description - A description of the gauge metric.
 * - bigint - Indicates if the counter uses 'bigint' data type.
 *
 * @example
 * import * as Metric from "effect/Metric"
 *
 * const numberGauge = Metric.gauge("memory_usage", {
 *   description: "A gauge for memory usage"
 * });
 *
 * const bigintGauge = Metric.gauge("cpu_load", {
 *   description: "A gauge for CPU load",
 *   bigint: true
 * });
 *
 * @since 2.0.0
 * @category constructors
 */
gauge;

/**
 * Represents a Histogram metric that records observations in specified value boundaries.
 * Histogram metrics are useful for measuring the distribution of values within a range.
 *
 * @param name - The name of the histogram metric.
 * @param boundaries - The boundaries for defining the histogram's value ranges.
 * @param description - A description of the histogram metric.
 *
 * @example
 * import * as Metric from "effect/Metric"
 * import * as MetricBoundaries from "effect/MetricBoundaries"
 *
 * const latencyHistogram = Metric.histogram("latency_histogram",
 *   MetricBoundaries.linear({ start: 0, width: 10, count: 11 }),
 *   "Measures the distribution of request latency."
 * );
 *
 * @since 2.0.0
 * @category constructors
 */
histogram;

/**
 * @since 2.0.0
 * @category aspects
 */
increment;

/**
 * @since 2.0.0
 * @category aspects
 */
incrementBy;

/**
 * Returns a new metric that is powered by this one, but which outputs a new
 * state type, determined by transforming the state type of this metric by the
 * specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
map$a;

/**
 * @since 2.0.0
 * @category mapping
 */
mapType;

/**
 * @since 2.0.0
 * @category aspects
 */
set$5;

/**
 * Captures a snapshot of all metrics recorded by the application.
 *
 * @since 2.0.0
 * @category getters
 */
snapshot;

/**
 * Creates a metric that ignores input and produces constant output.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$b;

/**
 * Creates a metric that ignores input and produces constant output.
 *
 * @since 2.0.0
 * @category constructors
 */
sync$7;

/**
 * Creates a Summary metric that records observations and calculates quantiles.
 * Summary metrics provide statistical information about a set of values, including quantiles.
 *
 * @param options - An object with configuration options for the Summary metric:
 * - name - The name of the Summary metric.
 * - maxAge - The maximum age of observations to retain.
 * - maxSize - The maximum number of observations to keep.
 * - error - The error percentage when calculating quantiles.
 * - quantiles - An `Chunk` of quantiles to calculate (e.g., [0.5, 0.9]).
 * - description - An optional description of the Summary metric.
 *
 * @example
 * import * as Metric from "effect/Metric"
 * import * as Chunk from "effect/Chunk"
 *
 * const responseTimesSummary = Metric.summary({
 *   name: "response_times_summary",
 *   maxAge: "60 seconds", // Retain observations for 60 seconds.
 *   maxSize: 1000, // Keep a maximum of 1000 observations.
 *   error: 0.01, // Allow a 1% error when calculating quantiles.
 *   quantiles: Chunk.make(0.5, 0.9, 0.99), // Calculate 50th, 90th, and 99th percentiles.
 *   description: "Measures the distribution of response times."
 * });
 *
 * @since 2.0.0
 * @category constructors
 */
summary;

/**
 * @since 2.0.0
 * @category constructors
 */
summaryTimestamp;

/**
 * Returns a new metric, which is identical in every way to this one, except
 * the specified tags have been added to the tags of this metric.
 *
 * @since 2.0.0
 * @category utils
 */
tagged$1;

/**
 * Returns a new metric, which is identical in every way to this one, except
 * dynamic tags are added based on the update values. Note that the metric
 * returned by this method does not return any useful information, due to the
 * dynamic nature of the added tags.
 *
 * @since 2.0.0
 * @category utils
 */
taggedWithLabelsInput;

/**
 * Returns a new metric, which is identical in every way to this one, except
 * the specified tags have been added to the tags of this metric.
 *
 * @since 2.0.0
 * @category utils
 */
taggedWithLabels;

/**
 * Creates a timer metric, based on a histogram, which keeps track of
 * durations in milliseconds. The unit of time will automatically be added to
 * the metric as a tag (i.e. `"time_unit: milliseconds"`).
 *
 * @since 2.0.0
 * @category constructors
 */
timer;

/**
 * Creates a timer metric, based on a histogram created from the provided
 * boundaries, which keeps track of durations in milliseconds. The unit of time
 * will automatically be added to the metric as a tag (i.e.
 * `"time_unit: milliseconds"`).
 *
 * @since 2.0.0
 * @category constructors
 */
timerWithBoundaries;

/**
 * Returns an aspect that will update this metric with the specified constant
 * value every time the aspect is applied to an effect, regardless of whether
 * that effect fails or succeeds.
 *
 * @since 2.0.0
 * @category aspects
 */
trackAll;

/**
 * Returns an aspect that will update this metric with the defects of the
 * effects that it is applied to.
 *
 * @since 2.0.0
 * @category aspects
 */
trackDefect;

/**
 * Returns an aspect that will update this metric with the result of applying
 * the specified function to the defect throwables of the effects that the
 * aspect is applied to.
 *
 * @since 2.0.0
 * @category aspects
 */
trackDefectWith;

/**
 * Returns an aspect that will update this metric with the duration that the
 * effect takes to execute. To call this method, the input type of the metric
 * must be `Duration`.
 *
 * @since 2.0.0
 * @category aspects
 */
trackDuration;

/**
 * Returns an aspect that will update this metric with the duration that the
 * effect takes to execute. To call this method, you must supply a function
 * that can convert the `Duration` to the input type of this metric.
 *
 * @since 2.0.0
 * @category aspects
 */
trackDurationWith;

/**
 * Returns an aspect that will update this metric with the failure value of
 * the effects that it is applied to.
 *
 * @since 2.0.0
 * @category aspects
 */
trackError;

/**
 * Returns an aspect that will update this metric with the result of applying
 * the specified function to the error value of the effects that the aspect is
 * applied to.
 *
 * @since 2.0.0
 * @category aspects
 */
trackErrorWith;

/**
 * Returns an aspect that will update this metric with the success value of
 * the effects that it is applied to.
 *
 * @since 2.0.0
 * @category aspects
 */
trackSuccess;

/**
 * Returns an aspect that will update this metric with the result of applying
 * the specified function to the success value of the effects that the aspect is
 * applied to.
 *
 * @since 2.0.0
 * @category aspects
 */
trackSuccessWith;

/**
 * Updates the metric with the specified update message. For example, if the
 * metric were a counter, the update would increment the method by the
 * provided amount.
 *
 * @since 2.0.0
 * @category utils
 */
update$3;

/**
 * Retrieves a snapshot of the value of the metric at this moment in time.
 *
 * @since 2.0.0
 * @category getters
 */
value$1;

/**
 * @since 2.0.0
 * @category utils
 */
withNow;

/**
 * @since 2.0.0
 * @category zipping
 */
zip$6;

/**
 * Unsafely captures a snapshot of all metrics recorded by the application.
 *
 * @since 2.0.0
 * @category unsafe
 */
unsafeSnapshot;

/**
 * @since 2.0.0
 * @category metrics
 */
fiberStarted;

/**
 * @since 2.0.0
 * @category metrics
 */
fiberSuccesses;

/**
 * @since 2.0.0
 * @category metrics
 */
fiberFailures;

/**
 * @since 2.0.0
 * @category metrics
 */
fiberLifetimes;

/**
 * @since 2.0.0
 * @category metrics
 */
fiberActive;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricBoundariesTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category refinements
 */
isMetricBoundaries;

/**
 * @since 2.0.0
 * @category constructors
 */
fromChunk$1;

/**
 * A helper method to create histogram bucket boundaries for a histogram
 * with linear increasing values.
 *
 * @since 2.0.0
 * @category constructors
 */
linear$1;

/**
 * A helper method to create histogram bucket boundaries for a histogram
 * with exponentially increasing values.
 *
 * @since 2.0.0
 * @category constructors
 */
exponential$1;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricHookTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
make$F;

/**
 * @since 2.0.0
 * @category constructors
 */
counter$1;

/**
 * @since 2.0.0
 * @category constructors
 */
frequency$1;

/**
 * @since 2.0.0
 * @category constructors
 */
gauge$1;

/**
 * @since 2.0.0
 * @category constructors
 */
histogram$1;

/**
 * @since 2.0.0
 * @category constructors
 */
summary$1;

/**
 * @since 2.0.0
 * @category utils
 */
onUpdate;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricKeyTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `MetricKey` is a unique key associated with each metric. The key is based
 * on a combination of the metric type, the name and tags associated with the
 * metric, an optional description of the key, and any other information to
 * describe a metric, such as the boundaries of a histogram. In this way, it is
 * impossible to ever create different metrics with conflicting keys.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category refinements
 */
isMetricKey;

/**
 * Creates a metric key for a counter, with the specified name.
 *
 * @since 2.0.0
 * @category constructors
 */
counter$3;

/**
 * Creates a metric key for a categorical frequency table, with the specified
 * name.
 *
 * @since 2.0.0
 * @category constructors
 */
frequency$3;

/**
 * Creates a metric key for a gauge, with the specified name.
 *
 * @since 2.0.0
 * @category constructors
 */
gauge$3;

/**
 * Creates a metric key for a histogram, with the specified name and boundaries.
 *
 * @since 2.0.0
 * @category constructors
 */
histogram$3;

/**
 * Creates a metric key for a summary, with the specified name, maxAge,
 * maxSize, error, and quantiles.
 *
 * @since 2.0.0
 * @category constructors
 */
summary$3;

/**
 * Returns a new `MetricKey` with the specified tag appended.
 *
 * @since 2.0.0
 * @category constructors
 */
tagged$2;

/**
 * Returns a new `MetricKey` with the specified tags appended.
 *
 * @since 2.0.0
 * @category constructors
 */
taggedWithLabels$1;

/**
 * Returns a new `MetricKey` with the specified tags appended.
 *
 * @since 2.0.0
 * @category constructors
 */
taggedWithLabelSet;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricKeyTypeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
CounterKeyTypeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
FrequencyKeyTypeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
GaugeKeyTypeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
HistogramKeyTypeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
SummaryKeyTypeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category modelz
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
counter$4;

/**
 * @since 2.0.0
 * @category constructors
 */
frequency$4;

/**
 * @since 2.0.0
 * @category constructors
 */
gauge$4;

/**
 * @since 2.0.0
 * @category constructors
 */
histogram$4;

/**
 * @since 2.0.0
 * @category constructors
 */
summary$4;

/**
 * @since 2.0.0
 * @category refinements
 */
isMetricKeyType;

/**
 * @since 2.0.0
 * @category refinements
 */
isCounterKey;

/**
 * @since 2.0.0
 * @category refinements
 */
isFrequencyKey;

/**
 * @since 2.0.0
 * @category refinements
 */
isGaugeKey;

/**
 * @since 2.0.0
 * @category refinements
 */
isHistogramKey;

/**
 * @since 2.0.0
 * @category refinements
 */
isSummaryKey;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricLabelTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `MetricLabel` represents a key value pair that allows analyzing metrics at
 * an additional level of granularity.
 *
 * For example if a metric tracks the response time of a service labels could
 * be used to create separate versions that track response times for different
 * clients.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
make$K;

/**
 * @since 2.0.0
 * @category refinements
 */
isMetricLabel;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricPairTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
make$E;

/**
 * @since 2.0.0
 * @category unsafe
 */
unsafeMake$1;

/** @internal */
const PollingMetricSymbolKey = "effect/MetricPolling";

/** @internal */
const PollingMetricTypeId = /*#__PURE__*/Symbol.for(PollingMetricSymbolKey);

/** @internal */
const make$k = (metric, poll) => {
  return {
    [PollingMetricTypeId]: PollingMetricTypeId,
    pipe() {
      return pipeArguments(this, arguments);
    },
    metric,
    poll
  };
};

/** @internal */
const collectAll = iterable => {
  const metrics = Array.from(iterable);
  return {
    [PollingMetricTypeId]: PollingMetricTypeId,
    pipe() {
      return pipeArguments(this, arguments);
    },
    metric: make$C(Array.of(void 0), (inputs, extraTags) => {
      for (let i = 0; i < inputs.length; i++) {
        const pollingMetric = metrics[i];
        const input = pipe(inputs, x => x[i]);
        pollingMetric.metric.unsafeUpdate(input, extraTags);
      }
    }, extraTags => Array.from(metrics.map(pollingMetric => pollingMetric.metric.unsafeValue(extraTags)))),
    poll: forEachSequential(metrics, metric => metric.poll)
  };
};

/** @internal */
const launch = /*#__PURE__*/dual(2, (self, schedule) => pipe(pollAndUpdate(self), zipRight$8(value$1(self.metric)), scheduleForked$1(schedule)));

/** @internal */
const poll$2 = self => self.poll;

/** @internal */
const pollAndUpdate = self => flatMap$6(self.poll, value => update$3(self.metric, value));

/** @internal */
const retry$3 = /*#__PURE__*/dual(2, (self, policy) => ({
  [PollingMetricTypeId]: PollingMetricTypeId,
  pipe() {
    return pipeArguments(this, arguments);
  },
  metric: self.metric,
  poll: retry_Effect(self.poll, policy)
}));

/** @internal */
const zip$1 = /*#__PURE__*/dual(2, (self, that) => ({
  [PollingMetricTypeId]: PollingMetricTypeId,
  pipe() {
    return pipeArguments(this, arguments);
  },
  metric: pipe(self.metric, zip$6(that.metric)),
  poll: zip$a(self.poll, that.poll)
}));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
PollingMetricTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `PollingMetric` is a combination of a metric and an effect that polls for
 * updates to the metric.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new polling metric from a metric and poll effect.
 *
 * @since 2.0.0
 * @category constructors
 */
make$k;

/**
 * Collects all of the polling metrics into a single polling metric, which
 * polls for, updates, and produces the outputs of all individual metrics.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAll;

/**
 * Returns an effect that will launch the polling metric in a background
 * fiber, using the specified schedule.
 *
 * @since 2.0.0
 * @category utils
 */
launch;

/**
 * An effect that polls a value that may be fed to the metric.
 *
 * @since 2.0.0
 * @category utils
 */
poll$2;

/**
 * An effect that polls for a value and uses the value to update the metric.
 *
 * @since 2.0.0
 * @category utils
 */
pollAndUpdate;

/**
 * Returns a new polling metric whose poll function will be retried with the
 * specified retry policy.
 *
 * @since 2.0.0
 * @category constructors
 */
retry$3;

/**
 * Zips this polling metric with the specified polling metric.
 *
 * @since 2.0.0
 * @category utils
 */
zip$1;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricRegistryTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
make$D;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
MetricStateTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
CounterStateTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
FrequencyStateTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
GaugeStateTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
HistogramStateTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
SummaryStateTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `MetricState` describes the state of a metric. The type parameter of a
 * metric state corresponds to the type of the metric key (`MetricStateType`).
 * This phantom type parameter is used to tie keys to their expected states.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
counter$2;

/**
 * @since 2.0.0
 * @category constructors
 */
frequency$2;

/**
 * @since 2.0.0
 * @category constructors
 */
gauge$2;

/**
 * @since 2.0.0
 * @category constructors
 */
histogram$2;

/**
 * @since 2.0.0
 * @category constructors
 */
summary$2;

/**
 * @since 2.0.0
 * @category refinements
 */
isMetricState;

/**
 * @since 2.0.0
 * @category refinements
 */
isCounterState;

/**
 * @since 2.0.0
 * @category refinements
 */
isFrequencyState;

/**
 * @since 2.0.0
 * @category refinements
 */
isGaugeState;

/**
 * @since 2.0.0
 * @category refinements
 */
isHistogramState;

/**
 * @since 2.0.0
 * @category refinements
 */
isSummaryState;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
PoolTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Pool<E, A>` is a pool of items of type `A`, each of which may be
 * associated with the acquisition and release of resources. An attempt to get
 * an item `A` from a pool may fail with an error of type `E`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Returns `true` if the specified value is a `Pool`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isPool;

/**
 * Makes a new pool of the specified fixed size. The pool is returned in a
 * `Scope`, which governs the lifetime of the pool. When the pool is shutdown
 * because the `Scope` is closed, the individual items allocated by the pool
 * will be released in some unspecified order.
 *
 * @since 2.0.0
 * @category constructors
 */
make$m;

/**
 * Makes a new pool with the specified minimum and maximum sizes and time to
 * live before a pool whose excess items are not being used will be shrunk
 * down to the minimum size. The pool is returned in a `Scope`, which governs
 * the lifetime of the pool. When the pool is shutdown because the `Scope` is
 * used, the individual items allocated by the pool will be released in some
 * unspecified order.
 *
 * ```ts
 * import * as Duration from "./Duration"
 * import * as Effect from "effect/Effect"
 * import * as Pool from "effect/Pool"
 * import * as Scope from "effect/Scope"
 * import { pipe } from "./Function"
 *
 * Effect.scoped(
 *   pipe(
 *     Pool.make(acquireDbConnection, 10, 20, Duration.seconds(60)),
 *     Effect.flatMap((pool) =>
 *       Effect.scoped(
 *         pipe(
 *           pool.get(),
 *           Effect.flatMap((connection) => useConnection(connection))
 *         )
 *       )
 *     )
 *   )
 * )
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
makeWithTTL$1;

/**
 * Retrieves an item from the pool in a scoped effect. Note that if
 * acquisition fails, then the returned effect will fail for that same reason.
 * Retrying a failed acquisition attempt will repeat the acquisition attempt.
 *
 * @since 2.0.0
 * @category getters
 */
get$a;

/**
 * Invalidates the specified item. This will cause the pool to eventually
 * reallocate the item, although this reallocation may occur lazily rather
 * than eagerly.
 *
 * @since 2.0.0
 * @category combinators
 */
invalidate$1;

/** @internal */
const ScopedRefSymbolKey = "effect/ScopedRef";

/** @internal */
const ScopedRefTypeId = /*#__PURE__*/Symbol.for(ScopedRefSymbolKey);

/** @internal */
const scopedRefVariance = {
  _A: _ => _
};

/** @internal  */
const close = self => flatMap$6(get$c(self.ref), tuple => tuple[0].close(exitUnit));

/** @internal */
const fromAcquire = acquire => uninterruptibleMask$1(restore => pipe(scopeMake(), flatMap$6(newScope => pipe(restore(pipe(acquire, mapInputContext$6(add$4(scopeTag, newScope)))), onError$2(cause => newScope.close(exitFail(cause))), flatMap$6(value => pipe(makeSynchronized([newScope, value]), flatMap$6(ref => {
  const scopedRef = {
    [ScopedRefTypeId]: scopedRefVariance,
    pipe() {
      return pipeArguments(this, arguments);
    },
    ref
  };
  return pipe(addFinalizer$2(() => close(scopedRef)), as$6(scopedRef));
})))))));

/** @internal */
const get$8 = self => map$f(get$c(self.ref), tuple => tuple[1]);

/** @internal */
const make$j = evaluate => fromAcquire(sync$a(evaluate));

/** @internal */
const set$4 = /*#__PURE__*/dual(2, (self, acquire) => flatten$6(modifyEffect$1(self.ref, ([oldScope, value]) => uninterruptibleMask$1(restore => pipe(scopeMake(), flatMap$6(newScope => pipe(restore(pipe(acquire, mapInputContext$6(add$4(scopeTag, newScope)))), exit$1, flatMap$6(exitMatch({
  onFailure: cause => pipe(newScope.close(exitUnit), ignore$2, as$6([failCause$a(cause), [oldScope, value]])),
  onSuccess: value => pipe(oldScope.close(exitUnit), ignore$2, as$6([unit$6, [newScope, value]]))
})))))))));

/** @internal */
const ReloadableSymbolKey = "effect/Reloadable";

/** @internal */
const ReloadableTypeId = /*#__PURE__*/Symbol.for(ReloadableSymbolKey);

/** @internal */
const reloadableVariance = {
  _A: _ => _
};

/** @internal */
const auto$1 = (tag, options) => scoped$3(reloadableTag(tag), pipe(build$1(manual$1(tag, {
  layer: options.layer
})), map$f(unsafeGet$6(reloadableTag(tag))), tap$5(reloadable => acquireRelease$2(pipe(reloadable.reload(), ignoreLogged$1, schedule_Effect(options.schedule), forkDaemon$1), interruptFiber))));

/** @internal */
const autoFromConfig = (tag, options) => scoped$3(reloadableTag(tag), pipe(context$7(), flatMap$6(env => pipe(build$1(auto$1(tag, {
  layer: options.layer,
  schedule: options.scheduleFromConfig(env)
})), map$f(unsafeGet$6(reloadableTag(tag)))))));

/** @internal */
const get$7 = tag => flatMap$6(reloadableTag(tag), reloadable => get$8(reloadable.scopedRef));

/** @internal */
const manual$1 = (tag, options) => scoped$3(reloadableTag(tag), pipe(context$7(), flatMap$6(env => pipe(fromAcquire(pipe(build$1(options.layer), map$f(unsafeGet$6(tag)))), map$f(ref => ({
  [ReloadableTypeId]: reloadableVariance,
  scopedRef: ref,
  reload: () => pipe(set$4(ref, pipe(build$1(options.layer), map$f(unsafeGet$6(tag)))), provideContext$6(env))
}))))));

/** @internal */
const tagMap = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/Reloadable/tagMap"), () => new WeakMap([]));

/** @internal */
const reloadableTag = tag => {
  if (tagMap.has(tag)) {
    return tagMap.get(tag);
  }
  const newTag = Tag$1();
  tagMap.set(tag, newTag);
  return newTag;
};

/** @internal */
const reload = tag => flatMap$6(reloadableTag(tag), reloadable => reloadable.reload());

/** @internal */
const reloadFork = tag => flatMap$6(reloadableTag(tag), reloadable => pipe(reloadable.reload(), ignoreLogged$1, forkDaemon$1, asUnit$4));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ReloadableTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Reloadable` is an implementation of some service that can be dynamically
 * reloaded, or swapped out for another implementation on-the-fly.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Makes a new reloadable service from a layer that describes the construction
 * of a static service. The service is automatically reloaded according to the
 * provided schedule.
 *
 * @since 2.0.0
 * @category constructors
 */
auto$1;

/**
 * Makes a new reloadable service from a layer that describes the construction
 * of a static service. The service is automatically reloaded according to a
 * schedule, which is extracted from the input to the layer.
 *
 * @since 2.0.0
 * @category constructors
 */
autoFromConfig;

/**
 * Retrieves the current version of the reloadable service.
 *
 * @since 2.0.0
 * @category getters
 */
get$7;

/**
 * Makes a new reloadable service from a layer that describes the construction
 * of a static service.
 *
 * @since 2.0.0
 * @category constructors
 */
manual$1;

/**
 * Reloads the specified service.
 *
 * @since 2.0.0
 * @category constructors
 */
reload;

/**
 * @since 2.0.0
 * @category context
 */
reloadableTag;

/**
 * Forks the reload of the service in the background, ignoring any errors.
 *
 * @since 2.0.0
 * @category constructors
 */
reloadFork;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
RequestTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Request<E, A>` is a request from a data source for a value of type `A`
 * that may fail with an `E`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Returns `true` if the specified value is a `Request`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isRequest;

/**
 * Constructs a new `Request`.
 *
 * @since 2.0.0
 * @category constructors
 */
of$1;

/**
 * Constructs a new `Request`.
 *
 * @since 2.0.0
 * @category constructors
 */
tagged;

/**
 * Complete a `Request` with the specified result.
 *
 * @since 2.0.0
 * @category request completion
 */
complete$2;

/**
 * Interrupts the child effect when requests are no longer needed
 *
 * @since 2.0.0
 * @category request completion
 */
interruptWhenPossible;

/**
 * Complete a `Request` with the specified effectful computation, failing the
 * request with the error from the effect workflow if it fails, and completing
 * the request with the value of the effect workflow if it succeeds.
 *
 * @since 2.0.0
 * @category request completion
 */
completeEffect;

/**
 * Complete a `Request` with the specified error.
 *
 * @since 2.0.0
 * @category request completion
 */
fail$a;

/**
 * Complete a `Request` with the specified value.
 *
 * @since 2.0.0
 * @category request completion
 */
succeed$a;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Entry<A>` keeps track of a request of type `A` along with a
 * `Ref` containing the result of the request, existentially hiding the result
 * type. This is used internally by the library to support data sources that
 * return different result types for different requests while guaranteeing that
 * results will be of the type requested.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category guards
 */
isEntry;

/**
 * @since 2.0.0
 * @category constructors
 */
makeEntry;

/** @internal */
const make$i = runAll => new RequestResolverImpl(requests => runAll(requests.map(_ => _.map(_ => _.request))));

/** @internal */
const makeWithEntry = runAll => new RequestResolverImpl(requests => runAll(requests));

/** @internal */
const makeBatched = run => new RequestResolverImpl(requests => requests.length > 1 ? forEachSequentialDiscard(requests, block => invokeWithInterrupt(run(block.filter(_ => !_.state.completed).map(_ => _.request)), block)) : requests.length === 1 ? run(requests[0].filter(_ => !_.state.completed).map(_ => _.request)) : unit$6);

/** @internal */
const around = /*#__PURE__*/dual(3, (self, before, after) => new RequestResolverImpl(requests => acquireUseRelease$3(before, () => self.runAll(requests), after), make$11("Around", self, before, after)));

/** @internal */
const batchN = /*#__PURE__*/dual(2, (self, n) => new RequestResolverImpl(requests => {
  return n < 1 ? die$9(IllegalArgumentException("RequestResolver.batchN: n must be at least 1")) : self.runAll(Array.from(map$l(reduce$i(requests, empty$z(), (acc, chunk) => appendAll$1(acc, chunksOf(unsafeFromArray(chunk), n))), chunk => Array.from(chunk))));
}, make$11("BatchN", self, n)));

/** @internal */
const mapInputContext$1 = /*#__PURE__*/dual(2, (self, f) => new RequestResolverImpl(requests => mapInputContext$6(self.runAll(requests), context => f(context)), make$11("MapInputContext", self, f)));

/** @internal */
const eitherWith = /*#__PURE__*/dual(3, (self, that, f) => new RequestResolverImpl(batch => pipe(forEachSequential(batch, requests => {
  const [as, bs] = pipe(requests, partitionMap$1(f));
  return zipWithOptions(self.runAll(Array.of(as)), that.runAll(Array.of(bs)), () => void 0, {
    concurrent: true
  });
})), make$11("EitherWith", self, that, f)));

/** @internal */
const fromFunction = f => makeBatched(requests => forEachSequentialDiscard(requests, request => complete$2(request, exitSucceed(f(request))))).identified("FromFunction", f);

/** @internal */
const fromFunctionBatched = f => makeBatched(as => forEach$6(f(as), (res, i) => complete$2(as[i], exitSucceed(res)), {
  discard: true
})).identified("FromFunctionBatched", f);

/** @internal */
const fromFunctionEffect = f => makeBatched(requests => forEach$6(requests, a => flatMap$4(exit(f(a)), e => complete$2(a, e)), {
  concurrency: "unbounded",
  discard: true
})).identified("FromFunctionEffect", f);

/** @internal */
const never = /*#__PURE__*/make$i(() => never$4).identified("Never");

/** @internal */
const provideContext$1 = /*#__PURE__*/dual(2, (self, context) => mapInputContext$1(self, _ => context).identified("ProvideContext", self, context));

/** @internal */
const race = /*#__PURE__*/dual(2, (self, that) => new RequestResolverImpl(requests => race$2(self.runAll(requests), that.runAll(requests))).identified("Race", self, that));

/**
 * @since 2.0.0
 */

/**
 * `RequestBlock` captures a collection of blocked requests as a data
 * structure. By doing this the library is able to preserve information about
 * which requests must be performed sequentially and which can be performed in
 * parallel, allowing for maximum possible batching and pipelining while
 * preserving ordering guarantees.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
single;

/**
 * @since 2.0.0
 * @category constructors
 */
empty$o;

/**
 * @since 2.0.0
 * @category constructors
 */
mapRequestResolvers;

/**
 * @since 2.0.0
 * @category constructors
 */
par;

/**
 * @since 2.0.0
 * @category constructors
 */
reduce$b;

/**
 * @since 2.0.0
 * @category constructors
 */
seq;

/**
 * Provides each data source with a fiber ref value.
 *
 * @since 2.0.0
 * @category utils
 */
requestBlockLocally;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
RequestResolverTypeId;

/**
 * Returns `true` if the specified value is a `RequestResolver`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isRequestResolver;

/**
 * Constructs a data source with the specified identifier and method to run
 * requests.
 *
 * @since 2.0.0
 * @category constructors
 */
make$i;

/**
 * Constructs a data source with the specified identifier and method to run
 * requests.
 *
 * @since 2.0.0
 * @category constructors
 */
makeWithEntry;

/**
 * Constructs a data source from a function taking a collection of requests
 * and returning a `RequestCompletionMap`.
 *
 * @since 2.0.0
 * @category constructors
 */
makeBatched;

/**
 * A data source aspect that executes requests between two effects, `before`
 * and `after`, where the result of `before` can be used by `after`.
 *
 * @since 2.0.0
 * @category combinators
 */
around;

/**
 * Returns a data source that executes at most `n` requests in parallel.
 *
 * @since 2.0.0
 * @category combinators
 */
batchN;

/**
 * Provides this data source with part of its required context.
 *
 * @since 2.0.0
 * @category context
 */
mapInputContext$1;

/**
 * Returns a new data source that executes requests of type `C` using the
 * specified function to transform `C` requests into requests that either this
 * data source or that data source can execute.
 *
 * @since 2.0.0
 * @category combinators
 */
eitherWith;

/**
 * Constructs a data source from a pure function.
 *
 * @since 2.0.0
 * @category constructors
 */
fromFunction;

/**
 * Constructs a data source from a pure function that takes a list of requests
 * and returns a list of results of the same size. Each item in the result
 * list must correspond to the item at the same index in the request list.
 *
 * @since 2.0.0
 * @category constructors
 */
fromFunctionBatched;

/**
 * Constructs a data source from an effectual function.
 *
 * @since 2.0.0
 * @category constructors
 */
fromFunctionEffect;

/**
 * A data source that never executes requests.
 *
 * @since 2.0.0
 * @category constructors
 */
never;

/**
 * Provides this data source with its required context.
 *
 * @since 2.0.0
 * @category context
 */
provideContext$1;

/**
 * Returns a new data source that executes requests by sending them to this
 * data source and that data source, returning the results from the first data
 * source to complete and safely interrupting the loser.
 *
 * @since 2.0.0
 * @category combinators
 */
race;

/**
 * Returns a new data source with a localized FiberRef
 *
 * @since 2.0.0
 * @category combinators
 */
resolverLocally;

/** @internal */
const ResourceSymbolKey = "effect/Resource";

/** @internal */
const ResourceTypeId = /*#__PURE__*/Symbol.for(ResourceSymbolKey);

/** @internal */
const cachedVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */
const auto = (acquire, policy) => tap$5(manual(acquire), manual => acquireRelease$2(pipe(refresh(manual), schedule_Effect(policy), interruptible$1, forkDaemon$1), interruptFiber));

/** @internal */
const manual = acquire => flatMap$6(context$7(), env => pipe(fromAcquire(exit$1(acquire)), map$f(ref => ({
  [ResourceTypeId]: cachedVariance,
  scopedRef: ref,
  acquire: () => provideContext$6(acquire, env)
}))));

/** @internal */
const get$6 = self => flatMap$6(get$8(self.scopedRef), identity$1);

/** @internal */
const refresh = self => set$4(self.scopedRef, map$f(self.acquire(), exitSucceed));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ResourceTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Resource` is a possibly resourceful value that is loaded into memory, and
 * which can be refreshed either manually or automatically.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Creates a new `Resource` value that is automatically refreshed according to
 * the specified policy. Note that error retrying is not performed
 * automatically, so if you want to retry on errors, you should first apply
 * retry policies to the acquisition effect before passing it to this
 * constructor.
 *
 * @since 2.0.0
 * @category constructors
 */
auto;

/**
 * Retrieves the current value stored in the cache.
 *
 * @since 2.0.0
 * @category getters
 */
get$6;

/**
 * Creates a new `Resource` value that must be manually refreshed by calling
 * the refresh method. Note that error retrying is not performed
 * automatically, so if you want to retry on errors, you should first apply
 * retry policies to the acquisition effect before passing it to this
 * constructor.
 *
 * @since 2.0.0
 * @category constructors
 */
manual;

/**
 * Refreshes the cache. This method will not return until either the refresh
 * is successful, or the refresh operation fails.
 *
 * @since 2.0.0
 * @category utils
 */
refresh;

/**
 * @since 2.0.0
 */

/**
 * Represents a set of `RuntimeFlag`s. `RuntimeFlag`s affect the operation of
 * the Effect runtime system. They are exposed to application-level code because
 * they affect the behavior and performance of application code.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Represents a flag that can be set to enable or disable a particular feature
 * of the Effect runtime.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * No runtime flags.
 *
 * @since 2.0.0
 * @category constructors
 */
None$1;

/**
 * The interruption flag determines whether or not the Effect runtime system will
 * interrupt a fiber.
 *
 * @since 2.0.0
 * @category constructors
 */
Interruption;

/**
 * The op supervision flag determines whether or not the Effect runtime system
 * will supervise all operations of the Effect runtime. Use of this flag will
 * negatively impact performance, but is required for some operations, such as
 * profiling.
 *
 * @since 2.0.0
 * @category constructors
 */
OpSupervision;

/**
 * The runtime metrics flag determines whether or not the Effect runtime system
 * will collect metrics about the Effect runtime. Use of this flag will have a
 * very small negative impact on performance, but generates very helpful
 * operational insight into running Effect applications that can be exported to
 * Prometheus or other tools via Effect Metrics.
 *
 * @since 2.0.0
 * @category constructors
 */
RuntimeMetrics;

/**
 * The wind down flag determines whether the Effect runtime system will execute
 * effects in wind-down mode. In wind-down mode, even if interruption is
 * enabled and a fiber has been interrupted, the fiber will continue its
 * execution uninterrupted.
 *
 * @since 2.0.0
 * @category constructors
 */
WindDown;

/**
 * The cooperative yielding flag determines whether the Effect runtime will
 * yield to another fiber.
 *
 * @since 2.0.0
 * @category constructors
 */
CooperativeYielding;

/**
 * Returns `true` if the `CooperativeYielding` `RuntimeFlag` is enabled, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
cooperativeYielding;

/**
 * Creates a `RuntimeFlagsPatch` which describes the difference between `self`
 * and `that`.
 *
 * @since 2.0.0
 * @category diffing
 */
diff$3;

/**
 * Constructs a differ that knows how to diff `RuntimeFlags` values.
 *
 * @since 2.0.0
 * @category utils
 */
differ$1;

/**
 * Disables the specified `RuntimeFlag`.
 *
 * @since 2.0.0
 * @category utils
 */
disable$1;

/**
 * Disables all of the `RuntimeFlag`s in the specified set of `RuntimeFlags`.
 *
 * @since 2.0.0
 * @category utils
 */
disableAll;

/**
 * @since 2.0.0
 * @category context
 */
disableCooperativeYielding;

/**
 * @since 2.0.0
 * @category context
 */
disableInterruption;

/**
 * @since 2.0.0
 * @category context
 */
disableOpSupervision;

/**
 * @since 2.0.0
 * @category context
 */
disableRuntimeMetrics;

/**
 * @since 2.0.0
 * @category context
 */
disableWindDown;

/**
 * Enables the specified `RuntimeFlag`.
 *
 * @since 2.0.0
 * @category utils
 */
enable$1;

/**
 * Enables all of the `RuntimeFlag`s in the specified set of `RuntimeFlags`.
 *
 * @since 2.0.0
 * @category utils
 */
enableAll;

/**
 * @since 2.0.0
 * @category context
 */
enableCooperativeYielding;

/**
 * @since 2.0.0
 * @category context
 */
enableInterruption;

/**
 * @since 2.0.0
 * @category context
 */
enableOpSupervision;

/**
 * @since 2.0.0
 * @category context
 */
enableRuntimeMetrics;

/**
 * @since 2.0.0
 * @category context
 */
enableWindDown;

/**
 * Returns true only if the `Interruption` flag is **enabled** and the
 * `WindDown` flag is **disabled**.
 *
 * A fiber is said to be interruptible if interruption is enabled and the fiber
 * is not in its wind-down phase, in which it takes care of cleanup activities
 * related to fiber shutdown.
 *
 * @since 2.0.0
 * @category getters
 */
interruptible$2;

/**
 * Returns `true` if the `Interruption` `RuntimeFlag` is enabled, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
interruption;

/**
 * Returns `true` if the specified `RuntimeFlag` is enabled, `false` otherwise.
 *
 * @since 2.0.0
 * @category elements
 */
isEnabled;

/**
 * Returns `true` if the specified `RuntimeFlag` is disabled, `false` otherwise.
 *
 * @since 2.0.0
 * @category elements
 */
isDisabled;

/**
 * @since 2.0.0
 * @category constructors
 */
make$T;

/**
 * @since 2.0.0
 * @category constructors
 */
none$5;

/**
 * Returns `true` if the `OpSupervision` `RuntimeFlag` is enabled, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
opSupervision;

/**
 * Patches a set of `RuntimeFlag`s with a `RuntimeFlagsPatch`, returning the
 * patched set of `RuntimeFlag`s.
 *
 * @since 2.0.0
 * @category utils
 */
patch$4;

/**
 * Converts the provided `RuntimeFlags` into a `string`.
 *
 * @category conversions
 * @since 2.0.0
 */
render$2;

/**
 * Returns `true` if the `RuntimeMetrics` `RuntimeFlag` is enabled, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
runtimeMetrics;

/**
 * Converts the provided `RuntimeFlags` into a `ReadonlySet<number>`.
 *
 * @category conversions
 * @since 2.0.0
 */
toSet$1;

/**
 * Returns `true` if the `WindDown` `RuntimeFlag` is enabled, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
windDown;

/** @internal */
const OP_WITH_STM_RUNTIME = "WithSTMRuntime";

/** @internal */

/** @internal */
const OP_ON_FAILURE = "OnFailure";

/** @internal */

/** @internal */
const OP_ON_RETRY = "OnRetry";

/** @internal */

/** @internal */
const OP_ON_SUCCESS = "OnSuccess";

/** @internal */

/** @internal */
const OP_PROVIDE = "Provide";

/** @internal */

/** @internal */
const OP_SYNC = "Sync";

/** @internal */

/** @internal */
const OP_SUCCEED$1 = "Succeed";

/** @internal */

/** @internal */
const OP_RETRY$1 = "Retry";

/** @internal */

/** @internal */
const OP_FAIL$1 = "Fail";

/** @internal */

/** @internal */
const OP_DIE$1 = "Die";

/** @internal */

/** @internal */
const OP_INTERRUPT$1 = "Interrupt";

/** @internal */
const OP_FAIL = "Fail";

/** @internal */

/** @internal */
const OP_DIE = "Die";

/** @internal */

/** @internal */
const OP_INTERRUPT = "Interrupt";

/** @internal */

/** @internal */
const OP_SUCCEED = "Succeed";

/** @internal */

/** @internal */
const OP_RETRY = "Retry";

/** @internal */
const OP_DONE$1 = "Done";

/** @internal */

/** @internal */
const OP_SUSPEND = "Suspend";

/** @internal */
class Versioned {
  constructor(value) {
    this.value = value;
  }
}

/** @internal */

/** @internal */
const make$h = (ref, isNew) => ({
  ref,
  isNew,
  isChanged: false,
  expected: ref.versioned,
  newValue: ref.versioned.value
});
const unsafeGet$1 = self => {
  return self.newValue;
};

/** @internal */
const unsafeSet$1 = (self, value) => {
  self.isChanged = true;
  self.newValue = value;
};

/** @internal */
const commit$1 = self => {
  self.ref.versioned = new Versioned(self.newValue);
};

/** @internal */
const copy = self => ({
  ref: self.ref,
  isNew: self.isNew,
  isChanged: self.isChanged,
  expected: self.expected,
  newValue: self.newValue
});

/** @internal */
const isInvalid = self => {
  return self.ref.versioned !== self.expected;
};

/** @internal */
const isChanged = self => {
  return self.isChanged;
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const JournalAnalysisInvalid = "Invalid";

/** @internal */

/** @internal */
const JournalAnalysisReadWrite = "ReadWrite";

/** @internal */

/** @internal */
const JournalAnalysisReadOnly = "ReadOnly";

/** @internal */

/** @internal */
const commitJournal = journal => {
  for (const entry of journal) {
    commit$1(entry[1]);
  }
};

/**
 * Analyzes the journal, determining whether it is valid and whether it is
 * read only in a single pass. Note that information on whether the
 * journal is read only will only be accurate if the journal is valid, due
 * to short-circuiting that occurs on an invalid journal.
 *
 * @internal
 */
const analyzeJournal = journal => {
  let val = JournalAnalysisReadOnly;
  for (const [, entry] of journal) {
    val = isInvalid(entry) ? JournalAnalysisInvalid : isChanged(entry) ? JournalAnalysisReadWrite : val;
    if (val === JournalAnalysisInvalid) {
      return val;
    }
  }
  return val;
};

/** @internal */
const prepareResetJournal = journal => {
  const saved = new Map();
  for (const entry of journal) {
    saved.set(entry[0], copy(entry[1]));
  }
  return () => {
    journal.clear();
    for (const entry of saved) {
      journal.set(entry[0], entry[1]);
    }
  };
};

/** @internal */
const collectTodos = journal => {
  const allTodos = new Map();
  for (const [, entry] of journal) {
    for (const todo of entry.ref.todos) {
      allTodos.set(todo[0], todo[1]);
    }
    entry.ref.todos = new Map();
  }
  return allTodos;
};

/** @internal */
const execTodos = todos => {
  const todosSorted = Array.from(todos.entries()).sort((x, y) => x[0] - y[0]);
  for (const [_, todo] of todosSorted) {
    todo();
  }
};

/** @internal */
const addTodo = (txnId, journal, todoEffect) => {
  let added = false;
  for (const [, entry] of journal) {
    if (!entry.ref.todos.has(txnId)) {
      entry.ref.todos.set(txnId, todoEffect);
      added = true;
    }
  }
  return added;
};

/** @internal */
const OP_DONE = "Done";

/** @internal */

/** @internal */
const OP_INTERRUPTED = "Interrupted";

/** @internal */

/** @internal */
const OP_RUNNING = "Running";

/** @internal */
const STMStateSymbolKey = "effect/STM/State";

/** @internal */
const STMStateTypeId = /*#__PURE__*/Symbol.for(STMStateSymbolKey);

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const isSTMState = u => {
  return typeof u === "object" && u != null && STMStateTypeId in u;
};

/** @internal */
const isRunning = self => {
  return self._tag === OP_RUNNING;
};

/** @internal */
const isDone = self => {
  return self._tag === OP_DONE;
};

/** @internal */
const done$4 = exit => {
  return {
    [STMStateTypeId]: STMStateTypeId,
    _tag: OP_DONE,
    exit,
    [symbol$1]() {
      return pipe(hash$1(STMStateSymbolKey), combine$a(hash$1(OP_DONE)), combine$a(hash$1(exit)));
    },
    [symbol](that) {
      return isSTMState(that) && that._tag === OP_DONE && equals$1(exit, that.exit);
    }
  };
};

/** @internal */
const interrupted = {
  [STMStateTypeId]: STMStateTypeId,
  _tag: OP_INTERRUPTED,
  [symbol$1]() {
    return pipe(hash$1(STMStateSymbolKey), combine$a(hash$1(OP_INTERRUPTED)), combine$a(hash$1("interrupted")));
  },
  [symbol](that) {
    return isSTMState(that) && that._tag === OP_INTERRUPTED;
  }
};

/** @internal */
const running = {
  [STMStateTypeId]: STMStateTypeId,
  _tag: OP_RUNNING,
  [symbol$1]() {
    return pipe(hash$1(STMStateSymbolKey), combine$a(hash$1(OP_RUNNING)), combine$a(hash$1("running")));
  },
  [symbol](that) {
    return isSTMState(that) && that._tag === OP_RUNNING;
  }
};

/** @internal */
const fromTExit = tExit => {
  switch (tExit._tag) {
    case OP_FAIL:
      {
        return done$4(fail$d(tExit.error));
      }
    case OP_DIE:
      {
        return done$4(die$8(tExit.defect));
      }
    case OP_INTERRUPT:
      {
        return done$4(interrupt$5(tExit.fiberId));
      }
    case OP_SUCCEED:
      {
        return done$4(succeed$f(tExit.value));
      }
    case OP_RETRY:
      {
        throw new Error("BUG: STM.STMState.fromTExit - please report an issue at https://github.com/Effect-TS/io/issues");
      }
  }
};

/** @internal */
const TExitSymbolKey = "effect/TExit";

/** @internal */
const TExitTypeId = /*#__PURE__*/Symbol.for(TExitSymbolKey);

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const variance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const isExit = u => {
  return typeof u === "object" && u != null && TExitTypeId in u;
};

/** @internal */
const isSuccess$1 = self => {
  return self._tag === OP_SUCCEED;
};

/** @internal */
const isRetry = self => {
  return self._tag === OP_RETRY;
};

/** @internal */
const fail$2 = error => ({
  [TExitTypeId]: variance,
  _tag: OP_FAIL,
  error,
  [symbol$1]() {
    return pipe(hash$1(TExitSymbolKey), combine$a(hash$1(OP_FAIL)), combine$a(hash$1(error)));
  },
  [symbol](that) {
    return isExit(that) && that._tag === OP_FAIL && equals$1(error, that.error);
  }
});

/** @internal */
const die$1 = defect => ({
  [TExitTypeId]: variance,
  _tag: OP_DIE,
  defect,
  [symbol$1]() {
    return pipe(hash$1(TExitSymbolKey), combine$a(hash$1(OP_DIE)), combine$a(hash$1(defect)));
  },
  [symbol](that) {
    return isExit(that) && that._tag === OP_DIE && equals$1(defect, that.defect);
  }
});

/** @internal */
const interrupt$1 = fiberId => ({
  [TExitTypeId]: variance,
  _tag: OP_INTERRUPT,
  fiberId,
  [symbol$1]() {
    return pipe(hash$1(TExitSymbolKey), combine$a(hash$1(OP_INTERRUPT)), combine$a(hash$1(fiberId)));
  },
  [symbol](that) {
    return isExit(that) && that._tag === OP_INTERRUPT && equals$1(fiberId, that.fiberId);
  }
});

/** @internal */
const succeed$3 = value => ({
  [TExitTypeId]: variance,
  _tag: OP_SUCCEED,
  value,
  [symbol$1]() {
    return pipe(hash$1(TExitSymbolKey), combine$a(hash$1(OP_SUCCEED)), combine$a(hash$1(value)));
  },
  [symbol](that) {
    return isExit(that) && that._tag === OP_SUCCEED && equals$1(value, that.value);
  }
});

/** @internal */
const retry$2 = {
  [TExitTypeId]: variance,
  _tag: OP_RETRY,
  [symbol$1]() {
    return pipe(hash$1(TExitSymbolKey), combine$a(hash$1(OP_RETRY)), combine$a(hash$1("retry")));
  },
  [symbol](that) {
    return isExit(that) && isRetry(that);
  }
};

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const done$3 = exit => {
  return {
    _tag: OP_DONE$1,
    exit
  };
};

/** @internal */
const suspend$1 = journal => {
  return {
    _tag: OP_SUSPEND,
    journal
  };
};

/** @internal */

/** @internal */
const txnCounter = {
  ref: 0
};

/** @internal */
const make$g = () => {
  const newId = txnCounter.ref + 1;
  txnCounter.ref = newId;
  return newId;
};

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const StreamTypeId = StreamTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Stream<R, E, A>` is a description of a program that, when evaluated, may
 * emit zero or more values of type `A`, may fail with errors of type `E`, and
 * uses an context of type `R`. One way to think of `Stream` is as a
 * `Effect` program that could emit multiple values.
 *
 * `Stream` is a purely functional *pull* based stream. Pull based streams offer
 * inherent laziness and backpressure, relieving users of the need to manage
 * buffers between operators. As an optimization, `Stream` does not emit
 * single values, but rather an array of values. This allows the cost of effect
 * evaluation to be amortized.
 *
 * `Stream` forms a monad on its `A` type parameter, and has error management
 * facilities for its `E` type parameter, modeled similarly to `Effect` (with
 * some adjustments for the multiple-valued nature of `Stream`). These aspects
 * allow for rich and expressive composition of streams.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * The default chunk size used by the various combinators and constructors of
 * `Stream`.
 *
 * @since 2.0.0
 * @category constants
 */
DefaultChunkSize;

/**
 * Creates a stream from a single value that will get cleaned up after the
 * stream is consumed.
 *
 * @since 2.0.0
 * @category constructors
 */
acquireRelease;

/**
 * Aggregates elements of this stream using the provided sink for as long as
 * the downstream operators on the stream are busy.
 *
 * This operator divides the stream into two asynchronous "islands". Operators
 * upstream of this operator run on one fiber, while downstream operators run
 * on another. Whenever the downstream fiber is busy processing elements, the
 * upstream fiber will feed elements into the sink until it signals
 * completion.
 *
 * Any sink can be used here, but see `Sink.foldWeightedEffect` and
 * `Sink.foldUntilEffect` for sinks that cover the common usecases.
 *
 * @since 2.0.0
 * @category utils
 */
aggregate;

/**
 * Like `aggregateWithinEither`, but only returns the `Right` results.
 *
 * @param sink A `Sink` used to perform the aggregation.
 * @param schedule A `Schedule` used to signal when to stop the aggregation.
 * @since 2.0.0
 * @category utils
 */
aggregateWithin;

/**
 * Aggregates elements using the provided sink until it completes, or until
 * the delay signalled by the schedule has passed.
 *
 * This operator divides the stream into two asynchronous islands. Operators
 * upstream of this operator run on one fiber, while downstream operators run
 * on another. Elements will be aggregated by the sink until the downstream
 * fiber pulls the aggregated value, or until the schedule's delay has passed.
 *
 * Aggregated elements will be fed into the schedule to determine the delays
 * between pulls.
 *
 * @param sink A `Sink` used to perform the aggregation.
 * @param schedule A `Schedule` used to signal when to stop the aggregation.
 * @since 2.0.0
 * @category utils
 */
aggregateWithinEither;

/**
 * Maps the success values of this stream to the specified constant value.
 *
 * @since 2.0.0
 * @category mapping
 */
as$1;
_async;

/**
 * Creates a stream from an asynchronous callback that can be called multiple
 * times The registration of the callback itself returns an effect. The
 * optionality of the error type `E` can be used to signal the end of the
 * stream, by setting it to `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
asyncEffect;

/**
 * Creates a stream from an asynchronous callback that can be called multiple
 * times. The registration of the callback returns either a canceler or
 * synchronously returns a stream. The optionality of the error type `E` can
 * be used to signal the end of the stream, by setting it to `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
asyncInterrupt;

/**
 * Creates a stream from an asynchronous callback that can be called multiple
 * times. The registration of the callback can possibly return the stream
 * synchronously. The optionality of the error type `E` can be used to signal
 * the end of the stream, by setting it to `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
asyncOption;

/**
 * Creates a stream from an asynchronous callback that can be called multiple
 * times. The registration of the callback itself returns an a scoped
 * resource. The optionality of the error type `E` can be used to signal the
 * end of the stream, by setting it to `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
asyncScoped;

/**
 * Returns a `Stream` that first collects `n` elements from the input `Stream`,
 * and then creates a new `Stream` using the specified function, and sends all
 * the following elements through that.
 *
 * @since 2.0.0
 * @category sequencing
 */
branchAfter;

/**
 * Fan out the stream, producing a list of streams that have the same elements
 * as this stream. The driver stream will only ever advance the `maximumLag`
 * chunks before the slowest downstream stream.
 *
 * @since 2.0.0
 * @category utils
 */
broadcast;

/**
 * Fan out the stream, producing a dynamic number of streams that have the
 * same elements as this stream. The driver stream will only ever advance the
 * `maximumLag` chunks before the slowest downstream stream.
 *
 * @since 2.0.0
 * @category utils
 */
broadcastDynamic;

/**
 * Converts the stream to a scoped list of queues. Every value will be
 * replicated to every queue with the slowest queue being allowed to buffer
 * `maximumLag` chunks before the driver is back pressured.
 *
 * Queues can unsubscribe from upstream by shutting down.
 *
 * @since 2.0.0
 * @category utils
 */
broadcastedQueues;

/**
 * Converts the stream to a scoped dynamic amount of queues. Every chunk will
 * be replicated to every queue with the slowest queue being allowed to buffer
 * `maximumLag` chunks before the driver is back pressured.
 *
 * Queues can unsubscribe from upstream by shutting down.
 *
 * @since 2.0.0
 * @category utils
 */
broadcastedQueuesDynamic;

/**
 * Allows a faster producer to progress independently of a slower consumer by
 * buffering up to `capacity` elements in a queue.
 *
 * @note This combinator destroys the chunking structure. It's recommended to
 *       use rechunk afterwards. Additionally, prefer capacities that are powers
 *       of 2 for better performance.
 * @since 2.0.0
 * @category utils
 */
buffer;

/**
 * Allows a faster producer to progress independently of a slower consumer by
 * buffering up to `capacity` chunks in a queue.
 *
 * @note Prefer capacities that are powers of 2 for better performance.
 * @since 2.0.0
 * @category utils
 */
bufferChunks;

/**
 * Switches over to the stream produced by the provided function in case this
 * one fails with a typed error.
 *
 * @since 2.0.0
 * @category error handling
 */
catchAll$1;

/**
 * Switches over to the stream produced by the provided function in case this
 * one fails. Allows recovery from all causes of failure, including
 * interruption if the stream is uninterruptible.
 *
 * @since 2.0.0
 * @category error handling
 */
catchAllCause;

/**
 * Switches over to the stream produced by the provided function in case this
 * one fails with some typed error.
 *
 * @since 2.0.0
 * @category error handling
 */
catchSome$1;

/**
 * Switches over to the stream produced by the provided function in case this
 * one fails with an error matching the given `_tag`.
 *
 * @since 2.0.0
 * @category error handling
 */
catchTag$1;

/**
 * Switches over to the stream produced by one of the provided functions, in
 * case this one fails with an error matching one of the given `_tag`'s.
 *
 * @since 2.0.0
 * @category error handling
 */
catchTags$1;

/**
 * Switches over to the stream produced by the provided function in case this
 * one fails with some errors. Allows recovery from all causes of failure,
 * including interruption if the stream is uninterruptible.
 *
 * @since 2.0.0
 * @category error handling
 */
catchSomeCause;

/**
 * Returns a new stream that only emits elements that are not equal to the
 * previous element emitted, using natural equality to determine whether two
 * elements are equal.
 *
 * @since 2.0.0
 * @category utils
 */
changes;

/**
 * Returns a new stream that only emits elements that are not equal to the
 * previous element emitted, using the specified function to determine whether
 * two elements are equal.
 *
 * @since 2.0.0
 * @category utils
 */
changesWith;

/**
 * Returns a new stream that only emits elements that are not equal to the
 * previous element emitted, using the specified effectual function to
 * determine whether two elements are equal.
 *
 * @since 2.0.0
 * @category utils
 */
changesWithEffect;

/**
 * Exposes the underlying chunks of the stream as a stream of chunks of
 * elements.
 *
 * @since 2.0.0
 * @category utils
 */
chunks;

/**
 * Performs the specified stream transformation with the chunk structure of
 * the stream exposed.
 *
 * @since 2.0.0
 * @category utils
 */
chunksWith;

/**
 * Combines the elements from this stream and the specified stream by
 * repeatedly applying the function `f` to extract an element using both sides
 * and conceptually "offer" it to the destination stream. `f` can maintain
 * some internal state to control the combining process, with the initial
 * state being specified by `s`.
 *
 * Where possible, prefer `Stream.combineChunks` for a more efficient
 * implementation.
 *
 * @since 2.0.0
 * @category utils
 */
combine;

/**
 * Combines the chunks from this stream and the specified stream by repeatedly
 * applying the function `f` to extract a chunk using both sides and
 * conceptually "offer" it to the destination stream. `f` can maintain some
 * internal state to control the combining process, with the initial state
 * being specified by `s`.
 *
 * @since 2.0.0
 * @category utils
 */
combineChunks;

/**
 * Concatenates the specified stream with this stream, resulting in a stream
 * that emits the elements from this stream and then the elements from the
 * specified stream.
 *
 * @since 2.0.0
 * @category utils
 */
concat;

/**
 * Concatenates all of the streams in the chunk to one stream.
 *
 * @since 2.0.0
 * @category constructors
 */
concatAll;

/**
 * Composes this stream with the specified stream to create a cartesian
 * product of elements. The `that` stream would be run multiple times, for
 * every element in the `this` stream.
 *
 * See also `Stream.zip` for the more common point-wise variant.
 *
 * @since 2.0.0
 * @category utils
 */
cross;

/**
 * Composes this stream with the specified stream to create a cartesian
 * product of elements, but keeps only elements from this stream. The `that`
 * stream would be run multiple times, for every element in the `this` stream.
 *
 * See also `Stream.zipLeft` for the more common point-wise variant.
 *
 * @since 2.0.0
 * @category utils
 */
crossLeft;

/**
 * Composes this stream with the specified stream to create a cartesian
 * product of elements, but keeps only elements from the other stream. The
 * `that` stream would be run multiple times, for every element in the `this`
 * stream.
 *
 * See also `Stream.zipRight` for the more common point-wise variant.
 *
 * @since 2.0.0
 * @category utils
 */
crossRight;

/**
 * Composes this stream with the specified stream to create a cartesian
 * product of elements with a specified function. The `that` stream would be
 * run multiple times, for every element in the `this` stream.
 *
 * See also `Stream.zipWith` for the more common point-wise variant.
 *
 * @since 2.0.0
 * @category utils
 */
crossWith;

/**
 * Delays the emission of values by holding new values for a set duration. If
 * no new values arrive during that time the value is emitted, however if a
 * new value is received during the holding period the previous value is
 * discarded and the process is repeated with the new value.
 *
 * This operator is useful if you have a stream of "bursty" events which
 * eventually settle down and you only need the final event of the burst. For
 * example, a search engine may only want to initiate a search after a user
 * has paused typing so as to not prematurely recommend results.
 *
 * @since 2.0.0
 * @category utils
 */
debounce;

/**
 * The stream that dies with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
die$2;

/**
 * The stream that dies with the specified lazily evaluated defect.
 *
 * @since 2.0.0
 * @category constructors
 */
dieSync$1;

/**
 * The stream that dies with an exception described by `message`.
 *
 * @since 2.0.0
 * @category constructors
 */
dieMessage$1;

/**
 * More powerful version of `Stream.broadcast`. Allows to provide a function
 * that determines what queues should receive which elements. The decide
 * function will receive the indices of the queues in the resulting list.
 *
 * @since 2.0.0
 * @category utils
 */
distributedWith;

/**
 * More powerful version of `Stream.distributedWith`. This returns a function
 * that will produce new queues and corresponding indices. You can also
 * provide a function that will be executed after the final events are
 * enqueued in all queues. Shutdown of the queues is handled by the driver.
 * Downstream users can also shutdown queues manually. In this case the driver
 * will continue but no longer backpressure on them.
 *
 * @since 2.0.0
 * @category utils
 */
distributedWithDynamic;

/**
 * Converts this stream to a stream that executes its effects but emits no
 * elements. Useful for sequencing effects using streams:
 *
 * @since 2.0.0
 * @category utils
 */
drain;

/**
 * Drains the provided stream in the background for as long as this stream is
 * running. If this stream ends before `other`, `other` will be interrupted.
 * If `other` fails, this stream will fail with that error.
 *
 * @since 2.0.0
 * @category utils
 */
drainFork;

/**
 * Drops the specified number of elements from this stream.
 *
 * @since 2.0.0
 * @category utils
 */
drop;

/**
 * Drops the last specified number of elements from this stream.
 *
 * @note This combinator keeps `n` elements in memory. Be careful with big
 *       numbers.
 * @since 2.0.0
 * @category utils
 */
dropRight;

/**
 * Drops all elements of the stream until the specified predicate evaluates to
 * `true`.
 *
 * @since 2.0.0
 * @category utils
 */
dropUntil;

/**
 * Drops all elements of the stream until the specified effectful predicate
 * evaluates to `true`.
 *
 * @since 2.0.0
 * @category utils
 */
dropUntilEffect;

/**
 * Drops all elements of the stream for as long as the specified predicate
 * evaluates to `true`.
 *
 * @since 2.0.0
 * @category utils
 */
dropWhile;

/**
 * Drops all elements of the stream for as long as the specified predicate
 * produces an effect that evalutates to `true`
 *
 * @since 2.0.0
 * @category utils
 */
dropWhileEffect;

/**
 * Returns a stream whose failures and successes have been lifted into an
 * `Either`. The resulting stream cannot fail, because the failures have been
 * exposed as part of the `Either` success case.
 *
 * @note The stream will end as soon as the first error occurs.
 *
 * @since 2.0.0
 * @category utils
 */
either$2;

/**
 * The empty stream.
 *
 * @since 2.0.0
 * @category constructors
 */
empty$6;

/**
 * Executes the provided finalizer after this stream's finalizers run.
 *
 * @since 2.0.0
 * @category utils
 */
ensuring$1;

/**
 * Executes the provided finalizer after this stream's finalizers run.
 *
 * @since 2.0.0
 * @category utils
 */
ensuringWith;

/**
 * Accesses the whole context of the stream.
 *
 * @since 2.0.0
 * @category context
 */
context$1;

/**
 * Accesses the context of the stream.
 *
 * @since 2.0.0
 * @category context
 */
contextWith$1;

/**
 * Accesses the context of the stream in the context of an effect.
 *
 * @since 2.0.0
 * @category context
 */
contextWithEffect;

/**
 * Accesses the context of the stream in the context of a stream.
 *
 * @since 2.0.0
 * @category context
 */
contextWithStream;

/**
 * Creates a stream that executes the specified effect but emits no elements.
 *
 * @since 2.0.0
 * @category constructors
 */
execute;

/**
 * Terminates with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$3;

/**
 * Terminates with the specified lazily evaluated error.
 *
 * @since 2.0.0
 * @category constructors
 */
failSync$1;

/**
 * The stream that always fails with the specified `Cause`.
 *
 * @since 2.0.0
 * @category constructors
 */
failCause;

/**
 * The stream that always fails with the specified lazily evaluated `Cause`.
 *
 * @since 2.0.0
 * @category constructors
 */
failCauseSync;

/**
 * Filters the elements emitted by this stream using the provided function.
 *
 * @since 2.0.0
 * @category filtering
 */
filter$2;

/**
 * Effectfully filters the elements emitted by this stream.
 *
 * @since 2.0.0
 * @category filtering
 */
filterEffect;

/**
 * Performs a filter and map in a single step.
 *
 * @since 2.0.0
 * @category utils
 */
filterMap;

/**
 * Performs an effectful filter and map in a single step.
 *
 * @since 2.0.0
 * @category utils
 */
filterMapEffect;

/**
 * Transforms all elements of the stream for as long as the specified partial
 * function is defined.
 *
 * @since 2.0.0
 * @category utils
 */
filterMapWhile;

/**
 * Effectfully transforms all elements of the stream for as long as the
 * specified partial function is defined.
 *
 * @since 2.0.0
 * @category utils
 */
filterMapWhileEffect;

/**
 * Creates a one-element stream that never fails and executes the finalizer
 * when it ends.
 *
 * @since 2.0.0
 * @category constructors
 */
finalizer;

/**
 * Finds the first element emitted by this stream that satisfies the provided
 * predicate.
 *
 * @since 2.0.0
 * @category elements
 */
find$1;

/**
 * Finds the first element emitted by this stream that satisfies the provided
 * effectful predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findEffect;

/**
 * Returns a stream made of the concatenation in strict order of all the
 * streams produced by passing each element of this stream to `f0`
 *
 * @since 2.0.0
 * @category sequencing
 */
flatMap$1;

/**
 * Flattens this stream-of-streams into a stream made of the concatenation in
 * strict order of all the streams.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatten$1;

/**
 * Submerges the chunks carried by this stream into the stream's structure,
 * while still preserving them.
 *
 * @since 2.0.0
 * @category sequencing
 */
flattenChunks;

/**
 * Flattens `Effect` values into the stream's structure, preserving all
 * information about the effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
flattenEffect;

/**
 * Unwraps `Exit` values that also signify end-of-stream by failing with `None`.
 *
 * For `Exit` values that do not signal end-of-stream, prefer:
 *
 * ```ts
 * stream.mapZIO(ZIO.done(_))
 * ```
 *
 * @since 2.0.0
 * @category sequencing
 */
flattenExitOption;

/**
 * Submerges the iterables carried by this stream into the stream's structure,
 * while still preserving them.
 *
 * @since 2.0.0
 * @category sequencing
 */
flattenIterables;

/**
 * Unwraps `Exit` values and flatten chunks that also signify end-of-stream
 * by failing with `None`.
 *
 * @since 2.0.0
 * @category sequencing
 */
flattenTake;

/**
 * Repeats this stream forever.
 *
 * @since 2.0.0
 * @category utils
 */
forever;

/**
 * Creates a stream from an `AsyncIterable`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromAsyncIterable;

/**
 * Creates a stream from a `Channel`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromChannel;

/**
 * Creates a channel from a `Stream`.
 *
 * @since 2.0.0
 * @category constructors
 */
toChannel;

/**
 * Creates a stream from a `Chunk` of values.
 *
 * @since 2.0.0
 * @category constructors
 */
fromChunk;

/**
 * Creates a stream from a subscription to a `PubSub`.
 *
 * @param shutdown If `true`, the `PubSub` will be shutdown after the stream is evaluated (defaults to `false`)
 * @since 2.0.0
 * @category constructors
 */
fromChunkPubSub;

/**
 * Creates a stream from a `Queue` of values.
 *
 * @param shutdown If `true`, the queue will be shutdown after the stream is evaluated (defaults to `false`)
 * @since 2.0.0
 * @category constructors
 */
fromChunkQueue;

/**
 * Creates a stream from an arbitrary number of chunks.
 *
 * @since 2.0.0
 * @category constructors
 */
fromChunks;

/**
 * Either emits the success value of this effect or terminates the stream
 * with the failure value of this effect.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEffect;

/**
 * Creates a stream from an effect producing a value of type `A` or an empty
 * `Stream`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEffectOption;

/**
 * Creates a stream from a subscription to a `PubSub`.
 *
 * @param shutdown If `true`, the `PubSub` will be shutdown after the stream is evaluated (defaults to `false`)
 * @since 2.0.0
 * @category constructors
 */
fromPubSub;

/**
 * Creates a stream from an `Iterable` collection of values.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterable$4;

/**
 * Creates a stream from an effect producing a value of type `Iterable<A>`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterableEffect;

/**
 * Creates a stream from an iterator
 *
 * @since 2.0.0
 * @category constructors
 */
fromIteratorSucceed;

/**
 * Creates a stream from an effect that pulls elements from another stream.
 *
 * See `Stream.toPull` for reference.
 *
 * @since 2.0.0
 * @category constructors
 */
fromPull;

/**
 * Creates a stream from a queue of values
 *
 * @param maxChunkSize The maximum number of queued elements to put in one chunk in the stream
 * @param shutdown If `true`, the queue will be shutdown after the stream is evaluated (defaults to `false`)
 * @since 2.0.0
 * @category constructors
 */
fromQueue;

/**
 * Creates a stream from a `ReadableStream`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream.
 *
 * @since 2.0.0
 * @category constructors
 */
fromReadableStream;

/**
 * Creates a stream from a `ReadableStreamBYOBReader`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/ReadableStreamBYOBReader.
 *
 * @param allocSize Controls the size of the underlying `ArrayBuffer` (defaults to `4096`).
 * @since 2.0.0
 * @category constructors
 */
fromReadableStreamByob;

/**
 * Creates a stream from a `Schedule` that does not require any further
 * input. The stream will emit an element for each value output from the
 * schedule, continuing for as long as the schedule continues.
 *
 * @since 2.0.0
 * @category constructors
 */
fromSchedule;

/**
 * Creates a pipeline that groups on adjacent keys, calculated by the
 * specified function.
 *
 * @since 2.0.0
 * @category grouping
 */
groupAdjacentBy;

/**
 * More powerful version of `Stream.groupByKey`.
 *
 * @since 2.0.0
 * @category grouping
 */
groupBy;

/**
 * Partition a stream using a function and process each stream individually.
 * This returns a data structure that can be used to further filter down which
 * groups shall be processed.
 *
 * After calling apply on the GroupBy object, the remaining groups will be
 * processed in parallel and the resulting streams merged in a
 * nondeterministic fashion.
 *
 * Up to `buffer` elements may be buffered in any group stream before the
 * producer is backpressured. Take care to consume from all streams in order
 * to prevent deadlocks.
 *
 * For example, to collect the first 2 words for every starting letter from a
 * stream of words:
 *
 * ```ts
 * import * as GroupBy from "./GroupBy"
 * import * as Stream from "./Stream"
 * import { pipe } from "./Function"
 *
 * pipe(
 *   Stream.fromIterable(["hello", "world", "hi", "holla"]),
 *   Stream.groupByKey((word) => word[0]),
 *   GroupBy.evaluate((key, stream) =>
 *     pipe(
 *       stream,
 *       Stream.take(2),
 *       Stream.map((words) => [key, words] as const)
 *     )
 *   )
 * )
 * ```
 *
 * @since 2.0.0
 * @category utils
 */
groupByKey;

/**
 * Partitions the stream with specified `chunkSize`.
 *
 * @since 2.0.0
 * @category utils
 */
grouped;

/**
 * Partitions the stream with the specified `chunkSize` or until the specified
 * `duration` has passed, whichever is satisfied first.
 *
 * @since 2.0.0
 * @category utils
 */
groupedWithin;

/**
 * Specialized version of haltWhen which halts the evaluation of this stream
 * after the given duration.
 *
 * An element in the process of being pulled will not be interrupted when the
 * given duration completes. See `interruptAfter` for this behavior.
 *
 * @since 2.0.0
 * @category utils
 */
haltAfter;

/**
 * Halts the evaluation of this stream when the provided effect completes. The
 * given effect will be forked as part of the returned stream, and its success
 * will be discarded.
 *
 * An element in the process of being pulled will not be interrupted when the
 * effect completes. See `interruptWhen` for this behavior.
 *
 * If the effect completes with a failure, the stream will emit that failure.
 *
 * @since 2.0.0
 * @category utils
 */
haltWhen;

/**
 * Halts the evaluation of this stream when the provided promise resolves.
 *
 * If the promise completes with a failure, the stream will emit that failure.
 *
 * @since 2.0.0
 * @category utils
 */
haltWhenDeferred;

/**
 * The identity pipeline, which does not modify streams in any way.
 *
 * @since 2.0.0
 * @category utils
 */
identityStream;

/**
 * Interleaves this stream and the specified stream deterministically by
 * alternating pulling values from this stream and the specified stream. When
 * one stream is exhausted all remaining values in the other stream will be
 * pulled.
 *
 * @since 2.0.0
 * @category utils
 */
interleave;

/**
 * Combines this stream and the specified stream deterministically using the
 * stream of boolean values `pull` to control which stream to pull from next.
 * A value of `true` indicates to pull from this stream and a value of `false`
 * indicates to pull from the specified stream. Only consumes as many elements
 * as requested by the `pull` stream. If either this stream or the specified
 * stream are exhausted further requests for values from that stream will be
 * ignored.
 *
 * @since 2.0.0
 * @category utils
 */
interleaveWith;

/**
 * Intersperse stream with provided `element`.
 *
 * @since 2.0.0
 * @category utils
 */
intersperse;

/**
 * Intersperse the specified element, also adding a prefix and a suffix.
 *
 * @since 2.0.0
 * @category utils
 */
intersperseAffixes;

/**
 * Specialized version of `Stream.interruptWhen` which interrupts the
 * evaluation of this stream after the given `Duration`.
 *
 * @since 2.0.0
 * @category utils
 */
interruptAfter;

/**
 * Interrupts the evaluation of this stream when the provided effect
 * completes. The given effect will be forked as part of this stream, and its
 * success will be discarded. This combinator will also interrupt any
 * in-progress element being pulled from upstream.
 *
 * If the effect completes with a failure before the stream completes, the
 * returned stream will emit that failure.
 *
 * @since 2.0.0
 * @category utils
 */
interruptWhen;

/**
 * Interrupts the evaluation of this stream when the provided promise
 * resolves. This combinator will also interrupt any in-progress element being
 * pulled from upstream.
 *
 * If the promise completes with a failure, the stream will emit that failure.
 *
 * @since 2.0.0
 * @category utils
 */
interruptWhenDeferred;

/**
 * The infinite stream of iterative function application: a, f(a), f(f(a)),
 * f(f(f(a))), ...
 *
 * @since 2.0.0
 * @category constructors
 */
iterate$1;

/**
 * Creates a stream from an sequence of values.
 *
 * @since 2.0.0
 * @category constructors
 */
make$o;

/**
 * Transforms the elements of this stream using the supplied function.
 *
 * @since 2.0.0
 * @category mapping
 */
map$2;

/**
 * Statefully maps over the elements of this stream to produce new elements.
 *
 * @since 2.0.0
 * @category mapping
 */
mapAccum;

/**
 * Statefully and effectfully maps over the elements of this stream to produce
 * new elements.
 *
 * @since 2.0.0
 * @category mapping
 */
mapAccumEffect;

/**
 * Returns a stream whose failure and success channels have been mapped by the
 * specified `onFailure` and `onSuccess` functions.
 *
 * @since 2.0.0
 * @category utils
 */
mapBoth$1;

/**
 * Transforms the chunks emitted by this stream.
 *
 * @since 2.0.0
 * @category mapping
 */
mapChunks;

/**
 * Effectfully transforms the chunks emitted by this stream.
 *
 * @since 2.0.0
 * @category mapping
 */
mapChunksEffect;

/**
 * Maps each element to an iterable, and flattens the iterables into the
 * output of this stream.
 *
 * @since 2.0.0
 * @category mapping
 */
mapConcat;

/**
 * Maps each element to a chunk, and flattens the chunks into the output of
 * this stream.
 *
 * @since 2.0.0
 * @category mapping
 */
mapConcatChunk;

/**
 * Effectfully maps each element to a chunk, and flattens the chunks into the
 * output of this stream.
 *
 * @since 2.0.0
 * @category mapping
 */
mapConcatChunkEffect;

/**
 * Effectfully maps each element to an iterable, and flattens the iterables
 * into the output of this stream.
 *
 * @since 2.0.0
 * @category mapping
 */
mapConcatEffect;

/**
 * Maps over elements of the stream with the specified effectful function.
 *
 * @since 2.0.0
 * @category mapping
 */
mapEffectOptions;

/**
 * Transforms the errors emitted by this stream using `f`.
 *
 * @since 2.0.0
 * @category mapping
 */
mapError$1;

/**
 * Transforms the full causes of failures emitted by this stream.
 *
 * @since 2.0.0
 * @category mapping
 */
mapErrorCause;

/**
 * Merges this stream and the specified stream together.
 *
 * New produced stream will terminate when both specified stream terminate if
 * no termination strategy is specified.
 *
 * @since 2.0.0
 * @category utils
 */
merge$2;

/**
 * Merges a variable list of streams in a non-deterministic fashion. Up to `n`
 * streams may be consumed in parallel and up to `outputBuffer` chunks may be
 * buffered by this operator.
 *
 * @since 2.0.0
 * @category utils
 */
mergeAll$1;

/**
 * Merges this stream and the specified stream together to a common element
 * type with the specified mapping functions.
 *
 * New produced stream will terminate when both specified stream terminate if
 * no termination strategy is specified.
 *
 * @since 2.0.0
 * @category utils
 */
mergeWith;

/**
 * Merges this stream and the specified stream together to produce a stream of
 * eithers.
 *
 * @since 2.0.0
 * @category utils
 */
mergeEither;

/**
 * Merges this stream and the specified stream together, discarding the values
 * from the right stream.
 *
 * @since 2.0.0
 * @category utils
 */
mergeLeft;

/**
 * Merges this stream and the specified stream together, discarding the values
 * from the left stream.
 *
 * @since 2.0.0
 * @category utils
 */
mergeRight;

/**
 * Returns a combined string resulting from concatenating each of the values
 * from the stream.
 *
 * @since 2.0.0
 * @category utils
 */
mkString;

/**
 * The stream that never produces any value or fails with any error.
 *
 * @since 2.0.0
 * @category constructors
 */
never$1;

/**
 * Runs the specified effect if this stream fails, providing the error to the
 * effect if it exists.
 *
 * Note: Unlike `Effect.onError` there is no guarantee that the provided
 * effect will not be interrupted.
 *
 * @since 2.0.0
 * @category utils
 */
onError;

/**
 * Runs the specified effect if this stream ends.
 *
 * @since 2.0.0
 * @category utils
 */
onDone;

/**
 * Translates any failure into a stream termination, making the stream
 * infallible and all failures unchecked.
 *
 * @since 2.0.0
 * @category error handling
 */
orDie$1;

/**
 * Keeps none of the errors, and terminates the stream with them, using the
 * specified function to convert the `E` into a defect.
 *
 * @since 2.0.0
 * @category error handling
 */
orDieWith$1;

/**
 * Switches to the provided stream in case this one fails with a typed error.
 *
 * See also `Stream.catchAll`.
 *
 * @since 2.0.0
 * @category error handling
 */
orElse$2;

/**
 * Switches to the provided stream in case this one fails with a typed error.
 *
 * See also `Stream.catchAll`.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseEither$1;

/**
 * Fails with given error in case this one fails with a typed error.
 *
 * See also `Stream.catchAll`.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseFail$1;

/**
 * Produces the specified element if this stream is empty.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseIfEmpty;

/**
 * Produces the specified chunk if this stream is empty.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseIfEmptyChunk;

/**
 * Switches to the provided stream in case this one is empty.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseIfEmptyStream;

/**
 * Succeeds with the specified value if this one fails with a typed error.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseSucceed$1;

/**
 * Like `Stream.unfold`, but allows the emission of values to end one step further
 * than the unfolding of the state. This is useful for embedding paginated
 * APIs, hence the name.
 *
 * @since 2.0.0
 * @category constructors
 */
paginate;

/**
 * Like `Stream.unfoldChunk`, but allows the emission of values to end one step
 * further than the unfolding of the state. This is useful for embedding
 * paginated APIs, hence the name.
 *
 * @since 2.0.0
 * @category constructors
 */
paginateChunk;

/**
 * Like `Stream.unfoldChunkEffect`, but allows the emission of values to end one step
 * further than the unfolding of the state. This is useful for embedding
 * paginated APIs, hence the name.
 *
 * @since 2.0.0
 * @category constructors
 */
paginateChunkEffect;

/**
 * Like `Stream.unfoldEffect` but allows the emission of values to end one step
 * further than the unfolding of the state. This is useful for embedding
 * paginated APIs, hence the name.
 *
 * @since 2.0.0
 * @category constructors
 */
paginateEffect;

/**
 * Partition a stream using a predicate. The first stream will contain all
 * element evaluated to true and the second one will contain all element
 * evaluated to false. The faster stream may advance by up to buffer elements
 * further than the slower one.
 *
 * @since 2.0.0
 * @category utils
 */
partition$1;

/**
 * Split a stream by an effectful predicate. The faster stream may advance by
 * up to buffer elements further than the slower one.
 *
 * @since 2.0.0
 * @category utils
 */
partitionEither;

/**
 * Peels off enough material from the stream to construct a `Z` using the
 * provided `Sink` and then returns both the `Z` and the rest of the
 * `Stream` in a scope. Like all scoped values, the provided stream is
 * valid only within the scope.
 *
 * @since 2.0.0
 * @category utils
 */
peel;

/**
 * Pipes all of the values from this stream through the provided sink.
 *
 * See also `Stream.transduce`.
 *
 * @since 2.0.0
 * @category utils
 */
pipeThrough;

/**
 * Pipes all the values from this stream through the provided channel.
 *
 * @since 2.0.0
 * @category utils
 */
pipeThroughChannel;

/**
 * Pipes all values from this stream through the provided channel, passing
 * through any error emitted by this stream unchanged.
 *
 * @since 2.0.0
 * @category utils
 */
pipeThroughChannelOrFail;

/**
 * Emits the provided chunk before emitting any other value.
 *
 * @since 2.0.0
 * @category utils
 */
prepend;

/**
 * Provides the stream with its required context, which eliminates its
 * dependency on `R`.
 *
 * @since 2.0.0
 * @category context
 */
provideContext$2;

/**
 * Provides a `Layer` to the stream, which translates it to another level.
 *
 * @since 2.0.0
 * @category context
 */
provideLayer;

/**
 * Provides the stream with the single service it requires. If the stream
 * requires more than one service use `Stream.provideContext` instead.
 *
 * @since 2.0.0
 * @category context
 */
provideService$1;

/**
 * Provides the stream with the single service it requires. If the stream
 * requires more than one service use `Stream.provideContext` instead.
 *
 * @since 2.0.0
 * @category context
 */
provideServiceEffect;

/**
 * Provides the stream with the single service it requires. If the stream
 * requires more than one service use `Stream.provideContext` instead.
 *
 * @since 2.0.0
 * @category context
 */
provideServiceStream;

/**
 * Transforms the context being provided to the stream with the specified
 * function.
 *
 * @since 2.0.0
 * @category context
 */
mapInputContext$2;

/**
 * Splits the context into two parts, providing one part using the
 * specified layer and leaving the remainder `R0`.
 *
 * @since 2.0.0
 * @category context
 */
provideSomeLayer;

/**
 * Constructs a stream from a range of integers, including both endpoints.
 *
 * @since 2.0.0
 * @category constructors
 */
range;

/**
 * Re-chunks the elements of the stream into chunks of `n` elements each. The
 * last chunk might contain less than `n` elements.
 *
 * @since 2.0.0
 * @category utils
 */
rechunk;

/**
 * Keeps some of the errors, and terminates the fiber with the rest
 *
 * @since 2.0.0
 * @category error handling
 */
refineOrDie$1;

/**
 * Keeps some of the errors, and terminates the fiber with the rest, using the
 * specified function to convert the `E` into a defect.
 *
 * @since 2.0.0
 * @category error handling
 */
refineOrDieWith$1;

/**
 * Repeats the entire stream using the specified schedule. The stream will
 * execute normally, and then repeat again according to the provided schedule.
 *
 * @since 2.0.0
 * @category utils
 */
repeat;

/**
 * Creates a stream from an effect producing a value of type `A` which repeats
 * forever.
 *
 * @since 2.0.0
 * @category constructors
 */
repeatEffect;

/**
 * Creates a stream from an effect producing chunks of `A` values which
 * repeats forever.
 *
 * @since 2.0.0
 * @category constructors
 */
repeatEffectChunk;

/**
 * Creates a stream from an effect producing chunks of `A` values until it
 * fails with `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
repeatEffectChunkOption;

/**
 * Creates a stream from an effect producing values of type `A` until it fails
 * with `None`.
 *
 * @since 2.0.0
 * @category constructors
 */
repeatEffectOption;

/**
 * Creates a stream from an effect producing a value of type `A`, which is
 * repeated using the specified schedule.
 *
 * @since 2.0.0
 * @category constructors
 */
repeatEffectWithSchedule;

/**
 * Repeats the entire stream using the specified schedule. The stream will
 * execute normally, and then repeat again according to the provided schedule.
 * The schedule output will be emitted at the end of each repetition.
 *
 * @since 2.0.0
 * @category utils
 */
repeatEither;

/**
 * Repeats each element of the stream using the provided schedule. Repetitions
 * are done in addition to the first execution, which means using
 * `Schedule.recurs(1)` actually results in the original effect, plus an
 * additional recurrence, for a total of two repetitions of each value in the
 * stream.
 *
 * @since 2.0.0
 * @category utils
 */
repeatElements;

/**
 * Repeats each element of the stream using the provided schedule. When the
 * schedule is finished, then the output of the schedule will be emitted into
 * the stream. Repetitions are done in addition to the first execution, which
 * means using `Schedule.recurs(1)` actually results in the original effect,
 * plus an additional recurrence, for a total of two repetitions of each value
 * in the stream.
 *
 * This function accepts two conversion functions, which allow the output of
 * this stream and the output of the provided schedule to be unified into a
 * single type. For example, `Either` or similar data type.
 *
 * @since 2.0.0
 * @category utils
 */
repeatElementsWith;

/**
 * Repeats the provided value infinitely.
 *
 * @since 2.0.0
 * @category constructors
 */
repeatValue;

/**
 * Repeats the entire stream using the specified schedule. The stream will
 * execute normally, and then repeat again according to the provided schedule.
 * The schedule output will be emitted at the end of each repetition and can
 * be unified with the stream elements using the provided functions.
 *
 * @since 2.0.0
 * @category utils
 */
repeatWith;

/**
 * When the stream fails, retry it according to the given schedule
 *
 * This retries the entire stream, so will re-execute all of the stream's
 * acquire operations.
 *
 * The schedule is reset as soon as the first element passes through the
 * stream again.
 *
 * @param schedule A `Schedule` receiving as input the errors of the stream.
 * @since 2.0.0
 * @category utils
 */
retry$4;

/**
 * Runs the sink on the stream to produce either the sink's result or an error.
 *
 * @since 2.0.0
 * @category destructors
 */
run;

/**
 * Runs the stream and collects all of its elements to a chunk.
 *
 * @since 2.0.0
 * @category destructors
 */
runCollect;

/**
 * Runs the stream and emits the number of elements processed
 *
 * @since 2.0.0
 * @category destructors
 */
runCount;

/**
 * Runs the stream only for its effects. The emitted elements are discarded.
 *
 * @since 2.0.0
 * @category destructors
 */
runDrain;

/**
 * Executes a pure fold over the stream of values - reduces all elements in
 * the stream to a value of type `S`.
 *
 * @since 2.0.0
 * @category destructors
 */
runFold;

/**
 * Executes an effectful fold over the stream of values.
 *
 * @since 2.0.0
 * @category destructors
 */
runFoldEffect;

/**
 * Executes a pure fold over the stream of values. Returns a scoped value that
 * represents the scope of the stream.
 *
 * @since 2.0.0
 * @category destructors
 */
runFoldScoped;

/**
 * Executes an effectful fold over the stream of values. Returns a scoped
 * value that represents the scope of the stream.
 *
 * @since 2.0.0
 * @category destructors
 */
runFoldScopedEffect;

/**
 * Reduces the elements in the stream to a value of type `S`. Stops the fold
 * early when the condition is not fulfilled. Example:
 *
 * @since 2.0.0
 * @category destructors
 */
runFoldWhile;

/**
 * Executes an effectful fold over the stream of values. Stops the fold early
 * when the condition is not fulfilled.
 *
 * @since 2.0.0
 * @category destructors
 */
runFoldWhileEffect;

/**
 * Executes a pure fold over the stream of values. Returns a scoped value that
 * represents the scope of the stream. Stops the fold early when the condition
 * is not fulfilled.
 *
 * @since 2.0.0
 * @category destructors
 */
runFoldWhileScoped;

/**
 * Executes an effectful fold over the stream of values. Returns a scoped
 * value that represents the scope of the stream. Stops the fold early when
 * the condition is not fulfilled.
 *
 * @since 2.0.0
 * @category destructors
 */
runFoldWhileScopedEffect;

/**
 * Consumes all elements of the stream, passing them to the specified
 * callback.
 *
 * @since 2.0.0
 * @category destructors
 */
runForEach;

/**
 * Consumes all elements of the stream, passing them to the specified
 * callback.
 *
 * @since 2.0.0
 * @category destructors
 */
runForEachChunk;

/**
 * Like `Stream.runForEachChunk`, but returns a scoped effect so the
 * finalization order can be controlled.
 *
 * @since 2.0.0
 * @category destructors
 */
runForEachChunkScoped;

/**
 * Like `Stream.forEach`, but returns a scoped effect so the finalization
 * order can be controlled.
 *
 * @since 2.0.0
 * @category destructors
 */
runForEachScoped;

/**
 * Consumes elements of the stream, passing them to the specified callback,
 * and terminating consumption when the callback returns `false`.
 *
 * @since 2.0.0
 * @category destructors
 */
runForEachWhile;

/**
 * Like `Stream.runForEachWhile`, but returns a scoped effect so the
 * finalization order can be controlled.
 *
 * @since 2.0.0
 * @category destructors
 */
runForEachWhileScoped;

/**
 * Runs the stream to completion and yields the first value emitted by it,
 * discarding the rest of the elements.
 *
 * @since 2.0.0
 * @category destructors
 */
runHead;

/**
 * Publishes elements of this stream to a `PubSub`. Stream failure and ending will
 * also be signalled.
 *
 * @since 2.0.0
 * @category destructors
 */
runIntoPubSub;

/**
 * Like `Stream.runIntoPubSub`, but provides the result as a scoped effect to
 * allow for scope composition.
 *
 * @since 2.0.0
 * @category destructors
 */
runIntoPubSubScoped;

/**
 * Enqueues elements of this stream into a queue. Stream failure and ending
 * will also be signalled.
 *
 * @since 2.0.0
 * @category destructors
 */
runIntoQueue;

/**
 * Like `Stream.runIntoQueue`, but provides the result as a scoped [[ZIO]]
 * to allow for scope composition.
 *
 * @since 2.0.0
 * @category destructors
 */
runIntoQueueElementsScoped;

/**
 * Like `Stream.runIntoQueue`, but provides the result as a scoped effect
 * to allow for scope composition.
 *
 * @since 2.0.0
 * @category destructors
 */
runIntoQueueScoped;

/**
 * Runs the stream to completion and yields the last value emitted by it,
 * discarding the rest of the elements.
 *
 * @since 2.0.0
 * @category destructors
 */
runLast;

/**
 * @since 2.0.0
 * @category destructors
 */
runScoped;

/**
 * Runs the stream to a sink which sums elements, provided they are Numeric.
 *
 * @since 2.0.0
 * @category destructors
 */
runSum;

/**
 * Statefully maps over the elements of this stream to produce all
 * intermediate results of type `S` given an initial S.
 *
 * @since 2.0.0
 * @category utils
 */
scan;

/**
 * Statefully and effectfully maps over the elements of this stream to produce
 * all intermediate results of type `S` given an initial S.
 *
 * @since 2.0.0
 * @category utils
 */
scanEffect;

/**
 * Statefully maps over the elements of this stream to produce all
 * intermediate results.
 *
 * See also `Stream.scan`.
 *
 * @since 2.0.0
 * @category utils
 */
scanReduce;

/**
 * Statefully and effectfully maps over the elements of this stream to produce
 * all intermediate results.
 *
 * See also `Stream.scanEffect`.
 *
 * @since 2.0.0
 * @category utils
 */
scanReduceEffect;

/**
 * Schedules the output of the stream using the provided `schedule`.
 *
 * @since 2.0.0
 * @category utils
 */
schedule;

/**
 * Schedules the output of the stream using the provided `schedule` and emits
 * its output at the end (if `schedule` is finite). Uses the provided function
 * to align the stream and schedule outputs on the same type.
 *
 * @since 2.0.0
 * @category utils
 */
scheduleWith;

/**
 * Creates a single-valued stream from a scoped resource.
 *
 * @since 2.0.0
 * @category constructors
 */
scoped;

/**
 * Emits a sliding window of `n` elements.
 *
 * ```ts
 * import * as Stream from "./Stream"
 * import { pipe } from "./Function"
 *
 * pipe(
 *   Stream.make(1, 2, 3, 4),
 *   Stream.sliding(2),
 *   Stream.runCollect
 * )
 * // => Chunk(Chunk(1, 2), Chunk(2, 3), Chunk(3, 4))
 * ```
 *
 * @since 2.0.0
 * @category utils
 */
sliding$2;

/**
 * Like `sliding`, but with a configurable `stepSize` parameter.
 *
 * @since 2.0.0
 * @category utils
 */
slidingSize;

/**
 * Converts an option on values into an option on errors.
 *
 * @since 2.0.0
 * @category utils
 */
some$2;

/**
 * Extracts the optional value, or returns the given 'default'.
 *
 * @since 2.0.0
 * @category utils
 */
someOrElse;

/**
 * Extracts the optional value, or fails with the given error 'e'.
 *
 * @since 2.0.0
 * @category utils
 */
someOrFail;

/**
 * Splits elements based on a predicate.
 *
 * ```ts
 * import * as Stream from "./Stream"
 * import { pipe } from "./Function"
 *
 * pipe(
 *   Stream.range(1, 10),
 *   Stream.split((n) => n % 4 === 0),
 *   Stream.runCollect
 * )
 * // => Chunk(Chunk(1, 2, 3), Chunk(5, 6, 7), Chunk(9))
 * ```
 *
 * @since 2.0.0
 * @category utils
 */
split;

/**
 * Splits elements on a delimiter and transforms the splits into desired output.
 *
 * @since 2.0.0
 * @category utils
 */
splitOnChunk;

/**
 * Splits strings on newlines. Handles both Windows newlines (`\r\n`) and UNIX
 * newlines (`\n`).
 *
 * @since 2.0.0
 * @category combinators
 */
splitLines;

/**
 * Creates a single-valued pure stream.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$4;

/**
 * Creates a single-valued pure stream.
 *
 * @since 2.0.0
 * @category constructors
 */
sync$1;

/**
 * Returns a lazily constructed stream.
 *
 * @since 2.0.0
 * @category constructors
 */
suspend$2;

/**
 * Takes the specified number of elements from this stream.
 *
 * @since 2.0.0
 * @category utils
 */
take$2;

/**
 * Takes the last specified number of elements from this stream.
 *
 * @since 2.0.0
 * @category utils
 */
takeRight;

/**
 * Takes all elements of the stream until the specified predicate evaluates to
 * `true`.
 *
 * @since 2.0.0
 * @category utils
 */
takeUntil;

/**
 * Takes all elements of the stream until the specified effectual predicate
 * evaluates to `true`.
 *
 * @since 2.0.0
 * @category utils
 */
takeUntilEffect;

/**
 * Takes all elements of the stream for as long as the specified predicate
 * evaluates to `true`.
 *
 * @since 2.0.0
 * @category utils
 */
takeWhile;

/**
 * Adds an effect to consumption of every element of the stream.
 *
 * @since 2.0.0
 * @category sequencing
 */
tap$1;

/**
 * Returns a stream that effectfully "peeks" at the failure or success of
 * the stream.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapBoth$1;

/**
 * Returns a stream that effectfully "peeks" at the failure of the stream.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapError$1;

/**
 * Returns a stream that effectfully "peeks" at the cause of failure of the
 * stream.
 *
 * @since 2.0.0
 * @category utils
 */
tapErrorCause;

/**
 * Sends all elements emitted by this stream to the specified sink in addition
 * to emitting them.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapSink;

/**
 * Delays the chunks of this stream according to the given bandwidth
 * parameters using the token bucket algorithm. Allows for burst in the
 * processing of elements by allowing the token bucket to accumulate tokens up
 * to a `units + burst` threshold. The weight of each chunk is determined by
 * the `costFn` function.
 *
 * If using the "enforce" strategy, chunks that do not meet the bandwidth
 * constraints are dropped. If using the "shape" strategy, chunks are delayed
 * until they can be emitted without exceeding the bandwidth constraints.
 *
 * Defaults to the "shape" strategy.
 *
 * @since 2.0.0
 * @category utils
 */
throttle;

/**
 * Delays the chunks of this stream according to the given bandwidth
 * parameters using the token bucket algorithm. Allows for burst in the
 * processing of elements by allowing the token bucket to accumulate tokens up
 * to a `units + burst` threshold. The weight of each chunk is determined by
 * the effectful `costFn` function.
 *
 * If using the "enforce" strategy, chunks that do not meet the bandwidth
 * constraints are dropped. If using the "shape" strategy, chunks are delayed
 * until they can be emitted without exceeding the bandwidth constraints.
 *
 * Defaults to the "shape" strategy.
 *
 * @since 2.0.0
 * @category utils
 */
throttleEffect;

/**
 * A stream that emits Unit values spaced by the specified duration.
 *
 * @since 2.0.0
 * @category constructors
 */
tick;

/**
 * Ends the stream if it does not produce a value after the specified duration.
 *
 * @since 2.0.0
 * @category utils
 */
timeout;

/**
 * Fails the stream with given error if it does not produce a value after d
 * duration.
 *
 * @since 2.0.0
 * @category utils
 */
timeoutFail;

/**
 * Fails the stream with given cause if it does not produce a value after d
 * duration.
 *
 * @since 2.0.0
 * @category utils
 */
timeoutFailCause;

/**
 * Switches the stream if it does not produce a value after the specified
 * duration.
 *
 * @since 2.0.0
 * @category utils
 */
timeoutTo;

/**
 * Converts the stream to a scoped `PubSub` of chunks. After the scope is closed,
 * the `PubSub` will never again produce values and should be discarded.
 *
 * @since 2.0.0
 * @category destructors
 */
toPubSub;

/**
 * Returns in a scope a ZIO effect that can be used to repeatedly pull chunks
 * from the stream. The pull effect fails with None when the stream is
 * finished, or with Some error if it fails, otherwise it returns a chunk of
 * the stream's output.
 *
 * @since 2.0.0
 * @category destructors
 */
toPull;

/**
 * Converts the stream to a scoped queue of chunks. After the scope is closed,
 * the queue will never again produce values and should be discarded.
 *
 * Defaults to the "suspend" back pressure strategy with a capacity of 2.
 *
 * @since 2.0.0
 * @category destructors
 */
toQueue;

/**
 * Converts the stream to a scoped queue of elements. After the scope is
 * closed, the queue will never again produce values and should be discarded.
 *
 * Defaults to a capacity of 2.
 *
 * @since 2.0.0
 * @category destructors
 */
toQueueOfElements;

/**
 * Converts the stream to a `ReadableStream`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream.
 *
 * @since 2.0.0
 * @category destructors
 */
toReadableStream;

/**
 * Applies the transducer to the stream and emits its outputs.
 *
 * @since 2.0.0
 * @category utils
 */
transduce;

/**
 * Creates a stream by peeling off the "layers" of a value of type `S`.
 *
 * @since 2.0.0
 * @category constructors
 */
unfold;

/**
 * Creates a stream by peeling off the "layers" of a value of type `S`.
 *
 * @since 2.0.0
 * @category constructors
 */
unfoldChunk;

/**
 * Creates a stream by effectfully peeling off the "layers" of a value of type
 * `S`.
 *
 * @since 2.0.0
 * @category constructors
 */
unfoldChunkEffect;

/**
 * Creates a stream by effectfully peeling off the "layers" of a value of type
 * `S`.
 *
 * @since 2.0.0
 * @category constructors
 */
unfoldEffect;

/**
 * A stream that contains a single `Unit` value.
 *
 * @since 2.0.0
 * @category constructors
 */
unit$1;

/**
 * Creates a stream produced from an `Effect`.
 *
 * @since 2.0.0
 * @category constructors
 */
unwrap;

/**
 * Creates a stream produced from a scoped `Effect`.
 *
 * @since 2.0.0
 * @category constructors
 */
unwrapScoped;

/**
 * Updates the specified service within the context of the `Stream`.
 *
 * @since 2.0.0
 * @category context
 */
updateService;

/**
 * Returns the specified stream if the given condition is satisfied, otherwise
 * returns an empty stream.
 *
 * @since 2.0.0
 * @category utils
 */
when$2;

/**
 * Returns the resulting stream when the given `PartialFunction` is defined
 * for the given value, otherwise returns an empty stream.
 *
 * @since 2.0.0
 * @category constructors
 */
whenCase;

/**
 * Returns the stream when the given partial function is defined for the given
 * effectful value, otherwise returns an empty stream.
 *
 * @since 2.0.0
 * @category utils
 */
whenCaseEffect;

/**
 * Returns the stream if the given effectful condition is satisfied, otherwise
 * returns an empty stream.
 *
 * @since 2.0.0
 * @category utils
 */
whenEffect;

/**
 * Wraps the stream with a new span for tracing.
 *
 * @since 2.0.0
 * @category tracing
 */
withSpan;

/**
 * Zips this stream with another point-wise and emits tuples of elements from
 * both streams.
 *
 * The new stream will end when one of the sides ends.
 *
 * @since 2.0.0
 * @category zipping
 */
zip$2;

/**
 * Zips this stream with another point-wise and emits tuples of elements from
 * both streams.
 *
 * The new stream will end when one of the sides ends.
 *
 * @since 2.0.0
 * @category zipping
 */
zipFlatten;

/**
 * Zips this stream with another point-wise, creating a new stream of pairs of
 * elements from both sides.
 *
 * The defaults `defaultLeft` and `defaultRight` will be used if the streams
 * have different lengths and one of the streams has ended before the other.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAll;

/**
 * Zips this stream with another point-wise, and keeps only elements from this
 * stream.
 *
 * The provided default value will be used if the other stream ends before
 * this one.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAllLeft;

/**
 * Zips this stream with another point-wise, and keeps only elements from the
 * other stream.
 *
 * The provided default value will be used if this stream ends before the
 * other one.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAllRight;

/**
 * Zips this stream that is sorted by distinct keys and the specified stream
 * that is sorted by distinct keys to produce a new stream that is sorted by
 * distinct keys. Combines values associated with each key into a tuple,
 * using the specified values `defaultLeft` and `defaultRight` to fill in
 * missing values.
 *
 * This allows zipping potentially unbounded streams of data by key in
 * constant space but the caller is responsible for ensuring that the
 * streams are sorted by distinct keys.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAllSortedByKey;

/**
 * Zips this stream that is sorted by distinct keys and the specified stream
 * that is sorted by distinct keys to produce a new stream that is sorted by
 * distinct keys. Keeps only values from this stream, using the specified
 * value `default` to fill in missing values.
 *
 * This allows zipping potentially unbounded streams of data by key in
 * constant space but the caller is responsible for ensuring that the
 * streams are sorted by distinct keys.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAllSortedByKeyLeft;

/**
 * Zips this stream that is sorted by distinct keys and the specified stream
 * that is sorted by distinct keys to produce a new stream that is sorted by
 * distinct keys. Keeps only values from that stream, using the specified
 * value `default` to fill in missing values.
 *
 * This allows zipping potentially unbounded streams of data by key in
 * constant space but the caller is responsible for ensuring that the
 * streams are sorted by distinct keys.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAllSortedByKeyRight;

/**
 * Zips this stream that is sorted by distinct keys and the specified stream
 * that is sorted by distinct keys to produce a new stream that is sorted by
 * distinct keys. Uses the functions `left`, `right`, and `both` to handle
 * the cases where a key and value exist in this stream, that stream, or
 * both streams.
 *
 * This allows zipping potentially unbounded streams of data by key in
 * constant space but the caller is responsible for ensuring that the
 * streams are sorted by distinct keys.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAllSortedByKeyWith;

/**
 * Zips this stream with another point-wise. The provided functions will be
 * used to create elements for the composed stream.
 *
 * The functions `left` and `right` will be used if the streams have different
 * lengths and one of the streams has ended before the other.
 *
 * @since 2.0.0
 * @category zipping
 */
zipAllWith;

/**
 * Zips the two streams so that when a value is emitted by either of the two
 * streams, it is combined with the latest value from the other stream to
 * produce a result.
 *
 * Note: tracking the latest value is done on a per-chunk basis. That means
 * that emitted elements that are not the last value in chunks will never be
 * used for zipping.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLatest;

/**
 * Zips the two streams so that when a value is emitted by either of the two
 * streams, it is combined with the latest value from the other stream to
 * produce a result.
 *
 * Note: tracking the latest value is done on a per-chunk basis. That means
 * that emitted elements that are not the last value in chunks will never be
 * used for zipping.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLatestWith;

/**
 * Zips this stream with another point-wise, but keeps only the outputs of
 * this stream.
 *
 * The new stream will end when one of the sides ends.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLeft$1;

/**
 * Zips this stream with another point-wise, but keeps only the outputs of the
 * other stream.
 *
 * The new stream will end when one of the sides ends.
 *
 * @since 2.0.0
 * @category zipping
 */
zipRight$1;

/**
 * Zips this stream with another point-wise and applies the function to the
 * paired elements.
 *
 * The new stream will end when one of the sides ends.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWith$1;

/**
 * Zips this stream with another point-wise and applies the function to the
 * paired elements.
 *
 * The new stream will end when one of the sides ends.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWithChunks;

/**
 * Zips each element with the next element if present.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWithNext;

/**
 * Zips each element with the previous element. Initially accompanied by
 * `None`.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWithPrevious;

/**
 * Zips each element with both the previous and next element.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWithPreviousAndNext;

/**
 * Zips this stream together with the index of elements.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWithIndex;

// -------------------------------------------------------------------------------------
// Do notation
// -------------------------------------------------------------------------------------

/**
 * @since 2.0.0
 * @category do notation
 */
Do;

/**
 * Binds a value from a stream in a `do` scope
 *
 * @since 2.0.0
 * @category do notation
 */
bind$1;

/**
 * Binds an effectful value in a `do` scope
 *
 * @since 2.0.0
 * @category do notation
 */
bindEffect;

/**
 * @since 2.0.0
 * @category do notation
 */
bindTo$1;
let_$1;

// -------------------------------------------------------------------------------------
// encoding
// -------------------------------------------------------------------------------------

/**
 * Decode Uint8Array chunks into a stream of strings using the specified encoding.
 *
 * @since 2.0.0
 * @category encoding
 */
decodeText;

/**
 * Encode a stream of strings into a stream of Uint8Array chunks using the specified encoding.
 *
 * @since 2.0.0
 * @category encoding
 */
encodeText;

/** @internal */
const STMSymbolKey = "effect/STM";

/** @internal */
const STMTypeId = /*#__PURE__*/Symbol.for(STMSymbolKey);

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const stmVariance = {
  _R: _ => _,
  _E: _ => _,
  _A: _ => _
};

/** @internal */
class STMPrimitive {
  _tag = OP_COMMIT;
  _op = OP_COMMIT;
  i1 = undefined;
  i2 = undefined;
  get [STMTypeId]() {
    return stmVariance;
  }
  constructor(i0) {
    this.i0 = i0;
    this[EffectTypeId] = stmVariance;
    this[StreamTypeId] = stmVariance;
    this[SinkTypeId] = stmVariance;
    this[ChannelTypeId] = stmVariance;
  }
  [symbol](that) {
    return this === that;
  }
  [symbol$1]() {
    return random$2(this);
  }
  commit() {
    return unsafeAtomically(this, constVoid, constVoid);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}

/** @internal */
const isSTM = u => typeof u === "object" && u != null && STMTypeId in u;

/** @internal */
const commit = self => unsafeAtomically(self, constVoid, constVoid);

/** @internal */
const unsafeAtomically = (self, onDone, onInterrupt) => withFiberRuntime(state => {
  const fiberId = state.id();
  const env = state.getFiberRef(currentContext);
  const scheduler = state.getFiberRef(currentScheduler);
  const priority = state.getFiberRef(currentSchedulingPriority);
  const commitResult = tryCommitSync(fiberId, self, env, scheduler, priority);
  switch (commitResult._tag) {
    case OP_DONE$1:
      {
        onDone(commitResult.exit);
        return commitResult.exit;
      }
    case OP_SUSPEND:
      {
        const txnId = make$g();
        const state = {
          value: running
        };
        const effect = async(k => tryCommitAsync(fiberId, self, txnId, state, env, scheduler, priority, k));
        return uninterruptibleMask(restore => pipe(restore(effect), catchAllCause$2(cause => {
          let currentState = state.value;
          if (isRunning(currentState)) {
            state.value = interrupted;
          }
          currentState = state.value;
          if (isDone(currentState)) {
            onDone(currentState.exit);
            return currentState.exit;
          }
          onInterrupt();
          return failCause$5(cause);
        })));
      }
  }
});

/** @internal */
const tryCommit = (fiberId, stm, state, env, scheduler, priority) => {
  const journal = new Map();
  const tExit = new STMDriver(stm, journal, fiberId, env).run();
  const analysis = analyzeJournal(journal);
  if (analysis === JournalAnalysisReadWrite) {
    commitJournal(journal);
  } else if (analysis === JournalAnalysisInvalid) {
    throw new Error("BUG: STM.TryCommit.tryCommit - please report an issue at https://github.com/Effect-TS/io/issues");
  }
  switch (tExit._tag) {
    case OP_SUCCEED:
      {
        state.value = fromTExit(tExit);
        return completeTodos(succeed$f(tExit.value), journal, scheduler, priority);
      }
    case OP_FAIL:
      {
        state.value = fromTExit(tExit);
        const cause = fail$9(tExit.error);
        return completeTodos(failCause$8(cause), journal, scheduler, priority);
      }
    case OP_DIE:
      {
        state.value = fromTExit(tExit);
        const cause = die$7(tExit.defect);
        return completeTodos(failCause$8(cause), journal, scheduler, priority);
      }
    case OP_INTERRUPT:
      {
        state.value = fromTExit(tExit);
        const cause = interrupt$4(fiberId);
        return completeTodos(failCause$8(cause), journal, scheduler, priority);
      }
    case OP_RETRY:
      {
        return suspend$1(journal);
      }
  }
};

/** @internal */
const tryCommitSync = (fiberId, stm, env, scheduler, priority) => {
  const journal = new Map();
  const tExit = new STMDriver(stm, journal, fiberId, env).run();
  const analysis = analyzeJournal(journal);
  if (analysis === JournalAnalysisReadWrite && isSuccess$1(tExit)) {
    commitJournal(journal);
  } else if (analysis === JournalAnalysisInvalid) {
    throw new Error("BUG: STM.TryCommit.tryCommitSync - please report an issue at https://github.com/Effect-TS/io/issues");
  }
  switch (tExit._tag) {
    case OP_SUCCEED:
      {
        return completeTodos(succeed$f(tExit.value), journal, scheduler, priority);
      }
    case OP_FAIL:
      {
        const cause = fail$9(tExit.error);
        return completeTodos(failCause$8(cause), journal, scheduler, priority);
      }
    case OP_DIE:
      {
        const cause = die$7(tExit.defect);
        return completeTodos(failCause$8(cause), journal, scheduler, priority);
      }
    case OP_INTERRUPT:
      {
        const cause = interrupt$4(fiberId);
        return completeTodos(failCause$8(cause), journal, scheduler, priority);
      }
    case OP_RETRY:
      {
        return suspend$1(journal);
      }
  }
};

/** @internal */
const tryCommitAsync = (fiberId, self, txnId, state, context, scheduler, priority, k) => {
  if (isRunning(state.value)) {
    const result = tryCommit(fiberId, self, state, context, scheduler, priority);
    switch (result._tag) {
      case OP_DONE$1:
        {
          completeTryCommit(result.exit, k);
          break;
        }
      case OP_SUSPEND:
        {
          addTodo(txnId, result.journal, () => tryCommitAsync(fiberId, self, txnId, state, context, scheduler, priority, k));
          break;
        }
    }
  }
};

/** @internal */
const completeTodos = (exit, journal, scheduler, priority) => {
  const todos = collectTodos(journal);
  if (todos.size > 0) {
    scheduler.scheduleTask(() => execTodos(todos), priority);
  }
  return done$3(exit);
};

/** @internal */
const completeTryCommit = (exit, k) => {
  k(exit);
};

/** @internal */

/** @internal */
const context = () => effect((_, __, env) => env);

/** @internal */
const contextWith = f => map$1(context(), f);

/** @internal */
const contextWithSTM = f => flatMap(context(), f);

/** @internal */
class STMDriver {
  contStack = [];
  constructor(self, journal, fiberId, r0) {
    this.self = self;
    this.journal = journal;
    this.fiberId = fiberId;
    this.env = r0;
  }
  getEnv() {
    return this.env;
  }
  pushStack(cont) {
    this.contStack.push(cont);
  }
  popStack() {
    return this.contStack.pop();
  }
  nextSuccess() {
    let current = this.popStack();
    while (current !== undefined && current.i0 !== OP_ON_SUCCESS) {
      current = this.popStack();
    }
    return current;
  }
  nextFailure() {
    let current = this.popStack();
    while (current !== undefined && current.i0 !== OP_ON_FAILURE) {
      current = this.popStack();
    }
    return current;
  }
  nextRetry() {
    let current = this.popStack();
    while (current !== undefined && current.i0 !== OP_ON_RETRY) {
      current = this.popStack();
    }
    return current;
  }
  run() {
    let curr = this.self;
    let exit = undefined;
    while (exit === undefined && curr !== undefined) {
      try {
        const current = curr;
        if (current) {
          switch (current._tag) {
            case "Tag":
              {
                curr = effect((_, __, env) => unsafeGet$6(env, current));
                break;
              }
            case "Left":
              {
                curr = fail$1(current.left);
                break;
              }
            case "None":
              {
                curr = fail$1(NoSuchElementException());
                break;
              }
            case "Right":
              {
                curr = succeed$2(current.right);
                break;
              }
            case "Some":
              {
                curr = succeed$2(current.value);
                break;
              }
            case "Commit":
              {
                switch (current.i0) {
                  case OP_DIE$1:
                    {
                      exit = die$1(current.i1());
                      break;
                    }
                  case OP_FAIL$1:
                    {
                      const cont = this.nextFailure();
                      if (cont === undefined) {
                        exit = fail$2(current.i1());
                      } else {
                        curr = cont.i2(current.i1());
                      }
                      break;
                    }
                  case OP_RETRY$1:
                    {
                      const cont = this.nextRetry();
                      if (cont === undefined) {
                        exit = retry$2;
                      } else {
                        curr = cont.i2();
                      }
                      break;
                    }
                  case OP_INTERRUPT$1:
                    {
                      exit = interrupt$1(this.fiberId);
                      break;
                    }
                  case OP_WITH_STM_RUNTIME:
                    {
                      curr = current.i1(this);
                      break;
                    }
                  case OP_ON_SUCCESS:
                  case OP_ON_FAILURE:
                  case OP_ON_RETRY:
                    {
                      this.pushStack(current);
                      curr = current.i1;
                      break;
                    }
                  case OP_PROVIDE:
                    {
                      const env = this.env;
                      this.env = current.i2(env);
                      curr = pipe(current.i1, ensuring(sync(() => this.env = env)));
                      break;
                    }
                  case OP_SUCCEED$1:
                    {
                      const value = current.i1;
                      const cont = this.nextSuccess();
                      if (cont === undefined) {
                        exit = succeed$3(value);
                      } else {
                        curr = cont.i2(value);
                      }
                      break;
                    }
                  case OP_SYNC:
                    {
                      const value = current.i1();
                      const cont = this.nextSuccess();
                      if (cont === undefined) {
                        exit = succeed$3(value);
                      } else {
                        curr = cont.i2(value);
                      }
                      break;
                    }
                }
                break;
              }
          }
        }
      } catch (e) {
        curr = die(e);
      }
    }
    return exit;
  }
}

/** @internal */
const catchAll = /*#__PURE__*/dual(2, (self, f) => {
  const stm = new STMPrimitive(OP_ON_FAILURE);
  stm.i1 = self;
  stm.i2 = f;
  return stm;
});

/** @internal */
const mapInputContext = /*#__PURE__*/dual(2, (self, f) => {
  const stm = new STMPrimitive(OP_PROVIDE);
  stm.i1 = self;
  stm.i2 = f;
  return stm;
});

/** @internal */
const die = defect => dieSync(() => defect);

/** @internal */
const dieMessage = message => dieSync(() => RuntimeException(message));

/** @internal */
const dieSync = evaluate => {
  const stm = new STMPrimitive(OP_DIE$1);
  stm.i1 = evaluate;
  return stm;
};

/** @internal */
const effect = f => withSTMRuntime(_ => succeed$2(f(_.journal, _.fiberId, _.getEnv())));

/** @internal */
const ensuring = /*#__PURE__*/dual(2, (self, finalizer) => matchSTM(self, {
  onFailure: e => zipRight(finalizer, fail$1(e)),
  onSuccess: a => zipRight(finalizer, succeed$2(a))
}));

/** @internal */
const fail$1 = error => failSync(() => error);

/** @internal */
const failSync = evaluate => {
  const stm = new STMPrimitive(OP_FAIL$1);
  stm.i1 = evaluate;
  return stm;
};

/** @internal */
const flatMap = /*#__PURE__*/dual(2, (self, f) => {
  const stm = new STMPrimitive(OP_ON_SUCCESS);
  stm.i1 = self;
  stm.i2 = f;
  return stm;
});

/** @internal */
const matchSTM = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => pipe(self, map$1(right), catchAll(e => pipe(onFailure(e), map$1(left))), flatMap(either => {
  switch (either._tag) {
    case "Left":
      {
        return succeed$2(either.left);
      }
    case "Right":
      {
        return onSuccess(either.right);
      }
  }
})));

/** @internal */
const withSTMRuntime = f => {
  const stm = new STMPrimitive(OP_WITH_STM_RUNTIME);
  stm.i1 = f;
  return stm;
};

/** @internal */
const interrupt = /*#__PURE__*/withSTMRuntime(_ => {
  const stm = new STMPrimitive(OP_INTERRUPT$1);
  stm.i1 = _.fiberId;
  return stm;
});

/** @internal */
const interruptAs$1 = fiberId => {
  const stm = new STMPrimitive(OP_INTERRUPT$1);
  stm.i1 = fiberId;
  return stm;
};

/** @internal */
const map$1 = /*#__PURE__*/dual(2, (self, f) => pipe(self, flatMap(a => sync(() => f(a)))));

/** @internal */
const orTry = /*#__PURE__*/dual(2, (self, that) => {
  const stm = new STMPrimitive(OP_ON_RETRY);
  stm.i1 = self;
  stm.i2 = that;
  return stm;
});

/** @internal */
const retry$1 = /*#__PURE__*/new STMPrimitive(OP_RETRY$1);

/** @internal */
const succeed$2 = value => {
  const stm = new STMPrimitive(OP_SUCCEED$1);
  stm.i1 = value;
  return stm;
};

/** @internal */
const sync = evaluate => {
  const stm = new STMPrimitive(OP_SYNC);
  stm.i1 = evaluate;
  return stm;
};

/** @internal */
const zip = /*#__PURE__*/dual(2, (self, that) => pipe(self, zipWith(that, (a, a1) => [a, a1])));

/** @internal */
const zipLeft = /*#__PURE__*/dual(2, (self, that) => pipe(self, flatMap(a => pipe(that, map$1(() => a)))));

/** @internal */
const zipRight = /*#__PURE__*/dual(2, (self, that) => pipe(self, flatMap(() => that)));

/** @internal */
const zipWith = /*#__PURE__*/dual(3, (self, that, f) => pipe(self, flatMap(a => pipe(that, map$1(b => f(a, b))))));

/** @internal */
const acquireUseRelease = /*#__PURE__*/dual(3, (acquire, use, release) => uninterruptibleMask(restore => {
  let state = running;
  return pipe(restore(unsafeAtomically(acquire, exit => {
    state = done$4(exit);
  }, () => {
    state = interrupted;
  })), matchCauseEffect({
    onFailure: cause => {
      if (isDone(state) && isSuccess$5(state.exit)) {
        return pipe(release(state.exit.value), matchCauseEffect({
          onFailure: cause2 => failCause$5(parallel(cause, cause2)),
          onSuccess: () => failCause$5(cause)
        }));
      }
      return failCause$5(cause);
    },
    onSuccess: a => pipe(restore(use(a)), matchCauseEffect({
      onFailure: cause => pipe(release(a), matchCauseEffect({
        onFailure: cause2 => failCause$5(parallel(cause, cause2)),
        onSuccess: () => failCause$5(cause)
      })),
      onSuccess: a2 => pipe(release(a), as$4(a2))
    }))
  }));
}));

/** @internal */
const as = /*#__PURE__*/dual(2, (self, value) => pipe(self, map$1(() => value)));

/** @internal */
const asSome = self => pipe(self, map$1(some$6));

/** @internal */
const asSomeError = self => pipe(self, mapError(some$6));

/** @internal */
const asUnit = self => pipe(self, map$1(constVoid));

/** @internal */
const attempt = evaluate => suspend(() => {
  try {
    return succeed$2(evaluate());
  } catch (defect) {
    return fail$1(defect);
  }
});
const bind = /*#__PURE__*/dual(3, (self, tag, f) => flatMap(self, k => map$1(f(k), a => ({
  ...k,
  [tag]: a
}))));

/* @internal */
const bindTo = /*#__PURE__*/dual(2, (self, tag) => map$1(self, a => ({
  [tag]: a
})));

/* @internal */
const let_ = /*#__PURE__*/dual(3, (self, tag, f) => map$1(self, k => ({
  ...k,
  [tag]: f(k)
})));

/** @internal */
const catchSome = /*#__PURE__*/dual(2, (self, pf) => catchAll(self, e => getOrElse$3(pf(e), () => fail$1(e))));
const catchTag = /*#__PURE__*/dual(3, (self, k, f) => catchAll(self, e => {
  if ("_tag" in e && e["_tag"] === k) {
    return f(e);
  }
  return fail$1(e);
}));

/** @internal */
const catchTags = /*#__PURE__*/dual(2, (self, cases) => catchAll(self, e => {
  const keys = Object.keys(cases);
  if ("_tag" in e && keys.includes(e["_tag"])) {
    return cases[e["_tag"]](e);
  }
  return fail$1(e);
}));

/** @internal */
const check = predicate => suspend(() => predicate() ? unit : retry$1);

/** @internal */
const collect = /*#__PURE__*/dual(2, (self, pf) => collectSTM(self, a => map$n(pf(a), succeed$2)));

/** @internal */
const collectSTM = /*#__PURE__*/dual(2, (self, pf) => matchSTM(self, {
  onFailure: fail$1,
  onSuccess: a => {
    const option = pf(a);
    return isSome(option) ? option.value : retry$1;
  }
}));

/** @internal */
const commitEither = self => flatten$3(commit(either(self)));

/** @internal */
const cond = (predicate, error, result) => {
  return suspend(() => predicate() ? sync(result) : failSync(error));
};

/** @internal */
const either = self => match(self, {
  onFailure: left,
  onSuccess: right
});

/** @internal */
const eventually = self => matchSTM(self, {
  onFailure: () => eventually(self),
  onSuccess: succeed$2
});

/** @internal */
const every$1 = /*#__PURE__*/dual(2, (iterable, predicate) => pipe(flatMap(sync(() => iterable[Symbol.iterator]()), iterator => {
  const loop = suspend(() => {
    const next = iterator.next();
    if (next.done) {
      return succeed$2(true);
    }
    return pipe(predicate(next.value), flatMap(bool => bool ? loop : succeed$2(bool)));
  });
  return loop;
})));

/** @internal */
const exists = /*#__PURE__*/dual(2, (iterable, predicate) => flatMap(sync(() => iterable[Symbol.iterator]()), iterator => {
  const loop = suspend(() => {
    const next = iterator.next();
    if (next.done) {
      return succeed$2(false);
    }
    return flatMap(predicate(next.value), bool => bool ? succeed$2(bool) : loop);
  });
  return loop;
}));

/** @internal */
const fiberId = /*#__PURE__*/effect((_, fiberId) => fiberId);

/** @internal */
const filter = /*#__PURE__*/dual(2, (iterable, predicate) => Array.from(iterable).reduce((acc, curr) => pipe(acc, zipWith(predicate(curr), (as, p) => {
  if (p) {
    as.push(curr);
    return as;
  }
  return as;
})), succeed$2([])));

/** @internal */
const filterNot = /*#__PURE__*/dual(2, (iterable, predicate) => filter(iterable, a => negate(predicate(a))));

/** @internal */
const filterOrDie = /*#__PURE__*/dual(3, (self, predicate, defect) => filterOrElse(self, predicate, () => dieSync(defect)));

/** @internal */
const filterOrDieMessage = /*#__PURE__*/dual(3, (self, predicate, message) => filterOrElse(self, predicate, () => dieMessage(message)));

/** @internal */
const filterOrElse = /*#__PURE__*/dual(3, (self, predicate, orElse) => flatMap(self, a => predicate(a) ? succeed$2(a) : orElse(a)));

/** @internal */
const filterOrFail = /*#__PURE__*/dual(3, (self, predicate, orFailWith) => filterOrElse(self, predicate, a => failSync(() => orFailWith(a))));

/** @internal */
const flatten = self => flatMap(self, identity$1);

/** @internal */
const flip = self => matchSTM(self, {
  onFailure: succeed$2,
  onSuccess: fail$1
});

/** @internal */
const flipWith = /*#__PURE__*/dual(2, (self, f) => flip(f(flip(self))));

/** @internal */
const match = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchSTM(self, {
  onFailure: e => succeed$2(onFailure(e)),
  onSuccess: a => succeed$2(onSuccess(a))
}));

/** @internal */
const forEach$3 = /*#__PURE__*/dual(args => isIterable(args[0]), (iterable, f, options) => {
  if (options?.discard) {
    return pipe(sync(() => iterable[Symbol.iterator]()), flatMap(iterator => {
      const loop = suspend(() => {
        const next = iterator.next();
        if (next.done) {
          return unit;
        }
        return pipe(f(next.value), flatMap(() => loop));
      });
      return loop;
    }));
  }
  return suspend(() => fromIterable$c(iterable).reduce((acc, curr) => zipWith(acc, f(curr), (array, elem) => {
    array.push(elem);
    return array;
  }), succeed$2([])));
});

/** @internal */
const fromEither = either => {
  switch (either._tag) {
    case "Left":
      {
        return fail$1(either.left);
      }
    case "Right":
      {
        return succeed$2(either.right);
      }
  }
};

/** @internal */
const fromOption = option => match$j(option, {
  onNone: () => fail$1(none$8()),
  onSome: succeed$2
});

/** @internal */
class STMGen {
  constructor(value) {
    this.value = value;
  }
  [Symbol.iterator]() {
    return new SingleShotGen(this);
  }
}
const adapter = function () {
  let x = arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    x = arguments[i](x);
  }
  return new STMGen(x);
};

/**
 * Inspired by https://github.com/tusharmath/qio/pull/22 (revised)
 * @internal
 */
const gen = f => suspend(() => {
  const iterator = f(adapter);
  const state = iterator.next();
  const run = state => state.done ? succeed$2(state.value) : flatMap(state.value.value, val => run(iterator.next(val)));
  return run(state);
});

/** @internal */
const head = self => pipe(self, matchSTM({
  onFailure: e => fail$1(some$6(e)),
  onSuccess: a => {
    const i = a[Symbol.iterator]();
    const res = i.next();
    if (res.done) {
      return fail$1(none$8());
    } else {
      return succeed$2(res.value);
    }
  }
}));

/** @internal */
const if_ = /*#__PURE__*/dual(args => typeof args[0] === "boolean" || isSTM(args[0]), (self, {
  onFalse,
  onTrue
}) => {
  if (typeof self === "boolean") {
    return self ? onTrue : onFalse;
  }
  return flatMap(self, bool => bool ? onTrue : onFalse);
});

/** @internal */
const ignore = self => match(self, {
  onFailure: () => unit,
  onSuccess: () => unit
});

/** @internal */
const isFailure = self => match(self, {
  onFailure: constTrue,
  onSuccess: constFalse
});

/** @internal */
const isSuccess = self => match(self, {
  onFailure: constFalse,
  onSuccess: constTrue
});

/** @internal */
const iterate = (initial, options) => iterateLoop(initial, options.while, options.body);
const iterateLoop = (initial, cont, body) => {
  if (cont(initial)) {
    return pipe(body(initial), flatMap(z => iterateLoop(z, cont, body)));
  }
  return succeed$2(initial);
};

/** @internal */
const loop = (initial, options) => options.discard ? loopDiscardLoop(initial, options.while, options.step, options.body) : map$1(loopLoop(initial, options.while, options.step, options.body), a => Array.from(a));
const loopLoop = (initial, cont, inc, body) => {
  if (cont(initial)) {
    return pipe(body(initial), flatMap(a => pipe(loopLoop(inc(initial), cont, inc, body), map$1(append$1(a)))));
  }
  return succeed$2(empty$z());
};
const loopDiscardLoop = (initial, cont, inc, body) => {
  if (cont(initial)) {
    return pipe(body(initial), flatMap(() => loopDiscardLoop(inc(initial), cont, inc, body)));
  }
  return unit;
};

/** @internal */
const mapAttempt = /*#__PURE__*/dual(2, (self, f) => matchSTM(self, {
  onFailure: e => fail$1(e),
  onSuccess: a => attempt(() => f(a))
}));

/** @internal */
const mapBoth = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchSTM(self, {
  onFailure: e => fail$1(onFailure(e)),
  onSuccess: a => succeed$2(onSuccess(a))
}));

/** @internal */
const mapError = /*#__PURE__*/dual(2, (self, f) => matchSTM(self, {
  onFailure: e => fail$1(f(e)),
  onSuccess: succeed$2
}));

/** @internal */
const merge$1 = self => matchSTM(self, {
  onFailure: e => succeed$2(e),
  onSuccess: succeed$2
});

/** @internal */
const mergeAll = /*#__PURE__*/dual(3, (iterable, zero, f) => suspend(() => Array.from(iterable).reduce((acc, curr) => pipe(acc, zipWith(curr, f)), succeed$2(zero))));

/** @internal */
const negate = self => pipe(self, map$1(b => !b));

/** @internal */
const none = self => matchSTM(self, {
  onFailure: e => fail$1(some$6(e)),
  onSuccess: match$j({
    onNone: () => unit,
    onSome: () => fail$1(none$8())
  })
});

/** @internal */
const option = self => match(self, {
  onFailure: () => none$8(),
  onSuccess: some$6
});

/** @internal */
const orDie = self => pipe(self, orDieWith(identity$1));

/** @internal */
const orDieWith = /*#__PURE__*/dual(2, (self, f) => pipe(self, mapError(f), catchAll(die)));

/** @internal */
const orElse = /*#__PURE__*/dual(2, (self, that) => flatMap(effect(journal => prepareResetJournal(journal)), reset => pipe(orTry(self, () => flatMap(sync(reset), that)), catchAll(() => flatMap(sync(reset), that)))));

/** @internal */
const orElseEither = /*#__PURE__*/dual(2, (self, that) => orElse(map$1(self, left), () => map$1(that(), right)));

/** @internal */
const orElseFail = /*#__PURE__*/dual(2, (self, error) => orElse(self, () => failSync(error)));

/** @internal */
const orElseOptional = /*#__PURE__*/dual(2, (self, that) => catchAll(self, match$j({
  onNone: that,
  onSome: e => fail$1(some$6(e))
})));

/** @internal */
const orElseSucceed = /*#__PURE__*/dual(2, (self, value) => orElse(self, () => sync(value)));

/** @internal */
const provideContext = /*#__PURE__*/dual(2, (self, env) => mapInputContext(self, _ => env));

/** @internal */
const provideSomeContext = /*#__PURE__*/dual(2, (self, context) => mapInputContext(self, parent => merge$8(parent, context)));

/** @internal */
const provideService = /*#__PURE__*/dual(3, (self, tag, resource) => provideServiceSTM(self, tag, succeed$2(resource)));

/** @internal */
const provideServiceSTM = /*#__PURE__*/dual(3, (self, tag, stm) => contextWithSTM(env => flatMap(stm, service => provideContext(self, add$4(env, tag, service)))));

/** @internal */
const reduce$4 = /*#__PURE__*/dual(3, (iterable, zero, f) => suspend(() => Array.from(iterable).reduce((acc, curr) => pipe(acc, flatMap(s => f(s, curr))), succeed$2(zero))));

/** @internal */
const reduceAll = /*#__PURE__*/dual(3, (iterable, initial, f) => suspend(() => Array.from(iterable).reduce((acc, curr) => pipe(acc, zipWith(curr, f)), initial)));

/** @internal */
const reduceRight = /*#__PURE__*/dual(3, (iterable, zero, f) => suspend(() => Array.from(iterable).reduceRight((acc, curr) => pipe(acc, flatMap(s => f(s, curr))), succeed$2(zero))));

/** @internal */
const refineOrDie = /*#__PURE__*/dual(2, (self, pf) => refineOrDieWith(self, pf, identity$1));

/** @internal */
const refineOrDieWith = /*#__PURE__*/dual(3, (self, pf, f) => catchAll(self, e => match$j(pf(e), {
  onNone: () => die(f(e)),
  onSome: fail$1
})));

/** @internal */
const reject = /*#__PURE__*/dual(2, (self, pf) => rejectSTM(self, a => map$n(pf(a), fail$1)));

/** @internal */
const rejectSTM = /*#__PURE__*/dual(2, (self, pf) => flatMap(self, a => match$j(pf(a), {
  onNone: () => succeed$2(a),
  onSome: flatMap(fail$1)
})));

/** @internal */
const repeatUntil = /*#__PURE__*/dual(2, (self, predicate) => repeatUntilLoop(self, predicate));
const repeatUntilLoop = (self, predicate) => flatMap(self, a => predicate(a) ? succeed$2(a) : repeatUntilLoop(self, predicate));

/** @internal */
const repeatWhile = /*#__PURE__*/dual(2, (self, predicate) => repeatWhileLoop(self, predicate));
const repeatWhileLoop = (self, predicate) => pipe(flatMap(self, a => predicate(a) ? repeatWhileLoop(self, predicate) : succeed$2(a)));

/** @internal */
const replicate = /*#__PURE__*/dual(2, (self, n) => Array.from({
  length: n
}, () => self));

/** @internal */
const replicateSTM = /*#__PURE__*/dual(2, (self, n) => all(replicate(self, n)));

/** @internal */
const replicateSTMDiscard = /*#__PURE__*/dual(2, (self, n) => all(replicate(self, n), {
  discard: true
}));

/** @internal */
const retryUntil = /*#__PURE__*/dual(2, (self, predicate) => matchSTM(self, {
  onFailure: fail$1,
  onSuccess: a => predicate(a) ? succeed$2(a) : retry$1
}));

/** @internal */
const retryWhile = /*#__PURE__*/dual(2, (self, predicate) => matchSTM(self, {
  onFailure: fail$1,
  onSuccess: a => !predicate(a) ? succeed$2(a) : retry$1
}));

/** @internal */
const partition = /*#__PURE__*/dual(2, (elements, f) => pipe(forEach$3(elements, a => either(f(a))), map$1(as => partitionMap(as, identity$1))));

/** @internal */
const some$1 = self => matchSTM(self, {
  onFailure: e => fail$1(some$6(e)),
  onSuccess: match$j({
    onNone: () => fail$1(none$8()),
    onSome: succeed$2
  })
});

/* @internal */
const all = (input, options) => {
  if (Symbol.iterator in input) {
    return forEach$3(input, identity$1, options);
  } else if (options?.discard) {
    return forEach$3(Object.values(input), identity$1, options);
  }
  return map$1(forEach$3(Object.entries(input), ([_, e]) => map$1(e, a => [_, a])), values => {
    const res = {};
    for (const [k, v] of values) {
      res[k] = v;
    }
    return res;
  });
};

/** @internal */
const succeedNone = /*#__PURE__*/succeed$2( /*#__PURE__*/none$8());

/** @internal */
const succeedSome = value => succeed$2(some$6(value));

/** @internal */
const summarized = /*#__PURE__*/dual(3, (self, summary, f) => flatMap(summary, start => flatMap(self, value => map$1(summary, end => [f(start, end), value]))));

/** @internal */
const suspend = evaluate => flatten(sync(evaluate));

/** @internal */
const tap = /*#__PURE__*/dual(2, (self, f) => flatMap(self, a => as(f(a), a)));

/** @internal */
const tapBoth = /*#__PURE__*/dual(2, (self, {
  onFailure,
  onSuccess
}) => matchSTM(self, {
  onFailure: e => pipe(onFailure(e), zipRight(fail$1(e))),
  onSuccess: a => pipe(onSuccess(a), as(a))
}));

/** @internal */
const tapError = /*#__PURE__*/dual(2, (self, f) => matchSTM(self, {
  onFailure: e => zipRight(f(e), fail$1(e)),
  onSuccess: succeed$2
}));

/** @internal */
const try_ = arg => {
  const evaluate = typeof arg === "function" ? arg : arg.try;
  return suspend(() => {
    try {
      return succeed$2(evaluate());
    } catch (error) {
      return fail$1("catch" in arg ? arg.catch(error) : error);
    }
  });
};

/** @internal */
const unit = /*#__PURE__*/succeed$2(void 0);

/** @internal */
const unless = /*#__PURE__*/dual(2, (self, predicate) => suspend(() => predicate() ? succeedNone : asSome(self)));

/** @internal */
const unlessSTM = /*#__PURE__*/dual(2, (self, predicate) => flatMap(predicate, bool => bool ? succeedNone : asSome(self)));

/** @internal */
const unsome = self => matchSTM(self, {
  onFailure: match$j({
    onNone: () => succeed$2(none$8()),
    onSome: fail$1
  }),
  onSuccess: a => succeed$2(some$6(a))
});

/** @internal */
const validateAll = /*#__PURE__*/dual(2, (elements, f) => flatMap(partition(elements, f), ([errors, values]) => isNonEmptyArray(errors) ? fail$1(errors) : succeed$2(values)));

/** @internal */
const validateFirst = /*#__PURE__*/dual(2, (elements, f) => flip(forEach$3(elements, a => flip(f(a)))));

/** @internal */
const when = /*#__PURE__*/dual(2, (self, predicate) => suspend(() => predicate() ? asSome(self) : succeedNone));

/** @internal */
const whenSTM = /*#__PURE__*/dual(2, (self, predicate) => flatMap(predicate, bool => bool ? asSome(self) : succeedNone));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
STMTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * `STM<R, E, A>` represents an effect that can be performed transactionally,
 *  resulting in a failure `E` or a value `A` that may require an environment
 *  `R` to execute.
 *
 * Software Transactional Memory is a technique which allows composition of
 * arbitrary atomic operations.  It is the software analog of transactions in
 * database systems.
 *
 * The API is lifted directly from the Haskell package Control.Concurrent.STM
 * although the implementation does not resemble the Haskell one at all.
 *
 * See http://hackage.haskell.org/package/stm-2.5.0.0/docs/Control-Concurrent-STM.html
 *
 * STM in Haskell was introduced in:
 *
 * Composable memory transactions, by Tim Harris, Simon Marlow, Simon Peyton
 * Jones, and Maurice Herlihy, in ACM Conference on Principles and Practice of
 * Parallel Programming 2005.
 *
 * See https://www.microsoft.com/en-us/research/publication/composable-memory-transactions/
 *
 * See also:
 *  Lock Free Data Structures using STMs in Haskell, by Anthony Discolo, Tim
 *  Harris, Simon Marlow, Simon Peyton Jones, Satnam Singh) FLOPS 2006: Eighth
 *  International Symposium on Functional and Logic Programming, Fuji Susono,
 *  JAPAN, April 2006
 *
 *  https://www.microsoft.com/en-us/research/publication/lock-free-data-structures-using-stms-in-haskell/
 *
 * The implemtation is based on the ZIO STM module, while JS environments have
 * no race conditions from multiple threads STM provides greater benefits for
 * synchronization of Fibers and transactional data-types can be quite useful.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category type lambdas
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * Returns `true` if the provided value is an `STM`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isSTM;

/**
 * Treats the specified `acquire` transaction as the acquisition of a
 * resource. The `acquire` transaction will be executed interruptibly. If it
 * is a success and is committed the specified `release` workflow will be
 * executed uninterruptibly as soon as the `use` workflow completes execution.
 *
 * @since 2.0.0
 * @category constructors
 */
acquireUseRelease;

/**
 * @since 2.0.0
 * @category utils
 */

/**
 * Runs all the provided transactional effects in sequence respecting the
 * structure provided in input.
 *
 * Supports multiple arguments, a single argument tuple / array or record /
 * struct.
 *
 * @since 2.0.0
 * @category constructors
 */
all;

/**
 * Maps the success value of this effect to the specified constant value.
 *
 * @since 2.0.0
 * @category mapping
 */
as;

/**
 * Maps the success value of this effect to an optional value.
 *
 * @since 2.0.0
 * @category mapping
 */
asSome;

/**
 * Maps the error value of this effect to an optional value.
 *
 * @since 2.0.0
 * @category mapping
 */
asSomeError;

/**
 * This function maps the success value of an `STM` to `void`. If the original
 * `STM` succeeds, the returned `STM` will also succeed. If the original `STM`
 * fails, the returned `STM` will fail with the same error.
 *
 * @since 2.0.0
 * @category mapping
 */
asUnit;

/**
 * Creates an `STM` value from a partial (but pure) function.
 *
 * @since 2.0.0
 * @category constructors
 */
attempt;

/**
 * Recovers from all errors.
 *
 * @since 2.0.0
 * @category error handling
 */
catchAll;

/**
 * Recovers from some or all of the error cases.
 *
 * @since 2.0.0
 * @category error handling
 */
catchSome;

/**
 * Recovers from the specified tagged error.
 *
 * @since 2.0.0
 * @category error handling
 */
catchTag;

/**
 * Recovers from multiple tagged errors.
 *
 * @since 2.0.0
 * @category error handling
 */
catchTags;

/**
 * Checks the condition, and if it's true, returns unit, otherwise, retries.
 *
 * @since 2.0.0
 * @category constructors
 */
check;

/**
 * Simultaneously filters and maps the value produced by this effect.
 *
 * @since 2.0.0
 * @category mutations
 */
collect;

/**
 * Simultaneously filters and maps the value produced by this effect.
 *
 * @since 2.0.0
 * @category mutations
 */
collectSTM;

/**
 * Commits this transaction atomically.
 *
 * @since 2.0.0
 * @category destructors
 */
commit;

/**
 * Commits this transaction atomically, regardless of whether the transaction
 * is a success or a failure.
 *
 * @since 2.0.0
 * @category destructors
 */
commitEither;

/**
 * Similar to Either.cond, evaluate the predicate, return the given A as
 * success if predicate returns true, and the given E as error otherwise
 *
 * @since 2.0.0
 * @category constructors
 */
cond;

/**
 * Retrieves the environment inside an stm.
 *
 * @since 2.0.0
 * @category constructors
 */
context;

/**
 * Accesses the environment of the transaction to perform a transaction.
 *
 * @since 2.0.0
 * @category constructors
 */
contextWith;

/**
 * Accesses the environment of the transaction to perform a transaction.
 *
 * @since 2.0.0
 * @category constructors
 */
contextWithSTM;

/**
 * Transforms the environment being provided to this effect with the specified
 * function.
 *
 * @since 2.0.0
 * @category context
 */
mapInputContext;

/**
 * Fails the transactional effect with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
die;

/**
 * Kills the fiber running the effect with a `Cause.RuntimeException` that
 * contains the specified message.
 *
 * @since 2.0.0
 * @category constructors
 */
dieMessage;

/**
 * Fails the transactional effect with the specified lazily evaluated defect.
 *
 * @since 2.0.0
 * @category constructors
 */
dieSync;

/**
 * Converts the failure channel into an `Either`.
 *
 * @since 2.0.0
 * @category mutations
 */
either;

/**
 * Executes the specified finalization transaction whether or not this effect
 * succeeds. Note that as with all STM transactions, if the full transaction
 * fails, everything will be rolled back.
 *
 * @since 2.0.0
 * @category finalization
 */
ensuring;

/**
 * Returns an effect that ignores errors and runs repeatedly until it
 * eventually succeeds.
 *
 * @since 2.0.0
 * @category mutations
 */
eventually;

/**
 * Determines whether all elements of the `Iterable<A>` satisfy the effectual
 * predicate.
 *
 * @since 2.0.0
 * @category constructors
 */
every$1;

/**
 * Determines whether any element of the `Iterable[A]` satisfies the effectual
 * predicate `f`.
 *
 * @since 2.0.0
 * @category constructors
 */
exists;

/**
 * Fails the transactional effect with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$1;

/**
 * Fails the transactional effect with the specified lazily evaluated error.
 *
 * @since 2.0.0
 * @category constructors
 */
failSync;

/**
 * Returns the fiber id of the fiber committing the transaction.
 *
 * @since 2.0.0
 * @category constructors
 */
fiberId;

/**
 * Filters the collection using the specified effectual predicate.
 *
 * @since 2.0.0
 * @category constructors
 */
filter;

/**
 * Filters the collection using the specified effectual predicate, removing
 * all elements that satisfy the predicate.
 *
 * @since 2.0.0
 * @category constructors
 */
filterNot;

/**
 * Dies with specified defect if the predicate fails.
 *
 * @since 2.0.0
 * @category filtering
 */
filterOrDie;

/**
 * Dies with a `Cause.RuntimeException` having the specified  message if the
 * predicate fails.
 *
 * @since 2.0.0
 * @category filtering
 */
filterOrDieMessage;

/**
 * Supplies `orElse` if the predicate fails.
 *
 * @since 2.0.0
 * @category filtering
 */
filterOrElse;

/**
 * Fails with the specified error if the predicate fails.
 *
 * @since 2.0.0
 * @category filtering
 */
filterOrFail;

/**
 * Feeds the value produced by this effect to the specified function, and then
 * runs the returned effect as well to produce its results.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatMap;

/**
 * Flattens out a nested `STM` effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatten;

/**
 * Flips the success and failure channels of this transactional effect. This
 * allows you to use all methods on the error channel, possibly before
 * flipping back.
 *
 * @since 2.0.0
 * @category mutations
 */
flip;

/**
 * Swaps the error/value parameters, applies the function `f` and flips the
 * parameters back
 *
 * @since 2.0.0
 * @category mutations
 */
flipWith;

/**
 * Folds over the `STM` effect, handling both failure and success, but not
 * retry.
 *
 * @since 2.0.0
 * @category folding
 */
match;

/**
 * Effectfully folds over the `STM` effect, handling both failure and success.
 *
 * @since 2.0.0
 * @category folding
 */
matchSTM;

/**
 * Applies the function `f` to each element of the `Iterable<A>` and returns
 * a transactional effect that produces a new `Chunk<A2>`.
 *
 * @since 2.0.0
 * @category traversing
 */
forEach$3;

/**
 * Lifts an `Either` into a `STM`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEither;

/**
 * Lifts an `Option` into a `STM`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromOption;

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
gen;

/**
 * Returns a successful effect with the head of the list if the list is
 * non-empty or fails with the error `None` if the list is empty.
 *
 * @since 2.0.0
 * @category getters
 */
head;
if_;

/**
 * Returns a new effect that ignores the success or failure of this effect.
 *
 * @since 2.0.0
 * @category mutations
 */
ignore;

/**
 * Interrupts the fiber running the effect.
 *
 * @since 2.0.0
 * @category constructors
 */
interrupt;

/**
 * Interrupts the fiber running the effect with the specified `FiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
const interruptAs = interruptAs$1;

/**
 * Returns whether this transactional effect is a failure.
 *
 * @since 2.0.0
 * @category getters
 */
isFailure;

/**
 * Returns whether this transactional effect is a success.
 *
 * @since 2.0.0
 * @category getters
 */
isSuccess;

/**
 * Iterates with the specified transactional function. The moral equivalent
 * of:
 *
 * ```ts
 * const s = initial
 *
 * while (cont(s)) {
 *   s = body(s)
 * }
 *
 * return s
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
iterate;

/**
 * Loops with the specified transactional function, collecting the results
 * into a list. The moral equivalent of:
 *
 * ```ts
 * const as = []
 * let s  = initial
 *
 * while (cont(s)) {
 *   as.push(body(s))
 *   s  = inc(s)
 * }
 *
 * return as
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
loop;

/**
 * Maps the value produced by the effect.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = map$1;

/**
 * Maps the value produced by the effect with the specified function that may
 * throw exceptions but is otherwise pure, translating any thrown exceptions
 * into typed failed effects.
 *
 * @since 2.0.0
 * @category mapping
 */
mapAttempt;

/**
 * Returns an `STM` effect whose failure and success channels have been mapped
 * by the specified pair of functions, `f` and `g`.
 *
 * @since 2.0.0
 * @category mapping
 */
mapBoth;

/**
 * Maps from one error type to another.
 *
 * @since 2.0.0
 * @category mapping
 */
mapError;

/**
 * Returns a new effect where the error channel has been merged into the
 * success channel to their common combined type.
 *
 * @since 2.0.0
 * @category mutations
 */
merge$1;

/**
 * Merges an `Iterable<STM>` to a single `STM`, working sequentially.
 *
 * @since 2.0.0
 * @category constructors
 */
mergeAll;

/**
 * Returns a new effect where boolean value of this effect is negated.
 *
 * @since 2.0.0
 * @category mutations
 */
negate;

/**
 * Requires the option produced by this value to be `None`.
 *
 * @since 2.0.0
 * @category mutations
 */
none;

/**
 * Converts the failure channel into an `Option`.
 *
 * @since 2.0.0
 * @category mutations
 */
option;

/**
 * Translates `STM` effect failure into death of the fiber, making all
 * failures unchecked and not a part of the type of the effect.
 *
 * @since 2.0.0
 * @category error handling
 */
orDie;

/**
 * Keeps none of the errors, and terminates the fiber running the `STM` effect
 * with them, using the specified function to convert the `E` into a defect.
 *
 * @since 2.0.0
 * @category error handling
 */
orDieWith;

/**
 * Tries this effect first, and if it fails or retries, tries the other
 * effect.
 *
 * @since 2.0.0
 * @category error handling
 */
orElse;

/**
 * Returns a transactional effect that will produce the value of this effect
 * in left side, unless it fails or retries, in which case, it will produce
 * the value of the specified effect in right side.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseEither;

/**
 * Tries this effect first, and if it fails or retries, fails with the
 * specified error.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseFail;

/**
 * Returns an effect that will produce the value of this effect, unless it
 * fails with the `None` value, in which case it will produce the value of the
 * specified effect.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseOptional;

/**
 * Tries this effect first, and if it fails or retries, succeeds with the
 * specified value.
 *
 * @since 2.0.0
 * @category error handling
 */
orElseSucceed;

/**
 * Tries this effect first, and if it enters retry, then it tries the other
 * effect. This is an equivalent of Haskell's orElse.
 *
 * @since 2.0.0
 * @category error handling
 */
orTry;

/**
 * Feeds elements of type `A` to a function `f` that returns an effect.
 * Collects all successes and failures in a tupled fashion.
 *
 * @since 2.0.0
 * @category traversing
 */
partition;

/**
 * Provides the transaction its required environment, which eliminates its
 * dependency on `R`.
 *
 * @since 2.0.0
 * @category context
 */
provideContext;

/**
 * Splits the context into two parts, providing one part using the
 * specified layer and leaving the remainder `R0`.
 *
 * @since 2.0.0
 * @category context
 */
provideSomeContext;

/**
 * Provides the effect with the single service it requires. If the transactional
 * effect requires more than one service use `provideEnvironment` instead.
 *
 * @since 2.0.0
 * @category context
 */
provideService;

/**
 * Provides the effect with the single service it requires. If the transactional
 * effect requires more than one service use `provideEnvironment` instead.
 *
 * @since 2.0.0
 * @category context
 */
provideServiceSTM;

/**
 * Folds an `Iterable<A>` using an effectual function f, working sequentially
 * from left to right.
 *
 * @since 2.0.0
 * @category constructors
 */
reduce$4;

/**
 * Reduces an `Iterable<STM>` to a single `STM`, working sequentially.
 *
 * @since 2.0.0
 * @category constructors
 */
reduceAll;

/**
 * Folds an `Iterable<A>` using an effectual function f, working sequentially
 * from right to left.
 *
 * @since 2.0.0
 * @category constructors
 */
reduceRight;

/**
 * Keeps some of the errors, and terminates the fiber with the rest.
 *
 * @since 2.0.0
 * @category mutations
 */
refineOrDie;

/**
 * Keeps some of the errors, and terminates the fiber with the rest, using the
 * specified function to convert the `E` into a `Throwable`.
 *
 * @since 2.0.0
 * @category mutations
 */
refineOrDieWith;

/**
 * Fail with the returned value if the `PartialFunction` matches, otherwise
 * continue with our held value.
 *
 * @since 2.0.0
 * @category mutations
 */
reject;

/**
 * Continue with the returned computation if the specified partial function
 * matches, translating the successful match into a failure, otherwise continue
 * with our held value.
 *
 * @since 2.0.0
 * @category mutations
 */
rejectSTM;

/**
 * Repeats this `STM` effect until its result satisfies the specified
 * predicate.
 *
 * **WARNING**: `repeatUntil` uses a busy loop to repeat the effect and will
 * consume a thread until it completes (it cannot yield). This is because STM
 * describes a single atomic transaction which must either complete, retry or
 * fail a transaction before yielding back to the Effect runtime.
 *   - Use `retryUntil` instead if you don't need to maintain transaction
 *     state for repeats.
 *   - Ensure repeating the STM effect will eventually satisfy the predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
repeatUntil;

/**
 * Repeats this `STM` effect while its result satisfies the specified
 * predicate.
 *
 * **WARNING**: `repeatWhile` uses a busy loop to repeat the effect and will
 * consume a thread until it completes (it cannot yield). This is because STM
 * describes a single atomic transaction which must either complete, retry or
 * fail a transaction before yielding back to the Effect runtime.
 *   - Use `retryWhile` instead if you don't need to maintain transaction
 *     state for repeats.
 *   - Ensure repeating the STM effect will eventually not satisfy the
 *     predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
repeatWhile;

/**
 * Replicates the given effect n times. If 0 or negative numbers are given, an
 * empty `Chunk` will be returned.
 *
 * @since 2.0.0
 * @category constructors
 */
replicate;

/**
 * Performs this transaction the specified number of times and collects the
 * results.
 *
 * @since 2.0.0
 * @category constructors
 */
replicateSTM;

/**
 * Performs this transaction the specified number of times, discarding the
 * results.
 *
 * @since 2.0.0
 * @category constructors
 */
replicateSTMDiscard;

/**
 * Abort and retry the whole transaction when any of the underlying
 * transactional variables have changed.
 *
 * @since 2.0.0
 * @category error handling
 */
const retry = retry$1;

/**
 * Filters the value produced by this effect, retrying the transaction until
 * the predicate returns `true` for the value.
 *
 * @since 2.0.0
 * @category mutations
 */
retryUntil;

/**
 * Filters the value produced by this effect, retrying the transaction while
 * the predicate returns `true` for the value.
 *
 * @since 2.0.0
 * @category mutations
 */
retryWhile;

/**
 * Converts an option on values into an option on errors.
 *
 * @since 2.0.0
 * @category getters
 */
some$1;

/**
 * Returns an `STM` effect that succeeds with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeed$1 = succeed$2;

/**
 * Returns an effect with the empty value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeedNone;

/**
 * Returns an effect with the optional value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeedSome;

/**
 * Summarizes a `STM` effect by computing a provided value before and after
 * execution, and then combining the values to produce a summary, together
 * with the result of execution.
 *
 * @since 2.0.0
 * @category mutations
 */
summarized;

/**
 * Suspends creation of the specified transaction lazily.
 *
 * @since 2.0.0
 * @category constructors
 */
suspend;

/**
 * Returns an `STM` effect that succeeds with the specified lazily evaluated
 * value.
 *
 * @since 2.0.0
 * @category constructors
 */
sync;

/**
 * "Peeks" at the success of transactional effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
tap;

/**
 * "Peeks" at both sides of an transactional effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapBoth;

/**
 * "Peeks" at the error of the transactional effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
tapError;
try_;

/**
 * The moral equivalent of `if (!p) exp`
 *
 * @since 2.0.0
 * @category mutations
 */
unless;

/**
 * The moral equivalent of `if (!p) exp` when `p` has side-effects
 *
 * @since 2.0.0
 * @category mutations
 */
unlessSTM;

/**
 * Converts an option on errors into an option on values.
 *
 * @since 2.0.0
 * @category getters
 */
unsome;

/**
 * Returns an `STM` effect that succeeds with `Unit`.
 *
 * @since 2.0.0
 * @category constructors
 */
unit;

/**
 * Feeds elements of type `A` to `f` and accumulates all errors in error
 * channel or successes in success channel.
 *
 * This combinator is lossy meaning that if there are errors all successes
 * will be lost. To retain all information please use `STM.partition`.
 *
 * @since 2.0.0
 * @category mutations
 */
validateAll;

/**
 * Feeds elements of type `A` to `f` until it succeeds. Returns first success
 * or the accumulation of all errors.
 *
 * @since 2.0.0
 * @category mutations
 */
validateFirst;

/**
 * The moral equivalent of `if (p) exp`.
 *
 * @since 2.0.0
 * @category mutations
 */
when;

/**
 * The moral equivalent of `if (p) exp` when `p` has side-effects.
 *
 * @since 2.0.0
 * @category mutations
 */
whenSTM;

/**
 * Sequentially zips this value with the specified one.
 *
 * @since 2.0.0
 * @category zipping
 */
zip;

/**
 * Sequentially zips this value with the specified one, discarding the second
 * element of the tuple.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLeft;

/**
 * Sequentially zips this value with the specified one, discarding the first
 * element of the tuple.
 *
 * @since 2.0.0
 * @category zipping
 */
zipRight;

/**
 * Sequentially zips this value with the specified one, combining the values
 * using the specified combiner function.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWith;

/**
 * @category do notation
 * @since 2.0.0
 */
bind;
let_;

/**
 * @category do notation
 * @since 2.0.0
 */
bindTo;

/**
 * The `CacheState` represents the mutable state underlying the cache.
 *
 * @internal
 */

/** @internal */
const makeCacheState = (map, keys, accesses, updating, hits, misses) => ({
  map,
  keys,
  accesses,
  updating,
  hits,
  misses
});

/**
 * Constructs an initial cache state.
 *
 * @internal
 */
const initialCacheState = () => makeCacheState(empty$k(), makeKeySet(), unbounded$6(), make$W(false), 0, 0);

/**
 * A `MapValue` represents a value in the cache. A value may either be
 * `Pending` with a `Promise` that will contain the result of computing the
 * lookup function, when it is available, or `Complete` with an `Exit` value
 * that contains the result of computing the lookup function.
 *
 * @internal
 */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
const complete = (key, exit, ownerCount, entryStats, timeToLive) => struct({
  _tag: "Complete",
  key,
  exit,
  ownerCount,
  entryStats,
  timeToLive
});

/** @internal */
const pending$2 = (key, scoped) => struct({
  _tag: "Pending",
  key,
  scoped
});

/** @internal */
const refreshing = (scoped, complete) => struct({
  _tag: "Refreshing",
  scoped,
  complete
});

/** @internal */
const toScoped = self => matchEffect$2(self.exit, {
  onFailure: cause => failCause$a(cause),
  onSuccess: ([value]) => acquireRelease$2(as$6(sync$a(() => incrementAndGet(self.ownerCount)), value), () => releaseOwner(self))
});

/** @internal */
const releaseOwner = self => matchEffect$2(self.exit, {
  onFailure: () => unit$6,
  onSuccess: ([, finalizer]) => flatMap$6(sync$a(() => decrementAndGet(self.ownerCount)), numOwner => when$4(finalizer(unit$5), () => numOwner === 0))
});

/** @internal */
const ScopedCacheSymbolKey = "effect/ScopedCache";

/** @internal */
const ScopedCacheTypeId = /*#__PURE__*/Symbol.for(ScopedCacheSymbolKey);
const scopedCacheVariance = {
  _Key: _ => _,
  _Error: _ => _,
  _Value: _ => _
};
class ScopedCacheImpl {
  [ScopedCacheTypeId] = scopedCacheVariance;
  constructor(capacity, scopedLookup, clock, timeToLive, context) {
    this.capacity = capacity;
    this.scopedLookup = scopedLookup;
    this.clock = clock;
    this.timeToLive = timeToLive;
    this.context = context;
    this.cacheState = initialCacheState();
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  cacheStats() {
    return sync$a(() => makeCacheStats({
      hits: this.cacheState.hits,
      misses: this.cacheState.misses,
      size: size$e(this.cacheState.map)
    }));
  }
  getOption(key) {
    return suspend$8(() => match$j(get$e(this.cacheState.map, key), {
      onNone: () => succeedNone$2,
      onSome: value => flatten$6(this.resolveMapValue(value))
    }));
  }
  getOptionComplete(key) {
    return suspend$8(() => match$j(get$e(this.cacheState.map, key), {
      onNone: () => succeedNone$2,
      onSome: value => flatten$6(this.resolveMapValue(value, true))
    }));
  }
  contains(key) {
    return sync$a(() => has$4(this.cacheState.map, key));
  }
  entryStats(key) {
    return sync$a(() => {
      const value = getOrUndefined(get$e(this.cacheState.map, key));
      if (value === undefined) {
        return none$8();
      }
      switch (value._tag) {
        case "Complete":
          {
            return some$6(makeEntryStats(value.entryStats.loadedMillis));
          }
        case "Pending":
          {
            return none$8();
          }
        case "Refreshing":
          {
            return some$6(makeEntryStats(value.complete.entryStats.loadedMillis));
          }
      }
    });
  }
  get(key) {
    return pipe(this.lookupValueOf(key), memoize$1, flatMap$6(lookupValue => suspend$8(() => {
      let k = undefined;
      let value = getOrUndefined(get$e(this.cacheState.map, key));
      if (value === undefined) {
        k = makeMapKey(key);
        if (has$4(this.cacheState.map, key)) {
          value = getOrUndefined(get$e(this.cacheState.map, key));
        } else {
          set$9(this.cacheState.map, key, pending$2(k, lookupValue));
        }
      }
      if (value === undefined) {
        this.trackMiss();
        return zipRight$8(this.ensureMapSizeNotExceeded(k), lookupValue);
      }
      return map$f(this.resolveMapValue(value), flatMap$6(match$j({
        onNone: () => {
          const val = value;
          const current = getOrUndefined(get$e(this.cacheState.map, key));
          if (equals$1(current, value)) {
            remove$5(this.cacheState.map, key);
          }
          return pipe(this.ensureMapSizeNotExceeded(val.key), zipRight$8(releaseOwner(val)), zipRight$8(this.get(key)));
        },
        onSome: succeed$h
      })));
    })), flatten$6);
  }
  invalidate(key) {
    return suspend$8(() => {
      if (has$4(this.cacheState.map, key)) {
        const mapValue = getOrUndefined(get$e(this.cacheState.map, key));
        remove$5(this.cacheState.map, key);
        switch (mapValue._tag) {
          case "Complete":
            {
              return releaseOwner(mapValue);
            }
          case "Pending":
            {
              return unit$6;
            }
          case "Refreshing":
            {
              return releaseOwner(mapValue.complete);
            }
        }
      }
      return unit$6;
    });
  }
  invalidateAll() {
    return forEachParUnboundedDiscard(fromIterable$7(Array.from(this.cacheState.map).map(([key]) => key)), key => this.invalidate(key), false);
  }
  refresh(key) {
    return pipe(this.lookupValueOf(key), memoize$1, flatMap$6(scoped => {
      let value = getOrUndefined(get$e(this.cacheState.map, key));
      let newKey = undefined;
      if (value === undefined) {
        newKey = makeMapKey(key);
        if (has$4(this.cacheState.map, key)) {
          value = getOrUndefined(get$e(this.cacheState.map, key));
        } else {
          set$9(this.cacheState.map, key, pending$2(newKey, scoped));
        }
      }
      let finalScoped;
      if (value === undefined) {
        finalScoped = zipRight$8(this.ensureMapSizeNotExceeded(newKey), scoped);
      } else {
        switch (value._tag) {
          case "Complete":
            {
              if (this.hasExpired(value.timeToLive)) {
                finalScoped = succeed$h(this.get(key));
              } else {
                const current = getOrUndefined(get$e(this.cacheState.map, key));
                if (equals$1(current, value)) {
                  const mapValue = refreshing(scoped, value);
                  set$9(this.cacheState.map, key, mapValue);
                  finalScoped = scoped;
                } else {
                  finalScoped = succeed$h(this.get(key));
                }
              }
              break;
            }
          case "Pending":
            {
              finalScoped = value.scoped;
              break;
            }
          case "Refreshing":
            {
              finalScoped = value.scoped;
              break;
            }
        }
      }
      return flatMap$6(finalScoped, s => scopedEffect(asUnit$4(s)));
    }));
  }
  size() {
    return sync$a(() => size$e(this.cacheState.map));
  }
  resolveMapValue(value, ignorePending = false) {
    switch (value._tag) {
      case "Complete":
        {
          this.trackHit();
          if (this.hasExpired(value.timeToLive)) {
            return succeed$h(succeedNone$2);
          }
          return as$6(this.ensureMapSizeNotExceeded(value.key), asSome$2(toScoped(value)));
        }
      case "Pending":
        {
          this.trackHit();
          if (ignorePending) {
            return succeed$h(succeedNone$2);
          }
          return zipRight$8(this.ensureMapSizeNotExceeded(value.key), map$f(value.scoped, asSome$2));
        }
      case "Refreshing":
        {
          this.trackHit();
          if (this.hasExpired(value.complete.timeToLive)) {
            if (ignorePending) {
              return succeed$h(succeedNone$2);
            }
            return zipRight$8(this.ensureMapSizeNotExceeded(value.complete.key), map$f(value.scoped, asSome$2));
          }
          return as$6(this.ensureMapSizeNotExceeded(value.complete.key), asSome$2(toScoped(value.complete)));
        }
    }
  }
  lookupValueOf(key) {
    return pipe(onInterrupt$1(flatMap$6(make$u(), scope => pipe(this.scopedLookup(key), provideContext$6(pipe(this.context, add$4(Scope, scope))), exit$1, map$f(exit => [exit, exit => close$1(scope, exit)]))), () => sync$a(() => remove$5(this.cacheState.map, key))), flatMap$6(([exit, release]) => {
      const now = this.clock.unsafeCurrentTimeMillis();
      const expiredAt = now + toMillis(this.timeToLive(exit));
      switch (exit._tag) {
        case "Success":
          {
            const exitWithFinalizer = succeed$f([exit.value, release]);
            const completedResult = complete(makeMapKey(key), exitWithFinalizer, make$W(1), makeEntryStats(now), expiredAt);
            let previousValue = undefined;
            if (has$4(this.cacheState.map, key)) {
              previousValue = getOrUndefined(get$e(this.cacheState.map, key));
            }
            set$9(this.cacheState.map, key, completedResult);
            return sync$a(() => flatten$6(as$6(this.cleanMapValue(previousValue), toScoped(completedResult))));
          }
        case "Failure":
          {
            const completedResult = complete(makeMapKey(key), exit, make$W(0), makeEntryStats(now), expiredAt);
            let previousValue = undefined;
            if (has$4(this.cacheState.map, key)) {
              previousValue = getOrUndefined(get$e(this.cacheState.map, key));
            }
            set$9(this.cacheState.map, key, completedResult);
            return zipRight$8(release(exit), sync$a(() => flatten$6(as$6(this.cleanMapValue(previousValue), toScoped(completedResult)))));
          }
      }
    }), memoize$1, flatten$6);
  }
  hasExpired(timeToLive) {
    return this.clock.unsafeCurrentTimeMillis() > timeToLive;
  }
  trackHit() {
    this.cacheState.hits = this.cacheState.hits + 1;
  }
  trackMiss() {
    this.cacheState.misses = this.cacheState.misses + 1;
  }
  trackAccess(key) {
    const cleanedKeys = [];
    offer$5(this.cacheState.accesses, key);
    if (compareAndSet(this.cacheState.updating, false, true)) {
      let loop = true;
      while (loop) {
        const key = poll$7(this.cacheState.accesses, EmptyMutableQueue);
        if (key === EmptyMutableQueue) {
          loop = false;
        } else {
          this.cacheState.keys.add(key);
        }
      }
      let size$1 = size$e(this.cacheState.map);
      loop = size$1 > this.capacity;
      while (loop) {
        const key = this.cacheState.keys.remove();
        if (key === undefined) {
          loop = false;
        } else {
          if (has$4(this.cacheState.map, key.current)) {
            const removed = getOrUndefined(get$e(this.cacheState.map, key.current));
            remove$5(this.cacheState.map, key.current);
            size$1 = size$1 - 1;
            cleanedKeys.push(removed);
            loop = size$1 > this.capacity;
          }
        }
      }
      set$a(this.cacheState.updating, false);
    }
    return cleanedKeys;
  }
  cleanMapValue(mapValue) {
    if (mapValue === undefined) {
      return unit$6;
    }
    switch (mapValue._tag) {
      case "Complete":
        {
          return releaseOwner(mapValue);
        }
      case "Pending":
        {
          return unit$6;
        }
      case "Refreshing":
        {
          return releaseOwner(mapValue.complete);
        }
    }
  }
  ensureMapSizeNotExceeded(key) {
    return forEachParUnboundedDiscard(this.trackAccess(key), cleanedMapValue => this.cleanMapValue(cleanedMapValue), false);
  }
}

/** @internal */
const make$f = options => {
  const timeToLive = decode(options.timeToLive);
  return makeWith({
    capacity: options.capacity,
    lookup: options.lookup,
    timeToLive: () => timeToLive
  });
};

/** @internal */
const makeWith = options => flatMap$6(clock$1, clock => buildWith(options.capacity, options.lookup, clock, exit => decode(options.timeToLive(exit))));
const buildWith = (capacity, scopedLookup, clock, timeToLive) => acquireRelease$2(flatMap$6(context$7(), context => sync$a(() => new ScopedCacheImpl(capacity, scopedLookup, clock, timeToLive, context))), cache => cache.invalidateAll());

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ScopedCacheTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Constructs a new cache with the specified capacity, time to live, and
 * lookup function.
 *
 * @since 2.0.0
 * @category constructors
 */
make$f;

/**
 * Constructs a new cache with the specified capacity, time to live, and
 * lookup function, where the time to live can depend on the `Exit` value
 * returned by the lookup function.
 *
 * @since 2.0.0
 * @category constructors
 */
makeWith;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
ScopedRefTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `ScopedRef` is a reference whose value is associated with resources,
 * which must be released properly. You can both get the current value of any
 * `ScopedRef`, as well as set it to a new value (which may require new
 * resources). The reference itself takes care of properly releasing resources
 * for the old value whenever a new value is obtained.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Creates a new `ScopedRef` from an effect that resourcefully produces a
 * value.
 *
 * @since 2.0.0
 * @category constructors
 */
fromAcquire;

/**
 * Retrieves the current value of the scoped reference.
 *
 * @since 2.0.0
 * @category getters
 */
get$8;

/**
 * Creates a new `ScopedRef` from the specified value. This method should
 * not be used for values whose creation require the acquisition of resources.
 *
 * @since 2.0.0
 * @category constructors
 */
make$j;

/**
 * Sets the value of this reference to the specified resourcefully-created
 * value. Any resources associated with the old value will be released.
 *
 * This method will not return until either the reference is successfully
 * changed to the new value, with old resources released, or until the attempt
 * to acquire a new value fails.
 *
 * @since 2.0.0
 * @category getters
 */
set$4;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
SinkTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Sink<R, E, In, L, Z>` is used to consume elements produced by a `Stream`.
 * You can think of a sink as a function that will consume a variable amount of
 * `In` elements (could be 0, 1, or many), might fail with an error of type `E`,
 * and will eventually yield a value of type `Z` together with a remainder of
 * type `L` (i.e. any leftovers).
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Replaces this sink's result with the provided value.
 *
 * @since 2.0.0
 * @category mapping
 */
as$2;

/**
 * A sink that collects all elements into a `Chunk`.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAll$1;

/**
 * A sink that collects first `n` elements into a chunk.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllN;

/**
 * Repeatedly runs the sink and accumulates its results into a `Chunk`.
 *
 * @since 2.0.0
 * @category utils
 */
collectAllFrom;

/**
 * A sink that collects all of its inputs into a map. The keys are extracted
 * from inputs using the keying function `key`; if multiple inputs use the
 * same key, they are merged using the `merge` function.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllToMap;

/**
 * A sink that collects first `n` keys into a map. The keys are calculated
 * from inputs using the keying function `key`; if multiple inputs use the the
 * same key, they are merged using the `merge` function.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllToMapN;

/**
 * A sink that collects all of its inputs into a set.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllToSet;

/**
 * A sink that collects first `n` distinct inputs into a set.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllToSetN;

/**
 * Accumulates incoming elements into a chunk until predicate `p` is
 * satisfied.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllUntil;

/**
 * Accumulates incoming elements into a chunk until effectful predicate `p` is
 * satisfied.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllUntilEffect;

/**
 * Accumulates incoming elements into a chunk as long as they verify predicate
 * `p`.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllWhile;

/**
 * Accumulates incoming elements into a chunk as long as they verify effectful
 * predicate `p`.
 *
 * @since 2.0.0
 * @category constructors
 */
collectAllWhileEffect;

/**
 * Repeatedly runs the sink for as long as its results satisfy the predicate
 * `p`. The sink's results will be accumulated using the stepping function `f`.
 *
 * @since 2.0.0
 * @category utils
 */
collectAllWhileWith;

/**
 * Collects the leftovers from the stream when the sink succeeds and returns
 * them as part of the sink's result.
 *
 * @since 2.0.0
 * @category utils
 */
collectLeftover;

/**
 * Transforms this sink's input elements.
 *
 * @since 2.0.0
 * @category mapping
 */
mapInput;

/**
 * Effectfully transforms this sink's input elements.
 *
 * @since 2.0.0
 * @category mapping
 */
mapInputEffect;

/**
 * Transforms this sink's input chunks. `f` must preserve chunking-invariance.
 *
 * @since 2.0.0
 * @category mapping
 */
mapInputChunks;

/**
 * Effectfully transforms this sink's input chunks. `f` must preserve
 * chunking-invariance.
 *
 * @since 2.0.0
 * @category mapping
 */
mapInputChunksEffect;

/**
 * A sink that counts the number of elements fed to it.
 *
 * @since 2.0.0
 * @category constructors
 */
count$2;

/**
 * Creates a sink halting with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
die$4;

/**
 * Creates a sink halting with the specified message, wrapped in a
 * `RuntimeException`.
 *
 * @since 2.0.0
 * @category constructors
 */
dieMessage$3;

/**
 * Creates a sink halting with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
dieSync$2;

/**
 * Transforms both inputs and result of this sink using the provided
 * functions.
 *
 * @since 2.0.0
 * @category mapping
 */
dimap;

/**
 * Effectfully transforms both inputs and result of this sink using the
 * provided functions.
 *
 * @since 2.0.0
 * @category mapping
 */
dimapEffect;

/**
 * Transforms both input chunks and result of this sink using the provided
 * functions.
 *
 * @since 2.0.0
 * @category mapping
 */
dimapChunks;

/**
 * Effectfully transforms both input chunks and result of this sink using the
 * provided functions. `f` and `g` must preserve chunking-invariance.
 *
 * @since 2.0.0
 * @category mapping
 */
dimapChunksEffect;

/**
 * A sink that ignores its inputs.
 *
 * @since 2.0.0
 * @category constructors
 */
drain$1;

/**
 * Creates a sink that drops `n` elements.
 *
 * @since 2.0.0
 * @category constructors
 */
drop$1;

/**
 * Drops incoming elements until the predicate is satisfied.
 *
 * @since 2.0.0
 * @category constructors
 */
dropUntil$1;

/**
 * Drops incoming elements until the effectful predicate is satisfied.
 *
 * @since 2.0.0
 * @category constructors
 */
dropUntilEffect$1;

/**
 * Drops incoming elements as long as the predicate is satisfied.
 *
 * @since 2.0.0
 * @category constructors
 */
dropWhile$1;

/**
 * Drops incoming elements as long as the effectful predicate is satisfied.
 *
 * @since 2.0.0
 * @category constructors
 */
dropWhileEffect$1;

/**
 * Returns a new sink with an attached finalizer. The finalizer is guaranteed
 * to be executed so long as the sink begins execution (and regardless of
 * whether or not it completes).
 *
 * @since 2.0.0
 * @category finalization
 */
ensuring$2;

/**
 * Returns a new sink with an attached finalizer. The finalizer is guaranteed
 * to be executed so long as the sink begins execution (and regardless of
 * whether or not it completes).
 *
 * @since 2.0.0
 * @category finalization
 */
ensuringWith$1;

/**
 * Accesses the whole context of the sink.
 *
 * @since 2.0.0
 * @category constructors
 */
context$2;

/**
 * Accesses the context of the sink.
 *
 * @since 2.0.0
 * @category constructors
 */
contextWith$2;

/**
 * Accesses the context of the sink in the context of an effect.
 *
 * @since 2.0.0
 * @category constructors
 */
contextWithEffect$1;

/**
 * Accesses the context of the sink in the context of a sink.
 *
 * @since 2.0.0
 * @category constructors
 */
contextWithSink;

/**
 * A sink that returns whether all elements satisfy the specified predicate.
 *
 * @since 2.0.0
 * @category constructors
 */
every$2;

/**
 * A sink that always fails with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$5;

/**
 * A sink that always fails with the specified lazily evaluated error.
 *
 * @since 2.0.0
 * @category constructors
 */
failSync$2;

/**
 * Creates a sink halting with a specified `Cause`.
 *
 * @since 2.0.0
 * @category constructors
 */
failCause$3;

/**
 * Creates a sink halting with a specified lazily evaluated `Cause`.
 *
 * @since 2.0.0
 * @category constructors
 */
failCauseSync$1;

/**
 * Filters the sink's input with the given predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
filterInput;

/**
 * Effectfully filter the input of this sink using the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
filterInputEffect;

/**
 * Creates a sink that produces values until one verifies the predicate `f`.
 *
 * @since 2.0.0
 * @category elements
 */
findEffect$1;

/**
 * A sink that folds its inputs with the provided function, termination
 * predicate and initial state.
 *
 * @since 2.0.0
 * @category folding
 */
fold;

/**
 * Folds over the result of the sink
 *
 * @since 2.0.0
 * @category folding
 */
foldSink;

/**
 * A sink that folds its input chunks with the provided function, termination
 * predicate and initial state. `contFn` condition is checked only for the
 * initial value and at the end of processing of each chunk. `f` and `contFn`
 * must preserve chunking-invariance.
 *
 * @since 2.0.0
 * @category constructors
 */
foldChunks;

/**
 * A sink that effectfully folds its input chunks with the provided function,
 * termination predicate and initial state. `contFn` condition is checked only
 * for the initial value and at the end of processing of each chunk. `f` and
 * `contFn` must preserve chunking-invariance.
 *
 * @since 2.0.0
 * @category constructors
 */
foldChunksEffect;

/**
 * A sink that effectfully folds its inputs with the provided function,
 * termination predicate and initial state.
 *
 * @since 2.0.0
 * @category constructors
 */
foldEffect;

/**
 * A sink that folds its inputs with the provided function and initial state.
 *
 * @since 2.0.0
 * @category constructors
 */
foldLeft;

/**
 * A sink that folds its input chunks with the provided function and initial
 * state. `f` must preserve chunking-invariance.
 *
 * @since 2.0.0
 * @category constructors
 */
foldLeftChunks;

/**
 * A sink that effectfully folds its input chunks with the provided function
 * and initial state. `f` must preserve chunking-invariance.
 *
 * @since 2.0.0
 * @category constructors
 */
foldLeftChunksEffect;

/**
 * A sink that effectfully folds its inputs with the provided function and
 * initial state.
 *
 * @since 2.0.0
 * @category constructors
 */
foldLeftEffect;

/**
 * Creates a sink that folds elements of type `In` into a structure of type
 * `S` until `max` elements have been folded.
 *
 * Like `Sink.foldWeighted`, but with a constant cost function of `1`.
 *
 * @since 2.0.0
 * @category constructors
 */
foldUntil;

/**
 * Creates a sink that effectfully folds elements of type `In` into a
 * structure of type `S` until `max` elements have been folded.
 *
 * Like `Sink.foldWeightedEffect` but with a constant cost function of `1`.
 *
 * @since 2.0.0
 * @category constructors
 */
foldUntilEffect;

/**
 * Creates a sink that folds elements of type `In` into a structure of type
 * `S`, until `max` worth of elements (determined by the `costFn`) have been
 * folded.
 *
 * @note
 *   Elements that have an individual cost larger than `max` will force the
 *   sink to cross the `max` cost. See `Sink.foldWeightedDecompose` for a
 *   variant that can handle these cases.
 *
 * @since 2.0.0
 * @category constructors
 */
foldWeighted;

/**
 * Creates a sink that folds elements of type `In` into a structure of type
 * `S`, until `max` worth of elements (determined by the `costFn`) have been
 * folded.
 *
 * The `decompose` function will be used for decomposing elements that cause
 * an `S` aggregate to cross `max` into smaller elements. For example:
 *
 * ```ts
 * pipe(
 *   Stream.make(1, 5, 1),
 *   Stream.transduce(
 *     Sink.foldWeightedDecompose(
 *       Chunk.empty<number>(),
 *       4,
 *       (n: number) => n,
 *       (n: number) => Chunk.make(n - 1, 1),
 *       (acc, el) => pipe(acc, Chunk.append(el))
 *     )
 *   ),
 *   Stream.runCollect
 * )
 * ```
 *
 * The stream would emit the elements `Chunk(1), Chunk(4), Chunk(1, 1)`.
 *
 * Be vigilant with this function, it has to generate "simpler" values or the
 * fold may never end. A value is considered indivisible if `decompose` yields
 * the empty chunk or a single-valued chunk. In these cases, there is no other
 * choice than to yield a value that will cross the threshold.
 *
 * `Sink.foldWeightedDecomposeEffect` allows the decompose function to return an
 * effect value, and consequently it allows the sink to fail.
 *
 * @since 2.0.0
 * @category constructors
 */
foldWeightedDecompose;

/**
 * Creates a sink that effectfully folds elements of type `In` into a
 * structure of type `S`, until `max` worth of elements (determined by the
 * `costFn`) have been folded.
 *
 * The `decompose` function will be used for decomposing elements that cause
 * an `S` aggregate to cross `max` into smaller elements. Be vigilant with
 * this function, it has to generate "simpler" values or the fold may never
 * end. A value is considered indivisible if `decompose` yields the empty
 * chunk or a single-valued chunk. In these cases, there is no other choice
 * than to yield a value that will cross the threshold.
 *
 * See `Sink.foldWeightedDecompose` for an example.
 *
 * @since 2.0.0
 * @category constructors
 */
foldWeightedDecomposeEffect;

/**
 * Creates a sink that effectfully folds elements of type `In` into a
 * structure of type `S`, until `max` worth of elements (determined by the
 * `costFn`) have been folded.
 *
 * @note
 *   Elements that have an individual cost larger than `max` will force the
 *   sink to cross the `max` cost. See `Sink.foldWeightedDecomposeEffect` for
 *   a variant that can handle these cases.
 *
 * @since 2.0.0
 * @category constructors
 */
foldWeightedEffect;

/**
 * A sink that executes the provided effectful function for every element fed
 * to it.
 *
 * @since 2.0.0
 * @category constructors
 */
forEach$5;

/**
 * A sink that executes the provided effectful function for every chunk fed to
 * it.
 *
 * @since 2.0.0
 * @category constructors
 */
forEachChunk;

/**
 * A sink that executes the provided effectful function for every chunk fed to
 * it until `f` evaluates to `false`.
 *
 * @since 2.0.0
 * @category constructors
 */
forEachChunkWhile;

/**
 * A sink that executes the provided effectful function for every element fed
 * to it until `f` evaluates to `false`.
 *
 * @since 2.0.0
 * @category constructors
 */
forEachWhile;

/**
 * Runs this sink until it yields a result, then uses that result to create
 * another sink from the provided function which will continue to run until it
 * yields a result.
 *
 * This function essentially runs sinks in sequence.
 *
 * @since 2.0.0
 * @category sequencing
 */
flatMap$2;

/**
 * Creates a sink from a `Channel`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromChannel$1;

/**
 * Creates a `Channel` from a Sink.
 *
 * @since 2.0.0
 * @category constructors
 */
toChannel$1;

/**
 * Creates a single-value sink produced from an effect.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEffect$2;

/**
 * Create a sink which publishes each element to the specified `PubSub`.
 *
 * @param shutdown If `true`, the `PubSub` will be shutdown after the sink is evaluated (defaults to `false`)
 * @since 2.0.0
 * @category constructors
 */
fromPubSub$1;

/**
 * Creates a sink from a chunk processing function.
 *
 * @since 2.0.0
 * @category constructors
 */
fromPush;

/**
 * Create a sink which enqueues each element into the specified queue.
 *
 * @param shutdown If `true`, the queue will be shutdown after the sink is evaluated (defaults to `false`)
 * @since 2.0.0
 * @category constructors
 */
fromQueue$1;

/**
 * Creates a sink containing the first value.
 *
 * @since 2.0.0
 * @category constructors
 */
head$1;

/**
 * Drains the remaining elements from the stream after the sink finishes
 *
 * @since 2.0.0
 * @category utils
 */
ignoreLeftover;

/**
 * Creates a sink containing the last value.
 *
 * @since 2.0.0
 * @category constructors
 */
last;

/**
 * Creates a sink that does not consume any input but provides the given chunk
 * as its leftovers
 *
 * @since 2.0.0
 * @category constructors
 */
leftover;

/**
 * Transforms this sink's result.
 *
 * @since 2.0.0
 * @category mapping
 */
map$4;

/**
 * Effectfully transforms this sink's result.
 *
 * @since 2.0.0
 * @category mapping
 */
mapEffect;

/**
 * Transforms the errors emitted by this sink using `f`.
 *
 * @since 2.0.0
 * @category mapping
 */
mapError$2;

/**
 * Transforms the leftovers emitted by this sink using `f`.
 *
 * @since 2.0.0
 * @category mapping
 */
mapLeftover;

/**
 * Creates a sink which transforms it's inputs into a string.
 *
 * @since 2.0.0
 * @category constructors
 */
mkString$1;

/**
 * Creates a sink which never terminates.
 *
 * @since 2.0.0
 * @category constructors
 */
never$2;

/**
 * Switch to another sink in case of failure
 *
 * @since 2.0.0
 * @category error handling
 */
orElse$3;

/**
 * Provides the sink with its required context, which eliminates its
 * dependency on `R`.
 *
 * @since 2.0.0
 * @category context
 */
provideContext$3;

/**
 * Runs both sinks in parallel on the input, , returning the result or the
 * error from the one that finishes first.
 *
 * @since 2.0.0
 * @category utils
 */
race$1;

/**
 * Runs both sinks in parallel on the input, returning the result or the error
 * from the one that finishes first.
 *
 * @since 2.0.0
 * @category utils
 */
raceBoth;

/**
 * Runs both sinks in parallel on the input, using the specified merge
 * function as soon as one result or the other has been computed.
 *
 * @since 2.0.0
 * @category utils
 */
raceWith;

/**
 * @since 2.0.0
 * @category error handling
 */
refineOrDie$2;

/**
 * @since 2.0.0
 * @category error handling
 */
refineOrDieWith$2;

/**
 * A sink that returns whether an element satisfies the specified predicate.
 *
 * @since 2.0.0
 * @category constructors
 */
some$3;

/**
 * Splits the sink on the specified predicate, returning a new sink that
 * consumes elements until an element after the first satisfies the specified
 * predicate.
 *
 * @since 2.0.0
 * @category utils
 */
splitWhere;

/**
 * A sink that immediately ends with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
succeed$5;

/**
 * A sink that sums incoming numeric values.
 *
 * @since 2.0.0
 * @category constructors
 */
sum;

/**
 * Summarize a sink by running an effect when the sink starts and again when
 * it completes.
 *
 * @since 2.0.0
 * @category utils
 */
summarized$1;

/**
 * Returns a lazily constructed sink that may require effects for its
 * creation.
 *
 * @since 2.0.0
 * @category constructors
 */
suspend$3;

/**
 * A sink that immediately ends with the specified lazy value.
 *
 * @since 2.0.0
 * @category constructors
 */
sync$2;

/**
 * A sink that takes the specified number of values.
 *
 * @since 2.0.0
 * @category constructors
 */
take$4;

/**
 * @since 2.0.0
 * @category constructors
 */
timed;

/**
 * Creates a sink produced from an effect.
 *
 * @since 2.0.0
 * @category constructors
 */
unwrap$1;

/**
 * Creates a sink produced from a scoped effect.
 *
 * @since 2.0.0
 * @category constructors
 */
unwrapScoped$1;

/**
 * Returns the sink that executes this one and times its execution.
 *
 * @since 2.0.0
 * @category utils
 */
withDuration;

/**
 * Feeds inputs to this sink until it yields a result, then switches over to
 * the provided sink until it yields a result, finally combining the two
 * results into a tuple.
 *
 * @since 2.0.0
 * @category zipping
 */
zip$3;

/**
 * Like `Sink.zip` but keeps only the result from this sink.
 *
 * @since 2.0.0
 * @category zipping
 */
zipLeft$2;

/**
 * Like `Sink.zip` but keeps only the result from `that` sink.
 *
 * @since 2.0.0
 * @category zipping
 */
zipRight$2;

/**
 * Feeds inputs to this sink until it yields a result, then switches over to
 * the provided sink until it yields a result, finally combining the two
 * results with `f`.
 *
 * @since 2.0.0
 * @category zipping
 */
zipWith$2;

/**
 * @since 2.0.0
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/SortedMap");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

const SortedMapProto = {
  [TypeId]: TypeId,
  [symbol$1]() {
    return pipe(hash$1(this.tree), combine$a(hash$1("effect/SortedMap")));
  },
  [symbol](that) {
    return isSortedMap(that) && equals$1(this.tree, that.tree);
  },
  [Symbol.iterator]() {
    return this.tree[Symbol.iterator]();
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "SortedMap",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const makeImpl = tree => {
  const self = Object.create(SortedMapProto);
  self.tree = tree;
  return self;
};

/**
 * @since 2.0.0
 * @category refinements
 */
const isSortedMap = u => isObject(u) && TypeId in u;

/**
 * @since 2.0.0
 * @category constructors
 */
const empty$5 = ord => makeImpl(empty$d(ord));

/**
 * @since 2.0.0
 * @category predicates
 */
const isEmpty$5 = self => size$6(self) === 0;

/**
 * @since 2.0.0
 * @category predicates
 */
const isNonEmpty$1 = self => size$6(self) > 0;

/**
 * @since 2.0.0
 * @category elements
 */
const get$5 = /*#__PURE__*/dual(2, (self, key) => findFirst$2(self.tree, key));

/**
 * Gets the `Order<K>` that the `SortedMap<K, V>` is using.
 *
 * @since 2.0.0
 * @category getters
 */
const getOrder = self => getOrder$1(self.tree);

/**
 * @since 2.0.0
 * @category elements
 */
const headOption$1 = self => first$1(self.tree);

/**
 * @since 2.0.0
 * @category folding
 */
const reduce$3 = /*#__PURE__*/dual(3, (self, zero, f) => reduce$7(self.tree, zero, f));

/**
 * @since 2.0.0
 * @category elements
 */
const remove$2 = /*#__PURE__*/dual(2, (self, key) => makeImpl(removeFirst(self.tree, key)));

/**
 * @since 2.0.0
 * @category elements
 */
const set$3 = /*#__PURE__*/dual(3, (self, key, value) => has$2(self.tree, key) ? makeImpl(insert(removeFirst(self.tree, key), key, value)) : makeImpl(insert(self.tree, key, value)));

/**
 * @since 2.0.0
 * @category getters
 */
const size$6 = self => size$c(self.tree);

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const SynchronizedRefTypeId = SynchronizedTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
makeSynchronized;

/**
 * @since 2.0.0
 * @category getters
 */
get$c;

/**
 * @since 2.0.0
 * @category utils
 */
getAndSet$2;

/**
 * @since 2.0.0
 * @category utils
 */
getAndUpdate$1;

/**
 * @since 2.0.0
 * @category utils
 */
getAndUpdateEffect;

/**
 * @since 2.0.0
 * @category utils
 */
getAndUpdateSome$1;

/**
 * @since 2.0.0
 * @category utils
 */
getAndUpdateSomeEffect;

/**
 * @since 2.0.0
 * @category utils
 */
modify$2;

/**
 * @since 2.0.0
 * @category utils
 */
modifyEffect$1;

/**
 * @since 2.0.0
 * @category utils
 */
modifySome$1;

/**
 * @since 2.0.0
 * @category utils
 */
modifySomeEffect;

/**
 * @since 2.0.0
 * @category utils
 */
set$7;

/**
 * @since 2.0.0
 * @category utils
 */
setAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
update$5;

/**
 * @since 2.0.0
 * @category utils
 */
updateEffect;

/**
 * @since 2.0.0
 * @category utils
 */
updateAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
updateAndGetEffect;

/**
 * @since 2.0.0
 * @category utils
 */
updateSome$1;

/**
 * @since 2.0.0
 * @category utils
 */
updateSomeEffect;

/**
 * @since 2.0.0
 * @category utils
 */
updateSomeAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
updateSomeAndGetEffectSynchronized;

/**
 * @since 2.0.0
 * @category unsafe
 */
unsafeMakeSynchronized;

/** @internal */
const SubscriptionRefSymbolKey = "effect/SubscriptionRef";

/** @internal */
const SubscriptionRefTypeId = /*#__PURE__*/Symbol.for(SubscriptionRefSymbolKey);

/** @internal */
const subscriptionRefVariance = {
  _A: _ => _
};

/** @internal */
class SubscriptionRefImpl {
  // @ts-ignore
  [RefTypeId] = refVariance;
  // @ts-ignore
  [SynchronizedRefTypeId] = synchronizedVariance;
  [SubscriptionRefTypeId] = subscriptionRefVariance;
  constructor(ref, pubsub, semaphore) {
    this.ref = ref;
    this.pubsub = pubsub;
    this.semaphore = semaphore;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  get changes() {
    return pipe(get$b(this.ref), flatMap$4(a => map$6(fromPubSub(this.pubsub, {
      scoped: true
    }), s => concat(make$o(a), s))), this.semaphore.withPermits(1), unwrapScoped);
  }
  modify(f) {
    return this.modifyEffect(a => succeed$7(f(a)));
  }
  modifyEffect(f) {
    return pipe(get$b(this.ref), flatMap$4(f), flatMap$4(([b, a]) => pipe(set$6(this.ref, a), as$4(b), zipLeft$4(publish$1(this.pubsub, a)))), this.semaphore.withPermits(1));
  }
}

/** @internal */
const get$4 = self => get$b(self.ref);

/** @internal */
const make$e = value => pipe(all$1([unbounded$3(), make$G(value), makeSemaphore(1)]), map$6(([pubsub, ref, semaphore]) => new SubscriptionRefImpl(ref, pubsub, semaphore)));

/** @internal */
const modify$1 = /*#__PURE__*/dual(2, (self, f) => self.modify(f));

/** @internal */
const modifyEffect = /*#__PURE__*/dual(2, (self, f) => self.modifyEffect(f));

/** @internal */
const set$2 = /*#__PURE__*/dual(2, (self, value) => pipe(set$6(self.ref, value), zipLeft$4(publish$1(self.pubsub, value)), self.semaphore.withPermits(1)));

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
SubscriptionRefTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `SubscriptionRef<A>` is a `Ref` that can be subscribed to in order to
 * receive the current value as well as all changes to the value.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category getters
 */
get$4;

/**
 * Creates a new `SubscriptionRef` with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
make$e;

/**
 * @since 2.0.0
 * @category utils
 */
modify$1;

/**
 * @since 2.0.0
 * @category utils
 */
modifyEffect;

/**
 * @since 2.0.0
 * @category utils
 */
set$2;

/**
 * A `Supervisor<T>` is allowed to supervise the launching and termination of
 * fibers, producing some visible value of type `T` from the supervision.
 *
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
SupervisorTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category context
 */
addSupervisor;

/**
 * Creates a new supervisor that tracks children in a set.
 *
 * @since 2.0.0
 * @category constructors
 */
fibersIn;

/**
 * Creates a new supervisor that constantly yields effect when polled
 *
 * @since 2.0.0
 * @category constructors
 */
fromEffect$5;

/**
 * A supervisor that doesn't do anything in response to supervision events.
 *
 * @since 2.0.0
 * @category constructors
 */
none$2;

/**
 * Creates a new supervisor that tracks children in a set.
 *
 * @since 2.0.0
 * @category constructors
 */
track;

/**
 * Unsafely creates a new supervisor that tracks children in a set.
 *
 * @since 2.0.0
 * @category unsafe
 */
unsafeTrack;

/** @internal */
const TRefSymbolKey = "effect/TRef";

/** @internal */
const TRefTypeId = /*#__PURE__*/Symbol.for(TRefSymbolKey);

/** @internal */
const tRefVariance = {
  _A: _ => _
};

/** @internal */
class TRefImpl {
  [TRefTypeId] = tRefVariance;
  /** @internal */

  /** @internal */

  constructor(value) {
    this.versioned = new Versioned(value);
    this.todos = new Map();
  }
  modify(f) {
    return effect(journal => {
      const entry = getOrMakeEntry(this, journal);
      const [retValue, newValue] = f(unsafeGet$1(entry));
      unsafeSet$1(entry, newValue);
      return retValue;
    });
  }
}

/** @internal */
const make$d = value => effect(journal => {
  const ref = new TRefImpl(value);
  journal.set(ref, make$h(ref, true));
  return ref;
});

/** @internal */
const get$3 = self => self.modify(a => [a, a]);

/** @internal */
const set$1 = /*#__PURE__*/dual(2, (self, value) => self.modify(() => [void 0, value]));

/** @internal */
const getAndSet = /*#__PURE__*/dual(2, (self, value) => self.modify(a => [a, value]));

/** @internal */
const getAndUpdate = /*#__PURE__*/dual(2, (self, f) => self.modify(a => [a, f(a)]));

/** @internal */
const getAndUpdateSome = /*#__PURE__*/dual(2, (self, f) => self.modify(a => match$j(f(a), {
  onNone: () => [a, a],
  onSome: b => [a, b]
})));

/** @internal */
const setAndGet = /*#__PURE__*/dual(2, (self, value) => self.modify(() => [value, value]));

/** @internal */
const modify = /*#__PURE__*/dual(2, (self, f) => self.modify(f));

/** @internal */
const modifySome = /*#__PURE__*/dual(3, (self, fallback, f) => self.modify(a => match$j(f(a), {
  onNone: () => [fallback, a],
  onSome: b => b
})));

/** @internal */
const update$2 = /*#__PURE__*/dual(2, (self, f) => self.modify(a => [void 0, f(a)]));

/** @internal */
const updateAndGet = /*#__PURE__*/dual(2, (self, f) => self.modify(a => {
  const b = f(a);
  return [b, b];
}));

/** @internal */
const updateSome = /*#__PURE__*/dual(2, (self, f) => self.modify(a => [void 0, match$j(f(a), {
  onNone: () => a,
  onSome: b => b
})]));

/** @internal */
const updateSomeAndGet = /*#__PURE__*/dual(2, (self, f) => self.modify(a => match$j(f(a), {
  onNone: () => [a, a],
  onSome: b => [b, b]
})));

/** @internal */
const getOrMakeEntry = (self, journal) => {
  if (journal.has(self)) {
    return journal.get(self);
  }
  const entry = make$h(self, false);
  journal.set(self, entry);
  return entry;
};

/** @internal */
const unsafeGet = /*#__PURE__*/dual(2, (self, journal) => unsafeGet$1(getOrMakeEntry(self, journal)));

/** @internal */
const unsafeSet = /*#__PURE__*/dual(3, (self, value, journal) => {
  const entry = getOrMakeEntry(self, journal);
  unsafeSet$1(entry, value);
  return undefined;
});

/** @internal */
const TArraySymbolKey = "effect/TArray";

/** @internal */
const TArrayTypeId = /*#__PURE__*/Symbol.for(TArraySymbolKey);

/** @internal */
const tArrayVariance = {
  _A: _ => _
};

/** @internal */
class TArrayImpl {
  [TArrayTypeId] = tArrayVariance;
  constructor(chunk) {
    this.chunk = chunk;
  }
}

/** @internal */
const collectFirst = /*#__PURE__*/dual(2, (self, pf) => collectFirstSTM(self, a => pipe(pf(a), map$n(succeed$2))));

/** @internal */
const collectFirstSTM = /*#__PURE__*/dual(2, (self, pf) => withSTMRuntime(runtime => {
  let index = 0;
  let result = none$8();
  while (isNone$1(result) && index < self.chunk.length) {
    const element = pipe(self.chunk[index], unsafeGet(runtime.journal));
    const option = pf(element);
    if (isSome(option)) {
      result = option;
    }
    index = index + 1;
  }
  return pipe(result, match$j({
    onNone: () => succeedNone,
    onSome: map$1(some$6)
  }));
}));

/** @internal */
const contains = /*#__PURE__*/dual(2, (self, value) => some(self, a => equals$1(a)(value)));

/** @internal */
const count = /*#__PURE__*/dual(2, (self, predicate) => reduce$2(self, 0, (n, a) => predicate(a) ? n + 1 : n));

/** @internal */
const countSTM = /*#__PURE__*/dual(2, (self, predicate) => reduceSTM$2(self, 0, (n, a) => map$1(predicate(a), bool => bool ? n + 1 : n)));

/** @internal */
const empty$4 = () => fromIterable$3([]);

/** @internal */
const every = /*#__PURE__*/dual(2, (self, predicate) => negate(some(self, a => !predicate(a))));

/** @internal */
const everySTM = /*#__PURE__*/dual(2, (self, predicate) => map$1(countSTM(self, predicate), count => count === self.chunk.length));

/** @internal */
const findFirst = /*#__PURE__*/dual(2, (self, predicate) => collectFirst(self, a => predicate(a) ? some$6(a) : none$8()));

/** @internal */
const findFirstIndex = /*#__PURE__*/dual(2, (self, value) => findFirstIndexFrom(self, value, 0));

/** @internal */
const findFirstIndexFrom = /*#__PURE__*/dual(3, (self, value, from) => findFirstIndexWhereFrom(self, a => equals$1(a)(value), from));

/** @internal */
const findFirstIndexWhere = /*#__PURE__*/dual(2, (self, predicate) => findFirstIndexWhereFrom(self, predicate, 0));

/** @internal */
const findFirstIndexWhereFrom = /*#__PURE__*/dual(3, (self, predicate, from) => {
  if (from < 0) {
    return succeedNone;
  }
  return effect(journal => {
    let index = from;
    let found = false;
    while (!found && index < self.chunk.length) {
      const element = unsafeGet(self.chunk[index], journal);
      found = predicate(element);
      index = index + 1;
    }
    if (found) {
      return some$6(index - 1);
    }
    return none$8();
  });
});

/** @internal */
const findFirstIndexWhereSTM = /*#__PURE__*/dual(2, (self, predicate) => findFirstIndexWhereFromSTM(self, predicate, 0));

/** @internal */
const findFirstIndexWhereFromSTM = /*#__PURE__*/dual(3, (self, predicate, from) => {
  const forIndex = index => index < self.chunk.length ? pipe(get$3(self.chunk[index]), flatMap(predicate), flatMap(bool => bool ? succeed$2(some$6(index)) : forIndex(index + 1))) : succeedNone;
  return from < 0 ? succeedNone : forIndex(from);
});

/** @internal */
const findFirstSTM = /*#__PURE__*/dual(2, (self, predicate) => {
  const init = [none$8(), 0];
  const cont = state => isNone$1(state[0]) && state[1] < self.chunk.length - 1;
  return map$1(iterate(init, {
    while: cont,
    body: state => {
      const index = state[1];
      return pipe(get$3(self.chunk[index]), flatMap(value => map$1(predicate(value), bool => [bool ? some$6(value) : none$8(), index + 1])));
    }
  }), state => state[0]);
});

/** @internal */
const findLast = /*#__PURE__*/dual(2, (self, predicate) => effect(journal => {
  let index = self.chunk.length - 1;
  let result = none$8();
  while (isNone$1(result) && index >= 0) {
    const element = unsafeGet(self.chunk[index], journal);
    if (predicate(element)) {
      result = some$6(element);
    }
    index = index - 1;
  }
  return result;
}));

/** @internal */
const findLastIndex = /*#__PURE__*/dual(2, (self, value) => findLastIndexFrom(self, value, self.chunk.length - 1));

/** @internal */
const findLastIndexFrom = /*#__PURE__*/dual(3, (self, value, end) => {
  if (end >= self.chunk.length) {
    return succeedNone;
  }
  return effect(journal => {
    let index = end;
    let found = false;
    while (!found && index >= 0) {
      const element = unsafeGet(self.chunk[index], journal);
      found = equals$1(element)(value);
      index = index - 1;
    }
    if (found) {
      return some$6(index + 1);
    }
    return none$8();
  });
});

/** @internal */
const findLastSTM = /*#__PURE__*/dual(2, (self, predicate) => {
  const init = [none$8(), self.chunk.length - 1];
  const cont = state => isNone$1(state[0]) && state[1] >= 0;
  return map$1(iterate(init, {
    while: cont,
    body: state => {
      const index = state[1];
      return pipe(get$3(self.chunk[index]), flatMap(value => map$1(predicate(value), bool => [bool ? some$6(value) : none$8(), index - 1])));
    }
  }), state => state[0]);
});

/** @internal */
const forEach$2 = /*#__PURE__*/dual(2, (self, f) => reduceSTM$2(self, void 0, (_, a) => f(a)));

/** @internal */
const fromIterable$3 = iterable => map$1(forEach$3(iterable, make$d), chunk => new TArrayImpl(chunk));

/** @internal */
const get$2 = /*#__PURE__*/dual(2, (self, index) => {
  if (index < 0 || index >= self.chunk.length) {
    return dieMessage("Index out of bounds");
  }
  return get$3(self.chunk[index]);
});

/** @internal */
const headOption = self => self.chunk.length === 0 ? succeed$2(none$8()) : map$1(get$3(self.chunk[0]), some$6);

/** @internal */
const lastOption = self => self.chunk.length === 0 ? succeedNone : map$1(get$3(self.chunk[self.chunk.length - 1]), some$6);

/** @internal */
const make$c = (...elements) => fromIterable$3(elements);

/** @internal */
const maxOption = /*#__PURE__*/dual(2, (self, order) => {
  const greaterThan$1 = greaterThan$3(order);
  return reduceOption(self, (acc, curr) => greaterThan$1(acc)(curr) ? curr : acc);
});

/** @internal */
const minOption = /*#__PURE__*/dual(2, (self, order) => {
  const lessThan$1 = lessThan$6(order);
  return reduceOption(self, (acc, curr) => lessThan$1(acc)(curr) ? curr : acc);
});

/** @internal */
const reduce$2 = /*#__PURE__*/dual(3, (self, zero, f) => effect(journal => {
  let index = 0;
  let result = zero;
  while (index < self.chunk.length) {
    const element = unsafeGet(self.chunk[index], journal);
    result = f(result, element);
    index = index + 1;
  }
  return result;
}));

/** @internal */
const reduceOption = /*#__PURE__*/dual(2, (self, f) => effect(journal => {
  let index = 0;
  let result = undefined;
  while (index < self.chunk.length) {
    const element = unsafeGet(self.chunk[index], journal);
    result = result === undefined ? element : f(result, element);
    index = index + 1;
  }
  return fromNullable$2(result);
}));

/** @internal */
const reduceOptionSTM = /*#__PURE__*/dual(2, (self, f) => reduceSTM$2(self, none$8(), (acc, curr) => isSome(acc) ? map$1(f(acc.value, curr), some$6) : succeedSome(curr)));

/** @internal */
const reduceSTM$2 = /*#__PURE__*/dual(3, (self, zero, f) => flatMap(toArray$1(self), reduce$4(zero, f)));

/** @internal */
const size$5 = self => self.chunk.length;

/** @internal */
const some = /*#__PURE__*/dual(2, (self, predicate) => map$1(findFirst(self, predicate), isSome));

/** @internal */
const someSTM = /*#__PURE__*/dual(2, (self, predicate) => map$1(countSTM(self, predicate), n => n > 0));

/** @internal */
const toArray$1 = self => forEach$3(self.chunk, get$3);

/** @internal */
const transform$2 = /*#__PURE__*/dual(2, (self, f) => effect(journal => {
  let index = 0;
  while (index < self.chunk.length) {
    const ref = self.chunk[index];
    unsafeSet(ref, f(unsafeGet(ref, journal)), journal);
    index = index + 1;
  }
  return void 0;
}));

/** @internal */
const transformSTM$2 = /*#__PURE__*/dual(2, (self, f) => flatMap(forEach$3(self.chunk, ref => flatMap(get$3(ref), f)), chunk => effect(journal => {
  const iterator = chunk[Symbol.iterator]();
  let index = 0;
  let next;
  while ((next = iterator.next()) && !next.done) {
    unsafeSet(self.chunk[index], next.value, journal);
    index = index + 1;
  }
  return void 0;
})));

/** @internal */
const update$1 = /*#__PURE__*/dual(3, (self, index, f) => {
  if (index < 0 || index >= self.chunk.length) {
    return dieMessage("Index out of bounds");
  }
  return update$2(self.chunk[index], f);
});

/** @internal */
const updateSTM = /*#__PURE__*/dual(3, (self, index, f) => {
  if (index < 0 || index >= self.chunk.length) {
    return dieMessage("Index out of bounds");
  }
  return pipe(get$3(self.chunk[index]), flatMap(f), flatMap(updated => set$1(self.chunk[index], updated)));
});

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TArrayTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Finds the result of applying a partial function to the first value in its
 * domain.
 *
 * @since 2.0.0
 * @category elements
 */
collectFirst;

/**
 * Finds the result of applying an transactional partial function to the first
 * value in its domain.
 *
 * @since 2.0.0
 * @category elements
 */
collectFirstSTM;

/**
 * Determine if the array contains a specified value.
 *
 * @macro trace
 * @since 2.0.0
 * @category elements
 */
contains;

/**
 * Count the values in the array matching a predicate.
 *
 * @macro trace
 * @since 2.0.0
 * @category folding
 */
count;

/**
 * Count the values in the array matching a transactional predicate.
 *
 * @macro trace
 * @since 2.0.0
 * @category folding
 */
countSTM;

/**
 * Makes an empty `TArray`.
 *
 * @since 2.0.0
 * @category constructors
 */
empty$4;

/**
 * Atomically evaluate the conjunction of a predicate across the members of
 * the array.
 *
 * @since 2.0.0
 * @category elements
 */
every;

/**
 * Atomically evaluate the conjunction of a transactional predicate across the
 * members of the array.
 *
 * @since 2.0.0
 * @category elements
 */
everySTM;

/**
 * Find the first element in the array matching the specified predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findFirst;

/**
 * Get the first index of a specific value in the array.
 *
 * @since 2.0.0
 * @category elements
 */
findFirstIndex;

/**
 * Get the first index of a specific value in the array starting from the
 * specified index.
 *
 * @since 2.0.0
 * @category elements
 */
findFirstIndexFrom;

/**
 * Get the index of the first entry in the array matching a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findFirstIndexWhere;

/**
 * Get the index of the first entry in the array starting from the specified
 * index, matching a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findFirstIndexWhereFrom;

/**
 * Get the index of the next entry that matches a transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findFirstIndexWhereSTM;

/**
 * Starting at specified index, get the index of the next entry that matches a
 * transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findFirstIndexWhereFromSTM;

/**
 * Find the first element in the array matching a transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findFirstSTM;

/**
 * Find the last element in the array matching a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findLast;

/**
 * Get the last index of a specific value in the array bounded above by a
 * specific index.
 *
 * @since 2.0.0
 * @category elements
 */
findLastIndex;

/**
 * Get the last index of a specific value in the array bounded above by a
 * specific index.
 *
 * @since 2.0.0
 * @category elements
 */
findLastIndexFrom;

/**
 * Find the last element in the array matching a transactional predicate.
 *
 * @since 2.0.0
 * @category elements
 */
findLastSTM;

/**
 * Atomically performs transactional effect for each item in array.
 *
 * @since 2.0.0
 * @category elements
 */
forEach$2;

/**
 * Makes a new `TArray` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterable$3;

/**
 * Extracts value from ref in array.
 *
 * @since 2.0.0
 * @category elements
 */
get$2;

/**
 * The first entry of the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
headOption;

/**
 * The last entry in the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
lastOption;

/**
 * Makes a new `TArray` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
make$c;

/**
 * Atomically compute the greatest element in the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
maxOption;

/**
 * Atomically compute the least element in the array, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
minOption;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
reduce$2;

/**
 * Atomically reduce the array, if non-empty, by a binary operator.
 *
 * @since 2.0.0
 * @category elements
 */
reduceOption;

/**
 * Atomically reduce the non-empty array using a transactional binary
 * operator.
 *
 * @since 2.0.0
 * @category elements
 */
reduceOptionSTM;

/**
 * Atomically folds using a transactional function.
 *
 * @macro trace
 * @since 2.0.0
 * @category folding
 */
reduceSTM$2;

/**
 * Returns the size of the `TArray`.
 *
 * @since 2.0.0
 * @category getters
 */
size$5;

/**
 * Determine if the array contains a value satisfying a predicate.
 *
 * @since 2.0.0
 * @category elements
 */
some;

/**
 * Determine if the array contains a value satisfying a transactional
 * predicate.
 *
 * @since 2.0.0
 * @category elements
 */
someSTM;

/**
 * Collects all elements into a chunk.
 *
 * @since 2.0.0
 * @since 2.0.0
 * @category destructors
 */
toArray$1;

/**
 * Atomically updates all elements using a pure function.
 *
 * @since 2.0.0
 * @category elements
 */
transform$2;

/**
 * Atomically updates all elements using a transactional effect.
 *
 * @since 2.0.0
 * @category elements
 */
transformSTM$2;

/**
 * Updates element in the array with given function.
 *
 * @since 2.0.0
 * @category elements
 */
update$1;

/**
 * Atomically updates element in the array with given transactional effect.
 *
 * @since 2.0.0
 * @category elements
 */
updateSTM;

/** @internal */
const TDeferredSymbolKey = "effect/TDeferred";

/** @internal */
const TDeferredTypeId = /*#__PURE__*/Symbol.for(TDeferredSymbolKey);

/** @internal */
const tDeferredVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */
class TDeferredImpl {
  [TDeferredTypeId] = tDeferredVariance;
  constructor(ref) {
    this.ref = ref;
  }
}

/** @internal */
const _await = self => flatten(collect(get$3(self.ref), option => isSome(option) ? some$6(fromEither(option.value)) : none$8()));

/** @internal */
const done$2 = /*#__PURE__*/dual(2, (self, either) => flatMap(get$3(self.ref), match$j({
  onNone: () => zipRight(set$1(self.ref, some$6(either)), succeed$2(true)),
  onSome: () => succeed$2(false)
})));

/** @internal */
const fail = /*#__PURE__*/dual(2, (self, error) => done$2(self, left(error)));

/** @internal */
const make$b = () => map$1(make$d(none$8()), ref => new TDeferredImpl(ref));

/** @internal */
const poll$1 = self => get$3(self.ref);

/** @internal */
const succeed = /*#__PURE__*/dual(2, (self, value) => done$2(self, right(value)));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TDeferredTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

_await;

/**
 * @since 2.0.0
 * @category mutations
 */
done$2;

/**
 * @since 2.0.0
 * @category mutations
 */
fail;

/**
 * @since 2.0.0
 * @category constructors
 */
make$b;

/**
 * @since 2.0.0
 * @category getters
 */
poll$1;

/**
 * @since 2.0.0
 * @category mutations
 */
succeed;

/** @internal */
const TMapSymbolKey = "effect/TMap";

/** @internal */
const TMapTypeId = /*#__PURE__*/Symbol.for(TMapSymbolKey);

/** @internal */
const tMapVariance = {
  _K: _ => _,
  _V: _ => _
};

/** @internal */
class TMapImpl {
  [TMapTypeId] = tMapVariance;
  constructor(tBuckets, tSize) {
    this.tBuckets = tBuckets;
    this.tSize = tSize;
  }
}

/** @internal */
const InitialCapacity = 16;
const LoadFactor = 0.75;

/** @internal */
const nextPowerOfTwo = size => {
  const n = -1 >>> Math.clz32(size - 1);
  return n < 0 ? 1 : n + 1;
};

/** @internal */
const hash = key => {
  const h = hash$1(key);
  return h ^ h >>> 16;
};

/** @internal */
const indexOf = (k, capacity) => hash(k) & capacity - 1;

/** @internal */
const allocate = (capacity, data) => {
  const buckets = Array.from({
    length: capacity
  }, () => empty$z());
  const distinct = new Map(data);
  let size = 0;
  for (const entry of distinct) {
    const index = indexOf(entry[0], capacity);
    buckets[index] = pipe(buckets[index], prepend$2(entry));
    size = size + 1;
  }
  return pipe(fromIterable$3(buckets), flatMap(buckets => pipe(make$d(buckets), flatMap(tBuckets => pipe(make$d(size), map$1(tSize => new TMapImpl(tBuckets, tSize)))))));
};

/** @internal */
const empty$3 = () => fromIterable$2([]);

/** @internal */
const find = /*#__PURE__*/dual(2, (self, pf) => findSTM(self, (key, value) => {
  const option = pf(key, value);
  if (isSome(option)) {
    return succeed$2(option.value);
  }
  return fail$1(none$8());
}));

/** @internal */
const findSTM = /*#__PURE__*/dual(2, (self, f) => reduceWithIndexSTM(self, none$8(), (acc, value, key) => isNone$1(acc) ? matchSTM(f(key, value), {
  onFailure: match$j({
    onNone: () => succeedNone,
    onSome: fail$1
  }),
  onSuccess: succeedSome
}) : succeed$1(acc)));

/** @internal */
const findAll = /*#__PURE__*/dual(2, (self, pf) => findAllSTM(self, (key, value) => {
  const option = pf(key, value);
  if (isSome(option)) {
    return succeed$2(option.value);
  }
  return fail$1(none$8());
}));

/** @internal */
const findAllSTM = /*#__PURE__*/dual(2, (self, pf) => map$1(reduceWithIndexSTM(self, empty$z(), (acc, value, key) => matchSTM(pf(key, value), {
  onFailure: match$j({
    onNone: () => succeed$2(acc),
    onSome: fail$1
  }),
  onSuccess: a => succeed$2(append$1(acc, a))
})), a => Array.from(a)));

/** @internal */
const forEach$1 = /*#__PURE__*/dual(2, (self, f) => reduceWithIndexSTM(self, void 0, (_, value, key) => asUnit(f(key, value))));

/** @internal */
const fromIterable$2 = iterable => suspend(() => {
  const data = fromIterable$b(iterable);
  const capacity = data.length < InitialCapacity ? InitialCapacity : nextPowerOfTwo(data.length);
  return allocate(capacity, data);
});

/** @internal */
const get$1 = /*#__PURE__*/dual(2, (self, key) => effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const index = indexOf(key, buckets.chunk.length);
  const bucket = unsafeGet(buckets.chunk[index], journal);
  return pipe(findFirst$6(bucket, entry => equals$1(entry[0])(key)), map$n(entry => entry[1]));
}));

/** @internal */
const getOrElse = /*#__PURE__*/dual(3, (self, key, fallback) => map$1(get$1(self, key), getOrElse$3(fallback)));

/** @internal */
const has$1 = /*#__PURE__*/dual(2, (self, key) => map$1(get$1(self, key), isSome));

/** @internal */
const isEmpty$4 = self => map$1(get$3(self.tSize), size => size === 0);

/** @internal */
const keys = self => map$1(toArray(self), map$m(entry => entry[0]));

/** @internal */
const make$a = (...entries) => fromIterable$2(entries);

/** @internal */
const merge = /*#__PURE__*/dual(4, (self, key, value, f) => flatMap(get$1(self, key), match$j({
  onNone: () => as(set(self, key, value), value),
  onSome: v0 => {
    const v1 = f(v0, value);
    return as(set(self, key, v1), v1);
  }
})));

/** @internal */
const reduce$1 = /*#__PURE__*/dual(3, (self, zero, f) => reduceWithIndex(self, zero, (acc, value) => f(acc, value)));

/** @internal */
const reduceSTM$1 = /*#__PURE__*/dual(3, (self, zero, f) => reduceWithIndexSTM(self, zero, (acc, value) => f(acc, value)));

/** @internal */
const reduceWithIndex = /*#__PURE__*/dual(3, (self, zero, f) => effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  let result = zero;
  let index = 0;
  while (index < buckets.chunk.length) {
    const bucket = buckets.chunk[index];
    const items = unsafeGet(bucket, journal);
    result = reduce$h(items, result, (acc, entry) => f(acc, entry[1], entry[0]));
    index = index + 1;
  }
  return result;
}));

/** @internal */
const reduceWithIndexSTM = /*#__PURE__*/dual(3, (self, zero, f) => flatMap(toArray(self), reduce$4(zero, (acc, entry) => f(acc, entry[1], entry[0]))));

/** @internal */
const remove$1 = /*#__PURE__*/dual(2, (self, key) => effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const index = indexOf(key, buckets.chunk.length);
  const bucket = unsafeGet(buckets.chunk[index], journal);
  const [toRemove, toRetain] = partition$5(bucket, entry => equals$1(entry[1], key));
  if (isNonEmpty$5(toRemove)) {
    const currentSize = unsafeGet(self.tSize, journal);
    unsafeSet(buckets.chunk[index], toRetain, journal);
    unsafeSet(self.tSize, currentSize - 1, journal);
  }
}));

/** @internal */
const removeAll$1 = /*#__PURE__*/dual(2, (self, keys) => effect(journal => {
  const iterator = keys[Symbol.iterator]();
  let next;
  while ((next = iterator.next()) && !next.done) {
    const buckets = unsafeGet(self.tBuckets, journal);
    const index = indexOf(next.value, buckets.chunk.length);
    const bucket = unsafeGet(buckets.chunk[index], journal);
    const [toRemove, toRetain] = partition$5(bucket, entry => equals$1(next.value)(entry[0]));
    if (isNonEmpty$5(toRemove)) {
      const currentSize = unsafeGet(self.tSize, journal);
      unsafeSet(buckets.chunk[index], toRetain, journal);
      unsafeSet(self.tSize, currentSize - 1, journal);
    }
  }
}));

/** @internal */
const removeIf$2 = /*#__PURE__*/dual(2, (self, predicate) => effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const capacity = buckets.chunk.length;
  const removed = [];
  let index = 0;
  let newSize = 0;
  while (index < capacity) {
    const bucket = unsafeGet(buckets.chunk[index], journal);
    const iterator = bucket[Symbol.iterator]();
    let next;
    let newBucket = empty$z();
    while ((next = iterator.next()) && !next.done) {
      if (!predicate(next.value[0], next.value[1])) {
        newBucket = prepend$2(newBucket, next.value);
        newSize = newSize + 1;
      } else {
        removed.push(next.value);
      }
    }
    unsafeSet(buckets.chunk[index], newBucket, journal);
    index = index + 1;
  }
  unsafeSet(self.tSize, newSize, journal);
  return removed;
}));

/** @internal */
const removeIfDiscard$1 = /*#__PURE__*/dual(2, (self, predicate) => effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const capacity = buckets.chunk.length;
  let index = 0;
  let newSize = 0;
  while (index < capacity) {
    const bucket = unsafeGet(buckets.chunk[index], journal);
    const iterator = bucket[Symbol.iterator]();
    let next;
    let newBucket = empty$z();
    while ((next = iterator.next()) && !next.done) {
      if (!predicate(next.value[0], next.value[1])) {
        newBucket = prepend$2(newBucket, next.value);
        newSize = newSize + 1;
      }
    }
    unsafeSet(buckets.chunk[index], newBucket, journal);
    index = index + 1;
  }
  unsafeSet(self.tSize, newSize, journal);
}));

/** @internal */
const retainIf$2 = /*#__PURE__*/dual(2, (self, predicate) => removeIf$2(self, (key, value) => !predicate(key, value)));

/** @internal */
const retainIfDiscard$1 = /*#__PURE__*/dual(2, (self, predicate) => removeIfDiscard$1(self, (key, value) => !predicate(key, value)));

/** @internal */
const set = /*#__PURE__*/dual(3, (self, key, value) => {
  const resize = (journal, buckets) => {
    const capacity = buckets.chunk.length;
    const newCapacity = capacity << 1;
    const newBuckets = Array.from({
      length: newCapacity
    }, () => empty$z());
    let index = 0;
    while (index < capacity) {
      const pairs = unsafeGet(buckets.chunk[index], journal);
      const iterator = pairs[Symbol.iterator]();
      let next;
      while ((next = iterator.next()) && !next.done) {
        const newIndex = indexOf(next.value[0], newCapacity);
        newBuckets[newIndex] = prepend$2(newBuckets[newIndex], next.value);
      }
      index = index + 1;
    }
    // insert new pair
    const newIndex = indexOf(key, newCapacity);
    newBuckets[newIndex] = prepend$2(newBuckets[newIndex], [key, value]);
    const newArray = [];
    index = 0;
    while (index < newCapacity) {
      newArray[index] = new TRefImpl(newBuckets[index]);
      index = index + 1;
    }
    const newTArray = new TArrayImpl(newArray);
    unsafeSet(self.tBuckets, newTArray, journal);
  };
  return effect(journal => {
    const buckets = unsafeGet(self.tBuckets, journal);
    const capacity = buckets.chunk.length;
    const index = indexOf(key, capacity);
    const bucket = unsafeGet(buckets.chunk[index], journal);
    const shouldUpdate = some$5(bucket, entry => equals$1(key)(entry[0]));
    if (shouldUpdate) {
      const newBucket = map$l(bucket, entry => equals$1(key)(entry[0]) ? [key, value] : entry);
      unsafeSet(buckets.chunk[index], newBucket, journal);
    } else {
      const newSize = unsafeGet(self.tSize, journal) + 1;
      unsafeSet(self.tSize, newSize, journal);
      if (capacity * LoadFactor < newSize) {
        resize(journal, buckets);
      } else {
        const newBucket = prepend$2(bucket, [key, value]);
        unsafeSet(buckets.chunk[index], newBucket, journal);
      }
    }
  });
});

/** @internal */
const setIfAbsent = /*#__PURE__*/dual(3, (self, key, value) => flatMap(get$1(self, key), match$j({
  onNone: () => set(self, key, value),
  onSome: () => unit
})));

/** @internal */
const size$4 = self => get$3(self.tSize);

/** @internal */
const takeFirst$1 = /*#__PURE__*/dual(2, (self, pf) => pipe(effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const capacity = buckets.chunk.length;
  const size = unsafeGet(self.tSize, journal);
  let result = none$8();
  let index = 0;
  while (index < capacity && isNone$1(result)) {
    const bucket = unsafeGet(buckets.chunk[index], journal);
    const recreate = some$5(bucket, entry => isSome(pf(entry[0], entry[1])));
    if (recreate) {
      const iterator = bucket[Symbol.iterator]();
      let newBucket = empty$z();
      let next;
      while ((next = iterator.next()) && !next.done && isNone$1(result)) {
        const option = pf(next.value[0], next.value[1]);
        if (isSome(option) && isNone$1(result)) {
          result = option;
        } else {
          newBucket = prepend$2(newBucket, next.value);
        }
      }
      unsafeSet(buckets.chunk[index], newBucket, journal);
    }
    index = index + 1;
  }
  if (isSome(result)) {
    unsafeSet(self.tSize, size - 1, journal);
  }
  return result;
}), collect(option => isSome(option) ? some$6(option.value) : none$8())));

/** @internal */
const takeFirstSTM$1 = /*#__PURE__*/dual(2, (self, pf) => pipe(findSTM(self, (key, value) => map$1(pf(key, value), a => [key, a])), collect(option => isSome(option) ? some$6(option.value) : none$8()), flatMap(entry => as(remove$1(self, entry[0]), entry[1]))));

/** @internal */
const takeSome$1 = /*#__PURE__*/dual(2, (self, pf) => pipe(effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const capacity = buckets.chunk.length;
  const builder = [];
  let newSize = 0;
  let index = 0;
  while (index < capacity) {
    const bucket = unsafeGet(buckets.chunk[index], journal);
    const recreate = some$5(bucket, entry => isSome(pf(entry[0], entry[1])));
    if (recreate) {
      const iterator = bucket[Symbol.iterator]();
      let newBucket = empty$z();
      let next;
      while ((next = iterator.next()) && !next.done) {
        const option = pf(next.value[0], next.value[1]);
        if (isSome(option)) {
          builder.push(option.value);
        } else {
          newBucket = prepend$2(newBucket, next.value);
          newSize = newSize + 1;
        }
      }
      unsafeSet(buckets.chunk[index], newBucket, journal);
    } else {
      newSize = newSize + bucket.length;
    }
    index = index + 1;
  }
  unsafeSet(self.tSize, newSize, journal);
  if (builder.length > 0) {
    return some$6(builder);
  }
  return none$8();
}), collect(option => isSome(option) ? some$6(option.value) : none$8())));

/** @internal */
const takeSomeSTM$1 = /*#__PURE__*/dual(2, (self, pf) => pipe(findAllSTM(self, (key, value) => map$1(pf(key, value), a => [key, a])), map$1(chunk => isNonEmptyArray(chunk) ? some$6(chunk) : none$8()), collect(option => isSome(option) ? some$6(option.value) : none$8()), flatMap(entries => as(removeAll$1(self, entries.map(entry => entry[0])), map$m(entries, entry => entry[1])))));

/** @internal */
const toArray = self => effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const capacity = buckets.chunk.length;
  const builder = [];
  let index = 0;
  while (index < capacity) {
    const bucket = buckets.chunk[index];
    builder.push(...unsafeGet(bucket, journal));
    index = index + 1;
  }
  return builder;
});

/** @internal */
const toHashMap = self => reduceWithIndex(self, empty$u(), (acc, value, key) => pipe(acc, set$b(key, value)));

/** @internal */
const toReadonlyArray$2 = self => reduceWithIndex(self, [], (acc, value, key) => [[key, value], ...acc]);

/** @internal */
const toReadonlyMap = self => reduceWithIndex(self, new Map(), (acc, value, key) => acc.set(key, value));

/** @internal */
const transform$1 = /*#__PURE__*/dual(2, (self, f) => effect(journal => {
  const buckets = pipe(self.tBuckets, unsafeGet(journal));
  const capacity = buckets.chunk.length;
  const newBuckets = Array.from({
    length: capacity
  }, () => empty$z());
  let newSize = 0;
  let index = 0;
  while (index < capacity) {
    const bucket = buckets.chunk[index];
    const pairs = unsafeGet(bucket, journal);
    const iterator = pairs[Symbol.iterator]();
    let next;
    while ((next = iterator.next()) && !next.done) {
      const newPair = f(next.value[0], next.value[1]);
      const index = indexOf(newPair[0], capacity);
      const newBucket = newBuckets[index];
      if (!some$5(newBucket, entry => equals$1(entry[0], newPair[0]))) {
        newBuckets[index] = prepend$2(newBucket, newPair);
        newSize = newSize + 1;
      }
    }
    index = index + 1;
  }
  index = 0;
  while (index < capacity) {
    unsafeSet(buckets.chunk[index], newBuckets[index], journal);
    index = index + 1;
  }
  unsafeSet(self.tSize, newSize, journal);
}));

/** @internal */
const transformSTM$1 = /*#__PURE__*/dual(2, (self, f) => pipe(flatMap(toArray(self), forEach$3(entry => f(entry[0], entry[1]))), flatMap(newData => effect(journal => {
  const buckets = unsafeGet(self.tBuckets, journal);
  const capacity = buckets.chunk.length;
  const newBuckets = Array.from({
    length: capacity
  }, () => empty$z());
  const iterator = newData[Symbol.iterator]();
  let newSize = 0;
  let next;
  while ((next = iterator.next()) && !next.done) {
    const index = indexOf(next.value[0], capacity);
    const newBucket = newBuckets[index];
    if (!some$5(newBucket, entry => equals$1(entry[0])(next.value[0]))) {
      newBuckets[index] = prepend$2(newBucket, next.value);
      newSize = newSize + 1;
    }
  }
  let index = 0;
  while (index < capacity) {
    unsafeSet(buckets.chunk[index], newBuckets[index], journal);
    index = index + 1;
  }
  unsafeSet(self.tSize, newSize, journal);
}))));

/** @internal */
const transformValues = /*#__PURE__*/dual(2, (self, f) => transform$1(self, (key, value) => [key, f(value)]));

/** @internal */
const transformValuesSTM = /*#__PURE__*/dual(2, (self, f) => transformSTM$1(self, (key, value) => map$1(f(value), value => [key, value])));

/** @internal */
const updateWith = /*#__PURE__*/dual(3, (self, key, f) => flatMap(get$1(self, key), option => match$j(f(option), {
  onNone: () => as(remove$1(self, key), none$8()),
  onSome: value => as(set(self, key, value), some$6(value))
})));

/** @internal */
const values = self => map$1(toArray(self), map$m(entry => entry[1]));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TMapTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Transactional map implemented on top of `TRef` and `TArray`. Resolves
 * conflicts via chaining.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Makes an empty `TMap`.
 *
 * @since 2.0.0
 * @category constructors
 */
empty$3;

/**
 * Finds the key/value pair matching the specified predicate, and uses the
 * provided function to extract a value out of it.
 *
 * @since 2.0.0
 * @category elements
 */
find;

/**
 * Finds the key/value pair matching the specified predicate, and uses the
 * provided effectful function to extract a value out of it.
 *
 * @since 2.0.0
 * @category elements
 */
findSTM;

/**
 * Finds all the key/value pairs matching the specified predicate, and uses
 * the provided function to extract values out them.
 *
 * @since 2.0.0
 * @category elements
 */
findAll;

/**
 * Finds all the key/value pairs matching the specified predicate, and uses
 * the provided effectful function to extract values out of them..
 *
 * @since 2.0.0
 * @category elements
 */
findAllSTM;

/**
 * Atomically performs transactional-effect for each binding present in map.
 *
 * @since 2.0.0
 * @category elements
 */
forEach$1;

/**
 * Makes a new `TMap` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterable$2;

/**
 * Retrieves value associated with given key.
 *
 * @since 2.0.0
 * @category elements
 */
get$1;

/**
 * Retrieves value associated with given key or default value, in case the key
 * isn't present.
 *
 * @since 2.0.0
 * @category elements
 */
getOrElse;

/**
 * Tests whether or not map contains a key.
 *
 * @since 2.0.0
 * @category elements
 */
has$1;

/**
 * Tests if the map is empty or not.
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty$4;

/**
 * Collects all keys stored in map.
 *
 * @since 2.0.0
 * @category elements
 */
keys;

/**
 * Makes a new `TMap` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
make$a;

/**
 * If the key is not already associated with a value, stores the provided value,
 * otherwise merge the existing value with the new one using function `f` and
 * store the result.
 *
 * @since 2.0.0
 * @category mutations
 */
merge;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
reduce$1;

/**
 * Atomically folds using a transactional function.
 *
 * @since 2.0.0
 * @category folding
 */
reduceSTM$1;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
reduceWithIndex;

/**
 * Atomically folds using a transactional function.
 *
 * @since 2.0.0
 * @category folding
 */
reduceWithIndexSTM;

/**
 * Removes binding for given key.
 *
 * @since 2.0.0
 * @category mutations
 */
remove$1;

/**
 * Deletes all entries associated with the specified keys.
 *
 * @since 2.0.0
 * @category mutations
 */
removeAll$1;

/**
 * Removes bindings matching predicate and returns the removed entries.
 *
 * @since 2.0.0
 * @category mutations
 */
removeIf$2;

/**
 * Removes bindings matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
removeIfDiscard$1;

/**
 * Retains bindings matching predicate and returns removed bindings.
 *
 * @since 2.0.0
 * @category mutations
 */
retainIf$2;

/**
 * Retains bindings matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
retainIfDiscard$1;

/**
 * Stores new binding into the map.
 *
 * @since 2.0.0
 * @category mutations
 */
set;

/**
 * Stores new binding in the map if it does not already exist.
 *
 * @since 2.0.0
 * @category mutations
 */
setIfAbsent;

/**
 * Returns the number of bindings.
 *
 * @since 2.0.0
 * @category getters
 */
size$4;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeFirst$1;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeFirstSTM$1;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeSome$1;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeSomeSTM$1;

/**
 * Collects all bindings into a `Chunk`.
 *
 * @since 2.0.0
 * @category destructors
 */
toArray;

/**
 * Collects all bindings into a `HashMap`.
 *
 * @since 2.0.0
 * @category destructors
 */
toHashMap;

/**
 * Collects all bindings into a `ReadonlyArray`.
 *
 * @since 2.0.0
 * @category destructors
 */
toReadonlyArray$2;

/**
 * Collects all bindings into a `ReadonlyMap`.
 *
 * @since 2.0.0
 * @category destructors
 */
toReadonlyMap;

/**
 * Atomically updates all bindings using a pure function.
 *
 * @since 2.0.0
 * @category mutations
 */
transform$1;

/**
 * Atomically updates all bindings using a transactional function.
 *
 * @since 2.0.0
 * @category mutations
 */
transformSTM$1;

/**
 * Atomically updates all values using a pure function.
 *
 * @since 2.0.0
 * @category mutations
 */
transformValues;

/**
 * Atomically updates all values using a transactional function.
 *
 * @since 2.0.0
 * @category mutations
 */
transformValuesSTM;

/**
 * Updates the mapping for the specified key with the specified function,
 * which takes the current value of the key as an input, if it exists, and
 * either returns `Some` with a new value to indicate to update the value in
 * the map or `None` to remove the value from the map. Returns `Some` with the
 * updated value or `None` if the value was removed from the map.
 *
 * @since 2.0.0
 * @category mutations
 */
updateWith;

/**
 * Collects all values stored in map.
 *
 * @since 2.0.0
 * @category elements
 */
values;

/** @internal */
const TPriorityQueueSymbolKey = "effect/TPriorityQueue";

/** @internal */
const TPriorityQueueTypeId = /*#__PURE__*/Symbol.for(TPriorityQueueSymbolKey);

/** @internal */
const tPriorityQueueVariance = {
  _A: _ => _
};

/** @internal */
class TPriorityQueueImpl {
  [TPriorityQueueTypeId] = tPriorityQueueVariance;
  constructor(ref) {
    this.ref = ref;
  }
}

/** @internal */
const empty$2 = order => pipe(make$d(empty$5(order)), map$1(ref => new TPriorityQueueImpl(ref)));

/** @internal */
const fromIterable$1 = order => iterable => pipe(make$d(Array.from(iterable).reduce((map, value) => pipe(map, set$3(value, pipe(map, get$5(value), match$j({
  onNone: () => of$4(value),
  onSome: prepend$3(value)
})))), empty$5(order))), map$1(ref => new TPriorityQueueImpl(ref)));

/** @internal */
const isEmpty$3 = self => map$1(get$3(self.ref), isEmpty$5);

/** @internal */
const isNonEmpty = self => map$1(get$3(self.ref), isNonEmpty$1);

/** @internal */
const make$9 = order => (...elements) => fromIterable$1(order)(elements);

/** @internal */
const offer$1 = /*#__PURE__*/dual(2, (self, value) => update$2(self.ref, map => set$3(map, value, match$j(get$5(map, value), {
  onNone: () => of$4(value),
  onSome: prepend$3(value)
}))));

/** @internal */
const offerAll$1 = /*#__PURE__*/dual(2, (self, values) => update$2(self.ref, map => Array.from(values).reduce((map, value) => set$3(map, value, match$j(get$5(map, value), {
  onNone: () => of$4(value),
  onSome: prepend$3(value)
})), map)));

/** @internal */
const peek$1 = self => withSTMRuntime(runtime => {
  const map = unsafeGet(self.ref, runtime.journal);
  return match$j(headOption$1(map), {
    onNone: () => retry$1,
    onSome: elements => succeed$2(elements[0])
  });
});

/** @internal */
const peekOption$1 = self => modify(self.ref, map => [map$n(headOption$1(map), elements => elements[0]), map]);

/** @internal */
const removeIf$1 = /*#__PURE__*/dual(2, (self, predicate) => retainIf$1(self, a => !predicate(a)));

/** @internal */
const retainIf$1 = /*#__PURE__*/dual(2, (self, predicate) => update$2(self.ref, map => reduce$3(map, empty$5(getOrder(map)), (map, value, key) => {
  const filtered = filter$a(value, predicate);
  return filtered.length > 0 ? set$3(map, key, filtered) : remove$2(map, key);
})));

/** @internal */
const size$3 = self => modify(self.ref, map => [reduce$3(map, 0, (n, as) => n + as.length), map]);

/** @internal */
const take$1 = self => withSTMRuntime(runtime => {
  const map = unsafeGet(self.ref, runtime.journal);
  return match$j(headOption$1(map), {
    onNone: () => retry$1,
    onSome: values => {
      const head = values[1][0];
      const tail = values[1].slice(1);
      unsafeSet(self.ref, tail.length > 0 ? set$3(map, head, tail) : remove$2(map, head), runtime.journal);
      return succeed$2(head);
    }
  });
});

/** @internal */
const takeAll$1 = self => modify(self.ref, map => {
  const builder = [];
  for (const entry of map) {
    builder.push(...entry[1]);
  }
  return [builder, empty$5(getOrder(map))];
});

/** @internal */
const takeOption = self => effect(journal => {
  const map = pipe(self.ref, unsafeGet(journal));
  return match$j(headOption$1(map), {
    onNone: () => none$8(),
    onSome: ([key, value]) => {
      const tail = value.slice(1);
      unsafeSet(self.ref, tail.length > 0 ? set$3(map, key, tail) : remove$2(map, key), journal);
      return some$6(value[0]);
    }
  });
});

/** @internal */
const takeUpTo$1 = /*#__PURE__*/dual(2, (self, n) => modify(self.ref, map => {
  const builder = [];
  const iterator = map[Symbol.iterator]();
  let updated = map;
  let index = 0;
  let next;
  while ((next = iterator.next()) && !next.done && index < n) {
    const [key, value] = next.value;
    const [left, right] = pipe(value, splitAt$1(n - index));
    builder.push(...left);
    if (right.length > 0) {
      updated = set$3(updated, key, right);
    } else {
      updated = remove$2(updated, key);
    }
    index = index + left.length;
  }
  return [builder, updated];
}));

/** @internal */
const toChunk$1 = self => modify(self.ref, map => {
  const builder = [];
  for (const entry of map) {
    builder.push(...entry[1]);
  }
  return [builder, map];
});

/** @internal */
const toReadonlyArray$1 = self => modify(self.ref, map => {
  const builder = [];
  for (const entry of map) {
    builder.push(...entry[1]);
  }
  return [builder, map];
});

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TPriorityQueueTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `TPriorityQueue` contains values of type `A` that an `Order` is defined
 * on. Unlike a `TQueue`, `take` returns the highest priority value (the value
 * that is first in the specified ordering) as opposed to the first value
 * offered to the queue. The ordering that elements with the same priority will
 * be taken from the queue is not guaranteed.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Constructs a new empty `TPriorityQueue` with the specified `Order`.
 *
 * @since 2.0.0
 * @category constructors
 */
empty$2;

/**
 * Makes a new `TPriorityQueue` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterable$1;

/**
 * Checks whether the queue is empty.
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty$3;

/**
 * Checks whether the queue is not empty.
 *
 * @since 2.0.0
 * @category getters
 */
isNonEmpty;

/**
 * Makes a new `TPriorityQueue` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
make$9;

/**
 * Offers the specified value to the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
offer$1;

/**
 * Offers all of the elements in the specified collection to the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
offerAll$1;

/**
 * Peeks at the first value in the queue without removing it, retrying until a
 * value is in the queue.
 *
 * @since 2.0.0
 * @category getters
 */
peek$1;

/**
 * Peeks at the first value in the queue without removing it, returning `None`
 * if there is not a value in the queue.
 *
 * @since 2.0.0
 * @category getters
 */
peekOption$1;

/**
 * Removes all elements from the queue matching the specified predicate.
 *
 * @since 2.0.0
 * @category getters
 */
removeIf$1;

/**
 * Retains only elements from the queue matching the specified predicate.
 *
 * @since 2.0.0
 * @category getters
 */
retainIf$1;

/**
 * Returns the size of the queue.
 *
 * @since 2.0.0
 * @category getters
 */
size$3;

/**
 * Takes a value from the queue, retrying until a value is in the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
take$1;

/**
 * Takes all values from the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
takeAll$1;

/**
 * Takes a value from the queue, returning `None` if there is not a value in
 * the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
takeOption;

/**
 * Takes up to the specified maximum number of elements from the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
takeUpTo$1;

/**
 * Collects all values into a chunk.
 *
 * @since 2.0.0
 * @category destructors
 */
toChunk$1;

/**
 * Collects all values into an array.
 *
 * @since 2.0.0
 * @category destructors
 */
toReadonlyArray$1;

/** @internal */
const OP_BACKPRESSURE_STRATEGY = "BackPressure";

/** @internal */

/** @internal */
const OP_DROPPING_STRATEGY = "Dropping";

/** @internal */

/** @internal */
const OP_SLIDING_STRATEGY = "Sliding";

const TEnqueueSymbolKey = "effect/TQueue/TEnqueue";

/** @internal */
const TEnqueueTypeId = /*#__PURE__*/Symbol.for(TEnqueueSymbolKey);
const TDequeueSymbolKey = "effect/TQueue/TDequeue";

/** @internal */
const TDequeueTypeId = /*#__PURE__*/Symbol.for(TDequeueSymbolKey);

/**
 * A `Strategy` describes how the queue will handle values if the queue is at
 * capacity.
 *
 * @internal
 */

/**
 * A strategy that retries if the queue is at capacity.
 *
 * @internal
 */

/**
 * A strategy that drops new values if the queue is at capacity.
 *
 * @internal
 */

/**
 * A strategy that drops old values if the queue is at capacity.
 *
 * @internal
 */

/** @internal */
const BackPressure = {
  _tag: OP_BACKPRESSURE_STRATEGY
};

/** @internal */
const Dropping = {
  _tag: OP_DROPPING_STRATEGY
};

/** @internal */
const Sliding = {
  _tag: OP_SLIDING_STRATEGY
};

/** @internal */
const tDequeueVariance = {
  _Out: _ => _
};

/** @internal */
const tEnqueueVariance = {
  _In: _ => _
};
class TQueueImpl {
  [TDequeueTypeId] = tDequeueVariance;
  [TEnqueueTypeId] = tEnqueueVariance;
  constructor(ref, requestedCapacity, strategy) {
    this.ref = ref;
    this.requestedCapacity = requestedCapacity;
    this.strategy = strategy;
  }
  capacity() {
    return this.requestedCapacity;
  }
  size = withSTMRuntime(runtime => {
    const queue = unsafeGet(this.ref, runtime.journal);
    if (queue === undefined) {
      return interruptAs(runtime.fiberId);
    }
    return succeed$2(queue.length);
  });
  isFull = map$1(this.size, size => size === this.requestedCapacity);
  isEmpty = map$1(this.size, size => size === 0);
  shutdown = withSTMRuntime(runtime => {
    unsafeSet(this.ref, void 0, runtime.journal);
    return unit;
  });
  isShutdown = effect(journal => {
    const queue = unsafeGet(this.ref, journal);
    return queue === undefined;
  });
  awaitShutdown = flatMap(this.isShutdown, isShutdown => isShutdown ? unit : retry$1);
  offer(value) {
    return withSTMRuntime(runtime => {
      const queue = pipe(this.ref, unsafeGet(runtime.journal));
      if (queue === undefined) {
        return interruptAs$1(runtime.fiberId);
      }
      if (queue.length < this.requestedCapacity) {
        queue.push(value);
        unsafeSet(this.ref, queue, runtime.journal);
        return succeed$2(true);
      }
      switch (this.strategy._tag) {
        case OP_BACKPRESSURE_STRATEGY:
          {
            return retry$1;
          }
        case OP_DROPPING_STRATEGY:
          {
            return succeed$2(false);
          }
        case OP_SLIDING_STRATEGY:
          {
            const dequeued = queue.shift();
            if (dequeued === undefined) {
              return succeed$2(true);
            }
            queue.push(value);
            unsafeSet(this.ref, queue, runtime.journal);
            return succeed$2(true);
          }
      }
    });
  }
  offerAll(iterable) {
    return withSTMRuntime(runtime => {
      const as = Array.from(iterable);
      const queue = unsafeGet(this.ref, runtime.journal);
      if (queue === undefined) {
        return interruptAs$1(runtime.fiberId);
      }
      if (queue.length + as.length <= this.requestedCapacity) {
        unsafeSet(this.ref, [...queue, ...as], runtime.journal);
        return succeed$2(true);
      }
      switch (this.strategy._tag) {
        case OP_BACKPRESSURE_STRATEGY:
          {
            return retry$1;
          }
        case OP_DROPPING_STRATEGY:
          {
            const forQueue = as.slice(0, this.requestedCapacity - queue.length);
            unsafeSet(this.ref, [...queue, ...forQueue], runtime.journal);
            return succeed$2(false);
          }
        case OP_SLIDING_STRATEGY:
          {
            const forQueue = as.slice(0, this.requestedCapacity - queue.length);
            const toDrop = queue.length + forQueue.length - this.requestedCapacity;
            const newQueue = queue.slice(toDrop);
            unsafeSet(this.ref, [...newQueue, ...forQueue], runtime.journal);
            return succeed$2(true);
          }
      }
    });
  }
  peek = withSTMRuntime(runtime => {
    const queue = unsafeGet(this.ref, runtime.journal);
    if (queue === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    const head = queue[0];
    if (head === undefined) {
      return retry$1;
    }
    return succeed$2(head);
  });
  peekOption = withSTMRuntime(runtime => {
    const queue = unsafeGet(this.ref, runtime.journal);
    if (queue === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    return succeed$2(fromNullable$2(queue[0]));
  });
  take = withSTMRuntime(runtime => {
    const queue = unsafeGet(this.ref, runtime.journal);
    if (queue === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    const dequeued = queue.shift();
    if (dequeued === undefined) {
      return retry$1;
    }
    unsafeSet(this.ref, queue, runtime.journal);
    return succeed$2(dequeued);
  });
  takeAll = withSTMRuntime(runtime => {
    const queue = unsafeGet(this.ref, runtime.journal);
    if (queue === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    unsafeSet(this.ref, [], runtime.journal);
    return succeed$2(queue);
  });
  takeUpTo(max) {
    return withSTMRuntime(runtime => {
      const queue = unsafeGet(this.ref, runtime.journal);
      if (queue === undefined) {
        return interruptAs$1(runtime.fiberId);
      }
      const [toTake, remaining] = splitAt(unsafeFromArray(queue), max);
      unsafeSet(this.ref, Array.from(remaining), runtime.journal);
      return succeed$2(Array.from(toTake));
    });
  }
}

/** @internal */
const isTQueue = u => {
  return isTEnqueue(u) && isTDequeue(u);
};

/** @internal */
const isTEnqueue = u => {
  return typeof u === "object" && u != null && TEnqueueTypeId in u;
};

/** @internal */
const isTDequeue = u => {
  return typeof u === "object" && u != null && TDequeueTypeId in u;
};

/** @internal */
const awaitShutdown$1 = self => self.awaitShutdown;

/** @internal */
const bounded$1 = requestedCapacity => makeQueue(requestedCapacity, BackPressure);

/** @internal */
const capacity$1 = self => {
  return self.capacity();
};

/** @internal */
const dropping$1 = requestedCapacity => makeQueue(requestedCapacity, Dropping);

/** @internal */
const isEmpty$2 = self => self.isEmpty;

/** @internal */
const isFull$1 = self => self.isFull;

/** @internal */
const isShutdown$1 = self => self.isShutdown;

/** @internal */
const offer = /*#__PURE__*/dual(2, (self, value) => self.offer(value));

/** @internal */
const offerAll = /*#__PURE__*/dual(2, (self, iterable) => self.offerAll(iterable));

/** @internal */
const peek = self => self.peek;

/** @internal */
const peekOption = self => self.peekOption;

/** @internal */
const poll = self => pipe(self.takeUpTo(1), map$1(head$5));

/** @internal */
const seek = /*#__PURE__*/dual(2, (self, predicate) => seekLoop(self, predicate));
const seekLoop = (self, predicate) => flatMap(self.take, a => predicate(a) ? succeed$2(a) : seekLoop(self, predicate));

/** @internal */
const shutdown = self => self.shutdown;

/** @internal */
const size$2 = self => self.size;

/** @internal */
const sliding$1 = requestedCapacity => makeQueue(requestedCapacity, Sliding);

/** @internal */
const take = self => self.take;

/** @internal */
const takeAll = self => self.takeAll;

/** @internal */
const takeBetween = /*#__PURE__*/dual(3, (self, min, max) => suspend(() => {
  const takeRemainder = (min, max, acc) => {
    if (max < min) {
      return succeed$2(acc);
    }
    return pipe(self.takeUpTo(max), flatMap(taken => {
      const remaining = min - taken.length;
      if (remaining === 1) {
        return pipe(self.take, map$1(a => pipe(acc, appendAll$1(unsafeFromArray(taken)), append$1(a))));
      }
      if (remaining > 1) {
        return pipe(self.take, flatMap(a => takeRemainder(remaining - 1, max - taken.length - 1, pipe(acc, appendAll$1(unsafeFromArray(taken)), append$1(a)))));
      }
      return succeed$2(pipe(acc, appendAll$1(unsafeFromArray(taken))));
    }));
  };
  return map$1(takeRemainder(min, max, empty$z()), c => Array.from(c));
}));

/** @internal */
const takeN = /*#__PURE__*/dual(2, (self, n) => pipe(self, takeBetween(n, n)));

/** @internal */
const takeUpTo = /*#__PURE__*/dual(2, (self, max) => self.takeUpTo(max));

/** @internal */
const unbounded$1 = () => makeQueue(Number.MAX_SAFE_INTEGER, Dropping);
const makeQueue = (requestedCapacity, strategy) => map$1(make$d([]), ref => new TQueueImpl(ref, requestedCapacity, strategy));

/** @internal */
const TPubSubSymbolKey = "effect/TPubSub";

/** @internal */
const TPubSubTypeId = /*#__PURE__*/Symbol.for(TPubSubSymbolKey);

/** @internal */

/** @internal */
const makeNode = (head, subscribers, tail) => ({
  head,
  subscribers,
  tail
});

/** @internal */
class TPubSubImpl {
  [TPubSubTypeId] = TPubSubTypeId;
  [TEnqueueTypeId] = tEnqueueVariance;
  constructor(pubsubSize, publisherHead, publisherTail, requestedCapacity, strategy, subscriberCount, subscribers) {
    this.pubsubSize = pubsubSize;
    this.publisherHead = publisherHead;
    this.publisherTail = publisherTail;
    this.requestedCapacity = requestedCapacity;
    this.strategy = strategy;
    this.subscriberCount = subscriberCount;
    this.subscribers = subscribers;
  }
  isShutdown = effect(journal => {
    const currentPublisherTail = unsafeGet(this.publisherTail, journal);
    return currentPublisherTail === undefined;
  });
  awaitShutdown = flatMap(this.isShutdown, isShutdown => isShutdown ? unit : retry$1);
  capacity() {
    return this.requestedCapacity;
  }
  size = withSTMRuntime(runtime => {
    const currentPublisherTail = unsafeGet(this.publisherTail, runtime.journal);
    if (currentPublisherTail === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    return succeed$2(unsafeGet(this.pubsubSize, runtime.journal));
  });
  isEmpty = map$1(this.size, size => size === 0);
  isFull = map$1(this.size, size => size === this.capacity());
  offer(value) {
    return withSTMRuntime(runtime => {
      const currentPublisherTail = unsafeGet(this.publisherTail, runtime.journal);
      if (currentPublisherTail === undefined) {
        return interruptAs$1(runtime.fiberId);
      }
      const currentSubscriberCount = unsafeGet(this.subscriberCount, runtime.journal);
      if (currentSubscriberCount === 0) {
        return succeed$2(true);
      }
      const currentPubSubSize = unsafeGet(this.pubsubSize, runtime.journal);
      if (currentPubSubSize < this.requestedCapacity) {
        const updatedPublisherTail = new TRefImpl(void 0);
        const updatedNode = makeNode(value, currentSubscriberCount, updatedPublisherTail);
        unsafeSet(currentPublisherTail, updatedNode, runtime.journal);
        unsafeSet(this.publisherTail, updatedPublisherTail, runtime.journal);
        unsafeSet(this.pubsubSize, currentPubSubSize + 1, runtime.journal);
        return succeed$2(true);
      }
      switch (this.strategy._tag) {
        case OP_BACKPRESSURE_STRATEGY:
          {
            return retry$1;
          }
        case OP_DROPPING_STRATEGY:
          {
            return succeed$2(false);
          }
        case OP_SLIDING_STRATEGY:
          {
            if (this.requestedCapacity > 0) {
              let currentPublisherHead = unsafeGet(this.publisherHead, runtime.journal);
              let loop = true;
              while (loop) {
                const node = unsafeGet(currentPublisherHead, runtime.journal);
                if (node === undefined) {
                  return retry$1;
                }
                const head = node.head;
                const tail = node.tail;
                if (head !== undefined) {
                  const updatedNode = makeNode(void 0, node.subscribers, node.tail);
                  unsafeSet(currentPublisherHead, updatedNode, runtime.journal);
                  unsafeSet(this.publisherHead, tail, runtime.journal);
                  loop = false;
                } else {
                  currentPublisherHead = tail;
                }
              }
            }
            const updatedPublisherTail = new TRefImpl(void 0);
            const updatedNode = makeNode(value, currentSubscriberCount, updatedPublisherTail);
            unsafeSet(currentPublisherTail, updatedNode, runtime.journal);
            unsafeSet(this.publisherTail, updatedPublisherTail, runtime.journal);
            return succeed$2(true);
          }
      }
    });
  }
  offerAll(iterable) {
    return map$1(forEach$3(iterable, a => this.offer(a)), every$7(identity$1));
  }
  shutdown = effect(journal => {
    const currentPublisherTail = unsafeGet(this.publisherTail, journal);
    if (currentPublisherTail !== undefined) {
      unsafeSet(this.publisherTail, void 0, journal);
      const currentSubscribers = unsafeGet(this.subscribers, journal);
      forEach$8(currentSubscribers, subscriber => {
        unsafeSet(subscriber, void 0, journal);
      });
      unsafeSet(this.subscribers, empty$s(), journal);
    }
  });
}

/** @internal */
class TPubSubSubscriptionImpl {
  [TPubSubTypeId] = TPubSubTypeId;
  [TDequeueTypeId] = tDequeueVariance;
  constructor(pubsubSize, publisherHead, requestedCapacity, subscriberHead, subscriberCount, subscribers) {
    this.pubsubSize = pubsubSize;
    this.publisherHead = publisherHead;
    this.requestedCapacity = requestedCapacity;
    this.subscriberHead = subscriberHead;
    this.subscriberCount = subscriberCount;
    this.subscribers = subscribers;
  }
  isShutdown = effect(journal => {
    const currentSubscriberHead = unsafeGet(this.subscriberHead, journal);
    return currentSubscriberHead === undefined;
  });
  awaitShutdown = flatMap(this.isShutdown, isShutdown => isShutdown ? unit : retry$1);
  capacity() {
    return this.requestedCapacity;
  }
  size = withSTMRuntime(runtime => {
    let currentSubscriberHead = unsafeGet(this.subscriberHead, runtime.journal);
    if (currentSubscriberHead === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    let loop = true;
    let size = 0;
    while (loop) {
      const node = unsafeGet(currentSubscriberHead, runtime.journal);
      if (node === undefined) {
        loop = false;
      } else {
        const head = node.head;
        const tail = node.tail;
        if (head !== undefined) {
          size = size + 1;
          if (size >= Number.MAX_SAFE_INTEGER) {
            loop = false;
          }
        }
        currentSubscriberHead = tail;
      }
    }
    return succeed$2(size);
  });
  isEmpty = map$1(this.size, size => size === 0);
  isFull = map$1(this.size, size => size === this.capacity());
  peek = withSTMRuntime(runtime => {
    let currentSubscriberHead = unsafeGet(this.subscriberHead, runtime.journal);
    if (currentSubscriberHead === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    let value = undefined;
    let loop = true;
    while (loop) {
      const node = unsafeGet(currentSubscriberHead, runtime.journal);
      if (node === undefined) {
        return retry$1;
      }
      const head = node.head;
      const tail = node.tail;
      if (head !== undefined) {
        value = head;
        loop = false;
      } else {
        currentSubscriberHead = tail;
      }
    }
    return succeed$2(value);
  });
  peekOption = withSTMRuntime(runtime => {
    let currentSubscriberHead = unsafeGet(this.subscriberHead, runtime.journal);
    if (currentSubscriberHead === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    let value = none$8();
    let loop = true;
    while (loop) {
      const node = unsafeGet(currentSubscriberHead, runtime.journal);
      if (node === undefined) {
        value = none$8();
        loop = false;
      } else {
        const head = node.head;
        const tail = node.tail;
        if (head !== undefined) {
          value = some$6(head);
          loop = false;
        } else {
          currentSubscriberHead = tail;
        }
      }
    }
    return succeed$2(value);
  });
  shutdown = effect(journal => {
    let currentSubscriberHead = unsafeGet(this.subscriberHead, journal);
    if (currentSubscriberHead !== undefined) {
      unsafeSet(this.subscriberHead, void 0, journal);
      let loop = true;
      while (loop) {
        const node = unsafeGet(currentSubscriberHead, journal);
        if (node === undefined) {
          loop = false;
        } else {
          const head = node.head;
          const tail = node.tail;
          if (head !== undefined) {
            const subscribers = node.subscribers;
            if (subscribers === 1) {
              const size = unsafeGet(this.pubsubSize, journal);
              const updatedNode = makeNode(undefined, 0, tail);
              unsafeSet(currentSubscriberHead, updatedNode, journal);
              unsafeSet(this.publisherHead, tail, journal);
              unsafeSet(this.pubsubSize, size - 1, journal);
            } else {
              const updatedNode = makeNode(head, subscribers - 1, tail);
              unsafeSet(currentSubscriberHead, updatedNode, journal);
            }
          }
          currentSubscriberHead = tail;
        }
      }
      const currentSubscriberCount = unsafeGet(this.subscriberCount, journal);
      unsafeSet(this.subscriberCount, currentSubscriberCount - 1, journal);
      unsafeSet(this.subscribers, remove$6(unsafeGet(this.subscribers, journal), this.subscriberHead), journal);
    }
  });
  take = withSTMRuntime(runtime => {
    let currentSubscriberHead = unsafeGet(this.subscriberHead, runtime.journal);
    if (currentSubscriberHead === undefined) {
      return interruptAs$1(runtime.fiberId);
    }
    let value = undefined;
    let loop = true;
    while (loop) {
      const node = unsafeGet(currentSubscriberHead, runtime.journal);
      if (node === undefined) {
        return retry$1;
      }
      const head = node.head;
      const tail = node.tail;
      if (head !== undefined) {
        const subscribers = node.subscribers;
        if (subscribers === 1) {
          const size = unsafeGet(this.pubsubSize, runtime.journal);
          const updatedNode = makeNode(void 0, 0, tail);
          unsafeSet(currentSubscriberHead, updatedNode, runtime.journal);
          unsafeSet(this.publisherHead, tail, runtime.journal);
          unsafeSet(this.pubsubSize, size - 1, runtime.journal);
        } else {
          const updatedNode = makeNode(head, subscribers - 1, tail);
          unsafeSet(currentSubscriberHead, updatedNode, runtime.journal);
        }
        unsafeSet(this.subscriberHead, tail, runtime.journal);
        value = head;
        loop = false;
      } else {
        currentSubscriberHead = tail;
      }
    }
    return succeed$2(value);
  });
  takeAll = this.takeUpTo(Number.POSITIVE_INFINITY);
  takeUpTo(max) {
    return withSTMRuntime(runtime => {
      let currentSubscriberHead = unsafeGet(this.subscriberHead, runtime.journal);
      if (currentSubscriberHead === undefined) {
        return interruptAs$1(runtime.fiberId);
      }
      const builder = [];
      let n = 0;
      while (n !== max) {
        const node = unsafeGet(currentSubscriberHead, runtime.journal);
        if (node === undefined) {
          n = max;
        } else {
          const head = node.head;
          const tail = node.tail;
          if (head !== undefined) {
            const subscribers = node.subscribers;
            if (subscribers === 1) {
              const size = unsafeGet(this.pubsubSize, runtime.journal);
              const updatedNode = makeNode(void 0, 0, tail);
              unsafeSet(currentSubscriberHead, updatedNode, runtime.journal);
              unsafeSet(this.publisherHead, tail, runtime.journal);
              unsafeSet(this.pubsubSize, size - 1, runtime.journal);
            } else {
              const updatedNode = makeNode(head, subscribers - 1, tail);
              unsafeSet(currentSubscriberHead, updatedNode, runtime.journal);
            }
            builder.push(head);
            n = n + 1;
          }
          currentSubscriberHead = tail;
        }
      }
      unsafeSet(this.subscriberHead, currentSubscriberHead, runtime.journal);
      return succeed$2(builder);
    });
  }
}

/** @internal */
const makeTPubSub = (requestedCapacity, strategy) => pipe(all([make$d(void 0), make$d(0)]), flatMap(([empty$1, pubsubSize]) => pipe(all([make$d(empty$1), make$d(empty$1), make$d(0), make$d(empty$s())]), map$1(([publisherHead, publisherTail, subscriberCount, subscribers]) => new TPubSubImpl(pubsubSize, publisherHead, publisherTail, requestedCapacity, strategy, subscriberCount, subscribers)))));
const makeSubscription = (pubsubSize, publisherHead, publisherTail, requestedCapacity, subscriberCount, subscribers) => pipe(get$3(publisherTail), flatMap(currentPublisherTail => pipe(all([make$d(currentPublisherTail), get$3(subscriberCount), get$3(subscribers)]), tap(([_, currentSubscriberCount]) => pipe(subscriberCount, set$1(currentSubscriberCount + 1))), tap(([subscriberHead, _, currentSubscribers]) => pipe(subscribers, set$1(pipe(currentSubscribers, add$2(subscriberHead))))), map$1(([subscriberHead]) => new TPubSubSubscriptionImpl(pubsubSize, publisherHead, requestedCapacity, subscriberHead, subscriberCount, subscribers)))));

/** @internal */
const awaitShutdown = self => self.awaitShutdown;

/** @internal */
const bounded = requestedCapacity => makeTPubSub(requestedCapacity, BackPressure);

/** @internal */
const capacity = self => self.capacity();

/** @internal */
const dropping = requestedCapacity => makeTPubSub(requestedCapacity, Dropping);

/** @internal */
const isEmpty$1 = self => self.isEmpty;

/** @internal */
const isFull = self => self.isFull;

/** @internal */
const isShutdown = self => self.isShutdown;

/** @internal */
const publish = /*#__PURE__*/dual(2, (self, value) => self.offer(value));

/** @internal */
const publishAll = /*#__PURE__*/dual(2, (self, iterable) => self.offerAll(iterable));

/** @internal */
const size$1 = self => self.size;

/** @internal */
const sliding = requestedCapacity => makeTPubSub(requestedCapacity, Sliding);

/** @internal */
const subscribe = self => makeSubscription(self.pubsubSize, self.publisherHead, self.publisherTail, self.requestedCapacity, self.subscriberCount, self.subscribers);

/** @internal */
const subscribeScoped = self => acquireRelease$1(subscribe(self), dequeue => shutdown(dequeue));

/** @internal */
const unbounded = () => makeTPubSub(Number.MAX_SAFE_INTEGER, Dropping);

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TPubSubTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * Waits until the `TPubSub` is shutdown. The `STM` returned by this method will
 * not resume until the queue has been shutdown. If the `TPubSub` is already
 * shutdown, the `STM` will resume right away.
 *
 * @since 2.0.0
 * @category mutations
 */
awaitShutdown;

/**
 * Creates a bounded `TPubSub` with the back pressure strategy. The `TPubSub` will retain
 * messages until they have been taken by all subscribers, applying back
 * pressure to publishers if the `TPubSub` is at capacity.
 *
 * @since 2.0.0
 * @category constructors
 */
bounded;

/**
 * Returns the number of elements the `TPubSub` can hold.
 *
 * @since 2.0.0
 * @category getters
 */
capacity;

/**
 * Creates a bounded `TPubSub` with the dropping strategy. The `TPubSub` will drop new
 * messages if the `TPubSub` is at capacity.
 *
 * @since 2.0.0
 * @category constructors
 */
dropping;

/**
 * Returns `true` if the `TPubSub` contains zero elements, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty$1;

/**
 * Returns `true` if the `TPubSub` contains at least one element, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isFull;

/**
 * Returns `true` if `shutdown` has been called, otherwise returns `false`.
 *
 * @since 2.0.0
 * @category getters
 */
isShutdown;

/**
 * Publishes a message to the `TPubSub`, returning whether the message was published
 * to the `TPubSub`.
 *
 * @since 2.0.0
 * @category mutations
 */
publish;

/**
 * Publishes all of the specified messages to the `TPubSub`, returning whether they
 * were published to the `TPubSub`.
 *
 * @since 2.0.0
 * @category mutations
 */
publishAll;

/**
 * Retrieves the size of the `TPubSub`, which is equal to the number of elements
 * in the `TPubSub`. This may be negative if fibers are suspended waiting for
 * elements to be added to the `TPubSub`.
 *
 * @since 2.0.0
 * @category getters
 */
size$1;

/**
 * Creates a bounded `TPubSub` with the sliding strategy. The `TPubSub` will add new
 * messages and drop old messages if the `TPubSub` is at capacity.
 *
 * For best performance use capacities that are powers of two.
 *
 * @since 2.0.0
 * @category constructors
 */
sliding;

/**
 * Subscribes to receive messages from the `TPubSub`. The resulting subscription can
 * be evaluated multiple times to take a message from the `TPubSub` each time. The
 * caller is responsible for unsubscribing from the `TPubSub` by shutting down the
 * queue.
 *
 * @since 2.0.0
 * @category mutations
 */
subscribe;

/**
 * Subscribes to receive messages from the `TPubSub`. The resulting subscription can
 * be evaluated multiple times within the scope to take a message from the `TPubSub`
 * each time.
 *
 * @since 2.0.0
 * @category mutations
 */
subscribeScoped;

/**
 * Creates an unbounded `TPubSub`.
 *
 * @since 2.0.0
 * @category constructors
 */
unbounded;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TDequeueTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
TEnqueueTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * The base interface that all `TQueue`s must implement.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Returns `true` if the specified value is a `TQueue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isTQueue;

/**
 * Returns `true` if the specified value is a `TDequeue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isTDequeue;

/**
 * Returns `true` if the specified value is a `TEnqueue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
isTEnqueue;

/**
 * Waits until the queue is shutdown. The `STM` returned by this method will
 * not resume until the queue has been shutdown. If the queue is already
 * shutdown, the `STM` will resume right away.
 *
 * @since 2.0.0
 * @category mutations
 */
awaitShutdown$1;

/**
 * Creates a bounded queue with the back pressure strategy. The queue will
 * retain values until they have been taken, applying back pressure to
 * offerors if the queue is at capacity.
 *
 * For best performance use capacities that are powers of two.
 *
 * @since 2.0.0
 * @category constructors
 */
bounded$1;

/**
 * Returns the number of elements the queue can hold.
 *
 * @since 2.0.0
 * @category getters
 */
capacity$1;

/**
 * Creates a bounded queue with the dropping strategy. The queue will drop new
 * values if the queue is at capacity.
 *
 * For best performance use capacities that are powers of two.
 *
 * @since 2.0.0
 * @category constructors
 */
dropping$1;

/**
 * Returns `true` if the `TQueue` contains zero elements, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty$2;

/**
 * Returns `true` if the `TQueue` contains at least one element, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
isFull$1;

/**
 * Returns `true` if `shutdown` has been called, otherwise returns `false`.
 *
 * @since 2.0.0
 * @category getters
 */
isShutdown$1;

/**
 * Places one value in the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
offer;

/**
 * For Bounded TQueue: uses the `BackPressure` Strategy, places the values in
 * the queue and always returns true. If the queue has reached capacity, then
 * the fiber performing the `offerAll` will be suspended until there is room
 * in the queue.
 *
 * For Unbounded TQueue: Places all values in the queue and returns true.
 *
 * For Sliding TQueue: uses `Sliding` Strategy If there is room in the queue,
 * it places the values otherwise it removes the old elements and enqueues the
 * new ones. Always returns true.
 *
 * For Dropping TQueue: uses `Dropping` Strategy, It places the values in the
 * queue but if there is no room it will not enqueue them and return false.
 *
 * @since 2.0.0
 * @category mutations
 */
offerAll;

/**
 * Views the next element in the queue without removing it, retrying if the
 * queue is empty.
 *
 * @since 2.0.0
 * @category getters
 */
peek;

/**
 * Views the next element in the queue without removing it, returning `None`
 * if the queue is empty.
 *
 * @since 2.0.0
 * @category getters
 */
peekOption;

/**
 * Takes a single element from the queue, returning `None` if the queue is
 * empty.
 *
 * @since 2.0.0
 * @category getters
 */
poll;

/**
 * Drops elements from the queue while they do not satisfy the predicate,
 * taking and returning the first element that does satisfy the predicate.
 * Retries if no elements satisfy the predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
seek;

/**
 * Interrupts any fibers that are suspended on `offer` or `take`. Future calls
 * to `offer*` and `take*` will be interrupted immediately.
 *
 * @since 2.0.0
 * @category mutations
 */
shutdown;

/**
 * Retrieves the size of the queue, which is equal to the number of elements
 * in the queue. This may be negative if fibers are suspended waiting for
 * elements to be added to the queue.
 *
 * @since 2.0.0
 * @category getters
 */
size$2;

/**
 * Creates a bounded queue with the sliding strategy. The queue will add new
 * values and drop old values if the queue is at capacity.
 *
 * For best performance use capacities that are powers of two.
 *
 * @since 2.0.0
 * @category constructors
 */
sliding$1;

/**
 * Takes the oldest value in the queue. If the queue is empty, this will return
 * a computation that resumes when an item has been added to the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
take;

/**
 * Takes all the values in the queue and returns the values. If the queue is
 * empty returns an empty collection.
 *
 * @since 2.0.0
 * @category mutations
 */
takeAll;

/**
 * Takes a number of elements from the queue between the specified minimum and
 * maximum. If there are fewer than the minimum number of elements available,
 * retries until at least the minimum number of elements have been collected.
 *
 * @since 2.0.0
 * @category mutations
 */
takeBetween;

/**
 * Takes the specified number of elements from the queue. If there are fewer
 * than the specified number of elements available, it retries until they
 * become available.
 *
 * @since 2.0.0
 * @category mutations
 */
takeN;

/**
 * Takes up to max number of values from the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
takeUpTo;

/**
 * Creates an unbounded queue.
 *
 * @since 2.0.0
 * @category constructors
 */
unbounded$1;

const TRandomSymbolKey = "effect/TRandom";

/** @internal */
const TRandomTypeId = /*#__PURE__*/Symbol.for(TRandomSymbolKey);
const randomInteger = state => {
  const prng = new PCGRandom();
  prng.setState(state);
  return [prng.integer(0), prng.getState()];
};
const randomIntegerBetween = (low, high) => {
  return state => {
    const prng = new PCGRandom();
    prng.setState(state);
    return [prng.integer(high - low) + low, prng.getState()];
  };
};
const randomNumber = state => {
  const prng = new PCGRandom();
  prng.setState(state);
  return [prng.number(), prng.getState()];
};
const withState = (state, f) => {
  return pipe(state, modify(f));
};
const shuffleWith = (iterable, nextIntBounded) => {
  const swap = (buffer, index1, index2) => pipe(buffer, get$2(index1), flatMap(tmp => pipe(buffer, updateSTM(index1, () => pipe(buffer, get$2(index2))), zipRight(pipe(buffer, update$1(index2, () => tmp))))));
  return pipe(fromIterable$3(iterable), flatMap(buffer => {
    const array = [];
    for (let i = array.length; i >= 2; i = i - 1) {
      array.push(i);
    }
    return pipe(array, forEach$3(n => pipe(nextIntBounded(n), flatMap(k => swap(buffer, n - 1, k))), {
      discard: true
    }), zipRight(toArray$1(buffer)));
  }));
};

/** @internal */
const Tag = /*#__PURE__*/Tag$1();
class TRandomImpl {
  [TRandomTypeId] = TRandomTypeId;
  constructor(state) {
    this.state = state;
    this.next = withState(this.state, randomNumber);
    this.nextBoolean = flatMap(this.next, n => succeed$2(n > 0.5));
    this.nextInt = withState(this.state, randomInteger);
  }
  nextRange(min, max) {
    return flatMap(this.next, n => succeed$2((max - min) * n + min));
  }
  nextIntBetween(low, high) {
    return withState(this.state, randomIntegerBetween(low, high));
  }
  shuffle(elements) {
    return shuffleWith(elements, n => this.nextIntBetween(0, n));
  }
}

/** @internal */
const live = /*#__PURE__*/effect$2(Tag, /*#__PURE__*/pipe( /*#__PURE__*/make$d( /*#__PURE__*/new PCGRandom(Math.random() * 4294967296 >>> 0).getState()), /*#__PURE__*/map$1(seed => new TRandomImpl(seed)), commit));

/** @internal */
const next = /*#__PURE__*/flatMap(Tag, random => random.next);

/** @internal */
const nextBoolean = /*#__PURE__*/flatMap(Tag, random => random.nextBoolean);

/** @internal */
const nextInt = /*#__PURE__*/flatMap(Tag, random => random.nextInt);

/** @internal */
const nextIntBetween = (low, high) => flatMap(Tag, random => random.nextIntBetween(low, high));

/** @internal */
const nextRange = (min, max) => flatMap(Tag, random => random.nextRange(min, max));

/** @internal */
const shuffle = elements => flatMap(Tag, random => random.shuffle(elements));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TRandomTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * The service tag used to access `TRandom` in the environment of an effect.
 *
 * @since 2.0.0
 * @category context
 */
Tag;

/**
 * The "live" `TRandom` service wrapped into a `Layer`.
 *
 * @since 2.0.0
 * @category context
 */
live;

/**
 * Returns the next number from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category random
 */
next;

/**
 * Returns the next boolean value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category random
 */
nextBoolean;

/**
 * Returns the next integer from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category random
 */
nextInt;

/**
 * Returns the next integer in the specified range from the pseudo-random number
 * generator.
 *
 * @since 2.0.0
 * @category random
 */
nextIntBetween;

/**
 * Returns the next number in the specified range from the pseudo-random number
 * generator.
 *
 * @since 2.0.0
 * @category random
 */
nextRange;

/**
 * Uses the pseudo-random number generator to shuffle the specified iterable.
 *
 * @since 2.0.0
 * @category random
 */
shuffle;

const TReentrantLockSymbolKey = "effect/TReentrantLock";

/** @internal */
const TReentrantLockTypeId = /*#__PURE__*/Symbol.for(TReentrantLockSymbolKey);
const WriteLockTypeId = /*#__PURE__*/Symbol.for("effect/TReentrantLock/WriteLock");
const ReadLockTypeId = /*#__PURE__*/Symbol.for("effect/TReentrantLock/ReadLock");
class TReentranLockImpl {
  [TReentrantLockTypeId] = TReentrantLockTypeId;
  constructor(state) {
    this.state = state;
  }
}

/** @internal */

/**
 * This data structure describes the state of the lock when multiple fibers
 * have acquired read locks. The state is tracked as a map from fiber identity
 * to number of read locks acquired by the fiber. This level of detail permits
 * upgrading a read lock to a write lock.
 *
 * @internal
 */
class ReadLock {
  [ReadLockTypeId] = ReadLockTypeId;
  constructor(readers) {
    this.readers = readers;
  }
  get readLocks() {
    return Array.from(this.readers).reduce((acc, curr) => acc + curr[1], 0);
  }
  get writeLocks() {
    return 0;
  }
  readLocksHeld(fiberId) {
    return getOrElse$3(get$g(this.readers, fiberId), () => 0);
  }
  writeLocksHeld(_fiberId) {
    return 0;
  }
}

/**
 * This data structure describes the state of the lock when a single fiber has
 * a write lock. The fiber has an identity, and may also have acquired a
 * certain number of read locks.
 *
 * @internal
 */
class WriteLock {
  [WriteLockTypeId] = WriteLockTypeId;
  constructor(readLocks, writeLocks, fiberId) {
    this.readLocks = readLocks;
    this.writeLocks = writeLocks;
    this.fiberId = fiberId;
  }
  readLocksHeld(fiberId) {
    return equals$1(fiberId)(this.fiberId) ? this.readLocks : 0;
  }
  writeLocksHeld(fiberId) {
    return equals$1(fiberId)(this.fiberId) ? this.writeLocks : 0;
  }
}
const isReadLock = lock => {
  return ReadLockTypeId in lock;
};
const isWriteLock = lock => {
  return WriteLockTypeId in lock;
};

/**
 * An empty read lock state, in which no fiber holds any read locks.
 */
const emptyReadLock = /*#__PURE__*/new ReadLock( /*#__PURE__*/empty$u());

/**
 * Creates a new read lock where the specified fiber holds the specified
 * number of read locks.
 */
const makeReadLock = (fiberId, count) => {
  if (count <= 0) {
    return emptyReadLock;
  }
  return new ReadLock(make$_([fiberId, count]));
};

/**
 * Determines if there is no other holder of read locks aside from the
 * specified fiber id. If there are no other holders of read locks aside
 * from the specified fiber id, then it is safe to upgrade the read lock
 * into a write lock.
 */
const noOtherHolder = (readLock, fiberId) => {
  return isEmpty$f(readLock.readers) || size$h(readLock.readers) === 1 && has$6(readLock.readers, fiberId);
};

/**
 * Adjusts the number of read locks held by the specified fiber id.
 */
const adjustReadLock = (readLock, fiberId, adjustment) => {
  const total = readLock.readLocksHeld(fiberId);
  const newTotal = total + adjustment;
  if (newTotal < 0) {
    throw new Error("BUG - TReentrantLock.ReadLock.adjust - please report an issue at https://github.com/Effect-TS/stm/issues");
  }
  if (newTotal === 0) {
    return new ReadLock(remove$7(readLock.readers, fiberId));
  }
  return new ReadLock(set$b(readLock.readers, fiberId, newTotal));
};
const adjustRead = (self, delta) => withSTMRuntime(runtime => {
  const lock = unsafeGet(self.state, runtime.journal);
  if (isReadLock(lock)) {
    const result = adjustReadLock(lock, runtime.fiberId, delta);
    unsafeSet(self.state, result, runtime.journal);
    return succeed$2(result.readLocksHeld(runtime.fiberId));
  }
  if (isWriteLock(lock) && equals$1(runtime.fiberId)(lock.fiberId)) {
    const newTotal = lock.readLocks + delta;
    if (newTotal < 0) {
      throw new Error(`Defect: Fiber ${threadName(runtime.fiberId)} releasing read locks it does not hold, newTotal: ${newTotal}`);
    }
    unsafeSet(self.state, new WriteLock(newTotal, lock.writeLocks, runtime.fiberId), runtime.journal);
    return succeed$2(newTotal);
  }
  return retry$1;
});

/** @internal */
const acquireRead = self => adjustRead(self, 1);

/** @internal */
const acquireWrite = self => withSTMRuntime(runtime => {
  const lock = unsafeGet(self.state, runtime.journal);
  if (isReadLock(lock) && noOtherHolder(lock, runtime.fiberId)) {
    unsafeSet(self.state, new WriteLock(lock.readLocksHeld(runtime.fiberId), 1, runtime.fiberId), runtime.journal);
    return succeed$2(1);
  }
  if (isWriteLock(lock) && equals$1(runtime.fiberId)(lock.fiberId)) {
    unsafeSet(self.state, new WriteLock(lock.readLocks, lock.writeLocks + 1, runtime.fiberId), runtime.journal);
    return succeed$2(lock.writeLocks + 1);
  }
  return retry$1;
});

/** @internal */
const fiberReadLocks = self => effect((journal, fiberId) => unsafeGet(self.state, journal).readLocksHeld(fiberId));

/** @internal */
const fiberWriteLocks = self => effect((journal, fiberId) => unsafeGet(self.state, journal).writeLocksHeld(fiberId));

/** @internal */
const lock = self => writeLock(self);

/** @internal */
const locked = self => zipWith(readLocked(self), writeLocked(self), (x, y) => x || y);

/** @internal */
const make$8 = /*#__PURE__*/map$1( /*#__PURE__*/make$d(emptyReadLock), readLock => new TReentranLockImpl(readLock));

/** @internal */
const readLock = self => acquireRelease$1(commit(acquireRead(self)), () => commit(releaseRead(self)));

/** @internal */
const readLocks = self => map$1(get$3(self.state), state => state.readLocks);

/** @internal */
const readLocked = self => map$1(get$3(self.state), state => state.readLocks > 0);

/** @internal */
const releaseRead = self => adjustRead(self, -1);

/** @internal */
const releaseWrite = self => withSTMRuntime(runtime => {
  const lock = unsafeGet(self.state, runtime.journal);
  if (isWriteLock(lock) && lock.writeLocks === 1 && equals$1(runtime.fiberId)(lock.fiberId)) {
    const result = makeReadLock(lock.fiberId, lock.readLocks);
    unsafeSet(self.state, result, runtime.journal);
    return succeed$2(result.writeLocksHeld(runtime.fiberId));
  }
  if (isWriteLock(lock) && equals$1(runtime.fiberId)(lock.fiberId)) {
    const result = new WriteLock(lock.readLocks, lock.writeLocks - 1, runtime.fiberId);
    unsafeSet(self.state, result, runtime.journal);
    return succeed$2(result.writeLocksHeld(runtime.fiberId));
  }
  throw new Error(`Defect: Fiber ${threadName(runtime.fiberId)} releasing write lock it does not hold`);
});

/** @internal */
const withLock = /*#__PURE__*/dual(2, (effect, self) => withWriteLock(effect, self));

/** @internal */
const withReadLock = /*#__PURE__*/dual(2, (effect, self) => uninterruptibleMask(restore => zipRight$4(restore(commit(acquireRead(self))), ensuring$4(effect, commit(releaseRead(self))))));

/** @internal */
const withWriteLock = /*#__PURE__*/dual(2, (effect, self) => uninterruptibleMask(restore => zipRight$4(restore(commit(acquireWrite(self))), ensuring$4(effect, commit(releaseWrite(self))))));

/** @internal */
const writeLock = self => acquireRelease$1(commit(acquireWrite(self)), () => commit(releaseWrite(self)));

/** @internal */
const writeLocked = self => map$1(get$3(self.state), state => state.writeLocks > 0);

/** @internal */
const writeLocks = self => map$1(get$3(self.state), state => state.writeLocks);

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TReentrantLockTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `TReentrantLock` is a reentrant read/write lock. Multiple readers may all
 * concurrently acquire read locks. Only one writer is allowed to acquire a
 * write lock at any given time. Read locks may be upgraded into write locks. A
 * fiber that has a write lock may acquire other write locks or read locks.
 *
 * The two primary methods of this structure are `readLock`, which acquires a
 * read lock in a scoped context, and `writeLock`, which acquires a write lock
 * in a scoped context.
 *
 * Although located in the STM package, there is no need for locks within STM
 * transactions. However, this lock can be quite useful in effectful code, to
 * provide consistent read/write access to mutable state; and being in STM
 * allows this structure to be composed into more complicated concurrent
 * structures that are consumed from effectful code.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Acquires a read lock. The transaction will suspend until no other fiber is
 * holding a write lock. Succeeds with the number of read locks held by this
 * fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
acquireRead;

/**
 * Acquires a write lock. The transaction will suspend until no other fibers
 * are holding read or write locks. Succeeds with the number of write locks
 * held by this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
acquireWrite;

/**
 * Retrieves the number of acquired read locks for this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
fiberReadLocks;

/**
 * Retrieves the number of acquired write locks for this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
fiberWriteLocks;

/**
 * Just a convenience method for applications that only need reentrant locks,
 * without needing a distinction between readers / writers.
 *
 * See `TReentrantLock.writeLock`.
 *
 * @since 2.0.0
 * @category mutations
 */
lock;

/**
 * Determines if any fiber has a read or write lock.
 *
 * @since 2.0.0
 * @category mutations
 */
locked;

/**
 * Makes a new reentrant read/write lock.
 *
 * @since 2.0.0
 * @category constructors
 */
make$8;

/**
 * Obtains a read lock in a scoped context.
 *
 * @since 2.0.0
 * @category mutations
 */
readLock;

/**
 * Retrieves the total number of acquired read locks.
 *
 * @since 2.0.0
 * @category mutations
 */
readLocks;

/**
 * Determines if any fiber has a read lock.
 *
 * @since 2.0.0
 * @category mutations
 */
readLocked;

/**
 * Releases a read lock held by this fiber. Succeeds with the outstanding
 * number of read locks held by this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
releaseRead;

/**
 * Releases a write lock held by this fiber. Succeeds with the outstanding
 * number of write locks held by this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
releaseWrite;

/**
 * Runs the specified workflow with a lock.
 *
 * @since 2.0.0
 * @category mutations
 */
withLock;

/**
 * Runs the specified workflow with a read lock.
 *
 * @since 2.0.0
 * @category mutations
 */
withReadLock;

/**
 * Runs the specified workflow with a write lock.
 *
 * @since 2.0.0
 * @category mutations
 */
withWriteLock;

/**
 * Obtains a write lock in a scoped context.
 *
 * @since 2.0.0
 * @category mutations
 */
writeLock;

/**
 * Determines if a write lock is held by some fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
writeLocked;

/**
 * Computes the number of write locks held by fibers.
 *
 * @since 2.0.0
 * @category mutations
 */
writeLocks;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TRefTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `TRef<A>` is a purely functional description of a mutable reference that can
 * be modified as part of a transactional effect. The fundamental operations of
 * a `TRef` are `set` and `get`. `set` transactionally sets the reference to a
 * new value. `get` gets the current value of the reference.
 *
 * NOTE: While `TRef<A>` provides the transactional equivalent of a mutable
 * reference, the value inside the `TRef` should be immutable.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category mutations
 */
get$3;

/**
 * @since 2.0.0
 * @category mutations
 */
getAndSet;

/**
 * @since 2.0.0
 * @category mutations
 */
getAndUpdate;

/**
 * @since 2.0.0
 * @category mutations
 */
getAndUpdateSome;

/**
 * @since 2.0.0
 * @category constructors
 */
make$d;

/**
 * @since 2.0.0
 * @category mutations
 */
modify;

/**
 * @since 2.0.0
 * @category mutations
 */
modifySome;

/**
 * @since 2.0.0
 * @category mutations
 */
set$1;

/**
 * @since 2.0.0
 * @category mutations
 */
setAndGet;

/**
 * @since 2.0.0
 * @category mutations
 */
update$2;

/**
 * @since 2.0.0
 * @category mutations
 */
updateAndGet;

/**
 * @since 2.0.0
 * @category mutations
 */
updateSome;

/**
 * @since 2.0.0
 * @category mutations
 */
updateSomeAndGet;

/** @internal */
const TSemaphoreSymbolKey = "effect/TSemaphore";

/** @internal */
const TSemaphoreTypeId = /*#__PURE__*/Symbol.for(TSemaphoreSymbolKey);

/** @internal */
class TSemaphoreImpl {
  [TSemaphoreTypeId] = TSemaphoreTypeId;
  constructor(permits) {
    this.permits = permits;
  }
}

/** @internal */
const make$7 = permits => map(make$d(permits), permits => new TSemaphoreImpl(permits));

/** @internal */
const acquire = self => acquireN(self, 1);

/** @internal */
const acquireN = /*#__PURE__*/dual(2, (self, n) => withSTMRuntime(driver => {
  if (n < 0) {
    throw IllegalArgumentException(`Unexpected negative value ${n} passed to Semaphore.acquireN`);
  }
  const value = unsafeGet(self.permits, driver.journal);
  if (value < n) {
    return retry;
  } else {
    return succeed$1(unsafeSet(self.permits, value - n, driver.journal));
  }
}));

/** @internal */
const available = self => get$3(self.permits);

/** @internal */
const release = self => releaseN(self, 1);

/** @internal */
const releaseN = /*#__PURE__*/dual(2, (self, n) => withSTMRuntime(driver => {
  if (n < 0) {
    throw IllegalArgumentException(`Unexpected negative value ${n} passed to Semaphore.releaseN`);
  }
  const current = unsafeGet(self.permits, driver.journal);
  return succeed$1(unsafeSet(self.permits, current + n, driver.journal));
}));

/** @internal */
const withPermit = /*#__PURE__*/dual(2, (self, semaphore) => withPermits(self, semaphore, 1));

/** @internal */
const withPermits = /*#__PURE__*/dual(3, (self, semaphore, permits) => uninterruptibleMask(restore => zipRight$4(restore(commit(acquireN(permits)(semaphore))), ensuring$4(self, commit(releaseN(permits)(semaphore))))));

/** @internal */
const withPermitScoped = self => withPermitsScoped(self, 1);

/** @internal */
const withPermitsScoped = /*#__PURE__*/dual(2, (self, permits) => acquireReleaseInterruptible(commit(acquireN(self, permits)), () => commit(releaseN(self, permits))));

/** @internal */
const unsafeMakeSemaphore = permits => {
  return new TSemaphoreImpl(new TRefImpl(permits));
};

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TSemaphoreTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category mutations
 */
acquire;

/**
 * @since 2.0.0
 * @category mutations
 */
acquireN;

/**
 * @since 2.0.0
 * @category getters
 */
available;

/**
 * @since 2.0.0
 * @category constructors
 */
make$7;

/**
 * @since 2.0.0
 * @category mutations
 */
release;

/**
 * @since 2.0.0
 * @category mutations
 */
releaseN;

/**
 * @since 2.0.0
 * @category mutations
 */
withPermit;

/**
 * @since 2.0.0
 * @category mutations
 */
withPermits;

/**
 * @since 2.0.0
 * @category mutations
 */
withPermitScoped;

/**
 * @since 2.0.0
 * @category mutations
 */
withPermitsScoped;

/**
 * @since 2.0.0
 * @category unsafe
 */
unsafeMakeSemaphore;

/** @internal */
const TSetSymbolKey = "effect/TSet";

/** @internal */
const TSetTypeId = /*#__PURE__*/Symbol.for(TSetSymbolKey);

/** @internal */
const tSetVariance = {
  _A: _ => _
};

/** @internal */
class TSetImpl {
  [TSetTypeId] = tSetVariance;
  constructor(tMap) {
    this.tMap = tMap;
  }
}

/** @internal */
const add = /*#__PURE__*/dual(2, (self, value) => set(self.tMap, value, void 0));

/** @internal */
const difference = /*#__PURE__*/dual(2, (self, other) => flatMap(toHashSet(other), values => removeIfDiscard(self, value => has$5(values, value))));

/** @internal */
const empty$1 = () => fromIterable([]);

/** @internal */
const forEach = /*#__PURE__*/dual(2, (self, f) => reduceSTM(self, void 0, (_, value) => f(value)));

/** @internal */
const fromIterable = iterable => map$1(fromIterable$2(Array.from(iterable).map(a => [a, void 0])), tMap => new TSetImpl(tMap));

/** @internal */
const has = /*#__PURE__*/dual(2, (self, value) => has$1(self.tMap, value));

/** @internal */
const intersection = /*#__PURE__*/dual(2, (self, other) => flatMap(toHashSet(other), values => pipe(self, retainIfDiscard(value => pipe(values, has$5(value))))));

/** @internal */
const isEmpty = self => isEmpty$4(self.tMap);

/** @internal */
const make$6 = (...elements) => fromIterable(elements);

/** @internal */
const reduce = /*#__PURE__*/dual(3, (self, zero, f) => reduceWithIndex(self.tMap, zero, (acc, _, key) => f(acc, key)));

/** @internal */
const reduceSTM = /*#__PURE__*/dual(3, (self, zero, f) => reduceWithIndexSTM(self.tMap, zero, (acc, _, key) => f(acc, key)));

/** @internal */
const remove = /*#__PURE__*/dual(2, (self, value) => remove$1(self.tMap, value));

/** @internal */
const removeAll = /*#__PURE__*/dual(2, (self, iterable) => removeAll$1(self.tMap, iterable));

/** @internal */
const removeIf = /*#__PURE__*/dual(2, (self, predicate) => pipe(removeIf$2(self.tMap, key => predicate(key)), map$1(map$m(entry => entry[0]))));

/** @internal */
const removeIfDiscard = /*#__PURE__*/dual(2, (self, predicate) => removeIfDiscard$1(self.tMap, key => predicate(key)));

/** @internal */
const retainIf = /*#__PURE__*/dual(2, (self, predicate) => pipe(retainIf$2(self.tMap, key => predicate(key)), map$1(map$m(entry => entry[0]))));

/** @internal */
const retainIfDiscard = /*#__PURE__*/dual(2, (self, predicate) => retainIfDiscard$1(self.tMap, key => predicate(key)));

/** @internal */
const size = self => map$1(toChunk(self), chunk => chunk.length);

/** @internal */
const takeFirst = /*#__PURE__*/dual(2, (self, pf) => takeFirst$1(self.tMap, key => pf(key)));

/** @internal */
const takeFirstSTM = /*#__PURE__*/dual(2, (self, pf) => takeFirstSTM$1(self.tMap, key => pf(key)));

/** @internal */
const takeSome = /*#__PURE__*/dual(2, (self, pf) => takeSome$1(self.tMap, key => pf(key)));

/** @internal */
const takeSomeSTM = /*#__PURE__*/dual(2, (self, pf) => takeSomeSTM$1(self.tMap, key => pf(key)));

/** @internal */
const toChunk = self => keys(self.tMap);

/** @internal */
const toHashSet = self => reduce(self, empty$s(), (acc, value) => pipe(acc, add$2(value)));

/** @internal */
const toReadonlyArray = self => reduce(self, [], (acc, value) => [...acc, value]);

/** @internal */
const toReadonlySet = self => map$1(toReadonlyArray(self), values => new Set(values));

/** @internal */
const transform = /*#__PURE__*/dual(2, (self, f) => transform$1(self.tMap, (key, value) => [f(key), value]));

/** @internal */
const transformSTM = /*#__PURE__*/dual(2, (self, f) => transformSTM$1(self.tMap, (key, value) => map$1(f(key), a => [a, value])));

/** @internal */
const union = /*#__PURE__*/dual(2, (self, other) => forEach(other, value => add(self, value)));

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TSetTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Transactional set implemented on top of `TMap`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Stores new element in the set.
 *
 * @since 2.0.0
 * @category mutations
 */
add;

/**
 * Atomically transforms the set into the difference of itself and the
 * provided set.
 *
 * @since 2.0.0
 * @category mutations
 */
difference;

/**
 * Makes an empty `TSet`.
 *
 * @since 2.0.0
 * @category constructors
 */
empty$1;

/**
 * Atomically performs transactional-effect for each element in set.
 *
 * @since 2.0.0
 * @category elements
 */
forEach;

/**
 * Makes a new `TSet` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
fromIterable;

/**
 * Tests whether or not set contains an element.
 *
 * @since 2.0.0
 * @category elements
 */
has;

/**
 * Atomically transforms the set into the intersection of itself and the
 * provided set.
 *
 * @since 2.0.0
 * @category mutations
 */
intersection;

/**
 * Tests if the set is empty or not
 *
 * @since 2.0.0
 * @category getters
 */
isEmpty;

/**
 * Makes a new `TSet` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
make$6;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
reduce;

/**
 * Atomically folds using a transactional function.
 *
 * @since 2.0.0
 * @category folding
 */
reduceSTM;

/**
 * Removes a single element from the set.
 *
 * @since 2.0.0
 * @category mutations
 */
remove;

/**
 * Removes elements from the set.
 *
 * @since 2.0.0
 * @category mutations
 */
removeAll;

/**
 * Removes bindings matching predicate and returns the removed entries.
 *
 * @since 2.0.0
 * @category mutations
 */
removeIf;

/**
 * Removes elements matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
removeIfDiscard;

/**
 * Retains bindings matching predicate and returns removed bindings.
 *
 * @since 2.0.0
 * @category mutations
 */
retainIf;

/**
 * Retains elements matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
retainIfDiscard;

/**
 * Returns the set's cardinality.
 *
 * @since 2.0.0
 * @category getters
 */
size;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeFirst;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeFirstSTM;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeSome;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
takeSomeSTM;

/**
 * Collects all elements into a `Chunk`.
 *
 * @since 2.0.0
 * @category destructors
 */
toChunk;

/**
 * Collects all elements into a `HashSet`.
 *
 * @since 2.0.0
 * @category destructors
 */
toHashSet;

/**
 * Collects all elements into a `ReadonlyArray`.
 *
 * @since 2.0.0
 * @category destructors
 */
toReadonlyArray;

/**
 * Collects all elements into a `ReadonlySet`.
 *
 * @since 2.0.0
 * @category destructors
 */
toReadonlySet;

/**
 * Atomically updates all elements using a pure function.
 *
 * @since 2.0.0
 * @category mutations
 */
transform;

/**
 * Atomically updates all elements using a transactional function.
 *
 * @since 2.0.0
 * @category mutations
 */
transformSTM;

/**
 * Atomically transforms the set into the union of itself and the provided
 * set.
 *
 * @since 2.0.0
 * @category mutations
 */
union;

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
TakeTypeId;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Take<E, A>` represents a single `take` from a queue modeling a stream of
 * values. A `Take` may be a failure cause `Cause<E>`, a chunk value `Chunk<A>`,
 * or an end-of-stream marker.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Creates a `Take` with the specified chunk.
 *
 * @since 2.0.0
 * @category constructors
 */
chunk;

/**
 * Creates a failing `Take` with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
die$3;

/**
 * Creates a failing `Take` with the specified error message.
 *
 * @since 2.0.0
 * @category constructors
 */
dieMessage$2;

/**
 * Transforms a `Take<E, A>` to an `Effect<never, E, A>`.
 *
 * @since 2.0.0
 * @category destructors
 */
done$5;

/**
 * Represents the end-of-stream marker.
 *
 * @since 2.0.0
 * @category constructors
 */
end;

/**
 * Creates a failing `Take` with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
fail$4;

/**
 * Creates a failing `Take` with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
failCause$1;

/**
 * Creates an effect from `Effect<R, E, A>` that does not fail, but succeeds with
 * the `Take<E, A>`. Error from stream when pulling is converted to
 * `Take.failCause`. Creates a single value chunk.
 *
 * @since 2.0.0
 * @category constructors
 */
fromEffect$1;

/**
 * Creates a `Take` from an `Exit`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromExit;

/**
 * Creates effect from `Effect<R, Option<E>, Chunk<A>>` that does not fail, but
 * succeeds with the `Take<E, A>`. Errors from stream when pulling are converted
 * to `Take.failCause`, and the end-of-stream is converted to `Take.end`.
 *
 * @since 2.0.0
 * @category constructors
 */
fromPull$1;

/**
 * Checks if this `take` is done (`Take.end`).
 *
 * @since 2.0.0
 * @category getters
 */
isDone$1;

/**
 * Checks if this `take` is a failure.
 *
 * @since 2.0.0
 * @category getters
 */
isFailure$2;

/**
 * Checks if this `take` is a success.
 *
 * @since 2.0.0
 * @category getters
 */
isSuccess$2;

/**
 * Constructs a `Take`.
 *
 * @since 2.0.0
 * @category constructors
 */
make$p;

/**
 * Transforms `Take<E, A>` to `Take<E, B>` by applying function `f`.
 *
 * @since 2.0.0
 * @category mapping
 */
map$3;

/**
 * Folds over the failure cause, success value and end-of-stream marker to
 * yield a value.
 *
 * @since 2.0.0
 * @category destructors
 */
match$1;

/**
 * Effectful version of `Take.fold`.
 *
 * Folds over the failure cause, success value and end-of-stream marker to
 * yield an effect.
 *
 * @since 2.0.0
 * @category destructors
 */
matchEffect;

/**
 * Creates a `Take` with a single value chunk.
 *
 * @since 2.0.0
 * @category constructors
 */
of;

/**
 * Returns an effect that effectfully "peeks" at the success of this take.
 *
 * @since 2.0.0
 * @category sequencing
 */
tap$2;

/**
 * @since 2.0.0
 */
/** @internal */
const TestAnnotationSymbolKey = "effect/TestAnnotation";

/**
 * @since 2.0.0
 */
const TestAnnotationTypeId = /*#__PURE__*/Symbol.for(TestAnnotationSymbolKey);

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/** @internal */
class TestAnnotationImpl {
  [TestAnnotationTypeId] = TestAnnotationTypeId;
  constructor(identifier, tag, initial, combine) {
    this.identifier = identifier;
    this.tag = tag;
    this.initial = initial;
    this.combine = combine;
  }
  [symbol$1]() {
    return pipe(hash$1(TestAnnotationSymbolKey), combine$a(hash$1(this.identifier)), combine$a(hash$1(this.tag)));
  }
  [symbol](that) {
    return isTestAnnotation(that) && this.identifier === that.identifier && equals$1(this.tag, that.tag);
  }
}

/**
 * @since 2.0.0
 */
const isTestAnnotation = u => {
  return typeof u === "object" && u != null && TestAnnotationTypeId in u;
};

/**
 * @since 2.0.0
 */
const make$5 = (identifier, tag, initial, combine) => {
  return new TestAnnotationImpl(identifier, tag, initial, combine);
};

/**
 * @since 2.0.0
 */
const compose = (left$1, right$1) => {
  if (isLeft$1(left$1) && isLeft$1(right$1)) {
    return left(left$1.left + right$1.left);
  }
  if (isRight$1(left$1) && isRight$1(right$1)) {
    return right(pipe(left$1.right, appendAll$1(right$1.right)));
  }
  if (isRight$1(left$1) && isLeft$1(right$1)) {
    return right$1;
  }
  if (isLeft$1(left$1) && isRight$1(right$1)) {
    return right$1;
  }
  throw new Error("BUG: TestAnnotation.compose - please report an issue at https://github.com/Effect-TS/io/issues");
};

/**
 * @since 2.0.0
 */
const fibers = /*#__PURE__*/make$5("fibers", /*#__PURE__*/Tag$1(), /*#__PURE__*/left(0), compose);

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 */
const TestAnnotationMapTypeId = /*#__PURE__*/Symbol.for("effect/TestAnnotationMap");

/**
 * @since 2.0.0
 */

/**
 * An annotation map keeps track of annotations of different types.
 *
 * @since 2.0.0
 */

/** @internal */
class TestAnnotationMapImpl {
  [TestAnnotationMapTypeId] = TestAnnotationMapTypeId;
  constructor(map) {
    this.map = map;
  }
}

/**
 * @since 2.0.0
 */
const empty = () => new TestAnnotationMapImpl(new Map());

/**
 * @since 2.0.0
 */
const make$4 = map => {
  return new TestAnnotationMapImpl(map);
};

/**
 * @since 2.0.0
 */
const overwrite = /*#__PURE__*/dual(3, (self, key, value) => make$4(self.map.set(key, value)));

/**
 * @since 2.0.0
 */
const update = /*#__PURE__*/dual(3, (self, key, f) => {
  let value = self.map.get(key);
  if (value === undefined) {
    value = key.initial;
  }
  return pipe(self, overwrite(key, f(value)));
});

/**
 * Retrieves the annotation of the specified type, or its default value if
 * there is none.
 *
 * @since 2.0.0
 */
const get = /*#__PURE__*/dual(2, (self, key) => {
  const value = self.map.get(key);
  if (value === undefined) {
    return key.initial;
  }
  return value;
});

/**
 * Appends the specified annotation to the annotation map.
 *
 * @since 2.0.0
 */
const annotate = /*#__PURE__*/dual(3, (self, key, value) => update(self, key, _ => key.combine(_, value)));

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestAnnotationsTypeId = /*#__PURE__*/Symbol.for("effect/TestAnnotations");

/**
 * @since 2.0.0
 */

/**
 * The `Annotations` trait provides access to an annotation map that tests can
 * add arbitrary annotations to. Each annotation consists of a string
 * identifier, an initial value, and a function for combining two values.
 * Annotations form monoids and you can think of `Annotations` as a more
 * structured logging service or as a super polymorphic version of the writer
 * monad effect.
 *
 * @since 2.0.0
 */

/** @internal */
class AnnotationsImpl {
  [TestAnnotationsTypeId] = TestAnnotationsTypeId;
  constructor(ref) {
    this.ref = ref;
  }
  get(key) {
    return map$f(get$b(this.ref), get(key));
  }
  annotate(key, value) {
    return update$4(this.ref, annotate(key, value));
  }
  supervisedFibers() {
    return descriptorWith$1(descriptor => flatMap$6(this.get(fibers), either => {
      switch (either._tag) {
        case "Left":
          {
            return succeed$h(empty$c(Order));
          }
        case "Right":
          {
            return pipe(either.right, forEachSequential(ref => sync$a(() => get$f(ref))), map$f(reduce$i(empty$c(Order), (a, b) => union$5(a, b))), map$f(filter$5(fiber => !equals$1(fiber.id(), descriptor.id))));
          }
      }
    }));
  }
}

/**
 * @since 2.0.0
 */
const TestAnnotations = /*#__PURE__*/Tag$1( /*#__PURE__*/Symbol.for("effect/Annotations"));

/**
 * @since 2.0.0
 */
const make$3 = ref => new AnnotationsImpl(ref);

/** @internal */

/** @internal */
const OP_SUSPENDED_WARNING_DATA_START = "Start";

/** @internal */

/** @internal */
const OP_SUSPENDED_WARNING_DATA_PENDING = "Pending";

/** @internal */

/** @internal */
const OP_SUSPENDED_WARNING_DATA_DONE = "Done";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/**
 * State indicating that a test has not adjusted the clock.
 *
 * @internal
 */
const start = {
  _tag: OP_SUSPENDED_WARNING_DATA_START
};

/**
 * State indicating that a test has adjusted the clock but a fiber is still
 * running with a reference to the fiber that will display the warning
 * message.
 *
 * @internal
 */
const pending$1 = fiber => {
  return {
    _tag: OP_SUSPENDED_WARNING_DATA_PENDING,
    fiber
  };
};

/**
 * State indicating that the warning message has already been displayed.
 *
 * @internal
 */
const done$1 = {
  _tag: OP_SUSPENDED_WARNING_DATA_DONE
};

/** @internal */
const isStart$1 = self => {
  return self._tag === OP_SUSPENDED_WARNING_DATA_START;
};

/** @internal */
const isPending$1 = self => {
  return self._tag === OP_SUSPENDED_WARNING_DATA_PENDING;
};

/**
 * `WarningData` describes the state of the warning message that is displayed
 * if a test is using time by is not advancing the `TestClock`. The possible
 * states are `Start` if a test has not used time, `Pending` if a test has
 * used time but has not adjusted the `TestClock`, and `Done` if a test has
 * adjusted the `TestClock` or the warning message has already been displayed.
 *
 * @internal
 */

/** @internal */
const OP_WARNING_DATA_START = "Start";

/** @internal */

/** @internal */
const OP_WARNING_DATA_PENDING = "Pending";

/** @internal */

/** @internal */
const OP_WARNING_DATA_DONE = "Done";

/**
 * State indicating that a test has used time but has not adjusted the
 * `TestClock` with a reference to the fiber that will display the warning
 * message.
 *
 * @internal
 */
const pending = fiber => {
  return {
    _tag: OP_WARNING_DATA_PENDING,
    fiber
  };
};

/**
 * State indicating that a test has used time or the warning message has
 * already been displayed.
 *
 * @internal
 */
const done = {
  _tag: OP_WARNING_DATA_DONE
};

/** @internal */
const isStart = self => {
  return self._tag === OP_WARNING_DATA_START;
};

/** @internal */
const isPending = self => {
  return self._tag === OP_WARNING_DATA_PENDING;
};

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestLiveTypeId = /*#__PURE__*/Symbol.for("effect/TestLive");

/**
 * @since 2.0.0
 */

/**
 * The `Live` trait provides access to the "live" default Effect services from
 * within tests for workflows such as printing test results to the console or
 * timing out tests where it is necessary to access the real implementations of
 * these services.
 *
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestLive = /*#__PURE__*/Tag$1( /*#__PURE__*/Symbol.for("effect/TestLive"));

/** @internal */
class LiveImpl {
  [TestLiveTypeId] = TestLiveTypeId;
  constructor(services) {
    this.services = services;
  }
  provide(effect) {
    return fiberRefLocallyWith$1(currentServices$1, merge$8(this.services))(effect);
  }
}

/**
 * @since 2.0.0
 */
const make$2 = services => new LiveImpl(services);

/**
 * @since 2.0.0
 */

/**
 * A `TestClock` makes it easy to deterministically and efficiently test effects
 * involving the passage of time.
 *
 * Instead of waiting for actual time to pass, `sleep` and methods implemented
 * in terms of it schedule effects to take place at a given clock time. Users
 * can adjust the clock time using the `adjust` and `setTime` methods, and all
 * effects scheduled to take place on or before that time will automatically be
 * run in order.
 *
 * For example, here is how we can test `Effect.timeout` using `TestClock`:
 *
 * ```ts
 * import * as Duration from "effect/Duration"
 * import * as Effect from "effect/Effect"
 * import * as Fiber from "effect/Fiber"
 * import * as TestClock from "effect/TestClock"
 * import * as Option from "effect/Option"
 *
 * Effect.gen(function*() {
 *   const fiber = yield* pipe(
 *     Effect.sleep(Duration.minutes(5)),
 *     Effect.timeout(Duration.minutes(1)),
 *     Effect.fork
 *   )
 *   yield* TestClock.adjust(Duration.minutes(1))
 *   const result = yield* Fiber.join(fiber)
 *   assert.deepStrictEqual(result, Option.none())
 * })
 * ```
 *
 * Note how we forked the fiber that `sleep` was invoked on. Calls to `sleep`
 * and methods derived from it will semantically block until the time is set to
 * on or after the time they are scheduled to run. If we didn't fork the fiber
 * on which we called sleep we would never get to set the time on the line
 * below. Thus, a useful pattern when using `TestClock` is to fork the effect
 * being tested, then adjust the clock time, and finally verify that the
 * expected effects have been performed.
 *
 * @since 2.0.0
 */

/**
 * `Data` represents the state of the `TestClock`, including the clock time.
 *
 * @since 2.0.1
 */

/**
 * @since 2.0.0
 */
const makeData = (instant, sleeps) => ({
  instant,
  sleeps
});

/**
 * The warning message that will be displayed if a test is using time but is
 * not advancing the `TestClock`.
 *
 * @internal
 */
const warning = "Warning: A test is using time, but is not advancing " + "the test clock, which may result in the test hanging. Use TestClock.adjust to " + "manually advance the time.";

/**
 * The warning message that will be displayed if a test is advancing the clock
 * but a fiber is still running.
 *
 * @internal
 */
const suspendedWarning = "Warning: A test is advancing the test clock, " + "but a fiber is not suspending, which may result in the test hanging. Use " + "TestAspect.diagnose to identity the fiber that is not suspending.";

/** @internal */
class TestClockImpl {
  [ClockTypeId] = ClockTypeId;
  constructor(clockState, live, annotations, warningState, suspendedWarningState) {
    this.clockState = clockState;
    this.live = live;
    this.annotations = annotations;
    this.warningState = warningState;
    this.suspendedWarningState = suspendedWarningState;
    this.currentTimeMillis = map$f(get$c(this.clockState), data => data.instant);
    this.currentTimeNanos = map$f(get$c(this.clockState), data => BigInt(data.instant * 1000000));
  }

  /**
   * Unsafely returns the current time in milliseconds.
   */
  unsafeCurrentTimeMillis() {
    return unsafeGet$2(this.clockState).instant;
  }

  /**
   * Unsafely returns the current time in nanoseconds.
   */
  unsafeCurrentTimeNanos() {
    return BigInt(unsafeGet$2(this.clockState).instant * 1000000);
  }

  /**
   * Returns the current clock time in milliseconds.
   */

  /**
   * Returns the current clock time in nanoseconds.
   */

  /**
   * Saves the `TestClock`'s current state in an effect which, when run, will
   * restore the `TestClock` state to the saved state.
   */
  save() {
    return map$f(get$c(this.clockState), data => set$7(this.clockState, data));
  }
  /**
   * Sets the current clock time to the specified instant. Any effects that
   * were scheduled to occur on or before the new time will be run in order.
   */
  setTime(instant) {
    return zipRight$8(this.warningDone(), this.run(() => instant));
  }
  /**
   * Semantically blocks the current fiber until the clock time is equal to or
   * greater than the specified duration. Once the clock time is adjusted to
   * on or after the duration, the fiber will automatically be resumed.
   */
  sleep(durationInput) {
    const duration = decode(durationInput);
    return flatMap$6(deferredMake(), deferred => pipe(modify$4(this.clockState, data => {
      const end = data.instant + toMillis(duration);
      if (end > data.instant) {
        return [true, makeData(data.instant, pipe(data.sleeps, prepend$2([end, deferred])))];
      }
      return [false, data];
    }), flatMap$6(shouldAwait => shouldAwait ? pipe(this.warningStart(), zipRight$8(deferredAwait(deferred))) : pipe(deferredSucceed(deferred, void 0), asUnit$4))));
  }
  /**
   * Returns a list of the times at which all queued effects are scheduled to
   * resume.
   */
  sleeps() {
    return map$f(get$c(this.clockState), data => map$l(data.sleeps, _ => _[0]));
  }
  /**
   * Increments the current clock time by the specified duration. Any effects
   * that were scheduled to occur on or before the new time will be run in
   * order.
   */
  adjust(durationInput) {
    const duration = decode(durationInput);
    return zipRight$8(this.warningDone(), this.run(n => n + toMillis(duration)));
  }
  /**
   * Increments the current clock time by the specified duration. Any effects
   * that were scheduled to occur on or before the new time will be run in
   * order.
   */
  adjustWith(durationInput) {
    const duration = decode(durationInput);
    return effect => zipLeftOptions(effect, this.adjust(duration), {
      concurrent: true
    });
  }
  /**
   * Returns a set of all fibers in this test.
   */
  supervisedFibers() {
    return this.annotations.supervisedFibers();
  }
  /**
   * Captures a "snapshot" of the identifier and status of all fibers in this
   * test other than the current fiber. Fails with the `Unit` value if any of
   * these fibers are not done or suspended. Note that because we cannot
   * synchronize on the status of multiple fibers at the same time this
   * snapshot may not be fully consistent.
   */
  freeze() {
    return flatMap$6(this.supervisedFibers(), fibers => pipe(fibers, reduce$9(empty$u(), (map, fiber) => pipe(fiber.status(), flatMap$6(status => {
      if (isDone$4(status)) {
        return succeed$h(set$b(map, fiber.id(), status));
      }
      if (isSuspended(status)) {
        return succeed$h(set$b(map, fiber.id(), status));
      }
      return fail$f(void 0);
    })))));
  }
  /**
   * Forks a fiber that will display a warning message if a test is using time
   * but is not advancing the `TestClock`.
   */
  warningStart() {
    return updateSomeEffect(this.warningState, data => isStart(data) ? some$6(pipe(this.live.provide(pipe(logWarning$1(warning), delay$1(seconds(5)))), interruptible$1, fork$2, map$f(fiber => pending(fiber)))) : none$8());
  }
  /**
   * Cancels the warning message that is displayed if a test is using time but
   * is not advancing the `TestClock`.
   */
  warningDone() {
    return updateSomeEffect(this.warningState, warningData => {
      if (isStart(warningData)) {
        return some$6(succeed$h(done));
      }
      if (isPending(warningData)) {
        return some$6(pipe(interruptFiber(warningData.fiber), as$6(done)));
      }
      return none$8();
    });
  }
  /**
   * Returns whether all descendants of this fiber are done or suspended.
   */
  suspended() {
    return pipe(this.freeze(), zip$a(this.live.provide(pipe(sleep$1(millis(5)), zipRight$8(this.freeze())))), flatMap$6(([first, last]) => equals$1(first, last) ? succeed$h(first) : fail$f(void 0)));
  }
  /**
   * Polls until all descendants of this fiber are done or suspended.
   */
  awaitSuspended() {
    return pipe(this.suspendedWarningStart(), zipRight$8(pipe(this.suspended(), zipWith$7(pipe(this.live.provide(sleep$1(millis(10))), zipRight$8(this.suspended())), equals$1), filterOrFail$2(identity$1, constVoid), eventually$2)), zipRight$8(this.suspendedWarningDone()));
  }
  /**
   * Forks a fiber that will display a warning message if a test is advancing
   * the `TestClock` but a fiber is not suspending.
   */
  suspendedWarningStart() {
    return updateSomeEffect(this.suspendedWarningState, suspendedWarningData => {
      if (isStart$1(suspendedWarningData)) {
        return some$6(pipe(this.live.provide(pipe(logWarning$1(suspendedWarning), zipRight$8(set$7(this.suspendedWarningState, done$1)), delay$1(seconds(5)))), interruptible$1, fork$2, map$f(fiber => pending$1(fiber))));
      }
      return none$8();
    });
  }
  /**
   * Cancels the warning message that is displayed if a test is advancing the
   * `TestClock` but a fiber is not suspending.
   */
  suspendedWarningDone() {
    return updateSomeEffect(this.suspendedWarningState, suspendedWarningData => {
      if (isPending$1(suspendedWarningData)) {
        return some$6(pipe(interruptFiber(suspendedWarningData.fiber), as$6(start)));
      }
      return none$8();
    });
  }
  /**
   * Runs all effects scheduled to occur on or before the specified instant,
   * which may depend on the current time, in order.
   */
  run(f) {
    return pipe(this.awaitSuspended(), zipRight$8(pipe(modify$4(this.clockState, data => {
      const end = f(data.instant);
      const sorted = pipe(data.sleeps, sort(pipe(Order$2, mapInput$5(_ => _[0]))));
      if (isNonEmpty$5(sorted)) {
        const [instant, deferred] = headNonEmpty(sorted);
        if (instant <= end) {
          return [some$6([end, deferred]), makeData(instant, tailNonEmpty(sorted))];
        }
      }
      return [none$8(), makeData(end, data.sleeps)];
    }), flatMap$6(option => {
      switch (option._tag) {
        case "None":
          {
            return unit$6;
          }
        case "Some":
          {
            const [end, deferred] = option.value;
            return pipe(deferredSucceed(deferred, void 0), zipRight$8(yieldNow$2()), zipRight$8(this.run(() => end)));
          }
      }
    }))));
  }
}

/**
 * @since 2.0.0
 */

/**
 * The `TestConfig` service provides access to default configuration settings
 * used by tests, including the number of times to repeat tests to ensure
 * they are stable, the number of times to retry flaky tests, the sufficient
 * number of samples to check from a random variable, and the maximum number of
 * shrinkings to minimize large failures.
 *
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestConfig = /*#__PURE__*/Tag$1( /*#__PURE__*/Symbol.for("effect/TestConfig"));

/**
 * @since 2.0.0
 */
const make$1 = params => params;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestSizedTypeId = /*#__PURE__*/Symbol.for("effect/TestSized");

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestSized = /*#__PURE__*/Tag$1(TestSizedTypeId);

/** @internal */
class SizedImpl {
  [TestSizedTypeId] = TestSizedTypeId;
  constructor(fiberRef) {
    this.fiberRef = fiberRef;
  }
  size() {
    return fiberRefGet(this.fiberRef);
  }
  withSize(size) {
    return effect => fiberRefLocally$1(this.fiberRef, size)(effect);
  }
}

/**
 * @since 2.0.0
 */
const make = size => new SizedImpl(fiberRefUnsafeMake(size));

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * The default Effect test services.
 *
 * @since 2.0.0
 */
const liveServices = /*#__PURE__*/pipe( /*#__PURE__*/make$12(TestAnnotations, /*#__PURE__*/make$3( /*#__PURE__*/unsafeMake$3( /*#__PURE__*/empty()))), /*#__PURE__*/add$4(TestLive, /*#__PURE__*/make$2(liveServices$1)), /*#__PURE__*/add$4(TestSized, /*#__PURE__*/make(100)), /*#__PURE__*/add$4(TestConfig, /*#__PURE__*/make$1({
  repeats: 100,
  retries: 100,
  samples: 200,
  shrinks: 1000
})));

/**
 * @since 2.0.0
 */
const currentServices = /*#__PURE__*/fiberRefUnsafeMakeContext(liveServices);

/**
 * Retrieves the `Live` service for this test and uses it to run the specified
 * workflow.
 *
 * @since 2.0.0
 */
const liveWith = f => fiberRefGetWith(currentServices, services => f(get$j(services, TestLive)));

/**
 * Retrieves the `Live` service for this test.
 *
 * @since 2.0.0
 */
/*#__PURE__*/liveWith(succeed$h);

/**
 * Retrieves the `Sized` service for this test and uses it to run the
 * specified workflow.
 *
 * @since 2.0.0
 */
const sizedWith = f => fiberRefGetWith(currentServices, services => f(get$j(services, TestSized)));

/**
 * Retrieves the `Sized` service for this test.
 *
 * @since 2.0.0
 */
/*#__PURE__*/sizedWith(succeed$h);

/**
 * Retrieves the `TestConfig` service for this test and uses it to run the
 * specified workflow.
 *
 * @since 2.0.0
 */
const testConfigWith = f => fiberRefGetWith(currentServices, services => f(get$j(services, TestConfig)));

/**
 * Retrieves the `TestConfig` service for this test.
 *
 * @since 2.0.0
 */
/*#__PURE__*/testConfigWith(succeed$h);

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $968d061d25540eb0$exports = {};

$parcel$export($968d061d25540eb0$exports, "RecordHook", function () { return $968d061d25540eb0$export$4475f942cbf3fc64; });
$parcel$export($968d061d25540eb0$exports, "BulkRecordHook", function () { return $968d061d25540eb0$export$4e02105ea584cac; });




class $390a7d1a104b5384$export$d804911c2b8eaa83 {
    constructor(records){
        this.records = records;
        this.toFlatFileRecords = ()=>{
            if (this.records instanceof (FlatfileRecords)) return this.records;
            else {
                const XRecords = this.records;
                const FFRecords = new (FlatfileRecords)(XRecords.map((record)=>{
                    let rawData = {};
                    for (let [k, v] of Object.entries(record.values))if (!!v.links?.length && v.value) {
                        const links = v.links.map((link)=>{
                            let linkedRawData = {};
                            for (let [lk, lv] of Object.entries(link.values))linkedRawData[lk] = lv.value;
                            return linkedRawData;
                        });
                        rawData[k] = {
                            value: v.value,
                            links: links
                        };
                    } else rawData[k] = v.value;
                    const metadata = record.metadata;
                    const rawRecord = {
                        rowId: record.id,
                        rawData: rawData,
                        metadata: metadata
                    };
                    return rawRecord;
                }));
                return FFRecords;
            }
        };
        this.toXRecords = ()=>{
            if (this.records[0] instanceof (FlatfileRecord)) {
                const FFRecords = this.records;
                return FFRecords.map((record)=>{
                    const recordWithInfo = record.toJSON();
                    let values = {};
                    for (let [k, v] of Object.entries(recordWithInfo.row.rawData)){
                        const messages = recordWithInfo.info.filter((info)=>info.field === k).map((info)=>({
                                message: info.message,
                                type: info.level,
                                source: "custom-logic"
                            }));
                        values[k] = {
                            value: v !== null && typeof v === "object" ? v.value : v,
                            messages: messages,
                            valid: true
                        };
                    }
                    const metadata = recordWithInfo.row.metadata;
                    return {
                        id: String(record.rowId),
                        values: values,
                        metadata: metadata
                    };
                });
            } else return this.records;
        };
        this.records = records;
    }
}


const $968d061d25540eb0$export$4475f942cbf3fc64 = async (event, handler, options = {})=>{
    const { concurrency: concurrency } = {
        concurrency: 10,
        ...options
    };
    return $968d061d25540eb0$export$4e02105ea584cac(event, async (records, event)=>{
        const handlers = await records.map((record)=>($3cwie$Effect).promise(async ()=>{
                await handler(record, event);
            }));
        return ($3cwie$Effect).runPromise(($3cwie$Effect).all(handlers, {
            concurrency: concurrency
        }));
    }, options);
};
const $968d061d25540eb0$export$4e02105ea584cac = async (event, handler, options = {})=>{
    const { versionId: versionId } = event.context;
    const fetchData = async ()=>{
        const data = await event.data;
        return data.records && data.records.length ? $968d061d25540eb0$var$prepareXRecords(data.records) : undefined;
    };
    try {
        const batch = await event.cache.init("records", fetchData);
        if (!batch || batch.records.length === 0) {
            if (options.debug) console.log("No records to process");
            await (0, $3cwie$flatfileapi).commits.complete(versionId);
            return;
        }
        // Execute client-defined data hooks
        await (0, $31bda95942fa1698$export$2f3768c184a3cc95)(batch.records, handler, options, event);
        event.afterAll(async ()=>{
            const batch = event.cache.get("records");
            const modifiedRecords = batch.records.filter($968d061d25540eb0$var$hasRecordChanges);
            if (!modifiedRecords || modifiedRecords.length === 0) {
                if (options.debug) console.log("No records modified");
                await (0, $3cwie$flatfileapi).commits.complete(versionId);
                return;
            }
            const recordsUpdates = new (0, $390a7d1a104b5384$export$d804911c2b8eaa83)(modifiedRecords).toXRecords();
            try {
                return await event.update(recordsUpdates);
            } catch (e) {
                console.log(`Error updating records: ${e}`);
            }
        });
    } catch (e) {
        console.log(`Error getting records: ${e}`);
    }
    return handler;
};
const $968d061d25540eb0$var$hasRecordChanges = (record)=>{
    const messageCount = record.toJSON().info.length;
    return JSON.stringify(record.originalValue) !== JSON.stringify(record.value) || messageCount > 0;
};
const $968d061d25540eb0$var$prepareXRecords = async (records)=>{
    const clearedMessages = records.map((record)=>{
        // clear existing cell validation messages
        Object.keys(record.values).forEach((k)=>{
            record.values[k].messages = [];
        });
        return record;
    });
    const fromX = new ($390a7d1a104b5384$export$d804911c2b8eaa83)(clearedMessages);
    return fromX.toFlatFileRecords();
};


var $10e929885b061e40$exports = {};

$parcel$export($10e929885b061e40$exports, "recordHookPlugin", function () { return $10e929885b061e40$export$8f27f26ab199cd01; });
$parcel$export($10e929885b061e40$exports, "bulkRecordHookPlugin", function () { return $10e929885b061e40$export$7ac68cd629161d7c; });
$parcel$export($10e929885b061e40$exports, "bulkRecordHook", function () { return $10e929885b061e40$export$7ac68cd629161d7c; });
$parcel$export($10e929885b061e40$exports, "recordHook", function () { return $10e929885b061e40$export$8f27f26ab199cd01; });

const $10e929885b061e40$export$8f27f26ab199cd01 = (sheetSlug, callback, options = {})=>{
    return (listener)=>{
        listener.on("commit:created", {
            sheetSlug: sheetSlug
        }, (event)=>{
            return ($968d061d25540eb0$export$4475f942cbf3fc64)(event, callback, options);
        });
    };
};
const $10e929885b061e40$export$7ac68cd629161d7c = (sheetSlug, callback, options = {})=>{
    return (listener)=>{
        listener.on("commit:created", {
            sheetSlug: sheetSlug
        }, (event)=>{
            return ($968d061d25540eb0$export$4e02105ea584cac)(event, callback, options);
        });
    };
};

function convertHook(hook) {
    return async (r) => {
        const hookResults = await hook(recordToDictionary(r), 0, 'update');
        return applyResults(hookResults, r);
    };
}
/**
 * Converts a Flatfile record to a basic scalar dictionary
 *
 * @param record
 */
function recordToDictionary(record) {
    const obj = record.value;
    return Object.keys(obj).reduce((acc, k) => {
        const prop = obj[k];
        if (prop && typeof prop === 'object' && 'value' in prop) {
            return { ...acc, [k]: prop.value };
        }
        else {
            return { ...acc, [k]: prop };
        }
    }, {});
}
/**
 * Applies a simple datahook response back to a record
 *
 * @param hookResults
 * @param record
 */
function applyResults(hookResults, record) {
    Object.keys(hookResults).forEach((k) => {
        const prop = hookResults[k];
        const value = typeof prop === 'object' ? prop?.value : prop;
        // historically only modified values had to be returned
        if (value !== undefined) {
            record.set(k, value ?? null);
        }
        const info = typeof prop === 'object' ? prop?.info : null;
        if (info) {
            info.forEach((i) => {
                if (i.level === 'error')
                    record.addError(k, i.message);
                if (i.level === 'warning')
                    record.addWarning(k, i.message);
                if (i.level === 'info')
                    record.addInfo(k, i.message);
            });
        }
    });
    return record;
}

/**
 * Implement the v2 validator shims on any migrated schema
 *
 * @todo Carl should add an e2e test here
 * @param sheetSlug
 */
function validators(sheetSlug) {
    return (listener) => {
        listener.use($10e929885b061e40$export$7ac68cd629161d7c(sheetSlug, async (records, event) => {
            const sheetId = event?.context.sheetId;
            const sheetSessionKey = `sheetConfig-${sheetId}`;
            const sheetConfig = await getSheetConfigFromSession(sheetSessionKey);
            const validator = new Validator(sheetConfig);
            records.forEach((record) => {
                const results = validator.validateRow(recordToDictionary(record));
                results.forEach((msg) => {
                    if (!msg.level || msg.level === 'error') {
                        record.addError(msg.key, msg.message);
                    }
                    if (msg.level === 'warning') {
                        record.addWarning(msg.key, msg.message);
                    }
                    if (msg.level === 'info') {
                        record.addInfo(msg.key, msg.message);
                    }
                });
            });
        }));
    };
}

/**
 * Convert v2 Configuration to modern Blueprint
 *
 * @param schema
 */
const configToBlueprint = (schema) => {
    let fields = [];
    fields = schema.fields.map((field) => {
        let out = {
            key: field.key,
            label: field.label || field.key,
            type: PlatformTypes.String,
            constraints: [],
        };
        if (field.description) {
            out.description = field.description;
        }
        if (field.type) {
            if (field.type === 'checkbox') {
                out.type = PlatformTypes.Bool;
            }
            if (field.type === 'select') {
                out.type = PlatformTypes.Enum;
                out.config = { options: field.options };
            }
        }
        if (field.validators) {
            field.validators.forEach((validator) => {
                if (validator.validate === 'required') {
                    out.constraints.push({ type: 'required' });
                }
                else if (validator.validate === 'unique') {
                    out.constraints.push({ type: 'unique' });
                }
                else {
                    if (!out?.metadata?.v2_validators) {
                        out.metadata = {};
                        out.metadata.v2_validators = [validator];
                    }
                    else {
                        out.metadata.v2_validators.push(validator);
                    }
                }
            });
        }
        return out;
    });
    return {
        name: schema?.type || 'No name provided',
        sheets: [
            {
                name: schema?.type || 'No sheet name',
                slug: schema?.type || 'sheetSlug',
                fields: fields,
            },
        ],
        actions: [
            {
                operation: 'submitAction',
                mode: 'foreground',
                label: 'Submit',
                description: 'Submit action for data egress',
                primary: true,
            },
        ],
    };
};
var PlatformTypes;
(function (PlatformTypes) {
    PlatformTypes["String"] = "string";
    PlatformTypes["Num"] = "number";
    PlatformTypes["Date"] = "date";
    PlatformTypes["Enum"] = "enum";
    PlatformTypes["Bool"] = "boolean";
    PlatformTypes["Ref"] = "reference";
})(PlatformTypes || (PlatformTypes = {}));

export { PlatformTypes, Validator, applyResults, configToBlueprint, convertHook, getResultsForContextSheet, handleData, recordToDictionary, validators };
